/**
 * Mocking client-server processing
 */

const _data = [
  {
    keyword: "(GAT-PAT)",
    meaning:
      "การทดสอบเพื่อเข้าศึกษาต่อในระดับมหาวิทยาลัย ทั้งในระบบรับตรงและระบบแอดมิชชั่นกลาง ดังนี้\r\nGAT (General Aptitude Test) คือ การทดสอบวิชาความถนัดทั่วไป ประกอบด้วย 2 ส่วน ได้แก่\r\n- ส่วนที่ 1 ความสามารถในการอ่าน การเขียน การคิดเชิงวิเคราะห์ และการแก้โจทย์ปัญหา\r\n- ส่วนที่ 2 ความสามารถในการสื่อสารด้วยภาษาอังกฤษ\r\n \r\nPAT (Professional and Academic Aptitude Test) คือ การทดสอบวิชาความถนัดทางวิชาการและวิชาชีพเพื่อวัดความรู้พื้นฐานกับศักยภาพที่จะเรียนในวิชาชีพนั้น ๆ ให้ประสบความสำเร็จ 7 วิชา  ได้แก่ \r\nความถนัดทางคณิตศาสตร์ /ความถนัดทางวิทยาศาสตร์ /ความถนัดทางวิศวกรรมศาสตร์/ความถนัดทางสถาปัตยกรรมศาสตร์/ความถนัดทางวิชาชีพครู/ความถนัดทางศิลปกรรมศาสตร์/ความถนัดทางภาษาต่างประเทศ \r\n\r\n* เกณฑ์คะแนนการผ่านของแต่ละวิชาขึ้นอยู่กับการกำหนดของแต่ละคณะ/ภาควิชา และสถาบันการศึกษาที่แตกต่างกัน",
    source:
      "สถาบันทดสอบทางการศึกษาแห่งชาติ (องค์การมหาชน) กระทรวงศึกษาธิการ. (2558). GAT/PAT, 2 พฤษภาคม 2562. http://www.niets.or.th/th/catalog/view/234 \r\n\r\n",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "g"
  },
  {
    keyword: "(O–NET)",
    meaning:
      "Ordinary National Education(O-net) คือ การทดสอบทางการศึกษาระดับชาติขั้นพื้นฐาน  เป็นการทดสอบเพื่อวัดความรู้และความคิดของนักเรียนชั้นประถมศึกษาปีที่ 6 มัธยมศึกษาปีที่ 3 และมัธยมศึกษาปีที่ 6 โดยประเมินตามมาตรฐานการเรียนรู้ในหลักสูตรแกนกลางการศึกษาขั้นพื้นฐาน พ.ศ. 2551 เพื่อชี้วัดคุณภาพและมาตรฐานทางการศึกษาของประเทศ \r\nซึ่งข้อสอบ O-net ประกอบด้วย 8 วิชา โดยแต่ละวิชามีคะแนนเต็ม 100 คะแนน ประกอบด้วย\r\n1. วิชาภาษาไทย\r\n2. วิชาสังคมศึกษา\r\n3. วิชาภาษาอังกฤษ\r\n4. วิชาคณิตศาสตร์\r\n5. วิชาวิทยาศาสตร์ \r\n6. วิชาสุขศึกษาและพลศึกษา \r\n7. วิชาศิลปะ \r\n8. วิชาการงานอาชีพและเทคโนโลยี\r\nทั้งนี้ วิชาที่นำมาคำนวณคะแนนแอดมิชชั่นมีเพียง 5 วิชาแรกเท่านั้น",
    source:
      "สถาบันทดสอบทางการศึกษาแห่งชาติ (องค์การมหาชน) กระทรวงศึกษาธิการ. (2558). O-NET (Ordinary National Educational Test), 4 มิถุนายน 2562. http://www.niets.or.th/th/catalog/view/211",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "o"
  },
  {
    keyword: "“When state owns, nobody owns. When nobody owns, nobody cares.”",
    meaning:
      "ระบบรัฐวิสาหกิจยังไม่มีการแบ่งบทบาทของผู้ที่เกี่ยวข้องออกจากกันให้ชัดเจน หลายกรณีมี conflict of roles รวมทั้งขาดหน่วยงานที่ทำหน้าที่เป็นเจ้าของ (แทนประชาชน) ที่ปกป้องและรับผิดชอบให้รัฐวิสาหกิจประกอบการอย่างมีประสิทธิภาพ และดำรงอยู่ได้อย่างยั่งยืน ดังที่ Magareth Thatcher อดีตนายกรัฐมนตรีของอังกฤษ พูดไว้ในช่วงปฏิรูปรัฐวิสาหกิจครั้งใหญ่ของอังกฤษ ว่า “When state owns, nobody owns. When nobody owns, nobody cares.” ",
    source:
      "กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม. การปฏิรูปสถาบันทางเศรษฐกิจ, 2 กันยายน 2562. http://www.mdes.go.th/assets/portals/1/files/610611_5_4%E0%B9%80%E0%B8%A8%E0%B8%A3%E0%B8%A9%E0%B8%90%E0%B8%81%E0%B8%B4%E0%B8%88.docx",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "w"
  },
  {
    keyword: "Accountability",
    meaning: 'ความสำนึกรับผิดชอบ เป็นองค์ประกอบสำคัญของ "ธรรมาภิบาล" ',
    source:
      "สมศักดิ์ สามัคคีธรรม. ความสำนึกรับผิดชอบกับการจัดการสาธารณะ, 29 สิงหาคม 2562. http://romphruekj.krirk.ac.th/books/2558/4/chap2.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "a"
  },
  {
    keyword: "ACMECS",
    meaning:
      "ยุทธศาสตร์ความร่วมมือทางเศรษฐกิจอิรวดี-เจ้าพระยา-แม่โขง (Ayeyawady-Chao Phraya-Mekong Economic Cooperation Strategy: ACMECS)  ประกอบด้วยประเทศสมาชิก 5 ประเทศ ได้แก่ กัมพูชา สาธารณรัฐประชาธิปไตยประชาชนลาว เมียนมา เวียดนาม และประเทศไทย เป็นกรอบความร่วมมือระดับอนุภูมิภาค โดยมีเป้าหมายหลักคือการส่งเสริมความร่วมมือทางเศรษฐกิจ เช่น การค้าการลงทุน การท่องเที่ยว และการเกษตร โดยไทยมีบทบาทนําในฐานะประเทศผู้ใหญ่ผ่านกลไก 2 หน่วยงาน คือ สํานักงานความร่วมมือพัฒนาเศรษฐกิจกับประเทศเพื่อนบ้าน (องค์กรมหาชน) หรือ NEDA และกรมความร่วมมือระหว่างประเทศ กระทรวงการต่างประเทศในการให้ความช่วยเหลือด้านโครงสร้างพื้นฐาน และด้านวิชาการ มุ่งเน้นการนำความเจริญไปสู่แนวชายแดน เพื่อปูทางไปสู่การค้าการลงทุนตามแนวชายแดน ซึ่งจะช่วยในการสร้างงาน สร้างรายได้และลดความเหลื่อมล้ำ/ ช่องว่างการพัฒนา",
    source:
      "กระทรวงการต่างประเทศ. ทำความรู้จัก ACMECS ความร่วมมือสามแม่น้ำ, 2 กันยายน 2562. http://www.mfa.go.th/main/th/information/8149/88649-%E0%B8%97%E0%B8%B3%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%A3%E0%B8%B9%E0%B9%89-ACMECS-%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%A3%E0%B9%88%E0%B8%A7%E0%B8%A1%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%AA%E0%B8%B2%E0%B8%A1%E0%B9%81%E0%B8%A1%E0%B9%88%E0%B8%99%E0%B9%89%E0%B8%B3.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "a"
  },
  {
    keyword: "AEC",
    meaning:
      "ASEAN Economic Community หมายถึง ประชาคมเศรษฐกิจอาเซียนที่มีเป้าหมายส่งเสริมอาเซียนให้เป็นตลาดและฐานการผลิตเดียว มีการเคลื่อนย้ายสินค้า บริการ การลงทุน แรงงานมีฝีมือ และเงินทุนอย่างเสรี\r\nภายในปี พ.ศ. 2558 (ค.ศ.2015)",
    source:
      "สำนักงานการปฏิรูปที่ดินเพื่อเกษตรกรรม. คำศัพท์เศรษฐกิจอาเซียน, 10 พฤษภาคม 2562. https://alro.go.th/asean_data/ewt_dl_link.php?nid=225",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "a"
  },
  {
    keyword: "Agenda - Based",
    meaning:
      "ภารกิจยุทธศาสตร์ แนวทางปฏิรูปภาครัฐ นโยบายเร่งด่วน หรือภารกิจที่ได้รับมอบหมายเป็นพิเศษ",
    source:
      "สำนักงานคณะกรรมการข้าราชการพลเรือน. คู่มือการประเมินข้าราชการพลเรือนประเภทบริหารระดับสูง: สำหรับผู้รับการประเมิน, 25 กันยายน 2562. https://www.ocsc.go.th/sites/default/files/attachment/article/manual_guide_executive_.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "a"
  },
  {
    keyword: "Agri Map",
    meaning:
      "เครื่องมือแสดงผลข้อมูลเชิงภูมิสารสนเทศ พร้อมระบบแนะนำผลการปรับเปลี่ยนกิจกรรมการผลิตด้วยพืชทดแทน ในรูปแบบเว็บแผนที่แบบออนไลน์ ซึ่งอำนวยความสะดวกให้กับผู้ใช้งานสามารถใช้งานได้จากทุกที่ทุกเวลาผ่านทางระบบอินเตอร์เน็ต เพื่อให้ผู้ใช้งานสามารถใช้งานอย่างมีประสิทธิภาพ จึงขอแนะนำสิ่งที่ผู้ใช้ควรตรวจสอบก่อนเข้าใช้งาน",
    source:
      "กระทรวงเกษตรและสหกรณ์ (2559). ระบบแผนที่เกษตรเพื่อการบริหารจัดการเชิงรุกออนไลน์ (Agri-Map Online), 25 กันยายน 2562. http://agri-map-online.moac.go.th/static/file/agrimap-manual.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "a"
  },
  {
    keyword: "ASEAN",
    meaning:
      "จัดตั้งขึ้นตามปฏิญญากรุงเทพ (Bangkok Declaration) เมื่อวันที่ 8 สิงหาคม 2510 เพื่อร่วมมือและส่งเสริมสันติภาพ เสถียรภาพ ความเจริญทางเศรษฐกิจ ความก้าวหน้าทางสังคม วัฒนธรรม วิชาการ วิทยาศาสตร์และการบริหารในภูมิภาค โดยประกอบด้วยประเทศสมาชิก 10 ประเทศ คือ อินโดนิเซีย มาเลเซีย ฟิลิปปินส์ สิงคโปร์ ไทย บรูไนดารุสซาลาม เวียดนาม ลาว พม่า และกัมพูชา",
    source:
      "กรมอาเซียน กระทรวงการต่างประเทศ. ASEAN (Association of South-East Asian Nations), 2 กันยายน 2562.\r\nhttp://www.mfa.go.th/asean/th/code?code=asean",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "a"
  },
  {
    keyword: "ASEAN single window",
    meaning:
      "ความตกลงว่าด้วยการอำนวยความสะดวกด้านศุลกากรด้วยระบบอิเล็กทรอนิกส์ ณ จุดเดียวของอาเซียน สืบเนื่องจากที่ประชุมรัฐมนตรีเศรษฐกิจอาเซียน ไดกำหนดแนวทางการพัฒนา “ASEAN Single Window” เพื่ออำนวยความสะดวกในทางการค้าระหว่างประเทศในการนำเข้า การสงออก การเคลื่อนย้ายสินค้าระหว่างกลุ่มประเทศอาเซียนให้สะดวกรวดเร็ว ลดต้นทุนการบริหารจัดการและการใช้ทรัพยากรต่างๆ",
    source:
      "กรมเจรจาการค้าระหว่างประเทศ. (2551). ความตกลงว่าด้วยการอำนวยความสะดวกด้านศุลกากรด้วย ระบบอิเล็กทรอนิกส์ ณ จุดเดียวของอาเซียน (ASEAN Single Window-ASW), 25 กันยายน 2562. http://www.thaifta.com/trade/script/vocab4_mar51.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "a"
  },
  {
    keyword: "ASEAN Standard",
    meaning:
      "เป็นการปรับมาตรฐานที่ใช้แตกต่างกันอยู่ในแต่ละประเทศให้สอดคล้องกับมาตรฐานที่ได้รับการยอมรับในระดับสากล",
    source:
      "สำนักงานมาตรฐานผลิตภัณฑ์อุตสาหกรรม (สมอ.) กระทรวงอุตสาหกรรม. ความร่วมมือกรอบอาเซียน, 16 ตุลาคม 2562. https://www.tisi.go.th/website/interstandard/asean",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "a"
  },
  {
    keyword: "B2B (Business to Business)",
    meaning:
      "การค้าระหว่างผู้ค้ากับหน่วยธุรกิจ แต่เป็นผู้ประกอบการครอบคลุมถึงการขายส่ง การทำการสั่งซื้อสินค้าผ่านทางระบบอิเล็กทรอนิกส์ ระบบห่วงโซ่การผลิต (Supply Chain Management) หรือเว็บไซต์ที่เป็นตัวกลางระหว่างผู้ที่ต้องการซื้อสินค้า/ บริการ กับผู้ให้บริการธุรกิจ รถเช่า ดำน้ำ สปาร์ กอล์ฟ สวนสนุก เป็นต้น",
    source:
      "กรมสรรพากร. ความรู้เกี่ยวกับอีคอมเมิร์ซ, 16 ตุลาคม 2562.  https://www.rd.go.th/publish/26228.0.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "b"
  },
  {
    keyword: "B2C (Business to Customer)",
    meaning:
      "การค้าระหว่างผู้ค้าโดยตรงถึงลูกค้าหรือผู้บริโภค เช่น เว็บไซต์ขายหนังสือออนไลน์ เน้นการขายหนังสือออนไลน์ หรือสื่อมัลติมีเดียทางการศึกษา โดยมีกลุ่มลูกค้าเป็นเด็ก นักเรียน นักศึกษา และบุคคลทั่วไป โดยการสั่งซื้อสินค้าจะทำผ่านระบบตะกร้าสินค้าอิเล็กทรอนิกส์ การชำระเงิน มีทางเลือกให้ลูกค้า เช่น โอนผ่านธนาคาร บัตรเครดิต ไปรษณีย์ธนาณัติ ในส่วนของการจัดส่งผ่านทางไปรษณีย์ หรือสามารถส่งแบบ Delivery ได้ด้วย เช่น ร้านค้าอิเล็กทรอนิกส์ ธนาคารอิเล็กทรอนิกส์ การขายอสังหาริมทรัพย์ เป็นต้น",
    source:
      "กรมสรรพากร. ความรู้เกี่ยวกับอีคอมเมิร์ซ, 16 ตุลาคม 2562. https://www.rd.go.th/publish/26228.0.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "b"
  },
  {
    keyword: "Benchmark",
    meaning:
      "Best-in-class คือเก่งที่สุดหรือดีที่อันจะเป็นต้นแบบที่จะใช้อ้างอิงเพื่อวัดหรือเปรียบเทียบ",
    source:
      "กรมตรวจบัญชีสหกรณ์. Benchmarking คืออะไร?, 25 กันยายน 2562. https://www.cad.go.th/ewtadmin/ewt/statistic/main.php?filename=news_25491117_2",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "b"
  },
  {
    keyword: "Big Data",
    meaning:
      "ข้อมูลปริมาณมหาศาล และสามารถใช้อธิบายลักษณะของข้อมูลที่อยู่ใน\r\nรูปแบบที่หลากหลาย และมีที่มาจากแหล่งต่าง ๆ ทั้งจากระบบคอมพิวเตอร์ที่ใช้งานในองค์กรต่าง ๆ เครื่องจักร อุปกรณ์ที่ควบคุมด้วยระบบคอมพิวเตอร์ เซ็นเซอร์ต่าง ๆ ที่สร้างข้อมูลและจัดเก็บข้อมูล\r\nตลอดเวลาอย่างต่อเนื่อง",
    source:
      'สำนักวิชาการ สำนักงานเลขาธิการสภาผู้แทนราษฎร. (2559). "Big Data" ในภาครัฐ, 28 สิงหาคม 2562. \r\nhttps://library2.parliament.go.th/ejournal/content_af/2559/dec2559-4.pdf',
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "b"
  },
  {
    keyword: "BOI Outbound",
    meaning:
      "สำนักงานคณะกรรมการส่งเสริมการลงทุน (Board of Investment : BOI) มีบทบาทในการส่งเสริมการลงทุนไทยในต่างประเทศควบคู่ไปกับการส่งเสริมการลงทุนในประเทศ (Inbound & Outbound) และได้จัดตั้งศูนย์พัฒนาการลงทุนไทยในต่างประเทศ (Thai Overseas Investment Support Center: TOISC) เพื่อสร้างองค์ความรู้ เสริมสร้างศักยภาพ สร้างความพร้อมให้กับนักลงทุนไทย โดยเฉพาะผู้ประกอบการขนาดกลางและขนาดเล็ก (SMEs) ที่มีศักยภาพเพื่อออกไปลงทุนในต่างประเทศ เพื่อตอบสนองการดำเนินยุทธศาสตร์เชิงรุกในการสร้างผู้ประกอบการและส่งเสริมให้ผู้ประกอบการไทยไปลงทุนในต่างประเทศ และเป็นการขับเคลื่อนเศรษฐกิจของประเทศไทย รวมทั้งสร้างความต่อเนื่องในการพัฒนาความรู้และสร้างโอกาสให้กับผู้ประกอบการไทย โดยให้สถาบันระหว่างประเทศเพื่อการค้าและการพัฒนา (องค์การมหาชน) ซึ่งเป็นหน่วยงานที่มีความรู้ ความเชี่ยวชาญในการประกอบธุรกิจในต่างประเทศ ดำเนินการพัฒนาผู้ประกอบการไทยเพื่อยกระดับศักยภาพ และเพิ่มขีดความสามารถในการแข่งขันให้กับประเทศ",
    source:
      "สถาบันระหว่างประเทศเพื่อการค้าและการพัฒนา. (2561). หลักสูตร “สร้างนักลงทุนในไทยต่างประเทศ (TOISC)” รุ่นที่ 14 – 15, 5 มิถุนายน 2562. http://www.itd.or.th/th/event/toisc14_15/",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "b"
  },
  {
    keyword: "Bottom-up",
    meaning:
      "ประชาชนเป็นผู้ร่วมกำหนดทิศทางนโยบาย และกระบวนการในการพัฒนาโดยตรง โดยมี “การออกแบบ” เป็นเครื่องมือสำคัญที่ใช้เพื่อปรับปรุงคุณภาพชีวิตหลายๆ ด้าน ไม่ว่าจะเป็นด้านสิ่งแวดล้อม ความปลอดภัยในชีวิตและทรัพย์สิน สภาพความเป็นอยู่ภายในชุมชน ฯลฯ",
    source:
      "สำนักนายกรัฐมนตรี. จาก Top-down สู่ Bottom-up นโยบายการพัฒนาชุมชนยุคใหม่ที่ใครๆ ก็ออกแบบได้, 25 กันยายน 2562.\r\nhttp://www.tcdc.or.th/articles/design_creativity/16266/#%E0%B8%88%E0%B8%B2%E0%B8%81-Top-down-%E0%B8%AA%E0%B8%B9%E0%B9%88-Bottom-up-%E0%B8%99%E0%B9%82%E0%B8%A2%E0%B8%9A%E0%B8%B2%E0%B8%A2%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%9E%E0%B8%B1%E0%B8%92%E0%B8%99%E0%B8%B2%E0%B8%8A%E0%B8%B8%E0%B8%A1%E0%B8%8A%E0%B8%99%E0%B8%A2%E0%B8%B8%E0%B8%84%E0%B9%83%E0%B8%AB%E0%B8%A1%E0%B9%88%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B9%83%E0%B8%84%E0%B8%A3%E0%B9%86-%E0%B8%81%E0%B9%87%E0%B8%AD%E0%B8%AD%E0%B8%81%E0%B9%81%E0%B8%9A%E0%B8%9A%E0%B9%84%E0%B8%94%E0%B9%89\r\n(ที่มาไม่ตรงกับเว็บไซต์)",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "b"
  },
  {
    keyword: "Business as Usual (BAU)",
    meaning:
      "กรณีเมื่อธุรกิจดำเนินไปตามปกติโดยที่ยังไม่มีการดำเนินมาตรการลดการปล่อยก๊าซเรือนกระจก ตลอดจนยังไม่มีการปรับเปลี่ยนหรือการลงมือเพื่อแก้ไขบรรเทาปัญหาโลกร้อน",
    source:
      "คณะทำงานโลกเย็นที่เป็นธรรม Thai Climate Justice Working Group (TCJ). (2556). คู่มือคำศัพท์โลกร้อน, 5 มิถุนายน 2562. http://www.thaiclimatejustice.org/knowledge/view/60",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "b"
  },
  {
    keyword: "capital gain tax",
    meaning:
      "ภาษีที่เก็บจากผลได้ที่เกิดจากการเพิ่มขึ้นในมูลค่าของสินทรัพย์หรือหลักทรัพย์ ซึ่งรวมถึงอสังหาริมทรัพย์ สังหาริมทรัพย์ เช่น ตราสารทางการเงิน อาคาร บ้านและ ที่ดิน เป็นต้น โดยผลได้จากทุนเกิดจากผลต่างระหว่างมูลค่า ขายกับต้นทุนหรือมูลค่าที่ซื้อสินทรัพย์หรือหลักทรัพย์นั้น",
    source:
      "สำนักนโยบายการออมและการลงทุน. (2556). ศัพท์น่ารู้เกี่ยวกับเศรษฐกิจ, 26 สิงหาคม 2562. http://www2.fpo.go.th/S-I/Source/word/Word.php?Language=Thai&BeginRec=1843&NumRecShow=8&sort=4&search=",
    sappear: "",
    mappear: "",
    rappear: "",
    firstalpha: "c"
  },
  {
    keyword: "cascade",
    meaning:
      "การถ่ายทอดเป้าหมายการปฏิบัติงานขององค์กรลงมาตามลำดับชั้นจากระดับองค์กรลงสู่ระดับสำนัก/กอง ฝ่าย/ส่วน/กลุ่ม จนถึงระดับบุคคล โดยเป้าหมายงานในระดับต่างๆ ต้องเป็นปัจจัยหนึ่งที่นำไปสู่เป้าหมายเชิงกลยุทธ์ขององค์กร",
    source:
      "กองการเจ้าหน้าที่ สำนักงานปลัดกระทรวงมหาดไทย. หลักการระบบบริหารผลการปฏิบัติงาน, 17 ธันวาคม 2562. http://www.personnel.moi.go.th/Site_2.htm",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "c"
  },
  {
    keyword: "CIPP MODEL",
    meaning:
      "การประเมินผลโครงการฝึกอบรม หมายถึง กระบวนการวัดที่มีการรวบรวมข้อมูลและวิเคราะห์ข้อมูลอย่างเป็นระบบโดยการนำรูปแบบจำลองซิปป์(CIPP model) ซึ่งเป็นการประเมิน 4 ด้าน ได้แก่ \r\n1. ด้านสภาวะแวดล้อม (context) ประกอบด้วย หลักการและเหตุผลของโครงการ โครงสร้างของหลักสูตรการฝึกอบรม เนื้อหาสาระของหลักสูตรการฝึกอบรม และผลการฝึกอบรมที่คาดหวัง \r\n2. ด้านปัจจัยเบื้องต้น (input)ประกอบด้วย วิทยากร สถานที่ฝึกอบรม อุปกรณ์ที่ใช้ในการฝึกอบรม เอกสารประกอบการฝึกอบรม เจ้าหน้าที่ผู้ดำเนินโครงการฝึกอบรม และงบประมาณ \r\n3. ด้านกระบวนการดำเนินงาน (process) ประกอบด้วย การจัดการฝึกอบรม การติดตามและประเมินผล \r\n4. ด้านการผลิต (product) หมายถึง ผลการฝึกอบรม การนำความรู้ไปใช้ในการปฏิบัติงาน",
    source:
      "วรรณภา ศรีพุธสมบูรณ์ สำนักพัฒนาและถ่ายทอดเทคโนโลยีการประมง กรมประมง กระทรวงเกษตรและสหกรณ์. (2557). การประเมินผลโครงการฝึกอบรมหลักสูตรการพัฒนาศักยภาพประมงจังหวัดประจำปีงบประมาณ พ.ศ. 2554, 2 กันยายน 2562. http://elib.fisheries.go.th/LIBCAB/DRAWERS/ABS/DATA0001/00001411.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "c"
  },
  {
    keyword: "Citizen Feedback",
    meaning:
      "เป็นความริเริ่มของแนวร่วมปฏิบัติของภาคเอกชนไทยในการต่อต้านการทุจริต Collective Action Coalition Against Corruption (CAC) โดยร่วมกับสมาคมวิจัยการตลาดแห่งประเทศไทย Thailand Marketing Research Society (TMRS) องค์กรต่อต้านคอร์รัปชัน (ประเทศไทย) และ HAND Enterprise ออกแบบและพัฒนาระบบแบบสอบถามแบบออนไลน์ เพื่อเปิดโอกาสให้ประชาชนที่ใช้บริการของหน่วยงานรัฐได้ให้ข้อมูลเกี่ยวกับความพึงพอใจและความโปร่งใสผ่านสมาร์ทโฟน โครงการ Citizen Feedback ได้รับการสนับสนุนจากสำนักงานคณะกรรมการพัฒนาระบบราชการ (ก.พ.ร.) ช่วยประสานงานกับหน่วยงานรัฐที่เข้าร่วมในโครงการต้นแบบ",
    source:
      "สมาคมวิจัยการตลาดแห่งประเทศไทย Thailand Marketing Research Society (TMRS) องค์กรต่อต้านคอร์รัปชัน (ประเทศไทย) HAND Enterprise และสำนักงานคณะกรรมการพัฒนาระบบราชการ (ก.พ.ร.). โครงการ Citizen Feedback, 29 สิงหาคม 2562. http://www.easyfeedback.org/",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "c"
  },
  {
    keyword: "citizen watchdogs",
    meaning: "อาสาสมัครประชาชน",
    source:
      "สนธิ คชวัฒน์ ผู้ทรงคุณวุฒิด้านสิ่งแวดล้อมและสุขภาพ สภาวิชาชีพวิทยาศาสตร์และเทคโนโลยี. ข้อเท็จจริงและแนวทางการลดและป้องกันฝุ่น 2.5, 16 ตุลาคม 2562. https://apps.hpc.go.th/dl/web/upFile/2019/02-5034-20190204133800/ebfea8c5214f7dab73206ffe3609adc1.pdf",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "c"
  },
  {
    keyword: "cloud computing",
    meaning:
      "บริการประมวลผลด้วยการใช้ทรัพยากรคอมพิวเตอร์ร่วมกันผ่านเครือข่ายตามความต้องการได้อย่างสะดวก โดยมีรูปแบบ ดังนี้\r\n1. การให้บริการโครงสร้างพื้นฐานหลัก (Infrastructure as a Service: IaaS) ประกอบด้วยระบบประมวลผลข้อมูล ระบบการจัดเก็บข้อมูล ระบบเครือข่าย และทรัพยากรพื้นฐานอื่นๆที่เกี่ยวข้องกับระบบประมวลผล ผู้ใช้บริการสามารถใช้งานซอฟต์แวร์บนโครงสร้างพื้นฐานและทรัพยากรที่ผู้ให้บริการจัดหาให้ได้อย่างมีประสิทธิภาพ โดยไม่ต้องบริหารจัดการโครงสร้างพื้นฐานที่จำเป็นด้วยตนเอง \r\n2. การให้บริการแพลตฟอร์ม (Platform as a Service: PaaS) ประกอบด้วย ระบบโปรแกรมงานคอมพิวเตอร์ ระบบฐานข้อมูล และระบบจัดการหรืองานบริการจากคอมพิวเตอร์ ผู้ใช้บริการสามารถพัฒนา ติดตั้ง และปรับแต่งซอฟต์แวร์ได้ โดยไม่ต้องบริหารจัดการในส่วนที่เกี่ยวข้องกับโครงสร้างพื้นฐาน เครือข่าย ระบบปฏิบัติการ และระบบจัดการฐานข้อมูล \r\n3. การให้บริการซอฟต์แวร์ (Software as a Service: SaaS) ผู้ให้บริการจัดเตรียมซอฟต์แวร์สำเร็จรูปแล้ว โดยผู้ใช้บริการสามารถกำหนดค่าความต้องการ พารามิเตอร์ ปริมาณหน่วยประมวลผลข้อมูล หน่วยเก็บข้อมูล และบริหารจัดการเพื่อให้ได้บริการตามวัตถุประสงค์ \r\n4. การให้บริการใดที่เป็นการรวมกันของสองบริการขึ้นไป จาก ข้อ 1 ถึง 3 \r\n5. การให้บริการอื่นที่ประกาศกำหนด",
    source:
      "ประกาศคณะกรรมการธุรกรรมทางอิเล็กทรอนิกส์ เรื่อง แนวทางการใช้บริการคลาวด์ พ.ศ. 2562. (2562, 11 มิถุนายน). ราชกิจจานุเบกษา. เล่ม 136 ตอนพิเศษ 149 ง.http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/E/149/T_0039.PDF",
    sappear: "",
    mappear: "",
    rappear: "4,9",
    firstalpha: "c"
  },
  {
    keyword: "Coal Bed Methane (CBM)",
    meaning:
      "ก๊าซมีเทนในชั้นถ่านหิน (Coal Bed Methane) มีส่วนประกอบและนำมาใช้ประโยชน์ได้เช่นเดียวกับก๊าซมีเทนในก๊าซธรรมชาติ แต่ต่างกันที่พบอยู่ในชั้นถ่านหิน ก๊าซมีเทนที่เกิดขึ้นจะสะสมตัวในลักษณะละลายอยู่ในชั้นน้ำ และแทรกซึมอยู่ในรอยแตกในชั้นถ่านหิน การนำก๊าซมีเทนมาใช้ประโยชน์จะต้องสูบน้ำออกจากหลุมผลิตให้ความกดดันในหลุมผลิตลดลงมากที่สุด เพื่อให้ก๊าซมีเทนซึ่งมีความดันต่ำไหลออกมาได้ ",
    source:
      "กรมเชื้อเพลิงธรรมชาติ กระทรวงพลังงาน. (2561). ก๊าซธรรมชาติ คอนเดนเสท LPG LNG CNG LCNG ก๊าซมีเทนในชั้นถ่านหิน ก๊าซโซฮอล์ และไบโอดีเซล คืออะไร, 26 กันยายน 2562. https://dmf.go.th/public/list/data/detail/id/11261/menu/604/page/2",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "c"
  },
  {
    keyword: "Collective Action Coalition against Corruption : CAC",
    meaning: "โครงการแนวร่วมปฏิบัติของภาคเอกชนไทยในการต่อต้านทุจริต",
    source:
      "สำนักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์. การทุจริตคอรัปชัน (Anti-corruption), 26 กันยายน 2562. https://www.sec.or.th/cgthailand/TH/Pages/corruption.aspx",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "c"
  },
  {
    keyword: "Common KPIs",
    meaning:
      "กลุ่มตัวชี้วัดร่วมกำหนดขึ้นโดยฝ่ายวางแผนและประเมินทรัพยากรบุคคล พิจารณาร่วมกับคณะทำงานปรับปรุงและกำหนดตัวชี้วัดผลการปฏิบัติงานของพนักงานรายบุคคลทุกระดับชั้น เพื่อให้ตัวชี้วัดผลการปฏิบัติงานของพนักงานสอดคล้องกับยุทธศาสตร์ และเป้าหมายขององค์กร",
    source:
      "การประปาส่วนภูมิภาค. คู่มือมาตรฐานตัวชี้วัด (KPIs Dictionary), 26 กันยายน 2562. http://www.oic.go.th/FILEWEB/CABINFOCENTER20/DRAWER038/GENERAL/DATA0000/00000096.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "c"
  },
  {
    keyword: "Competency",
    meaning:
      "กลุ่มของทักษะ ความรู้ ความสามารถ รวมทั้งพฤติกรรม คุณลักษณะและทัศนคติที่บุคลากรจำเป็นต้องมีเพื่อปฏิบัติงานอย่างมีประสิทธิภาพ ประสิทธิผล และเพื่อให้บรรลุผลสำเร็จตรงตามวัตถุประสงค์และเป้าหมายขององค์กร",
    source:
      "สำนักงานคณะกรรมการข้าราชการพลเรือน. การพัฒนาสมรรถนะหลัก (สําหรับข้าราชการใหม่), 29 สิงหาคม 2562. https://www.ocsc.go.th/sites/default/files/attachment/page/aptitude_development.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "c"
  },
  {
    keyword: "Competitive Advantage",
    meaning:
      "สิ่งที่เป็นความสามารถพิเศษขององค์กรที่คู่แข่งไม่สามารถเลียนแบบได้ หรือคู่แข่งต้องใช้เวลาในการปรับตัวเองมากก่อนที่เลียบแบบความสามารถของเราได้ เช่น นวัตกรรม ระบบการจัดการภายในองค์กร ระบบการบริหารองค์กร ภาพลักษณ์ขององค์กรเป็นต้น ปัจจัยที่เป็นพื้นฐานที่สำคัญมากที่สุดในการทำให้เกิดความได้เปรียบในการแข่งขันก็คือ ความรู้ (Knowledge) ที่องค์กรต้องพยายามสร้างขึ้นมา ด้วยการเรียนรู้ (Learning) และพัฒนามาเป็นองค์กรแห่งการเรียนรู้  (Learning Organization) ให้ได้ จากนั้นผู้บริหารต้องดึงเอาความรู้ต่าง ๆ ที่บุคลากรมี เพื่อมาสร้างนวัตกรรม (Innovation) ให้กับองค์กรต่อไป",
    source:
      "บริษัท ซีพีแอล คอนซัลติ้ง เอนจิเนียริ่ง. ความได้เปรียบในการแข่งขัน, 26 กันยายน 2562.\r\nhttp://www.cpl-consult.com/Document/General/Document_general_1.html\r\n",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "c"
  },
  {
    keyword: "competitive neutrality",
    meaning:
      "การวางตัวเป็นกลาง (Competitive Neutrality) ในการแข่งขันของภาครัฐ โดยหน่วยงานรัฐจะต้องถือหลักการว่าด้วยความเป็นกลางในการแข่งขันทางการค้าระหว่างรัฐวิสาหกิจและเอกชนเพื่อสร้างให้เกิดประสิทธิภาพในการแข่งขัน ซึ่งหลักการว่าด้วยความเป็นกลางเป็นการทำให้เห็นว่าการดำเนินการเดิมของรัฐที่สนับสนุนรัฐวิสาหกิจในแบบเดิมจะต้องมีการเปลี่ยนแปลงและปรับปรุงเพื่อสร้างให้เกิดตลาดใหม่ที่มีการแข่งขัน",
    source:
      "ศาสตราจารย์ ดร.ศักดา ธนิตกุล อาจารย์ประจำ คณะนิติศาสตร์ จุฬาลงกรณ์มหาวิทยาลัย. (2561). กฎหมายกับเศรษฐกิจ, 4 ตุลาคม 2562. http://www.library.law.chula.ac.th/home/file.aspx?ID=1003",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "c"
  },
  {
    keyword: "Computer Literacy",
    meaning: "การรู้คอมพิวเตอร์ขั้นพื้นฐาน",
    source:
      "สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ (สวทช.). 4 ด้านของการรู้สารสนเทศ (information literacy), 26 กันยายน 2562. https://www.nstda.or.th/th/nstda-knowledge/2843-4-facets-of-information-literacy",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "c"
  },
  {
    keyword: "conflict of roles",
    meaning:
      "ความขัดแย้งระหว่างบทบาท คือ การที่บุคคลดำรงตำแหน่งที่มีบทบาทสองบทบาทขัดแย้งกัน",
    source:
      "สำนักงานคณะกรรมการนโยบายวิทยาศาสตร์ เทคโนโลยีและนวัตกรรมแห่งชาติ. คู่มือป้องกันผลประโยชน์ทับซ้อน, 10 rฤษภาคม 2562. http://anti-corruption.nxpo.or.th/wp-content/uploads/2018/04/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%9C%E0%B8%A5%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B9%82%E0%B8%A2%E0%B8%8A%E0%B8%99%E0%B9%8C%E0%B8%97%E0%B8%B1%E0%B8%9A%E0%B8%8B%E0%B9%89%E0%B8%AD%E0%B8%99-conflict-of-interrest.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "c"
  },
  {
    keyword: "Corruption Perceptions Index : CPI",
    meaning:
      "ดัชนีการรับรู้การทุจริต (CPI) เป็นดัชนีสะท้อนภาพลักษณ์ (Perceptions) การทุจริตคอร์รัปชันของประเทศต่างๆทั่วโลก ซึ่งจัดทำขึ้นโดยองค์กรเพื่อความโปร่งใสนานาชาติ (TI) เป็นประจำทุกปี นักลงทุนหรือนักธุรกิจหลายประเทศใช้ดัชนี CPI เพื่อประเมินความน่าสนใจลงทุนของแต่ละประเทศ โดยมองว่าการทุจริตคอร์รัปชัน เป็นหนึ่งในปัจจัยที่เป็นต้นทุนหรือเป็นความเสี่ยง (risks) ในการเข้ามาประกอบธุรกิจ\r\nการจัดทำดัชนีการรับรู้การทุจริตขององค์กรเพื่อความโปร่งใสนานาชาติ ได้รวบรวมข้อมูลด้านการทุจริตคอร์รัปชันจากฐานข้อมูลที่เป็นการจัดอันดับหรือดัชนีชี้วัดซึ่งจัดทำขึ้นโดยหน่วยงานที่น่าเชื่อถือต่างๆ ทั่วโลก ",
    source:
      "สำนักงานคณะกรรมการป้องกันและปราบปรามการทุจริตแห่งชาติ. ข้อเสนอแนะเพื่อยกระดับดัชนีการรับรู้การทุจริต (Corruption Perceptions Index: CPI). 3 กันยายน 2562. https://www.nacc.go.th/article_attach/ExecutiveSummaryCPI.pdf",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "c"
  },
  {
    keyword: "CSR",
    meaning:
      "ความรับผิดชอบต่อสังคมและสิ่งแวดล้อมขององค์กร ซึ่งคือการดำเนินกิจการภายใต้หลักจริยธรรมและการจัดการที่ดี โดยรับผิดชอบสังคมและสิ่งเเวดล้อมทั้งในระดับไกลและใกล้ นำไปสู่การพัฒนาที่ยั่งยืน",
    source:
      "ห้องสมุดโรงเรียนช่างฝีมือทหาร. CSR คือ อะไร, 26 กันยายน 2562. http://61-90-231-85.static.asianet.co.th/mttslibrary/index.php/2015-05-29-16-17-20\r\n",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "c"
  },
  {
    keyword: "Cyber Security",
    meaning:
      "กระบวนการหรือการกระทำทั้งหมดที่จำเป็นเพื่อทำให้องค์กรปราศจากความเสี่ยง และความเสียหายที่มีผลต่อความปลอดภัยของข้อมูลข่าวสาร (Information) ในทุกรูปแบบ รวมถึงการระวังป้องกันต่อการอาชญากรรม การโจมตี การบ่อนทำลาย การจารกรรม และความผดพลาดต่างๆ โดยควรคำนึงถึงองค์ประกอบพื้นฐานของความปลอดภัยของข้อมูล หรือ CIA 3 ประการ ได้แก่ การรักษาความลับของข้อมูล (Confidentiality) การรักษาความคงสภาพของข้อมูลหรือความสมบูรณ์ของข้อมูล (Integrity) และความพร้อมใช้งานของข้อมูล (Availability)",
    source:
      "สำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน). ความมั่นคงปลอดภัยทางไซเบอร์ (Cyber Security), 26 กันยายน 2562. https://dga.or.th/upload/download/file_769c60982e4c374dcd33b41c29227a31.pdf",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "c"
  },
  {
    keyword: "Deep Water",
    meaning: "น้ำชั้นล่างมีอุณหภูมิต่ำ ความเค็มและความหนาแน่นสูงมาก",
    source:
      "ศูนย์การเรียนรู้วิทยาศาสตร์โลกและดาราศาสตร์. น้ำทะเล, 3 ตุลาคม 2562. https://sites.google.com/a/lesa.biz/www/earth/hydrosphere/sea-water",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "d"
  },
  {
    keyword: "Digital Evolution Index",
    meaning:
      "The Fletcher School at Tufts University ได้แบ่ง 50 ประเทศชั้นนำตามระดับความก้าวหน้าทางดิจิตอลและโอกาสในการพัฒนาเป็น 4 กลุ่ม คือ\r\n1. Stand Out (กลุ่มโดดเด่น)\r\n2. Stall Out (กลุ่มชะงักงัน) \r\n3. Break Out (กลุ่มอุบัติใหม่) \r\n4. Watch Out (กลุ่มเฝ้าระวัง)\r\nซึ่งไทยถูกจัดให้อยู่ในกลุ่มอุบัติใหม่ (Break Out)\r\n\r\n",
    source:
      "ศูนย์ศึกษายุทธศาสตร์ สถาบันวิชาการป้องกันประเทศ. (2558). โอกาสและความก้าวหน้า “เศรษฐกิจดิจิตอล” ของไทย, 3 ตุลาคม 2562. http://www.sscthailand.org/uploads_ssc/%E0%B8%89%E0%B8%9A%E0%B8%B1%E0%B8%9A%E0%B8%97%E0%B8%B5%E0%B9%88%2011-58%20%E0%B9%82%E0%B8%AD%E0%B8%81%E0%B8%B2%E0%B8%AA%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%81%E0%B9%89%E0%B8%B2%E0%B8%A7%E0%B8%AB%E0%B8%99%E0%B9%89%E0%B8%B2%20%E0%B9%80%E0%B8%A8%E0%B8%A3%E0%B8%A9%E0%B8%90%E0%B8%81%E0%B8%B4%E0%B8%88%E0%B8%94%E0%B8%B4%E0%B8%88%E0%B8%B4%E0%B8%95%E0%B8%AD%E0%B8%A5%20%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B9%84%E0%B8%97%E0%B8%A2.pdf ",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "d"
  },
  {
    keyword: "Distributed Energy Resources",
    meaning: "แหล่งพลังงานทางเลือกสะอาดที่กระจายอยู่ทั่วไป",
    source:
      "สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ (สวทช.). (2557).  ระบบโครงข่ายไฟฟ้าอัจฉริยะ : From Smart Grid to Smart Cities, 26 กันยายน 2562. http://www2.mtec.or.th/eventnstda/Template/index.aspx?EventID=S14069&ContentID=2165",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "d"
  },
  {
    keyword: "Earned Income",
    meaning:
      "เงินได้เนื่องจากการทำงาน เป็นเงินได้ประเภทที่เป็นค่าตอบแทน หรือจากการใช้น้ำพักน้ำแรงจากการทำงานหรือประกอบสัมมาชีพ ",
    source:
      "สำนักงานเศรษฐกิจการคลัง. (2557). เงินโอน แก้จน คนขยัน, 3 ตุลาคม 2562. http://www.fpo.go.th/main/getattachment/General-information-public-service/FPO-symposium/8515/NIT_Symposium_Benge_25-7-57.pdf.aspx",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "e"
  },
  {
    keyword: "Eastern Seaboard",
    meaning:
      'โครงการพัฒนาพื้นที่บริเวณชายฝั่งทะเลตะวันออก (Eastern Seaboard Development Program : ESB) หรือที่ทุกคนเรียกว่า "Eastern Seaboard" ซึ่งเป็นการพัฒนาพื้นที่บริเวณภาคตะวันออกของไทย 3 จังหวัดนั้นคือ 1) แหลมฉบัง จังหวัดชลบุรี 2) มาบตาพุด จังหวัดระยอง และ3) จังหวัดฉะเชิงเทรา เป็นการเปลี่ยนแปลงจากอุตสาหกรรมเบามาเป็นอุตสาหกรรมหนัก ',
    source:
      "หน่วยวิเคราะห์เศรษฐกิจมหภาคในประเทศ ส่วนเศรษฐกิจมหภาคศูนย์วิจัยเศรษฐกิจ ธุรกิจและเศรษฐกิจฐานราก. (2561).  EEC ภาคต่อ Eastern Seaboard ก้าวสำคัญการลงทุนไทย, 2 กันยายน 2562. https://www.gsb.or.th/getattachment/a7529f4e-ae04-44cd-9d50-e2bf9588bd7f/14MC_hotissue_internet_EEC_ex.aspx",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "e"
  },
  {
    keyword: "economic cost-benefit analysis",
    meaning:
      "การวิเคราะห์โครงการทางเศรษฐศาสตร์ เป็นเครื่องมือที่ใช้วิเคราะห์ในการจัดสรรทรัพยากรที่มีอยู่ให้มีความคุ้มค่ามากที่สุด",
    source:
      "มหาวิทยาลัยสุโขทัยธรรมาธิราช. การวิเคราะห์โครงการ : มุมมองทางการเงินและทางเศรษฐศาสตร์, 10 พฤษภาคม 2562. \r\nhttps://www.stou.ac.th/stouonline/lom/data/sec/Lom14/03-01.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "e"
  },
  {
    keyword: "Economic Planning Unit: EPU",
    meaning:
      "สำนักงานวางแผนเศรษฐกิจแห่งชาติ เป็นหน่วยงานที่กำกับดูแลกฎระเบียบด้านการทำธุรกรรมเกี่ยวกับการครอบครองอสังหาริมทรัพย์ของ “Foreign Interest”\r\n“Foreign Interest” ในที่นี้หมายถึง\r\n1. บุคคลที่ไม่ใช่ชาวมาเลเซีย และ/หรือ\r\n2. บุคคลที่ถือสถานภาพเป็นผู้มีถิ่นพ านักถาวรของมาเลเซีย (Permanent Resident) และ/หรือ\r\n3. บริษัทต่างประเทศ หรือสถาบันต่างประเทศ และ/หรือ\r\n4. บริษัทหรือสถาบันที่จัดตั้งในมาเลเซีย และมีผู้ถือหุ้นประเภทที่ระบุในข้อ 1, 2 และ 3 ข้างต้น มีสิทธิ์ออก\r\nเสียงมากกว่า 50%\r\n",
    source:
      "ศูนย์พัฒนาการค้าและธุรกิจไทยในอาเซียน สำนักงานส่งเสริมการค้าระหว่างประเทศ ณ กรุงกัวลาลัมเปอร์ ประเทศมาเลเซีย. การครอบครองอสังหาริมทรัพย์, 15 พฤษภาคม 2562. https://ditp.go.th/contents_attach/92563/92563.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "e"
  },
  {
    keyword: "e-government",
    meaning:
      "รัฐบาลอิเล็กทรอนิกส์ เป็นการนำเทคโนโลยีสารสนเทศ ฮาร์ดแวร์ หรือซอฟต์แวร์เข้ามามีส่วนช่วยในการพัฒนารัฐบาลอิเล็กทรอนิกส์ เพื่อลดช่องว่าง ลดความเหลื่อมล้ำทางสังคม ซึ่งเป็นการยกเลิกวิธีปฏิบัติงานแบบเดิมที่เป็นอุปสรรคในการทำงาน การปฏิรูประบบ\r\nการปฏิบัติงานภาครัฐเพื่อให้บรรลุเป้าหมายอย่างมีประสิทธิภาพ",
    source:
      "สำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน). รายงานการศึกษาและการยกระดับ UN e - Government Readiness Ranking 2012, 30 กันยายน 2562. http://old.ega.or.th/Content.aspx?c_id=399",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "e"
  },
  {
    keyword: "EIA",
    meaning:
      "หรือ Environmental Impact Assessment หมายถึง การประเมินผลกระทบสิ่งแวดล้อม ซึ่งเป็นกระบวนการศึกษาและประเมินผลที่อาจเกิดขึ้นจากการดําเนินโครงการหรือกิจการหรือการดําเนินการใดของรัฐหรือที่รัฐจะอนุญาตให้มีการดําเนินการที่อาจมีผลกระทบต่อทรัพยากรธรรมชาติ คุณภาพสิ่งแวดล้อม สุขภาพ อนามัย คุณภาพชีวิตหรือส่วนได้เสียอื่นใดของประชาชนหรือชุมชน ทั้งทางตรงและทางอ้อม โดยผ่านกระบวนการการมีส่วนร่วมของประชาชน เพื่อกําหนดมาตรการป้องกันแก้ไขผลกระทบดังกล่าว ผลการศึกษาเรียกว่า รายงานการประเมินผลกระทบสิ่งแวดล้อม",
    source:
      "พระราชบัญญัติส่งเสริมและรักษาคุณภาพสิ่งแวดล้อมแห่งชาติ (ฉบับที่ 2) พ.ศ. 2561 (2561, 19 เมษายน). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 27 ก หน้า 30.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/027/29.PDF",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "e"
  },
  {
    keyword: "e-logistics",
    meaning:
      "กระบวนการทำงานที่เกี่ยวข้องกับการวางแผนการดำเนินการ และการควบคุมการทำงานขององค์กร รวมทั้งการบริหารจัดการข้อมูลและธุรกรรมทางการเงินที่เกี่ยวข้องให้เกิดการเคลื่อนย้าย การจัดเก็บ การรวบรวม การกระจายสินค้าวัตถุดิบชิ้นส่วนประกอบ และการบริการ ให้มีประสิทธิภาพ และประสิทธิผลสูงสุดโดยคำนึงถึงความต้องการและความพึงพอใจของลูกค้าเป็นสำคัญ และระบบโลจิสติกส์ก็เป็นกระบวนการหนึ่งของการจัดการสินค้าและบริการตลอดห่วงโซ่อุปทาน",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์ (สพธอ). (2556). คลังความรู้ Logistics และ e-logistics, 28 สิงหาคม 2562. https://www.etda.or.th/terminology-detail/1563.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "e"
  },
  {
    keyword: "environmental value",
    meaning:
      "คุณค่าของสิ่งแวดล้อม เป็นคุณค่าทั้งหมดรวมไปถึงคุณค่าที่ประเมินเป็นตัวเงินไม่ได้ และคุณค่าที่มนุษย์ไม่ได้เป็นผู้กำหนดเข้าไป\r\n",
    source:
      "กรมป่าไม้. (2555). ความสำคัญของนิเวศวิทยาต่อสิ่งแวดล้อม, 3 ตุลาคม 2562. http://biodiversity.forest.go.th/index.php?option=com_content&view=article&id=529:2012-08-24-09-02-42&catid=25:the-project&Itemid=68",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "e"
  },
  {
    keyword: "EPU",
    meaning: "สำนักงานวางแผนเศรษฐกิจ มาเลเซีย (Economic Planning Unit: EPU) ",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. (2561). สศช.และสำนักงานวางแผนเศรษฐกิจ มาเลเซีย (Economic Planning Unit: EPU) ร่วมขับเคลื่อนการพัฒนาพื้นที่ชายแดนไทย-มาเลเซียภายใต้แผนงาน JDS, 4 กันยายน 2562. https://www.nesdb.go.th/ewt_news.php?nid=7481&filename=index\r\n(เว็บไซต์เข้าไม่ได้)",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "e"
  },
  {
    keyword: "Evidence-based Policy Making",
    meaning:
      "แนวคิดที่สนับสนุนให้การกำหนดนโยบายของรัฐมีความสมเหตุสมผลและเป็นระบบ โดยเฉพาะอย่างยิ่งในขั้นตอนของการตัดสินใจซึ่งควรคำนึงถึงและดำเนินการบนฐานของข้อมูลที่ดีและเพียงพอ",
    source:
      "ธีรพัฒน์ อังศุชวาล. (2557). การถ่ายโอนนโยบายสาธารณะ(Policy Transfer)ในกระบวนการกำหนดนโยบสยสื่อสาธารณะแห่งประเทศไทย, 3 กันยายน 2562. http://www.library.polsci.chula.ac.th/dl/d5cd433b9c3ece086770463e7cc3a80f",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "e"
  },
  {
    keyword: "Ex Ante Assessment",
    meaning: "การประเมินผลการวิจัยก่อนดำเนินการวิจัย",
    source:
      "สุนันทา สมพงษ์ ที่ปรึกษาการวิจัย สำนักงานคณะกรรมการวิจัยแห่งชาติ. (2560). การติดตามและประเมินผลการวิจัยและการประเมินการใช้ประโยชน์จากงานวิจัย, 21 ตุลาคม 2562. http://www.arda.or.th/datas/file/1494926486.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "e"
  },
  {
    keyword: "FDI",
    meaning:
      "การที่บริษัทที่ตั้งอยู่ในต่างประเทศหรือประเทศที่\r\nจะมาลงทุน (Source Countries) ต้องการมาลงทุนทําธุรกิจในประเทศไทยหรือประเทศที่รับการลงทุน (Host Countries) เพื่อสร้างผลกําไรส่งกลับไปยังบริษัทในประเทศของตน ซึ่งการลงทุนโดยตรงจากต่างประเทศ สามารถแบ่งตามผลกระทบต่อการค้าระหว่างประเทศได้เป็น 2 ประเภทใหญ่ๆ ได้แก่ \r\n1. การลงทุนโดยตรงจากต่างประเทศในแนวนอน (Horizontal FDI) \r\n2. การลงทุนโดยตรงจากต่างประเทศในแนวตั้ง (Vertical FDI)",
    source:
      "สำนักงานเลขาธิการสภาผู้แทนราษฎร. การลงทุนโดยตรงจากต่างประเทศ (Foreign Direct Investment: FDI) ในประเทศไทย, 10 มิถุนายน 2562. https://library2.parliament.go.th/ejournal/content_af/2557/may2557-2.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "f"
  },
  {
    keyword: "financing requirement",
    meaning: "ความต้องการทางการเงิน",
    source:
      "กรมตรวจบัญชีสหกรณ์. เงินเบิกเกินบัญชีธนาคาร(Overdraft หรือ Overdraw หรือ O/D), 3 ตุลาคม 2562. https://www.cad.go.th/cadweb_client/ewt_news.php?nid=2521&filename=index",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "f"
  },
  {
    keyword: "Flagship Project",
    meaning:
      "โครงการสำคัญที่ตอบสนองต่อเป้าหมายเชิงยุทธศาสตร์ของประเทศใน4 ด้าน ประกอบด้วย\r\n1.การเพิ่มรายได้จากฐานเดิม\r\n2.การสร้างรายได้จากโอกาสใหม่\r\n3.การเพิ่มประสิทธิภาพในการแข่งขัน\r\n4.การลดรายจ่าย",
    source:
      "สำนักปลัดกระทรวงทรัพยากรธรรมชาติและสิ่งแวดล้อม. ยุทธศาสตร์กระทรวงทรัพยากรธรรมชาติและสิ่งแวดล้อม พ.ศ. 2556-2561, 3 ตุลาคม 2562. http://www.reo01.mnre.go.th/attachment/iu/download.php?WP=nKI4nKN5oGE3ZHkCoMOahKGtnJg4WaNjoGI3ARjkoH9axUF5nrO4MNo7o3Qo7o3Q",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "f"
  },
  {
    keyword: "fragmented",
    meaning:
      "อัตลักษณ์ในหน่วยงานและคนขององค์กรที่มากเกินไปสามารถทำให้องค์กรอ่อนแอได้ หรือเกิดความแตกแยก",
    source:
      "อุษาศิริ สิริสุขะ สถาบันรับรองมาตรฐานไอเอสโอ. (2551). จิตวิญญาณขององค์กร, 10 ตุลาคม 2562. https://www.masci.or.th/upload/insightfile/AW_MASCInsight%201-24.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "f"
  },
  {
    keyword: "Futurist and Scenario Analysis",
    meaning:
      "การวิเคราะห์สถานการณ์ที่เป็นไปได้ในอนาคตขององค์กรในหลายๆทาง โดยอาศัยเหตุการณ์ที่เกิดขึ้นจากแนวโน้มในปัจจุบันรวมกับความไม่แน่นอนต่างๆที่เกิดขึ้นในอนาคตเพื่อนำไปสู่การวางแผนรับมือได้อย่างเหมาะสม",
    source:
      "สำนักนโยบายและยุทธศาสตร์. มารู้จัก Scenario Analysis (การวิเคราะห์พยากรณ์แนวโน้ม)  ใน 1 หน้ากัน, 17 ธันวาคม 2562. http://bps.sueksa.go.th/wp-content/uploads/2017/03/Scenario-Analysis-Infographic.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "f"
  },
  {
    keyword: "Global Issues",
    meaning:
      "ปัญหา /ข้อกังวลที่เกี่ยวข้องกับทั่วโลก ผลกระทบต่อประชาคมโลก และเป็นปัญหาที่ไม่สามารถแก้ไขได้โดยลําพังประเทศเดียว ต้องอาศัยความร่วมมือในกรอบพหุภาคีเป็นหลัก เช่น ประชาธิปไตย สิ่งแวดล้อม การเปลี่ยนแปลงสภาพภูมิอากาศ การพัฒนา มนุษยธรรมและความช่วยเหลือด้านภัยพิบัติ สาธารณสุข สันติภาพและความมั่นคง สิทธิมนุษยชน การก่อการร้าย สตรี น้ำ\r\nและประเด็นระดับโลกที่เห็นว่ามีความสําคัญต่อไทย ได้แก่ \r\n- สิ่งแวดล้อม /การพัฒนาเชิงอนุรักษ์สิ่งแวดล้อม/ความหลากหลายทางชีวภาพ\r\n- สิทธิมนุษยชน / การโยกย้ายถิ่นฐาน / ประชาธิปไตย และการทุจริต\r\n- ความมั่นคงของมนุษย์/ สาธารณสุข/ยาเสพติด/ความมั่นคงทางอาหารและเกษตรกรรม\r\n- สันติภาพและความมั่นคงระหว่างประเทศ /การลดอาวุธ/การต่อต้านการก่อการร้าย\r\n- การพัฒนา /การบริหารจัดการและการเตรียมรับภัยพิบัติ\r\n- การพึ่งพิงทางเศรษฐกิจ /การค้าระหว่างประเทศ/ความเชื่อมโยงระดับโลก/ สิทธิบัตรทรัพย์สินทางปัญญา\r\n- พลังงาน\r\n- สื่อระหว่างประเทศ และความมั่นคงแห่งชาติ\r\n- การอนุวัติการสนธิสัญญาระหว่างประเทศ",
    source:
      "นางสาวสวียา สันติพิทักษ์ กระทรวงการต่างประเทศ. (2554). การปรับโครงสร้างกรมองค์การระหว่างประเทศเพื่อรองรับประเด็นระดับโลก(Global Issues), 10 ตุลาคม 2562. http://www.mfa.go.th/dvifa/contents/filemanager/files/nbt/nbt3/IS3016.pdf",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "g"
  },
  {
    keyword: "GPS",
    meaning: "ระบบนำทางผ่านดาวเทียม",
    source:
      "กระทรวงศึกษาธิการ. (2552). การเลือกซื้อ GPS Receiver, 30 กันยายน 2562. http://www.moe.go.th/moe/th/news/detail.php?NewsID=12212&Key=itnews",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "g"
  },
  {
    keyword: "Gross domestic Expenditure on R&D : GERD)",
    meaning:
      "ค่าใช้จ่ายทางการวิจัยและพัฒนาของประเทศทั้งหมด ประกอบด้วย\r\n1. ค่าใช้จ่ายทางการวิจัยและพัฒนาของประเทศรวมทั้งหมด (การลงทุนภาครัฐ การลงทุนภาคเอกชน และแหล่งทุนอื่น ๆ)\r\n2. สัดส่วนการลงทุนด้าน R&D ของภาครัฐ (งบประมาณแผ่นดิน) ต่อที่ไม่ใช่งบประมาณแผ่นดินทั้งหมด\r\n3. สัดส่วนการลงทุนด้าน R&D ของภาครัฐ (งบประมาณแผ่นดิน) ต่อภาคเอกชน\r\n4. สัดส่วนค่าใช้จ่าย R&D ที่ดำเนินการวิจัยในภาคเอกชนต่อภาคอื่น ๆ รวมทั้งหมด\r\n5. ร้อยละของค่าใช้จ่ายทางการวิจัยและพัฒนาของประเทศต่อผลิตภัณฑ์มวลรวม\r\n6. ร้อยละของงบประมาณแผ่นดินด้านการวิจัยและพัฒนาต่องบประมาณรายจ่ายประจำปีงบประมาณ พ.ศ. 2560\r\n7. ค่าใช้จ่ายทางการวิจัยและพัฒนาของประเทศต่อจำนวนนักวิจัย 1 คน\r\n8. ค่าใช้จ่ายทางการวิจัยและพัฒนาของประเทศต่อประชากร 1 คน",
    source:
      "สำนักงานคณะกรรมการวิจัยแห่งชาติ. รายงานการสำรวจค่าใช้จ่ายและบุคลากรทางการวิจัยและพัฒนาของประเทศไทย ประจำปี 2561, 3 ตุลาคม 2562. https://www.research.chula.ac.th/wp-content/uploads/2019/12/NRCT-%E0%B8%A3%E0%B8%B2%E0%B8%A2%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%AA%E0%B8%B3%E0%B8%A3%E0%B8%A7%E0%B8%88%E0%B8%84%E0%B9%88%E0%B8%B2%E0%B9%83%E0%B8%8A%E0%B9%89%E0%B8%88%E0%B9%88%E0%B8%B2%E0%B8%A2%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%9A%E0%B8%B8%E0%B8%84%E0%B8%A5%E0%B8%B2%E0%B8%81%E0%B8%A3%E0%B8%A7%E0%B8%B4%E0%B8%88%E0%B8%B1.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "g"
  },
  {
    keyword: "high end",
    meaning: "อุปกรณ์ระดับสูง",
    source:
      "ฝ่ายวิจัยนโยบาย สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ. (2560). อุตสาหกรรมยานยนต์ไฟฟ้า, 7 ตุลาคม 2562. https://waa.inter.nstda.or.th/prs/pub/whitepaper_EVV2.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "h"
  },
  {
    keyword: "Holistic approach",
    meaning:
      "การบริหารจัดการทรัพยากรธรรมชาติและสิ่งแวดล้อม โดยคำนึงถึงความสัมพันธ์เชิงระบบหรือองค์รวม ซึ่งมีวัตถุประสงค์เพื่อการดำรงอยู่ของระบบนิเวศอย่างสมดุล และการตอบสนองต่อความต้องการของมนุษย์ในการใช้ประโยชน์จากทรัพยากรธรรมชาติและสิ่งแวดล้อมอย่างยั่งยืน",
    source:
      "จริยา มหาเทียร หลักสูตรพุทธศาสตรดุษฎีบัณฑิต มหาวิทยาลัยมหาจุฬาลงกรณราชวิทยาลัย. (2559). การจัดการทรัพยากรธรรมชาติและสิ่งแวดล้อม, 10 ตุลาคม 2562. https://www.google.com/search?ei=1baZXuDVO6SG4-EP6OGAkAw&q=%E0%B8%A3%E0%B8%B4%E0%B8%A2%E0%B8%B2+%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B9%80%E0%B8%97%E0%B8%B5%E0%B8%A2%E0%B8%A3+%E0%B8%AB%E0%B8%A5%E0%B8%B1%E0%B8%81%E0%B8%AA%E0%B8%B9%E0%B8%95%E0%B8%A3%E0%B8%9E%E0%B8%B8%E0%B8%97%E0%B8%98%E0%B8%A8%E0%B8%B2%E0%B8%AA%E0%B8%95%E0%B8%A3%E0%B8%94%E0%B8%B8%E0%B8%A9%E0%B8%8E%E0%B8%B5%E0%B8%9A%E0%B8%B1%E0%B8%93%E0%B8%91%E0%B8%B4%E0%B8%95+%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B8%A7%E0%B8%B4%E0%B8%97%E0%B8%A2%E0%B8%B2%E0%B8%A5%E0%B8%B1%E0%B8%A2%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B8%88%E0%B8%B8%E0%B8%AC%E0%B8%B2%E0%B8%A5%E0%B8%87%E0%B8%81%E0%B8%A3%E0%B8%93%E0%B8%A3%E0%B8%B2%E0%B8%8A%E0%B8%A7%E0%B8%B4%E0%B8%97%E0%B8%A2%E0%B8%B2%E0%B8%A5%E0%B8%B1%E0%B8%A2.+%282559%29.+%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%88%E0%B8%B1%E0%B8%94%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%97%E0%B8%A3%E0%B8%B1%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%81%E0%B8%A3%E0%B8%98%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B8%8A%E0%B8%B2%E0%B8%95%E0%B8%B4%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%AA%E0%B8%B4%E0%B9%88%E0%B8%87%E0%B9%81%E0%B8%A7%E0%B8%94%E0%B8%A5%E0%B9%89%E0%B8%AD%E0%B8%A1&oq=%E0%B8%A3%E0%B8%B4%E0%B8%A2%E0%B8%B2+%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B9%80%E0%B8%97%E0%B8%B5%E0%B8%A2%E0%B8%A3+%E0%B8%AB%E0%B8%A5%E0%B8%B1%E0%B8%81%E0%B8%AA%E0%B8%B9%E0%B8%95%E0%B8%A3%E0%B8%9E%E0%B8%B8%E0%B8%97%E0%B8%98%E0%B8%A8%E0%B8%B2%E0%B8%AA%E0%B8%95%E0%B8%A3%E0%B8%94%E0%B8%B8%E0%B8%A9%E0%B8%8E%E0%B8%B5%E0%B8%9A%E0%B8%B1%E0%B8%93%E0%B8%91%E0%B8%B4%E0%B8%95+%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B8%A7%E0%B8%B4%E0%B8%97%E0%B8%A2%E0%B8%B2%E0%B8%A5%E0%B8%B1%E0%B8%A2%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B8%88%E0%B8%B8%E0%B8%AC%E0%B8%B2%E0%B8%A5%E0%B8%87%E0%B8%81%E0%B8%A3%E0%B8%93%E0%B8%A3%E0%B8%B2%E0%B8%8A%E0%B8%A7%E0%B8%B4%E0%B8%97%E0%B8%A2%E0%B8%B2%E0%B8%A5%E0%B8%B1%E0%B8%A2.+%282559%29.+%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%88%E0%B8%B1%E0%B8%94%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%97%E0%B8%A3%E0%B8%B1%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%81%E0%B8%A3%E0%B8%98%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B8%8A%E0%B8%B2%E0%B8%95%E0%B8%B4%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%AA%E0%B8%B4%E0%B9%88%E0%B8%87%E0%B9%81%E0%B8%A7%E0%B8%94%E0%B8%A5%E0%B9%89%E0%B8%AD%E0%B8%A1&gs_lcp=CgZwc3ktYWIQAzIECAAQRzIECAAQRzIECAAQRzIECAAQRzIECAAQRzIECAAQRzIECAAQRzIECAAQR0oJCBcSBTEyLTEzSggIGBIEMTItMVD7FVj7FWDJG2gAcAF4AIABAIgBAJIBAJgBAKABAqABAaoBB2d3cy13aXo&sclient=psy-ab&ved=0ahUKEwiglOrwz-_oAhUkwzgGHegwAMIQ4dUDCAw&uact=5#",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "h"
  },
  {
    keyword: "Homogeneity",
    meaning: "ประชากรมีลักษณะแบบเดียวกัน มีความเป็นเอกพันธ์",
    source:
      "นางสาวลิขิตกุล กุลรัตนรักษ์ คณะครุศาสตร์ จุฬาลงกรณ์มหาวิทยาลัย. (2557). การพัฒนาหลักสูตรต้นแบบสาขาวิชาครุศาสตร์ศึกษาศาสตร์ตามกรอบสมรรถนะของครูในเอเชียตะวันออกเฉียงใต้ในศตวรรษที่ 21, 10 ตุลาคม 2562. file:///C:/Users/admin/Downloads/5384251727.pdf",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "h"
  },
  {
    keyword: "Hospitality",
    meaning:
      "การ “ให้บริการ” ในบริบทปัจจุบันได้ขยายความไปถึงการส่งมอบ “บริการ” ด้วยการต้อนรับอย่างมีมิตรไมตรีที่สร้างความสุข ประทับใจให้กับลูกค้าอย่างเอื้อเฟื้อและมีคุณธรรม",
    source:
      "จุรีรัตน์ คงตระกูล ผู้อํานวยการฝ่ายวางแผน การท่องเที่ยวแห่งประเทศไทย. (2551). ภาพรวมธุรกิจ Hospitality : ท่องเที่ยวไทย ไปได้ไกลกว่าที่คิด, 10 ตุลาคม 2562. http://www.etatjournal.com/upload/243/7_Thai_Hospitality.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "h"
  },
  {
    keyword: "IEC",
    meaning:
      "คณะกรรมาธิการระหว่างประเทศว่าด้วยมาตรฐานสาขาอิเล็กทรอเทคนิกส์ (International Electrotechnical Commission : IEC) \r\nเป็นองค์กรอิสระที่เริ่มก่อตั้งขึ้นเมื่อ พ.ศ. 2449 มีวัตถุประสงค์เพื่อจัดทำมาตรฐานระหว่างประเทศ ทางด้านไฟฟ้า อิเล็กทรอนิกส์ และเทคโนโลยีที่เกี่ยวข้อง นอกจากนี้ ยังดำเนินการจัดทำระบบการตรวจประเมิน เพื่อการรับรองคุณภาพให้กับมาตรฐานของ IEC เพื่อเป็นเครื่องมือในการอำนวยความสะดวกทางการค้าระหว่างประเทศ \r\nการเป็นสมาชิก IEC จะต้องมีการจัดตั้งคณะกรรมการแห่งชาติของประเทศ ซึ่งแต่ละประเทศจะมีคณะกรรมการแห่งชาติได้เพียงคณะเดียว",
    source:
      "สำนักงานมาตรฐานผลิตภัณฑ์อุตสาหกรรม (สมอ.) กระทรวงอุตสาหกรรม. IEC, 30 กันยายน 2562. https://www.tisi.go.th/website/interstandard/iec",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "i"
  },
  {
    keyword: "IFOAM",
    meaning:
      "ระบบที่พัฒนาขึ้นโดยสหพันธ์เกษตรอินทรีย์นานาชาติ (International Federation of Organic Agriculture Movements - IFOAM) \r\nซึ่งเริ่มจัดตั้งโครงการรับรองระบบงานเกษตรอินทรีย์ IFOAM (IFOAM Accreditation Programme) ขึ้นในปี พ.ศ. 2535 เพื่อให้บริการรับรองระบบงานแก่หน่วยตรวจรับรองเกษตรอินทรีย์ต่างๆ ทั่วโลก  ต่อมา ในปี พ.ศ. 2540 สหพันธ์ฯ ได้จัดตั้ง IOAS (International Organic Accreditation Service) เป็นองค์กรไม่แสวงกำไรขึ้น เพื่อทำหน้าที่ในการให้บริการรับรองระบบงานนี้ ภายใต้กรอบของโครงการรับรองระบบงานเกษตรอินทรีย์ IFOAM ",
    source:
      "กรมการค้าภายใน กระทรวงพาณิชย์. มาตรฐาน IFOAM, 3 กันยายน 2562. \r\nhttp://www.organic.moc.go.th/th/standard/soil",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "i"
  },
  {
    keyword: "IMD",
    meaning:
      "สถาบันการจัดการนานาชาติ (International Institute for Management Development: IMD) เพื่อจัดอันดับความสามารถในการแข่งขัน",
    source:
      "สมานลักษณ์ ตัณฑิกุล นักวิเคราะห์นโยบายและแผนชำนาญการพิเศษ สำนักขับเคลื่อนอุตสาหกรรมที่มีศักยภาพของประเทศ. การจัดอันดับความสามารถในการแข่งขันกับการกำหนดแนวทางการพัฒนาประเทศ, 30 กันยายน 2562. http://www.oie.go.th/sites/default/files/attachments/article/ranking_competitiveness.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "i"
  },
  {
    keyword: "Infrastructure Fund",
    meaning:
      "กองทุนรวมโครงสร้างพื้นฐาน กองทุนรวมประเภทหนึ่งที่ตั้งขึ้นเพื่อระดมทุนจากผู้ลงทุนทั่วไปทั้งรายย่อยและสถาบัน เพื่อลงทุนในกิจการโครงสร้างพื้นฐานที่เป็นประโยชน์สาธารณะในวงกว้างของประเทศไทย โดยกิจการโครงสร้างพื้นฐานเหล่านี้เป็นกิจการที่มีความจำาเป็น และเป็นประโยชน์ในการพัฒนาประเทศ อีกทั้งเป็นโครงการที่ใช้เงินลงทุนค่อนข้างสูง กองทุนรวมโครงสร้างพื้นฐานจึงจะสามารถช่วยแบ่งเบาภาระงบประมาณการลงทุนและการก่อหนี้สาธารณะของภาครัฐตลอดจนเป็นทางเลือกในการระดมทุนของภาคเอกชนในการพัฒนากิจการโครงสร้างพื้นฐานเหล่านี้ได",
    source:
      "สำานักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์ ตลาดหลักทรัพย์แห่งประเทศไทย. กองทุนรวมโครงสร้างพื้นฐาน, 10 ตุลาคม 2562. https://www.set.or.th/th/products/listing2/files/Brochure_Infra_Fund_200514_01.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "i"
  },
  {
    keyword: "Innovation Ecosystem",
    meaning:
      "การจัดทำมาตรการเพื่อเสริมสร้างสภาพแวดล้อมที่เอื้อต่อการพัฒนานวัตกรรม ในการสร้างสภาพแวดล้อมที่เหมาะสมต่อการพัฒนานวัตกรรมที่มีผลกระทบสูงทางเศรษฐกิจและสังคมจำต้องมีมาตรการสนับสนุนที่ครบถ้วน ประกอบด้วยมาตรการทางการเงินและทางภาษีเพื่อส่งเสริมการลงทุนด้านการวิจัยและพัฒนาเทคโนโลยีและนวัตกรรม มาตรการด้านแรงจูงใจเพื่อสนับสนุนการพัฒนาอุตสาหกรรมและคลัสเตอร์เป้าหมายของประเทศ ข้อเสนอการปรับปรุงแก้ไขหรือพัฒนากฎหมาย กฎระเบียบ ที่เอื้อต่อการลงทุนวิจัยและนวัตกรรม มาตรการสนับสนุนการพัฒนากำลังคนด้านวิจัยและนวัตกรรม และการพัฒนาโครงสร้างพื้นฐานที่เอื้อต่อกิจกรรมวิจัยและพัฒนา รวมทั้งมาตรการส่งเสริมการพัฒนามาตรฐานต่างๆ  ที่สำคัญ",
    source:
      "สำนักงานคณะกรรมการนโยบายวิทยาศาสตร์เทคโนโลยีและนวัตกรรมแห่งชาติ. (2561). แผนปฏิบัติการประจำปีงบประมาณ พ.ศ. 2562, 10 ตุลาคม 2562. http://www.nxpo.or.th/th/wp-content/uploads/2019/05/%e0%b8%a3%e0%b8%a7%e0%b8%a1%e0%b9%81%e0%b8%9c%e0%b8%99%e0%b8%9b%e0%b8%8f%e0%b8%b4%e0%b8%9a%e0%b8%b1%e0%b8%95%e0%b8%b4%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%9b%e0%b8%a3%e0%b8%b0%e0%b8%88%e0%b8%b3%e0%b8%9b%e0%b8%b5%e0%b8%87%e0%b8%9a%e0%b8%9b%e0%b8%a3%e0%b8%b0%e0%b8%a1%e0%b8%b2%e0%b8%93-62-V03-%e0%b9%80%e0%b8%aa%e0%b8%99%e0%b8%ad-%e0%b8%9a.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "i"
  },
  {
    keyword: "Integrity & Transparency Assessment : ITA",
    meaning:
      "การประเมินคุณธรรมและความโปร่งใสในการดำเนินงานของหน่วยงานภาครัฐ เป็นการประเมินที่มีจุดมุ่งหมายที่จะก่อให้เกิดการปรับปรุงพัฒนาด้านคุณธรรมและความโปร่งใสในหน่วยงานภาครัฐ ซึ่งเป็นการประเมินที่ครอบคลุมหน่วยงานภาครัฐทั่วประเทศ โดยใช้แนวทางและเครื่องมือการประเมินตามที่สำนักงานคณะกรรมการป้องกันและปราบปรามการทุจริตแห่งชาติ หรือ สำนักงาน ป.ป.ช. กำหนด ",
    source:
      "สำนักงานงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน). (2562). ประโยชน์ของ ITA หรือการประเมินคุณธรรมและความโปร่งใสในการดำเนินงานของหน่วยงานภาครัฐ ทำแล้วดียังไง, 10 ตุลาคม 2562. https://www.dga.or.th/th/content/890/13462/",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "i"
  },
  {
    keyword: "International Congress and Convention Association (ICCA)",
    meaning:
      "สมาคมส่งเสริมการประชุมระหว่างประเทศ เป็นสมาคมนานาชาติที่ก่อตั้งขึ้นในปี พ.ศ. 2506 (ค.ศ. 1963) เพื่ออุตสาหกรรมการประชุมนานาชาติ มีเครือข่ายสมาชิกสมาคมในทุกภาคส่วนของอุตสาหกรรมการประชุมนานาชาติใน 86 ประเทศทั่วโลก",
    source:
      "สำนักงานส่งเสริมการจัดประชุมและนิทรรศการ. รายงานตลาดการประชุมสมาคมนานาชาติในภูมิภาคเอเชียแปซิฟิกและตะวันออกกลาง, 17 ตุลาคม 2562. https://www.businesseventsthailand.com/uploads/press_media/file/190903-file-NbZz78EL1.pdf",
    sappear: 2,
    mappear: 5,
    rappear: "",
    firstalpha: "i"
  },
  {
    keyword: "ISO",
    meaning:
      "ISO มาจากคำว่า International Organization for Standardization (ISO) เป็นมาตรฐานการวัดคุณภาพองค์กรต่างๆ เพื่อรับรองระบบการบริหารและการดำเนินงานขององค์กรในแต่ละประเทศเพื่อให้เป็นมาตรฐานเดียวกันทั่วโลก\r\nตัวเลขที่อยู่ด้านหลังคำว่า ISO นั้น หมายถึง สินค้าและบริการที่แตกต่างกัน เช่น โรงแรม ภัตตาคาร สนามบิน และ โรงงานอุตสาหกรรม เป็นต้น ระดับของมาตรฐานการวัดคุณภาพจะแบ่งออกเป็น 4 ระดับ ได้แก่\r\n1.        ISO9000\r\n2.        ISO9001\r\n3.        ISO9002\r\n4.        ISO9003\r\nซึ่งเป็นการวัดคุณภาพจากการจัดการขององค์กร และ ISO14000 จะเป็นเรื่องสิ่งแวดล้อม \r\nการจัดทำระบบคุณภาพ ISO มีข้อดีคือ ทำให้ผู้บริโภคมั่นใจในผลิตภัณฑ์ที่ใช้บริการว่าได้รับการคุ้มครองทั้งในเรื่องของ คุณภาพ และ ความปลอดภัย",
    source:
      "สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ. ระบบ ISO คืออะไร?, 18 มิถุนายน 2562. https://www.nstda.or.th/th/vdo-nstda/sci-day-techno/3855",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "i"
  },
  {
    keyword: "IUU-fishing",
    meaning:
      "การป้องกัน ยับยั้งและขจัดการทำประมงที่ผิดกฎหมาย ขาดการรายงาน และไร้การควบคุม",
    source:
      "วิริยะ คล้ายแดง วิทยากรชำนาญการพิเศษ สำนักวิชาการ. การประมงที่ผิดกฎหมาย จากวิกฤตสู่การปฏิรูปประเทศ, 30 กันยายน 2562. https://library2.parliament.go.th/ebook/content-issue/2558/hi2558-060.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "i"
  },
  {
    keyword: "JETRO",
    meaning:
      "องค์การส่งเสริมการค้าต่างประเทศของญี่ปุ่น (Japan External Trade Organization: JETRO)เป็นหน่วยงานของรัฐที่เกี่ยวข้องกับการส่งเสริมการค้าและการลงทุนระหว่างประเทศญี่ปุ่นและต่างประเทศจัดตั้งขึ้นในปี พ.ศ.2501เพื่อส่งเสริมการส่งออกของญี่ปุ่นในต่างประเทศ",
    source:
      "กรมพัฒนาฝีมือแรงงาน กองวิเทศสัมพันธ์. ข้อมูลประกอบการเข้าเยี่ยมคารวะของ JETRO, 3 กันยายน 2562. http://home.dsd.go.th/icd/images/JETRO_25570609_for_public.pdf\r\n",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "j"
  },
  {
    keyword: "KPI",
    meaning:
      "ดัชนีหรือหน่วยวัดความสำเร็จของการปฏิบัติงานที่กำหนดขึ้น  โดยเป็นหน่วยวัดที่แสดงผลสัมฤทธิ์ของงาน และสามารถแสดงผลเป็นข้อมูลในรูปของตัวเลขเพื่อสะท้อนประสิทธิภาพและประสิทธิผลในการทำงานขององค์กรหรือหน่วยงานต่างๆ ภายในองค์กร",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์ (สพธอ.). (2555).  ตัวชี้วัดผลการปฏิบัติงานหลัก (Key Performance Indicators – KPIs), 30 กันยายน 2562. https://www.etda.or.th/content/1128.html",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "k"
  },
  {
    keyword: "Legatum Prosperity Index",
    meaning: "ดัชนีความเจริญรุ่งเรือง ",
    source:
      "ณัชพล ประดิษฐเพชรา สถาบันวิจัยเพื่อการพัฒนาประเทศไทย. (2560).  ถานการณ์และทิศทางคอร์รัปชันไทย, 30 กันยายน 2562. https://tdri.or.th/wp-content/uploads/2017/07/Corruption-Indicators-Presentation-KM_2.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "l"
  },
  {
    keyword: "LNG Receiving Terminal",
    meaning:
      "กิจการเก็บรักษาและแปรสภาพก๊าซธรรมชาติจากของเหลวเป็นก๊าซ ให้บริการรับ จัดเก็บ และแปรสภาพก๊าซธรรมชาติเหลว (LNG) เป็นก๊าซธรรมชาติ ส่งเข้าสู่ระบบท่อส่งก๊าซธรรมชาติ",
    source:
      "สำนักงานคณะกรรมการกำกับกิจการพลังงาน. (2560). ร่างหลักเกณฑ์การกำหนดอัตราค่าบริการสำหรับกิจการเก็บรักษาและแปรสภาพก๊าซธรรมชาติจากของเหลวเป็นก๊าซ, 8 ตุลาคม 2562. http://www.erc.or.th/ERCWeb2/Upload/Document/%E0%B9%80%E0%B8%AD%E0%B8%81%E0%B8%AA%E0%B8%B2%E0%B8%A3%E0%B9%81%E0%B8%99%E0%B8%9A2.1Hearing%E0%B9%80%E0%B8%A3%E0%B8%B7%E0%B9%88%E0%B8%AD%E0%B8%87%E0%B8%A3%E0%B9%88%E0%B8%B2%E0%B8%87%E0%B8%AB%E0%B8%A5%E0%B8%B1%E0%B8%81%E0%B9%80%E0%B8%81%E0%B8%93%E0%B8%91%E0%B9%8CLNG%20_Final2.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "l"
  },
  {
    keyword: "LTF",
    meaning:
      "กองทุนรวมหุ้นระยะยาว (Long Term Equity Fund) เน้นลงทุนในหุ้น โดยทางการสนับสนุนให้จัดตั้งขึ้นเพื่อเพิ่มสัดส่วนผู้ลงทุนสถาบันที่จะลงทุนระยะยาวในตลาดหลักทรัพย์ฯ ซึ่งการเพิ่มผู้ลงทุนสถาบันดังกล่าวจะช่วยให้ตลาดทุนไทยมีเสถียรภาพมากขึ้น",
    source:
      "ตลาดหลักทรัพย์แห่งประเทศไทย. (2558).  LTFคืออะไร, 30 กันยายน 2562. https://www.set.or.th/education/th/begin/mutualfund_content08.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "l"
  },
  {
    keyword: "Malaysia Plan (MP)",
    meaning:
      "แผนพัฒนาระดับชาติของมาเลเซีย มีการพัฒนาและการถ่ายระดับจากวิสัยทัศน์ระยะยาวจาก Outline Perspective Plan (OPP) 20 – 30 ปีและ Vision 2020 สู่แผนพัฒนาระยะกลาง 5 ปี หรือที่เรียกว่า Malaysia Plan (MP) ซึ่ง มี EPU เป็นหน่วยงานหลักในการยกร่างแผนฯ ผ่านกลไกการระดมสมองเพื่อรับฟังความคิดเห็นจากหน่วยงานภาครัฐที่เกี่ยวข้อง ทั้งในส่วนกลางระดับรัฐ และเขต ภาคเอกชน และผู้เชี่ยวชาญในสาขาต่างๆ ผ่าน Inter Agency Planning Group Technical Working Group และการประชุมกลุ่มย่อยมากกว่า 140 กลุ่ม เพื่อประกอบการยกร่างก่อนการนำเสนอต่อคณะกรรมการวางแผนการพัฒนาระดับชาติ (National Development Planning Committee) ซึ่งมีเลขาธิการคณะรัฐมนตรี (Chief Secretary to the Government) เป็นประธาน ก่อนนำเสนอคณะรัฐมนตรี และสภาเพื่อพิจารณาอนุมัติต่อไป กล่าวได้ว่า เป็นการวางแผนแบบ Top down และ Bottom up ซึ่งหน่วยงานวางแผนในส่วนกลาง และในระดับรัฐมีส่วนร่วมในการออกแบบแผนพัฒนาและร่วมกลั่นกรองแผนงาน/โครงการร่วมกัน มีการเปิดรับองค์ความรู้ เทคนิค และแลกเปลี่ยนข้อมูลเพื่อใช้ในการวางแผนจากภาคีการพัฒนาทั้งในประเทศและจากองค์กรระหว่างประเทศอย่างเป็นระบบ",
    source:
      "สำนักงานเลขานุการของคณะกรรมการปฏิรูปประเทศ. ร่างแผนปฏิรูปประเทศด้านเศรษฐกิจ, 7 ตุลาคม 2562. http://www.led.go.th/integration/pdf/3-2-5.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "m"
  },
  {
    keyword: "Matching Platform",
    meaning:
      "เป็นแพลตฟอร์มกลางระหว่างคนหางานและนายจ้างที่ต้องการสรรหาแรงงาน โดยนำเทคโนโลยีดิจิทัลปัญญาประดิษฐ์ เพิ่มประสิทธิภาพการให้บริการจับคู่งาน ให้มีความแม่นยำขึ้น",
    source:
      "สำนักเลขาธิการนายกรัฐมนตรี. (2561). ผลการประชุมคณะกรรมการขับเคลื่อนและเร่งรัดการดำเนินงานตามนโยบายรัฐบาล ครั้งที่ 8/2561, 17 ตุลาคม 2562. https://spm.thaigov.go.th/crtprs/spm-sp-layout6.asp?i=21111%2E81322702112113121111311",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "m"
  },
  {
    keyword: "Mega trends",
    meaning: "แนวโนมการเปลี่ยนแปลงในโลกอนาคตที่ไมสามารถหลีกเลี่ยงได",
    source:
      "ธนาคารแห่งประเทศไทย. ประเด็นชวนคิด: 6 Mega trends กับเศรษฐกิจไทย, 10 ตุลาคม 2562. https://www.bot.or.th/Thai/MonetaryPolicy/EconomicConditions/AAA/5MegaTrends.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "m"
  },
  {
    keyword: "Methane Hydrate",
    meaning:
      "เป็นผลึกของแข็งที่ประกอบด้วยโมเลกุลของมีเทนซึ่งถูกล้อมรอบด้วยโมเลกุลของน้ำที่ล้อมรอบใน\r\nลักษณะเป็นกรง มีสูตรทางเคมีเป็น (CH4·5.75H2O) หรือ(4CH4·23H2O), แต่ถ้าจะอธิบายอย่าง\r\nง่ายๆ ก็คือสารที่ประกอบด้วยมีเทนในรูปผลึกโครงสร้างคล้ายน้ำแข็งแห้ง บางทีเราจะเรียกว่า \r\nน้ำแข็งไฟ (fire ice) ",
    source:
      "ฝ่ายตลาดท่อจัดจำหน่ายก๊าซธรรมชาติ บริษัท ปตท. จำกัด (มหาชน). (2558). จุลสารก๊าซไลน์, \r\n28 สิงหาคม 2562. https://dscng.pttplc.com/(S(2oaso1s25wzm3shqelaajr12))/Files/Gasline/\r\nGasLine_313.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "m"
  },
  {
    keyword: "MSTQ",
    meaning:
      "ระบบการให้บริการเทคนิคด้านวิทยาศาสตร์และเทคโนโลยี(MSTQ) แบ่งเป็น 4 หมวดหลัก ได้แก่ \r\nระบบมาตรวิทยา (M:Metrology) การกำหนดมาตรฐาน (S:Standardization) การทดสอบ \r\n(T:Testing) และการรับรองคุณภาพ (Q:Quality Assurance) ระบบ MSTQ นี้เป็นโครงสร้าง\r\nพื้นฐานด้านคุณภาพ (Quality Infrastructure) ที่สำคัญในการผลักดันให้เกิดการเจริญเติบโต\r\nทางเศรษฐกิจ",
    source:
      "กระทรวงวิทยาศาสตร์และเทคโนโลยี (วท.). (2552). MSTQ ความเป็นมา, 28 สิงหาคม 2562. \r\nhttp://onestop.most.go.th/mstq/web/aboutUs",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "m"
  },
  {
    keyword: "MTEF",
    meaning:
      "การจัดทำประมาณการงบประมาณรายจ่ายล่วงหน้าระยะปานกลาง(Medium Term Expenditure Framework (MTEF) เป็นกรอบที่เชื่อมการตัดสินใจการจัดทำงบประมาณรายจ่ายประจำปีเข้ากับกลยุทธ์การจัดสรรทรัพยากรระยะปานกลาง (สำนักงานงบประมาณ ,2542:103) หรืออีกนัยหนึ่ง คือ กระบวนการที่ช่วยให้ระบวนการวางแผนการใช้จ่าย(Financial Planning) ของภาครัฐและการวางแผนในระยะปานกลาง",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์. (2555). คลังความรู้ MTEF, 28 สิงหาคม, 2562. https://www.etda.or.th/terminology-detail/1056.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "m"
  },
  {
    keyword: "Multidisciplinary",
    meaning:
      "หลักสูตรที่นำเอาความรู้หลายศาสตร์หรือหลายอนุศาสตร์เข้ามาใช้ในการเรียนการสอน เพื่อประโยชน์ในการวิเคราะห์ วิจัย จนกระทั่งผู้เรียนสามารถพัฒนาความรู้ องค์ความรู้เป็นศาสตร์ใหม่ขึ้นหรือเกิดอนุศาสตร์ใหม่ขึ้น",
    source:
      "สำนักงานมาตรฐานและประกันคุณภาพการศึกษา. นิยามศัพท์, 10 ตุลาคม 2562. http://www.qa.cmru.ac.th/web/UserFiles/files/qasystem/qa_definition58.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "m"
  },
  {
    keyword: "NIDA Model",
    meaning:
      "ในปี พ.ศ. 2557 ประเทศไทยอยู่ในยุคของการปฏิรูปประเทศ สถาบันจึงได้รวบรวมคณาจารย์เพื่อนำเสนอแนวทาง การปฏิรูปประเทศใน 15 ด้าน เพื่อเสนอต่อสภาปฏิรูปแห่งชาติ (ส.ป.ช.)",
    source:
      "สถาบันบัณฑิตพัฒนบริหารศาสตร์. Good University Report 2017, 1 ตุลาคม 2562. http://www.nida.ac.th/th/images/publications/GUR_2017.pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "n"
  },
  {
    keyword: "Non-Tariff Barriers",
    meaning:
      "อุปสรรคทางการค้าที่ไม่ใช่ภาษี (Non-Tariff Barriers)  เป็นกฎระเบียบข้อบังคับที่รัฐบาล ประเทศต่างๆ กำหนดขึ้นเพื่อเป็นสร้างอุปสรรคต่อการส่งออกของประเทศคู่ค้า หรือเพื่อกีดกันการนำเข้าที่ไม่สอดคล้อง กับความตกลงระหว่างประเทศ โดยทั่วไปพบว่าประเทศต่างๆ นำมาตรการที่มิใช่ภาษีมาใช้อย่างเข้มงวดเกินไป จนทำให้ ประเทศอื่นมองว่าเป็นมาตรการที่ไม่เป็นธรรม กลายเป็นอุปสรรคทางการค้าที่มิใช่ภาษีเกิดขึ้น เช่น การกำหนดคุณภาพที่ เกินมาตรฐานสากลหรือการเข้มงวดในการตรวจสอบมาตรฐานสินค้า และใช้เวลาในการตรวจสอบนานมากจนอาจทำให้ สินค้าเกิดความเสียหายตลอดจนการปฏิบัติด้านพิธีการศุลกากรที่ไม่เป็นธรรม เช่น - การบริหารโควตาภาษี (Tariffs Rate Quatas: TRQs) \r\n- สวัสดิภาพสัตว์ (Animal Welfare) \r\n- มาตรฐานสิ่งแวดล้อมที่เกี่ยวข้องกับการค้า (Trade-Related Environmental Measures) \r\n- การปิดฉลากสินค้าตัดแต่งสารพันธุกรรม (Genetically Modified Organisms: GMOs) \r\n- มาตรฐานแรงงาน (Trade and Labour Standard) เป็นต้น \r\n- การใช้มาตรการฝ่ายเดียวและอ้างว่าประเทศคู่ค้าไม่ปฏิบัติตามความตกลงของ WTO อย่างมีประสิทธิภาพ เช่น ประเด็นทรัพย์สินทางปัญญา \r\n- กฎระเบียบเกี่ยวกับกระบวนการตรวจสอบสินค้าและพิธีการศุลกากร \r\n- เงื่อนไขการลงทุนและนโยบายการแข่งขัน เป็นต้น",
    source:
      "กรมเจรจาการค้าระหว่างประเทศ กระทรวงพาณิชย์. (2556). ความรู้เบื้องต้นเกี่ยวกับ มาตรการที่มิใช่ภาษี(Non – Tariff Measures: NTMs) และอุปสรรคทางการค้าที่มิใช่ภาษี(Non-Tariff Barriers: NTBs), 7 ตุลาคม 2562. https://www.moc.go.th/index.php/moc-news-center-eng/item/non-tariff-measures-ntms-non-tariff-barriers-ntbs-11-2556.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "n"
  },
  {
    keyword: "ombudsman",
    meaning:
      "บุคคลที่พระมหากษัตริย์ทรงแต่งตั้งตามคำแนะนำของวุฒิสภา ซึ่งเป็นบุคคลที่เป็นที่ยอมรับนับถือของประชาชน มีความรอบรู้และมีประสบการณ์ในการบริหารราชการแผ่นดิน วิสาหกิจหรือกิจกรรมอันเป็นประโยชน์ร่วมกันของสาธารณะ และมีความซื่อสัตย์สุจริตเป็นที่ประจักษ์",
    source:
      "สำนักงานผู้ตรวจการแผ่นดิน (สผผ.). ผู้ตรวจการแผ่นดิน, 1 ตุลาคม 2562. https://www.ombudsman.go.th/10/documents/brochure%20OMB.pdf",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "o"
  },
  {
    keyword: "One Marine Chart",
    meaning: "แผนที่การจำแนกเขตทางทะเลและชายฝั่ง",
    source:
      "กรมประชาสัมพันธ์. (2561). รัฐบาล เร่ง ปฏิรูปแก้ปัญหาการกัดเซาะชายฝั่งทั้งอ่าวไทย ด้วยการนำป่าชายเลนเป็นแนวป้องกันการกัดเซาะแทนการสร้างเขื่อนป้องกันในรูปแบบใช้น้ำจืดผลักดันน้ำเค็ม, 7 ตุลาคม 2562. http://thainews.prd.go.th/th/website_th/news/news_detail/TNEVN6102160010008",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "o"
  },
  {
    keyword: "One Stop Shop",
    meaning:
      "การรับมือกับปัญหาของการบริหารจัดการ และการประสานงานระหว่างบุคคลและระหว่างหน่วยงานปกครองต่าง ๆ ของรัฐ ทั้งในระดับเดียวกันและต่างระดับกันที่จะรับเรื่องและแจ้งผลให้ผู้ใช้บริการ ณ จุดบริการเดียว",
    source:
      "ศูนย์ข้อมูลข่าวสารอาเซียน กรมประชาสัมพันธ์. (2559). โครงการ One Stop Shop ของเวียดนาม, 30 กันยายน 2562. http://www.aseanthai.net/ewt_news.php?nid=4758&filename=aseanknowledge",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "o"
  },
  {
    keyword: "one-stop service",
    meaning:
      "บริการดิจิทัลภาครัฐแบบเบ็ดเสร็จ ณ จุดเดียว เป็นศูนย์บริการร่วมรูปแบบออนไลน์ของภาครัฐ เพื่อการเข้าถึงข้อมูลและบริการภาครัฐแบบเบ็ดเสร็จ ณ จุดเดียว ช่วยให้ประชาชนผู้รับบริการสามารถพบกับส่วนราชการผู้ให้บริการได้ตลอดเวลา จากที่ไหนก็ได้\r\n",
    source:
      "สำนักงานพัฒนารัฐบาลดิจิทอล(องค์การมหาชน). (2561). One Stop Service(OSS), 30 กันยายน 2562. https://www.dga.or.th/upload/download/file_1207be8324f8debd0a21021c9281ed5b.pdf",
    sappear: "",
    mappear: "",
    rappear: "3,5",
    firstalpha: "o"
  },
  {
    keyword: "Operating budget",
    meaning:
      "งบประมาณดำเนินการ จะประกอบไปด้วยงบประมาณเหล่านี้คือ\r\n1.งบประมาณการขาย\r\n2.งบประมาณการผลิต\r\n3.งบประมาณวัตถุดิบ\r\n4.งบประมาณแรงงาน\r\n5.งบประมาณค่าใช้จ่ายโรงงาน\r\n6.งบประมาณต้นทุนการผลิต และงบประมาณต้นทุนสินค้าที่ขาย\r\n7.งบประมาณค่าใช้จ่ายในการขายและการบริหาร\r\n",
    source:
      "กรมส่งเสริมอุตสาหกรรม. การจัดทำงบประมาณ. 20 กันยายน 2562. https://bsc.dip.go.th/th/category/financial-accounting/fs-buggeting",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "o"
  },
  {
    keyword: "OSS",
    meaning:
      "OSS หรือ Open Source Software ซอฟต์แวร์ที่เปิดเผยต้นฉบับโปรแกรม ให้เสรีภาพในการแจกจ่าย เผยแพร่และปรับปรุง นับเป็นนวัตกรรมอันยิ่งใหญ่ที่ได้รับการยอมรับอย่างกว้างขวาง จากทุกวงการ ทุกประเทศ เหตุผลประการสำคัญคือการปฏิบัติที่สอดคล้องกับแนวคิดเศรษฐกิจพอเพียงตามพระราชดำริ พระบาทสมเด็จพระเจ้าอยู่หัวที่ได้พระราชทานแก่พสกนิกรชาวไทย รวมทั้งยังเป็นแนวทางที่เป็นรูปธรรมในการใช้ ICT อย่างมีคุณธรรมและจริยธรรม",
    source:
      "สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ. ขุมทรัพย์ซอฟต์แวร์ OSS/Freeware, 4 กันยายน 2562. https://www.nstda.or.th/th/nstda-knowledge/2655-treasure-software-ossfreeware",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "o"
  },
  {
    keyword: "Participatory Approach",
    meaning:
      "แนวคิดกระบวนการมีส่วนร่วมที่นับรวมผู้มีส่วนได้ส่วนเสียกับนโยบายกระบวนการเข้ามา เช่นนโยบายสาธารณะที่ใช้แนวคิดดังกล่าวประกอบก็จะมีการนับรวมประชาชนเข้ามามีส่วนร่วมกับทุกขั้นตอนในการกำหนด สร้างและขั้นใช้นโยบายด้วย เป็นต้น",
    source:
      "Unicef. PARTICIPATORY APPROACHES, 20 มิถุนายน 2562. https://www.unicef-irc.org/KM/IE/impact_5.php",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "p"
  },
  {
    keyword: "PDCA",
    meaning:
      "Plan คือ การวางแผน\r\nDO คือ การปฏิบัติตามแผน\r\nCheck คือ การตรวจสอบ\r\nAct คือการปรับปรุงการดำเนินการอย่างเหมาะสม หรือการจัดทำมาตรฐานใหม่ซึ่งถือเป็นพื้นฐานของการยกระดับคุณภาพ",
    source:
      "สุธาสินี โพธิจันทร์ นักวิชาการเพิ่มผลผลิต ส่วนรณรงค์ส่งเสริมการเพิ่มผลผลิต สถาบันเพิ่มผลผลิตแห่งชาติ. (2558). PDCA หัวใจสำคัญของการปรับปรุงอย่างต่อเนื่อง, 26 กันยายน 2562. https://www.ftpi.or.th/2015/2125",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "p"
  },
  {
    keyword: "PGS",
    meaning:
      "ดัชนีหรือหน่วยวัดความสำเร็จของการปฏิบัติงานที่กำหนดขึ้น  โดยเป็นหน่วยวัดที่แสดงผลสัมฤทธิ์ของงาน และสามารถแสดงผลเป็นข้อมูลในรูปของตัวเลขเพื่อสะท้อนประสิทธิภาพและประสิทธิผลในการทำงานขององค์กรหรือหน่วยงานต่างๆ ภายในองค์กร",
    source:
      "มูลนิธิเกษตรอินทรีไทย TOAF. พีจีเอส หมายถึงอะไร. 18 พฤศจิกายน 2562.\r\nhttp://toaf.bmwbkk.com/userfiles/file/V.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "p"
  },
  {
    keyword: "Platform",
    meaning:
      "ระบบโปรแกรมคอมพิวเตอร์ที่สามารถขยายขีดความสามารถอย่างไม่จำกัดมีการพัฒนาฟังก์ชั่นหรือโมดูลใหม่ๆ มาต่อยอดอยู่ตลอดเวลา เกิดนวัตกรรมใหม่ๆเสมอ และสามารถนำไปต่อเชื่อมกับระบบอื่นได้ แพลตฟอร์มไม่ได้จำกัดอยู่แค่ซอฟต์แวร์แต่ยังรวมไปถึงเว็บไซต์ หรือบริการที่คนอื่นสามารถเขียนโปรแกรมมาต่อเชื่อมหรือดึงข้อมูลได้โดยอัตโนมัติ",
    source:
      "กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม สำนักคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ. (ร่าง) แผนพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม. (หน้าที่ 64), 26 กันยายน 2562. ",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "p"
  },
  {
    keyword: "Policy Cycle",
    meaning: "วงจรของนโยบาย",
    source:
      "สถาบันชุมชนท้องถิ่นพัฒนา. (2560). การพัฒนานโยบายสาธารณะเพื่อสุขภาพแบบมีส่วนร่วม, 10 ตุลาคม 2562. https://www.ldm.in.th/cases/2937",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "p"
  },
  {
    keyword: "Policy labs",
    meaning: "การริเริ่มและทดสอบนโยบาย",
    source:
      "สำนักงานคณะกรรมการพัฒนาระบบราชการ. สำนักงาน ก.พ.ร. ร่วมกับสำนักงานโครงการพัฒนาแห่งสหประชาชาติ (UNDP) และสำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ จัดการประชุม เรื่อง “ห้องปฏิบัติการนวัตกรรมภาครัฐ…พลิกโฉมนวัตกรรมงานบริการสาธารณะ”, 10 ตุลาคม 2562. https://www.opdc.go.th/content/Mjc5MA",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "p"
  },
  {
    keyword: "Policy Maker",
    meaning: "ผู้วางนโยบาย, ผู้กำหนดนโยบาย",
    source:
      "สำนักงานเลขาธิการสภาผู้แทนราษฎร. (2560). กฎหมายซุปเปอร์โฮลดิ้ง : ปฏิรูปหรือแปรรูปรัฐวิสาหกิจ, 10 ตุลาคม 2562. http://library2.parliament.go.th/ejournal/content_af/2560/sep2560-3.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "p"
  },
  {
    keyword: "Policy Sandbox",
    meaning: "การปฏิบัติในสภาพแวดล้อมเฉพาะ",
    source:
      "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม. (2560). นโยบายและแผนระดับชาติว่าด้วยการพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม (พ.ศ. 2561 – 2580), 10 ตุลาคม 2562. https://www.dga.or.th/upload/download/file_d0f9c102e31944e66c6afb2cdac40722.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "p"
  },
  {
    keyword: "PPP (Public-Private Partnership) การร่วมลงทุนระหว่างรัฐและเอกชน",
    meaning:
      "การร่วมลงทุนระหว่างภาครัฐและภาคเอกชนเพื่อจัดทำโครงการโครงสร้างพื้นฐานและบริการสาธารณะที่เป็นหน้าที่ของรัฐ โดยรัฐมอบหมายหน้าที่ให้ภาคเอกชนดำเนินการจัดทำโครงการดังกล่าวแทนผ่านสัญญาร่วมลงทุน",
    source:
      "สำนักงานคณะกรรมการนโยบายรัฐวิสาหกิจ. การให้เอกชนร่วมลงทุนในกิจการของรัฐตามพระราชบัญญัติการให้เอกชนร่วมลงทุนในกิจการของรัฐ พ.ศ. 2556\r\nhttp://www.ppp.sepo.go.th/assets/document/file/slide.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "p"
  },
  {
    keyword: "precision farming",
    meaning:
      "เกษตรกรรมความแม่นยําสูง หรือเกษตรแม่นยําสูง เป็นกลยุทธ์ในการทําการเกษตรที่เป็นมิตรกับสิ่งแวดล้อม โดยเกษตรกรสามารถจะปรับการใช้ทรัพยากรให้สอดคล้องกับสภาพของพื้นที่ย่อยๆ รวมไปถึงการดูแลอย่างมีประสิทธิภาพและแม่นยํา ไม่ว่าจะเป็น การหว่านเมล็ดพืช การให้ปุ๋ยการใช้ยาปราบศัตรูพืช การไถพรวนดิน การรดน้ำ การคัดเลือกผลผลิต การเก็บเกี่ยวผลผลิต ",
    source:
      "ผศ. ดร. ธีรเกียรติ์ เกิดเจริญ ภาควิชาฟิสิกส์และศูนย์นาโนศาสตร์และนาโนเทคโนโลยีคณะวิทยาศาสตร์มหาวิทยาลัยมหิดล. (2553). การใช้เทคโนโลยีสารสนเทศในระบบการจัดการฟาร์ม, 10 ตุลาคม 2562. http://www.aec.agr.ku.ac.th/document/attach/attach_08Aug2012155814.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "p"
  },
  {
    keyword: "Product Champion",
    meaning:
      "ผลิตภัณฑ์ที่ได้รับการคัดเลือก ซึ่งมีความโดดเด่น ซึ่งจะสามารถมาพัฒนาและส่งเสริมให้ประสบความสำเร็จและสร้างประโยชน์ให้กับเชิงมูลค่าทางเศรษฐกิจและสร้างรายได้ให้กับประชาชนในจังหวัดได้เป็นอย่างดี",
    source:
      "สถาบันส่งเสริมการบริหารกิจการบ้านเมืองที่ดี สำนักงานคณะกรรมการพัฒนาระบบราชการ. โครงการการพัฒนาข้อมูลสถิติและสารสนเทศ ระดับพื้นที่ 76 จังหวัด/18 กลุ่มจังหวัด, 10 ตุลาคม 2562. https://www.igpthai.org/NS057/keyword.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "p"
  },
  {
    keyword: "Program-based",
    meaning: "ตัวอย่างชุดโครงการ",
    source:
      "งานบริหารโครงการวิจัย ฝ่ายวิจัย คณะแพทยศาสตร์ศิริราชพยาบาล. (2562). การจัดทำข้อเสนอการวิจัย เพื่อตั้งงบประมาณแผ่นดิน ประจำปี 2562, 3 ตุลาคม 2562.  https://www.si.mahidol.ac.th/th/research-academics/research/test/doc/funding/fund_out/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%88%E0%B8%B1%E0%B8%94%E0%B8%97%E0%B8%B3%E0%B8%82%E0%B9%89%E0%B8%AD%E0%B9%80%E0%B8%AA%E0%B8%99%E0%B8%AD%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%A7%E0%B8%B4%E0%B8%88%E0%B8%B1%E0%B8%A2%20%E0%B9%80%E0%B8%9E%E0%B8%B7%E0%B9%88%E0%B8%AD%E0%B8%82%E0%B8%AD%E0%B8%95%E0%B8%B1%E0%B9%89%E0%B8%87%E0%B8%87%E0%B8%9A%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%A1%E0%B8%B2%E0%B8%93%E0%B9%81%E0%B8%9C%E0%B9%88%E0%B8%99%E0%B8%94%E0%B8%B4%E0%B8%99%20%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%88%E0%B8%B3%E0%B8%9B%E0%B8%B5%202562%20.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "p"
  },
  {
    keyword: "Property Transaction Tax: PTT",
    meaning: "ภาษีการทำธุรกรรมในทรัพย์สิน",
    source:
      "ปัณณ์ อนันอภิบุตร สำนักงานเศรษฐกิจการคลัง. (2555). การปฏิรูประบบภาษีเพื่อสังคมไทยเสมอหน้า, 7 ตุลาคม 2562. https://thaipublica.org/wp-content/uploads/2012/08/50-page_Paper.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "p"
  },
  {
    keyword: "R&D",
    meaning:
      "research and development (R&D) การวิจัยและพัฒนา การศึกษาค้นคว้าเพื่อหาแนวทางการใช้ทรัพยากรที่ก่อให้เกิดความรู้ใหม่ โดยอาศัยเทคโนโลยี นวัตกรรมมาสร้างสรรค์ผลิตภัณฑ์ชนิดใหม่ หรือพัฒนาผลิตภัณฑ์ชนิดเดิมให้ดีขึ้น เพื่อให้การขับเคลื่อนเทคโนโลยีในการผลิตสินค้าและบริการก้าวต่อไปข้างหน้า และสามารถสนองความต้องการของตลาด  โดยมีวัตถุประสงค์ 3 ประการ คือ \r\n1. เพื่อยกระดับคุณภาพและมาตรฐานของผลิตภัณฑ์หรือบริการให้สูงขึ้นโดยต้นทุนการผลิตคงเดิม \r\n2. เพื่อลดต้นทุนการผลิต ซึ่งจะนำไปสู่ราคาที่ต่ำลง ขณะที่คุณภาพมาตรฐานของผลิตภัณฑ์และบริการคงเดิม \r\n3. การปรับปรุงพัฒนาผลิตภัณฑ์และบริการให้ใช้ประโยชน์ได้ดีขึ้น ให้น่าใช้ยิ่งขึ้น โดยมีราคาเท่าเดิมหรือถูกลงกว่าเดิม \r\nดังนั้น การวิจัยและพัฒนาเป็นปัจจัยและเป็นตัวแปรที่มีบทบาทสำคัญยิ่งต่อเศรษฐกิจทั้งในระดับมหภาคและระดับจุลภาค",
    source:
      "จินดารัตน์  โพธิ์นอก สำนักงานราชบัณฑิตยสภา. (2552). การวิจัยและพัฒนา, 30 กันยายน 2562. http://www.royin.go.th/?knowledges=%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%A7%E0%B8%B4%E0%B8%88%E0%B8%B1%E0%B8%A2%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%9E%E0%B8%B1%E0%B8%92%E0%B8%99%E0%B8%B2-%E0%B9%92%E0%B9%93-%E0%B9%80%E0%B8%A1%E0%B8%A9%E0%B8%B2\r\n\r\n",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "r"
  },
  {
    keyword: "RCEP",
    meaning:
      "Regional Comprehensive Economic Partnership (RCEP) คือ กรอบความร่วมมือทางเศรษฐกิจระหว่าง ASEAN 10 ประเทศกับคู่ภาคี ในปัจจุบันมี 6 ประเทศ คือ จีน ญี่ปุ่น เกาหลีใต้ อินเดีย ออสเตรเลีย และนิวซีแลนด์ RCEP พัฒนามาจาก ASEAN+1 โดยมุ่งหมายให้เกิดระบบการค้าเสรีที่ใช้กฎระเบียบเดียวกันของภาคีทั้งหมด 16 ประเทศเพื่อเชื่อมโยงเศรษฐกิจของอาเซียนเข้ากับเศรษฐกิจโลก (Global Supply Chain)",
    source:
      "กรมประชาสัมพันธ์. (2553). Regional Comprehensive Economic Partnership:RCEP คืออะไร, 28 สิงหาคม 2562. http://www.aseanthai.net/ewt_news.php?\r\nnid=5776&filename=aseanknowledge",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "r"
  },
  {
    keyword: "Regional Headquarters",
    meaning:
      "สำนักงานปฏิบัติการภูมิภาค คือ บริษัทที่ตั้งขึ้นตามกฎหมายไทย เพื่อประกอบกิจการให้บริการด้านการบริหาร หรือด้านเทคนิค หรือการให้บริการสนับสนุน แก่วิสาหกิจในเครือหรือสาขาของสำนักงานฯ ไม่ว่าจะตั้งอยู่ในประเทศไทยหรือในต่างประเทศ",
    source:
      "กรมสรรพากร. (2549). สำนักงานปฏิบัติการภูมิภาคคือ, 20 ธันวาคม 2562. http://www.rd.go.th/publish/8711.0.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "r"
  },
  {
    keyword: "RIA (Regulatory Impact Assessment)",
    meaning:
      "การประเมิน/วิเคราะห์ผลกระทบจากการกำหนดกฎหมาย กฎ และระเบียบ ซึ่งเป็นเครื่องมือในการวิเคราะห์ต้นทุน-ผลประโยชน์หรือ cost- benefot analysis (CBA) เพื่อประเมินว่ากฎหมาย กฎ และระเบียบ ที่ต้องการนำมาบังคับใช้นั้น มีต้นทุนที่เหมาะสมและก่อให้ผลประโยชน์สุทธิสูงสุด (net benefit) ต่อสังคม ชุมชน และประเทศ\r\n",
    source:
      "ความร่วมมือทางเศรษฐกิจเอเชีย-แปซิฟิก กระทรวงยุติธรรม และสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. แนวปฏิบัติในการวิเคราะห์ผลกระทบจากกฎหมายสำหรับหน่วยงานภาครัฐในประเทศไทย (Regulatory Impact Analysis (RIA) Guidelines for the Thailand Government, 12 กันยายน 2562, https://www.nesdb.go.th/download/RIA/ThailandRIATH.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "r"
  },
  {
    keyword: "roadshow",
    meaning: "กิจกรรมส่งเสริมการลงทุน",
    source:
      "ศูนย์บริการข้อมูลธุรกิจไทย-อินเดีย. สัมมนาทางธุรกิจและกิจกรรมจับคู่ทางธุรกิจ “MAKE IN INDIA” ROADSHOW AND BUSINESS OPPORTUNITY IN THAILAND, 18 ตุลาคม 2562. https://thaiindia.net/about-india/thai-india/item/2152-%E0%B8%AA%E0%B8%B1%E0%B8%A1%E0%B8%A1%E0%B8%99%E0%B8%B2%E0%B8%97%E0%B8%B2%E0%B8%87%E0%B8%98%E0%B8%B8%E0%B8%A3%E0%B8%81%E0%B8%B4%E0%B8%88%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%81%E0%B8%B4%E0%B8%88%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B8%88%E0%B8%B1%E0%B8%9A%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%97%E0%B8%B2%E0%B8%87%E0%B8%98%E0%B8%B8%E0%B8%A3%E0%B8%81%E0%B8%B4%E0%B8%88-%E2%80%9Cmake-in-india%E2%80%9D-roadshow-and-business-opportunity-in-thailand.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "r"
  },
  {
    keyword: "Rule Based System",
    meaning: "ระบบของกฎเกณฑ์",
    source:
      "สำนักวิจัยเศรษฐกิจการค้าระหว่างประเทศ กรมเศรษฐกิจการพาณิชย์. (2544). โครงการ การศึกษาวิจัยเศรษฐกิจและการค้าระหว่างประเทศ เพื่อรองรับการเจรจาเปิดเสรีทางการค้า, 18 ตุลาคม 2562. http://www.thaifta.com/ThaiFTA/Portals/0/File/study_ftacu44.htm",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "r"
  },
  {
    keyword: "Scenario Analysis",
    meaning:
      'กระบวนการวิเคราะห์เหตุการณ์ในอนาคต โดยการพิจารณา ทางเลือกของผลลัพธ์ต่างๆ ที่เป็นไปได้ (บางครั้งเรียกว่า "alternative worlds") ดังนั้น หลักการของ Scenario Analysis คือ การคาดการณ์ โดยไม่พยายามสร้างภาพที่จะเห็นได้ชัดแต่จะนำเสนอทางเลือกหลาย ๆ ทางที่สามารถพัฒนาได้ในอนาคต',
    source:
      "สำนักงานเลขาธิการวุฒิสภา. (2559). แผนยุทธศาสตร์สำนักงานเลขาธิการวุฒิสภาฉบับที่ ๔ (พ.ศ. ๒๕๖๐ – ๒๕๖๔) และแผนปฏิบัติราชการ ๔ ปี (พ.ศ. ๒๕๖๑ – ๒๕๖๔), 20 มิถุนายน 2562. https://www.senate.go.th/assets/portals/1/files/plan2560V4.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "s"
  },
  {
    keyword: "SDG",
    meaning:
      "SDGs มาจาก Sustainable Development Goals หมายถึง การจัดทำเป้าหมายการพัฒนาที่ยั่งยืน",
    source:
      "สถาบันแห่งชาติเพื่อการพัฒนาเด็กและครอบครัว มหาวิยาลัยมหิดล. SDGs : คืออะไร, 28 สิงหาคม 2562.\r\nhttps://personalweb.mahidol.ac.th/aree-yup/?page_id=428",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "s"
  },
  {
    keyword: "Sectoral-based",
    meaning: "แผนงานและโครงการขนาดใหญ่ในรายสาขา",
    source:
      "คณะทำงานจัดทำแนวทางการประเมินสิ่งแวดล้อมระดับยุทธศาสตร์. (2561). ร่างแนวทาง (Guideline) การประเมินสิ่งแวดล้อมระดับยุทธศาสตร์, 10 ตุลาคม 2562. https://www.nesdc.go.th/ewt_w3c/ewt_dl_link.php?nid=8372",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "s"
  },
  {
    keyword: "Shale Gas",
    meaning: "แก๊สธรรมชาติจากหินดินดาน",
    source:
      "เจนจิรา ภูริรักษ์พิติกร นักวิทยาศาสตร์ปฏิบัติการ โครงการเคมี กรมวิทยาศาสตร์บริการ. แก๊สธรรมชาติจากหินดินดาน: ทางเลือกใหม่ของพลังงานโลก, 7 ตุลาคม 2562. http://lib3.dss.go.th/fulltext/dss_j/2556_61_191_P16-20.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "s"
  },
  {
    keyword: "Single Agency",
    meaning: "การกำหนดนโยบายและมาตรฐานเป็นหน่วยงานเดียว",
    source:
      "กรมเศรษฐกิจระหว่างประเทศ (Department of International Economic Affairs) กระทรวงการต่างประเทศ. (2559). เปิดโครงสร้างสนง.มาตรฐานแห่งชาติ ยกระดับ10อุตสาหกรรมไทยแลนด์4.0, 18 ตุลาคม 2562. http://www.mfa.go.th/business/th/news/84/70343-%E0%B9%80%E0%B8%9B%E0%B8%B4%E0%B8%94%E0%B9%82%E0%B8%84%E0%B8%A3%E0%B8%87%E0%B8%AA%E0%B8%A3%E0%B9%89%E0%B8%B2%E0%B8%87%E0%B8%AA%E0%B8%99%E0%B8%87.%E0%B8%A1%E0%B8%B2%E0%B8%95%E0%B8%A3%E0%B8%90%E0%B8%B2%E0%B8%99%E0%B9%81%E0%B8%AB%E0%B9%88%E0%B8%87%E0%B8%8A%E0%B8%B2%E0%B8%95%E0%B8%B4-%E0%B8%A2%E0%B8%81%E0%B8%A3%E0%B8%B0%E0%B8%94%E0%B8%B1%E0%B8%9A10%E0%B8%AD%E0%B8%B8%E0%B8%95%E0%B8%AA%E0%B8%B2%E0%B8%AB%E0%B8%81%E0%B8%A3.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "s"
  },
  {
    keyword: "Single Visa",
    meaning: "การจัดการอนุมัติการตรวจลงตราเดียว",
    source:
      "สถาบันการต่างประเทศเทวะวงศ์วโรปการกระทรวงการต่างประเทศ. (2556). คำศัพท์ – คำย่อทางการทูตและการต่างประเทศ, 11 ตุลาคม 2562. http://www.mfa.go.th/dvifa/contents/files/articles-20170626-142548-533162.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "s"
  },
  {
    keyword: "skills gap",
    meaning:
      "ช่องว่างของทักษะ ภาวะที่ทักษะของแรงงานในตลาดไม่เพียงพอ หรือไม่ตรงตามคุณสมบัติตามความต้องการแรงงานในตลาด",
    source:
      "เกียรติอนันต์ ล้วนแก้ว คณะเศรษฐศาสตร์ มหาวิทยาลัยธรรมศาสตร์. ช่องว่างทักษะกับนัยยะที่มีต่อการพัฒนากำลังคนของประเทศไทย, 3 ตุลาคม 2562. http://www.econ.tu.ac.th/symposium40/paper/003_Symposium40-เกียรติอนันต์.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "s"
  },
  {
    keyword: "smart farmer",
    meaning:
      "เป็นบุคคลที่มีความภาคภูมิใจในความเป็นเกษตรกร มีความรอบรู้ในระบบการผลิตด้านการเกษตรแต่ละสาขา มีความสามารถในการวิเคราะห์เชื่อมโยงและบริหารจัดการการผลิตและการตลาดโดยใช้ข้อมูลประกอบการตัดสินใจคคำนึงถึงคุณภาพ ความปลอดภัยของผู้บริโภคสังคมและสิ่งแวดล้อม",
    source:
      "การขับเคลื่อนนโยบายสำคัญของกระทรวงเกษตรและสหกรณ์ 15 โครงการ. 2561\r\nhttps://www.moac.go.th/dwl-files-401291791023",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "s"
  },
  {
    keyword: "SME",
    meaning:
      "วิสาหกิจขนาดกลางและขนาดย่อม (Small and Medium Enterprises) เป็นธุรกิจที่มีจำนวนมากในประเทศไทย ผู้ประกอบการส่วนมากประกอบการในรูปของบุคคลธรรมดา คณะบุคคลหรือห้างหุ้นส่วนสามัญที่มิใช่นิติบุคคล ห้างหุ้นส่วนจำกัด บริษัทจำกัด หรือกิจการร่วมค้า ซึ่งจะประกอบธุรกิจขายสินค้า ผลิตสินค้า หรือให้บริการ",
    source:
      "กรมสรรพากร. (2561). ลักษณะของ SMEs, 3 ตุลาคม 2562. https://www.rd.go.th/publish/38056.0.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "s"
  },
  {
    keyword: "SMEs (Small and Medium Enterprises)",
    meaning:
      "วิสาหกิจขนาดกลางหรือวิสาหกิจขนาดย่อม ได้แก่ วิสาหกิจที่มีจำนวนการจ้างงาน รายได้ มูลค่าสินทรัพย์ถาวร หรือทุนจดทะเบียนที่ชำระแล้ว ตามหลักเกณฑ์ที่กำหนดในกฎกระทรวง",
    source:
      "พระราชบัญญัติส่งเสริมวิสาหกิจขนาดกลางและขนาดย่อม (ฉบับที่ ๒) พ.ศ. 2561. (2561,19 เมษายน 2561). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 27 ก หน้า 1.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/027/24.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "s"
  },
  {
    keyword: "Social Inclusion",
    meaning:
      "การที่ประชาชนสามารถเข้าถึงบริการทางสังคม บริการที่รัฐจัดหา และการเข้าถึงการจ้างงานอย่างเสมอภาค เท่าเทียมกัน เข้าใจในสิทธิและหน้าที่ในฐานะพลเมืองของประเทศในการดำเนินกิจกรรมเพื่อสังคม การถูกรวมให้เป็นส่วนหนึ่งของสถาบันต่างๆ ทั้งที่เกิดขึ้นตามกฎหมาย และที่เกิดจากค่านิยม บรรทัดฐาน และวัฒนธรรมร่วมของชุมชนจนกลายเป็นความสัมพันธ์ทางสังคมที่เป็นเรื่องของชีวิตประจำวัน เช่น มีสิทธิลงคะแนนเสียงเลือกตั้ง สิทธิเด็กและสตรีการได้รับค่าแรงงานที่เป็นธรรมตามสิทธิ เป็นต้น",
    source:
      "สถาบันพระปกเกล้า. (2553).  “คุณภาพสังคมกับคุณภาพประชาธิปไตยไทย”, 10 ตุลาคม 2562. http://www.kpi.ac.th/media_kpiacth/pdf/M10_446.pdf",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "s"
  },
  {
    keyword: "social movement",
    meaning:
      "การเรียกร้องของกลุ่มคนจำนวนหนึ่งที่ต้องการเปลี่ยนแปลงสังคมไปในทิศทางที่ตนปรารถนา โดยกลุ่มคนจำนวนหนึ่งเหล่านี้อาจมีนับพันหรือนับหมื่น ได้เข้าร่วมเรียกร้องโดยมีการจัดระเบียบทางสังคมอย่างหลวมๆ ซึ่งแต่ละกลุ่มอาจมีระดับของการมีส่วนร่วมแตกต่างกัน ลักษณะร่วมบางประการของการเคลื่อนไหวทางสังคม คือ ผู้เข้าร่วมเคลื่อนไหวมีจุดมุ่งหมายที่แน่ชัด (goal-oriented) และมีความตั้งใจที่จะทำการเปลี่ยนแปลง (international change)",
    source:
      "สุวิดา ธรรมมณีวงศ์ อาจารย์ประจำภาควิชาสังคมศาสตร์ คณะอักษรศาสตร์ มหาวิทยาลัยศิลปากร. \r\nการเคลื่อนไหวทางสังคม, 28 สิงหาคม 2562. http://www.arts.su.ac.th/document/suwida/001.pdf",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "s"
  },
  {
    keyword: "Social Safety Net",
    meaning:
      "เป็นระบบสวัสดิการที่ให้ความช่วยเหลือเป็นพิเศษกล่าวคือ การให้ความช่วยเหลือประชาชนในประเทศไทยจะมีระบบหรือตาข่ายที่คอยรองรับประชาชนที่ประสบปัญหาวิกฤตเศรษฐกิจอยู่ 3 ชั้น คือ เมื่อประชาชนประสบปัญหาแล้วจะมีตาข่ายชั้นที่ 1 รองรับ แต่หากชั้นที่ 1 ไม่สามารถรองรับได้ก็จะมีตาข่ายชั้นที่ 2 รองรับ จนกระทั่งถึงตาข่ายชั้นสุดท้ายที่รองรับ เพื่อคอยรองรับประชาชนที่ประสบปัญหาให้มีความเดือดร้อนน้อยที่สุดหรือเจ็บตัวน้อยที่สุด โดยระบบที่ประเทศไทยมีไว้นี้จะเป็นเครื่องมือที่คอยให้ความช่วยเหลือประชาชนที่เดือนร้อนก่อนที่ภาครัฐจะให้เข้าไปให้ความช่วยเหลือ ขณะนี้ระบบตาข่ายความปลอดภัยทางสังคมในประเทศไทย 3 ระบบคือ 1.) ระบบการออมแบบผูกพันและไม่บังคับ 2.) ระบบการออมแบบบังคับ 3.) ระบบสวัสดิการสังคม ส่วนระบบ Social Safety Net จะเป็นระบบที่คอยรองรับประชาชนที่ตกจากตาข่ายความปลอดภัยทางสังคมทั้ง 3 ชั้นนั้นเพื่อเป็นตาข่ายขั้นสุดท้ายที่คอยรองรับประชาชนที่ประสบปัญหาวิกฤตเศรษฐกิจ ดังนั้นภาครัฐจึงได้พัฒนาระบบ Social Safety Net ให้เป็นรูปเป็นร่าง เพื่อเป็นเครื่องมือในการให้ความช่วยเหลือประชาชนที่เดือนร้อนจากปัญหาวิกฤตเศรษฐกิจโดยเป็นระบบที่ประชาชนทุกคนจะต้องได้รับโดยทั่วถึงและเข้าถึงสวัสดิการได้ง่าย และเพื่อไม่ให้เกิดความซ้ำซ้อนในการให้ความช่วยเหลือ",
    source:
      "สำนักนโยบายการออมและการลงทุน. (2558). ศัพท์น่ารู้เกี่ยวกับเศรษฐกิจ,1 กรกฏาคม 2562.http://www2.fpo.go.th/S-I/Source/word/Word.php?Language=Thai&BeginRec=96&NumRecShow=8&sort=6&search=",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "s"
  },
  {
    keyword: "Specific KPIs",
    meaning: "ตัวชี้วัดเฉพาะด้านหรือเฉพาะประเด็นการพัฒนา",
    source:
      "สำนักวิจัยและพัฒนาระบบงานบุคคล สำนักงาน ก.พ. (2556). ตัวชี้วัดกลางกลุ่มงานสนับสนุน KPI, 11 ตุลาคม 2562. https://dcy.go.th/webnew/upload/knowledge/knowledge_th_20161010203811_1.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "s"
  },
  {
    keyword: "Spillover effects",
    meaning: "ผลกระทบล้นไหล",
    source:
      'ดิเรก ปัทมสิริวัฒน์ กรรมการสภามหาวิทยาลัยเกษตรศาสตร์ผู้ทรงคุณวุฒิ. "ภาษีบาป" เครื่องมือลดผลกระทบภายนอกที่ไม่พึงปราถนา: มิติใหม่ของการจัดเก็บภาษีอากร, 11 ตุลาคม 2562. http://www.econ.tu.ac.th/econtuarchive/index.php/download-economic-ebook/%E0%B9%80%E0%B8%A8%E0%B8%A3%E0%B8%A9%E0%B8%90%E0%B8%AA%E0%B8%B2%E0%B8%A3-%E0%B8%84%E0%B8%93%E0%B8%B0%E0%B9%80%E0%B8%A8%E0%B8%A3%E0%B8%A9%E0%B8%90%E0%B8%A8%E0%B8%B2%E0%B8%AA%E0%B8%95%E0%B8%A3%E0%B9%8C-%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B8%A7%E0%B8%B4%E0%B8%97%E0%B8%A2%E0%B8%B2%E0%B8%A5%E0%B8%B1%E0%B8%A2%E0%B8%98%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B8%A8%E0%B8%B2%E0%B8%AA%E0%B8%95%E0%B8%A3%E0%B9%8C/%E0%B8%9B%E0%B8%B5%E0%B8%97%E0%B8%B5%E0%B9%88-21-%E0%B8%9E-%E0%B8%A8/618-%E0%B9%80%E0%B8%A8%E0%B8%A3%E0%B8%A9%E0%B8%90%E0%B8%AA%E0%B8%B2%E0%B8%A3-%E0%B8%9B%E0%B8%B5%E0%B8%97%E0%B8%B5-21-%E0%B8%89%E0%B8%9A%E0%B8%B1%E0%B8%9A%E0%B8%97%E0%B8%B5%E0%B9%88-7-%E0%B8%81%E0%B8%A3%E0%B8%81%E0%B8%8E%E0%B8%B2%E0%B8%84%E0%B8%A1-2550/download',
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "s"
  },
  {
    keyword: "SPPII",
    meaning: "Project Monitoring System II ระบบติดตามผลโครงการ",
    source:
      "กลุ่มรัฐธรรมนูญกับผลกระทบการบริหารราชการแผ่นดิน ข้าราชการในโครงการพัฒนานักบริหารการเปลี่ยนแปลงรุ่นใหม่ รุ่นที่ 10. (2561). รัฐธรรมนูญกับผลกระทบการบริหารราชการแผ่นดิน, 11 ตุลาคม 2562. http://www.igpthai.org/CGSME/file/upload/psed10.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "s"
  },
  {
    keyword: "Stakeholder",
    meaning:
      "ผู้ที่ได้รับผลกระทบ ทั้งทางบวกและทางลบ ทั้งทางตรง และทางอ้อม จากการดำเนินการของส่วนราชการของท่าน เช่น ประชาชน ชุมชนในท้องถิ่น บุคลากร ในส่วนราชการ ผู้ส่งมอบงาน รวมทั้งผู้รับบริการด้วย",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์ (สพธอ.). (2555). Stakeholders, 3 กันยายน 2562. https://www.etda.or.th/terminology-detail/1053.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "s"
  },
  {
    keyword: "Strategic Foundation",
    meaning:
      "รากฐานเชิงยุทธศาสตร์ เป็นกระบวนการที่กำหนดหลักสำคัญสำหรับเป็นพื้นฐานรองรับการพัฒนาเป็นกรอบทิศทางของยุทธศาสตร์ (กระบวนการ\r\nหลักลำดับถัดไป) กระบวนการกำหนดรากฐานเชิงยุทธศาสตร์\r\nประกอบด้วย 4 ขั้นตอนหลักต่อเนื่องกัน คือ \r\n1. การกำหนดความมุ่งประสงค์แห่งชาติ (National Purpose) \r\n2. การกำหนดผลประโยชน์แห่งชาติ (National Interests) \r\n3. การกำหนดข้อเสนอแนะดุลแห่งอำนาจ (Guidance for Balance of\r\nPower) \r\n4. การประเมินผลและการย้อนกลับข้อมูล (Evaluation and Feedback)",
    source:
      "วารสารสถาบันวิชาการป้องกันประเทศ. (2561). แนวทางการพัฒนายุทธศาสตร์ชาติเพื่อการปฏิรูปประเทศ, 18 ตุลาคม 2562. https://www.tci-thaijo.org/index.php/ndsijournal/article/download/125350/94977/",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "s"
  },
  {
    keyword: "Talent Mobility",
    meaning:
      "การส่งเสริมบุคลากรด้านวิทยาศาสตร์ เทคโนโลยี และการจัดการจากภาครัฐและสถาบันอุดมศึกษาไปปฏิบัติงานในภาคอุตสาหกรรมหรือภาคธุรกิจเอกชน เพื่อก่อให้เกิดการแลกเปลี่ยนและสร้างองค์ความรู้ใหม่ระหว่างกันอันจะส่งผลต่อการเพิ่มขีดความสามารถการแข่งขันและการพัฒนาในภาคการผลิตและบริการให้มีความเข้มแข็งมากยิ่งขึ้น",
    source:
      "ฝ่ายเลขานุการศูนย์ประชาคมอาเซียนของรัฐสภา รัฐสภา. (2556). ปัญหาการสนับสนุนงบประมาณในการค้นคว้าวิจัยเพื่อค้นหานวัตกรรมใหม่ก่อนเข้าสู่ประชาคมเศรษฐกิจอาเซียน (AEC), 3 กันยายน 2562. https://www.parliament.go.th/question_asean/question_view_detail.php?id=QklaMTQ=",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "t"
  },
  {
    keyword: "Tax Credit",
    meaning:
      "การให้สินธิอันมีค่าเป็นตัวเงินสำหรับประโยชน์การคำภาษี เช่น กรณีผู้เสียได้ถูกหักภาษี ณ ที่จ่ายไว้แล้วจะสามารถนำภาษีนั้นมาถือเป็นเครดิตเพื่อหักกลบกับเงินภาษีที่ผู้เสียภาษีมีหน้าที่จะต้องชำระตามกฎหมายโดยหากเครดิตมีมากกว่าจำนวนเงินที่จะต้องชำระแล้วผู้เสียภาษีย่อมมีสิทธิได้รับคืนเงินภาษีเป็นเงิน ในบางประเทศยังได้ให้สิทธิประโยชน์เพื่อชักจูงการลงทุนระยะยาวโดยให้เครดิตภาษีแก่นักลงทุนในกรณีที่นำกำไรกลับมาลงทุนในกิจการต่อไป (มีจำนวนเป็นสัดส่วนกับเงินส่วนเพิ่มของกิจการ) (Re-investment Tax Credit )",
    source:
      "สำนักนโยบายการออมและการลงทุน. (2549). ศัพท์น่ารู้เกี่ยวกับเศรษฐกิจ, 26 กันยายน 2562. http://www2.fpo.go.th/S-I/Source/word/Word.php?Language=Thai&BeginRec=392&NumRecShow=8&sort=4&search=",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "t"
  },
  {
    keyword: "THAILAND 4.0",
    meaning:
      "โมเดลเศรษฐกิจที่จะนำพาประเทศไทยให้หลุดพ้นจากกับดักประเทศรายได้ปานกลาง กับดักความเหลื่อมล้ำ และกับดักความไม่สมดุล พร้อมๆ กับเปลี่ยนผ่านประเทศไทยไปสู่ประเทศในโลกที่หนึ่ง ที่มีความมั่นคง มั่งคั่ง และยั่งยืน ในบริบทของโลกยุค The Fourth Industrial Revolution อย่างเป็นรูปธรรม ตามแนวทางที่แผนยุทธศาสตร์ชาติ 20 ปีได้วางไว้ ด้วยการสร้างความเข้มแข็งจากภายใน ควบคู่ไปกับการเชื่อมโยงกับประชาคมโลก ตามแนวคิด “ปรัชญาเศรษฐกิจพอเพียง” โดยขับเคลื่อนผ่านกลไก“ประชารัฐ”",
    source:
      "กองบริหารงานวิจัยและประกันคุณภาพการศึกษา. (2559). Thailand 4.0 โมเดลขับเคลื่อนประเทศไทยสู่ความมั่งคั่ง มั่นคง และยั่งยืน, 26 กันยายน 2562. http://www.libarts.up.ac.th/v2/img/Thailand-4.0.pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "t"
  },
  {
    keyword:
      "The Organisation for Economic Co-operation and Development (OECD)",
    meaning:
      "องค์การเพื่อความร่วมมือทางเศรษฐกิจและการพัฒนามีบทบาทสำคัญในการเสริมความแข็งแกร่งทางด้านเศรษฐกิจให้แก่ประเทศสมาชิก โดยการปรับปรุงประสิทธิภาพการบริหารจัดการ ส่งเสริมการค้าเสรี และให้ความช่วยเหลือเพื่อพัฒนาทั้งในประเทศอุตสาหกรรมและประเทศกำลังพัฒนา",
    source:
      "กรมอาเซียน กระทรวงต่างประเทศ. (2561, 30 สิงหาคม). ประวัติและพัฒนาการ OECD, 19 มิถุนายน 2562. http://www.mfa.go.th/business/th/customize/16520-%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%A7%E0%B8%B1%E0%B8%95%E0%B8%B4%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%9E%E0%B8%B1%E0%B8%92%E0%B8%99%E0%B8%B2%E0%B8%81%E0%B8%B2%E0%B8%A3-OECD.html",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "t"
  },
  {
    keyword: "Third Party Access: TPA",
    meaning:
      "รูปแบบการประกอบกิจการไฟฟ้าอีกรูปแบบหนึ่ง ที่กำหนดให้เจ้าของกิจการที่เป็นผู้ครอบครองระบบส่งไฟฟ้า (ซึ่งเป็นกิจการที่ผูกขาดโดยธรรมชาติ) ให้สิทธิ์แก่บุคคลอื่น บุคคลที่ 3 ที่ไม่ใช่ลูกค้าของตัวเอง รวมทั้งคู่แข่ง อาทิ ผู้ประกอบกิจการผลิตไฟฟ้าอิสระ ผู้ใช้ไฟฟ้าทั่วไป สามารถเข้ามาใช้ประโยชน์จากระบบส่งไฟฟ้าของตนในเชิงพานิชย์ได้ ภายใต้หลักการและข้อปฏิบัติของกฎหมาย โดยรัฐบาลจะเป็นผู้กำหนดนโยบายในการนำมาใช้ปฏิบัติ วัตถุประสงค์ของ Third Party Access จากรูปแบบในต่างประเทศ TPA เกิดขึ้นเพื่อ ส่งเสริมการแข่งขันด้านผู้ผลิตไฟฟ้า ให้มีอิสระในการซื้อขายไฟ โดยสามารถทำข้อตกลงซื้อขายไฟฟ้ากับผู้ใช้ไฟฟ้าได้โดยตรง ทั้งนี้ต้องรับภาระค่าใช้บริการผ่านระบบส่งไฟฟ้า",
    source:
      "นายวัชรกฤษณ์ จงไพบูลย์พัฒนะ สังกัด กองวางแผนปฏิบัติการระบบส่งไฟฟ้า ฝ่ายควบคุมระบบกําลังไฟฟ้า การไฟฟ้าฝ้ายผลิตแห่งประเทศไทย.Third Party Access: TPA, 1 กรกฎาคม 2562.http://www.appp.or.th/imgadmins/document/24151037.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "t"
  },
  {
    keyword: "Tight Gas",
    meaning:
      "ก๊าซธรรมชาติประเภท unconventional ที่พบได้ในชั้นหินหลายชนิด เช่น ชั้นหินทรายหรือชั้นหินปูน ไม่เฉพาะในชั้นหินดินดานเท่านั้น",
    source:
      "ศูนย์บริการข้อมูลธุรกิจไทยในอาร์เจนตินา. ภาคอุตสาหกรรม, 3 กันยายน 2562. http://www.thaibizargen.com/index.php?lay=show&ac=article&Id=539673734",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "t"
  },
  {
    keyword: "transaction",
    meaning: "การประกอบกิจกรรมอย่างใดอย่างหนึ่ง โดยเฉพาะด้านธุรกิจและการเงิน ",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2550). ธุรการและธุรกรรมมีความหมายต่างกัน, 4 ธันวาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%98%E0%B8%B8%E0%B8%A3%E0%B8%81%E0%B8%B2%E0%B8%A3-%E0%B9%81%E0%B8%A5%E0%B8%B0-%E0%B8%98%E0%B8%B8%E0%B8%A3%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1-%E0%B8%A1%E0%B8%B5%E0%B8%84%E0%B8%A7%E0%B8%B2",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "t"
  },
  {
    keyword: "Transparency International : TI",
    meaning:
      "องค์กรเพื่อความโปร่งใสนานาชาติเป็นผู้นำในการต่อสู้และต่อต้านการคอร์รัปชัน โดยมีภารกิจที่สำคัญคือสร้างการเปลี่ยนแปลงไปในทางที่ให้โลกปราศจากการคอร์รัปชัน",
    source:
      "ศูนย์ปฏิบัติการต่อต้านการทุจริต กระทรวงอุตสาหกรรม. (2562). คะแนนดัชนีการรับรู้การทุจริต (CPI : CORRUPTION PERCEPTIONS INDEX), 26 กันยายน 2562. http://www.industry.go.th/anti_corrupt/index.php/agency/ita/cpi",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "t"
  },
  {
    keyword: "Travel & Tourism Competitiveness Index (TTCI)",
    meaning: "อันดับความสามารถในการแข่งขันด้านการท่องเที่ยว",
    source:
      "สำนักงานประชาสัมพันธ์จังหวัดเชียงราย. (2562). การพัฒนาแหล่งท่องเที่ยวเชิงอนุรักษ์ สืบสานวัฒนธรรมล้านนา และภูมิปัญญาท้องถิ่น ch, 26 กันยายน 2562. http://prcr.prdnorth.in.th/news-detail.php?type=1&id=1528",
    sappear: 2,
    mappear: 5,
    rappear: "",
    firstalpha: "t"
  },
  {
    keyword: "Treasury Centers",
    meaning:
      "นิติบุคคลที่ได้รับอนุญาตจากรัฐมนตรีว่าการกระทรวงการคลังให้ประกอบธุรกิจเกี่ยวกับการบริหารจัดการเงินตราต่างประเทศให้กับกลุ่มบริษัท",
    source:
      "ธนาคารแห่งประเทศไทย. ศูนย์บริหารเงิน (Treasury Center), 26 กันยายน 2562. https://www.bot.or.th/Thai/FinancialMarkets/ForeignExchangeRegulations/ForeignMeansOfPaymenBusinesses/Pages/TreasuryCenter.aspx",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "t"
  },
  {
    keyword: "U.S. Priority Watchlist",
    meaning: "บัญชีประเทศที่ต้องจับตามองพิเศษจากสหรัฐฯ",
    source:
      "กรมทรัพย์สินทางปัญญา กระทรวงพาณิชย์. (2560). สหรัฐฯ ประกาศปรับสถานะการคุ้มครองทรัพย์สินทางปัญญาของไทย ออกจากบัญชีประเทศที่ต้องจับตามองพิเศษ (PWL), 26 กันยายน 2562. http://www.ipthailand.go.th/th/dip-news/item/%E0%B8%AA%E0%B8%AB%E0%B8%A3%E0%B8%B1%E0%B8%90%E0%B8%AF-%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%81%E0%B8%B2%E0%B8%A8%E0%B8%9B%E0%B8%A3%E0%B8%B1%E0%B8%9A%E0%B8%AA%E0%B8%96%E0%B8%B2%E0%B8%99%E0%B8%B0%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%84%E0%B8%B8%E0%B9%89%E0%B8%A1%E0%B8%84%E0%B8%A3%E0%B8%AD%E0%B8%87%E0%B8%97%E0%B8%A3%E0%B8%B1%E0%B8%9E%E0%B8%A2%E0%B9%8C%E0%B8%AA%E0%B8%B4%E0%B8%99%E0%B8%97%E0%B8%B2%E0%B8%87%E0%B8%9B%E0%B8%B1%E0%B8%8D%E0%B8%8D%E0%B8%B2%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B9%84%E0%B8%97%E0%B8%A2-%E0%B8%AD%E0%B8%AD%E0%B8%81%E0%B8%88%E0%B8%B2%E0%B8%81%E0%B8%9A%E0%B8%B1%E0%B8%8D%E0%B8%8A%E0%B8%B5%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B9%80%E0%B8%97%E0%B8%A8%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%95%E0%B9%89%E0%B8%AD%E0%B8%87%E0%B8%88%E0%B8%B1%E0%B8%9A%E0%B8%95%E0%B8%B2%E0%B8%A1%E0%B8%AD%E0%B8%87%E0%B8%9E%E0%B8%B4%E0%B9%80%E0%B8%A8%E0%B8%A9-pwl.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "u"
  },
  {
    keyword: "Unconventional Gas",
    meaning:
      "แก๊สธรรมชาติที่แตกต่างจากแก๊สธรรมชาติที่ใช้กันอยู่ในปัจจุบัน (Conventional gas) แก๊สธรรมชาติ (Unconventional Gas) เช่น แก๊สธรรมชาติจากหินดินดานจะอยู่ลึกลงไปถึงชั้นหินดินดาน ",
    source:
      "เจนจิรา ภูริรักษ์พิติกร นักวิทยาศาสตร์ปฏิบัติการ โครงการเคมี กรมวิทยาศาสตร์บริการ. แก๊สธรรมชาติจากหินดินดาน: พลังงานทางเลือกใหม่ของพลังงานโลก, 11 ตุลาคม 2562. http://lib3.dss.go.th/fulltext/dss_j/2556_61_191_P16-20.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "u"
  },
  {
    keyword: "Unearned Income",
    meaning:
      "เงินได้ที่มิได้มาจากการทำงาน เงินได้หรือผลประโยชน์อื่นใดที่เกิดจากการงอกเงยของทรัพย์สิน",
    source:
      "สำนักงานเศรษฐกิจการคลัง. (2557). เงินโอน แก้จน คนขยัน, 3 ตุลาคม 2562. http://www.fpo.go.th/main/getattachment/General-information-public-service/FPO-symposium/8515/NIT_Symposium_Benge_25-7-57.pdf.aspx",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "u"
  },
  {
    keyword: "United Nations Convention Against Corruption : UNCAC",
    meaning:
      "เป็นกฎหมายระหว่างประเทศด้านการต่อต้านการทุจริตในระดับนานาชาติฉบับแรก โดยมีพันธกรณีต่อรัฐภาคีแบ่งออกเป็น ๓ ระดับ ได้แก่ \r\n1. พันธกรณีที่รัฐภาคีจะต้องปฏิบัติตาม \r\n2. พันธกรณีที่รัฐภาคีมีสิทธิเลือกที่จะกระทำหรือไม่ก็ได้ และ \r\n3. พันธกรณีที่รัฐภาคีจะต้องพิจารณา \r\nโดยแบ่งเนื้อหาหลักในอนุสัญญา UNCAC ได้ 5 หมวดหมู่ คือ หมวดการป้องกันการทุจริต หมวดการกำหนดความผิดทางอาญาและการบังคับใช้กฎหมาย หมวดความร่วมมือระหว่างประเทศ หมวดการติดตามทรัพย์สินคืน และหมวดความช่วยเหลือด้านเทคนิคและการแลกเปลี่ยนข้อมูล ปัจจุบัน มีรัฐภาคีรวม 186 ประเทศ รวมไทยซึ่งได้ลงนามและให้สัตยาบันเข้าเป็นภาคีอนุสัญญา UNCAC เมื่อวันที่ 9 ธ.ค. 2546 และวันที่ 1 มี.ค. 2554 ตามลำดับ",
    source:
      "ศูนย์ปฏิบัติการต่อต้านการทุจริต (ศปท.) กระทรวงการต่างประเทศ. (2561). อนุสัญญาสหประชาชาติว่าด้วยการต่อต้านการทุจริต (United Nations Convention against Corruption: UNCAC), 26 กันยายน 2562. http://www.mfa.go.th/acc/th/news/6825/92645-%E0%B8%AD%E0%B8%99%E0%B8%B8%E0%B8%AA%E0%B8%B1%E0%B8%8D%E0%B8%8D%E0%B8%B2%E0%B8%AA%E0%B8%AB%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%8A%E0%B8%B2%E0%B8%8A%E0%B8%B2%E0%B8%95%E0%B8%B4%E0%B8%A7%E0%B9%88%E0%B8%B2%E0%B8%94%E0%B9%89%E0%B8%A7%E0%B8%A2%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%95%E0%B9%88%E0%B8%AD%E0%B8%95%E0%B9%89%E0%B8%B2%E0%B8%99%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%97%E0%B8%B8%E0%B8%88%E0%B8%A3%E0%B8%B4%E0%B8%95-(Uni.html",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "u"
  },
  {
    keyword: "Universal Design",
    meaning:
      "แนวคิดเรื่องการออกแบบสิ่งแวดล้อม การสร้างสถานที่ และสิ่งของต่าง ๆ เพื่อให้ทุกคนที่อยู่ในสังคมสามารถใช้ประโยชน์จากสิ่งเหล่านั้นได้อย่างเต็มที่และเท่าเทียมกัน โดยไม่ต้องมีการออกแบบดัดแปลงพิเศษหรือเฉพาะเจาะจงเพื่อบุคคลกลุ่มหนึ่งกลุ่มใดโดยเฉพาะ",
    source:
      "สำนักงานกองทุนสนับสนุนการสร้างเสริมสุขภาพ (สสส.). (2554).  เรื่องน่ารู้ Universal Design: การออกแบบเพื่อคนทั้งมวล, 30 กันยายน 2562. https://www.thaihealth.or.th/Content/17180-%E0%B9%80%E0%B8%A3%E0%B8%B7%E0%B9%88%E0%B8%AD%E0%B8%87%E0%B8%99%E0%B9%88%E0%B8%B2%E0%B8%A3%E0%B8%B9%E0%B9%89%20Universal%20Design:%20%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%AD%E0%B8%AD%E0%B8%81%E0%B9%81%E0%B8%9A%E0%B8%9A%E0%B9%80%E0%B8%9E%E0%B8%B7%E0%B9%88%E0%B8%AD%E0%B8%84%E0%B8%99%E0%B8%97%E0%B8%B1%E0%B9%89%E0%B8%87%E0%B8%A1%E0%B8%A7%E0%B8%A5.html",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "u"
  },
  {
    keyword: "up-cycle",
    meaning:
      "กระบวนการที่เน้นการใช้ทรัพยากรอย่างคุ้มค่าด้วยการพัฒนาให้เศษวัสดุเหลือใช้กลายเป็นผลิตภัณฑ์ใหม่ที่มีคุณภาพและมีมูลค่าสูงขึ้น",
    source:
      "กรมส่งเสริมคุณภาพสิ่งแวดล้อม กระทรวงทรัพยากรธรรมชาติและสิ่งแวดล้อม. ระบบรับรองผลิตภัณฑ์หรือวัสดุที่ผลิตจากวัสดุเหลือใช้ที่เป็นมิตรกับสิ่งแวดล้อม (G-Upcycle) - เกี่ยวกับ G Upcycle, 3 ตุลาคม 2562. https://www.deqp.go.th/service-portal/g-green/gupcycle/%E0%B9%80%E0%B8%81-%E0%B8%A2%E0%B8%A7%E0%B8%81-%E0%B8%9A-g-upcycle/",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "u"
  },
  {
    keyword: "Value added",
    meaning:
      "ส่วนต่างระหว่างมูลค่าการผลิตและค่าใช้จ่ายขั้นกลางในการผลิต หรือกล่าวอีกนัยหนึ่งว่า มูลค่าเพิ่มประกอบปัจจัยการผลิตดังนี้\r\n1. ค่าจ้าง หรือค่าตอบแทนแรงงาน\r\n2. ภาษีทางอ้อม หัก เงินอุดหนุน\r\n3. ค่าเสื่อมราคา\r\n4. ส่วนเกินของการประกอบการ",
    source:
      "สำนักบัญชีประชาชาติ สำนักงานคณะกรรมการพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. คู่มือการประมวลผลสถิติบัญชีประชาชาติ, 3 ตุลาคม 2562. http://www.nesdc.go.th/ewt_dl_link.php?nid=3521&filename=national_account",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "v"
  },
  {
    keyword: "value for money",
    meaning: "ความคุ้มค่าทางการเงิน",
    source:
      "สำนักงานคณะกรรมการนโยบายรัฐวิสาหกิจ (สคร.). เกี่ยวกับการให้เอกชนร่วมทุนในกิจการของรัฐ, 3 ตุลาคม 2562. http://www.ppp.sepo.go.th/contents/4",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "v"
  },
  {
    keyword: "visa on arrival",
    meaning: "การตรวจลงตรา ณ ช่องทางอนุญาตของด่านตรวจคนเข้าเมือง",
    source:
      "ระเบียบสำนักงานตรวจคนเข้าเมือง พ.ศ. 2557. (2557, 10 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 131 ตอนพิเศษ 225 ง หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2557/E/225/2.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "v"
  },
  {
    keyword: "Visionary",
    meaning: "คนที่จะทำให้ Vision ประสบผลสำเร็จ",
    source:
      'กลุ่มงานคุ้มครองจริยธรรมกรมราชทัณฑ์. (2557). "วิสัยทัศน์กรมราชทัณฑ์" ความหมายของคำว่าวิสัยทัศน์ (Vision), 3 ตุลาคม 2562. http://www.correct.go.th/osss/a25547_57.pdf',
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "v"
  },
  {
    keyword: "Wage Income",
    meaning: "จัดเก็บภาษีเงินได้ในอัตราที่ต่ำกว่าค่าจ้างแรงงาน",
    source:
      "สำนักงานเศรษฐกิจการคลัง. การศึกษาแนวทางนำระบบภาษีเงินได้แบบแยกที่มาของเงินได้มาใช้ในประเทศ, 3 ตุลาคม 2562. http://www.fpo.go.th/eresearch/getattachment/215882bc-071a-4484-9c2d-3dc11f0a4e04/7712.aspx",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "w"
  },
  {
    keyword: "Wealth Income",
    meaning: "เงินได้ที่มิได้มาจากการทำงาน",
    source:
      "ดร.ปัณณ์ อนันอภิบุตร นายวิธีร์ พานิชวงศ์ ดร.สุมาพร ศรีสุนทร และนางสาวลลิตา ละสอน สำนักงานเศรษฐกิจการคลัง. (2557). เงินโอน แก้จน คนขยัน (Negative Income Tax), 11 ตุลาคม 2562. http://www.fpo.go.th/main/getattachment/General-information-public-service/FPO-symposium/8515/NIT_Symposium_Benge_25-7-57.pdf.aspx",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "w"
  },
  {
    keyword: "Web Crawler",
    meaning:
      "การดึงข้อมูลจากหน้าที่ระบุวัตถุบริวารต่างๆ ที่ประกอบกับหน้าเว็บนั้นเช่น รูปภาพ เป็นต้น พร้อมทั้งทำการดึงหน้าเว็บที่มีการเชื่อมต่อจากหน้าเว็บต้องการ โดยมุ่งหวังที่จะทำการคัดลอกเว็บไซต์ที่สมบูรณ์ เพื่อนำไปใช้ในการทำดัชนีค้นหาของโปรแกรมค้นหา เช่น กูเกิล หรือเพื่อจัดเก็บไว้ดูในสภาวะที่ผู้ใช้ไม่สามารถเชื่อมต่อกับอินเทอร์เน็ตได้",
    source:
      "รศ.ดร.วิโรจน อรุณมานะกุล ภาควิชาภาษาศาสตร์ คณะอักษรศาสตร จุฬาลงกรณมหาวิทยาลัย. (2559). การสร้างคลังข้อมูลภาษาไทยแบบสั่งสมและการสกัดหาคำเขียนผิดขรวิธีและคำปรากฏใหม่, 3 ตุลาคม 2562. http://pioneer.chula.ac.th/~awirote/publications/tmc-report.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "w"
  },
  {
    keyword: "World Bank",
    meaning:
      "แหล่งเงินทุนและให้ความช่วยเหลือทางเทคนิคที่สำคัญแก่ประเทศกำลังพัฒนาทั่วโลก",
    source:
      "สำนักงานส่งเสริมสังคมแห่งการเรียนรู้และคุณภาพเยาวชน (สสค.). (2555). ธนาคารโลก, 26 กันยายน 2562. http://www.qlf.or.th/Home/Contents/198",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "w"
  },
  {
    keyword: "World Bank’s Ease of Doing Business Index",
    meaning:
      "การจัดอันดับความยากง่ายในการประกอบธุรกิจในประเทศต่าง ๆ ทั่วโลก โดยธนาคารโลก",
    source:
      "กรมบังคับคดี กระทรวงยุติธรรม. (2560). การประชุมเพื่อรายงานผลการจัดอันดับความยาก-ง่าย ในการประกอบธุรกิจของธนาคารโลก ประจำปี 2561, 26 กันยายน 2562. http://www.led.go.th/doing/pdf/4EODB.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "w"
  },
  {
    keyword: "world Economic Forum (WEF)",
    meaning:
      "องค์กรระหว่างประเทศในด้านความร่วมมือระหว่างภาครัฐและเอกชน (International Organization for Public-Private Cooperation) การดำเนินกิจกรรมเพื่อเสนอแนะทิศทางในการกำหนดนโยบายด้านเศรษฐกิจ สังคม และการพัฒนาในระดับระหว่างประเทศ ผ่านเครือข่ายผู้นำภาคการเมือง ธุรกิจ และภาคประชาสังคม",
    source:
      "กองนโยบายเศรษฐกิจระหว่างประเทศ กรมเศรษฐกิจระหว่างประเทศ. (2555). World Economic Forum (WEF), 26 กันยายน 2562. http://www.mfa.go.th/business/th/cooperation/252/16479-World-Economic-Forum-(WEF).html",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "w"
  },
  {
    keyword: "Young Smart Farmer",
    meaning:
      "เกษตรกรรุ่นใหม่ที่ประกอบอาชีพและมีความสามารถ\r\nด้านการเกษตร สามารถทดแทนเกษตรกรรุ่นสูงอายุ นำเทคโนโลยีสมัยใหม่มาประยุกต์ใช้เพื่อเพิ่มประสิทธิภาพการผลิต การบริหารการจัดการ และการตลาดสินค้าเกษตร ไม่จำกัดเพศ อายุระหว่าง 17 – 45 ปี ",
    source:
      "กลุ่มพัฒนากลุ่มเกษตรกร กองพัฒนาสหกรณ์ภาคการเกษตรและกลุ่มเกษตรกร กรมส่งเสริมสหกรณ์. (2561). \r\nโครงการพัฒนาเกษตรกรปราดเปรื่อง (Smart Farmer)} 28 สิงหาคม 2562. \r\nhttp://office.cpd.go.th/dacfg/images/Karn2561/Smart-Farmer-2018.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "y"
  },
  {
    keyword: "เกษตร 4.0",
    meaning:
      "การเกษตรที่ใช้นวัตกรรมแบบเกษตรอัจฉริยะ (Smart Agriculture) ตั้งแต่การผลิต-แปรรูป-ตลาด ด้วยสินค้าที่มีความปลอดภัย ยกระดับมูลค่าด้วยคุณภาพมาตรฐาน ประหยัดทรัพยากรน้ำ และใช้พื้นที่การเกษตรให้เกิดประโยชน์สูงสุดเชิงเศรษฐกิจและสังคม",
    source:
      "ภูมิศักดิ์ ราศร สำนักงานเศรษฐกิจการเกษตร. แนวนโยบายการพัฒนาการเกษตรของไทย สู่การเชื่อมโยงระดับอุตสาหกรรม, 30 กรกฎาคม 2562.  https://www.gftexpo.com/images/ppt_%E0%B8%9A%E0%B8%A3%E0%B8%A3%E0%B8%A2%E0%B8%B2%E0%B8%A2_5%E0%B8%81%E0%B8%84_60.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรเพิ่มมูลค่า",
    meaning:
      "การนําผลิตผลทางการเกษตรมาแปรรูปโดยใช้กรรมวิธีการผลิตที่ไม่ซับซ้อน โดยเป็นการแปรรูปเพื่อให้ตรงกับความต้องการของผู้บริโภคเพื่อเพิ่มมูลค่าสินค้า สามารถจำแนกประเภทออกได้ดังนี้\r\n1. สินค้าเกษตรที่ไม่ใช่อาหาร เช่น ชานอ้อยจากโรงงานน้ำตาลที่สามารถนำไปใช้เป็นเชื้อเพลิง วัตถุดิบในการผลิตเยื่อกระดาษและไม้อัด เป็นต้น\r\n2. สินค้าเกษตรที่เป็นอาหาร ซึ่งต้องผ่านการแปรรูปให้เป็นผลิตภัณฑ์อาหารชนิดใหม่ เช่น การอบตากแห้ง การเผา คั่ว ทอด หรือการหมัก เป็นต้น",
    source:
      "กลุ่มส่งเสริมและพัฒนาผลิตภัณฑ์วิสาหกิจชุมชน กองส่งเสริมวิสาหกิจชุมชน กรมส่งเสริมการเกษตร. (ม.ป.ป). ความสำคัญของการสร้างมูลค่าเพิ่มสินค้าเกษตร, 5 มิถุนายน 2562. http://www.sceb.doae.go.th/data/ktank/ความสำคัญของการสร้างมูลค่าเพิ่มสินค้าเกษตร.pdf",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรแนวตั้ง",
    meaning:
      "การเพาะปลูกพืชในอาคารหรือโรงเรือนในลักษณะเป็นชั้น โดยใช้เทคโนโลยีต่าง ๆ เข้ามาช่วยในการเพาะปลูก ทั้งการควบคุมแสง ความชื้น ความเป็นกรด-ด่าง และความอุดมสมบูรณ์ของวัสดุปลูก ระบบการให้น้ำ การควบคุมโรคและแมลงศัตรูพืช รวมทั้ง การคัดเลือกพันธุ์พืช นอกจากนั้น ในการทำเกษตรกรรมแนวตั้งบางรูปแบบยังมีการนำระบบเทคโนโลยีสารสนเทศและคอมพิวเตอร์เข้ามาบริหารจัดการโรงเรือนอย่างเต็มรูปแบบ ได้แก่ การติดตามและควบคุมการเจริญเติบโตของพืช การวิเคราะห์แสงและควบคุมปริมาณแสง การควบคุมความชื้น และการควบคุมระบบการให้น้ำแบบเรียลไทม์ (real time) ส่งผลให้การทำเกษตรกรรมแนวตั้งสามารถเพาะปลูกได้ตลอดทั้งปี ในพื้นที่ขนาดจำกัด และได้ผลผลิตที่มีคุณภาพและปริมาณสูงกว่าการทำเกษตรกรรมทั่วไป",
    source:
      "สถาบันวิจัยสภาวะแวดล้อม จุฬาลงกรณ์มหาวิทยาลัย, เรื่องน่ารู้ : การทำเกษตรกรรมแนวตั้ง (Vertical Farming), 27 พฤศจิกายน 2561http://www.ej.eric.chula.ac.th/content/6105/35",
    sappear: 2,
    mappear: 3,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรแปรรูป",
    meaning:
      "การนำผลผลิตทางการเกษตรที่อยู่ในพื้นที่มาแปรรูปโดยผ่านกระบวนการทางวิทยาศาสตร์และเทคโนโลยีในกรรวิธีการผลิต ซึ่งมีประโยชน์ในการช่วยเก็บรักษาผลผลิตทางการเกษตรไว้บริโภคในครัวเรือนเป็นเวลานานโดยไม่เน่าเสีย หรือทำให้เกิดผลิตภัณฑ์ใหม่ๆ ที่มีรูปแบบและรสชาติแตกต่างจากไปเดิม ช่วยเพิ่มความหลากหลายให้แก่ผลผลิตทางการเกษตร ทำให้บริโภคสะดวกและง่ายขึ้น นอกจากนี้ยังช่วยเพิ่มช่องทางของตลาดให้มากขึ้น ตลอดจนช่วยกระจายปริมาณสินค้าเกษตรออกสู่ตลาดในปริมาณที่สมดุล",
    source:
      "ศูนย์ศึกษาการพัฒนาอ่าวคุ้งกระเบน กรมประมง. (2556). การแปรรูปผลผลิตทางการเกษตร, 5 มิถุนายน 2562. https://www.fisheries.go.th/cf-kung_krabaen/knowledge_14.pdf",
    sappear: 2,
    mappear: "3,9",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรแม่นยำ",
    meaning:
      "การทำเกษตรที่มีการวิเคราะห์สภาพพื้นที่ มุ่งเน้นการเพิ่มประสิทธิภาพ (Efficiency) และเพิ่มผลผลิตต่อพื้นที่ (Productivity) โดยใช้เทคโนโลยีและเครื่องจักรกลการเกษตรอัจฉริยะ ควบคุมกระบวนการผลิตในทุกขั้นตอน",
    source:
      "สำนักอธิบดีกรมพัฒนาที่ดิน กรมพัฒนาที่ดิน. 2562. สัมมนาเกษตรอัจฉริยะ, 24 เมษายน 2562 ณ ห้องมิราเคิลแกรนด์ซี ชั้น 4 โรงแรมมิราเคิล แกรนด์ คอนเวนชั่น กรุงเทพมหานคร:  กรุงเทพมหานคร.",
    sappear: 2,
    mappear: 3,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรในร่ม",
    meaning:
      "วิธีการในการทำเกษตรกรรมในอาคารสูง โรงเรือน โดยทั่วไปแล้วจะมีการใช้วิธีการปลูกแบบไฮโดรโปนิกส์ มีการใช้แสงจากหลอดไฟ LED และให้ธาตุอาหารที่เหมาะสมต่อการเจริญเติบโตของพืช",
    source:
      "Maximum yield.Indoor agriculture, 6 มิถุนายน 2562. https://www.maximumyield.com/definition/2151/indoor-farming",
    sappear: 2,
    mappear: 3,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรกร",
    meaning:
      "บุคคลธรรมดาที่ประกอบการเกษตร หรือนิติบุคคลที่มีวัตถุประสงค์ในการประกอบการเกษตร และได้ขึ้นทะเบียนเกษตรกรไว้กับหน่วยงานที่ขึ้นทะเบียนตามระเบียบฯ",
    source:
      "ศูนย์เทคโนโลยีสารสนเทศและการสื่อสาร กรมส่งเสริมการเกษตร กระทรวงเกษตรและสหกรณ์. คู่มือการขึ้นทะเบียน/ปรับปรุงทะเบียนเกษตรกร, 18 กันยายน 2562. http://farmer.doae.go.th/farmer61s.pdf\r\n",
    sappear: "",
    mappear: 3,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรกรรม",
    meaning:
      "การเพาะปลูก การเลี้ยงสัตว์ การจับสัตว์น้ำ การใช้และบำรุงรักษาทรัพยากรจากที่ดิน น้ำ และป่าไม้อย่างยั่งยืน และให้หมายความรวมถึงการสร้างมูลค่าเพิ่ม การแปรรูป การจำหน่าย ซึ่งเป็นกิจกรรมที่เกี่ยวเนื่องกับการเพาะปลูก การเลี้ยงสัตว์การจับสัตว์น้ำ การใช้และบำรุงรักษาทรัพยากรจากที่ดิน น้ำ และป่าไม้อย่างยั่งยืน และการอื่นตามที่รัฐมนตรีประกาศกำหนดในราชกิจจานุเบกษา\r\n",
    source:
      "พระราชบัญญัติกองทุนฟื้นฟูและพัฒนาเกษตรกร พ.ศ. 2542 (2542, 18 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 116 ตอนที่ 39 ก หน้า 13 http://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/039/13.PDF\r\n",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรกรรมยั่งยืน",
    meaning:
      "เป็นทางเลือกหนึ่งในการดำรงชีวิตและประกอบอาชีพของเกษตรกรรายย่อย โดยรูปแบบและวิธีการทำการเกษตรอย่างยั่งยืน จะขึ้นอยู่กับศักยภาพและความเหมาะสมของสภาพแวดล้อมในแต่ละพื้นที่และการตัดสินใจเลือกของเกษตรกร ซึ่งพิจารณาจากทรัพยากรธรรมชาติและสิ่งแวดล้อมที่มีอยู่ใน ภูมินิเวศ ฐานความรู้ ภูมิปัญญา และประสบการณ์การทำการเกษตรที่สั่งสมของเกษตรกร และฐานทางสังคม ที่สนับสนุนเกษตรกร มีการช่วยเหลือเกื้อกูล และแลกเปลี่ยนเรียนรู้ร่วมกัน โดยรูปแบบการทำเกษตรกรรมยั่งยืน ประกอบด้วย 5 รูปแบบหลักๆ ที่มีจุดเด่นแตกต่างกัน ดังนี้\r\n1. เกษตรทฤษฎีใหม่\r\n2. วนเกษตร\r\n3. เกษตรผสมผสาน\r\n4. เกษตรอินทรีย์\r\n5. เกษตรธรรมชาติ",
    source:
      "สำนักงานปลัดกระทรวงเกษตรและสหกรณ์, กองนโยบายเทคโนโลยีเพื่อการเกษตรและเกษตรกรรมยั่งยืน. รูปแบบการพัฒนาการเกษตรแบบยั่งยืน, 10 พฤศจิกายน 2559. https://www.opsmoac.go.th/sustainable_agri-sustainable_agri-preview-382891791792",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรชีวภาพ",
    meaning:
      "การทำเกษตร เพื่ออนุรักษ์ทรัพยากรธรรมชาติและสิ่งแวดล้อม เพื่ออนุชนรุ่นหลัง โดยการพัฒนาปลูก พืชหรือเลี้ยงสัตว์ เพื่อผลิตอาหารที่ปลอดภัย จากสารพิษและเกษตรอินทรีย์ โดยการ หยุดใช้สารเคมีที่เป็นพิษทางการเกษตร เช่น ยาปราบศัตรูพืช ได้แก่ ยาฆ่าแมลง ยาป้องกันกำจัดโรคพืช ยาป้องกันกำจัดแมลง ฯลฯ",
    source:
      "มหาวิทยาลัยเกษตรศาสตร์. (2545). การปลูกพริก, 23 กรกฎาคม 2562. https://www.ku.ac.th/e-magazine/january46/agri/chilli.html",
    sappear: 2,
    mappear: "3,9",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรทฤษฎีใหม่",
    meaning:
      "ระบบเกษตรที่เน้นการจัดการแหล่งน้ำ และการจัดสรรแบ่งส่วนพื้นที่ทำการเกษตรอย่างเหมาะสม ซึ่งจะทำให้เกษตรกรมีข้าวปลาอาหารไว้บริโภคอย่างพอเพียงตาม อัตตภาพ อันจะเป็นการแก้ปัญหาในเรื่องชีวิตความเป็นอยู่ของเกษตรกรแล้ว ยังก่อให้เกิดความมั่นคงทางเศรษฐกิจโดยรวมของประเทศ",
    source:
      "มูลนิธิเกษตรกรรมยั่งยืน (ประเทศไทย). เกษตรทฤษฎีใหม่ (New Theory farming), 23 กรกฎาคม 2562. http://www.sathai.org/autopagev4/show_page.php?topic_id=685&auto_id=15&TopicPk=",
    sappear: 2,
    mappear: 3,
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรธรรมชาติ",
    meaning:
      "ระบบเกษตรที่ร่วมกับธรรมชาติได้อย่างสอดคล้อง สร้างผลผลิตพืชและสัตว์ให้เหมาะสมกับระบบนิเวศของพื้นที่ โดยไม่แบ่งแยกทุกสิ่งออกจากธรรมชาติ พยายามแทรกแซงการใช้ปัจจัยการผลิตและเทคโนโลยีทางการผลิตให้น้อยที่สุด ทำให้ระบบการเกษตรและธรรมชาติเกื้อกูลซึ่งกันและกันอย่างเป็นองค์รวม เน้นการนำกระบวนการควบคุมธรรมชาติโดยธรรมชาติ โดยไม่มีการใช้สารเคมีในการป้องกันและกำจัดศัตรูพืช รวมทั้งไม่ใช้ปุ๋ยเคมีหรือเทคโนโลยีใดๆ เข้ามาแทรกแซงหรือใช้ในการปรับปรุงทรัพยากรธรรมชาติ การดำเนินกิจกรรมธรรมชาติจะต้องไม่ไถพรวนดิน ซึ่งก่อให้เกิดการทำลายโครงสร้างดิน เนื่องจากธรรมชาติได้สร้างให้ดินมีกระบวนการที่เป็นการไถพรวนในตัวเอง ช่วยลดการใช้หรือพึ่งพาปัจจัยการผลิตจากภายนอก และลดการแทรกแซงของมนุษย์ที่มีต่อธรรมชาติให้มากที่สุด โดยหันมาใช้กลไกทางธรรมชาติในการผลิตทางการเกษตร เกษตรกรสามารถประหยัดค่าใช้จ่าย โดยสร้างภูมิคุ้มกันจากต้นทุนทางการผลิต ลดรายจ่ายของครอบครัวโดยไม่ต้องซื้อสารเคมีกำจัดศัตรูพืชหรือปุ๋ยเคมี มีวิถีชีวิตความเป็นอยู่แบบพึ่งพาตนเอง และผลิตเพื่อการบริโภคภายในครัวเรือนและมั่นคงภายใต้ระบบนิเวศที่สมดุลในพื้นที่ของตน",
    source:
      "ปราชญ์เกษตรของแผ่นดิน กองนโยบายเทคโนโลยีเพื่อการเกษตรและเกษตรกรรมยั่งยืน สำนักงานปลัดกระทรวงเกษตรและสหกรณ์. (2559). เกษตรธรรมชาติ, 5 มิถุนายน 2562. https://www.moac.go.th/philosopher-sustainable_agri-preview-382891791797",
    sappear: 2,
    mappear: 3,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรปลอดภัย",
    meaning:
      "ระบบการเกษตรที่จะให้ผลิตผลที่ปลอดภัยจากสารพิษ หรือปลอดภัยจากการปนเปื้อนของสารและโลหะที่จะมีผลต่อผู้บริโภค นอกจากนั้นระบบการผลิตนั้นจะต้องปลอดภัยกับสิ่งแวดล้อม และเกษตรกรผู้ผลิตด้วย \r\nระบบเกษตรปลอดภัยอีกระบบหนึ่งที่กระทรวงเกษตรและสหกรณ์ ได้พัฒนาและส่งเสริมให้เป็นระบบมาตรฐานของชาติ โดยคำนึงถึงความปลอดภัยของบุคคลที่เกี่ยวข้อง ทั้งเกษตรกร ผู้ผลิต ผู้บริโภค รวมถึงผลกระทบต่อสิ่งแวดล้อม โดยคำนึงถึงความเป็นไปได้ และการยอมรับของผู้เกี่ยวข้อง ระบบนี้คือ “ระบบเกษตรดีที่เหมาะสม” หรือ GAP (Good Agricultural Practices , Good Animal Practices , Good Aguatic Practices) ระบบนี้สามารถผลิตได้ทั้งพืช ปศุสัตว์ และประมง",
    source:
      "ประสาท เกศวพิทักษ์ ที่ปรึกษาปลัดกระทรวงเกษตรและสหกรณ์. เกษตรปลอดภัย, 23 กรกฎาคม 2562. http://www.thaifert.com/knowledge_detail.php?id=13 ",
    sappear: "2,5",
    mappear: "3,6,9",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรผสมผสาน",
    meaning:
      "ระบบการเกษตรที่มีการปลูกพืชและการเลี้ยงสัตว์ มีสัตว์หลายชนิดในพื้นที่เดียวกัน \r\n โดยที่กิจกรรมการผลิตแต่ละชนิดจะต้องสามารถเกื้อกูลประโยชน์ต่อกันได้อย่างมีประสิทธิภาพ\r\n เป็นการใช้ทรัพยากรที่มีอยู่ภายในไร่นาอย่างเหมาะสมเพื่อก่อให้เกิดประโยชน์สูงสุด",
    source:
      "กองนโยบายเทคโนโลยีเพื่อการเกษตร และเกษตรกรรมยั่งยืน สำนักงานปลัดกระทรวงเกษตรและสหกรณ์. (2559). เกษตรผสมผสาน, 5 มิถุนายน 2562.\r\n https://www.moac.go.th/philosopher-sustainable_agri-preview-382891791795",
    sappear: "2,5",
    mappear: 3,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรพันธสัญญา",
    meaning:
      "ระบบการผลิตผลิตผลหรือบริการทางการเกษตรที่เกิดขึ้นจากสัญญา\r\nการผลิตผลิตผลหรือบริการทางการเกษตรประเภทเดียวกันระหว่าง\r\nผู้ประกอบธุรกิจ ทางการเกษตรฝ่ายหนึ่งกับบุคคลธรรมดาซึ่งประกอบอาชีพเกษตรกรรมตั้งแต่สิบรายขึ้นไป หรือกับสหกรณ์การเกษตรหรือ\r\nกลุ่มเกษตรกรตามกฎหมายว่าด้วยสหกรณ์ หรือกับวิสาหกิจชุมชนหรือเครือข่ายวิสาหกิจชุมชนตามกฎหมายว่าด้วยการส่งเสริมวิสาหกิจชุมชนซึ่งประกอบอาชีพเกษตรกรรมอีกฝ่ายหนึ่งที่มีเงื่อนไขในการผลิต จําหน่าย หรือจ้างผลิตผลิตผลหรือบริการทางการเกษตรอย่างหนึ่งอย่างใด \r\nโดยเกษตรกรตกลงที่จะผลิต จําหน่าย หรือรับจ้างผลิตผลิตผลทางการเกษตรตามจํานวน คุณภาพ ราคา หรือระยะเวลาที่กําหนดไว้ และ\r\nผู้ประกอบธุรกิจทางการเกษตรตกลงที่จะซื้อผลิตผลดังกล่าวหรือ\r\nจ่ายค่าตอบแทนตามที่กําหนดไว้ตามสัญญา โดยผู้ประกอบธุรกิจทางการเกษตรเข้าไปมีส่วนในกระบวนการผลิตเช่น เป็นผู้กําหนดวิธีการผลิต จัดหาพันธุ์ เมล็ดพันธุ์ ผลิตภัณฑ์ทางการเกษตร หรือปัจจัยการผลิตให้แก่เกษตรกร",
    source:
      "พระราชบัญญัติส่งเสริมและพัฒนาระบบเกษตรพันธสัญญา พ.ศ. 2560 (2560, 22 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 134 ตอนที่ 131. หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/A/056/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรยั่งยืนและปลอดภัย",
    meaning:
      "ระบบเกษตรกรรมที่เกี่ยวข้องกับการผสมผสานและเชื่อมโยงระหว่างดิน การเพาะปลูก และการเลี้ยงสัตว์ การเลิกหรือลดการใช้ทรัพยากรจากภายนอกระบบที่อาจเป็นอันตรายต่อสิ่งแวดล้อมและ/หรือสุขภาพของเกษตรกรและผู้บริโภค",
    source:
      "สมโสถติ์ ดำเนินงาม ผู้อำนวยการกองวิจัยและพัฒนาการจัดการที่ดิน กรมพัฒนาที่ดิน. บทบาทเครือข่ายภาครัฐ-ประชาสังคมในการขับเคลื่อนเกษตรกรรมยั่งยืน, 31 ตุลาคม 2562. https://www.opsmoac.go.th/sustainable_agri-dwl-files-391691791809",
    sappear: 2,
    mappear: 6,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรอัจฉริยะ",
    meaning:
      "การนำเทคโนโลยีที่ทันสมัยทั้งระบบคอมพิวเตอร์ การสื่อสาร ระบบเซนเซอร์และเทคโนโลยีชีวภาพมาผสมผสานกับงานด้านการเกษตร ควบคู่กับการเกษตรแบบวิศวกรรมเปลี่ยนแปลง (Geoengineering) ที่จะนำเอาเทคโนโลยีทันสมัยเข้ามาช่วย ",
    source:
      "สิตาวีร์ ธีรวิรุฬห์ สำนักวิชาการ สำนักงานเลขาธิการสภาผู้แทนราษฎร. (2559). สมาร์ทฟาร์ม (Smart Farm) การทเกษตรที่เป็นมิตรกับสิ่งแวดล้อม, 23 กรกฎาคม 2562. ",
    sappear: "2,5",
    mappear: "3,9",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรอัตลักษณ์พื้นถิ่น",
    meaning:
      "การส่งเสริมการนำอัตลักษณ์พื้นถิ่นและภูมิปัญญาท้องถิ่นมาใช้ในการผลิตสินค้าและผลิตภัณฑ์ทางการเกษตรที่มีมูลค่าเพิ่มเป็นสินค้าเกษตรชนิดใหม่ให้รองรับความต้องการของตลาดยุคใหม่ ส่งเสริมการประยุกต์ใช้ภูมิปัญญาและเทคโนโลยีการพัฒนากระบวนการผลิตและบรรจุภัณฑ์ พัฒนาคุณภาพให้ได้รับการรับรองมาตรฐาน รวมถึงส่งเสริมการขึ้นทะเบียนรับรองสิ่งบ่งชี้ทางภูมิศาสตร์ ตลอดจนส่งเสริมแบรนด์และสร้างเรื่องราวของสินค้าให้เป็นที่รู้จักและยอมรับ",
    source:
      "สุภัทร คำมุงคุณ วิทยากรเชี่ยวชาญ กลุ่มงานบริการวิชาการ 2 สำนักวิชาการ. (2562). การเกษตรสร้างมูลค่าตามยุทธศาสตร์ชาติ20 ปี, 31 ตุลาคม 2562. http://library2.parliament.go.th/giventake/content_royrueng/2562/rr2562-mar2.pdf",
    sappear: 2,
    mappear: 3,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรอินทรีย์",
    meaning:
      "ระบบจัดการการผลิตด้านการเกษตรแบบองค์รวมที่เกื้อหนุนต่อระบบนิเวศ รวมถึงความหลากหลายทางชีวภาพ วงจรชีวภาพ โดยเน้นการใช้วัสดุธรรมชาติ หลีกเลี่ยงการใช้วัตถุดิบจากการสังเคราะห์และไม่ใช้พืช สัตว์หรือจุลินทรีย์ที่ได้มาจากเทคนิคการดัดแปรพันธุกรรม (genetic modification) มีการจัดการกับผลิตภัณฑ์โดยเน้นการแปรรูปด้วยความระมัดระวัง เพื่อรักษาสภาพการเป็นเกษตรอินทรีย์และคุณภาพที่สำคัญของผลิตภัณฑ์ในทุกขั้นตอน",
    source:
      "สำนักงานมาตรฐานสินค้าเกษตรและอาหารแห่งชาติ กระทรวงเกษตรและสหกรณ์. แนวปฏิบัติในการใช้มาตรฐานสินค้าเกษตร เกษตรอินทรีย์ เล่ม 1 : การผลิต แปรรูป แสดงฉลาก และจําหน่ายผลิตผลและผลิตภัณฑ์เกษตรอินทรีย์ ตามพระราชบัญญัติมาตรฐานสินค้าเกษตร พ.ศ. 2551. (2551). , 30 กรกฎาคม 2562. https://www.acfs.go.th/standard/download/GUIDANCE_ORGANIC-PART-1_PRODUCTS-FROM-ORGANIC.pdf",
    sappear: "2,5",
    mappear: "3,6",
    rappear: 6,
    firstalpha: "ก"
  },
  {
    keyword: "เกษตรอินทรีย์เชิงพาณิชย์",
    meaning:
      "เป็นการผลิตเพื่อจำหน่ายผ่านทางระบบตลาด ซึ่งต้องมีตรารับรองมาตรฐานทัดเทียมกับมาตรฐานสากล ทำให้ผลผลิตสามารถส่งออกไปจำหน่ายในต่างประเทศได้ ",
    source:
      "สำนักงานปลัดกระทรวงพาณิชย์. (2554). Thailand organic mapping เส้นทางสายอินทรีย์. 13 สิงหาคม 2562. http://www.organic.moc.go.th/sites/default/files/attachments/moc/part_1.pdf",
    sappear: 2,
    mappear: 3,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "เกิดดุลยภาพแห่งอำนาจ",
    meaning:
      "การรักษาดุลยภาพเปรียบเหมือนการทำให้ตาชั่งไม่เอียงไปทางใดทางหนึ่ง เมื่อใดก็ตามกำลังอำนาจของชาติใดหรือกลุ่มชาติใดทางด้านหนึ่งของตาชั่งมีน้ำหนักเพิ่มขึ้นมากจนกระทั้งตาชั่งเสียดุลไป ชาติต่างๆที่อยู่อีกข้างของตาชั่งมีทางออกอยู่ 2 ทางคือ เพิ่มกำลังของตนเองให้มีขนาดทักเทียมกับอีกฝ่ายหนึ่ง หรือหาทางลดกำลังอำนาจของอีกฝ่ายหนึ่งลงมาให้ทัดเทียมกับตน วิธีการรักษาดุลยภาพให้คงอยู่มี 7 วิธี คือ\r\n  1.การเพิ่มกำลังอาวุธ วิธีนี้เป็นวิธีที่รวดเร็วที่สุดในการเพิ่มกำลังอำนาจให้ได้เปรียบเหนือชาติอื่น และยังช่วยทำให้สามารถแซงขึ้นหน้าทันคู่ปรปักษ์ในเรื่องกำลังอำนาจ\r\n  2.การลดกำลังอาวุธ การลดกำลังอาวุธสามารถทำให้เกิดการทำลายหรือรักษาดุลยภาพได้เหมือนกัน\r\n  3.การยึดครองและการชดเชย วิธีนี้จะช่วยเพิ่มกำลังอำนาจ โดยการเข้ายึดครองดินแดนที่มีประชากรอาศัยอยู่\r\n  4.การจัดตั้งรัฐหรือเขตกันชน เป็นวิธีการที่ป้องกันไม่ให้ดุลยภาพถูกทำลายไป\r\n  5.การเป็นพันธมิตรร่วม รัฐอาจจะปรับปรุงฐานะกำลังของตนได้ โดยการเข้าไปเป็นพันธมิตรกับฝ่ายที่ตนเห็นว่าจะช่วยทำให้ตนมีกำลังอำนาจเพิ่มมากขึ้น เพื่อถ่วงดุลอำนาจของอีกฝ่ายหนึ่ง\r\n  6.การเข้าแทรกแซงกิจการภายใน เป็นวิธีการอย่างหนึ่งที่ชาติมหาอำนาจนำมาใช้ ในกรณีที่ไม่มีความไว้วางใจและเชื่อมั่นในความจงรักภักดีของชาติเล็กๆ ที่เป็นบริวารหรือพันธมิตรกับตน\r\n  7.การแบ่งแยกและการเข้าครอบงำ การแยกพันธมิตรออกจากฝ่ายที่เป็นคู่ปรปักษ์ โยพยายามให้พันธะมิตรเหล่านั้นวางตัวเป็นกลางหรืออย่างน้อยที่สุดให้วางตัวอยู่แบบโดดเดี่ยว",
    source:
      "studyinternationalaffairs. (2560). ทฤษฎีความเกี่ยวพัน (Linkage Theory),ทฤษฏีดุลแห่งอำนาจ (Balance of Power Theory) และ แนวคิดทางภูมิรัฐศาสตร์, 5 มิถุนายน 2562. http://studyinternationalaffairs.blogspot.com/2017/08/linkage-theory-balance-of-power-theory.html",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ก"
  },
  {
    keyword: "เกียรติภูมิของประเทศ",
    meaning:
      'เกียรติที่ "ประเทศ" พึงได้รับเพราะความนิยมหรือจากชื่อเสียงหรือคำสรรเสริญ ',
    source:
      "พจนานุกรม ฉบับราชบัณฑิตยสถาน (2554). เกียรติภูมิ, 6 มิถุนายน 2562. http://www.royin.go.th/dictionary",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "เขตเกษตรเศรษฐกิจ",
    meaning:
      "เขตการผลิตทางการเกษตรซึ่งรวมทั้งการเลี้ยงสัตว์และการปลูกป่าที่กำหนดขึ้นให้เหมาะสมกับภาวะตลาดและเศรษฐกิจการเกษตรของประเทศ โดยคำนึงถึงสภาพที่คล้ายคลึงกันของปัจจัยหลัก เช่น ดินฟ้าอากาศ แหล่งน้ำ พืชที่ปลูก สัตว์ที่เลี้ยง ประเภทของเกษตรกรรมและรายได้หลักของเกษตรกร",
    source:
      "พระราชบัญญัติเศรษฐกิจการเกษตร พ.ศ. 2522 (2522, 23 มีนาคม). ราชกิจจานุเบกษา. เล่ม 96 ตอนที่ 40 หน้า 20. http://www.ratchakitcha.soc.go.th/DATA/PDF/2522/A/040/19.PDF",
    sappear: "",
    mappear: 6,
    rappear: "",
    firstalpha: "ข"
  },
  {
    keyword: "เขตเมือง",
    meaning:
      "พื้นที่มีประชากรอยู่กันอย่างหนาแน่นหรือมีจำนวนคนมากเมื่อเทียบกับพื้นที่ และประชากรส่วนใหญ่ในพื้นที่นั้นประกอบอาชีพที่มิใช่เกษตรกรรม",
    source:
      "สถาบันวิจัยประชากรและสังคม มหาวิทยาลัยมหิดล. ศัพทานุกรมการวิจัยทางประชากรและสังคม. (2557). เขตเมือง, 6 มิถุนายน 2562. http://www.popterms.mahidol.ac.th/Popterms/showmean.php?id=u00053&keyword=Urban%20area",
    sappear: 4,
    mappear: "",
    rappear: "",
    firstalpha: "ข"
  },
  {
    keyword: "เขตเศรษฐกิจพิเศษ",
    meaning:
      "บริเวณพื้นที่ที่คณะกรรมการนโยบายเขตพัฒนาเศรษฐกิจพิเศษ (กนพ.) กำหนดให้เป็นเขตพัฒนาเศรษฐกิจพิเศษ ซึ่งรัฐจะสนับสนุนโครงสร้างพื้นฐาน สิทธิประโยชน์การลงทุน การบริหารแรงงานต่างด้าวแบบไป-กลับ การให้บริการจุดเดียวเบ็ดเสร็จและการบริการอื่นที่จำเป็น",
    source:
      "เขตเศรษฐกิจพิเศษในประเทศไทย. สำนักยุทธศาสตร์และการวางแผนพัฒนาพื้นที่ สำนักงานคณะกรรมการพัฒนาการเศรษฐกิจและสังคมแห่งชาติ, 18 พฤศจิกายน 2562. www.https://www.nesdb.go.th/ewt_dl_link.php?nid=5193\r\n\r\nกรมการค้าต่างประเทศ. เขตพัฒนาเศรษฐกิจพิเศษ, 18 พฤศจิกายน 2562.\r\nhttps://www.youtube.com/watch?v=P8LrVQywuwA",
    sappear: "",
    mappear: 7,
    rappear: 3,
    firstalpha: "ข"
  },
  {
    keyword: "เขตทางทะเล",
    meaning:
      "ชายฝั่งทะเลและพื้นที่ทางทะเลที่ประเทศไทยมีอำนาจอธิปไตย\r\nหรือสิทธิอธิปไตย หรือมีสิทธิหรือเสรีภาพในการใช้หรือจะใช้ หรือมีหน้าที่รับผิดชอบตามกฎหมายระหว่างประเทศหรือตามสนธิสัญญาหรือด้วยประการใด ๆ ได้แก่ น่านน้ำภายใน ทะเลอาณาเขตเขตต่อเนื่อง เขตเศรษฐกิจจำเพาะ ไหล่ทวีป และทะเลหลวง และให้หมายความรวมถึงเกาะเทียมสิ่งติดตั้ง และสิ่งปลูกสร้างในทะเล รวมทั้งห้วงอากาศเหนือทะเล พื้นดินท้องทะเล ใต้พื้นดินท้องทะเลและพื้นที่ทางทะเลอื่นตามที่คณะกรรมการประกาศกำหนดในราชกิจจานุเบกษา",
    source:
      "พระราชบัญญัติการรักษาผลประโยชน์ของชาติทางทะเล พ.ศ. 2562. (2562, 12 มีนาคม). ราชกิจจานุเบกษา. เล่มที่ 136 ตอนที่ 30 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/030/T_0001.PDF",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ข"
  },
  {
    keyword: "เขตพัฒนาพิเศษภาคตะวันออก",
    meaning:
      "พื้นที่จังหวัดฉะเชิงเทรา ชลบุรี และระยอง และพื้นที่อื่นใดที่อยู่ในภาคตะวันออกที่กำหนดเพิ่มเติมโดยพระราชกฤษฎีกาเป็นเขตพัฒนาพิเศษภาคตะวันออก",
    source:
      "พระราชบัญญัติเขตพัฒนาพิเศษภาคตะวันออก พ.ศ.2561. (2561, 14 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 34 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/034/1.PDF",
    sappear: "",
    mappear: 9,
    rappear: "",
    firstalpha: "ข"
  },
  {
    keyword: "เขตอนุรักษ์",
    meaning:
      "เขตอุทยานแห่งชาติ เขตรักษาพันธุ์สัตว์ป่า เขตสงวนเพื่อการท่องเที่ยว และเขตพื้นที่คุ้มครองอย่างอื่นเพื่อสงวนและรักษาสภาพธรรมชาติตามที่มีกฎหมายกำหนด",
    source:
      "พระราชบัญญัติส่งเสริมและรักษาคุณภาพสิ่งแวดล้อมแห่งชาติ\r\nพ.ศ. 2535. (2535, 4 เมษายน). ราชกิจจานุเบกษา. เล่ม 109 ตอนที่ 17 หน้า 3.  http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/037/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ข"
  },
  {
    keyword: "เขาหัวโล้น",
    meaning:
      "ภาวะปัญหาทางสิ่งแวดล้อมที่ภูเขาและธรรมชาติสูญเสียป่าไม้ที่ปกคลุมไป ซึ่งต้นตอของการที่ป่าหายไปนั้นเกิดการความเสื่อมโทรมจากน้ำมือมนุษย์มาเป็นเวลานาน เช่น จากการทำไร่ข้าวโพดที่ที่ดินทุกแปลงถูกเปิดใช้งาน เป็นที่มาของภาพเขาหัวโล้น ความเสื่อมโทรมของพื้นที่เนื่องจากสารเคมีชนิดต่างๆ เมื่อพื้นที่เดิมเสื่อมหรือให้ผลผลิตไม่เพียงพอ หลายคนเลือกที่จะรุกล้ำเข้าไปปลูกในพื้นที่ป่ามากขึ้นจนทำให้พื้นที่ป่าถูกถางออกไป ในที่สุดก็เหลือเพียงเขาหัวโล้น",
    source:
      'วรรณโชค ไชยสะอาด. (2558). เบื้องลึก "เขาหัวโล้น" น่าน...เมื่อชาวบ้านติดกับดัก "ข้าวโพด," 24 มิถุนายน 2562. https://www.posttoday.com/social/local/397262',
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ข"
  },
  {
    keyword: "เคเบิลใต้น้ำ",
    meaning:
      "ระบบเคเบิลใต้น้ำ เป็นสื่ออีกอย่างหนึ่งที่มีการใช้ในการสื่อสาร โทรคมนาคมระหว่างประเทศ มีการรับส่งสัญญาณทุกชนิดได้อย่างมีประสิทธิภาพเป็นช่องทางการสื่อสารที่ใช้สำหรับรับ-ส่งสัญญาณผ่านสายเคเบิลเฉพาะ ชนิดที่วางฝังอยู่ใต้ทะเลเชื่อมโยงระหว่างสถานีเคเบิลใต้น้ำสองสถานี ซึ่งอาจเป็นระหว่างจุดต่อจุดหรือประเทศต่อประเทศใช้สำหรับการเชื่อมโยงที่มีระยะทางไกล",
    source:
      "วิกิพีเดีย สารานุกรมเสรี. (2560). เคเบิ้ลใต้น้ำ, 5 กรกฎาคม 2562. https://th.wikipedia.org/wiki/เคเบิลใต้น้ำ",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "เคมีภัณฑ์",
    meaning: "สารบริสุทธิ์ที่เตรียมได้โดยกรรมวิธีเคมีหรือที่ใช้ในกรรมวิธีเคมี",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. เคมีภัณฑ์. 12 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 1,
    rappear: 10,
    firstalpha: "ค"
  },
  {
    keyword: "เครือข่ายบริการในรูปแบบ SDU",
    meaning:
      "รูปแบบองค์กรของรัฐรูปแบบใหม่ที่ประสงค์ให้แตกต่างจากระบบราชการ รัฐวิสาหกิจ และองค์การมหาชน รูปแบบองค์กรใหม่",
    source:
      "สำนักงานคณะกรรมการกฤษฎีกา. SDU - Special Delivery Unit คืออะไร, 15 พฤษภาคม 2562. http://web.krisdika.go.th/acknowledgeDetail.jsp?code=8",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ค"
  },
  {
    keyword: "เครือข่ายบริการปฐมภูมิ",
    meaning:
      "หน่วยบริการปฐมภูมิที่รวมตัวกัน โดยประกอบด้วยหน่วยบริการ ประจำหนึ่งหน่วยเป็นแกนกลาง รวมตัวกับหน่วยบริการที่รับส่งต่อและหน่วยบริการปฐมภูมิ ทั้งนี้ อาจมี เครือข่ายหน่วยบริการร่วมให้บริการเข้าร่วมก็ได้ และได้ขึ้นทะเบียนเป็นเครือข่ายหน่วยบริการตามที่สำนักงาน หลักประกัน-สุขภาพแห่งชาติประกาศ โดยเครือข่ายหน่วยบริการมีสิทธิได้รับค่าใช้จ่ายเพื่อบริการสาธารณสุข จากหน่วยบริการ หรือจากกองทุน ตามที่คณะกรรมการกำหนด",
    source:
      "ระบบสุขภาพปฐมภูมิ พ.ศ. 2562. (2562, 30 เมษายน). ราชกิจนาบุเษก. เล่ม 136 ตอนที่ 56 ก หน้า 165-185.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/056/T_0165.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ค"
  },
  {
    keyword: "เครื่องใช้ไฟฟ้า",
    meaning:
      "อุปกรณ์ที่เปลี่ยนพลังงานไฟฟ้าเป็นพลังงานรูปอื่น เพื่อนำไปใช้ในชีวิตประจำวัน ได้แก่\r\n - อุปกรณ์ไฟฟ้าที่ให้แสง \r\n - อุปกรณ์ไฟฟ้าที่ให้ความร้อน \r\n - อุปกรณ์ไฟฟ้าที่ให้พลังงานกล \r\n - อุปกรณ์ไฟฟ้าที่ให้พลังงานเสียง\r\n  ข้อควรระวังในการใช้เครื่องใช้ไฟฟ้า\r\n 1.ใช้เครื่องใช้ไฟฟ้า และอุปกรณ์ไฟฟ้าอย่างระมัดระวัง\r\n 2.หมั่นตรวจดูแลสายไฟ และอุปกรณ์ไฟฟ้าให้อยู่ในสภาพที่ใช้ได้ดีและปลอดภัย\r\n 3.ถ้าไม่มีความรู้จริง อย่าแก้หรือซ่อมแซมเครื่องใช้ไฟฟ้าเองเป็นอันขาด\r\n ผลเสียที่จะเกิดขึ้น เมื่อใช้เครื่องใช้ไฟฟ้าอย่างไม่ระมัดระวัง\r\n 1.ถูกไฟฟ้าซ๊อต เนื่องจากไฟฟ้าลัดวงจร หรือไฟฟ้ารั่ว\r\n 2.เกิดเพลิงไหม้ เนื่องจากไฟฟ้าลัดวงจร หรือไฟฟ้ารั่ว",
    source:
      "ทวีศักดิ์ ภู่ชัย. อุปกรณ์ไฟฟ้า, 6 มิถุนายน 2562. http://www.thaigoodview.com/library/contest2552/type1/science03/11/Electricity-web/html/about.html\r\n \r\n พิชญ์ปฐวี ทับชุม. เครื่องใช้ไฟฟ้า, 6 มิถุนายน 2562. https://sites.google.com/site/084062xxxx/wngcr-fifa/kheruxng-chi-fifa-1",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "เครื่องมือทางเศรษฐศาสตร์",
    meaning:
      "เป็นการกำหนดมาตรการและระบบแรงจูงใจเพื่อเปลี่ยนแปลงพฤติกรรมของผู้ผลิตและผู้บริโภค เพื่อให้เกิดผลดีต่อสิ่งแวดล้อม ผ่านมาตรการด้านราคา มาตรการภาษี มาตรการด้านตลาด มาตรการด้านสินเชื่อและสิทธิประโยชน์ มาตรการการให้ใบอนุญาตที่ถ่ายโอนได้ในการปล่อยมลพิษ \r\n  เครื่องมือทางเศรษฐศาสตร์ที่ใช้ในประเทศไทยยังมีไม่มากนัก ตัวอย่างเครื่องมือที่ใช้อยู่ ได้แก่ \r\n1.  การลดภาษีนำเข้าอุปกรณ์เครื่องมือเครื่องจักรที่รักษาสิ่งแวดล้อม \r\n2.  การกำหนดอัตราภาษีที่ต่างกันระหว่างน้ำมันที่มีสารตะกั่วและน้ำมันไร้สารตะกั่ว \r\n3.  การเก็บค่าธรรมเนียมกำจัดมูลฝอยหรือค่าบำบัดน้ำเสีย เป็นต้น",
    source:
      "วารสารกลุ่มสาขาเศรษฐศาสตร์ : ศูนย์วิจัยเศรษฐศาสตร์ประยุกต์ คณะเศรษฐศาสตร์ มหาวิทยาลัยเกษตรศาสตร์ ได้รับทุนอุดหนุนจากสำนักงาน\r\n คณะกรรมการการอุดมศึกษา, 6 มิถุนายน 2562.\r\nhttp://www.journal.eco.ku.ac.th/journal.php?lang=thai&journal_id=18&data_id=117",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "เครื่องมือทางการคลัง",
    meaning:
      "เครื่องมือของนโยบายการคลังที่ใช้ในการจัดการรายรับ รายจ่าย และหนี้สาธารณะของรัฐบาล โดยมีวัตถุประสงค์ในการรักษาเสถียรภาพทางเศรษฐกิจของประเทศเป็นสำคัญ ซึ่งสามารถแบ่งได้เป็นเครื่องมือสองประเภท\r\n1. เครื่องมือทางด้านรายได้ หรือการเปลี่ยนแปลงอัตราภาษี\r\n2. เครื่องมือทางด้านรายจ่าย หรือการเปลี่ยนแปลงอัตราการใช้จ่ายของรัฐบาล\r\n",
    source:
      "ผศ.วรลักษณ์ หิมะกลัส คณะเศรษฐศาสตร์ มหาวิทยาลัยเชียงใหม่. (ม.ป.ป). การคลังและนโยบายการคลัง, 23 กรกฎาคม 2562. http://fuangfah.econ.cmu.ac.th/teacher/woraluck/econ100/Sheet/7_Public%20Finance.pdf",
    sappear: 5,
    mappear: 4,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "เครื่องมือผังเมืองทางบวก",
    meaning:
      'มาตรการส่งเสริมการพัฒนาตามผังเมืองเชิงบวก ที่นำแนวคิด "การโอนสิทธิการพัฒนาพื้นที่" หรือ Transfer of Development Rights (TDR) มาประยุกต์ใช้ ซึ่งแนวทางก็คือ การซื้อขาย “สิทธิ” ในการพัฒนาบนที่ดิน ระหว่างพื้นที่ที่ต้องการจะควบคุมการพัฒนาหรืออนุรักษ์ (Sending Areas) และพื้นที่ที่มีการเจริญเติบโตและได้รับการสนับสนุนการพัฒนา (Receiving Areas) โดยจะเป็นสิทธิในรูปแบบของการพัฒนาอาคาร ที่สามารถเพิ่มชั้นความสูงอาคาร, จำนวนอาคาร, ความหนาแน่นของอาคารได้มากขึ้น โดยเจ้าของสิทธิหรือ Sending Areas ก็จะสามารถได้ประโยชน์ในด้านการควบคุมการหนาแน่นในพื้นที่ให้ลดลง เพื่อการอนุรักษ์รักษาสิ่งแวดล้อม, รักษาพื้นที่เกษตรกรรม, รักษาพื้นที่ทางประวัติศาสตร์หรือพื้นที่รองรับน้ำได้ โดยมีข้อจำกัดคือ ถึงแม้จะมีการซื้อขายหรือโอนสิทธิในการพัฒนา แต่โฉนดยังคงเป็นของเจ้าของที่ดินหรือเจ้าของ Sending Areas แนวคิด TDR ถือเป็นมาตรการจัดการพื้นที่เชิงบวกที่ใช้วิธีการสนับสนุนการตัดสินใจของเจ้าของพื้นที่ในประเด็นของการควบคุมผลประโยชน์พื้นที่ ซึ่งตรงกันข้ามกับมาตรการผังเมืองเชิงลบที่ใช้วิธีการจำกัดสิทธิการใช้ประโยชน์ที่ดินต่อผู้เป็นเจ้าของที่ดินแทน',
    source:
      "เกียรติศักดิ์ จันทรา. (2560). รูปแบบการโอนสิทธิการพัฒนาที่เหมาะสมกับการพัฒนาผังเมือง\r\n ของประเทศไทยในอนาคต (วิทยานิพนธ์ปริญญามหาบัณฑิต). มหาวิทยาลัยธรรมศาสตร์\r\n , คณะสถาปัตยกรรมศาสตร์และการผังเมือง, สาขาวิชาการผังเมือง, 6 มิถุนายน 2562. http://ethesisarchive.library.tu.ac.th/thesis/2017/TU_2017_5916031163_7556_6113.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ค"
  },
  {
    keyword: "เครื่องหมายรับรองฉลากเขียว",
    meaning:
      "มาตรฐาน หรือเกณฑที่ใชในการพิจารณาใหการรับรองผลิตภัณฑวาสงผลกระทบตอสิ่งแวดล้อมนอยกวาเมื่อเปรียบเทียบกับผลิตภัณฑที่ทําหนาที่อยางเดียวกัน โดยพิจารณาตลอดทั้งวัฏจักรชีวิต (Life cycle consideration) จัดทําโดย คณะอนุกรรมการเทคนิคในรายกลุ่มผลิตภัณฑ และอนุมัติโดย คณะกรรมการนโยบายและบริหารงานฉลากเขียว เพื่อใชเป็นเกณฑ์ในการรับรอง โดยคณะอนุกรรมการรับรองฉลากเขียวที่ไดรับการแตงตั้งตามคุณสมบัติที่เหมาะสม",
    source:
      "สำนักงานเลขานุการโครงการฉลากเขียว. มูลนิธิสถาบันสิ่งแวดล้อมไทย. หลักเกณฑ์และเงื่อนไขการใช้เครื่องหมายรับรองฉลากเขียว (RR-202-04). 18 พฤศจิกายน 2562\r\nhttp://www.tei.or.th/greenlabel/download/RR-202-04.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ค"
  },
  {
    keyword: "เครื่องหมายรับรองฉลากเขียว ตระกร้าเขียว",
    meaning:
      "ฉลากสิ่งแวดล้อมที่กรมควบคุมมลพิษจัดทำขึ้นโดยพิจารณาจากผลกระทบต่อสิ่งแวดล้อมที่เกิดจากขั้นตอนต่างๆของสินค้าและบริการ ได้แก่ การจัดหาวัตถุดิบ การผลิต การให้บริการ การขนส่ง การใช้งาน และการกำจัดทิ้งเพื่อให้ภาครัฐใช้ในการจัดซื้อจัดจ้างสินค้าและบริการที่เป็นมิตรกับสิ่งแวดล้อม โดยสัญลักษณ์ตระกร้าเขียวยังไม่มีการดำเนินการในการออกฉลากเพื่อติดบนสินค้า แต่จะดำเนินการส่งเสริมการจัดซื้อจัดจ้างสินค้าและบริการที่เป็นมิตรกับสิ่งแวดล้อมภาครัฐ และศึกษาคัดเลือก กำหนดหลักเกณฑ์ของสินค้าและบริการที่เป็นมิตรกับสิ่งแวดล้อมรวมทั้งรวบรวมข้อมูลสินค้าและบริการที่เป็นมิตรกับ สิ่งแวดล้อม",
    source:
      "กรมส่งเสริมคุณภาพสิ่งแวดล้อม กระทรวงทรัพยากรธรรมชาติและสิ่งแวดล้อม. รู้จักฉลากตะกร้าเขียวและหลักเกณฑ์การได้รับตะกร้าเขียว, 28 มิถุนายน 2562. https://scpdatacenter.deqp.go.th/articledetail.php?id=14",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ค"
  },
  {
    keyword: "เงินเฟ้อ",
    meaning:
      "ภาวะที่ราคาสินค้าและบริการโดยทั่วไปเพิ่มสูงขึ้นต่อเนื่อง ซึ่งหาก\r\nเงินเฟ้อเพิ่มขึ้นมากจะกระทบต่อฐานะและความเป็นอยู่ของประชาชน",
    source:
      "ธนาคารแห่งประเทศไทย. ความหมายของอัตราเงินเฟ้อ, 15 พฤษภาคม 2562. https://www.bot.or.th/App/FinancialLiteracy/ExchangeRate/01_01_contentdownload_inflation.pdf",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ง"
  },
  {
    keyword: "เงินบำนาญ",
    meaning:
      "เงินที่จ่ายให้แก่สมาชิกเป็นรายเดือนเมื่อสมาชิกภาพของสมาชิกสิ้นสุดลง",
    source:
      "พระราชบัญญัติกองทุนบำเหน็จบำนาญข้าราชการ พ.ศ. 2539 (2539, 26 กันยายน). ราชกิจจานุเบกษา. เล่ม 113 ตอนที่ 42 ก หน้า 2.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2539/A/042/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ง"
  },
  {
    keyword: "เงินสงเคราะห์",
    meaning: "เงินอุดหนุนสำหรับการช่วยเหลือผู้ประสบความเดือดร้อน",
    source:
      "กรมพัฒนาสังคมและสวัสดิการ. แนวทางและมาตรการจ่ายเงินอุดหนุน, 17 พฤษภาคม 2562. http://www.dsdw2016.dsdw.go.th/buzzfile/guidepay-2018.pdf ",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ง"
  },
  {
    keyword: "เจตจำนง",
    meaning: "ความตั้งใจมุ่งหมาย, ความจงใจ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. เจตจำนง. 6 มิถุนายน 2562. http://www.royin.go.th/dictionary",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "จ"
  },
  {
    keyword: "เจตจำนงทางการเมือง",
    meaning:
      "ความปรารถนาและความมุ่งมั่นของฝ่ายการเมืองที่จะทำบางอย่างให้เกิดการปฏิรูป การเปลี่ยนแปลงในสังคม โดยมากมักจะโยงกับการพัฒนายั่งยืนโดยเรียกร้องให้ฝ่ายการเมืองดำเนินการให้เกิดนโยบายที่ชัดเจน เจตจำนงทางการเมืองแสดงออกให้มีการดำเนินการส่งเสริมสนับสนุนให้เรื่องนั้น ๆ เกิดขึ้นจริง อาจรวมถึงกฎระเบียบ กฎหมาย งบประมาณที่จำเป็น",
    source:
      "ดวงสมร บุญช่วย. (2554). 12 คำ จากร้อยคำ ที่ควรรู้, 10 มิถุนายน 2562. http://dungsmeun.blogspot.com/",
    sappear: "",
    mappear: 21,
    rappear: "",
    firstalpha: "จ"
  },
  {
    keyword: "เจตนารมณ์",
    meaning: "ความมุ่งหมายและมักเป็นความมุ่งหมายในทางที่ดี",
    source:
      "สำนักงานราชบัณฑิตยสภา. เจตนารมณ์. 6 มิถุนายน 2562. http://www.royin.go.th/?knowledges=%E0%B9%80%E0%B8%88%E0%B8%95%E0%B8%99%E0%B8%B2-%E0%B9%80%E0%B8%88%E0%B8%95%E0%B8%99%E0%B8%B2%E0%B8%A3%E0%B8%A1%E0%B8%93%E0%B9%8C-%E0%B9%92%E0%B9%99-%E0%B8%A1%E0%B8%B5%E0%B8%99%E0%B8%B2",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "จ"
  },
  {
    keyword: "เชื้อเพลิง",
    meaning:
      "ถ่านหิน หินน้ำมัน ทรายน้ำมัน น้ำมันเชื้อเพลิง ก๊าซเชื้อเพลิง เชื้อเพลิงสังเคราะห์ ฟืน ไม้ แกลบ กากอ้อย ขยะ และสิ่งอื่นตามที่คณะกรรมการนโยบายพลังงานแห่งชาติกำหนดโดยประกาศในราชกิจจานุเบกษา",
    source:
      "พระราชบัญญัติการส่งเสริมการอนุรักษ์พลังงาน พ.ศ. 2535. (2535, 23 มีนาคม). ราชกิจจานุเบกษา. เล่มที่ 109 ตอนที่ 33 หน้าที่ 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ช"
  },
  {
    keyword: "เชื้อเพลิงชีวภาพ",
    meaning:
      "พลังงานหมุนเวียนที่ไดจากการแปรรูปแหลงชีวมวล (มวลของพืชหรือวัสดุจากพืชชนิดตาง ๆ ทั้งบนพื้นดิน ในนํ้าและในทะเล รวมสิ่งมีชีวิตชั้นตํ่า เชน แบคทีเรีย รา แพลงกตอน สาหราย สาเหลา ที่ไดจากการผลิตแอลกอฮอล ตลอดจนมูลสัตวและของเสียอินทรียจากโรงงานอุตสาหกรรมเกษตร เชน ชานออย แกลบ ขี้เลื่อย เปนตน) ผานกระบวนการตาง ๆ เชน การผลิตเชื้อเพลิงเหลว การหมัก และการเผาไหม เปนตน สามารถนําไปใชประโยชนไดทั้งการผลิตไฟฟาและความรอน \r\nประเทศไทยโดยกระทรวงพลังงานมีการสงเสริมการใชพลังงานชีวภาพแบบตาง ๆ เชน โครงการ สงเสริมเทคโนโลยีแกสชีวภาพในภาคปศุสัตว์ โครงการสงเสริมเทคโนโลยีแกสชีวภาพในภาคอุตสาหกรรม และโครงการสงเสริมเทคโนโลยีแกสชีวภาพในภาคชุมชน มีสถานประกอบการเอกชน เชน โรงแรม รีสอรท โรงอาหาร โรงเรียน และกรมราชทัณฑเขารวมโครงการ ซึ่งเนนการผลิต แกสชีวภาพจากเศษอาหารมาใช้",
    source:
      "กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน กระทรวงพลังงาน. สารานุกรมพลังงานทดแทน. Alternative Energy Encyclopedia, (2557). หน้า 93.",
    sappear: "",
    mappear: "4,7",
    rappear: 5,
    firstalpha: "ช"
  },
  {
    keyword: "เชื้อเพลิงชีวมวลไม้โตเร็ว",
    meaning:
      "ไม้โตเร็ว เป็นวัตถุดิบอีกประเภทที่สามารถนำมาใช้เป็นพลังงานทดแทนได้เนื่องจาก องค์ประกอบของไม้ประกอบด้วย เซลลูโลส ร้อยละ 50 เฮมิเซลลูโลส ร้อยละ 25 และ และลิกนิน ร้อยละ 25 ซึ่งแบ่งไม้โตเร็ว ในแง่ของการใช้ประโยชน์ว่าต้องมีอัตราการเติบโตไม่น้อยกว่า 2.5 ลูกบาศก์เมตรต่อไร่ต่อปี และจะต้องมีอายุครบรอบหมุนเวียนในการตัดฟันไม่เกิน 7 ปี ไม้โตเร็วที่ นิยมปลูก มีมากมายหลายชนิด มีทั้งชนิดพื้นเมืองและไม้ต่างถิ่น เช่น ไม้เลี่ยน ซ้อ ทุ้งฟ้า ไม้สนทะเล ซึ่งเป็นไม้โตเร็วพื้นเมืองของไทย ในขณะที่ไม้สนประดิพัทธ์ สนคาริเบียน สนโอคาร์ปา กระถินณรงค์ กระถินยักษ์ กระถินเทพา และยูคาลิปตัส เป็นไม้โตเร็วต่างถิ่น โดยเฉพาะอย่างยิ่ง ไม้ยูคาลิปตัส",
    source:
      "ศูนย์วิจัยป่าไม้ คณะวนศาสตร์,สถาบันค้นคว้าและพัฒนาผลิตผลทางการเกษตรและอุตสาหกรรมเกษตร มหาวิทยาลัยยเกาตรศาสตร์. (2550). การใช้ประโยชน์ไม้โตเร็วเพื่อเป็นพลังงานทดแทนในการผลิตกระแสไฟฟ้าและแก๊สหุงต้ม, 10 มิถุนายน 2562. http://webkc.dede.go.th/testmax/sites/default/files/%E0%B8%A3%E0%B8%B2%E0%B8%A2%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%A7%E0%B8%B4%E0%B8%88%E0%B8%B1%E0%B8%A2%20%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%83%E0%B8%8A%E0%B9%89%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B9%82%E0%B8%A2%E0%B8%8A%E0%B8%99%E0%B9%8C%E0%B9%84%E0%B8%A1%E0%B9%89%E0%B9%82%E0%B8%95%E0%B9%80%E0%B8%A3%E0%B9%87%E0%B8%A7.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ช"
  },
  {
    keyword: "เชื้อเพลิงฟอสซิล",
    meaning:
      "เชื้อเพลิงซากดึกดำบรรพ์ หรือ เชื้อเพลิงฟอสซิล (อังกฤษ: fossil fuel; เชื้อเพลิงซากดึกดำบรรพ์เป็นศัพท์ทางธรณีวิทยา ส่วนเชื้อเพลิงฟอสซิลเป็นศัพท์ทางวิศวกรรมเครื่องกล) หรือแร่เชื้อเพลิง (อังกฤษ: mineral fuel) เป็นเชื้อเพลิงอันเกิดแต่ซากดึกดำบรรพ์ซึ่งได้แก่ไฮโดรคาร์บอนที่พบจากช่วงชั้นดิน (layer) ด้านบนสุดของเปลือกโลก \r\n  เชื้อเพลิงซากดึกดำบรรพ์มีตั้งแต่แร่สารระเหยสูง (volatile material) ซึ่งมีอัตราคาร์บอนต่อไฮโดรเจนต่ำ เป็นต้นว่า แก๊สมีเทน ไปจนถึงปิโตรเลียมเหลว (liquid petroleum) และแร่ไร้สารระเหย (nonvolatile material) ซึ่งแร่ไร้สารระเหยนี้มักประกอบด้วยคาร์บอนบริสุทธิ์ เป็นต้นว่า ถ่านแอนทราไซต์ (anthracite coal) ทั้งนี้ แก๊สมีเทนอันมีในแร่สารระเหยสูงเช่นว่าสามารถพบได้ในสารจำพวกไฮโดรคาร์บอนเพียงจำพวกเดียว ในรูปสารจำพวกไฮโดรคาร์บอนประสมกับน้ำมัน และในรูปมีเทนผังหนา (methane clathrate) การใช้ประโยชน์จากเชื้อเพลิงฟอสซิล มีด้วยกันหลากหลายรูปแบบ โดยสามารถแบ่งการใช้ประโยชน์ ตามสถานะ ดังนี้\r\n 1.น้ำมัน เป็นเชื้อเพลิงฟอสซิลเกิดจากซากสัตว์และซากพืชทับถมเป็นเวลาหลายล้านปี มีองค์ประกอบของสารไฮโดรคาร์บอน เมื่อสูบน้ำมันดิบขึ้นมาจากใต้ดินจะนำมาใช้โดยตรงไม่ได้ ต้องนำเข้าโรงกลั่น และผ่านกระบวนการผลิตที่แยกส่วนออก เป็นน้ำมันสำเร็จรูป (Petroleum Products) หลายชนิด ซึ่งมีคุณสมบัติเฉพาะแตกต่างกันไป เช่น น้ำมันเบนซิน น้ำมันดีเซล น้ำมัน อากาศยาน น้ำมันก๊าด และน้ำมันเตา\r\n 2.ถ่านหิน เป็นเชื้อเพลิงที่เกิดจากการทับถมของซากพืชที่ขึ้นอยู่ตามที่ชื้นแฉะเป็นเวลานานหลายล้านปี ภายใต้แรงกดดันและอุณหภูมิสูง เกิดเป็นสารประกอบไฮโดรคาร์บอนที่อยู่ในสถานะของแข็ง ซึ่งประกอบด้วย อะตอมของคาร์บอนไฮโดรเจน และออกซิเจนเป็นหลัก โดยอยู่ในสถานะของแข็ง \r\n 3.ก๊าซธรรมชาติ เป็นเชื้อเพลิงปิโตรเลียมชนิดหนึ่ง ซึ่งเป็นสารประกอบไฮโดรคาร์บอนเกิดจากการทับถมของสิ่งมีชีวิตนับล้านปี ประกอบด้วยก๊าซมีเทนเป็นหลักมีคุณสมบัติเป็นเชื้อเพลิงสะอาด มีการเผาไหม้สมบูรณ์จึงส่งผลกระทบต่อสิ่งแวดล้อมน้อยกว่าปิโตรเลียมประเภทอื่นๆ",
    source:
      "สาขาวิชาเทคโนโลยีสารสนเทศ วิทยาลัยเทคนิคเชียงใหม่. (2560). เชื้อเพลิงซากดึกดำบรรพ์, 10 มิถุนายน 2562. http://it.cmtc.ac.th/std2561/web/it1a/group1/Page/detailLearn/10_fossil.html\r\nทรูปลูกปัญญา. (2559). เชื้อเพลิงฟอสซิล, 10 มิถุนายน 2562. http://www.trueplookpanya.com/learning/detail/16303",
    sappear: 5,
    mappear: "",
    rappear: 10,
    firstalpha: "ช"
  },
  {
    keyword: "เชื้อเพลิงสะอาด",
    meaning:
      "พลังงานหมุนเวียนเป็นพลังงานที่สะอาด  ไม่มีผลกระทบต่อสิ่งแวดล้อม  และเป็นพลังงานที่หาง่ายมีอยู่ทั่วไปในท้องถิ่น  พลังงานหมุนเวียนมีข้อดีคือช่วยลดมลพิษเนื่องจากการผลิตไฟฟ้าจากเชื้อเพลิง   ช่วยลดการนำเข้าน้ำมันจากต่างประเทศ  ลดปริมาณก๊าซเรือนกระจกซึ่งทำให้เกิดภาวะโลกร้อน  ส่งเสริมให้ชุมชนหรือเอกชนสามารถผลิตพลังงานเอง  เช่นการผลิตไฟฟ้าจากพลังงานแสงอาทิตย์  พลังงานไฟฟ้าจากน้ำตก  เป็นต้น",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2556). พลังงานหมุนเวียน, 4 ธันวาคม 2562.\r\nhttp://www.royin.go.th/?knowledges=%E0%B8%9E%E0%B8%A5%E0%B8%B1%E0%B8%87%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B8%AB%E0%B8%A1%E0%B8%B8%E0%B8%99%E0%B9%80%E0%B8%A7%E0%B8%B5%E0%B8%A2%E0%B8%99-%E0%B9%91%E0%B9%96-%E0%B9%80%E0%B8%A1%E0%B8%A9%E0%B8%B2",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ช"
  },
  {
    keyword: "เชื้อไวรัสนิปาห์",
    meaning:
      "โรคติดต่อชนิดหนึ่งที่มีพาหะจากสัตว์เช่น ค้างคาวผลไม้ สุกร ม้า แมว แพะ หรือแกะเป็นต้น โดยเชื้อไวรัสนิปาห์จะก่อให้เกิดการติดเชื้ออย่างรุนแรงของระบบหายใจเกิดภาวะสมองอักเสบทำให้เสี่ยงต่อการเสียชีวิตได้ ทั้งนี้มีรายงานการพบโรคสมองอักเสบนิปาห์เป็นครั้งแรกตั้งแต่เดือนตุลาคม 2541 จนถึงเดือนพฤษภาคม พ.ศ. 2542 พบผู้ติดเชื้อ 265ราย เสียชีวิต 105 ราย เชื้อไวรัสนี้ถูกตั้งชื่อตามชื่อหมู่บ้านสุไหงนิปาห์ ประเทศมาเลเซีย ซึ่ง Dr. Chua Kos Bing แพทย์ชาวมาเลเซียเป็นผู้แยกเชื้อไวรัสนี้เป็นครั้งแรก เดิมเรียกชื่อไวรัสนี้ว่า ไวรัสคล้ายเฮนดร้า (Hendra-Like Virus) โดยในช่วงนั้นเกิดการระบาดของโรคไวรัสนิปาห์ในประเทศมาเลเซีย อินเดีย บังกลาเทศ และสิงคโปร์",
    source:
      "กระทรวงสาธารณสุข. ไวรัสนิปาห์(Nipah virus), 24 กันยายน 2562. http://dmsc2.dmsc.moph.go.th/webroot/Biology/biop/Nipahvirus.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ช"
  },
  {
    keyword: "เชื้อพันธุ์",
    meaning:
      "กลุ่มเซลล์ที่มีหน่วยพันธุกรรมหลากหลาย ซึ่งถ่ายทอดได้ ที่รวมตัวกันเป็นชิ้นส่วนของพืชที่ยังมีชีวิตและขยายพันธุ์ได้ ไม่ว่าจะอยู่ในรูปของเมล็ด เนื้อเยื่อหรือส่วนหนึ่งส่วนใดของพืช และให้หมายความรวมถึงสารพันธุกรรม ซึ่งสามารถถ่ายทอดลักษณะที่สารพันธุกรรมนั้นควบคุมอยู่ได้  ทั้งนี้ เฉพาะที่ใช้ประโยชน์ในการปรับปรุงพันธุ์",
    source:
      "พระราชบัญญัติกักพืช พ.ศ. 2507. (2507, 21 มีนาคม). ราชกิจจานุเบกษา. เล่ม 81 ตอนที่ 27. http://www.ratchakitcha.soc.go.th/DATA/PDF/2507/A/027/1.PDF",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ช"
  },
  {
    keyword: "เซลล์แสงอาทิตย์",
    meaning:
      "สิ่งประดิษฐ์อิเล็กทรอนิกส์ ที่เปลี่ยนพลังงานแสงอาทิตย์เป็นพลังงานไฟฟ้าได้โดยตรง เซลแสงอาทิตย์ทำจากสารกึ่งตัวนำ ซึ่งดูดกลืนพลังงานแสงอาทิตย์ แล้วเปลี่ยนเป็นพาหะนำไฟฟ้า พาหะนำไฟฟ้า ที่เกิดขึ้นจากพลังงานแสงอาทิตย์นี้ จะถูกแยกเป็นประจุไฟฟ้าบวกและลบ ด้วยโครงสร้างหัวต่อพีเอ็นของสารกึ่งตัวนำ เพื่อให้เกิดแรงดันไฟฟ้า ที่ขั้วทั้งสองของเซลล์แสงอาทิตย์ เมื่อต่อขั้วไฟฟ้าของเซลล์แสงอาทิตย์กับโหลด เช่น หลอดไฟฟ้า หรือมอเตอร์ไฟฟ้า กระแสไฟฟ้าจะไหลสู่โหลดเหล่านั้น และทำให้อุปกรณ์ไฟฟ้าเหล่านั้นทำงานได้",
    source:
      "สารานุกรมไทยสำหรับเยาวชนฯ เล่มที่ 20. เซลล์แสงอาทิตย์ 3 กันยายน 2562. http://kanchanapisek.or.th/kp6/sub/book/book.php?book=20&chap=6&page=t20-6-infodetail01.html",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ซ"
  },
  {
    keyword: "เด็กและเยาวชน",
    meaning: "บุคคลที่มีอายุต่ำกว่า 18 ปีบริบูรณ์\r\n",
    source:
      "กรมพัฒนาสังคมและสวัสดิการ. กิจกรรมที่เหมาะสมในการปรับเปลี่ยนพฤติกรรมเด็กและ\r\nเยาวชนที่กระทำความผิด, 17 พฤษภาคม 2562. http://www.dsdw2016.dsdw.go.th/doc_pr/ndc_2560-2561/PDF/8497s/5.%E0%B8%9A%E0%B8%97%E0%B8%97%E0%B8%B5%E0%B9%88%202.pdf",
    sappear: "",
    mappear: 21,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "เด็กปฐมวัย",
    meaning: "บุคคลซึ่งมีอายุต่ำกว่า 6 ปีซึ่งรวมถึงเด็กเล็กด้วย\r\n",
    source:
      "พระราชบัญญัติ กองทุนเพื่อความเสมอภาคทางการศึกษา\r\nพ.ศ. 2561. (2561, 13 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 33 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/033/1.PDF",
    sappear: 3,
    mappear: 11,
    rappear: 12,
    firstalpha: "ด"
  },
  {
    keyword: "เทคโนโลยีการจัดการข้อมูลขนาดใหญ่ (big data)",
    meaning:
      "ลักษณะของข้อมูลที่อยู่่ในรูปแบบที่หลากหลาย และมีที่มาจากแหล่งต่างๆทั้งจากระบบคอมพิวเตอร์ที่ใช้งานในองค์การต่างๆเครื่องจักร อุปกรณ์ที่ควบคุมด้วยระบบคอมพิวเตอร์ เซ็นเซอร์ต่างๆที่สร้างข้อมูลและจัดเก็บข้อมูลตลอดเวลาอย่างต่อเนื่อง อุปกรณ์เคลื่อนที่และสื่อสังคมที่ใช้ในการติดต่อสื่อสารถึงกันทุกที่ทุกเวลา ข้อมูลแหล่งข้อมูลดังกล่าวเกิดขึ้นในทุกๆวินาทีทั่วโลก ทั้งในที่ทำงานและในชีวิตประจำวัน",
    source:
      'วิชาญ ทรายอ่อน วิทยากรชำนาญการพิเศษ กลุ่มงานบริการวิชาการ 3 สำนักวิชาการ. (2559). " Big Data" ในภาครัฐ, 4 กันยายน 2562. https://library2.parliament.go.th/ejournal/content_af/2559/dec2559-4.pdf',
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ท"
  },
  {
    keyword: "เทคโนโลยีข้อมูลขนาดใหญ่",
    meaning:
      "เทคโนโลยีในการนำข้อมูลจำนวนมหาศาลมาวิเคราะห์ ประมวลผล และแสดงผลด้วยวิธีที่เหมาะสม ส่วนการวิเคราะห์ข้อมูลขนาด ใหญ่ เพื่อให้สามารถนำข้อมูลมาใช้ได้ง่ายขึ้น เพื่อประโยชน์ในการวางแผน หรือการตัดสินใจ เรียกว่า big data analytics",
    source:
      "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม. (2562). นโยบายและแผนระดับชาติว่าด้วยการพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม, 23 กรกฎาคม 2562. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/047/T_0001.PDF",
    sappear: 6,
    mappear: 20,
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword: "เทคโนโลยีคลาวด์",
    meaning:
      "การให้บริการประมวลผลแบบคลาวด์ เกิดจากแนวคิดการให้บริการโดยใช้ประโยชน์จากโครงสร้างพื้นฐานไอทีที่ทำงานเชื่อมโยงกัน โดยมีเซิร์ฟเวอร์มากมายทำงานสอดประสานเป็นหนึ่งเดียวกันเพื่อให้บริการแอพลิเคชั่นต่างๆ คลาวด์ทำงานโดยใช้ประโยชน์จากระบบประวลผลของระบบต่างๆ ทำให้เกิดบริการหลายอย่าง เช่น การประชุมผ่านอินเตอร์เน็ต ระบบประมวลผลแบบคลาวด์สามารถแบ่งออกเป็น 2 แบบใหญ่ๆ คือ Private Cloud Computing เป็นการใช้งานภายในองค์กร และ Public Cloud Computing ที่มีผู้ให้บริการสาธารณะจัดสรรการบริการเข้าถึงข้อมูลในรูปแบบต่างๆ ผ่านทางอินเทอร์เน็ตเป็นส่วนมาก โดยผู้ใช้ไม่จำเป้นต้องทราบว่ามีเซิร์ฟเวอร์ติดตั้งอยู่ที่ใดบ้าง สนใจเพียงแต่บริการที่ได้รับเท่านั้น",
    source:
      "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม. (2562). นโยบายและแผนระดับชาติว่าด้วยการพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม, 23 กรกฎาคม 2562. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/047/T_0001.PDF",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ท"
  },
  {
    keyword: "เทคโนโลยีชีวภาพ ",
    meaning:
      "เทคโนโลยีซึ่งนำเอาความรู้ทางด้านต่างๆของวิทยาศาสตร์มาประยุกต์ใช้กับสิ่งมีชีวิต หรือชิ้นส่วนของสิ่งมีชีวิต หรือผลผลิตของสิ่งมีชีวิต เพื่อเป็นประโยชน์ต่อมนุษย์ไม่ว่าจะเป็นทางการผลิตหรือทางกระบวนการของสินค้าหรือบริการ เพื่อใช้ประโยชน์เฉพาะอย่างตามที่เราต้องการ โดยสามารถใช้ประโยชน์ทางด้านต่างๆ เช่น ด้านการเกษตร ด้านอาหาร ด้านสิ่งแวดล้อม ด้านทางการแพทย์ เป็นต้น",
    source:
      "ThaiBiotech.info.เทคโนโลยีชีวภาพ, 18 พฤษภาคม 2562.https://www.thaibiotech.info/what-is-biotechnology.php",
    sappear: 2,
    mappear: 4,
    rappear: 2,
    firstalpha: "ท"
  },
  {
    keyword: "เทคโนโลยีชีวภาพด้านการแพทย์และสุขภาพ",
    meaning:
      "เทคโนโลยีชีวภาพ คือ เทคโนโลยีซึ่งนำเอาความรู้ทางด้านต่างๆของวิทยาศาสตร์มาประยุกต์ใช้กับสิ่งมีชีวิต หรือชิ้นส่วนของสิ่งมีชีวิต หรือผลผลิตของสิ่งมีชีวิต เพื่อเป็นประโยชน์ต่อมนุษย์ไม่ว่าจะเป็นทางการผลิตหรือทางกระบวนการ ของสินค้าหรือบริการ เพื่อใช้ประโยชน์เฉพาะอย่างตามที่เราต้องการ โดยสามารถใช้ประโยชน์ทางด้านต่างๆ เช่น ด้านการเกษตร ด้านอาหาร ด้านสิ่งแวดล้อม ด้านทางการแพทย์ เป็นต้น ทั้งนี้ เทคโนโลยีชีวภาพสามารถนำมาประยุกต์ใช้ในทางด้านการแพทย์และสุขภาพได้หลายอย่างหลายด้าน ตัวอย่างเช่น\r\n – ด้านยารักษาโรค เช่น การนำความรู้มาประยุกต์กันระหว่างทาง\r\n เทคโนโลยีชีวภาพกับสมุนไพรหรือสมุนไพรไทย จนสามารถทำยารักษาโรคตัวใหม่ได้\r\n – ด้านการป้องกันโรค เช่น การตรวจดีเอ็นเอ(DNA) เพื่อวิเคราะห์โรคทางพันธุกรรมของพ่อแม่เพื่อดูว่าบุตรที่เกิดมาจะมีโอกาสเกิดโรคทางพันธุกรรมใดๆหรือไม่ หรือ การทำวัคซีนเพื่อป้องกันโรค\r\n – ด้านการวินิจฉัยหาสาเหตุโรค เช่น การผลิตโมโนโคลนอลแอนติบอดีเพื่อตรวจวินิจฉัยโรคต่างๆ หรือ การตรวจดีเอ็นเอ(DNA) เพื่อวิเคราะห์โรคทางพันธุกรรม\r\n – ด้านการรักษาโรค เช่น การประยุกต์ใช้เทคโนโลยีชีวภาพกับการรักษาโรคเบาหวาน\r\n รวมถึงการประยุกต์รวมความรู้ทางเทคโนโลยีชีวภาพกับทางด้านการแพทย์ มาใช้ในงานทางด้านกฏหมายอย่างงานทางนิติวิทยาศาสตร์เพื่อใช้ในการวิเคราะห์หลักฐาน พิสูจน์หลักฐาน หรือ ในการสืบสวนคดี รวมถึงการพิสูจน์เอกลักษณ์บุคคล การพิสูจน์เครือญาติด้วย ดีเอ็นเอ(DNA)",
    source:
      " THAIBIOTECH. (2561). เทคโนโลยีชีวภาพทางด้านการแพทย์และสุขภาพ, 19 พฤศจิกายน 2562. \r\nhttps://www.thaibiotech.info/biotechnology_medicine.php",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword: "เทคโนโลยีดิจิทัล",
    meaning:
      "ทักษะความเข้าใจและใช้เทคโนโลยีดิจิทัล หรือDigital literacy หมายถึง ทักษะในการนำเครื่องมือ อุปกรณ์ และเทคโนโลยีดิจิทัลที่มีอยู่ในปัจจุบัน อาทิ คอมพิวเตอร์ โทรศัพท์ แท็บเลต โปรแกรมคอมพิวเตอร์ และสื่อออนไลน์ มาใช้ให้เกิดประโยชน์สูงสุด ในการสื่อสาร การปฏิบัติงาน และการทำงานร่วมกัน หรือใช้เพื่อพัฒนากระบวนการทำงาน หรือระบบงานในองค์กรให้มีความทันสมัยและมีประสิทธิภาพ ทักษะดังกล่าวครอบคลุมความสามารถ 4 มิติ\r\n 1. การใช้ (Use)\r\n 2. เข้าใจ (Understand)\r\n 3. การสร้าง (create)\r\n 4. เข้าถึง (Access) เทคโนโลยีดิจิทัล ได้อย่างมีประสิทธิภาพ",
    source:
      "วรรณภา จันทร์สะอาด. เทคโนโลยีดิจิตอล, 10 มิถุนายน 2562. http://wchan-digital.blogspot.com/p/digital-technology-digital-technology.html",
    sappear: "",
    mappear: "8,12",
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword: "เทคโนโลยีบรอดแบนด์",
    meaning:
      "เทคโนโลยีการสื่อสารผ่านเครือข่ายอินเทอร์เน็ตความเร็วสูง ที่สามารถรับส่งข้อมูลจำนวนมากผ่านสื่อใช้สาย เช่น เคเบิลใยแก้วนำแสง สายเคเบิลทีวี สายโทรศัพท์ (DSL) หรือสื่อไร้สายเช่น 3G, 4G/LTE และ WiMAX โดยความเร็วของการรับส่งข้อมูลตามที่กรอบนโยบาย ICT 2020 กำหนดนั้นจะอยู่ที่ 768 ล้านบิตต่อวินาทีซึ่งเป็นความเร็วขั้นต่ำ ไปจนถึง 100 ล้านบิตต่อวินาทีขึ้นไป ซึ่งเป็นบริการอินเทอร์เน็ตความเร็วสูงมาก หรือ Ultra Broadbandอนึ่ง กรอบนโยบาย ICT 2020 นี้อ้างอิง ชั้นความเร็วของการรับส่งข้อมูล (Broadband Speed Tiers) ตามที่ Feral Communications Commission แห่งประเทศสหรัฐอเมริกา กำหนดไว้ ซึ่งแบ่งออกเป็นทั้งหมด 7 กลุ่ม (Tiers) ได้แก่ \r\n1st Generation Data - 200 kbps to 768 kbps\r\nBasic Broadband Tiers 1 - 768 kbps to 1.5 Mbps\r\nBroadband Tiers 2 - 1.5 Mbps to 3 Mbps\r\nBroadband Tiers 3 - 3 Mbps to 6 Mbps\r\nBroadband Tiers 4 - 6 Mbps to 10 Mbps\r\nBroadband Tiers 5 - 10 Mbps to 25 Mbps\r\nBroadband Tiers 6 - 25 Mbps to 3 Mbps\r\nBroadband Tiers 7 - Greater to 100 Mbps",
    source:
      "สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ. (2554). คลังศัพท์ไทย, 4 กันยายน 2562. http://www.thaiglossary.com/node/51463",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ท"
  },
  {
    keyword: "เทคโนโลยีปัญญาประดิษฐ์ (Artificial Intelligence : AI)",
    meaning:
      "เทคโนโลยีที่การสรางความสามารถใหแกเครื่องจักรและคอมพิวเตอร ดวยอัลกอริทึมและ\r\nกลุมเครื่องมือทางสถิติ เพื่อสรางซอฟตแวรทรงปญญา ที่สามารถเลียนแบบความสามารถของมนุษยที่ซับซอนได เชน จดจำ แยกแยะ ใหเหตุผล ตัดสินใจ คาดการณ สื่อสารกับมนุษย \r\nเปนต้น ในบางกรณีอาจไปถึงขั้นเรียนรูไดดวยตนเอง",
    source:
      "สำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน). AI เทคโนโลยีปัญญาประดิษฐ์ สำหรับการบริหารงานและการบริการภาครัฐ, 12 กันยายน 2562. https://www.dga.or.th/upload/download/file_e4db016970b7f8b6764f4289c5e9a83f.pdf",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ท"
  },
  {
    keyword: "เทคโนโลยีระบบภูมิศาสตร์สารสนเทศ",
    meaning:
      "การบูรณาการความรู้และเทคโนโลยีทางด้านการรับรู้จากระยะไกล(Remote Sensing : RS) ระบบสารสนเทศภูมิศาสตร์ (Geographic Information System : GIS) และระบบดาวเทียมนำทางโลก (Global Navigation Satellite System : GNSS) เพื่อประยุกต์ใช้งานในด้านต่างๆ ให้เป็นไปอย่างมีประสิทธิภาพ โดยที่วิทยาการด้านการรับรู้จากระยะไกลซึ่งเป็นเทคโนโลยีที่สำคัญในการศึกษาองค์ประกอบต่างๆ บนพื้นโลกและในชั้นบรรยากาศ เพื่อศึกษาและติดตามการเปลี่ยนแปลงสภาพแวดล้อมทางธรรมชาติได้โดยการเลือกใช้ข้อมูลจากดาวเทียมที่มีความละเอียดของภาพและประเภทของดาวเทียมหลากหลาย ขึ้นอยู่กับการประยุกต์ใช้ในแต่ละเรื่อง นอกจากนี้ข้อมูลจากการสำรวจจากระยะไกลเป็นข้อมูลที่ได้มาอย่างรวดเร็ว สามารถตอบสนองความต้องการได้ทันทีสำหรับระบบสารสนเทศภูมิศาสตร์ สามารถจัดการข้อมูลเชิงพื้นที่ วิเคราะห์ข้อมูลและประยุกต์ใช้ในการวางแผนจัดการทรัพยากรธรรมชาติต่างๆ ได้อย่างมีประสิทธิภาพ นอกจากนี้ระบบดาวเทียมนำทางโลกสามารถนำมาใช้กำหนดตำแหน่งเชิงพื้นที่ และติดตามการเคลื่อนที่ของคนและสิ่งของได้อย่างรวดเร็วและแม่นยำ เทคโนโลยีภูมิสารสนเทศจึงเป็นวิทยาการที่สำคัญที่หลายหน่วยงานได้นำมาพัฒนาประเทศในหลากหลายด้าน เช่น ทรัพยากรธรรมชาติและสิ่งแวดล้อม เกษตร ผังเมือง การจราจรและการขนส่ง ความมั่นคงทางการทหาร ภัยธรรมชาติ และการค้าเชิงธุรกิจผลการวิเคราะห์ด้วยเทคโนโลยีภูมิสารสนเทศสามารถนำมาประกอบการวางแผนการตัดสินใจในเรื่องต่างๆ ได้อย่างถูกต้องและรวดเร็ว",
    source:
      "สำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ (องค์การมหาชน):GISTDA. ตำราเทคโนโลยีอวกาศและภูมิสารสนเทศศาสตร์ http://learn.gistda.or.th/",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ท"
  },
  {
    keyword: "เทคโนโลยีสะอาด",
    meaning:
      "การพัฒนา ปรับปรุงหรือเปลี่ยนแปลงกระบวนการผลิตหรือผลิตภัณฑ์อย่างต่อเนื่อง เพื่อให้การใช้วัตถุดิบ พลังงาน และทรัพยากรธรรมชาติเป็นไปอย่างมีประสิทธิภาพ ก่อให้เกิดผลกระทบ ความเสี่ยงต่อมนุษย์และสิ่งแวดล้อมน้อยที่สุดเท่าที่จะเป็นไปได้ โดยการลดมลพิษที่แหล่งกำเนิด และมีของเสียเกิดขึ้นน้อยที่สุดหรือไม่มีเลย ด้วยการเปลี่ยนวัตถุดิบ การใช้ซ้ำและการนำกลับมาใช้ใหม่ ซึ่งเป็นการอนุรักษ์สิ่งแวดล้อมและลดต้นทุนการผลิตควบคู่กันไป",
    source:
      "กรมส่งเสริมคุณภาพสิ่งแวดล้อม. เทคโนโลยีสะอาด - เทคโนโลยีสะอาด Clean Technology, 10 มิถุนายน 2562. https://www.deqp.go.th/service-portal/g-green/green-production-learning-center/clean-technology/clean-technology/",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword: "เทคโนโลยีอวกาศ",
    meaning: "เทคโนโลยีที่พัฒนาเพื่อใช้ประโยชน์จากอวกาศ",
    source:
      "พระราชกฤษฎีกาจัดตั้งสำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ(องค์การมหาชน) (ฉบับที่ 2) พ.ศ. 2562) (2562,31 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 72 ก หน้า 104. \r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/072/T_0103.PDF",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ท"
  },
  {
    keyword: "เทศบัญญัติท้องถิ่น\r\n",
    meaning:
      "กฎหมายเทศบาล เพื่อบังคับใช้ในเขตเทศบาลทั้งนี้อาศัยอำนาจตามพระราชบัญญัติเทศบาล พ.ศ.2496 โดยส่วนใหญ่มักเป็นกฎหมายเฉพาะที่มีลักษณะพิเศษและมีลักษณะจำเพาะที่ต้องการควบคุมเรื่องใดเรื่องหนึ่งเป็นพิเศษที่กฎหมายหลักไม่สามารถควบคุมหรือจัดการได้\r\n",
    source:
      "ศิวพงศ์ ทองเจือ วารสารวิชาคณะสถาปัตยกรรมศาสตร์ สจล. (2559). แนวทางการปรับปรุงข้อกำหนดการใช้ประโยชน์ที่ดินและอาคารในการพัฒนาเมืองและย่าน, 3 กันยายน 2562. https://www.tci-thaijo.org/index.php/archkmitl/article/download/78717/63062/",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ท"
  },
  {
    keyword: "เทียร์",
    meaning:
      "Trafficking in Person Report : TIP REPORT  คือ รายงานการค้ามนุษย์ของกระทรวงการต่างประเทศสหรัฐอเมริกา เป็นรายงานประจำปีที่กระทรวงการต่างประเทศสหรัฐฯ มีหน้าที่ต้องจัดทำตามกฎหมาย Trafficking Victims Protection Act of 2000 (TVPA) เพื่อเสนอต่อสภาสหรัฐเกี่ยวกับสถานการณ์การค้ามนุษย์ประเทศต่างๆ ทั่วโลก รายงานฯ จะครอบคลุมประเทศต่าง ๆ ซึ่งถูกตัดสินว่าเป็นประเทศต้นทาง ประเทศปลายทาง ประเทศทางผ่าน สำหรับผู้ตกเป็นเหยื่อของการค้ามนุษย์ในรูปแบบที่ร้ายแรงจำนวนมาก เนื่องจากการค้ามนุษย์มีแนวโน้มที่จะขยายตัวไปทุกประเทศในโลก รายงานเกี่ยวกับประเทศต่างๆ เป็นการบรรยายถึงขอบเขตและลักษณะของปัญหาการค้ามนุษย์  เหตุผลในการรวมประเทศดังกล่าวไว้ในรายงาน และความพยายามของรัฐบาลนั้น ๆ ในการต่อสู้กับการค้ามนุษย์ \r\n    รายงานยังรวมถึงการประเมินผลว่าความพยายามในการต่อสู้กับการค้ามนุษย์ของรัฐบาลในแต่ละประเทศนั้นสอดคล้องกับมาตรฐานขั้นต่ำในการขจัดการค้ามนุษย์ตามที่ระบุไว้ในกฎหมาย TVPA  ตามที่ได้มีการแก้ไขแล้วหรือไม่ นอกจากนี้ รายงานยังรวมข้อเสนอแนะในการดำเนินการต่าง ๆ เพื่อต่อสู้กับการค้ามนุษย์ รายงานส่วนที่เหลือจะอธิบายถึงความพยายามของรัฐบาลแต่ละประเทศในการบังคับใช้กฎหมายต่อต้านการค้ามนุษย์ คุ้มครองผู้ตกเป็นเหยื่อ และป้องกันการค้ามนุษย์ รายงานของแต่ละประเทศจะอธิบายพื้นฐานในการจัดให้ประเทศอยู่ในระดับ 1, ระดับ 2, ระดับ 2 ที่ถูกจับตามอง, หรือระดับ 3 ถ้าประเทศใดถูกจัดให้อยู่ในระดับ 2 ที่ถูกจับตามอง  รายงานจะอธิบายว่าเหตุใดจึงเป็นเช่นนั้นโดยใช้คำอธิบายซึ่งมีอยู่ในกฎหมาย TVPA ตามที่ได้มีการแก้ไขแล้ว\r\nสหรัฐฯ จัดระดับประเทศต่าง ๆ ตามเกณฑ์ในกฎหมาย TVPA เป็น 4 ระดับ ได้แก่\r\nระดับ 1 (Tier 1) : ประเทศซึ่งรัฐบาลปฏิบัติตามมาตรฐานขั้นต่ำของกฎหมาย TVPA  โดยสมบูรณ์ \r\nระดับ 2 (Tier 2) : ประเทศซึ่งรัฐบาลไม่ได้ปฏิบัติตามมาตรฐานขั้นต่ำของกฎหมาย TVPA โดยสมบูรณ์แต่กำลังใช้ความพยายามอย่างยิ่งในการที่จะปฏิบัติให้ได้ตาม มาตรฐานเหล่านั้น \r\nระดับ 2 ที่ถูกจับตามอง (Tier 2 Watch list) : ประเทศที่รัฐบาลไม่ได้ปฏิบัติตามมาตรฐานขั้นต่ำของกฎหมาย TVPA โดยสมบูรณ์แต่กำลังใช้ความพยายามอย่างยิ่งในการที่จะปฏิบัติให้ได้ตามมาตรฐานเหล่านั้น และ \r\nก) จำนวนสุทธิของผู้ที่ตกเป็นเหยื่อของรูปแบบที่รุนแรงของการค้ามนุษย์มีจำนวนมาก หรือกำลังเพิ่มขึ้นมาก หรือ \r\nข) ไม่สามารถแสดงหลักฐานว่ามีความพยายามเพิ่มขึ้นที่จะต่อสู้กับรูปแบบที่รุนแรงของการค้ามนุษย์จากปีที่ผ่านมา หรือ \r\nค) การตัดสินว่าประเทศนั้นกำลังใช้ความพยายามอย่างมากที่จะปฏิบัติให้ได้ตามมาตรฐานขั้นต่ำมาจากการให้คำมั่นสัญญาของประเทศนั้นว่าจะดำเนินมาตรการเพิ่มเติมในปีถัดมา \r\nระดับ 3 (Tier 3 ) : ประเทศต่าง ๆ ซึ่งรัฐบาลไม่ได้ปฏิบัติตามมาตรฐานขั้นต่ำโดยสมบูรณ์และไม่ได้ใช้ความพยายาม อย่างมีนัยสำคัญที่จะดำเนินการดังกล่าว",
    source:
      "กระทรวงแรงงาน. ปัญหาการค้ามนุษย์, 10 มิถุนายน 2562. http://www.mol.go.th/content/human_trafficking",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ท"
  },
  {
    keyword: "เป้าหมายของ MTEF",
    meaning:
      "กรอบที่เชื่อมการตัดสินใจการจัดทำงบประมาณรายจ่ายประจำปีเข้ากับกลยุทธ์การจัดสรรทรัพยากรระยะปานกลาง \r\nอีกนัยหนึ่ง คือ กระบวนการที่ช่วยให้ระบวนการวางแผนการใช้จ่าย(Financial Planning) ของภาครัฐและการวางแผนในระยะปานกลาง",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์ (องค์การมหาชน). คลังความรู้, 21 พฤษภาคม 2562. https://www.etda.or.th/terminology-detail/1056.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ป"
  },
  {
    keyword: "เป้าหมายระยะยาว Triple Aim",
    meaning:
      "มุ่งเน้นเป้าหมาย 3 มิติร่วมกัน ได้แก่ \r\nมิติที่1 สุขภาวะของประชากร (Population’s Health) \r\nมิติที่2 คือ คุณภาพของบริการ (Service excellent & Patient’s experience of care)\r\nมิติที่3 คือ ค่าใช้จ่ายด้านสุขภาพต่อประชากร (Cost per capita) ที่เหมาะสม",
    source:
      "กองการพยาบาล สำนักงานปลัดกระทรวง กระทรวงสาธารณสุข. (2560). แนวทางการจัดบริการพยาบาลในคลินิกหมอครอบครัว (Primary Care Cluster), 25 ตุลาคม 2562. http://www.nursing.go.th/Book_nurse/primarycarecluster/primarycarecluster.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ป"
  },
  {
    keyword: "เพดานค่าใช้จ่าย",
    meaning: "ขอบเขตระดับสูงสุดของค่าใช้จ่าย",
    source:
      "ณรงค์พล โชตเศรษฐ์ และ กฤติพร ศรียะพันธ์ สํานักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ. (2554). อภิธานศัพท์สําหรับองค์ความรู้การกํากับดูแลโครงสร้างและกิจการสาธารณูปโภค, 10 ตุลาคม 2562. http://regulationbodyofknowledge.org/wp-content/uploads/2013/04/glossary_THAI.pdf",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "พ"
  },
  {
    keyword: "เพศภาวะ",
    meaning:
      "บทบาท พฤติกรรม การกระทำและคุณลักษณะของบุคคลในสังคม ผ่านการหลอมสร้างจากการปลูกฝังและกำหนดแบบแผนการแสดงออกและการปฏิบัติทางเพศระหว่างหญิง-ชายให้แตกต่างกัน เพศภาวะเป็นความสัมพันธ์ระหว่างหญิง-ชายที่ก่อรูปในทางสังคมและวัฒนธรรม สามารถเปลี่ยนแปลงได้ตามกาลเวลา บริบททางสังคม เศรษฐกิจ และการเมือง เป็นการรับรู้ตัวเอง เลือกใช้ชีวิตทางเพศของตัวเอง ซึ่งอาจจะไม่ตรงตามเพศสรีระ ดังที่เรียกกันว่าคนข้ามเพศ ดังนั้น เพศภาวะ\r\nจึงมีความหมายมากกว่าความเป็นชายและความเป็นหญิง",
    source:
      "กฤตยา อาชวนิจกุล และกุลภา วจนสาระ.\r\nมองผ่านเลนส์เพศภาวะและความหลากหลาย:ข้อเสนอการพัฒนายุทธศาสตร์เพื่อสุขภาวะผู้หญิง, 11 มิถุนายน 2562 .http://resource.thaihealth.or.th/system/files/documents/mngphaanelns.pdf",
    sappear: 4,
    mappear: "",
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "เพศสภาพ",
    meaning: "ความเป็นหญิงหรือเป็นชาย เช่น เขามีเพศสภาพไม่ตรงกับเพศกำเนิด\r\n",
    source:
      'พจนานุกรม ฉบับราชบัณฑิตยสถาน. (2554). คำเกี่ยวกับ "เพศ", 25 กรกฎาคม 2562. http://www.royin.go.th/wp-content/uploads/2017/03/%E0%B8%84%E0%B8%B3%E0%B9%80%E0%B8%81%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%A7%E0%B8%81%E0%B8%B1%E0%B8%9A%E0%B9%80%E0%B8%9E%E0%B8%A822-03-2560.pdf',
    sappear: 4,
    mappear: "15,17",
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "เพศสภาวะ",
    meaning:
      "หรือ Gender คือ บทบาทความเป็นเพศที่ถูกกำหนดและประกอบสร้าง ขี้นจากขนบธรรมเนียม ประเพณี โครงสร้างอำนาจ และกลไกทางสังคมต่างๆ ซึ่งส่งผลต่อการนิยามตนเอง หรืออัตลักษณ์ทางเพศ (Gender Identity) และการแสดงบทบาททางเพศ หรือตัวตนทางเพศของบุคคลในสังคม เช่น การแสดงบทบาทความเป็นหญิง หรือความเป็นชาย หรือความเป็นเพศอื่นๆ ในสังคมของบุคคล เพศสภาพ เป็นผลลัพธ์จากกระบวนการขัดเกลาทางสังคมที่เชื่อมโยงกับทัศนคติ ความเชื่อ วัฒนธรรม ค่านิยม ขนบธรรมเนียม ประเพณี ซึ่งไม่มีสถานะตายตัว สามารถเปลี่ยนแปลงได้ตามยุคสมัย ตามความแตกต่างทาง สังคมและวัฒนธรรม และไม่จำเป็นจะต้องสอดคล้องกับเพศสรีระหรือเพศกำเนิดก็ได้",
    source:
      "กฤตยา อาชวนิจกุล. (2554). เพศวิถีที่กำลังเปลี่ยนไปในสังคมไทย, 11 มิถุนายน 2562. http://www2.ipsr.mahidol.ac.th/ConferenceVII/Download/2011-Article-03.pdf",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "เพิ่มผลิตผล",
    meaning:
      "กระบวนการในการปฏิบัติงานเพื่อให้ได้สินค้า บริการ หรืองานที่มีคุณภาพสอดคล้องกับความต้องการของลูกค้า ด้วยวิธีการในการลดต้นทุน ลดการสูญเสียทุกรูปแบบ การใช้ทรัพยากรอย่างคุ้มค่า การใช้เทคโนโลยีที่เหมาะสม การพัฒนาศักยภาพของผู้ปฏิบัติงานในองค์กร และการใช้เทคนิคการทำงานต่าง ๆ เข้ามาเพื่อเพิ่มประสิทธิภาพในการทำงาน",
    source:
      "ดร.วิทยา อินทร์สอน, ผศ.ดร.ไพโรจน์ ด้วงนคร, ปัทมาพร ท่อชู. ทำความเข้าใจแนวคิดของการเพิ่มผลผลิต, 10 มิถุนายน 2562. http://www.thailandindustry.com/onlinemag/view2.php?id=461&section=4&issues=24",
    sappear: 5,
    mappear: 19,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "เภสัชภัณฑ์",
    meaning:
      "เภสัชเคมีภัณฑ์ หรือชีววัตถุใด ๆ ที่ใช้เพื่อการวินิจฉัย บำบัด บรรเทา รักษา หรือป้องกันโรคหรือความเจ็บป่วยของมนุษย์ ที่มีผลต่อโครงสร้างหรือการทำงานใด ๆ ของร่างกายมนุษย์",
    source:
      "สมาคมผู้วิจัยและผลิตเภสัชภัณฑ์. (2555), เกณฑ์จริยธรรม ฉบับที่ 9 https://www.pharmacy.cmu.ac.th/filessum/ethics/010.pdf",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ภ"
  },
  {
    keyword: "เมืองกีฬาต้นแบบ",
    meaning:
      "จังหวัดหรือพื้นที่ทางการปกครองที่มีความพร้อมในการพัฒนาและจัดกิจกรรมการกีฬา เพื่อประโยชน์ สุขภาพ และคุณภาพชีวิตของประชาชน การสร้างความเป็นเลิศ การพัฒนาองค์ความรู้ทางการกีฬา การฝึกซ้อม และการจัดการแข่งขันกีฬา รวมถึงการสร้างมูลค่าเพิ่มทางเศรษฐกิจของประเทศด้วยการส่งเสริมการมีส่วนร่วมของภาครัฐและภาคประชาสังคม ",
    source:
      "สำนักงานเลขาธิการสภาผู้แทนราษฎร. (2560). รายงานของคณะกรรมาธิการขับเคลื่อนการปฏิรูปประเทศด้านกีฬา ศิลปะ วัฒนธรรม การศาสนา คุณธรรม และจริยธรรม สภาขับเคลื่อนการปฏิรูปประเทศ เรื่อง “การจัดตั้งเมืองกีฬา”(Sport City), 1 สิงหาคม 2562. https://www.parliament.go.th/ewtcommittee/ewt/drive_sport/download/article/article_20170522163827.pdf",
    sappear: "",
    mappear: 14,
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "เมืองน่าอยู่",
    meaning:
      "เมืองที่มีการสร้างสรรค์และปรับปรุงสภาพแวดล้อมทั้งทางด้านกายภาพและสังคมอย่างต่อเนื่อง รวมทั้งมีการขยายฐานทรัพยากรของชุมชนเพื่อส่งเสริมให้ประชาชนช่วยเหลือสนับสนุนซึ่งกันและกันในการดำรงชีวิต ทุกบทบาทหน้าที่ และพัฒนาให้แต่ละคนมีศักยภาพสูงสุด ",
    source:
      "ปาริชาติ อ่อนทิมวงค์ นักวิชาการอิสระ แผนงานนโยบายสาธารณะเพื่อการพัฒนาอนาคตของเมือง ศูนย์ศึกษามหานครและเมือง วิทยาลัยรัฐกิจ มหาวิทยาลัยรังสิต. (2559). การประยุกต์แผนที่วัฒนธรรมเพื่องานด้านการพัฒนาเมือง กรณีศึกษา iDiscover City Walks Application, 20 พฤศจิกายน 2562. http://furd-rsu.org/wp-content/uploads/delightful-downloads/2017/02/CulturalMapping_ParichartOntimwong.pdf ",
    sappear: 2,
    mappear: 6,
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "เมืองน่าอยู่อัจฉริยะ",
    meaning:
      "เมืองที่ใช้ประโยชน์จากเทคโนโลยีสารสนเทศและการสื่อสารมาเพิ่มประสิทธิภาพในการบริหารจัดการเมืองเพื่อยกระดับคุณภาพชีวิตของประชาชน มีสังคมและสิ่งแวดล้อมคุณภาพสูงที่ตอบสนองความต้องการในทุกด้านของประชาชนโดยมี 6 องค์ประกอบสำคัญคือ \r\n1. การสัญจรอัจฉริยะ\r\n2. พลังงานอัจฉริยะ\r\n3. ชุมชนอัจฉริยะ\r\n4. สิ่งแวดล้อมอัจฉริยะ\r\n5. เศรษฐกิจอัจฉริยะ\r\n6. การบริหารจัดการอัจฉริยะ",
    source:
      "สำนักงานคณะกรรมการส่งเสริมการลงทุน. (ม.ป.ป). เมืองอัจฉริยะน่าอยู่ในอีอีซี, 1 สิงหาคม 2562. https://www.eeco.or.th/sites/default/files/เมืองอัจฉริยะน่าอยู่.pdf",
    sappear: 2,
    mappear: 6,
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "เมืองอัจฉริยะ",
    meaning:
      "เมืองที่ใช้ประโยชน์จากเทคโนโลยีและนวัตกรรมที่ทันสมัยและชาญฉลาดเพื่อเพิ่มประสิทธิภาพของการให้บริการและการบริหารจัดการเมือง ลดค่าใช้จ่ายและการใช้ทรัพยากรของเมืองและประชากรเป้าหมาย โดยเน้นการออกแบบที่ดีและการมีส่วนร่วมของภาคธุรกิจและภาคประชาชนในการพัฒนาเมือง ภายใต้แนวคิดการพัฒนาเมืองน่าอยู่ เมืองทันสมัย ให้ประชาชนในเมืองมีคุณภาพชีวิตที่ดี มีความสุขอย่างยั่งยืน ... คณะกรรมการขับเคลื่อนการพัฒนาเมืองกำหนดรูปแบบเมืองอัจฉริยะต้นแบบ ประกอบด้วย 6 สาขาอัจฉริยะ ได้แก่ \r\n1. เศรษฐกิจอัจฉริยะ (Smart Economy)\r\n2. ระบบขนส่งและการสื่อสารอัจฉริยะ (Smart Mobility)\r\n3. พลังงานและสิ่งแวดล้อมอัจฉริยะ (Smart Energy & Environment)\r\n4. ระบบบริหารภาครัฐอัจฉริยะ (Smart Governance)\r\n5. พลเมืองอัจฉริยะ (Smart People)\r\n6. การดำรงชีวิตอัจฉริยะ (Smart Living)",
    source:
      "สำนักงานเมืองอัจฉริยะประเทศไทย สำนักงานส่งเสริมเศรษฐกิจดิจิทัล. (ม.ป.ป). นิยาม “เมืองอัจฉริยะ,” 20 พฤศจิกายน 2562. https://smartcitythailand.or.th/web?web008",
    sappear: "2,4",
    mappear: "6,9",
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "เมืองอุตสาหกรรม",
    meaning: "เมืองนี้เป็นเมืองท่าและเป็นเมืองอุตสาหกรรม",
    source:
      'NECTEC Lexitron, Tanaka Corpus. (2562). คำแปล ความหมาย ของ "เมืองอุตสาหกรรม" , 8 กรกฎาคม 2562. https://www.addnine.com/web/dict/search/%E0%B9%80%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%87%E0%B8%AD%E0%B8%B8%E0%B8%95%E0%B8%AA%E0%B8%B2%E0%B8%AB%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1',
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "เมืองอุตสาหกรรมนิเวศ",
    meaning:
      "การพัฒนาพื้นที่อุตสาหกรรมตามแนวคิดการพัฒนาที่ยั่งยืน โดยมีการจัดวางผังพร้อมทั้งสาธารณูปโภค สาธารณูปการ และสิ่งอำนวยความสะดวกอย่างเหมาะสม เพื่อรองรับ\r\nการดำเนินธุรกิจของผู้ประกอบการที่มุ่งเน้นการบริหารจัดการทรัพยากร และพลังงานอย่างมีประสิทธิภาพ และเป็นมิตรต่อสิ่งแวดล้อม โดยการมีส่วนร่วมของชุมชน ทั้งนี้เพื่อการอยู่ร่วมกันอย่างกลมกลืนและเกื้อหนุนซึ่งกันและกันของภาคอุตสาหกรรมและชุมชนบริเวณโดยรอบพื้นที่อุตสาหกรรม",
    source:
      "กองการพัฒนาอย่างยั่งยืน ฝ่ายสิ่งแวดล้อม. การนิคมอุตสาหกรรมแห่งประเทศไทย. คู่มือการจัดทำแผนแม่บทการเป็นเมืองอุตสาหกรรมเชิงนิเวศ ตามกรอบยุทธศาสตร์ประเทศ \r\n\r\nhttps://www.ieat.go.th/assets/uploads/attachment/file/20180713211554163370737.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ม"
  },
  {
    keyword: "เรียลไทม์",
    meaning:
      "ช่วงเวลาสั้นมากที่เกิดขึ้นขณะระบบคอมพิวเตอร์กำลังรับและจัดการข้อมูล",
    source:
      "พจนานุกรมอิเล็กทรอนิกส์ไทย – อังกฤษ LEXiTRON เวอร์ชัน 3.0. Real Time, 20 พฤศจิกายน 2562. https://lexitron.nectec.or.th/",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "เรือสำราญ",
    meaning:
      "ธุรกิจการท่องเที่ยวที่เติบโตต่อเนื่องมาอย่างยาวนาน ลักษณะเฉพาะของเรือสำราญคือการผสมผสานระหว่างธุรกิจที่พักและการคมนาคมขนส่งไว้ด้วยกัน โดยนำกิจกรรมที่มีสาระและความบันเทิงต่างๆ นำเสนอระหว่างการเดินทางล่องเรือ มีบริการพื้นฐานต่างๆ เช่น ห้องอาหาร การแสดง กาสิโน สปา ร้านขายของปลอดภาษี คลับ สระว่ายน้ำ เป็นต้น และอาจจะมีบริการเสริมอื่นๆ ให้เหมาะสมกับกลุ่มลูกค้าเป้าหมาย และใช้ท่าเรือแวะพักต่างๆ เป็นจุดดึงดูดกลุ่มเป้าหมายให้ตัดสินใจล่องเรือสำราญ ทั้งนี้ความปลอดภัยตลอดการล่องเรือถือเป็นสิ่งที่สำคัญมากที่สุด",
    source:
      "ดร. ไพฑูรย์ มนต์พานทอง คณะการจัดการการท่องเที่ยว สถาบันบัณฑิตพัฒนบริหารศาสตร์. (2558). การท่องเที่ยวเรือสำราญกับความท้าทายของประเทศไทย, 8 กรกฎาคม 2562. http://www.etatjournal.com/web/menu-read-tat/menu-2015/menu-42015/682-42015-cruise",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "เวชกรรม",
    meaning:
      "การตรวจโรค การวินิจฉัยโรค การบำบัดโรค การป้องกันโรค การผดุงครรภ์การปรับสายตาด้วยเลนซ์สัมผัส การแทงเข็มหรือการฝังเข็มเพื่อบำบัดโรคหรือเพื่อระงับความรู้สึก รวมถึงการศัลยกรรม การใช้รังสี การฉีดยาหรือสสาร การสอดใส่วัตถุใด ๆ เข้าไปในร่างกาย ทั้งนี้ เพื่อการคุมกำเนิด การเสริมสวย หรือการบำรุงร่างกาย",
    source:
      "พระราชบัญญัติวิชาชีพเวชกรรม พ.ศ. 2525. (2525 ,11 สิงหาคม). ราชกิจจานุเบกษา. เล่ม 99 ตอนที่ 111 ฉบับพิเศษ. 6 มิถุนายน 2562. http://web.krisdika.go.th/data/lawabout/lawdetail/lawdetail_099.htm",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "ว"
  },
  {
    keyword: "เวชภัณฑ์",
    meaning: "สิ่งของเครื่องมือเครื่องใช้เกี่ยวกับการแพทย์",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. เวชภัณฑ์, 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/index.php",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ว"
  },
  {
    keyword: "เวชศาสตร์",
    meaning: "ชื่อตํารารักษาโรคแผนโบราณวิชาว่าด้วยการรักษาโรคโดยการใช้ยา",
    source:
      "พจนานุกรมแปล ไทย-ไทย ราชบัณฑิตยสถาน. เวชศาสตร์. 8 กรกฎาคม 2562. https://dictionary.sanook.com/search/dict-th-th-royal-institute/%E0%B9%80%E0%B8%A7%E0%B8%8A%E0%B8%A8%E0%B8%B2%E0%B8%AA%E0%B8%95%E0%B8%A3%E0%B9%8C",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ว"
  },
  {
    keyword: "เวชสำอาง",
    meaning:
      "ผลิตภัณฑ์ที่รวมเอาคุณสมบัติของเครื่องสำอางและยาเข้าไว้ด้วยกัน คือ เป็นเครื่องสำอางที่สามารถออกฤทธิ์หรือทำให้มีการเปลี่ยนแปลงอย่างเห็นได้ชัดกว่าเครื่องสำอาง ซึ่งเครื่องสำอางมีความสามารถและประสิทธิภาพในการทำความสะอาด หรือส่งเสริมให้เกิดความงามเท่านั้น และกลไกการทำงาน หรือการออกฤทธิ์จะเห็นผลได้ช้า หรือได้น้อยกว่าเวชสำอาง ผลิตภัณฑ์ที่จัดเป็นเวชสำอางจะไม่เน้นเรื่องการเสริมความงาม แต่จะให้ความสำคัญในเรื่องของประสิทธิภาพในการรักษาปัญหาเฉพาะที่เป็นจุดประสงค์หลัก ทำให้เกิดการเปลี่ยนแปลงของโครงสร้างผิวหนัง สามารถช่วยให้ผิวพรรณดีขึ้นจากภายในได้แต่ไม่จัดเป็นยา",
    source:
      "พูนศิริ อัตราภรณ์ประดิษฐ์. (2558). แผนธุรกิจผลิตภัณฑ์เวชสำอางบำรุงผิวสารสกัดจากฟักข้าว.(การค้นคว้าอิสระบริหารธุรกิจมหาบัณฑิต). มหาวิทยาลัยธรรมศาสตร์. กรุงเทพฯhttp://ethesisarchive.library.tu.ac.th/thesis/2015/TU_2015_5702030882_2820_1823.pdf",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "ว"
  },
  {
    keyword: "เวลาแฝงในการส่งข้อมูล (latency)",
    meaning:
      "การแสดงเวลาที่ใช้ในการนำ 1 แพ็คเกตของข้อมูล จากจุดหนึ่งไปอีกจุดหนึ่ง บางการใช้ latency เป็นการวัดโดยการส่ง1 แพ็คเกตที่ส่งกลับไปยังผู้ส่ง ซึ่ง 1 รอบการเดินทางพิจารณาเป็น latency ในระบบคอมพิวเตอร์ latency มักใช้ในความหมาย ความล่าช้า หรือ การคอยที่เพิ่มจริง หรือเวลาการตอบสนองมากกว่า เวลาที่คาดหวัง ส่วนที่ทำให้เกิดการหน่วงเวลาของคอมพิวเตอร์ ได้แก่ ความเร็วข้อมูลไม่พอดี ระหว่างไมโครโพรเซสเซอร์ กับอุปกรณ์นำเข้าและส่งออก และ buffer ของข้อมูลไม่พอภายในคอมพิวเตอร์",
    source:
      "กรมวิทยาศาสตร์และเทคโนโลยีกลาโหม. (2556). latency คืออะไร, 4 กันยายน 2562. http://www.dstd.mi.th/board/index.php?PHPSESSID=irdke6bh837159jo1kii9nhv37&topic=528.msg850#msg850",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ว"
  },
  {
    keyword: "เศรษฐกิจเสรีนิยม",
    meaning:
      "หรือ ระบบเศรษฐกิจแบบทุนนิยม คือ ระบบเศรษฐกิจที่เอกชนมีบทบาทสำคัญในการเป็นเจ้าของปัจจัยการผลิต และเป็นผู้ประกอบการทางเศรษฐกิจ  ในระบบทุนนิยม เอกชนหรือองค์การธุรกิจสามารถใช้ปัจจัยการผลิตได้อย่างเสรีโดยที่รัฐไม่เข้ามาแทรกแซงการทำงาน  ระบบเศรษฐกิจแบบทุนนิยมจะขับเคลื่อนโดยการแข่งขันภายใต้กลไกตลาดและมีกำไรเป็นสิ่งจูงใจให้ผลิตสินค้าและบริการ",
    source:
      "สำนักราชบัณฑิยสภา. (2552). ทุนนิยม-สังคมนิยม, 3 กันยายน 2562. http://www.royin.go.th/?knowledges=%E0%B8%97%E0%B8%B8%E0%B8%99%E0%B8%99%E0%B8%B4%E0%B8%A2%E0%B8%A1-%E0%B8%AA%E0%B8%B1%E0%B8%87%E0%B8%84%E0%B8%A1%E0%B8%99%E0%B8%B4%E0%B8%A2%E0%B8%A1-%E0%B9%91%E0%B9%97-%E0%B8%9E%E0%B8%A4%E0%B8%A8",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ศ"
  },
  {
    keyword: "เศรษฐกิจและสังคมสีเขียว",
    meaning:
      "ระบบเศรษฐกิจที่นำไปสู่การยกระดับคุณภาพความเป็นอยู่ของมนุษย์ เพิ่มความเป็นธรรมทางสังคม และในขณะเดียวกันก็สามารถลดความเสี่ยงทางด้านสิ่งแวดล้อมและปัญหาความขาดแคลนของทรัพยากรลงได้ ซึ่งแนวคิดเรื่องเศรษฐกิจสีเขียวได้ถูกนำเสนอจากโครงการสิ่งแวดล้อมแห่งสหประชาชาติ (UNEP) เพื่อปรับแก้ไขระบบเศรษฐกิจ (เสรีใหม่นิยม) ที่เป็นอยู่ให้เป็นไปในทิศทางที่มุ่งสู่เป้าหมายการพัฒนาที่ยั่งยืนมากขึ้น \r\n",
    source:
      "กรมเจรจาการค้าระหว่างประเทศ. (2559). เศรษฐกิจสีเขียว (Green Economy) คืออะไร, 3 กันยายน 2562. http://www.aseanthai.net/ewt_news.php?nid=5604&filename=aseanknowledge \r\n",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ศ"
  },
  {
    keyword: "เศรษฐกิจชีวภาพ หรือ เศรษฐกิจฐานชีวภาพ",
    meaning:
      "ระบบเศรษฐกิจที่นำความรู้และนวัตกรรมโดยเฉพาะทางด้านชีววิทยาหรือวิทยาศาสตร์ชีวภาพอื่น ๆ มาช่วยพัฒนาการผลิตสินค้าและบริการที่ใช้ประโยชน์จากทรัพยากรชีวภาพ เช่น การเกษตร อาหาร สุขภาพ การแพทย์ และพลังงาน ให้มีประสิทธิภาพอย่างยั่งยืน",
    source:
      "กระทรวงวิทยาศาสตร์และเทคโนโลยี. สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ (สวทช.). เศรษฐกิจชีวภาพ. (2562). หน้า 9.\r\nhttps://www.mhesi.go.th/main/STBookSeries/BS005Bioeconomy.pdf",
    sappear: "",
    mappear: 4,
    rappear: 5,
    firstalpha: "ศ"
  },
  {
    keyword: "เศรษฐกิจชุมชน",
    meaning:
      "เศรษฐกิจทุกสาขาของชุมชนและหมู่บ้าน ซึ่งดำเนินอยู่บนพื้นฐานการใช้ประโยชน์จากทรัพยากรและสิ่งแวดล้อมอย่างเหมาะสม คุ้มค่าและยั่งยืน เป็นการผลิตที่เลี้ยงชีวิต ครอบครัวและชุมชนได้อย่างพอเพียง ส่วนเกินแห่งผลผลิตนี้เป็นเศรษฐกิจแห่งการแลกเปลี่ยน ซื้อขายหรือแปรรูปตามกำลังและวัฒนธรรมของชุมชนเอง",
    source:
      "ระเบียบกระทรวงมหาดไทยว่าด้วยการดำเนินงานโครงการเศรษฐกิจชุมชน พ.ศ. 2541 (2553, 17 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 127 ตอนพิเศษ 60 ง หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2553/E/060/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "ศ"
  },
  {
    keyword: "เศรษฐกิจฐานราก",
    meaning:
      "ระบบเศรษฐกิจของชุมชนท้องถิ่นที่สามารถพึ่งตนเองภายใต้ปรัชญาเศรษฐกิจพอเพียงที่มีการช่วยเหลือเอื้อเฟื้อซึ่งกันและกัน มีคุณธรรม และเป็นระบบเศรษฐกิจที่เอื้อให้เกิดการพัฒนาด้านอื่น ๆ ในพื้นที่ ทั้งเศรษฐกิจ สังคม ผู้คน ชุมชน วัฒนธรรม สิ่งแวดล้อม ทรัพยากรธรรมชาติอย่างเข้มแข็งและยั่งยืน",
    source:
      "สถาบันพัฒนาองค์กรชุมชน (องค์การมหาชน) กระทรวงการพัฒนาสังคมและความมั่นคงของมนุษย์. (2559).คู่มือการส่งเสริมการพัฒนา“ระบบเศรษฐกิจฐานราก”, 10 มิถุนายน 2562. http://www.codi.or.th/attachments/article/15058/Guide_economic_280959.pdf",
    sappear: 4,
    mappear: "16,20",
    rappear: "",
    firstalpha: "ศ"
  },
  {
    keyword: "เศรษฐกิจดิจิทัล",
    meaning:
      "เป็นการขับเคลื่อนเศรษฐกิจของประเทศโดยการนำเอาเทคโนโลยีดิจิทัลเข้ามาใช้เพื่อเพิ่มผลผลิต เพิ่มผลงาน โดยใช้เวลาน้อยลงและสร้างมูลค่าเพิ่มให้แก่สินค้าและบริการต่าง ๆ เพื่อให้สามารถแข่งขันกับชาติต่างๆ ได้ ",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์ (สพธอ.). เศรษฐกิจดิจิทัล (Digital Economy), 3 กันยายน 2562. https://www.etda.or.th/digital-economy.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ศ"
  },
  {
    keyword: "เศรษฐกิจผู้สูงวัย",
    meaning:
      "ระบบเศรษฐกิจส่วนที่เกี่ยวข้องกับกิจกรรมที่ตอบสนองความต้องการและความจำเป็นสำหรับผู้สูงวัย ทั้งผลิตภัณฑ์ บริการและกิจกรรมทางเศรษฐกิจอื่นๆ โดยผู้สูงวัยในที่นี้มักนับรวมผู้ที่มีอายุ 50 ปีขึ้นไป\r\n",
    source:
      "กระทรวงวิทยาศาสตร์และเทคโนโลยี สำนักงานพัฒนาวิทยาศาสตร์ละเทคโนโลยีแหงชาติ (สวทช.). (2562). SILVER ECONOMY เศรษฐกิจผู้สูงวัย, 3 กันยายน 2562. http://waa.inter.nstda.or.th/stks/pub/2019/20190318-book-silver-economy.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ศ"
  },
  {
    keyword: "เศรษฐกิจพอเพียง",
    meaning:
      "ปรัชญาที่พระบาทสมเด็จพระเจ้าอยู่หัวรัชกาลที่ 9 พระราชทานเป็น แนวทางการดำรงชีวิตและปฏิบัติตนของประชาชนตั้งแต่ระดับครอบครัว ระดับชุมชน จนถึงระดับรัฐ ให้ดำเนินไปในทางสายกลาง ไม่ประมาท ไม่โลภ ไม่เบียดเบียนผู้อื่น คำนึงถึงความพอประมาณ ความมีเหตุผล มีภูมิคุ้มกันในตัว ตลอดจนใช้ความรู้และคุณธรรม เป็นพื้นฐานในการดำรงชีวิตให้รอดพ้นจากวิกฤติ มีความมั่นคงและยั่งยืนท่ามกลางกระแสโลกาภิวัตน์และความเปลี่ยนแปลงต่าง ๆ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ธนาคารโลก. 6 มิถุนายน 2562. http://www.royin.go.th/dictionary/index.php",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "ศ"
  },
  {
    keyword: "เศรษฐกิจภาคทะเล",
    meaning:
      "หรือ ‘เศรษฐกิจสีน้ำเงิน’  (Blue Economy) เป็นเศรษฐกิจฐานทรัพยากรทางทะเลและชายฝั่ง ซึ่งครอบคลุมกิจกรรมทางเศรษฐกิจที่ใช้ประโยชน์จากทรัพยากรทางทะเลทั้งทางตรงและทางอ้อม อาทิ การเป็นแหล่งอาหาร แร่ ทรัพยากรธรรมชาติ การเป็นแหล่งพลังงาน การท่องเที่ยว การขนส่ง และภาคบริการที่เกี่ยวเนื่อง เป็นต้น",
    source:
      "สำนักงานกองทุนสนับสนุนการวิจัย (สกว.). (2561). เศรษฐกิจสีน้ำเงิน: พื้นที่ใหม่ของการพัฒนาเศรษฐกิจ, 11 กันยายน 2562. http://www.knowledgefarm.in.th/report-blue-economy/",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "ศ"
  },
  {
    keyword: "เศรษฐกิจมหภาค",
    meaning:
      "เศรษฐกิจขนาดใหญ่ โดยจะศึกษาหน่วยเศรษฐกิจโดยรวมทั้งระบบ เช่น ผลผลิตหรือรายได้ประชาชาติ ระดับการออม การลงทุนของประชาชน นโยบายรัฐบาล นโยบายการคลัง เป็นต้น",
    source:
      "DotThai. (2561). เศรษฐศาสตร์มหภาค คืออะไร และศึกษาเกี่ยวกับอะไร, 12 มิถุนายน 2562. http://doithai.com/article/83/เศรษฐศาสตร์มหภาค-คืออะไร-และศึกษาเกี่ยวกับอะไร",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ศ"
  },
  {
    keyword: "เศรษฐกิจระดับฐานราก",
    meaning:
      "ระบบเศรษฐกิจของชุมชนท้องถิ่น ที่สามารถพึ่งตนเองภายใต้ปรัชญาเศรษฐกิจพอเพียงที่มีการช่วยเหลือเอื้อเฟื้อซึ่งกันและกัน มีคุณธรรม และเป็นระบบเศรษฐกิจที่เอื้อให้เกิดการพัฒนาด้านอื่นๆ ในพื้นที่ ทั้งเศรษฐกิจ สังคม ผู้คน ชุมชน วัฒนธรรม สิ่งแวดล้อม ทรัพยากรธรรมชาติอย่างเข้มแข็งและยั่งยืน",
    source:
      "สถาบันพัฒนาองค์กรชุมชน (องค์การมหาชน)\r\nกระทรวงการพัฒนาสังคมและความมั่นคงของมนุษย์ .(2559).คู่มือการส่งเสริมการพัฒนา“ระบบเศรษฐกิจฐานราก”, 10 มิถุนายน 2562. หน้า9 http://www.codi.or.th/attachments/article/15058/Guide_economic_280959.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ศ"
  },
  {
    keyword: "เศรษฐกิจสีเขียว",
    meaning:
      "ระบบเศรษฐกิจที่ส่งผลให้เกิดการปรับปรุงความเป็นอยู่ของมนุษย์และความเท่าเทียมทางสังคม ขณะเดียวกันก็ลดความเสี่ยงที่จะเกิดอันตรายต่อสิ่งแวดล้อมและความขาดแคลนทางระบบนิเวศอย่างมีนัยสำคัญด้วยวิธีการที่ใช้และปล่อยคาร์บอนออกน้อย ใช้ทรัพยากรอย่างมีประสิทธิภาพมาก และเกิดจากความร่วมมือของคนในสังคม",
    source:
      "สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ.กระทรวงวิทยาศาสตร์และเทคโนโลยี. เศรษฐกิจสีเขียว GREEN ECONOMY. 21 พฤศจิกายน 2562\r\n\r\nhttps://waa.inter.nstda.or.th/stks/pub/2019/20190318-book-green-economy.pdf",
    sappear: "",
    mappear: "4,9,18",
    rappear: 6,
    firstalpha: "ศ"
  },
  {
    keyword: "เศรษฐศาสตร์",
    meaning:
      "วิชาว่าด้วยการผลิต การจำหน่ายจ่ายแจกและการบริโภคใช้สอยสิ่งต่าง ๆ ของชุมชน โดยสามารถแบ่งแยกย่อยได้เป็น 2 สาขาใหญ่ๆ คือ \r\n1. เศรษฐศาสตร์จุลภาค ได้แก่ เศรษฐศาสตร์ภาคที่ศึกษาปัญหาเศรษฐกิจส่วนเอกชน หรือ ปัญหาการตลาด กลไกราคา เป็นต้น \r\n2. เศรษฐศาสตร์มหัพภาค ได้แก่ เศรษฐศาสตร์ภาคที่ศึกษาปัญหาเศรษฐกิจของประเทศโดยส่วนรวม เช่น ปัญหาเรื่องรายได้ของประชาชาติ การออมทรัพย์ของประชากร ปัญหาการลงทุน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. เศรษฐศาสตร์. 6 มิถุนายน 2562. http://www.royin.go.th/dictionary/index.php",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "ศ"
  },
  {
    keyword: "เศรษฐศาสตร์เพื่อสิ่งแวดล้อม",
    meaning:
      "การกำหนดมาตรการและระบบแรงจูงใจเพื่อเปลี่ยนแปลงพฤติกรรมของภาคการผลิตและผู้บริโภคเพื่อให้เป็นคุณต่อสภาพสิ่งแวดล้อม อาทิ มาตรการลดการบริโภค ลดการปล่อยมลพิษ ลดการทิ้งขยะ/ของเหลือใช้ ฯลฯ ทั้งนี้โดยเลือกใช้มาตรการต่างๆ อาทิ ภาษีสิ่งแวดล้อม การเก็บค่าธรรมเนียมจากการทิ้งขยะหรือการปล่อยของเสีย สินเชื่อเพื่อสิ่งแวดล้อม การลงทุนด้านสิ่งแวดล้อม ค่าปรับ ระบบมัดจำ-คืนเงิน การกำหนดกรรมสิทธิ์ ให้มีความชัดเจน ฯลฯ",
    source:
      "มหาวิทยาลัยเกษตรศาสตร์. (2544). การใช้เครื่องมือเศรษฐศาสตร์เพื่ออนุรักษ์สิ่งแวดล้อม, 4 กันยายน 2562. http://www.journal.eco.ku.ac.th/upload/document/thai/20080525104425.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ศ"
  },
  {
    keyword: "เสถียรภาพ",
    meaning:
      "ความมั่นคง, ความคงตัว, ความไม่เปลี่ยนแปลง, เช่น เสถียรภาพทางการเมือง เศรษฐกิจไม่ดีรัฐบาลก็ไม่มีเสถียรภาพ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. เสถียรภาพ. 6 มิถุนายน 2562. http://www.royin.go.th/dictionary/index.php",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ส"
  },
  {
    keyword: "เสถียรภาพระบบการเงิน",
    meaning:
      "ความมั่นคงของระบบการเงินเพื่อทำหน้าที่เป็นตัวกลางในการดำเนินกิจกรรมทางเศรษฐกิจได้อย่างมีประสิทธิภาพ ทั้งนี้ ระบบการเงินมีขอบเขตที่กว้างมาก ไม่ได้ครอบคลุมเพียงสถาบันการเงินในการเป็นตัวเชื่อมระหว่างผู้ออมและผู้ลงทุนเท่านั้น แต่รวมถึงระบบการชำระเงิน ตลาดเงิน ตลาดทุน ตลอดจนธุรกิจประกันภัย อันเป็นช่องทางในการบริหารความเสี่ยง ดังนั้น ระบบการเงินที่มีเสถียรภาพจึงมีความสำคัญ เพราะหากขาดเสถียรภาพอาจสามารถลุกลามเป็นวิกฤตการเงิน (financial crisis) ที่ส่งผลกระทบรุนแรงต่อเศรษฐกิจและความเป็นอยู่ของประชาชน ดังเช่น วิกฤตแฮมเบอร์เกอร์ในสหรัฐฯ เมื่อปี 2551 ที่ระบบการเงินขาดเสถียรภาพจากการมีอัตราดอกเบี้ยต่ำ กล่าวคือ สถาบันการเงินปล่อยสินเชื่อเพื่อที่อยู่อาศัยแก่ผู้กู้ที่มีความเสี่ยงสูง (ซับไพรม์) มากเกินไปในช่วงอัตราดอกเบี้ยต่ำ จนเกิดการผิดนัดชำระหนี้มากกว่าคาด ส่งผลลบต่อเศรษฐกิจสหรัฐฯ อย่างมาก และส่งผลต่อเนื่องไปยังเศรษฐกิจประเทศอื่น ๆ เป็นวงกว้างด้วย",
    source:
      "สุพริศร์ สุวรรณิก ฝ่ายเศรษฐกิจมหภาค ธนาคารแห่งประเทศไทย. ทำไมธนาคารกลางต้องรักษา “เสถียรภาพระบบการเงิน”?, 11 มิถุนายน 2562. https://www.bot.or.th/Thai/ResearchAndPublications/articles/Pages/Article_08Feb2019.aspx",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "เสรีนิยม",
    meaning:
      "อุดมการณ์หรือความคิดทางการเมืองที่มุ่งให้สิทธิเสรีภาพแก่ปัจเจกบุคคลอย่างเต็มที่ภายใต้ขอบเขตของกฎหมาย หลักการพื้นฐานของเสรีนิยม ได้แก่ สิทธิมนุษยชน โดยเฉพาะอย่างยิ่งสิทธิในชีวิต และทรัพย์สิน (right of life, property) ความเสมอภาคสำหรับทุกคนภายใต้กฎหมาย การปกครองโดยการเห็นชอบจากประชาชนโดยกระบวนการเลือกตั้ง ความโปร่งใสในการปกครองบ้านเมือง",
    source:
      "รศ.ดร.ปธาน สุวรรณมงคล. สถาบันพระปกเกล้า , 18 พฤศจิกายน 2562\r\nhttp://wiki.kpi.ac.th/index.php?title=%E0%B9%80%E0%B8%AA%E0%B8%A3%E0%B8%B5%E0%B8%99%E0%B8%B4%E0%B8%A2%E0%B8%A1",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ส"
  },
  {
    keyword: "เสรีภาคการเงิน",
    meaning:
      "กฎเกณฑ์การค้าบริการระหว่างประเทศมีความโปร่งใสชัดเจน ผู้ให้บริการด้านการเงินได้รับการปฏิบัติที่เท่าเทียมและเป็นธรรม และการผ่อนคลายกฎเกณฑ์ให้ผู้เล่นในตลาดสามารถทำธุรกิจได้เท่าเทียมกันมากขึ้น",
    source:
      "ธนาคารแห่งประเทศไทย. การเปิดเสรีการค้าบริการภาคการเงิน, 17 ตุลาคม 2562. https://www.bot.or.th/Thai/FinancialInstitutions/Highlights/ASEANCommunity/FIServices/Pages/default.aspx",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ส"
  },
  {
    keyword: "เสรีภาพ",
    meaning:
      "ความเป็นอิสระของคนเราที่จะทำ หรือ ไม่ทำอะไรก็ได้ การใช้เสรีภาพต้องอยู่ในขอบเขต เช่น เรามีเสรีภาพในการ แสดงความคิดเห็น ก็ต้องไม่พูดให้ร้ายคนอื่น หรือมีเสรีภาพในการประกอบ อาชีพ แต่ไปค้ายาเสพติด ก็ถือว่าทำผิดกฎหมาย",
    source:
      "สำนักงานคณะกรรมการการเลือกตั้ง. สาระน่ารู้เกี่ยวกับรัฐธรรมนูญ ชุด สิทธิ เสรีภาพ และหน้าที่ของปวงชนชาวไทย, 18 กันยายน 2562.\r\nhttps://www.ect.go.th/nakhonsawan/ewt_dl_link.php?nid=225",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ส"
  },
  {
    keyword: "เสรีภาพขั้นพื้นฐาน",
    meaning:
      "อำนาจตัดสินใจด้วยตนเองของมนุษย์ที่จะเลือกดำเนินพฤติกรรมของตนเอง โดยไม่มีบุคคลอื่นใดอ้างหรือใช้อำนาจแทรกแซงเกี่ยวข้องกับการตัดสินใจนั้น และเป็นการตัดสินใจด้วยตนเองที่จะกระทำหรือไม่กระทำการสิ่งหนึ่งสิ่งใดอันไม่เป็นการฝ่าฝืนต่อกฎหมาย",
    source:
      "นายสมชาต แสวงการ วิทยาลัยรัฐธรรมนูญ สำนักงานศาลรัฐธรรมนูญ. สิทธิเสรีภาพในการชุมนุมสาธารณะอย่างมีความรับผิดชอบตามกฎหมาย} 18 ธันวาคม 2562. http://www.constitutionalcourt.or.th/occ_web/ewt_dl_link.php?nid=1526",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ส"
  },
  {
    keyword: "เสียงข้างน้อย (การเมือง)",
    meaning:
      "เสียงข้างน้อยในการประชุมสภาผู้แทนราษฎร การประชุมวุฒิสภา การประชุมรัฐสภา และการประชุมคณะกรรมาธิการ ซึ่งการปกครองระบอบประชาธิปไตยเป็นรูปแบบการปกครองที่ยึดเอาเสียงข้างมากเป็นหลัก แต่อย่างไรก็ตามเสียงข้างน้อยก็ใช่ว่าจะถูกละเลยหรือถูกมองข้ามไป",
    source:
      "ศุภพรรัตน์ สุขพุ่ม และ รองเลขาธิการสภาผู้แทนราษฎร จเร พันธุ์เปรื่อง. เสียงข้างมาก เสียงข้างน้อย. 11 มิถุนายน 2562. http://wiki.kpi.ac.th/index.php?title=%E0%B9%80%E0%B8%AA%E0%B8%B5%E0%B8%A2%E0%B8%87%E0%B8%82%E0%B9%89%E0%B8%B2%E0%B8%87%E0%B8%A1%E0%B8%B2%E0%B8%81_%E0%B9%80%E0%B8%AA%E0%B8%B5%E0%B8%A2%E0%B8%87%E0%B8%82%E0%B9%89%E0%B8%B2%E0%B8%87%E0%B8%99%E0%B9%89%E0%B8%AD%E0%B8%A2",
    sappear: "",
    mappear: "",
    rappear: "1,4",
    firstalpha: "ส"
  },
  {
    keyword: "เอกเทศสัญญา",
    meaning: "สัญญาที่มีกฎหมายกำหนดชื่อและหลักเกณฑ์ไว้เป็นการเฉพาะ",
    source:
      "อ. ดร.เอมผกา เตชะอภัยคุณ คณะนิติศาสตร์ มหาวิทยาลัยธรรมศาสตร์. (2559). เอกเทศสัญญา 1 ครั้งที่ 1-3, 25 กันยายน 2562. http://blogs.law.tu.ac.th/students/wp-content/uploads/2016/03/%E0%B9%80%E0%B8%AD%E0%B8%81%E0%B9%80%E0%B8%97%E0%B8%A8%E0%B8%AA%E0%B8%B1%E0%B8%8D%E0%B8%8D%E0%B8%B2-1-%E0%B8%84%E0%B8%A3%E0%B8%B1%E0%B9%89%E0%B8%87%E0%B8%97%E0%B8%B5%E0%B9%88-1-6-update.pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "อ"
  },
  {
    keyword: "เอกภาพ",
    meaning: "ความเป็นอันหนึ่งอันเดียวกัน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. เอกภาพ. 6 มิถุนายน 2562. http://www.royin.go.th/dictionary/index.php",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "อ"
  },
  {
    keyword: "เอกลักษณ์",
    meaning:
      "การที่บุคคลมีการนึกคิดและให้ความหมายทางสังคมตามการประเมินค่าซึ่งกันและกันระหว่างบุคคลเกี่ยวกับบทบาทของตนเองตามตำแหน่งหรือ\r\nสถานภาพ เพื่อใช้ในการติดต่อสัมพันธ์กับผู้อื่นตามประเภทต่างๆ ของสังคมที่ทำให้บุคคลรับรู้ว่าตนเองมีความเหมือนและความแตกต่างจากผู้อื่น\r\nที่อยู่ในบทบาทและตำแหน่งเดียวกันหรือต่างกัน",
    source:
      "กรมปศุสัตว์. ยุทธศาสตร์กรมปศุสัตว์ หน้า 170. 18 กรกฎาคม 2562. http://www.dld.go.th/th/images/stories/about_us/organization_chart/2561/strategy2561_2565.pdf",
    sappear: "",
    mappear: "2,3,5",
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "เอกสารสิทธิ์",
    meaning:
      "เอกสารที่เป็นหลักฐานแห่งการก่อ เปลี่ยนแปลง โอน สงวนหรือระงับซึ่งสิทธิ",
    source:
      "ประมวลพระราชบัญญัติให้ใช้ประมวลกฎหมายอาญา พ.ศ.2499. (2499, 19 พฤศจิกายน). ราชกิจจานุเบกษา. เล่มที่ 73 ตอนที่ 95 หน้า 14.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2499/A/095/12.PDF",
    sappear: 4,
    mappear: "",
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "เอทานอล",
    meaning:
      "เอทานอลเป็นแอลกอฮอล์ชนิดหนึ่งซึ่งเกิดจากการหมักพืชเพื่อเปลี่ยนแป้งจากพืชเป็นน้ำตาลแล้ว\r\nเปลี่ยนจากน้ำตาลเป็นแอลกอฮอล์เมื่อทำให้เป็นแอลกอฮอล์บริสุทธิ์ 95% โดยการกลั่นจะเรียกว่า \r\nเอทานอล (Ethanol) เอทานอลที่นำไปผสมในน้ำมันเพื่อใช้เติมเครื่องยนต์เป็นแอลกอฮอล์ที่มี\r\nความบริสุทธิ์ตั้งแต่ 99.5% โดยปริมาตรซึ่งสามารถใช้เป็นเชื้อเพลิงได้\r\n",
    source:
      "กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน กระทรวงพลังงาน. เชื้อเพลิงเอทานอล, 29 สิงหาคม 2562. \r\nhttp://webkc.dede.go.th/testmax/sites/default/files/%E0%B9%80%E0%B8%8A%E0%B8%B7%E0%\r\nB9%89%E0%B8%AD%E0%B9%80%E0%B8%9E%E0%B8%A5%E0%B8%B4%E0%B8%87%20%E0%B9\r\n%80%E0%B8%AD%E0%B8%97%E0%B8%B2%E0%B8%99%E0%B8%AD%E0%B8%A5.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "อ"
  },
  {
    keyword: "เอทิลีน",
    meaning:
      "เอทิลีนเป็นฮอร์โมนพืชที่มีสถานะเป็นแก๊ส มีบทบาทต่อการเจริญเติบโตของพืชตั้งแต่เมล็ดงอกจนต้นพืชตาย โดยมีบทบาทที่สำคัญทั้งในการพัฒนาและการเสื่อมถอยของพืช เช่น การเกิดการตอบสนอง 3 แบบ (triple response) ในต้นกล้าของพืชใบเลี้ยงคู่ การกระตุ้นการเกิดรากฝอยและรากแขนง การควบคุมการสุกของผลไม้ รวมทั้งการหลุดร่วงของใบ ดอก และผล เนื้อเยื่อพืชทุกชนิดสามารถสังเคราะห์เอทิลีนได้\r\nโดยปกติพืชมีการสร้างเอทิลีนในปริมาณน้อย แต่เมื่อผลไม้สุกหรือมีการกระทบกระเทือนของผล เช่น การช้ำ หรือการเกิดบาดแผล รวมทั้งพืชที่เผชิญกับสภาวะเครียด เนื่องจากปัจจัยแวดล้อมที่ไม่เหมาะสม เช่น ดิน\r\nเค็ม อุณหภูมิที่สูงหรือต่ำเกินไป พืชจะมีการสร้างเอทิลีนเพิ่มขึ้น และเอทิลีนที่พืชสร้างขึ้นนี้สามารถไปกระตุ้นกระบวนการต่าง ๆ ที่ตอบสนองต่อเอทิลีนให้เกิดขึ้นอย่างรวดเร็ว เช่น การสุก การเปลี่ยนสีของเปลือกผล การหลุดร่วงของดอกและใบ และการตายของพืช",
    source:
      "ผู้ช่วยศาสตราจารย์ ดร.กนกวรรณ เสรีภาพ. (2555). คู่มือสื่อการสอนวิชาชีววิทยา เรื่อง เอทิลีน, 29 สิงหาคม 2562. \r\nhttp://www.phukhieo.ac.th/obec-media/2555/manual/%A4%D9%E8%C1%D7%CD%AA%D5%C7%\r\nC7%D4%B7%C2%D2/50_%E0%CD%B7%D4%C5%D5%B9.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "อ"
  },
  {
    keyword: "แนฟทา Naptha",
    meaning:
      "ผลิตภัณฑ์ที่ได้จากการกลั่นน้ำมันดิบ เป็นน้ำมันส่วนเบา อยู่ระหว่าง gasoline และ kerosene ใช้เป็นน้ำมันเบนซินที่ใช้กับเครื่องรถยนต์ หรือใช้เป็นวัตถุดิบในอุตสาห-กรรมปิโตรเคมี",
    source:
      "กรมเชื้อเพลิงธรรมชาติ กระทรวงพลังงาน. นิยามศัพท์, 29 สิงหาคม 2562. https://dmf.go.th/public/list/data/index/menu/670/page/10",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "น"
  },
  {
    keyword: "แนวคิด Marine Spatial Planning (MSP)",
    meaning:
      "แนวคิดการวางแผนเชิงพื้นที่ทางทะเล (Marine Spatial Planning: MSP)  เป็นการกำหนดแผนเชิงยุทธศาสตร์ในการใช้ทะเล ผนวกกับเครื่องมือในการบริหารจัดการอื่นๆ เช่น การจัดการทะเลและชายฝั่งอย่างบูรณาการ ถือเป็นกระบวนทัศน์ใหม่ด้านการบริหารจัดการที่จะนำไปสู่การพัฒนาอย่างยั่งยืน",
    source:
      "สภาขับเคลื่อนการปฏิรูปประเทศ. (2560). ข้อเสนอแนะเชิงนโยบายเรื่องการแบ่งเขตารใช้ประโยชน์และกำหนดพื้นที่คุ้มครองทางทะเล หน้า 13, 1 สิงหาคม 2562. https://www.parliament.go.th/ewtadmin/ewt/parliament_parcy/download/usergroup_disaster/8-13.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "น"
  },
  {
    keyword: "แนวคิดเมืองซับน้ำ",
    meaning:
      "การรับมือต่อการเปลี่ยนแปลงภูมิอากาศ และแก้ไขปัญหาน้ำท่วมและการระบายน้ำในเมืองใหญ่ทั่วประเทศ เนื่องจากการเติบโตของเมืองไม่สมดุลกับการพัฒนาระบบระบายน้ำของเมืองใหญ่ๆ ถ้ามีฝนตก 1-2 ชั่วโมงต่อเนื่อง ส่งผลให้เกิดปัญหาน้ำท่วมเป็นประจำ",
    source:
      "สำนักงานประชาสัมพันธ์กรุงเทพมหานคร. กทม. ร่วมประชุมแผนยุทธศาสตร์ชาติ เรื่องเมืองซับน้ำรับมือต่อการเปลี่ยนแปลงภูมิอากาศ, 23 พฤษภาคม 2562. http://www.prbangkok.com/th/board/view/MDY1cDBzNnM0NHIyb3Ezc3E2NnEyNDk0cDRyOTQzcjQwOTU0MQ==",
    sappear: 5,
    mappear: 19,
    rappear: "",
    firstalpha: "น"
  },
  {
    keyword: "แนวคิดของ Anti-Slapp Law",
    meaning:
      "การฟ้องคนหรือกลุ่มคนที่พูดหรือแสดงความคิดเห็นในประเด็นอันเป็นประโยชน์สาธารณะ โดยใช้กระบวนการทางศาลขัดขวางคำพูดหรือการกระทำของบุคคลเหล่านั้นไม่ให้ราบรื่น",
    source:
      "องค์กรต่อต้านคอร์รัปชัน (ประเทศไทย). Anti-SLAPP Law, 1 ตุลาคม 2562. http://www.anticorruption.in.th/2016/th/detail/152/5/Anti-SLAPP%20Law",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "น"
  },
  {
    keyword: "แนวคิดสุขภาพหนึ่งเดียว",
    meaning:
      "One Health เป็นวิธีการแก้ไขปัญหาสุขภาพแนวทางใหม่ที่รวมเอาแนวทางการปฏิบัติสุขภาพคน สุขภาพสัตว์และสุขภาพสิ่งแวดล้อมเข้าไว้ด้วยกัน เพื่อนำสู่การมีสุขภาพที่ดี โดยองค์รวม",
    source:
      "ปานเทพ รัตนากร. สุขภาพหนึ่งเดียว (One Health), 5 กรกฎาคม 2562. http://www.vs.mahidol.ac.th/th/index.php/component/k2/onehealth",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "น"
  },
  {
    keyword: "แนวนโยบายแห่งรัฐ",
    meaning:
      "เป็นบทบัญญัติที่กำหนดไว้ในรัฐธรรมนูญ โดยได้มีการบัญญัติไว้ครั้งแรกในรัฐธรรมนูญแห่งราชอาณาจักรไทย พุทธศักราช 2492 หมวดที่ 5 ว่าด้วย “แนวนโยบายแห่งรัฐ” เพื่อเป็นแนวทางสำหรับการตรากฎหมายและการกำหนดนโยบายในการบริหารราชการแผ่นดิน ทั้งนี้แนวนโยบายพื้นฐานแห่งรัฐ ถือเป็นกรอบสำหรับการกำหนดนโยบายของรัฐบาลว่านโยบายที่กำหนดออกมานั้นจะต้องครอบคลุมถึงเรื่องใด และจะเป็นหลักประกันว่า แม้จะมีการเปลี่ยนแปลงรัฐบาลไปกี่ชุด แนวนโยบายของรัฐบาลที่เข้ามาบริหารประเทศจะยังคงเดิม คือ อยู่ในกรอบแนวนโยบายพื้นฐานแห่งรัฐตามที่กำหนดไว้ในรัฐธรรมนูญ",
    source:
      "สถาบันพระปกเกล้า. แนวนโยบายพื้นฐานแห่งรัฐ, 12 มิถุนายน 2562. http://wiki.kpi.ac.th/index.php?title=%E0%B9%81%E0%B8%99%E0%B8%A7%E0%B8%99%E0%B9%82%E0%B8%A2%E0%B8%9A%E0%B8%B2%E0%B8%A2%E0%B8%9E%E0%B8%B7%E0%B9%89%E0%B8%99%E0%B8%90%E0%B8%B2%E0%B8%99%E0%B9%81%E0%B8%AB%E0%B9%88%E0%B8%87%E0%B8%A3%E0%B8%B1%E0%B8%90",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "น"
  },
  {
    keyword: "แนวปฏิบัติที่ดี (Best Practice)",
    meaning:
      "วิธีปฏิบัติ หรือขั้นตอนการปฏิบัติที่ทำให้องค์การประสบความสำเร็จหรือนำไปสู่ความเป็นเลิศตามเป้าหมาย เป็นที่ยอมรับในวงวิชาการหรือวิชาชีพนั้น ๆ และมีหลักฐานของความสำเร็จปรากฏชัดเจน โดยมีการสรุปวิธีปฏิบัติ หรือขั้นตอนการปฏิบัติ ตลอดจนความรู้และประสบการณ์ ที่ได้บันทึกเป็นเอกสาร และเผยแพร่ให้หน่วยงานภายในหรือภายนอกสามารถนำไปใช้ประโยชน์ได้",
    source:
      "ชนาธิป ลีนิน กองวิเทศสัมพันธ์และการประกันคุณภาพ มหาวิทยาลัยเทคโนโลยีราชมงคลศรีวิชัย. รู้จักแนวปฏิบัติที่ดี : Best Practice, 12 มิถุนายน 2562. http://ks.rmutsv.ac.th/th/bestpractice",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "น"
  },
  {
    keyword: "แนวปะการัง",
    meaning:
      "ระบบนิเวศทางทะเลที่มีความสำคัญยิ่งต่อมนุษย์ แนวปะการังเป็นแหล่งอนุบาล ที่หลบภัยของบรรดาสัตว์ทะเล ที่มีความสำคัญในทางเศรษฐกิจและเป็นแหล่งโปรตีนที่สำคัญของมนุษย์ อีกทั้งมีความสำคัญต่อการประมงในระดับพื้นบ้านและเชิงพาณิชย์",
    source:
      "กรมทรัพยากรทางทะเลและชายฝั่ง. การจัดสร้างปะการังเทียมในประเทศไทย หน้า 5. 12 มิถุนายน 2562. https://www.dmcr.go.th/download/?file=qTMcMUujpP5gZ3pmGQEgBJp0qQOcZKt3pQIgYKplGQWgZzpgqTIcoUucpTMgY3qyGTkgnJqzqP9cqUuxpP9gMUquGT9goTqjqUIcY3u0pT9go3qlGUqgq2q3qP9cBauQ&n=%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%88%E0%B8%B1%E0%B8%94%E0%B8%AA%E0%B8%A3%E0%B9%89%E0%B8%B2%E0%B8%87%E0%B8%9B%E0%B8%B0%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%B1%E0%B8%87%E0%B9%80%E0%B8%97%E0%B8%B5%E0%B8%A2%E0%B8%A1%E0%B9%83%E0%B8%99%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B9%80%E0%B8%97%E0%B8%A8%E0%B9%84%E0%B8%97%E0%B8%A2&t=GT5gq2qxqS9cMUug&type=rQR%3Q&up=rQR%3Q&id=qQWcZatl",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "น"
  },
  {
    keyword: "แบนด์วิดธ์ (bandwidth)",
    meaning:
      "ความกว้างของแถบคลื่นความถี่ แบนด์วิชท์เป็นคำที่ใช้วัดความเร็วในการส่งข้อมูลของอินเทอร์เน็ต ",
    source:
      "สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ (สวทช.) .แบนด์วิชท์ (Bandwidth), \r\n29 สิงหาคม 2562. https://www.nstda.or.th/th/nstda-knowledge/3020-bandwidth",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "บ"
  },
  {
    keyword: "แบบจำลองเศรษฐมิติ (Econometric Model)",
    meaning:
      "สาขาหนึ่งของเศรษฐศาสตร์โดยเน้นการใช้วิธีการทางสถิติและทฤษฎีเศรษฐศาสตร์มาใช้วิเคราะห์ข้อมูลทางสถิติ การประมาณค่าพารามิเตอร์ ความสัมพันธ์ของตัวแปรต่างๆ ศึกษาสมการแบบต่างๆ ปัญหาที่เกิดขึ้นในการใช้สมการแต่ละแบบ และการใช้เครื่องมือทางเศรษฐมิติมาสร้างแบบจำลองเศรษฐกิจมหภาค (macro economic model) เพื่อใช้ในการพยากรณ์แนวโน้มเศรษฐกิจ",
    source:
      "สำนักนโยบายการออมและการลงทุน, ศัพท์น่ารู้เกี่ยวกับเศรษฐกิจ, 3 กันยายน 2562. http://www2.fpo.go.th/S-I/Source/word/Word.php?Language=Thai&BeginRec=385&NumRecShow=8&sort=6&search=",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "บ"
  },
  {
    keyword: "แผงโซลาร์เซลล์",
    meaning:
      "เป็นสิ่งประดิษฐ์ที่สร้างขึ้นให้เป็นอุปกรณ์ที่สามารถเปลี่ยนพลังงานจากแสงอาทิตย์เป็นพลังงานไฟฟ้าถูกสร้างขึ้นครั้งแรกในปี ค.ศ. 1954 โดยแชปปิน (Chapin) ฟูลเลอร์ (Fuller) และเพียสัน (Pearson) ซึ่งได้ค้นพบเทคโนโลยีการสร้างรอยต่อ P-N ของผลึกซิลิคอนจนได้เซลล์แสงอาทิตย์ขึ้นมาเป็นครั้งแรกในโลกซึ่งมีประสิทธิ์ภาพเพียง 6% โดยในระยะเวลาเริ่มต้น ได้นำเซลล์แสงอาทิตย์ไปใช้งานในการผลิตพลังงานไฟฟ้าทางด้านอวกาศดาวเทียมระบบสื่อสารต่างๆจนในปัจจุบันมีการผลิตใช้งานอย่างแพร่หลายเนื่องจากความต้องการผลิตไฟฟ้าด้วยเทคโนโลยีสะอาดที่เพิ่มสูงขึ้นและการพัฒนาเทคโนโลยีส่งผลให้เซลล์แสงอาทิตย์มีราคาถูกลงและประสิทธิภาพสูงขึ้น",
    source:
      "กระทรวงพลังงาน. (2554). คู่มือการพัฒนาและการลงทุนผลิตพลังงานทดแทน, 30 กรกฎาคม 2562. https://energy.go.th/2015/wp-content/uploads/2016/02/2-solar.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ผ"
  },
  {
    keyword: "แผนแม่บทภายใต้ยุทธศาสตร์ชาติ",
    meaning: "แผนแม่บทเพื่อบรรลุเป้าหมายตามที่กำหนดไว้ในยุทธศาสตร์ชาติ",
    source:
      "พระราชบัญญัติการจัดทำยุทธศาสตร์ชาติ พ.ศ. 2560 (2560, 31 กรกฎาคม). ราชกิจจานุเบกษา. เล่มที่ 134 ตอนที่ 79 ก หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/A/079/1.PDF",
    sappear: "",
    mappear: "15,16,7",
    rappear: 2,
    firstalpha: "ผ"
  },
  {
    keyword: "แผนไทยเฟิร์ส",
    meaning:
      "พัฒนาสมุนไพรให้คนไทยรู้จัก เชื่อมั่น ชอบ และใช้ บริการการแพทย์แผนไทย การแพทย์พื้นบ้าน การแพทย์ทางเลือก และผลิตภัณฑ์สมุนไพรไทย\r\nโดยใช้กลไก 3 อาร์ เอ็นจิ้น (3R Engine) ได้แก่\r\n1.รีแบรนด์ดิ้ง (Re-Branding) โดยเร่งสร้างค่านิยม แผนไทยเฟิร์ส\r\n2.รีแอสชัวแรนส์ (Re-Assurance) บูรณาการการแพทย์แผนไทยร่วมกับคลินิกหมอครอบครัว พัฒนาคุณภาพมาตรฐานและขยายความครอบคลุมการจัดบริการ พัฒนาระบบการรับรองคุณภาพสมุนไพร ตลอดจนรับรองหมอพื้นบ้านหรือวิธีการรักษาทางการแพทย์พื้นบ้านที่ปลอดภัยกับประชาชน\r\n3.รีเสิร์ชแอนด์อินโนเวชั่น (Research & Innovation) พัฒนาและเชื่อมโยงระบบข้อมูลการวิจัย นวัตกรรมด้านการแพทย์แผนไทยฯและสมุนไพร เพื่อให้เกิดประโยชน์ในระบบสุขภาพ ส่งเสริมเศรษฐกิจอย่างครบวงจร รวมถึงสร้างสรรค์ต่อยอดภูมิปัญญาด้านนวัตกรรมและเทคโนโลยี",
    source:
      "กรมสุขภาพจิต. ข่าวจากหนังสือพิมพ์ที่เกี่ยวข้องกับสุขภาพจิต , 3 กันยายน 2562. https://www.dmh.go.th/news-dmh/view.asp?id=27458",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ผ"
  },
  {
    keyword: "แผนการดำเนินงานโจฮันเนสเบิร์ก",
    meaning:
      "กรอบแนวทางการปฏิบัติเพื่อให้บรรลุวัตถุประสงค์ในการดำเนินการตามแผนปฏิบัติการ 21 และข้อตกลงอื่น ๆ โดยอาศัยหลักการการพัฒนาอย่างบูรณาการด้านเศรษฐกิจ สังคม และสิ่งแวดล้อม และหลักการความรับผิดชอบร่วมกัน ทั้งนี้ การดำเนินการต้องได้รับความร่วมมือระหว่างภาครัฐและกลุ่มต่างๆ ในสังคม และการมีธรรมาภิบาลทั้งในระดับประเทศและระหว่างประเทศ",
    source:
      "สำนักความร่วมมือด้านทรัพยากรธรรมชาติและสิ่งแวดล้อมระหว่างประเทศ. ความรู้เบื้องต้นเกี่ยวกับการพัฒนาที่ยั่งยืน. 20 พฤศจิกายน 2562. \r\nhttp://www.harvardasia.co.th/wp-content/uploads/2016/09/pdffile.compressed.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ผ"
  },
  {
    keyword: "แผนงาน",
    meaning:
      "ระบบการประสานโครงการพัฒนาที่เกี่ยวข้องกันตั้งแต่สองโครงการขึ้นไป\r\nให้มีขั้นตอนการดำเนินงานที่สอดคล้องสัมพันธ์กันในอันที่จะบรรลุวัตถุประสงค์และเป้าหมายที่ต้องการ",
    source:
      "พระราชบัญญัติสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ พ.ศ. 2561 (2561, 25 ธันวาคม). ราชกิจจานุเบกษา. เล่มที่ 135 ตอนที่ 112 ก. หน้า 31, 24 กรกฎาคม 2562. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/112/T_0030.PDF",
    sappear: "",
    mappear: "",
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "แผนบริหารจัดการน้ำมันเชื้อเพลิง (Oil Plan)",
    meaning:
      "กำหนดทิศทางการบริหารจัดการด้านน้ำมันเชื้อเพลิงให้สอดคล้องกับเป้าหมายที่ระบุภายใต้แผนอื่นๆโดยเฉพาะแผนอนุรักษ์พลังงาน และแผนพัฒนาพลังงานทดแทนและพลังงานทางเลือก โดยมีเป้าหมายเพื่อใช้เป็นกรอบสำหรับการด เนินนโยบายและการจัดทำแผนด้านน้ำมันเชื้อเพลิงในอนาคต โดยคำนึงถึงสภาพแวดล้อมต่างๆ รวมถึงความเสี่ยงที่อาจเกิดขึ้นในอนาคตซึ่งอาจส่งผลกระทบทั้งทางตรงและทางอ้อมต่อการพัฒนาด้านพลังงานของประเทศ",
    source:
      "สำนักงานนโยบายและแผนพลังงาน (สนพ.) กระทรวงพลังงาน. (2559). แผนบริหารจัดการน้ำมันเชื้อเพลิง พ.ศ. 2558-2579 (Oil Plan 2015) 2, 4 ตุลาคม 2562. http://www.eppo.go.th/index.php/th/plan-policy/tieb/oilplan",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ผ"
  },
  {
    keyword:
      "แผนบูรณาการพลังงานระยะยาว (Thailand Integrated Energy Blueprint, TIEB)",
    meaning:
      "ประกอบด้วย 5 แผน ได้แก่\r\n1. แผนพัฒนากำลังผลิตไฟฟ้าของประเทศไทย\r\n2. แผนอนุรักษ์พลังงาน\r\n3. แผนพัฒนาพลังงานทดแทนและพลังงานทางเลือก\r\n4. แผนบริหารจัดการก๊าซธรรมชาติ\r\n5. แผนบริหารจัดการน้ำมันเชื้อเพลิง",
    source:
      "สำนักงานนโยบายและแผนพลังงาน (สนพ.) กระทรวงพลังงาน. (2559).  แผนบูรณาการพลังงานระยะยาว (TIEB), 1 ตุลาคม 2562. http://www.eppo.go.th/index.php/th/plan-policy/tieb",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ผ"
  },
  {
    keyword: "แผนปฎิบัติราชการ",
    meaning:
      "แผนที่ระบุสาระสำคัญเกี่ยวกับนโยบายปฏิบัติราชการของส่วนราชการ เป้าหมายและผลสัมฤทธิ์ของงาน รวมทั้งงบประมาณรายได้ รายจ่าย และทรัพยากรที่คาดการว่าต้องใช้ในช่วงระยะที่แผนของหน่วยงาน หรือส่วนราชการใดส่วนราชการหนึ่งกำหนดไว้ โดยแบ่งแผนฯเป็น 2 ประเภท ได้แก่ 1) แผนปฏิบัติราชการของส่วนราชการระยะ 5 ปี และ 2) แผนปฏิบัติราชการของส่วนราชการรายปี ซึ่งต้องสอดคล้องกับยุทธศาสตร์ชาติ แผนแม่บทฯ แผนการปฏิรูปประเทศ แผนพัฒนาฯ แผนความมั่นคง นโยบายของคณะรัฐมนตรีที่แถลงต่อรัฐสภา และอื่น ๆ",
    source:
      "พระราชกฤษฎีกาว่าด้วยหลักเกณฑ์และวิธีการบริหารกิจการบ้านเมืองที่ดี (ฉบับที่ 2) พ.ศ. 2562. (2562,30 เมษายน). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 56 ก. หน้า 254. http://www.ratchakitcha. soc.go.th/DATA/PDF/2562/A/056/T_0253.PDF",
    sappear: "",
    mappear: "",
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "แผนผังภูมินิเวศ",
    meaning:
      "ยุทธศาสตร์และกระบวนการการสร้างความสมดุล และการบูรณาการระหว่างการอนุรักษ์และการพัฒนาเป็นการพัฒนาที่มุ่งสู่ความยั่งยืน แผนผังภูมินิเวศตั้งอยู่บนฐานของ ระบบนิเวศและการมีส่วนร่วมของทุกภาคีมิใช่เพื่อผลประโยชน์ของกลุ่มใดกลุ่มหนึ่งหรือเพื่อผลประโยชน์ของคนรุ่นปัจจุบัน แต่เพื่อคุณภาพชีวิตและผลประโยชน์ของชนรุ่นหลังด้วย",
    source:
      "สมาคมสันนิบาตเทศบาลแห่งประเทศไทย.  โครงการแผนผังภูมินิเวศช่วยเมืองเปลี่ยนเพื่อเมืองน่าอยู่สู่โลกยั่งยืน, 23 พฤษภาคม 2562. https://www.nmt.or.th/files/com_km/2019-12/20191211_jcywxero.pdf",
    sappear: "2,5",
    mappear: 6,
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword:
      "แผนพัฒนากำลังผลิตไฟฟ้าของประเทศ (Power\r\n Development Plan: PDP)",
    meaning:
      "แผนแม่บทในการผลิตไฟฟ้าของประเทศ ว่าด้วยการจัดหาพลังงานไฟฟ้าในระยะยาว 15 -20 ปี เพื่อสร้างความมั่นคงและความเพียงพอของกำลังการผลิตไฟฟ้า โดยคำนึงนโยบาย พลังงานของประเทศและปัจจัยต่างๆ ทั้งด้านเศรษฐกิจ สังคม และสิ่งแวดล้อม อาทิ การเจริญเติบโตทางเศรษฐกิจ การกระจายการใช้เชื้อเพลิงในการผลิตไฟฟ้า กำลังผลิตไฟฟ้าสำรองที่เหมาะสม การเพิ่มประสิทธิภาพการใช้พลังงาน นโยบายการพัฒนาพลังงานหมุนเวียน ฯลฯ แผนพัฒนากำลังผลิตไฟฟ้าจะมีการทบทวนเป็นระยะๆ หรือทุก 1 - 2 ปี เพื่อพิจารณาปัจจัยต่างๆ ว่ามีการเปลี่ยนแปลงไปจากสมมุติฐานเดิมหรือไม่ เพื่อจัดทำฉบับใหม่หรือฉบับปรับปรุง",
    source:
      "การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย. (2561).  แผนพัฒนากำลังการผลิตไฟฟ้า (Power Development Plan : PDP), 1 ตุลาคม 2562. http://www.egat.co.th/index.php?option=com_content&view=article&id=325&Itemid=207",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ผ"
  },
  {
    keyword:
      "แผนพัฒนาพลังงานทดแทนและพลังงานทางเลือก พ.ศ. 2558-2579 (Alternative Energy Development Plan : AEDP 2015)",
    meaning:
      "การให้ความสำคัญในการส่งเสริมการผลิตพลังงานจากวัตถุดิบพลังงานทดแทนที่มีอยู่ภายในประเทศให้ได้เต็มตามศักยภาพ การพัฒนาศักยภาพการผลิตพลังงานทดแทนด้วยเทคโนโลยีที่มีความเหมาะสม และการพัฒนาพลังงานทดแทนเพื่อผลประโยชน์ร่วมในมิติด้านสังคมและสิ่งแวดล้อมแก่ชุมชน",
    source:
      "กระทรวงพลังงาน. (2558).  แผนพัฒนาพลังงานทดแทนและพลังงานทางเลือก พ.ศ. 2558 – 2579 (Alternative Energy Development Plan: AEDP2015), 1 ตุลาคม 2562. http://www.dede.go.th/download/files/AEDP2015_Final_version.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ผ"
  },
  {
    keyword: "แผนอนุรักษ์พลังงาน (Energy Efficiency Plan: EEP)",
    meaning:
      "สาระสำคัญของการจัดทำแผน ในช่วงระยะสั้นถึงปานกลางมีการพยากรณ์ว่าราคาน้ำมันในตลาดโลกน่าจะอยู่ในระดับที่ต่ำกว่า 50 เหรียญสหรัฐต่อบาร์เรล ดังนั้นกระทรวงพลังงาน จึงเห็นว่าเป็นโอกาสเหมาะที่จะยกระดับความเข้มข้นของการขับเคลื่อนแผนอนุรักษ์พลังงาน จึงมีความจำเป็นที่จะต้องปรับปรุงแผนเดิมให้มีความเหมาะสมมากยิ่งขึ้น",
    source:
      "สำนักงานนโยบายและแผนพลังงาน (สนพ.) กระทรวงพลังงาน. แผนอนุรักษ์พลังงาน (EEP), 8 กรกฎาคม 2562. http://www.eppo.go.th/index.php/th/plan-policy/tieb/eep",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ผ"
  },
  {
    keyword: "แพทย์เวชศาสตร์ครอบครัว",
    meaning:
      "แพทย์ที่ได้รับหนังสืออนุมัติหรือวุฒิบัตรเพื่อแสดงความรู้ความชำนาญในการประกอบวิชาชีพเวชกรรมสาขาเวชศาสตร์ครอบครัว",
    source:
      "พระราชบัญญัติระบบสุขภาพปฐม พ.ศ. 2562. (2562, 30 เมษายน). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 56 ก หน้า 166. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/056/T_0165.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "พ"
  },
  {
    keyword: "แพลตฟอร์ม\r\n",
    meaning:
      "ระบบโปรแกรมคอมพิวเตอร์ที่สามารถขยายขีดความสามารถอย่างไม่จำกัด มีการพัฒนาฟังก์ชั่นหรือโมดุลใหม่ๆมาต่อยอดอยู่ตลอดเวลา เกิดนวัตกรรมใหม่ ๆเสมอ และสามารถนำไปต่อเชื่อมกับระบบอื่นได้ แพลตฟอร์มไม่ได้จำกัดอยู่แค่่ซอฟต์แวร์แต่ยังรวมไปถึงเว็บไซต์ หรือบริการอื่นที่คนอื่นสามารถเขียนโปรแกรมมาต่อเชื่อมหรือดึงข้อมูลได้โดยอัตโนมัติ",
    source:
      "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม. (2562). นโยบายและแผนระดับชาติว่าด้วยการพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม, 23 กรกฎาคม 2562. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/047/T_0001.PDF",
    sappear: "",
    mappear: 8,
    rappear: "2,5",
    firstalpha: "พ"
  },
  {
    keyword: "แรงงานไร้ฝีมือ",
    meaning: "แรงงานที่มีการศึกษาระดับมัธยมศึกษาตอนต้นและต่ํากว่า",
    source:
      "ดร. เสาวณี จันทะพงษ์ สวนเศรษฐกิจภาค สภอ. ธนาคารแหงประเทศไทย. (2555). การขาดแคลนแรงงานไทย: สภาพปัญหา สาเหตุและแนวทางแก้ไข, 10 มิถุนายน 2562. https://www.bot.or.th/Thai/MonetaryPolicy/ArticleAndResearch/DocumentEconomicSeminar/LabourShortage.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ร"
  },
  {
    keyword: "แรงงานกลุ่มเปราะบาง",
    meaning:
      "กลุ่มเปราะบาง\r\n- ผู้ที่มีความจำเป็นต้องพึ่งพิงผู้อื่น ไม่สามารถแสดงความคิดเห็น อย่างเป็นอิสระ หรือตัดสินใจด้วยตนเอง\r\n- เป็นกลุ่มที่ถูกเอารัดเอาเปรียบได้ง่าย\r\n- ผู้ที่พักรักษาตัวในโรงพยาบาล เด็กทารก ผู้ที่มีความพิการทางสมอง ผู้ป่วยวิกฤต ผู้ป่วยทางจิต หญิงตั้งครรภ์ ผู้ด้อยโอกาส\r\n- นักโทษ ทหารเกณฑ์ แรงงานต่างด้าว",
    source:
      "ผศ.ดร.จรวยพร ศรีศศลักษณ์ สถาบันการพัฒนาการคุ้มครองการวิจัยในมนุษย์ สถาบันวิจัยระบบสาธารณสุข. (2556). กลุ่มเปราะบาง (Vulnerable Groups) คือใครมีข้อพิจารณาด้านจริยธรรมอย่างไร, 24 ธันวาคม 2562. https://kb.hsri.or.th/dspace/bitstream/handle/11228/3717/jaruayporn.pdf?sequence=2&isAllowed=y",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "แรงงานนอกระบบ",
    meaning:
      "แรงงานที่ทำงานอิสระไม่มีการจ้างงานอย่างเป็นทางการ ไม่มีค่าจ้าง ค่าตอบแทนที่แน่นอน ไม่ได้อยู่ในกรอบความคุ้มครองของกฎหมายคุ้มครองแรงงาน หรือเป็นแรงงานที่ไม่ได้รับความคุ้มครองในระบบประกันสังคม ได้แก่ แรงงานที่ทำงานไม่เต็มเวลา (Part-Time Worker) แรงงานที่รับงานไปทำที่บ้าน (Home-Base Worker) แรงงานที่ทำงานแบบเหมาช่วง (Sub-Contract Worker)\r\n และแรงงานที่ทำงานระยะสั้น (Short-Time Worker)",
    source:
      "ศูนย์ประสานงานแรงงานนอกระบบ. (2555). ความหมายของแรงงานนอกระบบ, 11 มิถุนายน 2562. http://isw-thai.blogspot.com/2012/10/blog-post_1.html",
    sappear: "",
    mappear: 17,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "แหล่งกำเนิดมลพิษ",
    meaning:
      "โรงงานอุตสาหกรรม อาคาร สิ่งก่อสร้าง ยานพาหนะและสถานที่ประกอบกิจการใด ๆ ซึ่งเป็นแหล่งที่มาของมลพิษ",
    source:
      "พระราชบัญญัติควบคุมโรคจากการประกอบอาชีพและโรคจากสิ่งแวดล้อม พ.ศ. 2562. (2562, 22 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 67 ก หน้า 217. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/067/T_0215.PDF",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ห"
  },
  {
    keyword: "แอ่งน้ำบาดาล",
    meaning: "น้ำใต้ผิวดินทั้งหมดอยู่ใต้ระดับเขตอิ่มน้ำ ",
    source:
      "ทีมวิชาการธรณีไทย. (2551). น้ำบาดาลและการพัฒนาที่ยั่งยืน, 5 กรกฎาคม 2562. http://www.geothai.net/hydrogeology/",
    sappear: 5,
    mappear: 19,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "แฮกแตร์",
    meaning:
      "หน่วยมาตราวัดพื้นที่ 1 เฮกตาร์เท่ากับ 10,000 ตารางเมตร หรือประมาณ 6 ไร่ 1 งาน",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2553). มาตรา, 4 ตุลาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%A1%E0%B8%B2%E0%B8%95%E0%B8%A3%E0%B8%B2-%E0%B9%92-%E0%B8%9E%E0%B8%A4%E0%B8%A8%E0%B8%88%E0%B8%B4%E0%B8%81%E0%B8%B2%E0%B8%A2%E0%B8%99-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%93",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ฮ"
  },
  {
    keyword: "โครงการ CSR",
    meaning:
      "แนวคิดขององค์การในการดําเนินกิจกรรม การวางแผน การตัดสินใจ การสื่อสารประชาสัมพันธ์ การบริหารจัดการ และการดําเนินการที่คํานึงถึงผลกระทบต่อสังคมและสิ่งแวดล้อม โดยอาจสอดแทรกเรื่องนี้ไว้ในกระบวนการประกอบธุรกิจ เช่น กระบวนการผลิตหรือการบริการ การดูแลบุคลากรในองค์การและครอบครัว รวมไปถึงการดูแลชุมชนและสังคมโดยรอบ นอกจากนี้ CSR ในหลายองค์การอาจเป็นการตั้งเงื่อนไขให้กับผู้มีส่วนได้เสียอันหมายถึง ลูกค้า คู่ค้า ผู้ลงทุน รัฐบาล และองค์การพัฒนาชุมชนรวมกันดูแลรับผิดชอบสังคมด้วย",
    source:
      "กลุ่มพัฒนาระบบบริหาร สำนักงานคณะกรรมการพัฒนาระบบราชการ. ความรับผิดชอบต่อสังคม CSR:Corporate Social Responsibility. ก.พลพิมพ์(1996) จำกัด, 11 มิถุนายน 2562. http://www.dla.go.th/work/kpinow/7ebook/pdf/2554/CSR.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ค"
  },
  {
    keyword: "โครงการ zero waste",
    meaning:
      "แนวคิดสำหรับของเสียเหลือศูนย์หรือ Zero waste เป็นปรัชญาที่ส่งเสริมการหมุนเวียนทรัพยากรให้กลับมาใช้ใหม่เพื่อเป็นการใช้ทรัพยากรอย่างมีประสิทธิภาพสูงสุด และเป็นการลดปริมาณของเสียที่เกิดขึ้นให้เหลือน้อยลง อีกทั้งเพื่อลดปัญหามลพิษต่างๆจากการกำจัดของเสียโดยวิธีการฝังกลบและ/หรือเตาเผาอีกด้วย เพราะในปัจจุบันมีข้อจำกัดด้านพื้นที่สำหรับกำจัดของเสียและวิธีการควบคุมมลพิษด้านกลิ่นและไอระเหยที่ต้องมีค่าใช้จ่ายการลงทุนที่ค่อนข้างสูง และเกิดผลกระทบต่อสิ่งแวดล้อมตามมาอย่างมหาศาล",
    source:
      "สมาคมพัฒนาคุณภาพสิ่งแวดล้อม. ZERO WASTE ขยะเหลือศูนย์ เป็นจริงได้ไม่ใช่แค่ฝัน, 12 มิถุนายน 2562. http://adeq.or.th/zero-waste-%E0%B9%80%E0%B8%9B%E0%B9%87%E0%B8%99%E0%B8%88%E0%B8%A3%E0%B8%B4%E0%B8%87%E0%B9%84%E0%B8%94%E0%B9%89/",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ค"
  },
  {
    keyword: "โครงการเกษตรทฤษฎีใหม่",
    meaning:
      "ระบบเกษตรที่เน้นการจัดการแหล่งน้ำ และการจัดสรรแบ่งส่วนพื้นที่ทำการเกษตรอย่างเหมาะสม ซึ่งจะทำให้เกษตรกรมีข้าวปลาอาหารไว้บริโภคอย่างพอเพียงตาม อัตตภาพ อันจะเป็นการแก้ปัญหาในเรื่องชีวิตความเป็นอยู่ของเกษตรกรแล้ว ยังก่อให้เกิดความมั่นคงทางเศรษฐกิจโดยรวมของประเทศ",
    source:
      "มูลนิธิเกษตรกรรมยั่งยืน. เกษตรทฤษฎีใหม่ (New Theory farming), 12 มิถุนายน 2562. http://www.sathai.org/autopagev4/show_page.php?topic_id=685&auto_id=15&TopicPk=",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ค"
  },
  {
    keyword: "โครงการในพระราชดำริ",
    meaning:
      "โครงการที่ก่อตั้งขึ้นภายใต้พระราชดําริของพระบาทสมเด็จพระปรมินทรมหาภูมิพลอดุลยเดชฯ บรมนารถบพิตร หรือ ในหลวงรัชกาลที่ 9 เพื่อมุ่งเน้นการช่วยเหลือ แก้ปัญหาความเดือดร้อนของราษฎร และพัฒนาความเป็นอยู่ของราษฎรให้เกิดความพออยู่ พอกิน  ในการทำมาหากิน ทั้งยังช่วยยกระดับคุณภาพชีวิตของประชาชนเพิ่มขึ้น ",
    source:
      "มูลนิธิชัยพัฒนา. โครงการพระราชดำริ, 12 มิถุนายน 2562. https://www.chaipat.or.th/royal-projects-in-various-regions/south/category/902-1.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ค"
  },
  {
    keyword: "โครงข่ายคมนาคม",
    meaning: "การติดต่อไปมาถึงกัน, การสื่อสาร",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. คมนาคม, 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "โครงข่ายบรอดแบนด์",
    meaning:
      "เทคโนโลยีการสื่อสารผ่านเครือข่ายอินเทอร์เน็ตความเร็วสูงที่สามารถรับส่งข้อมูลจำนวนมากผ่านสื่อใช้สายและไร้สาย กรณีสื่อใช้สาย เช่น เคเบิลใยแก้วนำแสง สายเคเบิลทีวี สายโทรศัพท์ (DSL) หรือสื่อไร้สายอย่าง 3G 4G โดยความเร็วของการรับส่งข้อมูลอย่างน้อยที่สุดจะอยู่ที่ 256 kbps ไปจนถึงมากที่สุดถึง 100 ล้าน bps ขึ้นไป",
    source:
      "ณกฤช เศวตนันทน์. บรอดแบนด์สู่ชุมชน, 10 กรกฎาคม 2562. http://lawyer-thailand.com/%E0%B8%9A%E0%B8%A3%E0%B8%AD%E0%B8%94%E0%B9%81%E0%B8%9A%E0%B8%99%E0%B8%94%E0%B9%8C%E0%B8%AA%E0%B8%B9%E0%B9%88%E0%B8%8A%E0%B8%B8%E0%B8%A1%E0%B8%8A%E0%B8%99/",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "โครงข่ายบรอดแบรนด์ความเร็วสูง",
    meaning:
      "โครงข่ายการสื่อสารข้อมูลผ่านเครือข่ายอินเทอร์เน็ตความเร็วสูง ที่สามารถรับส่งข้อมูลจำนวนมากด้วยเทคโนโลยีการสื่อสารที่ไม่จำกัดรูปแบบทั้งที่เป็นสื่อใช้สาย หรือสื่อไร้สาย",
    source:
      "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม. (2562). นโยบายและแผนระดับชาติว่าด้วยการพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม, 23 กรกฎาคม 2562. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/047/T_0001.PDF",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "โครงสร้างทางเศรษฐกิจ",
    meaning:
      "ส่วนประกอบที่สำคัญทางเศรษฐกิจ แบบได้ 3 ส่วน ดังนี้\r\n 1.โครงสร้างการผลิต คือ การผลิตสินค้าและบริการจำแนกตามโครงสร้างการผลิตโดยใช้บัญชีผลิตภัณฑ์ในประเทศเบื้องต้น\r\n 2.โครงสร้างตลาดสินค้าและบริการ แบ่งได้ 2 ตลาด คือ ตลาดภายในประเทศ และตลาดภายนอกประเทศ\r\n 3.โครงสร้างของปัจจัยการผลิตและการจำแนกแจกจ่ายผลผลิต",
    source:
      "สุดารัตน์ พิมลรัตนกานต์. โครงสร้างเศรษฐกิจ ปัญหาเศรษฐกิจของประเทศไทยและแนวทางแก้ไข, 10 กรกฎาคม 2562. http://pakpian.blogspot.com/p/15.html",
    sappear: 2,
    mappear: 4,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "โครงสร้างประชากร",
    meaning:
      "โครงสร้างของประชากรมนุษย์ (population structure) นิยมแสดงด้วยพีระมิดประชากร (population pyramid) ซึ่งเป็นแผนภาพประกอบด้วยกราฟแท่งแสดงอายุของประชากรในแต่ละช่วงวัยต่างๆ กัน  โดยสามารถแบ่งช่วงอายุประชากรออกได้เป็น 3 ช่วงด้วยกันคือ ช่วงวัยก่อนเจริญพันธุ์ มีอายุตั้งแต่แรกเกิด-14 ปี ช่วงวัยเจริญพันธุ์ มีอายุตั้งแต่ 15-44 ปี และช่วงวัยหลังเจริญพันธุ์ มีอายุตั้งแต่ 45 ปีขึ้นไป  ซึ่งกราฟแต่ละแท่งจะแสดงจำนวนร้อยละของประชากรทั้งหมดในช่วง 5 ปี เช่น 0-4 ปี 5-9 ปี และ 10-14 ปี เป็นต้น นอกจากนี้ กราฟแท่งที่แสดงนี้จะแยกประชากรเพศชายและเพศหญิงออกจากกันคนละด้านในแผนภาพเดียวกัน พีระมิดประชากรมนุษย์สามารถเขียนแสดงในรูปแบบต่างๆ ได้ 4 รูปแบบ ได้แก่ พีระมิดแบบขยายตัว พีระมิดแบบคงที่  พีระมิดแบบเสถียร  และพีระมิดแบบหดตัว",
    source:
      "สถาบันส่งเสริมการสอนวิทยาศาสตร์และเทคโนโลยี, โครงสร้างประชากรไทยกับแนวโน้มการเปลี่ยนแปลงในอนาคต, 3 ธันวาคม 2553.\r\nhttp://biology.ipst.ac.th/%E0%B9%82%E0%B8%84%E0%B8%A3%E0%B8%87%E0%B8%AA%E0%B8%A3%E0%B9%89%E0%B8%B2%E0%B8%87%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%8A%E0%B8%B2%E0%B8%81%E0%B8%A3%E0%B9%84%E0%B8%97%E0%B8%A2%E0%B8%81%E0%B8%B1%E0%B8%9A/",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "โครงสร้างพื้นฐาน",
    meaning:
      "ระบบหรือโครงสร้างทางกายภาพที่จำเป็นต่อชุมชน เพื่อใช้งานหรืออำนวยความสะดวก หรือบริการที่จำเป็นเพื่อขับเคลื่อนเศรษฐกิจตามรูปแบบทางเศรษฐศาสตร์ เช่น ระบบคมนาคม ระบบพลังงาน ระบบจัดการน้ำ และระบบสื่อสาร เป็นต้น",
    source:
      "Modify Technology News. (2560). โครงสร้างพื้นฐาน คืออะไร, 17 มิถุนายน 2562. https://www.modify.in.th/17591",
    sappear: 5,
    mappear: "2,18",
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "โครงสร้างพื้นฐานด้านดิจิทัล",
    meaning:
      "โครงสร้างพื้นฐานด้านเทคโนโลยีสารสนเทศ (IT) โทรคมนาคม (Telecommunication) และการแพร่ภาพกระจายเสียง (Broadcast) รวมทั้งการหลอมรวมของเทคโนโลยี (Convergence) ทั้ง 3 ด้านที่เป็นนวัตกรรมใหม่ในการพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม",
    source:
      "Boonlert Aroonpiboon. (2558). นโยบายดิจิทัลเพื่อเศรษฐกิจและสังคม (Digital Economy), 9 กรกฎาคม 2562. http://www.thailibrary.in.th/2015/03/15/digital-economy/",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "โครงสร้างพื้นฐานสำคัญทางสารสนเทศ",
    meaning:
      "คอมพิวเตอร์หรือระบบคอมพิวเตอร์ ซึ่งหน่วยงานของรัฐหรือหน่วยงานเอกชนใช้ในกิจการของตนที่เกี่ยวข้องกับการรักษาความมั่นคงปลอดภัย\r\nของรัฐ ความปลอดภัยสาธารณะ ความมั่นคงทางเศรษฐกิจของประเทศ หรือโครงสร้างพื้นฐานอันเป็นประโยชน์สาธารณะ ",
    source:
      "พระราชบัญญัติการรักษาความมั่นคงปลอดภัยไซเบอร์ พ.ศ. 2562. (2562, พฤษภาคม 2562). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 69 ก หน้า 22. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/069/T_0020.PDF",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "โครงสร้างระบบ ICT",
    meaning:
      "เทคโนโลยีสารสนเทศและการสื่อสาร Information and Communication Technology (ICT) เป็นเครื่องมือที่มีความสําคัญอย่างยิ่งต่อการขับเคลื่อนเศรษฐกิจดิจิทัลหรืออาจเรียกได้ว่าเป็นเทคโนโลยีดิจิทัล ทั้งด้านอุปกรณ์และระบบเครือข่ายต่างๆ หากประชากรและภาคธุรกิจของประเทศสามารถเข้าถึงและใช้ประโยชน์จากเทคโนโลยีสารสนเทศได้เท่าไหร่ยิ่งแสดงให้เห็นว่าประเทศนั้นๆ มีความพร้อมในการพัฒนาเศรษฐกิจดิจิทัลอันเป็นพื้นฐานสําคัญต่อความสามารถในการแข่งขันของประเทศในโลกยุคใหม",
    source:
      "สํานักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติปฏิบัติราชการกลุ่มงานเศรษฐกิจดิจิทัล กระทรวงเทคโนโลยีสารสนเทศและการสื่อสาร. (2558). เอกสารประกอบการประชุมผู้บริหารเทคโนโลยีสารสนเทศระดับสูงภาครัฐ, 10 กันยายน 2562. http://www.mdes.go.th/assets/portals/1/files/download/2558_04_08%202%E0%B9%80%E0%B8%AD%E0%B8%81%E0%B8%AA%E0%B8%B2%E0%B8%A3%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%9E%E0%B8%B1%E0%B8%92%E0%B8%99%E0%B8%B2%E0%B9%80%E0%B8%A8%E0%B8%A3%E0%B8%A9%E0%B8%90%E0%B8%81%E0%B8%B4%E0%B8%88%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%AA%E0%B8%B1%E0%B8%87%E0%B8%84%E0%B8%A1%E0%B8%94%E0%B8%B4%E0%B8%88%E0%B8%B4%E0%B8%97%E0%B8%B1%E0%B8%A5.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ค"
  },
  {
    keyword: "โฆษณา",
    meaning:
      "ความถึงกระทำการไม่ว่าโดยวิธีใด ๆ ให้ประชาชนเห็นหรือทราบข้อความเพื่อประโยชน์ในทางการค้า\r\n",
    source:
      "พระราชบัญญัติคุ้มครองผู้บริโภค พ.ศ. 2522. (2522, 4 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 96 ตอนที่ 72 ก หน้า 22 .http://www.ratchakitcha.soc.go.th/DATA/PDF/2522/A/072/20.PDF",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ฆ"
  },
  {
    keyword: "โจทก์",
    meaning:
      "บุคคลธรรมดาหรือนิติบุคคล ผู้ที่มีสภาพบุคคลมีสิทธิและหน้าที่ตามกฎหมาย ส่วนสิ่งที่ไม่มีสภาพเป็นนิติบุคคลเช่น รัฐบาลกลุ่มหรือคณะบุคคลกองมรดก หน่วยราชการที่มีฐานะเป็นกอง สำนักสงฆ์สุเหร่า อำเภอ ชมรม เป็นต้น ไม่มีกฎหมายบัญญัติรับรองให้มีสถานะเป็นนิติบุคคล ดังนั้น จึงไม่อาจเป็นโจทก์ฟ้องได้",
    source:
      "สำนักงานศาลยุติธรรม กองสารนิเทศและประชาสัมพันธ์. คู่มือการติดต่อราชการศาลยุติธรรมฉบับประชาชน. หน้า 39-40. https://www.coj.go.th/th/file/get/file/20190218d41d8cd98f00b204e9800998ecf8427e004459.pdf ",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "จ"
  },
  {
    keyword: "โซล่าเซลล์",
    meaning:
      "เป็นสิ่งประดิษฐ์กรรมทางอิเลคทรอนิกส์ ที่สร้างขึ้นเพื่อเป็นอุปกรณ์สำหรับเปลี่ยนพลังงานแสงอาทิตย์ให้เป็นพลังงานไฟฟ้า โดยการนำสารกึ่งตัวนำ เช่น ซิลิกอน ซึ่งมีราคาถูกที่สุดและมีมากที่สุดบนพื้นโลกมาผ่านกระบวนการทางวิทยาศาสตร์เพื่อผลิตให้เป็นแผ่นบางบริสุทธิ์ และทันทีที่แสงตกกระทบบนแผ่นเซลล์ รังสีของแสงที่มีอนุภาคของพลังงานประกอบที่เรียกว่า โฟตอน (Proton) จะถ่ายเทพลังงานให้กับอิเล็กตรอน (Electron) ในสารกึ่งตัวนำจนมีพลังงานมากพอที่จะกระโดดออกมาจากแรงดึงดูดของอะตอม (atom) และเคลื่อนที่ได้อย่างอิสระ ดังนั้นเมื่ออิเล็กตรอนเคลื่อนที่ครบวงจรจะทำให้เกิดไฟฟ้ากระแสตรงขึ้น เมื่อพิจารณาลักษณะการผลิตไฟฟ้าจากเซลล์แสงอาทิตย์พบว่า เซลล์แสงอาทิตย์จะมีประสิทธิภาพการผลิตไฟฟ้าสูงที่สุดในช่วงเวลากลางวัน ซึ่งสอดคล้องและเหมาะสมในการนำเซลล์แสงอาทิตย์มาใช้ผลิตไฟฟ้า เพื่อแก้ไขปัญหาการขาดแคลนพลังงานไฟฟ้าในช่วงเวลากลางวัน",
    source:
      "การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย. เซลล์แสงอาทิตย์ (Solar Cell). 13 มิถุนายน 2562. http://www4.egat.co.th/re/solarcell/solarcell.htm",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ซ"
  },
  {
    keyword: "โซลาร์ฟาร์ม",
    meaning:
      "ระบบโซล่าฟาร์ม SOLAR FARM system หรือที่เรียกว่า โรงงานผลิตไฟฟ้าจากแสงอาทิตย์ Photovoltaic power station เป็นระบบเซลล์แสงอาทิตย์ขนาดใหญ่ (PV) ที่ออกแบบมาสำหรับการผลิตพลังงานไฟฟ้าจำนวนมากๆ ระดับเมกะวัตต์ MW อุตสาหกรรมพลังงานทั่วโลกกำลังให้ความสนใจและมี แนวโน้มขยายตัวอย่างต่อเนื่อง เนื่องจากเป็นพลังงานสะอาดที่ใช้ไม่มีวันหมดและเป็นการผลิตที่มีมลพิษต่อสิ่งแวดล้อมต่ำ และเป็นพลังงานทางเลือกที่ใช้ทดแทนพลังงานจากฟอสซิลอย่างนํ้ามันและก๊าซ ธรรมชาติ และถ่านหินซึ่งนับวันจะร่อยหรอหมดไป\r\n ที่ตั้งของประเทศไทยอยู่ในเขตศูนย์เส้นสูตร ทำให้มีช่วงเวลาในการรับแสงอาทิตย์ตลอดทั้งปีอย่างมากมาย โดยพื้นที่ส่วนใหญ่ได้รับแสงอาทิตย์เฉลี่ยวันละประมาณ 5 กิโลวัตต์-ชั่วโมงต่อตารางเมตร ซึ่งสูงกว่าประเทศทางแถบยุโรปที่มีค่าเฉลี่ยเพียงวันละ 3-4 กิโลวัตต์ต่อชั่วโมงต่อตารางเมตร จึงเป็นพื้นที่ที่มีศักยภาพสูงสำหรับธุรกิจโซลาร์ฟาร์มเป็นอย่างมาก",
    source:
      "บริษัท นิกซ์ เคเบิ้ล จำกัด. จับตา โซล่าฟาร์ม ดีจริงหรือไม่? ต่ออนาคตพลังงานทดแทนไทย, 13 มิถุนายน 2562. https://www.nyxcable.com/%E0%B8%88%E0%B8%B1%E0%B8%9A%E0%B8%95%E0%B8%B2-%E0%B9%82%E0%B8%8B%E0%B8%A5%E0%B9%88%E0%B8%B2%E0%B8%9F%E0%B8%B2%E0%B8%A3%E0%B9%8C%E0%B8%A1-%E0%B8%94%E0%B8%B5%E0%B8%88%E0%B8%A3%E0%B8%B4%E0%B8%87%E0%B8%AB/",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ซ"
  },
  {
    keyword: "โซลาร์รูฟ",
    meaning:
      "โซลาร์ รูฟ (Solar Roof) คือระบบเปลี่ยนพลังงานแสงอาทิตย์มาเป็นพลังงานไฟฟ้าบนหลังคา โดยใช้แผงเซลล์แสงอาทิตย์ (Solar Module) ที่ติดตั้งบนหลังคาที่พักอาศัยหรืออาคารต่าง ๆ รับพลังงานแสงเข้ามาเปลี่ยนเป็นไฟฟ้ากระแสตรง ก่อนส่งไปยังเครื่องแปลงไฟ (Inverter) เพื่อเปลี่ยนจากไฟฟ้ากระแสตรงเป็นไฟฟ้ากระแสสลับ แล้วนำพลังงานไฟฟ้าที่ได้ไปใช้งานต่อไป โดยจะใช้เองภายในครัวเรือนหรือนำไปจำหน่ายให้กับภาครัฐก็ได้ ซึ่งสามารถติดตั้งได้กับหลังคา ทุกประเภท ได้แก่ หลังคากระเบื้องซีแพคโมเนีย หลังคาลอนคู่ หลังคาคอนกรีต หลังคาเมทัลชีท และหลังคากระเบื้องแบบเรียบ ยกเว้นหลังคาที่ใช้โครงไม้ หลังคาสังกะสี และหลังคาที่มีร่มเงาปกคลุมตลอดทั้งวัน",
    source:
      "บริษัท เอสพีซีจี จำกัด (มหาชน). (2558). โซลาร์รูฟ ทางเลือกใหม่ของพลังงาน กับการใช้บ้านทำเงิน, 13 มิถุนายน 2562. http://www.spcg.co.th/index.php/th/knowledge/detail/250",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ซ"
  },
  {
    keyword: "โดรน",
    meaning:
      "อากาศยานที่ควบคุมการบินโดยผูควบคุมการบินอยูภายนอกอากาศยานและใชระบบควบคุมอากาศยาน ทั้งนี้ ไมรวมถึงเครื่องบินเล็ก\r\nซึ่งใชเปนเครื่องเลนตามกฎกระทรวงกําหนดวัตถุซึ่งไมเปนอากาศยาน พ.ศ. ๒๕๔๘",
    source:
      "ประกาศกระทรวงคมนาคม เรื่อง หลักเกณฑ์การขออนุญาตและเงื่อนไขในการบังคับหรือปล่อยอากาศยานซึ่งไม่มีนักบิน ประเภทอากาศยานที่ควบคุมการบินจากภายนอก พ.ศ. 2558. (2558, 27 สิงหาคม). ราชกิจจานุเบกษา. เล่ม 132 ตอนที่ 86 ง หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2558/D/086/6.PDF",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "โทรคมนาคม",
    meaning:
      "การส่ง การแพร่ หรือการรับเครื่องหมายสัญญาณตัวหนังสือ ตัวเลข ภาพ เสียง รหัส หรือการอื่นใดซึ่งสามารถให้เข้าใจความหมายได้โดยระบบสายระบบคลื่นความถี่ ระบบแสง ระบบแม่เหล็กไฟฟ้าอื่น หรือระบบอื่น",
    source:
      "พระราชบัญญัติองค์กรจัดสรรคลื่นความถี่และกำกับกิจการวิทยุกระจายเสียงวิทยุโทรทัศน์และกิจการโทรคมนาคม พ.ศ. 2543 (2553,19 ธันวาคม). ราชกิจจานุเบกษา.เล่ม 127 ตอนที่ 78 ก หน้า 2 http://www.ratchakitcha.soc.go.th/DATA/PDF/2553/A/078/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ท"
  },
  {
    keyword: "โทษปรับทางปกครอง",
    meaning:
      "สภาพบังคับ (sanction) สำหรับการกระทำที่ฝ่าฝืนข้อห้ามตามกฎหมาย หรือไม่ปฏิบัติตามบทบัญญัติที่กฎหมายบัญญัติให้ต้องกระทำ และข้อห้ามมิให้กระทำการ หรือบังคับให้ต้องกระทำการนั้น ยังมิใช่เรื่องที่ร้ายแรงถึงระดับผิดศีลธรรม หรือความสงบเรียบร้อยของสังคม หรือความมั่นคงของรัฐ หรือกระทบต่อสิ่งแวดล้อม ผู้กระทำการฝ่าฝืนกฎหมายที่มีโทษทางปกครอง มิใช่อาชญากร แต่เป็นการกระทำที่ผิดกฎระเบียบเล็กน้อยในสังคมเท่านั้น",
    source:
      "ศาสตราจารย์พิเศษ ดร.กมลชัย รัตนสกาววงศ์ , ทฤษฎีและแนวคิดเกี่ยวกับการกำหนดโทษทางปกครองในการตรากฎหมาย สำนักงานคณะกรรมการกฤษฎีกา , 18 พฤศจิกายน 2562\r\nhttp://web.krisdika.go.th/data/outsitedata/article77/file77/c06.pdf",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ท"
  },
  {
    keyword: "โทษปรับทางอาญา",
    meaning:
      "โทษปรับทางอาญา จะต้องชำระเงินตามจำนวนที่กำหนดไว้ในคำพิพากษาต่อศาล",
    source:
      "พระราชบัญญัติให้ใช้ประมวลกฎหมายอาญา พ.ศ. 2499 (13 พฤศจิกายน 2499). มาตรา 28. http://www.krisdika.go.th/librarian/get?sysid=772817&ext=html",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ท"
  },
  {
    keyword: "โทษอาญา",
    meaning:
      "โทษสำหรับลงแก่ผู้กระทำความผิด มีดังนี้\r\n1. ประหารชีวิต\r\n2. จำคุก\r\n3. กักขัง\r\n4. ปรับ\r\n5. ริบทรัพย์สิน",
    source:
      "พระราชบัญญัติให้ใช้ประมวลกฎหมายอาญา พ.ศ. 2499 (13 พฤศจิกายน 2499). มาตรา 18 .http://www.krisdika.go.th/librarian/get?sysid=772817&ext=html",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ท"
  },
  {
    keyword: "โทษานุโทษ",
    meaning: "ความผิดมากและน้อย",
    source:
      "วิกิพจนานุกรม พจนานุกรมเสรี. (2561). โทษานุโทษ, 12 กรกฎาคม 2562. https://th.wiktionary.org/wiki/%E0%B9%82%E0%B8%97%E0%B8%A9%E0%B8%B2%E0%B8%99%E0%B8%B8%E0%B9%82%E0%B8%97%E0%B8%A9",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "ท"
  },
  {
    keyword: "โบราณคดี",
    meaning:
      "ศาสตร์ของการใช้หลักวิชาการและวิธีการทั้งทางวิทยาศาสตร์และศิลปะมาผสมผสานกัน ใช้ศึกษา ค้นคว้าเพื่อให้เกิดความรู้และความเข้าใจในเรื่องเกี่ยวกับตัวของมนุษย์ในอดีต รวมทั้งสังคม วัฒนธรรม และสิ่งแวดล้อมของมนุษย์เมื่อครั้งอดีต หรือกล่าวอีกอย่างหนึ่งได้ว่า โบราณคดี คือ การศึกษาให้เข้าใจเรื่องราวในทุกด้านของมนุษย์ในอดีต รวมทั้งสิ่งแวดล้อมทุกประเภทที่สัมพันธ์กับมนุษย์ในอดีต ",
    source:
      "กรมศิลปากร สำนักโบราณคดี. (2557). หนังสือโบราณคดีสำหรับเยาวชน, 13 มิถุนายน 2562. http://www.finearts.go.th/promotion/parameters/km/item/โบราณคดีคืออะไร.html",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "บ"
  },
  {
    keyword: "โบราณวัตถุ",
    meaning:
      "สังหาริมทรัพย์ที่เป็นของโบราณ ไม่ว่าจะเป็นสิ่งประดิษฐ์ หรือเป็นสิ่งที่เกิดขึ้นตามธรรมชาติ หรือที่เป็นส่วนหนึ่งส่วนใดของโบราณสถาน ซากมนุษย์หรือซากสัตว์ ซึ่งโดยอายุหรือโดยลักษณะแห่งการประดิษฐ์หรือโดยหลักฐานเกี่ยวกับประวัติของสังหาริมทรัพย์นั้น เป็นประโยชน์ในทางศิลปประวัติศาสตร์หรือโบราณคดี\r\n",
    source:
      "พระราชบัญญัติโบราณสถาน โบราณวัตถุ ศิลปวัตถุ และพิพิธภัณฑสถานแห่งชาติ พ.ศ.2504 (2504,29 สิงหาคม) ราชกิจจานุเบกษา.เล่ม 109 ตอนที่ 38 ก หน้า 13 http://www.ratchakitcha.soc.go.th/DATA/PDF/2504/A/066/980.PDF",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "บ"
  },
  {
    keyword: "โบราณสถาน",
    meaning:
      "อสังหาริมทรัพย์ซึ่งโดยอายุหรือโดยลักษณะแห่งการก่อสร้าง หรือโดยหลักฐานเกี่ยวกับประวัติของอสังหาริมทรัพย์นั้นเป็นประโยชน์ในทางศิลป ประวัติศาสตร์ หรือโบราณคดี  ทั้งนี้ ให้รวมถึงสถานที่ที่เป็นแหล่งโบราณคดี แหล่งประวัติศาสตร์ และอุทยานประวัติศาสตร์ด้วย\r\n",
    source:
      "พระราชบัญญัติโบราณสถาน โบราณวัตถุ ศิลปวัตถุ และพิพิธภัณฑสถานแห่งชาติ (ฉบับที่ 2) พ.ศ. 2535 (2535, 5 เมษายน ) ราชกิจจานุเบกษา.เล่ม 109 ตอนที่ 38 ก หน้า 13 http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/038/12.PDF",
    sappear: "",
    mappear: 5,
    rappear: "",
    firstalpha: "บ"
  },
  {
    keyword: "โมเดล Government 4.0",
    meaning:
      "ไทยแลนด์ 4.0 คือโมเดลเศรษฐกิจที่จะพาประเทศไทยให้หลุดพ้นจากกับดักของประเทศรายได้ปานกลาง (เปลี่ยนจาก “More for Less” เป็น “Less for More”) กับดักความเหลื่อมล้า และกับดักความไม่สมดุล พร้อม ๆ กับการเปลี่ยนผ่านประเทศไทยไปสู่ ประเทศในโลกที่หนึ่งที่มี ความมั่นคง มั่งคั่ง และยั่งยืน",
    source:
      "สำนักงานคณะกรรมการพัฒนาระบบราชการ. การเตรียมความพร้อมเข้าสู่ยุคไทยแลนด์ 4.0, 11 กันยายน 2562. file:///C:/Users/admin/Downloads/thailand%204.0.pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ม"
  },
  {
    keyword: "โมบายคอมเมิร์ซ",
    meaning:
      "รูปแบบหนึ่งของการพาณิชย์ อิเล็กทรอนิกส์ (E-Commerce) ผ่านทางระบบเครือข่าย ไร้สาย โดยอาศัยอุปกรณ์เชื่อมโยงไร้สาย เช่น โทรศัพท์มือถือ (Mobile Phone) เครื่องโน้ตบุ๊ค (Notebook) เครื่องปาล์ม (Palm) เครื่องพีดีเอ (PDA) และเครื่อง pocket PC ผ่านสื่อกลาง WAP: Wireless Application Protocol",
    source:
      "Tuptim Kunakorn. บทที่ 7 โมบายคอมเมิร์ช (Mobile Commerce: M-Commerce), 25 มิถุนายน 2562. https://slideplayer.in.th/slide/3995708/",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "โรคไม่ติดต่อ",
    meaning:
      "หมายถึง โรคที่เกิดจากความผิดปกติหรือความเสื่อมโทรมของร่างกายและจิคใจ ไม่สามารถที่จะติดต่อไปหาบุคคลอื่นได้ เช่น โรคหัวใจ โรคเบาหวาน โรคมะเร็ง โรคนิ่ว โรคจิต โรคประสาท และโรคความดันเลือดต่างๆ เป็นต้น",
    source:
      "พระราชบัญญัติโรคติดต่อ, 30 กรกฎาคม 2562. https://www.parliament.go.th/ewtadmin/ewt/elaw_parcy/ewt_dl_link.php?nid=1537",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "โรคระบาด",
    meaning:
      "สถานการณ์การติดเชื้อโรค หรือโรคติดเชื้อที่เกิดขึ้นในระยะเวลาเดียวกันในชุมชน ในถิ่นหรือในแหล่งหนึ่งแหล่งใด ในอัตราสูงกว่าสถานการณ์ปกติที่ควรเป็น โดยการติดเชื้อนั้นลุกลามแพร่กระจายอยู่ในชุมชน ในถื่น หรือในแหล่งนั้นๆ ที่อยู่ใกล้เคียงจุดเริ่มต้นของ\r\nโรค และสามารถแพร่กระจายลุกลามไปยังชุมชนอื่น ๆ ที่อยู่ไกล ๆ ออกไปได้หลาย ๆ ชุมชน หรือหลาย ๆ สถานที่",
    source:
      "Resilience Library Southeast Asia Resources. คำศัพท์ด้านภัยพิบัติ, 30 กันยายน 2562. https://www.rcrc-resilience-southeastasia.org/wp-content/uploads/2017/03/disaster-terminology-th.pdf",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "โรคอุบัติใหม่",
    meaning:
      "โรคติดต่อที่เกิดขึ้นในมนุษย์ซึ่งรวมถึงโรคติดเชื้อชนิดใหม่ที่เพิ่งค้นพบการระบาดในมนุษย์เชื้อโรคที่กลายพันธุ์ โรคติดเชื้อที่พบในพื้นที่ใหม่ และโรคติดต่ออุบัติซ้ำที่เป็นโรคติดต่อจากเชื้อโรคที่เคยแพร่ระบาดในอดีต และสงบไปหลายปีแล้วกลับมาระบาดขึ้นใหม่\r\n",
    source:
      "แผนปฏิบัติการป้องกันโรคติดต่ออุบัติใหม่ และโรคติดต่ออันตราย กระทรวงสาธารณสุข\r\nhttp://122.155.1.141/site2/download-src.php?did=30594",
    sappear: 5,
    mappear: 13,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "โรคอุบัติซ้ำ",
    meaning:
      "โรคติดเชื้อที่เคยแพร่ระบาดในอดีต และสงบไปแล้ว เป็นเวลานานหลายปี แต่กลับมาระบาดขึ้นอีก",
    source:
      "สารานุกรมไทยสำหรับเยาวชนฯ เล่มที่ ๒๔. เรื่องที่ ๘ โรคติดเชื้ออุบัติใหม่ และโรคติดเชื้ออุบัติซ้ำ, 23 กรกฎาคม 2562. http://kanchanapisek.or.th/kp6/sub/book/book.php?book=24&chap=8&page=t24-8-infodetail01.html ",
    sappear: 5,
    mappear: 13,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "โรงเรียนประชาธิปไตย",
    meaning:
      "การจัดการเรียนการสอนของโรงเรียนในเรื่องเกี่ยวกับการเมืองการปกครองในระบอบประชาธิปไตย มักจะสอนกันในลักษณะของการเป็นวิชาหนึ่งในหลักสูตรการเรียนการสอนซึ่งจะเป็นการสร้างความรู้เท่านั้น แต่ไม่สามารถจะนำไปสู่เจตนคติและทักษะของความเป็นพลเมืองในระบอบประชาธิบไตยได้ ซึ่งการพัฒนาสร้างสรรค์ให้สมาชิกในสังคมมีวัฒนธรรมทางการเมืองและวิถีชีวิตแบบประชาธิปไตยจะต้องอาศัยกระบวนการอบรมกล่อมเกลาทางสังคมที่ยาวนานและมีความต่อเนื่อง และที่สำคัญที่สุดต้องเริ่มต้นตั้งแต่วัยเด็กและเยาวชน ด้วยกระบวนการของการจัดการเรียนรู้หรือการให้การศึกษาทางการเมืองที่จะนำไปสู่เป้าหมายที่สำคัญทั้ง 3 ด้าน คือ มีความรู้ มีเจตนคติ และมีทักษะของความเป็นพลเมืองในการปฏิบัติตนและอยู่ร่วมกับผู้อื่นตามวิถีประชาธิปไตย",
    source:
      "สถาบันชุมชนท้องถิ่นพัฒนา (LDI). (2561). โรงเรียนประชาธิปไตยตัวอย่าง : โรงเรียนเทศบาล ๒(วัดใน) อ.เมือง จ.สมุทรปราการ, 10 กรกฎาคม 2562. https://www.ldm.in.th/cases/5902",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ร"
  },
  {
    keyword: "โรงไฟฟ้า",
    meaning:
      "ทำหน้าที่แปลงพลังงานรูปต่าง ๆ เช่น  พลังงานศักย์ของน้ำ พลังงานเคมีในเชื้อเพลิงฟอสซิลและพลังงานนิวเคลียร์ที่ใช้เชื้อเพลิงนิวเคลียร์เป็นพลังงานไฟฟ้า โรงไฟฟ้าสามารถแบ่งประเภทตามเชื้อเพลิงที่ใช้และกระบวนการผลิตไฟฟ้า ดังนี้\r\n•        โรงไฟฟ้าพลังความร้อน (thermal power plant) \r\n•        โรงไฟฟ้ากังหันก๊าซ (gas turbine power plant) \r\n•        โรงไฟฟ้าพลังความร้อนร่วม (combined-cycle power plant) \r\n•        โรงไฟฟ้านิวเคลียร้ (nuclear power plant) \r\n•        โรงไฟฟ้าพลังน้ำ (hydroelectric power plant) \r\n•        โรงไฟฟ้าดีเซล (diesel power plant) \r\n•        โรงไฟฟ้าที่ใช้พลังงานหมุนเวียน (renewable energy) ",
    source:
      "การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย. โรงไฟฟ้าในประเทศไทย. ประเภทของโรงไฟฟ้า มีกี่ประเภท, 12 มิถุนายน 2562. https://www.egat.co.th/index.php?option=com_content&view=article&id=1454",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "โรงไฟฟ้าของผู้ผลิตไฟฟ้าขนาดใหญ่ (IPP)",
    meaning:
      "1. บริษัท ผลิตไฟฟ้าขนอม จำกัด\r\n      - โรงไฟฟ้าพลังความร้อนร่วม (ชุดที่ 2)\r\n2. บริษัท ผลิตไฟฟ้าราชบุรี โฮลดิ้ง จำกัด (มหาชน)\r\n      - โรงไฟฟ้าพลังความร้อน\r\n      - โรงไฟฟ้าพลังความร้อนร่วม (ชุดที่ 1)\r\n      - โรงไฟฟ้าพลังความร้อนร่วม (ชุดที่ 2)\r\n      - โรงไฟฟ้าพลังความร้อนร่วม (ชุดที่ 3)\r\n  3. บริษัท ผลิตไฟฟ้าราชบุรี จำกัด สาขาไตร เอนเนอจี้ชุด1\r\n  4. บริษัท โกลบอล เพาเวอร์ ซินเนอร์ยี่ จำกัด\r\n  5. บริษัท โกลว์ ไอพีพี จำกัด\r\n  6. บริษัท อีสเทิร์น เพาเวอร์ แอนด์ อิเล็คตริค จำกัด\r\n  7. บริษัท บีแอลซีพี เพาเวอร์ จำกัด\r\n  8. บริษัท กัลฟ์เพาเวอร์เจนเนอเรชั่น จำกัด\r\n  9. บริษัท ราชบุรีเพาเวอร์ จำกัด\r\n10. บริษัท เก็คโค่-วัน จำกัด\r\n11. บริษัท กัลฟ์ เจพี เอ็นเอส จำกัด\r\n      - บริษัท กัลฟ์ เจพี เอ็นเอส จำกัด โครงการ 1\r\n      - บริษัท กัลฟ์ เจพี เอ็นเอส จำกัด โครงการ 2\r\n12. บริษัท กัลฟ์ เจพี ยูที จำกัด\r\n      - บริษัท กัลฟ์ เจพี ยูที จำกัด โครงการ 1\r\n      - บริษัท กัลฟ์ เจพี ยูที จำกัด โครงการ 2",
    source:
      "การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย. (2562).กำลังผลิตโรงไฟฟ้าเอกชน, 30 กันยายน 2562. http://www.egat.co.th/index.php?option=com_content&view=article&id=355&Itemid=116",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "โรงไฟฟ้าชีวมวล",
    meaning:
      "โรงไฟฟ้าที่ใช้เศษวัสดุต่างๆที่เป็นชีวมวล เป็นเชื้อเพลิงในการผลิตไฟฟ้า หรือ ผลิตไอน้ำ ซึ่งอาจเป็นวัสดุชนิดเดียวกันหรือหลายชนิดรวมกัน เช่น โรงน้ำตาลใช้กากอ้อยที่ได้จากการหีบอ้อยเป็นเชื้อเพลิงในการผลิตไฟฟ้าโรงสีขนาดใหญ่ที่ใช้แกลบเป็นเชื้อเพลิงหลักในการผลิตไฟฟ้าการใช้ก๊าซชีวภาพ(Biogas) จากการหมักน้ำเสีย(ที่ได้มาจากกระบวนการผลิตทางอุตสาหกรรมหรือมูลสัตว์(จากฟาร์มเลี้ยงสัตว์) มาผลิตกระแสไฟฟ้า ฯลฯ",
    source:
      "สมาคมพลังงานทดแทนสู่ชุมชนแห่งประเทศไทย-TRECA. Biomass, 3 ตุลาคม 2562. http://www.reca.or.th/library-biomass.aspx",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "โรงไฟฟ้าฐาน",
    meaning:
      "โรงไฟฟ้าที่จะต้องเดินเครื่องอยู่ในระบบตลอดเวลา 24 ชั่วโมง และใช้เวลาในการติดเครื่อง (Start Up) นาน",
    source:
      "ธวัชชัย จักรไพศาล. (2560). ไฟฟ้า: มีพอใช้กันนานเท่าใด, 12 มิถุนายน 2562. https://www.thailand-energy-academy.org/assets/upload/coursedocument/file/600921_%E0%B8%A7%E0%B8%9E%E0%B8%99.%2010%20%E0%B9%84%E0%B8%9F%E0%B8%9F%E0%B9%89%E0%B8%B2%20%E0%B8%A1%E0%B8%B5%E0%B8%9E%E0%B8%AD%E0%B9%83%E0%B8%8A%E0%B9%89%E0%B8%81%E0%B8%B1%E0%B8%99%E0%B8%AD%E0%B8%B5%E0%B8%81%E0%B8%99%E0%B8%B2%E0%B8%99%E0%B9%80%E0%B8%97%E0%B9%88%E0%B8%B2%E0%B9%83%E0%B8%94-v4-compress.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "โรงไฟฟ้าถ่านหิน",
    meaning:
      "การนำถ่านหินมาใช้ในการผลิตไฟฟ้า ถ่านหินมีหลายเกรดตั้งแต่คุณภาพต่ำไปจนถึงคุณภาพสูง ปัจจุบันเทคโนโลยีถ่านหินได้ถูกพัฒนาจนมีความสะอาดมากขึ้น \r\nข้อดี คือ เงินลงทุนต่ำแต่ได้กระแสไฟฟ้าจำนวนมาก กระแสไฟฟ้ามีความสม่ำเสมอและมีเสถียรภาพ \r\nส่วนข้อเสีย คือ ถ่านหินก่อให้เกิดมลพิษ และถ่านหินมีราคาผันผวนตามราคาโลก",
    source:
      "Investdiary. (2562). วิเคราะห์ธุรกิจโรงไฟฟ้าฉบับเบื้องต้น, 12 มิถุนายน 2562. https://investdiary.co/2019/01/06/172/",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "โรงไฟฟ้าถ่านหินเทคโนโลยีสะอาด",
    meaning:
      "โรงไฟฟ้าถ่านหินที่ใช้เทคโนโลยีประสิทธิภาพสูง ปล่อยคาร์บอนไดออกไซด์ (CO2) ในระดับต่ำ รวมทั้งสามารถกำจัดมลสารต่าง ๆ อาทิ ฝุ่นละออง ก๊าซออกไซด์ของไนโตรเจน ก๊าซซัลเฟอร์ไดออกไซด์ หรือ ดักจับไอปรอทได้ ",
    source:
      "สมดุลแหล่งพลังงานไฟฟ้า. (2560). โรงไฟฟ้าถ่านหินเทคโนโลยีสะอาด, 12 มิถุนายน 2562. http://www.balanceenergythai.com/cleancoal-technology/\r\n\r\nhttps://www.youtube.com/watch?v=x9DqlQkSRvc",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "โรงไฟฟ้าที่เสริมความมั่นคง (Ancillary Services)",
    meaning:
      "การบริการของผู้ผลิต/ขายไฟฟ้าเพื่อสนับสนุนระบบไฟฟ้าให้สามารถทำหน้าที่ส่งกำลังไฟฟ้าไปยังผู้ใช้ไฟฟ้าได้อย่างมีประสิทธิภาพ สามารถแบ่งตามเงื่อนไขการทำงาน ได้ดังนี้\r\n1.เงื่อนไขการทำงาน ณ สภาวะปกติ (Normal conditions) \r\n    - การจัดการความไม่สมดุลของพลังงาน คือ มีระบบควบคุมกำลังการผลิตที่เร็วพอกับการ เปลี่ยนแปลงโดยทั่วไปของโหลด \r\n2.เงื่อนไขการทำงานกรณีฉุกเฉิน (Contingency conditions) \r\n    - การควบคุมในกรณีฉุกเฉิน คือ มีระบบควบคุมกำลังการผลิตที่เร็วพอกับการเปลี่ยนแปลงของระบบไฟฟ้าในกรณีฉุกเฉิน เช่น โรงไฟฟ้าบางแห่งหลุดออกจากระบบ เป็นต้น \r\n    - กำลังการผลิตสำรอง คือ ความสามารถในการเป็นแหล่งผลิตสำรอง สำหรับการฟื้นฟูระบบไฟฟ้าหลังเหตุการณ์ฉุกเฉิน \r\n3.เงื่อนไขกรณีอื่นๆ (Other services) \r\n    - การควบคุมแรงดัน คือ ความสามารถรับ/จ่ายกำลังไฟฟ้ารีแอคทีฟเพื่อควบคุมแรงดัน \r\n    - Black start คือ ความสามารถในการเดินเครื่องได้ด้วยตนเองโดยไม่พึ่งกำลังไฟฟ้าจากระบบ ไฟฟ้า เพื่อช่วยในการฟื้นฟูระบบไฟฟ้า",
    source:
      "รองฤทธิ์ ฉัตรถาวร. 2558. การคิดราคากำลังไฟฟ้ารีแอคทีฟในต่างประเทศ, 20 มกราคม 2558 ห้อง Monet-Pissarro ชั้น 4 โรงแรมโนโวเทล สยามสแควร. กรุงเทพมหานคร: คณะวิศวกรรมศาสตร์ จุฬาลงกรณ์มหาวิทยาลัย",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "โรงไฟฟ้าที่ทำหน้าที่ Standby Reserve",
    meaning:
      "เป็นโรงไฟฟ้าสำรองตามแผนการผลิตไฟฟ้าโดยมาตรฐานสากลจะกำหนดไว้ราวร้อยละ 15 ของความต้องการไฟฟ้าสูงสุด ซึ่งจากกำลังผลิตติดตั้งภายในประเทศราว33,000 เมกะวัตต์ จะพบว่ามีกำลังผลิตสำรอง ในปัจจุบันประมาณ 5,000 เมกะวัตต์ เนื่องจากในการวางแผนการผลิตไฟฟ้าจะต้องคำนึงถึงปัจจัยอื่นๆ อย่างรอบคอบ อาทิ ความต้องการไฟฟ้าที่อาจเพิ่มสูงกว่าการพยากรณ์ การหยุดซ่อมโรงไฟฟ้าการเสื่อมสภาพของโรงไฟฟ้า ความเสี่ยงด้านเชื้อเพลิง ข้อจำกัดของระบบส่งในแต่ละพื้นที่ และลักษณะทางเทคนิคของโรงไฟฟ้าแต่ละประเภท",
    source:
      "ฝ่ายสื่อสารองค์การ, การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย. กำลังผลิตสำรอง: หลักประกันความมั่นคงของระบบไฟฟ้า, 12 มิถุนายน 2562. https://www.egat.co.th/index.php?option=com_content&view=article&id=357&Itemid=217",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "โรงไฟฟ้าพลังน้ำ",
    meaning:
      "โรงไฟฟ้าพลังน้ำ เป็นแหล่งผลิตไฟฟ้าที่สำคัญอีกชนิดหนึ่งของประเทศไทย โรงไฟฟ้าชนิดนี้ใช้น้ำในลำน้ำธรรมชาติเป็นพลังงานในการเดินเครื่อง โดยวิธีสร้างเขื่อนปิดกั้นแม่น้ำไว้ เป็นอ่างเก็บน้ำ ให้มีระดับอยู่ในที่สูงจนมีปริมาณน้ำ และแรงดันเพียงพอที่จะนำมาหมุนเครื่องกังหันน้ำและเครื่องกำเนิดไฟฟ้าซึ่งอยู่ในโรงไฟฟ้าท้ายน้ำที่มีระดับต่ำกว่าได้ กำลังผลิตติดตั้งและพลังงานไฟฟ้าที่ผลิตได้จากโรงไฟฟ้าชนิดนี้ จะเพิ่มเป็นสัดส่วนโดยตรงกับแรงดันและปริมาณน้ำที่ไหลผ่านเครื่องกังหันน้ำ",
    source:
      "การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย. โรงไฟฟ้าพลังน้ำ, 27 มิถุนายน 2562. https://www.me.psu.ac.th/Power_Plant_Engineering/EGAT/PPlant/Hydro.htm\r\n\r\n\r\nhttps://www.youtube.com/watch?v=WqC3yamo8Yk",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "โรงกลั่น",
    meaning:
      "โรงกลั่นน้ำมันเชื้อเพลิง สถานที่ผลิตและจำหน่ายน้ำมันเชื้อเพลิง และหมายความรวมถึงโรงแยกก๊าซและโรงงานอุตสาหกรรมเคมีปิโตรเลียมและสารละลายด้วย",
    source:
      "พระราชบัญญัติการส่งเสริมการอนุรักษ์พลังงาน พ.ศ. 2535. (2535, 23 มีนาคม). ราชกิจจานุเบกษา. เล่มที่ 109 ตอนที่ 33 หน้าที่ 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "โลกเสมือน",
    meaning:
      "การจำลองสภาพแวดล้อม ที่สามารถตอบสนองต่อการใช้งานของผู้ใช้หลายคน พร้อมๆ กัน ผ่านเครือข่ายออนไลน์ นั่นหมายความว่า โลกเสมือนจะต้องรองรับ การใช้งานของผู้ใช้ได้ตลอดเวลา (24 ชั่วโมงต่อวัน) อย่างไรก็ตามโลกเสมือนจะมีคุณลักษณะทั่วไป 6ข้อดังนี้\r\n  1. Share Space : ผู้ใช้หลายคนสามารถเข้าไปยังสถานที่ ต่างๆ ได้ในเวลาเดียวกัน\r\n  2. Graphical User Interface : โลกเสมือนจะใช้ภาพใน การนำเสนอ โดยอาจจะเป็นภาพ 2มิติหรือ 3 มิติก็ได้\r\n  3. Immediacy : มีการตอบสนองเกิดขึ้นทันที\r\n  4. Interactivity : ผู้ใช้สามารถสร้าง พัฒนาและเปลี่ยนแปลง ข้อมูลที่ต้องการในโลกเสมือนได้เอง\r\n  5. Persistence : สถานที่หรือข้อมูลต่างๆ ในโลกเสมือน จะยังคงมีอยู่ต่อไป ถึงแม้ว่าผู้ใช้จะไม่ได้ log in เข้าสู่ระบบ \r\n  6. Socialization/Community: ส่งเสริมให้เกิดการรวม กลุ่มของผู้ใช้เป็นสังคมย่อยๆ เช่น ทีม คลับ เพื่อนบ้าน เป็นต้น",
    source:
      "นางสาวภัศรา พิริยมานันท์ และ นายชิงชัย ฉันธนารัตน์. โลกเสมือนจริง (Virtual World), 12มิถุนายน 2553. http://msmisthammasat.blogspot.com/2010/12/virtual-world.html",
    sappear: "",
    mappear: 10,
    rappear: "",
    firstalpha: "ล"
  },
  {
    keyword: "โลกไซเบอร์",
    meaning:
      "การแพร่กระจายไปทั่วโลก การที่ประชาคมโลกไม่ว่าจะอยู่ ณ จุดใด สามารถรับรู้ สัมพันธ์ หรือรับผลกระทบจากสิ่งที่เกิดขึ้นได้อย่างรวดเร็วกว้างขวาง ซึ่งเนื่องมาจากการพัฒนาระบบสารสนเทศเป็นต้น",
    source:
      "สำนักงานราชบัณฑิตยสภา. โลกาภิวัตน์, 18 พฤศจิกายน 2562. http://www.royin.go.th/?knowledges=globalisazation-%E0%B9%82%E0%B8%A5%E0%B8%81%E0%B8%B2%E0%B8%A0%E0%B8%B4%E0%B8%A7%E0%B8%B1%E0%B8%95%E0%B8%99%E0%B9%8C",
    sappear: "",
    mappear: 10,
    rappear: "",
    firstalpha: "ล"
  },
  {
    keyword: "โลกไร้พรมแดน",
    meaning:
      "การแพร่กระจายไปทั่วโลก การที่ประชาคมโลกไม่ว่าจะอยู่ ณ จุดใด สามารถรับรู้ สัมพันธ์ หรือรับผลกระทบจากสิ่งที่เกิดขึ้นได้อย่างรวดเร็วกว้างขวาง ซึ่งเนื่องมาจากการพัฒนาระบบสารสนเทศเป็นต้น",
    source:
      "สำนักงานราชบัณฑิตยสภา. โลกาภิวัตน์, 18 พฤศจิกายน 2562. http://www.royin.go.th/?knowledges=globalisazation-%E0%B9%82%E0%B8%A5%E0%B8%81%E0%B8%B2%E0%B8%A0%E0%B8%B4%E0%B8%A7%E0%B8%B1%E0%B8%95%E0%B8%99%E0%B9%8C",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ล"
  },
  {
    keyword: "โลกาภิวัตน์",
    meaning:
      "การแพร่กระจายไปทั่วโลก การที่ประชาคมโลกไม่ว่าจะอยู่ ณ จุดใด สามารถรับรู้ สัมพันธ์ หรือรับผลกระทบจากสิ่งที่เกิดขึ้นได้อย่างรวดเร็วกว้างขวาง ซึ่งเนื่องมาจากการพัฒนาระบบสารสนเทศเป็นต้น",
    source:
      "สำนักงานราชบัณฑิตยสภา. โลกาภิวัตน์, 18 พฤศจิกายน 2562. http://www.royin.go.th/?knowledges=globalisazation-%E0%B9%82%E0%B8%A5%E0%B8%81%E0%B8%B2%E0%B8%A0%E0%B8%B4%E0%B8%A7%E0%B8%B1%E0%B8%95%E0%B8%99%E0%B9%8C",
    sappear: "",
    mappear: 2,
    rappear: 3,
    firstalpha: "ล"
  },
  {
    keyword: "โลจิสติกส์",
    meaning:
      "กระบวนการทำงานต่าง ๆ ที่เกี่ยวข้องกับการวางแผน การดำเนินการ และการควบคุมการทำงานขององค์กร รวมทั้งการบริหารจัดการข้อมูลและธุรกรรมทางการเงินที่เกี่ยวข้อง ให้เกิดการเคลื่อนย้าย การจัดเก็บ การรวบรวม การกระจายสินค้า วัตถุดิบ ชิ้นส่วนประกอบ และการบริการ ให้มีประสิทธิภาพ และประสิทธิผลสูงสุด โดยคำนึงถึงความต้องการและความพึงพอใจของลูกค้าเป็นสำคัญ",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. (2562). แผนยุทธศาสตร์การพัฒนาระบบโลจิสติกส์ของประเทศไทย ฉบับที่ 3 (พ.ศ. 2560-2564), 19 พฤศจิกายน 2562. https://www.nesdb.go.th/download/document/logistic/plan3.pdf",
    sappear: "",
    mappear: "2,8",
    rappear: "",
    firstalpha: "ล"
  },
  {
    keyword: "โอกาสเข้าถึงบริการทางการเงิน",
    meaning:
      "การที่บุคคลหรือครัวเรือนมีโอกาสการเข้าถึงและสามารถใช้ผลิตภัณฑ์หรือบริการทางการเงินที่เหมาะสมได้อย่างมีประสิทธิภาพ ยั่งยืน ด้วยต้นทุนที่เป็นธรรม โปร่งใส และสอดคล้องกับระดับรายได้ ภายใต้การกำกับดูแลที่เหมาะสม",
    source:
      "ธนาคารแห่งประเทศไทย. (2561). การเข้าถึงบริการทางการเงิน (Financial Inclusion), 25 กันยายน 2562. https://www.botlc.or.th/item/kc_recommendation/00000000010",
    sappear: "",
    mappear: 8,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "ใบอนุญาต",
    meaning: "ใบอนุญาตประกอบกิจการโรงงาน",
    source:
      "พระราชบัญญัติโรงงาน พ.ศ. 2535. (2535, 9 เมษายน). ราชกิจจานุเบกษา. เล่ม 109 ตอนที่ 44 หน้า 63. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/044/62.PDF",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "บ"
  },
  {
    keyword: "ใบอนุญาต รง.4",
    meaning:
      "อาคาร สถานที่ หรือยานพาหนะ ที่ใช้เครื่องจักรที่มีกำลังรวมตั้งแต่ 5 แรงม้าขึ้นไปหรือใช้แรงงานตั้งแต่ 7 คนขึ้นไปสำหรับทำ ผลิต ประกอบ บรรจุ ซ่อม ซ่อมบำรุงทดสอบ ปรับปรุง แปรสภาพ ลำเลียง เก็บรักษาหรือทำลายสิ่งใดๆ ทั้งนี้ตามประเภทหรือชนิดของโรงงานที่กำหนดในกฎกระทรวง ซึ่งตามกฎหมายได้แบ่งโรงงานออกเป็น 3 จำพวก ได้แก่ \r\nโรงงานจำพวกที่ 1 คือ โรงงานที่มีแรงม้ารวมของเครื่องจักร 5-20 แรงม้า และ/หรือมีจำนวนคนงาน 7-20 คน (ยกเว้นโรงงานที่มีมลภาวะให้จัดเป็นโรงงานจำพวกที่ 3) โรงงานกลุ่มนี้สามารถประกอบกิจการได้ทันทีตามความประสงค์ของผู้ประกอบกิจการ แต่ต้องปฏิบัติตามหลักเกณฑ์ที่กำหนดในกฎกระทรวงและประกาศกระทรวง\r\nโรงงานจำพวกที่ 2 คือ โรงงานที่มีแรงม้ารวมของเครื่องจักรมากกว่า 20 แรงม้าแต่ไม่เกิน 50 แรงม้าและ/หรือมีจำนวนคนงาน 21-50 คน (ยกเว้นโรงงานที่มีมลภาวะให้จัดเป็นโรงงานจำพวกที่ 3) เป็นโรงงานที่ไม่ต้องขออนุญาต แต่ต้องปฏิบัติตามหลักเกณฑ์ที่กำหนดเช่นเดียวกับโรงงานจำพวกที่ 1 และเมื่อจะเริ่มประกอบกิจการโรงงานต้องแจ้งต่อพนักงานเจ้าหน้าที่ทราบก่อน\r\nโรงงานจำพวกที่ 3 คือ โรงงานที่มีแรงม้ารวมของเครื่องจักรมากกว่า 50 แรงม้า และ/หรือ มีจำนวนคนงานมากกว่า 50 คน หรือเป็นโรงงานที่มีมลภาวะ เป็นโรงงานที่ต้องรับใบอนุญาตก่อนจึงจะตั้งโรงงานได้โดยผู้ประกอบการจะต้องทำใบขออนุญาต ได้แก่ แบบ รง. 3 คือ แบบคำขอรับใบอนุญาตและแบบ รง. 4 คือใบอนุญาตประกอบกิจการโรงงาน นอกจากนี้ ยังมีแบบ รง. 3/1 คือ แบบขอต่ออายุใบอนุญาตและ แบบ รง.3/2 คือ แบบคำขอรับโอนใบอนุญาตประกอบกิจการ ซึ่งจะใช้ในกรณีที่มีการซื้อ เช่า หรือเช่าซื้อโรงงาน รวมถึงการรับเป็นมรดก เป็นต้น",
    source:
      "เศกสันติ์ ยังนิ่ง นักวิเคราะห์นโยบายและแผนชำนาญการ. ใบอนุญาตประกอบกิจการโรงงาน (ร.ง. 4), 4 กันยายน 2562. http://202.129.59.73/spt/know/130959new/c1.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "บ"
  },
  {
    keyword: "ไซเบอร์",
    meaning:
      "ข้อมูลและการสื่อสารที่เกิดจากการให้บริการหรือการประยุกต์ใช้เครือข่ายคอมพิวเตอร์ ระบบอินเทอร์เน็ต หรือโครงข่ายโทรคมนาคม รวมทั้งการให้บริการโดยปกติของดาวเทียมและระบบเครือข่ายที่คล้ายคลึงกัน ที่เชื่อมต่อกันเป็นการทั่วไป",
    source:
      "พระราชบัญญัติการรักษาความมั่นคงปลอดภัยไซเบอร์ พ.ศ. 2562. (2562, 27 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอน 69 ก หน้า 21. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/069/T_0020.PDF",
    sappear: 1,
    mappear: "",
    rappear: "",
    firstalpha: "ซ"
  },
  {
    keyword: "ไซโล (Siloed)",
    meaning:
      "พฤติกรรมหรือกรอบความคิดประเภทที่ว่าหน่วยงานต่าง ๆ ในองค์กรเดียวกัน ไม่ยอมแลกเปลี่ยนข้อมูลหรือองค์ความรู้ระหว่างกัน ซึ่งพฤติกรรมเช่นนี้ทำให้ประสิทธิภาพการดำเนินงานต่ำลง ขวัญกำลังใจพนักงานตก และอาจส่งผลถึงขั้นทำลายวัฒนธรรมองค์กรได้",
    source:
      "pigkypink. (2561). ทลายการทำงานแบบไซโล, 10 กรกฎาคม 2562. http://oknation.nationtv.tv/blog/pigkystory/2018/04/04/entry-1",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ซ"
  },
  {
    keyword: "ไต่สวน",
    meaning:
      "การแสวงหา รวบรวม และการดําเนินการอื่นใด เพื่อให้ได้มา ซึ่งข้อเท็จจริงและพยานหลักฐาน ",
    source:
      "พระราชบัญญัติประกอบรัฐธรรมนูญว่าด้วยการป้องกันและปราบปรามการทุจริต พ.ศ. 2561. (2561, 21 กรกฎาคม). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 52 ก หน้า 4. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/052/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "ต"
  },
  {
    keyword: "ไบโอโพลิส (Biopolish)",
    meaning:
      "ศูนย์กลางการวิจัยและนวัตกรรมเพื่อพัฒนาอุตสาหกรรมภายใต้เศรษฐกิจฐานชีวภาพ (Bio-Economy) ใช้ประโยชน์จากฐานเกษตรกรรมและความหลากหลายทางชีวภาพ",
    source:
      "สำนักงานคณะกรรมการนโยบายเขตพัฒนาพิเศษภาคตะวันออก (สกพอ.). EECd EECi, 5 กรกฎาคม 2562. https://www.eeco.or.th/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%88%E0%B8%B1%E0%B8%94%E0%B8%95%E0%B8%B1%E0%B9%89%E0%B8%87%E0%B9%80%E0%B8%82%E0%B8%95%E0%B8%AA%E0%B9%88%E0%B8%87%E0%B9%80%E0%B8%AA%E0%B8%A3%E0%B8%B4%E0%B8%A1/EECd-EECi",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "บ"
  },
  {
    keyword: "ไบโอดีเซล",
    meaning:
      "เชื้อเพลิงทดแทนประเภทดีเซลจากธรรมชาติ โดยการนำเอาน้ำมันจากพืชหรือสัตว์ ซึ่งเป็นสารประกอบอินทรีย์ประเภทไตรกลีเซอไรด์ มาผ่านกระบวนการทางเคมีที่เรียกว่า ทรานส์เอสเตอริฟิเคชัน (Transesterifcation) โดยทำปฏิกิริยากับแอลกอฮอล์ (EthanolหรือMethanol) และมีด่างเป็นตัวเร่งปฏิกิริยา เช่น โซเดียมไฮดรอกไซด์ (NaOH) จะได้ผลิตผลเป็นเอสเตอร์ (Ester) และผลิตภัณฑ์ผลพลอยได้กลีเซอรอล (Glycerol) ซึ่งเราจะเรียกชนิดของไบโอดีเซลแบบเอสเตอร์นี้ตามชนิดของแอลกอฮอล์ที่ใช้ในการทำปฏิกิริยา ไบโอดีเซลชนิดเอสเตอร์นี้มี คุณสมบัติที่เหมือนกับน้ำมันดีเซลมากที่สุด เพราะไม่มีปัญหากับเครื่องยนต์",
    source:
      "สถานวิจัยและพัฒนาพลังงานทดแทนจากน้ำมันปาล์มและพืชน้ำมัน. ไบโอดีเซลคืออะไร?, 12 มิถุนายน 2562. http://www.biodiesel.eng.psu.ac.th/whatis.php",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "บ"
  },
  {
    keyword: "ไม้เศรษฐกิจ",
    meaning:
      "ไม้ยืนต้นทุกชนิด รวมถึงไผ่ที่ปลูก หรือขึ้นเองตามธรรมชาติและอยู่นอกเขตป่าอนุรักษ์ที่มีการใช้ประโยชน์เนื้อไม้และ/หรือ ผลิตผลอื่นที่ไม่ใช่เนื้อไม้เพื่อการค้า ดังนั้น อาจกล่าวโดยรวมได้ว่า ไม้เศรษฐกิจ เป็นไม้ที่สามารถนำมาสร้างมูลค่า หรือแปรรูปเป็นผลิตภัณฑ์อื่นๆ รวมถึงให้ประโยชน์ทั้งทางตรงและทางอ้อมแก่ผู้ปลูก",
    source:
      "กรมป่าไม้. (2561). ไม้มีค่าทางเศรษฐกิจ, 30 กรกฎาคม 2562. http://forestinfo.forest.go.th/pfd/Files/FileEBook/EB23.pdf",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "ไมโครพลาสติก",
    meaning:
      "เม็ดพลาสติกขนาดเล็กกว่า 5 มิลลิเมตร (5,000 ไมครอน) มาจากพลาสติกต่างๆ ที่ใช้ในครัวเรือนและอุตสาหกรรม เช่น เม็ดบีดส์ เม็ดสครับในเครื่องสำอางและยาสีฟันหรือมาจากขยะ ",
    source:
      "การประปานครหลวง. (ม.ป.ป). ไมโครพลาสติกในน้ำดื่ม, 13 มิถุนายน 2562. https://www.mwa.co.th/ewt_dl_link.php?nid=34119",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ม"
  },
  {
    keyword: "ไฮโดรคาร์บอน",
    meaning:
      "สารประกอบอินทรีย์ที่มีเฉพาะธาตุคาร์บอนและไฮโดรเจนเป็นองค์ประกอบ ในธรรมชาติพบสารประกอบไฮโดรคาร์บอนเกิดอยู่ในแหล่งต่างๆ เช่น ยางไม้ ถ่านหิน ปิโตรเลียม นอกจากนี้ยังพบว่ามีสารประกอบไฮโดรคาร์บอนจำนวนมากที่ได้จากการสังเคราะห์แหล่งกำเนิดของสารประกอบไฮโดรคาร์บอนที่สำคัญที่สุด คือ ปิโตรเลียม\r\nไฮโดรคาร์บอน ประกอบไปด้วยธาตุคาร์บอน (carbon) และ ไฮโดรเจน (hydrogen)\r\nประเภทของไฮโดรคาร์บอน\r\nไฮโดรคาร์บอนมีอยู่ 3 ประเภทหลักๆ ได้แก่\r\n1. อะโรมาติคไฮโดรคาร์บอน (aromatic hydrocarbon) \r\n2. ไฮโดรคาร์บอนอิ่มตัว (saturated hydrocarbon) \r\n3. ไฮโดรคาร์บอนไม่อิ่มตัว (unsaturated hydrocarbon) ",
    source:
      "กรมสรรพสามิต. Hydrocarbon Solvent, 12 มิถุนายน 2562. https://www.excise.go.th/cs/groups/public/documents/document/mjaw/mdcy/~edisp/webportal16200072537.ppt",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ฮ"
  },
  {
    keyword: "กฎ",
    meaning:
      "กฎตามกฎหมายว่าด้วยวิธีปฏิบัติราชการทางปกครอง บรรดาที่มีผล\r\nให้เกิดภาระแก่ประชาชน หรือการไม่ปฏิบัติตามจะมีผลให้ต้องได้รับโทษหรือเสียสิทธิ หรือกระทบต่อสถานะของบุคคล ",
    source:
      "พระราชบัญญัติหลักเกณฑ์การจัดทำร่างกฎหมายและการประเมินผลสัมฤทธิ์ของกฎหมาย พ.ศ. 2562. (2562,31 พฤษภาคม) ราชกิจจานุเบกษา. เล่มที่ 136 ตอนที่ 72 ก หน้า 2\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/072/T_0001.PDF",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กฎหมาย",
    meaning: "พระราชบัญญัติประกอบรัฐธรรมนูญ พระราชบัญญัติ และ\r\nประมวลกฎหมาย",
    source:
      "พระราชบัญญัติหลักเกณฑ์การจัดทำร่างกฎหมายและการประเมินผลสัมฤทธิ์ของกฎหมาย พ.ศ. 2562. (2562,31 พฤษภาคม) ราชกิจจานุเบกษา. เล่มที่ 136 ตอนที่ 72 ก หน้า 1\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/072/T_0001.PDF",
    sappear: 6,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กฎหมายการมีส่วนร่วมของประชาชนในกระบวนการนโยบายสาธารณะ",
    meaning:
      "การมีส่วนร่วมของประชาชน เป็นรากฐานที่สำคัญของกระบวนการประชาธิปไตย สอดคล้องตามพระราชบัญญัติระเบียบบริหารราชการแผ่นดิน (ฉบับที่ 5) พ.ศ. 2545 ในมาตรา 3/1 วรรคสามที่ระบุว่า “ในการปฏิบัติหน้าที่ของส่วนราชการต้องใช้วิธีการบริหารกิจการบ้านเมืองที่ดี โดยเฉพาะอย่างยิ่งให้คำนึงถึงความรับผิดชอบของผู้ปฏิบัติงานการมีส่วนร่วมของประชาชน การเปิดเผยข้อมูล การติดตามตรวจสอบและประเมินผลการปฏิบัติงาน ทั้งนี้ตามความเหมาะสมของแต่ละภารกิจ”",
    source:
      "สำนักงานเลขาธิการสภาผู้แทนราษฎร. การปรับปรุงระบบกฎหมายที่เกี่ยวข้องเพื่อเสริมสร้างธรรมาภิบาล ประสิทธิภาพและการพัฒนาบุคลากรภาครัฐ : ร่างพระราชบัญญัติการมีส่วนร่วมของประชาชนในกระบวนการนโยบายสาธารณะ, 25 กันยายน 2562. https://library2.parliament.go.th/giventake/content_nrsa2558/d052459-03.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ก"
  },
  {
    keyword: "กฎหมายทางทะเล",
    meaning:
      "สภาพความมีอยู่ของกฎหมายทะเลที่เป็นหลักสากล ต้องกล่าวถึงกฎหมายระหว่างประเทศว่าด้วยทะเลซึ่งเป็นแม่บทของบรรดากฎหมายทางทะเลอื่น ๆ ทั้งหมด มีลักษณะควบคุมกิจกรรมหรือเหตุการณ์ทางทะเลเป็นการเฉพาะเรื่องที่มีผลกระทบต่อการควบคุมการใช้ประโยชน์จากทะเล การควบคุมพฤติกรรมของผู้ใช้ทะเล และการสนับสนุนให้มีการอนุรักษ์และใช้ประโยชน์จากมหาสมุทรและทรัพยากรทางทะเลอย่างยั่งยืน ได้แก่ อาทิ 1) อนุสัญญาสหประชาชาติว่าด้วยกฎหมายทะเล ค.ศ. 1982 ทำให้มีหลักกฎหมายในการจัดระเบียบกิจกรรมทางทะเลในทุกด้านอย่างสมบูรณ์มากขึ้น โดยมีบทบัญญัติเกี่ยวกับการกำหนดเขตและระบอบทางทะเล อำนาจและสิทธิอธิปไตยหรือสิทธิหน้าที่ใด ๆ ของรัฐในแต่ละเขตพื้นที่ การสำรวจและการใช้ทรัพยากรในส่วนพื้นดินท้องทะเลและมหาสมุทรและบริเสณใต้พื้นที่เหล่านั้นที่อยู่นอกเขตอำนาจแห่งรัฐ ครอบคลุมไปถึงการเดินเรือ ช่องแคบที่ใช้สำหรับการเดินเรือระหว่างประเทศ สิทธิของเรือรบในการขึ้นตรวจตรา และอื่น ๆ 2) กฎหมายและความตกลงระหว่างประเทศด้านการเดินเรือและความปลอดภัยทางทะเล 3) กฎหมายและความตกลงระหว่างประเทศด้านมลพิษทางทะเล 4) กฎหมายและความตกลงระหว่างประเทศด้านความรับผิดและการชดเชยความเสียหาย 5) กฎหมายและความตกลงระหว่างประเทศด้านความมั่นคงทางทะเล เช่น อนุสัญญาสหประชาชาติว่าด้วยการต่อต้านอาชญากรรมข้ามชาติที่จัดตั้งในลักษณะองค์กร ค.ศ. 2000 6) กฎหมายและความตกลงระหว่างประเทศที่เกี่ยวกับการทำประมง 7) กฎหมายและความตกลงระหว่างประเทศที่เกี่ยวกับทรัพยากรและสิ่งแวดล้อม 8) กฎหมายและความตกลงระหว่างประเทศที่เกี่ยวกับแรงงานทางทะเล",
    source:
      "สำนักงานสภาความมั่นคงแห่งชาติ. (2562, 18 กันยายน). ทะเลและมหาสมุทรและผลประโยชน์ของชาติทางทะเล, 6 ธันวาคม 2562. http://www.nsc.go.th/Lists/List3/Attachments/45 /ทะเลและมหาสมุทรและผลประโยชน์ของชาติทางทะเล.pdf",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กฎหมายประมวลรัษฎากร",
    meaning:
      "กฎหมายที่ให้อำนาจกรมสรรพากรจัดเก็บภาษี 5 ประเภทใหญ่ ๆ ได้แก่ ภาษีเงินได้บุคคลธรรมดา ภาษีเงินได้นิติบุคคล ภาษีมูลค่าเพิ่ม ภาษีธุรกิจเฉพาะ และอากรแสตมป์ ภาษีอากรแต่ละประเภทมีลักษณะและวิธีการจัดเก็บที่แตกต่างกัน",
    source:
      "กรมสรรพากร. (2561). ประเภทภาษีอากร, 5 กรกฎาคม 2562. https://www.rd.go.th/publish/38055.0.html",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ก"
  },
  {
    keyword: "กฎหมายลำดับรอง",
    meaning:
      "กฎหมายลำดับรองมีสถานะเป็นกฎหมายและมีผลใช้บังคับเป็นการทั่วไปเช่นเดียวกับกฎหมายระดับพระราชบัญญัติ แต่มีสถานะต่ำกว่ากฎหมายระดับพระราชบัญญัติ โดยการออกกฎหมายลำดับรองต้องอาศัยอำนาจตามบทบัญญัติแห่งกฎหมายระดับพระราชบัญญัติเท่านั้น และบทบัญญัติของกฎหมายลำดับรองจะขัดหรือแย้งต่อกฎหมายระดับพระราชบัญญัติมิได้ หากเรื่องใดกฎหมายระดับพระราชบัญญัติมิได้บัญญัติไว้แจ้งชัดให้ออกกฎหมายลำดับรองกำหนดรายละเอียดในเรื่องใด ฝ่ายบริหารจะออกกฎหมายลำดับรองกำหนดรายละเอียดในเรื่องนั้นมิได้",
    source:
      "ปกรณ์ นิลประพันธ์. (2558). ปฏิรูปกฎหมายลำดับรอง: การปฏิรูปที่จับต้องได้จริง, 5 กรกฎาคม 2562. http://lawdrafter.blogspot.com/2015/01/blog-post.html",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ก"
  },
  {
    keyword: "กทปส.",
    meaning:
      "กองทุนวิจัยและพัฒนากิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคม เพื่อประโยชน์สาธารณะ (กทปส.) มีหน้าที่ส่งเสริมและสนับสนุนการวิจัยและพัฒนาด้านกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคม รวมถึงการพัฒนาบุคลากร การคุ้มครองผู้บริโภค การดำเนินการให้ประชาชนได้รับการบริการอย่างทั่วถึง ตลอดจนสนับสนุนการดำเนินการตามกฎหมายว่าด้วยกองทุนพัฒนาสื่อปลอดภัยและสร้างสรรค์และสนับสนุนการใช้คลื่นความถี่ให้เกิดประสิทธิภาพสูงสุด",
    source:
      "กองทุนวิจัยและพัฒนากิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคม เพื่อประโยชน์สาธารณะ. รู้จักกับ กองทุน กทปส., 5 กรกฎาคม 2562. https://btfp.nbtc.go.th/",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ก"
  },
  {
    keyword: "กรรมสิทธิ์",
    meaning:
      "ความเป็นเจ้าของทรัพย์สิทธิทั้งปวงที่ผู้เป็นเจ้าของมีอยู่เหนือทรัพย์สิน ในอันที่จะใช้สอย จำหน่าย ได้ดอกผล ติดตามและเอาคืน รวมทั้งขัดขวางมิให้ผู้อื่นสอดเข้าเกี่ยวข้องกับทรัพย์สินนั้นโดยมิชอบด้วยกฎหมาย\r\n",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. กรรมสิทธิ์, 10 มิถุนายน 2562. http://www.royin.go.th/dictionary",
    sappear: 4,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กรรมาธิการ",
    meaning:
      "กรรมาธิการสามัญหรือกรรมาธิการวิสามัญ มีอำนาจหน้าที่พิจารณากระทำกิจการ หรือศึกษาเรื่องใดๆอันอยู่ในอำนาจหน้าที่ของสภาหรือตามที่สภามอบหมาย",
    source:
      "ข้อบังคับการประชุมสภาปฏิรูปแห่งชาติ พ.ศ. 2557. (2557, 4 พฤศจิกายน). ราชกิจจานุเบกษา เล่มที่ 131 ตอนพิเศษ 221ง หน้า 1, 2 สิงหาคม 2562. http://www.ratchakitcha.soc.go.th/DATA/PDF/2557/E/221/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "กรอบความคิดแบบเติบโต (Growth Mindset)",
    meaning:
      "ความเชื่อว่าคุณสมบัติพื้นฐานที่เรามีเป็นสิ่งที่ พัฒนาได้ด้วยความพยายาม ถึงจะมีความแตกต่างกันในทุกๆ ด้านของแต่ละบุคคล เช่น พรสวรรค์ที่ติดตัวมาแต่กำเนิด ความถนัด ความสนใจ และนิสัยใจคอ แต่ทุกคนสามารถเปลี่ยนแปลงและเติบโตได้ด้วยความพยายามและประสบการณ์ ",
    source:
      "พีรศุษย์ บุญมาธรรม, ปราโมทย์ ตงฉิน และสุกัญชลิกา บุญมาธรรม. (2561). การพัฒนากรอบความคิด(Mindset)สู่ความสำเร็จ. https://www.slideshare.net/markable33/mindset-102894166",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "กรอบความร่วมมือทางเศรษฐกิจอิรวดี–เจ้าพระยา-แม่โขง",
    meaning:
      "เป็นกรอบความร่วมมือทางเศรษฐกิจในระดับอนุภูมิภาคที่จัดตั้งขึ้นเพื่อใช้ประโยชน์จากความแข็งแกร่งและความหลากหลายของทั้งห้าประเทศสมาชิก (กัมพูชา ลาว เมียนมาร์ ไทย และเวียดนาม )เพื่อส่งเสริมการพัฒนาอย่างสมดุล",
    source:
      "กรมเศรษฐกิจระหว่างประเทศ กองส่งเสริมเศรษฐสัมพันธ์และความร่วมมือ. (2555). ยุทธศาสตร์ความร่วมมือทางเศรษฐกิจ อิรวดี - เจ้าพระยา – แม่โขง, 25 มิถุนายน 2562. http://www.mfa.go.th/business/th/cooperation/245/16231-%E0%B8%A2%E0%B8%B8%E0%B8%97%E0%B8%98%E0%B8%A8%E0%B8%B2%E0%B8%AA%E0%B8%95%E0%B8%A3%E0%B9%8C%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%A3%E0%B9%88%E0%B8%A7%E0%B8%A1%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%97%E0%B8%B2%E0%B8%87%E0%B9%80%E0%B8%A8%E0%B8%A3%E0%B8%A9%E0%B8%90%E0%B8%81%E0%B8%B4%E0%B8%88%E0%B8%AD%E0%B8%B4%E0%B8%A3%E0%B8%A7%E0%B8%94%E0%B8%B5---%E0%B9%80%E0%B8%88%E0%B9%89%E0%B8%B2%E0%B8%9E%E0%B8%A3%E0%B8%B0%E0%B8%A2%E0%B8%B2.html",
    sappear: 2,
    mappear: 5,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กรอบยั่งยืนทางการคลัง",
    meaning:
      "การกำหนดกฎเกณฑ์ทางการคลัง (Fiscal Rules) ที่มีตัวชี้วัดและเป้าหมายที่ชัดเจน โดยรัฐบาลจะใช้กรอบความยั่งยืนทางการคลังเพื่อเป็นแนวทางในการกำหนดวงเงินงบประมาณรายจ่ายประจำปี และการบริหารจัดการทางด้านการคลัง รวมทั้งนำมาพิจารณาร่วมกับแผนและมาตรการดำเนินการตามนโยบายของรัฐบาล",
    source:
      "สำนักงานเศรษฐกิจการคลัง กระทรวงการคลัง. (2550). วิธีการจัดทำข้อมูลเพื่อการบริหารความเสี่ยงด้านการคลัง, 1 สิงหาคม 2562. http://www2.fpo.go.th/FPO/index2.php?mod=Content&file=contentview&contentID=CNT0003006&categoryID=CAT0000146",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กรอบอนุสัญญาสหประชาชาติ (UNFCCC)",
    meaning:
      "โครงการสิ่งแวดล้อมแห่งสหประชาชาติ (United Nations Environment Programme: UNEP) ร่วมกับองค์การอุตุนิยมวิทยาโลก (World Meteorological Organization: WMO) ได้จัดตั้งคณะกรรมการระหว่างรัฐบาลด้านการเปลี่ยนแปลงสภาพภูมิอากาศ (Intergovernmental Panel on Climate Change: IPCC) ขึ้นเมื่อปี ค.ศ. 1988 โดยมีวัตถุประสงค์เพื่อศึกษาวิเคราะห์ข้อมูลทางวิทยาศาสตร์ที่เกี่ยวข้องกับประเด็นการเปลี่ยนแปลงสภาพภูมิอากาศ และเพื่อเตรียมมาตรการและกลยุทธ์ที่เป็นไปได้ในการบริหารจัดการที่เกี่ยวข้องกับการเปลี่ยนแปลงสภาพภูมิอากาศ โดยในปี ค.ศ. 1990 IPCC ได้จัดทำรายงานที่มีข้อสรุปยืนยันว่ากิจกรรมต่างๆ ของมนุษย์ส่งผลกระทบต่อสภาพภูมิอากาศจริง ประกอบกับในปีนั้นได้มีการจัดการประชุม Second World Climate Conference ขึ้น จึงทำให้ปัญหาการเปลี่ยนแปลงสภาพภูมิอากาศเป็นเรื่องที่อยู่ในความสนใจของนานาประเทศ",
    source:
      "สำนักงานนโยบายและแผนพลังงาน (สนพ.) กระทรวงพลังงาน. (2559). กรอบอนุสัญญาสหประชาชาติ (UNFCCC), 25 กันยายน 2562. http://www.eppo.go.th/index.php/th/plan-policy/climatechange/unitednation/unfccc",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ก"
  },
  {
    keyword: "กระแสโลกาภิวัตน์",
    meaning:
      "กระแสการเปลี่ยนแปลงที่เกิดขึ้นอย่างกว้างขวางทำให้เกิดการติดต่อด้านเศรษฐกิจระหว่างประเทศ  การสร้างตลาดการค้า  การแข่งขัน  การส่งออก  การบริการ  การลงทุน  และองค์ความรู้ เทคโนโลยีร่วมสมัย ผู้บริโภคได้รับประโยชน์จากความเจริญก้าวหน้า  ความรวดเร็วในการใช้เทคโนโลยีใหม่ สินค้านำเข้าราคาถูกลง  ทำให้เกิดการแข่งขันระหว่างประเทศ\r\n\r\n ",
    source:
      "ดร.จรวยพร ธรณินทร์ กรรมการในคณะกรรมการสภาการศึกษา อดีตปลัดกระทรวงศึกษาธิการ อดีตกรรมการพิทักษ์ระบบคุณธรรม. (2548). ข้อมูลโลกาภิวัตน์, 11 กันยายน 2562. http://www.moe.go.th/charuaypon/works/word_charuaypon_108.doc",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "กระแสสังคม",
    meaning:
      "ความคิดเห็นของคนส่วนใหญ่ในสังคมที่มีอิทธิพลต่อการดำเนินการเรื่องใดเรื่องหนึ่ง เช่น กระแสสังคมกดดันให้ตำรวจไม่ดำเนินคดีกับเด็กที่ผิดกฎหมาย",
    source:
      "พจนานุกรม ฉบับราชบัณฑิตยสถาน พ.ศ. 2552. กระแสสังคม, 29 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "ก"
  },
  {
    keyword: "กระบวนการยุติธรรม",
    meaning:
      " วิธีดำเนินการให้ความคุ้มครองสิทธิเสรีภาพและให้ความเป็นธรรมในทางกฎหมายแก่บุคคลโดยบุคลากรและองค์กร หรือ สถาบันต่างๆ ซึ่งมีหน้าที่บริหารงานยุติธรรม ได้แก่ พนักงานฝ่ายปกครองหรือตำรวจ พนักงานสอบสวน พนักงานอัยการ ทนายความ ศาลกระทรวงยุติธรรม และกรมราชทัณฑ์ อีกความหมายหนึ่ง กระบวนการยุติธรรม หมายถึง การดำเนินการคดีเมื่อมีข้อพิพาทเกิดขึ้น ระหว่างผู้เสียหายร้องทุกข์ต่อเจ้าพนักงาน มีการสืบสวนหาข้อเท็จจริงกับผู้กระทำผิด จนถึงการฟ้องร้อง ต่อศาลทั้งในกรณีของคดีแพ่งและคดีอาญา",
    source:
      "สำนักงานศาลรัฐธรรมนูญ. กระบวนการยุตธรรมในระบอบประชาธิปไตย 100 ปี , 6 มิถุนายน 2562. http://www.constitutionalcourt.or.th/occ_web/ewt_dl_link.php?nid=1467",
    sappear: 4,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กระบวนการยุติธรรมชุมชน",
    meaning:
      "แนวคิดที่เน้นให้ชุมชนเข้ามามีส่วนร่วมในการดำเนินกิจกรรมเพื่ออำนวยความยุติธรรม สร้างความเป็นธรรมและความสงบสุขในสังคมด้วยคนในชุมชนเองเพื่อให้สอดคล้องกับสภาพปัญหาและความต้องการของชุมชน ซึ่งเป็นการให้ความสำคัญกับความเข้าใจปัญหาในระดับพื้นที่และกระบวนการแก้ปัญหา โดยถือเป็นหุ้นส่วนกับภาครัฐในการป้องกัน ควบคุม การจัดการความขัดแย้ง และการแก้ไขฟื้นฟูผู้กระทำผิดในชุมชน รวมถึงการลดการพึ่งพิงผู้มีอำนาจและลดการผลักความรับผิดชอบให้สถาบัน",
    source:
      "พลตำรวจเอก ชัชวาล สุขสมจิตร์ วิทยาลัยรัฐธรรมนูญ สำนักงานศาลรัฐธรรมนูญ. หลักนิติธรรมกับการเข้าถึงความยุติธรรมของประชาชน: ยุติธรรมชุมชน, 6 ธันวาคม 2562. http://www.constitutionalcourt.or.th/occ_web/ewt_dl_link.php?nid=1408",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กระบวนทัศน์",
    meaning:
      "หรือ paradigm คือ กรอบความคิดหรือแนวทางทั่วไปที่ใช้ในการมองโลก หรือหมายถึง ระบบคิด วิธีคิด หรือแบบของการคิดที่ใช้เป็นแนวในการศึกษาวิจัยเรื่องใดเรื่องหนึ่ง หรือเป็นแนวในการจัดระบบในสังคม",
    source:
      "สำนักงานราชบัณฑิตยสภา พ.ศ. 2550. กระบวนทัศน์. 6 มิถุนายน 2562. http://www.royin.go.th/?knowledges=กระบวนทัศน์-๑๘-เมษายน-๒๕",
    sappear: 5,
    mappear: "2,10,18",
    rappear: 2,
    firstalpha: "ก"
  },
  {
    keyword: "กลไกการแข่งขันของตลาดเสรี",
    meaning:
      "เป็นตลาดสินค้าหรือบริการที่มีการปล่อยให้เป็นไปตามอุปสงค์และอุปทานหรือกลไกตลาด ค่อยกำหนดราคาและปริมาณการซื้อขายอย่างเสรี โดยปราศจากการแทรกแซงใด ๆ จากรัฐบาล ระบบเศรษฐกิจที่ส่งเสริมตลาดเสรีเรียกว่าระบบเศรษฐกิจแบบตลาดเสรี",
    source:
      "สำนักนโยบายการออมและการลงทุน. ศัพท์น่ารู้เกี่ยวกับเศรษฐกิจ, 31 ตุลาคม 2562. http://www2.fpo.go.th/S-I/Source/word/Word.php?Language=Thai&BeginRec=1355&NumRecShow=8&sort=1&search=",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "กลไกการจ่ายค่าตอบแทนการให้บริการของระบบนิเวศ",
    meaning:
      "เป็นวิธีการหรือกลุ่มของวิธีการต่างๆ ที่วางอยู่บนหลักการ “ผู้ที่ได้รับประโยชน์เป็นผู้จ่าย” ซึ่งจะส่งผลให้เกิดแรงจูงใจในการใช้ทรัพยากรอย่างมีประสิทธิภาพมากขึ้น โดยการสร้างแรงจูงใจทางเศรษฐกิจ เพื่อให้เกิดการอนุรักษ์ฟื้นฟูระบบนิเวศให้เกิดความยั่งยืน",
    source:
      "สำนักวางแผนการเกษตร ทรัพยากรธรรมชาติและสิ่งแวดล้อม: สำนักงานคณะกรรมการพัฒนาการเศรษฐกิจและสังคมแห่งชาติ . (2554). การจ่ายค่าตอบแทนการให้บริการของระบบนิเวศ Payment for Ecosystem Service: PES, 16 กันยายน 2562. http://www.nesdb.go.th/ewt_w3c/ewt_dl_link.php?nid=2699",
    sappear: 2,
    mappear: 6,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กลไกคาร์บอนเครดิต",
    meaning:
      'กลไกทางการตลาดที่สนับสนุนการลดก๊าซเรือนกระจก โดยกำหนดให้ปริมาณก๊าซเรือนกระจกที่ลดได้ หรือ “คาร์บอนเครดิต” เป็นสินค้าสำหรับการซื้อขายได้ใน "ตลาดคาร์บอน" ซึ่งตามทฤษฎีเศรษฐศาสตร์แล้ว กลไกการตลาดดังกล่าวจะเป็นการทำให้ต้นทุนของการลดปล่อยก๊าซเรือนกระจกต่ำที่สุด ตลาดคาร์บอนสามารถแยกออกได้เป็น 2 กลุ่ม ได้แก่ 1) ตลาดทางการ 2)ตลาดแบบสมัครใจ',
    source:
      "องค์การบริหารก๊าซเรือนกระจก, คาร์บอนเครดิตและสถานการณ์ตลาด. http://www.tgo.or.th/2015/thai/content.php?s1=15&s2=50",
    sappear: 2,
    mappear: 6,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กลยุทธ์",
    meaning:
      "แนวทางที่ทำให้องค์กรประสบความสำเร็จหรือเกิดการได้เปรียบทางการแข่งขัน โดยเป็นการกำหนด\r\n 1. องค์กรจะเข้าไปแข่งขันที่ไหน (Where to compete) เพื่อบอกให้รู้ว่าองค์กรจะเติบโตอย่างไรและเติบโตเข้าไปในธุรกิจไหนอย่างไร และการเติบโตเข้าไปในธุรกิจนั้นจะช่วยทำให้องค์กรประสบความสำเร็จได้อย่างไร\r\n 2. องค์กรจะแข่งขันในธุรกิจนั้นอย่างไร (How to compete) เพื่อบอกให้รู้ว่าองค์กรจะสร้างความแตกต่างและคุณค่าในสายตาของลูกค้าอย่างไร",
    source:
      "จุฬาวิทยานุกรม. (2554) กลยุทธ์, 13 มิถุนายน 2562. http://www.chulapedia.chula.ac.th/index.php?title=%E0%B8%81%E0%B8%A5%E0%B8%A2%E0%B8%B8%E0%B8%97%E0%B8%98%E0%B9%8C",
    sappear: "",
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กล่อมเกลาทางสังคม",
    meaning:
      "กระบวนการอบรมสั่งสอนสมาชิกในสังคมโดยครอบครัว กลุ่มเพื่อน สถาบันการศึกษา ศาสนา กลุ่มอาชีพ และสื่อมวลชน เพื่อให้สมาชิกของสังคมเรียนรู้ระเบียบวินัยของสังคม และตระหนักในคุณค่าของความดี โดยนำเอาคุณความดี ระเบียบ วินัยนั้นๆไปเป็นแนวทางประพฤติตนให้เป็นคนดีมีคุณธรรม",
    source:
      "ดำรงค์ ชลสุข. (2561). หลักสูตรต้านทุจริตศึกษา : กับการขัดเกลาทางสังคม, 27 มิถุนายน 2562. https://www.matichon.co.th/columnists/news_1020640",
    sappear: "",
    mappear: 21,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่ม OEMs",
    meaning:
      "ย่อมาจาก Original Equipment Manufacturer หมายถึง การรับจ้างผลิตสินค้าให้กับแบรนด์ต่าง ๆ ตามแบบที่ลูกค้ากำหนด มักจะเป็นโรงงานเปิดใหม่ ๆ หรือโรงงานที่ไม่เน้นการสร้างแบรนด์ของตนเอง และโรงงานที่ไม่มีความชำนาญในการออกแบบผลิตภัณฑ์ประโยชน์ที่ได้รับจากการทำ OEM สามารถแบ่งได้เป็น 2 ด้านดังนี้\r\n1. ด้านผู้ประกอบการ OEM \r\n- ไม่ต้องลงทุนด้านการวิจัยและออกแบบผลิตภัณฑ์ รวมถึงการออกแบบตราสินค้า \r\n- ประหยัดค่าใช้จ่ายในการโฆษณาและประชาสัมพันธ์สินค้า \r\n- ลดความเสี่ยงทางด้านการหาตลาดเอง\r\n2. ด้านผู้จ้างผลิตสินค้า\r\n- ลดต้นทุนการผลิต โดยสามารถย้ายฐานการผลิตไปยังประเทศที่มีต้นทุนการผลิตต่ำได้\r\n- เจ้าของแบรนด์ไม่จำเป็นต้องมีโรงงานเป็นของตัวเอง ซึ่งทำให้เกิดความคล่องตัวหากต้องเปลี่ยนลักษณะหรือกลยุทธ์ทางธุรกิจ",
    source:
      "กรมส่งเสริมอุตสาหกรรม กองโลจิสติกส์. โครงการสร้างนักจัดการโลจิสติกส์และซัพพลายเชนมืออาชีพ\r\nระดับสากล 17 กุมภาพันธ์, 10 มิถุนายน 2562.  http://www.logistics.go.th/en/news-article/etc-article/5311-2015-02-17",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มเปราะบาง",
    meaning:
      "บุคคลที่ต้องการการดูแลเป็นพิเศษ ต้องการการสนับสนุน การปกป้องเพราะปัจจัยทางด้านอายุ ความพิการ ความเสี่ยงต่อการถูกกระทำหรือถูกเพิกเฉย",
    source:
      "มูลนิธิศูนย์วิจัยและติดตามความเป็นธรรรมทางสุขภาพ. รายงานฉบับสมบูรณ์การสังเคราะห์องค์ความรู้และสถานการณ์การขับเคลื่อนนโยบายสาธารณะประเด็นสิทธิด้านสุขภาพของกลุ่มเปราะบาง, 11 ตุลาคม 2562. https://kbphpp.nationalhealth.or.th/bitstream/handle/123456789/7743/Report%20Final%20Revised%20Sila%202%20Complete%20%E0%B8%9B%E0%B8%B5%2060.pdf?sequence=1&isAllowed=y",
    sappear: "",
    mappear: 17,
    rappear: 9,
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคเหนือตอนบน",
    meaning:
      "กลุ่มจังหวัดภาคเหนือตอนบน 1 ประกอบด้วย จังหวัดเชียงใหม่ จังหวัดแม่ฮ่องสอน จังหวัดลําปาง และจังหวัดลําพูน โดยให้จังหวัดเชียงใหม่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด\r\nกลุ่มจังหวัดภาคเหนือตอนบน 2 ประกอบด้วย จังหวัดเชียงราย จังหวัดน่าน จังหวัดพะเยาและจังหวัดแพร่ โดยให้จังหวัดเชียงรายเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคเหนือตอนล่าง",
    meaning:
      "กลุ่มจังหวัดภาคเหนือตอนล่าง 1 ประกอบด้วย จังหวัดตาก จังหวัดพิษณุโลก จังหวัดเพชรบูรณ์ จังหวัดสุโขทัย และจังหวัดอุตรดิตถ์ โดยให้จังหวัดพิษณุโลกเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด\r\nกลุ่มจังหวัดภาคเหนือตอนล่าง 2 ประกอบด้วย จังหวัดกําแพงเพชร จังหวัดนครสวรรค์ จังหวัดพิจิตร และจังหวัดอุทัยธานี โดยให้จังหวัดนครสวรรค์เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคใต้ชายแดน",
    meaning:
      "จังหวัดนราธิวาส จังหวัดปัตตานี จังหวัดยะลา โดยให้จังหวัดยะลาเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคใต้ฝั่งอันดามัน",
    meaning:
      "จังหวัดกระบี่ จังหวัดตรัง จังหวัดพังงา จังหวัดภูเก็ต จังหวัดระนอง และจังหวัดสตูล โดยให้จังหวัดภูเก็ตเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคใต้ฝั่งอ่าวไทย",
    meaning:
      "จังหวัดชุมพร จังหวัดนครศรีธรรมราช จังหวัดพัทลุง จังหวัดสุราษฎร์ธานี และจังหวัดสงขลา โดยให้จังหวัดสุราษฎร์ธานีเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคกลางตอนกลาง",
    meaning:
      "จังหวัดนนทบุรี จังหวัดปทุมธานี จังหวัดนครปฐมและจังหวัดสมุทรปราการ โดยให้จังหวัดนครปฐมเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคกลางตอนบน",
    meaning:
      "จังหวัดชัยนาท จังหวัดพระนครศรีอยุธยา จังหวัดลพบุรี จังหวัดสระบุรี จังหวัดสิงห์บุรี และจังหวัดอ่างทอง โดยให้จังหวัดพระนครศรีอยุธยาเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคตะวันออก",
    meaning:
      "กลุ่มจังหวัดภาคตะวันออก 1 ประกอบด้วย จังหวัดฉะเชิงเทรา จังหวัดชลบุรี และจังหวัดระยอง โดยให้จังหวัดชลบุรีเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด\r\nกลุ่มจังหวัดภาคตะวันออก 2 ประกอบด้วย จังหวัดจันทบุรี จังหวัดตราด จังหวัดนครนายกจังหวัดปราจีนบุรี และจังหวัดสระแก้ว โดยให้จังหวัดปราจีนบุรีเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนกลาง",
    meaning:
      "จังหวัดกาฬสินธุ์ จังหวัดขอนแก่น จังหวัดมหาสารคาม และจังหวัดร้อยเอ็ด โดยให้จังหวัดขอนแก่นเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนบน",
    meaning:
      "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนบน 1 ประกอบด้วย จังหวัดบึงกาฬ จังหวัดเลย จังหวัดหนองคาย จังหวัดหนองบัวลําภู และจังหวัดอุดรธานี โดยให้จังหวัดอุดรธานีเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนบน 2 ประกอบด้วย จังหวัดนครพนม จังหวัดมุกดาหาร และจังหวัดสกลนคร โดยให้จังหวัดสกลนครเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนล่าง",
    meaning:
      "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนล่าง 1 ประกอบด้วย จังหวัดชัยภูมิจังหวัดนครราชสีมา จังหวัดบุรีรัมย์ และจังหวัดสุรินทร์ โดยให้จังหวัดนครราชสีมาเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด\r\nกลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนล่าง 2 ประกอบด้วย จังหวัดยโสธรจังหวัดศรีสะเกษ จังหวัดอํานาจเจริญ และจังหวัดอุบลราชธานี โดยให้จังหวัดอุบลราชธานีเป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด",
    source:
      "ประกาศคณะกรรมการนโยบายการบริหารงานจังหวัดและกลุ่มจังหวัดแบบบูรณาการ เรื่อง การจัดตั้งกลุ่มจังหวัดและกำหนดจังหวัดที่เป็นศูนย์ปฏิบัติการของกลุ่มจังหวัด (ฉบับที่ 3). (2560, 17 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 281 ง หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/281/14.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มชาติพันธุ์",
    meaning:
      "กลุ่มชนที่มีความแตกต่างทางวัฒนธรรมและมีจิตสำนึกของความเป็นชาติพันธุ์ของตนเอง ",
    source:
      "ศูนยฺมานุษยวิทยาสิรินธร. (ม.ป.ป). ข้อมูลสำคัญเกี่ยวกับกลุ่มชาติพันธุ์ : ความหมายและการเรียกชื่อ, 11 มิถุนายน 2562. http://www.sac.or.th/databases/ethnicredb/more_information.php",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "ก"
  },
  {
    keyword:
      "กลุ่มประเทศความริเริ่มแห่งอ่าวเบงกอลสำหรับความร่วมมือหลากหลายสาขาทางวิชาการและเศรษฐกิจ",
    meaning: "บังกลาเทศ ภูฏาน อินเดีย เมียนมาร์ เนปาล ศรีลังกา และไทย",
    source:
      "กองส่งเสริมเศรษฐสัมพันธ์และความร่วมมือ กรมเศรษฐกิจระหว่างประเทศ. (2557). กรอบความร่วมมือเศรษฐกิจระหว่างประเทศ, 26 กันยายน 2562. http://www.mfa.go.th/business/th/cooperation/245/42516-%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%A3%E0%B8%B4%E0%B9%80%E0%B8%A3%E0%B8%B4%E0%B9%88%E0%B8%A1%E0%B9%81%E0%B8%AB%E0%B9%88%E0%B8%87%E0%B8%AD%E0%B9%88%E0%B8%B2%E0%B8%A7%E0%B9%80%E0%B8%9A%E0%B8%87%E0%B8%81%E0%B8%AD%E0%B8%A5%E0%B8%AA%E0%B8%B3%E0%B8%AB%E0%B8%A3%E0%B8%B1%E0%B8%9A%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%A3%E0%B9%88%E0%B8%A7%E0%B8%A1%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%AB%E0%B8%A5%E0%B8%B2%E0%B8%81%E0%B8%AB%E0%B8%A5%E0%B8%B2%E0%B8%A2.html",
    sappear: "",
    mappear: 9,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มประเทศอินโดจีน",
    meaning: " ประกอบด้วย ประเทศเมียนมาร์ ไทย ลาว เวียดนาม และกัมพูชา ",
    source:
      "ดร.ธนิต โสรัตน์ รองประธานสภาอุตสาหกรรมแห่งประเทศไทย. (2555). “คาบสมุทรอินโดจีนบทบริบทใหม่เอเซีย”, 26 กันยายน 2562. https://www.bot.or.th/Thai/MonetaryPolicy/NorthEastern/Doclib_seminar55/Seminar_Tanit%20-%207%20Sep%202012.pdf",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มผู้ด้อยโอกาส",
    meaning:
      "ผู้ที่ประสบปัญหาความเดือดร้อน และได้รับผลกระทบในด้านเศรษฐกิจ สังคม การศึกษา สาธารณสุข การเมือง กฎหมาย วัฒนธรรม ภัยธรรมชาติและภัยสงคราม รวมถึงผู้ที่ขาดโอกาสที่จะเข้าถึงบริการขั้นพื้นฐานของรัฐ อันจะส่งผลให้ไม่สามารถดำรงชีวิตได้เท่าเทียมกับผู้อื่น ได้แก่ คนยากจน คนเร่ร่อน คนไร้สัญชาติ ผู้พ้นโทษ ผู้ติดเชื้อเอสไอวี ผู้ป่วยเอดส์และครอบครัว",
    source:
      "กรมพัฒนาสังคมและสวัสดิการ.(2561) ประกาศคณะกรรมการสร้างเสริมกิจการเพื่อสังคมแห่งชาติ ว่าด้วยหลักเกณฑ์และวิธีการยื่นคำขอหนังสือรับรองกิจการเพื่อสังคม พ.ศ. 2561.http://61.19.50.68/dsdw/buzzfile/20180516154233-498.pdf",
    sappear: 4,
    mappear: 17,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มพลังสร้างข้อรังเกียจทางสังคม (Social Sanction)",
    meaning:
      "ปรากฏการณ์ที่เกิดขึ้นกับทุกสังคมในโลกมาเป็นเวลานับพันปี โดยทั่วไปจุดมุ่งหมายของการลงโทษโดยสังคมเป็นไปเพื่อสร้างความอับอายขายหน้าให้แก่ผู้ถูกกระทำ เพื่อให้บุคคลผู้นั้นต้องปรับเปลี่ยนแก้ไขทัศนคติและพฤติกรรมตนเองเสียใหม่เพื่อให้สามารถอยู่ร่วมกับชุมชนหรือสังคมนั้นๆ ให้ได้หากเขาผู้นั้นยังปรารถนาที่จะดำรงชีพอยู่ร่วมกับชุมชนต่อไปในบางกรณีที่รุนแรง ชุมชนหรือสังคมอาจลงโทษโดยการขับไล่บุคคลหรือครอบครัวของบุคคลนั้นให้ต้องหลบหนีไปจากชุมชนดั้งเดิม กล่าวได้ว่าการลงโทษโดยสังคมเป็นกลไกชนิดหนึ่งของสังคมมาตั้งแต่ยุคโบราณในการควบคุมสังคมของตนเองให้อยู่ในภาวะที่มีดุลยภาพ",
    source:
      "วารสารสังคมศาสตร์ คณะรัฐศาสตร์ จุฬาลงกรณ์มหาวิทยาลัย. (2559). การลงโทษโดยสังคม, 7 ตุาคม 2562. http://www.library.polsci.chula.ac.th/dl/3d4544c2e1ea646620900c074bc665e9",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "ก"
  },
  {
    keyword: "กลุ่มวิสาหกิจ",
    meaning:
      "กิจการของชุมชนเกี่ยวกับการผลิตสินค้า การให้บริการหรือการอื่น ๆ ที่ดำเนินการโดยคณะบุคคลที่มีความผูกพัน มีวิถีชีวิตร่วมกันและรวมตัวกันประกอบกิจการดังกล่าว ไม่ว่าจะเป็นนิติบุคคลในรูปแบบใด หรือไม่เป็นนิติบุคคล เพื่อสร้างรายได้และเพื่อการพึ่งพาตนเองของครอบครัว ชุมชนและระหว่างชุมชน",
    source:
      "กองส่งเสริมวิสาหกิจชุมชน กรมส่งเสริมการเกษตร. วิสาหกิจชุมชนน่ารู้, 9 ตุลาคม 2562. http://www.sceb.doae.go.th/Ssceb2.htm",
    sappear: 4,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กองทุน",
    meaning: "กองทุนเพื่อความเสมอภาคทางการศึกษา",
    source:
      "พระราชบัญญัติ กองทุนเพื่อความเสมอภาคทางการศึกษา\r\nพ.ศ. 2561. (2561, 13 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 33 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 12,
    firstalpha: "ก"
  },
  {
    keyword: "กองทุน Social Investment Fund (SIF)",
    meaning:
      "เป็นกองทุนที่มุ่งให้การสนับสนุนโดยตรงแก่องค์กรหรือชุมชนระดับท้องถิ่นเพื่อเพิ่มพูนศักยภาพและเสริมสร้างความเข้มแข็งแก่องค์กรหรือชุมชนระดับรากหญ้า",
    source:
      "ธนาคารโลก สำนักงานประเทศไทย.(2543). อิมแพค ธนาคารโลกและประเทศไทย, 4 กันยายน 2562. http://documents.worldbank.org/curated/en/305521468132604962/pdf/275150Thai0impact1no120oct100.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "กองทุนประกันภัย",
    meaning:
      "สัญญาทางการเงินบนพื้นฐานของการศึกษาคณิตศาสตร์ประกันภัยเกี่ยวกับรูปแบบขาดทุนของประชากรจำนวนมาก การประกันภัยให้ วิธีการลดความสูญเสียทางการเงินจากเหตุการณ์ไฟไหม้ โจรกรรม เป็นต้นโดยการชำระเงิน (เบี้ยประกัน) เพื่อครอบคลุมค่าใช้จ่ายกรณีที่เกิดขึ้น",
    source:
      "ณรงค์พล โชตเศรษฐ์ และ กฤติพร ศรียะพันธ์ สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ. (2554). อภิธานศัพท์สำหรับองค์ความรู้การกำกับดูแลโครงสร้างและกิจการสาธารณูปโภค, 1 พฤศจิกายน 2562. http://regulationbodyofknowledge.org/wp-content/uploads/2013/04/glossary_THAI.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "กองทุนสุขภาพ",
    meaning:
      "กองทุนหลักประกันสุขภาพแห่งชาติ กองทุนสวัสดิการรักษาพยาบาล ข้าราชการ และกองทุนประกันสังคม",
    source:
      "สถาบันวิจัยระบบสาธารณสุข. (2555).  ลดความเหลื่อมล้ำ เพิ่มความเป็นธรรม “3 กองทุนสุขภาพ” รับความท้าทายในอนาคต, 16 ตุลาคม 2562. file:///C:/Users/admin/AppData/Local/Temp/Rar$DIa0.656/hsri_forum_v1_n6_nov2012.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ก"
  },
  {
    keyword: "กับดักของการเป็นประเทศรายได้ปานกลาง (Middle Income Trap)",
    meaning:
      "สภาวะของประเทศที่สามารถพัฒนาจากประเทศรายได้ต่ำไปเป็นรายได้ปานกลางได้สำเร็จในเวลานาน (ค่าว่า “รายได้” ในที่นี้ หมายถึงรายได้ประชาชาติต่อจำนวนประชากร) แต่การขยายตัวของเศรษฐกิจหลังจากนั้นกลับชะลอลงมาก ส่งผลให้ประเทศดังกล่าวต้องติดอยู่ในฐานะรายได้ปานกลางต่อไป และยังไม่มีแนวโน้มที่จะยกระดับกลายเป็นประเทศรายได้สูงได้",
    source:
      "ธนาคารแห่งประเทศไทย. Middle Income Trap: กับดักเศรษฐกิจที่รอการก้าวข้าม หน้า 1, 18 กรกฎาคม 2562. https://www.bot.or.th/Thai/ResearchAndPublications/DocLib_/Article_7Nov2017.pdf",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ก"
  },
  {
    keyword: "กับดักประเทศรายได้ปานกลาง",
    meaning:
      "สภาวะของประเทศที่สามารถพัฒนาจากประเทศรายได้ต่ำไปเป็นรายได้ปานกลางได้สำเร็จในเวลานาน (ค่าว่า “รายได้” ในที่นี้ หมายถึงรายได้ประชาชาติต่อจำนวนประชากร) แต่การขยายตัวของเศรษฐกิจหลังจากนั้นกลับชะลอลงมาก ส่งผลให้ประเทศดังกล่าวต้องติดอยู่ในฐานะรายได้ปานกลางต่อไป และยังไม่มีแนวโน้มที่จะยกระดับกลายเป็นประเทศรายได้สูงได้",
    source:
      "ธนาคารแห่งประเทศไทย. Middle Income Trap: กับดักเศรษฐกิจที่รอการก้าวข้าม หน้า 1, 18 กรกฎาคม 2562. https://www.bot.or.th/Thai/ResearchAndPublications/DocLib_/Article_7Nov2017.pdf",
    sappear: "",
    mappear: 2,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กากอุตสาหกรรม",
    meaning:
      "หรือ “สิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว” หมายถึง ของเสียหรือสิ่งที่ ไม่ใช้แล้วที่เกิดจากการประกอบกิจการโรงงาน ตั้งแต่กระบวนการรับวัตถุดิบ การผลิต การตรวจสอบคุณภาพ การบำบัด มลพิษ การซ่อมบำรุงเครื่องจักร/อุปกรณ์ การรื้อถอน/ก่อสร้างอาคารภายในบริเวณโรงงาน รวมทั้งกากตะกอน หรือ สิ่งตกค้างจากสิ่งเหล่านั้น ทั้งที่อยู่ในสภาวะของแข็ง ของเหลว กึ่งแข็ง กึ่งเหลวหรือก๊าซ ทั้งนี้รวมถึงของเสียอันตรายที่เกิดจากอาคารสำนักงานและที่พักคนงานที่อยู่ภายในบริเวณโรงงาน โดยของเสียอันตรายคือสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้วที่มีองค์ประกอบหรือปนเปื้อนสารอันตราย หรือที่มีคุณสมบัติที่เป็นอันตราย",
    source:
      "กรมโรงงานอุตสาหกรรม. (2558). คู่มือการจัดการกากอุตสาหกรรม, 20 มิถุนายน 2562. https://iei.or.th/media/file/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%88%E0%B8%B1%E0%B8%94%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%81%E0%B8%B2%E0%B8%81%E0%B8%AD%E0%B8%B8%E0%B8%95%E0%B8%AA%E0%B8%B2%E0%B8%AB%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1.pdf",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กากอุตสาหกรรมอันตราย",
    meaning:
      "ของเสียหรือสิ่งที่ไม่ใช้แล้วที่เกิดจากการประกอบกิจการโรงงาน ตั้งแต่กระบวนการรับวัตถุดิบ การผลิต การตรวจสอบคุณภาพ การบำบัด มลพิษ การซ่อมบำรุงเครื่องจักร/อุปกรณ์ การรื้อถอน/ก่อสร้างอาคารภายในบริเวณโรงงาน รวมทั้งกากตะกอน หรือ สิ่งตกค้างจากสิ่งเหล่านั้น ทั้งที่อยู่ในสภาวะของแข็ง ของเหลว กึ่งแข็ง กึ่งเหลวหรือก๊าซ ทั้งนี้รวมถึงของเสียอันตรายที่เกิดจากอาคารสำนักงานและที่พักคนงานที่อยู่ภายในบริเวณโรงงาน โดยของเสียอันตรายคือสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้วที่มีองค์ประกอบหรือปนเปื้อนสารอันตราย หรือที่มีคุณสมบัติที่เป็นอันตราย",
    source:
      "กรมโรงงานอุตสาหกรรม. (2558). คู่มือการจัดการกากอุตสาหกรรม, 20 มิถุนายน 2562. https://iei.or.th/media/file/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%88%E0%B8%B1%E0%B8%94%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%81%E0%B8%B2%E0%B8%81%E0%B8%AD%E0%B8%B8%E0%B8%95%E0%B8%AA%E0%B8%B2%E0%B8%AB%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ก"
  },
  {
    keyword: "ก๊าซเรือนกระจก",
    meaning:
      "บรรดาก๊าซอันเป็นส่วนประกอบหนึ่งของบรรยากาศทั้งที่มีอยู่ตามธรรมชาติหรือที่มนุษย์สร้างขึ้น ซึ่งดูดซึมและปล่อยซ้ำรังสีอินฟาเรด",
    source:
      "พระราชกฤษฎีกาจัดตั้งองค์การบริหารจัดการก๊าซเรือนกระจก (องค์การมหาชน) พ.ศ. 2550, (2550, 6 กรกฎาคม). ราชกิจจานุเบกษา. เล่ม 124 ตอนที่ 31 ก หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2550/A/031/53.PDF",
    sappear: 5,
    mappear: 18,
    rappear: 2,
    firstalpha: "ก"
  },
  {
    keyword: "ก๊าซแบบลอยน้ำ (Floating Storage and Regasification Unit: FSRU)",
    meaning:
      "เป็นโครงการสถานีเก็บรักษาและแปรสภาพก๊าซธรรมชาติจากของเหลวเป็นก๊าซแบบลอยน้ำ เป็นโครงการที่เกิดขึ้นเพื่อการสร้างความมั่นคงในการจัดหาก๊าซธรรมชาติระยะยาว และการรองรับเชื้อเพลิงจากต่างประเทศ โดยการนำเข้าก๊าซธรรมชาติ ที่ผ่านกระบวนการเปลี่ยนสถานะเป็นก๊าซธรรมชาติเหลว (Liquefied Natural Gas – LNG) และขนส่งโดยเรือขนส่ง LNG เดินทางมายังท่าเทียบเรือประเทศปลายทาง ก่อนจะขนถ่าย LNG เข้าสู่ FSRU เพื่อแปลงสภาพเป็นก๊าซส่งเข้าสู่ท่อลำเลียงไปยังจุดหมายปลายทางต่อไป",
    source:
      "การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย. (2560). ทำความรู้จัก FSRU เบื้องต้น, 29 มิถุนายน 2562. https://www.egat.co.th/index.php?option=com_content&view=article&id=2248:fsru&catid=49&Itemid=251",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "ก๊าซโซลีนธรรมชาติ (NGL)",
    meaning:
      "ก๊าซโซลีนธรรมชาติ หรือ Natural Gasoline (NGL, C5H12) ประกอบด้วย ก๊าซเพนเทน เฮกเซนและสารประกอบตัวอื่น ๆ ที่มีคาร์บอนผสมอยู่ตั้งแต่ C5H12 ขึ้นไป NGL จะนำมากลั่นเป็นน้ำมันเบนซิน (Motor Gassoline) และสำหรับบางส่วนของก๊าซเพนเทน เฮกเซนและเฮปเทน รวมทั้งสารประกอบตัวอื่น ๆ ซึ่งมีคุณสมบัติเป็นของเหลวที่ระเหยได้เร็ว จะแยกส่งให้กับโรงงานอุตสาหกรรมปิโตรเคมีเป็นวัตถุดิบสำหรับเป็นตัวทำละลายในการทดลองทางเคมี หรืออุตสาหกรรมสีแลกเกอร์ ทินเนอร์ อุตสาหกรรมยางเป็นต้น",
    source:
      "กรมส่งเสริมคุณภาพสิ่งแวดล้อม. (2558). คลังความรู้ พลังงาน : มารู้จักประโยชน์ของก๊าซธรรมชาติ (Natural Gas) กันเถอะ, 12 กรกฎาคม 2562. https://www.deqp.go.th/knowledge/%E0%B8%9E%E0%B8%A5-%E0%B8%87%E0%B8%87%E0%B8%B2%E0%B8%99/%E0%B8%A1%E0%B8%B2%E0%B8%A3-%E0%B8%88-%E0%B8%81%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B9%82%E0%B8%A2%E0%B8%8A%E0%B8%99-%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B8%81-%E0%B8%B2%E0%B8%8B%E0%B8%98%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B8%8A%E0%B8%B2%E0%B8%95-natural-gas-%E0%B8%81-%E0%B8%99%E0%B9%80%E0%B8%96%E0%B8%AD%E0%B8%B0/",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "ก๊าซชีวภาพ",
    meaning:
      "ก๊าซที่เกิดขึ้นจากการหมักย่อยสลายของสารอินทรีย์ด้วยวิธีทางชีววิทยา (Biological Treatment) ภายใต้สภาวะไร้อากาศ (Anaerobic Condition) องค์ประกอบหลักของก๊าซชีวภาพโดยทั่วไปจะได้แก่ ก๊าซมีเทน (CH4) ประมาณ 60-70 % ก๊าซคาร์บอนไดออกไซด์ (CO2) ประมาณ 28-38 % และก๊าซอื่นๆ ประมาณ 2 % เช่น ไฮโดรเจนซัลไฟด์ (H2S) ไนโตรเจน (N2) และไอน้ำ เป็นต้น เนื่องจากก๊าซคาร์บอนไดออกไซด์ เป็นก๊าซที่คงตัวและไม่ติดไฟ ดังนั้น คุณสมบัติของก๊าซชีวภาพที่ใช้เป็นเชื้อเพลิงได้จึงขึ้นอยู่กับปริมาณของก๊าซมีเทน \r\n ประโยชน์ของก๊าซชีวภาพ \r\n 1. ใช้เป็นแหล่งเชื้อเพลิงเพื่อผลิตพลังงานความร้อนใช้ในฟาร์ม \r\n 2. ใช้ในการผลิตพลังงานกล / ไฟฟ้า \r\n 3. การผลิตพลังงานความร้อนร่วม (Cogeneration System) \r\n",
    source:
      "ผศ. ดร.พิชญ รัชฎาวงศ์ ภาควิชาวิศวกรรมสิ่งแวดล้อม ศูนย์การสื่อสารนานาชาติแห่งจุฬาลงกรณ์. ก๊าซชีวภาพ. 21 มิถุนายน 2562. http://www.chulapedia.chula.ac.th/index.php?title=ก๊าซชีวภาพ",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "ก๊าซธรรมชาติ",
    meaning:
      "สารประกอบไฮโดรคาร์บอนที่ประกอบด้วยมีเทนเป็นส่วนใหญ่ที่มีสภาพเป็นก๊าซหรือของเหลว",
    source:
      "พระราชบัญญัติ การประกอบกิจการพลังงาน พ.ศ. 2550 (2550, 10 ธันวาคม). ราชกิจจานุเบกษา. เล่ม 124 ตอนที่ 89 ก หน้า 13.  http://www.ratchakitcha.soc.go.th/DATA/PDF/2550/A/089/12.PDF",
    sappear: "",
    mappear: 7,
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "ก๊าซธรรมชาติเหลว (Liquid Natural Gas:LNG)",
    meaning:
      "ก๊าซธรรมชาติเหลว หรือ LNG เริ่มต้นจากการได้ ก๊าซธรรมชาติ (Natural Gas – NG) จากโรงแยกก๊าซธรรมชาติ นำไปผ่านกระบวนการคัดแยกจนกลายเป็นของเหลว หรือ LNG  จุดเด่นของ LNG คือ มีปริมาตรเล็กกว่าก๊าซธรรมชาติถึง 600 เท่า ทำให้สะดวกต่อการขนส่งได้ในปริมาณมากๆ สะอาด ปลอดภัย ไร้กลิ่น ปราศจากสารกัดกร่อน และติดไฟยาก เพราะเมื่อเกิดการรั่วไหล LNG จะระเหยขึ้นสู่อากาศทันที ไม่เหลือสารตกค้างในดิน โดย LNG ถูกนำมาใช้ในภาคอุตสาหกรรมกว่า 50 ปี ในการผลิตกระแสไฟฟ้า เป็นเชื้อเพลิงในยานพาหนะ และให้ความร้อนในโรงงานอุตสาหกรรม",
    source:
      "การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย. (2560). ทำความรู้จัก FSRU เบื้องต้น, 29 มิถุนายน 2562. \r\nhttps://www.egat.co.th/index.php?option=com_content&view=article&id=2248:fsru&\r\ncatid=49&Itemid=251",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "ก๊าซปิโตรเลียมเหลว (Liquefied Petroleum Gas: LPG)",
    meaning:
      "ก๊าซปิโตรเลียมที่ประกอบด้วยโพรเพน โพรพิลีน นอร์แมลบิวเทน ไอโซบิวเทน หรือบิวทิลีน อย่างใดอย่างหนึ่งหรือหลายอย่างผสมกันเป็นส่วนใหญ่",
    source:
      "พระราชบัญญัติกองทุนน้ำมันเชื้อเพลิง พ.ศ. 2562. (2562, 24 พฤษภาคม). ราชกิจจานุเบกษา. เล่มที่ 136 ตอนที่ 69 ก หน้าที่ 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/069/T_0001.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "ก๊าซมีเทน",
    meaning:
      "ก๊าซมีเทน (methane) เป็นเชื้อเพลิงผลิตกระแสไฟฟ้าเป็นหลัก แต่บางประเทศใช้เป็นวัตถุดิบตั้งต้นเพื่อผลิตเคมีภัณฑ์ เช่น เมทานอล ปุ๋ยยูเรีย เป็นต้น ",
    source:
      "ฝ่ายสื่อสารองค์กร บริษัท ปตท. จำกัด (มหาชน). (2554). สารานุกรมเปิดโลกปิโตรเคมี Petrochemical \r\nEncyclopedia, 29 สิงหาคม 2562. http://www.pttplc.com/th/Media-Center/Energy-Knowledge/\r\nDocuments/MD24%20knowledge01/PetrochemicalEncyclopedia2011.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "ก๊าซอีเทนโพรเพน",
    meaning:
      "ก๊าซอีเทน (C2) เป็นวัตถุดิบในอุตสาหกรรมปิโตรเคมีขั้นต้นเพื่อผลิตเอทิลีน ซึ่งเป็นสารตั้งต้นในการผลิตเม็ดพลาสติก เส้นใยพลาสติกโพลีเอทิลีน (PE) เพื่อใช้ผลิตเส้นใยพลาสติก และผลิตภัณฑ์พลาสติกชนิดต่าง ๆ ก๊าซโพรเพน (C3) ใช้ผลิตโพรพิลีน ซึ่งเป็นสารตั้งต้นในอุตสาหกรรมปิโตรเคมี เพื่อใช้ในการผลิตเม็ดพลาสติกโพลีโพรพิลีน (PP) เช่น ยางในห้องเครื่องยนต์ หม้อแบตเตอรี่ กาว สารเพิ่มคุณภาพน้ำมันเครื่องรวมทั้งใช้เป็นเชื้อเพลิงในโรงงานอุตสาหกรรมได้",
    source:
      "กรมเชื้อเพลิงธรรมชาติ กระทรวงพลังงาน. (2561). ปิโตรเลียมมีประโยชน์อย่างไร, 4 ตุลาคม 2562. https://dmf.go.th/public/list/data/detail/id/11266/menu/604/page/2",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "การเก็บรักษาอาหารตลอดห่วงโซ่",
    meaning:
      "การเก็บรักษาอาหารตลอดวงจรการผลิตอาหารตั้งแต่วัตถุดิบ ปัจจัยการผลิตการเพาะปลูก การเพาะเลี้ยง การตัดแต่ง การแปรรูป การขนส่ง การปรุง การประกอบ การบรรจุการเก็บรักษา การจัดจําหน่าย การกระจาย จนถึงผู้บริโภค รวมทั้งการนําเข้า การนําผ่าน และการส่งออก",
    source:
      "พระราชบัญญัติคณะกรรมการอาหารแห่งชาติ พ.ศ. 2551. (2551,31 มกราคม). ราชกิจจานุเบกษา. เล่ม 125 ตอนที่ 31 ก หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2551/A/031/39.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ก"
  },
  {
    keyword: "การเกษตรสร้างมูลค่า",
    meaning:
      "การนำผลิตผลทางการเกษตรมาแปรสภาพจากลักษณะเดิมเป็นกระบวนการผลิตไม่ซับซ้อน ซึ่งอาจเกิดจากการแปรสภาพตามธรรมชาติให้ต่างไปจากเดิมเพื่อให้ตรงกับความต้องการของผู้บริโภค ซึ่งมีทั้งสินค้าเกษตรด้านที่ไม่ใช่อาหารและด้านอาหาร",
    source:
      "สำนักงานเลขาธิการสภาผู้แทนราษฎร. (2562). การเกษตรสร้างมูลค่าตามยุทธศาสตร์ชาติ20 ป, 13 กันยายน 2562. http://library2.parliament.go.th/giventake/content_royrueng/2562/rr2562-mar2.pdf",
    sappear: 2,
    mappear: 9,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การเคารพศักดิ์ศรีความเป็นมนุษย์ (ในกระบวนการยุติธรรม)",
    meaning:
      "ศักดิ์ศรีความเป็นมนุษย์ เป็นคำอธิบายความหมายของสิทธิมนุษยชน ในแง่ของการให้คุณค่าแก่ความเป็นคน ว่าทุกคนมีคุณค่าเท่าเทียมกัน ซึ่งเป็นหลักการสำคัญของสิทธิมนุษยชนที่กำหนดสิทธิมาตั้งแต่เกิด ใครจะละเมิดไม่ได้และไม่สามารถถ่ายโอนให้แก่กันได้ ซึ่งรวมไปถึงสิทธิในการมีชีวิตและความมั่นคงในการมีชีวิตอยู่ เพราะคนทุกคนที่เกิดมาบนโลกมีศักดิ์ศรีของความเป็นมนุษย์ ดังนั้นการปฏิบัติต่อกันของผู้คนในสังคมจึงต้องเคารพความเป็นมนุษย์ ห้ามทำร้ายร่างกายหรือทรมานอย่างโหดร้าย ตลอดจนการกระทำใดๆที่ถือเป็นการเหยียดหยามความเป็นมนุษย์ ซึ่งศักดิ์ศรีความเป็นมนุษย์ได้รับการรองรับอยู่ในปฏิญญาสากลว่าด้วยสิทธิมนุษยชน กติการะหว่างประเทศ อนุสัญญา และปฏิญญาระหว่างประเทศหลายฉบับ สังคมในปัจจุบันมักจะละเลยศักดิ์ศรีความเป็นมนุษย์เพราะมีการให้คุณค่าของคนต่างกันตามสถานภาพทางสังคมของคนแต่ละคน เช่น กำนัน นายทหาร ภารโรง นายกรัฐมนตรี ซึ่งสถานภาพเหล่านั้นไม่ใช่ตัวชี้วัดว่ามนุษย์หรือคนคนนั้นมีศักดิ์ศรีของมนุษย์หรือไม่ แต่ศักดิ์ศรีของความเป็นมนุษย์ คือ การให้คุณค่าความเป็นคนตามธรรมชาติไม่ว่าจะเกิดมาเป็น ผู้ชาย ผู้หญิง กระเทย คนพิการ ปัญญาอ่อนหรือยากจน ต้องถือว่าคนทุกคนมีคุณค่าเท่ากัน ต้องปฏิบัติต่อกันเยี่ยงมนุษย์อย่างเสมอหน้ากัน เพราะถือว่าเป็นการเคารพศักดิ์ศรีความเป็นมนุษย์ด้วยกัน",
    source:
      "นายพิสิษฐ์ เหล่าศิริรัตน์ วิทยาลัยรัฐธรรมนูญ สำนักงานศาลรัฐธรรมนูญ. (2558). หลักสิทธิมนุษยชน กับ ภาคเอกชน, 19 สิงหาคม 2562. http://www.constitutionalcourt.or.th/occ_web/ewt_dl_link.php?nid=1495",
    sappear: 6,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การเงินฐานราก",
    meaning:
      "บริการทางการเงินสำหรับคนในชุมชนต่างๆโดยมีหลักการรวมเงิน รวมทุนบนพื้นฐานการพึ่งพาตนเองและการบริหารจัดการตามกรอบภูมิปัญญาชาวบ้าน ",
    source:
      "สำนักงานเศรษฐกิจการคลัง กระทรวงการคลัง. สถาบันการเงินชุมชน : Micro Finance, 6 กันยายน 2562. http://v-reform.org/wp-content/uploads/2012/06/MicroFinanceWeb.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "การเตรียมความพร้อม",
    meaning:
      "ความพยายามในการเตรียมการรับมือกับภัยพิบัติ มุ่งเน้นกิจกรรมต่าง ๆ ที่ทำให้\r\nผู้คนมีความสามารถในการคาดการณ์ เผชิญเหตุ และจัดการกับผลกระทบจาก\r\nภัยพิบัติอย่างเป็นระบบ หากมีการเตรียมความพร้อมได้ดีจะทำให้สามารถดำเนิน\r\nการต่าง ๆ ได้อย่างเหมาะสมทั้งในช่วงก่อน ระหว่าง และหลังการเกิดภัยพิบัติ\r\nและเพิ่มโอกาสในการรักษาชีวิตให้ปลอดภัยจากเหตุการณ์ภัยพิบัติได้มากขึ้น ",
    source:
      "กรมป้องกันและบรรเทาสาธารณภัย. หนังสือคำศัพท์ด้านการบริหารจัดการความเสี่ยงจากภัยพิบัติ, 9 กันยายน 2562. http://www.disaster.go.th/th/download-src.php?did=1225",
    sappear: "",
    mappear: "11,23",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "การเติบโตที่ยั่งยืน",
    meaning:
      "การพัฒนาที่ยั่งยืนเป็นการพัฒนาที่ครอบคลุมการพัฒนาในทุกด้านและทุกมิติ กล่าวคือ ทั้งเศรษฐกิจ สังคม ทรัพยากรธรรมชาติและสิ่งแวดล้อม จิตใจ วัฒนธรรม ฯลฯ โดยมีคนเป็นศูนย์กลางหรือเป้าหมายของการพัฒนา เพื่อให้คน อยู่ดี กินดี และมีความสุข ทั้งในรุ่นนี้ และรุ่นต่อ ๆ ไป",
    source:
      "สำนักงานคณะกรรมการพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. (2546). การพัฒนาที่ยั่งยืนในบริบทไทย, 19 พฤศจิกายน 2562\r\n\r\nhttps://www.nesdb.go.th/download/article/article_20150813133735.pdf",
    sappear: 4,
    mappear: 16,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword:
      "การเป็นหุ้นส่วนระหว่างรัฐและเอกชน Public-Private Partnerships (PPPs)",
    meaning:
      "การที่เอกชนร่วมลงทุนในกิจการของรัฐโดยการอนุญาต หรือให้สัมปทาน หรือให้สิทธิแก่เอกชนดําเนินกิจการของรัฐ ทั้งในกิจการเชิงพาณิชย์และสังคม ซึ่งกิจการของรัฐดังกล่าวต้องเป็นกิจการของส่วนราชการ รัฐวิสาหกิจ หน่วยงานอื่นของรัฐ หรือองค์กรปกครองส่วนท้องถิ่นมีอํานาจหน้าที่ตามกฎหมาย หรือกิจการดังกล่าวจะต้องให้ทรัพยากรธรรมชาติ หรือทรัพย์สินของส่วนราชการ รัฐวิสาหกิจ หน่วยงานอื่นของรัฐ หรือองค์กรปกครองส่วนท้องถิ่น",
    source:
      "สํานักงบประมาณของรัฐสภา. (2559). รายงานวิชาการสำนักงบประมาณของรัฐสภา: การวิเคราะห์การร่วมทุนระหว่างภาครัฐและภาคเอกชน\r\n(Public Private Partnership : PPP), 6 มิถุนายน 2562. https://library2.parliament.go.th/ebook/content-ebspa/pbo-report3-2559.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "การเปลี่ยนแปลงเชิงโครงสร้าง",
    meaning:
      "1) ข้อจำกัดด้านกำลังแรงงาน \r\n2) ความต้องการแรงงานที่เปลี่ยนแปลงไปจากเทคโนโลยีที่ก้าวหน้าขึ้น\r\n3) ระบบการศึกษาของไทยยังไม่สามารถผลิตแรงงานได้ตามความต้องการของเศรษฐกิจที่เปลี่ยนแปลงเร็ว",
    source:
      "ธนาคารแห่งประเทศไทย. (2561). ความท้าทายเชิงโครงสร้างของเศรษฐกิจไทยและการประสานนโยบายเศรษฐกิจ, 18 ตุลาคม 2562. https://www.bot.or.th/Thai/MonetaryPolicy/MonetPolicyComittee/MPR/BOX_MPR/BOX_MPR_22561_1.pdf",
    sappear: "",
    mappear: 8,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การเปลี่ยนแปลงทางเทคโนโลยีอย่างฉับพลัน ( Disruptive Technology)",
    meaning:
      "นวัตกรรมหรือเทคโนโลยีที่ถูกนำมาใช้ในการสร้างตลาดและมูลค่าให้กับตัวผลิตภัณฑ์ที่นำเทคโนโลยีมาใช้ และส่งผลกระทบอย่างรุนแรง (Disrupt) ต่อตลาดของผลิตภัณฑ์เดิมรวมทั้งอาจจะทำให้ธุรกิจที่ใช้เทคโนโลยีแบบเดิมๆได้รับผลกระทบจนต้องล้มหรือปิดกิจการไป ซึ่งจะแตกต่างจากนวัตกรรมทั่วไปที่ถูกนำมาใช้เพื่อวัตถุประสงค์ในการช่วยเพิ่มประสิทธิภาพ เพิ่มคุณภาพของสินค้า หรือลดต้นทุนกระบวนการผลิตแบบเดิมๆ เท่านั้น",
    source:
      "สำนักวิชาการ สำนักงานเลขาธิการสภาผู้แทนราษฎร. (2562). Disruptive Technology การดำรงชีวิตจะเปลี่ยนไป, 11 กันยายน 2562. https://library2.parliament.go.th/ejournal/content_af/2562/feb2562-4.pdf",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ก"
  },
  {
    keyword: "การเปลี่ยนแปลงภูมิอากาศ",
    meaning:
      "การเปลี่ยนแปลงภูมิอากาศ (climate change) คือ การเปลี่ยนแปลงลักษณะอากาศเฉลี่ย (average weather) ในพื้นที่หนึ่งซึ่งลักษณะอากาศเฉลี่ย หมายถึง ลักษณะทั้งหมดที่เกี่ยวข้องกับอากาศ เช่น อุณหภูมิ ฝน ลม เป็นต้น (ในความหมายตามกรอบของอนุสัญญาว่าด้วยการเปลี่ยนแปลงภูมิอากาศ FCCC (Framework Convention on Climate Change) \r\nการเปลี่ยนแปลงภูมิอากาศ คือ การเปลี่ยนแปลงสภาพภูมิอากาศ อันเป็นผลทางตรง หรือทางอ้อมจากกิจกรรมของมนุษย์ ที่ทำให้องค์ประกอบของบรรยากาศเปลี่ยนแปลงไป นอกเหนือจากความผันแปรตามธรรมชาติ\r\nการเปลี่ยนแปลงภูมิอากาศ (ในทางรัฐบาล)  (Intergovernmental Panel on Climate Change) คือ การเปลี่ยนแปลงสภาพภูมิอากาศ ไม่ว่าจะเนื่องมาจาก ความผันแปรตามธรรมชาติ หรือกิจกรรมของมนุษย์",
    source:
      "กรมอุตุนิยมวิทยา. การเปลี่ยนแปลงภูมิอากาศ คืออะไร?, 27 มิถุนายน 2562. http://climate.tmd.go.th/content/article/9",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การเปลี่ยนแปลงสภาพภูมิอากาศ",
    meaning:
      "การเปลี่ยนแปลงของสภาพภูมิอากาศในระยะยาว เป็นผลมาจากปรากฏการณ์\r\nโลกร้อนและกิจกรรมของมนุษย์ทั้งทางตรงและทางอ้อม ก่อให้เกิดการเปลี่ยนแปลงของอุณหภูมิ ปริมาณน้ำฝน ความถี่และความรุนแรงของการเกิดพายุ รวมถึงการเปลี่ยนแปลงของระดับน้ำทะเล และการเปลี่ยนแปลงองค์ประกอบของบรรยากาศโลก ",
    source:
      "กรมป้องกันและบรรเทาสาธารณภัย. หนังสือคำศัพท์ด้านการบริหารจัดการความเสี่ยงจากภัยพิบัติ, 9 กันยายน 2562. http://www.disaster.go.th/th/download-src.php?did=1225",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การเฝ้าระวัง",
    meaning:
      "การสังเกต การเก็บรวบรวม และการวิเคราะห์ข้อมูล ตลอดจน\r\nการรายงาน และการติดตามผลของโรคจากการประกอบอาชีพและโรคจากสิ่งแวดล้อมอย่างต่อเนื่อง\r\nด้วยกระบวนการที่เป็นระบบ เพื่อประโยชน์ในการป้องกันและการควบคุมโรค",
    source:
      "พระราชบัญญัติควบคุมโรคจากการประกอบอาชีพและโรคจากสิ่งแวดล้อม พ.ศ. 2562. (2562, 22 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 67 ก หน้า 217. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/067/T_0215.PDF",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ก"
  },
  {
    keyword: "การเฝ้าระวังและเตือนภัยทางสังคม",
    meaning:
      "กระบวนการรวบรวมข้อมูลอย่างต่อเนื่อง ภายใต้ประเด็นที่กำหนดไว้ โดยบุคลากรที่ฝึกฝนมาโดยเฉพาะ จากนั้นจึงทำการวิเคราะห์ข้อมูล แปลผล นำเสนอรายงาน และกรณีที่คาดการณ์แนวโน้มว่าอาจจะก่อความไม่ปลอดภัยต่อสาธารณะอาจต้องทำการเตือยภัยทางสังคม",
    source:
      "ณัฐจารีย์ จินดาวงศ์ มหาบัณฑิตหลักสูตรรัฐศาสตร์ มหาวิทยาลัยสุโขทัยธรรมาธิราช, ปภาวดี มนตรีวัต รองศาสตราจารย์ประจำสาขาวิชาวิทยาการจัดการ มหาวิทยาลัยสุโขทัยธรรมาธิราช, ดร.ไตรรัตน์ โภคพลากรณ์ รองศาสตราจารย์คณะรัฐศาสตร์ มหาวิทยาลัยธรรมศาสตร์. (2556). ปัจจัยจูงใจที่ส่งผลต่อการปฏิบัติงานของอาสาสมัครพัฒนาสังคมและความมั่นคงของมนุษย์จังหวัดนครศรีธรรมราชในการเฝ้าระวังและเตือนภัยทางสังคม, 3 ธันวาคม 2562. https://www.tci-thaijo.org/index.php/stou-sms-pr/article/view/16945/15272",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "ก"
  },
  {
    keyword: "การเพิ่มความสามารถในการแข่งขันของประเทศ",
    meaning:
      "ความสามารถในการแข่งขัน 3 ด้าน คือ ด้านปัจจัยนําเข้า (Input) ด้านประสิทธิภาพของกระบวนการการทํางานขององค์กร (Process) และด้านผลลัพธ์จากการแข่งขัน (Output) โดยมีเป้าหมายของการพัฒนาความสามารถในการแข่งขันเหมือนกัน คือ การยกระดับมาตรฐานการครองชีพของประชาชน ดังนั้น การควบคุมค่าจ้างแรงงานให้ต่ำและการลดค่าเงินจะสะท้อนให้เห็นว่าประเทศมีขีดความสามารถที่ต่ำมากกว่าการเพิ่มขีดความสามารถในการแข่งขัน ดังนั้น การพิจารณาความสามารถในการแข่งขันต้องเน้นที่ปัจจัยที่กําหนดขีดความสามารถในการแข่งขัน คือ ผลิตภาพหรือประสิทธิภาพการผลิต (Productivity) ซึ่งวัดจากมูลค่าเพิ่มของสินค้าและบริการที่ผลิตได้เทียบกับปริมาณปัจจัยการผลิตที่ใช้ไปหนึ่งหน่วย ดังนั้น ผลิตภาพของประเทศจึงขึ้นอยู่กับทั้งราคาของสินค้าและบริการที่ประเทศจะขายได้และประสิทธิภาพในการใช้ปัจจัยการผลิต ซึ่งประเทศที่มีผลิตภาพสูงมีค่าเงินที่แข็งแกร่งและท้ายสุดก็มีมาตรฐานการครองชีพที่สูงขึ้นตามมา ดังนั้น การยกระดับผลิตภาพจึงเป็นเป้าหมายของการพัฒนาขีดความสามารถในการแข่งขันของประเทศไม่ใช่การส่งออก",
    source:
      "สํานักงานคณะกรรมการพัฒนาขีดความสามารถในการแข่งขันของประเทศสํานักงานคณะกรรมการพัฒนาการเศรษฐกิจและสังคมแหงชาติ. (2554). ยุทธศาสตร์การพัฒนาขีดความสามารถในการแข่งขันของประเทศไทยในระยะยาว, 16 กันยายน 2562. https://www.nesdb.go.th/ewt_dl_link.php?nid=3757",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "การเพิ่มผลิตภาพ Productivity",
    meaning:
      "ประกอบด้วย 3 ส่วน ได้แก่ \r\n1. การลดต้นทุน ที่จะทำให้สามารถประหยัดภาษีของประชาชน \r\n2. การผลิตสินค้าหรือบริการได้มากขึ้นหรือมีคุณภาพที่ดีขึ้นโดยใช้งบประมาณเท่าเดิม \r\n3. การบรรลุวัตถุประสงค์ด้านความผาสุกของประชาชน",
    source:
      "สถาบันเพิ่มผลผลิตแห่งชาติ. การวัดผลิตภาพภาครัฐ, 18 ตุลาคม 2562. https://www.ftpi.or.th/2016/9965",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "การเพิ่มผลิตภาพการผลิต",
    meaning:
      "ประกอบด้วย 3 ส่วน ได้แก่ \r\n1. การลดต้นทุน ที่จะทำให้สามารถประหยัดภาษีของประชาชน \r\n2. การผลิตสินค้าหรือบริการได้มากขึ้นหรือมีคุณภาพที่ดีขึ้นโดยใช้งบประมาณเท่าเดิม \r\n3. การบรรลุวัตถุประสงค์ด้านความผาสุกของประชาชน",
    source:
      "สถาบันเพิ่มผลผลิตแห่งชาติ. การวัดผลิตภาพภาครัฐ, 18 ตุลาคม 2562. https://www.ftpi.or.th/2016/9965",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การเมืองภาคพลเมือง",
    meaning:
      "การเมืองหรือสถานการณ์ที่ประชาชนได้รับสิทธิและเสรีภาพในการเข้ามามีส่วนร่วมในกระบวนการทางนโยบาย มีการกระจายอำนาจให้ประชาชนสามารถกำหนดวิถีชีวิตของตนเองโดยไม่ละเมิดสิทธิของผู้อื่น ภายใต้กรอบของกฎหมาย โดยกิจกรรมใดทางนโยบายที่อาจเกิดผลกระทบต่อประชาชน ประชาชนจะต้องเข้ามามีส่วนร่วมตั้งแต่เริ่มแรก และประชาชนสามารถดำเนินกิจกรรมต่าง ๆ ทางการเมืองได้ด้วยตนเอง",
    source:
      "ถวิลวดี บุรีกุล. การเมืองภาคพลเมือง, 9 กรกฎาคม 2562. http://wiki.kpi.ac.th/index.php?title=%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%87%E0%B8%A0%E0%B8%B2%E0%B8%84%E0%B8%9E%E0%B8%A5%E0%B9%80%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%87",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ก"
  },
  {
    keyword: "การเสริมสร้างและรักษาดุลยภาพสภาวะแวดล้อมระหว่างประเทศ",
    meaning:
      "ส่งเสริมปฏิสัมพันธ์ในทุกระดับกับนานาประเทศ โดยเฉพาะประเทศมหาอำนาจและประเทศที่มีความสำคัญทางยุทธศาสตร์ในมิติต่างๆอย่างสมดุล พัฒนาและเสริมสร้างระบบ กลไก มาตรการ ตลอดถึงความร่วมมือระหว่างประเทศให้สามารถดำเนินไปได้อย่างมีประสิทธิภาพ สนับสนุนการแลกเปลี่ยน แบ่งปัน และใช้ประโยชน์จากข้อมูลข่าวสารด้านความมั่นคงร่วมกันอย่างกว้างขวางและต่อเนื่อง ผลักดันการหารือทั้งแบบทวิภาคีและพหุภาคีในทุกระดับอย่างสร้างสรรค์รวมทั้งเสริมสร้างความสัมพันธ์ลดความหวาดระแวงระหว่างกัน โดยอาศัยการแลกเปลี่ยนการเยือนในระดับต่าง ๆ และการจัดเวทีสนทนาแลกเปลี่ยนความคิดเห็น จนทำให้บรรยากาศการดำเนินการระหว่างประเทศในทุกเรื่องทุกขั้นตอน ดำเนินไปได้อย่างราบรื่น ต่อเนื่อง และมีเสถียรภาพอย่างแท้จริง",
    source:
      "สำนักวิชาการ สำนักเลขาธิการสภาผู้แทนราษฎร. (2561). กรอบยุทธศาสตร์ชาติด้านความมั่นคง, 11 กันยายน 2562. https://www.etda.or.th/terminology-detail/1203.html",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การเสริมสร้างความสามารถในการแข่งขัน",
    meaning:
      "การยกระดับความเป็นอยู่และสวัสดิการของประชาชนให้ดีขึ้นทั้งด้านเศรษฐกิจ สังคม สิ่งแวดล้อม ตลอดจนครอบคลุมถึงสิทธิเสรีภาพที่ประชาชนพึงได้รับเป็นสําคัญด้วย\r\n",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ, ยุทธศาสตร์การพัฒนาขีดความสามารถในการแข่งขันของประเทศไทยในระยะยาว, มกราคม 2554.\r\nhttps://www.nesdb.go.th/ewt_dl_link.php?nid=3757",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การเสริมสร้างพลังทางสังคม",
    meaning:
      "ศักยภาพที่แสดงให้เห็นและมีปฏิสัมพันธ์ในบริบทของความสัมพันธ์ทางสังคมขอบเขตการสร้างเสริมความสามารถเฉพาะตัวของปัจเจกบุคคล และศักยภาพในการถ่ายทอดสู่สังคม โดยความสัมพันธ์ทางสังคม การเสริมสร้างพลังทางสังคม ซึ่งประกอบด้วยองค์ความรู้และ\r\nตลาดแรงงาน โดยจะครอบคลุมเรื่องสัญญาว่าจ้าง โอกาสการย้ายงาน และการแบ่งเวลาให้งานและชีวิตครอบครัว การเสริมสร้างความสามารถของพวกเขาให้เข้าถึงมิติอื่น ๆ ของคุณภาพสังคม",
    source:
      "อิศราภรณ์ ชมชื่น. ปัจจัยที่มีความสัมพันธ์กับการเสริมสร้างพลังทางสังคม หน้า 8, 18 กันยายน 2562. http://libdcms.nida.ac.th/thesis6/2556/b180268.pdf",
    sappear: 4,
    mappear: "2,15",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การแข่งขันทางการค้า",
    meaning:
      "การที่ผู้ประกอบธุรกิจแต่ละราย ซึ่งอาจเป็นผู้จำหน่าย ผู้ผลิต ผู้ส่งหรือผู้นำเข้ามาในราชอาณาจักร \r\nผู้ซื้อเพื่อผลิตหรือจำหน่ายสินค้าหรือบริการอย่างหนึ่งอย่างใด สามารถที่จะกำหนดราคาหรือปริมาณการขายสินค้าหรือบริการได้โดยไม่ถูกจำกัดด้วยข้อตกลงหรือเงื่อนไขใดๆไม่ว่าโดยทางตรงหรือทางอ้อมให้ต้องระงับ ลด หรือจำกัดการบริการ การผลิต การจำหน่ายหรือส่งมอบให้ต่ำกว่าความต้องการของตลาดและไม่ถูกแทรกแซงในการประกอบธุรกิจซึ่งมีผลทำให้ราคาสินค้าและบริการเป็นไปตามความความต้องการของตลาดและผู้บริโภคหรือผู้ใช้บริการมีอิสระในการเลือกซื้อสินค้าและบริการได้อย่างเต็มที่ตามความต้องการของตนเอง",
    source:
      "พระราชบัญญัติการแข่งขันทางการค้า พ.ศ. 2542 (2542, 31 มีนาคม). ราชกิจจานุเบกษา. เล่ม 116 ตอนที่ 22 ก.ttp://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/022/7.PDF",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การแบ่งเขต",
    meaning:
      "การจัดแบ่งพื้นที่ตามลักษณะที่กำหนดขึ้น เพื่อประโยชน์ในการบริการจัดการความเสี่ยงจากภัยพิบัติ เช่น การจัดพื้นที่ประสบอุทกภัย พื้นที่เขตแผ่นดินไหว\r\n",
    source:
      "กรมป้องกันและบรรเทาสาธารณภัย. หนังสือคำศัพท์ด้านการบริหารจัดการความเสี่ยงจากภัยพิบัติ, 9 กันยายน 2562. http://www.disaster.go.th/th/download-src.php?did=1225",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ก"
  },
  {
    keyword: "การแบ่งปันผลประหยัด (Shared Saving)",
    meaning:
      "รูปแบบนี้ บริษัทจัดการพลังงาน (ESCO) เป็นผู้ลงทุน และรับความเสี่ยงค่าใช้จ่ายที่ได้ลงทุนก่อนแล้วนำเอาผลประโยชน์สุทธิของโครงการที่สามารถดำเนินการได้มาแบ่งผลประโยชน์ระหว่าง บริษัทจัดการพลังงาน (ESCO) กับผู้รับบริการ",
    source:
      "สถาบันพลังงานเพื่ออุตสาหกรรม สภาอุตสาหกรรมแห่งประเทศไทย. สัญญาพลังงาน, 2 ตุลาคม 2562. https://thaiesco.org/thai/network_contract.aspx",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "การแปรรูปเป็นเชื้อเพลิง Refuse Derived Fuel (RDF)",
    meaning:
      "ขยะมูลฝอยที่ผ่านกระบวนการจัดการต่างๆ เช่น การคัดแยกวัสดุที่เผาไหม้ได้ออกมา การฉีกหรือตัดขยะมูลฝอยออกเป็นชิ้นเล็กๆ ขยะเชื้อเพลิงที่ได้นี้จะมีค่าความร้อนสูงกว่าหรือมีคุณสมบัติเป็นเชื้อ เพลิงที่ดีกว่าการนำขยะมูลฝอยที่เก็บรวบรวมมาใช้โดยตรง เนื่องจากมีองค์ประกอบทั้งทางเคมีและกายภาพสม่ำเสมอกว่า ข้อดีของขยะเชื้อเพลิง คือ ค่าความร้อนสูง (เมื่อเปรียบเทียบกับขยะมูลฝอยที่เก็บรวบรวมมา) ง่ายต่อการจัดเก็บ การขนส่ง การจัดการต่างๆ รวมทั้งส่งผลกระทบต่อสิ่งแวดล้อมต่ำ",
    source:
      "กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน (พพ.) กระทรวงพลังงาน. ขยะเชื้อเพลิง (Refuse Derived Fuel), 28 มิถุนายน 2562. http://www.dede.go.th/ewt_news.php?nid=507&filename=waste_energy",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "การแพทย์แผนไทย",
    meaning:
      "การประกอบโรคศิลปะตามความรู้หรือตําราแบบไทยที่ถ่ายทอดและพัฒนาสืบต่อกันมา หรือตามการศึกษาจากสถานศึกษาที่คณะกรรมการรับรอง",
    source:
      "พระราชบัญญัติการประกอบโรคศิลปะ พ.ศ. 2542. (2542, 10 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 116 ตอนที่ 39 ก หน้า 29. http://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/039/28.PDF",
    sappear: "",
    mappear: "4,5",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การแพทย์แผนปัจจุบัน",
    meaning:
      "การแพทย์ที่ให้การรักษาทางยา การผ่าตัด รังสีรักษา ยาเคมีบำบัด และ วิชาแพทย์สาขาต่างๆ โดยวิชาความรู้ด้านแพทยศาสตร์ และการพยาบาล เป็นวิชาความรู้ที่แพทย์ พยาบาล ต้องผ่านการเรียน การสอน การฝึกฝน จากโรงเรียนแพทย์ โรงเรียนพยาบาล เป็นความรู้ทางวิทยาศาสตร์ ที่พิสูจน์ได้ ตรวจสอบได้ มีแหล่งที่มาจากการศึกษาถูกต้องตามหลักวิชาและหลักสถิติ มีการศึกษาวิจัย มีการเผยแพร่องค์ความรู้ และมีการรับรองจากองค์กร/ สถาบันต่างๆทั่วโลกว่า ให้ประโยชน์ต่อผู้ป่วยได้จริง",
    source:
      "สมาคมรังสีรักษาและมะเร็งวิทยาแห่งประเทศไทย. (ม.ป.ป). การแพทย์แผนปัจจุบันการแพทย์แบบต่างๆ, 18 กรกฎาคม 2562. https://www.thastro.org/การแพทย์แบบต่างๆ/",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การแพทย์แม่นยำ",
    meaning:
      "การแพทย์แม่นยํา (Precision Medicine) เป็นแนวความคิดใหม่ทางการแพทย์ใช้นวัตกรรมที่ทันสมัย นำเอาข้อมูลพันธุกรรมมนุษย์ที่ลงลึกระดับยีนมาช่วยพัฒนาให้เกิดบริการทางการแพทย์และสาธารณสุขแนวใหม่ ช่วยเปลี่ยนจากการรักษามาเป็นการป้องกันโรค ",
    source:
      "สำนักสารนิเทศ สำนักงานปลัดกระทรวงสาธารณสุข. (2561).แผนปฏิบัติการการแพทย์แม่นยำ, 26 กรกฎาคม 2562. https://pr.moph.go.th/?url=gallery/detail/3/06/112193/แผนปฏิบัติการการแพทย์แม่นยำ/",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การแพทย์ฉุกเฉิน",
    meaning:
      "การปฏิบัติการฉุกเฉิน การศึกษา การฝึกอบรม การค้นคว้าและการวิจัยเกี่ยวกับการประเมินการจัดการ \r\nการบําบัดรักษาผู้ป่วยฉุกเฉิน และการป้องกันการเจ็บป่วยที่เกิดขึ้นฉุกเฉิน",
    source:
      "พระราชบัญญัติการแพทย์ฉุกเฉิน พ.ศ. 2551. (2551, 6 มีนาคม). ราชกิจจานุเบกษา. เล่ม 125 ตอนที่ 44 ก หน้า 2.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2551/A/044/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ก"
  },
  {
    keyword: "การแพทย์ทางไกล",
    meaning:
      "การแพทย์ทางไกล (TeleMedicine) เป็นการนำเอาความก้าวหน้าด้านการสื่อสารโทรคมนาคมมาประยุกต์ใช้กับการบริการทางการแพทย์ โดยใช้การส่งสัญญาณข้อมูลภาพและเสียงผ่านสื่อ ควบคู่กับเครือข่ายคอมพิวเตอร์ ทำให้แพทย์สามารถติดต่อกันได้ด้วยภาพเคลื่อนไหวและเสียง สามารถแลกเปลี่ยนข้อมูลคนไข้ระหว่างกันและกัน พร้อมกับแลกเปลี่ยนประสบการณ์และปรึกษาหารือเสมือนว่าอยู่ในห้องเดียวกัน นอกนั้นยังสามารถนำมาใช้ประชุมปรึกษาหารือ ด้านการบริหารงาน วิชาการ และการเรียนการสอนหรือศึกษาทางไกล เป็นการนำเทคโนโลยีสารสนเทศและการสื่อสารอันทันสมัย มาช่วยสนับสนุนการปฏิบัติงานให้มีประสิทธิภาพ เพิ่มคุณภาพการให้บริการแก่ประชาชนที่อาศัยอยู่ในพื้นที่ทุรกันดาร รวมถึงพื้นที่ห่างไกลจากตัวเมืองที่ต้องใช้ระยะเวลาในการเดินทางยาวนานและมีความยากลำบากในการเดินทางเพื่อเข้าถึงบริการด้านสาธารณสุข เช่น พื้นที่บริเวณชายขอบจังหวัดทางภาพตะวันตก เป็นต้น",
    source:
      "สถาบันพัฒนาบุคลากรด้านดิจิทัลภาครัฐ Thailand Digital Government Academy. สามหน่วยงานรัฐ สธ. DE และ EGA ร่วมมือพัฒนาระบบแพทย์ทางไกล วางเครือข่ายระบบ GIN, 27 มิถุนายน 2562. https://tdga.dga.or.th/tdga_uat/index.php/en/ข่าวประชาสัมพันธ์/2017-02-28-10-56-55",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การโฆษณา",
    meaning:
      "การนำสำเนาจำลองของงานไม่ว่าในรูปหรือลักษณะอย่างใดที่ทำขึ้นโดยความยินยอมของผู้สร้างสรรค์ออกจำหน่ายโดยสำเนาจำลองนั้นมีปรากฏต่อสาธารณชนเป็นจำนวนมากพอสมควรตามสภาพของงานนั้น แต่ทั้งนี้ไม่หมายความรวมถึง การแสดงหรือการทำให้ปรากฏซึ่งนาฏกรรม ดนตรีกรรม หรือภาพยนตร์ การบรรยายหรือการปาฐกถาซึ่งวรรณกรรม การแพร่เสียงแพร่ภาพเกี่ยวกับงานใด การนำศิลปกรรมออกแสดงและการก่อสร้างงานสถาปัตยกรรม\r\n",
    source:
      "พระราชบัญญัติลิขสิทธิ์ พ.ศ. 2537 (2537,21 ธันวาคม) ราชกิจจานุเบกษา.เล่ม 111 ตอนที่ 59 ก  หน้า 4 http://www.ratchakitcha.soc.go.th/DATA/PDF/2537/A/059/1.PDF",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การโอนสิทธิการพัฒนาพื้นที",
    meaning:
      "การแลกเปลี่ยนสิทธิการพัฒนาระหว่างแปลงที่ดินของเอกชนด้วยกันโดยมีรัฐเป็นผู้รับรอง",
    source:
      "สำนักการวางแผนและพัฒนาเมือง. (2561). การประชุมหารือมาตรการทางผังเมือง แนวทาง และวิธีดำเนินการ ครั้งที่ 1 : มาตรการโอนสิทธิการพัฒนา (Transfer of Development Right หรือ TDR), 31 ตุลาคม 2562. http://plan4bangkok.com/F2_01_BMA_Plan_PM-1_TDR.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ก"
  },
  {
    keyword: "การใช้น้ำซ้ำ",
    meaning:
      "การนําน้ำทิ้งมาใช้ใหม่จะต้องพิจารณาปัจจัยหลายด้าน โดยน้ำทิ้งถูกนํามาใช้ใหม่ในกิจกรรมหลักๆ ดังนี้ \r\n1. การนํามาใช้ใหม่ในเมือง (Urban Reuse) \r\n2. การนํามาใช้ใหม่ในงานเกษตรกรรม (Agricultural Reuse) เช่น ให้น้ำพืชที่เป็นอาหาร(Food Crops) / พืชที่ไม่ใช่อาหาร (Non-Food Crops) และการปศุสัตว์ (Livestock)\r\n3. การนําน้ำมากักเก็บไว้ (Impoundments) เพื่อการพักผ่อนหย่อนใจงานปรับภูมิทัศน์(Recreational and Landscape Impoundments)\r\n4. การนำมาใช้ใหม่ในด้านสิ่งแวดล้อม (Environmental Reuse) เช่น Wetland (สัตว์ป่าและการประมง) การเพิ่มน้ำในแม่น้ำลําคลอง บรรเทาอุทกภัย ผลกระทบทางนิเวศวิทยา\r\n5. การนํามาใช้ใหม่ในอุตสาหกรรม (Industrial Reuse) เช่น Cooling Towers, Boiler Water Makeup น้ำจากกระบวนการผลิตน้ำมัน และ แก๊สธรรมชาติ\r\n6. การเติมน้ำลงใต้ดินเพื่อเพิ่มน้ำบาดาล (Ground water Recharge) เป็นน้ำใช้ (Non potable Reuse)\r\n7. การนํามาใช้ใหม่ในการบริโภค (Potable Reuse) ทั้งโดยตรง (Direct Potable Reuse) และโดยอ้อม(Indirect Potable Reuse) ",
    source:
      "คณะอนุกรรมการมาตรฐานการประกอบวิชาชีพ สภาวิศวกร. (2561). ระบบการนำน้ำทิ้งกลับมาใช้ใหม่, 18 ตุลาคม 2562. http://www.coe.or.th/coe-2/Download/Articles/ENV/CH4.pdf",
    sappear: 5,
    mappear: 19,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การใช้พลังงานในภาคอุตสาหกรรม",
    meaning:
      "ภาคอุตสาหกรรมเป็นสาขาเศรษฐกิจที่มีการใช้พลังงานมากที่สุดของประเทศไทย และมีแนวโน้มการใช้พลังงานเพิ่มขึ้นอย่างต่อเนื่อง ซึ่งจะได้รับผลกระทบจากการเปลี่ยนแปลงของสถานการณ์พลังงานหลักในตลาดโลกมากกว่าสาขาเศรษฐกิจอื่น และมีความจำเป็นที่จะต้องปรับเปลี่ยนมาใช้พลังงานทดแทนมากขึ้น เพื่อลดการพึ่งพิงการนำเข้าพลังงานจากต่างประเทศ ",
    source:
      "นางสาวศศิมา วงษ์เสรี สำนักนโยบายอุตสาหกรรมมหภาค. (2556). ไฟฟ้าจากพลังงานทดแทนกับภาคอุตสาหกรรม, 18 ตุลาคม 2562. http://www.oie.go.th/sites/default/files/attachments/article/renewable_energy.pdf",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การใช้พลังงานขั้นสุดท้าย",
    meaning:
      "พลังงานที่เกิดจากการนำพลังงานขั้นต้นมาแปรรูป ปรับปรุงคุณภาพให้สามารถใช้งานได้หลากหลาย หรือมีประสิทธิภาพมากขึ้น เช่น พลังงานปิโตเลียม พลังงานไฟฟ้า ",
    source:
      "บริษัท ปตท. จำกัด (มหาชน). รวมแหล่งพลังงานในประเทศไทยสามารถนำไปใช้ประโยชน์อะไรได้บ้าง, 23 ธันวาคม 2562. https://blog.pttexpresso.com/energy-sources-in-thailand/",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "การให้ทุนของ Angel Investor",
    meaning:
      "อยู่บนพื้นฐานการรับรองตนเองผ่านระบบของ crowdfunding portal โดยสรุปสาระสำคัญของผู้ลงทุนที่มีลักษณะเฉพาะได้ดังนี้\r\n1.ผู้ลงทุนที่มิใช้บุคคลธรรมดาซึ่งมีลักษณะดังนี้\r\n    - ผู้ให้บริการหรือเครือข่ายอิเล็กทรอนิกส์\r\n    - ผู้สนับสนุนการหาแหล่งทุนด้วยวิธีทางอิเล็กทรอนิกส์\r\n    - ผู้ลงทุนที่มีวัตถุประสงค์ในการบ่มเพาะหรือสนับสนุนทุนให้แก่กิจการ\r\n2.บุคคลธรรมดาซึ่งมีสินทรัพย์ที่นับรวมกับ คู่สมรสแล้วมีรายได้ต่อปีตั้งแต่สองล้านบาทขึ้นไปหรือมีสินทรัพย์สุทธิตั้งแต่ยี่สี่สิบล้านบาทขึ้นไป\r\n    - เป็นหรือเคยเป็นกรรมการหรือผู้บริหารหรือผู้จัดการกองทรัสต์\r\n    - เป็นหรือเคยเป็นกรรมการหรือผู้บริหารที่รับผิดชอบด้านการลงทุน",
    source:
      "สำนักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์. (2558). การกำหนดบทนิยามผู้ลงทุนที่มีลักษณะเฉพาะ(Qualified Investor)หรือ Angel Investor สำหรับการลงทุนในหลักทรัพย์ที่เสนอขายผ่านระบบหรือเครือข่ายอิเล็กทรอนิกส์ (Crowdfunding), 1 ตุลาคม 2562. https://capital.sec.or.th/webapp/phs/upload/phs1433831223hearing_11_2558.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "การให้บริการ (AFAS)",
    meaning:
      "ASEAN Framework Agreement on Services : AFAS ความตกลงระหว่างสมาชิกอาเซียน เพื่อขยายความร่วมมือด้านบริการและเปิดเสรีการค้าบริการระหว่างประเทศสมาชิกอาเซียนให้มากขึ้นเพื่อเพิ่มประสิทธิภาพในการให้บริการและเพิ่มความสามารถในการแข่งขันกับประเทศนอกกลุ่มรวมทั้งเพื่อลดอุปสรรคในการค้าบริการระหว่างประเทศสมาชิก และเพื่อเปิดเสรีการค้าบริการภายในกลุ่มสมาชิกอาเซียน",
    source:
      "สำนักนโยบายการออมและการลงทุน. (2553). ตลาดเสรี Free market, 9 กันยายน 2562. http://www2.fpo.go.th/S-I/Source/word/Word.php?Language=Thai",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "การให้บริการประชาชน (ภาครัฐ)",
    meaning:
      "มีหลักการให้บริการที่สำคัญ 5 ประการ คือ\r\n1. หลักความสอดคล้องกับความต้องการของบุคคลเป็นส่วนใหญ่ คือ ประโยชน์และบริการ\r\nที่องค์การจัดให้นั้นจะต้องตอบสนองความต้องการของบุคลากรส่วนใหญ่หรือทั้งหมด มิใช่เป็นการจัดการให้แก่บุคคลกลุ่มหนึ่งโดยเฉพาะ\r\n2. หลักความสม่ าเสมอ คือ การให้บริการนั้น ๆ ต้องด าเนินไปอย่างต่อเนื่อง สม่ าเสมอ\r\n3. หลักความเสมอภาค คือ บริการที่จัดนั้นจะต้องให้แก่ผู้มาใช้บริการทุกคนอย่างเสมอหน้า\r\nและเท่าเทียมกัน ไม่มีการให้สิทธิพิเศษแก่บุคคลหรือกลุ่มคนใดในลักษณะแตกต่างจากกลุ่มคนอื่น ๆอย่างเห็นได้ชัด\r\n4. หลักความประหยัด ค่าใช้จ่ายที่จะต้องใช้ในการบริการ จะต้องไม่มากจนเกินกว่าผลที่จะ\r\nได้รับ\r\n5. หลักความสะดวก บริการที่จัดให้แก่ผู้รับบริการ จะต้องเป็นไปในลักษณะปฏิบัติง่าย\r\nสะดวกสบาย สิ้นเปลืองทรัพยากรไม่มากนัก ทั้งยังไม่เป็นการสร้างภาวะยุ่งยากใจให้แก่ผู้ให้บริการหรือผู้ใช้บริการมากจนเกินไป",
    source:
      "สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏหมู่บ้านจอมบึง. ความพึงพอใจของผู้รับบริการ\r\nที่มีต่อคุณภาพการให้บริการของเทศบาล, 10 ตุลาคม 2562. http://www.oic.go.th/FILEWEB/CABINFOCENTER21/DRAWER006/GENERAL/DATA0000/00000095.PDF",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การไต่สวนมูลฟ้อง",
    meaning: "กระบวนไต่สวนของศาลเพื่อวินิจฉัยถึงมูลคดีซึ่งจำเลยต้องหา",
    source:
      "พระราชบัญญัติประมวลกฎหมายวิธีพิจารณาความอาญา พ.ศ. 2477 และที่แก้ไขเพิ่มเติม. http://www.krisdika.go.th/librarian/get?sysid=570066&ext=pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ก"
  },
  {
    keyword: "การกระจายความเจริญ",
    meaning:
      "การเชื่อมโยงกรุงเทพฯ - ชานเมือง และหัวเมืองใหญ่ ที่ต้องการจะกระจายความเจริญ ความแออัดออกนอกเขตเมืองกรุงเทพฯ และเมืองใหญ่",
    source:
      "กรมประชาสัมพันธ์. การกระจายความเจริญ คือการเชื่อมโยงกรุงเทพฯ-ชานเมืองและหัวเมืองใหญ่, 10 ตุลาคม 2562. https://www.youtube.com/watch?v=61beLUnK5-U",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การกระจายทรัพยากร",
    meaning:
      "การนำเอาทรัพยากรที่หาได้ยากใช้ให้เกิดประโยชน์แก่มวลมนุษย์ในสังคม จะผลิตสินค้าอะไร ผลิตในปริมาณเท่าไร และใครจะเป็นผู้บริโภค พร้อมทั้งการนำปัจจัยต่าง ๆ มาใช้ในการผลิต",
    source:
      "สำนักงานเศรษฐกิจการคลัง. ศัพท์น่ารู้เกี่ยวกับเศรษฐกิจ, 10 ตุลาคม 2562. \r\nhttp://www2.fpo.go.th/S-I/Source/word/Word.php?Language=Thai&BeginRec=430&NumRecShow=8&sort=1&search=",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ก"
  },
  {
    keyword: "การกระจายรายได้",
    meaning:
      "มี 2 ความหมาย ได้แก่\r\n 1. การกระจายรายได้ตามหน้าที่การผลิต หมายถึง การกระจายรายได้ไปยังเจ้าของปัจจัยการผลิต ได้แก่ เจ้าของปัจจัยการผลิตประเภทที่ดิน แรงงาน ทุน และการประกอบการ รายได้จะถูกจัดสรรไปยังเจ้าของปัจจัยการผลิตประเภทต่างๆมากน้อยแตกต่างกันไป แต่ส่วนใหญ่รายได้จะตกอยู่กับเจ้าของปัจจัยการผลิตประเภททุน แต่ตามความหมายนี้ไม่นิยมนำมาใช้เนื่องจากไม่สามารถชี้ให้เห็นเด่นชัดถึงความเหลื่อมล้ำของการกระจายรายได้\r\n 2. การกระจายรายได้ตามขนาด หมายถึง การกระจายรายได้ของครัวเรือนโดยเรียงลำดับตามขนาดของรายได้จากกลุ่มที่มีรายได้ต่ำสุดไปยังกลุ่มที่มีรายได้สูงสุด จากนั้นคำนวณหารายได้รวมของแต่ละกลุ่มเป็นร้อยละของรายได้รวมทั้งหมด",
    source:
      "มหาวิทยาลัยสุโขทัยธรรมาธิราช.ความยากจนและการกระจายรายได้, 21 มิถุนายน 2562. https://www.stou.ac.th/Study/Services/Sec/60335/03-05.html",
    sappear: "",
    mappear: "3,16",
    rappear: "3,5",
    firstalpha: "ก"
  },
  {
    keyword: "การกระจายสินค้า",
    meaning:
      "กิจกรรมที่เกี่ยวข้องกับการเคลื่อนย้ายถ่ายเทของวัตถุดิบ สินค้า ผลิตภัณฑ์ อะไหล่ ฯลฯ จากโรงงานผู้ผลิตไปยังผู้บริโภค กิจกรรมเหล่านี้ประกอบด้วยการขนส่ง การจัดเก็บสินค้า การควบคุมพัสดุคงคลัง การขนถ่ายวัสดุ การจัดการคำสั่งซื้อ การวิเคราะห์สถานที่ตั้งคลังสินค้าและศูนย์กระจายสินค้า การบรรจุภัณฑ์ทางอุตสาหกรรม การประมวลผลข้อมูล และการสื่อสารระหว่างเครือข่ายที่จำเป็นต่อการบริหารจัดการอย่างมีประสิทธิผล",
    source:
      "Logistics Glossary-ศัพท์โลจิสติกส์วันละคำสองคำ, 21 มิถุนายน 2562. http://logistics-glossary.blogspot.com/2015/",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การกระจายอำนาจและการสร้างสมรรถนะการบริหารจัดการบุคลากร",
    meaning:
      "รูปแบบโครงสร้างเครือข่าย องค์ประกอบและกลยุทธ์ในการบริหารจัดการงานแบบกระจายอำนาจเชิงระบบที่เกิดดุลยภาพทั้งความรู้ ความสามารถ ทักษะกระบวนการและการปฏิบัติงาน",
    source:
      "สำนักพัฒนาระบบบริหารงานบุคคลและนิติการ (Bureau of Personnel Administration Development and Legal Affairs) สำนักงานคณะกรรมการการศึกษาขั้นพื้นฐาน. รูปแบบการบริหารแบบกระจายอำนาจ “CLUSTERs”, 6 พฤศจิกายน 2562. http://personnel.obec.go.th/home/%E0%B8%A3%E0%B8%B9%E0%B8%9B%E0%B9%81%E0%B8%9A%E0%B8%9A%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%9A%E0%B8%A3%E0%B8%B4%E0%B8%AB%E0%B8%B2%E0%B8%A3%E0%B9%81%E0%B8%9A%E0%B8%9A%E0%B8%81%E0%B8%A3%E0%B8%B0%E0%B8%88",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ก"
  },
  {
    keyword: "การกระจายอำนาจให้องค์กรปกครองส่วนท้องถิ่น",
    meaning:
      "ยุทธศาสตร์หนึ่งในการบริหารจัดการบ้านเมืองของประเทศโดยการลดบทบาทหน้าที่ของราชการบริหารส่วนกลางและส่วนภูมิภาคให้เหลือแต่ภารกิจหลักที่ต้องทำเท่าที่จำเป็นและเพิ่มบทบาทให้ อปท. เข้าดำเนินการแทนโดยเฉพาะด้านการจัดบริการสาธารณะในท้องถิ่น กล่าวคือ ส่วนกลางและส่วนภูมิภาคจะดำเนินภารกิจที่เป็นงานส่วนรวมของประเทศและให้ อปท. รับผิดชอบภารกิจที่เกี่ยวข้องกับชีวิตความเป็นอยู่ของประชาชนทั้งนี้เพื่อให้การบริการสาธารณะต่างๆตอบสนองความต้องการของประชาชนได้อย่างทั่วถึงและรวดเร็วและสอดคล้องกับสภาพปัญหาของแต่ละท้องถิ่น",
    source:
      "สำนักงานคณะกรรมการการกระจายอำนาจให้แก่องค์กรปกครองส่วนท้องถิ่น . การกระจายอำนาจไปสู่ท้องถิ่น ,19 พฤศจิกายน 2562\r\nhttps://drive.google.com/file/d/1M2bQFBQTO8tWl595qgXBOeETzMj_x2xs/view",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ก"
  },
  {
    keyword: "การกระจายอำนาจไปสู่ท้องถิ่น",
    meaning:
      "เป็นยุทธศาสตร์หนึ่งในการบริหารจัดการบ้านเมืองของประเทศโดยการลดบทบาทหน้าที่ของราชการบริหารส่วนกลางและส่วนภูมิภาคให้เหลือแต่ภารกิจหลักที่ต้องทำเท่าที่จำเป็นและเพิ่มบทบาทให้ อปท. เข้าดำเนินการแทนโดยเฉพาะด้านการจัดบริการสาธารณะในท้องถิ่น กล่าวคือ ส่วนกลางและส่วนภูมิภาคจะดำเนินภารกิจที่เป็นงานส่วนรวมของประเทศและให้ อปท. รับผิดชอบภารกิจที่เกี่ยวข้องกับชีวิตความเป็นอยู่ของประชาชนทั้งนี้เพื่อให้การบริการสาธารณะต่างๆตอบสนองความต้องการของประชาชนได้อย่างทั่วถึงและรวดเร็วและสอดคล้องกับสภาพปัญหาของแต่ละท้องถิ่น",
    source:
      "สำนักงานคณะกรรมการการกระจายอำนาจให้แก่องค์กรปกครองส่วนท้องถิ่น . การกระจายอำนาจไปสู่ท้องถิ่น ,19 พฤศจิกายน 2562\r\n\r\nhttps://drive.google.com/file/d/1M2bQFBQTO8tWl595qgXBOeETzMj_x2xs/view",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ก"
  },
  {
    keyword: "การกัดเซาะชายฝั่ง",
    meaning:
      "เกิดจากธรรมชาติ เช่น ลมมรสุมและพายุหมุนเขตร้อน คลื่นลม กระแสน้ำชายฝั่ง น้ำขึ้นน้ำลง และลักษณะทางกายภาพของชายฝั่ง เป็นต้น และการกระทำของมนุษย์ เช่น การพัฒนาชายฝั่ง การบุกรุกป่าชายเลน การสูบน้ำบาดาล การสร้างเขื่อนหรือฝายกั้นน้ำ การก่อสร้างท่าเทียบเรือบริเวณชายฝั่ง และการก่อสร้างโครงการชายฝั่ง เป็นต้น",
    source:
      "กรมทรัพยากรทางทะเลและชายฝั่ง. การกัดเซาะชายฝั่ง. 21 มิถุนายน 2562. https://www.dmcr.go.th/detailAll/23991/nws/",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ก"
  },
  {
    keyword: "การขายฝาก",
    meaning:
      "สัญญาซื้อขายซึ่งกรรมสิทธิ์ในทรัพย์สินตกไปยังผู้ซื้อ   โดยมีข้อตกลงกันว่าผู้ขาย อาจไถ่ทรัพย์นั้นคืนได้",
    source:
      "กรมที่ดิน. การจดทะเบียนขายฝาก, 28 มิถุนายน 2562. http://nam.dol.go.th/lo/smt/handbook/march/news14.htm",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ก"
  },
  {
    keyword: "การข่าวกรอง",
    meaning:
      "การดำเนินการเพื่อให้ทราบถึงความมุ่งหมาย กำลังความสามารถ\r\nและความเคลื่อนไหว รวมทั้งวิถีทางของบุคคล กลุ่มบุคคล หรือองค์การใด ทั้งภายในประเทศ\r\nและต่างประเทศ ที่อาจกระทำการอันเป็นพฤติการณ์เป็นภัยคุกคาม ทั้งนี้ เพื่อรักษาความมั่นคงหรือประโยชน์แห่งรัฐและให้รัฐบาลนำมาประกอบการพิจารณาในการกำหนดนโยบายแห่งชาติ\r\n",
    source:
      "พระราชบัญญัติข่าวกรองแห่งชาติ พ.ศ. 2562. (2562, 16 เมษายน). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 50 ก หน้า 23. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/050/T_0022.PDF",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การขึ้นทะเบียนรับรองสิ่งบ่งชี้ทางภูมิศาสตร์",
    meaning:
      "การขึ้นทะเบียนสัญลักษณ์หรือสิ่งอื่นใดที่ใช้เรียกหรือใช้แทนแหล่งภูมิศาสตร์และที่สามารถบ่งบอกว่าสินค้าที่เกิดจากแหล่งภูมิศาสตร์นั้นเป็นสินค้าที่มีคุณภาพ มีชื่อเสียง หรือมีคุณลักษณะเฉพาะของแหล่งภูมิศาสตร์ดังกล่าว ซึ่งสิ่งบ่งชี้ทางภูมิศาสตร์ถือเป็นทรัพย์สินทางปัญญาประเภทหนึ่ง",
    source:
      "แสงอรุณ ยู่ไล้ ส่วนวางแผนรายภูมิภาค สำนักแผนและยุทธศาสตร์ สสว. มารู้จัก GI กันดีกว่า, 1 สิงหาคม 2562. https://www.sme.go.th/upload/mod_download/1.%E0%B8%AA%E0%B8%B4%E0%B9%88%E0%B8%87%E0%B8%9A%E0%B9%88%E0%B8%87%E0%B8%8A%E0%B8%B5%E0%B9%89%E0%B8%97%E0%B8%B2%E0%B8%87%E0%B8%A0%E0%B8%B9%E0%B8%A1%E0%B8%B4%E0%B8%A8%E0%B8%B2%E0%B8%AA%E0%B8%95%E0%B8%A3%E0%B9%8C(GI-1)(%E0%B8%9C%E0%B8%99.).pdf",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การคลังสุขภาพ",
    meaning:
      "รูปแบบระบบภาษีและระบบประกันสังคมเพื่อจัดบริการหลักประกันสุขภาพแห่งชาติซึ่งมีข้อดี คือ สอดคล้องกับบริบทของประเทศไทยที่แรงงานส่วนใหญ่อยู่ในภาคการจ้างงานแบบไม่เป็นทางการ และมีการกระจายรายได้ไม่ดีในลักษณะ “รวยกระจุก จนกระจาย” วิธีการคลังแบบผสมผสานดังกล่าวทำประเทศไทยสามารถดำเนินการสร้างหลักประกันสุขภาพครอบคลุมคนไทยทุกคนได้ ",
    source:
      "สำนักงานวิจัยเพื่อการพัฒนาหลักประกันสุขภาพไทย (สวปก.) เครือสถาบันวิจัยระบบสาธารณสุข (สวรส.). (2556). รายงานฉบับสมบูรณ์การคลังสุขภาพสำหรับระบบบริการสุขภาพพึงประสงค์, 12 กันยายน 2562. http://hisro.or.th/main/download/book025.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ก"
  },
  {
    keyword: "การคาดการณ์",
    meaning:
      "การประกาศหรือการคาดคะเนเหตุการณ์บางอย่างในอนาคต โดยอาศัยการสังเกตการณ์ ประสบการณ์ และเหตุผลทางวิทยาศาสตร์",
    source:
      "กรมป้องกันและบรรเทาสาธารณภัย. หนังสือคำศัพท์ด้านการบริหารจัดการความเสี่ยงจากภัยพิบัติ, 9 กันยายน 2562. http://www.disaster.go.th/th/download-src.php?did=1225",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การค้ามนุษย์",
    meaning:
      "การจัดหา การขนส่ง การส่งต่อ การจัดให้อยู่อาศัยหรือการรับไว้ซึ่งบุคคลด้วยวิธีการขู่เข็ญ หรือด้วยการใช้กำลัง หรือด้วยการบีบบังคับในรูปแบบอื่นใด ด้วยการลักพาตัว ด้วยการฉ้อโกง ด้วยการหลอกลวงด้วยการใช้อำนาจโดยมิชอบหรือด้วยการใช้สถานะความเสี่ยงภัยจากการค้ามนุษย์โดยมิชอบ หรือมีการให้ หรือรับเงิน หรือผลประโยชน์เพื่อให้ได้มาซึ่งความยินยอมของบุคคลผู้มีอำนาจ ควบคุมบุคคลอื่นเพื่อความมุ่งประสงค์ในการแสวงประโยชน์ การแสวงประโยชน์อย่างน้อยที่สุด ให้รวมถึงการแสวงหาประโยชน์จากการค้าประเวณีของบุคคลอื่นหรือการแสวงประโยชน์ทางเพศในรูปแบบอื่น การบังคับใช้แรงงานหรือบริการการเอาคนลงเป็นทาสหรือการกระทำอื่นเสมือนการเอาคนลงเป็นทาส การทำให้ตกอยู่ใต้บังคับ หรือการตัดอวัยวะออกจากร่างกาย",
    source:
      "กระทรวงแรงงาน. ปัญหาการค้ามนุษย์, 21 มิถุนายน 2562. http://www.mol.go.th/content/human_trafficking",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ก"
  },
  {
    keyword: "การค้าระหว่างประเทศ",
    meaning:
      "กิจกรรมการซื้อขายแลกเปลี่ยน (Exchange) สินค้าและบริการข้ามแดน โดยอาจเป็นการแลกเปลี่ยนสิ่งของกันโดยตรง (Barter System) หรือการค้าโดยใช้เงินเป็นสื่อกลาง ทำให้มีการเคลื่อนย้ายเงินทุนและวิทยาการเทคโนโลยีต่างๆ ระหว่างประเทศ  ได้แก่ การนำเข้าและส่งออกสินค้า พิธีการศุลกากร การเคลื่อนย้ายเงินทุนและวิทยาการเทคโนโลยีต่างๆ ระหว่างประเทศ การตลาดระหว่างประเทศ การค้าชายแดน",
    source:
      "สถาบันระหว่างประเทศเพื่อการค้าและการพัฒนา(สคพ.). นิยามที่เกี่ยวข้องกับการศึกษาโครงการ, 21 มิถุนายน 2562. http://164.115.41.183/?q=th/content/%E0%B8%99%E0%B8%B4%E0%B8%A2%E0%B8%B2%E0%B8%A1%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B9%80%E0%B8%81%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%A7%E0%B8%82%E0%B9%89%E0%B8%AD%E0%B8%87%E0%B8%81%E0%B8%B1%E0%B8%9A%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%A8%E0%B8%B6%E0%B8%81%E0%B8%A9%E0%B8%B2%E0%B9%82%E0%B8%84%E0%B8%A3%E0%B8%87%E0%B8%81%E0%B8%B2%E0%B8%A3",
    sappear: 2,
    mappear: 3,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การคุ้มครองทางสังคม",
    meaning:
      "การจัดระบบหรือมาตรการในรูปแบบต่างๆ เพื่อคุ้มครองสิทธิขั้นพื้นฐานของประชาชนทุกคนตามที่รัฐธรรมนูญแห่งราชอาณาจักรไทยบัญญัติไว้ ไม่ว่าจะเป็นบริการสังคม การประกันสังคม การช่วยเหลือทางสังคม การคุ้มครองอย่างเป็นทางการและไม่เป็นทางการ ซึ่งครอบคลุมถึงการจัดโครงข่ายการคุ้มครองทางสังคม (Social Safety Nets) สําหรับผู้ด้อยโอกาสและคนยากจน และการจัดการกับความเสี่ยงทางสังคม (Social Risk Management) ที่เกิดขึ้นจากวิกฤตทางเศรษฐกิจ สังคม และภัยพิบัติต่างๆ",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. (2545). รายงานการพัฒนาเศรษฐกิจและสังคมของประเทศ:ความอยู่ดีมีสุขของคนไทย, 18 กรกฎาคม 2562. http://www.nesdb.go.th/images/content/book33-45.pdf",
    sappear: "",
    mappear: 17,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การคุ้มครองผู้บริโภค",
    meaning:
      "การป้องกัน ปกป้อง ระวัง ดูแล พิทักษ์รักษา ให้อารักขา กันไว้ไม่ให้ผู้ที่ซื้อของมาใช้ ผู้กิน ผู้เสพ ผู้ใช้สอย ผู้นำมาใช้ให้เกิดประโยชน์เกิดภัยอันตราย บาดเจ็บ หรือเกิดความเสียหาย",
    source:
      "ทีมงานทรูปลูกปัญญา. (2558). การคุ้มครองผู้บริโภคหมายถึงอะไร, 28 มิถุนายน 2562. http://www.trueplookpanya.com/new/asktrueplookpanya/questiondetail/13665",
    sappear: 4,
    mappear: 17,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การคุมประพฤติ",
    meaning:
      "การสืบเสาะและพินิจ และการคุมความประพฤติผู้ถูกคุมความประพฤติให้ปฏิบัติตามเงื่อนไขที่กำหนดไว้ตามคำสั่งหรือหนังสือแจ้งของศาล หรือเจ้าพนักงานผู้มีอำนาจ รวมทั้งการใช้มาตรการแก้ไขฟื้นฟูผู้กระทำผิด",
    source:
      "พระราชบัญญัติคุมประพฤติ พ.ศ. 2559 (2559, 3 ตุลาคม). ราชกิจจานุเบกษา. เล่ม 133 ตอนที่ 88 ก\r\nหน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2559/A/088/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ก"
  },
  {
    keyword: "การจัดการเรียนรู้ตลอดชีวิต",
    meaning:
      "ขั้นตอนในการพัฒนา ดูแล ฝึกฝน อบรม บ่มเพาะ และจัดกระบวนการเรียนรู้ที่บูรณาการระหว่างการศึกษาเพื่อคุณวุฒิตามระดับในรูปแบบการศึกษานอกระบบ การศึกษาเพื่อการดำรงชีวิต และการศึกษาตามอัธยาศัย เพื่อให้บุคคลสามารถพัฒนาตนเองเพื่อประกอบอาชีพ หรือยกระดับคุณภาพชีวิตได้อย่างต่อเนื่องตลอดชีวิต",
    source:
      "สำนักงานปลัดกระทรวง กระทรวงศึกษาธิการ. ร่างพระราชบัญญัติส่งเสริมการเรียนรู้ตลอดชีวิต, 18 กันยายน 2562. https://1drv.ms/b/s!AnSQcBexe2xChk5T7gMsm4aJi_rj",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การจัดการขยะมูลฝอย",
    meaning:
      "กระบวนการจัดการขยะแบบผสมผสาน มีเป้าหมายเพื่อลดปริมาณขยะ ณ แหล่งกำเนิดขยะ ได้แก่ ครัวเรือนต่างๆ ในชุมชนเพื่อลดปัญหาและต้นทุนการจัดการขยะมูลฝอยโดยทั้งภาครัฐและประชาชนมี ส่วนร่วมทุกขั้นตอน เพื่อพัฒนาชุมชนให้สะอาดและมีคุณภาพชีวิตที่ดี",
    source:
      "มูลนิธิโลกสีเขียว. ศัพท์สิ่งแวดล้อม, 29 มิถุนายน 2562. http://greenworld.or.th/vocab_en/",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การจัดการน้้าเชิงลุ่มน้้า",
    meaning:
      "แผนการใช้ที่ดินในลุ่มน้ำ โดยมีการกำหนดวัตถุประสงค์ที่แน่นอน เช่น การควบคุมการตกตะกอนและการกัดเซาะ การควบคุมการไหลของน้ำ เพื่อส่งน้ำ หรือระบายน้ำให้แก่พื้นที่เพาะปลูกหรือป้องกันน้ำท่วม เป็นต้น",
    source:
      "กรมชลประทาน กระทรวงเกษตรและสหกรณ์. การจัดการลุ่มน้ำ หน้า 237, 2 ตุลาคม 2562. http://www.oic.go.th/iwebtemp/25630421/7053099061818146589408.PDF",
    sappear: "",
    mappear: 19,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การจัดการภัยพิบัติ",
    meaning:
      "การจัดการภัยพิบัติสมัยใหม่มีลักษณะของการเตรียมการเชิงรุก โดยมีปัจจัยเกี่ยวข้อง 3 ประการ คือ การเปลี่ยนแปลงของสถานภูมิอากาศที่ขยายตัวเป็นวงกว้างมากขึ้นและรุนแรงมากขึ้น ผู้รับความเสียหายมีจำนวนมากขึ้น และปัญหาที่เป็นผลจากภัยพิบัติต้องการการดูแลในระยะยาวมากขึ้น โดยดำเนินการด้วยวิธีต่างๆ เพื่อหลีกเลี่ยงการสูญเสียชีวิตและทรัพย์สินที่จะเกิดขึ้นจากภัยพิบัติ รวมทั้งมาตรการที่ครอบคลุมการแก้ปัญหาทั้งระยะสั้นและระยะยาว ซึ่งเป็นการวางแผนเพื่อเผชิญหน้ากับสถานการณ์ตั้งแต่ก่อนเกิดเหตุระหว่างเกิดเหตุและหลังเกิดเหตุที่ต่อเนื่องจนครบกระบวนการเรียกว่า 'วงจรการจัดการสาธารณภัย' (Disaster Management Cycle) ",
    source:
      'โครงการความร่วมมือระหว่างรัฐบาลไทยกับองค์การอนามัยโลก "แผนงานการจัดการทางด้านภัยพิบัติ". แนวคิดการจัดการภัยพิบัติ, 24 ธันวาคม 2562. http://who-rtg.com/files/content/factsheet/aw_1.pdf',
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การจัดการภาวะฉุกเฉินทางสาธารณสุข",
    meaning:
      "การเกิดโรคหรือภัยคุกคามทางสุขภาพที่ก่อให้เกิดอันตรายต่อชีวิต อาจเป็นเหตุการณ์ที่ผิดปกติไม่เคยพบมาก่อนมีผลกระทบทางสุขภาพอย่างรุนแรง มีโอกาสที่จะแพร่ไปสู่พื้นที่อื่น หรือทำให้เกิดจำกัดการเคลื่อนที่ของผู้คนหรือสินค้าโดยภาวะฉุกเฉินทางสาธารณสุขมีแนวโน้มที่จะพบได้มากขึ้นเรื่อยๆ โดยเฉพาะอย่างยิ่งภัยที่เกิดจากโรคติดต่อ",
    source:
      "กรมควบคุมโรค. (2562). แผนปฏิบัติการ ศูนย์ปฏิบัติการภาวะฉุกเฉินทางสาธารณสุข, 10 กันยายน 2562. http://122.155.1.141/site2/download-src.php?did=30582",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ก"
  },
  {
    keyword: "การจัดการสารสนเทศระบบบริการสุขภาพแห่งชาติ",
    meaning:
      "การจัดการข้อมูล ข้อความ และสารสนเทศที่เกิดจากการรักษาพยาบาล หรือบริการที่เกี่ยวกับสุขภาพแก่บุคคล รวมถึงข้อมูล ข้อความ และสารสนเทศที่เกี่ยวข้องกับการเบิกจ่ายการให้การรักษาพยาบาล หรือบริการที่เกี่ยวกับสุขภาพที่เกิดขึ้นทั้งในและนอกสถานพยาบาล",
    source:
      "สำนักกรรมาธิการ สำนักเลขาธิการสภาผู้แทนราษฎร ปฏิบัติหน้าที่สำนักงานเลขาธิการสภาขับเคลื่อนการปฏิรูปประเทศ. (2559). การจัดตั้งสำนักงานมาตรฐานและการจัดการสารสนเทศระบบบริการสุขภาพแห้งชาติ (สมสส.), 7 ตุลาคม 2562. https://library2.parliament.go.th/giventake/content_nrsa2558/d032859-14.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ก"
  },
  {
    keyword: "การจัดซื้อจัดจ้างสีเขียว",
    meaning:
      "การจัดซื้อสินค้าที่เป็นมิตรกับสิ่งแวดล้อม หรือจัดจ้างบริการที่\r\nเป็นมิตรกับสิ่งแวดล้อม ตามรายการสินค้าและบริการที่ผ่านการพิจารณาเกณฑ์ ข้อกำหนดที่เป็นมิตรกับสิ่งแวดล้อมของกรมควบคุมมลพิษ (ตะกร้าเขียว) สินค้าที่ได้ฉลากเขียว (Green Label) บริการโรงแรมที่ได้รับเกียรติบัตรใบไม้เขียว (Green Leaf) บริการโรงแรมที่ผ่านเกณฑ์สถานประกอบการที่พักสีเขียว (Green Hotel) และผลิตภัณฑ์ผ้าที่เป็นมิตรกับสิ่งแวดล้อม (Cool Mode) เป็นต้น",
    source:
      "กรมควบคุมมลพิษ. คู่มือการจัดซื้อจัดจ้างสินค้าและบริการที่เป็นมิตรกับสิ่งแวดล้อม พ.ศ. 2561, 28 มิถุนายน 2562. http://infofile.pcd.go.th/ptech/Procurement%20of%20goods%20and%20services%20Manual.pdf?CFID=2050244&CFTOKEN=63813225",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การจัดผังเมือง",
    meaning:
      "การวาง จัดทำและดำเนินการให้เป็นไปตามผังเมืองรวมและผังเมืองโดยเฉพาะในบริเวณเมืองและบริเวณที่เกี่ยวข้องหรือชนบทเพื่อสร้างหรือพัฒนาเมืองหรือส่วนของเมืองขึ้นใหม่ หรือแทนเมือง/ส่วนของเมืองที่ได้รับความเสียหายเพื่อให้มีหรือทำให้ดียิ่งขึ้น ให้มีสุขลักษณะ ความสะดวกสบาย ความเป็นระเบียบ ความสวยงาม การใช้ประโยชน์ในทรัพย์สิน ความปลอดภัยของประชาชนและสวัสดิภาพของสังคม เพื่อส่งเสริมการเศรษฐกิจและสภาพแวดล้อมเพื่อดำรงรักษาหรือบูรณะสถานที่และวัตถุที่มีประโยชน์หรือคุณค่าในทางศิลปกรรม สถาปัตยกรรม ประวัติศาสตร์ และโบราณคดี เพื่อบำรุงรักษาทรัพยากรธรรมชาติ ภูมิประเทศที่งดงามและมีคุณค่าทางธรรมชาติ",
    source:
      "พระราชบัญญัติการผังเมือง พ.ศ. 2518 (2518, 5 กุมภาพันธ์). ราชกิจจานุเบกษา. เล่ม 92 ตอน 33 ฉบับพิเศษ หน้า1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/071/T_0027.PDF",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การจัดรูปที่ดิน",
    meaning:
      "การดําเนินงานพัฒนาที่ดินที่ใช้เพื่อเกษตรกรรมให้สมบูรณ์ทั่วถึงที่ดินทุกแปลง เพื่อเพิ่มผลผลิตและลดต้นทุนการผลิต โดยทําการรวบรวมที่ดินหลายแปลงในบริเวณเดียวกัน เพื่อวางผังจัดรูปที่ดินเสียใหม่ การจัดระบบชลประทาน การจัดสร้างถนนหรือทางลําเลียงในไร่นา การปรับระดับพื้นที่ดิน การบํารุงดิน การวางแผนการผลิตและการจําหน่ายผลิตผลการเกษตร รวมตลอดถึงการแลกเปลี่ยน การโอน การรับโอนสิทธิในที่ดิน การให้เช่าซื้อที่ดิน และการอื่น ๆ ที่เกี่ยวกับการจัดรูปที่ดินเพื่อเกษตรกรรม",
    source:
      "พระราชบัญญัติจัดรูปที่ดินเพื่อเกษตรกรรม พ.ศ. 2558. (2558, 2 มีนาคม). ราชกิจจานุเบกษา. เล่ม 132 ตอนที่ 14 ก หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2558/A/014/1.PDF ",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ก"
  },
  {
    keyword: "การจัดสรรค่าภาคหลวง",
    meaning:
      "ข้อ 1  ให้กรมทรัพยากรธรณีจัดสรรค่าภาคหลวงแร่ให้แก่องค์การบริหารส่วนตำบลที่มีการจัดเก็บค่าภาคหลวงแร่นั้นในอัตราร้อยละสามสิบในกรณีที่รัฐมนตรีว่าการกระทรวงอุตสาหกรรมสั่งให้คืนค่าภาคหลวงแร่ให้แก่ผู้ใช้แร่ตามกฎหมายว่าด้วยแร่ ให้กรมทรัพยากรธรณีหักค่าภาคหลวงแร่ไว้เพื่อจ่ายคืนให้แก่ผู้ใช้แร่ก่อน แล้วจึงนำค่าภาคหลวงแร่ที่เหลือมาจัดสรรให้แก่องค์การบริหารส่วนตำบลในอัตราที่กำหนดตามวรรคหนึ่ง\r\nข้อ 2  ให้กรมทรัพยากรธรณีจัดสรรค่าภาคหลวงปิโตรเลียมให้แก่องค์การบริหารส่วนตำบลที่มีการจัดเก็บค่าภาคหลวงปิโตรเลียมนั้นในอัตราร้อยละยี่สิบค่าภาคหลวงปิโตรเลียมตามวรรคหนึ่ง ให้หมายความถึงค่าภาคหลวงปิโตรเลียมที่จัดเก็บเป็นตัวเงินเท่านั้น\r\nข้อ 3  การจัดสรรค่าภาคหลวงแร่หรือค่าภาคหลวงปิโตรเลียมที่จัดเก็บสำหรับแร่หรือปิโตรเลียมที่ผลิตได้จากประทานบัตรหรือสัมปทาน แล้วแต่กรณี ที่มีพื้นที่ตามประทานบัตรหรือสัมปทานอยู่ในเขตพื้นที่ขององค์การบริหารส่วนตำบลหลายแห่งให้กรมทรัพยากรธรณีจัดสรรค่าภาคหลวงแร่หรือค่าภาคหลวงปิโตรเลียมให้แก่องค์การบริหารส่วนตำบลนั้น ๆ แห่งละเท่ากัน\r\nข้อ 4  การจัดสรรค่าภาคหลวงแร่หรือค่าภาคหลวงปิโตรเลียม ให้จัดสรรปีละสี่งวดดังนี้\r\n\r\nงวดที่หนึ่ง ค่าภาคหลวงที่ได้รับในเดือนตุลาคมถึงเดือนธนวาคมให้จัดสรรภายในเดือนมกราคม\r\nงวดที่สอง ค่าภาคหลวงที่ได้รับในเดือนมกราคมถึงเดือนมีนาคมให้จัดสรรภายในเดือนเมษายน\r\nงวดที่สาม ค่าภาคหลวงที่ได้รับในเดือนเมษายนถึงเดือนมิถุนายนให้จัดสรรภายในเดือนกรกฎาคม\r\nงวดที่สี่ ค่าภาคหลวงที่ได้รับในเดือนกรกฎาคมถึงเดือนกันยายนให้จัดสรรภายในเดือนตุลาคม\r\n\r\nในกรณีมีความจำเป็นทำให้ไม่อาจจัดสรรค่าภาคหลวงแร่หรือค่าภาคหลวงปิโตรเลียมงวดใดได้ภายในระยะเวลาที่กำหนด ให้ขยายระยะเวลาการจัดสรรงวดนั้นออกไปตามที่รัฐมนตรีว่าการกระทรวงอุตสาหกรรมและรัฐมนตรีว่าการกระทรวงมหาดไทยจะตกลงกัน",
    source:
      "กฎกระทรวง. (2539). ออกตามความในพระราชบัญญัติสภาตำบลและองค์การบริหารส่วนตำบล, 4 ตุลาคม 2562. http://web.krisdika.go.th/data/law/law2/%CA52/%CA52-2b-2539-001.htm",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "การจัดอันดับโดยสถาบันการจัดการนานาชาติ (IMD)",
    meaning:
      "สถาบันการจัดการนานาชาติ (International Institute for Management Development: IMD) เป็นสถาบันระดับโลกที่จัดอันดับความสามารถในการแข่งขันของประเทศต่างๆ ทั่วโลก โดยมุ่งเน้นความสามารถของประเทศในการสร้างและรักษาสภาวะแวดล้อมทางเศรษฐกิจให้เอื้อต่อการเสริมสร้างและพัฒนาความสามารถในการแข่งขันของภาคธุรกิจทั้งในระดับประเทศและระหว่างประเทศ ซึ่งจะนำไปสู่ความมั่งคั่งในระยะยาว โดยมีการประกาศผลการจัดอันดับในเดือนพฤษภาคมของทุกปี โดยเกณฑ์การจัดอันดับพิจารณาจากปัจจัยของประเทศที่เสริมสร้างและพัฒนาความสามารถในการแข่งขันฯ ประกอบด้วย 4 กลุ่มหลัก 5 กลุ่มย่อย",
    source:
      "ศูนย์เทคโนโลยีสารสนเทศการขนส่งและจราจร. (2561). อันดับความสามารถในการแข่งขันของประเทศไทย ปี 2561, 13 กันยายน 2562. http://www.otp.go.th/uploads/tiny_uploads/DataStatistics/2562/25230823-IMD2018.pdf\r\n",
    sappear: "",
    mappear: 23,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การจัดอันดับโดยสภาเศรษฐกิจโลก (WEF) ",
    meaning:
      "สภาเศรษฐกิจโลก (World Economic Forum : WEF) เป็นองค์กรที่มีการจัดอันดับความสามารถในการแข่งขันของประเทศทั่วโลกที่เป็นสมาชิกและเผยแพร่ผ่านทาง The Global Competitiveness Report หรือรายงานความสามารถในการแข่งขัน โดยใช้ดัชนีความสามารถในการแข่งขันระดับโลก หรือที่เรียกว่า Global Competitiveness Index (GCI) เป็นตัวชี้วัดเปรียบเทียบในด้านต่างๆโดยเกณฑ์การจัดอันดับความสามารถในการแข่งขันของ WEF พิจารณาจากปัจจัยของประเทศที่ส่งเสริมให้มีการเจริญเติบโตทางเศรษฐกิจอย่างต่อเนื่องและยั่งยืน ประกอบด้วย 3 ปัจจัย (Factors) 12 เสาหลัก (Pillars) และ 123 เกณฑ์ชี้วัด \r\n\r\n",
    source:
      "ศูนย์เทคโนโลยีสารสนเทศการขนส่งและจราจร. (2561). ผลการจัดอันดับการประเมินคุณภาพโครงสร้างพื้นฐานของประเทศไทย \r\nโดยสภาเศรษฐกิจโลก (WEF), 13 กันยายน 2562. \r\nhttp://www.otp.go.th/uploads/tiny_uploads/Public/2560/04-April/04-25590907-WEF.pdf",
    sappear: "",
    mappear: 23,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การจัดอันดับประสิทธิภาพระบบบริการสุขภาพ",
    meaning:
      "เป็นการจัดอันดับ 56 ประเทศที่มีความคุ้มค่าด้านระบบดูแลสุขภาพ โดยใช้การคำนวณเปรียบเทียบระหว่างค่าใช้จ่ายกับอายุขัยโดยเฉลี่ยของคนในประเทศ",
    source:
      "Bloomberg. Bloomberg Health-care efficiency index. 15 พฤศจิกายน 2562. https://www.bloomberg.com/news/articles/2018-09-19/u-s-near-bottom-of-health-index-hong-kong-and-singapore-at-top",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การจ้างเหมาบริการ",
    meaning:
      "การจ้างเหมาบริการของส่วนราชการในปัจจุบัน เป็นการดำเนินการตามแนวทางการลดขนาดกำลังคนของส่วนราชการและให้ภาคเอกชนเข้ามามีส่วนร่วมในกิจกรรมภาครัฐมากขึ้น",
    source:
      "สำนักงานเลขาธิการสภาผู้แทนราษฎร สำนักงบประมาณของรัฐสภา. (2562). จ้างเหมาบริการ, 9 สิงหาคม 2562. https://www.parliament.go.th/ewtadmin/ewt/parbudget/ewt_dl_link.php?nid=387",
    sappear: "",
    mappear: 20,
    rappear: 2,
    firstalpha: "ก"
  },
  {
    keyword: "การจ่ายไฟฟ้า แบบ Firm",
    meaning: "สัญญาที่มีความแน่นอน มีการตกลงปริมาณการซื้อ-ขายที่ชัดเจน",
    source:
      "วุฒิกร สติฐิต รองกรรมการผู้จัดการใหญ่หน่วยธุรกิจก๊าซธรรมชาติ บริษัท ปตท. จำกัด (มหาชน). ความรู้เบื้องต้นเกี่ยวกับก๊าซธรรมชาติ, 10 ตุลาคม 2562. https://www.thailand-energy-academy.org/assets/upload/coursedocument/file/62_02_26%20-%20Gas%20World%20(%E0%B8%AA%E0%B8%B3%E0%B8%AB%E0%B8%A3%E0%B8%B1%E0%B8%9A%20Public)_0.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "การจ่ายไฟฟ้า แบบ Non-firm",
    meaning: "สัญญาที่ไม่แน่นอน สามารถเปลี่ยนแปลงปริมาณการซื้อ – ขายได้",
    source:
      "วุฒิกร สติฐิต รองกรรมการผู้จัดการใหญ่หน่วยธุรกิจก๊าซธรรมชาติ บริษัท ปตท. จำกัด (มหาชน). ความรู้เบื้องต้นเกี่ยวกับก๊าซธรรมชาติ, 10 ตุลาคม 2562. https://www.thailand-energy-academy.org/assets/upload/coursedocument/file/62_02_26%20-%20Gas%20World%20(%E0%B8%AA%E0%B8%B3%E0%B8%AB%E0%B8%A3%E0%B8%B1%E0%B8%9A%20Public)_0.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "การชะล้างพังทลายของดิน",
    meaning:
      "กระบวนการที่เกิดจากการที่มีแรง ซึ่งอาจเกิดจากน้ำ ลม หรือแรงโน้มถ่วงของโลก มากระทำให้วัตถุธาตุหรือสารแตกแยกออกจากกัน แล้วเคลื่อนย้ายออกอนุภาคของดินหรือวัตถุธาตุดังกล่าวไปตกตะกอนทับถมอีกแห่งหนึ่ง",
    source:
      "นิติพัฒน์ นวมมะโน มหาวิทยาลัยสงขลานครินทร์. การชะล้างของดินบนเขาคอหงส์ และมูลค่าการสูญเสียทางเศรษฐกิจ, 10 กันยายน 2562. http://kb.psu.ac.th/psukb/bitstream/2010/9027/1/373933.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ก"
  },
  {
    keyword: "การชาร์จประจุ",
    meaning:
      "การอัดประจุแบตเตอรี่โดยเชื่อมต่อยานยนต์ไฟฟ้าเข้ากับแหล่งจ่ายไฟฟ้าโดยตรงผ่านสายเคเบิล (หรือสายชาร์จ) ซึ่งเป็นตัวนำไฟฟ้า การอัดประจุไฟฟ้าวิธีนี้จะอาศัยหลักการนำไฟฟ้าผ่านตัวนำไฟฟ้า โดยพลังงานไฟฟ้าจะไหลจากแหล่งจ่ายไฟฟ้าผ่านสายเคเบิลเข้าสู่แบตเตอรี่ของยานยนต์ไฟฟ้า ซึ่งถือเป็นรูปแบบการอัดประจุไฟฟ้าที่มีการใช้งานแพร่หลายในปัจจุบัน เนื่องจากสามารถติดตั้งได้ง่าย มีประสิทธิภาพสูง และสามารถใช้ได้ทั้งการอัดประจุไฟฟ้ากระแสสลับและกระแสตรง",
    source:
      "การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย การไฟฟ้านครหลวง การไฟฟ้าส่วนภูมิภาค. (2559). รายงานแผนพัฒนาโครงสร้างพื้นฐานด้านไฟฟ้าเพื่อรองรับยานยนต์ไฟฟ้าของประเทศไทย, 6 พฤศจิกายน 2562. http://www.eppo.go.th/images/Infromation_service/studyreport/EV_plan.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "การชำระเงินทางอิเล็กทรอนิกส์",
    meaning:
      "การชำระค่าสินค้าและบริการหรือโอนเงินผ่านเครือข่ายอินเทอร์เน็ต  โดยผู้ใช้บริการสามารถเลือกชำระค่าสินค้าและบริการได้ในรูปแบบต่างๆ",
    source:
      "ศูนย์คุ้มครองผู้ใช้บริการทางการเงิน ธนาคารแห่งประเทศไทย. การชำระเงินผ่านอินเทอร์เน็ต (Internet Payment), 1 สิงหาคม 2562.  https://www.1213.or.th/th/serviceunderbot/payment/Pages/internet-payment.aspx",
    sappear: "",
    mappear: 8,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การดำเนินการแบบเบ็ดเสร็จ (One Stop Service)",
    meaning:
      "แนวคิดที่ต้องการอำนวยความสะดวกแก่ผู้มาติดต่อให้สามารถรับบริการต่างๆ ได้ ณ ที่แห่งเดียว แทนที่การติดต่อหลายแห่ง ทำให้ได้รับความสะดวกสบายประหยัดเวลา และค่าใช้จ่าย ทั้งยังลดภาระค่าใช้จ่ายของหน่วยงาน สามารถใช้ร่วมกันทั้งสถานที่ บุคลากร ตลอดจนเครื่องมือเครื่องใช้ต่างๆ นอกจากนี้ การให้บริการแบบจุดเดียวเบ็ดเสร็จ One-Stop Service ยังอาจหมายถึง การนำงานที่ให้บริการทั้งหมดที่เกี่ยวข้อง มารวมให้บริการอยู่ในที่เดียวกัน ในลักษณะที่ส่งต่องาน ระหว่างกันทันทีหรือเสร็จในขั้นตอนหรือเสร็จในจุดให้บริการเดียว โดยมีจุดประสงค์เพื่อให้การให้บริการมีความรวดเร็วขึ้น รูปแบบของการให้บริการแบบจุดเดียวเบ็ดเสร็จ มีได้หลายรูปแบบที่สำคัญ คือ\r\n1) การนำหลายหน่วยงานมารวมให้บริการอยู่ในสถานที่เดียวกัน เป็นการนำงานหลายขั้นตอนที่ต้องผ่านหลายหน่วยงานมารวมกันไว้ให้บริการอยู่ในสถานที่เดียวกัน\r\n2) กระจายอำนาจมาให้หน่วยงานใดหน่วยงานหนึ่งทำหน้าที่ให้บริการแบบเบ็ดเสร็จ เป็นการกระจายอำนาจไปให้เจ้าหน้าที่ของหน่วยงานใดหน่วยงานหนึ่งเป็นผู้ที่ทำหน้าที่ให้บริการแทนทั้งหมด โดยมีเจ้าหน้าที่เพียงคนเดียวทำหน้าที่ให้บริการเบ็ดเสร็จทั้งหมด\r\n3) การปรับปรุงและออกแบบใหม่ในการให้บริการ รูปแบบนี้อาจใช้วิธีการปรับลดหรือยุบรวมขั้นตอน (reprocess) หรือการสร้างใหม่ (redesign) \r\n4) การให้บริการผ่านทางอินเทอร์เน็ตได้เสร็จทันที การให้บริการผ่านทางอินเทอร์เน็ตได้เสร็จทันที\r\n",
    source:
      "กระทรวงเทคโนโลยีสารสนเทศและการสื่อสาร. (2559). แผนพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม, 12 กันยายน 2562. http://www.mdes.go.th/assets/portals/1/files/590613_4Digital_Economy_Plan-Book.pdf",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ก"
  },
  {
    keyword: "การดำเนินงาน",
    meaning:
      "การนําแผนที่วางไว้แล้วไปปฏิบัติอันเป็นการทํางานของผู้ปฏิบัติงานที่เริ่มต้นกลับด้านกันกับการวางแผน คือ (1) การนําทรัพยากรตามปริมาณและคุณภาพที่ได้รับการจัดสรรไปใช้ตาม (2) กระบวนการที่วางไว้โดยจะต้องเป็นไปตามมาตรฐานต่างๆ เช่น ขั้นตอน กฏเกณฑ์เวลาค่าใช้จ่าย พฤติกรรมที่กําหนด อันจะเป็นผลให้องค์กรได้รับ (3) ผลงานตามที่คาดหมายไว้ในแผนทั้งในเชิงปริมาณคุณภาพและเวลา อันจะทําให้เกิด (4) ผลลัพธ์ที่จะยังประโยชน์ต่อองค์การ ดังที่กําหนดเจตนารมณ์เชิงกลยุทธ์ไว้\r\n",
    source:
      "ทัศนีย์ ผลชานิโก ผู้เชี่ยวชาญเฉพาะด้านวิชาการประชาสัมพันธ์ กรมประชาสัมพันธ์. การวางแผนการประชาสัมพันธ, 5 กันยายน 2562. https://www.prd.go.th/ewt_dl_link.php?nid=124417",
    sappear: "",
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การดำเนินงานเชิงยุทธ์",
    meaning:
      "การวางแผนหลอมรวมครอบคลุมกิจกรรมทั้งหมดขององค์การ หรือแผนงานใหญ่ขององค์การ โดยจะระบุไว้ “อย่างกว้าง” และ “มองไกล” ไปพร้อมๆกัน ซึ่งมักจะเป็นแผนระยะยาว 5 - 10 ปี ซึ่งจะต้องสอดคล้องกับแผนระดับนโยบาย",
    source:
      "กองบัญชาการศึกษา สำนักงานตำรวจแห่งชาติ. ศาสตร์และศิลป์ในการวางแผน, 6 พฤศจิกายน 2562. http://edupol.org/eduOrganize/publicDoc/project/composePlan/sumarizeComposePlan.pdf",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ก"
  },
  {
    keyword: "การดำเนินงานแบบบูรณาการ",
    meaning:
      "การนําแผนที่วางไว้แล้วไปปฏิบัติอันเป็นการทํางานของผู้ปฏิบัติงานที่เริ่มต้นกลับด้านกันกับการวางแผน คือ (1) การนําทรัพยากรตามปริมาณและคุณภาพที่ได้รับการจัดสรรไปใช้ตาม (2) กระบวนการที่วางไว้โดยจะต้องเป็นไปตามมาตรฐานต่างๆ เช่น ขั้นตอน กฏเกณฑ์เวลาค่าใช้จ่าย พฤติกรรมที่กําหนด อันจะเป็นผลให้องค์กรได้รับ (3) ผลงานตามที่คาดหมายไว้ในแผนทั้งในเชิงปริมาณคุณภาพและเวลา อันจะทําให้เกิด (4) ผลลัพธ์ที่จะยังประโยชน์ต่อองค์การ ดังที่กําหนดเจตนารมณ์เชิงกลยุทธ์ไว้\r\n",
    source:
      "ทัศนีย์ ผลชานิโก ผู้เชี่ยวชาญเฉพาะด้านวิชาการประชาสัมพันธ์ กรมประชาสัมพันธ์. การวางแผนการประชาสัมพันธ, 5 กันยายน 2562. https://www.prd.go.th/ewt_dl_link.php?nid=124417",
    sappear: 6,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การดำเนินงานร่วมกัน (Joint Key Performance Indicators)",
    meaning:
      "ตัวชี้วัดระหว่างกระทรวงที่มีเป้าหมายร่วมกัน (Joint KPIs)\r\nหลักการ Joint KPIs โดยกําหนดให้มี Joint KPIs 3 ระดับ ดังนี้\r\n1. Impact JKPIs จะถูกกําหนดเป็นตัวชี้วัด Joint KPIs ในคํารับรองฯ เฉพาะกระทรวง/ส่วนราชการที่เป็นเจ้าภาพหลักในแต่ละเรื่อง น้ำหนักแล้วแต่ความเหมาะสม\r\n2. Outcome JKPIs จะถูกกําหนดเป็นตัวชี้วัด Joint KPIs ในคํารับรองฯ เฉพาะกระทรวง/ส่วนราชการที่เป็นเจ้าภาพหลักในแต่ละ Chain น้ำหนักแล้วแต่ความเหมาะสม และถ่ายทอดตัวชี้วัดไปยังคํารับรองฯ ระดับกรม ตามหลักการที่สํานักงาน ก.พ.ร. กําหนด\r\n3. Output JKPIs จะถูกกําหนดเป็นตัวชี้วัด Joint KPIs ในคํารับรองฯ ระดับกรม น้ำหนักแล้วแต่ความเหมาะสม",
    source:
      "สำนักงานคณะกรรมการพัฒนาระบบราชการ. (2557). กรอบการประเมินผลการปฏิบัติราชการระดับกระทรวง ประจําปีงบประมาณ พ.ศ. 2558, 9 96]k8, 2562. http://www.ldd.go.th/Lddwebsite/web_adg/download/%E0%B8%95%E0%B8%B1%E0%B8%A7%E0%B8%8A%E0%B8%B5%E0%B9%89%E0%B8%A7%E0%B8%B1%E0%B8%9458/%E0%B8%81%E0%B8%A3%E0%B8%AD%E0%B8%9A%E0%B8%84%E0%B8%B3%E0%B8%A3%E0%B8%B1%E0%B8%9A%E0%B8%A3%E0%B8%AD%E0%B8%87%2058.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "การตรวจสอบการใช้อำนาจรัฐ",
    meaning:
      "ตามรัฐธรรมนูญได้กำหนดกลไกในการตรวจสอบการใช้อำนาจรัฐให้สามารถปฏิบัติหน้าที่ได้อย่างมีประสิทธิภาพ สุจริต เที่ยงธรรม และมีส่วนร่วมในการป้องกันหรือแก้ไขวิกฤตของประเทศ โดยกลไกที่กล่าวมามีดังนี้\r\nกลไกที่ 1 คัดกรองคุณสมบัติของบุคคลก่อนเข้าสู่ตำแหน่งทางการเมืองอย่างเข้มงวด เช่น ไม่เคยทุจริต ไม่เคยถูกไล่ออกจากหน่วยงานรัฐ ไม่เคยทำผิดคดีร้ายแรง เช่น ค้ายาเสพติด ค้ามนุษย์ ฟอกเงิน เป็นต้น\r\nกลไกที่ 2 ถอดถอนคนไม่ดี ที่ทำการทุจริตและประพฤติมิชอบ ใช้อำ นาจโดยมิชอบ ฝ่าฝืนจริยธรรมอย่างร้ายแรง ออกจากตำแหน่ง\r\nกลไกที่ 3 มีรัฐสภา ศาลรัฐธรรมนูญ และองค์กรอิสระ ประกอบด้วยคณะกรรมการการเลือกตั้ง (กกต.) ผู้ตรวจการแผ่นดิน คณะกรรมการป้องกันและปราบปรามการทุจริตแห่งชาติ (ป.ป.ช.) คณะกรรมการตรวจเงินแผ่นดิน(คตง.) และคณะกรรมการสิทธิมนุษยชนแห่งชาติ (กสม.) คอยตรวจสอบกลไกสุดท้ายคือกลไกที่ 4 ประชาชนมีส่วนร่วมในการแจ้งเบาะแสข้อมูลและหน่วยงานรัฐทำ งานอย่างโปร่งใส ",
    source:
      "สำนักงานคณะกรรมการการเลือกตั้ง. (2560). องค์กรอิสระและการตรวจสอบอำนาจรัฐ, 4 กันยายน 2562. https://www.ect.go.th/lamphun/ewt_dl_link.php?nid=489",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ก"
  },
  {
    keyword: "การถ่วงดุลการใช้อำนาจรัฐ",
    meaning:
      "การใช้อำนาจขององค์กรที่ใช้อำนาจอธิปไตยทั้ง 3 (อำนาจนิติบัญญัติ อำนาจบริหาร อำนาจตุลาการ) ซึ่งจะทำหน้าที่ตรวจสอบและถ่วงดุลย์อำนาจซึ่งกันและกัน ภายใต้ระบบแห่งการตรวจสอบและถ่วงดุลย์ซึ่งกันและกัน เช่น\r\n  -ฝ่ายนิติบัญญัติถ่วงดุลย์อำนาจของฝ่ายบริหาร โดยสภามีการลงมติเลือกนายกรัฐมนตรี, การเปิดอภิปรายไม่ไว้วางใจคณะรัฐมนตรี นายกรัฐมนตรีหรือรัฐมนตรีเป็นรายบุคคล, การอนุมัติงบประมาณรายจ่ายประจำปี\r\n  -ฝ่ายบริหารถ่วงดุลย์อำนาจของฝ่ายนิติบัญญัติ โดยนายกรัฐมนตรี มีอำนาจยุบสภาผู้แทนราษฎรเพื่อเลือกตั้งใหม่ (ประธานสภาไม่มีสิทธิ์ยุบสภา)\r\n  -ฝ่ายตุลาการถ่วงดุลย์อำนาจฝ่ายบริหาร โดยผู้พิพากษามีอำนาจพิจารณาคดีที่ผู้ดำรงตำแหน่งทางการเมืองที่มี ความผิดในคดีอาญาใช้อำนาจรัฐนอกเหนือกฎหมายบัญญัติไว้",
    source:
      "นายดิฐ อัศวพลังพรหม วิทยาลัยการยุติธรรม สำนักศาลยุติธรรม. (2557). การถ่วงดุลย์ 3 เสาหลัก อำนาจนิติบัญญัติ อำนาจบริหาร อำนาจตุลาการ, 9 กันยายน 2562. http://elib.coj.go.th/managecourt/data/MC2557_18_86.pdf",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ก"
  },
  {
    keyword: "การถ่ายเทพลังงานไฟฟ้าผ่านสายส่งเชื่อมโยง (Tie-line)",
    meaning: "เชื่อมโยงระบบไฟฟ้าจากระบบหนึ่งเข้ากับอีกระบบหนึ่ง",
    source:
      "สำนักงานคณะกรรมการอาชีวศึกษา. การส่งและจ่ายไฟฟ้า, 24 ตุลาคม 2562. http://www.tatc.ac.th/files/0910290994850_1106060993022.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "การท่องเที่ยวเชิงนิเวศ",
    meaning:
      "การท่องเที่ยวที่ดำเนินการภายใต้ขีดจำกัดความสามารถของธรรมชาติและตระหนักถึงการมีส่วนร่วมของชุมชนและวิถีชีวิต ขนบธรรมเนียม ประเพณี อีกทั้งต้องยอมรับให้ประชาชนทุกส่วนได้รับผลประโยชน์ทางเศรษฐกิจที่เกิดจากการท่องเที่ยวอย่างเสมอภาค",
    source:
      "กรมการท่องเที่ยว. การท่องเที่ยวเชิงอนุรักษ์หรือเชิงนิเวศ (Ecotourism), 11 มิถุนายน 2562. https://www.dot.go.th/storage/3_01_2562/toC25eSAERqO4cFUmNddPHRz2Ax6gJVqHu7lmulN.pdf",
    sappear: 2,
    mappear: 6,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การท่องเที่ยวเชิงวัฒนธรรม",
    meaning:
      " การท่องเที่ยวในแหล่งท่องเที่ยวทางวัฒนธรรม โดยมีการให้ความรู้และความภูมิใจที่เน้นเสนอลักษณะวัฒนธรรม ประวัติศาสตร์ โบราณคดีและสถานที่ต่างๆ ที่มนุษย์สร้างขึ้นโดยเกี่ยวเนื่องกับความเป็นอยู่ของสังคม และให้ทุกฝ่ายร่วมกันรับผิดชอบต่อสิ่งแวดล้อม",
    source:
      "นายเจษฎา ขวัญเมือง และคณะ. Tourism around the world คลังคำศัพท์, 30 กรกฎาคม 2562. https://touristbuu.wordpress.com/%E0%B8%84%E0%B8%A5%E0%B8%B1%E0%B8%87%E0%B8%84%E0%B8%B3%E0%B8%A8%E0%B8%B1%E0%B8%9E%E0%B8%97%E0%B9%8C/",
    sappear: "",
    mappear: 5,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การท่องเที่ยวเชิงสุขภาพ",
    meaning:
      "สามารถแบ่งตามจุดมุ่งหมายได้สองลักษณะ คือ \r\n1. การท่องเที่ยวเชิงส่งเสริมสุขภาพ (wellness tourism) มีลักษณะการเดินทางเพื่อพักผ่อนเยี่ยมชมสถานที่ท่องเที่ยวต่าง ๆ และจัดสรรเวลาเพื่อทำกิจกรรมส่งเสริมบำรุงรักษาสุขภาพ เช่น การนวดแผนไทย สปา การอาบน้ำพุร้อน เป็นต้น เพื่อให้นักท่องเที่ยวรู้สึกผ่อนคลายและส่งผลให้มีสุขภาพกายและสุขภาพใจที่ดี  \r\n2. การท่องเที่ยวเชิงบำบัดรักษาสุขภาพ (medical tourism) ที่เป็นการเดินทางท่องเที่ยวเยี่ยมชมสถานที่ท่องเที่ยวต่าง ๆ ขณะเดียวกันก็แบ่งเวลาบางส่วนไปรับบริการบำบัดรักษาสุขภาพ ฟื้นฟูสุขภาพในสถานบริการสุขภาพอย่างโรงพยาบาลหรือสถานบริการพยาบาลที่มีมาตรฐาน เช่น การตรวจร่างกาย รักษาโรคต่าง ๆ ผ่าตัดหรือศัลยกรรม โดยเน้นไปที่การรักษาฟื้นฟูสุขภาพของนักท่องเที่ยว",
    source:
      "สำนักงานปลัดกระทรวงการท่องเที่ยวและกีฬา. รายงานฉบับสมบูรณ์ (Final Report)\r\nโครงการรายงานภาวะเศรษฐกิจการท่องเที่ยวรายไตรมาส ประจำปี พ.ศ. 2560,\r\n19 พฤศจิกายน 2562.\r\nhttps://mots.go.th/old/download/pdf/01ProjectTourismEconomicFinalReport2560.pdf",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การท่องเที่ยวเชิงอนุรักษ์",
    meaning:
      "เป็นรูปแบบของการท่องเที่ยวอย่างยั่งยืน กล่าวคือ เป็นการท่องเที่ยวรูปแบบหนึ่งที่เกี่ยวข้องกับการเดินทางไปยังแหล่งธรรมชาติ และแหล่งวัฒนธรรมอย่างมีความรับผิดชอบ โดยไม่ก่อให้เกิดการรบกวนหรือทำความเสียหายแก่ทรัพยากรธรรมชาติ และสิ่งแวดล้อม แต่มีวัถตุประสงค์อย่างมุ่งมั่นเพื่อชื่นชม ศึกษา เรียนรู้ และเพลิดเพลินไปกับทัศนียภาพ พืชพรรณ และสัตว์ป่า ตลอดจนลักษณะทางวัฒนธรรมที่ปรากฏในแหล่งธรรมชาตินั้น อีกทั้งช่วยสร้างโอกาส ทางเศรษฐกิจที่ส่งผลให้การอนุรักษ์ทรัพยากรธรรมชาติ และสิ่งแวดล้อมเกิดประโยชน์ต่อชุมชนท้องถิ่นด้วย",
    source:
      "กรมอุทยานแห่งชาติ สัตว์ป่า และพันธุ์พืช กรมอุทยานแห่งชาติ. การท่องเที่ยวเชิงอนุรักษ์หรือเชิงนิเวศ (Ecotourism), 11 มิถุนายน 2562. http://www.dnp.go.th/park/sara/tour/eco.htm",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การท่องเที่ยวภายในประเทศ",
    meaning:
      "ผู้พำนักอาศัยที่มีถิ่นพำนักอยู่ในประเทศ\r\nและเดินทางท่องเที่ยวภายในประเทศ",
    source:
      "สำนักงานการท่องเที่ยวและกีฬาจังหวัดชัยนาท. นิยามศัพท์ด้านการท่องเที่ยว, 8 กรกฎาคม 2562. https://chainat.mots.go.th/download/article/article_20180618135139.pdf",
    sappear: "",
    mappear: 5,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การท่องเที่ยวระหว่างประเทศ",
    meaning: "ประกอบด้วยการท่องเที่ยวขาเข้า และการท่องเที่ยวขาออก ",
    source:
      "สำนักงานการท่องเที่ยวและกีฬาจังหวัดชัยนาท. นิยามศัพท์ด้านการท่องเที่ยว, 8 กรกฎาคม 2562. https://chainat.mots.go.th/download/article/article_20180618135139.pdf",
    sappear: "",
    mappear: 5,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การท่องเที่ยวอย่างยั่งยืน",
    meaning:
      "การจัดการรูปแบบการท่องเที่ยวเพื่อตอบสนองความจำเป็นทางเศรษฐกิจ สังคม วัฒนธรรม และสุนทรียภาพ โดยคำนึงถึงการใช้ทรัพยากรที่มีคุณค่าอย่างสมเหตุสมผลและสามารถรักษาเอกลักษณ์ของธรรมชาติ วัฒนธรรม เพื่อการใช้ประโยชน์อย่างยั่งยืน",
    source:
      "พระราชกฤษฎีกาจัดตั้งองค์การบริหารพัฒนาพื้นที่พิเศษเพื่อการท่องเที่ยวอย่างยั่งยืน (องค์การมหาชน) พ.ศ. 2546. (2546, 24 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 120 ตอนที่ 49 ก หน้า 282. http://web.krisdika.go.th/data/law/law2/%CD17/%CD17-2a-2546-a0003.htm",
    sappear: "",
    mappear: 5,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การทำงานในเชิงรุก",
    meaning:
      "การทำงานที่มีการวางแผนล่วงหน้าอย่างละเอียด รอบคอบ รู้จักและรับผิดชอบตนเอง โดยสามารถที่จะเลือกตอบสนองแรงกระตุ้นภายนอก ในมุมมองและคุณค่าของตนเองที่ยอมตกอยู่ภายใต้อิทธิพลสิ่งแวดล้อมรอบข้างและสถานการณ์ภายนอกบีบบังคับให้ต้องจำใจทำ รวมถึงมีสติไม่จมปลักกับปัญหา แต่ตอบสนองด้วยสติในคุณค่าที่เชื่อมั่นต่างจากการทำงานแบบตั้งรับ ที่จะกระทำเมื่อสถานการณ์บีบบังคับให้ตอบสนอง ในบางครั้งอาจมีความรู้สึกเข้ามาเกี่ยวข้องด้วย เมื่อเกิดข้อผิดพลาดจะโทษสิ่งแวดล้อมรอบข้าง เงื่อไขข้อจำกัดต่างๆโดยไม่พิจารณาตนเองเป็นหลัก",
    source:
      "ศูนย์ประกันคุณภาพการศึกษา สถาบันเทคโนโลยีพระจอมเกล้าพระนครเหนือ. (2548). การพัฒนาคนเชิงรุก, 1 พฤศจิกายน 2562. http://www.qa.kmutnb.ac.th/qa_news/2548/QANEWS087_25480101.pdf",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การทำงานร่วมกันระหว่างหน่วยงาน Accreditation Body (AB)",
    meaning:
      "หน่วยงานภาครัฐที่กำหนดมาตรฐานในส่วนที่เกี่ยวข้อง ให้องค์กรที่เกี่ยวข้องรับรองไปปฏิบัติและสามารถดำเนินการในฐานะหน่วยตรวจตามฐานนั้นได้",
    source:
      "สำนักงานพัฒนามาตรฐานแรงงาน. รู้ไว้ได้ประโยชน์, 2 ตุลาคม 2562. http://tls.labour.go.th/2018/attachments/article/705/atircle%201-09-09-59.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "การทำงานระบบดิจิทัล (ภาครัฐ)",
    meaning:
      "การนำเทคโนโลยีดิจิทัลมาใช้เป็นเครื่องมือในการบริหารงาน ภาครัฐและการบริการสาธารณะ โดยปรับปรุงการบริหารจัดการและบูรณาการข้อมูลภาครัฐและการทำงานให้มีความสอดคล้องและเชื่อมโยงเข้าด้วยกันอย่างมั่นคงปลอดภัยและมีธรรมาภิบาล เพื่อเพิ่มประสิทธิภาพ และอำนวยความสะดวกในการให้บริการประชาชน ในการเปิดเผยข้อมูลภาครัฐต่อสาธารณชน และสร้างการมีส่วนร่วมของทุกภาคส่วน",
    source:
      "พระราชบัญญัติการบริหารงานและการให้บริการภาครัฐผ่านระบบดิจิทัล. (2562), 13 กันยายน 2562.  http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/067/T_0057.PDF",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การทูตเพื่อประชาชน",
    meaning:
      "การทูตที่เน้นตอบสนองความต้องการของประชาชนในทุกมิติ โดยมีการนำนวัตกรรมมาใช้เพื่อตอบสนองความต้องการของประชาชนและสอดคล้องกับนโยบายของรัฐในการสนับสนุนการมีส่วนร่วมของประชาชนในการกำหนดนโยบาย เพื่อให้บรรลุเป้าหมายสูงสุดในการทำให้การต่างประเทศเป็นการต่างประเทศของประชาชนและเพื่อผลประโยชน์ของประชาชนอย่างแท้จริง อันจะเป็นการสนับสนุนกระบวนการพัฒนาประชาธิปไตยแบบมีส่วนร่วมภายในประเทศอีกทางหนึ่ง",
    source:
      "กรมการกงศุล. (ม.ป.ป). การทูตเพื่อประชาชน, 17 มิถุนายน 2562. http://www.consular.go.th/main/th/organize/19716-นโยบาย.html",
    sappear: "",
    mappear: 2,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การทูตสาธารณะ",
    meaning:
      "การดําเนินการทางการทูตแบบหนึ่ง เพื่อโน้มน้าวชักจูงให้สาธารณชนและกลุ่มเป้าหมายและกลุ่มผลประโยชน์ต่าง ๆ ในต่างประเทศที่มีบทบาทสําคัญต่อการตัดสินใจของรัฐ ให้มีความชื่นชมและเข้าใจถึงแนวทางการดําเนินนโยบายต่างประเทศของประเทศใดประเทศหนึ่ง ซึ่งจะช่วยเสริมสร้างความสัมพันธ์ระดับประชาชนให้มีความใกล้ชิดแน่นแฟ้นและประสบความสําเร็จอย่างแนบเนียน โดยจะมีความแตกต่างจากการดําเนินการทางการทูตแบบดั้งเดิมที่เน้นการสื่อสารระหว่างรัฐต่อรัฐ แต่การทูตสาธารณะจะเน้นวิธีการดําเนินความสัมพันธ์ระหว่างรัฐกับประชาชน ภาคเอกชน ภาคประชาสังคม หรือสื่อมวลชนในต่างประเทศ หรือระหว่างประชาชนด้วยกันเอง ทั้งนี้ การทูตวัฒนธรรมที่ใช้วัฒนธรรมเป็นสื่อเชื่อมความเข้าใจอันดีระหว่างประชาชนถือเป็นเครื่องมือหนึ่งของการดําเนินงานการทูตสู่สาธารณชน",
    source:
      "สถาบันการต่างประเทศเทวะวงศ์วโรปการ กระทรวงการต่างประเทศ. (2552). คําศัพท์– คําย่อทางการทูตและการ ต่างประเทศ, 11 มิถุนายน 2562. http://www.mfa.go.th/dvifa/contents/files/articles-20170626-142548-533162.pdf",
    sappear: "",
    mappear: 2,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การบริการใหม่ที่เป็นพลวัต",
    meaning:
      "การบริการใหม่ที่ไม่หยุดนิ่งอยู่กับที่ และมีความสามารถเคลื่อนที่ไปข้างหน้าด้วยพลังในตัวเอง",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2555). พลวัต. 18 ตุลาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%9E%E0%B8%A5%E0%B8%A7%E0%B8%B1%E0%B8%95-%E0%B9%96-%E0%B8%AA%E0%B8%B4%E0%B8%87%E0%B8%AB%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%95",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การบริการจัดการความเสี่ยง",
    meaning:
      "การบริหารปัจจัยและควบคุมกิจกรรม รวมทั้งกระบวนการดำเนินงานต่างๆ โดยลดมูลเหตุแต่ละโอกาสที่จะทำให้เกิดความเสียหายจากการดำเนินงานที่ไม่เป็นไปตามแผน เพื่อให้ระดับของความเสี่ยงและผลกระทบที่จะเกิดขึ้นในอนาคตอยู่ในระดับที่สามารถรับได้ ประเมินได้ ควบคุมได้ และตรวจสอบได้อย่างมีระบบ โดยคำนึงถึงการบรรลุวัตถุประสงค์หรือเป้าหมายของหน่วยงานเป็นสำคัญ",
    source:
      "สำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน). นิยามศัพท์แบบสำรวจระดับความพร้อมรัฐบาลดิจิทัลหน่วยงานภาครัฐของประเทศไทย ประจำปี 2562,12 กรกฎาคม 2562. https://www.dga.or.th/upload/download/file_5017b7c2653e33f74099c3563e942e1c.pdf",
    sappear: "",
    mappear: "8,16",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การบริหารงานยุติธรรม",
    meaning:
      "การดําเนินการที่เกี่ยวกับการบริหารจัดการในการอํานวยความยุติธรรม การป้องกันและแก้ไขปัญหาอาชญากรรม การคุ้มครองความปลอดภัยในชีวิตและทรัพย์สิน การคุ้มครองสิทธิเสรีภาพให้กับประชาชน \r\nการบังคับการตามกฎหมายและการอํานวยความสะดวกแก่ประชาชน แต่ไม่รวมถึงอํานาจอิสระในการพิจารณาพิพากษาอรรถคดีของศาล\r\nและการดําเนินการของหน่วยงานอิสระตามรัฐธรรมนูญ",
    source:
      "พระราชบัญญัติพัฒนาการบริหารงานยุติธรรมแห่งชาติ พ.ศ. 2549. (2549, 15 มีนาคม). ราชกิจจานุเบกษา. เล่มที่ 123 ตอนที่ 26 ก หน้า 6. http://www.ratchakitcha.soc.go.th/DATA/PDF/2549/00184410.PDF",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ก"
  },
  {
    keyword: "การบริหารจัดการเชิงรุก",
    meaning:
      "การทำงานที่มีการวางแผนล่วงหน้าอย่างละเอียด รอบคอบ รู้จักและรับผิดชอบตนเอง เป็นการทำงานที่มีประสิทธิภาพ",
    source:
      "ศูนย์ประกันคุณภาพการศึกษา สถาบันเทคโนโลยีพระจอมเกล้าพระนครเหนือ. (2548). การพัฒนาคนเชิงรุก, 18 ตุลาคม 2562. http://www.qa.kmutnb.ac.th/qa_news/2548/QANEWS087_25480101.pdf",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การบริหารจัดการเมือง",
    meaning:
      "การบริหารเมืองที่ดีย่อมแสดงให้เห็นถึงการมีระบบบริหารของเมืองที่สามารถครอบคลุมถึงประชาชนทุกกลุ่มและกลุ่มจะสามารถมีผู้แทนของตนเข้าไปมีส่วนร่วมในการบริหารเมืองด้วย นอกจากนั้น การดำเนินการใดๆของภาครัฐทุกระดับก็จะต้องรับผิดชอบต่อการถูกตรวจสอบได้ มีความซื่อสัตย์และโปร่งใส",
    source:
      "ดร. เกรียงพล พัฒนรัฐ วิทยาลัยรัฐธรรมนูญ สำนักงานศาสรัฐธรรมนูญ. การพัฒนาเมืองอย่างยั่งยืน, 7 สิงหาคม 2562. http://www.constitutionalcourt.or.th/ewtadmin/ewt/occ_web/ewt_dl_link.php?nid=1253",
    sappear: 2,
    mappear: 6,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การบริหารจัดการที่ดิน",
    meaning:
      "การบูรณาการในการดูแลรักษา การสงวนหวงห้าม การอนุรักษ์ การฟื้นฟูและพัฒนาซึ่งที่ดิน การกระจายการถือครองที่ดิน การใช้ประโยชน์อย่างสมดุลหรือการแก้ไขปัญหาด้านที่ดิน รวมทั้งการอื่นใดที่จ าเป็นเพื่อให้การใช้ที่ดินมีประสิทธิภาพ เกิดผลสัมฤทธิ์\r\nเป็นธรรม และยั่งยืน",
    source:
      "พระราชบัญญัติคณะกรรมการนโยบายที่ดินแห่งชาติ พ.ศ.2562. (2562, 14 เมษายน). ราชกิจจานุเบกษา. เล่มที่ 136 ตอนที่ 49 ก หน้าที่ 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/049/T_0001.PDF. ",
    sappear: "",
    mappear: 16,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การบริหารจัดการน้ำ",
    meaning:
      "การจัดการน้ำที่มีปริมาณเพียงพอและคุณภาพที่เหมาะสม การจัดคุณภาพน้ำจึงเป็นส่วนที่สำคัญของการบริหารจัดการน้ำแบบผสมผสาน คุณภาพน้ำที่เสื่อมโทรม ทำให้ไม่เหมาะสมสำหรับผู้ใช้ที่อยู่ท้ายน้ำ ดังนั้น จึงจำเป็นต้องพัฒนาสถาบัน/องค์กรที่มีขีดความสามารถในการผสมผสานด้านปริมาณและคุณภาพ เพื่อส่งเสริมให้สังคมมนุษย์ตระหนักถึงผลของการทำให้เกิดการลดและการกำจัดของเสีย",
    source:
      "ชลธิชา ต๊ะทองด้วง. (2557). ปัญหาทางกฎหมายเกี่ยวกับการบริหารจัดการน้ำโดยรัฐในประเทศไทย หน้า 51, 12 กรกฎาคม 2562. http://libdoc.dpu.ac.th/thesis/152816.pdf",
    sappear: 5,
    mappear: 19,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การบริหารจัดการพลังงาน",
    meaning:
      "ระบบการจัดการพลังงานประกอบด้วยส่วนประกอบหลัก 3 ส่วน คือ การวัด การจัดการข้อมูล และการควบคุม ระบบการจัดการพลังงานจะมีขอบเขตตั้งแต่ที่ใช้คนแบบง่าย ๆ ไปจนถึงระบบที่ใช้คอมพิวเตอร์ควบคุม",
    source:
      "กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน กระทรวงพลังงาน. ระบบการจัดการพลังงาน, 10 กรกฎาคม 2562. http://www2.dede.go.th/bhrd/old/web_display/factory/factory_management_energy.html",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "การบริหารสินทรัพย์",
    meaning:
      "1. การรับซื้อหรือรับโอนสินทรัพย์ด้อยคุณภาพของสถาบันการเงิน รวมตลอดจนหลักประกันของสินทรัพย์นั้นเพื่อนำมาบริหารหรือจำหน่ายจ่ายโอนต่อไป\r\n2. กิจการอื่นที่เกี่ยวเนื่องหรือเกี่ยวกับกิจการตาม 1 ที่รัฐมนตรีประกาศกำหนดโดยความเห็นชอบของคณะรัฐมนตรี",
    source:
      "พระราชกำหนดบริษัทบริหารสินทรัพย์ พ.ศ. 2541. (2541, 21 สิงหาคม 2541). ราชกิจจานุเบกษา. เล่ม 115 ตอนที่ 51 ก หน้า 12. http://www.ratchakitcha.soc.go.th/DATA/PDF/2541/A/051/12.PDF",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ก"
  },
  {
    keyword: "การบังคับตามคำพิพากษา",
    meaning:
      "ขั้นตอนของกฎหมายหลังจากที่ศาลได้มีคำพิพากษาหรือมีคำสั่งชี้ขาดตัดสินคดี โดยปกติในคำพิพากษาของศาลนั้น ก็จะมีการกำหนดให้ฝ่ายที่แพ้คดี ซึ่งเรียกว่า “ลูกหนี้ตามคำพิพากษา” ต้องกระทำการอย่างใดอย่างหนึ่งให้กับอีกฝ่ายหนึ่งเสมอ เช่น ให้จำเลยคืนเงินหรือให้ชำระค่าเสียหายแก่โจทก์ ให้จำเลยออกไปจากที่พิพาท หรือรื้อถอนสิ่งปลูกสร้างต่างๆ ออกไปจากที่พิพาท หรือในคดีอาญา ศาลจะมีคำพิพากษาลงโทษปรับจำเลยหรือมีคำสั่งปรับผู้ประกันจำเลย เป็นต้น",
    source:
      "สำนักงานการบังคับคดี. กระบวนงานการบังคับคดี, 1 สิงหาคม 2562. http://www.led.ago.go.th/index.php/2013-09-18-08-52-29",
    sappear: "",
    mappear: 22,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การบูรณาการ",
    meaning:
      "การประสานกันของแผน กระบวนการ สารสนเทศ การจัดสรรทรัพยากร การปฏิบัติการ ผลลัพธ์ และการวิเคราะห์ เพื่อสนับสนุนเป้าประสงค์ที่สำคัญขององค์กร การบูรณาการที่มีประสิทธิผล เป็นมากกว่าความสอดคล้องไปในแนวทางเดียวกัน (Alignment) และจะสำเร็จได้ก็ต่อเมื่อการดำเนินการของแต่ละองค์ประกอบภายในระบบการจัดการผลการดำเนินการมีความเชื่อมโยงกันเป็นหนึ่งเดียวอย่างสมบูรณ์",
    source:
      "งานจัดการความรู้ คณะแพทยศาสตร์ศิริราชพยาบาล มหาวิทยาลัยมหิดล. (2556). การบูรณาการ (Integration), 9 กันยายน 2562. http://www1.si.mahidol.ac.th/km/node/2287",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ก"
  },
  {
    keyword: "การปกครองในระบอบประชาธิปไตยอันมีพระมหากษัตริย์ทรงเป็นประมุข",
    meaning:
      "อำนาจในการออกกฎหมายมาบังคับใช้เป็นอำนาจและหน้าที่ของรัฐสภาซึ่งเป็นองค์กรที่ใช้อำนาจนิติบัญญัติและถือเป็นสภาผู้แทนของประชาชน  และมอบหมายให้รัฐสภาเป็นองค์กรซึ่งทำหน้าที่ในตรากฎหมายของประเทศไทย ซึ่งได้ปรากฏหลักการโดยชัดเจนตามบทบัญญัติของรัฐธรรมนูญแห่งราชอาณาจักรไทย พุทธศักราช 2550 มาตรา 90 ที่ว่า “ร่างพระราชบัญญัติประกอบรัฐธรรมนูญและร่างพระราชบัญญัติจะตราขึ้นเป็นกฎหมายได้ก็แต่โดยคำแนะนำและยินยอมของรัฐสภา และเมื่อพระมหากษัตริย์ได้ทรงลงพระปรมาภิไธยหรือถือเสมือนว่าได้ทรงลงพระปรมาภิไธยตามรัฐธรรมนูญนี้แล้ว ให้ประกาศในราชกิจจานุเบกษาเพื่อใช้บังคับเป็นกฎหมายต่อไป”",
    source:
      "กองบรรณาธิการ สำนักกฎหมาย สํานักงานเลขาธิการสภาผู้แทนราษฎร. (2553). “ยุทธศาสตร์เพื่อการพัฒนากระบวนการนิติบัญญัติไทย”, 12 กันยายน 2562. http://web.senate.go.th/lawdatacenter/includes/FCKeditor/upload/Image/b/IN33_jul_7_5.pdf",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ก"
  },
  {
    keyword: "การปฏิรูปขนานใหญ่",
    meaning:
      "การปรับเปลี่ยนการทำงานอย่างขนานใหญ่ (radical และต้องเป็นการเปลี่ยนแปลงชนิดหน้ามือเป็นหลังมือ",
    source:
      "ดร.ครรชิต มาลัยวงศ์. (2541). การปฏิรูประบบราชการ: ยุทธศาสตร์สำคัญของการเปลี่ยนแปลง สำนักงานคณะกรรมการปฏิรูประบบราชการ, 4 ธันวาคม 2562. http://www.drkanchit.com/books/book-r13.html",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ก"
  },
  {
    keyword: "การปฏิรูปด้านสถาบันเศรษฐกิจ",
    meaning:
      "การปรับกลไกและบทบาทของภาครัฐให้พร้อมรับมือกับความท้าทายในอนาคตที่บริบททางเศรษฐกิจและสังคมเปลี่ยนแปลงอย่างไม่หยุดนิ่ง ",
    source:
      "กองบรรณาธิการ สำนักกฎหมาย. (2561). การปฏิรูปประเทศด้านเศรษฐกิจ, 9 กันยายน 2562. http://web.senate.go.th/lawdatacenter/includes/FCKeditor/upload/Image/b/IN87.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "การปฏิรูปประเทศ",
    meaning:
      "การปฏิรูปประเทศเป็นการปรับปรุงสิ่งที่เห็นว่าเป็นปัญหาหรือผิดไปจากสภาพที่เหมาะสม โดยนำมาจัดรูปแบบใหม่ให้สมควรแก่ยุคสมัย หากยังขาดสิ่งใดที่ควรมีก็ย่อมต้องจัดให้มีสิ่งนั้น การปฏิรูปจึงต้องมีฝ่ายที่ได้ในบางเรื่องและเสียในบางเรื่อง ประเด็นสำคัญของการปฏิรูปจึงอยู่ที่ว่าการปฏิรูปดังกล่าวมีเป้าหมายอย่างไร และจะส่งผลในระยะสั้น ระยะกลาง ระยะยาวอย่างไร สำหรับประเทศไทยในห้วงระยะเวลาที่ผ่านมาได้ในความสำคัญกับคำว่าการปฏิรูปมากขึ้น หลังจากเผชิญปัญหาในหลายด้านไม่ว่าจะเป็นด้านการเมือง ด้านการบริหารราชการแผ่นดิน ด้านกฎหมาย ด้านกระบวนการยุติธรรม ด้านการศึกษา ด้านเศรษฐกิจ และอื่นๆ",
    source:
      "สำนักวิชาการ สำนักงานเลขาธิการสภาผู้แทนราชฎร. (2560). การปฏิรูปประเทศตามรัฐธรรมนูญแห่งราชอาณาจักรไทย พุทธศักราช 2560, 11 กรกฎาคม 2562. https://library2.parliament.go.th/ebook/content-issue/2560/hi2560-043.pdf",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ก"
  },
  {
    keyword: "การปฏิรูปองค์กร",
    meaning:
      "การปรับกลไกและบทบาทของภาครัฐให้พร้อมรับมือกับความท้าทายในอนาคตที่บริบททางเศรษฐกิจและสังคมเปลี่ยนแปลงอย่างไม่หยุดนิ่ง ",
    source:
      "กองบรรณาธิการ สำนักกฎหมาย. (2561). การปฏิรูปประเทศด้านเศรษฐกิจ, 9 กันยายน 2562. http://web.senate.go.th/lawdatacenter/includes/FCKeditor/upload/Image/b/IN87.pdf",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การปฏิวัติ",
    meaning:
      "การเปลี่ยนแปลงระบบ เช่น ปฏิวัติอุตสาหกรรม, การเปลี่ยนแปลงระบอบการบริหารบ้านเมือง เช่น ปฏิวัติการปกครอง",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ปฏิวัติ. 20 พฤศจิกายน 2562 \r\nhttp://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ก"
  },
  {
    keyword: "การปฏิวัติอุตสาหกรรมครั้งที่ 4",
    meaning:
      "ยุคที่ระบบอินเทอร์เน็ตแพร่หลายมากขึ้น มีการพัฒนาอุปกรณ์ที่เกี่ยวข้อง เช่น เซ็นเซอร์ที่มีขนาดเล็กลงแต่ทรงพลังมากขึ้น และมีราคาที่ถูกลง รวมทั้งมีการคิดค้นปัญญาประดิษฐ์และจักรกลเรียนรู้ (Machine Learning:  ML) เทคโนโลยีที่กำลังเกิดขึ้นในยุคนี้จะมีความซับซ้อนและบูรณาการกันได้ดีมากกว่าเดิม ส่วนในการผลิต เทคโนโลยีจะเข้าไปช่วยทำให้เกิด “โรงงานอัจฉริยะ” ที่ระบบการผลิตทั้งที่เป็นกายภาพและระบบเสมือนทำงานร่วมกันได้อย่างยืดหยุ่น นอกจากนี้ ยังมีพัฒนาที่ก้าวหน้ากว่ายุคใดในอดีต เช่น การจัดลำดับพันธุกรรม นาโนเทคโนโลยี พลังงานทดแทน คอมพิวเตอร์ระบบควอนตัม เป็นต้น จะเกิดการปฏิสัมพันธ์ระหว่างเทคโนโลยีทั้งในด้านกายภาพ ดิจิทัล และชีวภาพ โดยเริ่มต้นตั้งแต่ปี 2000 เป็นต้นมา ",
    source:
      "ตลาดหลักทรัพย์แห่งประเทศไทย. (2561), The Fourth Industrial Revolution ยุคแห่งการปฏิวัติอุตสาหกรรมครั้งที่ 4, มิถุนายน 2561. \r\nhttps://www.set.or.th/set/enterprise/article/detail.do?contentId=5475",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การปนเปื้อน",
    meaning:
      "การที่น้ำเกิดมีจุลชีพ สารเคมี ขยะ ของเสียเกิดขึ้นในปริมาณที่ทำให้น้ำนั้นไม่เหมาะแก่การนำไปใช้",
    source:
      "กรมควบคุมมลพิษ.บัญชีรายชื่อคำศัพท์, 18 กันยายน 2562. http://www.pcd.go.th/info_serv/QandA/defaultThai.cfm?task=listVocab",
    sappear: "",
    mappear: 3,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การประเมินคุณภาพ",
    meaning:
      "กระบวนการวิเคราะห์ และเปรียบเทียบผลการดำเนินงานของสถานศึกษาตามรายการตรวจสอบและตัวบ่งชี้คุณภาพที่กำหนดว่าอยู่ในระดับใด",
    source:
      "มหาวิทยาลัยเชียงใหม่. นิยามศัพท์เฉพาะ การประเมินคุณภาพ, 12 กันยายน 2562. http://web.agri.cmu.ac.th/qa/document/2553/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD/cmu/technical_term/123.pdf",
    sappear: "",
    mappear: 12,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การประเมินผลสัมฤทธิ์ของกฎหมาย",
    meaning:
      "การประเมินผลสัมฤทธิ์ที่เกิดขึ้นจากการบังคับ\r\nใช้กฎหมายและกฎว่าได้ผลตรงตามวัตถุประสงค์ของการตรากฎหมายนั้นมากน้อยเพียงใด คุ้มค่ากับภาระที่เกิดขึ้นแก่รัฐและประชาชนหรือไม่ หรือมีผลกระทบอื่นอันก่อให้เกิดความไม่เป็นธรรมแก่ประชาชนหรือไม่\r\nเพียงใด\r\n",
    source:
      "พระราชบัญญัติหลักเกณฑ์การจัดทำร่างกฎหมายและการประเมินผลสัมฤทธิ์ของกฎหมาย พ.ศ. 2562. (2562, 31 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136  ตอนที่ 72 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/072/T_0001.PDF\r\n",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ก"
  },
  {
    keyword: "การประเมินย้อนกลับ (feedback)",
    meaning:
      "การให้ข้อมูลสารสนเทศเกี่ยวกับความสำเร็จและสิ่งที่จำเป็นต้องได้รับการพัฒนาหรือปรับปรุงแก้ไข",
    source:
      "โชติมา หนูพริก กลุ่มพัฒนาและส่งเสริมการวัดและประเมินผลการเรียนรู้ สำนักวิชาการและมาตรฐานการศึกษา. เทคนิคการประเมินเพื่อพัฒนาการเรียนรู้ : การตั้งคำถามและการให้ข้อมูลย้อนกลับเพื่อส่งเสริมการเรียนรู้, 10 กันยายน 2562. http://www.curriculumandlearning.com/upload/%E0%B8%AA%E0%B8%A3%E0%B8%B8%E0%B8%9B%20concept%20QF_1426389005.pdf\r\n",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "การประเมินสิ่งแวดล้อมระดับยุทธศาสตร์",
    meaning:
      "กระบวนการที่เป็นระบบเพื่อใช้สนับสนุนการตัดสินใจในการกำหนดนโยบาย แผน หรือแผนงาน โดยคำนึงถึงปัจจัยทางด้านสิ่งแวดล้อม ร่วมกับปัจจัยทางด้านเศรษฐกิจ สังคม และปัจจัยอื่น ๆ โดยเปิดโอกาสให้ทุกภาคส่วนที่เกี่ยวข้องเข้ามามีส่วนร่วม เพื่อให้เกิดการพัฒนาที่ยั่งยืน",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. (ร่าง) แนวทาง (Guideline) การประเมินสิ่งแวดล้อมระดับยุทธศาสตร์, 20 สิงหาคม 2562. https://www.nesdc.go.th/ewt_w3c/ewt_dl_link.php?nid=8372",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ก"
  },
  {
    keyword: "การประกันผลผลิต",
    meaning:
      "เป็นการประกันภัยที่ให้ความคุ้มครองความเสียหาย หรือสูญเสียต่อผลผลิตที่เอาประกันภัย ซึ่งเกิดจากภัยตามที่ระบุไว้ในกรมธรรม์ โดยอาจกำหนดให้คุ้มครองภัยทุกชนิด หรืออาจกำหนดให้คุ้มครองเฉพาะบางภัย เช่น น้ำท่วม ภัยแล้ง ลมพายุ ลูกเห็บตก เป็นต้น",
    source:
      "สำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย (คปภ.). 2019.การประกันภัยพืชผล, 6 มิถุนายน 2562. http://www.oic.or.th/th/education/insurance/miscellaneous/crop",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "การประมง",
    meaning:
      "การทําการประมง การเพาะเลี้ยงสัตว์น้ํา การดูแลรักษาสัตว์น้ํา\r\nการแปรรูปสัตว์น้ํา และหมายความรวมถึงการกระทําใดๆ ที่เป็นการสนับสนุนการทําการประมง",
    source:
      "พระราชกำหนดการประมง พ.ศ. 2558. (2558, 13 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 132 ตอนที่ 108 ก หน้า 3. http://www.ratchakitcha.soc.go.th/DATA/PDF/2558/A/108/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ก"
  },
  {
    keyword: "การประมวลผลบนกลุ่มเมฆ",
    meaning:
      "การประมวลผลแบบคลาวด์ ที่เกิดจากแนวคิดการให้บริการโดยใช้ประโยชน์จากโครงสร้างพื้นฐานไอทีที่ทำงานเชื่อมโยงกัน โดยมีเซิร์ฟเวอร์มากมายทำงานสอดประสานเป็นหนึ่งเดียวกัน เพื่อให้บริการแอพพลิเคชั่นต่างๆ มีข้อดีคือลดความซับซ้อนยุ่งยากของผู้ต้องการใช้บริการ อีกทั้งยังช่วยประหยัดพลังงานและลดค่าใช้จ่าย เพราะคลาวด์ คอมพิวติ้ง ทำงานผ่านเทคโนโลยีเสมือน (virtualization) ระบบจึงไม่ได้ถูกจำกัดในเรื่องของสมรรถนะและขีดความสามารถของการใช้ระบบประมวลผลจากระบบต่าง ๆ ทำให้เกิดการบริการหลาย ๆ อย่าง เช่น การประชุมผ่านอินเทอร์เน็ต web conferencing, online meetings ผู้ใช้งานอาจอยู่ในห้อง เดียวกัน หรือห่างไกลกันคนละซีกโลกก็ได้ ",
    source:
      "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม. (2562). นโยบายและแผนระดับชาติว่าด้วยการพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม, 23 กรกฎาคม 2562. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/047/T_0001.PDF",
    sappear: "",
    mappear: 8,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การปรับเปลี่ยนค่านิยมและวัฒนธรรม (การเมือง)",
    meaning:
      "วัฒนธรรมทางการเมืองถูกกำหนดขึ้นหรือได้รับอิทธิพลจากภูมิหลังทางประวัติศาสตร์ ขนบธรรมเนียมประเพณี ศาสนา โดยผ่านกระบวนการอบรมหล่อหลอมของสังคมในระดับต่าง ๆ แล้วถ่ายทอดจากคนรุ่นหนึ่งไปสู่คนรุ่นต่อ ๆ ไปอย่างต่อเนื่อง และสอดรับกับสภาวะแวดล้อมของการเปลี่ยนแปลงทางการเมืองในแต่ละช่วงเวลา",
    source:
      "สำนักงานเลขาธิการสภาผู้แทนราษฎร. (2558). วัฒนธรรมทางการเมือง, 12 กันยายน 2562. https://www.parliament.go.th/ewtadmin/ewt/parliament_parcy/ewt_dl_link.php?nid=34911&filename=jula_sarn",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ก"
  },
  {
    keyword: "การปรับตัวจากการเปลี่ยนแปลงสภาพภูมิอากาศ",
    meaning:
      "การปรับเปลี่ยนพฤติกรรม วิถีชีวิต และสิ่งแวดล้อมเพื่อให้สามารถดำรงชีวิตอยู่ได้ภายใต้ผลกระทบที่เกิดขึ้นจากการเปลี่ยนแปลงสภาพภูมิอากาศ เช่น การปรับเปลี่ยนรูปแบบการผลิต การสร้างมาตรการป้องกันภัยพิบัติหรือสัญญาณเตือนภัยล่วงหน้า การเตรียมรับมือกับปัญหาความมั่นคงทางอาหาร การใช้ทรัพยากรน้ำที่ขาดแคลนอยู่อย่างประหยัด การพัฒนาพืชผลที่ทนต่อความแห้งแล้ง การคัดเลือกสายพันธุ์ต้นไม้และวิธีการทำป่าไม้ที่ทนต่อพายุและไฟป่า การจัดที่ดินเพื่ออพยพสายพันธุ์สัตว์และพืช",
    source:
      "กรมป้องกันและบรรเทาสาธารณภัย. หนังสือคำศัพท์ด้านการบริหารจัดการความเสี่ยงจากภัยพิบัติ, 9 กันยายน 2562. http://www.disaster.go.th/th/download-src.php?did=1225",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การปลดปล่อยและเคลื่อนย้ายมลพิษ         ",
    meaning:
      "ระบบฐานข้อมูล เกี่ยวกับชนิดและปริมาณมลพิษ ซึ่งมิใช่ความเข้มข้นของสารที่มีการปลดปล่อยจากแหล่งกำเนิด เช่น โรงงานอุตสาหกรรม สู่สิ่งแวดล้อม ทั้งอากาศ ดิน และน้ำ รวมทั้งข้อมูลเกี่ยวกับการขนย้ายน้ำเสียและของเสียออกนอกสถานประกอบการเพื่อบำบัดหรือกำจัด ซึ่งเผยแพร่สู่สาธารณชนผ่านทางอินเตอร์เน็ต",
    source:
      "กรมควบคุมมลพิษ กระทรวงทรัพยากรธรรมชาติและสิ่งแวดล้อม. (2561). ทำเนียบการปลดปล่อยและเคลื่อนย้ายมลพิษ (Pollutant Release and Transfer Registers: PRTR), 24 ตุลาคม 2562. http://www.pcd.go.th/Info_serv/pol_maptapoot_wastePRTR.html",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ก"
  },
  {
    keyword: "การปลูกฝังค่านิยมและวัฒนธรรม",
    meaning:
      "กระบวนการในการขัดเกลาทางสังคม (Socialization) ที่เป็นการปลูกฝังบรรทัดฐาน ค่านิยมที่พึงประสงค์ในขณะนั้นของสังคมให้เกิดขึ้นในตัวบุคคลและถ่ายทอดค่านิยมดังกล่าวให้สืบทอดต่อไปในสังคม",
    source:
      "สุพัตรา สุภาพ และคณะ. (2533). หนังสือเรียนสังคมศึกษา ส401, 18 กรกฎาคม 2562.https://www.baanjomyut.com/library_3/extension-5/social_organization/06.html",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การป้องกัน",
    meaning:
      "มาตรการหรือแนวทางต่าง ๆ เพื่อช่วยขจัดผลกระทบเชิงลบจากเหตุการณ์\r\nภัยพิบัติที่อาจเกิดกับบุคคลหรือทรัพย์สินให้หมดไปอย่างสิ้นเชิง ครอบคลุมถึง\r\nมาตรการเชิงโครงสร้างและมาตรการที่ไม่ใช่เชิงโครงสร้าง ",
    source:
      "กรมป้องกันและบรรเทาสาธารณภัย. หนังสือคำศัพท์ด้านการบริหารจัดการความเสี่ยงจากภัยพิบัติ, 9 กันยายน 2562. http://www.disaster.go.th/th/download-src.php?did=1225",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การป้องกันการทุจริตในงานก่อสร้าง (CoST)",
    meaning:
      'โครงการความโปร่งใสในการก่อสร้างภาครัฐ (CoST) ในโครงการก่อสร้างของรัฐวิสาหกิจ จัดโดย สถาบันวิจัยเพื่อการพัฒนาประเทศไทย (TDRI) ร่วมกับ สำนักงานคณะกรรมการนโยบายรัฐวิสาหกิจ (สคร.) ธิปไตร แสละวงศ์ นักวิจัยอาวุโส TDRI  กล่าวว่า CoST เป็นคำย่อของ "Construction Sector Transparency" Initiative  สืบเนื่องจากทั้งองค์กรเพื่อความโปร่งใสสากล และ ธนาคารโลก (World Bank) เสนอแนะให้รัฐบาลประเทศต่างๆ เปิดเผยข้อมูลโครงการก่อสร้างต่างๆ มากขึ้น',
    source:
      "องค์กรต่อต้านคอร์รัปชัน (ประเทศไทย). (2560). แบบอย่างจากสุวรรณภูมิ'CoST'ลดโกง-ใช้งบคุ้มค่า, 2 ตุลาคม 2562. http://www.anticorruption.in.th/2016/th/detail/393/4/%E0%B9%81%E0%B8%9A%E0%B8%9A%E0%B8%AD%E0%B8%A2%E0%B9%88%E0%B8%B2%E0%B8%87%E0%B8%88%E0%B8%B2%E0%B8%81%E0%B8%AA%E0%B8%B8%E0%B8%A7%E0%B8%A3%E0%B8%A3%E0%B8%93%E0%B8%A0%E0%B8%B9%E0%B8%A1%E0%B8%B4'CoST'%E0%B8%A5%E0%B8%94%E0%B9%82%E0%B8%81%E0%B8%87-%E0%B9%83%E0%B8%8A%E0%B9%89%E0%B8%87%E0%B8%9A%E0%B8%84%E0%B8%B8%E0%B9%89%E0%B8%A1%E0%B8%84%E0%B9%88%E0%B8%B2",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "ก"
  },
  {
    keyword: "การผลิตไฟฟ้าจากชีวมวล (Biomass)",
    meaning:
      "ทําได้โดยการเผาไหม้ชีวมวลโดยตรง (Direct Combustion) และกระบวนการเคมีความร้อน (Thermochemical Conversion) ",
    source:
      "สำนักงานนโยบายและแผนพลังงาน. พลังงานชีวมวล, 3 ตุลาคม 2562. http://www.eppo.go.th/images/Power/renewable-energy/14.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "การผลิตไฟฟ้าระบบรวมศูนย์ (Centralized System)",
    meaning:
      "การไหลของกระแสไฟฟ้าเป็นไปในทิศทางเดียวจากโรงไฟฟ้าขนาดใหญ่ไปยังผู้ใช้ไฟฟ้า",
    source:
      "สาขาวิชาพลังงานทดแทน คณะพลังงานและสิ่งแวดล้อม มหาวิทยาลัยพะเยา. (2562). ระบบสมาร์ตกริด คืออะไร?, 8 ตุลาคม 2562. http://www.seen.up.ac.th/leaflet/assets/pp-%E0%B8%AA%E0%B8%B2%E0%B8%82%E0%B8%B2%E0%B8%9E%E0%B8%A5%E0%B8%B1%E0%B8%87%E0%B8%87%E0%B8%B2%E0%B8%99.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "การผันน้ำในพื้นที่ที่มีความสำคัญ",
    meaning:
      "การก่อสร้างทางผันน้ำ หรือขุดคลองสายใหม่ เชื่อมต่อกับลำน้ำที่มีปัญหาน้ำท่วม เพื่อผันน้ำทั้งหมด หรือน้ำเฉพาะบางส่วนที่จะล้นตลิ่ง แล้วทำให้เกิดน้ำท่วม ออกไปจากลำน้ำให้ไหลไปตามทางผันน้ำ ที่ขุดขึ้นใหม่ ไปลงลำน้ำสายอื่น หรือระบายออกสู่ทะเล ตามความเหมาะสม\r\n1. โดยทั่วไปนิยมการผันน้ำเฉพาะส่วนที่จะไหลล้นตลิ่ง ซึ่งทำให้เกิดน้ำท่วมออกไปจากลำน้ำ โดยที่น้ำส่วนใหญ่ ซึ่งมีระดับไม่ล้นตลิ่งนั้น ยังคงปล่อยให้ไหลอยู่ในลำน้ำเดิมตามปกติ สำหรับวิธีการผันน้ำในรูปแบบนี้ ที่บริเวณปากทางแยกเข้าลำน้ำสายใหม่ จะต้องสร้างอาคาร เพื่อควบคุมบังคับน้ำให้ไหลเข้าสู่ลำน้ำสายใหม่ในปริมาณที่พอเหมาะ โดยอาคารควบคุมบังคับน้ำดังกล่าวอาจสร้างเป็นแบบฝาย ซึ่งสามารถควบคุมน้ำให้ไหลเข้าลำน้ำสายใหม่ได้โดยอัตโนมัติ หรือสร้างประตูระบายน้ำที่ควบคุมบังคับน้ำ โดยบานประตู ซึ่งเปิดและปิดได้ตามความเหมาะสม\r\n2. กรณีที่ต้องการผันน้ำทั้งหมดให้ไหลไปตามทางน้ำที่ขุดใหม่ควรขุดลำน้ำสายใหม่แยกออกจากลำน้ำสายเดิม ตรงบริเวณที่ลำน้ำเป็นแนวโค้ง โดยกำหนดให้ท้องลำน้ำที่ขุดมีระดับเสมอกับท้องลำน้ำเดิมเป็นอย่างน้อย หลังจากนั้นจึงนำดินที่ขุดจากลำน้ำใหม่ไปถมปิดลำน้ำสายเดิม พร้อมกับเกลี่ยและบดอัดดินให้แน่นจนเต็มโดยตลอด เพื่อนำพื้นที่ไปใช้ประโยชน์ในด้านอื่นต่อไป",
    source:
      "โครงการสารานุกรมไทยสำหรับเยาวชน. วิธีการป้องกันและบรรเทาน้ำท่วม, 18 ตุลาคม 2562. http://kanchanapisek.or.th/kp6/sub/book/book.php?book=12&chap=8&page=t12-8-infodetail14.html",
    sappear: 5,
    mappear: 19,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การฝึกอบรม",
    meaning:
      "การจัดหรือการรับการฝึกอบรมเพื่อพัฒนาครู บุคลากรทางการศึกษา\r\nหรือผู้เรียนในทุกระดับ",
    source:
      "พระราชบัญญัติ กองทุนเพื่อความเสมอภาคทางการศึกษา\r\nพ.ศ. 2561. (2561, 13 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 33 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/033/1.PDF",
    sappear: 1,
    mappear: "",
    rappear: "8,12",
    firstalpha: "ก"
  },
  {
    keyword: "การพยากรณ์ความต้องการพลังงานของประเทศ",
    meaning:
      "เพื่อให้เกิดความแม่นยำและครอบคลุมการใช้งานพลังงานไฟฟ้าในประเทศไทย การจัดทำแผน PDP ทุกครั้งจะต้องกำหนดหลักการการพยากรณ์ความต้องการพลังงานไฟฟ้าให้รัดกุมและเหมาะสมกับสถานการณ์ด้านพลังงานในช่วงนั้นๆ การพยากรณ์ความต้องการพลังงานไฟฟ้าทำโดยการพยากรณ์ไฟฟ้าระดับจำหน่ายโดยใช้แบบจำลองการพยากรณ์ความต้องการไฟฟ้าในแบบจำลองดังกล่าวได้แบ่งการพยากรณ์ความต้องการไฟฟ้าตามเขตของการไฟฟ้านครหลวง และการไฟฟ้าส่วนภูมิภาค ตามประเภทผู้ใช้ไฟฟ้า ได้แก่ กลุ่มที่อยู่อาศัย กลุ่มธุรกิจ กลุ่มอุตสาหกรรม และอื่นๆความต้องการไฟฟ้าของผู้ใช้ไฟฟ้าประเภทต่างๆ นั้น มีแนวโน้มการเปลี่ยนแปลงแปรผันตามอัตราการเติบโตทางเศรษฐกิจ จำนวนประชากร",
    source:
      "สำนักงานนโยบายและแผนพลังงาน กระทรวงพลังงาน. คูมือ แผนพัฒนากำลังผลิตไฟฟ้าของประเทศไทย(Power Development Plan : PDP), 24 ตุลาคม 2562. http://www.eppo.go.th/images/Infromation_service/NEWS/2018/PDP_Public_Hearing2018_3.pdf\r\n\r\n\r\n",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "การพักการลงโทษ",
    meaning:
      "การปลดปล่อยออกไปก่อนครบกำหนดโทษตามคำพิพากษาศาลภายใต้เงื่อนไข คุมประพฤติที่กำหนด การพักการลงโทษมิใช่สิทธิของผู้ต้องขัง แต่เป็นประโยชน์ที่ทางราชการให้แก่นักโทษเด็ดขาดที่มีความประพฤติดี มีความก้าวหน้าทางการศึกษา ทำงานเกิดผลดีแก่เรือนจำหรือทำความชอบแก่ทางราชการเป็นพิเศษ",
    source:
      "กรมราชทัณฑ์. การพักการลงโทษ, 10 กรกฎาคม 2562. http://www.correct.go.th/popnogb/menu2/m25.html",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ก"
  },
  {
    keyword: "การพัฒนาเขตเศรษฐกิจสามฝ่าย อินโดนีเซีย-มาเลเซีย-ไทย",
    meaning:
      "เป็นโครงการความร่วมมือระหว่างประเทศอินโดนีเซีย มาเลเซีย และไทย ที่เริ่มต้นขึ้นในช่วงปี พ.ศ. 2536 โดยผู้นำทั้ง 3 ประเทศได้เห็นชอบการผลักดันการพัฒนาความร่วมมือทางเศรษฐกิจในลักษณะไตรภาคีเพื่อเร่งรัดการปฏิรูปทางเศรษฐกิจในพื้นที่ส่วนภูมิภาคที่ยังด้อยพัฒนาบนเกาะสุมาตราของอินโดนีเซีย ภาคเหนือของมาเลเซีย และภาคใต้ของไทย ซึ่งธนาคารเพื่อการพัฒนาแห่งเอเชีย (Asian Development Bank : ADB) ได้ทำการศึกษาความเป็นไปได้และกำหนดแนวทางการดำเนินงานในการพัฒนาเขตเศรษฐกิจดังกล่าว ก่อนที่ที่ประชุมระดับรัฐมนตรีและเจ้าหน้าที่อาวุโสของทั้งสามประเทศจะให้ความเห็นชอบในการประชุมครั้งที่ 4 ระหว่างวันที่ 14-16 ธันวาคม พ.ศ. 2537\r\n แผนงาน IMT – GT เน้นความร่วมมือในหลากหลายสาขา ได้แก่ ด้านการค้าและการลงทุน, ด้านการเกษตรและอุตสาหกรรมการเกษตร, ด้านการท่องเที่ยว, ด้านระบบสาธารณูปโภคขั้นพื้นฐานและการเชื่อมต่อการขนส่ง,ด้านการพัฒนาทรัพยากรมนุษย์ และ ด้านการผลิตและให้บริการฮาลาล โดยมีจุดมุ่งหมายที่สำคัญคือ การพัฒนาในเขตจังหวัดพื้นที่ทางตอนใต้ โดยเน้นบทบาทของภาคเอกชนให้เข้ามามีส่วนร่วมในการพัฒนา",
    source:
      "กลุ่มงานอาเซียน สำนักประสานความร่วมมือระหว่างประเทศ. (2562). แผนงานการพัฒนาเขตเศรษฐกิจพิเศษสามฝ่าย อินโดนีเซีย – มาเลเซีย – ไทย (IMT-GT), 7 สิงหาคม 2562. https://icb2.mol.go.th/asean_workgroup/%E0%B9%81%E0%B8%9C%E0%B8%99%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%9E%E0%B8%B1%E0%B8%92%E0%B8%99%E0%B8%B2%E0%B9%80%E0%B8%82%E0%B8%95%E0%B9%80%E0%B8%A8%E0%B8%A3%E0%B8%A9%E0%B8%90%E0%B8%81%E0%B8%B4%E0%B8%88%E0%B8%9E%E0%B8%B4%E0%B9%80%E0%B8%A8%E0%B8%A9%E0%B8%AA%E0%B8%B2%E0%B8%A1%E0%B8%9D%E0%B9%88%E0%B8%B2%E0%B8%A2-%E0%B8%AD%E0%B8%B4%E0%B8%99%E0%B9%82%E0%B8%94%E0%B8%99%E0%B8%B5%E0%B9%80%E0%B8%8B%E0%B8%B5%E0%B8%A2-%E0%B8%A1%E0%B8%B2%E0%B9%80%E0%B8%A5%E0%B9%80%E0%B8%8B%E0%B8%B5%E0%B8%A2-%E0%B9%84%E0%B8%97%E0%B8%A2-imt-gt",
    sappear: 2,
    mappear: 5,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การพัฒนาเมือง",
    meaning:
      "ส่วนหนึ่งของการวางแผนภาคและเมืองซึ่งเป็นการวางแผนเชิงพื้นที่ที่มีทรัพยากรอย่างใดอย่างหนึ่งหรือหลายอย่างขาดแคลน ไม่เพียงพอต่อความต้องการในการใช้งานอย่างอิสระ เสรีของประชาชนทุกคนอย่างเท่าเทียม จึงต้องมีการวางแผนการใช้สอยพื้นที่ เพื่อให้เกิดการจัดสรรทรัพยากรอย่างทั่วถึง เป็นธรรมและมีประสิทธิภาพ",
    source:
      "ผู้ช่วยศาสตราจารย์ ดร.พนิต ภู่จินดา วิทยาลัยพัฒนาการปกครองท้องถิ่น สถาบันพระปกเกล้า. (2556). การผังเมืองกับการพัฒนาเมือง, 7 สิงหาคม 2562. http://padatabase.net/uploads/files/03/doc/90_.pdf",
    sappear: 2,
    mappear: 6,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การพัฒนาเมืองและพื้นที่พิเศษ",
    meaning:
      "เป็นการพัฒนาเชิงพื้นที่ที่เกี่ยวข้องกับการพัฒนาในทุกมิติของการพัฒนาทั้งในด้านเศรษฐกิจ สังคม ทรัพยากรธรรมชาติและสิ่งแวดล้อม รวมทั้งความมั่นคง นอกจากนี้ ในพื้นที่ชายแดน ความร่วมมือระหว่างประเทศและการเปลี่ยนแปลงเงื่อนไขของการพัฒนาในประเทศเพื่อนบ้านเป็นอีกประเด็นที่ต้องให้ความสำคัญ  โดยให้ความสำคัญกับการสร้างความเข้มแข็งของฐานการผลิตและบริการเดิมและการขยายฐานการผลิตและบริการใหม่ การพัฒนาเมืองสำคัญให้เติบโตอย่างมีคุณภาพ การพัฒนาและฟื้นฟูพื้นที่บริเวณชายฝั่งทะเลตะวันออก การบริหารจัดการพื้นที่เศรษฐกิจชายแดน รวมทั้งการเพิ่มประสิทธิภาพกลไกการขับเคลื่อนการพัฒนาภาคและเมือง",
    source:
      "สำนักยุทธศาสตร์และการวางแผนพัฒนาพื้นที่ และสำนักพัฒนาเศรษฐกิจและสังคมภาคกลาง. (2559). การพัฒนาภาค เมือง และพื้นที่เศรษฐกิจ, 24 กันยายน 2562. https://waa.inter.nstda.or.th/stks/pub/2018/20181107-city-region-economy-area-development-strategy.pdf",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การพัฒนาตามแนวระเบียงเศรษฐกิจ",
    meaning:
      "การพัฒนาขีดความสามารถในการแข่งขันโดยลดต้นทุนทางด้านการค้าผ่านแดน การขนส่งและการ\r\nผลิตร่วม  การส่งเสริมการลงทุนผ่านแดน การพัฒนาขีดความสามารถในการแข่งขันโดยส่งเสริมความร่วมมือทางการเงิน เทคโนโลยีการตลาด การผลิต  สร้างความเข้มแข็งให้ชุมชนผู้อยู่อาศัยด้วยการยกระดับรายได้พัฒนาทักษะฝีมือ  การพัฒนาแนวพื้นที่พัฒนาให้เกิดความยั่งยืนทางการเงิน เศรษฐกิจ สิ่งแวดล้อม",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. การพัฒนาแนวพื้นที่พัฒนาเศรษฐกิจ (Economic Corridors Development). 24 ตุลาคม 2562. https://www.nesdc.go.th/ewt_dl_link.php?nid=5136",
    sappear: 2,
    mappear: 5,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การพัฒนาที่ยั่งยืน",
    meaning:
      "การพัฒนาที่ก่อให้เกิดความสมดุลหรือมีปฏิสัมพันธ์ที่เกื้อกูลกันในระหว่างมิติอันเป็นองค์ประกอบที่จะทำให้ชีวิตมนุษย์อยู่ดี มีสุข ทั้งด้านเศรษฐกิจ สังคม การเมือง วัฒนธรรม จิตใจ และทรัพยากรธรรมชาติและสิ่งแวดลอ้ม ทั้งต่อคนในรุ่นปัจจุบัน และคนรุ่นอนาคต",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. การพัฒนาที่ยั่งยืนของไทย, 18 มิถุนายน 2562. https://www.nesdc.go.th/images/content/data03_2-46.pdf",
    sappear: "",
    mappear: 1,
    rappear: 2,
    firstalpha: "ก"
  },
  {
    keyword: "การพัฒนาบริการประชาชน",
    meaning:
      "มาตรการตามยุทธศาสตร์การพัฒนาระบบราชการไทย พ.ศ. 2546-2550\r\n1. มาตรการตามยุทธศาสตร์การปรับเปลี่ยนกระบวนการและวิธีการทำงาน\r\n    ปรับปรุงขั้นตอนและแนวทางการให้บริการประชาชน โดยให้แต่ละส่วนราชการเสนอแผนในการปรับปรุงแก้ไขกฎหมาย และระเบียบปฏิบัติของทางราชการที่ล้าสมัย ไม่มีความจำเป็น หรืออาจเป็นอุปสรรคต่อการให้บริการประชาชน โดยเฉพาะการมอบอำนาจ การอนุมัติ อนุญาติและการสั่งการต่างๆให้เสร็จสิ้น ณ จุดให้บริการเดียวกัน\r\n2. มาตรการตามยุทธศาสตร์การเสริมสร้างระบบราชการให้ทันสมัย\r\n   2.1 สนับสนุนและส่งเสริมให้ส่วนราชการและรัฐวิสาหกิจจัดช่องทางให้ประชาชนขอใช้บริการ รับบริการ และดำเนินการธุรกรรมทางอิเล็กทรอนิกส์ โดยผ่านระบบอินเทอร์เน็ต หรือส่วนบริการทางโทรศัพท์ ได้อย่างกว้างขวางภายใต้การวางมาตรฐานด้านฮาร์ดแวร์-ซอฟแวร์ และรูปแบการให้บริการที่กระทรวงเทคโนโลยีสารสนเทศและการสื่อสารประสานกำหนด\r\n   2.2 ส่งเสริมและกำหนดมาตรฐานการให้บริการของรัฐในระดับสำนักงานที่มีประสิทธิภาพถูกต้องและรวดเร็ว ในรูปแบบของศูนย์บริการอิเล็กทรอนิกส์แบบครบวงจรที่มีการแลกเปลี่ยนข้อมูลระหว่างหน่วยงานภาครัฐ เช่นเดียวกับการให้บริการรัฐบาลอิเล็กทรอนิกส์ทางอินเทอร์เน็ต\r\nมาตรการตามพระราชกฤษฎีกาว่าด้วยหลักเกณฑ์และวิธีการบริหารกิจการบ้านเมืองที่ดี พ.ศ. 2546\r\n1. การรับฟังความคิดเห็นและความพึงพอใจของสังคมโดยรวม และประชาชนผู้รับบริการเพื่อปรับปรุงวิธีการปฏิบัติการให้เหมาะสม\r\n2. ให้มาตรการกระจายอำนาจการตัดสินใจเกี่ยวกับการสั่ง การอนุญาต การอนุมัติ การปฏิบัติราชการเพื่อให้เกิดความรวดเร็วและลดขั้นตอนการปฏิบัติราชการ\r\n3. ในการปฏิบัติงานที่เกี่ยวข้องกับการบริการประชาชน หรือส่วนราชการด้วยกัน ให้ส่วนราชการแต่และแห่งจัดทำแผนภูมิขั้นตอนและระยะเวลาการดำเนินการ และปิดประกาศให้แระชาชนทราบ\r\n4. เพื่ออำนวยความสะดวกแก่ประชาชนให้ส่วนราชการร่วมกันจัดตั้งศูนย์บริการร่วมกระทรวง ศูนย์บริการร่วมจังหวัด ศูนย์บริการร่วมอำเภอ ให้ประชาชนสามารถติดต่อในเรื่องต่างๆใด้ในที่เดียวกัน\r\n5. ให้ส่วนราชการทบทวนเพื่อดำเนินการยกเลิก ปรบปรุง กฎหมาย กฎระเบียบ ทั้งนี้โดยคำนึงถึงความสะดวก รวดเร็ว และลดภาระของประชาชนเป็นสำคัญ\r\n6. ในการบริการประชาชนหรือติดต่อระหว่างส่วนราชการด้วยกัน ให้ส่วนราชการกำหนดระยะเวลาแล้วเสร็จของงานและประกาศให้ประชาชนทราบเป็นการทั่วไป พร้อมกับจัดให้มีระบบเครือข่ายสารสนเทศ เพื่ออำนวยความสะดวกให้แก่ประชาชนที่จะเข้าถึงข้อมูลข่าวสารได้ง่าย",
    source:
      "สำนักงานคณะกรรมการพัฒนาระบบราชการ. 4 ปี การพัฒนาระบบราชการไทย พัฒนาคุณภาพการให้บริการประชาชนที่ดีขึ้น, 24 ตุลาคม 2562. https://www2.opdc.go.th/uploads/files/chapter2_4yearopdc.pdf",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การพัฒนาประชาธิปไตย",
    meaning:
      "การวิจัย การเก็บรวบรวมองค์ความรู้และประสบการณ์เกี่ยวกับการเมืองการปกครองระบอบประชาธิปไตยอันมีพระมหากษัตริย์ทรงเป็นประมุขตลอดจนการส่งเสริมการเผยแพร่ การฝึกอบรมเพื่อให้ระบอบและวิถีชีวิตประชาธิปไตยเป็นปึกแผ่นและยั่งยืน\r\n",
    source:
      "พระราชบัญญัติสถาบันพระปกเกล้า พ.ศ. 2541 (2541,4 กันยายน) ราชกิจจานุเบกษา.เล่ม115 ตอนที่ 57 ก  หน้า 20 http://www.ratchakitcha.soc.go.th/DATA/PDF/2541/A/057/20.PDF\r\n",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ก"
  },
  {
    keyword: "การพัฒนาปัจจัยแวดล้อม",
    meaning:
      "นโยบายด้านปัจจัยแวดล้อม (Enabling Factor) ด้วยการดำเนินการ 4 ด้าน คือ\r\n1. การพัฒนาโครงสร้างพื้นฐาน เช่น การจัดตั้งศูนย์ทดสอบกลางเพื่อการทดสอบและรับรองมาตฐานยางล้อ และชิ้นส่วนยานต์ การพัฒนาพื้นที่อุตสาหกรรม\r\n2. การส่งเสริมระบบเศรษฐกิจดิจิทัล โดยเฉพาะการวางยุทธศาสตร์ดิจิทัลเอสเอ็มอี เพื่อให้ผู้ประกอบการเอสเอ็มอีสามารถแข่งขันได้\r\n3. การปรับปรุงกฎระเบียบ / กฎหมาย และการบริหาราชการบนพื้นฐานธรรมภิบาล เพื่อลดอุปสรรค และต้นทุนการประกอบการ เช่น การลดระยะเวลาในการออกใบอนุญาตตั้งโรงงาน การส่งเสริมการปฏิบัติราชการอย่างมีธรรมภิบาล และเปิดช่องทางการสื่อสารให้ประชาชนสามารถติดต่อกับทางเจ้าหน้าที่ของรัฐได้อย่างสะดวก\r\n4. การพัฒนาทรัพยากรมนุษย์ ด้วยการพัฒนาผู้ประกอบการสู่ระดับโลก เชื่อมโยงข้อมูลระหว่างภาคธุรกิจ และภาคการศึกษาเพื่อสร้างบุคลากรให้ตรงตามความต้องการ",
    source:
      "กระทรวงอุตสาหกรรม. (2559). พัฒนาอุตสาหกรรมไทยตามบริบทโลก, 6 พฤศจิกายน 2562. http://www.industry.go.th/industry/index.php/th/knowledge/item/10614-2016-05-23-05-51-38",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "การพัฒนาปัญญาประดิษฐ์",
    meaning:
      "การนำความฉลาดและความรู้ที่สร้างขึ้นมาจากสิ่งที่ไม่มีชีวิต ซึ่งรวบรวมหลายๆ สิ่งไว้ในสิ่งนั้น เพื่อให้ตอบสนองความต้องการของมนุษย์ให้สามารถคิดและเป็นผู้ช่วยในด้านต่างๆ มีระบบคิด ระบบกระทำอย่างมีเหตุผลตามปัจจัยเหมือนมนุษย์",
    source:
      "พันเอก ไชยสิทธิ์ ตันตยกุล ศูนย์วิจัยยุทธศาสตร์ไทย-จีน สำนักงานคณะกรรมการวิจัยแห่งชาติ. (2561). การพัฒนาเทคโนโลยีปัญญาประดิษฐ์ หรือ AI (Artificial Intelligence) และการนำ AI มาใช้ ตามแผนยุทธศาสตร์การพัฒนา AI แห่งชาติ, 9 กันยายน 2562. http://www.vijaichina.com/articles/1016",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ก"
  },
  {
    keyword: "การพัฒนาผลิตภัณฑ์ทางการเงิน",
    meaning:
      "ผู้ออกผลิตภัณฑ์ควรจัดให้มีกระบวนการที่เหมาะสมในการพัฒนาผลิตภัณฑ์ให้มีความหลากหลาย โดยให้มีความสำคัญกับสภาพแวดล้อมที่เกี่ยวข้อง ผลประโยชน์ และความต้องการของผู้บริโภคเป็นสำคัญ รวมถึงความคิดเห็นและข้อเสนอแนะจากหน่วยงานด้านอื่นที่นอกเหนือไปจากหน่วยงานที่ที่เป็นผู้พัฒนาผลิตภัณฑ์ เช่น การตลาด การขาย และการบริการลูกค้า เพื่อให้แน่ใจว่าผลิตภัณฑ์ที่พัฒนาขึ้นนั้นสอดคล้องกับความต้องการของผู้บริโภค และมีรายละเอียด ลักษณะ เงื่อนไข และความเสี่ยงที่ผู้บริโภคสามารถเข้าใจได้",
    source:
      "สำนักนโยบายธุรกิจและบัญชีสถาบันการเงิน ธนาคารแห่งประเทศไทย. (2556). การนำเสนอข้อมูลเกี่ยวกับผลิตภัณฑ์ทางการเงินของธนาคารพาณิชย์, 24 ตุลาคม 2562. https://www.bot.or.th/Thai/fipcs/Documents/FPG/2556/ThaiPDF/25560255.pdf",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การพัฒนาฝีมือแรงงาน",
    meaning:
      "กระบวนการที่ทำให้ผู้รับการฝึกและประชากรวัยทำงานมีฝีมือ ความรู้ความสามารถ จรรยาบรรณแห่งวิชาชีพ และทัศนคติที่ดีเกี่ยวกับการทำงานอันได้แก่ การฝึกอบรมฝีมือแรงงาน การกำหนดมาตรฐานฝีมือแรงงาน และการอื่นที่เกี่ยวข้อง",
    source:
      "พระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545. (2545, 1 ตุลาคม). ราชกิจจานุเบกษา. เล่ม 119 ตอนที่ 98/1 ก หน้า 2. \r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/00102979.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "การพัฒนาพื้นที่ตามแนวระเบียงเศรษฐกิจ",
    meaning:
      "ภายหลังวิกฤติเศรษฐกิจในปี พ.ศ. 2540 ประเทศ GMS ได้เพิ่มจุดเน้นความร่วมมือตามยุทธศาสตร์ 3Cs – การเชื่อมโยง (Connectivity) การพัฒนาขีดความสามารถ (Competitiveness) และประชาคม (Community)โดยเน้นการพัฒนาตามแนวพื้นที่ ระเบียงเศรษฐกิจ (Economic Corridor) ในพื้นที่ที่มีศักยภาพตามแนวคมนาคมเชื่อมโยงหลัก 3 แนว ได้แก่ 1) แนวเหนือ-ใต้ เชื่อมโยงไทย-พม่า/ลาว-จีน 2) แนวตะวันออก-ตะวันตก เชื่อมโยงพม่าไทย-ลาว-เวียดนาม และ 3) แนวตอนใต้เชื่อมโยงไทย- กัมพูชา-เวียดนาม โดยแนวคิดการพัฒนาแนวพื้นที่ ระเบียงเศรษฐกิจ (Economic Corridor) เป็นการพัฒนาแบบองค์รวมในพื้นที่ที่มีศักยภาพตามแนวคมนาคมเชื่อมโยงหลักของอนุภูมิภาค เพื่อสร้างโอกาสทางธุรกิจและทำให้เกิดการกระจายประโยชน์และโอกาสจากจุดความเจริญหลักให้เชื่อมโยงไปถึงยังพื้นที่ที่ยังขาดการพัฒนาตามแนวคมนาคมดังกล่าวเพื่อกระตุ้นการพัฒนาเศรษฐกิจของแต่ละประเทศสมาชิก โดยมีหลักการสำคัญ คือ การอำนวยความสะดวกในการเคลื่อนย้ายสินค้า บริการ ประชากร รวมถึงเชื่อมโยงการผลิตการค้าและการลงทุนร่วมกัน",
    source:
      "สํานักงานประสานความร่วมมือระหว่างประเทศ\r\nสํานักงานคณะกรรมการพัฒนาการเศรษฐกิจและสังคมแห่งชาติ (กันยายน 2554). การพัฒนาแนวพื้นที่พัฒนาเศรษฐกิจ (Economic Corridors Development), 14 พฤศจิกายน 2562. https://www.nesdb.go.th/ewt_dl_link.php?nid=5136",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การพัฒนาอย่างยั่งยืน",
    meaning:
      "กระบวนการพัฒนาอย่างรอบด้าน อันได้แก่ การพัฒนาด้านเศรษฐกิจ สังคม และ\r\nสิ่งแวดล้อมพร้อม ๆ กัน โดยให้ความสำคัญกับคุณภาพของการพัฒนามากกว่า\r\nอัตราการเจริญเติบโต การพัฒนาที่มีคุณภาพเป็นการสร้างความเจริญเติบโตที่\r\nสร้างงานแก่ประชาชน ตอบสนองความต้องการของประชาชนอย่างเท่าเทียมและ\r\nยุติธรรม และในกระบวนการพัฒนานี้ไม่ใช้ทรัพยากรธรรมชาติจนเกินศักยภาพ\r\nของธรรมชาติ เป็นการพัฒนาที่ก่อให้เกิดความสมดุลหรือมีปฏิสัมพันธ์ที่เกื้อกูล\r\nกันในระหว่างมิติต่าง ๆ และตอบสนองความต้องการของคนรุ่นปัจจุบันโดยไม่\r\nลดทอนศักยภาพการพัฒนาที่จะตอบสนองความต้องการของคนรุ่นต่อไป",
    source:
      "กรมป้องกันและบรรเทาสาธารณภัย. หนังสือคำศัพท์ด้านการบริหารจัดการความเสี่ยงจากภัยพิบัติ, 9 กันยายน 2562. http://www.disaster.go.th/th/download-src.php?did=1225",
    sappear: "",
    mappear: 2,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การพาณิชย์",
    meaning:
      "การค้าขาย, ชื่อกระทรวงที่มีอำนาจหน้าที่เกี่ยวกับการพาณิชย์ และกิจการทางเศรษฐกิจที่เกี่ยวเนื่องกับการพาณิชย์รวมตลอดทั้งการซื้อขายและแลกเปลี่ยนสินค้า การควบคุมและส่งเสริมเกี่ยวกับกิจการค้าและการประกันภัย",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2542. พาณิชย์. 29 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การฟอกเงิน",
    meaning:
      "การโอน รับโอน หรือเปลี่ยนสภาพทรัพย์สินที่เกี่ยวกับการกระทำความผิดบางประการ เพื่อซุกซ่อนหรือปกปิดแหล่งที่มาของทรัพย์สินนั้น หรือเพื่อช่วยเหลือผู้อื่นมิให้ต้องรับโทษหรือรับโทษน้อยลง หรือการปกปิดอำพรางการได้มา ฯลฯ ซึ่งเป็นทรัพย์สินที่เกี่ยวกับการกระทำความผิด",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. \r\nฟอกเงิน, 17 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 1,
    mappear: "",
    rappear: 4,
    firstalpha: "ก"
  },
  {
    keyword: "การฟื้นฟู",
    meaning:
      "การปรับสภาพระบบสาธารณูปโภค การดำรงชีพ และสภาวะวิถีความเป็นอยู่ของ\r\nชุมชนที่ประสบภัยให้กลับสู่สภาวะปกติ หรือพัฒนาให้ดียิ่งขึ้นกว่าเก่าตามความ\r\nเหมาะสม โดยการนำเอาปัจจัยต่าง ๆ ในการลดความเสี่ยงจากภัยพิบัติเข้ามา\r\nช่วยในการฟื้นฟูด้วย (build back better) หมายรวมถึง การซ่อมสร้าง\r\n(reconstruction) และการฟื้นสภาพ (rehabilitation)",
    source:
      "กรมป้องกันและบรรเทาสาธารณภัย. หนังสือคำศัพท์ด้านการบริหารจัดการความเสี่ยงจากภัยพิบัติ, 9 กันยายน 2562. http://www.disaster.go.th/th/download-src.php?did=1225",
    sappear: "",
    mappear: 19,
    rappear: "7,9",
    firstalpha: "ก"
  },
  {
    keyword: "การมีประสิทธิภาพ (Efficiency)",
    meaning:
      "การปฏิบัติการที่ต้องใช้ทรัพยากรอย่างประหยัด เกิดผลิตภาพที่คุ้มค่าต่อการลงทุนและบังเกิดประโยชน์สูงสุดต่อส่วนรวม ทั้งนี้ ต้องมีการลดขั้นตอนและเวลาในการปฏิบัติงาน เพื่ออำนวยความสะดวกและลดภาระค่าใช่จ่าย ตลอดจนยกเลิกภารกิจที่ล้าสมัยและไม่มีความจำเป็น    ",
    source:
      "สำนักงานคณะกรรมการข้าราชการพลเรือน.หลักธรรมาภิบาลของการบริหารกิจการบ้านเมืองที่ดี หน้า 4. 19 พฤศจิกายน 2562.\r\nhttps://www.ocsc.go.th/sites/default/files/attachment/article/7.1_hlakthrrmaaphibaalkhngkaarbrihaarkicchkaarbaanemuuengthiidii.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "การมีส่วนร่วมของประชาชน",
    meaning:
      "การกระจายโอกาสให้ประชาชนมีส่วนร่วมทางการเมือง การปกครองและการบริหารเกี่ยวกับการตัดสินใจ การจัดสรรทรัพยากรของชุมชนและของชาติ โดยการให้ข้อมูล แสดงความคิดเห็น ให้คำแนะนำปรึกษา ร่วมวางแผน ร่วมปฏิบัติ ตลอดจนการควบคุมโดยตรงจากประชาชน",
    source:
      "สำนักงานคณะกรรมการข้าราชการพลเรือน. คำศัพท์ไทย - อังกฤษ สำหรับติดต่อราชการและการประชุมระหว่างประเทศ, 12 กรกฎาคม 2562. https://www.ocsc.go.th/sites/default/files/attachment/page/thaienglish_2ndedition.pdf",
    sappear: "",
    mappear: "19,22",
    rappear: "1,6,11",
    firstalpha: "ก"
  },
  {
    keyword: "การรองรับและบริหารความเสี่ยง (Foresight and Future Labs)",
    meaning:
      "กระบวนการที่ใช้ในการบริหารจัดการให้โอกาสที่จะเกิดเหตุการณ์ความเสี่ยงลดลงหรือผลกระทบของความเสียหายจากเหตุการณ์ความเสี่ยงลดลงอยู่ในระดับที่องค์กรยอมรับได้",
    source:
      "องค์การพิพิธภัณฑ์วิทยาศาสตร์แห่งชาติ. ความเสี่ยง (Risk), 31 ตุลาคม 2562. http://www.thai-sciencemuseum.com/risk/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%9A%E0%B8%A3%E0%B8%B4%E0%B8%AB%E0%B8%B2%E0%B8%A3%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B9%80%E0%B8%AA%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%87/%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%AB%E0%B8%A1%E0%B8%B2%E0%B8%A2%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%84%E0%B8%B3%E0%B8%88%E0%B8%B3%E0%B8%81%E0%B8%B1%E0%B8%94%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "การระงับข้อพิพาท",
    meaning:
      "“ข้อตกลงระงับข้อพิพาท” หมายความว่า ข้อตกลงที่คู่กรณีตกลงให้มีผลผูกพันโดยชอบด้วยกฎหมายเพื่อระงับข้อพิพาทหรือข้อเรียกร้องใด ๆ ที่แต่ละฝ่ายมีอยู่ และให้คู่กรณีแต่ละฝ่ายต่างมีสิทธิหน้าที่ หรือความรับผิดเพียงเท่าที่กำหนดไว้ในข้อตกลงนั้น",
    source:
      "พระราชบัญญัติการไกล่เกลี่ยข้อพิพาท พ.ศ. 2562. (2562, 22 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 67 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/067/T_0001.PDF",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ก"
  },
  {
    keyword: "การรักษาเสถียรภาพการเงิน",
    meaning:
      "ความมั่นคงของระบบการเงินเพื่อทำหน้าที่เป็นตัวกลางในการดำเนินกิจกรรมทางเศรษฐกิจได้อย่างมีประสิทธิภาพ ทั้งนี้ ระบบการเงินมีขอบเขตที่กว้างมาก ไม่ได้ครอบคลุมเพียงสถาบันการเงินในการเป็นตัวเชื่อมระหว่างผู้ออมและผู้ลงทุนเท่านั้น แต่รวมถึงระบบการชำระเงิน ตลาดเงิน ตลาดทุน ตลอดจนธุรกิจประกันภัย อันเป็นช่องทางในการบริหารความเสี่ยง ดังนั้น ระบบการเงินที่มีเสถียรภาพจึงมีความสำคัญ เพราะหากขาดเสถียรภาพอาจสามารถลุกลามเป็นวิกฤตการเงิน (financial crisis) ที่ส่งผลกระทบรุนแรงต่อเศรษฐกิจและความเป็นอยู่ของประชาชน",
    source:
      "ธนาคารแห่งประเทศไทย. (2561), ทำไมธนาคารกลางต้องรักษาเสถียรภาพทางการเงิน?\r\nhttps://www.bot.or.th/Thai/ResearchAndPublications/articles/Pages/Article_08Feb2019.aspx",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การรักษาความมั่นคงภายในราชอาณาจักร",
    meaning:
      "การดำเนินการเพื่อป้องกัน ควบคุม แก้ไข และฟื้นฟูสถานการณ์ใดที่เป็นภัยหรืออาจเป็นภัยอันเกิดจากบุคคลหรือกลุ่มบุคคลที่ก่อให้เกิดความไม่สงบสุข ทำลาย หรือทำความเสียหายต่อชีวิต ร่างกาย หรือทรัพย์สินของประชาชนหรือของรัฐ รวมถึงในกรณีที่เกิดหรือคาดว่าจะเกิดสาธารณภัยตามกฎหมายว่าด้วยการป้องกันและบรรเทาสาธารณภัย ให้กลับสู่สภาวะปกติเพื่อให้เกิดความสงบเรียบร้อยของประชาชน หรือความมั่นคงของรัฐ",
    source:
      "พระราชบัญญัติการรักษาความมั่นคงภายในราชอาณาจักร พ.ศ. 2551. (2551, 27 กุมภาพันธ์). ราชกิจานุเบกษา. เล่มที่125 ตอนที่ 29 ก หน้าที่ 34.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2551/A/039/33.PDF",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การรักษาความยั่งยืนทางการคลัง",
    meaning:
      "ความยั่งยืนหรือเสถียรภาพทางการคลังในระยะปานกลางและระยะยาว กระทรวงการคลังโดยสำนักงานเศรษฐกิจการคลังได้จัดทำกรอบความยั่งยืนด้านการคลัง หรือ การประมาณการรายได้ รายจ่าย ดุลการคลัง และหนี้สาธารณะ ในระยะปานกลาง 5 ปี  ของรัฐบาล เพื่อใช้เป็นแนวทางในการบริหารจัดการทางด้านการคลัง และนำมาพิจารณาร่วมกับแผนและมาตรการดำเนินการตามนโยบายของรัฐบาล สำนักงานเศรษฐกิจการคลังได้มีการปรับปรุงตัวชี้วัดและเป้าหมายของกรอบความยั่งยืนด้านการคลังและแบบจำลองความยั่งยืนด้านการคลังอย่างต่อเนื่อง เพื่อให้เหมาะสมกับสภาวะด้านเศรษฐกิจ การคลังของประเทศ และก่อให้เกิดความยั่งยืนทางการคลัง",
    source:
      "กลุ่มงานบริหารความเสี่ยงทางด้านการคลัง สำนักเศรษฐกิจการคลัง. (2550). การพัฒนากรอบความยั่งยืนด้านการคลัง, 29 ตุลาคม 2562. http://www2.fpo.go.th/FPO/index2.php?mod=Content&file=contentview&contentID=CNT0003633&categoryID=CAT0000154",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การรักษาวินัยการเงินการคลัง",
    meaning:
      "การรักษาวินัยการคลัง และการควบคุมการใช้จ่ายและผลการดำเนินงานทางการคลังของรัฐบาล อาทิ รายจ่าย การก่อหนี้ ตลอดจนภาระผูกพันทางงบประมาณอื่นของรัฐบาล ฯลฯ เพื่อให้เป็นไปตามระดับที่กฎหมายกำหนด และไม่เป็นภาระต่องบประมาณในอนาคต",
    source:
      "เจตน์  ดิษฐอุดม สถาบันพระปกเกล้า. วินัยการคลัง, 12 กันยายน 2562. http://wiki.kpi.ac.th/index.php?title=%E0%B8%A7%E0%B8%B4%E0%B8%99%E0%B8%B1%E0%B8%A2%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%84%E0%B8%A5%E0%B8%B1%E0%B8%87",
    sappear: 6,
    mappear: 20,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การรักษาสมดุลนิเวศ",
    meaning:
      "กลไกของการรักษาดุลยภาพในระบบนิเวศ มีการรักษาสมดุล 2 ลักษณะดังนี้ \r\n1. สมดุลของการหมุนเวียนสารและการถ่ายทอดพลังงานให้เหมาะสม \r\n2. สมดุลของประชากรในสิ่งมีชีวิต เช่น การควบคุมการล่าเหยื่อโดยจัดให้ปริมาณของผู้ล่าและเหยื่ออยู่ในสัดส่วนที่เหมาะสมจะช่วยควบคุมจำนวนจำนวนประชากรในระบบนิเวศให้เกิดความสมดุล",
    source:
      "สุจินดา สนธิญาติ, พชร ชาตาคม, ภาคภูมิ หาฤกดิ์, รักษ์สุดา ดาวโชติ และสุพัตรา บำรุงเดช. ดุลยภาพของระบบนิเวศ, 26 มิถุนายน 2562. https://sites.google.com/site/science0152/19",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การรักษาอำนาจอธิปไตย",
    meaning:
      "อํานาจสูงสุดในการบริหารประเทศแบ่งออก เป็น 3 ฝ่าย มีสถาบันที่ใช้อํานาจอธิปไตยทั้ง 3 แทนประชาชน ดังนี้\r\n  1. อํานาจนิติบัญญัติ - รัฐสภา ทําหน้าที่ตรากฎหมายขึ้นใช้ในประเทศ\r\n  2. อํานาจบริหาร - คณะรัฐมนตรี (รัฐบาล) ทําหน้าที่บริหารประเทศ\r\n  3. อํานาจตุลาการ - ศาล ทําหน้าที่พิจารณาพิพากษาคดี\r\nความสัมพันธ์กันระหว่างอํานาจทั้ง 3 คืออํานาจนิติบัญญัติ อํานาจบริหารและอํานาจตุลาการนั้นมีความสัมพันธ์กันอย่างใกล้ชิด โดยที่รัฐธรรมนูญ จะให้ความสัมพันธ์ของอํานาจทั้งสามสมดุลกันควบคุม ซึ่งกันและกันและไม่อยู่ภายใต้อิทธิพลของกันและกัน และเนื่องจากการ ปกครองระบอบประชาธิปไตย ตามที่บัญญัติไว้ในรัฐธรรมนูญเป็นแบบ ประชาธิปไตยแบบรัฐสภา ดังนั้นความสัมพันธ์ระหว่างรัฐสภา คณะรัฐมนตรี และศาลจึงเป็นไป ตามหลักการ ของประชาธิปไตย แบบรัฐสภา",
    source:
      "กรมประชาสัมพันธ์. (2559). อํานาจอธิปไตย คืออะไร, 13 กันยายน 2562. https://www.prd.go.th/ewt_news.php?nid=153015&filename=index",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ก"
  },
  {
    keyword: "การรับมือ",
    meaning:
      "มาตรการหรือการปฏิบัติการต่าง ๆ ที่ควรเกิดขึ้นอย่างรวดเร็วและทันท่วงทีเพื่อ\r\nรักษาชีวิตและให้ความช่วยเหลือบรรเทาทุกข์ขั้นพื้นฐานแก่ประชาชนที่ได้รับ\r\nความเดือดร้อนจากเหตุการณ์ภัยพิบัติ เช่น การกู้ชีพกู้ภัย การปฐมพยาบาล\r\nการแจกถุงยังชีพและสิ่งของบรรเทาทุกข์ การบัญชาการในเหตุการณ์ฉุกเฉิน\r\nการประสานงานเพื่อลำเลียงผู้ป่วย การบริหารจัดการศูนย์อพยพ ",
    source:
      "กรมป้องกันและบรรเทาสาธารณภัย. หนังสือคำศัพท์ด้านการบริหารจัดการความเสี่ยงจากภัยพิบัติ, 9 กันยายน 2562. http://www.disaster.go.th/th/download-src.php?did=1225",
    sappear: "",
    mappear: "1,2,8,13,19",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การรับรอง JCI",
    meaning:
      "เป็นองค์กรสากลจากประเทศสหรัฐอเมริกาที่คอยตรวจสอบมาตรฐานคุณภาพและความปลอดภัย เพื่อให้การรับรองคุณภาพแก่โรงพยาบาลต่างๆ โรงพยาบาลที่ได้รับมาตรฐาน JCI คือ โรงพยาบาลที่มีความเป็นเลิศในทุกมาตรฐาน ซึ่งรวมไปถึงความมุ่งมั่นในการพัฒนาศักยภาพของโรงพยาบาลให้ดียิ่งขึ้น  ",
    source:
      "โรงพยาบาลสิริโรจน์. การรับรอง JCI, 5 กันยายน 2562. https://www.phuketinternationalhospital.com/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%A3%E0%B8%B1%E0%B8%9A%E0%B8%A3%E0%B8%AD%E0%B8%87-jci/",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "การรู้เท่าทันสื่อ",
    meaning:
      "เกี่ยวข้องกับองค์ประกอบทั้งหมดในกระบวนการสื่อสาร ทั้งในด้านของผู้ส่งสาร หรือผู้ผลิตเนื้อหาข่าวสารสื่อหรือช่องทางการสื่อสาร ผู้รับสาร และผลกระทบที่ได้รับ แนวคิดและทฤษฎีที่เกี่ยวข้องกับสื่อ และนำมาใช้เป็นหลักในการเรียนรู้หรือทำความเข้าใจ เพื่อให้เกิดการรู้เท่าทันสื่อนั้นมุ่งชี้ให้เห็นถึงบริบทหรือสภาพแวดล้อมของสื่อ เพื่อทำความเข้าใจกระบวนการทำงานของสื่อและตอบสนองต่อเนื้อหาข่าวสารของสื่ออย่างรู้เท่าทัน",
    source:
      "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ. รู้เท่าทันสื่อ หน้า 39, 5 สิงหาคม 2562. http://bcp.nbtc.go.th/uploads/items/attachments/b7bb35b9c6ca2aee2df08cf09d7016c2/_651dab51d77cc9cc0b46de8a418db8e7.pdf",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ก"
  },
  {
    keyword: "การลงทุนทางสังคม",
    meaning:
      "เป็นการลงทุนแบบหนึ่งที่นอกเหนือจากผลตอบแทนทางการเงินแล้วผู้ลงทุนยังต้องการให้ธุรกิจสามารถสร้างหรือทำให้เกิดผลกระทบทางที่ดีขึ้นต่อสังคมและสิ่งแวดล้อมไปพร้อมกับการดำเนินธุรกิจ ผลกระทบที่ว่านี้ควรเป็นผลกระทบที่ยั่งยืน รวมถึงสามารถขยายผลให้เติบโตอย่างยั่งยืนในระยะยาวไปพร้อมกับผลตอบแทนทางการเงิน",
    source:
      "ตลาดหลักทรัพย์แห่งประเทศไทย. การลงทุนเพื่อสังคม, 6 พฤศจิกายน 2562. https://www.set.or.th/sustainable_dev/th/sr/sri/ii_p1.html?printable=true",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "ก"
  },
  {
    keyword: "การลงมติ",
    meaning: "ลงความเห็นร่วมกันอย่างใดอย่างหนึ่ง.",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ลงมติ. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ก"
  },
  {
    keyword: "การลดการใช้ดุลยพินิจ",
    meaning:
      "กรณีที่เจ้าหน้าที่ฝ่ายปกครองไม่ใช้ดุลพินิจ ทั้ง ๆ ที่ตามข้อเท็จจริงที่เกิดขึ้นนั้น องค์กรเจ้าหน้าที่ฝ่ายปกครองต้องตัดสินใจดำเนินการอย่างใดอย่างหนึ่ง เช่น มีผู้ชุมนุมประท้วงปิดถนนทำให้บุคคลทั่วไปไม่อาจสัญจรไปมาได้ องค์กรเจ้าหน้าที่ฝ่ายปกครองอาจต้องตัดสินใจสั่งให้สลายการชุมนุม หรือดำเนินการให้มีการสลายการชุมนุม",
    source:
      "กองนิติการ กลุ่มงานที่ปรึกษากฎหมาย นิติกรรมและสัญญา. หลักการใช้ดุลพินิจ, 9 กันยายน 2562. http://protection.labour.go.th/2018/images/Manual/0001.pdf",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "ก"
  },
  {
    keyword: "การลดผลกระทบจากการเปลี่ยนแปลงสภาพภูมิอากาศ",
    meaning:
      "การแทรกแซงเพื่อลดความรุนแรงและควบคุมอัตราการเปลี่ยนแปลงของสภาพ\r\nภูมิอากาศในระยะยาว หมายรวมถึงยุทธศาสตร์สําหรับลดกิจกรรมของมนุษย์ใน\r\nการปล่อยก๊าซเรือนกระจก (greenhouse gas) อันเป็นสาเหตุหนึ่งของการ\r\nเปลี่ยนแปลงสภาพภูมิอากาศ",
    source:
      "กรมป้องกันและบรรเทาสาธารณภัย. หนังสือคำศัพท์ด้านการบริหารจัดการความเสี่ยงจากภัยพิบัติ, 9 กันยายน 2562. http://www.disaster.go.th/th/download-src.php?did=1225",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การละเมิดสิทธิผู้บริโภค",
    meaning:
      "การล่วงเกินหรือฝ่าฝืนไม่รับประกัน ไม่ทำตามสิทธิของผู้บริโภคที่จะได้รับการคุ้มครอง จึงต้องมีพระราชบัญญัติคุ้มครองผู้บริโภค (ฉบับที่ ๔) พ.ศ. ๒๕๖๒ เพื่อให้การคุ้มครองผู้บริโภคด้านความปลอดภัยของสินค้าและบริการมีความเหมาะสมและเป็นไปอย่างมีประสิทธิภาพอันจะเป็นประโยชน์ต่อการคุ้มครองผู้บริโภค และป้องกันการละเมิดสิทธิดังกล่าว",
    source:
      "พระราชบัญญัติคุ้มครองผู้บริโภค (ฉบับที่ 4) พ.ศ. 2562. (2562, 27 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอน69 ก. หน้า1, 18 กรกฎาคม 2562. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/069/T_0096.PDF",
    sappear: 4,
    mappear: 17,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การวางแผนเชิงพื้นที่ทางทะเล",
    meaning:
      "การกำหนดทิศทางการพัฒนา อนุรักษ์ และฟื้นฟูพื้นที่ทางทะเลและชายฝั่งให้สามารถสร้างความมั่นคงทางแหล่งพลังงาน ความมั่งคั่งทางการประมง การท่องเที่ยว การอุตสาหกรรม และการคมนาคมขนส่ง และความยั่งยืนของระบบนิเวศทางทะเล รวมทั้งจัดการกับพื้นที่ที่มีความเสื่อมโทรมจากการใช้ประโยชน์อย่างเข้มข้นและพื้นที่ชายฝั่งที่ถูกกัดเซาะ โดยคำนึงถึงความสัมพันธ์ระหว่างมิติเศรษฐกิจสังคม และสิ่งแวดล้อม และการมีส่วนร่วมของชุมชนท้องถิ่น",
    source:
      "สำนักงานนโยบายและแผนทรัพยากรธรรมชาติและสิ่งแวดล้อม กระทรวงทรัพยากรธรรมชาติและสิ่งแวดล้อม. (2561). นโยบายและแผนการส่งเสริมและรักษาคุณภาพสิ่งแวดล้อมแห่งชาติ พ.ศ. 2560 - 2579, 8 ตุลาคม 2562. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/E/054/29.PDF",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ก"
  },
  {
    keyword: "การวิเคราะห์การจัดการข้อมูลขนาดใหญ่",
    meaning:
      "เพื่อให้สามารถนำข้อมูลมาใช้ได้ง่ายขึ้น และเป็นประโยชน์ในการวางแผนหรือการตัดสินใจ เพื่อให้สามารถนำข้อมูลมาใช้ได้ง่ายขึ้น เพื่อประโยชน์ในการวางแผนหรือการตัดสินใจ",
    source:
      "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม. (2562). นโยบายและแผนระดับชาติว่าด้วยการพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม, 23 กรกฎาคม 2562. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/047/T_0001.PDF",
    sappear: 6,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การวิเคราะห์ความเสี่ยง",
    meaning:
      "กระบวนการกำหนดลักษณะ ขนาด หรือขอบเขตของความเสี่ยงโดยการวิเคราะห์ภัยที่เกิดขึ้น รวมทั้งประเมินสภาวะการเปิดรับต่อความเสี่ยง (exposure) ความเปราะบาง (vulnerability) ศักยภาพ (capacity) ในการรับมือของชุมชนที่อาจเป็นอันตราย และคาดการณ์ผลกระทบต่อชีวิต ทรัพย์สิน การดำรงชีวิตและสิ่งแวดล้อม เป็นการวิเคราะห์ความน่าจะเป็นในการเกิดผลกระทบจากภัยในพื้นที่หนึ่ง ๆ มีประโยชน์ในการวางแผนเพื่อจัดการความเสี่ยงอย่างมีระบบ",
    source:
      "กรมป้องกันและบรรเทาสาธารณภัย. หนังสือคำศัพท์ด้านการบริหารจัดการความเสี่ยงจากภัยพิบัติ, 9 กันยายน 2562. http://www.disaster.go.th/th/download-src.php?did=1225",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การวิเคราะห์ผลกระทบ",
    meaning: "การวิเคราะห์ผลกระทบที่อาจเกิดขึ้นจากกฎหมาย",
    source:
      "พระราชบัญญัติหลักเกณฑ์การจัดทำร่างกฎหมายและการประเมินผลสัมฤทธิ์ของกฎหมาย พ.ศ. 2562. (2562, 31 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136  ตอนที่ 72 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/072/T_0001.PDF\r\n",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ก"
  },
  {
    keyword: "การวิจัย",
    meaning:
      "การศึกษาค้นคว้า วิเคราะห์ หรือทดลองอย่างเป็นระบบ อันจะทำให้ได้มาซึ่งข้อเท็จจริง ความรู้ใหม่ หรือหลักการไปใช้ในการตั้งกฎ ทฤษฎี แนวทางในการปฏิบัติ เพื่อเป็นพื้นฐานของการพัฒนาด้านวิทยาศาสตร์ เทคโนโลยี สังคมศาสตร์ มนุษยศาสตร์ และศิลปวิทยาการแขนงต่าง ๆ รวมทั้งเพื่อสร้างนวัตกรรม อันจะสามารถนำมาใช้ประโยชน์ได้",
    source:
      "พระราชบัญญัติสภานโยบายการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมแห่งชาติ\r\nพ.ศ. 2562. (2562, 1 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 57 ก หน้า 9. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/057/T_0008.PDF",
    sappear: "",
    mappear: 23,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การวิจัยและพัฒนา",
    meaning:
      "กระบวนการศึกษาค้นคว้าอย่างมีระบบ มีจุดมุ่งหมายเพื่อพัฒนาและตรวจสอบคุณภาพของผลิตภัณฑ์ซึ่งมี 2 ลักษณะ ได้แก่ ผลิตภัณฑ์ประเภทสื่อวัสดุอุปกรณ์ (Material) และผลิตภัณฑ์ประเภทวิธีการหรือกระบวนการ (Process) โดยดำเนินการทดสอบในสภาพจริงและทำการปรับปรุงผลิตภัณฑ์หลายๆ รอบ จนได้ผลิตภัณฑ์ที่มีคุณภาพ เพื่อนำไปใช้ในการพัฒนากลุ่มคน หน่วยงานหรือองค์การให้มีประสิทธิภาพยิ่งขึ้น",
    source:
      "ผศ.ดร.วาโร เพ็งสวัสดิ์. (2552). การวิจัยและการพัฒนา (Research and Development). วารสารมหาวิทยาลัยราชภัฏสกลนคร, 1(2), 2",
    sappear: "1,2,5",
    mappear: 8,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การวิจัยและพัฒนานวัตกรรม",
    meaning:
      "เครื่องมือหรือกลยุทธ์ในการหาความรู้ใหม่อย่างเป็นระบบ มีทิศทางที่แน่ชัด เพื่อปรับปรุงเปลี่ยนแปลงหรือเพื่อแก้ไขปัญหาของงานที่กำลังดำเนินการอยู่เป็นประจำ หรือใช้ในการพัฒนาเพื่อให้ได้นวัตกรรมสิ่งประดิษฐ์ หรือองค์ความรู้ที่มีศักยภาพ มีมาตรฐาน เกิดประโยชน์แก่สังคมอย่างกว้างขวาง",
    source:
      "สันต์ สุวทันพรกูล ผู้ช่วยนักวิจัยโครงการด้านการศึกษา คณะครุศาสตร์ จุฬาลงกรณ์มหาวิทยาลัย. แนวทางการวิจัยและพัฒนานวัตกรรมทางการศึกษา, 24 ตุลาคม 2562. http://sripatum-review.spu.ac.th/doc/51_17-09-2018_11-45-32.pdf",
    sappear: "",
    mappear: 23,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การศึกษา",
    meaning:
      "กระบวนการเรียนรู้เพื่อความเจริญงอกงามของบุคคลและสังคม    \r\nโดยการถ่ายทอดความรู้ การฝึก การอบรม การสืบสานทางวัฒนธรรม การสร้างสรรค์จรรโลงความก้าวหน้าทางวิชาการ การสร้างองค์ความรู้อันเกิดจากการจัดสภาพแวดล้อม สังคม การเรียนรู้และปัจจัย\r\nเกื้อหนุนให้บุคคลเรียนรู้อย่างต่อเนื่องตลอดชีวิต",
    source:
      "พระราชบัญญัติการศึกษาแห่งชาติ พ.ศ. 2542. (2542, 19 สิงหาคม). ราชกิจจานุเบกษา. เล่ม 113 ตอนที่ 74 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/074/1.PDF                                                                       ",
    sappear: "",
    mappear: "",
    rappear: 12,
    firstalpha: "ก"
  },
  {
    keyword: "การศึกษาขั้นพื้นฐาน",
    meaning: "การศึกษาก่อนระดับอุดมศึกษา",
    source:
      "พระราชบัญญัติการศึกษาแห่งชาติ พ.ศ. 2542 (2542, 19 สิงหาคม). ราชกิจจานุเบกษา. เล่ม 116 ตอนที่ 74 ก หน้า 2.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/074/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "ก"
  },
  {
    keyword: "การศึกษาตลอดชีวิต",
    meaning:
      "การศึกษาที่เกิดจากการผสมผสานระหว่างการศึกษาใน\r\nระบบ การศึกษานอกระบบและการศึกษาตามอัธยาศัย เพื่อให้สามารถพัฒนาคุณภาพชีวิตได้อย่าง\r\nต่อเนื่องตลอดชีวิต",
    source:
      "พระราชบัญญัติการศึกษาแห่งชาติ พ.ศ. 2542. (2542, 19 สิงหาคม). ราชกิจจานุเบกษา. เล่ม 113 ตอนที่ 74 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/074/1.PDF   ",
    sappear: "",
    mappear: "",
    rappear: 12,
    firstalpha: "ก"
  },
  {
    keyword: "การศึกษาวิจัยเชิงประเมินผล",
    meaning:
      "กระบวนการให้ได้มาซึ่งสารสนเทศเกี่ยวกับความก้าวหน้าโครงการ และความสำเร็จของโครงการ อันเป็นเครื่องบ่งชี้ถึงคุณค่าของโครงการ กล่าวคือ เป็นเครื่องแสดงว่าโครงการได้ดำเนินไปแล้วได้ผลตามวัตถุประสงค์ของโครงการมากน้อยเพียงใด ตลอดจนในอนาคตควรจะดำเนินการอย่างไร ซึ่งเป็นการพัฒนาคุณค่าโดยใช้ผลงานในอดีตและพิจารณาถึงศักยภาพ และทางเลือกในการดำเนินงานในอนาคตต่อไป",
    source:
      "คณะทำงานศึกษาและดำเนินการจัดทำวิจัย โครงการแข่งขันตอบปัญหาความรู้เกี่ยวกับรัฐสภา. (2550). โครงการแข่งขันตอบปัญหาความรู้เกี่ยวกับรัฐสภา, 21 ตุลาคม 2562. https://library2.parliament.go.th/ebook/content-ebbas/quiz2550res.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ก"
  },
  {
    keyword: "การสงเคราะห์",
    meaning:
      "ระบบการทำงานซึ่งนายจ้างอนุญาตให้ลูกจ้างที่ทำงานมานานจนกระทั่งเข้าสู่วัยชรา สุขภาพไม่ดี ลูกจ้างที่ประสบอุบัติเหตุ ลูกจ้างที่ร่างกายพิการบางส่วน ฯลฯ ได้ทำงานที่เบากว่าเดิม โดยคงนับอายุงานต่อเนื่องและได้รับสิทธิอื่นๆ เช่นเดิม",
    source:
      "กรมสวัสดิการและคุ้มครองแรงงาน. ศัพท์ด้านแรงงาน, 18 กันยายน 2562. https://www.labour.go.th/index.php/component/seoglossary/1-dictionary/R",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "การสร้างเครื่องหมายการค้า",
    meaning:
      "เครื่องหมายที่เกี่ยวข้องกับสินค้า เพื่อแสดงว่าสินค้าที่ใช้เครื่องหมายนั้นแตกต่างกับสินค้าที่ใช้เครื่องหมายการค้าของบุคคลอื่น เช่น บรีส มาม่า กระทิงแดง เป็นต้น ปัจจุบันผู้ประกอบการค้าใช้เครื่องหมายการค้าเป็นเครื่องมือนำทางการค้า ทั้งภายในประเทศและการส่งออกสินค้าไปจำหน่ายยังต่างประเทศ เจ้าของเครื่องหมายการค้าจึงมีความจำเป็นต้องจดทะเบียนขอรับความคุ้มครองสิทธิในประเทศต่าง ๆ ก่อนส่งสินค้าไปจำหน่าย เพื่อป้องกันปัญหาการละเมิดเครื่องหมายการค้า และมิให้ผู้ใดนำเครื่องหมายการค้าของตนไปจดทะเบียนในต่างประเทศโดยมิได้เป็นเจ้าของ",
    source:
      "กระทรวงพาณิชย์. (2558). ความหมายของเครื่องหมายการค้า, 7 สิงหาคม 2562. https://www.moc.go.th/index.php/2015-11-02-02-35-13/item/4222.html",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การสร้างความเป็นธรรม",
    meaning:
      'ความเป็นธรรมในสังคมเป็นองค์ประกอบสำคัญของสิทธิพลเมือง สะท้อนถึงความยุติธรรมสำหรับคนในสังคม กล่าวคือ คนทุกคนในสังคมควรได้รับสิทธิพื้นฐาน การคุ้มครอง โอกาสและสิทธิ์ประโยชน์ทางสังคม ถือเป็นข้อผูกพันทางสังคมในการจัดสรรทรัพยากรและการจัดบริการสวัสดิการสังคม ที่ควรให้ความสำคัญในการหลีกเลี่ยงจาก 3 ประเด็น ได้แก่ 1. อคติ คือ ความเชื่อหรือทัศนคติเชิงลบที่ไม่ชอบต่อบุคคลหรือกลุ่มอันเป็นมายาคติ และทำให้ก่อแนวคิดที่ไม่ถูกต้องต่อเรื่องใดเรื่องหนึ่ง, 2. การเลือกปฏิบัติ คือ การกระทำที่ปฏิบัติต่อประชาชนอย่างแตกต่างกัน อันเป็นผลมาจากความเชื่อที่มีอคติต่อเรื่องนั้นๆ หากการเลือกปฏิบัติมีการขยายวงกว้างการพัฒนาไปสู่ระบบการเลือกปฏิบัติจะนำไปสู่ "การกดขี่", 3. การกดขี่ คือ การบีบบังคับและการใช้อำนาจโดยไม่มีเหตุผล',
    source:
      "ธนาชัย สุนทรอนันตชัย. (2560). ความเท่าเทียม ความเสมอภาค และความเป้นธรรมทางสังคม กับการจัดสวัสดิการสังคมของประเทศไทย, 12 กรกฎาคม 2562. http://www.kmutt.ac.th/jif/public_html/Download/Format_Checker/9/5.pdf",
    sappear: 4,
    mappear: "15,16,17",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การสร้างนวัตกรรม",
    meaning:
      "การคิดค้นและแสวงหาวิธีการหรือ solution ใหม่ๆ ทำให้เกิด big impact เพื่อปรับปรุง\r\nและออกแบบการให้บริการสาธารณะให้สามารถตอบสนองปัญหาความต้องการของ\r\nประชาชนได้อย่างมีคุณภาพ และการใช้วิธีการห้องปฏิบัติการ (GovLab/Public Sector Innovation Lab) และใช้วิธีการ\r\nออกแบบ (Design Thinking) โดยให้ประชาชนเข้ามามีส่วนร่วม เพื่อสร้างความเข้าใจ\r\nเข้าถึงความรู้สึกนึกคิด (Empathize) ก่อนจะสร้างจินตนาการ พัฒนาต้นแบบ (Prototype) ทำการทดสอบ ปฏิบัติจริงและขยายผลต่อไป\r\n",
    source:
      "สำนักงานคณะกรรมการพัฒนาระบบราชการ. (2561). อภิธานศัพท์ การสร้างนวัตกรรม, 2 กันยายน 2562. http://hp.anamai.moph.go.th/article_attach/%E0%B8%AD%E0%B8%A0%E0%B8%B4%E0%B8%98%E0%B8%B2%E0%B8%99%E0%B8%A8%E0%B8%B1%E0%B8%9E%E0%B8%97%E0%B9%8C%207%2004%2061-1.pdf",
    sappear: "",
    mappear: "4,23",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การสร้างมูลค่าเพิ่ม (Value Creation)",
    meaning:
      "การสร้างคุณค่าที่แท้จริงขององค์กร ด้วยการพัฒนาความสามารถขององค์กรให้โดดเด่นเป็นเอกลักษณ์เสริมสร้างจุดเด่นที่ดีอยู่แล้ว รวมถึงนำเอาความรู้และทักษะใหม่ๆที่เหมาะสมมาประยุกต์ใช้เพื่อตอบสนองความต้องการธุรกิจและความเหมาะสมทางการตลาด",
    source:
      "นายพรพจน์ ลีลาพรชัย วิทยาลัยนวัตกรรม มหาวิทยาลัยธรรมศาสตร์.(2560). การศึกษาปัจจัยความสำเร็จในการสร้าง Value Creation สำหรับ Startup และ SME ในธุรกิจความรู้เข้มข้น KIBS, 3 กันยายน 2562. http://ethesisarchive.library.tu.ac.th/thesis/2017/TU_2017_5323030386_3344_6399.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "การสร้างสรรค์บรรจุภัณฑ์อัจฉริยะ",
    meaning:
      "การพัฒนาที่เกิดบรรจุภัณฑ์รูปแบบใหม่ที่เน้นทางด้านความสะดวกสบายต่อผู้บริโภค ฉีกกฎบรรจุภัณฑ์แบบเดิมๆที่มีหน้าที่เพียงปกป้องสินค้า หรือมีแค่ความสวยงาม แต่บรรจุภัณฑ์อัจฉริยะได้นำเอาเทคโนโลยีสมัยใหม่มาผสมผสานกับบรรจุภัณฑ์เพื่อยืดอายุผลไม้หรืออาหารในบรรจุภัณฑ์นั้นเพื่อให้มีอายุในการรับประทานที่ยาวนานขึ้น และสามารถเก็บไว้ได้นานยิ่งขึ้น",
    source:
      "กรมส่งเสริมอุตสาหกรรม. เทคโนโลยีกับบรรจุภัณฑ์, 24 ตุลาคม 2562. https://bsc.dip.go.th/th/category/production2/sm-technologypackage2",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การสอดส่อง (ในกระบวนการยุติธรรม)",
    meaning:
      "กระบวนการติดตามดูแล ให้คำแนะนำและช่วยเหลือผู้กระทำผิดที่อยู่ระหว่างการคุมประพฤติ โดยมีพนักงานคุมประพฤติและเครือข่ายที่เกี่ยวของเป็นผู้ควบคุมดูแลตามสภาพปัญหา และความต้องการเป็นรายบุคคล",
    source:
      "กระทรวงยุติธรรม. (2560). งานการควบคุมและสอดส่อง, 22 ตุลาคม 2562. https://www.moj.go.th/view/8008",
    sappear: 6,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การสอบทานธุรกิจ (Due Diligence)",
    meaning:
      "การตรวจสอบธุรกิจตามวัตถุประสงค์ของผู้ว่าจ้าง โดยอาจพิจารณาธุรกิจทั้งหมด หรือเพียงบางส่วนเป็นการเฉพาะเจาะจงก็ได้ ซึ่งมักจะหมายถึง การสอบทานประเภทจำกัดขอบเขต หรือการสอบทานโดยวิธีการสอบทานที่ผู้ว่าจ้างและผู้ปฏิบัติงานได้ตกลงร่วมกัน",
    source:
      "อุณากร พฤฒิธาดา หุ้นส่วนสำนักงานไร้ซวอเตอร์เฮ้าส์ และศิลปพร ศรีจั่นเพรช อาจารย์ประจำภาควิชาการบัญชี มหาวิทยาลัยธรรมศาสตร์. (2547). Due Diligence, 10 ตุลาคม 2562. http://library.dip.go.th/multim1/edoc/13599.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ก"
  },
  {
    keyword: "การสำรวจขุดเจาะ",
    meaning:
      "การสำรวจเริ่มจากการศึกษาสภาพภูมิประเทศและสภาพทางธรณีวิทยาอย่างไรก็ตามการสำรวจภาคพื้นดินจะได้ข้อมูลคร่าวๆ ซึ่งจะนำมาใช้ในการคาดคะเนว่ามีน้ำมันดิบหรือก๊าซธรรมชาติสะสมตัวอยู่หรือไม่ แต่จะไม่ทราบแน่ชัด จะต้องทำการขุดเจาะสำรวจเสียก่อน การศึกษาสภาพภูมิประเทศได้จากการศึกษาแผนที่ทางธรณีวิทยาตัวอย่างหิน ภาพถ่ายจากดาวเทียม",
    source:
      "iEnergyGuru. (2558). การสำรวจและการขุดเจาะหาแหล่งก๊าซธรรมชาติ, 12 กรกฎาคม 2562. https://ienergyguru.com/2015/05/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%AA%E0%B8%B3%E0%B8%A3%E0%B8%A7%E0%B8%88%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%82%E0%B8%B8%E0%B8%94%E0%B9%80%E0%B8%88%E0%B8%B2%E0%B8%B0-natural-gas/",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "การสืบเสาะ (ในกระบวนการยุติธรรม)",
    meaning:
      "กระบวนการแสวงหาข้อเท็จจริงเกี่ยวกับประวัติภูมิหลังทางสังคมของผู้กระทำผิด เพื่อวิเคราะห์ คัดกรองผู้กระทำผิด และให้ศาลนำมาประกอบการพิจารณาใช้มาตรการที่เหมาะสมต่อผู้กระทำผิดแต่ละรายต่อไป ",
    source:
      "กระทรวงยุติธรรม. (2560). การสืบเสาะและพินิจ, 10 กันยายน 2562. https://www.moj.go.th/view/7950",
    sappear: 6,
    mappear: 22,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "การสืบเสาะและพินิจ",
    meaning:
      "การแสวงหาข้อเท็จจริงและรายละเอียดเกี่ยวกับผู้ถูกสืบเสาะและพินิจเพื่อประมวลข้อเท็จจริง จัดทํารายงานและความเห็นเสนอประกอบการพิจารณาของศาลหรือเจ้าพนักงานผู้มีอํานาจ",
    source:
      "พระราชบัญญัติคุมประพฤติ พ.ศ. 2559. (2559, 3 ตุลาคม). ราชกิจจานุเบกษา. เล่ม 133 ตอนที่ 88 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2559/A/088/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ก"
  },
  {
    keyword: "การสูญเสียปีสุขภาวะ",
    meaning: "การตายก่อนวัยอันควร หรือการมีชีวิตอยู่ด้วยความเจ็บปวดหรือพิการ",
    source:
      "มูลนิธิเพื่อการพัฒนานโยบายสุขภาพระหว่างประเทศ สำนักงานพัฒนานโยบายสุขภาพระหว่างประเทศ. (2558). การสูญเสียปีสุขภาวะ Disability-Adjusted Life Year : DALY รายงานภาระโรคและการบาดเจ็บของประชากรไทย พ.ศ. 2556, 11 ตุลาคม 2562. http://www.satun.m-society.go.th/category/%E0%B8%9C%E0%B8%B9%E0%B9%89%E0%B8%94%E0%B9%89%E0%B8%AD%E0%B8%A2%E0%B9%82%E0%B8%AD%E0%B8%81%E0%B8%B2%E0%B8%AA/",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ก"
  },
  {
    keyword: "การหันเหคดี (Diversion)",
    meaning:
      "แนวคิดในการนำผู้กระทำความผิดออกจากกระบวนการยุติธรรมที่เป็นทางการ โดยการเปลี่ยนแปลงการปฏิบัติต่อผู้ต้องหาจำเลยและผู้ต้องขังตามขั้นตอนของกฎหมาย เกิดจากการปฏิรูปครั้งใหญ่ในสหรัฐอเมริการะหว่างกลางทศวรรษที่ 60 ถึงกลางทศวรรษที่70 โดยการใช้วิธีแก้ไขผู้กระทำผิดในชุมชนเป็นหลัก (community-based treatment)โครงการหันเหหรือกลั่นกรองผู้กระทำ",
    source:
      "อาจารย์ ดร.สุทธิพล ทวีชัยการ เลขาธิการคณะกรรมการการเลือกตั้ง. กระบวนการยุติธรรมทางเลือกในคดีอาญา, 26 กันยายน 2562. http://law.stou.ac.th/dynfiles/41717-9-A.pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ก"
  },
  {
    keyword: "การอนุรักษ์",
    meaning:
      "วิธีการใช้ทรัพยากรอยางคุ้มค่า และรวมทั้งก่อให้เกิดประโยชน์สูงสุดต่อมนุษย์และยาวนานที่สุด โดยสูญเสียทรัพยากรน้อยที่สุด",
    source:
      "มหาวิทยาลัยบูรพา. บทที่ 1 บทนำ ความเป็นมาและความสำคัญของปัญหา, 21 กรกฎาคม 2562.  http://digital_collect.lib.buu.ac.th/dcms/files/54930415/chapter1.pdf",
    sappear: "1,2,5",
    mappear: "",
    rappear: 6,
    firstalpha: "ก"
  },
  {
    keyword: "การอนุวัติตามพันธกรณี",
    meaning:
      "การดำเนินการให้เป็นผลตามบทบัญญัติแห่งอนุสัญญา (implement the provisions of a convention) โดยการตรากฎหมายภายในประเทศ หรือปรับแก้กฎหมายภายในประเทศ เพื่อให้สอดคล้องและรองรับกับพันธกรณีอนุสัญญาดังกล่าว",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์ (องค์การมหาชน). (2555). อนุวัติการ (Implementation), 16 ตุลาคม 2562. https://www.etda.or.th/terminology-detail/1211.html",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ก"
  },
  {
    keyword: "การอภัยโทษ",
    meaning: "การยกโทษ เปลี่ยนโทษหนักเป็นเบา หรือลดโทษให้",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2542. \r\nอภัยโทษ, 29 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ก"
  },
  {
    keyword: "กำลังผลิตไฟฟ้าสูงสุด (Peak Demand)",
    meaning:
      "ค่าสูงสุดของค่าพลังไฟฟ้า ในช่วงเวลาใดช่วงเวลาหนึ่ง มีหน่วยเป็นกิโลวัตต์ (kW) หรือเมกะวัตต์ (1 MW = 1,000 kW) ",
    source:
      "การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย. สถานการณ์พลังงานไฟฟ้าและการผลิตไฟฟ้าของประเทศไทย, 3 ตุลาคม 2562. http://web.senate.go.th/w3c/senate/pictures/comm/1540/%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%95%E0%B9%89%E0%B8%AD%E0%B8%87%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%83%E0%B8%8A%E0%B9%89%E0%B8%9E%E0%B8%A5%E0%B8%B1%E0%B8%87%E0%B9%84%E0%B8%9F%E0%B8%9F%E0%B9%89%E0%B8%B2%E0%B8%AA%E0%B8%B9%E0%B8%87%E0%B8%AA%E0%B8%B8%E0%B8%94.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "กำลังผลิตสำรอง",
    meaning:
      "1. กำลังผลิตสำรองของระบบผลิตไฟฟ้า (Standby Reserve) เป็นโรงไฟฟ้าสำรองตามแผนการผลิตไฟฟ้าโดยมาตรฐานสากลจะกำหนดไว้ราวร้อยละ 15 ของความต้องการไฟฟ้าสูงสุด ซึ่งจากกำลังผลิตติดตั้งภายในประเทศราว33,000 เมกะวัตต์ จะพบว่ามีกำลังผลิตสำรอง ในปัจจุบันประมาณ 5,000 เมกะวัตต์ เนื่องจากในการวางแผนการผลิตไฟฟ้าจะต้องคำนึงถึงปัจจัยอื่นๆ อย่างรอบคอบอาทิ ความต้องการไฟฟ้าที่อาจเพิ่มสูงกว่าการพยากรณ์ การหยุดซ่อมโรงไฟฟ้าการเสื่อมสภาพของโรงไฟฟ้า ความเสี่ยงด้านเชื้อเพลิง ข้อจำกัดของระบบส่งในแต่ละพื้นที่ และลักษณะทางเทคนิคของโรงไฟฟ้าแต่ละประเภท\r\n2. กำลังผลิตสำรองพร้อมจ่าย (Spinning Reserve) เป็นกำลังผลิตสำรองจากโรงไฟฟ้าที่เดินเครื่องอยู่หรือสามารถสั่งเพิ่มการจ่ายไฟฟ้าได้ทันทีที่ระบบมีความต้องการ ซึ่งตามมาตรฐานจะต้องมีจำนวน 800 – 1,600 เมกะวัตต์ หรืออย่างน้อยมากกว่ากำลังผลิตของโรงไฟฟ้าที่ใหญ่ที่สุด เพื่อรองรับหากเกิดเหตุการณ์ขัดข้องที่โรงไฟฟ้าพลังความร้อนขนาดใหญ่ เช่น กำลังผลิต 800 เมกะวัตต์ ศูนย์ควบคุมระบบกำลังไฟฟ้าแห่งชาติก็สามารถสั่งจ่ายไฟฟ้าเพิ่มขึ้นทันทีป้องกันปัญหาไฟตกหรือดับ ซึ่งอาจลุกลามจนเกิดไฟฟ้าดับเป็นบริเวณกว้าง (Blackout) ได้",
    source:
      "การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย. กำลังผลิตสำรอง: หลักประกันความมั่นคงของระบบไฟฟ้า, 1 ตุลาคม 2562. http://www.egat.co.th/index.php?option=com_content&view=article&id=357&catid=38&Itemid=323",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "กิจกรรม",
    meaning:
      "งานที่ต้องทำภายใต้ภารกิจนั้น เพื่อให้ได้ผลผลิต ทั้งในรูปของผลิตภัณฑ์และบริการ และมีการมอบหมายผู้รับผิดชอบอย่างชัดเจน การระบุงานใดเป็นกิจกรรมต้องสามารถอธิบายให้เห็นกระบวนการได้คือ เห็นที่มาของกิจกรรม (Input), ผลผลิต (Output) และผู้ใช้(User) อย่างชัดเจน ทั้งนี้ในแต่ละภารกิจไม่ควรแตกย่อยกิจกรรมมาก นั่นหมายถึงการกระจายต้นทุนหรือจัดสรรทรัพยากรลงไปดำเนินการให้สำเร็จ ซึ่งทำได้ยาก",
    source:
      "สำนักงานคณะกรรมการพัฒนาระบบราชการ. เอกสารการจัดทำแผนปฏิรูปองค์การฯ. อภิธานศัพท์, 31 กรกฎาคม 2562.  http://hp.anamai.moph.go.th/article_attach/%E0%B8%AD%E0%B8%A0%E0%B8%B4%E0%B8%98%E0%B8%B2%E0%B8%99%E0%B8%A8%E0%B8%B1%E0%B8%9E%E0%B8%97%E0%B9%8C%207%2004%2061-1.pdf",
    sappear: "",
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กิจกรรมเพื่อตอบแทนสังคม",
    meaning:
      "การดำเนินกิจกรรมที่รับผิดชอบต่อสังคมและสิ่งแวดล้อมขององค์กร ซึ่งคือการดำเนินกิจการภายใต้หลักจริยธรรมและการจัดการที่ดี โดยรับผิดชอบสังคมและสิ่งเเวดล้อมทั้งในระดับไกลและใกล้ นำไปสู่การพัฒนาที่ยั่งยืน",
    source:
      "ห้องสมุดโรงเรียนช่างฝีมือทหาร. CSR คือ อะไร, 3 กันยายน 2562. http://61-90-231-85.static.asianet.co.th/mttslibrary/index.php/2015-05-29-16-17-20\r\n",
    sappear: "",
    mappear: 10,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กิจกรรมทางทะเล",
    meaning:
      "การดำเนินการเพื่อใช้ประโยชน์ในเขตทางทะเลใน\r\nรูปแบบต่าง ๆ เช่น การพาณิชยนาวี การประมง การท่องเที่ยว การแสวงประโยชน์จากทรัพยากร\r\nที่ไม่มีชีวิต การวางสายเคเบิลหรือท่อใต้ทะเล การอนุรักษ์และการจัดการทรัพยากรธรรมชาติและ\r\nสิ่งแวดล้อมทางทะเลและชายฝั่ง การป้องกันและบรรเทาสาธารณภัย หรือการสำรวจและวิจัย\r\nวิทยาศาสตร์ทางทะเล ",
    source:
      "พระราชบัญญัติการรักษาผลประโยชน์ของชาติทางทะเล พ.ศ. 2562. (2562, 12 มีนาคม). ราชกิจจานุเบกษา. เล่มที่ 136 ตอนที่ 30 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/030/T_0001.PDF",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กิจกรรมสาธารณประโยชน์",
    meaning: "กิจกรรมที่เป็นประโยชน์ทั่วไปแก่ประชาชน",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2557). สาธารณะ, 22 ตุลาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%AA%E0%B8%B2%E0%B8%98%E0%B8%B2%E0%B8%A3%E0%B8%93%E0%B8%B0",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กิจกรรมสาธารณะ",
    meaning: "กิจกรรมที่เป็นประโยชน์ทั่วไปแก่ประชาชน",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2557). สาธารณะ, 22 ตุลาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%AA%E0%B8%B2%E0%B8%98%E0%B8%B2%E0%B8%A3%E0%B8%93%E0%B8%B0",
    sappear: 6,
    mappear: "",
    rappear: "",
    firstalpha: "ก"
  },
  {
    keyword: "กิจการโทรคมนาคม",
    meaning:
      "กิจการซึ่งให้บริการส่ง การแพร่ หรือการรับเครื่องหมาย สัญญาณ ตัวหนังสือ ตัวเลข ภาพ เสียง รหัส หรือการอื่นใด ซึ่งสามารถให้เข้าใจความหมายได้โดยระบบสาย ระบบคลื่นความถี่ ระบบแสง ระบบแม่เหล็กไฟฟ้าอื่น หรือระบบอื่นระบบใดระบบหนึ่ง หรือหลายระบบรวมกัน หรือกิจการโทรคมนาคมตามที่มีกฎหมายบัญญัติหรือตามที่คณะกรรมการร่วมกำหนดให้เป็นกิจการโทรคมนาคม",
    source:
      "พระราชบัญญัติองค์กรจัดสรรคลื่นความถี่และกำกับกิจการวิทยุกระจายเสียงวิทยุโทรทัศน์และกิจการโทรคมนาคม พ.ศ. 2543 (2553,19 ธันวาคม). ราชกิจจานุเบกษา.เล่ม 127 ตอนที่ 78 ก หน้า 3 http://www.ratchakitcha.soc.go.th/DATA/PDF/2553/A/078/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ก"
  },
  {
    keyword: "กิจการโทรทัศน์",
    meaning:
      "กิจการซึ่งให้บริการการส่งข่าวสารสาธารณะ หรือรายการไปยังเครื่องรับที่สามารถรับชมการให้บริการนั้น ๆ ได้ ไม่ว่าจะส่งโดยผ่านระบบสายระบบคลื่นความถี่ ระบบแสง ระบบแม่เหล็กไฟฟ้าอื่น หรือระบบอื่น ระบบใดระบบหนึ่ง หรือ หลายระบบรวมกัน หรือกิจการโทรทัศน์ตามที่มีกฎหมายบัญญัติหรือตามที่คณะกรรมการร่วมกำหนดให้เป็นกิจการโทรทัศน์",
    source:
      "พระราชบัญญัติองค์กรจัดสรรคลื่นความถี่และกำกับกิจการวิทยุกระจายเสียงวิทยุโทรทัศน์และกิจการโทรคมนาคม พ.ศ. 2543 (2553,19 ธันวาคม). ราชกิจจานุเบกษา.เล่ม 127 ตอนที่ 78 ก หน้า 2 http://www.ratchakitcha.soc.go.th/DATA/PDF/2553/A/078/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ก"
  },
  {
    keyword: "กิจการกระจายเสียง",
    meaning:
      "กิจการซึ่งให้บริการการส่งข่าวสารสาธารณะ หรือรายการไปยังเครื่องรับที่สามารถรับฟังการให้บริการนั้น ๆ ได้ ไม่ว่าจะส่งโดยผ่านระบบสายระบบคลื่นความถี่ ระบบแสง ระบบแม่เหล็กไฟฟ้าอื่น หรือระบบอื่น ระบบใดระบบหนึ่ง หรือหลายระบบรวมกัน หรือกิจการกระจายเสียงตามที่มีกฎหมายบัญญัติหรือตามที่คณะกรรมการร่วมกำหนดให้เป็นกิจการกระจายเสียง\r\n",
    source:
      "พระราชบัญญัติองค์กรจัดสรรคลื่นความถี่และกำกับกิจการวิทยุกระจายเสียงวิทยุโทรทัศน์และกิจการโทรคมนาคม พ.ศ. 2543 (2553,19 ธันวาคม). ราชกิจจานุเบกษา.เล่ม 127 ตอนที่ 78 ก หน้า 2 http://www.ratchakitcha.soc.go.th/DATA/PDF/2553/A/078/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ก"
  },
  {
    keyword: "กิจการจำหน่าย (Retail)",
    meaning:
      "การค้าปลีก (Retailing) จำแนกได้ตามลักษณะของสินค้าและบริการได้ ดังนี้\r\n- ร้านค้าปลีกแบบดั้งเดิม (Traditional Trade) หรือร้านโชห่วย เป็นร้านค้าที่จำหน่ายสินค้าอุปโภคบริโภค ที่ยังคงไว้ซึ่งลักษณะการจำหน่ายสินค้าและบริการรูปแบบเดิมการจัดวางสินค้าไม่ทันสมัย ส่วนใหญ่เป็นร้านห้องแถวที่มีพื้นที่ไม่มาก การบริหารจัดการเป็นแบบครอบครัว การลงทุนน้อย ไม่มีระบบการจัดการที่ได้มาตรฐาน\r\n- ร้านค้าปลีกสมัยใหม่ (Modern Trade) เป็นร้านค้าที่มีการจัดการเป็นระบบและมีมาตรฐาน มีการใช้เทคโนโลยีที่ทันสมัย ส่วนมากเป็นการจัดตั้งเป็นบริษัทร่วมทุนทั้งในและต่างประเทศ แบ่งเป็น 8 ประเภท ดังนี้\r\n  1. ห้างสรรพสินค้า (Department Store)\r\n  2. ซูปเปอร์เซ็นเตอร์ (Supercenter) หรือ ไฮเปอร์มาร์เก็ต (Hypermarket)\r\n  3. Cash & Carry เป็นธุรกิจดิสเคาท์สโตร์ (Discount Store) จำหน่ายสินค้าคราวละมากๆในราคาขายส่ง\r\n  4. ซุปเปอร์มาร์เก็ต (Supermarket)\r\n  5. ร้านค้าเฉพาะอย่าง (Specialty Store)\r\n  6. ห้างจำหน่ายสินค้าเฉพาะกลุ่ม (Category Killer)\r\n  7. ร้านสะดวกซื้อ (Convenience Store) หรือ Minimart\r\n  8. การค้าปลีกแบบไม่มีร้านค้า (Non-store retailing) แบ่งเป็น 3 กลุ่ม ได้แก่\r\n       8.1 การค้าปลีกโดยการตลาดทางตรง (Direct marketing) เช่น การค้าทางไปรษณีย์การค้าทางโทรคมนาคม การค้าผ่านทางโทรทัศน์ การค้าอิเลคทรอนิกส์\r\n       8.2 การค้าปลีกโดยการขายตรง (Direct selling) เช่น การเดินขายของตัวแทนขายหรือการเคาะประตูหน้าบ้านเสนอสินค้า\r\n       8.3 การค้าปลีกโดยเครื่องอัตโนมัติ อาทิ การขายเครื่องดื่ม และขนมขบเคี้ยวซึ่งมีการวางเครื่องอัตโนมัติตามหน้าศูนย์การค้า โรงเรียน โรงพยาบาลสถานบันเทิงและชุมชนต่าง ๆ",
    source:
      "กรมเจรจาการค้าระหว่างประเทศ. (2555). ธุรกิจบริการ : การจัดจำหน่าย DISTRIBUTION SERVICES, 1 ตุลาคม 2562. https://www.dtn.go.th/files/94/Media/Mk/dist29-05-55.pdf\r\n",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "กิจการพลังงาน",
    meaning: "กิจการไฟฟ้า กิจการก๊าซธรรมชาติ หรือกิจการระบบโครงข่ายพลังงาน",
    source:
      "พระราชบัญญัติการประกอบกิจการพลังงาน พ.ศ. 2550. (2550, 9 ธันวาคม). ราชกิจจานุเบกษา. เล่มที่ 124 ตอนที่ 89 ก หน้าที่ 13. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ก"
  },
  {
    keyword: "กิจการอวกาศ",
    meaning:
      "การสำรวจ การทดลองหรือการดำเนินการอื่นใดในอวกาศรวมถึงการส่งหรือพยายามส่งวัตถุอวกาศขึ้นสู่อวกาศการดำเนินการเพื่อให้วัตถุอวกาศโคจรในอวกาศหรือกลับสู่พื้นโลกหรือการดำเนินกิจกรรมที่จำเป็นต่อการส่งการโคจรและการกลับคืนสู่พื้นโลกของวัตถุอวกาศ เช่น การให้บริการสถานที่ส่งหรือสถานที่ลงจอดวัตถุอวกาศและให้หมายความรวมถึงการดำเนินกิจกรรมอื่นในการใช้ประโยชน์จากอวกาศตามประกาศของคณะกรรมการ",
    source:
      "สำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ (องค์การมหาชน). ร่างพระราชบัญญัติกิจการอวกาศ พ.ศ. ...., 26 กันยายน 2562. https://www.gistda.or.th/main/system/files_force/article/2582/file/document_space-14003.pdf",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ก"
  },
  {
    keyword: "ขนบธรรมเนียม",
    meaning: "แบบอย่างที่นิยมกันมา",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ขนบธรรมเนียม. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ข"
  },
  {
    keyword: "ขนบธรรมเนียมและประเพณีอันดีงาม",
    meaning: "แบบอย่างที่นิยมกันมา",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ขนบธรรมเนียม. 27 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "ข"
  },
  {
    keyword: "ขยะมูลฝอย",
    meaning:
      "เศษกระดาษ เศษผ้า เศษอาหาร เศษสินค้า เศษวัตถุ ถุงพลาสติก ภาชนะที่ใส่อาหาร เถ้า มูลสัตว์ ซากสัตว์หรือสิ่งอื่นใดที่เก็บกวาดจากถนน ตลาด ที่เลี้ยงสัตว์หรือที่อื่น และหมายความรวมถึงมูลฝอยติดเชื้อ มูลฝอยที่เป็นพิษ หรืออันตรายจากชุมชนหรือครัวเรือน ยกเว้นวัสดุที่ไม่ใช้แล้วของโรงงานซึ่งมีลักษณะและคุณสมบัติที่กำหนดไว้ตามกฎหมายว่าด้วยโรงงาน ",
    source:
      "กรมควบคุมมลพิษ กระทรวงทรัพยากรธรรมชาติและสิ่งแวดล้อม. (ม.ป.ป). ความรู้ด้านการลด คัดแยก และนำขยะมูลฝอยกลับมาใช้ใหม่, 18 มิถุนายน 2562. http://www.pcd.go.th/info_serv/waste_3r.htm",
    sappear: 5,
    mappear: "18,19",
    rappear: "",
    firstalpha: "ข"
  },
  {
    keyword: "ขยะอินทรีย์",
    meaning:
      "ขยะที่เน่าเสียและย่อยสลายได้เร็ว สามารถนำมาหมักทำปุ๋ยได้ เช่น เศษผัก เปลือกผลไม้ เศษอาหาร ใบไม้ เศษเนื้อสัตว์ เป็นต้น",
    source:
      "กรมควบคุมมลพิษ. คู่มือประชาชน เพื่อการลด คัดแยก และใช้ประโยชน์ขยะมูลฝอยชุมชน. 18 พฤศจิกายน 2562. \r\nhttp://infofile.pcd.go.th/waste/waste_recycle.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ข"
  },
  {
    keyword: "ของเสีย",
    meaning:
      "ขยะมูลฝอย สิ่งปฏิกูล น้ำเสีย อากาศเสีย มลสาร หรือ\r\nวัตถุอันตรายอื่นใด ซึ่งถูกปล่อยทิ้งหรือมีที่มาจากแหล่งกำเนิดมลพิษ รวมทั้งกาก ตะกอน หรือสิ่ง\r\nตกค้างจากสิ่งเหล่านั้น ที่อยู่ในสภาพของแข็ง ของเหลว หรือก๊าซ",
    source:
      "พระราชบัญญัติส่งเสริมและรักษาคุณภาพสิ่งแวดล้อมแห่งชาติ พ.ศ. 2535. (2535, 4 เมษายน). ราชกิจจานุเบกษา. เล่ม 109 ตอนที่ 17 หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/037/1.PDF",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ข"
  },
  {
    keyword: "ของเสียอันตราย",
    meaning:
      "ของเสียทุกประเภททั้งของแข็ง ของเหลว และก๊าซ อาจเป็นสารชนิดเดียวหรือของผสมระหว่างสารหลายชนิด ซึ่งถูกทิ้งจากแหล่งกำเนิดสู่สิ่งแวดล้อม มีศักยภาพที่เป็นอันตรายต่อมนุษย์ พืช สัตว์ และสิ่งแวดล้อม",
    source:
      "กระทรวงอุสาหกรรม. (2535). คำนิยามที่เกี่ยวกับ “ของเสียอันตราย”, 24 กรกฎาคม 2562. http://digi.library.tu.ac.th/thesis/la/0894/15APPENDIX_A.pdf",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ข"
  },
  {
    keyword: "ของกลาง",
    meaning:
      "สินค้า วัตถุใดๆ หรือทรัพย์สินซึ่งได้ยึดมาอยู่ในความคุ้มครองของพนักงานเจ้าหน้าที่ เพื่อเป็นพยานหลักฐานในการดำเนินคดีจนกว่าคดีถึงที่สุด ",
    source:
      "กรมสรรพสามิต. (2560). ว่าด้วยการปฏิบัติเกี่ยวกับของกลางในคดีกระทำผิดกฎหมายในหน้าที่ของกรมสรรพสามิต, 26 กันยายน 2562. https://www.excise.go.th/cs/groups/public/documents/document/dwnt/mzq5/~edisp/uatucm349068.pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ข"
  },
  {
    keyword: "ของป่า",
    meaning:
      "สิ่งต่าง ๆ ที่เกิดขึ้นหรือมีอยู่ในป่าเป็นต้นว่า\r\n1. ไม้ฟืน ถ่าน เปลือกไม้ ใบไม้ ดอกไม้ เมล็ด ผลไม้ หน่อไม้ ชันไม้ และยางไม้\r\n2. หญ้า อ้อ พง แขม ปรือ คา กก กระจูด กล้วยไม้ กูด เห็ด และพืชอื่น\r\n3. ซากสัตว์ ไข่ หนัง เขา นอ งา กราม ขนาย กระดูก ขน รังนก ครั่ง รังผึ้ง น้ำผึ้ง ขี้ผึ้ง และมูลค้างคาว\r\n4. ดิน หิน กรวด ทราย แร่ และน้ำมัน\r\n",
    source:
      "พระราชบัญญัติป่าสงวนแห่งชาติ พ.ศ. 2507  (2507,28 เมษายน) ราชกิจจานุเบกษา.เล่ม 81 ตอนที่ 38 ก หน้า 13 http://www.ratchakitcha.soc.go.th/DATA/PDF/2507/A/038/263.PDF",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ข"
  },
  {
    keyword: "ข้อตกลงคุณธรรม (Integrity Pact)",
    meaning:
      "ข้อตกลงที่เป็นลายลักษณ์อักษรในการจัดซื้อจัดจ้างว่าจะไม่กระทำการใด ๆ ที่ส่อไปในทางทุจริต เช่น ไม่เรียกรับเงินสินบนหรือผลประโยชน์อื่นใด และจะปฏิบัติหน้าที่ของตนด้วยความซื่อสัตย์ สุจริต โปร่งใส และเป็นธรรม ข้อตกลงคุณธรรมจึงเป็นการลงนามด้วยกัน 3 ฝ่ายร่วมกัน คือ\r\n 1) หน่วยงานภาครัฐ \r\n 2) หน่วยงานภาคเอกชนที่สนใจเข้ามาเป็นผู้เสนอราคาหรือเสนองานกับภาครัฐ \r\n 3) ภาคประชาสังคม คือ ผู้สังเกตการณ์ (Observer) \r\n โดยยอมรับให้มีบุคคลที่สามที่มาจากภาคประชาสังคมเข้ามามีส่วนร่วมเป็นผู้สังเกตการณ์ในกระบวนการจัดซื้อจัดจ้างนั้น ๆ ตั้งแต่การจัดทำร่างขอบเขตของงาน (Terms of Reference : TOR) จนถึงสิ้นสุดสัญญา",
    source:
      "องค์กรต่อต้านคอร์รัปชัน (ประเทศไทย) Anti-Corruption Organization of Thailand. (2559). ข้อตกลงคุณธรรม(Integrity Pact), 29 มิถุนายน 2562. http://www.anticorruption.in.th/2016/th/detail/67/9/%E0%B8%82%E0%B9%89%E0%B8%AD%E0%B8%95%E0%B8%81%E0%B8%A5%E0%B8%87%E0%B8%84%E0%B8%B8%E0%B8%93%E0%B8%98%E0%B8%A3%E0%B8%A3%E0%B8%A1(Integrity%20Pact)",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "ข"
  },
  {
    keyword:
      "ข้อบัญญัติเกณฑ์มาตรฐานอาคารด้านพลังงาน (Building Energy Code: BEC)",
    meaning:
      "เกณฑ์มาตรฐานประสิทธิภาพพลังงานขั้นต่ำในอาคารที่จะขออนุญาตก่อสร้างหรือดัดแปลงซึ่งได้รับการบรรจุในกฎกระทรวง กำหนดประเภท หรือขนาดของอาคาร และมาตรฐาน หลักเกณฑ์และวิธีการในการออกแบบอาคารเพื่อการอนุรักษ์พลังงาน พ.ศ. 2552 กระทรวงพลังงาน ประกอบด้วยการออกแบบระบบกรอบอาคาร ระบบไฟฟ้าแสงสว่าง ระบบปรับอากาศ อุปกรณ์ผลิตน้ำร้อนการใช้พลังงานโดยรวมของอาคาร และการใช้พลังงานหมุนเวียนในระบบต่างๆ ของอาคาร",
    source:
      "กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน (พพ.) กระทรวงพลังงาน. แนวทางเบื้องต้นในการออกแบบอาคารอนุรักษ์พลังงานประสิทธิภาพสูงเชิงสถาปัตยกรรม, 5 กันยายน 2562. http://www.eppo.go.th/images/Infromation_service/Publication/Publication/PDF/Architectural%20Guidebook.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ข"
  },
  {
    keyword: "ข้อบัญญัติท้องถิ่น",
    meaning:
      "กฎซึ่งออกโดยอาศัยอำนาจนิติบัญญัติของราชการส่วนท้องถิ่น เช่น เทศบัญญัติ ข้อบังคับสุขาภิบาล ข้อบัญญัติจังหวัด ข้อบัญญัติกรุงเทพมหานคร หรือข้อบัญญัติเมืองพัทยา เป็นต้น",
    source:
      "พระราชบัญญัติควบคุมอาคาร พ.ศ. 2522. (2522, 14 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 96 ตอนที่ 80 หน้า 5. http://www.ratchakitcha.soc.go.th/DATA/PDF/2522/A/080/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ข"
  },
  {
    keyword: "ข้อมูล",
    meaning:
      "ข้อเท็จจริง (facts) ที่เกี่ยวกับเรื่องต่างๆ ซึ่งอาจเป็นข้อเท็จจริงที่เป็นตัวเลข เช่น จำนวนผู้ป่วยที่ติดเชื้อ HIV ในหมู่บ้าน ราคาของพืชผักและผลไม้ต่างๆ ในหมู่บ้าน เป็นต้น หรืออาจเป็นข้อเท็จจริงที่ไม่ใช่ตัวเลข เช่น การศึกษา หรือ อาชีพของคนในหมู่บ้าน เป็นต้น",
    source:
      "สำนักงานสถิติแห่งชาติ. การเก็บรวบรวมข้อมูลสถิติ, 29 สิงหาคม 2562. http://service.nso.go.th/nso/knowledge/estat/esta1_1.html",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ข"
  },
  {
    keyword: "ข้อมูลเชิงประจักษ์",
    meaning:
      "ข้อมูลที่เก็บจากแหล่งข้อมูลโดยตรง หรือจากประสบการณ์จริง ไม่ใช่ข้อมูลที่ได้มาจากความนึกคิด หรือสมมุติขึ้น",
    source:
      "ศัพทานุกรมการวิจัยทางประชากรและสังคม มหาวิทยาลัยมหิดล. ข้อมูลเชิงประจักษ์, 18 มิถุนายน 2562. http://www.popterms.mahidol.ac.th/Popterms/showmeanTH.php?id=e00231&keyword=empirical%20data",
    sappear: 6,
    mappear: 15,
    rappear: "",
    firstalpha: "ข"
  },
  {
    keyword: "ข้อมูลขนาดใหญ่ (big data)",
    meaning:
      "ปริมาณข้อมูลที่มีขนาดใหญ่มาก (ระดับ tera byte หรือ peta byte) เกินกว่าขีดความสามารถในการประมวลผลของระบบฐานข้อมูลธรรมดาจะรองรับได้ (volumn) และข้อมูลมีการเปลี่ยนแปลงอย่างรวดเร็ว (velocity) เช่น ข้อมูลจาก social media ข้อมูลการซื้อขาย ข้อมูล transaction การเงินหรือการใช้โทรศัพท์ หรือข้อมูลจาก sensor จึงทำให้ข้อมูลมีหลากหลายรูปแบบ (variety) ทั้งที่มีรูปแบบและไม่มีรูปแบบ ซึ่งอาจจะอยู่ในรูปทั้ง RDBMS, text, XML, JSON หรือ image สำหรับ big data technology คือ เทคโนโลยีในการนำข้อมูลจำนวนมหาศาลมาวิเคราะห์ ประมวลผล และแสดงผลด้วยวิธีที่เหมาะสม ส่วนการวิเคราะห์ข้อมูลขนาด ใหญ่ เพื่อให้สามารถนำข้อมูลมาใช้ได้ง่ายขึ้น เพื่อประโยชน์ในการวางแผน หรือการตัดสินใจ เรียกว่า big data analytics",
    source:
      "ประกาศนโยบายและแผนระดับชาติว่าด้วยการพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม พ.ศ. 2561-2580. (2562, 11 เมษายน). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 47 ก หน้า 53.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/047/T_0001.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ข"
  },
  {
    keyword: "ข้อมูลข่าวสาร",
    meaning:
      "สิ่งที่สื่อความหมายให้รู้เรื่องราวข้อเท็จจริง ข้อมูลหรือสิ่งใดๆไม่ว่าการสื่อความหมายนั้น จะทำได้โดย\r\nสภาพของสิ่งนั้นเองหรือโดยผ่านวิธีการใดๆและไม่ว่าจะได้จัดทำไว้ในรูปของเอกสาร แฟ้ม รายงาน หนังสือ แผนผัง แผนที่ ภาพวาด\r\nภาพถ่ายฟิล์ม การบันทึกภาพหรือเสียง การบันทึกโดยเครื่องคอมพิวเตอร์หรือวิธีอื่นใดที่ทำให้สิ่งที่บันทึกไว้ปรากฏได้",
    source:
      "พระราชบัญญัติข้อมูลข่าวสารของราชการ พ.ศ. 2540. (2540, 10 กันยายน) ราชกิจจานุเบกษา. เล่ม 114 ตอนที่ 46 ก หน้าที่ 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2540/A/046/1.PDF",
    sappear: "",
    mappear: "1,10,16,20",
    rappear: "",
    firstalpha: "ข"
  },
  {
    keyword: "ข้อมูลทะเบียนราษฎร",
    meaning:
      "ข้อมูลตัวบุคคลเกี่ยวกับชื่อ ชื่อสกุล เพศ วันเดือนปีเกิดและตาย สัญชาติ ศาสนา ภูมิลำเนา สถานะ การสมรส วุฒิการศึกษา ชื่อบิดามารดาหรือผู้รับบุตรบุญธรรม ชื่อคู่สมรส และชื่อบุตร และข้อมูลอื่นที่จำเป็นเพื่อการดำเนินงานทะเบียนต่าง ๆ ",
    source:
      "พระราชบัญญัติการทะเบียนราษฎร พ.ศ. 2534. (2534, 22 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 108 ตอนที่ 203 หน้า 98. http://www.ratchakitcha.soc.go.th/DATA/PDF/2534/A/203/97.PDF\r\n",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ข"
  },
  {
    keyword: "ข้อมูลที่ไม่มีโครงสร้าง (Unstructured data)",
    meaning:
      "ข้อมูลที่ไม่ได้มีการกำหนดรูปแบบข้อมูลไว้ล่วงหน้า หรือไม่ได้จัดให้อยู่ในลักษณะที่กำหนดไว้ล่วงหน้า ข้อมูลที่ไม่มีโครงสร้างโดยทั่วไปจะเป็นข้อมูลที่เกิดจากการพิมพ์ เช่นไฟล์เอกสาร word, pdf, html หรือ ไฟล์รูปภาพ วีดีโอเสียง เป็นต้น ",
    source:
      "ฝ่ายนวัตกรรม สำนักงานรัฐบาลอิเล็กทรอนิกส์ (องค์การมหาชน) (สรอ.). (2558). แนวปฏิบัติและมาตรฐานเชิงเทคนิคสำหรับ ศูนย์กลางข้อมูลเปิดภาครัฐ (Data.go.th), 7 ตุลาคม 2562. file:///C:/Users/admin/Downloads/file_8341def396b3fe55dbca5e8e81f53e85.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ข"
  },
  {
    keyword: "ข้อมูลทุติยภูมิ",
    meaning:
      "ข้อมูลที่ผู้ใช้ไม่ได้เก็บรวบรวมเอง แต่มีผู้อื่นหรือ หน่วยงานอื่นๆ ทำการเก็บรวบรวมไว้แล้ว เช่น จากรายงาน ที่พิมพ์แล้ว หรือยังไม่ได้พิมพ์ของ หน่วยงานของรัฐบาล สมาคม บริษัท สำนักงานวิจัย นักวิจัย วารสาร หนังสือพิมพ์ เป็นต้น การนำเอาข้อมูลเหล่านี้มาใช้เป็นการประหยัดเวลาและค่าใช้จ่าย แต่ในบางครั้งข้อมูลอาจจะไม่ตรงกับความต้องการของผู้ใช้ หรือมีรายละเอียดไม่เพียงพอที่จะนำไปวิเคราะห์ นอกจากนี้ในบางครั้ง ข้อมูลนั้นอาจมีความผิดพลาดและผู้ใช้มักจะไม่ทราบข้อผิดพลาดดังกล่าว ซึ่งอาจมีผลกระทบต่อการสรุปผล ดังนั้น ผู้ที่จะนำข้อมูลทุติยภูมิมาใช้ควรระมัดระวังและตรวจสอบคุณภาพข้อมูลก่อนที่จะนำไปวิเคราะห์",
    source:
      "สำนักงานสถิติแห่งชาติ. (2547). แหล่งที่มาของข้อมูล (Source of Data), 29 สิงหาคม 2562. http://service.\r\nnso.go.th/nso/nsopublish/know/estat1_4.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ข"
  },
  {
    keyword: "ข้อมูลส่วนบุคคล",
    meaning:
      "ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้ไม่ว่าทางตรงหรือทางอ้อม แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะ",
    source:
      "พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล\r\nพ.ศ. 2562. (2562, 27 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 69 ก หน้า 54.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/069/T_0052.PDF",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "ข"
  },
  {
    keyword: "ข้อมูลสารสนเทศ",
    meaning:
      "สาระเนื้อหาที่เกิดจากการนำข้อมูล (Data) มาคิด วิเคราะห์ คำนวณ เรียบเรียง จัดกลุ่ม จัดลำดับ แยกประเภท สรุป ทำให้มีความหมาย และเกิดประโยชน์ต่อผู้รับหรือผู้ใช้",
    source:
      "นางสาวณนัฐรักษ์ อรุณทัต สาขาวิชานโยบายและการบริหารเทคโนโลยีสารสนเทศ วิทยาลัยนวัตกรรม มหาวิทยาลัยธรรมศาสตร์. (2560). แนวทางการพัฒนาระบบสารสนเทศเพื่อการบริหารจัดการโรงเรียนกรณีศึกษา โรงเรียนเอกชนแห่งหนึ่ง, 10 กันยายน 2562. http://ethesisarchive.library.tu.ac.th/thesis/2017/TU_2017_5823036164_7238_5922.pdf",
    sappear: "",
    mappear: "",
    rappear: "2,4",
    firstalpha: "ข"
  },
  {
    keyword: "ขัดเกลา",
    meaning:
      "ทําให้เกลี้ยงเกลา ทําให้เรียบร้อย อบรมพรํ่าสอน  เช่น ขัดเกลานิสัย",
    source:
      "จินดารัตน์  โพธิ์นอก สำนักงานราชบัณฑิตยสภา. (2553). ขัดกันเหลือเกิน, 29 สิงหาคม 2562. \r\nhttp://www.royin.go.th/?knowledges=%E0%B8%82%E0%B8%B1%E0%B8%94%E0%B8%81%\r\nE0%B8%B1%E0%B8%99%E0%B9%80%E0%B8%AB%E0%B8%A5%E0%B8%B7%E0%B8%AD%\r\nE0%B9%80%E0%B8%81%E0%B8%B4%E0%B8%99-%E0%B9%91%E0%B9%94-%E0%B8%81%\r\nE0%B8%A3%E0%B8%81%E0%B8%8E%E0%B8%B2\r\n",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ข"
  },
  {
    keyword: "ขีดความสามารถ",
    meaning:
      "ความสามารถที่จะกระทำการอย่างใดอย่างหนึ่ง หรือความสามารถที่อาจจะพัฒนาต่อไปให้เป็นประโยชน์มากขึ้น",
    source:
      "กรมป้องกันและบรรเทาสาธารณภัย. หนังสือคำศัพท์ด้านการบริหารจัดการความเสี่ยงจากภัยพิบัติ, 9 กันยายน 2562. http://www.disaster.go.th/th/download-src.php?did=1225",
    sappear: "",
    mappear: "1,2,4,5,13,15",
    rappear: "2,5,7,9",
    firstalpha: "ข"
  },
  {
    keyword: "ขีดความสามารถทางการแข่งขัน",
    meaning:
      'ระดับความสามารถในการสร้างปัจจัยแวดล้อมทางเศรษฐกิจ ทั้งด้านปัจจัยการผลิต นโยบาย และกฎระเบียบ และสถาบันที่เอื้อให้ธุรกิจและอุตสาหกรรมในประเทศ สามารถเพิ่มผลผลิตได้ในโลกใหม่ ที่เศรษฐกิจมีความซับซ้อน เทคโนโลยีและพฤติกรรมผู้บริโภคเปลี่ยนแปลงอย่างรวดเร็ว "ผลิตภาพ" ไม่ใช่แค่เรื่องของประสิทธิภาพการผลิต (Efficiency) เท่านั้น แต่ยังรวมถึงการสร้างมูลค่าเพิ่ม (Value Creation) ด้วย ซึ่งขีดความสามารถทางการแข่งขันนี้ไม่ใช่เพียงการจัดอันดับเท่านั้น แต่เป็นเครื่องมือที่ใช้ทำความเข้าใจสถานะของการพัฒนาเศรษฐกิจและสังคมของประเทศ ใช้ติดตาม วางแผน ตรวจสอบ ประเมินผล และสร้างการมีส่วนร่วมในการพัฒนาเศรษฐกิจและสังคมของแต่ละประเทศ',
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. (2562), Thailand compitativeness enhancement, สิงหาคม 2562. https://www.nesdc.go.th/ewt_dl_link.php?nid=9436",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ข"
  },
  {
    keyword: "คณะกรรมการบริหารราชการแผ่นดินตามกรอบการปฏิรูปประเทศ",
    meaning:
      'แนวทางการปฏิรูปประเทศไทยและการบริหารราชการแผ่นดินซึ่งเป็นนโยบายโดยตรงจากท่านนายกรัฐมนตรี เกี่ยวกับคณะกรรมการบริหารราชการแผ่นดินตามกรอบการปฏิรูปประเทศ ยุทธศาสตร์ชาติและการสร้างความสามัคคีปรองดอง (ป.ย.ป.) เพื่อให้ประชาชนและทุกส่วนราชการเข้าใจ "การขับเคลื่อนประเทศไทยในระยะเปลี่ยนผ่าน" อีกทั้ง ทุกส่วนราชการจะต้องเร่งผลักดันภารกิจที่สำคัญและการปฏิรูปให้สำเร็จโดยเร็ว',
    source:
      "สำนักงานคณะกรรมการข้าราชการพลเรือน (สำนักงาน ก.พ.). แนวทางการปฏิรูปประเทศไทยและการบริหารราชการแผ่นดิน, 21 ตุลาคม 2562. https://www.ocsc.go.th/blog/2017/02/%E0%B9%81%E0%B8%99%E0%B8%A7%E0%B8%97%E0%B8%B2%E0%B8%87%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%9B%E0%B8%8F%E0%B8%B4%E0%B8%A3%E0%B8%B9%E0%B8%9B%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B9%80%E0%B8%97%E0%B8%A8%E0%B9%84%E0%B8%97%E0%B8%A2%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%9A%E0%B8%A3%E0%B8%B4%E0%B8%AB%E0%B8%B2%E0%B8%A3%E0%B8%A3%E0%B8%B2%E0%B8%8A%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%81%E0%B8%9C%E0%B9%88%E0%B8%99%E0%B8%94%E0%B8%B4%E0%B8%99",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ค"
  },
  {
    keyword: "คณะกรรมการพัฒนากฎหมาย",
    meaning: "คณะกรรมการพัฒนากฎหมายตามกฎหมาย ว่าด้วยคณะกรรมการกฤษฎีกา",
    source:
      "พระราชบัญญัติหลักเกณฑ์การจัดทำร่างกฎหมายและการประเมินผลสัมฤทธิ์ของกฎหมาย พ.ศ. 2562. (2562, 31 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136  ตอนที่ 72 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/072/T_0001.PDF\r\n",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ค"
  },
  {
    keyword: "คณะรัฐมนตรี",
    meaning:
      "คณะบุคคลซึ่งพระมหากษัตริย์ทรงแต่งตั้ง ประกอบด้วยนายกรัฐมนตรีคนหนึ่ง และรัฐมนตรีอื่นอีกไม่เกินจำนวนที่กำหนดไว้ในรัฐธรรมนูญ เพื่อทําหน้าที่บริหารราชการแผ่นดิน",
    source:
      "สถาบันพระปกเกล้า. คณะรัฐมนตรี, 18 พฤศจิกายน 2562. http://wiki.kpi.ac.th/index.php?title=%E0%B8%84%E0%B8%93%E0%B8%B0%E0%B8%A3%E0%B8%B1%E0%B8%90%E0%B8%A1%E0%B8%99%E0%B8%95%E0%B8%A3%E0%B8%B5#cite_note-1 ",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ค"
  },
  {
    keyword: "คดีทางการแพทย์",
    meaning: "คดีเกี่ยวกับการรักษาพยาบาลเป็นคดีที่มีลักษณะเฉพาะ",
    source:
      "กระทรวงสาธารณสุข. (2556). คู่มือกฎหมายและคดีทางการแพทย์ สําหรับแพทย์, 24 กันยายน 2562. https://www.tm.mahidol.ac.th/legal/sites/default/files/305.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ค"
  },
  {
    keyword: "คดีปกครอง",
    meaning:
      "คดีที่เป็นข้อพิพาทระหว่างหน่วยงานทางปกครอง หรือเจ้าหน้าที่ของรัฐกับเอกชน หรือข้อพิพาทระหว่างหน่วยงานทางการปกครอง หรือเจ้าหน้าที่ของรัฐด้วยกันเอง และเป็นคดีในเรื่องดังต่อไปนี้\r\n1.คดีพิพาทเกี่ยวกับการที่หน่วยงานทางการปกครอง หรือเจ้าหน้าที่ของรัฐออกกฎ คำสั่ง หรือการกระทำอื่นใดโดยไม่ชอบด้วยกฎหมาย เช่น กรณีผู้ฟ้องคดีเห็นว่าพนักงานท้องถิ่นปฏิเสธไม่ออกใบอนุญาตก่อสร้างโดยไม่ชอบด้วยกฎหมาย หรือกรณีผู้ฟ้องคดีเห็นว่าผู้บังคับบัญชามีคำสั่งลงโทษทางวินัยโดยไม่เป็นธรรม เป็นต้น\r\n2. คดีพิพาทเกี่ยวกับหน่วยงานทางปกครอง หรือเจ้าหน้าที่ของรัฐละเลยต่อหน้าที่ตามกฎหมายกำหนดให้ต้องปฏิบัติ หรือปฏิบัติหน้าที่ล่าช้าเกินสมควร เช่น กรณีที่เจ้าพนักงานท้องถิ่นละเลยต่อหน้าที่ไม่ตรวจตรา และออกคำสั่งให้เจ้าของอาคารรื้อถอนที่ก่อสร้าง หรือต่อเติมไม่ได้รับอนุญาต กรณีเจ้าพนักงานที่ดินดำเนินการออกโฉนดที่ดินล่าช้าเกินสมควร เป็นต้น\r\n3.คดีพิพาทเกี่ยวกับการกระทำละเมิด หรือความรับผิดชอบอย่างอื่นของหน่วยงานทางปกครองหรือเจ้าหน้าที่ของรัฐ อันเกิดจากการใช้อำนาจล่าช้าเกินสมควร เช่น การที่เจ้าพนักงานที่ดินออกคำสั่งเพิกถอนโฉนดที่ดินโดยไม่ชอบด้วยกฎหมาย ทำให้ผู้ฟ้องคดีได้รับเสียหาย และผู้ฟ้องคดีเรียกค่าเสียหายดังกล่าว หรือการฟ้องเรียกค่าทดแทนการเวนคืน หรือการรอนสิทธิจากการวางท่อประปา หรือเสาไฟฟ้าแรงสูงเป็นต้น\r\n4.คดีพิพาทเกี่ยวกับสัญญาทางปกครอง เช่น ข้อพิพาทเกี่ยวกับสัญญาจ้างเอกชน ก่อสร้างถนน อาคารเรียน หรือข้อพิพาทเกี่ยวกับการเรียกเก็บค่าสัมปทานตามสัญญาสัมปทานทำไม้ป่าชายเลน หรือสัญญาที่หน่วยงานทางปกครองทำกับข้าราชการที่ได้รับอนุญาตให้ลาศึกษาต่อเป็นต้น\r\n5.คดีที่มีกฎหมายกำหนดให้หน่วยงานทางปกครอง หรือเจ้าของรัฐต้องฟ้องคดีต่อศาลเพื่อบังคับให้บุคคลกระทำการหรือละเว้นการกระทำ เช่น กรณีเจ้าหน้าที่ของกรมการขนส่งทางน้ำฟ้องคดีต่อศาลปกครอง เพื่อมีคำสั่งให้เอกชนรื้อถอนสะพาน หรือบ้านที่ปลูกรุกล้ำแม่น้ำ กรณีเจ้าพนักงานท้องถิ่นฟ้องคดีต่อศาลปกครองเพื่อมีคำสั่งให้จับกุม และกักขังบุคคล ซึ่งไม่ปฏิบัติตามคำสั่งของเจ้าพนักงานท้องถิ่นตามพระราชบัญญัติควบคุมอาคาร ฯ เป็นต้น\r\n6.คดีที่กฎหมายกำหนดให้อยู่ในเขตอำนาจของศาลปกครอง เช่น กรณีที่ฟ้องขอให้เพิกถอนคำชี้ขาด หรือบังคับตามคำชี้ขาดของอนุญาโตตุลาการเกี่ยวกับสัญญาทางปกครอง เป็นต้น",
    source:
      "สถาบันพระปกเกล้า. คดีปกครอง, 17 มิถุนายน 2562.http://wiki.kpi.ac.th/index.php?title=%E0%B8%84%E0%B8%94%E0%B8%B5%E0%B8%9B%E0%B8%81%E0%B8%84%E0%B8%A3%E0%B8%AD%E0%B8%87",
    sappear: 4,
    mappear: "",
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "คดีมโนสาเร่",
    meaning:
      "คดีที่มีคำขอให้ปลดเปลื้องทุกข์อันอาจคำนวณเป็นราคาเงินได้และฟ้องคดีขับไล่บุคคลใดๆ ออกจากอสังหาริมทรัพย์อันมีค่าเช่าหรืออาจให้เช่าได้",
    source:
      "พระราชกฤษฎีกากำหนดจำนวนเงินในคดีมโนสาเร่ พ.ศ. 2546 (2546, 30 ตุลาคม). ราชกิจจานุเบกษา. เล่ม 120 ตอนที่ 107 ก หน้า 37. http://www.ratchakitcha.soc.go.th/DATA/PDF/00131730.PDF",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ค"
  },
  {
    keyword: "คดีอาญา",
    meaning:
      "คดีที่เกี่ยวกับความผิดและมีโทษซึ่งกำหนดไว้ในประมวลกฎหมายอาญาและกฎหมายอื่น ๆ ที่มีโทษทางอาญา ซึ่งโทษทางอาญามีอยู่ 5 ประการคือ ประหารชีวิต จำคุก กักขัง ปรับ และริบทรัพย์สิน \r\n โดยคดีอาญาแบ่งเป็น 2 ประเภท คือ \r\n (1) คดีอาญาที่ยอมความไม่ได้หรือคดีอาญาแผ่นดิน เช่น คดีลักทรัพย์ คดีฉ้อโกงประชาชน เป็นต้น \r\n (2) คดีอาญาที่ยอมความได้หรือคดีอาญาความผิดต่อส่วนตัว เช่น คดียักยอกทรัพย์ คดีฉ้อโกง เป็นต้น",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์. (2555). คดีอาญา, 21 มิถุนายน 2562. https://www.etda.or.th/terminology-detail/952.html",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ค"
  },
  {
    keyword: "คนพิการ",
    meaning:
      "บุคคลซึ่งมีข้อจํากัดในการปฏิบัติกิจกรรมในชีวิตประจําวันหรือเข้าไปมีส่วนร่วมทางสังคม เนื่องจากมีความบกพร่องทางการเห็น การได้ยิน การเคลื่อนไหว การ\r\nสื่อสาร จิตใจ อารมณ์พฤติกรรม สติปัญญา การเรียนรู้หรือความบกพร่องอื่นใด ประกอบกับมีอุปสรรคในด้านต่าง ๆ และมีความจําเป็นเป็นพิเศษที่จะต้องได้รับความช่วยเหลือด้านหนึ่งด้านใด\r\nเพื่อให้สามารถปฏิบัติกิจกรรมในชีวิตประจําวันหรือเข้าไปมีส่วนร่วมทางสังคมได้อย่างบุคคลทั่วไปทั้งนี้ตามประเภทและหลักเกณฑ์ที่รัฐมนตรีว่าการกระทรวงการพัฒนาสังคมและความมั่นคงของ\r\nมนุษย์ประกาศกําหนด",
    source:
      "พระราชบัญญัติส่งเสริมและพัฒนาคุณภาพชีวิตคนพิการ พ.ศ. 2550. (2550, 27 กันยายน). ราชกิจจานุเบกษา. เล่ม 124 ตอนท ี่ 61 ก หน้า 9. http://www.ratchakitcha.soc.go.th/DATA/PDF/2550/A/061/8.PDF",
    sappear: "",
    mappear: 17,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "คนสามวัย",
    meaning: "วัยเด็กถึงวัยครองคู่  วัยกลางคนคือวัยพ่อแม่ และวัยสูงอายุ",
    source:
      "กลุ่มงานข้อมูลสารสนเทศและการสื่อสาร สำนักงานจังหวัดหนองคาย. โครงการศูนย์สามวัย สานใยรักแห่งครอบครัว สร้างสุขภาพชาวหนองคายอย่างยั่งยืน, 12 กรกฎาคม 2562. http://202.28.118.8/nk2015/web/site/view?id=1742",
    sappear: 4,
    mappear: "",
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "คมนาคม",
    meaning: "การติดต่อไปมาถึงกัน, การสื่อสาร",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. คมนาคม. 17 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ครรลองของระบอบประชาธิปไตยอันมีพระมหากษัตริย์ทรงเป็นประมุข",
    meaning: "การปกครองประชาชน โดยประชาชน และเพื่อประชาชน",
    source:
      "สำนักงานเลขาธิการสภาผู้แทนราษฎร. (2560). การเข้าชื่อเสนอกฎหมายโดยประชาชนตามบทบัญญัติของรัฐธรรมนูญแห่งราชอาณาจักรไทย พุทธศักราช 2560, 21 ตุลาคม 2562. http://library2.parliament.go.th/giventake/content_royrueng/2560/rr2560-aug3.pdf",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ค"
  },
  {
    keyword: "ครอบครัว",
    meaning:
      "บุคคลตั้งแต่สองคนขึ้นไปที่ใช้ชีวิตร่วมกันฉันสามีภริยา หรือมีความผูกพันทางสายโลหิต หรือทางกฎหมาย หรือเกี่ยวดองเป็นเครือญาติ ซึ่งสมาชิกในครอบครัวต่างมีบทบาทหน้าที่ต่อกัน และมีความสัมพันธ์ที่เกื้อกูลกัน",
    source:
      "กรมกิจการสตรีและสถาบันครอบครัว กระทรวงการพัฒนาสังคมและความมั่นคงของมนุษย์. นิยามและประเภทครอบครัว. หน้า 4. 13 ธันวาคม 2562. ",
    sappear: 3,
    mappear: "10,11",
    rappear: 9,
    firstalpha: "ค"
  },
  {
    keyword: "ครัวเรือน",
    meaning:
      "หน่วยการอยู่อาศัย (unit of residence) ของบุคคลหรือกลุ่มคนที่อยู่ร่วมกันและกินอยู่ร่วมกันในสถานที่เดียวกัน โดยไม่คำนึงถึงความสัมพันธ์ทางสายโลหิตหรือทางเครือญาติ โดยบุคคลเหล่านั้นจัดหาหรือใช้สิ่งอุปโภคบริโภคอันจำเป็นแก่การครองชีพร่วมกัน",
    source:
      "กรมกิจการสตรีและสถาบันครอบครัว กระทรวงการพัฒนาสังคมและความมั่นคงของมนุษย์. นิยามและประเภทครอบครัว. หน้า 4. 13 ธันวาคม 2562. https://eoffice.ku.ac.th:8443/eoffice/kuoffice/gen02/58xW6m.pdf",
    sappear: 4,
    mappear: 3,
    rappear: 9,
    firstalpha: "ค"
  },
  {
    keyword: "ครัวเรือนเกษตร",
    meaning: "บุคคลในครัวเรือนคนใดคนหนึ่งหรือหลายคนที่ประกอบการเกษตร",
    source:
      "ศูนย์เทคโนโลยีสารสนเทศและการสื่อสาร กรมส่งเสริมการเกษตร กระทรวงเกษตรและสหกรณ์. คู่มือการขึ้นทะเบียน/ปรับปรุงทะเบียนเกษตรกร, 18 กันยายน 2562. http://farmer.doae.go.th/farmer61s.pdf\r\n",
    sappear: "",
    mappear: 3,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ครุภัณฑ์",
    meaning:
      "สินทรัพยที่หนวยงานมีไวเพื่อใชในการดําเนินงานมีลักษณะคงทนและมีอายุการใชงานเกินกว่า 1 ป โดยใหบันทึกรับรูครุภัณฑ์ที่มีมูลคาตั้งแต่5,000 บาท ขึ้นไปตามราคาทุนเปนรายการสินทรัพยถาวรในบัญชีของหนวยงาน โดยบันทึกรายละเอียดครุภัณฑ์ในทะเบียนคุมทรัพยสินและใหคํานวณคาเสื่อมราคาประจําปสําหรับครุภัณฑที่มีมูลคาไมถึง 5,000 บาท ใหบันทึกเป็นคาใชจายประเภทคาครุภัณฑมูลคาต่ำกวาเกณฑและใหบันทึกรายละเอียดของเกณฑดังกลาวในทะเบียนคุมทรัพยสิน\r\nเพื่อประโยชน์ในการควบคุมรายการทรัพย์สินของทางราชการโดยไมต้องคำนวณคาเสื่อมราคาประจําปี",
    source:
      "กรมบัญชีกลาง. การบันทึกบัญชีวัสดุหรือครุภัณฑ์, 10 กรกฎาคม 2562. \r\nhttp://kromchol.rid.go.th/internal/InternalAudit/assets/0410.3_v48.pdf",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "ค"
  },
  {
    keyword: "ครุภัณฑ์การแพทย์",
    meaning:
      "(1) เครื่องมือ เครื่องใช้ เครื่องกล วัตถุที่ใช้ใส่เข้าไปในร่างกายมนุษย์หรือสัตว์ น้ำยาที่ใช้ตรวจในห้องปฏิบัติการ ผลิตภัณฑ์ ซอฟต์แวร์ หรือวัตถุอื่นใด ที่ผู้ผลิตมุ่งหมายเฉพาะสำหรับใช้อย่างหนึ่งอย่างใดดังต่อไปนี้ ไม่ว่าจะใช้โดยลำพัง ใช้ร่วมกันหรือใช้ประกอบกับสิ่งอื่นใด\r\n(2) อุปกรณ์ หรือส่วนประกอบของเครื่องมือ เครื่องใช้ เครื่องกล ผลิตภัณฑ์ หรือวัตถุตาม(1)\r\n(3) เครื่องมือ เครื่องใช้ เครื่องกล ผลิตภัณฑ์ หรือวัถุอื่นที่รัฐมนตรีประกาศกำหนดว่าเป็นเครื่องมือแพทย์",
    source:
      "พระราชบัญญัติเครื่องมือแพทย์ พ.ศ. 2551 (2551, 5 มีนาคม). ราชกิจจานุเบกษา. เล่ม 125 ตอนที่ 43 ก หน้า 26. http://www.ratchakitcha.soc.go.th/DATA/PDF/2551/A/043/25.PDF",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "คลัสเตอร์",
    meaning:
      "การรวมกลุ่มของธุรกิจและสถาบันที่เกี่ยวข้องที่ดำเนินกิจกรรมอยู่ในพื้นที่ใกล้เคียงกัน โดยมีความร่วมมือ เกื้อหนุน เชื่อมโยงซึ่งกันและกันอย่างครบวงจร ทั้งในแนวตั้งและแนวนอน เพื่อพัฒนาความเข้มแข็งของห่วงโซ่มูลค่า (Value Chain) เสริมสร้างศักยภาพด้าน การลงทุนของประเทศไทย และช่วยกระจายความเจริญไปสู่ภูมิภาคและท้องถิ่น",
    source:
      "สำนักงานคณะกรรมการส่งเสริมการลงทุน. อนาคตไทยก้าวไกลด้วยคลัสเตอร์, 26 มิถุนายน 2562. http://chonburi.boi.go.th/public/upload/center_4/file/BOI-brochure-cluster%20area-TH-20151116.pdf",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "คลัสเตอร์ของเกษตร",
    meaning:
      "การรวมกลุ่มของธุรกิจและสถาบันที่เกี่ยวข้องที่ดำเนินกิจกรรมอยู่ในพื้นที่ใกล้เคียงกัน โดยมีความร่วมมือ เกื้อหนุน เชื่อมโยงซึ่งกันและกันอย่างครบวงจร ทั้งในแนวตั้งและแนวนอน เพื่อพัฒนาความเข้มแข็งของห่วงโซ่มูลค่า (Value Chain) เสริมสร้างศักยภาพด้าน การลงทุนของประเทศไทย และช่วยกระจายความเจริญไปสู่ภูมิภาคและท้องถิ่น",
    source:
      "สำนักงานคณะกรรมการส่งเสริมการลงทุน. อนาคตไทยก้าวไกลด้วยคลัสเตอร์, 26 มิถุนายน 2562. http://chonburi.boi.go.th/public/upload/center_4/file/BOI-brochure-cluster%20area-TH-20151116.pdf",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "คลัสเตอร์อุตสาหกรรม",
    meaning:
      "กลุ่มของธุรกิจและสถาบันที่เกี่ยวข้อง มารวมตัวดำเนินกิจการอยู่ในพื้นที่ใกล้เคียงกัน (Geographic Proximity) มีความร่วมมือเกื้อหนุน เชื่อมโยงและเสริมกิจการซึ่งกันและกันอย่างครบวงจร (Commonality and Complementary) ทั้งในแนวตั้งและแนวนอน โดยความเชื่อมโยงในแนวตั้ง (Vertical Linkage) เป็นความเชื่อมโยงของผู้ประกอบการธุรกิจอุตสาหกรรม ตั้งแต่ธุรกิจต้นน้ำจนถึงปลายน้ำ และความเชื่อมโยงในแนวนอน (Horizontal Linkage) เป็นความเชื่อมโยงกับอุตสาหกรรมสนับสนุนด้านต่างๆ รวมทั้งธุรกิจให้บริการ สมาคมการค้า สถาบันการศึกษาและฝึกอบรม สถาบันวิจัยพัฒนา ตลอดจนหน่วยงานภาครัฐต่างๆ ที่เกี่ยวข้อง เพื่อร่วมดำเนินงานให้บรรลุเป้าหมายการเพิ่มขีดความสามารถในการแข่งขันที่ยั่งยืน ด้วยการเพิ่มผลิตภาพ (Productivity) และสร้างนวัตกรรมร่วมกัน",
    source:
      "ศูนย์ข้อมูลข่าวสารของราชการ กรมส่งเสริมอุตสาหกรรม. โครงการพัฒนาการรวมกลุ่มและเชื่อมโยงอุตสาหกรรม (Clusters), 16 ธันวาคม 2562. http://info.dip.go.th/%E0%B9%82%E0%B8%84%E0%B8%A3%E0%B8%87%E0%B8%81%E0%B8%B2%E0%B8%A3/%E0%B9%82%E0%B8%84%E0%B8%A3%E0%B8%87%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%AB%E0%B8%A5%E0%B8%81%E0%B8%81%E0%B8%AA%E0%B8%AD/Cluster/tabid/137/Default.aspx",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "คลินิกหมอครอบครัว",
    meaning:
      "การจัดรูปแบบบริการสาธารณสุขในระดับปฐมภูมิเป็นกลุ่มบริการ โดยการจัดให้มีทีมสหวิชาชีพซึ่งประกอบด้วยแพทย์ ทันตแพทย์ เภสัชกร พยาบาล นักกายภาพบำบัด นักวิชาการสาธารณสุขและวิชาชีพอื่นๆรวมเป็นทีมหมอครอบครัว หรืออาจเรียกได้ว่า “Family medical care team” ร่วมกันดูแลประชาชนที่รับผิดชอบ(catchment population) โดยจัดให้มีจำนวนประชากร 10,000 คน/ทีม ทำหน้าที่ดูแลประชาชนแบบญาติมิตรใช้หลักเวชศาสตร์ครอบครัวเป็นหัวใจในการดำเนินงาน และให้ทีม 3 ทีมมารวมตัวกันเกิดเป็นกลุ่มเครือข่ายบริการปฐมภูมิให้ชื่อว่า “คลินิกหมอครอบครัว”หรือ Primary Care Cluster (PCC) เท่ากับ 1 cluster ร่วมกันดูแลประชาชนประมาณ 30,000 คน สำหรับสถานที่ตั้งของหน่วยบริการให้พิจารณาตามความจำเป็นสำหรับการเข้าถึงบริการของประชาชนที่ดูแล สามารถจัดให้มีหน่วยบริการได้ตั้งแต่ 1 แห่งจนถึง 3 แห่งได้ตามความเหมาะสมและความคุ้มค่า",
    source:
      "นพ. โสภณ เมฆธน ปลัดกระทรวงสาธารณสุข.(คณะกรรมการปฏิรูปประเทศด้านสาธารณสุข) แนวทางการดำเนินงานคลินิกหมอครอบครัวสำหรับหน่วยบริการ, 26 กันยายน 2562. http://www.ato.moph.go.th/sites/default/files/download/primary%20care%20cluster_guide%20%28pcc%29.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ค"
  },
  {
    keyword: "คลื่นความถี่",
    meaning:
      "คลื่นวิทยุหรือคลื่นแฮรตเซียนซึ่งเป็นคลื่นแม่เหล็กไฟฟ้าที่มีความถี่ต่ำกว่าสามล้านเมกะเฮิรตซ์ลงมาที่ถูกแพร่กระจายในที่ว่างโดยปราศจากสื่อนำที่ประดิษฐ์ขึ้น",
    source:
      "พระราชบัญญัติองค์กรจัดสรรคลื่นความถี่และกำกับกิจการวิทยุกระจายเสียงวิทยุโทรทัศน์และกิจการโทรคมนาคม พ.ศ. 2543 (2553,19 ธันวาคม). ราชกิจจานุเบกษา.เล่ม 127 ตอนที่ 78 ก หน้า 2\r\n",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ค"
  },
  {
    keyword: "ความเข้มข้นการใช้พลังงาน Energy Intensity (EI)",
    meaning:
      "อัตราส่วนของปริมาณพลังงานที่ใช้ต่อผลของกิจกรรม (Output) ที่ใช้พลังงานนั้นๆ",
    source:
      "กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน กระทรวงพลังงาน. รายงานสถานภาพการใช้พลังงานของโรงงานควบคุม ประจำปี พ.ศ. 2545, 7 ตุลาคม 2562. http://www.enconlab.com/fbr/factory_status/report2545/123_effic_energy.html",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ค"
  },
  {
    keyword: "ความเท่าเทียม",
    meaning:
      "มุมมองที่ถือว่าบุคคลทุกคนต้องได้รับการปฏิบัติอย่างเท่าเทียมกัน โดยมิได้พิจารณาหรือคำนึงถึงข้อแตกต่างของแต่ละบุคคลเลย",
    source:
      "ธนาชัย สุนทรอนันตชัย อาจารย์ประจำคณะนิติศาสตร์ มหาวิทยาลัยหัวเฉียวเฉลิมพระเกียรติ. ความเท่าเทียม ความเสมอภาค และความเป็นธรรมทางสังคม กับการจัดสวัสดิการสังคมของประเทศไทย, 26 สิงหาคม 2562. http://www.kmutt.ac.th/jif/public_html/Download/Format_Checker/9/5.pdf\r\n",
    sappear: 4,
    mappear: 15,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความเป็นธรรมแก่สังคม",
    meaning:
      "มนุษย์เราทุกคนเป็นมนุษย์ที่มีเหตุมีผล จึงเป็นผู้ที่มีเสรีและเสมอภาคและต้องการได้รับความเคารพ ดังนั้น การที่รัฐหรือใครจะจัดสรรผลประโยชน์และทรัพยากรให้กับสมาชิกต้องดำเนินการตามสัญญาประชาคม (Social Contact)ที่เป็นไปด้วยความเท่าเทียม เสมอภาคและเคารพในสิทธิความเป็นมนุษย์ของสมาชิก",
    source:
      "วิชยา โกมินทร์ บวร ทรัพย์สิงห์ สถาบันวิจัยสังคม จุฬาลงกรณ์มหาวิทยาลัย. (2557). การสร้างความเป็นธรรมทางสังคมเรื่องที่อยู่อาศัยในกลุ่มคนจนเมือง, 24 กันยายน 2562. http://www.cusri.chula.ac.th/backup/download/cluster8.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ค"
  },
  {
    keyword: "ความเป็นธรรมแนวตั้งและแนวนอน (ภาษี)",
    meaning:
      "หลักความเป็นธรรมในแนวนอนหรือหลักความเสมอภาคในแนวนอน (Horizontal Equity) มีหลักว่า บุคคลที่มีสถานะและความสามารถที่เหมือนกันควรที่จะเสียภาษีในจำนวนที่เท่ากัน ส่วนหลักความเป็นธรรมในแนวตั้งหรือหลักความเสมอภาคในแนวตั้ง (Vertical Equity) มีหลักว่า บุคคลที่มีสถานะที่แตกต่างกันควรที่จะเสียภาษีในจำนวนที่แตกต่างกัน",
    source:
      "นิจจารีย์ กีรติบำรุงพงศ์ รองศาสตราจารย์ ดร.จิรศักดิ์ รอดจันทร์ นักศึกษาและอาจารย์สาขานิติศาสตร์ มหาวิทยาลัยธุรกิจบัณฑิตย์. ปัญหากฎหมายเกี่ยวกับบัญชีอัตราภาษีเงินได้บุคคลธรรมดาตามประมวลรัษฎากรของประเทศไทย, 26 สิงหาคม 2562. http://www.dpu.ac.th/graduate/upload/content/files/%E0%B8%9B%E0%B8%B5%E0%B8%97%E0%B8%B5%E0%B9%88%203%20%E0%B8%89%E0%B8%9A%E0%B8%B1%E0%B8%9A%E0%B8%97%E0%B8%B5%E0%B9%88%203%20%E0%B9%80%E0%B8%A1%E0%B8%A9%E0%B8%B2%E0%B8%A2%E0%B8%99%20-%20%E0%B8%81%E0%B8%A3%E0%B8%81%E0%B8%8E%E0%B8%B2%E0%B8%84%E0%B8%A1%202558/46-Jour_V3_No_3_%E0%B8%9B%E0%B8%B1%E0%B8%8D%E0%B8%AB%E0%B8%B2%E0%B8%81%E0%B8%8E%E0%B8%AB%E0%B8%A1%E0%B8%B2%E0%B8%A2%E0%B9%80%E0%B8%81%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%A7%E0%B8%81%E0%B8%B1%E0%B8%9A%E0%B8%9A%E0%B8%B1%E0%B8%8D%E0%B8%8A%E0%B8%B5%E0%B8%AD%E0%B8%B1%E0%B8%95%E0%B8%A3%E0%B8%B2%E0%B8%A0%E0%B8%B2%E0%B8%A9%E0%B8%B5%E0%B9%80%E0%B8%87%E0%B8%B4%E0%B8%99%E0%B9%84%E0%B8%94%E0%B9%89%E0%B8%9A%E0%B8%B8%E0%B8%84%E0%B8%84%E0%B8%A5%E0%B8%98%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B8%94%E0%B8%B2.pdf",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความเป็นพลเมือง",
    meaning:
      "คนที่มีสิทธิและหน้าที่ในฐานะประชาชนของประเทศใดประเทศหนึ่ง  หรือประชาชนที่อยู่ภายใต้ผู้ปกครองเดียวกัน มักมีวัฒนธรรมเดียวกัน",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2556). พลเมือง, 1 ตุลาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%9E%E0%B8%A5%E0%B9%80%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%87-%E0%B9%93%E0%B9%91-%E0%B8%98%E0%B8%B1%E0%B8%99%E0%B8%A7%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%96",
    sappear: "",
    mappear: 1,
    rappear: 1,
    firstalpha: "ค"
  },
  {
    keyword: "ความเย็นเหลือทิ้ง",
    meaning: "กระบวนการเปลี่ยนสถานะของแอลเอ็นจี (LNG) จากของเหลวไปเป็นก๊าซ",
    source:
      "องค์การบริหารจัดการก๊าซเรือนกระจก. การนำพลังงานความเย็นเหลือทิ้งจากกระบวนการเปลี่ยนสถานะของแอลเอ็นจี (LNG) จากของเหลวไปเป็นก๊าซเพื่อทดแทนเครื่องทำน้ำเย็น, 19 ธันวาคม 2562. http://ghgreduction.tgo.or.th/tver-method/tver-methodology-for-voluntary-greenhouse-gas-reduction/ee/item/1226-lng.html",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ค"
  },
  {
    keyword: "ความเสมอภาค",
    meaning:
      "การปฏิบัติราชการต้องให้บริการอย่างเท่าเทียมกัน ไม่มีการแบ่งแยกด้านชายหญิง ถิ่นกำเนิด เชื้อชาติ ภาษา เพศ อายุ สภาพทางกายหรือสุขภาพ สถานะของบุคคลฐานะทางเศรษฐกิจและสังคม ความเชื่อทางศาสนา การศึกษาอบรม และอื่น ๆ อีกทั้งยังต้องคำนึงถึงโอกาสความ\r\nเท่าเทียมกันของการเข้าถึงบริการสาธารณะของ กลุ่มบุคคลผู้ด้อยโอกาสในสังคมด้วย",
    source:
      "สำนักงานคณะกรรมการข้าราชการพลเรือน.หลักธรรมาภิบาลของการบริหารกิจการบ้านเมืองที่ดี หน้า 4. 25 กรกฎาคม 2562.\r\nhttps://www.ocsc.go.th/sites/default/files/attachment/article/7.1_hlakthrrmaaphibaalkhngkaarbrihaarkicchkaarbaanemuuengthiidii.pdf",
    sappear: 4,
    mappear: "1,7,15,16,17",
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความเสมอภาคแนวตั้งและแนวนอน (ภาษี)  ",
    meaning:
      "หลักความเป็นธรรมในการจัดเก็บภาษี โดยให้บุคคลที่มีสถานะและความสามารถที่เหมือนกันควรที่จะเสียภาษีในจำนวนที่เท่ากัน และ บุคคลที่มีสถานะและความสามารถที่แตกต่างกันควรที่จะเสียภาษีในจำนวนที่แตกต่างกัน",
    source:
      "นิจจารีย์ กีรติบำรุงพงศ์ รองศาสตราจารย์ ดร.จิรศักดิ์ รอดจันทร์ นักศึกษาและอาจารย์สาขานิติศาสตร์ มหาวิทยาลัยธุรกิจบัณฑิตย์. ปัญหากฎหมายเกี่ยวกับบัญชีอัตราภาษีเงินได้บุคคลธรรมดาตามประมวลรัษฎากรของประเทศไทย, 26 สิงหาคม 2562. http://www.dpu.ac.th/graduate/upload/content/files/%E0%B8%9B%E0%B8%B5%E0%B8%97%E0%B8%B5%E0%B9%88%203%20%E0%B8%89%E0%B8%9A%E0%B8%B1%E0%B8%9A%E0%B8%97%E0%B8%B5%E0%B9%88%203%20%E0%B9%80%E0%B8%A1%E0%B8%A9%E0%B8%B2%E0%B8%A2%E0%B8%99%20-%20%E0%B8%81%E0%B8%A3%E0%B8%81%E0%B8%8E%E0%B8%B2%E0%B8%84%E0%B8%A1%202558/46-Jour_V3_No_3_%E0%B8%9B%E0%B8%B1%E0%B8%8D%E0%B8%AB%E0%B8%B2%E0%B8%81%E0%B8%8E%E0%B8%AB%E0%B8%A1%E0%B8%B2%E0%B8%A2%E0%B9%80%E0%B8%81%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%A7%E0%B8%81%E0%B8%B1%E0%B8%9A%E0%B8%9A%E0%B8%B1%E0%B8%8D%E0%B8%8A%E0%B8%B5%E0%B8%AD%E0%B8%B1%E0%B8%95%E0%B8%A3%E0%B8%B2%E0%B8%A0%E0%B8%B2%E0%B8%A9%E0%B8%B5%E0%B9%80%E0%B8%87%E0%B8%B4%E0%B8%99%E0%B9%84%E0%B8%94%E0%B9%89%E0%B8%9A%E0%B8%B8%E0%B8%84%E0%B8%84%E0%B8%A5%E0%B8%98%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B8%94%E0%B8%B2.pdf",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความเสมอภาคทางการศึกษา",
    meaning:
      "การที่ประชาชนมีสิทธิที่จะได้รับและเข้าถึงการศึกษาและพัฒนาอย่างเสมอภาคและทั่วถึง โดยให้ความช่วยเหลือผู้ขาดแคลนทุนทรัพย์ ลดความเหลื่อมล้ำในการศึกษา รวมทั้งเสริมสร้างและพัฒนาคุณภาพและประสิทธิภาพครู",
    source:
      "พระราชบัญญัติ กองทุนเพื่อความเสมอภาคทางการศึกษา\r\nพ.ศ. 2561. (2561, 13 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 33 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 12,
    firstalpha: "ค"
  },
  {
    keyword: "ความเสมอภาคทางสังคม",
    meaning:
      "ความเท่าเทียมกันทางสังคมของสมาชิกทุกคนในสังคม การไม่เลือกปฏิบัติเพราะความแตกต่างทางอัตลักษณ์ของบุคคล หรือ กล่าวได้ว่า ถิ่นกำเนิด ชาติพันธุ์ ภาษา ผิวสี เพศ ศาสนา รายได้หรือทรัพย์สิน \r\nชนชั้น วรรณะ ความสมบูรณ์ของร่างกาย สุขภาพ",
    source:
      "กรมประชาสัมพันธ์. (2560). ความเสมอภาค...ตามหลักประชาธิปไตย, 26 สิงหาคม 2562. https://www.prd.go.th/ewt_news.php?nid=159513&filename=index",
    sappear: "",
    mappear: 23,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความเหลื่อมล้ำ",
    meaning:
      "ความไม่เท่าเทียมกัน, ซึ่งเนื่องจากความไม่เท่าเทียมกันปรากฏในทุก ๆ เรื่อง, ในทุก ๆ พื้นที่, ในทุก ๆ ภาคส่วน และในทุก ๆ กาลเวลา ดังนั้นจึงเป็นปรากฏการณ์ที่ไม่อาจจะขจัดให้หมดสิ้นไปได้ “ความเหลื่อมล้ำ” ในภาพรวม ๆ มีทั้ง “ความเหลื่อมล้ำทางการเมือง” (political inequality) “ความเหลื่อมล้ำทางเศรษฐกิจ” (economic inequality) และ “ความเหลื่อมล้ำทางสังคม” (social inequality)",
    source:
      'ดร.วิชิตวงศ์ ณ ป้อมเพรช. (2561). ทำความเข้าใจ"ความเหลื่อมล้ำ", 12 กรกฎาคม 2562. https://www.prachachat.net/columns/news-168380',
    sappear: 4,
    mappear: "15,16,17",
    rappear: "1,",
    firstalpha: "ค"
  },
  {
    keyword: "ความเหลื่อมล้ำในการศึกษา",
    meaning:
      "ความไม่เท่าเทียมกันทางการศึกษาอันเนื่องมาจากคุณภาพหรือมาตรฐานของสถานศึกษา คุณภาพหรือประสิทธิภาพของครู หรือฐานะทางเศรษฐกิจหรือสังคม",
    source:
      "พระราชบัญญัติ กองทุนเพื่อความเสมอภาคทางการศึกษา\r\nพ.ศ. 2561. (2561, 13 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 33 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 12,
    firstalpha: "ค"
  },
  {
    keyword: "ความคุ้มครองทางสังคม",
    meaning:
      "การจัดระบบหรือมาตรการในรูปแบบ ต่างๆ เพื่อคุ้มครองสิทธิขั้นพื้นฐานของประชาชนทุกคนตามที่รัฐธรรมนูญแห่งราชอาณาจักรไทยบัญญัติไว้ ไม่ว่าจะเป็นบริการสังคม การประกันสังคม การช่วยเหลือทางสังคม การคุ้มครองอย่างเป็นทางการและไม่เป็ นทางการ ซึ่งครอบคลุมถึงการจัดโครงข่ายการคุ้มครองทางสังคม (Social Safety Nets) สําหรับผู้ด้อยโอกาสและคนยากจน และการจัดการกับความเสี่ยงทางสังคม (Social Risk Management) ที่เกิดขึ้นจากวิกฤตทางเศรษฐกิจ สังคม และภัยพิบัติต่างๆ",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. (2545). รายงานการพัฒนาเศรษฐกิจและสังคมของประเทศ:ความอยู่ดีมีสุขของคนไทย, 18 กรกฎาคม 2562. http://www.nesdb.go.th/images/content/book33-45.pdf",
    sappear: 4,
    mappear: 17,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความฉลาดทางอารมณ์",
    meaning:
      "ความสามารถที่จะเข้าใจ และควบคุมอารมณ์ของตนเองได้อย่างเหมาะสมตามวัย สามารถปรับตัวและอยู่ร่วมกับผู้อื่นในสังคมได้อย่างมีความสุข ความฉลาดทางอารมณ์จะทำให้เด็กเติบโตเป็นผู้ใหญ่ที่มีความคิด อารมณ์ และพฤติกรรมที่เหมาะสม",
    source:
      "สถาบันราชานุกูล. พัฒนาการ IQ&EQ, 19 มิถุนายน 2562. http://rajanukul.go.th/iqeq/index.php?mode=iqeq&group_id=0&id=144",
    sappear: "",
    mappear: 11,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความชอบธรรม",
    meaning: " ถูกตามหลักธรรม, ถูกตามนิตินัย.",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ชอบธรรม. \r\n22 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ค"
  },
  {
    keyword: "ความต้องการใช้ไฟฟ้า",
    meaning:
      "ความต้องการไฟฟ้าในการเติบโตทางเศรษฐกิจ การพัฒนาสาธารณูปโภคพื้นฐาน และการพัฒนาด้านคุณภาพชีวิตของสังคมโดยรวม ",
    source:
      "พงษ์ดิษฐ พจนา การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย. (2561). วิกฤติพลังงานไฟฟ้า...ทางออกสุดท้ายที่เหลืออยู่, 9 ตุลาคม 2562. https://www.egat.co.th/index.php?option=com_content&view=article&id=363&I%09temid=217",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ค"
  },
  {
    keyword: "ความต้องการไฟฟ้าสูงสุด (Peak Load)",
    meaning:
      "ช่วงเวลาที่มีปริมาณการใช้ไฟฟ้าสูงสุดของแต่ละวัน เช่น ปริมาณความต้องการใช้ไฟฟ้าของประเทศไทย สูงสุดอยู่ในช่วง 9 โมงเช้า ถึง 4 ทุ่ม ต่ำสุดอยู่ในช่วง 4 ทุ่ม ถึง 9 โมงเช้า",
    source:
      "กรมเชื้อเพลิงธรรมชาติ กระทรวงพลังงาน. นิยามศัพท์, 3 ตุลาคม 2562. https://dmf.go.th/public/list/data/index/menu/670/page/11",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ค"
  },
  {
    keyword: "ความพึ่งได้ของโรงไฟฟ้า (Dependable Capacity Factor)",
    meaning: "อัตรากําลังผลิตไฟฟ้าที่พึ่งพาได้",
    source:
      "รศ.ดร.จํานง สรพิพัฒน์ และคณะบัณฑิตวิทยาลัยร่วมด้านพลังงานและสิ่งแวดล้อมมหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี. (2556). การประเมินความมั่นคงทางด้านพลังงานในภาคผลิตไฟฟ้าของประเทศไทย, 7 ตุลาคม 2562. https://waa.inter.nstda.or.th/stks/pub/2019/20190614-energy-security.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ค"
  },
  {
    keyword: "ความมั่นคง",
    meaning:
      "เป็นกรอบแนวคิดใหม่ซึ่งได้ขยายขอบเขตความมั่นคงของชาติ ให้เป็นเรื่องที่เกี่ยวข้องกับทุกองคาพยพในสังคมอย่างไม่อาจหลีกเลี่ยงได้ ทุกภาคส่วนจึงจำต้องมีการเสริมสร้างศักยภาพ ความตระหนักรู้ ความเข้าใจ ตลอดจนยกระดับจิตสำนึกและการมีส่วนร่วมในการดำเนินการต่างๆ ที่เกี่ยวข้องกับความมั่นคงส่วนรวมอย่างจริงจัง เพื่อให้เกิดความพร้อมมีขีดความสามารถในการบริหารจัดการได้อย่างทันท่วงที ตลอดจนมุ่งมั่นในการพิทักษ์รักษาไว้ซึ่งความมั่นคงแห่งชาติให้ยั่งยืนสืบไป",
    source:
      "คณะกรรมการจัดทำยุทธศาสตร์ชาติด้านความมั่นคง. (2561). ยุทธศาสตร์ชาติด้านความมั่นคง, 28 ตุลาคม 2562. http://bps.moph.go.th/new_bps/sites/default/files/3.National%20Security%20Strategy.pdf",
    sappear: 1,
    mappear: "",
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความมั่นคงแบบองค์รวม",
    meaning:
      "เป็นกรอบแนวคิดใหม่ซึ่งได้ขยายขอบเขตความมั่นคงของชาติ ให้เป็นเรื่องที่เกี่ยวข้องกับทุกองคาพยพในสังคมอย่างไม่อาจหลีกเลี่ยงได้ ทุกภาคส่วนจึงจำต้องมีการเสริมสร้างศักยภาพ ความตระหนักรู้ ความเข้าใจ ตลอดจนยกระดับจิตสำนึกและการมีส่วนร่วมในการดำเนินการต่างๆ ที่เกี่ยวข้องกับความมั่นคงส่วนรวมอย่างจริงจัง เพื่อให้เกิดความพร้อมมีขีดความสามารถในการบริหารจัดการได้อย่างทันท่วงที ตลอดจนมุ่งมั่นในการพิทักษ์รักษาไว้ซึ่งความมั่นคงแห่งชาติให้ยั่งยืนสืบไป",
    source:
      "คณะกรรมการจัดทำยุทธศาสตร์ชาติด้านความมั่นคง. (2561). ยุทธศาสตร์ชาติด้านความมั่นคง, 28 ตุลาคม 2562. http://bps.moph.go.th/new_bps/sites/default/files/3.National%20Security%20Strategy.pdf",
    sappear: 1,
    mappear: 1,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความมั่นคงของมนุษย์",
    meaning:
      "การที่ประชาชนได้รับหลักประกันด้านสิทธิความปลอดภัย การสนองตอบต่อความจำเป็นขั้นพื้นฐาน โดยจะต้องปลอดจากความกลัว ปลอดจากความขาดแคลนหรือต้องการ และสามารถดำรงชีวิตอยู่ในสังคมได้อย่างมีศักดิ์ศรี",
    source:
      "กรมองค์การระหว่างประเทศ กระทรวงต่างประเทศ. (2560). ความมั่นคงของมนุษย์, 27 มิถุนายน 2562. \r\nhttp://www.mfa.go.th/thai_inter_org/th/other/77151-ความมั่นคงของมนุษย์.html",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความมั่นคงด้านน้ำ",
    meaning:
      "ความพอเพียงของทรัพยากรน้ำทั้งในด้านปริมาณและคุณภาพเพื่อสุขอนามัย การดำรงชีวิต รักษาระบบนิเวศน์ และใช้เป็นปัจจัยในการผลิต รวมทั้งเพียงพอที่จะใช้สำหรับบรรเทาความเสี่ยงอันเกิดจากน้ำที่กระทบต่อประชาชน สิ่งแวดล้อม และเศรษฐกิจ",
    source:
      "รศ.ดร.สุจริต คูณธนกุลวงศ์ และคณะ. แนวคิดความมั่นคงด้านทรัพยากรน้ำ หน้า 2-3, 10 กรกฎาคม 2562. http://project-wre.eng.chula.ac.th/watercu_eng/sites/default/files/%E0%B8%A3%E0%B8%B2%E0%B8%A2%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B9%81%E0%B8%99%E0%B8%A7%E0%B8%84%E0%B8%B4%E0%B8%94%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%A1%E0%B8%B1%E0%B9%88%E0%B8%99%E0%B8%84%E0%B8%87%E0%B8%94%E0%B9%89%E0%B8%B2%E0%B8%99%E0%B8%99%E0%B9%89%E0%B8%B3.pdf",
    sappear: 5,
    mappear: 19,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความมั่นคงทางไซเบอร์",
    meaning:
      "มาตรการและการดำเนินการที่กำหนดขึ้นเพื่อรักษาความมั่นคงปลอดภัยไซเบอร์ของประเทศให้สามารถปกป้อง ป้องกัน หรือรับมือกับ สถานการณ์ด้านภัยคุกคามทางไซเบอร์ที่ส่งผลกระทบหรืออาจก่อให้เกิดความเสี่ยงต่อการให้บริการ หรือการประยุกต์ใช้เครือข่ายคอมพิวเตอร์ อินเทอร์เน็ต โครงข่ายโทรคมนำคม หรือการให้บริการ โดยปกติของดาวเทียม อันกระทบต่อความมั่นคงของชาติซึ่งรวมถึงความมั่นคงทางการทหาร ความสงบเรียบร้อยภายในประเทศ และความมั่นคงทางเศรษฐกิจ",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์. ร่างพระราชบัญญัติว่าด้วยการรักษาความมั่นคงปลอดภัยไซเบอร์, 21 มิถุนายน 2562. https://ictlawcenter.etda.or.th/de_laws/download_file/1_Cabinet_Draft-de_laws_cyber-security-protection-act.pdf",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความมั่นคงทางพลังงาน",
    meaning:
      "การมีพลังงานพร้อมใช้อย่างเพียงพอทั้งในปัจจุบันและอนาคต โดยจะต้องมีการจัดหาพลังงานให้มีปริมาณที่เพียงพอและต้องคำนึงถึงพลังงานหลักที่มีอยู่ พร้อมทั้งหาแหล่งพลังงานทดแทนหรือพลังงานทางเลือกที่มีปริมาณเพียงพอต่อการใช้พลังงานให้สามารถตอบสนองความต้องการขั้นพื้นฐานของประชาชน ซึ่งแนวทางที่จะนำไปสู่ “ความมั่นคงทางพลังงาน” มีหลายองค์ประกอบทั้งด้านการผลิต การบริโภค การมีประสิทธิภาพในการใช้ รวมถึงผลกระทบต่อสิ่งแวดล้อม ซึ่งล้วนแต่มีความเกี่ยวข้องและเป็นปัจจัยสำคัญที่ส่งผลต่อความมั่นคงทางพลังงานของประเทศ ทั้งนี้การที่จะบรรลุเป้าหมายแห่งความมั่นคงทางพลังงานอย่างยั่งยืนได้นั้น จำเป็นต้องมีความร่วมมือกันทั้งจากภาครัฐและเอกชนในประเทศ รวมไปถึงความร่วมมือระหว่างประเทศในระดับภูมิภาค",
    source:
      'กลุ่มสารสนเทศด้านสังคม. (2559). จาก "ความมั่นคงทางพลังงาน" สู่ผลกระทบทางสิ่งแวดล้อม, 12 กรกฎาคม 2562. http://service.nic.go.th/strategy.php?file=strategy/policy-4',
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ค"
  },
  {
    keyword: "ความมั่นคงทางอาหาร",
    meaning:
      "สถานการณ์ที่เกิดขึ้นเมื่อประชาชนสามารถเข้าถึงอาหารที่ปลอดภัยและมีคุณค่า\r\nทางโภชนาการในปริมาณที่เพียงพอสำหรับการเจริญเติบโตตามปกติ การพัฒนา\r\nและการใช้ชีวิตอย่างกระตือรือร้นและมีสุขภาพดี ความไม่มั่นคงทางอาหารอาจมี\r\nสาเหตุมาจากการหาอาหารไม่ได้ กำลังซื้อที่ไม่เพียงพอ การแบ่งสันปันส่วนที่ไม่\r\nเหมาะสม หรือการใช้อาหารไม่เพียงพอในระดับครัวเรือน",
    source:
      "กรมป้องกันและบรรเทาสาธารณภัย. หนังสือคำศัพท์ด้านการบริหารจัดการความเสี่ยงจากภัยพิบัติ, 9 กันยายน 2562. http://www.disaster.go.th/th/download-src.php?did=1225",
    sappear: "",
    mappear: 3,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความมั่นคงปลอดภัยไซเบอร์",
    meaning:
      "(cyber security) ความมั่นคงปลอดภัยที่เกี่ยวข้องกับการทำธุรกรรมทางอิเล็กทรอนิกส์ รวมถึงการรักษาความมั่นคงปลอดภัยทางโลกดิจิทัล ซึ่งมีความเกี่ยวข้องกับเทคโนโลยีสารสนเทศ เพื่อการสื่อสาร การรักษาความลับของข้อมูล ที่ต้องคำนึงถึงการป้องกันภัย และควบคุมการทำรายการผ่านระบบออนไลน์ การป้องกัน การละเมิดข้อมูล มาตรฐานที่เกี่ยวข้องและวิธีการจัดการความปลอดภัย ความเชื่อมั่นของผู้ใช้",
    source:
      "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม. (2562). นโยบายและแผนระดับชาติว่าด้วยการพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม, 23 กรกฎาคม 2562. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/047/T_0001.PDF",
    sappear: 2,
    mappear: "",
    rappear: 8,
    firstalpha: "ค"
  },
  {
    keyword: "ความมั่นคงปลอดภัยทางไซเบอร์",
    meaning:
      "ภาพรวมของการบริหารความเสี่ยง การปฏิบัติ การอบรม วิธีปฏิบัติที่เป็นเลิศ การรับประกัน และเทคโนโลยีที่สามารถปกป้องสภาพแวดล้อมทางไซเบอร์ องค์กร และสินทรัพย์ของผู้ใช้งาน ได้แก่ อุปกรณ์สำหรับเชื่อมต่อคอมพิวเตอร์ ข้อมูลส่วนตัว โครงสร้างพื้นฐาน แอปพลิเคชัน บริการ ระบบสารสนเทศ และภาพรวมของการส่งผ่าน หรือ เก็บข้อมูลในไซเบอร์",
    source:
      "สำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน). รายงานสถานภาพการพัฒนารัฐบาลอิเล็กทรอนิกส์ของประเทศไทย ประจำปี 2559, 4 ตุลาคม 2562. https://www.dga.or.th/upload/download/file_123998dfa37c174adfa2d529837a4f8c.pdf",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความยากจน",
    meaning:
      "สภาพที่ประชาชนมีความเป็นอยู่ที่ต่ำกว่ามาตรฐาน กล่าวคือ ไม่มีรายได้เพียงพอที่จะใช้จ่ายในการซื้อสิ่งจำเป็นขั้นพื้นฐานในการครองชีพ เช่น อาหาร เครื่องนุ่งห่ม ที่อยู่อาศัย ความยากจนอาจวัดได้ใน ๒ ลักษณะ คือ ความยากจนสัมบูรณ์ (absolute poverty) กับความยากจนสัมพัทธ์ (relative poverty) ความยากจนสัมบูรณ์ คือสภาพที่ประชาชนไม่มีรายได้เพียงพอที่จะมีชีวิตอยู่ได้ ซึ่งอาจแก้ไขได้ด้วยการพัฒนาเศรษฐกิจ หรือมีเทคโนโลยีที่ดีขึ้น ก็จะช่วยขจัดความยากจนนั้นได้ ส่วนความยากจนสัมพัทธ์เป็นการเปรียบเทียบระหว่างกลุ่มของประชาชนที่มีรายได้แตกต่างกัน ดังนั้น ความยากจนสัมพัทธ์จึงจะมีอยู่ตลอดเวลา แม้ว่ากลุ่มประชาชนที่ยากจนที่สุดมีรายได้เพียงพอที่จะใช้จ่ายในการครองชีพได้ก็ตาม",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2552). ความยากจน, 27 มิถุนายน 2562. http://www.royin.go.th/?knowledges=%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%A2%E0%B8%B2%E0%B8%81%E0%B8%88%E0%B8%99-%E0%B9%98-%E0%B9%80%E0%B8%A1%E0%B8%A9%E0%B8%B2%E0%B8%A2%E0%B8%99-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%92",
    sappear: 4,
    mappear: "16,17",
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความยากจนหลายมิติ ",
    meaning:
      "ประกอบด้วย 5 มิติ ได้แก่ (1) ด้านสุขภาพ (2) ด้านความเป็นอยู่ (3) ด้านการศึกษา (4) ด้านรายได้ และ (5) ด้านการเข้าถึงบริการภาครัฐ ซึ่งเป็นการนำข้อมูลจากระบบข้อมูลขนาดใหญ่สำหรับการพัฒนาคนตลอดช่วงชีวิต (Thai People Map and Analytics Platform: TPMAP) มาใช้ในการชี้เป้าระดับบุคคลและครัวเรือน เพื่อแก้ไขปัญหาความยากจนหลายมิติระดับบุคคลและครัวเรือนในระดับพื้นที่ที่เหมาะสมและครอบคลุมกลุ่มเป้าหมายได้อย่างมีประสิทธิภาพยิ่งขึ้น",
    source:
      "ระบบ TPMAP Thai People Map and Analytics Platform. ความยากจนหลายมิติ, 20 พฤศจิกายน 2562. https://www.tpmap.in.th/",
    sappear: "",
    mappear: 15,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความร้อนใต้พิภพ",
    meaning:
      "พลังงานธรรมชาติที่เกิดจากความร้อนที่ถูกกักเก็บอยู่ภายใต้ผิวโลก\r\nโดยปกติแล้วอุณหภูมิภายใต้ผิวโลกจะเพิ่มขึ้น ตามความลึก กล่าวคือยิ่งลึกลงไป อุณหภูมิจะยิ่งสูงขึ้น และในบริเวณส่วนล่างของ ชั้นเปลือกโลก (Continental Crust) หรือที่ความลึกประมาณ 25 – 30 กิโลเมตร อุณหภูมิจะมีค่าอยู่ในเฉลี่ย ประมาณ 250 ถึง 1,000 องศาเซลเซียส ในขณะที่ตรงจุดศูนย์กลางของโลก อุณหภูมิอาจจะสูงถึง 3,500 ถึง 4,500 องศาเซลเซียส ความร้อนจะไหลออกมาจากภายในโลก เปลือกโลกจะทำหน้าที่เป็นฉนวนกันความร้อน โดย Inner core เป็นของแข็ง ส่วนของ Outer core เป็นของเหลว ส่วนของ Mantle มีสภาพกึ่งเหลวกึ่งแข็ง และ Crust เป็นของแข็ง",
    source:
      "สถาบันวิศวกรรมพลังงาน มหาวิทยาลัยเกษตรศาสตร์. (2558). พลังงานความร้อนใต้พิภพ (GEOTHERMAL ENERGY), 3 กันยายน 2562. http://www.eei-ku.com/wordpress/?p=10581",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ค"
  },
  {
    keyword: "ความรอบรู้ด้านสุขภาพ",
    meaning:
      "ความสามารถและทักษะในการเข้าถึงข้อมูลด้านสุขภาพ ความรู้ ความเข้าใจเพื่อวิเคราะห์ ประเมินและจัดการตนเอง รวมทั้งสามารถชี้แนะเรื่องสุขภาพแก่บุคคล ครอบครัว และชุมชนได้ การพัฒนา Health Literacy จึงเป็นการสร้างและพัฒนาขีดความสามารถในระดับบุคคลและเป็นการธำรงรักษาสุขภาพตนเองอย่างยั่งยืน",
    source:
      "กองสุขศึกษา กรมสนับสนุนบริการสุขภาพ กระทรวงสาธารณสุข. (2561). การเสริมสร้างและประเมินความรอบรู้ด้านสุขภาพและพฤติกรรมสุขภาพ. กรุงเทพมหานคร: กระทรวงสาธารณสุขhttp://www.hed.go.th/linkhed/file/575",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ค"
  },
  {
    keyword: "ความลักลั่น",
    meaning:
      "ขาดความเป็นระเบียบทำให้เกิดเหลื่อมล้ำไม่เป็นไปตามกฎตามแบบตามลำดับ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วิจารณญาณ. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ค"
  },
  {
    keyword: "ความสมานฉันท์",
    meaning: "ความพอใจร่วมกัน, ความเห็นพ้องกัน",
    source:
      "กรมประชสัมพันธ์. (2559). ปรองดองสมานฉันท์สร้างสรรค์สังคมสงบสุข, 24 รกฎาคม 2562. https://www.prd.go.th/ewt_news.php?nid=152361&filename=index",
    sappear: 4,
    mappear: "",
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความสามารถในการแข่งขันของประเทศไทยในระดับสากลดีขึ้น (GTCI)",
    meaning:
      "ผลการจัดอันดับศักยภาพการแข่งขันด้านทรัพยากรมนุษย์ของโลก (Global Talent Competitiveness Index: GTCI) ที่ประเมินจากหลายมิติทั้งด้านการผลิต การดึงดูดและการรักษาคนเก่งไว้ในประเทศ เพื่อเป็นข้อมูลเชิงนโยบายในการพัฒนากลยุทธ์การส่งเสริมความสามารถของประเทศให้แข่งขันกับประเทศอื่นได้ GTCI สร้างจากข้อมูลสถิติสำคัญ 65 ตัวที่ได้จากรายงานของ OECD UNESCO และ World Bank และอีกส่วนหนึ่งมาจากการสำรวจความคิดเห็นของผู้ประกอบการธุรกิจต่างประเทศ มี 6 กรอบการประเมิน คือ \r\n1. ปัจจัยส่งเสริมภายในประเทศ (Enable) พิจารณาจากสภาพแวดล้อมทางกฎระเบียบ ด้านการตลาด ธุรกิจและแรงงาน\r\n2. การดึงดูดแรงงาน (Attract)\r\n3. การพัฒนาแรงงาน (Grow) พิจารณาเรื่องการศึกษาในระบบ การเรียนรู้ตลอดชีวิต และการเข้าถึงโอกาสที่จะเติบโต\r\n4. การรักษาแรงงาน (Retain)\r\n5. ทักษะสายวิชาชีพ (Vocational Skills)\r\n6. ความรู้ความสามารถของแรงงาน (Global Knowledge Skills)",
    source:
      "ดร.เสาวณี จันทะพงษ์ผู้เชี่ยวชาญอาวุโส ด้านแบบจำลองเศรษฐกิจมหภาค ฝ่ายเศรษฐกิจมหภาค สายนโยบายการเงิน และ นางสาวธันว์ธิดา วงศ์ประสงค์ นักวิชาการ สำนักงานส่งเสริมสังคมแห่งการ เรียนรู้และคุณภาพเยาวชน (สสค.). (2561). ศักยภาพการแข่งขันด้านทรัพยากรมนุษย์: ไทยอยู่ไหนและจะสร้างทักษะในศตวรรษที่ 21 อย่างไร, 13 กันยายน 2562. https://www.bot.or.th/Thai/ResearchAndPublications/DocLib_/Article02Feb2018.pdf\r\n",
    sappear: "",
    mappear: 12,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความสามารถทางการแข่งขันด้านการท่องเที่ยว",
    meaning:
      "World Economic Forum (WEF) ได้จัดอันดับความสามารถในการแข่งขันด้านการเดินทางและการท่องเที่ยวของประเทศต่าง ๆ พิจารณาจากปัจจัยต่าง ๆ ใน 4 เสาหลัก โดยมีองค์ประกอบในแต่ละเสา ดังนี้\r\n1. สภาพแวดล้อมที่เอื้ออำนวย\r\n1) สภาพแวดล้อมทางธุรกิจ (Business Environment)\r\n2) ความมั่นคงปลอดภัย (Safety and Security)\r\n3) สุขภาพและอนามัย (Health and Hygiene)\r\n4) ทรัพยากรมนุษย์และตลาดแรงงาน (Human Resources and Labour Market)\r\n5) ความพร้อมทางด้านเทคโนโลยีสารสนเทศและการสื่อสาร (ICT Readiness)\r\n2. นโยบายและเงื่อนไขที่สำคัญ\r\n1) การให้ความสำคัญกับการเดินทางและท่องเที่ยว (Prioritization of Travel and Tourism)\r\n2) การเปิดรับนานาชาติ (International Openness)\r\n3) การแข่งขันด้านราคา (Price Competitiveness)\r\n4) ความยั่งยืนของสิ่งแวดล้อม (Environmental Sustainability)\r\n3. โครงสร้างพื้นฐาน\r\n1) โครงสร้างพื้นฐานด้านการขนส่งทางอากาศ (Air Transport Infrastructure)\r\n2) โครงสร้างพื้นฐานด้านการขนส่งทางบกและทางน้ำ (Ground and Port Infrastructure)\r\n3) โครงสร้างพื้นฐานบริการด้านการท่องเที่ยว (Tourist Service Infrastructure)\r\n4. ธรรมชาติและทรัพยากรทางวัฒนธรรม\r\n1) ทรัพยากรธรรมชาติ (Natural Resources)\r\n2) ทรัพยากรทางวัฒนธรรมและการท่องเที่ยวเพื่อธุรกิจ (Cultural Resources and Business Travel)",
    source:
      " สันติพจน์  กลับดี ส่วนอาเซียน สำนักการประชาสัมพันธ์ต่างประเทศ กรมประชาสัมพันธ์. (2559). ความสามารถในการแข่งขันด้านการท่องเที่ยวของไทยในกลุ่มอาเซียน, 17 กันยายน 2562. http://www.aseanthai.net/ewt_news.php?nid=5651&filename=index\r\n",
    sappear: 2,
    mappear: 5,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความสามารถพิเศษของพหุปัญญา",
    meaning:
      "ตามทฤษฎีพหุปัญญาของโฮวาร์ด การ์ดเนอร์  ซึ่งจำแนกไว้ 8 ด้าน ได้แก่ ด้านวาจา/ภาษา ด้านดนตรี/จังหวะ ด้านตรรกะ/คณิตศาสตร์ ด้านทัศนสัมพันธ์/มิติสัมพันธ์ ด้านร่างกาย/การเคลื่อนไหว ด้านธรรมชาติ ด้านการรู้ตนเอง และด้านความสัมพันธ์กับผู้อื่น ",
    source:
      "สำนักงานเลขาธิการสภาการศึกษา. (2550). การจัดการเรียนรู้แบบบูรณาการสู่พหุปัญญา, 15 สิงหาคม 2562. http://bsri.swu.ac.th/fileindex/childcenter/full50050.pdf",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ความหลากหลายทางชีวภาพ",
    meaning:
      "ความหลากหลายของสิ่งมีชีวิตทั้งมวล และให้หมายความรวมถึงความหลากหลายทางพันธุกรรม ทางชนิดพันธุ์ และทางระบบนิเวศอันเป็นถิ่นกำเนิดของสิ่งมีชีวิตเหล่านั้น",
    source:
      "พระราชบัญญัติป่าชุมชน พ.ศ. 2562 (2562, 29 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 71 ก หน้า 73.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/071/T_0071.PDF",
    sappear: "2,4,5",
    mappear: "3,4,18,19,23",
    rappear: 6,
    firstalpha: "ค"
  },
  {
    keyword: "คอนเดนเสท",
    meaning:
      "ไอน้ำผลิตจากหม้อไอน้ำแล้วถูกส่งไปยังอุปกรณ์ที่ใช้ไอน้ำผ่านท่อส่งจ่ายไอน้ำ ไอน้ำจะสูญเสียความร้อนไปสู่อากาศรอบๆ ท่อทำให้ไอน้ำบางส่วนเปลี่ยนสถานะกลายเป็นน้ำร้อน",
    source:
      "กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน กระทรวงพลังงาน. ระบบการผลิตและส่งจ่ายไอน้ำ, 26 กันยายน 2562. http://www2.dede.go.th/bhrd/old/web_display/factory/factory_steam.html",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ค"
  },
  {
    keyword: "คอมเพล็กซ์โรงกลั่น",
    meaning:
      "โรงกลั่นที่มีหน่วยเปลี่ยนสภาพของผลิตภัณฑ์(Cracking units) เนื่องจากมีต้นทุนการลงทุนสูงกว่า ซึ่งเป็นกระบวนการเพิ่มเติมจากกระบวนการกลั่นแบบ Distillation จึงสามารถปรับปรุงคุณภาพผลิตภัณฑ์น้ำมันชนิดหนักที่มีมูลค่าต่ำให้เป็นน้ำมันชนิดเบาขึ้นที่มีมูลค่าสูงกว่าได้",
    source:
      "รชฏ เลียงจันทร์.(2562). อุตสาหกรรมโรงกลั่นน้ำมัน, 10 ตุลาคม 2562. https://www.krungsri.com/bank/getmedia/aceda7f5-312d-4aa2-bbfa-2bbcdd93cb1b/IO_Refinery_190329_TH_EX.aspx",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ค"
  },
  {
    keyword: "คอร์รัปชัน",
    meaning:
      "ความผิดที่ระบุไว้ในประมวลกฎหมายอาญา ได้แก่ ความผิดต่อตำแหน่งหน้าที่ราชการ, ความผิดที่เกี่ยวกับความยุติธรรม และความผิดต่อตำแหน่งหน้าที่ในการยุติธรรม หรือเป็นการกระทำเพื่อแสวงหาผลประโยชน์ที่มิชอบด้วยกฎหมายสำหรับตนเองหรือผู้อื่น เช่น \r\n1. การเบียดบังทรัพย์ของทางราชการเป็นของตนหรือเป็นของผู้อื่นโดยทุจริต \r\n2. ใช้อำนาจในตำแหน่งโดยมิชอบ \r\n3. การบอกว่าจะให้ทรัพย์สิน หรือประโยชน์แก่เจ้าพนักงาน ",
    source:
      "องค์กรต่อต้านคอร์รัปชัน (ประเทศไทย). (2560). วงจรคอร์รัปชัน, 21 มิถุนายน 2562. http://www.anticorruption.in.th/2016/th/detail/135/5/%E0%B8%A7%E0%B8%87%E0%B8%88%E0%B8%A3%E0%B8%84%E0%B8%AD%E0%B8%A3%E0%B9%8C%E0%B8%A3%E0%B8%B1%E0%B8%9B%E0%B8%8A%E0%B8%B1%E0%B8%99",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ค"
  },
  {
    keyword: "คะแนน PISA ด้านการอ่าน คณิตศาสตร์ และวิทยาศาสตร์",
    meaning:
      "PISA ย่อมาจาก Programme for International Student Assessment เป็นโครงการที่มีจุดมุ่งหมายเพื่อประเมินว่านักเรียนที่จบการศึกษาภาคบังคับ (ซึ่งถือเป็นข้อตกลงเบื้องต้นคือ เยาวชนอายุ 15 ปี เพราะโดยทั่วไปเยาวชนวัยนี้ คือ วัยที่กำลังจะจบการศึกษาภาคบังคับ) จะได้รับการเตรียมพร้อมความรู้และทักษะที่จำเป็นสำหรับการเป็นประชาชนที่มีคุณภาพในอนาคต และมีส่วนร่วมสร้างสังคม\r\n  การรู้เรื่องคณิตศาสตร์ (Mathematics literacy) มีความหมายมากกว่าการคิดเลขและการทำโจทย์ การรู้จักรูปคณิตศาสตร์ หรือการจัดการข้อมูล แต่หมายรวมถึงการรู้ขอบเขตและข้อจำกัดของแนวคิดคณิตศาสตร์ สามารถติดตามและประเมินข้อโต้แย้งเชิงคณิตศาสตร์ เสนอปัญหาเชิงคณิตศาสตร์ เลือกวิธีการนำเสนอสถานการณ์เชิงคณิตศาสตร์ และสามารถตัดสินปัญหาบนพื้นฐานของคณิตศาสตร์ เพื่อแสดงว่าเป็นประชากรที่มีความคิดสร้างสรรค์และรอบคอบ\r\n  การรู้วิทยาศาสตร์ (Scientific Literacy) ตามความหมายของ PISA หมายถึงการรู้กระบวนการ (Process) การรู้แนวคิดและสาระเนื้อหา (Concepts and Content) และรู้จักการใช้ความรู้วิทยาศาสตร์เพื่อที่จะสามารถเข้าใจเรื่องราวที่เกิดขึ้นในสังคมในสื่อมวลชน และตัดสินใจประเด็นของโลกที่เกี่ยวข้องกับตัวเองทั้งในปัจจุบันและอนาคต",
    source:
      "โครงการ PISA ประเทศไทย สถาบันส่งเสริมการสอนวิทยาศาสตร์และเทคโนโลยี (สสวท.) กระทรวงศึกษาธิการhttps://pisathailand.ipst.ac.th/about-pisa/",
    sappear: "",
    mappear: 12,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "คะแนนความง่ายในการประกอบธุรกิจ",
    meaning:
      "ประเทศไทยเป็นประเทศที่มีความสะดวกในการประกอบธุรกิจเป็นอันดับที่ 27 จาก 190 ประเทศทั่วโลก จัดเป็นอันดับที่ 3 ของอาเซียน รองจากสิงคโปร์ (อันดับ 2) และมาเลเซีย (อันดับที่ 15) ",
    source:
      "ศูนย์ข้อมูลข่าวสารอาเซียน กรมประชาสัมพันธ์. (2562). การจัดอันดับความยาก-ง่ายในการประกอบธุรกิจของธนาคารโลก Doing Business 2019, 6 พฤศจิกายน 2562. http://www.aseanthai.net/ewt_news.php?nid=8751&filename=aseanknowledge",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ค"
  },
  {
    keyword:
      "คะแนนความสามารถในการแข่งขันการพัฒนาทุนมนุษย์ด้านทักษะ (Skill) ของ World Economic Forum (WEF)",
    meaning:
      "ส่วนหนึ่งของเกณฑ์ประเมินความสามารถในการแข่งขัน (Global Competitive Index: GCI)  อยู่ในปัจจัยชี้วัดเรื่องทุนมนุษย์ (Human Capital) เสาหลัก (Pillars) ที่ 6 ด้านทักษะ (Skill)\r\n",
    source:
      "Klaus Schwab. (2019). Competitiveness Report 2019. World Economic Forum. 19 พฤศจิกายน 2562. สืบค้นจาก http://www3.weforum.org/docs/WEF_TheGlobalCompetitivenessReport2019.pdf",
    sappear: "",
    mappear: 11,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ค่าเสียหายทางแพ่ง",
    meaning:
      "จำนวนเงินที่ศาลสั่งให้ลูกหนี้ชำระหนี้แก่เจ้าหนี้เป็นการชดใช้ความเสียหาย",
    source:
      "นายศิระณัฐ วิทยาธรรมธัช นิติกรปฏิบัติการ กองกฎหมายและคดี สำนักงานคณะกรรมการคุ้มครองผู้บริโภค. (2558). “ค่าเสียหายในบริบทการคุ้มครองผู้บริโภค”, 9 กันยายน 2562. http://www.ocpb.go.th/download/article/article_20180223091243.pdf\r\n",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ค"
  },
  {
    keyword:
      "ค่าใช้จ่ายในการวิจัยพัฒนา (Gross Domestic Expenditure on R&D, or GERD)",
    meaning:
      " ค่าใช้จ่ายทั้งหมดในปีที่อ้างอิง เพื่อใช้ในกิจกรรมในการวิจัยและพัฒนาในสถาบันหรือหน่วยงานที่จัดตั้งขึ้นภายในประเทศ ค่าใช้จ่ายดังกล่าว ประกอบด้วย หมวดค่าใช้จ่าย 2 หมวด คือ\r\n1. ค่าใช้จ่ายในการลงทุน (Capital costs) ได้แก่\r\n        ก. ค่าที่ดินและสิ่งก่อสร้าง\r\n        ข. ค่าเครื่องมือและอุปกรณ์\r\n2. ค่าใช้จ่ายในการดำเนินการ (Operating cost)\r\n        ก. ค่าใช้จ่ายด้านกำลังคน\r\n        ข. ค่าใช้จ่ายดำเนินการอื่น",
    source:
      "ศูนย์วิทยทรัพยากร จุฬาลงกรณ์มหาวิทยาลัย. (มนตรี จุฬาวัฒนทล, ระบบการวิจัยและพัฒนาในประเทศ (กรุงเทพฯ: สำนักงานกองทุนสนับสนุนการวิจัยและพัฒนา), 2537). บทที่ 2 แนวความคิดและผลงานวิจัยที่เกี่ยวข้อง, 4 กันยายน 2562. http://cuir.car.chula.ac.th/dspace/bitstream/123456789/28681/5/Aeimporn_on_ch2.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ค"
  },
  {
    keyword: "ค่าใช้จ่ายด้านสาธารณสุข",
    meaning:
      "ค่าใช้จ่ายต่าง ๆ ที่เกิดขึ้นจากการให้บริการสาธารณสุขของหน่วยบริการ ได้แก่ (1) ค่าสร้างเสริมสุขภาพ และป้องกันโรค (2) ค่าตรวจวินิจฉัยโรค (3) ค่าตรวจและรับฝากครรภ์ (4) ค่าบำบัดและบริการทางการแพทย์ (5) ค่ายา ค่าเวชภัณฑ์ ค่าอวัยะเทียม และค่าอุปกรณ์ทางการแพทย์ (6) ค่าทำคลอด (7) ค่ากินอยู่ในหน่วยบริการ (8) ค่าบริบาลทารกแรกเกิด (9) ค่ารถพยายาลหรือค่าพาหนะรับส่งผู้ป่วย (10) ค่าพาหนะรับส่งผู้ทุพพลภาพ (11) ค่าฟื้นฟูสมรรถภาพร่างกาย และจิตใจ และ (12) ค่าใช้จ่ายอื่นที่จำเป็นเพื่อการบริการสาธารณสุขตามที่คณะกรรมการกำหนด",
    source:
      "พระราชบัญญัติหลักประกันสุขภาพแห่งชาติ พ.ศ. 2545. (2545, 18 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม119 ตอนที่ 116 ก หน้า 2. \r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/00117199.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ค"
  },
  {
    keyword: "ค่าครองชีพ",
    meaning: "ค่าใช้จ่ายที่จําเป็นในการดํารงชีพระหว่างศึกษา",
    source:
      "พระราชบัญญัติ กองทุนเพื่อความเสมอภาคทางการศึกษา\r\nพ.ศ. 2561. (2561, 13 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 33 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 12,
    firstalpha: "ค"
  },
  {
    keyword: "ค่าจ้าง",
    meaning:
      "เงินทุกประเภทที่นายจ้างจ่ายให้แก่ลูกจ้างเป็นค่าตอบแทนการทำงานในวันและเวลาทำงานปกติไม่ว่าจะคำนวณตามระยะเวลาหรือคำนวณตามผลงานที่ลูกจ้างทำได้ และให้หมายความรวมถึงเงินที่นายจ้างจ่ายให้ในวันหยุดและวันลาซึ่งลูกจ้างไม่ได้ทำงานด้วย  ทั้งนี้ ไม่ว่าจะกำหนดคำนวณหรือจ่ายในลักษณะใดหรือโดยวิธีการใด และไม่ว่าจะเรียกชื่ออย่างไร",
    source:
      "พระราชบัญญัติประกันสังคม พ.ศ. 2533 (2533,1 กันยายน)  ราชกิจจานุเบกษา. เล่ม 107 ตอนที่ 161 ก หน้า 3 http://www.ratchakitcha.soc.go.th/DATA/PDF/2533/A/161/1.PDF",
    sappear: 4,
    mappear: "",
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ค่านิยม",
    meaning:
      "สิ่งที่สังคมถือว่ามีค่าพึงปราถนาต้องการให้เป็นเป้าหมายของสังคมและปลูกฝังให้สมาชิกของสังคมยึดถือเป็นเป้าหมายในการดำเนินชีวิต",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2542. ค่านิยม. 29 มิถุนายน 2562. http://www.royin.go.th/dictionary/ ",
    sappear: 3,
    mappear: "",
    rappear: 1,
    firstalpha: "ค"
  },
  {
    keyword: "ค่านิยมเสรีภาพ",
    meaning:
      "สมาชิกของสังคมมีสิทธิ เสรีภาพ และหน้าที่ในสังคมอย่างเสมอภาคเท่าเทียมกัน เช่น สมาชิกในสังคมไทยทุกคนมีหน้าที่ในการปฏิบัติตามกฎหมายอย่างเท่าเทียมกัน มีสิทธิที่จะได้รับการศึกษาพื้นฐานอย่างเท่าเทียมกัน มีสิทธิที่จะได้รับการรักษาพยาบาลอย่างเท่าเทียมกัน มีเสรีภาพในการแสดงความคิดเห็นอย่างเท่าเทียมกัน",
    source:
      "สำนักงานเลขาธิการสภาผู้แทนราษฎร ปฏิบัติหน้าที่สำนักงานเลขาธิการสภาปฏิรูปแห่งชาติ. (2558). วาระพัฒนาที่ 4 : ระบบค่านิยม คุณธรรม จริยธรรมเพื่อความเป็นพลเมืองที่ดีและมนุษย์ที่สมบูรณ์, 9 กันยายน 2562. https://library2.parliament.go.th/giventake/content_nrcinf/nrc2557-pr66.pdf\r\n",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ค"
  },
  {
    keyword: "ค่านิยมวัฒนธรรมที่พึงประสงค์",
    meaning:
      'แนวปฏิบัติขององค์กร ที่สมาชิกในองค์กรใช้เป็นมาตรฐานในการประเมินค่าสิ่งต่างๆว่าควรปฏิบัติหรือไม่ควรปฏิบัติ ซึ่งจะเป็นกรอบให้แก่องค์กรที่จะปฏิบัติแต่ในสิ่งที่ถูกต้องและทิศทางที่ถูกต้องอยู่ตลอดเวลาโดยสมาชิกทุกคนจะต้องรับรู้และร่วมแรงร่วมใจปฏิบัติ ซึ่งจะนำไปสู่การมีพฤติกรรมที่สอดคล้องกับค่านิยมนั้นจนกลายเป็นวัฒนธรรมองค์กรและการที่จะเสริมสร้างวัฒนธรรมองค์กรได้นั้น จะต้องมีการกำหนดค่านิยม อันถือเป็นแกนของ "วัฒนธรรมองค์กร" นับเป็นขั้นตอนแรก จากนั้นจะต้องสื่อสารค่านิยมนั้นให้กลายเป็นพฤติกรรมขององค์กรจะต้องมีการเสริมแรง เพื่อให้บุคลากรประพฤติปฏิบัติตามอย่างต่อเนื่องจนกลายเป็นวัฒนธรรมองค์กรในที่สุด',
    source:
      "กรมทรัพยากรธรณี. คู่มือ ค่านิยมและวัฒนธรรม, 24 ธันวาคม 2562. http://www.dmr.go.th/ewtadmin/ewt/hrd/images/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%84%E0%B9%88%E0%B8%B2%E0%B8%99%E0%B8%B4%E0%B8%A2%E0%B8%A1%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%A7%E0%B8%B1%E0%B8%92%E0%B8%99%E0%B8%98%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B8%81%E0%B8%A3%E0%B8%A1%E0%B8%97%E0%B8%A3%E0%B8%B1%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%81%E0%B8%A3%E0%B8%98.pdf",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ค่าบริการสายส่ง (Wheeling Charge)",
    meaning:
      "การเปิดให้มีการซื้อขายไฟฟ้าโดยตรงระหว่างผู้ผลิตและผู้ใช้ไฟฟ้า โดยใช้บริการสายส่งและสายจําหน่ายของการไฟฟ้า ทั้งนี้ รัฐจะเป็นผู้กํากับดูแลอัตราค่าใช้บริการ \r\nองค์ประกอบค่าบริการระบบส่ง\r\n- ค่าใช้จ่ายในการดําเนินการเพื่อจัดส่งไฟฟ้า\r\n- ค่าบริการเสริมความมั่นคงในการควบคุมระบบไฟฟ้า(Ancillary services)\r\n และค่าภาระความสูญเสียในสายส่ง\r\n",
    source:
      "นายวัชรกฤษณ์ จงไพบูลย์พัฒนะ สังกัด กองวางแผนปฏิบัติการระบบส่งไฟฟ้า ฝ่ายควบคุมระบบกําลังไฟฟ้า การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย. Third Party Access (TPA), 3 กันยายน 2562. http://www.appp.or.th/imgadmins/document/24151037.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ค"
  },
  {
    keyword: "ค่าพยากรณ์ความต้องการไฟฟ้ารายภาค",
    meaning:
      "ค่าพยากรณ์ความต้องการไฟฟ้า 5 ภาคหลักในระบบ 3 การไฟฟ้า ได้แก่ การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย (กฟผ.) การไฟฟ้านครหลวง (กฟน.) และการไฟฟ้าส่วนภูมิภาค (กฟภ.)) ได้แก่ เขตนครหลวง ภาคกลางภาคตะวันออกเฉียงเหนือ ภาคใต้ และ ภาคเหนือ มีแนวโน้มสอดคล้องกับสถิติอัตราการเติบโตของความต้องการไฟฟ้ารายสถานีไฟฟ้าแรงสูงของ กฟผ. รายภาค",
    source:
      "สำนักงานนโยบายและแผนพลังงาน กระทรวงพลังงาน. (2562). แผนพัฒนากำลังผลิตไฟฟ้าของประเทศไทย พ.ศ. 2561 - 2580 (PDP2018), 9 กันยายน 2562. http://www.eppo.go.th/images/Infromation_service/public_relations/PDP2018/PDP2018.pdf\r\n",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ค"
  },
  {
    keyword: "ค่าภาคหลวง",
    meaning:
      'มาจากคำว่า Special Remuneration Benefit หมายถึง การเก็บผลประโยชน์พิเศษจากกำไรส่วนเกิน ผลประโยชน์ตอบแทนพิเศษนี้ได้กำหนดให้มีขึ้นตามพระราชบัญญัติปิโตรเลียม (ฉบับที่ 4) พ.ศ. 2532 โดยมีจุดประสงค์เพื่อให้รัฐได้รับส่วนแบ่งผลประโยชน์มากยิ่งขึ้น (นอกเหนือไปจากค่าภาคหลวงและภาษีที่ได้รับอยู่ตามปรกติ) ในกรณีของการที่ผู้รับสัมปทานพบแหล่งปิโตรเลียมขนาดใหญ่ หรือได้รับประโยชน์จากการที่น้ำมันดิบในตลาดโลกมีราคาสูงขึ้นอย่างฉับพลันหรือมีต้นทุนการสำรวจและผลิตต่ำ การคำนวณผลประโยชน์ตอบแทนพิเศษจะกระทำเป็นรายปีจากจำนวน \\"กำไรปิโตรเลียม\\" ก่อนหักภาษีเงินได้ปิโตรเลียม หากปีใดไม่มี \\"กำไรปิโตรเลียม\\" เกิดขึ้นก็ยังไม่มีภาระต้องเสีย และ \\"จำนวนขาดทุนปิโตรเลียม\\" ในปีนั้น ก็สามารถยกยอดไปหักจากรายได้ในปีต่อๆไปได้จนกว่าจะหมด',
    source:
      "กรมเชื้อเพลิงธรรมชาติ. นิยามศัพท์, 10 ตุลาคม 2562. https://dmf.go.th/public/list/data/index/menu/670/textsearch/%E0%B8%AA%E0%B8%B3%E0%B8%A3%E0%B8%AD%E0%B8%87%E0%B9%80%E0%B8%8A%E0%B8%B7%E0%B9%89%E0%B8%AD%E0%B9%80%E0%B8%9E%E0%B8%A5%E0%B8%B4%E0%B8%87/page/10",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ค"
  },
  {
    keyword: "คาร์บอนเครดิต",
    meaning:
      "ปริมาณก๊าซเรือนกระจกที่สามารถลดได้จากการดำเนินโครงการกลไกการพัฒนาที่สะอาด หรือ CDM (Clean Development Mechanism) ได้รับการนำมาใช้เป็นกลไกเพื่อประเทศที่พัฒนาแล้วจะประสบปัญหาในการลดปริมาณก๊าซ",
    source:
      "วิกิพีเดีย สารานุกรม. (2556). คาร์บอนเครดิต, 12 กรกฎาคม 2562. https://th.wikipedia.org/wiki/%E0%B8%84%E0%B8%B2%E0%B8%A3%E0%B9%8C%E0%B8%9A%E0%B8%AD%E0%B8%99%E0%B9%80%E0%B8%84%E0%B8%A3%E0%B8%94%E0%B8%B4%E0%B8%95",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "คาร์บอนไดออกไซด์",
    meaning:
      "คาร์บอนไดออกไซด์เป็นก๊าซที่ไม่มีสี อยู่ในชั้นบรรยากาศมีสัดส่วนประมาณ 0.03% โครงสร้างโมเลกุลประกอบด้วยคาร์บอน 1 อะตอมและออกซิเจน 2 อะตอม (CO2) เมื่ออยู่ในสถานะของแข็ง จะเรียกว่า น้ำแข็งแห้ง (Dry Ice) ก๊าซคาร์บอนไดออกไซต์ในอากาศเกิดจากธรรมชาติ และเกิดจากฝีมือมนุษย์ เช่น การเผาไหม้เชื้อเพลิงที่มีธาตุคาร์บอนเป็นองค์ประกอบอย่างสมบูรณ์ โรงงานอุตสาหกรรม การตัดไม้ทำลายป่า เป็นต้น",
    source:
      "สถาบันมาตรวิทยาแห่งชาติ กระทรวงวิทยาศาสตร์และเทคโนโลยี. วัสดุอ้างอิงเพื่อการตรวจวัดปริมาณก๊าซคาร์บอนไดออกไซต์ในอากาศ, 21 สิงหาคม 2562. http://www.nimt.or.th/etrm/upload/basicdescription/file-8.pdf",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "คาร์บอนต่ำ",
    meaning:
      "ตัวเลขประมาณการปริมาณการปล่อยก๊าซเรือนกระจกรายปีในระดับโลก ซึ่งความเข้มของก๊าซเรือนกระจกในชั้นบรรยากาศอยู่ในระดับที่ยอมรับกันว่าไม่เป็นการแทรกแซงของมนุษย์ที่เป็นอันตรายกับระบบภูมิอากาศ",
    source:
      "กรมส่งเสริมคุณภาพสิ่งแวดล้อม. สังคมคาร์บอนต่ำ, 24 กันยายน 2562. http://actionforclimate.deqp.go.th/?p=6624",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "ค่าฤชาธรรมเนียม",
    meaning:
      "ค่าธรรมเนียมที่กฎหมายบังคับให้ต้องเสียและค่าใช้จ่ายต่าง ๆ ในการดำเนินคดี รวมถึงค่าป่วยการพยาน ค่าทนายความ และค่าธรรมเนียมศาลอื่น ๆ",
    source:
      'พจนานุกรม ฉบับราชบัณฑิตยสถาน พ.ศ. 2542. ค่าฤชาธรรมเนียม, 29 มิถุนายน 2562. http://www.royin.go.th/dictionary/"',
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ค"
  },
  {
    keyword: "ค่าสินไหมทดแทน",
    meaning:
      "สิ่งที่ให้หรือการกระทําที่ทําเพื่อชดใช้หรือทดแทนความเสียหายที่เกิดขึ้นแก่ทรัพย์สินหรือบุคคลอันเนื่องมาจากการละเมิดหรือการผิดสัญญา รวมทั้งการคืนทรัพย์สินให้แก่ผู้เสียหายด้วย",
    source:
      "สุนันทา จันทร์แก้ว นักกฎหมายกฤษฎีกาชํานาญการ ปฏิบัติราชการในกองกฎหมายกระบวนการยุติธรรม ฝ่ายกฎหมายกระบวนการยุติธรรมทางแพ่ง สํานักงานคณะกรรมการกฤษฎีกา. ค่าสินไหมทดแทนกรณีละเมิดที่ก่อให้เกิดความเสียหายทางจิตใจ, 9 กันยายน 2562. http://web.krisdika.go.th/data/activity/act225.pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ค"
  },
  {
    keyword: "คำร้องทุกข์",
    meaning:
      "การที่ผู้เสียหายได้กล่าวหาต่อเจ้าหน้าที่ตามบทบัญญัติแห่งประมวลกฎหมายนี้ ว่ามีผู้กระทำความผิดขึ้น จะรู้ตัวผู้กระทำความผิดหรือไม่ก็ตามซึ่งกระทำให้เกิดความเสียหายแก่ผู้เสียหาย และการกล่าวหาเช่นนั้นได้กล่าวโดยมีเจตนาจะให้ผู้กระทำความผิดได้รับโทษ",
    source:
      "พระราชบัญญัติประมวลกฎหมายวิธีพิจารณาความอาญา พ.ศ. 2477 และที่แก้ไขเพิ่มเติม.  http://www.krisdika.go.th/librarian/get?sysid=570066&ext=pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ค"
  },
  {
    keyword: "คำวินิจฉัยของศาลรัฐธรรมนูญ",
    meaning:
      "1. องค์คณะของตุลาการศาลรัฐธรรมนูญในการนั่งพิจารณาและในการทำคำวินิจฉัย ต้องประกอบด้วยตุลาการไม่น้อยกว่า 7 คน (รัฐธรรมนูญมาตรา 211 วรรคหนึ่ง)\r\n2. คำวินิจฉัยของศาลรัฐธรรมนูญ ให้ถือเสียงข้างมาก เว้นแต่จะมีบทบัญญัติของรัฐธรรมนูญกำหนดข้อยกเว้นไว้เป็นอย่างอื่น (รัฐธรรมนูญมาตรา 211 วรรคสอง) ยกเว้นกรณีการวินิจฉัยว่าพระราชกำหนดใดไม่เป็นไปตามมาตรา ๑๗๒ วรรคหนึ่ง จะต้องมีคะแนนเสียงไม่น้อยกว่าสองในสามของจำนวนตุลาการศาลรัฐธรรมนูญทั้งหมดเท่าที่มีอยู่(รัฐธรรมนูญ มาตรา 173)\r\n3. รัฐธรรมนูญกำหนดให้ตุลาการศาลรัฐธรรมนูญซึ่งเป็นองค์คณะทุกคนจะต้องทำความเห็นในการวินิจฉัยในส่วนของตน พร้อมแถลงด้วยวาจาต่อที่ประชุมแล้วให้ที่ประชุมปรึกษาหารือร่วมกันก่อนแล้วจึงลงมติ ความเห็นส่วนตนให้ทำโดยสังเขปตามข้อกำหนดของศาลรัฐธรรมนูญ โดยการทำวินิจฉัยดังกล่าว องค์คณะอาจมอบหมายให้ตุลาการคนหนึ่งคนใดเป็นผู้จัดทำคำวินิจฉัยตามมติของศาลก็ได้ คำวินิจฉัยของศาลให้ประกาศในราชกิจจานุเบกษาภายใน 30 วันนับแต่วันที่มีคำวินิจฉัย (พระราชบัญญัติประกอบรัฐธรรมนูญว่าด้วยวิธีพิจารณาของศาลรัฐธรรมนูญ พ.ศ. 2561 มาตรา 75)\r\n4. คำวินิจฉัยของศาลรัฐธรรมนูญให้เป็นเด็ดขาด มีผลผูกพันรัฐสภาคณะรัฐมนตรี ศาล องค์กรอิสระและหน่วยงานของรัฐ (รัฐธรรมนูญ มาตรา 211 วรรคสี่) \r\n5. คำวินิจฉัยของศาลรัฐธรรมนูญให้ใช้ได้ในคดีทั้งปวง แต่ไม่กระทบต่อคำพิพากษาของศาลอันถึงที่สุดแล้ว เว้นแต่ในคดีอาญาให้ถือว่าผู้ซึ่งเคยถูกศาลพิพากษาว่ากระทำความผิดตามบทบัญญัติแห่งกฎหมายที่ศาลรัฐธรรมนูญวินิจฉัยว่าไม่ชอบด้วยมาตรา 5 นั้น เป็นผู้ไม่เคยกระทำความผิดดังกล่าว หรือถ้าผู้นั้นยังรับโทษอยู่ก็ให้ปล่อยตัวไป แต่ทั้งนี้ไม่ก่อให้เกิดสิทธิที่จะเรียกร้องค่าชดเชยหรือค่าเสียหายใดๆ (รัฐธรรมนูญ มาตรา 212)\r\n6. สาระสำคัญของคำวินิจฉัยของศาลรัฐธรรมนูญอย่างน้อยต้องประกอบด้วยข้ออ้างและคำขอในคำร้องหรือหนังสือขอให้ศาลพิจารณาวินิจฉัยข้อโต้แย้งในคำชี้แจงข้อกล่าวหา ประเด็นแห่งคดี สรุปข้อเท็จจริงที่ได้จากการพิจารณา เหตุผลในการวินิจฉัยในแต่ละประเด็น และบทบัญญัติของรัฐธรรมนูญและกฎหมายที่ยกขึ้นอ้างอิง รวมทั้งผลแห่งคำวินิจฉัย นอกจากนี้คำวินิจฉัยของศาลต้องลงลายมือชื่อของตุลาการที่วินิจฉัย ถ้าตุลาการคนใดมีเหตุจำเป็นอันไม่อาจหลีกเลี่ยงได้ไม่สามารถลงลายมือชื่อได้ ให้องค์คณะนั้นมอบหมายให้ตุลาการคนใดคนหนึ่งที่เป็นองค์คณะจดแจ้งเหตุดังกล่าวแล้วติดรวมไว้กับคำวินิจฉัย (พระราชบัญญัติประกอบรัฐธรรมนูญว่าด้วยวิธีพิจารณาของศาลรัฐธรรมนูญ พ.ศ. 2561 มาตรา 73)",
    source:
      "สำนักงานศาลรัฐธรรมนูญ. (2561). ความรู้เบื้องต้นเกี่ยวกับศาลรัฐธรรมนูญ, 1 ตุลาคม 2562. http://english.constitutionalcourt.or.th/occ_web/download/institute_constitutionalcourt/basicofcourt.pdf",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ค"
  },
  {
    keyword: "คำสั่งปล่อยชั่วคราว",
    meaning:
      "การยื่นคำร้องต่อศาลเพื่อขอให้พิจารณาปล่อยผู้ต้องหาหรือจำเลยชั่วคราวโดยไม่ต้องมีประกันหรือมีประกันหรือมีประกันและหลักประกัน ภายในระยะเวลาที่กำหนด ",
    source:
      "กองการต่างประเทศ สำนักงานศาลยุติธรรม. (2555). การขอปล่อยชั่วคราวจากศาล, 1 ตุลาคม 2562. https://oia.coj.go.th/th/file/get/file/2019021321cc07521f6601cc8211fd0cb8ab28a2142524.pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ค"
  },
  {
    keyword: "คุณธรรม",
    meaning:
      "สภาพความดีที่เกิดขึ้นในจิตใจของคน และแสดงออกเป็นการประพฤติปฏิบัติที่ดีจนเคยชินก่อให้เกิดประโยชน์สุขในสังคม คุณธรรมระดับบุคคลแบ่งได้เป็น 4 กลุ่ม ดังนี้\r\n1. คุณธรรมที่เป็นปัจจัยผลักดัน ทำให้คนเกิดความเพียรพยายามทำในสิ่งที่มุ่งหมายไว้ให้สำเร็จ ประกอบด้วย วินัย อดทน ขยัน\r\n2. คุณธรรมที่เป็นปัจจัยหล่อเลี้ยง สร้างแรงผลักดันให้เกิดคุณธรรม ประกอบด้วย ซื่อสัตย์ ซื่อตรง รับผิดชอบ\r\n3. คุณธรรมที่เป็นปัจจัยเหนี่ยวรั้ง ไม่ให้คนทำในสิ่งที่ไม่ถูกต้อง ประกอบด้วย มีสติ พอเพียง\r\n4. คุณธรรมที่เป็นปัจจัยสนับสนุน ให้คนเข้าไปมีส่วนร่วมทำกิจกรรมต่าง ๆ โดยมุ่งหวังผลประโยชน์ส่วนรวม ประกอบด้วย เมตตา กรุณา กตัญญู เสียสละ",
    source:
      "ศูนย์ปฏิบัติการต่อต้านการทุจริต (ศปท.) กระทรวงการต่างประเทศ. การส่งเสริมคุณธรรม พอเพียง วินัย สุจริต จิตอาสา สร้างคนดีสู่สังคม, 10 กรกฎาคม 2562. http://www.mfa.go.th/acc/th/news/6825/94624-%E0%B9%81%E0%B8%99%E0%B8%B0%E0%B8%99%E0%B8%B3%E0%B8%AB%E0%B8%99%E0%B8%B1%E0%B8%87%E0%B8%AA%E0%B8%B7%E0%B8%AD-%22%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%AA%E0%B9%88%E0%B8%87%E0%B9%80%E0%B8%AA%E0%B8%A3%E0%B8%B4%E0%B8%A1%E0%B8%84%E0%B8%B8%E0%B8%93%E0%B8%98%E0%B8%A3%E0%B8%A3%E0%B8%A1-%E0%B8%9E%E0%B8%AD%E0%B9%80%E0%B8%9E%E0%B8%B5%E0%B8%A2%E0%B8%87-%E0%B8%A7%E0%B8%B4%E0%B8%99%E0%B8%B1.html",
    sappear: 3,
    mappear: 10,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "คุณธรรมจริยธรรม (การเมือง)",
    meaning:
      "การจัดให้มีประมวลจริยธรรมของผู้ดำรงตำแหน่งทางการเมืองและเจ้าหน้าที่ของรัฐ ถ้าหากข้าราชการและเจ้าหน้าที่รัฐฝ่าฝืนมีความผิดทางวินัย ผู้ดำรงตำแหน่งฝ่าฝืนและเป็นความผิดร้ายแรงให้ผู้ตรวจการแผ่นดินส่งเรื่องให้สำนักงานคณะกรรมการป้องกันและปราบปราบการทุจริตแห่งชาติ (ป.ป.ช.) และถือเป็นเหตุให้ถูกถอดถอนออกจากตำแหน่งโดยมติวุฒิสภาได้",
    source:
      "ศูนย์เฝ้าระวังสถานการณ์ภาคใต้. (2553). จริยธรรมนักการเมืองกับแนวทางการปฏิรูปประเทศไทย, 21 ตุลาคม 2562. https://deepsouthwatch.org/th/node/812",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ค"
  },
  {
    keyword: "คุณภาพในทางน้ำ",
    meaning:
      "ความเหมาะสมของน้ำเพื่อใช้ในกิจกรรมเฉพาะของมนุษย์คุณภาพของน้ำตามแหล่งน้ำธรรมชาติ จะเปลี่ยนแปลงไปมากหรือน้อยขึ้นอยู่กับปัจจัยของสภาพแวดล้อมเป็นสำคัญ ได้แก่ สภาพภูมิประเทศ ภูมิอากาศ ลักษณะของธรณีวิทยา พืชพรรณธรรมชาติ รวมถึงกิจกรรมของมนุษย์และสิ่งมีชีวิตอื่นๆ",
    source:
      "กรมอุทยานแห่งชาติ สัตว์ป่า และพันธุ์พืช. คุณภาพน้ำของลุ่มน้ำ, 24 กันยายน 2562. http://www.dnp.go.th/Research/watershade/qullity.html",
    sappear: 5,
    mappear: 19,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword:
      "คุณภาพของน้ำในแหล่งน้ำผิวดิน แหล่งน้ำทะเล และแหล่งน้ำใต้ดิน อยู่ในเกณฑ์เหมาะสมกับประเภทของการใช้ประโยชน์",
    meaning:
      "ความเหมาะสมของน้ำเพื่อใช้ในกิจกรรมเฉพาะของมนุษย์คุณภาพของน้ำตามแหล่งน้ำธรรมชาติ จะเปลี่ยนแปลงไปมากหรือน้อยขึ้นอยู่กับปัจจัยของสภาพแวดล้อมเป็นสำคัญ ได้แก่ สภาพภูมิประเทศ ภูมิอากาศ ลักษณะของธรณีวิทยา พืชพรรณธรรมชาติ รวมถึงกิจกรรมของมนุษย์และสิ่งมีชีวิตอื่นๆ",
    source:
      "กรมอุทยานแห่งชาติ สัตว์ป่า และพันธุ์พืช. คุณภาพน้ำของลุ่มน้ำ, 26 กันยายน 2562. http://www.dnp.go.th/Research/watershade/qullity.html",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "คุณภาพสิ่งแวดล้อม",
    meaning:
      "ดุลยภาพของธรรมชาติ อันได้แก่ สัตว์ พืช\r\nและทรัพยากรธรรมชาติต่าง ๆ และสิ่งที่มนุษย์ได้ทำขึ้น ทั้งนี้ เพื่อประโยชน์ต่อการดำรงชีพของ\r\nประชาชน และความสมบูรณ์สืบไปของมนุษยชาติ",
    source:
      "พระราชบัญญัติส่งเสริมและรักษาคุณภาพสิ่งแวดล้อมแห่งชาติ พ.ศ. 2535. (2535, 4 เมษายน). ราชกิจจานุเบกษา. เล่ม 109 ตอนที่ 17 หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/037/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ค"
  },
  {
    keyword: "คุณภาพอากาศ เสียง และความสั่นสะเทือนอยู่ในเกณฑ์มาตรฐานประเทศไทย",
    meaning:
      "คุณภาพอากาศ\r\n1. ก๊าซคาร์บอนมอนอกไซด์ (CO) 1 ชม.  ไม่เกิน 30 ppm. (34.2 มก./ลบ.ม.)   8 ชม.ไม่เกิน 9 ppm. (10.26 มก./ลบ.ม)\r\n2. ก๊าซไนโตรเจนไดออกไซด์ (NO2) 1 ชม.ไม่เกิน 0.17 ppm. (0.32 มก./ลบ.ม.)  1 ปี ไม่เกิน 0.03 ppm. (0.057 มก./ลบ.ม.)\r\n3. ก๊าซโอโซน (O3)   1 ชม.ไม่เกิน 0.10 ppm. (0.20 มก./ลบ.ม.)   8 ชม.ไม่เกิน 0.07 ppm. (0.14 มก./ลบ.ม.)\r\n4. ก๊าซซัลเฟอร์ไดออกไซด์ (SO2)  1 ปี ไม่เกิน 0.04 ppm. (0.10 มก./ลบ.ม)  24 ชม. ไม่เกิน 0.12 ppm.(0.30 มก./ลบ.ม) 1 ชม.ไม่เกิน 0.3 ppm.(780 มคก./ลบ.ม)\r\n5. ตะกั่ว (Pb) 1 เดือน ไม่เกิน 1.5 มคก./ลบ.ม        \r\n6. ฝุ่นละอองขนาดไม่เกิน 100 ไมครอน  24 ชม.  ไม่เกิน 0.33 มก./ลบ.ม.  1 ปี  ไม่เกิน 0.10 มก./ลบ.ม.\r\n7. ฝุ่นละอองขนาดไม่เกิน 10 ไมครอน  24 ชม.  ไม่เกิน 0.12 มก./ลบ.ม   1 ปี ไม่เกิน 0.05 มก./ลบ.ม\r\n8. ฝุ่นละอองขนาดไม่เกิน 2.5 ไมครอน   24 ชม.  ไม่เกิน 0.05 มก./ลบ.ม.  1 ปี  ไม่เกิน 0.025 มก./ลบ.ม.\r\n\r\nคุณภาพเสียงและความสั่นสะเทือน\r\n1.ค่าระดับเสียงสูงสุด ไม่เกิน 115 เดซิเบลเอ\r\n2.ค่าระดับเสียงเฉลี่ย 24 ชั่วโมง ไม่เกิน 70 เดซิเบลเอ",
    source:
      "กรมควบคุมมลพิษ กระทรวงทรัพยากรธรรมชาติและสิ่งแวดล้อม. มาตรฐานคุณภาพอากาศและเสียง,  2 ธันวาคม 2562. http://www.pcd.go.th/info_serv/reg_std_airsnd04.html#s1",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ค"
  },
  {
    keyword: "งบประมาณแบบขาเดียวด้านรายจ่าย",
    meaning:
      "การทำงบประมาณที่มุ่งให้ความสำคัญกับการจัดทำงบประมาณรายจ่ายเป็นหลัก",
    source:
      "สถาบันพระปกเกล้า. (2546). บทวิจารณ์หนังสือ เรื่อง ระบบงบประมาณและการจัดการแบบมุ่งผลสำเร็จในภาครัฐ, 7 พฤศจิกายน 2562. http://wiki.kpi.ac.th/index.php?title=%E0%B8%9A%E0%B8%97%E0%B8%A7%E0%B8%B4%E0%B8%88%E0%B8%B2%E0%B8%A3%E0%B8%93%E0%B9%8C%E0%B8%AB%E0%B8%99%E0%B8%B1%E0%B8%87%E0%B8%AA%E0%B8%B7%E0%B8%AD_%E0%B9%80%E0%B8%A3%E0%B8%B7%E0%B9%88%E0%B8%AD%E0%B8%87_%E0%B8%A3%E0%B8%B0%E0%B8%9A%E0%B8%9A%E0%B8%87%E0%B8%9A%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%A1%E0%B8%B2%E0%B8%93%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%88%E0%B8%B1%E0%B8%94%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%81%E0%B8%9A%E0%B8%9A%E0%B8%A1%E0%B8%B8%E0%B9%88%E0%B8%87%E0%B8%9C%E0%B8%A5%E0%B8%AA%E0%B8%B3%E0%B9%80%E0%B8%A3%E0%B9%87%E0%B8%88%E0%B9%83%E0%B8%99%E0%B8%A0%E0%B8%B2%E0%B8%84%E0%B8%A3%E0%B8%B1%E0%B8%90",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ง"
  },
  {
    keyword: "งบประมาณในระยะกลาง (Medium Term Expenditure Framework: MTEF)",
    meaning:
      "กรอบที่เชื่อมการตัดสินใจการจัดทำงบประมาณรายจ่ายประจำปีเข้ากับกลยุทธ์การจัดสรรทรัพยากรระยะปานกลางหรืออีกนัยหนึ่ง คือ กระบวนการที่ช่วยให้กระบวนการวางแผนการใช้จ่าย (Financial Planning) ของภาครัฐและการวางแผนในระยะปานกลาง",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์. (2555). MTEF, 18 กรกฎาคม 2562. https://www.etda.or.th/terminology-detail/1056.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ง"
  },
  {
    keyword: "งบประมาณรายจ่าย",
    meaning:
      "จำนวนเงินอย่างสูงที่อนุญาตให้จ่ายหรือให้ก่อหนี้ผูกพันได้ตามวัตถุประสงค์และภายในระยะเวลาที่กําหนดไว้ในกฎหมายว่าด้วยงบประมาณรายจ่าย",
    source:
      "พระราชบัญญัติวิธีการงบประมาณ พ.ศ. 2561. (2561, 11 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 92 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/092/1.PDF",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ง"
  },
  {
    keyword: "งานบริการ",
    meaning:
      "งานจ้างบริการ งานจ้างเหมาบริการ งานจ้างทําของและการรับขนตามประมวลกฎหมายแพ่งและพาณิชย์จากบุคคลธรรมดาหรือนิติบุคคล แต่ไม่หมายความรวมถึงการจ้างลูกจ้างของหน่วยงานของรัฐ การรับขนในการเดินทางไปราชการหรือไปปฏิบัติงานของหน่วยงานของรัฐ\r\nงานจ้างที่ปรึกษา งานจ้างออกแบบหรือควบคุมงานก่อสร้าง และการจ้างแรงงานตามประมวลกฎหมายแพ่งและพาณิชย์ ",
    source:
      "พระราชบัญญัติการจัดซื้อจัดจ้างและการบริหารพัสดุภาครัฐ พ.ศ. 2560. (2560, 24 กุมภาพันธ์). ราชกิจจานุเบกษา. เล่ม 134 ตอนที่ 24 ก หน้า 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/A/024/13.PDF",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ง"
  },
  {
    keyword: "งานบริการภาครัฐที่ปรับเปลี่ยนเป็นดิจิทัล",
    meaning:
      "การนำเทคโนโลยีดิจิทัลมาใช้ในการปรับปรุงประสิทธิภาพการบริหารจัดการของหน่วยงานรัฐทั้งส่วนกลางและส่วนภูมิภาคอย่างมีแบบแผนและเป็นระบบจนพัฒนาสู่การเป็นรัฐบาลดิจิทัลโดยสมบูรณ์",
    source:
      "กระทรวงเทคโนโลยีสารสนเทศและการสื่อสาร. แผนพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม, 22 ตุลาม 2562. https://www.dga.or.th/upload/download/file_9fa5ae40143e13a659403388d226efd8.pdf",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ง"
  },
  {
    keyword: "จรรยาบรรณ",
    meaning:
      "ประมวลความประพฤติที่ผู้ประกอบอาชีพการงานแต่ละอย่างกำหนดขึ้น เพื่อรักษาและส่งเสริมเกียรติคุณชื่อเสียงและฐานะของสมาชิก อาจเขียนเป็นลายลักษณ์อักษรหรือไม่ก็ได้",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. จรรยาบรรณ. 21 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "จ"
  },
  {
    keyword: "จรรยาบรรณสื่อ",
    meaning:
      "ประมวลความประพฤติที่ผู้ประกอบอาชีพการงานแต่ละอย่างกำหนดขึ้น เพื่อรักษาและส่งเสริมเกียรติคุณชื่อเสียงและฐานะของสมาชิก อาจเขียนเป็นลายลักษณ์อักษรหรือไม่ก็ได้",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. จรรยาบรรณ. 21 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "จ"
  },
  {
    keyword: "จราจรอัจฉริยะ",
    meaning:
      "ระบบด้านจราจรและขนส่งที่เกิดจากการนำเอาเทคโนโลยีด้านสารสนเทศและการสื่อสารโทรคมนาคมมาช่วยปรับปรุงหรือเพิ่มประสิทธิภาพในด้านต่างๆให้ดียิ่งขึ้น ช่วยลดระยะเวลาที่สูญเสียไปในการเดินทาง ลดอุบัติเหตุ หรือเพิ่มความสะดวกสบายในการเดินทาง",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์. (2556). Intelligent Transport System (ITS), 18 กรกฎาคม 2562. https://www.etda.or.th/terminology-detail/1629.html",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "จ"
  },
  {
    keyword: "จริยธรรม",
    meaning: "ธรรมที่เป็นข้อประพฤติปฏิบัติ, ศีลธรรม, กฎศีลธรรม",
    source:
      "พจนานุกรม ฉบับราชบัณฑิตยสถาน พ.ศ. 2554. จริยธรรม, 29 สิงหาคม 2562. \r\nhttp://www.royin.go.th/dictionary/",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "จ"
  },
  {
    keyword:
      "จังหวัดที่มีผลิตภัณฑ์มวลรวมต่อคนต่อปี (Gross Provincial Product Per Capita)",
    meaning:
      "มูลค่าของสินค้าและบริการขั้นสุดท้ายที่ผลิตได้จากการประกอบการในขอบเขตพื้นที่จังหวัดในรอบระยะเวลาหนึ่ง",
    source:
      "อภิชัย ธรรมเสริมสุข สำนักบัญชีประชาชาติ สนง. คณะกรรมการพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. (2558). การจัดทำข้อมูลGDP/GPPและการวิเคราะห์เศรษฐกิจ, 23 ธันวาคม 2562.\r\nhttp://www.industry.go.th/psd/index.php/2016-05-02-05-17-59/item/download/209_aa0b78e4f11b8a50b4a57417db2f80d9",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "จ"
  },
  {
    keyword: "จังหวัดพันธุ์ใหม่",
    meaning:
      "การพัฒนาจังหวัดที่มีความคล่องตัวในการบริหารระบบงาน ระบบเงิน และระบบกำลังคน ",
    source:
      "สำนักงานคณะกรรมการพัฒนาระบบราชการ. (2562). หลักการและเหตุผล และแนวคิดของจังหวัดพันธุ์ใหม่ที่มีความคล่องตัวในการบริหารระบบงาน ระบบเงินและระบบกำลังคน, 16 ตุลาคม 2562. https://dmcrth.dmcr.go.th/attachment/nw/download.php?WP=rUqjoz00qmAZG22DM7y04TyerPMjZ20kqmMZZz1CM5O0hJatrTDo7o3Q",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "จ"
  },
  {
    keyword: "จัดเก็บภาษีกึ่งอิสระ (Semi-autonomous Revenue Agency: SARA)",
    meaning:
      "การให้ความเป็นอิสระจากกระทรวงการคลังในการดำเนินการด้านงบประมาณ การบริหารการเงิน การบริหารบุคลากร รวมทั้งการให้มีสถานะเป็นหน่วยงานที่มีกฎหมายรองรับ",
    source:
      "ร้อยโท บรรชัย พุฑฒิบัณฑิต กระทรวงการต่างประเทศ. (2561). หน่วยงานจัดเก็บภาษีกึ่งอิสระ ตอบโจทย์ประเทศไทยหรือไม่, 11 กันยายน 2562. http://www.mfa.go.th/dvifa/contents/filemanager/files/nbt/nbt10/IS/10005.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "จ"
  },
  {
    keyword: "จัดการบริหารน้ำเชิงลุ่มน้ำอย่างมีธรรมาภิบาล",
    meaning:
      " แนวทางการบริหารจัดการทรัพยากรน้ำแบบผสมผสาน (Integrated Water Resources Management : IWRM) โดยได้มีการจัดตั้งหน่วยงานที่รับผิดชอบ จัดทำนโยบายด้านการบริหารจัดการทรัพยากรน้ำ รวมถึงการปฏิรูปกฎหมายที่เกี่ยวข้อง เพื่อทำให้เกิดสภาพแวดล้อมที่เอื้ออำนวย (Enabling Environment) ต่อการบริหารจัดการอย่างมีธรรมาภิบาล",
    source:
      "กรมส่งเสริมคุณภาพสิ่งแวดล้อม. การจัดการน้ำ, 20 พฤศจิกายน 2562. http://actionforclimate.deqp.go.th/?p=6706",
    sappear: 5,
    mappear: 19,
    rappear: "",
    firstalpha: "จ"
  },
  {
    keyword: "จัดตั้งเขตสุขภาพ",
    meaning:
      "กระทรวงสาธารณสุข ได้เริ่มทดลองการดำเนินงานปรับรูปแบบการจัดบริการและการบริหารจัดการในลักษณะเขตสุขภาพ ในปี 2556 โดยแบ่งเป็น 12 เขต แต่ละเขตครอบคลุม 4-8 จังหวัด ประชากร 4-6 ล้านคน เพื่อให้มีขนาดที่เหมาะสม (Economy of scale) ในการจัดระบบการบริการสุขภาพในเขตพื้นที่ได้ตรงกับปัญหาสุขภาพในพื้นที่ เอื้อต่อการพัฒนาระบบส่งต่อ โดยมุ่งหวังเพิ่มการเข้าถึงบริการที่มีคุณภาพ และเพิ่มประสิทธิภาพการบริหารจัดการ รวมทั้งมีการกระจายอำนาจการบริหารจัดการจากส่วนกลางไปสู่ส่วนภูมิภาค ด้วยการมอบอำนาจเชิงปฏิบัติการให้ผู้ตรวจราชการเขต ผ่านการกำหนดตัวชี้วัด และกำกับติดตามการนำนโยบายสู่การปฏิบัติระดับเขต",
    source:
      "คณะทำงานพัฒนารูปแบบการจัดตั้งเขตสุขภาพเพื่อประชาชน สำนักงานคณะกรรมการสุขภาพแห่งชาติ. (2558). รูปแบบการจัดตั้งเขตสุขภาพเพื่อประชาชน, 12 กันยายน 2562. https://www.nationalhealth.or.th/sites/default/files/upload_files/60_01_15_8475.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "จ"
  },
  {
    keyword: "จัดทำกฎหมาย",
    meaning:
      "การจัดทำและพิจารณาร่างกฎหมายเพื่อให้มีกฎหมายขึ้นใหม่ ยกเลิก ปรับปรุง หรือแก้ไขเพิ่มเติมกฎหมาย",
    source:
      "พระราชบัญญัติหลักเกณฑ์การจัดทำร่างกฎหมายและการประเมินผลสัมฤทธิ์ของกฎหมาย พ.ศ. 2562. (2562, 31 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136  ตอนที่ 72 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/072/T_0001.PDF\r\n",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "จ"
  },
  {
    keyword: "จัดทำพระราชบัญญัติระบบสุขภาพปฐมภูมิและกฏหมายลูก",
    meaning:
      "กระทรวงสาธารณสุขได้มีการจัดทำแผนยุทธศาสตร์ชาติ ระยะ 20 ปี (ด้านสาธารณสุข) เพื่อเป็นกรอบแนวทางในการดำเนินงานของหน่วยงานด้านสาธารณสุข โดยมีการกำหนดเป้าหมาย ให้ประชาชนสุขภาพดี เจ้าหน้าที่มีความสุข ระบบสุขภาพยั่งยืน และมีการกำหนดยุทธศาสตร์สำคัญไว้ 4 ยุทธศาสตร์ คือ 1) ส่งเสริมสุขภาพ ป้องกันโรค และคุ้มครองผู้บริโภคเป็นเลิศ (Promotion, Prevention & Protection Excellence) 2) บริการเป็นเลิศ (Service Excellence) 3) บุคลากรเป็นเลิศ (People Excellence) และ 4) บริหารเป็นเลิศด้วยธรรมาภิบาล (Governance Excellence)\r\n\r\n",
    source:
      "กลุ่มงานคณะกรรมาธิการการสาธารณสุข สำนักกรรมาธิการ 3 สำนักงานเลขาธิการวุฒิสภา ปฏิบัติหน้าที่สำนักงานเลขาธิการสภานิติบัญญัติแห่งชาติ. (2561). สรุปผลการดำเนินงานคณะกรรมาธิการการสาธารณสุข, 12 กันยายน 2562. https://www.senate.go.th/assets/portals/28/fileups/146/files/%E0%B8%AA%E0%B8%A3%E0%B8%B8%E0%B8%9B%E0%B8%9C%E0%B8%A5%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%94%E0%B8%B3%E0%B9%80%E0%B8%99%E0%B8%B4%E0%B8%99%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B8%84%E0%B8%93%E0%B8%B0%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B8%B2%E0%B8%98%E0%B8%B4%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%AA%E0%B8%B2%E0%B8%98%E0%B8%B2%E0%B8%A3%E0%B8%93%E0%B8%AA%E0%B8%B8%E0%B8%82%20%E0%B8%9B%E0%B8%B5%E0%B8%97%E0%B8%B5%E0%B9%88%204.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "จ"
  },
  {
    keyword: "จัดบริการร่วม (Shared Service)",
    meaning:
      "เครื่องมือทางธุรกิจที่เหมาะสำหรับกระบวนการทำงานขององค์กรขนาดใหญ่ที่มีบริษัทในเครือเป็นจำนวนมาก และงานบางลักษณะมีกระบวนการทำงานที่ซ้ำๆกัน และไม่ได้เป็นธุรกิจหลัก",
    source:
      "นางสาวศศิ อ่วมเพ็ง คณะพาณิชยศาสตร์และการบัญชี มหาวิทยาลัยธรรมศาสตร์. (2558). ปัจจัยที่มีอิทธิพลต่อความตั้งใจลาออกของพนักงานระดับบังคับบัญชา สำนักงานบัญชีกลาง บริษัท ปูนซิเมนต์ไทยจำกัด (มหาชน), 9 กันยายน 2562. http://ethesisarchive.library.tu.ac.th/thesis/2015/TU_2015_5702030064_3548_1896.pdf\r\n",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "จ"
  },
  {
    keyword: "จารีตประเพณี",
    meaning:
      "จารีตประเพณี คือประเพณีที่สังคมถือว่าถ้าใครในสังคมฝ่าฝืนหรืองดเว้นไม่กระทำตาม ถือว่าเป็นความผิดความชั่วจารีตประเพณีเป็นจรรยาและศีลธรรมของสังคม ",
    source:
      "สำนักงานราชบัณฑิตยสภา. ประเพณี. 30 สิงหาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B9%80%E0%B8%\r\n9E%E0%B8%93%E0%B8%B5-%E0%B9%92%E0%B9%91-%E0%B9%80%E0%B8%A1%E0%B8%A9%E0%\r\nB8%B2%E0%B8%A2%E0%B8%99-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%94",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "จ"
  },
  {
    keyword: "จำเลย",
    meaning: "บุคคลซึ่งถูกฟ้องยังศาลแล้วโดยข้อหาว่าได้กระทำความผิด",
    source:
      "พระราชบัญญัติประมวลกฎหมายวิธีพิจารณาความอาญา พ.ศ. 2477 และที่แก้ไขเพิ่มเติม.http://www.krisdika.go.th/librarian/get?sysid=570066&ext=pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "จ"
  },
  {
    keyword: "จำนวนเมืองขนาดกลางที่ได้รับการพัฒนา",
    meaning:
      "เมืองขนาดกลาง หมายถึง “เมือง (หรือจังหวัด) ที่มีขนาดจำนวนประชากรประมาณ 2 แสนถึง 1 ล้านคน และมีอัตราการเติบโตของผลิตภัณฑ์มวลรวมระดับจังหวัดเฉลี่ยสะสมต่อปีเป็นระยะเวลา 5 ปี ประมาณร้อยละ 2” ซึ่งเมืองเหล่านี้มีการพัฒนาด้วยการลงทุนเพื่อพัฒนาโครงสร้างพื้นฐานและบริการสาธารณะในพื้นที่ อาทิ ระบบขนส่งมวลชน โครงการที่อยู่อาศัย ระบบโทรคมนาคมและการสื่อสาร โรงเรียน โรงพยาบาล\r\n\r\nซึ่งแผนแม่บทภายใต้ยุทธศาสตร์ชาติ ประเด็น พื้นที่และเมืองน่าอยู่อัจฉริยะ (พ.ศ. 2561 - 2580) กำหนดให้เมืองหรือจังหวัดเป้าหมาย ได้แก่ เชียงราย กาญจนบุรี พระนครศรีอยุธยา พิษณุโลก นครราชสีมา หนองคาย มุกดาหาร สุราษฎร์ธานี น่าน อุดรธานี อุบลราชธานี บุรีรัมย์ นครสวรรค์ สระบุรี ร้อยเอ็ด สกลนคร กระบี่ ยะลา ราชบุรี ลำปาง",
    source:
      "รายงานผลการสำรวจและศึกษาวิจัย ซีรีส์ความรู้ส่องโอกาส สร่างอาชีพ เรื่องการขยายตัวของความเป็นเมือง (Urbanization)  โดยสำนักงานบริหารและพัฒนาองค์ความรู้ ร่วมกับ บริษัท ดิวันโอวัน เปอร์เซ็นต์ จำกัด (2560, 30 มีนาคม) . 4 ธันวาคม 2562. https://thematter.co/thinkers/urbanization-trend/21171)",
    sappear: "",
    mappear: 6,
    rappear: "",
    firstalpha: "จ"
  },
  {
    keyword: "จำนวนเมืองคุณภาพสิ่งแวดล้อมภายในเมืองอยู่ในเกณฑ์มาตรฐาน",
    meaning:
      "เมืองคุณภาพสิ่งแวดล้อม หมายถึง “เมืองสิ่งแวดล้อมยั่งยืน” ซึ่งประกอบด้วย 4 องค์ประกอบสำคัญ คือ เมืองอยู่ดี คนมีสุข สิ่งแวดล้อมยั่งยืน และเทศบาลแห่งการเรียนรู้และการบริหารจัดการที่ดี ได้แก่ 1. เมืองอยู่ดี  มีการใช้ประโยชน์ที่ดินอย่างเหมาะสม โครงสร้างพื้นฐานเพียงพอสำหรับคนทุกกลุ่ม มีความมั่นคงด้านที่อยู่อาศัย ปลอดภัย และเศรษฐกิจมั่นคง\r\n2. คนมีสุข คนมีสุขภาพดี ได้รับการศึกษา สวัสดิการ และการพิทักษ์สิทธิ์ ที่เหมาะสมและเท่าเทียม ครอบครัวอบอุ่น ชุมชนเอื้ออาทร มีกิจกรรมสร้างสรรค์ สังคมดำรงประเพณี วัฒนธรรม และภูมิปัญญาท้องถิ่น\r\n3. สิ่งแวดล้อมยั่งยืน ทรัพยากรธรรมชาติมีความสมบูรณ์ มีพื้นที่สีเขียวเพียงพอ ภูมิทัศน์สวยงาม \r\nของเสียหรือมลพิษได้รับการจัดการอย่างเหมาะสม และประชาชนมีวิถีชีวิตที่เป็นมิตรกับ สิ่งแวดล้อม\r\n4. เทศบาลแห่งการเรียนรู้และการบริหารจัดการที่ดี มีวิสัยทัศน์และแผนงาน ชัดเจน บุคลากรมี\r\nความรอบรู้และเชี่ยวชาญ ระบบการทำงานได้รับการพัฒนาอย่างต่อเนื่อง พร้อมการบริหารจัดการที่ดี และมีนวัตกรรมการพัฒนาเมือง\r\nจำนวนเมืองคุณภาพสิ่งแวดล้อม คือ จำนวนเมืองที่ได้รับการประเมินเมืองสิ่งแวดล้อมยั่งยืนและได้รับคะแนนไม่น้อยกว่าร้อยละ 70\r\n",
    source:
      "กรมส่งเสริมคุณภาพสิ่งแวดล้อม กระทรวงทรัพยากรธรรมชาติและสิ่งแวดล้อม. คู่มือการประเมินเมืองสิ่งแวดล้อมยั่งยืน ประจำปี 2561. 4 ธันวาคม 2562. https://www.deqp.go.th/media/878323/greencity61.pdf ",
    sappear: "",
    mappear: 6,
    rappear: "",
    firstalpha: "จ"
  },
  {
    keyword: "จำนวนเมืองที่ได้รับการพัฒนาเมืองให้เป็นเมืองอัจฉริยะ",
    meaning:
      "เมืองอัจฉริยะ หมายถึง “เมืองที่ใช้ประโยชน์จากเทคโนโลยีและนวัตกรรมที่ทันสมัยและชาญฉลาด เพื่อเพิ่มประสิทธิภาพของการให้บริการและการบริหารจัดการเมือง ลดค่าใช้จ่ายและการใช้ทรัพยากรของเมืองและประชากรเป้าหมาย โดยเน้นการออกแบบที่ดี และการมีส่วนร่วมของภาคธุรกิจและภาคประชาชนในการพัฒนาเมือง ภายใต้แนวคิดการพัฒนา เมืองน่าอยู่ เมืองทันสมัย ให้ประชาชนในเมืองมีคุณภาพชีวิตที่ดี มีความสุขอย่างยั่งยืน” \r\n\r\nขณะที่ จำนวนเมืองทีได้รับการรับรองโดยคณะกรรมการขับเคลื่อนการพัฒนาเมืองอัจฉริยะและได้รับตราสัญลักษณ์เมืองอัจฉริยะ",
    source:
      "สำนักงานเมืองอัจฉริยะประเทศไทย. 4 ธันวาคม 2562. https://www.smartcitythailand.or.th/",
    sappear: "",
    mappear: 6,
    rappear: "",
    firstalpha: "จ"
  },
  {
    keyword:
      "จำนวนเมืองศูนย์กลางทางเศรษฐกิจที่มีการพัฒนาศูนย์เศรษฐกิจ แหล่งที่อยู่อาศัยและพื้นที่เฉพาะ",
    meaning:
      "“เมือง (หรือจังหวัด) ที่มีขนาดจำนวนประชากรมากกว่า \r\n1 ล้านคน และมีอัตราการเติบโตของผลิตภัณฑ์มวลรวมระดับจังหวัดเฉลี่ยสะสมต่อปีเป็นระยะเวลา \r\n5 ปี สูงกว่าร้อยละ 4” ซึ่งเมืองเหล่านี้เป็นพื้นที่เป้าหมายในการพัฒนาโครงสร้างพื้นฐานและบริการสาธารณะในพื้นที่ อาทิ ระบบขนส่งมวลชน โครงการที่อยู่อาศัย ระบบโทรคมนาคมและการสื่อสาร โรงเรียน โรงพยาบาล\r\n\r\nซึ่งแผนแม่บทภายใต้ยุทธศาสตร์ชาติ ประเด็น พื้นที่และเมืองน่าอยู่อัจฉริยะ (พ.ศ. 2561 - 2580) กำหนดให้เมืองหรือจังหวัดเป้าหมาย ได้แก่ พื้นที่กรุงเทพและปริมณฑล เชียงใหม่ ขอนแก่น สงขลา ภูเก็ต และพื้นที่เขตพัฒนาพิเศษภาคตะวันออก \r\n",
    source:
      "รายงานผลการสำรวจและศึกษาวิจัย ซีรีส์ความรู้ส่องโอกาส สร่างอาชีพ เรื่องการขยายตัวของความเป็นเมือง (Urbanization)  โดยสำนักงานบริหารและพัฒนาองค์ความรู้ ร่วมกับ บริษัท ดิวันโอวัน เปอร์เซ็นต์ จำกัด (2560, 30 มีนาคม) . 4 ธันวาคม 2562. https://thematter.co/thinkers/urbanization-trend/21171)",
    sappear: "",
    mappear: 6,
    rappear: "",
    firstalpha: "จ"
  },
  {
    keyword: "จำนวนท่าเรือท่องเที่ยวในประเทศไทย",
    meaning:
      "ดำเนินการรวบรวมข้อมูลรายละเอียดเกี่ยวกับท่าเทียบเรือทั่วประเทศไทยที่กรมเจ้าท่าเป็นผู้ดำเนินการก่อสร้าง สำหรับใช้เป็นข้อมูลประกอบการตัดสินใจในการวางแผน กำหนดนโยบาย และแก้ปัญหาในการพัฒนาท่าเรือและเส้นทางคมนาคมขนส่งทางน้ำให้สมบูรณ์ยิ่งขึ้น และเพื่อเผยแพร่ข้อมูลให้แก่หน่วยงานที่เกี่ยวข้องและผู้สนใจทั่วไป",
    source:
      "กรมเจ้าท่า. (2562). รายงานท่าเทียบเรือที่กรมเจ้าท่าดำเนินการก่อสร้างแล้วเสร็จ ณ ปี งบประมาณ 2562, 25 กรกฎาคม 2562. https://md.go.th/stat/images/pdf_report_stat/2562/report_port_MD_build2562.pdf",
    sappear: "",
    mappear: 5,
    rappear: "",
    firstalpha: "จ"
  },
  {
    keyword: "จำนวนธุรกิจที่เป็นวิสาหกิจเพื่อสังคม",
    meaning:
      "การสำรวจความต้องการของวิสาหกิจเพื่อสังคมที่ได้รับการขึ้นทะเบียนวิสาหกิจเพื่อสังคมจากสำนักงานสร้างเสริมกิจการเพื่อสังคมแห่งชาติ (สกส.) จำนวน 101 ราย พบว่าส่วนใหญ่ต้องการได้รับการสนับสนุนส่งเสริม 7 ประการ ประกอบด้วย \r\n1) การผสานแนวคิดและความรู้ด้านนวัตกรรมทางสังคมในระบบการศึกษา \r\n2) การฝึกอบรมและพัฒนาทักษะของผู้ประกอบการเพื่อสังคม \r\n3) ระบบการจดทะเบียนและกฎระเบียบของกิจการเพื่อสังคม \r\n4) ระบบการสื่อสารส่งเสริมช่องทางการตลาด \r\n5) ระบบการจัดซื้อจัดจ้างสินค้าและบริการจากกิจการเพื่อสังคม \r\n6) ระบบการลดหย่อนภาษีเพื่อการลงทุนในวิสาหกิจเพื่อสังคม \r\n7) สนามการลงทุนเพื่อสังคม \r\n",
    source:
      "กองส่งเสริมธุรกิจชุมชน กรมพัฒนาธุรกิจการค้า กระทรวงพาณิชย์. (2560). วิสาหกิจเพื่อสังคมกับบทบาทที่เหนือกว่าการเป็นผู้ให้, 19 กันยายน 2562. http://www.dbd.go.th/ewt_news.php%3Fnid%3D469405193%26filename%3Dindex+&cd=3&hl=th&ct=clnk&gl=th",
    sappear: "",
    mappear: 10,
    rappear: "",
    firstalpha: "จ"
  },
  {
    keyword: "จิตสาธารณะ",
    meaning:
      " จิตสาธารณะ  ประกอบด้วยคำว่า จิต กับ สาธารณะ.  จิต หมายถึง ใจ หรือสิ่งที่ทำหน้าที่คิด นึก และรู้.  สาธารณะ หมายถึง ทั่วไป เพื่อประชาชนทั่วไป จิตสาธารณะ หมายถึง สำนึกหรือความคิดที่จะทำสิ่งที่เป็นประโยชน์ให้แก่สังคม หรือคนทั่วไป",
    source:
      "สำนักงานราชบัณฑิตยสภา. จิตสาธารณะ. 19 มิถุนายน 2562.\r\nhttp://www.royin.go.th/?knowledges=%E0%B8%88%E0%B8%B4%E0%B8%95%E0%B8%AA%E0%B8%B2%E0%B8%98%E0%B8%B2%E0%B8%A3%E0%B8%93%E0%B8%B0-%E0%B9%99-%E0%B8%A1%E0%B8%81%E0%B8%A3%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%94",
    sappear: "1,3",
    mappear: 1,
    rappear: 1,
    firstalpha: "จ"
  },
  {
    keyword: "จิตอาสา",
    meaning:
      "ความสำนึกของบุคคลที่มีต่อส่วนรวม เป็นจิตที่เป็นผู้ให้ คิดดี คิดทางบวกมีความหวังดีต่อผู้อื่น เป็นความสมัครใจ เต็มใจ ตั้งใจทำ อยากช่วยเหลือ โดยไม่หวังผลตอบแทน และส่งผลให้เกิดความสุขทางจิตใจ ผู้ที่มีจิตสาธารณะจะแสดงพฤติกรรมที่อาสาทำประโยชน์เพื่อส่วนรวม การงดเว้นการกระทำที่จะส่งผลให้เกิดความชำรุดเสียหาย การมีส่วนร่วมดูแลรักษาและเคารพสิทธิของบุคคลอื่นในการใช้ทรัพย์สินส่วนรวม",
    source:
      "สารานุกรมวิชาชีพครู เฉลิมพระเกียรติ พระบาทสมเด็จพระเจ้าอยู่หัว เนื่องในโอกาสพระราชพิธีมหามงคลเฉลิมพระชนมพรรษา 7 รอบ 5 ธันวาคม 2554. จิตอาสา. กรุงเทพฯ: สำนักงานเลขาธิการคุรุสภา. หน้า 233 - 237.\r\nhttp://www.curriculumandlearning.com/upload/Academicpapers/8_1435646596.%20%20%E0%B8%88%E0%B8%B4%E0%B8%95%E0%B8%AD%E0%B8%B2%E0%B8%AA%E0%B8%B2.pdf",
    sappear: "",
    mappear: 10,
    rappear: 9,
    firstalpha: "จ"
  },
  {
    keyword: "จุดหมายปลายทางการท่องเที่ยว",
    meaning:
      "สถานที่ซึ่งเป็นแหล่งท่องเที่ยวที่นักท่องเที่ยวเลือกเดินทางไปเยือนหรือเยี่ยมชม",
    source:
      "นายเจษฎา ขวัญเมือง และคณะ. Tourism around the world คลังคำศัพท์, 30 กรกฎาคม 2562. https://touristbuu.wordpress.com/%E0%B8%84%E0%B8%A5%E0%B8%B1%E0%B8%87%E0%B8%84%E0%B8%B3%E0%B8%A8%E0%B8%B1%E0%B8%9E%E0%B8%97%E0%B9%8C/",
    sappear: "",
    mappear: 5,
    rappear: "",
    firstalpha: "จ"
  },
  {
    keyword: "จุลภาค",
    meaning:
      "การศึกษากิจกรรมทางเศรษฐกิจของบุคคล ครัวเรือน เป็นการศึกษาเฉพาะส่วนย่อย ๆ ในระยะเวลาหนึ่ง ๆ เช่น พฤติกรรมของตลาด กลไกราคา",
    source:
      "ธนาคารแห่งประเทศไทย.เศรษฐศาสตร์เล่มเดียวอยู่.https://www.bot.or.th/Thai/ResearchAndPublications/Doc_Publication/Book_Economic2555.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "จ"
  },
  {
    keyword: "ฉลากสิ่งแวดล้อม",
    meaning:
      "ฉลากที่บ่งบอกความเป็นมิตรต่อสิ่งแวดล้อม ซึ่งมอบให้กับผลิตภัณฑ์ หรือบริการที่มีคุณสมบัติตรงตามข้อกำหนด ปัจจุบันฉลากสิ่งแวดล้อมมีอยู่หลากหลาย ทั้งที่เป็นแบบผู้ผลิตเป็นผู้ออกฉลากเอง และแบบที่ดำเนินการโดยองค์กรกลาง โดยฉลากในปัจจุบันสามารถแบ่งออกเป็น 3 ประเภท ดังนี้\r\n1. ฉลากสำหรับสินค้าหรือบริการที่ดำเนินการโดยองค์กรกลางที่ไม่มีส่วนได้ส่วนเสีย (Third Party)\r\n2. ฉลากผลิตภัณฑ์ที่ผู้ผลิตเป็นผู้ออกฉลากเอง\r\n3. ฉลากที่แสดงข้อมูลเชิงปริมาณบนพื้นฐานของการประเมินตลอดวัฏจักรของสินค้า",
    source:
      "กรมควบคุมมลพิษ. คู่มือการจัดซื้อจัดจ้างสินค้าและบริการที่เป็นมิตรกับสิ่งแวดล้อม พ.ศ. 2561, 28 มิถุนายน 2562. http://infofile.pcd.go.th/ptech/Procurement%20of%20goods%20and%20services%20Manual.pdf?CFID=2050244&CFTOKEN=63813225",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ฉ"
  },
  {
    keyword: "ฉลากสีเขียว",
    meaning:
      "ฉลากที่ติดบนสินค้าเพื่อต้องการสื่อสารให้ผู้บริโภครู้ว่า สินค้านี้ได้รับการรับรองว่าเป็นสินค้าที่มีองค์ประกอบ กระบวนการผลิต การใช้ ตลอดจนถึงการทิ้งทำลายที่มีผลกระทบต่อสิ่งแวดล้อมน้อยกว่าสินค้าประเภทเดียวกันที่ไม่ได้รับการรับรอง ",
    source:
      "สำนักงานสิ่งแวดล้อมภาคที่ 16. (2555). สินค้าฉลากเขียว, 29 มิถุนายน 2562. http://reo16.mnre.go.th/reo16/knowledge/detail/99",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ฉ"
  },
  {
    keyword: "ฉ้อราษฎร์บังหลวง",
    meaning:
      "ทุจริตเบียดบังเงินหลวง  การ “โกงประชาชน” ด้วยการใช้อำนาจโดยมิชอบและการ “โกงหลวง” ด้วยการเบียดบังของหลวงไปใช้ประโยชน์ในกิจการของตนเองหรือผู้ใกล้ชิด",
    source:
      "วีรวิท คงศักดิ์ กรรมการในคณะกรรมการปฏิรูปประเทศด้านการป้องกันและปราบปรามการทุจริตและประพฤติมิชอบ. (2551). “ฉ้อราษฎร์บังหลวง”, 24 กันยายน 2562. http://ethics.dmsc.moph.go.th/download/5%20March%2062-4.pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ฉ"
  },
  {
    keyword: "ฉันทามติ (Commitment)",
    meaning:
      "แนวปฏิบัติในการตัดสินใจที่จะมีมติดําเนินการหรือไม่ดําเนินการในเรื่องใดเรื่องหนึ่ง โดยแม้ทุกฝ่ายจะมิได้เห็นพ้องร่วมกัน แต่ก็ไม่มีผู้ใดคัดค้าน",
    source:
      "สถาบันการต่างประเทศเทวะวงศ์วโรปการกระทรวงการต่างประเทศ. (2556). คำศัพท์ – คำย่อทางการทูตและการต่างประเทศ, 11 ตุลาคม 2562. http://www.mfa.go.th/dvifa/contents/files/articles-20170626-142548-533162.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ฉ"
  },
  {
    keyword: "ฉากทัศน์ (Long-Term Scenario Planning)",
    meaning:
      "มโนภาพเกี่ยวกับสถานการณ์ในอนาคตที่มี \r\n“ความเป็นไปได้ (Probability)”",
    source:
      "สำนักงานนวัตกรรมแห่งชาติ. เครื่องมือการมองอนาคต, 11 กรกฎาคม 2562. https://ifi.nia.or.th/wp-content/uploads/2019/11/foresight_tools-2.pdf",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ฉ"
  },
  {
    keyword: "ช่อสะอาด",
    meaning:
      "สัญลักษณ์ช่อดอกไม้ ที่สะท้อนแนวคิดการส่งเสริมคุณธรรมความดีอย่างชัดเจน โดยการรวบรวมมือที่ขาวสะอาดของคนไทยทุกหมู่เหล่าเข้าไว้ด้วยกัน และประสานไว้เป็นหนึ่งเดียว ผูกด้วยโบว์สีธงชาติไทยแสดงถึงการรวมพลังไทยทำดีทุกคนเข้าไว้ด้วยกัน กลายเป็นพลังอันยิ่งใหญ่ที่แสดงออกถึงการมีส่วนร่วมที่จะสร้างค่านิยมที่ถูกต้องเหมาะสมขึ้นในสังคม ด้วยการตั้งมั่นทำความดีอย่างบริสุทธิ์และจริงใจ ไม่คดโกง ยึดถือความซื่อสัตย์สุจริตเป็นที่ตั้ง ไม่ทุจริตต่อทั้งตนเอง ผู้อื่น สังคม และประเทศชาติ",
    source:
      "สำนักงานป้องกันและปราบปรามการทุจริตแห่งชาติ. ช่อสะอาด, 11 กันยายน 2562.\r\nhttps://www.nacc.go.th/files/article/attachments/2019112115133072.pdf",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "ช"
  },
  {
    keyword: "ชันสูตร พลิกศพ",
    meaning:
      "การตรวจวิเคราะห์ทางห้องปฏิบัติการ และรวบรวมวัตถุตัวอย่างที่เกี่ยวกับเชื้อโรคหรือพิษจากสัตว์ที่เกี่ยวข้องกับกระบวนการชันสูตรพลิกศพหรือกระบวนการชันสูตรซากสัตว์ในห้องปฏิบัติการ",
    source:
      "ประกาศกระทรวงสาธารณสุขเรื่องกระบวนการวินิจฉัยโรค หรือกระบวนการชันสูตรพลิกศพที่เกี่ยวกับเชื้อโรคและพิษจากสัตว์พุทธศักราช 2560. (2560, พฤศจิกายน 24). ราชกิจจานุเบกษา. เล่ม 134 ตอนพิเศษ 289. หน้า 40. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/E/289/40.PDF",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ช"
  },
  {
    keyword: "ชาติพันธุ์",
    meaning:
      "กลุ่มที่มีพันธะเกี่ยวข้องกัน และที่แสดงเอกลักษณ์ออกมา โดยการผูกพันลักษณาการของเชื้อชาติและสัญชาติเข้าด้วยกัน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ.2542. ชาติพันธุ์. 29 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ช"
  },
  {
    keyword: "ชีวเภสัชภัณฑ์",
    meaning:
      "เป็นผลิตภัณฑ์ยาที่ผลิตขึ้นโดยใช้สิ่งมีชีวิตหรือได้จากสิ่งที่มีชีวิตโดยปัจจุบันยาชีววัตถุส่วนใหญ่ได้จากเทคโนโลยีการตัดต่อทางพันธุกรรมเพื่อสร้างดีเอ็นเอสายผสม (recombinant DNA หรือ rDNA) จากสารพันธุกรรมของสิ่งมีชีวิตต่างชนิดกัน เพื่อให้ได้โมเลกุลของ DNA ที่สามารถผลิตโปรตีนที่เหมาะสมสำหรับการพัฒนาเป็นยาสำหรับบำบัดรักษาและป้องกันโรคต่างๆ ",
    source:
      "ศูนย์การศึกษาต่อเนื่องทางเภสัชศาสตร์ สภาเภสัชกรรม. (2559). ยาชีวเภสัชภัณฑ์ (biopharmaceuticals), 9 กันยายน 2562. https://ccpe.pharmacycouncil.org/index.php?option=seminar_detail&subpage=seminar_detail&id=116",
    sappear: 2,
    mappear: 4,
    rappear: "",
    firstalpha: "ช"
  },
  {
    keyword: "ชีวมวล",
    meaning:
      "สิ่งที่ได้จากสิ่งมีชีวิตหรือสารอินทรีย์ที่สามารถเปลี่ยนเป็นพลังงานได้ โดยรวมถึงวัสดุเหลือทิ้งทางการเกษตรต่างๆ เช่น ฟางข้าว แกลบ กากอ้อย ทะลายปาล์ม เศษไม้ มูลสัตว์ ของเสียจากโรงงานอุตสาหกรรมแปรรูปผลิตผลทางการเกษตร และของเสียจากชุมชน ในที่นี้จะกล่าวเฉพาะวัสดุเหลือทิ้งทางการเกษตรเท่านั้น ",
    source:
      "กลุ่มพลังงานชีวมวล สำนักวิจัย ค้นคว้าพลังงาน กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน กระทรวงพลังงาน. พลังงานชีวมวล, 16 กันยายน 2562.  http://www2.dede.go.th/kmmf/download/%E0%B8%99%E0%B8%A7%E0%B8%B1%E0%B8%95%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1/%E0%B8%AA%E0%B8%A7%E0%B8%84/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%9E%E0%B8%A5%E0%B8%B1%E0%B8%87%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B8%8A%E0%B8%B5%E0%B8%A7%E0%B8%A1%E0%B8%A7%E0%B8%A5.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ช"
  },
  {
    keyword: "ชีววัตถุ",
    meaning:
      "ยา หรือ ผลิตภัณฑ์ทางการแพทย์ที่ผลิตจากสิ่งมีชีวิต หรือจากชิ้นส่วนของสิ่งมีชีวิตที่ไม่รวมถึงพืช เช่น ผลิตจากส่วนประกอบต่าง ๆ (เช่น จาก เลือด เซลล์ เนื้อเยื่อ) ที่ได้มาจาก คน สัตว์ จุลชีพ ",
    source:
      "ศาสตราจารย์เกียรติคุณ แพทย์หญิง พวงทอง ไกรพิบูลย์. (2559). ชีววัตถุ (Biological product), 15 กรกฎาคม 2562. http://haamor.com/th/%E0%B8%8A%E0%B8%B5%E0%B8%A7%E0%B8%A7%E0%B8%B1%E0%B8%95%E0%B8%96%E0%B8%B8/",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "ช"
  },
  {
    keyword: "ชีววิทยาสังเคราะห์",
    meaning:
      "เทคโนโลยีที่ได้พัฒนาให้มีความก้าวหน้า และเป็นมิติใหม่ของเทคโนโลยีชีวภาพสมัยใหม่ ที่ผสมผสานความรู้ทางด้านวิทยาศาสตร์ เทคโนโลยี และวิศวกรรมเพื่อส่งเสริมให้เกิดความเข้าใจที่ดียิ่งขึ้น เพื่อการออกแบบ การปรับปรุงแก้ไข การผลิต และ/หรือ ดัดแปลงสารพันธุกรรม สิ่งมีชีวิต หรือระบบทางชีววิทยาได้",
    source:
      "คณะกรรมการเทคนิคด้านความปลอดภัยทางชีวภาพ ศูนย์พันธุวิศวกรรมและเทคโนโลยีชีวภาพแห่งชาติสำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ. (2559). แนวทางปฏิบัติเพื่อความปลอดภัยทางชีวภาพสำหรับการดำเนินงานด้านเทคโนโลยีชีวภาพสมัยใหม่, 1 ตุลาคม 2562. \r\nhttps://www.nrms.go.th/FileUpload/AttatchFile/News/256009221248565794475.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ช"
  },
  {
    keyword: "ชุมชนเป็นฐาน",
    meaning:
      "มุ่งทำงานกับชุมชนชนบทที่มีโครงสร้างการบริหารงานท้องถิ่นที่มีผู้มีส่วนได้ส่วนเสียจำนวนมาก ให้เข้ามามีส่วนร่วมดำเนินการด้วยความรู้สึกเป็นเจ้าของชุมชน โดยให้ชุมชนเป็นผู้ดำเนินการและเป็นผู้รับประโยชน์ด้วยกระบวนการมีส่วนร่วมในการแก้ปัญหาตั้งแต่ขั้นเข้าใจปัญหา วางแผนและออกแบบกิจกรรม ดำเนินการ และติดตามกำกับ มากกว่านั้นยังกระตุ้นให้ใช่แนวคิดพึ่งตนเองและวัฒนธรรมชุมชน",
    source:
      'คณะสาธารณสุขศาสตร์ มหาวิทยาลัยมหิดล และ สำนักงานกองทุนสนับสนุนการสร้างเสริมสุขภาพ. (2557). บันทึกไว้ "เป็นบทเรียน" การควบคุมบุหรี่ (มวนเองหรือยาเส้น) โดยใช้ชุมชนเป็นฐาน, 24 ธันวาคม 2562. http://resource.thaihealth.or.th/library/hot/15289',
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "ช"
  },
  {
    keyword: "ซัลเฟอร์",
    meaning:
      "เป็นสารที่อาจลุกติดไฟและระเบิดอย่างรุนแรงขณะเกิดลุกไหม้ได้ แต่หากหายใจรับสารซัลเฟอร์เข้าไป จะก่อให้เกิดการระคายเคือง ไอ เจ็บคอ ปวดศีรษะ หากสัมผัสผิวหนัง ทำให้แสบไหม้อย่างรุนแรง หากกลืนกินจะทำลายระบบ ทางเดินอาหาร ถูกตาจะระคายเคือง ตาแดง ปวดตา และยังส่งผลกระทบต่อสิ่งแวดล้อม",
    source:
      'สำนักงานคณะกรรมการอาหารและยา กระทรวงสาธารณสุข. "ซัลเฟอร์" วัตถุอันตราย, 26 กันยายน 2562. http://elib.fda.moph.go.th/library/default.asp?page2=subdetail&id=21781',
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ซ"
  },
  {
    keyword: "ฎีกา",
    meaning:
      "การคัดค้านคําพิพากษาหรือคําสั่งศาลอุทธรณ์ที่คู่ความยื่นต่อศาลชั้นต้น เพื่อเสนอให้ศาลฎีกาพิจารณาพิพากษาหรือวินิจฉัย\r\nชี้ขาด",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2556). ฎีกา, 18 กรกฎาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%8E%E0%B8%B5%E0%B8%81%E0%B8%B2-%E0%B9%94-%E0%B9%80%E0%B8%A1%E0%B8%A9%E0%B8%B2%E0%B8%A2%E0%B8%99-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%96",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ฎ"
  },
  {
    keyword: "ฐานข้อมูลสมุนไพร (Big Data)",
    meaning:
      "การบูรณาการการเชื่อมโยงข้อมูลสมุนไพรระหว่างสองหน่วยงาน อีกทั้งยังเป็นการอำนวยความสะดวกให้ผู้ใช้บริการ สามารถเข้าถึงแหล่งข้อมูลได้ง่ายขึ้นและตรงตามความต้องการยิ่งขึ้นต่อไป",
    source:
      'กรมส่งเสริมการค้าระหว่างประเทศ. (2562). DITP เตรียมจัดกิจกรรมนำผู้ซื้อ ผู้นำเข้า เจรจาซื้อขาย "สมุนไพร" ในไทย, 22 ตุลาคม2562. https://gnews.apps.go.th/static/file/35/34262/%E0%B8%88%E0%B8%B1%E0%B8%9A%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%AA%E0%B8%A1%E0%B8%B8%E0%B8%99%E0%B9%84%E0%B8%9E%E0%B8%A3.docx',
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ฐ"
  },
  {
    keyword: "ฐานสมรรถนะ",
    meaning:
      "หลักสูตรฐานสมรรถนะเป็นแนวทางในการปฏิรูปหลักสูตรและการจัดการเรียนการสอนเพื่อมุ่งตอบสนองการเปลี่ยนแปลงในศตวรรษที่ 21 โดยมีเป้าหมายให้ผู้เรียนเกิดสมรรถนะหลักที่จำเป็นสำหรับการทำงาน การแก้ปัญหา และการดำรงชีวิต ประกอบด้วย 10 สมรรถนะหลักที่สำคัญ คือ สมรรถนะที่ 1. ภาษาไทยเพื่อการสื่อสาร (Thai Language for Communication) สมรรถนะที่ 2. คณิตศาสตร์ในชีวิตประจำวัน (Mathematics in Everyday Life) สมรรถนะที่ 3. การสืบสอบทางวิทยาศาสตร์และจิตวิทยาศาสตร์ (Scientific Inquiry and Scientific Mind) สมรรถนะที่ 4. ภาษาอังกฤษเพื่อการสื่อสาร (English for Communication) สมรรถนะที่ 5. ทักษะชีวิตและความเจริญแห่งตน (Life Skills and Personal Growth) สมรรถนะที่ 6. ทักษะอาชีพและการเป็นผู้ประกอบการ (Career Skills and Entrepreneurship) สมรรถนะที่ 7.  ทักษะการคิดขั้นสูงและนวัตกรรม (Higher-order Thinking Skills and Innovation) สมรรถนะที่ 8. การรู้เท่าทันสื่อ สารสนเทศ และดิจิทัล (Media,Information and Digital Literacy) สมรรถนะที่ 9. การทำงานแบบรวมพลังเป็นทีม และภาวะผู้นำ (Collaboration, Teamwork and Leadership) สมรรถนะที่ 10. พลเมืองตื่นรู้และสำนึกสากล (Active Citizen and Global Mindedness) ",
    source:
      "กระทรวงศึกษาธิการ. (2562). ทำไมต้อง..หลักสูตรฐานสมรรถนะ, 7 สิงหาคม 2562. https://www.moe.go.th/moe/th/news/detail.php?NewsID=54320&Key=news2",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "ฐ"
  },
  {
    keyword: "ดัชนีการเปลี่ยนแปลงราคาและปริมาณบริการ",
    meaning:
      "ตัวชี้วัดการเปลี่ยนแปลงของราคาสินค้า และบริการโดยเฉลี่ยที่ผู้บริโภคจ่ายไปสำหรับกลุ่มสินค้าและบริการที่กำหนดหรือมีจำเพาะ",
    source:
      "กระทรวงพาณิชย์. (2559). ดัชนีราคาผู้บริโภคทั่วไปและดัชนีราคาผู้บริโภคพื้นฐานของประเทศ, 9 กันยายน 2562. http://www.indexpr.moc.go.th/price_present/cpi/data/index_47.asp?list_month=01&list_year=2559&list_region=country",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีการพัฒนามนุษย์",
    meaning:
      "ดัชนีที่บ่งบอกถึงการพัฒนาใน 3 ด้าน ได้แก่ ด้านสุขภาพ (วัดจาก Life Expectancy หรืออายุขัยโดยเฉลี่ยของประชากร) ด้านการศึกษา (วัดจาก Adult Literacy rate หรืออัตราการอ่านออกเขียนได้ และ การเข้าชั้นเรียนโดยเฉลี่ย) ด้านเศรษฐกิจ (วัดจากผลิตภัณฑ์มวลรวมประชาชาติ หรือ GDP โดยแปรค่าแบบ PPP) ทั้ง 3 ตัวชี้วัดนี้นำมาประกอบเป็นดัชนีการพัฒนามนุษย์ โดยค่า HDI จะมีค่าระหว่าง 0 ถึง 1 ซึ่งการพัฒนามนุษย์นั้นถือเป็นปัจจัยที่สำคัญในการสร้างความก้าวหน้าและมั่นคงให้แต่ละประเทศ และยังถือเป็นหนึ่งในประเด็นของเสาหลักประคมสังคมและวัฒนธรรมอีกด้วย",
    source:
      "กลุ่มประสานและติดตามสารสนเทศ ศูนย์สารสนเทศยุทธศาสตร์ภาครัฐ สำนักงานสถิติแห่งชาติ. (2562). ดัชนีการพัฒนามนุษย์ของกลุ่มประเทศอาเซียน (Human Development Index : HDI), 18 กรกฎาคม 2562. สืบค้นจากhttp://www.nic.go.th/%E0%B8%82%E0%B9%89%E0%B8%AD%E0%B8%A1%E0%B8%B9%E0%B8%A5%E0%B8%95%E0%B8%B1%E0%B8%A7%E0%B8%8A%E0%B8%B5%E0%B9%89%E0%B8%A7%E0%B8%B1%E0%B8%94/364-%E0%B8%94%E0%B8%B1%E0%B8%8A%E0%B8%99%E0%B8%B5%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%9E%E0%B8%B1%E0%B8%92%E0%B8%99%E0%B8%B2%E0%B8%A1%E0%B8%99%E0%B8%B8%E0%B8%A9%E0%B8%A2%E0%B9%8C%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B8%81%E0%B8%A5%E0%B8%B8%E0%B9%88%E0%B8%A1%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B9%80%E0%B8%97%E0%B8%A8%E0%B8%AD%E0%B8%B2%E0%B9%80%E0%B8%8B%E0%B8%B5%E0%B8%A2%E0%B8%99-human-development-index-hdi.html",
    sappear: 3,
    mappear: 11,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีการพัฒนาอย่างทั่วถึง",
    meaning:
      "ดัชนีชี้วัดว่าแต่ละประเทศมีการพัฒนาเศรษฐกิจแบบกระจายความมั่งคั่งได้ดีในระดับใด",
    source:
      "ขวัญใจ เตชเสนสกุล ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย (EXIM BANK). Inclusive Development Index…ดัชนีตัวใหม่ที่ใช้ชี้วัดระดับการพัฒนาอย่างทั่วถึง, 16 ธันวาคม. https://www.exim.go.th/getattachment/a74387de-540f-4277-adfc-aab1b05a4472/Inclusive-Development-Index%E2%80%A6%E0%B8%94%E0%B8%8A%E0%B8%99%E0%B8%95%E0%B8%A7%E0%B9%83%E0%B8%AB%E0%B8%A1%E0%B8%97%E0%B9%83%E0%B8%8A%E0%B8%8A%E0%B8%A7%E0%B8%94%E0%B8%A3%E0%B8%B0%E0%B8%94%E0%B8%9A%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%9E%E0%B8%92%E0%B8%99%E0%B8%B2%E0%B8%AD%E0%B8%A2%E0%B8%B2%E0%B8%87%E0%B8%97%E0%B8%A7%E0%B8%96%E0%B8%87-%E0%B8%A7%E0%B8%B2%E0%B8%A3%E0%B8%AA%E0%B8%B2%E0%B8%A3%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%87%E0%B8%99%E0%B8%98%E0%B8%99%E0%B8%B2%E0%B8%84%E0%B8%B2%E0%B8%A3-%E0%B8%89%E0%B8%9A%E0%B8%9A%E0%B9%80%E0%B8%94%E0%B8%AD%E0%B8%99%E0%B8%A1%E0%B8%99%E0%B8%B2%E0%B8%84%E0%B8%A1-2561.aspx",
    sappear: "",
    mappear: 16,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีการรับรู้การทุจริตของประเทศไทย",
    meaning:
      "องค์กรเพื่อความโปร่งใสนานาชาติ (Transparency International: TI) มีฐานะเป็นองค์กรภาคประชาสังคมระหว่างประเทศและมีวัตถุประสงค์ในการต่อสู้กับการทุจริตทุกรูปแบบ รวมทั้งได้มีการวัดการรับรู้การทุจริต (CPI) หรือที่เคยรับรู้มาก่อนนี้ คือ ดัชนีภาพลักษณ์คอร์รัปชัน เป็นการวัดความรับรู้ถึงสถานการณ์ทุจริตของ 180 ประเทศเป็นประจำทุกปี",
    source:
      "สำนักงานคณะกรรมการป้องกันและปราบปรามการทุจริตแห่งชาติ. ดัชนีการรับรู้การทุจริต (Corruption Perceptions Index : CPI) ตอนที่ 1, 10 ตุลาคม 2562.\r\nhttps://www.nacc.go.th/files/article/attachments/2019120221251286.pdf",
    sappear: "",
    mappear: 21,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีครอบครัวอบอุ่น",
    meaning:
      "เป็นดัชนีรวม (composite index) ซึ่งประกอบด้วย 5 องค์ประกอบ ด้วยกัน คือ\r\n1. โครงสร้างครอบครัว \r\n2. บทบาทของครอบครัว \r\n3. สัมพันธภาพในครอบครัว\r\n4. องค์ประกอบด้านการพึ่งตนเอง \r\n5. การเกื้อกูลสังคมอย่างมีคุณธรรม",
    source:
      "สาวิตรี ทยานศิลป์ สถาบันแห่งชาติเพื่อการพัฒนาเด็กและครอบครัว มหาวิทยาลัยมหิดล. (2554). ความสัมพันธ์ในครอบครัว, 16 สิงหาคม 2562. https://www.hiso.or.th/hiso5/report/download.php?name=thai2011_8",
    sappear: "",
    mappear: 11,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีความก้าวหน้าของการพัฒนาคนด้านสุขภาพ",
    meaning:
      "องค์ประกอบของดัชนีย่อยด้านสุขภาพ 4 ตัว คือ\r\n1. ร้อยละของทารกแรกเกิดที่มีน้ำหนักต่ำกว่าเกณฑ์ หมายถึง ร้อยละของจำนวนทารกแรกเกิดที่มีอายุน้อยกว่า 28 วันที่มีน้ำหนักต่ำกว่า 2,500 กรัม ต่อจำนวนทารกแรกเกิดทั้งหมด ซึ่งเป็นข้อมูลของการเกิดมีชีพ\r\n2. ร้อยละของประชากรที่เจ็บป่วยที่เป็นผู้ป่วยใน หมายถึง ร้อยละของจำนวนผู้ป่วยในต่อจำนวนประชากรทั้งหมด\r\n3. ร้อยละของประชากรที่พิการ หมายถึง ร้อยละของประชากรที่พิการต่อจำนวนประชากรทั้งหมด\r\n4. ร้อยละของคะแนนสุขภาพจิต หมายถึง คะแนนรวมที่ได้จากการตอบแบบสอบถามวัดสุขภาพจิตจำนวน 15 ข้อ ที่มีองค์ประกอบหลัก 4 ด้านของสุขภาพจิต คือ สภาพจิตใจ สมรรถภาพของจิตใจ คุณภาพของจิตใจ และปัจจัยสนับสนุน โดยมีคะแนนเต็ม 45 คะแนน ดังนั้น ร้อยละของคะแนนสุขภาพจิต คือ คะแนนสุขภาพจิต หาร 45 คูณ 100",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. (2560). ดัชนีความก้าวหน้าของคน ประจำปี 2562 หน้า 24, 30 ตุลาคม 2562. http://social.nesdc.go.th/social/Portals/0/HAI%202562%20Web.pdf",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีความผูกพันของบุคลากรภาครัฐ",
    meaning:
      "การค้นหาปัจจัยที่มีผลต่อความสุข ความพึงพอใจ และแรงจูงใจของบุคลากรอย่างเป็นระบบและครอบคลุมทั้งองค์กร วัดความสุขของบุคลากรและบ่งชี้ความสัมพันธ์ระหว่างความสุขในชีวิตกับการทำงาน เพื่อนำผลการวิเคราะห์ข้อมูลที่รวบรวมได้ไปใช้ในการพัฒนาองค์กรด้านระบบบริหารงานบุคคล การเรียนรู้และสร้างแรงจูงใจ ตลอดจนการสร้างความผาสุกและความพึงพอใจของบุคลากร",
    source:
      "คณะทำงานเสริมสร้างความผูกพันองค์กร สำนักยุทธศาสตร์สุขภาพจิต. (2560). รายงานผลการสำรวจความผูกพันของบุคลากรต่อองค์กร ของสำนักยุทธศาสตร์สุขภาพจิต, 9 ธันวาคม 2562. https://plan.dmh.go.th/forums/index.php?action=dlattach;topic=1110.0;attach=1956",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีความมั่นคงด้านน้ำเพื่อการพัฒนาเศรษฐกิจ",
    meaning:
      "ดัชนีความมั่นคงด้านน้ำทางเศรษฐกิจ ซึ่งสามารถวัดได้จากประสิทธิภาพการใช้น้ำในการผลิตเชิงเศรษฐกิจ 3 ด้านคือ การเกษตร อุตสาหกรรมและการผลิตพลังงาน เนื่องจากความต้องการน้ำเพื่อการเกษตร อุตสาหกรรม และการผลิตไฟฟ้าเพิ่มขึ้นตลอดเวลา ดังนั้นจึงจำเป็นต้องพิจารณาและวางแผนบริหารจัดการการใช้น้ำร่วมกันแบบบูรณาการ ไม่ควรแยกวางแผนการใช้น้ำของแต่ละภาคส่วนการใช้น้ำ ปัญหาความสัมพันธ์ระหว่างน้ำ-อาหาร-พลังงาน ช่วยก่อให้เกิดการตื่นตัวเกี่ยวกับการบริหารจัดการน้ำเพื่อสนับสนุนกิจกรรมทางเศรษฐกิจ ความมั่นคงด้านน้ำทางเศรษฐกิจจะเป็นตัวชี้วัดการใช้น้ำในการผลิตอาหาร การอุตสาหกรรม และการพลังงาน เพื่อแก้ปัญหาความยากจน และเพื่อสนับสนุนให้มีการเจริญเติบโตทางเศรษฐกิจอย่างยั่งยืน จำเป็นต้องมีน้ำมากขึ้นหรือมีการใช้น้ำอย่างมีประสิทธิภาพมากขึ้น",
    source:
      "รศ.ดร.วราวุธ วุฒิวณิชย์ ภาควิชาวิศวกรรมชลประทาน มหาวิทยาลัยเกษตรศาสตร์. (2557). ความมั่นคงด้านทางน้ำ (Water Security), 2 กันยายน 2562. http://irre.ku.ac.th/otpaper/pdf/2.Water%20Security.pdf",
    sappear: "",
    mappear: 19,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีความมั่นคงด้านน้ำเพื่อสิ่งแวดล้อม",
    meaning:
      "ดัชนีความมั่นคงด้านน้ำเพื่อสิ่งแวดล้อม (การรบกวนต้นน้ำ, มลพิษ, การพัฒนาทรัพยากรน้ำ, ปัจจัยด้านชีวภาพ) เพื่อให้สามารถฟื้นฟูความสมบูรณ์ของแม่น้ำและระบบนิเวศ ทรัพยากรธรรมชาติและสิ่งแวดล้อมของเอเชียได้รับผลกระทบอย่างมากในช่วงที่รัฐบาลให้ความสำคัญกับการมุ่งพัฒนาเศรษฐกิจ มากกว่าการดูแลรักษาสิ่งแวดล้อม แต่ในปัจจุบันผู้นำประเทศในเอเชียหันมาให้ความสนใจการพัฒนาอย่างยั่งยืน ดัชนีดังกล่าวจะเป็นตัวชี้วัดความสามารถในการฟื้นฟูความสมบูรณ์ของแม่น้ำและระบบนิเวศในระดับประเทศ และระดับภูมิภาค ความยั่งยืนในการพัฒนาและปรับปรุงคุณภาพความเป็นอยู่ขึ้นอยู่กับทรัพยาการธรรมชาติ",
    source:
      "รศ.ดร.วราวุธ วุฒิวณิชย์ ภาควิชาวิศวกรรมชลประทาน มหาวิทยาลัยเกษตรศาสตร์. (2557). ความมั่นคงด้านทางน้ำ (Water Security), 2 กันยายน 2562. http://irre.ku.ac.th/otpaper/pdf/2.Water%20Security.pdf",
    sappear: "",
    mappear: 19,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีความมั่นคงด้านน้ำในเขตเมือง",
    meaning:
      "ดัชนีความมั่นคงด้านน้ำสำหรับเมือง (ระบบจ่ายน้ำ, ระบบบำบัดน้ำเสีย, ระบบระบายน้ำ) เพื่อพัฒนาเมืองให้สดใสและน่าอยู่ ในภูมิภาคเอเชียและแปซิฟิก ประชากร 43% อาศัยอยู่ในเมือง ในช่วง 20 ปีที่ผ่านมา ประชากรเมืองเพิ่มมากขึ้นถึง 29% เมืองในเอเชียเป็นปัจจัยสำคัญในการขับเคลื่อนเศรษฐกิจ ดัชนีความมั่นคงด้านน้ำสำหรับเมืองจะเป็นตัวชี้วัดมาตรฐานการให้บริการและการจัดการน้ำเพื่อสนับสนุนเมืองที่สดใสและน่าอยู่",
    source:
      "รศ.ดร.วราวุธ วุฒิวณิชย์ ภาควิชาวิศวกรรมชลประทาน มหาวิทยาลัยเกษตรศาสตร์. (2557). ความมั่นคงด้านทางน้ำ (Water Security), 2 กันยายน 2562. http://irre.ku.ac.th/otpaper/pdf/2.Water%20Security.pdf",
    sappear: "",
    mappear: 19,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีความมั่นคงด้านน้ำของประเทศ",
    meaning:
      "ดัชนีความมั่นคงด้านน้ำของประเทศไทย ประกอบด้วย 5 ด้าน คือ \r\n1. ระดับครัวเรือน (การมีน้ำประปาหมู่บ้าน) \r\n2. ด้านเศรษฐกิจ (ปริมาณการใช้น้ำในภาคเกษตรและภาคอุตสาหกรรมต่อปริมาณการใช้น้ำทั้งหมด) \r\n3. ระดับชุมชน (การเข้าถึงแหล่งน้ำประปา)\r\n4. ระดับลุ่มน้ำ(ดัชนีคุณภาพน้ำทั่วไป) \r\n5. การปรับตัวเข้าสู่สภาพเดิม (ความถี่ภัยน้ำแล้งและภัยน้ำท่วม) \r\nพบว่า อัตราการใช้น้ำ และโครงสร้างการใช้น้ำมีความสัมพันธ์กับผลิตภัณฑ์มวลรวมต่อคนของจังหวัด หมายความว่า โครงสร้างการใช้น้ำระดับจังหวัด จะเริ่มจากการใช้น้ำภาคเกษตรเป็นหลัก เมื่อมีการพัฒนาก็มีน้ำชุมชนเพิ่ม และพัฒนาการใช้น้ำอุตสาหกรรมเพิ่ม ซึ่งส่งผลให้ผลิตภัณฑ์มวลรวมต่อหัวของจังหวัดเพิ่มขึ้น ตามการเติบโตของเมือง และการพัฒนาอุตสาหกรรมในพื้นที่ ",
    source:
      "รองศาสตราจารย์ ดร.สุจริต คูณธนกุลวงศ์ หัวหน้าภาควิชาวิศวกรรมแหล่งน้ำ คณะวิศวกรรมศาสตร์ จุฬาลงกรณ์มหาวิทยาลัย. ความมั่นคงด้านน้ำกับการพัฒนาเศรษฐกิจ, 2 กันยายน 2562. http://project-wre.eng.chula.ac.th/watercu_eng/sites/default/files/publication/thai%20and%20cc/%E0%B8%9C%E0%B8%99%E0%B8%A7%E0%B8%81/%E0%B8%9C%E0%B8%99%E0%B8%A7%E0%B8%81%20%E0%B8%87%20%E0%B8%94%E0%B8%B1%E0%B8%8A%E0%B8%99%E0%B8%B5%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%A1%E0%B8%B1%E0%B9%88%E0%B8%99%E0%B8%84%E0%B8%87%E0%B8%94%E0%B9%89%E0%B8%B2%E0%B8%99%E0%B8%99%E0%B9%89%E0%B8%B3%E0%B8%84%E0%B8%B7%E0%B8%AD%E0%B8%AD%E0%B8%B0%E0%B9%84%E0%B8%A3_final.pdf",
    sappear: "",
    mappear: 19,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีความมั่นคงด้านน้ำอุปโภคบริโภค",
    meaning:
      "ทุกประเทศต้องมีระบบน้ำและระบบสุขาภิบาลที่น่าเชื่อถือและปลอดภัย เพื่อให้บริการแก่ประชาชนทุกชุมชน ความมั่นคงด้านน้ำเพื่อครัวเรือนถือเป็นปัจจัยพื้นฐานในการแก้ไขปัญหาความยากจน",
    source:
      "รศ.ดร.วราวุธวุฒิวณิชย์\r\nภาควิชาวิศวกรรมชลประทาน คณะวิศวกรรมศาสตร์ กำแพงแสน มหาวิทยาลัยเกษตรศาสตร์ วิทยาเขตกำแพงแสน, 2 กันยายน 2562.\r\nhttp://irre.ku.ac.th/otpaper/pdf/2.Water%20Security.pdf",
    sappear: "",
    mappear: 19,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword:
      "ดัชนีความยากจนแบบหลากหลายมิติของ กลุ่มเป้าหมายที่ต้องการความช่วยเหลือ",
    meaning:
      "Multidimensional Poverty Index (MPI) หรือดัชนีวัดความยากจนแบบหลายมิติ ดัชนีแบบใหม่ไม่ได้เน้นเฉพาะรายได้ แต่ใช้วัดความขัดสนอื่นๆ ผ่านเรื่องการศึกษา สุขภาพ และความเป็นอยู่ขั้นพื้นฐาน MPI สามารถใช้วิเคราะห์เพื่อบ่งชี้ว่าใครลําบากมากที่สุด โดยได้แสดงแง่มุมความยากลําบากและปัจจัยที่เกี่ยวข้องกับความยากลําบากนั้นด้วย วิธีนี้ทําให้ผู้วางแผนนโยบายสามารถกําหนดนโยบายและเลือกกลุ่มคนยากจนได้อย่างถูกต้องและมีประสิทธิภาพ เนื่องจากการกําหนดเป้าหมายทางนโยบายในการลดความยากจนโดยมองแค่ทางด้านรายได้อย่างเดียว อาจทําให้ละเลยกลุ่มคนบางกลุ่มที่มีความขัดสนในด้านอื่นไปเพราะความยากจนทางด้านรายได้อาจไม่ได้สะท้อนถึงความขัดสนในด้านอื่นๆ ที่ไม่ใช่ตัวเงิน เช่น กลุ่ม B จัดอยู่ในกลุ่มคนที่ไม่จนด้านรายได้ แต่มีความขัดสนในด้านอื่นที่ไม่ใช่ตัวเงิน ดังนั้นหากรัฐเลือกช่วยเหลือคนจนตามเกณฑ์รายได้ รัฐก็จะช่วยเหลือ กลุ่ม C และ D เท่านั้น ในขณะที่กลุ่ม B อาจเป็นกลุ่มที่รัฐมองข้ามไป",
    source:
      "สำนักคณะกรรมการพัฒนาการเศรษฐกิจและสังคมแห่งชาติ สำนักพัฒนาฐานข้อมูลและตัวชี้วัดภาวะสังคม. (2557). รายงานการวิเคราะห์สถานการณ์ความยากจนและความเหลื่อมล้ำในประเทศไทย ปี2555, 2 กันยายน 2562. http://www.nesdc.go.th/ewt_w3c/ewt_dl_link.php?nid=2669",
    sappear: "",
    mappear: 17,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีความยากจนหลายมิติ",
    meaning:
      "ใช้วัความขัดสนต่าง ๆ ผ่านการศึกษา สุขภาพ สถานะทางเศรษฐกิจ และความเป็นอยู่ขั้นพื้นฐาน ซึ่งสามารถวิเคราะห์และบ่งชี้ได้ว่าใครลำบากที่สุด โดยแสดงความยากลำบากและปัจจัยที่เกี่ยวข้องกับความยากลำบาก ทำให้ผู้วางแผนนโยบายสามารถกำหนดนโยบายและเลือกกลุ่มคนยากจน เพื่อลดความยากจนได้อย่างถูกต้องและมีประสิทธิภาพ โดยใช้ข้อมูลสำมะโนประชากรที่มีอยู่ ส่วนข้อมูลอื่น ๆ  เช่น การทำงาน ความปลอดภัย การพัฒนาตนเอง จะมีการใช้ในอนาคต \r\nวิธีการคำนวณ MPI (MPI = H*A)\r\n*** H คือ ร้อยละของความยากจนต่อประชากรทั้งหมด (Headcount) \r\nA คือ ร้อยละเฉลี่ยความขัดสนในมิติต่าง ๆ ของคนจน (the average percentage of dimensions in which poor people are deprived) \r\nซึ่งสะท้อนความยากจนในแต่ละครอบครัวและระดับประเทศ รวมทั้งคำนึงถึงความรุนแรงของความขัดสนในมิติต่าง ๆ ของคนจน ",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ, รายงานการวิเคราะห์สถานการณ์ความยากจนและความเหลื่อมล้ำในประเทศไทย ปี 2555, 15 ตุลาคม 2562. https://www.nesdc.go.th/ewt_w3c/ewt_dl_link.php?nid=2669\r\n",
    sappear: "",
    mappear: 15,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีความอยู่เย็นเป็นสุข",
    meaning:
      '"สภาวะที่คนมีคุณภาพชีวิตที่ดี ดำรงชีวิตอย่างมีดุลยภาพทั้งจิต กาย ปัญญา ที่เชื่อมโยงกับ เศรษฐกิจ สังคม และสิ่งแวดล้อมอย่างเป็นองค์รวมและสัมพันธ์กันได้ถูกต้องดีงาม นำไปสู่การอยู่ร่วมกันอย่างสันติระหว่างคนกับคน และระหว่างคนกับธรรมชาติและสิ่งแวดล้อม"\r\nดัชนีความอยู่เย็นเป็นสุขฯ ประกอบด้วย 6 องค์ประกอบหลัก ได้แก่\r\n1. การมีสุขภาวะ \r\n2. ครอบครัวอบอุ่น \r\n3. ชุมชนเข้มแข็ง \r\n4. เศรษฐกิจเข้มแข็งและเป็นธรรม \r\n5. สภาพแวดล้อมและระบบนิเวศสมดุล และ\r\n6. สังคมประชาธิปไตยที่มีธรรมาภิบาล',
    source:
      "สำนักงานคณะกรรมการพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. (2559). อยู่เย็นเป็นสุข, 9 กันยายน 2562. http://www.nesdc.go.th/article_attach/0201.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีคุณธรรม 5 ประการ ",
    meaning:
      "หลักจริยธรรมเป็นสิ่งสำคัญที่จะทำให้การประพฤติปฏิบัติของเจ้าหน้าที่ของรัฐได้รับการยอมรับจากสาธารณชน และมีความสำคัญต่อการดำรงไว้ซึ่งความมั่นคงแห่งรัฐ\r\nความซื่อสัตย์สุจริต (Honesty and Integrity) การยึดมั่นในความสัตย์จริงและในสิ่งที่ถูกต้องดีงาม มีความซื่อตรงและเจตนาที่บริสุทธิ์ ประพฤติปฏิบัติต่อตนเองและผู้อื่นโดยชอบ ไม่คดโกง\r\nการมีจิตสาธารณะ (Greater Good) การมีจิตสำนึกเพื่อส่วนร่วม มีความตระหนักรู้และคำนึงถึงสังคมส่วนรวม มีความรับผิดชอบต่อตัวเองในการกระทำใดๆ เพื่อไม่ให้เกิดผลกระทบเสียหายต่อส่วนรวมและพร้อมที่จะเสียสละประโยชน์ส่วนตนเพื่อรักษาผลประโยชน์ของส่วนรวม\r\nความเป็นธรรมทางสังคม (Fairness and Justice) การปฏิบัติต่อผู้อื่นอย่างเสมอภาคและเท่าเทียมกัน และอย่างมีเหตุผลโดยไม่เลือกปฏิบัติต่อ เพศ เชื้อชาติ ชนชั้น สถานะทางเศรษฐกิจและสังคม\r\nการกระทำผิดอย่างรับผิดชอบ (Responsibility and Accountability) การมีจิตสำนึกในบทบาทและหน้าที่ของตัวเองและปฏิบัติหน้าที่ให้ดีที่สุดเคารพกฎเกณฑ์กติกา พร้อมให้ตรวจสอบการกระทำได้เสมอ หากมีการกระทำผิดก็พร้อมที่จะยอมรับและแก้ไขในสิ่งที่ผิด\r\nการเป็นอยู่อย่างพอเพียง (Sufficiency and Moderation)\r\n",
    source:
      "ศิริรัตน์ วสุวัต ผู้เชี่ยวชาญ สำนักงานคณะกรรมการป้องกันและปราบปรามการทุจริตแห่งชาติ. คุณธรรม จริยธรรม และประโยชน์ทับซ้อน, 2 กันยายน 2562. http://www.okmd.or.th/upload/pdf/Doc_ITA_3.pdf",
    sappear: "",
    mappear: 10,
    rappear: " ",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีคุณภาพมหาสมุทร (คะแนน)",
    meaning:
      "Ocean Health Index: OHI เป็นเครื่องมือที่ถูกนำมาใช้ติดตามและประเมินผลสุขภาพของระบบนิเวศน์มหาสมุทร โดยมีกรอบแนวคิดที่บูรณาการระหว่างตัวชี้วัดด้านต่าง ๆ ที่ครอบคลุมทั้งด้านสังคมและสิ่งแวดล้อม\r\n",
    source:
      "ศาสตราจารย์ ดร. เผดิมศักดิ์ จารยะพันธ์. ดัชนีคุณภาพมหาสมุทร Ocean Health Index, 8 พฤศจิกายน 2562. https://www.dmcr.go.th/download/?file=M2M0MTyjrP5jZ20mqmMZYJ0mMmE0A2xjrQIjZJ03qmMZAJ0kMl10BTxjrQOjZ205qmSZZT0lMl10MJyfrTyjMz0iq2IZoT1cM2M0Y2ywrUOjY21xq2SZo21fM3O0qJxirUEjo21iq3WZq213M3q0Y2x6rRZ%3Q&n=01&t=&type=rQR%3Q&up=rQN%3Q",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีนวัตกรรมโลก (Global Innovation Index)",
    meaning:
      "ดัชนีได้รับการพัฒนาขึ้นสําหรับชี้วัดความสามารถด้านนวัตกรรมของแต่ละประเทศโดยเริ่มจัดทําครั้งแรกในปีค.ศ. 2007 โดย สถาบัน INSEAD ในความร่วมมือกับ WIPO และในปีค.ศ. 2017 นี้ถือเป็นปีที่ 10 ของการจัดทําดัชนี GII โดยทําการสํารวจและจัดอันดับประเทศ/เขตเศรษฐกิจ ครอบคลุม 127 ประเทศ/เขตเศรษฐกิจ ทั่วโลก GII ประกอบด้วยดัชนีย่อย 2 ตัวได้แก่ ดัชนีย่อยปัจจัยเข้าทางนวัตกรรม (Innovation input sub-index) และดัชนีย่อยผลผลิตทางนวัตกรรม(Innovation output sub-index)โดยให้น้ําหนักดัชนีย่อยทั้งสองตัวเท่ากัน\r\n",
    source:
      "อภิยุกต์ อํานวยกาญจนสิน สํานักวิจัยเศรษฐกิจอุตสาหกรรม. นวัตกรรมในประเทศไทยและภาคอุตสาหกรรม สถานะและช่องว่างการพัฒนา, 3 กันยายน 2562. http://www.oie.go.th/sites/default/files/attachments/article/innovation.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีนิติธรรม",
    meaning:
      "เครื่องมือการประเมินเชิงปริมาณที่ออกแบบโดยโครงการยุติธรรมโลก (World Justice Project - WJP) ซึ่งเป็นหน่วยงานอิสระไม่แสวงหากำไร โดยดัชนีที่จัดทำขึ้นนี้ก็เพื่อวัดว่าประเทศต่างๆ ยึดมั่นต่อหลักนิติธรรมมากน้อยเพียงใด ซึ่งประเมินจากปัจจัยที่ส่งผลต่อหลักนิติธรรมทั้งหมด 8 ด้าน คือ 1) การจำกัดอำนาจของรัฐบาล 2) การทุจริต 3) ความมั่นคง 4) สิทธิขั้นพื้นฐาน 5) ระบอบปกครองแบบเปิด 6) การบังคับใช้กฎหมายและระเบียบ 7) ระบบยุติธรรมทางทางแพ่ง และ 8) ระบบยุติธรรมทางอาญา โดยทำการสัมภาษณ์บุคคลทั่วไป และผู้เชี่ยวชาญ",
    source:
      "ศูนย์สารสนเทศยุทธศาสตร์ภาครัฐ สำนักงานสถิติแห่งชาติ. ดัชนีชี้วัดหลักนิติธรรม (The Rule of Law Index), 27 สิงหาคม 2562. http://service.nic.go.th/index.php?file=set-of-indicators/di-asean-1-5-1",
    sappear: "",
    mappear: 22,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีพัฒนาการเด็กสมวัย",
    meaning:
      "เด็กที่ได้รับตรวจคัดกรองพัฒนาการโดยใช้คู่มือเฝ้าระวังและส่งเสริมพัฒนาการเด็กปฐมวัย(DSPM) แล้วผลการตรวจคัดกรอง ผ่านครบ 5 ด้าน ในการตรวจคัดกรองพัฒนาการครั้งแรก รวมกับเด็กที่พบพัฒนาการสงสัยล่าช้าและได้รับการติดตามให้ได้รับการกระตุ้นพัฒนาการ และประเมินซ้ำแล้วผลการประเมิน ผ่านครบ 5 ด้านภายใน 30 วัน การตั้งค่าเป้าหมายร้อยละของเด็กอายุ 0 – 5 ปี มีพัฒนาการสมวัย ที่ร้อยละ 85",
    source:
      "สำนักส่งเสริมสุขภาพ กรมอนามัย, สถาบันพัฒนาอนามัยเด็กแห่งชาติกรมอนามัย, สถาบันราชานุกูล กรมสุขภาพจิต และสำนักนโยบายและยุทธศาสตร์ สำนักงานปลัดกระทรวงสาธารณสุข. (2562 Promotion & Prevention Excellence (ยุทธศาสตร์ด้านส่งเสริมสุขภาพ ป้องกันโรคและคุ้มครองผู้บริโภคเป็นเลิศ), 11 ธันวาคม 2562. http://bie.moph.go.th/cockpit/template_file/1.2%20Template%20%E0%B8%9E%E0%B8%B1%E0%B8%92%E0%B8%99%E0%B8%B2%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%94%E0%B9%87%E0%B8%81%20%E0%B8%9B%E0%B8%B5%202562.pdf",
    sappear: "",
    mappear: 11,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีรัฐบาลอิเล็กทรอนิกส์ ",
    meaning:
      "จัดทำโดยองค์กรสหประชาชาติ (United Nations: UN) เพื่อประเมินความพร้อมของการพัฒนารัฐบาลอิเล็กทรอนิกส์ของประเทศต่างๆ เพื่อให้เห็นถึงทิศทางการพัฒนารัฐบาลอิเล็กทรอนิกส์ และสะท้อนถึงความสามารถของภาครัฐในการนำเทคโนโลยีสารสนเทศมาประยุกต์ใช้ในการให้บริการแก่ประชาชน โดยทำการสำรวจจากประเทศที่เป็นสมาชิกจำนวน 193 ประเทศ ประกอบด้วยการพิจารณา 3 ด้านที่สำคัญ คือ\r\n1) การให้บริการออนไลน์ (Online Service Index)\r\n2) โครงสร้างพื้นฐานโทรคมนาคม (Telecommunication Infrastructure Index)\r\n3) ทุนมนุษย์ (Human Capital Index) ",
    source:
      "สำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน). ดัชนีรัฐบาลอิเล็กทรอนิกส์, 21 ตุลาคม 2562. https://www.dga.or.th/th/content/2013/13254/",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีวัดประสิทธิภาพด้านโลจิสติกส์ระหว่างประเทศของประเทศไทย",
    meaning:
      "ค่าที่ใช้ประเมินความสามารถในการแข่งขันด้านโลจิสติกส์ของในแต่ละประเทศ การเปรียบเทียบดัชนีวัดประสิทธิภาพด้านโลจิสติกส์ระหว่างประเทศของไทย ระหว่างปี 2555-2559 พบว่าข้อมูลการจัดอันดับ LPI ของธนาคารโลกในปี 2559 พบว่าประเทศไทยอยู่อันดับที่ 45 จาก 160 ประเทศทั่วโลก ลดลงจากอันดับที่ 35 ในปี 2557 ทั้งนี้หากพิจารณาเปรียบเทียบองค์ประกอบของเกณฑ์ชี้วัดทั้ง 6 ตัว พบว่าอันดับลดลงเกือบทุกด้าน โดยเฉพาะ ด้านความตรงต่อเวลาของการบริการ ระบบการติดตามและตรวจสอบสินค้า ยกเว้นการเตรียมการขนส่งระหว่างประเทศที่มีลำดับปรับดีขึ้นเล็กน้อย ",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. แผนยุทธศาสตร์ การพัฒนาระบบโลจิสติกส์ของประเทศไทย ฉบับที่ 3 (พ.ศ.2560-2564), 31 กรกฎาคม 2562. http://www.nesdc.go.th/ewt_dl_link.php?nid=6923&filename=logistic",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีสมรรถนะสิ่งแวดล้อม ",
    meaning:
      "การประเมินสมรรถนะของสิ่งแวดล้อมผ่านดัชนีย่อย 10 ค่า ที่ครอบคลุมประเด็นคุณภาพสิ่งแวดล้อม และประเด็นคุณภาพระบบนิเวศ ได้แก่ \r\n1. ภาระโรคที่เกิดจากสิ่งแวดล้อม\r\n2. ผลกระทบจากมลพิษทางอากาศต่อมนุษย์\r\n3. ผลกระทบเรื่องน้ำต่อมนุษย์\r\n4. ผลกระทบจากมลพิษทางอากาศต่อระบบนิเวศ\r\n5. ผลกระทบเรื่องน้ำต่อระบบนิเวศ\r\n6. ความหลากหลายทางชีวภาพและแหล่งที่อยู่อาศัย\r\n7. การเกษตร\r\n8. การประมง\r\n9. ป่าไม้\r\n10. ปัจจัยต่อการเปลี่ยนแปลงทางภูมิอากาศ",
    source:
      "Yale Center for Environmental Law and Policy. Environmental Performance Index of Thailand. 15 พฤศจิกายน 2562. https://epi.envirocenter.yale.edu/epi-country-report/THA",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดัชนีสันติภาพโลก",
    meaning:
      "จัดทำโดยสถาบันเพื่อเศรษฐศาสตร์และสันติภาพ มีจุดมุ่งหมายในการส่งเสริมและสร้างความเข้าใจด้านสันติภาพ ความยุติธรรม การประนีประนอม และการยุติความขัดแย้งโดยสันติวิธีทั้งในระดับประเทศ ภูมิภาคและระดับโลก \r\nโดยความหมายของสันติภาพในที่นี่มีความหมายที่กว้างกว่าการไม่มีสงครามและความรุนแรง แต่ยังหมายถึงการพัฒนาทางเศรษฐกิจและความยุติธรรมทางสังคมที่อยู่บนหลักความมั่นคงปลอดภัย การลดปริมาณและการแข่งขันสะสมอาวุธ การมีเสรีภาพ การยอมรับความหลากหลาย ศักดิ์ศรีและการเคารพในสิทธิมนุษยชน",
    source:
      "สำนักงานส่งเสริมสังคมแห่งการเรียนรู้และคุณภาพเยาวชน. ผลการจัดอันดับดัชนีสันติภาพโลก, 18 กันยายน 2562. http://www.qlf.or.th/Home/Contents/944",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดิจิทัล",
    meaning:
      "เทคโนโลยีที่ใช้วิธีการนำสัญลักษณ์ศูนย์และหนึ่ง หรือสัญลักษณ์อื่น มาแทนค่าสิ่งทั้งปวง เพื่อใช้สร้างหรือก่อให้เกิดระบบต่าง ๆ เพื่อให้มนุษย์ใช้ประโยชน์",
    source:
      "พระราชบัญญัติการบริหารงานและการให้บริการภาครัฐผ่านระบบดิจิทัล พ.ศ. 2562 (2562, 22 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 67 ก หน้า 57. \r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/067/T_0057.PDF",
    sappear: "",
    mappear: "8,12",
    rappear: "",
    firstalpha: "ด"
  },
  {
    keyword: "ดุลพินิจตามอำเภอใจของเจ้าหน้าที่",
    meaning:
      "ไม่ใช่เป็นการใช้อำนาจดุลพินิจแต่เป็นการใช้อำนาจโดยไม่ชอบด้วยกฎหมาย หากฝ่ายปกครองใช้อำนาจตามอำเภอใจหรือใช้อำนาจดุลพินิจไปโดยไม่ชอบก็อาจถูกตรวจสอบความชอบด้วยกฎหมายโดยผู้บังคับบัญชาของฝ่ายปกครอง  ศาลปกครอง หรือผู้ตรวจการแผ่นดินของรัฐสภา และอาจต้องรับผิดในทางแพ่ง ทางอาญา และทางวินัยจากผลการกระทำ",
    source:
      "สำนักกฎหมาย สำนักงานปลัดกระทรวงมหาดไทย. (2561). ดุลพินิจของฝ่ายปกครอง, 12 กันยายน 2562. http://www.law.moi.go.th/2551/article007.doc",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ด"
  },
  {
    keyword: "ต้นทุนเชิงขนาด (Economy of Scale)",
    meaning:
      "การประหยัดต่อขนาด (Economies of Scale) หมายถึง ความได้เปรียบที่เกิดขึ้นจากการที่หน่วย\r\nธุรกิจสามารถผลิตผลผลิตได้ในจำนวนมากขึ้นจนทำให้ต้นทุนในการผลิตเฉลี่ยต่อหน่วยต่ำลงได้อย่างไรก็ตามหากการขยายผลผลิตไปกลับทำให้ต้นทุนการผลิตผลผลิตสูงขึ้นมาจะเรียกว่าธุรกิจเกิดการไม่ประหยัดต่อขนาด (Diseconomies of Scale) ",
    source:
      "สำนักงานเศรษฐกิจการคลัง กระทรวงการคลัง. การประหยัดต่อขนาด (Economies of Scale), 12 กันยายน 2562. http://www2.fpo.go.th/S-I/Source/ECO/ECO71.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ต"
  },
  {
    keyword: "ต้นทุนทางสังคม",
    meaning:
      'จากบริบทในยุทธศาสตร์ชาติด้านการพัฒนาและเสริมสร้างศักยภาพทรัพยากรมนุษย์\r\n"การสร้างค่านิยมและวัฒนธรรมที่พึงประสงค์จากภาคธุรกิจ โดยกระตุ้นให้ภาคธุรกิจมี\r\nการบริหารจัดการอย่างมีธรรมาภิบาล พัฒนาสร้างความรู้สึกรับผิดชอบต่อสังคมของคนทุกคนในบริษัท\r\nทั้งพนักงานและลูกค้า ปรับเปลี่ยนทัศนคติการคำนวณผลตอบแทนให้คำนึงถึงต้นทุนทางสังคม ส่งเสริมการจัดกิจกรรมเพื่อตอบแทนสังคม รวมทั้งกระตุ้นให้เกิดการประกอบธุรกิจเพื่อสังคม"\r\nต้นทุนทางสังคมในที่นี้ จึงหมายถึง Social Cost หมายถึง ความเสียหายและผลกระทบเชิงลบที่เกิดขึ้นต่อสังคมและสิ่งแวดล้อม เช่น มลพิษ ความเจ็บป่วย ซึ่งเป็นผลมาจากกิจกรรมใดกิจกรรมหนึ่งจากนโยบาย แนวทางพัฒนา หรือนวัตกรรม เช่น การพัฒนาอุตสาหกรรมอย่างไม่มีแบบแผน ดังนั้น ในขั้นตอนการผลิตและค่าใช้จ่ายต่าง ๆ ต้องคำนึงถึงต้นทุนทางสังคมดังนี้ด้วย\r\n\r\n',
    source:
      "พจนานุกรม Cambridge. Social Cost, 21 พฤศจิกายน 2562. https://dictionary.cambridge.org/dictionary/english/social-cost",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "ต"
  },
  {
    keyword: "ตรวจธาตุเจ้าเรือน",
    meaning:
      "การแพทย์แผนไทยกล่าวว่าร่างกายมนุษย์ประกอบขึ้นจาก 4 ธาตุคือธาตุดิน (ปถวีธาตุ) ธาตุน้ำ(อาโปธาตุ, เสมหะ)ธาตุลม (วาโยธาตุ,วาตะ)และธาตุไฟ (เตโชธาตุ, ปิตตะ) ในร่างกายแต่ละบุคคลจะมีสัดส่วนของธาตุทั้ง 4 ไม่เท่ากัน โดยมีธาตุใดธาตุหนึ่งเป็นหลัก เรียกว่าธาตุเจ้าเรือน ซึ่งแบ่งออกเป็น 2 ประเภท คือ ธาตุเจ้าเรือนกำเนิด หมายถึงธาตุที่ติดตัวมาตั้งแต่กำเนิด แต่สามารถเปลี่ยนแปลงได้จากปัจจัยที่มีอิทธิพลได้แก่ อายุ ฤดูกาล กาลเวลา ถิ่นที่อยู่ และมูลเหตุการเกิดโรคที่เกิดจากพฤติกรรม ส่วนธาตุเจ้าเรือนอีกประเภทหนึ่ง คือ ธาตุเจ้าเรือนปกติลักษณะ หมายถึงธาตุที่แสดงออกจากบุคลิกลักษณะของแต่ละบุคคลที่เปลี่ยนแปลงจากอิทธิพลของตรีธาตุ ซึ่งแบ่ง เป็น 3 ลักษณะหลัก คือ วาตะ ปิตตะ และเสมหะ",
    source:
      "สถานการแพทย์แผนไทยประยุกต์ คณะแพทยศาสตร์ศิริราชพยาบาล มหาวิทยาลัยมหิดล. (2560). การพัฒนาแบบประเมินเพื่อการวินิจฉัยธาตุเจ้าเรือนปกติลักษณะทางการแพทย์แผนไทย, 11 ตุลาคม 2562. file:///C:/Users/admin/Downloads/97665-Article%20Text-243918-1-10-20170830.pdf\r\n",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ต"
  },
  {
    keyword: "ตลาดเสรี",
    meaning:
      "ตลาดในอุดมคติ เป็นตลาดสินค้าหรือบริการที่มีการปล่อยให้เป็นไปตามอุปสงค์และอุปทานหรือกลไกตลาดค่อยกำหนดราคาและปริมาณการซื้อขายอย่างเสรี โดยปราศจากการแทรกแซงใด ๆ จากรัฐบาล ระบบเศรษฐกิจที่ส่งเสริมตลาดเสรีเรียกว่าระบบเศรษฐกิจแบบตลาดเสรี",
    source:
      "สำนักนโยบายการออมและการลงทุน. (2553). ตลาดเสรี Free market, 9 กันยายน 2562. http://www2.fpo.go.th/S-I/Source/word/Word.php?Language=Thai&BeginRec=1356&NumRecShow=8&sort=1&search=",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ต"
  },
  {
    keyword: "ตลาดแรงงาน",
    meaning:
      "การติดต่อตกลงกันไม่ว่าโดยวิธีใดก็ตามระหว่างผู้ประสงค์จะทำงานและผู้ต้องการจ้างงานเพื่อก่อให้เกิดการจ้างงาน การติดต่อตกลงดังกล่าว อาจทำในท้องที่ใดท้องที่หนึ่งในระดับภูมิภาค ประเทศ หรือระหว่างประเทศก็ได้และอาจรวมถึงวิธีการจ้าง การจัดหางาน การเข้าออกงาน การเคลื่อนย้ายแรงงานฯ",
    source:
      "กรมสวัสดิการและคุ้มครองแรงงาน. คำศัพท์ด้านแรงงาน, 10 กรกฎาคม 2562. https://www.labour.go.th/index.php/component/seoglossary/1-dictionary/L",
    sappear: "",
    mappear: 11,
    rappear: "",
    firstalpha: "ต"
  },
  {
    keyword: "ตลาดการลงทุนเพื่อสังคม (Social Impact Investment Market)",
    meaning:
      "การลงทุนแบบหนึ่งที่นอกเหนือจากผลตอบแทนทางการเงินแล้ว ผู้ลงทุนยังต้องการให้ธุรกิจสามารถสร้างหรือทำให้เกิดผลกระทบทางที่ดีขึ้นต่อสังคมและสิ่งแวดล้อมไปพร้อมกับการดำเนินธุรกิจ ผลกระทบที่ว่านี้ควรเป็นผลกระทบที่ยั่งยืน รวมถึงสามารถขยายผลให้เติบโตอย่างยั่งยืนในระยะยาวไปพร้อมกับผลตอบแทนทางการเงิน",
    source:
      "ตลาดหลักทรัพย์แห่งประเทศไทย. การลงทุนเพื่อสังคม, 9 กันยายน 2562. https://www.set.or.th/sustainable_dev/th/social_impact_investment/about_p1.html",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "ต"
  },
  {
    keyword: "ตลาดทุน",
    meaning:
      "แหล่งเพื่อการระดมทุนและการลงทุนระยะยาวกว่า 1 ปี โดยสามารถแบ่งย่อยได้อีกตามประเภทของตราสารหรือสิทธิที่ผู้ลงทุนได้รับ กล่าวคือ ตลาดหลักทรัพย์ เป็นช่องทางการระดมทุนของภาคธุรกิจผ่านการออกจำหน่ายหุ้นสามัญ โดยผู้ลงทุนมีฐานะเป็นเจ้าของ และตลาดตราสารหนี้ ซึ่งผู้ลงทุนมีฐานะเป็นเจ้าหนี้ โดยตราสารที่ใช้ซื้อขายแลกเปลี่ยนมีทั้งพันธบัตรรัฐบาลที่ภาครัฐเป็นผู้ออกและหุ้นกู้ระยะยาวที่ภาคเอกชนเป็นผู้ออก",
    source:
      "ธนาคารแห่งประเทศไทย. โครงสร้างตลาดการเงิน, 24 กรกฎาคม 2562. https://www.bot.or.th/Thai/FinancialMarkets/FinancialMarketDevelopment/ThaiFinancialMarketStructure/Pages/default.aspx",
    sappear: "",
    mappear: 8,
    rappear: "",
    firstalpha: "ต"
  },
  {
    keyword: "ตัวชี้วัดการต่างประเทศไทย",
    meaning:
      "ประเด็นยุทธศาสตร์ที่ 1 ส่งเสริมความสัมพันธ์อันดีกับเพื่อนบ้านและประเทศในภาคเอเชียตะวันออกเฉียงใต้\r\nตัวชีวัด ร้อยละเฉลี่ยความสำเร็จในการดำเนินความสัมพันธ์กับประเทศ เพื่อนบ้านและประเทศในภูมิภาคเอเชียตะวันออกเฉียงใต้\r\nประเด็นยุทธศาสตร์ที่ 2 ส่งเสริมบทบาทที่สร้างสรรค์ของไทยในการขับเคลื่อนประชาคมอาเซียน\r\nตัวชี้วัด 1. ร้อยละความสำเร็จในการส่งเสริมบทบาทไทยในอาเซียน\r\nประเด็นยุทธศาสตร์ที่ 3 เสริมสร้างสถานะความสัมพันธ์กับประเทศยุทธศาสตร์\r\nตัวชี้วัด 1. ร้อยละความสำเร็จในการส่งเสริมความสัมพันธ์อันดีกับประเทศหรือกลุ่มประเทศยุทธศาสตร์\r\nประเด็นยุทธศาสตร์ที่ 4 ผลักดันบทบาทไทยที่สร้างสรรค์และรับผิดชอบ เป็นที่ยอมรับของประชาคมโลก\r\nตัวชี้วัด 1. ร้อยละเฉลี่ยความสำเร็จในการดำเนินการส่งเสริมบทบาทในเวทีระหว่างประเทศ\r\nประเด็นยุทธศาสตร์ที่ 5 ยกระดับขีดความสามารถในการแข่งขันและความร่วมมือทางเศรษฐกิจ\r\nตัวชี้วัด ร้อยละความสำเร็จในการส่งเสริมบทบาทไทยในกรอบความร่วมมือระหว่างประเทศต่างๆ (ด้านเศรษฐกิจ)\r\nประเด็นยุทธศาสตร์ที่ 6 เสริมสร้างภาพลักษณ์ ความเชื่อมั่นและทัศนคติที่ดีต่อไทย\r\nตัวชี้วัด 1. ร้อยละเฉลี่ยความสำเร็จในการดำเนินการเสริมสร้าง ภาพลักษณ์และความเชื่อมั่นต่อประเทศไทย\r\n            2. ร้อยละเฉลี่ยความสำเร็จในการให้ความร่วมมือเพื่อการพัฒนา\r\nประเด็นยุทธศาสตร์ที่ 7 ส่งเสริมการมีส่วนร่วมของทุกภาคส่วนและพัฒนาคุณภาพการให้บริการแก่ประชาชน\r\nตัวชี้วัด ร้อยละเฉลี่ยความสำเร็จในการดำเนินนโยบายการทูตสาธารณะ\r\nประเด็นยุทธศาสตร์ที่ 8 พัฒนาขีดความสามารถขององค์กร\r\nตัวชี้วัด 1. ร้อยละเฉลี่ยความสำเร็จในการดำเนินภารกิจแบบบูรณาการในต่างประเทศ\r\n             2. ร้อยละการเบิกจ่ายเงินงบประมาณภาพรวมประจำปี",
    source:
      "กระทรวงการต่างประเทศ. (2559). แผนปฏิบัติราชการของกระทรวงการต่างประเทศ ประจำปีงบประมาณ พ.ศ. 2559, 1 พฤศจิกายน 2562. http://www.oic.go.th/FILEWEB/CABINFOCENTER7/DRAWER036/GENERAL/DATA0000/00000046.PDF",
    sappear: "",
    mappear: 2,
    rappear: "",
    firstalpha: "ต"
  },
  {
    keyword: "ตัวชี้วัดร่วม (Joint KPIs)",
    meaning:
      "ตัวชี้วัดระหว่างกระทรวงที่มีเป้าหมายร่วมกัน (Joint KPIs)\r\nหลักการ Joint KPIs โดยกําหนดให้มี Joint KPIs 3 ระดับ ดังนี้\r\n1. Impact JKPIs จะถูกกําหนดเป็นตัวชี้วัด Joint KPIs ในคํารับรองฯ เฉพาะกระทรวง/ส่วนราชการที่เป็นเจ้าภาพหลักในแต่ละเรื่อง น้ำหนักแล้วแต่ความเหมาะสม\r\n2. Outcome JKPIs จะถูกกําหนดเป็นตัวชี้วัด Joint KPIs ในคํารับรองฯ เฉพาะกระทรวง/ส่วนราชการที่เป็นเจ้าภาพหลักในแต่ละ Chain น้ํำหนักแล้วแต่ความเหมาะสม และถ่ายทอดตัวชี้วัดไปยังคํารับรองฯ ระดับกรม ตามหลักการที่สํานักงาน ก.พ.ร. กําหนด\r\n3. Output JKPIs จะถูกกําหนดเป็นตัวชี้วัด Joint KPIs ในคํารับรองฯ ระดับกรม น้ำหนักแล้วแต่ความเหมาะสม",
    source:
      "สำนักงานคณะกรรมการพัฒนาระบบราชการ. (2557). กรอบการประเมินผลการปฏิบัติราชการระดับกระทรวง ประจําปีงบประมาณ พ.ศ. 2558, 30 กันยายน 2562. http://www.ldd.go.th/Lddwebsite/web_adg/download/%E0%B8%95%E0%B8%B1%E0%B8%A7%E0%B8%8A%E0%B8%B5%E0%B9%89%E0%B8%A7%E0%B8%B1%E0%B8%9458/%E0%B8%81%E0%B8%A3%E0%B8%AD%E0%B8%9A%E0%B8%84%E0%B8%B3%E0%B8%A3%E0%B8%B1%E0%B8%9A%E0%B8%A3%E0%B8%AD%E0%B8%87%2058.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ต"
  },
  {
    keyword: "ตุลาการ",
    meaning:
      "อำนาจที่ใช้โดยศาล ศาลทำหน้าที่พิจารณาตัดสินคดี โดยมีความเป็นอิสระไม่ถูกแทรกแซงใด ๆ",
    source:
      "สำนักงานคณะกรรมการการเลือกตั้ง.หลักการสำคัญของการปกครองระบอบประชาธิปไตย. ตุลาการ หน้า 2. 18 กันยายน 2562.\r\nhttps://www.ect.go.th/dec/ewt_dl_link.php?nid=75",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ต"
  },
  {
    keyword: "ถกแถลง",
    meaning:
      "กระบวนการต่อเนื่องที่ข้อมูลหรือความคิดใหม่ๆถูกนำมาต่อเติมเพิ่มขยายในการแลกเปลี่ยนสนทนากัน ด้วยเหตุนี้มันจึงขึ้นกับเส้นทางการดำเนินไปของการสนทนาหรือที่เรียกว่า Path dependent ผลของการสนทนาขึ้นอยู่กับลำดับก่อนหลังของการนำเสนอประเด็นการสนทนา โดยประเด็นสนทนาที่ถูกหยิบยกขึ้นมานำเสนอก่อนจะมีส่วนทำให้การสนทนานั้นเคลื่อนไปในทิศทางหนึ่งแทนที่จะเป็นไปในทิศทางอื่นๆ",
    source:
      "นพ. ดร. โกมาตร จึงเสถียรทรัพย์ ผู้อำนวยการสำนักวิจัยสังคมและสุขภาพ สำนักวิชาการสาธารณสุข กระทรวงสาธารณสุข. สมัชชาสุขภาพ นโยบายสาธารณะกับประชาธิปไตยแบบร่วมไตร่ตรอง, 4 ธันวาคม 2562. https://www.academia.edu/5962391/6_%E0%B8%9A%E0%B8%97%E0%B8%AA%E0%B8%A3%E0%B8%B8%E0%B8%9B_%E0%B8%AA%E0%B8%A1%E0%B8%B1%E0%B8%8A%E0%B8%8A%E0%B8%B2%E0%B8%AA%E0%B8%B8%E0%B8%82%E0%B8%A0%E0%B8%B2%E0%B8%9E_%E0%B8%99%E0%B9%82%E0%B8%A2%E0%B8%9A%E0%B8%B2%E0%B8%A2%E0%B8%AA%E0%B8%B2%E0%B8%98%E0%B8%B2%E0%B8%A3%E0%B8%93%E0%B8%B0%E0%B8%81%E0%B8%B1%E0%B8%9A%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%8A%E0%B8%B2%E0%B8%98%E0%B8%B4%E0%B8%9B%E0%B9%84%E0%B8%95%E0%B8%A2%E0%B9%81%E0%B8%9A%E0%B8%9A%E0%B8%A3_%E0%B8%A7%E0%B8%A1%E0%B9%84%E0%B8%95%E0%B8%A3_%E0%B8%95%E0%B8%A3%E0%B8%AD%E0%B8%87",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ถ"
  },
  {
    keyword: "ถวายสัตย์ปฏิญาณ",
    meaning:
      "ถวาย (ให้) คำมั่นสัญญาอันเป็นความจริง แด่พระบาทสมเด็จพระเจ้าอยู่หัว ซึ่งเป็นการแสดงความจงรักภักดีต่อพระมหากษัตริย์",
    source:
      "นางสาววรรณวนัช สว่างแจ้ง วิทยากรชำนาญการพิเศษ สถาบันพระปกเกล้า. การถวายสัตย์ปฏิญาณของคณะรัฐมนตรี, 26 กันยายน 2562. http://wiki.kpi.ac.th/index.php?title=%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%96%E0%B8%A7%E0%B8%B2%E0%B8%A2%E0%B8%AA%E0%B8%B1%E0%B8%95%E0%B8%A2%E0%B9%8C%E0%B8%9B%E0%B8%8F%E0%B8%B4%E0%B8%8D%E0%B8%B2%E0%B8%93%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B8%84%E0%B8%93%E0%B8%B0%E0%B8%A3%E0%B8%B1%E0%B8%90%E0%B8%A1%E0%B8%99%E0%B8%95%E0%B8%A3%E0%B8%B5",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ถ"
  },
  {
    keyword: "ทนาย",
    meaning: "ผู้ที่สภาทนายความได้รับจดทะเบียนและออกใบอนุญาตให้เป็นทนายความ",
    source:
      "พระราชบัญญัติทนายความ พ.ศ. 2528. (2528, 19 กันยายน). ราชกิจจานุเบกษา. เล่ม 102 ตอนที่ 129 หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2528/A/129/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ท"
  },
  {
    keyword: "ทรัพย์สิน",
    meaning:
      "รายการของวัตถุที่ถือครองได้ ทั้งที่มีรูปร่างและไม่มี รูปร่าง ซึ่งมีมูลค่าเป็นเงิน แบ่งเป็น 3 ประเภทใหญ่ คือ \r\n• ทรัพย์สินมีตัวตน (tangible assets) เช่น โรงงาน เครื่องจักร ที่ดิน สินค้าบริโภคถาวร \r\n• ทรัพย์สินทางการเงิน (financial assets) เช่น เงินตรา ธนบัตร หุ้น พันธบัตร \r\n• ทรัพย์สินไม่มีตัวตน (intangible assets) เช่น เครื่องหมายการค้า (trade-mark) ค่าความนิยม (goodwill) ของสินค้าหรือของกิจการ ทรัพย์สินทางปัญญา",
    source:
      "กรมป้องกันและบรรเทาสาธารณภัย. หนังสือคำศัพท์ด้านการบริหารจัดการความเสี่ยงจากภัยพิบัติ, 9 กันยายน 2562. http://www.disaster.go.th/th/download-src.php?did=1225",
    sappear: "",
    mappear: "1,5,6,8,21,",
    rappear: "3,9,11,",
    firstalpha: "ท"
  },
  {
    keyword: "ทรัพย์สินทางปัญญา",
    meaning:
      "ผลงานอันเกิดจากการประดิษฐ์ คิดค้น หรือสร้างสรรค์ของมนุษย์ ซึ่งเน้นที่ผลผลิตของสติปัญญาและความชำนาญ โดยไม่คำนึงถึงชนิดของการสร้างสรรค์หรือวิธีในการแสดงออก ทรัพย์สินทางปัญญาอาจแสดงออกในรูปแบบของสิ่งที่จับต้องได้ เช่น สินค้าต่างๆ หรือในรูปของสิ่งที่จับต้องไม่ได้ เช่น บริการ แนวคิดในการดำเนินธุรกิจ กรรมวิธีการผลิตทางอุตสาหกรรม เป็นต้น\r\n",
    source:
      "กรมทรัพย์สินทางปัญญา กระทรวงพาณิชย์. ความรู้เบื้องต้นเกี่ยวกับทรัพย์สินทางปัญญา, \r\n21 มิถุนายน 2562. \r\nhttps://www.ipthailand.go.th/images/633/book/basic_IP.pdf",
    sappear: 2,
    mappear: "3,4,5",
    rappear: 2,
    firstalpha: "ท"
  },
  {
    keyword: "ทรัพยากรทางทะเลและชายฝั่ง",
    meaning:
      "สิ่งที่มีอยู่หรือเกิดขึ้นตามธรรมชาติในบริเวณทะเล\r\nและชายฝั่ง รวมถึงพรุชายฝั่ง พื้นที่ชุ่มน้ำชายฝั่ง คลอง คูแพรก ทะเลสาบ และบริเวณพื้นที่ปากแม่น้ำ\r\nที่มีพื้นที่ติดต่อกับทะเลหรืออิทธิพลของน้ำทะเลเข้าถึง เช่น ป่าชายเลน ป่าชายหาด หาด ที่ชายทะเล\r\nเกาะ หญ้าทะเล ปะการัง ดอนหอย พืชและสัตว์ทะเล หรือสิ่งที่มนุษย์สร้างขึ้นเพื่อประโยชน์แก่ระบบนิเวศ\r\nทางทะเลและชายฝั่ง เช่น ปะการังเทียม แนวลดแรงคลื่น และการป้องกันการกัดเซาะชายฝั่ง",
    source:
      "พระราชบัญญัติส่งเสริมการบริหารจัดการทรัพยากรทางทะเลและชายฝั่ง พ.ศ. 2558. (2558, 26 มีนาคม). ราชกิจจานุเบกษา. เล่มที่ 132 ตอนที่ 21 ก หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2558/A/021/49.PDF",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword: "ทรัพยากรธรรมชาติ",
    meaning:
      "สิ่งต่างๆที่เกิดขึ้นเองตามธรรมชาติ และมนุษย์สามารถนำมาใช้ประโยชน์ได้ เช่น บรรยากาศ ดิน น้ำ ป่าไม้ ทุ่งหญ้า สัตว์ป่า แร่ธาตุ พลังงาน และกำลังแรงงานมนุษย์ เป็นต้น",
    source:
      "สารานุกรมไทยสำหรับเยาวชนฯ เล่มที่ 19. ความหมายของการจัดการทรัพยากรธรรมชาติและสิ่งแวดล้อม, 5 กรกฎาคม 2562. http://kanchanapisek.or.th/kp6/sub/book/book.php?book=19&chap=1&page=t19-1-infodetail02.html",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword: "ทรัพยากรน้ำ",
    meaning:
      "ของเหลวที่เกิดจากการรวมตัวกันของก๊าซไฮโดรเจน และก๊าซออกซิเจน น้ำเป็นสิ่งที่เกิดขึ้นเองตามธรรมชาติ มีการหมุนเวียนเคลื่อนที่จากที่แห่งหนึ่งไปยังอีกแห่งหนึ่ง และเปลี่ยนแปลงจากสถานะหนึ่งไปเป็นอีกสถานะหนึ่ง เช่น เป็นของแข็ง ของเหลว เป็นต้น การหมุนเวียนเปลี่ยนไปของน้ำนี้เรียกว่า วัฎจักร ของน้ำ",
    source:
      "สารานุกรมไทยสำหรับเยาวชนฯ เล่มที่ 21. ทรัพยากรน้ำ, 5 กรกฎาคม 2562. http://kanchanapisek.or.th/kp6/sub/book/book.php?book=21&chap=8&page=t21-8-infodetail09.html",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword: "ทรัพยากรมนุษย์",
    meaning:
      "ผลรวมของความรู้  ความชำนาญ  ความถนัดของประชากรทั้งหมดในประเทศ กล่าวได้ว่าทรัพยากรมนุษย์ คือ ผลรวมทั้งปริมาณและคุณภาพ ดังนี้ \r\n1. ผลรวมด้านปริมาณ คือ จำนวนและการกระจายของประชากรและกำลังงาน  \r\n2. ผลรวมด้านคุณภาพ คือ  ความรู้  ความชำนาญ  ความถนัด  คุณค่า  และแรงจูงใจ แนวความคิดที่เน้นคน (ทรัพยากรมนุษย์) เป็นศูนย์กลางของการพัฒนา คือ คนเป็นผู้บริหารจัดการปัจจัยที่เกี่ยวข้องแบบองค์รวม  ได้แก่  ครอบครัว  ชุมชน สังคม  เศรษฐกิจ  การเมือง  และทรัพยากรธรรมชาติและสิ่งแวดล้อม",
    source:
      "สำนักงานคณะกรรมการมาตรฐานการบริหารงานบุคคลส่วนท้องถิ่น. ( 2552). ทรัพยากรมนุษย์, 21 พฤศจิกายน 2562. \r\nhttp://www.local.moi.go.th/2009/article/209530.doc\r\n",
    sappear: 3,
    mappear: 2,
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword: "ทวิภาคี",
    meaning:
      "2 ฝ่าย,เรียกสัญญาระหว่างประเทศที่มีคู่สัญญา 2 ฝ่าย ว่า สัญญาทวิภาคี",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ทวิภาคี. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 1,
    mappear: 2,
    rappear: 5,
    firstalpha: "ท"
  },
  {
    keyword: "ทวิยุทธศาสตร์",
    meaning:
      "ยุทธศาสตร์ 2 ทาง ยุทธศาสตร์แรกเรียกว่ายุทธศาสตร์โลกาภิวัตน์พัฒนา ต้องส่งเสริมให้แข่งขันกับโลกข้างนอกได้ อีกด้านหนึ่งพบว่าประเทศไทยยังมีความเหลื่อมล้ำ ต้องแก้ไขกฎหมาย เพื่อแก้ปัญหาการจัดสรรผลประโยชน์แบบเดิมๆ เพื่อส่งเสริมการแข่งขันในระดับโลกและอุ้มชูคนที่ไม่ได้ไปแข่งขัน",
    source:
      "ศักดิ์สิทธิ์ ประดับศิลป์ สำนักข่าว กรมประชาสัมพันธ์. (2561). รายงานพิเศษ : การปฏิรูปกฎหมายจะทำให้ปัญหาความเหลื่อมล้ำภายในประเทศลดลงได้, 9 ตุลาคม 2562. http://thainews.prd.go.th/th/website_th/news/news_detail/WNPOL6102070010019",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ท"
  },
  {
    keyword: "ท่องเที่ยวเชิงเกษตร",
    meaning:
      "การท่องเที่ยวอีกรูปแบบหนึ่งที่ได้ทั้งความเพลิดเพลินและความรู้นำกลับไปประยุกต์ใช้หรือประกอบอาชีพได้ เหนืออื่นใดนี่คือการได้กลับไปค้นหา เรียนรู้ เข้าใจ ภาคภูมิใจกับอาชีพเกษตรกรรม รากฐานของแผ่นดินไทยที่เปี่ยมไปด้วยคุณค่า ภายใต้แนวคิด ปรัชญา องค์ความรู้ ภูมิปัญญาของบรรพบุรุษเกษตรกรไทย ได้สัมผัสกับวิถีชีวิตความเป็นอยู่ของชาวชนบท ขนบธรรมเนียม วัฒนธรรม ประเพณี รูปแบบกิจกรรม และการประกอบอาชีพทางการเกษตรที่หลากหลาย ทั้งวิถีดั้งเดิมจนถึงการใช้เทคโนโลยีขั้นสูง ท่ามกลางทัศนียภาพธรรมชาติที่สวยงาม บริหารจัดการโดยเกษตรกรและชุมชน ความประทับใจที่เกิดจากการได้ชม ชิม ซื้อผลิตภัณฑ์ และมีส่วนร่วมในกิจกรรมต่างๆ ก่อเกิดความรู้ ทักษะ และประสบการณ์แก่ผู้มาท่องเที่ยว ทั้งยังส่งผลให้เกิดรายได้แก่ชุมชน จากการจำหน่ายผลผลิตทางการเกษตร ผลิตภัณฑ์แปรรูป ค่าตอบแทนจากการให้บริการแก่นักท่องเที่ยว ",
    source:
      "เครือข่ายท่องเที่ยวเชิงเกษตรจังหวัดกลุ่มภาคกลางตอนล่าง. การท่องเที่ยวเชิงเกษตร, 8 กรกฎาคม 2562. http://agrotourismtavaravadee.com/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%97%E0%B9%88%E0%B8%AD%E0%B8%87%E0%B9%80%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%A7%E0%B9%80%E0%B8%8A%E0%B8%B4%E0%B8%87%E0%B9%80%E0%B8%81%E0%B8%A9%E0%B8%95%E0%B8%A3/",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ท"
  },
  {
    keyword: "ท่องเที่ยวเชื่อมโยงภูมิภาค",
    meaning:
      "โครงข่ายคมนาคมทั้งทางถนน ราง น้ำ และอากาศ และกรอบความร่วมมือกับประเทศเพื่อนบ้าน เพื่อการเชื่อมโยงเส้นทางการท่องเที่ยวภายในประเทศ อนุภูมิภาค และอาเซียนบนฐานอัตลักษณ์เดียวกัน เพื่อส่งเสริมให้เป็นจุดหมายปลายทางการท่องเที่ยวร่วมกัน",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. แผนแม่บทภายใต้ยุทธศาสตร์ชาติ(5) ประเด็น การท่องเที่ยว, 24 ตุลาคม 2562. http://nscr.nesdb.go.th/wp-content/uploads/2019/04/05-%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%97%E0%B9%88%E0%B8%AD%E0%B8%87%E0%B9%80%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%A7.pdf",
    sappear: 2,
    mappear: 5,
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword: "ท่องเที่ยวทางการแพทย์",
    meaning:
      "การที่บุคคลจากประเทศหนึ่งเดินทางไปอีกประเทศหนึ่ง โดยมีวัตถุประสงค์เพื่อเข้ารับ\r\nบริการทางการแพทย์ในประเทศนั้นๆ ซึ่งขณะอยู่ในประเทศเป้าหมายก็มีการทำกิจกรรมเชิงท่องเทียวพักผ่อน อาทิ ช้อปปิ้ง ชมเมือง ชิมอาหารท้องถิ่น ไปด้วยในคราวเดียวกัน",
    source:
      "มหาวิทยาลัยมหิดล. Strategic Health Tourism Management in Thailand,  24 กันยายน 2562. https://www.cm.mahidol.ac.th/program/ms/images/Latest_News/MS_News/2019-04-03-strategic-health-tourism-management-in-thailand/HealthTourismE-Book.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ท"
  },
  {
    keyword: "ท่องเที่ยวผู้สูงอายุ",
    meaning:
      "รูปแบบและพฤติกรรมท่องเที่ยวที่แตกต่างจากนักท่องเที่ยวทั่วไป คือ  เน้นการท่องเที่ยวและบริการที่มีคุณภาพดี คุ้มค่า เน้นการซื้อด้วยเหตุผลไม่ใช่อารมณ์ ให้ความสำคัญกับความพึงพอใจเป็นหลัก พักนานใช้จ่ายสูง มีความสามารถในการซื้อบริการในราคาสูง เนื่องจากมีเงินเก็บจากการทำงานหนักมาทั้งชีวิต จึงมีศักยภาพสูงในการบริโภค ขณะเดียวกันคำนึงถึงความมั่นใจด้านความปลอดภัย ความมั่นใจด้านบริการ ใส่ใจดูแลสุขภาพที่ดี เลือกกิจกรรมที่เหมาะกับวัยและสุขภาพ อีกทั้งนักท่องเที่ยวกลุ่มนี้ไม่ต้องกังวลต่อค่าใช้จ่ายในการเดินทาง เนื่องจากเป็นผู้มีประสบการณ์ในการใช้ชีวิต จึงมีความละเอียดรอบคอบในการเลือกซื้อสินค้าและบริการต่างๆ มากยิ่งขึ้น และเนื่องจากผู้สูงอายุมักมีข้อจำกัดในการเดินทางมากกว่าวัยหนุ่มสาว ดังนั้นการเตรียมความพร้อมในการรองรับตลาดกลุ่มนี้จึงต้องมีการศึกษาในรายละเอียดค่อนข้างมาก และควรมีการเตรียมการที่ดี",
    source:
      "จิราวดี รัตนไพฑูรย์ชัย สถาบันระหว่างประเทศเพื่อการค้าและการพัฒนา (ITD). (2557). ตลาดนักท่องเที่ยวผู้สูงอายุ : โอกาสใหม่ไทย เติบโตรับ AEC, 2 ตุลาคม 2562. http://www.itd.or.th/th/%E0%B8%95%E0%B8%A5%E0%B8%B2%E0%B8%94%E0%B8%99%E0%B8%B1%E0%B8%81%E0%B8%97%E0%B9%88%E0%B8%AD%E0%B8%87%E0%B9%80%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%A7%E0%B8%9C%E0%B8%B9%E0%B9%89%E0%B8%AA%E0%B8%B9/",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ท"
  },
  {
    keyword: "ทักษะในศตวรรษที่ 21",
    meaning:
      "กลุ่มความรู้  ทักษะ และนิสัยการทำงาน ที่เชื่อว่ามีความสำคัญยิ่งต่อความสำเร็จในการเรียนรู้ตลอดชีวิต ทักษะดังกล่าวนี้เป็นผลจากการพัฒนากรอบความคิดการเรียนรู้ในศตวรรษที่ 21 (21st Century Learning Framework) โดยภาคีเพื่อทักษะแห่งศตวรรษที่ 21  (The Partnership for 21st  Century Skills)  เบอร์นี ทริลลิง และชาลส์ แฟเดล (Bernie Trilling & Charles Fadel)  ได้เสนอในหนังสือ  21st Century Skills: Learning for Life in Our Times (2009) เป็นสมการ    3Rs ´ 7Cs  =  ทักษะแห่งศตวรรษที่ 21  โดย 3Rs ประกอบด้วย ทักษะการรู้หนังสือ ได้แก่  Reading (ทักษะการอ่าน),  Writing (’Riting-ทักษะการเขียน) และ  Arithmetic  (’Rithmetic-ทักษะเลขคณิต)  ส่วน 7Cs  ประกอบด้วย ทักษะ 7 ด้าน คือ (1) ด้านการคิดอย่างมีวิจารณญาณและการแก้ปัญหา (critical thinking and problem solving)   (2) ด้านการสื่อสารสารสนเทศและการรู้เท่าทันสื่อ (communications, information, and media literacy)   (3) ด้านความร่วมมือ การทำงานเป็นทีมและภาวะผู้นำ (collaboration, teamwork and leadership)  (4) ด้านการสร้างสรรค์และนวัตกรรม (creativity and innovation)  (5) ด้านคอมพิวเตอร์ และเทคโนโลยีสารสนเทศและการสื่อสาร (computing and ICT literacy  (6) ด้านการทำงาน การเรียนรู้ และการพึ่งตนเอง (career and learning self–reliance) และ (7) ด้านความเข้าใจต่างวัฒนธรรม \r\nต่างกระบวนทัศน์ (cross–cultural understanding)",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2557). ทักษะแห่งศตวรรษที่ ๒๑, 3 กันยายน 2562. http://www.royin.go.th/?knowledges=%E0%B8%97%E0%B8%B1%E0%B8%81%E0%B8%A9%E0%B8%B0%E0%B9%81%E0%B8%AB%E0%B9%88%E0%B8%87%E0%B8%A8%E0%B8%95%E0%B8%A7%E0%B8%A3%E0%B8%A3%E0%B8%A9%E0%B8%97%E0%B8%B5%E0%B9%88-%E0%B9%92%E0%B9%91",
    sappear: "",
    mappear: 11,
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword: "ทักษะการรู้ดิจิทัล",
    meaning:
      "ทักษะในการนำเครื่องมือ อุปกรณ์ และเทคโนโลยีดิจิทัลที่มีอยู่ในปัจจุบัน อาทิ คอมพิวเตอร์ โทรศัพท์ แทปเลต โปรแกรมคอมพิวเตอร์ และสื่อออนไลน์ มาใช้ให้เกิดประโยชน์สูงสุด ในการสื่อสาร การปฏิบัติงาน และการทำงานร่วมกัน หรือใช้เพื่อพัฒนากระบวนการทำงาน หรือระบบงานในองค์กรให้มีความทันสมัยและมีประสิทธิภาพ ทักษะดังกล่าวครอบคลุมความสามารถ 4 มิติ\r\n 1.การใช้ (Use)\r\n 2.เข้าใจ (Understand)\r\n 3.การสร้าง (create)\r\n 4.เข้าถึง (Access) เทคโนโลยีดิจิทัล ได้อย่างมีประสิทธิภาพ",
    source:
      "สำนักงานคณะกรรมการข้าราชการพลเรือน (สำนักงาน ก.พ.). Digital literacy คืออะไร, 18 กรกฎาคม 2562. https://www.ocsc.go.th/DLProject/mean-dlp",
    sappear: "",
    mappear: 12,
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword: "ทักษะด้านดิจิทัล",
    meaning:
      "ความสามารถในการเรียนรู้ เข้าใจ และนำเทคโนโลยีดิจิทัลมาใช้ในการดำเนินงาน\r\nเช่น \r\n- รู้เท่าทันและใช้เทคโนโลยีให้เกิดประโยชน์\r\n- เข้าใจนโยบาย กฎหมายและมาตรฐาน \r\n- ใช้ดิจิทัลเพื่อการประยุกต์และพัฒนา\r\n- ใช้ดิจิทัลเพื่อการวางแผน บริหารจัดการ และนำองค์กร \r\n- ใช้ดิจิทัลเพื่อขับเคลื่อนการเปลี่ยนแปลงและสร้างสรรค์ เป็นต้น",
    source:
      "สำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน). นิยามศัพท์แบบสำรวจระดับความพร้อมรัฐบาลดิจิทัลหน่วยงานภาครัฐของประเทศไทย ประจำปี 2562,12 กรกฎาคม 2562. https://www.dga.or.th/upload/download/file_5017b7c2653e33f74099c3563e942e1c.pdf",
    sappear: "",
    mappear: 11,
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword: "ทัศนคติ",
    meaning: "แนวความคิดเห็น",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ทัศนคติ. 23 กรกฎาคม 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ท"
  },
  {
    keyword: "ทัศนศิลป์",
    meaning:
      "ศิลปกรรมประเภทหนึ่งซึ่งแสดงออกด้วยลักษณะที่เป็นรูปภาพหรือรูปทรง รับรู้ได้ด้วยการเห็นและสัมผัสได้ด้วยการจับต้อง เช่น ภาพจิตรกรรม ภาพพิมพ์ งานประติมากรรม งานสถาปัตยกรรม",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ทัศนศิลป์. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ท"
  },
  {
    keyword: "ท่าเรือ",
    meaning: "สถานที่สำหรับให้บริการแก่เรือในการจอด เทียบ บรรทุก หรือขนถ่ายของ",
    source:
      "พระราชบัญญัติส่งเสริมการพาณิชยนาวี พ.ศ. 2521. (2521, 18 ธันวาคม). ราชกิจจานุเบกษา. เล่ม 95 ตอนที่ 143 หน้า 3. http://www.ratchakitcha.soc.go.th/DATA/PDF/2521/A/143/1.PDF",
    sappear: "",
    mappear: 5,
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword:
      "ทำเนียบการปลดปล่อยและเคลื่อนย้ายมลพิษ (PRTR)                                        ",
    meaning:
      "ระบบฐานข้อมูล เกี่ยวกับชนิดและปริมาณมลพิษ ซึ่งมิใช่ความเข้มข้นของสารที่มีการปลดปล่อยจากแหล่งกำเนิด เช่น โรงงานอุตสาหกรรม สู่สิ่งแวดล้อม ทั้งอากาศ ดิน และน้ำ รวมทั้งข้อมูลเกี่ยวกับการขนย้ายน้ำเสียและของเสียออกนอกสถานประกอบการเพื่อบำบัดหรือกำจัด ซึ่งเผยแพร่สู่สาธารณชนผ่านทางอินเตอร์เน็ต",
    source:
      "กรมควบคุมมลพิษ กระทรวงทรัพยากรธรรมชาติและสิ่งแวดล้อม. (2561). ทำเนียบการปลดปล่อยและเคลื่อนย้ายมลพิษ (Pollutant Release and Transfer Registers: PRTR), 24 ตุลาคม 2562. http://www.pcd.go.th/Info_serv/pol_maptapoot_wastePRTR.html",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ท"
  },
  {
    keyword: "ทีมภาคีเครือข่ายแนวราบ/แนวดิ่ง",
    meaning:
      "- รูปแบบตามแนวดิ่ง เป็นโครงสร้างเครือข่ายตามอำนาจหน้าที่ที่มีการจัดลำดับขั้นลดหลั่นกันลงไปตามโครงสร้างบังคับบัญชาแบบลำดับชั้น โดยมีแกนนำซึ่งเป็นผู้นำเครือข่ายและผู้มีอำนาจในการสั่งการ หรือระดมมวลชนสมาชิกในเครือข่ายให้ มาร่วมดำเนินกิจกรรมต่างๆ ของเครือข่าย โดยสมาชิกมีหน้าที่รับการถ่ายทอดคำสั่งเท่านั้น\r\n- รูปแบบตามแนวราบ เป็นโครงสร้างเครือข่ายที่เน้นการประสานงาน/การมอบหมายงานและความร่วมมือในแนวราบเป็นหลัก อาศัยความสัมพันธ์ระหว่างแกนนำที่เป็นจุดเชื่อมต่อ (Node) ของแต่ละเครือข่าย ซึ่งส่วนใหญ่เป็นลักษณะกลไกบริหารเครือข่ายของกลุ่ม/เครือข่ายประชาคมเพื่อสุขภาพ โครงสร้างเครือข่ายแบบนี้จึงให้ความสำคัญกับแกนนำหรือผู้นำเครือข่าย ซึ่งภาวะผู้นำของเครือข่ายมีความสำคัญมากในการผลักดันไปสู่ความสำเร็จของผลงาน ทั้งนี้ การใช้ภาวะผู้นำในการขับเคลื่อน เป็นการอาศัยทุนทางสังคมที่มี อยู่เดิมในรูปของความสัมพันธ์เชิงเครือญาติ และความสัมพันธ์ฉันท์มิตรในการประสานงานและขอความร่วมมือในการดำเนินงาน",
    source:
      "กองสุขศึกษา กรมสนับสนุนบริการสุขภาพ กระทรวงสาธารณสุข. (2556). การสร้างเครือข่ายและการมีส่วนร่วมในการปรับเปลี่ยนพฤติกรรมสุขภาพของชุมชน, 10 กันยายน 2562.http://www.hed.go.th/linkhed/file/91",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ท"
  },
  {
    keyword: "ที่สาธารณะ",
    meaning:
      "สาธารณสมบัติของแผ่นดินนอกจากที่รกร้างว่าง\r\nเปล่า และหมายความรวมถึงถนนและทางน้ำด้วย",
    source:
      "พระราชบัญญัติรักษาความสะอาดและความเป็นระเบียบเรียบร้อยของบ้านเมือง พ.ศ. 2534. (2534, 28 กุมภาพันธ์). ราชกิจจานุเบกษา. เล่มที่109 ตอนที่ 15 หน้า 29. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/015/28.PDF",
    sappear: "",
    mappear: 12,
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword: "ทุจริตต่อหน้าที่",
    meaning:
      "ปฏิบัติหรือละเว้นการปฏิบัติอย่างใดในตําแหน่งหรือหน้าที่ หรือปฏิบัติหรือละเว้นการปฏิบัติอย่างใดในพฤติการณ์ที่อาจทําให้ผู้อื่นเชื่อว่ามีตําแหน่งหรือหน้าที่ ทั้งที่ตนมิได้มีตําแหน่งหรือหน้าที่นั้น หรือใช้อํานาจในตําแหน่งหรือหน้าที่ ทั้งนี้ เพื่อแสวงหาประโยชน์ ที่มิควรได้โดยชอบสําหรับตนเองหรือผู้อื่น หรือกระทําการอันเป็นความผิดต่อตําแหน่งหน้าที่ราชการหรือความผิดต่อตําแหน่งหน้าที่ในการยุติธรรมตามประมวลกฎหมายอาญาหรือตามกฎหมายอื่น",
    source:
      "พระราชบัญญัติประกอบรัฐธรรมนูญว่าด้วยการป้องกันและปราบปรามการทุจริต พ.ศ. 2561. (2561, 21 กรกฎาคม). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 52 ก หน้า 4. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/052/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "ท"
  },
  {
    keyword:
      "ทุนการศึกษาเพื่อพัฒนาฝีมือแรงงาน (Central Scholarship Coordinating Agency : CSCA)",
    meaning:
      "การให้โอกาสแก่ประชาชนที่มีรายได้ต่ำ เพื่อให้สามารถเข้าถึงโอกาส ที่อาจไม่ได้รับโดยลำพังจากการศึกษาขั้นพื้นฐาน เพื่อให้มีการเข้าถึงปัญหาอย่างเป็นระบบ และส่งเสริมให้ภาคเอกชนเข้ามามีส่วนร่วมในการพัฒนาแรงงานที่อาจมีพื้นฐานมาจากครอบครัวที่มีฐานะทางเศรษฐกิจที่ไม่ดี เพื่อให้มีโอกาสเข้าสู่ตลาดแรงงานที่ให้ผลตอบแทนที่สูงขึ้น และที่สำคัญที่สุดคือเพื่อให้สามารถเพิ่มความคล่องตัวในการไต่ลำดับของสถานะทางเศรษฐกิจและสังคม (social and economic mobility)",
    source:
      "กระทรวงดิจิทอลเพื่อเศรษฐกิจและสังคม. การปฏิรูปด้านความเท่าเทียมและการเติบโตอย่างมีส่วนร่วม, 4 กันยายน 2562. http://www.mdes.go.th/assets/portals/1/files/610611_5_3%E0%B9%80%E0%B8%A8%E0%B8%A3%E0%B8%A9%E0%B8%90%E0%B8%81%E0%B8%B4%E0%B8%88.docx",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ท"
  },
  {
    keyword: "ทุนข้ามชาติ",
    meaning:
      "การที่รัฐบาลหรือเอกชนของประเทศหนึ่งนำเงินไปลงทุนดำเนินธุรกิจเพื่อแสวงหาผลประโยชน์ในอีกประเทศหนึ่ง โดยคาดว่าจะได้รับผลตอบแทนที่สูงกว่าการลงทุนภายในประเทศของตน รวมทั้งเพื่อกระจายความเสี่ยงจากการลงทุนภายในประเทศ",
    source:
      "รองศาสตราจารย์(พิเศษ) ดร.จักรกฤษณ์ ดวงพัสตรา. ประเทศไทยกับการลงทุนระหว่างประเทศ,  9 ธนวาคม 2562. https://www.stou.ac.th/schoolsweb/sec/UploadedFile/60341-5.pdf",
    sappear: 1,
    mappear: "",
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword: "ทุนทางวัฒนธรรม",
    meaning:
      "มรดกภูมิปัญญาทางวัฒนธรรมของชาติ แบ่งตามรูปธรรมและนามธรรมออกได้เป็น 2 ลักษณะ คือ ที่จับต้องได้ (Tangible) และที่จับต้องไม่ได้ (Intangible) ซึ่งกรมส่งเสริมวัฒนธรรม กระทรวงวัฒนธรรม ได้กำหนดไว้มี 6 สาขา ได้แก่ 1) ภาษา และวรรณกรรมพื้นบ้าน 2) ศิลปะการแสดง 3) แนวทางปฏิบัติทางสังคม พิธีกรรม และงานเทศกาล 4) งานช่างฝีมือดั้งเดิม 5) ความรู้และแนวปฏิบัติเกี่ยวกับธรรมชาติและจักรวาล และ 6) กีฬาภูมิปัญญาไทย",
    source:
      "กรมส่งเสริมวัฒนธรรม.(2562), วัฒนธรรม คุณค่าสู่มูลค่า, 10 ตุลาคม 2562. http://www.culture.go.th/culture_th/ewt_news.php?nid=3972&filename=index",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword: "ทุนทางศิลปวัฒนธรรม",
    meaning:
      "รูปแบบของโบราณสถาน โบราณวัตถุ ศิลปะวัตถุ และงานศิลปกรรมต่างๆ ที่บรรพบุรุษได้สร้างสรรค์สั่งสมไว้สืบทอดมาเป็นมรดกวัฒนธรรมให้แก่อนุชนคนรุ่นหลัง ",
    source:
      "กรมส่งเสริมวัฒนธรรม กระทรวงวัฒนธรรม. (2562). วัฒนธรรมคุณค่าสู่มูลค่า วัฒนธรรมเป็นยุทธศาสตร์ที่สร้างมูลค่า สร้างเศรษฐกิจและสร้างชาติได้จริงหรือ?, 1 พฤษศิจายน 2562. http://www.culture.go.th/culture_th/ewt_news.php?nid=3972&filename=index",
    sappear: "",
    mappear: 15,
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword: "ทุนทางสังคม",
    meaning:
      "การรวมตัว ร่วมคิด ร่วมทำ บนฐานของความไว้เนื้อเชื่อใจ สายใยความผูกพัน และวัฒนธรรมที่ดีงามของสังคมไทยผ่านระบบความสัมพันธ์ ในองค์ประกอบหลัก ได้แก่ คน สถาบัน วัฒนธรรม และองค์ความรู้ ซึ่งจะเกิด เป็นพลังในชุมชนและสังคม",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. การเสริมสร้างทุนทางสังคมเพื่อการพัฒนาที่ยั่งยืนในแผนพัฒนาฯ10, 18 กรกฎาคม 2562. https://www.nesdc.go.th/download/plan10/23.pdf",
    sappear: "",
    mappear: "15,17",
    rappear: "",
    firstalpha: "ท"
  },
  {
    keyword: "ทุพพลภาพ",
    meaning:
      "การสูญเสียอวัยวะหรือสูญเสียสมรรถภาพของอวัยวะหรือของร่างกาย หรือสูญเสียสภาวะปกติของจิตใจ จนทําให้ความสามารถในการทํางานลดลงถึงขนาดไม่อาจประกอบการงานตามปกติได้ ทั้งนี้ ตามหลักเกณฑ์ที่เลขาธิการประกาศกําหนดโดยคําแนะนําของคณะกรรมการการแพทย์",
    source:
      "พระราชบัญญัติประกันสังคม (ฉบับที่ 4) พ.ศ. 2558. (2558, 22 มิถุนายน). ราชกิจจานุเบกษา. เล่ม 132 ตอนที่ 53 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2558/A/053/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ท"
  },
  {
    keyword: "ธนาคารเฉพาะกิจของภาครัฐ",
    meaning:
      "สถาบันการเงินของรัฐที่มีกฎหมายเฉพาะจัดตั้งขึ้น เพื่อดำเนินการตามนโยบายของรัฐในการพัฒนาส่งเสริมเศรษฐกิจ และสนับสนุนการลงทุนต่าง ๆ โดยอยู่ภายใต้การกำกับดูแลของกระทรวงการคลัง ซึ่งได้มอบหมายให้ ธปท. ทำหน้าที่ตรวจสอบผลการดำเนินงานและความเสี่ยง และรายงานผลการตรวจสอบไปยังรัฐมนตรีว่าการกระทรวงการคลัง",
    source:
      "ศูนย์คุ้มครองผู้ใช้บริการทางการเงิน (ศคง.). สถาบันการเงินเฉพาะกิจ (Specialized Financial Institutions : SFIs), 18 กรกฎาคม 2562. https://www.1213.or.th/th/aboutfcc/finservices/Pages/SFIs.aspx",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ธ"
  },
  {
    keyword: "ธนาคารคลังสมอง",
    meaning:
      "เป็นศูนย์รวมผู้ทรงคุณวุฒิในสาขาอาชีพต่าง ๆ ที่เกษียณอายุแล้ว  ที่มีความพร้อมและสมัครใจที่จะนำปัญญา ความรู้ และประสบการณ์ มาช่วยพัฒนาประเทศโดยไม่หวังผลตอบแทนส่วนตัว  แต่มุ่งถึงผลประโยชน์ส่วนรวมของประเทศชาติ",
    source:
      "ธนาคารสมอง วุฒิอาสา (Senior Volunteer) สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ.\r\nhttp://brainbank.nesdc.go.th/Default.aspx?tabid=128",
    sappear: "",
    mappear: 11,
    rappear: "",
    firstalpha: "ธ"
  },
  {
    keyword: "ธนาคารความหลากหลายทางชีวภาพแห่งชาติ",
    meaning:
      " หน่วยงานกลางที่ทำหน้าที่ประสานและบริหารจัดการด้านต่างๆ ดังนี้\r\n1. การจัดทำบัญชีรายการความหลากหลายทางชีวภาพในภาพรวมของประเทศ(Inventories Listing) เพื่อประเมินสถานภาพและเป็นข้อมูลสำหรับการกำหนดนโยบายของรัฐบาลและหน่วยงานที่ต้องรายงานต่อ CBD โดยการกำหนดมาตรฐานของข้อมูลในการเก็บบันทึกข้อมูลสิ่งมีชีวิตแต่ละชนิด มีการตรวจสอบและยืนยันข้อมูลแล้ว\r\n2. กำหนดรูปแบบการจัดเก็บเชื้อพันธุ์ความหลากหลากหลายทางชีวภาพในรูปแบบตัวจริง ตัวอย่างแห้ง ของสิ่งมีชีวิตทุกประเภท (Collections) ทั้งที่พบในป่า พิพิธภัณฑ์ (natural Museum)สวนพฤกษศาสตร์ (botanical garden) ธนาคารเมล็ดพันธุ์ (seed bank) หรือ เซลล์สัตว์ ไปจนถึงการเก็บรักษาในรูปแบบเนื้อเยื่อ เพื่อการเก็บรักษาระยะยาว ( biodiversiry Repository) รวมไปสิ่งการเก็บรักษาชิ้นส่วนทางพันธุกรรมในรูปแบบ DNA/RNA /whole genome บันทึกการแลกเปลี่ยนตามกฎหมาย การกำหนดนโยบาย สถานที่สำรองในการเก็บรักษาเพื่อความปลอดภัย โดยเน้นที่ต้นน้ำและทุกส่วนของ organism เท่านั้น \r\n3. กำหนดมาตรฐานและจัดทำระบบฐานข้อมูลกลาง (Biodiversity Information canter) โดยมีมาตรฐานโครงสร้างข้อมูล (Standard data set) ให้ทุกหน่วยงานและนักวิชาการดำเนิน การบันทึก จัดหาเครื่องมืออุปกรณ์ทางเทคโนโลยีสารสนเทศ เพื่อรองรับการประเมินผล จัดทำระดับชั้นความลับและการเข้าถึง รวมไปถึงการเชื่อมโยง ระบบฐานข้อมูลความหลากหลายทางชีวภาพกับหน่วยงานที่มีการจัดเก็บและเป็นเจ้าของข้อมูลหรือหน่วยงานหลักในการเก็บรักษาสิ่งมีชีวิต \r\n4. สนับสนุนและกำหนดทิศทางงบประมาณในการวิจัย (Biodiversity Research Center) ตั้งแต่การสำรวจ การเก็บรักษาเพื่อการคงอยู่ของทรัพยากร และการใช้ประโยชน์จากเชื้อพันธุกรรมรวมถึงการสนับสนุนการพัฒนาศักยภาพของบุคลากรที่เกี่ยวข้อง",
    source:
      "สำนักงานเลขาธิการสภาผู้แทนราษฎร ปฏิบัติหน้าที่สำนักงานเลขาธิการสภาขับเคลื่อนการปฏิรูปประเทศ. (2560). “เศรษฐกิจอนาคต” (เศรษฐกิจชีวภาพ), 9 ตุลาคม 2562. https://library2.parliament.go.th/giventake/content_nrsa2558/d040360-02.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ธ"
  },
  {
    keyword: "ธนาคารทรัพยากรชีวภาพแห่งชาติ",
    meaning:
      "แหล่งเก็บรักษาทรัพยากรชีวภาพไว้นอกสภาพธรรมชาติ เพื่อควบคุมคุณภาพ และบำรุงรักษาให้คงสภาพมีชีวิตได้ยาวนาน สำหรับเป็นแหล่งวัตถุดิบต้นทางที่มีข้อมูลวิทยาศาสตร์ครบถ้วน เพื่อการใช้ประโยชน์ในอุตสาหกรรมและในระดับชุมชน ได้อย่างมีประสิทธิภาพ รวดเร็ว และยั่งยืน",
    source:
      "สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ. (2561). Biobank ต้นทุนอนาคตของชาติ, 16 ตุลาคม 2562. http://nstdachannel.tv/20180327-biobank/",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "ธ"
  },
  {
    keyword: "ธนาคารหน่วยกิต",
    meaning:
      "ระบบทะเบียนเฉพาะสำหรับผู้เรียนที่เข้าศึกษาในรายวิชา ต่างๆ หลักสูตรระยะสั้น หลักสูตรฝึกอบรม หรือหลักสูตรระยะยาวในระดับอนุปริญญา หรือปริญญาตรีของ สถาบันอุดมศึกษาที่จัดไว้สำหรับการจัดการศึกษาในระบบธนาคารหน่วยกิตโดยจัดให้มีสมุดสะสม หน่วยกิตสำหรับผู้เรียนให้สามารถนำผลการเรียนและผลการเรียนรู้มาสะสมหน่วยกิตและฝากในธนาคารหน่วยกิต ของสถาบันอุดมศึกษาได้โดยไม่จำกัดระยะเวลาในการสะสมหน่วยกิต และระยะเวลาในการเรียน",
    source:
      "การจัดการความรู้ มหาวิทยาลัยเทคโนโลยีราชมงคลล้านนา. (2558). “ธนาคารหน่วยกิต” Credit bank system for Life long Education, 2 กรกฎาคม 2562. https://kaewpanya.rmutl.ac.th/km/?p=325",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "ธ"
  },
  {
    keyword: "ธรณีวิทยา",
    meaning: "วิชาว่าด้วยความรู้เกี่ยวกับประวัติ โครงสร้าง และสภาพของโลก",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ธรณีวิทยา. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ธ"
  },
  {
    keyword: "ธรรมนูญชุมชน",
    meaning:
      "ธรรมนูญที่เกิดขึ้นในระดับชุมชน คนในชุมชนร่วมกันออกแบบ และกำหนดข้อตกลงและการปฏิบัติ โดยการยอมรับร่วมกันของคนในชุมชน คนในพื้นที่นั้น ๆ เช่น ระเบียบ ข้อบังคับในการใช้ที่ดินหรือทรัพยากรหมู่บ้าน",
    source:
      "ชุดความรู้การจัดทำธรรมนูญตำบลสู่การจัดการตนเอง หน้า 4 โดยสถาบันพัฒนาองค์กรชุมชน (องค์การมหาชน)\r\nhttps://www.codi.or.th/attachments/article/14956/book-KNOW-180859.pdf",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ธ"
  },
  {
    keyword: "ธรรมาธิปไตย",
    meaning: "การถือธรรมเป็นใหญ่, การถือความถูกต้องเป็นหลัก",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ธรรมาธิปไตย. 23 กรกฎาคม 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ธ"
  },
  {
    keyword: "ธรรมาภิบาล",
    meaning:
      "หลักการบริหารจัดการที่ดี อันเกี่ยวข้องกับนโยบายของส่วนราชการและพฤติกรรมของบุคลากรในองค์การ สำหรับรัฐบาลไทย ได้วางหลักของการบริหารจัดการบ้านเมืองที่ดีไว้ว่า ประกอบด้วยหลักการ 6 ประการ ได้แก่ 1) หลักนิติธรรม2) หลักคุณธรรม 3) หลักความโปร่งใส 4) หลักการมีส่วนร่วม 5) หลักสำนึกรับผิดชอบ และ 6) หลักความคุ้มค่า",
    source:
      "สถาบันพระปกเกล้า.ธรรมาภิบาล, 29 มิถุนายน 2562. http://wiki.kpi.ac.th/index.php?title=%E0%B8%98%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B8%B2%E0%B8%A0%E0%B8%B4%E0%B8%9A%E0%B8%B2%E0%B8%A5",
    sappear: "4,5",
    mappear: "1,2,18",
    rappear: 3,
    firstalpha: "ธ"
  },
  {
    keyword: "ธรรมาภิบาลในการบริหารจัดการน้ำ",
    meaning:
      "ทรัพยากรแหล่งน้ำเป็นทรัพยากรพื้นฐานในการพัฒนาประเทศ และเป็นทรัพยากรที่มีความสำคัญต่อการดำรงชีวิตของมนุษย์ อย่างไรก็ตาม จากการขยายตัวของภาคการเกษตร อุตสาหกรรม ท่องเที่ยวและบริการ รวมถึงการเพิ่มขึ้นของจำนวนประชากร และความไม่แน่นอนของการเปลี่ยนแปลงสภาพอากาศ ได้ส่งผลให้ปัญหาเกี่ยวกับทรัพยากรนามีความหลากหลายและมีแนวโน้มทวีความรุนแรงเพิ่มมากขึ้น แนวทางการบริหารจัดการทรัพยากรนาแบบผสมผสาน (Integrated Water Resources Management : IWRM) ได้ถูกประยุกต์ใช้ในหลายประเทศ โดยได้มีการจัดตั้งหน่วยงานที่รับผิดชอบ จัดทำนโยบายด้านการบริหารจัดการทรัพยากรน้ำ รวมถึงการปฏิรูปกฎหมายที่เกี่ยวข้อง เพื่อทำให้เกิดสภาพแวดล้อมที่เอื้ออำนวย (Enabling Environment) ต่อการบริหารจัดการ ซึ่งการดำเนินการดังกล่าวมีส่วนสัมพันธ์กับการมีธรรมาภิบาลในการจัดการน้ำ (Water Governance)",
    source:
      "ศูนย์สารสนเทศสิ่งแวดล้อม กรมส่งเสริมคุณภาพสิ่งแวดล้อม กระทรวงทรัพยากรธรรมชาติและสิ่งแวดล้อม. (2559). การจัดการน้ำ, 30 ตุลาคม 2562. http://www.environnet.in.th/archives/1480",
    sappear: 5,
    mappear: 19,
    rappear: "",
    firstalpha: "ธ"
  },
  {
    keyword: "ธรรมาภิบาลด้านสิ่งแวดล้อม",
    meaning:
      "การบริหารจัดการที่มีความโปร่งใส ความยุติธรรม และการมีส่วนร่วมของประชาชนในการจัดการทรัพยากรธรรมชาติและสิ่งแวดล้อม ซึ่งการมีส่วนร่วมของประชาชนจะเป็นแรงผลักดันที่ทำให้เกิดกระบวนการตัดสินใจที่เหมาะสม ทั้งในระดับนโยบายและการปฏิบัติที่ดีในการแก้ปัญหาทรัพยากรและสิ่งแวดล้อม ซึ่งมีการดำเนินการ 7 หลัก ดังนี้\r\n 1. ประชาชนเข้าถึงข้อมูลข่าวสาร\r\n 2. ประชาชนมีส่วนร่วมในการแก้ปัญหา\r\n 3. ความโปร่งใส\r\n 4. ความรับผิดชอบต่อสังคม\r\n 5. นิติธรรม\r\n 6. ความยุติธรรม\r\n 7. ความยั่งยืน\r\n",
    source:
      "คณะทำงานพัฒนาคุณภาพ การบริหารจัดการภาครัฐ จังหวัดสมุทรปราการ. องค์ความรู้การส่งเสริมอุตสาหกรรมเชิงนิเวศน์เป็นมิตรกับสิ่งแวดล้อมและชุมชน, 9 กันยายน 2562. http://www.samutprakan.go.th/newweb/index.php?option=com_phocadownload&view=category&download=143:2013-02-22-10-48-50&id=13:-km&Itemid=43",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ธ"
  },
  {
    keyword: "ธุรกรรม",
    meaning:
      "กิจกรรมที่เกี่ยวกับการทำนิติกรรม สัญญาหรือการดำเนินการใด ๆ กับผู้อื่น ทางการเงิน ทางธุรกิจ หรือการดำเนินการเกี่ยวกับทรัพย์สิน\r\n",
    source:
      "พระราชบัญญัติป้องกันและปราบปรามการฟอกเงิน พ.ศ. 2542 (2542,2 เมษายน) ราชกิจจานุเบกษา.เล่ม 116 ตอนที่ 29 ก  หน้า 46 http://www.ratchakitcha.soc.go.th/DATA/PDF/2537/A/059/1.PDF",
    sappear: "",
    mappear: 3,
    rappear: "",
    firstalpha: "ธ"
  },
  {
    keyword: "ธุรกรรมออนไลน์",
    meaning:
      "กิจกรรมใด ๆ ที่กระทำขึ้นระหว่างหน่วยธุรกิจ บุคคล รัฐ ตลอดจนองค์กรเอกชนหรือองค์กรของรัฐใด ๆ เพื่อวัตถุประสงค์ทางธุรกิจ การค้า และการติดต่องานราชการ โดยใช้วิธีการทางอิเล็กทรอนิกส์ทั้งหมดหรือแต่บางส่วน",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์. (2559). อีคอมเมิร์ซ, 12 กันยายน 2562. https://www.etda.or.th/terminology-detail/อีคอมเมิร์ซ.html\r\n",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ธ"
  },
  {
    keyword: "ธุรกิจ",
    meaning:
      "กิจการในทางเกษตรกรรม อุตสาหกรรม พาณิชยกรรม\r\nการบริการ หรือกิจการอื่นที่มีลักษณะคล้ายคลึงกัน\r\n",
    source:
      "พระราชบัญญัติว่าด้วยราคาสินค้าและบริการ พ.ศ. 2542 (2542,31 มีนาคม)  ราชกิจจานุเบกษา. เล่ม 116 ตอนที่ 22 ก หน้า 18 http://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/022/23.PDF",
    sappear: "",
    mappear: 5,
    rappear: "",
    firstalpha: "ธ"
  },
  {
    keyword: "ธุรกิจ start-up",
    meaning:
      "กลุ่มบุคคลหรือองค์กรธุรกิจขนาดเล็กที่จัดตั้งขึ้นด้วยบุคลากรและทรัพยากรจำนวนน้อย แต่มีความคิดที่ต้องการสร้างสรรค์นวัตกรรมใหม่ที่สามารถเปลี่ยนแปลงโลกด้วยเทคโนโลยีสารสนเทศ หรือ IT",
    source:
      "กระทรวงอุตสาหกรรม. (2559). Startup, 9 กันยายน 2562. http://www.industry.go.th/industry/index.php/th/knowledge/item/10604-startup",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ธ"
  },
  {
    keyword: "ธุรกิจเพื่อสังคม",
    meaning:
      "บริษัท ห้างหุ้นส่วนนิติบุคคล หรือนิติบุคคลอื่น ที่ตั้งขึ้นตามกฎหมายไทย ซึ่งดำเนินกิจการเกี่ยวกับการผลิต การจำหน่ายสินค้าหรือการบริการ โดยมีวัตถุประสงค์เพื่อสังคมเป็นเป้าหมายหลักของกิจการ และได้รับการจดทะเบียนตามพระราชบัญญัติส่งเสริมวิสาหกิจเพื่อสังคม พ.ศ. ๒๕๖๒",
    source:
      "พระราชบัญญัติส่งเสริมวิสาหกิจเพื่อสังคมพ.ศ. 2562 (2562, 19 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 67ก หน้า 33, 1 สิงหาคม 2562. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/067/T_0032.PDF",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "ธ"
  },
  {
    keyword: "ธุรกิจขนาดกลาง",
    meaning:
      "กิจการที่จำนวนการจ้างงานหรือมูลค่าสินทรัพย์ถาวรสุทธิไม่รวมที่ดิน ดังนี้\r\nประเภท กิจการการผลิต จำนวน 51-200 (คน) สินทรัพย์ถาวรเกินกว่า 50-200 (ล้านบาท)\r\nประเภท กิจการบริการ จำนวน 51-200 (คน) สินทรัพย์ถาวรเกินกว่า 50-200 (ล้านบาท)\r\nประเภทกิจการค้าส่ง จำนวน 26-50 (คน) สินทรัพย์ถาวรเกินกว่า 50-100 (ล้านบาท)\r\nประเภทกิจการค้าปลีก จำนวน 16-30 (คน) สินทรัพย์ถาวรเกินกว่า 30-60 (ล้านบาท)",
    source:
      "ธนาคารแห่งประเทศไทย. ธุรกิจขนาดกลางและย่อม (SMEs) และการให้สินเชื่อแก่ SMEs, 30 ตุลาคม 2562. https://www.bot.or.th/Thai/FinancialInstitutions/Highlights/FSMP1/QA_TB.pdf",
    sappear: "",
    mappear: 8,
    rappear: "",
    firstalpha: "ธ"
  },
  {
    keyword: "ธุรกิจขนาดย่อม",
    meaning:
      "กิจการที่มีจำนวนการจ้างงานหรือมูลค่าสินทรัพย์ถาวรสุทธิไม่รวมที่ดิน ดังนี้\r\nประเภทกิจการการผลิต จำนวนไม่เกิน 50 (คน) สินทรัพย์ถาวรไม่เกิน 50 (ล้านบาท)\r\nประเภทกิจการบริการ จำนวนไม่เกิน 50 (คน) สินทรัพย์ถาวรไม่เกิน 50 (ล้านบาท)\r\nประเภทกิจการค้าส่ง จำนวนไม่เกิน 25 (คน) สินทรัพย์ถาวรไม่เกิน 50 (ล้านบาท)\r\nประเภทกิจการค้าปลีก จำนวนไม่เกิน 15 (คน) สินทรัพย์ถาวรไม่เกิน 30 (ล้านบาท) ",
    source:
      "ธนาคารแห่งประเทศไทย. ธุรกิจขนาดกลางและย่อม (SMEs) และการให้สินเชื่อแก่ SMEs, 30 ตุลาคม 2562. https://www.bot.or.th/Thai/FinancialInstitutions/Highlights/FSMP1/QA_TB.pdf",
    sappear: "",
    mappear: 8,
    rappear: "",
    firstalpha: "ธ"
  },
  {
    keyword: "ธุรกิจดิจิทัล",
    meaning:
      "หรือธุรกิจเทคโนโลยีดิจิทัล คือ ธุรกิจที่มีการสร้างสรรค์สินค้าหรือบริการใหม่ด้วยการประยุกต์ใช้เทคโนโลยีและนวัตกรรมดิจิทัล ซึ่งก่อให้เกิดคุณค่าและรูปแบบการทำธุรกิจแบบใหม่ที่แตกต่างจากการทำธุรกิจแบบเดิม (disruptive business) โดยธุรกิจเทคโนโลยีดิจิทัลครอบคลุมทั้งธุรกิจใหม่และธุรกิจเดิมที่มีการคิดค้นนวัตกรรมหรือมีการปรับเปลี่ยนรูปแบบการทำธุรกิจ (business model) และกระบวนการทางธุรกิจแบบใหม่ ซึ่งอาศัยเทคโนโลยีดิจิทัลเป็นพื้นฐานสำคัญในการสร้างมูลค่าเพิ่มให้กับสินค้าหรือบริการและตอบสนองความต้องการของผู้ใช้งานทั้งในระดับการใช้งานในอุตสาหกรรมและผู้ใช้งานทั่วไป",
    source:
      "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม. (2562). นโยบายและแผนระดับชาติว่าด้วยการพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม, 23 กรกฎาคม 2562. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/047/T_0001.PDF",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ธ"
  },
  {
    keyword: "ธุรกิจตั้งต้นใหม่",
    meaning:
      "กลุ่มบุคคลหรือองค์กรธุรกิจขนาดเล็กที่จัดตั้งขึ้นด้วยบุคลากรและทรัพยากรจำนวนน้อย แต่มีความคิดที่ต้องการสร้างสรรค์นวัตกรรมใหม่ที่สามารถเปลี่ยนแปลงโลกด้วยเทคโนโลยีสารสนเทศ หรือ IT",
    source:
      "กระทรวงอุตสาหกรรม. (2559). Startup, 3 กันยายน 2562. http://www.industry.go.th/industry/index.php/th/knowledge/item/10604-startup",
    sappear: "",
    mappear: 8,
    rappear: "",
    firstalpha: "ธ"
  },
  {
    keyword: "ธุรกิจพาณิชยนาวี",
    meaning:
      "การค้าทางทะเลโดยทั่วไปจะเน้นหนักถึงการค้าระหว่างประเทศทางทะเล ซึ่งหมายความรวมถึงการผลิตสินค้าเพื่อการค้าต่างประเทศหรือการส่งออกสินค้าโดยทางเรือการดําเนินการต่างๆ ทั้งการขนส่งการดูแลความปลอดภัยของสินค้าเพื่อให้สินค้าไปถึงจุดหมายปลายทางอย่างสะดวกรวดเร็ว ปลอดภัยและประหยัด ซึ่งมีทั้งการประกันภัยในสินค้าการประกันเรือ ทั้งตัวเรือและเครื่องยนต์ การบรรจุและหีบห่อสินค้า การยกขนสินค้าและการจัดเก็บและรักษาสินค้าระหว่างรอการขนส่งและในการขนส่งและขนถ่ายสินค้ารวมตลอดถึงการรอจําหน่าย กิจกรรมที่เกี่ยวข้องกับการพาณิชยนาวีจึงอาจกล่าวได้ว่าประกอบด้วยกิจกรรมต่าง ๆ ดังต่อไปนี้\r\n• การผลิตสินค้าเพื่อการส่งออกทางทะเล\r\n• การขนส่งทางทะเลและการขนส่งต่อเนื่องหลายรูปแบบ\r\n• การท่าเรือ\r\n• โรงพักสินค้า\r\n• การยกขนสินค้า\r\n• การบรรจุหีบห่อ\r\n• การธนาคารและการประกันภัย",
    source:
      'กมลชนก สุทธิวาทนฤพุฒิ ธุรกิจพาณิชยนาวี จุฬาลงกรณ์มหาวิทยาลัย. (2541). ศัพท์พาณิชยนาวี ขอเสนอคําว่า "พาณิชยนาวี", 1 ตุลาคม 2562. http://www.tri.chula.ac.th/twwwroot/word/word001.pdf',
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ธ"
  },
  {
    keyword: "ธุรกิจสตาร์ทอัพ",
    meaning:
      "กลุ่มบุคคลหรือองค์กรธุรกิจขนาดเล็กที่จัดตั้งขึ้นด้วยบุคลากรและทรัพยากรจำนวนน้อย แต่มีความคิดที่ต้องการสร้างสรรค์นวัตกรรมใหม่ที่สามารถเปลี่ยนแปลงโลกด้วยเทคโนโลยีสารสนเทศ หรือ IT",
    source:
      "กระทรวงอุตสาหกรรม. (2559). Startup, 9 กันยายน 2562. http://www.industry.go.th/industry/index.php/th/knowledge/item/10604-startup",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ธ"
  },
  {
    keyword: "นโยบาย",
    meaning: "หลักและวิธีปฏิบัติซึ่งถือเป็นแนวดำเนินการ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. นโยบาย. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "น"
  },
  {
    keyword: "นโยบาย PPP",
    meaning:
      "PPP (พีพีพี) ความร่วมมือระหว่างภาครัฐและภาคเอกชน การร่วมลงทุนระหว่างภาครัฐและภาคเอกชนในกิจการของรัฐ โดยมักเป็นการให้เอกชนร่วมลงทุนในโครงการพื้นฐาน หรือโครงการให้บริการสาธารณะในระยะยาวที่มุ่งเน้นการให้บริการที่มีประสิทธิภาพคุ้มค่ากับต้นทุนมากกว่าภาครัฐจะดำเนินการเอง เป็นทางเลือกในการพัฒนาประเทศอย่างมีประสิทธิภาพ ซึ่งให้เอกชนมีส่วนร่วมในกิจกรรมต่าง ๆ เช่น การก่อสร้าง การดำเนินการบำรุงรักษา การจัดหาเงินทุน การให้บริการ ซึ่งเอกชนเป็นผู้บริหารจัดการความเสี่ยงของโครงการตามระยะเวลาและรายละเอียดของสัญญาที่กำหนดไว้",
    source:
      "กรมป้องกันและบรรเทาสาธารณภัย. หนังสือคำศัพท์ด้านการบริหารจัดการความเสี่ยงจากภัยพิบัติ, 9 กันยายน 2562. http://www.disaster.go.th/th/download-src.php?did=1225",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "น"
  },
  {
    keyword: "นโยบายขาดดุล",
    meaning: " จำนวนรายรับของรัฐบาลน้อยกว่ารายจ่ายของรัฐบาล",
    source:
      "สำนักนโยบายการออมและการลงทุน. (2546). งบประมาณขาดดุล Budget Deficit, 9 กันยายน 2562. http://www2.fpo.go.th/S-I/Source/word/Word.php?Language=Thai&BeginRec=1148&NumRecShow=8&sort=1&search=",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "น"
  },
  {
    keyword: "นโยบายประชานิยม",
    meaning:
      "นโยบายที่สนับสนุนประชาชนคนยากจนเป็นหลัก เพื่อมุ่งหวังความนิยมทางการเมืองโดยไม่จำเป็นต้องมีความสมเหตุสมผลหรือเป้าหมายทางเศรษฐศาสตร์มหภาคมารองรับ นโยบายประชานิยมจะมีหลากหลายรูปแบบที่ปรากฏ แต่จะมีลักษณะร่วมกันตรงที่การเป็นนโยบายที่มุ่งเอาอกเอาใจและสนองความต้องการของประชาชน ตลอดจนการไม่แสดงถึงจำนวนเงินที่ใช้ในการดำเนินนโยบาย เปรียบเสมือนอุดมการณ์และนโยบายทางการเมืองที่เป็นที่นิยมของประชาชน และหลายพรรคการเมืองในประเทศไทยได้ใช้นโยบายประชานิยมนี้ในการหาเสียงเลือกตั้ง โดยนโยบายประชานิยมนั้นเปิดโอกาสให้ประชาชนสามารถส่งเสียงบอกนักการเมืองผ่านคูหาเลือกตั้งผ่านได้ ซึ่งทำให้นักการเมืองต้องหันมาให้ความสนใจต่อความเป็นอยู่และความต้องการของประชาชนมากขึ้น",
    source:
      "ภูวกฤต เหมหาชาติ สำนักส่งเสริมพระพุทธศาสนาและบริการสังคม. (2558). นโยบายประชานิยม, 9 กันยายน 2562. http://bps.mcu.ac.th/wp-content/uploads/2016/12/C-%E0%B8%99%E0%B9%82%E0%B8%A2%E0%B8%9A%E0%B8%B2%E0%B8%A2%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%8A%E0%B8%B2%E0%B8%99%E0%B8%B4%E0%B8%A2%E0%B8%A1_%E0%B9%80%E0%B8%A1%E0%B8%A2-18-30.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "น"
  },
  {
    keyword: "นโยบายรัฐบาล",
    meaning:
      "นโยบายที่ถูกกำหนดขึ้นโดยรัฐบาล ซึ่งอาจจะเป็นองค์กรหรือตัวบุคคลที่มีอำนาจหน้าที่\r\nโดยตรงตามกฎหมายภายใต้ระบบการเมืองนั้นๆ ทั้งนี้นโยบายสาธารณะจะครอบคลุมตั้งแต่สิ่งที่รัฐบาลตั้งใจว่าจะกระทำหรือไม่กระทำ การตัดสินใจของรัฐบาลในการแบ่งสรรทรัพยากรหรือคุณค่าต่างๆ ในสังคม กิจกรรม หรือการกระทำต่างๆ ของรัฐบาล รวมจนถึงผลผลิตและผลลัพธ์ที่เกิดขึ้นจริง อันเป็นสิ่งที่เกิดขึ้นติดตามมาจากการดำเนินงานของรัฐบาล\r\n",
    source:
      "นายทศพร ศิริสัมพันธ์.นโยบายสาธาณะ. อางถึงใน รัฐสภาสาร ปีที่ 65 ฉบับที่ 11\r\nhttps://www.parliament.go.th/ewtadmin/ewt/parliament_parcy/download/article/article_20180307095240.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "น"
  },
  {
    keyword: "นโยบายสาธารณะ",
    meaning:
      "นโยบายที่ถูกกำหนดขึ้นโดยรัฐบาล ซึ่งอาจจะเป็นองค์กรหรือตัวบุคคลที่มีอำนาจหน้าที่\r\nโดยตรงตามกฎหมายภายใต้ระบบการเมืองนั้นๆ ทั้งนี้นโยบายสาธารณะจะครอบคลุมตั้งแต่สิ่งที่รัฐบาลตั้งใจว่าจะกระทำหรือไม่กระทำ การตัดสินใจของรัฐบาลในการแบ่งสรรทรัพยากรหรือคุณค่าต่างๆ ในสังคม กิจกรรม หรือการกระทำต่างๆ ของรัฐบาล รวมจนถึงผลผลิตและผลลัพธ์ที่เกิดขึ้นจริง อันเป็นสิ่งที่เกิดขึ้นติดตามมาจากการดำเนินงานของรัฐบาล\r\n",
    source:
      "นายทศพร ศิริสัมพันธ์.นโยบายสาธาณะ. อางถึงใน รัฐสภาสาร ปีที่ 65 ฉบับที่ 11\r\nhttps://www.parliament.go.th/ewtadmin/ewt/parliament_parcy/download/article/article_20180307095240.pdf",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "น"
  },
  {
    keyword: "นวัตกร",
    meaning:
      "แนวความคิดที่เน้น คน (ทรัพยากรมนุษย์)  เป็นศูนย์กลางของการพัฒนา คือ คนเป็นผู้บริหารจัดการปัจจัยที่เกี่ยวข้องแบบองค์รวม  ได้แก่  ครอบครัว  ชุมชน  สังคม  เศรษฐกิจ  การเมือง  และทรัพยากรธรรมชาติและสิ่งแวดล้อม",
    source:
      "สำนักงาน ก.พ.ร. (2561, กุมภาพันธ์) คู่มือชุดเครื่องมือ(Toolkit) จากการถอดบทเรียนเกี่ยวกับกระบวนการคิดเชิงออกแบบ(Design Thinking), 21 พฤศจิกายน 2562. https://www2.opdc.go.th/psic/spaw2/uploads/files/Toolkitpsic16761.pdf",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "น"
  },
  {
    keyword: "นวัตกรรม",
    meaning:
      "ผลิตภัณฑ์ สิ่งประดิษฐ์ บริการ กรรมวิธีที่เกี่ยวกับการผลิต การจัดโครงสร้างองค์กร ระบบบริหารจัดการ การบริหารการเงิน ธุรกิจ การตลาด หรือในการอื่นใด\r\nทั้งนี้ ซึ่งเป็นสิ่งใหม่หรือพัฒนาให้ดีขึ้นกว่าเดิมอย่างมีนัยสำาคัญ และนำไปใช้ประโยชน์ได้ในวงกว้างทั้งในเชิงพาณิชย์และสาธารณะ",
    source:
      "พระราชบัญญัติสภานโยบายการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมแห่งชาติ พ.ศ. 2562 (2562, 1 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม139 ตอนที่ 57 ก หน้า 9. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/057/T_0008.PDF",
    sappear: "1,2,3,4,5,6",
    mappear: "8,9,15,16,18",
    rappear: 2,
    firstalpha: "น"
  },
  {
    keyword: "นวัตกรรมในเชิงลึก (Deep Tech)",
    meaning:
      "เทคโนโลยีขั้นสูง คือ ผลลัพธ์ที่ได้จากความก้าวหน้าทางเทคโนโลยีและวิทยาศาสตร์ที่ไม่เหมือนใคร ลอกเลียนแบบได้ยาก และเป็นทรัพย์สินทางปัญญาที่มีสิทธิบัตรคุ้มครองเพราะผ่านการวิจัยและพัฒนาด้านวิทยาศาสตร์และวิศวกรรมอย่างยาวนาน",
    source:
      "สำนักนวัตกรรมแห่งชาติ. DEEP TECH: STARTUP ที่เป็นมากกว่า STARTUP, 21 ตุลาคม 2562. https://nia.or.th/public/index.php/DeepTech",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "น"
  },
  {
    keyword: "นวัตกรรมด้านคมนาคม",
    meaning:
      "ส่งเสริมการวิจัยและพัฒนา เพื่อนำเทคโนโลยี นวัตกรรมและระบบเทคโนโลยีอัจฉริยะต่างๆ ที่มีความก้าวหน้าอย่างรวดเร็วมาปรับใช้ในการพัฒนาโครงสร้างพื้นฐานและบรืหารจัดการด้านคมนาคมขนส่งให้มีประสิทธิภาพสูงขึ้น และเป็นเครื่องมือและกลไกสำคัญในการให้บริการ การบริหารจัดการบริการขนส่ง สนับสนุนนโยบายของภาครัฐในการพัฒนาเศรษฐกิจและสังคม และส่งเสริมการผลิตของภาคการเกษตรและอุตสาหกรรม",
    source:
      "กระทรวงคมนาคม. (2559). แผนงานในภารกิจของกระทรวงคมนาคมภายใต้ (ร่าง) ยุทธศาสตร์การพัฒนาระบบคมนาคมขนส่งของไทยระยะ 20 ปี, 6 พฤศจิกายน 2562. http://www.otp.go.th/uploads/tiny_uploads/PolicyPlan/1-PolicyPlan/25600316-OpertionPlan/25600316-OpertionPlan3.pdf",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "น"
  },
  {
    keyword: "นวัตกรรมทางการเงิน",
    meaning:
      "การสร้างเครื่องมือทางการเงินใหม่ๆ โดยอ้างอิงถึงเทคโนโลยี สถาบันที่เกี่ยวข้อง และองค์ประกอบของผู้มีส่วนร่วมในตลาด ดังนั้นนวัตกรรมจึงประกอบไปด้วยผลิตภัณฑ์และกระบวนการที่เป็นสิ่งใหม่",
    source:
      "ผู้ช่วยศาสตราจารย์ ดร.ภัทรกิตติ์ เนตินิยม มหาวิทยาลัยธรรมศาสตร์. ภาพรวมนวัตกรรมทางการเงิน, 8 ตุลาคม 2562. http://fin.bus.ku.ac.th/pdf/P/02_P_Fin%20Inno_STOU.pdf",
    sappear: "",
    mappear: 16,
    rappear: "",
    firstalpha: "น"
  },
  {
    keyword: "นวัตกรรมทางสังคม",
    meaning:
      "ผลผลิตทางความคิดสร้างสรรค์ มีความแปลกใหม่ และสร้างผลกระทบต่อสังคมได้ในวงกว้าง อาจจะอยู่ในรูปแบบของระบบการจัดการทรัพยากร การสื่อสาร ศิลปวัฒนธรรม รูปแบบการเรียนรู้เพื่อการพัฒนาศักยภาพ การให้ความช่วยเหลือเพื่อนมนุษย์",
    source:
      "ผู้ช่วยศาสตราจารย์ชานนท์ โกมลมาลย์ อาจารย์ประจำคณะสังคมสงเคราะห์ศาสตร์ มหาวิทยาลัยธรรมศาสตร์. (2561). นวัตกรรมทางสังคมเพื่อขับเคลื่อนสุขภาวะโดยการมีส่วนร่วมของเด็กและเยาวชน, 21 ตุลาคม 2562. file:///C:/Users/admin/Downloads/168434-Article%20Text-472521-1-10-20190128.pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "น"
  },
  {
    keyword: "นวัตกรรมรูปแบบใหม่ (Sandbox)",
    meaning:
      "พื้นที่ที่ปลอดภัยในการทดลองและการทดสอบ รวมทั้งสามารถเกิดความผิดพลาดในการทดลองและการทดสอบใน Sandbox ได้เพราะถือว่าเป็นพื้นที่ที่ตัดขาดและไม่เกิดผลกระทบต่อส่วนอื่น Sandbox จึงมีความสำคัญในแง่ของการเป็นพื้นที่ที่ใช้พัฒนานวัตกรรมที่เกิดจากเทคโนโลยีสมัยใหม่เพื่อนำมาใช้สร้างประโยชน์ในภาครัฐและภาคเอกชน\r\n",
    source:
      "พิธุวรรณ กิติคุณ วิทยากรชำนาญการพิเศษ กลุ่มงานบริการวิชาการ 1 สำนักวิชาการ. (2562). การปฏิรูประบบราชการ: การพัฒนาและการรังสรรค์นวัตกรรมในรูปแบบใหม่ (Sandbox), 4 กันยายน 2562. https://library2.parliament.go.th/ebook/content-issue/2562/hi2562-006.pdf\r\n",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "น"
  },
  {
    keyword: "นักท่องเที่ยวคุณภาพ",
    meaning:
      "นักท่องเที่ยวที่มีกำลังซื้อสูง สามารถจับจ่ายซื้อสินค้าทางการท่องเที่ยวตามที่ต้องการได้ และขณะเดียวกันเป็นนักท่องเที่ยวทีไม่ก่อผลกระทบต่อสภาพแวดล้อมทั้งด้านธรรมชาติ สังคมและวัฒนธรรม นักท่องเที่ยวคุณภาพ ได้แก่ นักท่องที่เที่ยววัยทองหรือนักท่องเที่ยวสูงอายุ นักท่องเที่ยวคุณภาพ Incentive เป็นต้น",
    source:
      "นายเจษฎา ขวัญเมือง และคณะ. Tourism around the world คลังคำศัพท์, 30 กรกฎาคม 2562. https://touristbuu.wordpress.com/%E0%B8%84%E0%B8%A5%E0%B8%B1%E0%B8%87%E0%B8%84%E0%B8%B3%E0%B8%A8%E0%B8%B1%E0%B8%9E%E0%B8%97%E0%B9%8C/",
    sappear: "",
    mappear: 5,
    rappear: "",
    firstalpha: "น"
  },
  {
    keyword: "นันทนาการเชิงพาณิชย์",
    meaning:
      "กิจกรรมนันทนาการที่ได้รับการพัฒนาให้เป็นธุรกิจหรือดำเนินการให้เป็นกิจกรรมเพื่อการหารายได้",
    source:
      "กรมพลศึกษา กระทรวงการท่องเที่ยวและกีฬา. แผนพัฒนานันทนาการแห่งชาติ ฉบับที่ 3 (พ.ศ. 2560 - 2564), 17 ตุลาคม 2562. https://chainat.mots.go.th/download/article/article_20190625135219.pdf",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "น"
  },
  {
    keyword: "นาโนเทคโนโลยี",
    meaning:
      "เทคโนโลยีของวิทยาศาสตร์ประยุกต์ที่เอาไปใช้ประโยชน์ในการออกแบบเพื่อประดิษฐ์วัสดุหรือผลิตภัณฑ์ใหม่ๆ การสังเคราะห์วัสดุที่มีข้อด้อยลดลง การตรวจวิเคราะห์และวินิจฉัยที่มีความละเอียดแม่นยำยิ่งขึ้นสำหรับวัสดุหรือสิ่งของที่เล็กมากอยู่ในระดับนาโนเมตร ซึ่งนาโนเทคโนโลยีจะให้ความสำคัญแก่กระบวนการเตรียมหรือการใช้เทคโนโลยีในช่วงแรก โดยเริ่มจากการควบคุมแต่ละโมเลกุล หรือ อะตอม ที่ส่งผลต่อการประกอบหรือการรวมตัวกันทำให้เกิดเป็นสารที่มีขนาดใหญ่ ทำให้นาโนเทคโนโลยีมีความพิเศษ คือ มีความเฉพาะเจาะจง สามารถควบคุมการทำงานของสารที่สร้างขึ้นได้ทั้งในด้านเคมีและฟิสิกส์อย่างมีประสิทธิภาพ",
    source:
      "สถาบันส่งเสริมการสอนวิทยาศาสตร์และเทคโนโลยี (สสวท.). (2560). นาโนเทคโนโลยี (Nanotechnology), 25 มิถุนายน 2562. https://www.scimath.org/lesson-chemistry/item/7081-nanotechnology",
    sappear: 2,
    mappear: 23,
    rappear: 2,
    firstalpha: "น"
  },
  {
    keyword: "น้ำมันเชื้อเพลิง",
    meaning:
      "ก๊าซ นำมันเบนซิน น้ำมันเชื้อเพลิงสำหรับเครื่องบิน น้ำมันก๊าด น้ำมันดีเซล น้ำมันเตา น้ำมันอื่น ๆ ที่คล้ายกับน้ำมันที่ได้ออกชื่อมาแล้วและผลิตภัณฑ์ปิโตเลียมอื่นตามที่คณะกรรมการนโยบายพลังงานแห่งชาติกำหนดโดยประกาศในราชกิจกานุเบกษา",
    source:
      "พระราชบัญญัติการส่งเสริมการอนุรักษ์พลังงาน พ.ศ. 2535. (2535, 23 มีนาคม). ราชกิจจานุเบกษา. เล่มที่ 109 ตอนที่ 33 หน้าที่ 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "น"
  },
  {
    keyword: "น้ำมันเตา",
    meaning:
      "นํ้ามันเชื้อเพลิงชนิดหนึ่ง ใช้พ่นเข้าไปจุดเผาในเตาเพื่อให้ความร้อนแก่หม้อนํ้าเครื่องจักร",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2551). ยุคน้ำมันแพง, 30 สิงหาคม 2562. \r\nhttp://www.royin.go.th/?knowledges=%e0%b8%a2%e0%b8%b8%e0%b8%84%e0%b8%99%e0%b9%\r\n89%e0%b8%b3%e0%b8%a1%e0%b8%b1%e0%b8%99%e0%b9%81%e0%b8%9e%e0%b8%87-%e0%\r\nb9%92-%e0%b8%a1%e0%b8%b4%e0%b8%96%e0%b8%b8%e0%b8%99%e0%b8%b2%e0%b8%a2%\r\ne0%b8%99",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "น"
  },
  {
    keyword: "น้ำมันดิบ",
    meaning:
      "นํ้ามันที่สกัดหรือสูบขึ้นมาจากแหล่งกําเนิด และยังมิได้ทําให้บริสุทธิ์ หรือยังมิได้นําไปกลั่นแยกออกเป็นส่วน ๆ",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2558). น้ำมันดิบ, 30 สิงหาคม 2562. \r\nhttp://www.royin.go.th/?knowledges=%E0%B8%99%E0%B9%89%E0%B8%B3%E0%B8%A1%E0%B8%B1%\r\nE0%B8%99%E0%B8%94%E0%B8%B4%E0%B8%9A",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "น"
  },
  {
    keyword: "น้ำมันสำเร็จรูป",
    meaning:
      "น้ำมันสำเร็จรูปหรือน้ำมันเชื้อเพลิง คือ น้ำมันที่สำเร็จรูปพร้อมใช้เป็นเชื้อเพลิง นำไปเติมใส่ถังใช้งานได้ทันที น้ำมันสำเร็จรูปเป็นผลพวงจากการกลั่นน้ำมันดิบ ทำให้ได้ LPG เบนซิน ดีเซล น้ำมันก๊าด น้ำมันเครื่องบิน น้ำมันเตา\r\n1. น้ำมันสำเร็จรูปชนิดเบา ประกอบด้วย ก๊าซปิโตรเลียมเหลว แนฟทาชนิดเบา และรีฟอร์เมต \r\n2. น้ำมันสำเร็จรูปกึ่งหนักกึ่งเบา ซึ่งประกอบด้วย น้ำมันอากาศยาน และน้ำมันดีเซล \r\n3. น้ำมันสำเร็จรูปชนิดหนัก ซึ่งประกอบด้วยน้ำมันเตา",
    source:
      "บริษัท ปตท. อะโรเมติกส์และการกลั่น จำกัด(มหาชน). การประกอบธุรกิจของแต่ละสายผลิตภัณฑ์ , 4 ตุลาคม 2562. http://capital.sec.or.th/webapp/corp_fin/datafile/dsf/1062022008-04-04TC104L02006.DOC",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "น"
  },
  {
    keyword: "นิเวศวิทยา",
    meaning:
      "วิชาที่ศึกษาความสัมพันธ์ระหว่าง สิ่งมีชีวิต (organism) กับสิ่งแวดล้อม (environment) หรือแหล่งที่อยู่ (Habitat) ตามธรรมชาติ ความสัมพันธ์ต่างๆ จะแสดงถึงการมีระบบ จึงเรียก ระบบนิเวศ ซึ่งระบบความสัมพันธ์ส่วนใหญ่จะเกี่ยวข้องกับวิถีการดำรงชีวิต เช่น การหาอาหาร การกินอาหาร การแข่งขันเพื่อการอยู่รอด การปรับตัวให้เหมาะสมกับสภาพแวดล้อม การพึ่งพากันเพื่อให้สังคมเป็นปกติและที่สำคัญที่สุด คือ ระบบการรักษาสมดุลระหว่างสิ่งมีชีวิตในระบบนิเวศในแง่ของการถ่ายทอดพลังงานการหมุนเวียนสารในระบบนิเวศ",
    source:
      "อาภรณ์ รับไซ. (2560). นิเวศวิทยา, 25 มิถุนายน 2562. https://www.scimath.org/lesson-biology/item/7040-2017-05-22-14-49-08",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "น"
  },
  {
    keyword: "นิคมอุตสาหกรรม",
    meaning:
      "เขตพื้นที่ดินซึ่งจัดสรรไว้สำหรับโรงงานอุตสาหกรรมเข้าไปอยู่รวมกันอย่างเป็นสัดส่วน อันประกอบด้วย พื้นที่อุตสาหกรรม สิ่งอำนวยความสะดวก สาธารณูปโภค และสาธารณูปการครบครัน เช่น ถนน ท่อระบายน้ำ โรงกำจัดน้ำเสียส่วนกลาง ระบบป้องกันน้ำท่วม ไฟฟ้า น้ำประปา โทรศัพท์ นอกจากนั้น ยังประกอบด้วยบริการอื่น ๆ ที่จำเป็นอีก อาทิ เช่น ที่ทำการไปรษณีย์โทรเลข ธนาคาร ศูนย์การค้า ที่พักอาศัย สำหรับคนงาน สถานีบริการน้ำมัน เป็นต้น",
    source:
      "การนิคมอุตสาหกรรมแห่งประเทศไทย (กนอ.). บทบาทหน้าที่ความรับผิดชอบขององค์กร, 25 มิถุนายน 2562. https://www.ieat.go.th/about/roles-responsibilities",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "น"
  },
  {
    keyword: "นิติธรรม",
    meaning:
      "หลักพื้นฐานแห่งกฎหมายที่บุคคลทุกคนต้องอยู่ภายใต้บังคับแห่งกฎหมายอย่างเท่าเทียมกัน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2542. นิติธรรม. 25 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 5,
    mappear: "",
    rappear: 3,
    firstalpha: "น"
  },
  {
    keyword: "นิติบุคคล",
    meaning:
      "นิติบุคคล หมายถึง กลุ่มบุคคล องค์กร หรือทรัพย์สินที่จัดสรรไว้เป็นกองทุนเพื่อดำเนินกิจการอันใดอันหนึ่ง ซึ่งกฎหมายบัญญัติให้เป็นบุคคลอีกประเภทหนึ่งที่มิใช่บุคคลธรรมดา นิติบุคคลจะมีขึ้นได้ก็แต่ด้วยอาศัยอำนาจแห่งประมวลกฎหมายแพ่งและพาณิชย์หรือกฎหมายอื่น นิติบุคคลย่อมมีสิทธิและหน้าที่ตามบทบัญญัติแห่งประมวลกฎหมายแพ่งและพาณิชย์หรือกฎหมายอื่น ภายในขอบแห่งอำนาจหน้าที่หรือวัตถุประสงค์ดังได้บัญญัติหรือกำหนดไว้ในกฎหมาย ข้อบังคับ หรือตราสารจัดตั้ง นอกจากนั้น นิติบุคคลย่อมมีสิทธิและหน้าที่เช่นเดียวกับบุคคลธรรมดา เว้นแต่สิทธิและหน้าที่ซึ่งโดยสภาพจะพึงมีพึงเป็นได้เฉพาะแก่บุคคลธรรมดาเท่านั้น เช่น กระทรวง ทบวง กรม องค์การบริหารส่วนจังหวัด เทศบาล องค์การบริหารส่วนตำบล กรุงเทพมหานคร เมืองพัทยา",
    source:
      "สำนักราชบัณฑิตยสภา. บุคคล/บุคคลธรรมดา/นิติบุคคล. 25 มิถุนายน 2562. http://www.royin.go.th/?knowledges=%E0%B8%9A%E0%B8%B8%E0%B8%84%E0%B8%84%E0%B8%A5%E0%B8%9A%E0%B8%B8%E0%B8%84%E0%B8%84%E0%B8%A5%E0%B8%98%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B8%94%E0%B8%B2%E0%B8%99%E0%B8%B4%E0%B8%95%E0%B8%B4%E0%B8%9A%E0%B8%B8e",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "น"
  },
  {
    keyword: "นิติวิทยาศาสตร์",
    meaning:
      "วิชาที่ว่าด้วยการนำหลักวิทยาศาสตร์สาขาต่าง ๆ มาประยุกต์เพื่อแก้ปัญหาทางกฎหมาย และการพิสูจน์ข้อเท็จจริงเกี่ยวกับคดีความ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ.2554. นิติวิทยาศาสตร์. 20 พฤศจิกายน2562. http://www.royin.go.th/dictionary/index.php",
    sappear: 6,
    mappear: 22,
    rappear: "",
    firstalpha: "น"
  },
  {
    keyword: "นิติสัมพันธ์",
    meaning: "ความเกี่ยวพันทางกฎหมาย",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554 นิติสัมพันธ์. 20 พฤศจิกายน 2562. \r\nhttp://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "น"
  },
  {
    keyword: "นิรโทษกรรมภาษี",
    meaning:
      "การยกโทษในความผิดที่ได้กระทำไปแล้ว ไม่ว่าจะเป็นทางอาญาหรือทางแพ่ง และอาจรวมถึงโทษทางปกครองให้แก่ผู้กระทำความผิด ",
    source:
      "สำนักงานคณะกรรมการกฤษฎีกา. (2561). นิรโทษกรรม อภัยโทษ ล้างมลทิน ความร่วมมือระหว่างประเทศในกระบวนการยุติธรรม สัญชาติ องค์การระหว่างประเทศ, 22 ตุลาคม 2562. http://web.krisdika.go.th/data/ebook/thailaw/thailaw54.pdf",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "น"
  },
  {
    keyword: "นิวเคลียร์",
    meaning:
      "“นิวเคลียร์” เป็นคำคุณศัพท์ของคำว่า “นิวเคลียส (nucleus)” ซึ่งเป็นส่วนใจกลางของปรมาณูของธาตุทุกชนิด “ปรมาณู” มาจากคำว่า “อะตอม (atom)” ในภาษาอังกฤษ เรามักนิยมเรียกทับศัพท์ว่า “อะตอม” โดยที่ปรมาณู หรืออะตอม จะประกอบด้วย นิวเคลียส ซึ่งเป็นแกนกลาง และมีอิเล็กตรอนโคจรอยู่รอบๆ นิวเคลียส",
    source:
      "ผศ. ดร. สมพร จองคำ นายกสมาคมนิวเคลียร์แห่งประเทศไทย. พลังงานนิวเคลียร์คืออะไร มาจากไหน?, 30 สิงหาคม 2562. \r\nhttp://www.nst.or.th/article/article0111.htm",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "น"
  },
  {
    keyword: "บรรทัดฐาน",
    meaning: "แบบแผนสำหรับยึดถือเป็นแนวทางปฏิบัติ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. บรรทัดฐาน. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "บ"
  },
  {
    keyword: "บรรษัท",
    meaning:
      "- การรวมกันเข้าหุ้นส่วนทำการค้าขาย (คำนาม) \r\n- นิติบุคคลที่มีฐานะอย่างเดียวกับบริษัทจำกัด โดยมีกฎหมายจัดตั้งขึ้นโดยเฉพาะ (คำที่ใช้ในกฎหมาย)",
    source:
      "พจนานุกรม ฉบับราชบัณฑิตยสถาน พ.ศ. 2554. บรรษัท, 11 มิถุนายน 2562.http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "บ"
  },
  {
    keyword: "บรรษัทภิบาล",
    meaning:
      "การกำกับดูแลกิจการให้เจริญรุดหน้าอย่างมีประสิทธิภาพ ด้วยเงื่อนไขของความถูกต้องโปร่งใส การมีจริยธรรมที่ดี โดยคำนึงถึงผู้มีส่วนได้เสียในกิจการเป็นหลัก",
    source:
      "สถาบันไทยพัฒน์ มูลนิธิบูรณะชนบทแห่งประเทศไทย ในพระบรมราชูปถัมภ์. บรรษัทภิบาลและบรรษัทบริบาลเกี่ยวข้องกับเศรษฐกิจพอเพียงอย่างไร, 11 กันยายน 2562. http://faq.sufficiencyeconomy.com/2007/07/corporate-governance-5-corporate-social.html",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "บ"
  },
  {
    keyword: "บรรษัทวิสาหกิจแห่งชาติ",
    meaning:
      "ทำหน้าที่ในฐานะผู้ถือหุ้นในรัฐวิสาหกิจที่เป็นบริษัทแทนกระทรวงการคลัง เพื่อเสริมสร้างประสิทธิภาพในการดำเนินงานของรัฐวิสาหกิจให้มีความพร้อมในการแข่งขันพานิชย์ และสามารถดำเนินการได้อย่างเต็มศักยภาพ โดยยังคงความเป็นรัฐวิสาหกิจไว้",
    source:
      "สำนักวิชาการ สำนักงานเลขาธิการสภาผู้แทนราษฎร. (2560). กฎหมายซุปเปอร์โฮลดิ้ง : ปฏิรูปหรือแปรรูปรัฐวิสาหกิจ, \r\n30 สิงหาคม 2562. https://library2.parliament.go.th/ejournal/content_af/2560/sep2560-3.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "บ"
  },
  {
    keyword: "บริการ",
    meaning:
      "การรับจัดทำการงาน การให้สิทธิใด ๆหรือการให้ใช้หรือให้ประโยชน์ในทรัพย์สินหรือกิจการใด ๆ โดยเรียกค่าตอบแทนเป็นเงินหรือผลประโยชน์อื่น แต่ไม่รวมถึงการจ้างแรงงานตามกฎหมายแรงงาน\r\n",
    source:
      "พระราชบัญญัติคุ้มครองผู้บริโภค พ.ศ. 2522. (2522, 4 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 96 ตอนที่ 72 ก หน้า 21 .http://www.ratchakitcha.soc.go.th/DATA/PDF/2522/A/072/20.PDF",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "บ"
  },
  {
    keyword: "บริการในลักษณะรวมศูนย์ (Software-as-a-service)",
    meaning:
      "ความร่วมมือของสำนักงานรัฐบาลอิเล็กทรอนิกส์ (องค์การมหาชน) (EGA) สำนักงานส่งเสริมซอฟต์แวร์แห่งชาติ (องค์การมหาชน) (SIPA) และเขตอุตสาหกรรมซอฟต์แวร์ประเทศไทย (Software Park) เพื่อส่งเสริมให้ภาคเอกชนมีส่วนร่วมในการนำความรู้ การวางแผนงาน และการนำเทคโนโลยีที่ทันสมัยมาใช้ในการพัฒนาระบบและซอฟต์แวร์ที่มีความสมบูรณ์ มีประสิทธิภาพ และตอบสนองความต้องการสูงสุดบนระบบ G-Cloud เพื่อรองรับความต้องการของหน่วยงานภาครัฐ",
    source:
      "สำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน) (สพร.). (2558). การให้บริการซอฟต์แวร์ผ่านเครือข่ายอินเทอร์เน็ตภาครัฐ Government Software as a Service : G-SaaS, 7 ตุลาคม 2562. https://www.dga.or.th/th/profile/935/",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "บ"
  },
  {
    keyword: "บริการจุดเดียวและองค์รวม",
    meaning:
      "บริการภาครัฐแบบเบ็ดเสร็จ ณ จุดเดียว เป็นศูนย์บริการร่วมรูปแบบออนไลน์ของภาครัฐ เพื่อการเข้าถึงข้อมูลและบริการภาครัฐแบบเบ็ดเสร็จ ณ จุดเดียว ช่วยให้ประชาชนผู้รับบริการสามารถพบกับส่วนราชการผู้ให้บริการได้ตลอดเวลา จากที่ไหนก็ได้\r\n",
    source:
      "สำนักงานพัฒนารัฐบาลดิจิทอล(องค์การมหาชน). (2561). One Stop Service(OSS), 3 กันยายน 2562. https://www.dga.or.th/upload/download/file_1207be8324f8debd0a21021c9281ed5b.pdf",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "บ"
  },
  {
    keyword: "บริการดิจิทัล",
    meaning:
      "การใช้เทคโนโลยีดิจิทัลในการให้บริการ ให้ความช่วยเหลือ หรืออำนวยความสะดวกให้แก่ภาคประชาชน ภาคธุรกิจ และภาครัฐ ทั้งผู้ขอรับบริการภายในและภายนอกหน่วยงาน โดยบริการดังกล่าวอาจจะเป็นในลักษณะของการให้ข้อมูล (Information) มีการปฏิสัมพันธ์กับประชาชน (Interaction) รองรับการดำเนินธุรกรรมภาครัฐ (Interchange Transaction) หรือการบูรณาการ (Integration) ก็ได้\r\nเช่น การขอใช้สาธารณูปโภค การค้นหาตำแหน่งงานว่าง การชำระภาษี เป็นต้น",
    source:
      "สำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน) (สพร.). นิยามศัพท์แบบสำรวจระดับความพร้อมรัฐบาลดิจิทัลหน่วยงานภาครัฐ ประจำปี พ.ศ. 2561\r\nhttps://www.dga.or.th/upload/download/file_a5d324a1ab1a9d616705da1cade7b62a.pdf",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "บ"
  },
  {
    keyword: "บริการสาธารณสุข",
    meaning:
      "บริการต่าง ๆ อันเกี่ยวกับการสร้างเสริมสุขภาพการป้องกันและควบคุมโรคและปัจจัยที่คุกคามสุขภาพ การตรวจวินิจฉัยและบําบัดสภาวะความเจ็บป่วย และการฟื้นฟูสมรรถภาพของบุคคล ครอบครัวและชุมชน",
    source:
      "พระราชบัญญัติสุขภาพแห่งชาติ พ.ศ. 2550. (2550, 19 มีนาคม). ราชกิจจานุเบกษา. เล่ม 124 ตอนที่ 16 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2550/A/016/1.PDF",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "บ"
  },
  {
    keyword: "บริการสาธารณสุขระดับตติยภูมิ",
    meaning:
      "การบริการทางการแพทย์ที่ให้การรักษาและดูแลผู้ป่วย โดยเฉพาะกลุ่มผู้ป่วยที่มีอาการซับซ้อนที่ต้องการรับการรักษาระดับตติยภูมิ ซึ่งเป็นระบบที่ต้องรับส่งต่อผู้ป่วยจากสถานบริการระดับปฐมภูมิและทุติยภูมิ รวมทั้งเป็นแหล่งองค์ความรู้ เทคโนโลยีทางการแพทย์และบุคคลากรทางการแพทย์ที่มีความเชี่ยวชาญระดับสูงของประเทศ ",
    source:
      "นพ. ชุษณะ มะกรสาร ศิวาพร สังรวม สินินาฏ อันบุรี (สำนักที่ปรึกษา กรมการแพทย์). ระบบบริการทางการแพทย์, 12 พฤศจิกายน 2562. https://www.hiso.or.th/hiso/picture/reportHealth/report/report8_3.pdf",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "บ"
  },
  {
    keyword: "บริการสาธารณสุขระดับทุติยภูมิ",
    meaning:
      "เน้นการแก้ไขปัญหาความเจ็บป่วยและผลกระทบจากความเจ็บป่วยที่ซับซ้อน รุนแรงจนถึงวิกฤติต้องการการช่วยเหลือจากบุคลากรด้านสุขภาพที่มีความรู้ความสามารถเฉพาะทาง ใช้เทคโนโลยีขั้นสูงในการสืบค้น การช่วยเหลือเพื่อป้องกัน แก้ไขปัญหา การดูแลในระดับทุติยภูมิยังครอบคลุมถึงการป้องกันการเจ็บป่วยซ้ำ การฟื้นฟูสภาพเพื่อให้ประชาชนมีศักยภาพชีวิตที่ดี การดูแลในระดับทุติยภูมิจะต้องมีระบบการดูแลต่อเนื่อง และส่งต่อที่มีประสิทธิภาพระหว่างสถานบริการในระดับเดียวกันและต่างระดับ และมีการถ่ายทอดเทคโนโลยีระหว่างกัน",
    source:
      "สมจิต หนุเจริญกุล ศาสตราจารย์ ภาควิชาพยาบาลศาสตร์ คณะแพทยศาสตร์โรงพยาบาลรามาธิบดี มหาวิทยาลัยมหิดล. (2543). การปฏิรูประบบบริการการพยาบาลในระดับทุตยภูมิและตติยภูมิ, 12 พฤศจิกายน 2562. https://med.mahidol.ac.th/nursing/jns/DocumentLink/2543/issue_02/01.pdf",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "บ"
  },
  {
    keyword: "บริการสาธารณะ",
    meaning:
      "กิจการอันจำเป็นและเป็นประโยชน์ต่อประชาชนเป็นส่วนรวมที่รัฐหรือองค์กรปกครองส่วนท้องถิ่นจัดทำขึ้นเพื่อบริการแก่ประชาชน เช่น กิจการสาธารณูปโภค กิจการขนส่งคนโดยสาร",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. บริการสาธารณะ. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 6,
    mappear: 20,
    rappear: 2,
    firstalpha: "บ"
  },
  {
    keyword: "บริการสุขภาพ",
    meaning:
      '"สุขภาพ” หมายความว่า ภาวะของมนุษย์ที่สมบูรณ์ทั้งทางกาย ทางจิต ทางปัญญา และทางสังคมเชื่อมโยงกันเป็นองค์รวมอย่างสมดุล\r\n“ระบบสุขภาพ” หมายความว่า ระบบความสัมพันธ์ทั้งมวลที่เกี่ยวข้องกับสุขภาพ\r\n“บริการสาธารณสุข” หมายความว่า บริการต่าง ๆ อันเกี่ยวกับการสร้างเสริมสุขภาพการป้องกันและควบคุมโรคและปัจจัยที่คุกคามสุขภาพ การตรวจวินิจฉัยและบําบัดสภาวะความเจ็บป่วย และการฟื้นฟูสมรรถภาพของบุคคล ครอบครัวและชุมชน\r\n\r\n',
    source:
      "พระราชบัญญัติสุขภาพแห่งชาติ พ.ศ. 2550. (2550, 19 มีนาคม). ราชกิจจานุเบกษา. เล่ม 124 \r\nตอนที่ 16 ก หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2550/A/016/1.PDF\r\n\r\n",
    sappear: "",
    mappear: 11,
    rappear: 5,
    firstalpha: "บ"
  },
  {
    keyword: "บริการอนามัย",
    meaning: "การบริการเกี่ยวกับสุขภาพ ที่ถูกสุขลักษณะ",
    source:
      "สำนักงานราชบัณฑิตยสถาน. (2556). อนามัย, 12 พฤศจิกายน 2562. http://www.royin.go.th/?knowledges=%E0%B8%AD%E0%B8%99%E0%B8%B2%E0%B8%A1%E0%B8%B1%E0%B8%A2-%E0%B9%91%E0%B9%93-%E0%B8%9E%E0%B8%A4%E0%B8%A9%E0%B8%A0%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%96",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "บ"
  },
  {
    keyword: "บริบท",
    meaning:
      "คำ ข้อความ หรือสถานการณ์แวดล้อมเพื่อช่วยให้เข้าใจความหมายของภาษาหรือของถ้อยคำ, ปริบท ก็ว่า.",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. บริบท, 21 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "บ"
  },
  {
    keyword: "บริษัทข้ามชาติ",
    meaning:
      "บริษัทที่มีฐานการผลิตหรือการลงทุนโดยตรงอยู่ในต่างประเทศอย่างน้อยหนึ่งประเทศและครอบคลุมกิจการระดับโลก",
    source:
      "กรมเชื้อเพลิงธรรมชาติ. นิยามศัพท์, 10 ตุลาคม 2562. https://dmf.go.th/public/list/data/index/menu/670/textsearch/%E0%B8%AA%E0%B8%B3%E0%B8%A3%E0%B8%AD%E0%B8%87%E0%B9%80%E0%B8%8A%E0%B8%B7%E0%B9%89%E0%B8%AD%E0%B9%80%E0%B8%9E%E0%B8%A5%E0%B8%B4%E0%B8%87/page/10",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "บ"
  },
  {
    keyword: "บริษัทร่วมทุน (Venture Capital)",
    meaning:
      "เป็นธุรกิจบริหารเงินร่วมลงทุนในลักษณะกองทุนระยะยาว โดยที่กองทุนดังกล่าวเข้าไปซื้อหุ้นในกิจการใดๆที่มีศักยภาพในการเติบโตสูง เพื่อที่ในอนาคตกองทุนนั้นจะได้ออกตัว (Exit) โดยมีผลตอบแทนการลงทุนที่คุ้มค่าความเสี่ยง",
    source:
      "สำนักนโยบายการออมและการลงทุน สำนักงานเศรษฐกิจการคลัง. (2557). มาทำความรู้จักกับช่องทางการระดมทุนในรูปแบบธุรกิจเงินร่วมลงทุน(Venture Capital) กันเถอะ, 4 ตุลาคม 2562. http://www2.fpo.go.th/S-I/Source/Article/Article174.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "บ"
  },
  {
    keyword: "บริหารจัดการภาครัฐ",
    meaning:
      "การพัฒนาคุณภาพการบริหารจัดการภาครัฐ (Public Sector Management Quality Award : PMQA)  เป็นกรอบการบริหารจัดการองค์การ ที่สำนักงาน ก.พ.ร. ได้ส่งเสริมและสนับสนุนให้ส่วนราชการนำไปใช้ในการประเมินองค์การด้วยตนเองที่ครอบคลุมภาพรวมในทุกมิติ เพื่อยกระดับคุณภาพการบริหารจัดการให้เทียบเท่ามาตรฐานสากล โดยมุ่งเน้นให้หน่วยงานราชการปรับปรุงองค์การอย่างรอบด้านและอย่างต่อเนื่องครอบคลุมทั้ง 7 ด้าน\r\n1.การนำองค์การ  \r\n2.การวางแผนเชิงยุทธศาสตร์\r\n3.การให้ความสำคัญกับผู้รับบริการและผู้มีส่วนได้ส่วนเสีย\r\n4.การวัด การวิเคราะห์ และการจัดการความรู้\r\n5.การมุ่งเน้นทรัพยากรมนุษย์\r\n6.การจัดการกระบวนการ\r\n7.ผลลัพธ์การดำเนินการ",
    source:
      "สำนักงานคณะกรรมการพัฒนาระบบราชการ. (2559). การพัฒนาคุณภาพการบริหารจัดการภาครัฐ, 8 ตุลาคม 2562. https://www2.opdc.go.th/special.php?spc_id=4&content_id=153",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "บ"
  },
  {
    keyword: "บริหารภาคีเครือข่ายแบบ synergic",
    meaning:
      "การรวมตัวเป็นเครือข่ายในลักษณะการแลกเปลี่ยนต้องสกัดเอาส่วนดีหรือจุดแข็งของแต่ละฝ่ายมาเรียนรู้และสนับสนุนกันและกันเป็นการผนึกกำลัง (synergy) ในลักษณะที่มากกว่า 1+1=2 แต่ต้องเป็น1+1>2 เรียกว่าเป็น “พลังทวีคูณ” ผลลัพธ์ที่ได้จากการทำงานเป็นเครือข่ายต้องดีกว่าผลรวมที่เกิดจากการปล่อยให้ต่างคนต่างทำแล้วนำผลลัพธ์ของแต่ละคนมารวมกัน",
    source:
      "ศูนย์บริหารข้อมูลตลาดแรงงาน กองบริหารข้อมูลตลาดแรงงาน. การสร้างเครือข่ายข้อมูลข่าวสารตลาดแรงงานสู่ตําบล หมู่บ้าน, 11 ตุลาคม 2562. https://www.doe.go.th/prd/assets/upload/files/lmia_th/0a416c0b816a2290b35d64bb442105cf.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "บ"
  },
  {
    keyword: "บัญชีนวัตกรรม ",
    meaning:
      "ผลิตภัณฑ์หรือบริการใหม่ที่พัฒนาขึ้นจากกระบวนการวิจัย พัฒนา หรือการปรับปรุงผลิตภัณฑ์หรือบริการเดิมด้วยองค์ความรู้ด้านวิทยาศาสตร์และเทคโนโลยีในประเทศไทย โดยคนไทยมีส่วนร่วม ซึ่งอาจเป็นผลิตภัณฑ์หรือบริการที่มีความคล้ายคลึงกับสิ่งที่มีอยู่แล้วก็ได้ ทั้งนี้นวัตกรรมไทยต้องผ่านการทดสอบและรับรองโดยหน่วยงานที่เชื่อถือได้ มีความปลอดภัยต่อผู้ใช้ และบริเวณใกล้เคียง อนึ่งนวัตกรรมไทยในที่นี้ ไม่จำเป็นต้องพัฒนาขึ้นในประเทศทั้งหมด อาจซื้อหรือนำเข้าบางส่วนมาจากต่างประเทศก็ได้",
    source:
      "สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ (สวทช.). บัญชีนวัตกรรมไทย, 4 ตุลาคม 2562. http://www.innovation.go.th/thai-innovation-register",
    sappear: "",
    mappear: 8,
    rappear: "",
    firstalpha: "บ"
  },
  {
    keyword: "บำเหน็จ",
    meaning:
      "เงินที่จ่ายให้แก่สมาชิกโดยจ่ายให้ครั้งเดียวเมื่อสมาชิกภาพของสมาชิกสิ้นสุดลง",
    source:
      "พระราชบัญญัติกองทุนบำเหน็จบำนาญข้าราชการ พ.ศ.2539 (2539, 27 กันยายน). ราชกิจจานุเบกษา. เล่ม 113 ตอนที่ 42 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2539/A/042/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "บ"
  },
  {
    keyword: "บุคคลกลุ่มพิเศษ",
    meaning:
      "บุคคลผู้พิการทุกประเภท ทุกระดับ ได้แก่ ผู้พิการทางการมองเห็นผู้พิการทางการได้ยินหรือสื่อความหมาย ผู้พิการ ทางร่างกาย หรือการเคลื่อนไหวและผู้พิการทางสติปัญญาหรือการเรียนรู้",
    source:
      "กรมพลศึกษา กระทรวงการท่องเที่ยวและกีฬา. แผนพัฒนานันทนาการแห่งชาติ ฉบับที่ 3 (พ.ศ. 2560 - 2564), 17 ตุลาคม 2562. https://chainat.mots.go.th/download/article/article_20190625135219.pdf",
    sappear: "",
    mappear: 14,
    rappear: "",
    firstalpha: "บ"
  },
  {
    keyword: "บุคลากรดิจิทัล",
    meaning:
      "บุคลากรที่อยู่ในอุตสาหกรรมดิจิทัล ที่ใช้เทคโนโลยีเข้มข้นและบุคลากรที่ใช้เทคโนโลยีและนวัตกรรมเพื่อเปลี่ยนแปลงรูปแบบและกระบวนการทำธุรกิจ",
    source:
      "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม. (2562). นโยบายและแผนระดับชาติว่าด้วยการพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม, 8 ตุลาคม 2562. https://www.etda.or.th/content_files/2/files/05_Thailand_Digital_Plan.pdf",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "บ"
  },
  {
    keyword: "บุคลากรทางการศึกษา",
    meaning: "บุคลากรทางการศึกษาตามกฎหมายว่าด้วยการศึกษาแห่งชาติ",
    source:
      "พระราชบัญญัติ กองทุนเพื่อความเสมอภาคทางการศึกษา\r\nพ.ศ. 2561. (2561, 13 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 33 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 12,
    firstalpha: "บ"
  },
  {
    keyword: "บุคลากรนันทนาการ",
    meaning:
      "บุคลากรที่ทำหน้าที่เกี่ยวกับนันทนาการ ได้แก่ ผู้นำนันทนาการ อาสาสมัคร บุคลากรนันทนาการอาชีพ และผู้บริหารจัดการด้านนันทนาการ",
    source:
      "กรมพลศึกษา กระทรวงการท่องเที่ยวและกีฬา. แผนพัฒนานันทนาการแห่งชาติ ฉบับที่ 3 (พ.ศ. 2560 - 2564), 17 ตุลาคม 2562. https://chainat.mots.go.th/download/article/article_20190625135219.pdf",
    sappear: "",
    mappear: 14,
    rappear: "",
    firstalpha: "บ"
  },
  {
    keyword: "บุคลากรวิจัยและนวัตกรรม",
    meaning:
      "ประกอบไปด้วยบุคลากร 3 กลุ่ม ได้แก่\r\n1) นักวิจัย หมายถึงผู้ที่ทำหน้าที่สร้างสรรค์องค์ความรู้ใหม่ ผลิตภัณฑ์ใหม่ กระบวนการใหม่ ระบบใหม่ รวมถึงบริหารจัดการโครงการวิจัยที่เกี่ยวข้อง\r\n2) ผู้ช่วยวิจัย หมายถึงช่างเทคนิคหรือบุคลากรที่ปฏิบัติงานในโครงการวิจัยและพัฒนาที่ต้องอาศัยความรู้เชิงเทคนิคและประสบการณ์ในศาสตร์ที่เกี่ยวข้องและปฏิบัติงานอยู่ภายใต้การควบคุมดูแลของนักวิจัยและ\r\n3) บุคลากรสนับสนุนอื่นๆ ทั้งที่ใช้ทักษะและไม่ใช้ทักษะที่ปฏิบัติงานในโครงการวิจัยและพัฒนาหรือสนับสนุนโครงการวิจัยและพัฒนาโดยตรง\r\nบุคลากรอีกกลุ่มหนึ่งคือบุคลากรที่มีบทบาทในกิจกรรมนวัตกรรม ทั้งที่เป็นนวัตกรรมทางเทคโนโลยีและนวัตกรรมเชิงสังคม โดยนอกเหนือจากเหนือจากบุคลากรวิจัยและพัฒนา บุคลากรกลุ่มนี้อาจรวมถึงนักวิทยาศาสตร์ วิศวกร นักพัฒนาเทคโนโลยี นักประดิษฐ์ นวัตกร ช่างเทคนิค แรงงาน STEM เกษตรกร นักบริหาร จัดการงานวิจัย เทคโนโลยีและนวัตกรรม นักบริหารจัดการองค์ความรู้ และปราชญ์ชาวบ้าน",
    source:
      "สภานโยบายวิจัยและนวัตกรรมแห่งชาติ. (ร่าง) แผนกลยุทธ์การพัฒนาบุคลากรวิจัยและนวัตกรรม ระยะ 20 ปี, 6 พฤศจิกาคม 2562. http://www2.nrct.go.th/portals/0/downloads/%E0%B8%A3%E0%B9%88%E0%B8%B2%E0%B8%87-%E0%B9%81%E0%B8%9C%E0%B8%99%E0%B8%81%E0%B8%A5%E0%B8%A2%E0%B8%B8%E0%B8%97%E0%B8%98%E0%B9%8C%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%9E%E0%B8%B1%E0%B8%92%E0%B8%99%E0%B8%B2%E0%B8%9A%E0%B8%B8%E0%B8%84%E0%B8%A5%E0%B8%B2%E0%B8%81%E0%B8%A3%E0%B8%A7%E0%B8%B4%E0%B8%88%E0%B8%B1%E0%B8%A2%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%99%E0%B8%A7%E0%B8%B1%E0%B8%95%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1-20%E0%B8%9B%E0%B8%B560-79.pdf",
    sappear: "",
    mappear: 23,
    rappear: "",
    firstalpha: "บ"
  },
  {
    keyword: "บุคลากรสุขภาพ",
    meaning: "แพทย์ ทันตแพทย์ เภสัชกร พยาบาลวิชาชีพ และพยาบาลเทคนิค",
    source:
      "สำนักนโยบายและยุทธศาสตร์ สำนักงานปลัดกระทรวงสาธารณสุข. (2559). แผนยุทธศาสตร์ชาติ ระยะ 20 ปี (ด้านสาธารณสุข), 29 ตุลาคม 2562. https://waa.inter.nstda.or.th/stks/pub/2017/20171117-MinistryofPublicHealth.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "บ"
  },
  {
    keyword: "บุริมสิทธิ",
    meaning:
      "สิทธิเหนือทรัพย์สินของลูกหนี้ในการที่จะได้รับชําระหนี้อันค้างชําระแก่ตนจากทรัพย์สินนั้นก่อนเจ้าหนี้อื่น ๆ",
    source:
      "กรมทะเบียนที่ดิน กระทรวงเกษตราธิการ. (2473). การจดทะเบียนบุริมสิทธิ, 3 กันยายน 2562. http://www.dol.go.th/registry/DocLib3/%E0%B8%9A%E0%B8%B8%E0%B8%A3%E0%B8%B4%E0%B8%A1%E0%B8%AA%E0%B8%B4%E0%B8%97%E0%B8%98%E0%B8%B4.pdf\r\n",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "บ"
  },
  {
    keyword: "บูรณาการ",
    meaning:
      "กระบวนการผสมผสานเชื่อมโยงองค์ความรู้ตั้งแต่ ๒ องค์ความรู้ขึ้นไปเข้าด้วยกันอย่างสอดคล้องเป็นระบบ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. บูรณาการ, 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 4,
    mappear: 15,
    rappear: 1,
    firstalpha: "บ"
  },
  {
    keyword: "ปฏิบัติการฉุกเฉิน",
    meaning:
      "การปฏิบัติการด้านการแพทย์ฉุกเฉินนับแต่การรับรู้ถึงภาวะการเจ็บป่วยฉุกเฉินจนถึงการดําเนินการให้ผู้ป่วยฉุกเฉินได้รับการบําบัดรักษาให้\r\nพ้นภาวะฉุกเฉินซึ่งรวมถึงการประเมิน การจัดการ การประสานงาน การควบคุม ดูแลการติดต่อสื่อสาร การลําเลียงหรือขนส่งการตรวจวินิจฉัย และการบําบัดรักษาพยาบาลผู้ป่วยฉุกเฉินทั้งนอกสถานพยาบาลและในสถานพยาบาล\r\n",
    source:
      "พระราชบัญญํติการแพทย์ฉุกเฉิน พ.ศ. 2551. (2551, 6 มีนาคม).\r\nราชกิจนาบุเษก. เล่ม 125 ตอนที่ 44 ก หน้า 2.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2551/A/044/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ป"
  },
  {
    keyword: "ปฏิรูปที่ดิน",
    meaning: "การพัฒนาพื้นที่ให้เอื้อต่อการใช้ประโยชน์ในที่ดินเพื่อเกษตรกรรม",
    source:
      "สำนักงานการปฏิรูปที่ดินเพื่อเกษตรกรรม. (2561). คู่มือการให้บริการประชาชนตามพระราชบัญญัติการอำนวยความสะดวกในการพิจารณาอนุญาตของทางราชการ พ.ศ. 2558 ระยะที่ 2, 4 ตุลาคม 2562. https://www.alro.go.th/alro_th/ewt_news.php?nid=1378&filename=index",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ป"
  },
  {
    keyword: "ปฏิสัมพันธ์",
    meaning:
      "การกระทำหรือการประกอบกิจกรรมระหว่างสิ่งสองสิ่งหรือสิ่งหลายสิ่งเพื่อให้ได้มาซึ่งผลลัพธ์ ไม่ว่าผลลัพธ์นั้นจะออกมาในทางที่ดีมีประโยชน์หรือออกมาในทางที่ก่อให้เกิดผลเสียต่อสิ่งที่กำลังกระทำหรือตอบโต้",
    source:
      "วิกิพีเดีย. (2560). ปฏิสัมพันธ์, 15 กรกฎาคม 2562. https://th.wikipedia.org/wiki/%E0%B8%9B%E0%B8%8F%E0%B8%B4%E0%B8%AA%E0%B8%B1%E0%B8%A1%E0%B8%9E%E0%B8%B1%E0%B8%99%E0%B8%98%E0%B9%8C",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ปฐมวัย",
    meaning:
      "เด็กซึ่งมีอายุต่ำกว่าหกปีบริบูรณ์ และให้ความหมายรวมถึงเด็กซึ่งต้องได้รับการพัฒนาก่อนเข้ารับการศึกษาในระดับปฐมศึกษา",
    source:
      "พระราชบัญญัติการพัฒนาเด็กปฐมวัย พ.ศ. 2562. (2562, 30 เมษายน). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 56 หน้า 5. \r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/056/T_0005.PDF",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ประเทศ CLMV",
    meaning:
      "CLMV คือ ประเทศในกลุ่ม asean ได้แก่ กัมพูชา ลาว พม่า เวียดนาม ที่มีแนวโน้มเศรษฐกิจโตต่อเนื่องและยังมีแร่ธาตุทรัพยากรอุดมสมบูรณ์ และยังมีค่าจ้างแรงงานไม่สูงมากนัก จึงเป็นประเทศที่มีคนสนใจเข้าไปลงทุนการผลิตและการตลาด แต่เนื่องด้วย CLMV นั้นมีพรมแดนติดกับไทยทุกประเทศ จึงเหมาะมากที่ผู้ประกอบการไทยจะเข้าไปลงทุนหรือทำธุรกิจ",
    source:
      "เรียนรู้พฤติกรรมผู้ซื้อในตลาด CLMV\r\nhttps://www.dtn.go.th/files/245/all%20ppt/Maketing_Behavior_in_CLMV.pdf",
    sappear: "",
    mappear: "",
    rappear: "5,10",
    firstalpha: "ป"
  },
  {
    keyword: "ประเทศไทย 4.0",
    meaning:
      "ยุทธศาสตร์การพัฒนาประเทศ โดยมุ่งเน้นการปรับเปลี่ยนโครงสร้างทางเศรษฐกิจมาสู่ระบบเศรษฐกิจที่เน้นการสร้างมูลค่า Value-Based Economy เพื่อพาประเทศไทยหลุดพ้นจากกับดักรายได้ปานกลางและกับดักความเหลื่อมล้ำทางสังคม รวมทั้งกับดักความไม่สมดุลในการพัฒนา โดยมีการปรับเปลี่ยนใน 4 มิติ ได้แก่ 1. ความมั่งคั่งทางเศรษฐกิจ 2. ความอยู่ดีมีสุขของผู้คนในสังคม 3. การยกระดับศักยภาพและคุณค่าของมนุษย์ 4. การรักษ์สิ่งแวดล้อม",
    source:
      "สำนักโฆษก สำนักเลขาธิการนายกรัฐมนตรี. วารสารไทยคู่ฟ้า (2559). เล่มที่ 33 มกราคม - มีนาคม 2560. https://spm.thaigov.go.th/FILEROOM/spm-thaigov/DRAWER004/GENERAL/DATA0000/00000368.PDF ",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ประเทศพัฒนาแล้ว",
    meaning:
      "ประเทศที่มีระดับรายได้ประชาชาติเฉลี่ยจริงสูงและโดยเปรียบเทียบแล้วมีภาคอุตสาหกรรมตติยภูมิ (บริการ) ขนาดใหญ่",
    source:
      "ณรงค์พล โชตเศรษฐ์ และ กฤติพร ศรียะพันธ์ สํานักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ. (2554). อภิธานศัพท์สําหรับองค์ความรู้การกํากับดูแลโครงสร้างและกิจการสาธารณูปโภค, 10 ตุลาคม 2562. http://regulationbodyofknowledge.org/wp-content/uploads/2013/04/glossary_THAI.pdf",
    sappear: "",
    mappear: 2,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ประเทศรายได้ปานกลาง",
    meaning:
      "สภาพของประเทศที่สามารถยกระดับจากประเทศยากจนมีรายได้ต่ำเข้าสู่ประเทศมีรายได้ปานกลาง แต่หลังจากนั้นต้องใช้ระยะเวลานานจึงจะสามารถก้าวขึ้นเป็นประเทศมีรายได้สูงเนื่องจากอัตราการเจริญเติบโตทางเศรษฐกิจต่ำ และอัตราเพิ่มขึ้นของประชากรสูง",
    source:
      "นางสาวมัณฑกา ลบล้ำเลิศ กลุ่มความร่วมมือระหว่างประเทศ. (2560). ประเทศไทย กับ กับดักรายได้ปานกลาง, 8 ตุลาคม 2562. file:///C:/Users/admin/Downloads/%C2%A1%C3%91%C2%BA%C2%B4%C3%91%C2%A1%C3%83%C3%92%C3%82%C3%A4%C2%B4%C3%A9%C2%BB%C3%92%C2%B9%C2%A1%C3%85%C3%92%C2%A7.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ป"
  },
  {
    keyword: "ประเทศรายได้สูง",
    meaning:
      "เกณฑ์การแบ่งกลุ่มประเทศตามระดับรายได้ของธนาคารโลกปี 2559 ประเทศที่มีรายได้สูง คือ ประเทศที่มีระดับรายได้ประชากรต่อหัว >12,235 สหรัฐอเมริกา",
    source:
      "บุญชัย จรัสแสงสมบูรณ์ ที่ปรึกษาด้านเศรษฐกิจระหว่างประเทศ สำนักงานเศรษฐกิจการคลัง. กับดักรายได้ปานกลาง: ความท้าทายที่ประเทศไทยต้องก้าวข้าม, 11 พฤศจิกายน 2562. http://www.dsdw2016.dsdw.go.th/doc_pr/ndc_2560-2561/PDF/8445e/8445%E0%B8%99%E0%B8%B2%E0%B8%A2%E0%B8%9A%E0%B8%B8%E0%B8%8D%E0%B8%8A%E0%B8%B1%E0%B8%A2%20%E0%B8%88%E0%B8%A3%E0%B8%B1%E0%B8%AA%E0%B9%81%E0%B8%AA%E0%B8%87%E0%B8%AA%E0%B8%A1%E0%B8%9A%E0%B8%B9%E0%B8%A3%E0%B8%93%E0%B9%8C.pdf",
    sappear: "",
    mappear: 16,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ประเมินความเสี่ยง",
    meaning:
      "การประเมินความเสี่ยงในเชิงคุณภาพและเชิงปริมาณต่อสิ่งที่จะเกิดขึ้นกับสุขภาพหรืออนามัยของมนุษย์และสิ่งแวดล้อม โดยแสดงประเภทสารมลพิษหรือความรุนแรงของพิษในสารนั้นๆ",
    source:
      "กรมควบคุมมลพิษ.บัญชีรายชื่อคำศัพท์, 18 กันยายน 2562. http://www.pcd.go.th/info_serv/QandA/defaultThai.cfm?task=listVocab",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ประโยชน์สาธารณะ",
    meaning:
      "ประโยชน์ของชุมชนโดยรวมไม่ใช่ผลรวมของผลประโยชน์ของปัจเจกบุคคล และไม่ใช่ผลประโยชน์ของกลุ่มคน ",
    source:
      "สำนักงานปลัดกระทรวงเกษตรและสหกรณ์. แนวทางการปฏิบัติงานเพื่อป้องกันผลประโยชน์ทับซ้อนของสำนักงานปลัดกระทรวงเกษตรและสหกรณ์, 18 กรกฎาคม 2562.   https://www.opsmoac.go.th/news-files-391191791856",
    sappear: "",
    mappear: 22,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ประกันคุณภาพการศึกษา",
    meaning:
      "การมีระบบและกลไกในการควบคุมตรวจสอบและประเมินการดำเนินงานในแต่ละองค์ประกอบคุณภาพ ตามรายการตรวจสอบ และตัวบ่งชี้คุณภาพที่กำหนด เพื่อเป็นหลักประกันแก่ผู้มีส่วนเกี่ยวข้องและสาธารณชนได้มั่นใจว่าสถานศึกษาแห่งนั้นสามารถให้ผลผลิตทางการศึกษาที่มีคุณภาพ",
    source:
      "มหาวิทยาลัยเชียงใหม่. นิยามศัพท์เฉพาะ การประกันคุณภาพการศึกษา, 12 กันยายน 2562.\r\nhttp://web.agri.cmu.ac.th/qa/document/2553/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD/cmu/technical_term/123.pdf",
    sappear: "",
    mappear: 12,
    rappear: 12,
    firstalpha: "ป"
  },
  {
    keyword: "ประกาศเจตนารมณ์",
    meaning: "การประกาศความมุ่งหมายและมักเป็นความมุ่งหมายในทางที่ดี ",
    source:
      "สำนักงานราชบัณฑิตยสถาน. (2550). เจตนา – เจตนารมณ์, 12 พฤศจิกายน 2562. http://www.royin.go.th/?knowledges=%E0%B9%80%E0%B8%88%E0%B8%95%E0%B8%99%E0%B8%B2-%E0%B9%80%E0%B8%88%E0%B8%95%E0%B8%99%E0%B8%B2%E0%B8%A3%E0%B8%A1%E0%B8%93%E0%B9%8C-%E0%B9%92%E0%B9%99-%E0%B8%A1%E0%B8%B5%E0%B8%99%E0%B8%B2",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ป"
  },
  {
    keyword: "ประกาศอุดมการณ์",
    meaning:
      "ประกาศหลักการที่วางระเบียบไว้เป็นแนวปฏิบัติเพื่อให้บรรลุเป้าหมายที่กำหนดไว้",
    source:
      "สำนักงานราชบัณฑิตยสถาน. (2556). อุดมการณ์, 11 พฤศจิกายน 2562. http://www.royin.go.th/?knowledges=%E0%B8%AD%E0%B8%B8%E0%B8%94%E0%B8%A1%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%93%E0%B9%8C-%E0%B9%97-%E0%B8%9E%E0%B8%A4%E0%B8%A9%E0%B8%A0%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%96",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ป"
  },
  {
    keyword: "ประชากรสูงอายุ",
    meaning:
      "ประชากรมีอายุสูงขึ้น วัดได้จากสัดส่วน (proportion) ของประชากรสูงอายุ (aged population) หรือ อายุมัธยฐาน (median age) ที่เพิ่มสูงขึ้น",
    source:
      "ศูนย์ศตวรรษิกชน สถาบันวิจัยประชากรและสังคม มหาวิทยาลัยมหิดล. old population, 3 กันยายน 2562. http://www.thaicentenarian.mahidol.ac.th/TECIC/index.php?option=com_glossary&Itemid=84",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ป"
  },
  {
    keyword: "ประชาคม",
    meaning: "ชุมชน, กลุ่มชนซึ่งอยู่รวมกันและมีการติดต่อสัมพันธ์กัน",
    source:
      "พจนานุกรม ฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ประชาคม , 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ประชาคมอาเซียน",
    meaning:
      "การรวมตัวกันของกลุ่มประเทศในภูมิภาคเอเชียตะวันออกเฉียงใต้ ภายใต้ชื่อสมาคมประชมคมแห่งเอเชียตะวันออกเฉียงใต้ Association of Southeast Asian Nations หรือ ASEAN ก่อตั้งขึ้นเมื่อวันที่ 8 สิงหาคม ค.ศ.1967 ณ กรุงเทพฯ เป็นองค์กรความร่วมมือระดับภูมิภาค การเจริญเติบโตทางการค้าและทางเศรษฐกิจ รวมทั้งการพัฒนาทางสังคมของประเทศสมาชิก เพื่อภูมิภาคเอเชียตะวันออกเฉียงใต้ แรกเริ่มประกอบด้วย 5 ประเทศ คือ อินโดนีเซีย มาเลเซีย ฟิลิปปินส์ สิงคโปร์ และไทย ต่อมาภายหลังได้มีชาติสมาชิกเพิ่มขึ้น คือ ประเทศบรูไน  เวียดนาม ลาว พม่าและกัมพูชา\r\n เมื่ออาเซียนอายุครบ 30 ปี ผู้นำอาเซียนได้ตกลงจัดตั้งประชาคมอาเซียน (ASEAN Community)ขึ้น โดยมีกฎกติการ่วมกันมากขึ้นภายใต้ 3 เสาหลัก ได้แก่\r\n 1. ประชาคมการเมืองและความมั่นคงอาเซียน (ASEAN Political - Security Community - APSC)\r\n 2. ประชาคมเศรษฐกิจอาเซียน (ASEAN Economic Community - AEC)\r\n 3. ประชาคมสังคมและวัฒนธรรมอาเซียน (ASEAN Socio - Cultural Community - ASCC)",
    source:
      "กองส่งเสริมศิลปะและวัฒนธรรม. ประชาคมอาเซียน คืออะไร, 2 กรกฎาคม 2562. http://department.utcc.ac.th/thaiculture/index.php/360/24-2013-03-07-08-42-24",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ประชาธิปไตย",
    meaning: "ระบอบการปกครองที่ถือมติปวงชนเป็นใหญ่, การถือเสียงข้างมากเป็นใหญ่",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. \r\nประชาธิปไตย, 20 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 1,
    mappear: "",
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ประชาธิปไตยแบบทางตรง",
    meaning:
      "การมีส่วนร่วมทางการเมืองในระบอบประชาธิปไตยโดยตรง\r\n(Direct Democracy) ซึ่งการมีส่วนร่วมในลักษณะนี้ประชาชน หรือพลเมืองของรัฐจะทำหน้าที่เป็น “สภา” โดยทุกคนจะมีส่วนร่วมในการประชุมพิจารณาเรื่องต่าง ๆ ด้วยตัวเอง เพราะเชื่อว่า ประชาชนทุกคนต้องมีส่วนร่วมในการกำหนดกฎเกณฑ์ในสังคม แต่ภายหลังเมื่อสมาชิก\r\nของสังคมเพิ่มมากขึ้นและสังคมมีความซับซ้อนขึ้น การปกครองในระบอบประชาธิปไตยโดยตรงจึงกลายเป็นเรื่องยากที่จะสามารถทำได้จริง เพราะประชาชนทุกคนไม่สามารถเข้ามาใช้อำนาจของตนเองได้ในทุกกิจกรรมของประเทศ  ปัจจุบันมีการใช้ประชาธิปไตยทางตรง\r\nในเรื่องของการลงประชามติ (referendum) การเสนอร่างกฎหมาย (initiative) และการถอดถอนผู้แทนรายบุคคลหรือทั้งสภา",
    source:
      "สำนักเลขาธิการสภาผู้แทนราษฎร.การมีส่วนร่วมทางการเมืองในระบอบประชาธิปไตย. ประชาธิปไตยทางตรง (Direct Democracy) , 19 พฤศจิยายน 2562.\r\nhttps://www.parliament.go.th/ewtadmin/ewt/parliament_parcy/download/article/article_20180531155204.pdf",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ป"
  },
  {
    keyword: "ประชาธิปไตยแบบปรึกษาหารือ",
    meaning:
      "การมีส่วนร่วมทางการเมืองของประชาชนในระบอบ\r\nประชาธิปไตยแบบถกแถลง (สานเสวนาหาทางออก)  (Deliberative Democracy) เป็นประชาธิปไตยแบบถกแถลงที่เป็นกระบวนการสำคัญของประชาธิปไตยภาคพลเมือง ประชาธิปไตยชุมชน เป็นความพยายามที่จะแก้ไขปัญหาที่เกิดจากข้อบกพร่องของประชาธิปไตย\r\nแบบตัวแทนที่เป็นรูปแบบสถาบันที่ตายตัวไม่สามารถตอบสนองความต้องการของประชาชนที่มีความซับซ้อน และมีความแตกต่างหลากหลายได้",
    source:
      "สำนักเลขาธิการสภาผู้แทนราษฎร.การมีส่วนร่วมทางการเมืองในระบอบประชาธิปไตย. ประชาธิปไตยทางตรง (Direct Democracy) , 19 พฤศจิยายน 2562.\r\nhttps://www.parliament.go.th/ewtadmin/ewt/parliament_parcy/download/article/article_20180531155204.pdf",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ป"
  },
  {
    keyword: "ประชาธิปไตยในแบบของไทย",
    meaning:
      "รูปการปกครองแบบประชาธิปไตย ซึ่งเหมาะสมกับวัฒนธรรมประเพณีของชาติไทยและสอดคล้องกับสถานการณ์",
    source:
      "สุมาลี พันธุ์ยุรา. ระบอบประชาธิปไตยแบบไทย, 2 กรกฎาคม 2562. http://wiki.kpi.ac.th/index.php?title=%E0%B8%A3%E0%B8%B0%E0%B8%9A%E0%B8%AD%E0%B8%9A%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%8A%E0%B8%B2%E0%B8%98%E0%B8%B4%E0%B8%9B%E0%B9%84%E0%B8%95%E0%B8%A2%E0%B9%81%E0%B8%9A%E0%B8%9A%E0%B9%84%E0%B8%97%E0%B8%A2",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ป"
  },
  {
    keyword: "ประชาธิปไตยชุมชน",
    meaning:
      "รูปแบบหนึ่งของประชาธิปไตยแบบมีส่วนร่วมที่เน้นการดำเนินการโดยชุมชน เพื่อให้ชุมชนใช้สิทธิการมีส่วนร่วมในการบริหารกิจการท้องถิ่น ร่วมกับองค์การบริหารส่วนท้องถิ่นและภาคราชการ รวมไปถึงการแก้ไขปัญหาและการพัฒนาในด้านต่างๆที่ดำเนินการโดยชุมชนเอง ภายใต้แนวคิดชุมชนจัดการตนเอง เป็นการนำพาประชาชนให้แสดงออกถึงความเป็นพลเมืองที่จะใช้อำนาจของตนเองควบคู่ไปกับการมอบอำนาจให้ตัวแทนผ่านกระบวนการในการขับเคลื่อนชุมชนในทุกระดับ",
    source:
      "ภาวินี รอดประเสริฐ, วราวุธ บุญศรี. (2561). ประชาธิปไตยชุมชน: กระบวนการขับเคลื่อนสังคม, 2 กรกฎาคม 2562. http://www.journal.msu.ac.th/upload/articles/article2133_2694.pdf",
    sappear: 4,
    mappear: "",
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ประชาพิจารณ์",
    meaning:
      "การแสดงความคิดเห็นของประชาชนต่อประเด็นปัญหาใดปัญหาหนึ่ง โดยการจัดทำประชาพิจารณ์อาจกระทำโดยหน่วยงานของรัฐ ทั้งนี้ เพื่อที่จะรับฟังความเห็นของประชาชน ในกรณีที่ประชาชนเป็นผู้ได้รับผลกระทบโดยตรง",
    source:
      "ปธาน สุวรรณมงคล. ประชาพิจารณ์, 2 กรกฎาคม 2562. http://wiki.kpi.ac.th/index.php?title=%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%8A%E0%B8%B2%E0%B8%9E%E0%B8%B4%E0%B8%88%E0%B8%B2%E0%B8%A3%E0%B8%93%E0%B9%8C",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ป"
  },
  {
    keyword: "ประชามติ",
    meaning:
      "1. มติของประชาชนส่วนใหญ่ในประเทศที่แสดงออกในเรื่องใดเรื่องหนึ่งหรือที่ใดที่หนึ่ง\r\n2. มติของประชาชนที่รัฐให้สิทธิออกเสียงลงคะแนนรับรองร่างกฎหมายสำคัญที่ได้ผ่านสภานิติบัญญัติแล้ว หรือให้ตัดสินในปัญหาสำคัญในการบริหารประเทศ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ประชามติ. 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ป"
  },
  {
    keyword: "ประชารัฐ",
    meaning:
      "“ประชารัฐ” เกิดจากคำว่า “ประชา” หมายถึง ประชาชน รวมกับ\r\n คำว่า “รัฐ” คือ รัฐบาล จึงสรุปความหมายได้ว่าเป็นการ\r\n ประสานพลังทุกภาคส่วน ทั้งภาครัฐ ภาคเอกชน\r\n ภาคประชาชน รวมทั้ง ภาคส่วนย่อยอื่น ๆ\r\n ช่วยขับเคลื่อนประเทศในแต่ละด้านอย่างสร้างสรรค์\r\n พัฒนา เศรษฐกิจฐานราก นำไปสู่การพึ่งพาตนเอง\r\n ได้อย่างยั่งยืน",
    source:
      "สำนักงานเลขาธิการสภาผู้แทนราษฎร. (2561).สานพลังประชารัฐ,18 มิถุนายน 2562.https://www.parliament.go.th/ewtadmin/ewt/parliament_parcy/download/article/article_20180731115248.pdf",
    sappear: 4,
    mappear: 18,
    rappear: 2,
    firstalpha: "ป"
  },
  {
    keyword: "ประชารัฐโมเดล",
    meaning:
      "ความร่วมมือระหว่างรัฐบาลและประชาชน โดยรัฐบาลและประชาชน ซึ่งรัฐบาลจะเป็นผู้อำนวยความสะดวกและเปิดให้ประชาชนเข้ามามีส่วนร่วมตามกระบวนการประชาธิปไตย เพื่อไม่ให้เกิดความขัดแย้งระหว่างรัฐบาลกับประชาชน ",
    source:
      "นายอานันท์ เกียรติสารพิภพ นิติกรชำนาญการพิเศษ สำนักวิชาการ. (2560). ยุทธศาสตร์ประชารัฐ, 26 กันยายน 2562. https://library2.parliament.go.th/giventake/content_royrueng/2560/rr2560-dec6.pdf",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ประชาสังคม",
    meaning:
      "ประชาสังคมเป็นรูปแบบของสังคมที่ให้ความสำคัญต่อกิจกรรมสาธารณะแตกต่างกับกิจกรรมของครอบครัวและกิจกรรมของรัฐดั้งเดิม กิจกรรมประชาสังคมดำเนินการภายใต้กรอบนิติกรรม และมีขอบเขตครอบคลุมประเด็นการมีส่วนร่วมสาธารณะ องค์การ อาสาสมัคร สื่อสารมวลชน องค์การวิชาชีพ สหภาพแรงงาน ฯลฯ\r\nประชาสังคมมีลักษณะเป็นพลวัตซึ่งรวมความหมายถึงขบวนการทางสังคม หรือหมายถึงความเป็นพลเมืองในแง่ที่เป็นพลวัตของความเป็นประชาชนที่เกี่ยวข้องกับกระบวนการพิจารณา ตรวจสอบ ทบทวน และกำหนดนิยามใหม่ของสิทธิและหน้าที่ของประชาชน บางครั้ง ประชาสังคมใช้คำว่า “ภาคที่ 3” (third sector) แทน ซึ่งหมายถึง ภาคที่ไม่ใช่รัฐบาลและธุรกิจ หากแต่เป็นภาคอิสระ (independent sector) หรือภาคประชาชน”",
    source:
      "สำนักงานราชบัณฑิตยสภา. ประชาสังคม. 2 กรกฎาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%8A%E0%B8%B2%E0%B8%AA%E0%B8%B1%E0%B8%87%E0%B8%84%E0%B8%A1-%E0%B9%94-%E0%B8%A1%E0%B8%B4%E0%B8%96%E0%B8%B8%E0%B8%99%E0%B8%B2%E0%B8%A2%E0%B8%99-%E0%B9%92%E0%B9%95",
    sappear: 5,
    mappear: 18,
    rappear: 11,
    firstalpha: "ป"
  },
  {
    keyword: "ประชุมเชิงปฏิบัติการ (workshop)",
    meaning:
      "การประชุมร่วมกันเป็นกลุ่มสำหรับระยะเวลาหนึ่ง เน้นการฝึกหรือลงมือปฏิบัติ เพื่อให้เกิดทักษะ/ความเชี่ยวชาญ",
    source:
      "นางละเอียด  เอี่ยมสุวรรณ ผู้อำนวยการกองคลัง กรมควบคุมโรค กระทรวงสาธารณสุข. ความแตกต่างระหว่าง การประชุมราชการ vs การประชุมเชิงปฏิบัติการ/การฝึกอบรม, 11 กันยายน 2562. http://envocc.ddc.moph.go.th/uploads/media/b.ppt",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ป"
  },
  {
    keyword: "ประทานบัตร",
    meaning:
      "หนังสือสำคัญที่ออกให้ตามกฎหมายว่าด้วยแร่ เพื่อให้มีสิทธิทำเหมืองแร่ภายในเขตที่กำหนดในหนังสือสำคัญนั้น",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ประทานบัตร. 18 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ประนีประนอม",
    meaning: "ผ่อนหนักผ่อนเบาให้แก่กัน, ปรองดองกัน, อะลุ้มอล่วยกัน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ประนีประนอม. 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ป"
  },
  {
    keyword: "ประมงพาณิชย์",
    meaning:
      "การทําการประมงโดยใช้เรือประมงที่มีขนาดตั้งแต่สิบตันกรอสขึ้นไป หรือที่ใช้เครื่องยนต์มีกําลังแรงม้าถึงขนาดที่รัฐมนตรีประกาศกําหนด หรือใช้เรือประมงโดยมีหรือ ใช้เครื่องมือทําการประมงตามประเภท วิธี จํานวนแรงงานที่ใช้ หรือลักษณะการทําการประมงตามที่ รัฐมนตรีประกาศกําหนด และให้หมายความรวมถึงการใช้เรือประมงดังกล่าวทําการแปรรูปสัตว์น้ําไม่ว่า จะมีการทําการประมงด้วยหรือไม่ก็ตาม",
    source:
      "พระราชกำหนดการประมง (ฉบับที่ 2) พ.ศ. 2560. (2560, 28 มิถุนายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนที่ 67 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/A/067/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ป"
  },
  {
    keyword: "ประมงพื้นบ้าน",
    meaning:
      "การทำการประมงในเขตทะเลชายฝั่งไม่ว่าจะใช้เรือประมง หรือใช้เครื่องมือโดยไม่ใช้เรือประมง  ทั้งนี้ ที่มิใช่เป็นประมงพาณิชย์",
    source:
      "พระราชกำหนดการประมง พ.ศ. 2558. (2558, 13 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 132 ตอนที่ 108 ก หน้า 3. http://www.ratchakitcha.soc.go.th/DATA/PDF/2558/A/108/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ป"
  },
  {
    keyword: "ประมวลความประพฤติ (Code of Conducts)",
    meaning:
      "สิ่งที่ต้องปฏิบัติหรือต้องละเว้นปฏิบัติ  หากฝ่าฝืน จะเป็นการผิดวินัย ต้องถูกลงโทษ ",
    source:
      "ธนาคารแห่งประเทศไทย. ข้อบังคับธนาคารแห่งประเทศไทย ว่าด้วยประมวลจริยธรรมและจรรยาบรรณพนักงาน (Code of Conduct &Ethics), 7 ตุลาคม 2562. https://www.bot.or.th/Thai/AboutBOT/RolesAndHistory/Pages/moral.aspx",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "ป"
  },
  {
    keyword: "ประมวลจริยธรรม",
    meaning:
      "ให้ข้าราชการทั้งหลายเกิดสำนึกลึกซึ้งและเที่ยงธรรมในหน้าที่ ผดุงเกียรติและศักดิ์ศรีข้าราชการควรแก่ความไว้วางใจและเชื่อมั่นของปวงชน และดำรงตนตั้งมั่นเป็นแบบอย่างที่ดีงาม สมกับความเป็นข้าราชการ",
    source:
      "ประมวลจริยธรรมข้าราชการพลเรือน. (2552, 5 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 126 ตอนพิเศษ 162 ง หน้า 74. http://www.ratchakitcha.soc.go.th/DATA/PDF/2552/E/162/73.PDF",
    sappear: 6,
    mappear: "",
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ประมวลรัษฎากร",
    meaning:
      "ประมวลรัษฎากรเป็นกฎหมายที่ให้อำนาจกรมสรรพากรจัดเก็บภาษี 5 ประเภทใหญ่ ๆ ได้แก่ ภาษีเงินได้บุคคลธรรมดา ภาษีเงินได้นิติบุคคล ภาษีมูลค่าเพิ่ม ภาษีธุรกิจเฉพาะ และอากรแสตมป์ ภาษีอากรแต่ละประเภทมีลักษณะและวิธีการจัดเก็บที่แตกต่างกัน",
    source:
      "กรมสรรพากร. (2561). ประเภทภาษีอากร, 30 สิงหาคม 2562. https://www.rd.go.th/publish/38055.0.html",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ป"
  },
  {
    keyword: "ประวัติศาสตร์ท้องถิ่น",
    meaning:
      "เครื่องมือหนึ่งที่ทำให้คนเห็นรากเหง้าของตนเอง เกิดสำนึกความเห็นคุณค่า ความภูมิใจ และศักดิ์ศรีของสิ่งที่ตนเองมีอยู่ที่เป็นมรดกตกทอดมาจากบรรพบุรุษในท้องถิ่น ความภูมิใจนี้ทำให้คนเรามีความเชื่อมั่นในตัวเองว่ามีของดีอยู่ ใครมาบอกให้เชื่ออะไรก็ไม่หลงตามเขาไปง่าย ๆ",
    source:
      "สำนักงานคณะกรรมการส่งเสริมวิทยาศาสตร์ วิจัยและนวัตกรรม (สกสว.). (2552). ความสำคัญและบทบาทของประวัติศาสตร์ท้องถิ่นในปัจจุบัน, 25 ตุลาคม 2562. https://www.trf.or.th/index.php?option=com_content&view=article&id=1031:---35&catid=37:research-exploitation&Itemid=148&option=com_content&view=article&id=1031:---35&catid=37:research-exploitation&Itemid=148",
    sappear: "",
    mappear: 12,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ประวิงเวลา",
    meaning:
      "การพยายามทำให้เรื่องที่กำลังจะเกิดขึ้นเกิดช้ากว่าเดิมเพื่อประโยชน์ของตน",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2556). ถ่วงเวลา-ประวิงเวลา-ซื้อเวลา, 2 กรกฎาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%96%E0%B9%88%E0%B8%A7%E0%B8%87%E0%B9%80%E0%B8%A7%E0%B8%A5%E0%B8%B2-%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%A7%E0%B8%B4%E0%B8%87%E0%B9%80%E0%B8%A7%E0%B8%A5%E0%B8%B2-%E0%B8%8B%E0%B8%B7%E0%B9%89%E0%B8%AD",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ป"
  },
  {
    keyword: "ประสิทธิผล",
    meaning: "ผลสำเร็จ, ผลที่เกิดขึ้น",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ประสิทธิผล. 22 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: "1,2",
    firstalpha: "ป"
  },
  {
    keyword: "ประสิทธิภาพ",
    meaning: "ความสามารถที่ทำให้เกิดผลในการงาน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ประสิทธิภาพ. 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ป"
  },
  {
    keyword: "ปราชญ์ชาวบ้าน",
    meaning:
      "บุคคลที่เป็นเจ้าของภูมิปัญญาชาวบ้าน และนำภูมิปัญญาไปใช้ประโยชน์ในการ ดำรงชีวิตจนประสบความสำเร็จ สามารถถ่ายทอดเชื่อมโยงคุณค่าของอดีตกับปัจจุบันได้เหมาะสม",
    source:
      "สำนักงานพัฒนาชุมชนอำเภอเขาคิชฌกูฎ จังหวัดจันทบุรี. (2560). ปราชญ์ชาวบ้าน คือ, 21 มิถุนายน 2562. http://district.cdd.go.th/khaokhitchakut/services/%E0%B8%9B%E0%B8%A3%E0%B8%B2%E0%B8%8A%E0%B8%8D%E0%B9%8C%E0%B8%8A%E0%B8%B2%E0%B8%A7%E0%B8%9A%E0%B9%89%E0%B8%B2%E0%B8%99-%E0%B8%84%E0%B8%B7%E0%B8%AD/",
    sappear: "",
    mappear: 10,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ปศุสัตว์",
    meaning:
      "สัตว์เศรษฐกิจที่มนุษย์นำมาเลี้ยง เพื่อผลประโยชน์อย่างใดอย่างหนึ่ง หรือหลายอย่าง เช่น เพื่อใช้งาน และเป็นอาหาร เป็นต้น สัตว์เศรษฐกิจมีทั้งสัตว์สี่เท้า เช่น โค กระบือ ม้า แพะ แกะ สุกร และสัตว์ปีก เช่น เป็ด ไก่ ห่าน ไก่งวง เป็นต้น",
    source:
      "สารานุกรมไทยสำหรับเยาวชนฯ. เล่มที่ ๑๒. เรื่องที่ ๕ การพัฒนาการเกษตรในชนบท การเลี้ยงปศุสัตว์. 29 มิถุนายน 2562. http://kanchanapisek.or.th/kp6/sub/book/book.php?book=12&chap=5&page=t12-5-infodetail01.html",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ปัจเจกบุคคล",
    meaning: "เฉพาะคนหรือบุคคลแต่ละคน",
    source:
      "สำนักงานราชบัณฑิตยสภา. ปัจเจกบุคคล , 18 พฤศจิกายน 2562. http://www.royin.go.th/?knowledges=%E0%B8%9B%E0%B8%B1%E0%B8%88%E0%B9%80%E0%B8%88%E0%B8%81-%E0%B9%91%E0%B9%97-%E0%B8%98%E0%B8%B1%E0%B8%99%E0%B8%A7%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%95",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ป"
  },
  {
    keyword: "ปัจจัยเสี่ยงที่คุกคามสุขภาวะ",
    meaning:
      "ปัจจัยที่เพิ่มโอกาศของการเกิดโรคและผลกระทบต่อสุขภาวะของบุคคลหรือกลุ่มบุคคล ซึ่งอาจก่อให้เกิดผลกระทบต่อสุขภาวะของบุคคลหรือกลุ่มบุคคล ซึ่งอาจก่อให้เกิดผลกระทบได้ทั้งทางตรงและทางอ้อม และไม่เพียงส่งผลกระทบสุขภาวะทางจิต ทางปัญญา และทางสังคม",
    source:
      "สำนักงานกองทุนสนับสนุนการสร้างเสริมสุขภาพ. ทิศทาง เป้าหมาย และยุทธศาสตร์ ระยะ 10 ปี กองทุนสนับสนุนการสร้างเสริมสุจภาพ พ.ศ. 2555- 2564, 9 ธันวาคม 2562. https://www.thaihealth.or.th/contact/getfile_books.php?e_id=429",
    sappear: 3,
    mappear: 13,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ปัญญาประดิษฐ์",
    meaning:
      "วิทยาการด้านปัญญาที่จะมาช่วยให้มนุษย์แก้ปัญหาต่างๆ ได้ดีขึ้น โดยสร้างหุ่นยนต์ให้สามารถทำงานได้เหมือนมนุษย์ หรือจะใส่ซอฟต์แวร์ปัญญาประดิษฐ์ลงไปในคอมพิวเตอร์ ให้คอมพิวเตอร์ช่วยจำลองการทำงานต่างๆ เลียนแบบพฤติกรรมของคน โดยเน้นตามแนวความคิดแบบสมองมนุษย์ที่มีการวางแผนขั้นตอนการเรียนรู้ การคิด การกระทำ การให้เหตุผล การตัดสินใจ การปรับตัว การแก้ปัญหา รวมไปถึงการเลือกแนวทางการดำเนินการในลักษณะคล้ายมนุษย์",
    source:
      "ศูนย์เทคโนโลยีสารสนเทศและการสื่อสาร สำนักงานปลัดกระทรวงวิทยาศาสตร์และเทคโนโลยี. เทคโนโลยีเสมือนมนุษย์ AI, 26 กันยายน 2562. https://www.ops.go.th/main/index.php/knowledge-base/article-pr/661-ai.html",
    sappear: 2,
    mappear: "1,4",
    rappear: 10,
    firstalpha: "ป"
  },
  {
    keyword: "ป่า",
    meaning:
      "ที่ดินรวมตลอดถึง ภูเขา ห้วย หนอง คลอง บึง บาง ลำน้ำ ทะเลสาบ เกาะ และที่ชายทะเลที่ยังมิได้มีบุคคลได้มาตามกฎหมาย\r\n",
    source:
      "พระราชบัญญัติป่าสงวนแห่งชาติ พ.ศ. 2507  (2507,28 เมษายน) ราชกิจจานุเบกษา.เล่ม 81 ตอนที่ 38 ก หน้า 13 http://www.ratchakitcha.soc.go.th/DATA/PDF/2507/A/038/263.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ป"
  },
  {
    keyword: "ป่าเศรษฐกิจ",
    meaning:
      "พื้นที่ป่าสงวนแห่งชาติที่กำหนดไว้เพื่อการผลิตไม้และของป่า รวมถึงพื้นที่เศรษฐกิจตามนัยมติคณะรัฐมนตรีเกี่ยวกับการกำหนดชั้นคุณภาพลุ่มน้ำและการจำแนกเขตการใช้ประโยชน์ที่ดินป่าไม้ในพื้นที่ป่าชายเลน ป่าสงวนแห่งชาติที่ถูกกำหนดเป็นป่าค่อนข้างเสื่อมโทรมและใกล้เขตชุมชน ได้แก่ พื้นที่พัฒนาป่าธรรมชาติ",
    source:
      "ดรรชณี เฉยเพ็ชร นักวิชาการสิ่งแวดล้อมชำนาญการ กรมชลประทาน และเกื้อศักดิ์ ทาทอง หัวหน้ากลุ่มสิ่งแวดล้อมโครงการ สำนักบริหารโครงการ กรมชลประทาน. เทคนิคอย่างง่ายในการพิจารณาระดับการศึกษาจัดทำรายงานการวิเคราะห์ผลกระทบสิ่งแวดล้อมด้านโครงการพัฒนาแหล่งน้ำเพื่อประกอบการขออนุญาตใช้พื้นที่ป่าไม้, 25 ตุลาคม 2562. http://oopm.rid.go.th/subordinate/opm11/document/eia-guideline.pdf\r\n",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ป่าครอบครัว",
    meaning:
      "การปลูกต้นไม้หลากหลายชนิด ในที่ดินที่ครอบครัวครอบครองอยู่ เช่น ที่ว่างในบ้าน ตามหัวไร่ปลายนา หรือปลูกแซมในสวนในแปลงปลูกพืชเศรษฐกิจ ซึ่งอาจเป็นพื้นที่ป่าดั้งเดิมที่อนุรักษ์ไว้ให้เป็นป่าธรรมชาติ หรือเป็นพื้นที่ที่ครอบครัวปลูกขึ้นใหม่ เพื่อเป็นแหล่งอาหารและป่าที่ยั่งยืน",
    source:
      "สำนักงานพัฒนาเศรษฐกิจจากฐานชีวภาพ (องค์การมหาชน). (2560). ป่าครอบครัว…สืบสานปฏิธานพ่อ สานต่อเศรษฐกิจพอเพียง, 19 กรกฎาคม 2562. http://www.bedo.or.th/bedo/new-content.php?id=202",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ป่าชายเลน",
    meaning:
      "ระบบนิเวศที่ประกอบไปด้วยพันธุ์พืช พันธุ์สัตว์หลายชนิด ดำรงชีวิตร่วมกันในสภาพแวดล้อมที่เป็นดินเลน น้ำกร่อย และมีน้ำทะเลท่วมถึงอย่างสม่ำเสมอ ซึ่งจะพบได้ตามชายฝั่งทะเล ปากแม่น้ำ ทะเลสาบ และรอบเกาะแก่งต่างๆ ในพื้นที่ชายฝั่งทะเล พันธุ์ไม้ที่มีมากและมีบทบาทสำคัญที่สุดในป่าชายเลน คือ ไม้โกงกาง จึงมีชื่อเรียกอีกอย่างว่า ป่าโกงกาง",
    source:
      "กรมทรัพยากรทางทะเลและชายฝั่ง. ข้อมูลทั่วไปของป่าชายเลน, 18 กรกฎาคม 2562. https://km.dmcr.go.th/th/c_11",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ป่าชายหาด",
    meaning:
      "ป่าชายหาดหรือสังคมพืชป่าชายหาด พบตามชายฝั่งทะเลที่เป็นหาดทรายพืชพรรณไม้เป็นแนวแคบ ๆ หรือกระจัดกระจายเป็นหย่อม ๆ เป็นป่าที่ปกคลุมอยู่บริเวณชายฝั่งทะเลที่ดินเป็นดินทรายน้ำทะเลท่วมไม่ถึงหรือบริเวณหาดทรายเก่าที่ยกตัวสูงขึ้น หรือบริเวณที่หินชิดฝั่งทะเล ดินค่อนข้างเค็มและที่สำคัญคือมีไอเค็ม (salt spray) จากทะเลพัดเข้าถึง พรรณพืชส่วนใหญ่ของป่าชนิดนี้เป็นพืชทนเค็ม(halophytes) และลำต้นคดงอด้วยแรงลม ส่วนสังคมพืชบนหน้าผา (cliff community) ที่อยู่ริมทะเลมักเป็นพืชที่ทนความแห้งแล้ง (xerophytes) ไม่ถือเป็นสังคมพืชป่าชายหาดแม้ว่ามีพืชทนเค็มปรากฏปะปนอยู่บ้าง ด้วยเหตุนี้ป่าชายหาดจึงจำกัดอยู่เฉพาะบริเวณหาดทรายตั้งแต่แนวต้นไม้ซึ่งคลื่นพัดขึ้นมาท่วมไม่ถึง ลึกเข้าไปจนหมดอิทธิพลของไอเค็มจากทะเล",
    source:
      "กรมรัพยากรทางทะเล. (2556). ลักษณะของป่าชายหาด, 5 กรกฎาคม 2562. https://km.dmcr.go.th/th/c_213",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ป่าชุมชน",
    meaning:
      "ป่านอกเขตป่าอนุรักษ์หรือพื้นที่อื่นของรัฐนอกเขตป่าอนุรักษ์ ที่ได้รับอนุมัติให้จัดตั้งเป็นป่าชุมชน โดยชุมชนร่วมกับรัฐในการอนุรักษ์ ฟื้นฟูจัดการบำรุงรักษา ตลอดจนใช้ประโยชน์จากทรัพยากรธรรมชาติ สิ่งแวดล้อม และความหลากหลายทางชีวภาพในป่าชุมชน อย่างสมดุลและยั่งยืน",
    source:
      "พระราชบัญญัติป่าชุมชน พ.ศ. 2562 (29 พฤษภาคม 2562). ราชกิจจานุเบกษา เล่ม 136 ตอนที่ 71 ก หน้า 72. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/071/T_0071.PDF",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ป่าต้นน้ำ",
    meaning:
      "ป่าธรรมชาติที่ปรากฎอยู่บริเวณพื้นที่แหล่งต้นน้ำลำธาร ซึ่งโดยทั่วไปอยู่ในพื้นที่สูงจากระดับน้ำทะเล 700 เมตรขึ้นไป หรือเป็นพื้นที่ลาดชันมากกว่า 35% ชนิดของป่าไม้ที่มักจะปรากฎให้เห็นในพื้นที่ต้นน้ำ ได้แก่ ป่าดิบเขา ป่าดิบชื้น ป่าดิบแล้ง ป่าเบญจพรรณ และป่าเต็งรัง ทั้งนี้พื้นที่ต้นน้ำแห่งหนึ่งอาจถูกปกคลุมไปด้วยป่าไม้เพียงชนิดเดียว หรือหลายชนิดปะปนกันไปได้ ขึ้นอยู่กับหลายปัจจัย อาทิ อุณหภูมิ ปริมาณน้ำฝน ลักษณะภูมิประเทศ และชนิดของดิน ซึ่งส่งผลให้ระบบนิเวศของป่าต้นน้ำมีความหลากหลายแตกต่างกันไปตามชนิด ปริมาณ และประเภทของสิ่งมีชีวิตที่อยู่ในผืนป่า แต่สิ่งที่เหมือนกัน คือ คุณค่าของป่าต้นน้ำ ที่ทำหน้าที่ควบคุมระบบการดูดซับและเก็บกักน้ำฝนตามธรรมชาติ ตลอดจนการควบคุมการกัดเซาะการพังทลายของดิน รวมทั้งช่วยลดความร้อนจากแสงอาทิตย์ และช่วยดูดซับก๊าซคาร์บอนไดออกไซด์ ซึ่งเป็นก๊าซเรือนกระจกชนิดหนึ่งได้",
    source:
      "มูลนิธิไทยรักษ์ป่า. (2557). ป่าต้นน้ำ ต้นทางชีวิต, 19 กรกฎาคม 2562. http://www.thairakpa.org/%E0%B8%9B%E0%B9%88%E0%B8%B2%E0%B8%95%E0%B9%89%E0%B8%99%E0%B8%99%E0%B9%89%E0%B8%B3-%E0%B8%95%E0%B9%89%E0%B8%99%E0%B8%97%E0%B8%B2%E0%B8%87%E0%B8%8A%E0%B8%B5%E0%B8%A7%E0%B8%B4%E0%B8%95/",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ป่าอนุรักษ์",
    meaning:
      "ป่าที่ประกาศเป็นพื้นที่คุ้มครองป่าไม้ ทัศนียภาพตามกฎหมาย (พ.ร.บ.อุทยานแห่งชาติ พ.ร.บ.เขตรักษาพันธุ์สัตว์ป่า) ห้ามบุคคลเข้าไปใช้ประโยชน์โดยไม่ได้รับอนุญาต ป่าอนุรักษ์ที่สำคัญ ได้แก่\r\n  1. อุทยานแห่งชาติ \r\n  2. วนอุทยาน\r\n  3. เขตรักษาพันธุ์สัตว์ป่า (Wildlife Scactuary)",
    source:
      "กรมส่งเสริมคุณภาพสิ่งแวดล้อม. ป่าอนุรักษ์. 25 มิถุนายน 2562. http://local.environnet.in.th/formal_data2.php?id=75",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "ป"
  },
  {
    keyword: "ปิโตรเคมี ",
    meaning:
      " “ปิโตรเคมี” มาจากรากศัพท์เดิมคือ สารเคมีหรือเคมีภัณฑ์จากปิโตรเลียม(petroleum chemicals) ในเบื้องต้น หมายถึง สารเคมี กลุ่มสารเคมีหรือเคมีภัณฑ์ใดๆ ที่มีองค์ประกอบหลักคือ สารประกอบไฮโดรคาร์บอนที่มาจากปิโตรเลียมหรือก๊าซธรรมชาติ เช่น เอทิลีน โพรพิลีน เบนซีน เป็นต้นต่อมาได้ขยายความครอบคลุมถึงสารอินทรีย์อีกหลายชนิดและสารอนินทรีย์บางชนิด และยังมีที่มาจากแหล่งอื่นนอกจากปิโตรเลียมด้วย เช่น เบนซีนจากถ่านหิน",
    source:
      "ฝ่ายสื่อสารองค์กร บริษัท ปตท. จำกัด (มหาชน). (2554). สารานุกรมเปิดโลกปิโตรเคมี Petrochemical \r\nEncyclopedia, 29 สิงหาคม 2562. http://www.pttplc.com/th/Media-Center/Energy-Knowledge/\r\nDocuments/MD24%20knowledge01/PetrochemicalEncyclopedia2011.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ป"
  },
  {
    keyword: "ปิโตรเลียม",
    meaning:
      "นํ้ามันดิบ ประกอบด้วยสารไฮโดรคาร์บอนและสารอินทรีย์อื่น ๆ อีกมาก องค์ประกอบไม่แน่นอนแล้วแต่แหล่งที่พบ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ปิโตรเลียม. 20 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 2,
    rappear: 10,
    firstalpha: "ป"
  },
  {
    keyword: "ปิดกว้างและเชื่อมโยงข้อมูลกัน",
    meaning:
      "ต้องมีความเปิดเผยโปร่งใสในการทำงาน โดยบุคคลภายนอกสามารถเข้าถึงข้อมูล\r\nข่าวสารของทางราชการหรือมีการแบ่งปันข้อมูลซึ่งกันและกันและสามารถเข้ามา\r\nตรวจสอบการทำงานได้ตลอดจนเปิดกว้างให้กลไกหรือภาคส่วนอื่น ๆ เช่น ภาคเอกชน\r\nภาคประชาสังคมได้เข้ามามีส่วนร่วม และโอนถ่ายภารกิจที่ภาครัฐไม่ควรดำเนินการเอง\r\nออกไปให้แก่ภาคส่วนอื่น ๆ เป็นผู้รับผิดชอบดำเนินการแทน โดยการจัดระเบียบ\r\nความสัมพันธ์ในเชิงโครงสร้างให้สอดรับกับการทำงานแนวระนาบ ในลักษณะของ\r\nเครือข่าย มากกว่าตามสายการบังคับบัญชาในแนวดิ่ง ขณะเดียวกันก็ยังต้องเชื่อมโยงการ\r\nทำงานในภาครัฐด้วยกันเองให้มีเอกภาพและสอดรับประสานกัน ไม่ว่าจะเป็นราชการ\r\nบริหารส่วนกลาง ส่วนภูมิภาค และส่วนท้องถิ่น",
    source:
      "สำนักงานคณะกรรมการพัฒนาระบบราชการ. (2561). อภิธานศัพท์ เปิดกว้างและเชื่อมโยงกัน, 2 กันยายน 2562. http://hp.anamai.moph.go.th/article_attach/%E0%B8%AD%E0%B8%A0%E0%B8%B4%E0%B8%98%E0%B8%B2%E0%B8%99%E0%B8%A8%E0%B8%B1%E0%B8%9E%E0%B8%97%E0%B9%8C%207%2004%2061-1.pdf",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ป"
  },
  {
    keyword: "ผลกระทบ (Impact)",
    meaning:
      "ผลกระทบ (Impact) หรือ ผลลัพธ์ขั้นสุดท้าย (Ultimate Outcome) หมายถึง ผลกระทบที่ต่อเนื่องจากผลลัพธ์ (Outcome) เช่น เมื่อประชาชนมีรายได้เพิ่มขึ้น มีคุณภาพชีวิตดีขึ้น ส่งผลให้สามารถลดช่องว่าง/ความเหลื่อมล้าของรายได้ สามารถเพิ่มการกระจายรายได้สู่สังคมได้ทางหนึ่ง",
    source:
      "นางสาววรรณา ทองเจริญศิริกุล นักวิเคราะห์นโยบายและแผนชำนาญการพิเศษ สำนักนโยบายอุตสาหกรรมมหภาค. \r\nเทคนิคการจัดทำโครงการอัจฉริยะ (Smart Project), 29 สิงหาคม 2562. http://www.oie.go.th/sites/default/\r\nfiles/attachments/article/smart_project.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ผ"
  },
  {
    keyword: "ผลประโยชน์แห่งชาติ",
    meaning:
      "ผลประโยชน์แห่งชาติ ได้แก่\r\n  1. การมีเอกราช อธิปไตย และบูรณภาพแห่งเขตอำนาจรัฐ\r\n  2. การดำรงอยู่อย่างมั่นคง ยั่งยืนของสถาบันหลักของชาติ\r\n  3. การดำรงอยู่อย่างมั่นคงของชาติและประชาชนจากภัยคุกคามทุกรูปแบบ\r\n  4. การอยู่ร่วมกันในชาติอย่างสันติสุข เป็นปึกแผ่น มั่นคงทางสังคม ท่ามกลางพหุสังคมและการมี\r\nเกียรติและศักดิ์ศรีของความเป็นมนุษย์\r\n  5. ความเจริญเติบโตของชาติ ความเป็นธรรม และความอยู่ดีมีสุขของประชาชน\r\n  6. ความยั่งยืนของฐานทรัพยากรธรรมชาติสิ่งแวดล้อม ความมั่นคงทางพลังงาน อาหาร\r\n  7. ความสามารถในการรักษาผลประโยชน์ของชาติภายใต้การเปลี่ยนแปลงของสภาวะแวดล้อม\r\nระหว่างประเทศ\r\n  8.  การอยู่ร่วมกันอย่างสันติ ประสานสอดคล้องกันด้านความมั่นคงในประชาคมอาเซียน\r\nและประชาคมโลกอย่างมีเกียรติและศักดิ์ศร",
    source:
      "สำนักงานสภาความมั่นคงแห่งชาติ. นโยบายความมั่นคงแห่งชาติ \r\nพ.ศ. 2558–2564.  21 พฤศจิกายน 2562. http://www.nsc.go.th/Download1/policy58.pdf",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ผ"
  },
  {
    keyword: "ผลประโยชน์ของชาติทางทะเล",
    meaning:
      "ผลประโยชน์ของประเทศไทยอันพึงได้รับจากกิจกรรมทางทะเล หรือประโยชน์อื่นใดในเขตทางทะเล ไม่ว่าโดยตรงหรือโดยอ้อม เพื่อให้เกิดประโยชน์ในทุก ๆ ด้าน เช่น ด้านความมั่นคง ด้านเศรษฐกิจ ด้านสังคม ด้านวิทยาศาสตร์และเทคโนโลยี ด้านทรัพยากร หรือด้านสิ่งแวดล้อม",
    source:
      "พระราชบัญญัติการรักษาผลประโยชน์ของชาติทางทะเล พ.ศ. 2562. (2562). ผลประโยชน์ของชาติทางทะเล, 7 ตุลาคม 2562. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/030/T_0001.PDF",
    sappear: 1,
    mappear: "",
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ผลประโยชน์ส่วนตน",
    meaning:
      "ไม่ได้ครอบคลุมเพียงผลประโยชน์ด้านการงานหรือธุรกิจของเจ้าหน้าที่ แต่รวมถึง\r\nคนที่ติดต่อสัมพันธ์ด้วย เช่น เพื่อน ญาติคู่แข่ง ศัตรู เมื่อใดเจ้าหน้าที่ประสงค์\r\nจะให้คนเหล่านี้ได้หรือเสียประโยชน์ เมื่อนั้นก็ถือว่ามีเรื่องผลประโยชน์ส่วนตน\r\nมาเกี่ยวข้องผลประโยชน์ส่วนตน มี 2 ประเภทคือ ที่เกี่ยวกับเงิน (pecuniary)\r\nและที่ไม่เกี่ยวกับเงิน (non-pecuniary)",
    source:
      "กรมอนามัย. คู่มือป้องกันการทุจริตและผลประโยชน์ทับซ้อน, 18 กันยายน 2562. http://www.oic.go.th/FILEWEB/CABINFOCENTER17/DRAWER002/GENERAL/DATA0000/00000174.PDF",
    sappear: "",
    mappear: 21,
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ผลผลิต (Output)",
    meaning:
      "ผลงาน หรือ บริการที่องค์กรนั้นจัดทำขึ้น โดยกิจกรรมที่ให้เกิดผลงานนั้นจะอยู่ภายใต้การควบคุมขององค์การ",
    source:
      "นางสาววรรณา ทองเจริญศิริกุล นักวิเคราะห์นโยบายและแผนชำนาญการพิเศษ สำนักนโยบายอุตสาหกรรมมหภาค. \r\nเทคนิคการจัดทำโครงการอัจฉริยะ (Smart Project), 29 สิงหาคม 2562. http://www.oie.go.th/sites/default/\r\nfiles/attachments/article/smart_project.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ผ"
  },
  {
    keyword: "ผลลัพธ์ (Outcome)",
    meaning:
      "ผลกระทบที่เกิดจากผลผลิต หรือ ผลงานที่ได้ทำขึ้น ซึ่งจะก่อให้เกิดการเปลี่ยนแปลงต่อผู้รับบริการ อันเนื่องจากการดำเนินการ",
    source:
      "นางสาววรรณา ทองเจริญศิริกุล นักวิเคราะห์นโยบายและแผนชำนาญการพิเศษ สำนักนโยบายอุตสาหกรรมมหภาค. \r\nเทคนิคการจัดทำโครงการอัจฉริยะ (Smart Project), 29 สิงหาคม 2562. http://www.oie.go.th/sites/default/\r\nfiles/attachments/article/smart_project.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ผ"
  },
  {
    keyword: "ผลสัมฤทธิ์",
    meaning: "ความสำเร็จ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สัมฤทธิ์. 22 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ผ"
  },
  {
    keyword: "ผลิตภัณฑ์ไบโอพลาสติก",
    meaning:
      'พลาสติกที่ผลิตขึ้นจากวัสดุธรรมชาติ ส่วนใหญ่เป็นพืช สามารถย่อยสลายได้ในธรรมชาติ ช่วยลดปัญหามลพิษในสิ่งแวดล้อมวัสดุธรรมชาติที่สามารถนำมาผลิตเป็นพลาสติกชีวภาพมีหลายชนิด เช่น cellulose collagen casein polyester แป้ง (starch) โปรตีนจากถั่ว และข้าวโพด เป็นต้น ซึ่ง "แป้ง" เป็นวัสดุที่เหมาะสมที่สุดเพราะมีจำนวนมากและราคาถูก เนื่องจากสามารถหาได้จากพืชชนิดต่าง ๆ เช่น ข้าวโพด ข้าวสาลี มันฝรั่ง มันเทศ มันสำปะหลัง เป็นต้น',
    source:
      "กรมส่งเสริมอุตสาหกรรม. ไบโอพลาสติก, 4 ตุลาคม 2562. http://innovation.dip.go.th/innovation/?page_id=1094",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ผ"
  },
  {
    keyword: "ผลิตภัณฑ์ปิโตรเคมีสายโอเลฟินส์",
    meaning: "เอทีลีน โพรพิลีน และบิวทาไดอีน",
    source:
      "บริษัท ปตท. จำกัด (มหาชน). ธรกิจปิโตเคมี, 4 ตุลาคม 2562. http://www.pttplc.com/th/About/Business/PTT-Affiliate-Business/Petrochemical/pages/Business.aspx",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ผ"
  },
  {
    keyword: "ผลิตภัณฑ์ปิโตรเคมีสายอะโรเมติกส์",
    meaning: "เบนซีน โทลูอีน และมิกซ์ไซลีน",
    source:
      "บริษัท ปตท. จำกัด (มหาชน). ธรกิจปิโตเคมี, 4 ตุลาคม 2562. http://www.pttplc.com/th/About/Business/PTT-Affiliate-Business/Petrochemical/pages/Business.aspx",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ผ"
  },
  {
    keyword: "ผลิตภัณฑ์มวลรวมในประเทศ (GDP)",
    meaning:
      "มูลค่าสินค้าและบริการขั้นสุดท้ายที่ผลิตขึ้นโดยใช้ทรัพยากรที่คนของประเทศนั้นๆ เป็นเจ้าของ มีทั้งที่ผลิตภายในและนอกประเทศในช่วงระยะเวลาหนึ่ง โดยอาจคำนวณเป็นราย 3-6 เดือน และ 12 เดือน",
    source:
      "กรมตรวจบัญชีสหกรณ์. ผลิตภัณฑ์มวลรวมประชาชาติ Gross National Product (GNP), 19 กันยายน 2562. https://www.cad.go.th/cadweb_client/ewt_news.php?nid=2848&filename=index",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ผ"
  },
  {
    keyword: "ผลิตภัณฑ์สุขภาพ",
    meaning: "อาหาร ยา เครื่องมือแพทย์  และเครื่องสำอาง",
    source:
      "สำนักงานคณะกรรมการอาหารและยา ( อย. ). (2556). อย. ดำเนินคดีผลิตภัณฑ์สุขภาพรวม 91 ราย พบสารกำจัดศัตรูพืชในผักผลไม้มากสุด, 25 กันยายน 2562. https://oryor.com/%E0%B8%AD%E0%B8%A2/detail/media_news/368",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ผ"
  },
  {
    keyword: "ผลิตภาพ",
    meaning:
      "จำนวนของผลผลิตสินค้าหรือบริการต่อปัจจัยการผลิตที่ใช้ในการผลิตของหน่วยการผลิต อุตสาหกรรม หรือประเทศ ผลิตภาพสามารถจำแนกตามประเภทของปัจจัยการผลิต เช่น\r\n*ผลิตภาพแรงงาน คือ จำนวนผลผลิตต่อแรงงาน 1 คน หรือต่อ 1 ชั่วโมงของการทำงาน\r\n*ผลิตภาพทุน คือ จำนวนผลผลิตต่อเงินทุน 1 หน่วยผลิตภาพการผลิตรวม (totol factor productivity) คือการเพิ่มขึ้นของผลผลิตที่เกิดจากปัจจัยอื่นนอกเหนือจากปัจจัยการผลิตที่ใช้ เช่น การพัฒนาทางเทคโนโลยี การปรับปรุงการบริหาร และการพัฒนาคุณภาพของแรงงาน",
    source:
      "พจนานุกรมศัพท์เศรษฐศาสตร์ แห่งราชบัณฑิตยสถาน. (2558). ผลิตภาพ,\r\n19 พฤศจิกายน 2562. \r\nhttp://www.royin.go.th/?printing=%E0%B8%9E%E0%B8%88%E0%B8%99%E0%B8%B2%E0%B8%99%E0%B8%B8%E0%B8%81%E0%B8%A3%E0%B8%A1%E0%B8%A8%E0%B8%B1%E0%B8%9E%E0%B8%97%E0%B9%8C%E0%B9%80%E0%B8%A8%E0%B8%A3%E0%B8%A9%E0%B8%90%E0%B8%A8%E0%B8%B2%E0%B8%AA-3",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ผ"
  },
  {
    keyword: "ผลิตภาพแรงงาน",
    meaning:
      "การใช้ปัจจัยแรงงาน 1 หน่วย ก่อให้ปัจจัยทุนและปัจจัยอื่นๆ คงที่ การวัดปัจจัยแรงงาน อาจจะวัดได้ทั้งในรูปของจำนวนแรงงานและจำนวนชั่วโมง",
    source:
      "สำนักยุทธศาสตร์และการวางแผนเศรษฐกิจมหภาค. (2551). ผลิตภาพการผลิตของประเทศไทย, 5 สิงหาคม 2562. สืบค้นจาก https://www.nesdb.go.th/article_attach/Binder6.pdf",
    sappear: "",
    mappear: 11,
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ผลิตภาพการผลิต",
    meaning:
      "ขนาดของผลผลิต (Output) ที่ผลิตได้จากการใส่ปัจจัยการผลิต (Input) เข้าไปในกระบวนการผลิต ซึ่งการวัดผลิตภาพการผลิตสามารถวัดได้ 2 ลักษณะ คือ 1) การวัดผลิตภาพการผลิตบางส่วน (Partial productivity) 2) การวัดผลิตภาพการผลิตรวม (Total Factor Productivity: TFP)",
    source:
      "สํานักยุทธศาสตร์และการวางแผนเศรษฐกิจมหภาค. (2551). ผลตภาพการผลิต การพัฒนาเศรษฐกิจของไทย, 26 กันยายน 2562. https://www.nesdc.go.th/article_attach/Binder6.pdf",
    sappear: "",
    mappear: "4,23",
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ผลิตภาพการผลิตของประเทศ (ตัวชี้วัด)",
    meaning:
      "ขนาดของผลผลิต (Output) ที่ผลิตได้จากการใส่ปัจจัยการผลิต (Input) เข้าไปในกระบวนการผลิต ซึ่งการวัดผลิตภาพการผลิตสามารถวัดได้ 2 ลักษณะ คือ 1) การวัดผลิตภาพการผลิตบางส่วน (Partial productivity) เป็นการวัดผลิตภาพการผลิตของการใช้ปัจจัยการผลิตชนิดใดชนิดหนึ่ง โดยที่ให้ปัจจัยอื่นๆ คงที่ผลิตภาพการผลิตเป็นการวัดอัตราส่วนของผลผลิตต้อการใช้ปัจจัยการผลิต ซึ่งแสดงถึงการใช้ปัจจัยการผลิต (Input) 1 หน่วย ก่อให้เกิดผลผลิต (Output) กี่หน่วย, 2) การวัดผลิตภาพการผลิตรวม (Total Factor Productivity: TFP)  หมายถึง การเพิ่มขึ้นของผลผลิตโดยมิได้มีที่มาจากการเพิ่มขึ้นของปัจจัยการผลิต คือ ปัจจัยแรงงาน ที่ดิน และปัจจัยทุน ซึ่งนักเศรษฐศาสตร์จะเรียกส่วนที่เพิ่มขึ้นดังกล่าวว่าเป็น Residual Growth หรือเป็นผลมาจาก ความก้าวหน้าทางเทคโนโลยี Technical progress) และอื่นๆ ซึ่งมีองค์ประกอบหลายปัจจัย ได้แก่ การบริหารจัดการ ประสบการณ์คุณภาพของแรงงานซึ่งขึ้นอยู่กับระดับการศึกษา อายุเพศ และที่สําคัญคือ ปัจจัยเทคโนโลยีของทุน รวมถึงการวิจัยและพัฒนา (R&D) การมีประสิทธิภาพ (Efficiency) ในการผลิต เป็นต้น ",
    source:
      "สํานักยุทธศาสตร์และการวางแผนเศรษฐกิจมหภาค. (2551). ผลิตภาพการผลิตของประเทศไทย, 27 สิงหาคม 2562. https://www.nesdc.go.th/article_attach/Binder6.pdf",
    sappear: 2,
    mappear: "4,23",
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ผลิตภาพจากการใช้น้ำ",
    meaning:
      "ปริมาณน้ำ 1 หน่วยสามารถสร้างมูลค่าให้กับประเทศเป็นจำนวนเงินเท่าไร โดยวัดจากมูลค่าจากผลิตภัณฑ์มวลรวมของประเทศ (GDP) หารด้วยปริมาณการใช้น้ำของประเทศ (Water total use) แบ่งออกเป็น ภาคอุตสาหกรรม และ ภาคการเกษตร",
    source:
      "นายโชคชัย สุทธิธรรมจิต. คณะวิศวกรรมศาสตร์ จุฬาลงกรณ์มหาวิทยาลัย. ผลิตภาพของน้ำ,10 กรกฎาคม 2562.\r\nhttp://project-wre.eng.chula.ac.th/watercu_eng/sites/default/files/4.1%20KD2%20WaterProductivity_Chula%20%2829-10-61%29-edit3-print.pdf",
    sappear: 5,
    mappear: 19,
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ผังเมืองรวม",
    meaning:
      "แผนผัง นโยบายและโครงการ รวมทั้งมาตรการควบคุมทั่วไปที่ใช้เป็นแนวทางในการพัฒนา และดำรงรักษาเมือง และบริเวณที่เกี่ยวข้อง หรือชนบทในด้านที่เกี่ยวกับการใช้ประโยชน์ทรัพย์สิน การคมนาคมและการขนส่ง การสาธารณูปโภค บริการสาธารณะ และสภาพแวดล้อม เพื่อให้บรรลุวัตถุประสงค์ของการผังเมือง",
    source:
      "กรมควบคุมมลพิษ.บัญชีรายชื่อคำศัพท์, 18 กันยายน 2562. http://www.pcd.go.th/info_serv/QandA/defaultThai.cfm?task=listVocab",
    sappear: "",
    mappear: 6,
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้เสียเปรียบในสังคม",
    meaning:
      "กลุ่มเด็กและเยาวชน สตรี ผู้พิการ คนยากจน คนไร้ที่พึ่ง ผู้สูงอายุ คนไร้สถานะทางทะเบียนราษฎร ผู้พ้นโทษ ผู้ติดเชื้อเอช ไอ วี และผู้บริโภค",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. (2560). เดินหน้าปฏิรูปเพื่อลดช่องว่างสำหรับผู้เสียเปรียบในสังคม, 1 ตุลาคม 2560. https://www.nesdc.go.th/ewt_news.php?nid=7111&filename=index",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้เสียหาย",
    meaning:
      "บุคคลซึ่งได้รับความเสียหายถึงแก่ชีวิตหรือร่างกายหรือจิตใจเนื่องจากการกระทำความผิดอาญาของผู้อื่น โดยตนมิได้มีส่วนเกี่ยวข้องกับการกระทำความผิดนั้น",
    source:
      "พระราชบัญญัติค่าตอบแทนผู้เสียหายและค่าทดแทนและค่าใช้จ่ายแก่จำเลยในคดีอาญา\r\nพ.ศ. 2544. (2544, 31 ตุลาคม). มาตรา 3. http://web.krisdika.go.th/lawHeadContent.jsp?fromPage=lawHeadContent&formatFile=htm&hID=0",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ใช้แรงงาน",
    meaning:
      "ประชากรในวัยทำงาน ไม่รวมถึงคนพิการ คนวิกลจริต นักเรียน นักศึกษา แม่บ้าน นักบวช ทหาร ผู้ต้องขังและผู้ประกอบกิจการเพื่อหากำไร; ความสามารถในการทำงานเพื่อประโยชน์ในทางเศรษฐกิจ กิจการที่คนงานทำในการผลิตเศรษฐทรัพย์ ผู้ใช้แรงงาน",
    source:
      "ศาสตราจารย์นิคม จันทรวิทุร สำนักงานราชบัณฑิตยสภา. (2558). แรงงาน, 1 ตุลาคม 2562. http://www.royin.go.th/?knowledges=%E0%B9%81%E0%B8%A3%E0%B8%87%E0%B8%87%E0%B8%B2%E0%B8%99",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ให้การบริบาล",
    meaning:
      "การใช้ความเป็นวิชาชีพ (Professional) ที่เป็นความรู้เฉพาะ คุณธรรม จริยธรรม ความรัก ความห่วงใย และจิตใจเสียสละในการปฏิบัติงาน",
    source:
      "พลอากาศตรี นายแพทย์ อิทธพร คณะเจริญ รองเลขาธิการแพทยสภา ผู้ทรงคุณวุฒิ คณะกรรมการคุ้มครองผู้บริโภค.(2559). ความเสี่ยงทางกฎหมาย ที่เกี่ยวข้องกับวิชาชีพสุขภาพ, 25 กันยายน 2562. file:///C:/Users/admin/Downloads/%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B9%80%E0%B8%AA%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%87%E0%B8%94%E0%B9%89%E0%B8%B2%E0%B8%99%E0%B8%81%E0%B8%8E%E0%B8%AB%E0%B8%A1%E0%B8%B2%E0%B8%A2%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B9%80%E0%B8%81%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%A7%E0%B8%81%E0%B8%B1%E0%B8%9A%E0%B8%A7%E0%B8%B4%E0%B8%8A%E0%B8%B2%E0%B8%8A%E0%B8%B5%E0%B8%9E%E0%B9%80%E0%B8%97%E0%B8%84%E0%B8%99%E0%B8%B4%E0%B8%84%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%81%E0%B8%9E%E0%B8%97%E0%B8%A2%E0%B9%8C%20%E0%B9%82%E0%B8%94%E0%B8%A2%E0%B8%9E%E0%B8%A5%E0%B8%AD%E0%B8%B2%E0%B8%81%E0%B8%B2%E0%B8%A8%E0%B8%95%E0%B8%A3%E0%B8%B5%20%E0%B8%99%E0%B8%B2%E0%B8%A2%E0%B9%81%E0%B8%9E%E0%B8%97%E0%B8%A2%E0%B9%8C%20%E0%B8%AD%E0%B8%B4%E0%B8%97%E0%B8%98%E0%B8%9E%E0%B8%A3%20%E0%B8%84%E0%B8%93%E0%B8%B0%E0%B9%80%E0%B8%88%E0%B8%A3%E0%B8%B4%E0%B8%8D%20%E0%B8%A3%E0%B8%AD%E0%B8%87%E0%B9%80%E0%B8%A5%E0%B8%82%E0%B8%B2%E0%B8%98%E0%B8%B4%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%81%E0%B8%9E%E0%B8%97%E0%B8%A2%E0%B8%AA%E0%B8%A0%E0%B8%B2.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ชี้เบาะแส",
    meaning:
      "บุคคลซึ่งมิได้เป็นเจ้าหน้าที่ของสำนักงาน ที่ชี้เบาะแสเกี่ยวกับการกระทำการอันไม่สุจริตหรือเที่ยงธรรม",
    source:
      "ระเบียบคณะกรรมการการเลือกตั้งว่าด้วยค่าใช้จ่ายในการแสวงหาข้อมูลข่าวสารและการให้รางวัลแก่ผู้ชี้เบาะแสการกระทำการอันไม่สุจริตหรือเที่ยงธรรมในการเลือกตั้ง พ.ศ. 2562. (2562, 22 มีนาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 37 ก หน้า 7. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/037/T_0006.PDF",
    sappear: "",
    mappear: 21,
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ซื้อ",
    meaning:
      "ผู้นำเข้าที่อยู่ในต่างประเทศซึ่งซื้อสินค้าหรือบริการจาก\r\nประเทศไทย หรือสินค้าที่ผลิตในประเทศไทย\r\n",
    source:
      "พระราชบัญญัติธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย พ.ศ. 2536 (2536,6 กันยายน) ราชกิจจานุเบกษา.เล่ม 110 ตอนที่ 127 ก หน้า 3 http://www.ratchakitcha.soc.go.th/DATA/PDF/2536/A/127/10.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ด้อยโอกาส",
    meaning:
      "ผู้ประสบปัญหาความเดือดร้อนและได้รับผลกระทบในด้านเศรษฐกิจ สังคม การศึกษา สาธารณสุข การเมือง กฎหมาย วัฒนธรรม ภัยธรรมชาติ และภัยสงคราม รวมถึงผู้ที่ขาดโอกาสที่จะเข้าถึงบริการขั้นพื้นฐานของรัฐ อันจะส่งผลให้ไม่สามารถดำรงชีวิตได้เท่าเทียมกับผู้อื่น ได้แก่ คนยากจน คนเร่ร่อน คนไร้สัญชาติ ผู้พ้นโทษ ผู้ติดเชื้อเอชไอวี และผู้ป่วยเอดส์และครอบครัว\r\n",
    source:
      "ระเบียบสำนักงานส่งเสริมสวัสดิภาพและพิทักษ์เด็ก เยาวชน ผู้ด้อยโอกาส คนพิการ และผู้สูงอายุ พ.ศ. 2550 (2551, 25 มกราคม). ราชกิจจานุเบกษา. เล่ม 125 ตอนพิเศษ 18 ง หน้า 36. http://www.ratchakitcha.soc.go.th/DATA/PDF/2551/E/018/35.PDF",
    sappear: "",
    mappear: 22,
    rappear: 9,
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ตรวจราชการของรัฐ",
    meaning:
      "ผู้ตรวจราชการสํานักนายกรัฐมนตรีผู้ตรวจ ราชการกระทรวง ผู้ตรวจราชการกรม หรือผู้ดํารงตําแหน่งที่เรียกชื่ออย่างอื่นที่มีหน้าที่ในการตรวจราชการแต่ไม่รวมถึงผู้ทําหน้าที่ตรวจสอบภายใน",
    source:
      "ระเบียบสํานักนายกรัฐมนตรีว่าด้วยการตรวจราชการ พ.ศ. 2548. (2548, 5 กันยายน). ราชกิจจานุเบกษา. เล่ม 122 ตอนพิเศษ 76 ง หน้า 7. \r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2548/00169842.PDF",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ต้องโทษ",
    meaning:
      "ผู้ต้องคำพิพากษาหรือคำสั่งของศาลให้ลงโทษหรือให้กักกันและให้หมายความรวมถึงผู้ถูกลงโทษโดยคำสั่งที่ชอบด้วยกฎหมายซึ่งมีผลเช่นเดียวกับการถูกลงโทษ โดยคำคำพิพากษาหรือคำสั่งของศาล",
    source:
      "สำนักงานคณะกรรมการกฤษฎีกา. (2561). นิรโทษกรรม อภัยโทษ ล้างมลทิน ความร่วมมือระหว่างประเทศในกระบวนการยุติธรรม สัญชาติ องค์การระหว่างประเทศ, 21 ตุลาคม 2562. http://web.krisdika.go.th/data/ebook/thailaw/thailaw54.pdf",
    sappear: "",
    mappear: 22,
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ต้องหา",
    meaning: "บุคคลผู้ถูกหาว่าได้กระทำความผิด แต่ยังมิได้ถูกฟ้องต่อศาล",
    source:
      "พระราชบัญญัติประมวลกฎหมายวิธีพิจารณาความอาญา พ.ศ. 2477 และที่แก้ไขเพิ่มเติม. http://www.krisdika.go.th/librarian/get?sysid=570066&ext=pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ถูกคุมความประพฤติ",
    meaning:
      "ผู้ต้องหา จําเลย นักโทษเด็ดขาด หรือบุคคลอื่นที่ศาลหรือเจ้าพนักงานผู้มีอํานาจ กําหนดให้ปฏิบัติตามเงื่อนไขที่กฎหมายบัญญัติภายใต้การคุมความประพฤติของพนักงานคุมประพฤติ\r\n",
    source:
      "พระราชบัญญัติคุมประพฤติ พ.ศ. 2559. (2559, 3 ตุลาคม). ราชกิจจานุเบกษา. เล่ม 133 ตอนที่ 88 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2559/A/088/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้บริโภค",
    meaning:
      " ผู้ซื้อหรือได้รับบริการจากผู้ประกอบธุรกิจหรือผู้ซึ่งได้รับการเสนอหรือการชักชวนจากผู้ประกอบธุรกิจเพื่อให้ซื้อสินค้าหรือรับบริการ และหมายความรวมถึงผู้ใช้สินค้าหรือผู้ได้รับบริการจากผู้ประกอบธุรกิจโดยชอบ แม้มิได้เป็นผู้เสียค่าตอบแทนก็ตาม\r\n",
    source:
      "พระราชบัญญัติคุ้มครองผู้บริโภค (ฉบับที่ 2) พ.ศ. 2541. (2541, 24 มีนาคม). ราชกิจจานุเบกษา. เล่ม 115 ตอนที่ 15 ก หน้า 1 .http://www.ratchakitcha.soc.go.th/DATA/PDF/2541/A/015/1.PDF",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ประกอบการเกษตร",
    meaning:
      "การปลูกพืช การเลี้ยงปศุสัตว์การเลี้ยงสัตว์น้ำ การทํานาเกลือสมุทร\r\nการปลูกหม่อน การเลี้ยงไหม การเพาะเลี้ยงแมลงเศรษฐกิจ และเกษตรอื่นๆ โดยมีวัตถุประสงค์เพื่อการบริโภคหรือจําหน่ายหรือใช้งานในฟาร์ม อย่างใดอย่างหนึ่งหรือหลายอย่างรวมกันดังต่อไปนี้\r\n1) การทํานาหรือทําไร่อย่างใดอย่างหนึ่งหรือ รวมกัน บนเนื้อที่ตั้งแต่หนึ่งไร่ขึ้นไป\r\n2) การปลูกผัก หรือการปลูกไม้ดอกไม้ประดับ หรือการเพาะเห็ด หรือการปลูกพืชอาหารสัตว์อย่างใดอย่างหนึ่งหรือรวมกัน บนเนื้อที่ตั้งแต่หนึ่งงานขึ้นไป\r\n3) การปลูกไม้ผลไม้ยืนต้น หรือการปลูกสวนป่า หรือปลูกป่าเศรษฐกิจแบบสวนเฉพาะอย่างใดอย่างหนึ่ง\r\nหรือรวมกัน บนเนื้อที่ตั้งแต่หนึ่งไร่และมีจํานวนต้นตั้งแต่สิบห้าต้นขึ้นไป\r\n4) การปลูกไม้ผล หรือไม้ยืนต้นแบบสวนผสม อย่างใดอย่างหนึ่งหรือรวมกัน บนเนื้อที่ตั้งแต่หนึ่งไร่\r\nและมีจํานวนต้นตั้งแต่สิบห้าต้นขึ้นไป\r\n5) การเลี้ยงแม่โคนม ตั้งแต่หนึ่งตัวขึ้นไป\r\n6) การเลี้ยงโค หรือกระบือ อย่างใดอย่างหนึ่งหรือรวมกัน ตั้งแต่สองตัวขึ้นไป\r\n7) การเลี้ยงสุกร แพะ หรือแกะ อย่างใดอย่างหนึ่งหรือรวมกัน ตั้งแต่ห้าตัวขึ้นไป\r\n8) การเลี้ยงสัตว์ปีก ตั้งแต่ห้าสิบตัวขึ้นไป\r\n9) การเลี้ยงสัตว์น้ำ หรือการเพาะเลี้ยงสัตว์น้ำ อย่างใดอย่างหนึ่งหรือรวมกัน\r\n10) การทํานาเกลือสมุทร บนเนื้อที่ตั้งแต่หนึ่งไร่ขึ้นไป\r\n11) การปลูกหม่อน การเลี้ยงไหม อย่างใดอย่างหนึ่งหรือรวมกัน\r\n12) การเพาะเลี้ยงแมลงเศรษฐกิจและเกษตรอื่นๆ หมายความว่า การเลี้ยงผึ้งพันธุ์ผึ้งโพรง ชันโรง ครั่ง จิ้งหรีด ด้วงสาคูไส้เดือนดิน ชีวภัณฑ์และอื่นๆ ที่มีลักษณะเดียวกัน\r\n13) ประกอบการเกษตร อย่างใดอย่างหนึ่งหรือหลายอย่างรวมกัน นอกเหนือจากหลักเกณฑ์ที่กําหนดตาม 1) ถึง 12) และมีรายได้ตั้งแต่แปดพันบาทต่อปีขึ้นไป\r\n",
    source:
      "ศูนย์เทคโนโลยีสารสนเทศและการสื่อสาร กรมส่งเสริมการเกษตร กระทรวงเกษตรและสหกรณ์. คู่มือการขึ้นทะเบียน/ปรับปรุงทะเบียนเกษตรกร, 18 กันยายน 2562. http://farmer.doae.go.th/farmer61s.pdf\r\n",
    sappear: "",
    mappear: 3,
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ประกอบการชุมชน",
    meaning:
      "กิจการของชุมชนเกี่ยวกับการผลิตสินค้า การให้บริการหรืออื่น ๆ ที่ดำเนินการโดยคณะบุคคลที่มีความผูกพัน มีวิถีชีวิตร่วมกันและรวมตัวกันประกอบกิจการดังกล่าว ไม่ว่าจะเป็นนิติบุคคลในรูปแบบใด หรือไม่เป็นนิติบุคคล เพื่อสร้างรายได้และเพื่อการพึ่งพาตนเองของครอบครัว ชุมชนและระหว่างชุมชน",
    source:
      "สำนักงานเลขานุการ คณะกรรมการส่งเสริมวิสาหกิจชุมชน. วิสาหกิจ, 6 พฤศจิกายน 2562. http://www.sceb.doae.go.th/Ssceb2.htm#%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%AB%E0%B8%A1%E0%B8%B2%E0%B8%A2",
    sappear: "",
    mappear: 8,
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ประกอบการรายย่อย",
    meaning:
      "กิจการประเภทวิสาหกิจชุมชน (โดยทั่วไปมีลูกจ้างน้อยกว่า 10 คนรวมแรงงานในครัวเรือน) ซึ่งมีขนาดของสินทรัพย์และรายได้ต่ำ และมีผู้ประกอบการเพียงคนเดียว โดยมักจะเป็นอาชีพเสริมจากการทำเกษตรกรรม เช่น การแปรรูปอาหาร และงานหัตถกรรม",
    source:
      "ธนาคารแห่งประเทศไทย. ธุรกิจขนาดกลางและย่อม (SMEs) และการให้สินเชื่อแก่ SMEs, 30 ตุลาคม 2562. https://www.bot.or.th/Thai/FinancialInstitutions/Highlights/FSMP1/QA_TB.pdf",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ประกอบธุรกิจ",
    meaning:
      "ผู้ขาย ผู้ผลิตเพื่อขาย ผู้สั่งหรือนำเข้ามาในราชอาณาจักรเพื่อขาย หรือผู้ซื้อเพื่อขายต่อซึ่งสินค้า หรือผู้ให้บริการและหมายความรวมถึงผู้ประกอบกิจการโฆษณาด้วย\r\n",
    source:
      "พระราชบัญญัติคุ้มครองผู้บริโภค พ.ศ. 2522. (2522, 4 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 96 ตอนที่ 72 ก หน้า 21 .http://www.ratchakitcha.soc.go.th/DATA/PDF/2522/A/072/20.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ประกอบวิชาชีพ",
    meaning:
      "ผู้ประกอบโรคศิลปะ ผู้ประกอบวิชาชีพเวชกรรม การพยาบาล การผดุงครรภ์ ทันตกรรม เภสัชกรรม หรือผู้ประกอบวิชาชีพอื่นตามที่รัฐมนตรีกำหนดโดยประกาศในราชกิจจานุเบกษา\r\n",
    source:
      "พระราชบัญญัติสถานพยาบาล พ.ศ. 2541 (2541,24 มีนาคม) ราชกิจจานุเบกษา.เล่ม115 ตอนที่ 15 ก  หน้า 33 http://www.ratchakitcha.soc.go.th/DATA/PDF/2541/A/015/32.PDF",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ป่วยฉุกเฉิน",
    meaning:
      "บุคคลซึ่งได้รับบาดเจ็บหรือมีอาการป่วยกะทันหัน ซึ่งเป็น\r\nภยันตรายต่ออการดํารงชีวิตหรือการทํางานของอวัยวะสําคัญ จําเป็น\r\nต้องได้รับการประเมิน การจัดการและการบําบัดรักษาอย่างทันท่วงทีเพื่อป้องกันการเสียชีวิตหรือการรุนแรงขึ้นของการบาดเจ็บหรืออาการป่วยนั้น",
    source:
      "พระราชบัญญัติการแพทย์ฉุกเฉิน พ.ศ. 2551. (2551, 6 มีนาคม.). ราชกิจนาบุเษก.เล่ม 125 ตอนที่ 44 ก หน้า 2.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2551/A/044/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ผลิต",
    meaning:
      "(1) ผู้ซึ่งทำการกสิกรรม การประมง การปศุสัตว์ หรือการป่าไม้เพื่อการค้า\r\n(2) ผู้ประกอบการขนส่งสินค้าเกษตร คลังสินค้าเกษตร สะพานปลา ห้องเย็น โรงฆ่าสัตว์หรือกิจการต่อเนื่องอื่นที่เกี่ยวกับสินค้าเกษตรตามที่คณะกรรมการกำหนด\r\n(3) ผู้ซึ่งนำสินค้าเกษตรมาบรรจุหีบห่อ แปรรูป หรือกระทำด้วยวิธีการใด ๆ",
    source:
      "พระราชบัญญัติมาตรฐานสินค้าเกษตร พ.ศ. 2551. (2551, 22 กุมภาพันธ์). ราชกิจจานุเบกษา. เล่ม 125 ตอนที่ 37 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2551/A/037/1.PDF",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้พิพากษา",
    meaning: "ผู้มีอำนาจและหน้าที่ในการพิจารณาพิพากษาอรรถคดีในศาล",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. \r\nผู้พิพากษา, 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้มีรายได้น้อย",
    meaning:
      "ผู้มีรายได้น้อยจะแบ่งเป็น 2 กลุ่ม คือ กลุ่มที่ต่ำกว่า 100,000 บาท และกลุ่มที่ต่ำกว่า 30,000 บาท โดยมาจากการดูเส้นความยากจน ที่ใช้เกณฑ์ของสำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติเป็นหลัก ซึ่งได้กำหนดไว้ว่าเส้นความยากจนจะอยู่ที่รายได้ประมาณ 2,000 กว่าบาท/เดือน หรือปีละไม่เกิน 30,000 บาท จึงเท่ากับว่าถ้ามีรายได้ 0-30,000 บาท ถือว่าเป็นผู้ที่ยากจน ส่วนตั้งแต่ 30,000 บาทขึ้นไป จนถึง 100,000 บาท เป็นผู้ที่อยู่สูงกว่าเส้นความยากจนถือเป็นแค่ผู้มีรายได้น้อย",
    source:
      "สำนักเลขาธิการนายกรัฐมนตรี. (2561). มาตรการสวัสดิการแห่งรัฐนวัตกรรมเพื่อแก้ปัญหาความยากจน, 6 พฤศจิกายน 2562. https://spm.thaigov.go.th/FILEROOM/spm-thaigov/DRAWER004/GENERAL/DATA0000/00000438.PDF",
    sappear: 4,
    mappear: 16,
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้มีส่วนได้ส่วนเสีย",
    meaning:
      "ทุกกลุ่มที่ได้รับผลประโยชน์ หรืออาจได้รับผลกระทบจากการดำเนินงานและความสำเร็จขององค์กร ",
    source:
      "มหาวิทยาลัยเชียงใหม่. นิยามศัพท์เฉพาะ ผู้มีส่วนได้ส่วนเสีย, 12 กันยายน 2562. http://web.agri.cmu.ac.th/qa/document/2553/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD/cmu/technical_term/123.pdf",
    sappear: "",
    mappear: "",
    rappear: "5,10",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ลงทุน",
    meaning:
      "1) ผู้ประกอบกิจการในประเทศที่เกี่ยวเนื่องกับการส่งออกซึ่งสินค้าหรือบริการ\r\nจากประเทศไทยกิจการที่ได้มาหรือสนับสนุนการได้มาซึ่งเงินตราต่างประเทศ หรือกิจการที่ลดการสูญเสียเงินตราต่างประเทศ\r\n(2) ผู้ประกอบกิจการในต่างประเทศ ซึ่งมีผู้ลงทุนหรือร่วมลงทุนดังต่อไปนี้\r\n      (ก) เป็นผู้มีสัญชาติไทย หรือ\r\n      (ข) เป็นนิติบุคคลที่จดทะเบียนในประเทศไทยซึ่งมีทุนเกินกึ่งหนึ่งของนิติบุคคลนั้นถือโดยบุคคลตาม (ก) หรือนิติบุคคลซึ่งมีบุคคลตาม (ก) ลงทุนมีมูลค่าเกินกึ่งหนึ่งของทุนทั้งหมดในนิติบุคคลนั้น และเป็นผู้มีอำนาจตามกฎหมาย หรือข้อบังคับหรือตามข้อตกลงในการแต่งตั้งกรรมการส่วนใหญ่ของจำนวนกรรมการทั้งหมด หรือในการออกคะแนนเสียงข้างมากเพื่อกำหนดนโยบายการดำเนินงานของนิติบุคคลนั้น\r\n",
    source:
      "พระราชบัญญัติธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย (ฉบับที่ 2) พ.ศ. 2542 (2542,5 ธันวาคม) ราชกิจจานุเบกษา.เล่ม 116 ตอนที่ 123 ก หน้า 16 http://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/123/16.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้ส่งออก",
    meaning:
      "ผู้ประกอบการที่อยู่ในประเทศ รวมทั้งบุคคลซึ่งมี\r\nคุณสมบัติตามที่คณะกรรมการกำหนดซึ่งทำการส่งออกสินค้าหรือบริการไปจำหน่ายยังต่างประเทศเพื่อให้ได้มาซึ่งผลตอบแทนเป็นเงินตราหรือทรัพย์สินอื่นใดที่เทียบมูลค่าเป็นเงินตราเข้ามาในราชอาณาจักร และให้หมายความรวมถึงผู้ให้บริการแก่บุคคลในต่างประเทศ\r\n",
    source:
      "พระราชบัญญัติธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย พ.ศ. 2536 (2536,6 กันยายน) ราชกิจจานุเบกษา.เล่ม 110 ตอนที่ 127 ก หน้า 3 http://www.ratchakitcha.soc.go.th/DATA/PDF/2536/A/127/10.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้สูงอายุที่มีภาวะพึ่งพิง",
    meaning:
      "ผู้สูงอายุที่มีคะแนนประเมินความสามารถในการดำเนินชีวิตประจำวันตามค่าดัชนี Barthel Adl winder เท่ากับหรือน้อยกว่า 11 คะแนนซึ่งแบ่งออกเป็น 4 กลุ่ม และมีสิทธิได้รับบริการสาธารณสุขตามชุดสิทธิประโยชน์",
    source:
      "แนวทางการปฏิบัติ เรื่องการรับเงิน การเก็บรักษาเงิน และการจ่ายเงินค่าบริการสาธารณสุขสำหรับการดูแลผู้สูงอายุระยะยาวที่มีภาวพึ่งพิง\r\nhttps://dhes.moph.go.th/wp-content/uploads/2018/12/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD-LTC-%E0%B8%89%E0%B8%9A%E0%B8%B1%E0%B8%9A%E0%B8%AA%E0%B8%A1%E0%B8%9A%E0%B8%B9%E0%B8%A3%E0%B8%93%E0%B9%8C-%E0%B8%9B%E0%B8%B5-2561.pdf",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ผู้หลบหนีเข้าเมือง",
    meaning: "คนต่างด้าวซึ่งเข้ามาในราชอาณาจักร",
    source:
      "พระราชบัญญัติคนเข้าเมืองพุทธศักราช 2522. (2522, กุมภาพันธ์ 24). http://web.krisdika.go.th/data/law/law2/%A402/%A402-20-9999-update.pdf",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ผ"
  },
  {
    keyword: "ฝายชะลอน้ำ",
    meaning:
      "สิ่งก่อสร้างที่สร้างปิดขวางทางน้ำไหล สำหรับทดกรองน้ำที่ไหลมาให้มีระดับสูงขึ้น เพื่อสร้างความชุ่มชื้นให้กับพื้นที่ น้ำที่ไหลมาตามลำน้ำสามารถไหลผ่านตัวฝายทดน้ำได้เนื่องจากทำจากวัสดุไม่ทึบน้ำ ช่วยดักกรองตะกอนที่ไหลมากับน้ำ และน้ำที่ไหลผ่านจะไหลลงไปในลำน้ำเดิม",
    source:
      "ผู้ทรงคุณวุฒิด้านวิศวกรรมโยธา (ด้านสำรวจและหรือออกแบบ) กองประสานงานโครงการอันเนื่องมาจากพระราชดำริ คณะทำงาน สำนักออกแบบวิศวกรรมและสถาปัตยกรรม กรมชลประทาน. (2559). คู่มือการกำหนดรูปแบบ ก่อสร้าง ซ่อมปรับปรุง บำรุงรักษา และเพิ่มประสิทธิภาพฝายชะลอน้ำพอเพียงตามแนวพระราชดำริ, 7 สิงหาคม 2562. http://ridceo.rid.go.th/phrae/images/Download/ManualCheckDam5907.pdf",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ฝ"
  },
  {
    keyword: "ฝ่ายตุลาการ",
    meaning: "ผู้มีอำนาจและหน้าที่ในการพิจารณาพิพากษาอรรถคดี",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ตุลาการ. 22 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ฝ"
  },
  {
    keyword: "พนักงานสอบสวน",
    meaning: "เจ้าพนักงานซึ่งกฎหมายให้มีอำนาจและหน้าที่ทำการสอบสวน",
    source:
      "พระราชบัญญัติประมวลกฎหมายวิธีพิจารณาความอาญา พ.ศ. 2477 และที่แก้ไขเพิ่มเติม.http://www.krisdika.go.th/librarian/get?sysid=570066&ext=pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "พ"
  },
  {
    keyword: "พนักงานอัยการ",
    meaning:
      "เจ้าพนักงานผู้มีหน้าที่ฟ้องผู้ต้องหาต่อศาล  ทั้งนี้ จะเป็นข้าราชการในกรมอัยการหรือเจ้าพนักงานอื่นผู้มีอำนาจเช่นนั้นก็ได้",
    source:
      "พระราชบัญญัติประมวลกฎหมายวิธีพิจารณาความอาญา พ.ศ. 2477 และที่แก้ไขเพิ่มเติม.http://www.krisdika.go.th/librarian/get?sysid=570066&ext=pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "พ"
  },
  {
    keyword: "พยาน",
    meaning:
      "พยานบุคคลซึ่งจะมาให้หรือได้ให้ข้อเท็จจริง ต่อพนักงานผู้มีอำนาจสืบสวนคดีอาญา พนักงานผู้มีอำนาจสอบสวนคดีอาญา พนักงานผู้มีอำนาจฟ้องคดีอาญา หรือศาลในการดำเนินคดี\r\nอาญา รวมทั้งผู้ชำนาญการพิเศษ แต่มิให้หมายความรวมถึงจำเลยที่อ้างตนเอง เป็นพยาน",
    source:
      "พระราชบัญญัติคุ้มครองพยานในคดีอาญา พ.ศ. 2546 . (2546, 20 มิถุนายน). ราชกิจจานุเบกษา. เล่ม 120 ตอน 58 ก หน้า 4.  http://www.ratchakitcha.soc.go.th/DATA/PDF/00124899.PDF",
    sappear: "",
    mappear: 21,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พยานหลักฐาน",
    meaning:
      "พยานวัตถุ พยานเอกสาร หรือพยานบุคคลซึ่งน่าจะพิสูจน์ได้ว่าจำเลยมีผิดหรือบริสุทธิ์ ให้อ้างเป็นพยานหลักฐานได้ แต่ต้องเป็นพยานชนิดที่มิได้เกิดขึ้นจากการจูงใจ มีคำมั่นสัญญา ขู่เข็ญ หลอกลวงหรือโดยมิชอบประการอื่น ",
    source:
      "พระราชบัญญัติให้ใช้ประมวลกฎหมายวิธีพิจารณาความอาญา พ.ศ. 2477. (2477, 7 มีนาคม 2477). มาตรา 226 หน้า 74. http://www.krisdika.go.th/librarian/get?sysid=570066&ext=pdf",
    sappear: "",
    mappear: 22,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พระธรรมวินัย",
    meaning:
      "พระธรรมคำสั่งสอนของพระพุทธเจ้า ซึ่งมี 3 ปิฎก คือ\r\n 1. พระวินัยปิฏก เกี่ยวกับระเบียบข้อประพฤติ ปฏิบัติ เพื่อพรหมจรรย์ขั้นสูงยิ่งขึ้นเป็นส่วนใหญ่\r\n 2.พระสุตตันปิฏก เกี่ยวกับหลักธรรม ที่ทรงเทศนาแก่บุคคลต่าง ๆ ณ สถานที่ต่างๆ เป็นส่วนใหญ่\r\n 3.พระอภิธรรมปิฏก เกี่ยวกับสภาพธรรม พร้อมทั้งเหตุ และผลของธรรม ทั้งปวง",
    source:
      "paderm. (2557). พระธรรมวินัยใครบัญญัติ, 18 กรกฎาคม 2562. https://www.dhammahome.com/webboard/topic/25795",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พระบรมราชโองการ",
    meaning:
      "คำสั่งราชการของพระมหากษัตริย์หรือพระบาทสมเด็จพระเจ้าอยู่หัวฯ เรียกว่า พระบรมราชโองการ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. พระบรมราชโองการ. 5 มิถุนายน 2562. \r\nhttp://www.royin.go.th/?knowledges=%E0%B8%9A%E0%B8%A3%E0%B8%A1-%E0%B9%92%E0%B9%94-%E0%B8%A1%E0%B8%B5%E0%B8%99%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%90",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "พ"
  },
  {
    keyword: "พระราชบัญญัติ",
    meaning:
      "รูปแบบของกฎหมายที่พระมหากษัตริย์ทรงตราขึ้นโดยคำแนะนำและยินยอมของฝ่ายนิติบัญญัติ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. พระราชบัญญัติ. 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "พ"
  },
  {
    keyword: "พระราชบัญญัติข้อมูลข่าวสารของราชการ",
    meaning:
      'กฎหมายที่รองรับ "สิทธิได้รู้"ของประชาชน โดยได้กำหนดสิทธิในการรับรู้ข้อมูลข่าวสารของราชการ และกำหนดหน้าที่ของหน่วยงานของรัฐและเจ้าหน้าที่ให้ต้องปฏิบัติตามกฎหมาย เพื่อรองรับการคุ้มครองสิทธิของประชาชนไปพร้อมกัน',
    source:
      "คู่มือสิทธิการรับรู้ข้อมูลข่าวสารของราชการ. กลุ่มงานวิชาการ สำนักงานคณะกรรมการข้อมูลข่าวสารของราชการ สำนักงานปลัดสำนักนายกรัฐมนตรี , 30 สิงหาคม 2562. https://www.boi.go.th/clean/pdf_files/handbook_oic.pdf",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "พ"
  },
  {
    keyword: "พฤติการณ์",
    meaning:
      "เหตุการณ์ที่เป็นมาหรือที่จะเป็นไป, ความเป็นไปในเวลากระทำการ เช่น พฤติการณ์ของเขาแสดงว่ามีเมตตากรุณา พฤติการณ์ของเขาแสดงถึงความทารุณโหดร้าย",
    source:
      "พจนานุกรม ฉบับราชบัณฑิตยสถาน พ.ศ. 2554. พฤติการณ์ , 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "พ"
  },
  {
    keyword: "พลเมือง",
    meaning:
      "บุคคลที่อยู่ในประเทศซึ่งมีสิทธิ์ออกเสียงและสามารถแสดงความคิดเห็น รวมถึง การมีส่วนร่วมในเรื่องต่างๆภายในประเทศ และการบริหารประเทศรวมถึงนโยบายที่รัฐจัดขึ้น ซึ่งพลเมืองเองก็มีสิทธิ์และสามารถเสนอความคิดเห็นออกมาเป็นนโยบายต่างๆ ได้",
    source:
      "ศูนย์พัฒนาการเมืองภาคพลเมือง สถาบันพระปกเกล้า จังหวัดลำพูน. สภาพลเมือง, 11 กันยายน 2562.\r\nhttps://kaewpanya.rmutl.ac.th/kservice/lpkpi/admin/courses/kpi1.pdf",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พลเมืองที่ดี",
    meaning:
      "ตระหนักถึงสิทธิของตนเองและต้องทำหน้าที่ที่กฎหมายรัฐธรรมนูญกำหนดด้วย เช่น เสียภาษีให้รัฐ  อนุรักษ์ทรัพยากรธรรมชาติและสิ่งแวดล้อม.",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2556). พลเมือง, 30 กันยายน 2562.\r\nhttp://www.royin.go.th/?knowledges=%E0%B8%9E%E0%B8%A5%E0%B9%80%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%87-%E0%B9%93%E0%B9%91-%E0%B8%98%E0%B8%B1%E0%B8%99%E0%B8%A7%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%96",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พลวัต (dynamic) ",
    meaning:
      "สิ่งที่ไม่หยุดนิ่งอยู่กับที่ และมีความสามารถเคลื่อนที่ไปข้างหน้าด้วยพลังในตัวเอง เช่น ภาษามีความเป็นพลวัต คือมีความเปลี่ยนแปลงตลอดเวลา.",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2555). พลวัต, \r\n30 สิงหาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%\r\n9E%E0%B8%A5%E0%B8%A7%E0%B8%B1%E0%B8%95-%E0%B9%96-%E0%B8%AA%E0%B8%B4%E0%B8%\r\n87%E0%B8%AB%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%95",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "พ"
  },
  {
    keyword: "พลวัตของการทุจริต",
    meaning:
      "การทุจริตที่ยากแก่การตรวจสอบ การทุจริตต่างๆมักเป็นผลมาจากหน่วยงานภาครัฐที่มีการดำเนินงานที่ไม่โปร่งใสหรือเจ้าหน้าที่รัฐกระทำการทุจริตต่อหน้าที่รวมไปถึงช่องโหว่ต่างๆทางกฎหมาย",
    source:
      "กรมสนับสนุนบริการสุขภาพ กลุ่มงานคุ้มครองจริยธรรม. (2560). คู่มือการป้องกันการละเว้นการปฏิบัติหน้าที่ในภารกิจหลักและภารกิจสนับสนุน, 19 พฤศจิกายน 2562. http://203.157.7.98/et/fileupload_doc/2018-03-12-6-18-2723677.pdf",
    sappear: "",
    mappear: 21,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พลังงาน ",
    meaning:
      "ความสามารถในการทำงานซึ่งมีอยู่ในตัวของสิ่งที่อาจให้งานได้ ได้แก่ พลังงานหมุนเวียน และพลังงานสิ้นเปลือง และให้หมายความรวมถึงสิ่งที่อาจให้งานได้ เช่น เชื้อเพลิง ความร้อน และไฟฟ้า เป็นต้น\r\n",
    source:
      "พระราชบัญญัติคณะกรรมการนโยบายพลังงานแห่งชาติ พ.ศ. 2535 (2535,12 กุมภาพันธ์) ราชกิจจานุเบกษา.เล่ม 109 ตอนที่ 9  หน้า 1 http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/009/1.PDF",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พลังงานแสงอาทิตย์",
    meaning:
      "พลังงานที่ผลิตได้จากการแผ่รังสีของดวงอาทิตย์ในรูปของแสงแดด ที่ประกอบด้วยพลังงานแสงและพลังงานความร้อน ซึ่งพลังงานแสงอาทิตย์ ประกอบด้วย 2 ส่วน ได้แก่ พลังงานแสงและพลังงานความร้อน โดยพลังงานทั้ง 2 ส่วนนี้สามารถนำไปใช้ประโยชน์ในการผลิตพลังงานได้ 2 รูปแบบ ได้แก่ พลังงานไฟฟ้า และพลังงานความร้อน",
    source:
      "สำนักงานสิ่งแวดล้อมภาคที่ 13 (ชลบุรี). (2561). พลังงานแสงอาทิตย์, 25 มิถุนายน 2562. http://www.mnre.go.th/reo13/th/news/detail/9385",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "พ"
  },
  {
    keyword: "พลังงานไฟฟ้า",
    meaning:
      "พลังงานรูปแบบหนึ่ง ซึ่งสามารถเปลี่ยนไปเป็นพลังงานอีกรูปแบบหนึ่งได้ เกิดจากแหล่งกำเนิดหลายประเภท ซึ่งการนำพลังงานไฟฟ้ามาใช้จะต้องมีการเชื่อมต่อแหล่งกำเนิดไฟฟ้าเข้ากับสิ่งที่จะนำพลังงานไฟฟ้าไปใช้เรียกว่า วงจรไฟฟ้า โดยพลังงานไฟฟ้าที่ได้จะถูกเปลี่ยนรูปแบบไปเป็นพลังงานรูปแบบต่างๆ ",
    source:
      "นพรัตน์ คงสัตรา. พลังงานไฟฟ้าคืออะไร, 29 มิถุนายน 2562. https://sites.google.com/site/scikroonop/phlangngan-fifa-khux-xari",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พลังงานไฮโดรเจน",
    meaning:
      "ไฮโดรเจนเป็นธาตุที่เบาที่สุดและเป็นองค์ประกอบของน้ำ (H2O) ที่มีมากที่สุดบนโลก นอกจากนี้ยังเป็นธาตุที่รวมอยู่ในโมเลกุลของสารประกอบอื่นๆ เช่น สารประกอบจําพวกไฮโดรคาร์บอน (HC) ซึ่งเป็นผลิตภัณฑ์ของปิโตรเลียมที่มีความสําคัญสําหรับการพัฒนาทางเศรษฐกิจของประเทศ คุณสมบัติทั่วไปของไฮโดรเจน คือ ไม่มีสี ไม่มีกลิ่น ติดไฟง่าย มีความสะอาดสูง ไม่เป็นพิษและเป็นมิตรกับสิ่งแวดล้อม ประโยชน์ของการนําก๊าซไฮโดรเจนมาใช้งานคือใช้เป็นเชื้อเพลิงในการเผาไหม้และให้ความร้อนออกมา หรือใช้ในเซลล์เชื้อเพลิงโดยปฏิกิริยาทางเคมีแล้วเกิดกระแสไฟฟ้าซึ่งสามารถนําไปใช้ได้ทั้งในการขับเคลื่อนรถ ผลิตกระแสไฟฟ้า อุปกรณ์อิเล็คทรอนิคส์ขนาดเล็กและอื่นๆ",
    source:
      "สำนักวิจัยค้นคว้าพลังงาน กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน กระทรวงพลังงาน. คู่มือความรู้ด้านพลังงานไฮโดรเจน, 30 กันยายน 2562. http://www2.dede.go.th/kmmf/download/%E0%B8%99%E0%B8%A7%E0%B8%B1%E0%B8%95%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1/%E0%B8%AA%E0%B8%A7%E0%B8%84/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%9E%E0%B8%A5%E0%B8%B1%E0%B8%87%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B9%84%E0%B8%AE%E0%B9%82%E0%B8%94%E0%B8%A3%E0%B9%80%E0%B8%88%E0%B8%99.pdf",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พลังงานของเสีย",
    meaning:
      "ทางเลือกประการหนึ่งสำหรับการจัดหาแหล่งพลังงานทดแทน ซึ่งเป็นการผลิตพลังงานแบบอนุรักษ์สิ่งแวดล้อม และลดการปล่อยมลพิษออกสู่ธรรมชาติ เทคโนโลยีการเปลี่ยนของเสียให้เป็นพลังงานทดแทนที่สำคัญ 2 เทคโนโลยี ซึ่งสามารถเปลี่ยนของเสียให้เป็นพลังงานทดแทน และสามารถนำไปใช้งานได้อย่างมีประสิทธิภาพ คือ การผลิตก๊าซชีวภาพจากน้ำเสีย ขยะมูลฝอย และ มูลสัตว์ และ การแปรรูปของเสียเป็นพลังงานด้วยกระบวนการทางความร้อน",
    source:
      "จุฬาวิทยานุกรม. (2554).  พลังงานทดแทนจากของเสีย, 1 ตุลาคม 2562. http://www.chulapedia.chula.ac.th/index.php?title=%E0%B8%9E%E0%B8%A5%E0%B8%B1%E0%B8%87%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B8%97%E0%B8%94%E0%B9%81%E0%B8%97%E0%B8%99%E0%B8%88%E0%B8%B2%E0%B8%81%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B9%80%E0%B8%AA%E0%B8%B5%E0%B8%A2",
    sappear: 5,
    mappear: 19,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พลังงานชีวภาพ",
    meaning:
      "พลังงานหมุนเวียนที่ไดจากการแปรรูปแหลงชีวมวล (มวลของพืชหรือวัสดุจากพืชชนิดตาง ๆ ทั้งบนพื้นดิน ในนํ้าและในทะเล รวมสิ่งมีชีวิตชั้นตํ่า เชน แบคทีเรีย รา แพลงกตอน สาหราย สาเหลา ที่ไดจากการผลิตแอลกอฮอล ตลอดจนมูลสัตวและของเสียอินทรียจากโรงงานอุตสาหกรรมเกษตร เชน ชานออย แกลบ ขี้เลื่อย เปนตน) ผานกระบวนการตาง ๆ เชน การผลิตเชื้อเพลิงเหลว การหมัก และการเผาไหม เปนตน สามารถนําไปใชประโยชนไดทั้งการผลิตไฟฟาและความรอน ประเทศไทยโดยกระทรวงพลังงานมีการสงเสริมการใชพลังงานชีวภาพแบบตาง ๆ เชน โครงการสงเสริมเทคโนโลยีแกสชีวภาพในภาคปศุสัตว โครงการสงเสริมเทคโนโลยีแกสชีวภาพในภาคอุตสาหกรรม และโครงการสงเสริมเทคโนโลยีแกสชีวภาพในภาคชุมชน มีสถานประกอบการเอกชน เชน โรงแรม รีสอรท โรงอาหาร โรงเรียน และกรมราชทัณฑเขารวมโครงการ ซึ่งเนนการผลิต\r\nแกสชีวภาพจากเศษอาหารมาใช้",
    source:
      "กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน กระทรวงพลังงาน. สารานุกรมพลังงานทดแทน. Alternative Energy Encyclopedia, (2557). หน้า 93.\r\nhttps://energy.go.th/2015/wp-content/uploads/2016/02/alt-energy-encyclopedia.pdf",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พลังงานชีวมวล",
    meaning:
      "เชื้อเพลิงที่ได้จากสิ่งมีชีวิตเช่น ไม้ฟืน แกลบ กากอ้อย เศษไม้ เศษหญ้า เศษเหลือทิ้งจากการเกษตร เหล่านี้ใช้เผาให้ความร้อนได้ เป็นเชื้อเพลิงชีวภาพแบบของแข็ง และความร้อนนี้แหละที่เอาไปปั่นไฟ โดยเหตุที่ประเทศไทยทำการเกษตรอย่างกว้างขวาง วัสดุเหลือใช้จากการเกษตร เช่น แกลบ ขี้เลื่อย ชานอ้อย กากมะพร้าว ซึ่งมีอยู่จำนวนมาก (เทียบได้น้ำมันดิบปีละไม่น้อยกว่า 6,500 ล้านลิตร) ก็ควรจะใช้เป็นเชื้อเพลิงผลิตไฟฟ้าในเชิงพาณิชย์ได้\r\n ในกรณีของโรงเลื่อย โรงสี โรงน้ำตาลขนาดใหญ่ อาจจะยินยอมให้จ่ายพลังงานไฟฟ้าให้กับระบบไฟฟ้าของการไฟฟ้าต่างๆในประเทศ ในลักษณะของการผลิตร่วม (Co-generation) ซึ่งมีใช้อยู่แล้วหลายแห่งในต่างประเทศโดยวิธีดังกล่าวแล้วจะช่วยให้สามารถใช้ประโยชน์จากแหล่งพลังงานในประเทศสำหรับส่วนรวมได้มากยิ่งขึ้น ทั้งนี้อาจจะรวมถึงการใช้ไม้ฟืนจากโครงการปลูกไม้โตเร็วในพื้นที่นับล้านไร่ ในกรณีที่รัฐบาลจำเป็นต้องลดปริมาณการปลูกมันสำปะหลัง อ้อย เพื่อแก้ปัญหาระยะยาวทางด้านการตลาดของพืชทั้งสองชนิด อนึ่ง สำหรับผลิตผลจากชีวมวลในลักษณะอื่นที่ยังใช้เป็นเชื้อเพลิงได้ เช่น แอลกอฮอล์ จากมันสำปะหลัง ก๊าซจากฟืน(Wood gas) ก๊าซจากการหมักเศษวัสดุเหลือจากการเกษตร และขยะชุมชน (ก๊าซชีวภาพ) หากมีความคุ้มค่าในเชิงพาณิชย์ก็อาจนำมาใช้เป็นเชื้อเพลิงสำหรับผลิตไฟฟ้าได้เช่นกัน",
    source:
      "ตลาดหลักทรัพย์แห่งประเทศไทย. พลังงานทดแทน, 29 มิถุนายน 2562. http://www.setsocialimpact.com/Article/Detail/61313",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พลังงานทดแทน",
    meaning:
      "พลังงานที่นำมาใช้แทนน้ำมันเชื้อเพลิง สามารถแบ่งตามแหล่งที่ได้มากเป็น 2 ประเภท คือ \r\n1. พลังงานทดแทนจากแหล่งที่ใช้แล้วหมดไป อาจเรียกว่า พลังงานสิ้นเปลือง ได้แก่ ถ่านหิน ก๊าซธรรมชาติ นิวเคลียร์ หินน้ำมัน และทรายน้ำมัน เป็นต้น \r\n2. พลังงานทดแทนอีกประเภทหนึ่งเป็นแหล่งพลังงานที่ใช้แล้ว สามารถหมุนเวียนมาใช้ได้อีก เรียกว่า พลังงานหมุนเวียน ได้แก่ แสงอาทิตย์ ลม ชีวมวล น้ำ และไฮโดรเจน เป็นต้น เป็นพลังงานที่สะอาด ไม่มีผลกระทบต่อสิ่งแวดล้อม",
    source:
      "ตลาดหลักทรัพย์แห่งประเทศไทย. พลังงานทดแทน, 29 มิถุนายน 2562. http://www.setsocialimpact.com/Article/Detail/61313",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "พ"
  },
  {
    keyword: "พลังงานทางเลือก",
    meaning:
      "พลังงานที่นํามาใชแทนเชื้อเพลิงฟอสชิล (ดู fossil fuel) สามารถแบ่งตามแหลงที่ไดเปน 2 ประเภท คือ \r\n1. พลังงานทดแทนจากแหลงที่ใชแล้วหมดไปหรือพลังงานสิ้นเปลือง (depleted resources) ไดแก นิวเคลียร และ แรพลังงานอื่น เชน ยูเรเนียม พลูโตเนียม เปนตน \r\n2. พลังงานที่ใชแลวสามารถผลิตขึ้นใหมแล้วหมุนเวียนมาใชไดอีก (renewable resources) ไดแก แสงอาทิตย ลม ชีวมวล และ นํ้า เป็นต้น",
    source:
      "กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน กระทรวงพลังงาน. สารานุกรมพลังงานทดแทน Alternative Energy Encyclopedia, (2557). หน้า 89.\r\nhttps://energy.go.th/2015/wp-content/uploads/2016/02/alt-energy-encyclopedia.pdf",
    sappear: "",
    mappear: 4,
    rappear: 10,
    firstalpha: "พ"
  },
  {
    keyword: "พลังงานน้ำ",
    meaning:
      "พลังงานหรือกำลังที่เกิดจากการไหลของน้ำ ซึ่งเป็นพลังที่มีอนุภาพมาก หากไม่สามารถควบคุมได้ พลังน้ำนั้นก็สามารถทำให้เกิดความเสียหายแก่ชีวิตและทรัพย์สินได้อย่างกว้างขวาง ดังตัวอย่างเช่น การเกิดอุทกภัยในบริเวณที่ลาดเชิงเขา หรือบริเวณที่มีความลาดชันสูง และการเกิดสึนามิ เป็นต้น ในทางตรงกันข้าม หากสามารถควบคุมพลังน้ำได้ตามแนวทางที่เหมาะสม พลังน้ำอันมหาศาลนั้น ก็สามารถนำมาใช้เป็นประโยชน์แก่มนุษยชาติได้",
    source:
      "สมาคมพลังงานทดแทนสู่ชุมชนแห่งประเทศไทย-TRECA คณะวิศวกรรมศาสตร์ มหาวิทยาลัยเทคโนโลยีราชมงคลธัญบุรี. พลังงานน้ำ, 29 มิถุนายน 2562. http://www.reca.or.th/library-hydro-power.aspx",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "พ"
  },
  {
    keyword: "พลังงานลม",
    meaning:
      "ลมเป็นปรากฏการณ์ทางธรรมชาติ ซึ่งเกิดจากความแตกต่างของอุณหภูมิ ความกดดันของบรรยากาศและแรงจากการหมุนของโลก สิ่งเหล่านี้เป็นปัจจัยที่ก่อให้เกิดความเร็วลมและกำลังลม เป็นที่ยอมรับโดยทั่วไปว่าลมเป็นพลังงานรูปหนึ่งที่มีอยู่ในตัวเอง ซึ่งบางครั้งแรงที่เกิดจากลมอาจทำให้บ้านเรือนที่อยู่อาศัยพังทลาย ต้นไม้หักโค่นลง สิ่งของวัตถุต่างๆ ล้มหรือปลิวลอยไปตามลม ฯลฯ ในปัจจุบันมนุษย์จึงได้ให้ความสำคัญและนำพลังงานจากลมมาใช้ประโยชน์มากขึ้น เนื่องจากพลังงานลมมีอยู่โดยทั่วไปและเป็นพลังงานที่สะอาดไม่ก่อให้เกิดอันตรายต่อสภาพแวดล้อม รวมทั้งสามารถนำมาใช้ประโยชน์ได้อย่างได้โดยไม่หมดไป\r\n",
    source:
      "กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน (พพ.) กระทรวงพลังงาน. พลังงานลม, 29 สิงหาคม 2562. \r\nhttp://www.dede.go.th/ewt_w3c/ewt_news.php?nid=513&filename=",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "พ"
  },
  {
    keyword: "พลังงานสะอาด",
    meaning:
      "พลังงานที่เป็นมิตรต่อสิ่งแวดล้อม กล่าวคือ ไม่ทำลายสิ่งแวดล้อมในทุกขั้นตอนของการแปรรูปพลังงาน เช่น พลังงานแสงอาทิตย์ พลังงานลม เป็นต้น",
    source:
      "กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน กระทรวงพลังงาน. (2559). สารานุกรมพลังงานทดแทน, 30 กรกฎาคม 2562. https://energy.go.th/2015/wp-content/uploads/2016/02/alt-energy-encyclopedia.pdf",
    sappear: 2,
    mappear: 6,
    rappear: 10,
    firstalpha: "พ"
  },
  {
    keyword: "พลังงานหมุนเวียน",
    meaning:
      "พลังงานที่ได้จากไม้ ฝืน แกลบ กาก อ้อย ชีวมวล น้ำ แสงอาทิตย์ ความร้อนใต้พิภพ ลม และคลื่น",
    source:
      "พระราชบัญญัติการส่งเสริมการอนุรักษษ์พลังงาน พ.ศ. 2535, (2535, 2 เมษายน). ราชกิจจานุเบกษา. เล่ม 109 ตอนที่ 33 หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/033/1.PDF ",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "พ"
  },
  {
    keyword: "พลังอำนาจแห่งชาติ",
    meaning:
      "1. กำลังทหาร กองทัพและการป้องกันประเทศ\r\n2. การเมือง\r\n3. เศรษฐกิจ\r\n4. จิตสังคม\r\n5. วิทยาศาสตร์เทคโนโลยี",
    source:
      "พลอากาศโท เดชา หันหาบุญ รองผู้อำนวยการสำนักงานราชองครักษ์ประจำ กรมราชองครักษ์. ความมั่นคงของชาติ, 2 ตุลาคม 2562. http://www.stabundamrong.go.th/base/j9.2.pdf",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พลาสติกชีวภาพ",
    meaning:
      "พลาสติกชีวภาพ (Bioplastic) หรือพลาสติกชีวภาพย่อยสลายได้ (Biodegradable plastic) หมายถึง พลาสติกที่ผลิตขึ้นจากวัสดุธรรมชาติ ส่วนใหญ่เป็นพืชที่สามารถย่อยสลายได้ในธรรมชาติ (biodegradable) ช่วยลดปัญหามลพิษในสิ่งแวดล้อม วัสดุธรรมชาติที่สามารถนำมาผลิตเป็นพลาสติกชีวภาพมีหลายชนิด เช่น cellulose collagen casein polyester แป้ง (starch) โปรตีนจากถั่ว และข้าวโพด เป็นต้น ซึ่งวัสดุประเภทแป้งมีความเหมาะสมที่สุด เนื่องจาก มีจำนวนมาก ราคาถูก สามารถหาได้จากพืชชนิดต่าง ๆ เช่น ข้าวโพด ข้าวสาลี มันฝรั่ง มันเทศ มันสำปะหลัง เป็นต้น",
    source:
      "กรมส่งเสริมอุตสาหกรรม. พลาสติกชีวภาพ (Bioplastic), 24 มิถุนายน 2562. http://library.dip.go.th/Industrial%20Innovation/www/innonew0-01.html",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พสกนิกร",
    meaning:
      "คนที่อยู่ในประเทศ ไม่ว่าจะเป็นพลเมืองของประเทศนั้นหรือคนต่างด้าวที่มาอาศัยอยู่ก็ตาม",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. พสกนิกร. 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "พ"
  },
  {
    keyword: "พหุปัญญา",
    meaning:
      "ความสามารถของมนุษย์ที่จะค้นหาปัญหา และหาทางแก้ไขปัญหา รวมไปถึงความสามารถในการคิดค้นสิ่งใหม่ๆ เพื่อตอบสนองหรือรับใช้สังคมของตน",
    source:
      "จันทร์เพ็ญ ชูประภาวรรณ. พหุปัญญา (Multiple Intelligence), 2 กรกฎาคม 2562. http://taamkru.com/th/%E0%B8%9E%E0%B8%AB%E0%B8%B8%E0%B8%9B%E0%B8%B1%E0%B8%8D%E0%B8%8D%E0%B8%B2/",
    sappear: "",
    mappear: 2,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พหุภาคี",
    meaning:
      "1. หลายฝ่าย\r\n2. เรียกสนธิสัญญาที่มีคู่สัญญาหลายฝ่ายว่า สนธิสัญญาพหุภาคี",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. พหุภาคี. 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 1,
    mappear: 2,
    rappear: 1,
    firstalpha: "พ"
  },
  {
    keyword: "พหุวัฒนธรรม",
    meaning:
      "การอยู่ร่วมกันบนฐานของความหลากหลายทางวัฒนธรรมด้านต่าง ๆ เช่น ภาษา ศาสนา การแต่งกาย เชื้อชาติ โดยมีความเคารพและความเข้าใจในความแตกต่างหลากหลายดังกล่าวนั้น",
    source:
      "สำนักงานกองทุนสนับสนุนการสร้างเสริมสุขภาพ. (2557). เรียนรู้ อยู่ร่วม บนความต่างของวัฒนธรรม, 31 กรกฎาคม 2562. https://www.thaihealth.or.th/Content/25574-เรียนรู้%20อยู่ร่วม%20บนความต่างของวัฒนธรรม%20%20%20%20%20%20%20%20.html",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พัฒนาการสมวัย",
    meaning:
      "เด็กที่ได้รับตรวจคัดกรองพัฒนาการโดยใช้คู่มือเฝ้าระวังและส่งเสริมพัฒนาการเด็กปฐมวัย",
    source:
      "สำนักส่งเสริมสุขภาพ กรมอนามัย, สถาบันพัฒนาอนามัยเด็กแห่งชาติ กรมอนามัย และกองยุทธศาสตร์และแผนงาน สำนักงานปลัดกระทรวงสาธารณสุข. ร้อยละของเด็กอายุ 0-5 ปี มีพัฒนาการสมวัย, 19 ธันวาคม 2562. http://healthkpi.moph.go.th/kpi/kpi-list/view/?id=742",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พันธมิตร",
    meaning:
      "ความสัมพันธ์ระหว่างรัฐที่จะช่วยเหลือกันตามสนธิสัญญาที่ทำไว้ เพื่อร่วมรบหรือเพื่อการป้องกันร่วมกัน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2542. พันธมิตร. 25 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "พ"
  },
  {
    keyword: "พันธุ์พืช",
    meaning:
      "กลุ่มของพืชที่มีพันธุกรรมและลักษณะทางพฤกษศาสตร์ เหมือนหรือคล้ายคลึงกัน มีคุณสมบัติเฉพาะตัวที่สม่ำเสมอ คงตัว และแตกต่างจากกลุ่มอื่นในพืชชนิดเดียวกัน และให้หมายความรวมถึงต้นพืชที่จะขยายพันธุ์ให้ได้กลุ่มของพืชที่มีคุณสมบัติดังกล่าวข้างต้น\r\n",
    source:
      "พระราชบัญญัติคุ้มครองพันธุ์พืช พ.ศ. 2542 (2542,24 พฤศจิกายน) ราชกิจจานุเบกษา. เล่ม 116 ตอนที่ 118 ก หน้า 15 http://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/118/15.PDF ",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "พ"
  },
  {
    keyword: "พันธุวิศวกรรม",
    meaning:
      "การปรับปรุงเปลี่ยนแปลงลักษณะทางพันธุกรรมของสิ่งมีชีวิต ลักษณะเหล่านี้ขึ้นอยู่กับตัวกำหนด ภายในเซลล์แต่ละเซลล์ สามารถเปลี่ยนแปลงรหัสคำสั่งให้เซลล์ปฏิบัติตามที่เราประสงค์ได้ตามสมควร สามารถเขียนพิมพ์เขียวของเซลล์ได้ใหม่ ให้มีลักษณะที่ต้องการบางอย่างได้ ความสำเร็จของนักพันธุวิศวกรรมนี้ เราได้นำมาใช้ประโยชน์ทางอุตสาหกรรม การแพทย์ และการเกษตร",
    source:
      "สารานุกรมไทยสำหรับเยาวชนฯ เล่มที่ 14. พันธุวิศวกรรม, 30 กรกฎาคม 2560. http://saranukromthai.or.th/sub/book/book.php?book=14&chap=8&page=t14-8-infodetail05.html",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พาณิชย์นาวี",
    meaning:
      "การขนส่งทางทะเล การประกันภัยทางทะเล การเดินเรือ กิจการอู่เรือและกิจการท่าเรือ และหมายความรวมถึงกิจการอย่างอื่นที่เกี่ยวเนื่องโดยตรงหรือเป็นส่วนประกอบกับกิจการดังกล่าวตามที่กำหนดในกฎกระทรวงตามพระราชบัญญัติส่งเสริมการพาณิชยนาวี พ.ศ. 2521",
    source:
      "สำนักงานคณะกรรมการส่งเสริมวิทยาศาสตร์ วิจัย และนวัตกรรม. (2555). พาณิชยนาวีไทย : ความสำเร็จหรือความล้มเหลว, 25 มิถุนายน 2562. https://www.trf.or.th/research-digest/1055-2013-12-07-03-23-20",
    sappear: 5,
    mappear: "1,18",
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พื้นที่เศรษฐกิจพิเศษ",
    meaning:
      "บริเวณพื้นที่ที่คณะกรรมการนโยบายเขตพัฒนาเศรษฐกิจพิเศษ (กนพ.) กำหนดให้เป็นเขตพัฒนาเศรษฐกิจพิเศษ ซึ่งรัฐจะสนับสนุนโครงสร้างพื้นฐาน สิทธิประโยชน์การลงทุน การบริหารแรงงานต่างด้าวแบบไป-กลับ การให้บริการจุดเดียวเบ็ดเสร็จและการบริการอื่นที่จำเป็น",
    source:
      "Open Development Thailand. (2561) เขตพัฒนาเศรษฐกิจพิเศษ, 18 พฤศจิกายน 2562.\r\nhttps://thailand.opendevelopmentmekong.net/th/topics/special-economic-zones/#ref-1952-1",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พื้นที่เสี่ยง",
    meaning:
      "บริเวณที่มีความเป็นไปได้ว่าจะเกิดภัยพิบัติหรือมีแนวโน้มที่จะเกิดภัยพิบัติ",
    source:
      "กรมป้องกันและบรรเทาสาธารณภัย. หนังสือคำศัพท์ด้านการบริหารจัดการความเสี่ยงจากภัยพิบัติ, 9 กันยายน 2562. http://www.disaster.go.th/th/download-src.php?did=1225",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "พ"
  },
  {
    keyword: "พื้นที่แนวกันชน",
    meaning:
      "พื้นที่ที่กำหนดขึ้นเพื่อเป็นแถบกั้นระหว่างพื้นที่อนุรักษ์กับพื้นที่ที่อยู่ติดกันหรือโดยรอบพื้นที่อนุรักษ์ หรือเป็นแนวกั้นสุดท้ายก่อนที่จะเข้าถึงเขตอนุรักษ์ ซึ่งอาจมีข้อจำกัดบางประการในการใช้ทรัพยากร และไม่อนุญาตให้มีการตั้งชุมชน ตลอดจนกิจกรรมใดๆ ที่เกิดผลกระทบเชิงลบต่อพื้นที่อนุรักษ์ แนวกันชนจึงเหมือนรั้วรอบเขตพื้นที่อนุรักษ์ที่อาจเป็นพื้นที่ป่าเศรษฐกิจหรือปลูกสวนป่า ทั้งนี้ขึ้นอยู่กับข้อตกลงหรือการต่อรองระหว่างรัฐ ชุมชนท้องถิ่นและผู้ที่เกี่ยวข้องอื่นๆ",
    source:
      "วีระชัย นาควิบูลย์วงศ์.(2550) การจัการพี้นที่กันชนในประเทศไทย (2550), 18 พฤศจิกายน 2562. http://landforum.trf.or.th/attachments/article/21/PDF04-02.pdf",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พื้นที่คุ้มครอง",
    meaning:
      "พื้นที่ดิน หรือพื้นที่ทางทะเล ได้จัดตั้งขึ้นเพื่อคุ้มครองและรักษาความหลากหลายทางชีวภาพ ทรัพยากรธรรมชาติ วัฒนธรรม และคุณค่าทางทัศนียภาพ ซึ่งดำเนินการโดยใช้กฎหมายในการจัดตั้งและบริหารจัดการ",
    source:
      "กรมอุทยานแห่งชาติ สัตว์ป่า และพันธุ์พืช. บทที่ 3 พื้นที่คุ้มครองในประเทศไทย, 21 มิถุนายน 2562. http://app.dnp.go.th/opac/multimedia/research/1364_48/chapter3.pdf",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พื้นที่คุ้มครองทางทะเล",
    meaning:
      "Marine Protected Area-MPA คือ พื้นที่บริเวณน้ำขึ้นน้ำลง หรือบริเวณพื้นท้องทะเลรวมทั้งมวลน้ำ สิ่งมีชีวิตทั้งพืชและสัตว์ ลักษณะทางประวัติศาสตร์และสังคม ซึ่งต้องสงวนรักษาไว้ด้วยระเบียบกฎหมายหรือด้วยวิธีการที่มีประสิทธิภาพอื่นใด เพื่อคุ้มครองส่วนหนึ่งส่วนใด หรือทั้งหมดของสภาพแวดล้อมบริเวณนั้น",
    source:
      "อนุวัฒน์ นทีวัฒนา. สำนักความหลากหลายทางชีวภาพในทะเลและชายฝั่ง. กรมทรัพยากรทางทะเลและชายฝั่ง. พื้นที่คุ้มครองทางทะเลในประเทศไทย : เป้าหมายปี ค.ศ. 2010/2012 ภายใต้อนุสัญญาว่าด้วยความหลากหลายทางชีวภาพ, 21 พฤศจิกายน 2562.\r\nhttps://www.dmcr.go.th/detailLib/2878",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "พ"
  },
  {
    keyword: "พื้นที่คุ้มครองทางทะเลและชายฝั่ง",
    meaning:
      "Marine and Coastal Protected Area-MCPA คือ พื้นที่ที่กำหนดไว้ภายในหรืออยู่ประชดกับสภาพแวดล้อมทางทะเล อันรวมทั้งมวลน้ำ สิ่งมีชีวิตทั้งพืชและสัตว์ ลักษณะสำคัญทางประวัติศาสตร์และวัฒนธรรม ซึ่งได้รับการจัดการโดยกลไกทากฎหมายหรือวิธีการที่มีประสิทธิภาพอื่นๆ รวมทั้งวัฒนธรรม ประเพณี เพื่อให้สามารถคุ้มครองความหลากหลายทางชีวิภาพทางทะเลและชายฝั่งและสิ่งแวดล้อมเป็นอย่างดี",
    source:
      "อนุวัฒน์ นทีวัฒนา. สำนักความหลากหลายทางชีวภาพในทะเลและชายฝั่ง. กรมทรัพยากรทางทะเลและชายฝั่ง. พื้นที่คุ้มครองทางทะเลในประเทศไทย : เป้าหมายปี ค.ศ. 2010/2012 ภายใต้อนุสัญญาว่าด้วยความหลากหลายทางชีวภาพ,  21 พฤศจิกายน 2562.\r\nhttps://www.dmcr.go.th/detailLib/2878",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "พ"
  },
  {
    keyword: "พื้นที่ชลประทาน",
    meaning:
      "1. พื้นที่ชลประทานที่มีระบบชลประทาน พื้นที่การเกษตรที่ได้รับประโยชน์จากการควบคุมและบริหารจัดการน้ำด้วยระบบชลประทาน ประกอบด้วยพื้นที่ทําการเกษตรรวมคันคูน้ำที่มีระบบส่งและระบายน้ำรวมทั้งอาคารสําหรับควบคุมน้ำ\r\n2. พื้นที่ชลประทานที่ไม่มีระบบชลประทาน พื้นที่การเกษตรที่มีการใช้น้ำจากแหล่งน้ำของกรมชลประทานที่สร้างขึ้นโดยไม่มีระบบชลประทานอํานวยความสะดวกในการนําน้ำไปใช้ในพื้นที่การเกษตร",
    source:
      "ศูนย์สารสนเทศ กรมส่งเสริมการเกษตร. (2552). การชลประทาน, 2 ตุลาคม 2562. http://www.agriinfo.doae.go.th/definition/irr.pdf",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พื้นที่ชายฝั่งตะวันออก (Eastern Seaboard)",
    meaning:
      "การพัฒนาพื้นที่บริเวณภาคตะวันออกของไทย 3 จังหวัด คือ 1) แหลมฉบัง จังหวัดชลบุรี 2) มาบตาพุด จังหวัดระยอง และ3) จังหวัดฉะเชิงเทรา เป็นการเปลี่ยนแปลงจากอุตสาหกรรมเบามาเป็นอุตสาหกรรมหนัก เช่น ยานยนต์และชิ้นส่วนรถยนต์ ชิ้นส่วนคอมพิวเตอร์ น้ำมันและก๊าซธรรมชาติ ปิโตรเคมีและเม็ดพลาสติก เป็นต้น",
    source:
      "ธนาคารออมสิน. EEC ภาคต่อ Eastern Seaboard ก้าวสำคัญการลงทุนไทย , 19 พฤศจิกายน 2562.\r\nhttps://www.gsb.or.th/getattachment/a7529f4e-ae04-44cd-9d50-e2bf9588bd7f/14MC_hotissue_internet_EEC_ex.aspx",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "พ"
  },
  {
    keyword: "พื้นที่ชุ่มน้ำ",
    meaning:
      "ที่ลุ่ม ที่ราบลุ่ม ที่ชื้นแฉะ พรุ แหล่งน้ำ ทั้งที่เกิดขึ้นเองตามธรรมชาติและที่มนุษย์สร้างขึ้น ทั้งที่มีน้ำขังหรือน้ำท่วมถาวรและชั่วคราว เป็นแหล่งน้ำนิ่งและน้ำไหล น้ำจืด น้ำกร่อย และน้ำเค็ม รวมไปถึงชายฝั่งทะเลและที่ในทะเลในบริเวณซึ่งเมื่อน้ำลดลงต่ำสุด มีความลึกของระดับน้ำไม่เกิน 6 เมตร",
    source:
      "สำนักงานนโยบายและแผนทรัพยากรธรรมชาติและสิ่งแวดล้อม. (2557). พื้นที่ชุ่มน้ำ คืออะไร, 2 ตุลาคม 2562. http://wetland.onep.go.th/w_mean.html",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พื้นที่ต้นน้ำ",
    meaning:
      "แบ่งออกเป็น 2 ส่วน คือ\r\n1. ต้นน้ำ ส่วนหนึ่งของพื้นที่ลุ่มน้ำที่อยู่บนพื้นที่สูง เช่น ภูเขา \r\n2. ลุ่มน้ำ พื้นที่ที่อยู่เหนือสุดๆหนึ่งบนลำธาร ที่ทำหน้าที่รองรับน้ำฝนและลำเลียงน้ำฝนในส่วนที่เหลือจากการนำไปใช้ของต้นไม้ การเก็บกักเอาไว้ในดิน และการรั่วซึมผ่านชั้นหินอยู่ใต้ชั้นดินออกนอกพื้นที่ลุ่มน้ำไป โดยลำเลียงน้ำในส่วนที่เกินนี้ลงสู่ธารทั้งทางผิวดินและใต้ผิวดิน",
    source:
      "ส่วนวิจัยต้นน้ำ สำนักอนุรักษ์และจัดการต้นน้ำ กรมอุทยานแห่งชาติ สัตว์ป่า และพันธ์พืช. (2556). คุณค่าป่าต้นน้ำ, 2 ตุลาคม 2562. http://www.dnp.go.th/watershed/publication_files/ws_value.pdf",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พื้นที่ทางการเกษตร (Agricultural zoning)",
    meaning:
      "เขตการผลิตทางการเกษตรที่กำหนดขึ้นให้เหมาะสม\r\nกับภาวะตลาดและเศรษฐกิจการเกษตรของประเทศ โดยคำนึงถึงสภาพที่คล้ายคลึงกันของปัจจัยหลัก เช่น ดินฟ้าอากาศ แหล่งน้ำ พืชที่ปลูก สัตว์ที่เลี้ยงประเภทของเกษตรกรรม และรายได้หลักของเกษตรกร",
    source:
      "คณะเศรษฐศาสตร์ มหาวิทยาลัยศรีนครินทรวิโรฒ. 2553\r\nการวิเคราะห์การเปลี่ยนแปลงการใช้ที่ดินและผลตอบแทนทางการเงินในการลงทุนปลูก\r\nพืชเศรษฐกิจในภาคตะวันออก. พรรณิภา อนุรักษากรกุล,ณรงค์ พลีรักษ์. 19 พฤศจิกายน 2562.https://www.tci-thaijo.org/index.php/econswu/article/download/177671/126492/\r\n",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "พ"
  },
  {
    keyword: "พื้นที่สีเขียว",
    meaning:
      "พื้นที่กลางแจ้ง และกึ่งกลางแจ้งที่มีขอบเขตที่ดินทั้งหมดหรือบางส่วนปกคลุมด้วยพรรณพืชบนดินที่ซึมน้ำได้หรืออาจมีสิ่งก่อสร้างอยู่ด้วย ทั้งในพื้นที่สีเขียวในเขตเมืองและนอกเขตเมือง อาจเป็นพื้นที่สาธารณะหรือเอกชนที่สาธารณชนสามารถเข้าไปใช้ประโยชน์ได้ ประกอบด้วย พื้นที่สีเขียวเพื่อนันทนาการและความงามทางภูมิทัศน์ พื้นที่อรรถประโยชน์ เช่น พื้นที่เกษตรกรรมและพื้นที่สาธารณูปการ พื้นที่แนวกันชน พื้นที่สีเขียวในสถาบันต่างๆ พื้นที่ธรรมชาติและกึ่งธรรมชาติอันเป็นถิ่นที่อยู่ของสิ่งมีชีวิต ได้แก่ พื้นที่ป่าไม้ พื้นที่ชุ่มน้ำ รวมถึงพื้นที่ชายหาด พื้นที่ริมน้ำ พื้นที่ที่เป็นริ้วยาวตามแนวเส้นทางคมนาคมทางบก ทางน้ำ และแนวสาธารณูปการต่างๆ หรือพื้นที่อื่นๆ เช่น พื้นที่สีเขียวที่ปล่อยรกร้าง พื้นที่สีเขียวที่ถูกรบกวนสภาพธรรมชาติ และพื้นที่สีเขียวที่มีการใช้ประโยชน์ผสมผสานกัน",
    source:
      "สำนักงานนโยบายและแผนทรัพยากรธรรมชาติและสิ่งแวดล้อม กระทรวงทรัพยากรธรรมชาติและสิ่งแวดล้อม. (2548). ความหมายของพื้นที่สีเขียว, 26 กันยายน 2562. http://www.onep.go.th/eurban/plant/green_area.php",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "พื้นที่สีเขียวในเขตเมืองและชุมชน",
    meaning:
      "พื้นที่สีเขียวในเมืองและที่โล่งในเขตชุมชน (เทศบาล) ซึ่งมีพืชพรรณเป็นองค์ประกอบหลักได้รับการจัดการตามหลักวิชาวนวัฒนวิทยาและภูมิสถาปัตย์ เพื่อเสริมสร้างภูมิทัศน์ให้เอื้ออำนวยต่อการพักผ่อนหย่อนใจ และทำหน้าที่เป็นปอดของเมืองอย่างยั่งยืน อันจะทำให้ชุมชนเมืองเป็นเมืองสีเขียวที่น่าอยู่ \r\nพื้นที่สีเขียวในเขตชุมชนจะเป็นที่ดินของรัฐ ที่ดินของเอกชน หรือที่ดินประเภทพิเศษ อันได้แก่ ที่ดินทรัพย์สินส่วนพระองค์ ที่ดินศาสนสถานก็ได้ จุดที่สำคัญไม่ได้อยู่ที่ความเป็นเจ้าของ แต่อยู่ที่หน้าที่หลัก ในขณะที่พื้นที่สีเขียวในเขตชุมชนเมือง หมายถึง พื้นที่ในเขตเทศบาล ซึ่งมีพืชพรรณเป็นองค์ประกอบหลัก โดยพื้นที่เหล่านั้นต้องได้รับการจัดการตามหลักวิชาวนวัฒนวิทยาและภูมิสถาปัตย์ ให้เกิดความร่มรื่นสวยงามเพื่อประชาชนจะได้รับประโยชน์ ทั้งโดยทางตรงเพื่อการพักผ่อนหย่อนใจ และ/หรือโดยทางอ้อมเพื่อรักษาสภาพแวดล้อม พื้นที่สีเขียวที่ยั่งยืนควรมีไม้ยืนต้นเป็นองค์ประกอบหลัก",
    source:
      "สำนักสิ่งแวดล้อมชุมชนและพื้นที่เฉพาะ สำนักงานนโยบายและแผนทรัพยากรธรรมชาติและสิ่งแวดล้อม. ฐานข้อมูลพรรณไม้ที่เหมาะสมกับพื้นที่สีเขียวและภูมิภาค, 19 กันยายน 2562. http://www.onep.go.th/eurban/plant/green_area.php",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "พ"
  },
  {
    keyword: "พื้นที่สีเทา (Grey Area)",
    meaning:
      "การยินยอมให้มีการแสวงหาผลประโยชน์ เช่น ประเทศที่พัฒนาหรือหลุดจากกับดักรายได้ปานกลางแล้ว จะมีพื้นที่สีเทาน้อยลงหรือไม่นั้น คือ การจะทำให้ประเทศหลุดจากกับดักรายได้ปานกลาง จะต้อง\r\nทำให้การคอร์รัปชันน้อยลง ขณะเดียวกันการบริหารจัดการประเทศแบบสีเทาก็ไม่ช่วยให้ประเทศชาติเจริญรุ่งเรืองได้ เพราะความมั่นคงและยั่งยืนที่แท้จริงต้องอยู่บนพื้นฐานของคุณธรรมความดี",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. (2556). วารสารเศรษฐกิจและสังคม, 19 กันยายน 2562. https://www.nesdc.go.th/ewt_w3c/ewt_dl_link.php?filename=economic_magazine&nid=4861",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "พ"
  },
  {
    keyword: "พื้นที่อนุรักษ์มรดกทางวัฒนธรรม",
    meaning:
      "อนุสรณ์สถาน: ผลงานสถาปัตยกรรม ผลงานทางประติมากรรม หรือจิตรกรรมที่ใหญ่โต ส่วนประกอบหรือโครงสร้างทางโบราณคดี จารึก ถ้ำ ที่อยู่อาศัย และร่องรอยที่ผสมผสานกันของสิ่งต่างๆข้างต้น ซึ่งมีคุณค่าโดดเด่นในระดับสากลในมิติทางประวัติศาสตร์ ศิลปะ หรือวิทยาศาสตร์ และรวมถึงแหล่งโบราณคดี ซึ่งมีคุณค่าโดดเด่นในระดับสากล ในมิติทางด้านประวัติศาสตร์ สุนทรียศาสตร์ ชาติพันธุ์วิทยา หรือมานุษยวิทยา",
    source:
      "สำนักงานนโยบายและแผนทรัพยากรธรรมชาติและสิ่งแวดล้อม. (2556). ความรู้ด้านการอนุรักษ์คุ้มครองแหล่งมรดกสำหรับเยาวชน, 8 สิงหาคม 2562. http://www.onep.go.th/nced/wp-content/uploads/2016/09/%E0%B9%80%E0%B8%AD%E0%B8%81%E0%B8%AA%E0%B8%B2%E0%B8%A3%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%A3%E0%B8%B9%E0%B9%89%E0%B8%94%E0%B9%89%E0%B8%B2%E0%B8%99%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%AD%E0%B8%99%E0%B8%B8%E0%B8%A3%E0%B8%B1%E0%B8%81%E0%B8%A9%E0%B9%8C%E0%B8%84%E0%B8%B8%E0%B9%89%E0%B8%A1%E0%B8%84%E0%B8%A3%E0%B8%AD%E0%B8%87%E0%B9%81%E0%B8%AB%E0%B8%A5%E0%B9%88%E0%B8%87%E0%B8%A1%E0%B8%A3%E0%B8%94%E0%B8%81%E0%B9%82%E0%B8%A5%E0%B8%81-%E0%B8%AA%E0%B8%B3%E0%B8%AB%E0%B8%A3%E0%B8%B1%E0%B8%9A%E0%B9%80%E0%B8%A2%E0%B8%B2%E0%B8%A7%E0%B8%8A%E0%B8%99.pdf",
    sappear: 2,
    mappear: 6,
    rappear: "",
    firstalpha: "พ"
  },
  {
    keyword: "ฟาร์มอัจฉริยะ",
    meaning:
      "การนำเทคโนโลยีดิจิทัลและวิทยาศาสตร์ในสาขาที่เกี่ยวข้อง (เช่น เทคโนโลยีชีวภาพและเทคโนโลยีนาโน) มาใช้เพื่อพัฒนาการเกษตรให้ครอบคลุมถึงการจัดทำทะเบียนเกษตรกรรายแปลง การทำระบบจัดการและแลกเปลี่ยนความรู้ทางการเกษตรการบริหารจัดการพื้นที่เพาะปลูกและฟาร์มการบริการจัดการระบบน้ำและการใช้น้ำ การวางแผนการผลิต การทำระบบบัญชี การปรับปรุงประสิทธิภาพระบบขนส่งและโลจิสติกส์ ไปจนถึงการพัฒนาผลิตภัณฑ์ที่ได้มาตรฐาน การทำการตลาด และการตรวจสอบย้อนกลับของผลิตภัณฑ์เกษตร เป็นต้น",
    source:
      "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม. (2562). นโยบายและแผนระดับชาติว่าด้วยการพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม, 23 กรกฎาคม 2562. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/047/T_0001.PDF",
    sappear: 2,
    mappear: 3,
    rappear: "",
    firstalpha: "ฟ"
  },
  {
    keyword: "ภัยคุกคาม",
    meaning:
      "ภาวะหรือสถานการณ์ที่ก่อให้เกิดความไม่มั่นคงซึ่งเป็นปัญหาที่มีความรุนแรง สลับซับซ้อน หากไม่ดำเนินการแก้ไขจะเกิดผลกระทบในวงกว้างต่อความมั่นคงแห่งชาติ",
    source:
      "พระราชบัญญัติสภาความมั่นคงแห่งชาติ พ.ศ. 2559. (2559, 26 กันยายน). ราชกิจจานุเบกษา. เล่ม 133 ตอนที่ 85 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2559/A/085/1.PDF",
    sappear: 1,
    mappear: "",
    rappear: "",
    firstalpha: "ภ"
  },
  {
    keyword: "ภัยคุกคามไซเบอร์",
    meaning:
      "การกระทำหรือการดำเนินการใด ๆ โดยมิชอบโดยใช้คอมพิวเตอร์หรือระบบคอมพิวเตอร์หรือโปรแกรมไม่พึงประสงค์โดยมุ่งหมายให้เกิดการประทุษร้ายต่อระบบคอมพิวเตอร์ ข้อมูลคอมพิวเตอร์ หรือข้อมูลอื่นที่เกี่ยวข้อง และเป็นภยันตรายที่ใกล้จะถึงที่จะก่อให้เกิดความเสียหายหรือส่งผลกระทบต่อการทำงานขอคอมพิวเตอร์ ระบบคอมพิวเตอร์ หรือข้อมูลอื่นที่เกี่ยวข้อง",
    source:
      "พระราชบัญญัติการรักษาความมั่นคงปลอดภัยไซเบอร์ พ.ศ. 2562. (2562, 27 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอน 69 ก หน้า 21. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/069/T_0020.PDF",
    sappear: 2,
    mappear: 7,
    rappear: "",
    firstalpha: "ภ"
  },
  {
    keyword: "ภัยคุกคามสุขภาพ",
    meaning:
      "สิ่งต่างๆ ที่มีผลเสียต่อสุขภาพเกิดขึ้นโดย\r\n - โรคติดต่อ เช่น โรคเอดส์ โรคติดเชื้ออื่นๆ เป็นต้น\r\n - โรคเรื้อรังต่างๆ เช่น มะเร็ง ความดันโลหิตสูง เป็นต้น\r\n - ขาดน้ำดื่มที่สะอาดและปลอดภัย\r\n - อากาศเป็นพิษ ทําให้เกิดโรคภัยต่างๆ\r\n - ระบบการให้บริการสุขภาพสําหรับประชาชนโดยเฉพาะผู้ด้อยโอกาส",
    source:
      "กระทรวงการพัฒนาสังคมและความมั่นคงของมนุษย์. (2547). บทที่2 ความมั่นคงด้านสุขภาพ, 1 ตุลาคม 2562. https://www.m-society.go.th/article_attach/2463/2670.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ภ"
  },
  {
    keyword: "ภัยธรรมชาติ",
    meaning:
      "เกิดจากการเปลี่ยนแปลงของธรรมชาติ หรือมนุษย์ได้ทำให้มันเกิดขึ้นมา ภัยธรรมชาติมีหลายรูปแบบแตกต่างกันไปบางอย่างร้ายแรงน้อย บางอย่างร้ายแรงมาก ซึ่งอาจทำให้เกิดผลเสียต่อชีวิตและทรัพย์สิน เช่น การเกิดอุทกภัยหรือน้ำท่วม การเกิดพายุ การเกิดแผ่นดินไหว ภูเขาไฟระเบิด เป็นต้น ซึ่งภัยธรรมชาติต่าง ๆ ไม่ว่าจะร้ายแรงมากหรือน้อยก็เกิดขึ้นได้ทุกเวลาโดยที่มนุษย์ไม่ได้ตั้งตัว",
    source:
      "ศูนย์อุตุนิยมวิทยาภาคเหนือ. (2562) ภัยธรรมชาติ, 20 พฤศจิกายน 2562. http://www.cmmet.tmd.go.th/met/natural_danger.php",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "ภ"
  },
  {
    keyword: "ภัยพิบัติ",
    meaning:
      "สาธารณภัยต่าง ๆ ได้แก่ อัคคีภัย วาตภัย อุทกภัย ภัยแล้ง ภาวะฝนแล้ง ฝนทิ้งช่วง ภัยจากลูกเห็บ ภัยอันเกิดจากไฟป่า ภัยที่เกิดจากโรคหรือการระบาดของแมลงหรือศัตรูพืชทุกชนิด อากาศหนาวจัดผิดปกติ ภัยสงคราม และภัยอันเนื่องมาจากการกระทำของผู้ก่อการร้าย กองกำลังจากนอกประเทศ ตลอดจนภัยอื่นๆ ไม่ว่าเกิดจากธรรมชาติ หรือมีบุคคลหรือสัตว์ทำให้เกิดขึ้น ซึ่งก่อให้เกิดอันตรายแก่ชีวิต ร่างกายของประชาชน หรือก่อให้เกิดความเสียหายแกทรัพย์สินของประชาชน",
    source:
      "ระเบียบกระทรวงการคลังว่าด้วยเงินทดรองราชการเพื่อช่วยเหลือผู้ประสบภัยพิบัติกรณีฉุกเฉิน. (2556). คู่มือการบริหารจัดการการช่วยเหลือผู้ประสบภัยพิบัติด้านการเกษตร, 23 กรกฎาคม 2562. http://www.udonthani.doae.go.th/files/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%8A%E0%B9%88%E0%B8%A7%E0%B8%A2%E0%B9%80%E0%B8%AB%E0%B8%A5%E0%B8%B7%E0%B8%AD%E0%B8%9C%E0%B8%B9%E0%B9%89%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%AA%E0%B8%9A%E0%B8%A0%E0%B8%B1%E0%B8%A2%E0%B8%9E%E0%B8%B4%E0%B8%9A%E0%B8%B1%E0%B8%95%E0%B8%B4.pdf",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "ภ"
  },
  {
    keyword: "ภัยพิบัติทางธรรมชาติ",
    meaning:
      "สาธารณภัยต่าง ๆ ได้แก่ อัคคีภัย วาตภัย อุทกภัย ภัยแล้ง ภาวะฝนแล้ง ฝนทิ้งช่วง ภัยจากลูกเห็บ ภัยอันเกิดจากไฟป่า ภัยที่เกิดจากโรคหรือการระบาดของแมลงหรือศัตรูพืชทุกชนิด อากาศหนาวจัดผิดปกติ ภัยสงคราม และภัยอันเนื่องมาจากการกระทำของผู้ก่อการร้าย กองกำลังจากนอกประเทศ ตลอดจนภัยอื่นๆ ไม่ว่าเกิดจากธรรมชาติ หรือมีบุคคลหรือสัตว์ทำให้เกิดขึ้น ซึ่งก่อให้เกิดอันตรายแก่ชีวิต ร่างกายของประชาชน หรือก่อให้เกิดความเสียหายแกทรัพย์สินของประชาชน",
    source:
      "ระเบียบกระทรวงการคลังว่าด้วยเงินทดรองราชการเพื่อช่วยเหลือผู้ประสบภัยพิบัติกรณีฉุกเฉิน. (2556). คู่มือการบริหารจัดการการช่วยเหลือผู้ประสบภัยพิบัติด้านการเกษตร, 23 กรกฎาคม 2562. http://www.udonthani.doae.go.th/files/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%8A%E0%B9%88%E0%B8%A7%E0%B8%A2%E0%B9%80%E0%B8%AB%E0%B8%A5%E0%B8%B7%E0%B8%AD%E0%B8%9C%E0%B8%B9%E0%B9%89%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%AA%E0%B8%9A%E0%B8%A0%E0%B8%B1%E0%B8%A2%E0%B8%9E%E0%B8%B4%E0%B8%9A%E0%B8%B1%E0%B8%95%E0%B8%B4.pdf",
    sappear: "",
    mappear: 9,
    rappear: "",
    firstalpha: "ภ"
  },
  {
    keyword: "ภาคบริการ",
    meaning:
      "ภาคที่มีบทบาทสำคัญต่อการพัฒนาและรักษาเสถียรภาพทางเศรษฐกิจของประเทศ นอกจากจะเป็นสาขาการผลิตที่สร้างรายได้และสร้างงานให้กับประเทศในสัดส่วนที่สูงแล้ว ยังเป็นองค์ประกอบพื้นฐานในการช่วยสนับสนุนการพัฒนาภาคการผลิตอื่นๆ ของประเทศ และเป็นภาคธุรกิจที่มีบาบาทในการดึงดูดเงินลงทุนจากต่างประเทศเข้ามาปีละหลายแสนล้านบาท โดยเฉพาะธุรกิจบริการด้านการเงิน การขนส่งและสื่อสาร และการค้าส่ง-ค้าปลีก",
    source:
      "สำนักงานสภาพัฒนาการเศรษกิจและสังคมแห่งชาติ. การปรับโครงสร้างภาคบริการ, 21 ตุลาคม 2562. https://www.nesdc.go.th/article_attach/02Service.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ภ"
  },
  {
    keyword: "ภาคประชาสังคม",
    meaning:
      "จัดตั้งขึ้นเป็นเอกเทศจากภาครัฐ และนอกภาคการเมือง โดยเป็นพื้นที่ของกลุ่มคนและผู้กระทำการทางสังคม ซึ่งมีวัฒนธรรมและเศรษฐกิจที่หลากหลายมาร่วมกันแสดงตน เพื่อแลกเปลี่ยนข้อมูลข่าวสารและความคิด นำไปสู่การสร้างเอกลัษณ์ ความผูกพัน และความเชื่อร่วมกัน โดยมีเป้าหมายเพื่อการพิทักษ์ หรือเพิ่มพูนผลประโยชน์ที่เป็นรูปธรรมของกลุ่ม",
    source:
      "สถาบันส่งเสริมภาคประชาสังคม. ความสำคัญและการขับเคลื่อนเพื่อส่งเสริมความเข้มแข็งขององค์กรภาคประชาสังคม, 31 ตุลาคม 2562. http://thaicivilsociety.com/?p=content&id_content=249",
    sappear: 4,
    mappear: "2,12,15",
    rappear: "1,9",
    firstalpha: "ภ"
  },
  {
    keyword: "ภาครัฐแบบเปิดเผยและเชื่อมโยงกัน (Open and Connected Government)",
    meaning:
      "ภาครัฐที่มีความเปิดเผยโปร่งใสในการทำงาน โดยบุคคลภายนอกสามารถเข้าถึงข้อมูลข่าวสารของทางราชการหรือมีการแบ่งปันข้อมูลซึ่งกันและกัน และสามารถเข้ามาตรวจสอบการทำงานได้ตลอดจนเปิดกว้างให้กลไกหรือภาคส่วนอื่น ๆ เช่น ภาคเอกชน\r\nภาคประชาสังคม ได้เข้ามามีส่วนร่วม และโอนถ่ายภารกิจที่ภาครัฐไม่ควรดำเนินการเองออกไปให้แก่ภาคส่วนอื่น ๆ เป็นผู้รับผิดชอบดำเนินการแทน โดยการจัดระเบียบความสัมพันธ์ในเชิงโครงสร้างให้สอดรับกับการทำงานในแนวระนาบ ในลักษณะของเครือข่าย มากกว่าตามสายการบังคับบัญชาในแนวดิ่ง ขณะเดียวกันก็ยังต้องเชื่อมโยงการทำงานภายในภาครัฐด้วยกันเองให้มีเอกภาพและสอดรับประสานกัน ไม่ว่าจะเป็นราชการบริหารส่วนกลาง ส่วนภูมิภาค และส่วนท้องถิ่น",
    source:
      "ระบบราชการ 4.0 ยึดหลักธรรมาภิบาลเพื่อประโยชน์สุขของประชาชน, สำนักงานคณะกรรมการพัฒนาระบบราชการ, 5 สิงหาคม 2562.\r\nhttps://www2.opdc.go.th/uploads/files/2561/Government4.pdf",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "ภ"
  },
  {
    keyword: "ภาคีเครือข่าย",
    meaning:
      "กลุ่มบุคคล องค์กรที่มีเป้าหมายร่วมกัน มารวมตัวกันด้วยความสมัครใจ เพื่อทำกิจกรรมให้บรรลุเป้าหมาย (ร่วมคิด / วางแผน ร่วมทำ ร่วมประเมินผล)  โดยมีความสัมพันธ์แนวราบ มีความเสมอภาค และเรียนรู้ร่วมกันอย่างต่อเนื่อง",
    source:
      "ศูนย์การศึกษานอกระบบและการศึกษาตามอัธยาศัย จังหวัดชัยภูมิ. (2557). การพัฒนาระบบภาคีเครือข่าย, 5 สิงหาคม 2562.\r\nhttp://chaiyaphum.nfe.go.th/1005/index.php?name=knowledge1&file=readknowledge&id=38",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ภ"
  },
  {
    keyword: "ภาคีเครือข่ายพัฒนา",
    meaning:
      "การเชื่อมประสานการทำงานการพัฒนาศักยภาพชุมชนที่มีกลไกในชุมชนและตัวชุมชนเป็นศูนย์กลาง สามารถลดความซ้้าซ้อน เพิ่มความคุ้มค่า ในการทำงานตามภารกิจของแต่ละหน่วยงาน",
    source:
      "สำนักงานพัฒนาชุมชนจังหวัดลำพูน กรมการพัฒนาชุมชน กระทรวงมหาดไทย. (2560). มาตรฐานการพัฒนาชุมชน, 24 ตุลาคม 2562. http://lamphun.cdd.go.th/services/standard",
    sappear: "",
    mappear: 15,
    rappear: "",
    firstalpha: "ภ"
  },
  {
    keyword: "ภาคีการพัฒนา",
    meaning:
      "การประสานการทำงานการพัฒนาศักยภาพชุมชนที่มีกลไกในชุมชนและตัวชุมชนเป็นศูนย์กลาง สามารถลดความซ้้าซ้อน เพิ่มความคุ้มค่า ในการทำงานตามภารกิจของแต่ละหน่วยงาน",
    source:
      "สำนักงานพัฒนาชุมชนจังหวัดลำพูน กรมการพัฒนาชุมชน กระทรวงมหาดไทย. (2560). มาตรฐานการพัฒนาชุมชน (มชช.), 31 ตุลาคม 2562. http://lamphun.cdd.go.th/services/standard",
    sappear: "",
    mappear: "15,17",
    rappear: "",
    firstalpha: "ภ"
  },
  {
    keyword: "ภาพยนตร์",
    meaning:
      "โสตทัศนวัสดุอันประกอบด้วยลำดับของภาพ ซึ่งสามารถนำออกฉายต่อเนื่องได้อย่างภาพยนตร์หรือสามารถบันทึกลงบนวัสดุอื่น เพื่อนำออกฉายต่อเนื่องได้อย่างภาพยนตร์ และให้หมายความรวมถึงเสียงประกอบภาพยนตร์นั้นด้วย \r\n",
    source:
      "พระราชบัญญัติลิขสิทธิ์ พ.ศ. 2537 (2537,21 ธันวาคม) ราชกิจจานุเบกษา.เล่ม 111 ตอนที่ 59 ก  หน้า 3 http://www.ratchakitcha.soc.go.th/DATA/PDF/2537/A/059/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ภ"
  },
  {
    keyword: "ภาระทางการคลัง",
    meaning:
      "ภาระหรือหนี้ที่รัฐบาลจะต้องหรืออาจจะต้องชำระคืนโดยจ่ายจากเงินงบประมาณเมื่อเกิดเหตุการณ์นั้นขึ้น ซึ่งภาระทางการคลังมักจะเป็นสาเหตุส่วนใหญ่ของการเกิดความเสี่ยงทางการคลังและจะมีผลกระทบต่อฐานะทางการคลังของรัฐบาลโดยอาจจะเกิดขึ้นอย่างแน่นอนหรือมีความน่าจะเป็นในการเกิดเหตุการณ์นั้นขึ้น",
    source:
      "สำนักงานเศรษฐกิจการคลัง. หนี้สาธารณะและภาระทางการคลัง, 29 ตุลาคม 2562. http://www2.fpo.go.th/FPO/admin/scripts/getpdf.php?id=2488",
    sappear: 4,
    mappear: "",
    rappear: "",
    firstalpha: "ภ"
  },
  {
    keyword: "ภาระผูกพันด้านงบประมาณ",
    meaning:
      "รายการงบประมาณรายจ่ายที่กำหนดให้ต้องจ่ายเงินงบประมาณรายจ่ายเกินหนึ่งปีงบประมาณขึ้นไปในขณะที่ได้ก่อหนี้ผูกผัน",
    source:
      "สำนักงานเลขาธิการสภาผู้แทนราษฎร. (2559). การวิเคราะห์ภาระผูกพันงบประมาณข้ามปีตามร่างพระราชบัญญัติงบประมาณรายจ่ายประจำปีงบประมาณ พ.ศ. 2560, 29 ตุลาคม 2562. https://www.parliament.go.th/ewtadmin/ewt/parbudget/ewt_dl_link.php?nid=305",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ภ"
  },
  {
    keyword: "ภาวะฉุกเฉิน",
    meaning:
      "ภาวะอันอาจเป็นภัยต่อความมั่นคงหรือความปลอดภัยแห่งราชอาณาจักร หรืออันอาจทำให้ประเทศตกอยู่ในภาวะคับขันหรือภาวการณ์รบหรือการสงคราม\r\n",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ภาวะฉุกเฉิน. 19 สิงหาคม 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ภ"
  },
  {
    keyword: "ภาวะผู้นำ",
    meaning:
      "ภาวะผู้นำสมัยใหม่หรือผู้นำในศตวรรษที่ 2020 จะมีคุณลักษณะที่สำคัญ ประกอบด้วย \r\n1. ต้องรู้จักสร้างความร่วมือและเครือข่าย \r\n2. เน้นการพัฒนาบุคลากรเป็นเป้าหมายสำคัญ โดยให้การวิพากษ์อย่างจริงใจ และนำทางก้าวหน้าในอาชีพและให้โอกาสทางการเรียนรู้ 3. คล่องแคล่วในเรื่องการใช้เทคโนโลยีติดต่อประสานงานกับลูกค้าและบุคลากร \r\n4. สามารถทำงานท่ามกลางวัฒนธรรมที่หลากหลายและรู้จักทำงานร่วมกับองค์กรอื่น ๆ ในลักษณะพึ่งพาซึ่งกันและกัน\r\n5.  รู้จักคาดการณ์อนาคตและสร้างสรรค์สิ่งใหม่ ๆ เพื่อให้เกิดนวัตกรรม",
    source:
      "ปาจิตา ดิศกุล ณ อยุธยา. (2557). ผู้นำและการพัฒนาผู้นำ. หนังสือวิชาการประจำปี 2557 สถาบันพัฒนาข้าราชการพลเรือน สำนักงาน ก.พ. (น. 20-24), 18 พฤศจิกายน 2562.\r\nhttps://www.ocsc.go.th/sites/default/files/document/csti-yearbook-2557-for-web.pdf",
    sappear: 6,
    mappear: "",
    rappear: 2,
    firstalpha: "ภ"
  },
  {
    keyword: "ภาวะผู้นำขององค์กร (Competency and Leadership)",
    meaning:
      "ความตั้งใจหรือความสามารถในการเป็นผู้นําของกลุ่มคน ปกครอง รวมถึงการกําหนดทิศทาง วิสัยทัศน์เป้าหมาย วิธีการทํางาน ให้ผู้ใต้บังคับบัญชาหรือทีมงานปฏิบัติงานได้อย่างราบรื่น เต็มประสิทธิภาพและบรรลุวัตถุประสงค์ขององค์กร",
    source:
      "สถาบันพัฒนาข้าราชการพลเรือน สักนักงาน ก.พ. (2553). หลักสูตรผู้นำทัมที่มีประสิทธิภาพ, 17 ตุลาคม 2562. http://ocsc.chulaonline.net/document/teamleader/Effective_Team_Leader.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ภ"
  },
  {
    keyword: "ภาวะหนี้สิน",
    meaning:
      "คือ ความผูกพันทงกฎหมายระหว่างบุคคลฝ่ายหนึ่ง ซึ่งเรียกว่าเจ้าหนี้ มีความชอบธรรมที่จะบังคับอีกฝ่ายหนึ่ง ซึ่งเรียกว่าลูกหนี้ให้จำต้องส่งมองทรัพย์สินกระทำการ หรืองดเว้นกระทำการอย่าใดอย่างหนึ่ง เพื่อประโยชน์แก่เจ้าหนี้",
    source:
      "ภัทราภรณ์ แก้วจารนัย. (2558). ภาวะหนี้สินของพนักงานจ้างองค์กรปกครองส่วนท้องถิ่น, 18 กรกฎาคม 2562. http://digital_collect.lib.buu.ac.th/dcms/files/56920827.pdf หน้า 8",
    sappear: 4,
    mappear: "",
    rappear: "",
    firstalpha: "ภ"
  },
  {
    keyword: "ภาษีเงินได้",
    meaning:
      'ตามประมวลกฎหมายรัษฎากร ตามมตรา 38 ภาษีเงินได้นี้อยู่ในประเภทภาษีอากรประเมิน และให้เจ้าพนักงานประเมินเป็นผู้ประเมินเกี่ยวกับภาษี และ\r\nมาตรา 39 \r\n"เงินได้พึงประเมิน" หมายความว่า เงินได้อันเข้าลักษณะพึงเสียภาษี ในหมวดนี้ เงินได้ที่กล่าวนี้ให้หมายความรวมตลอดถึงทรัพย์สิน หรือประโยชน์อย่างอื่นที่ได้รับ ซึ่งอาจคิดคำนวณได้เป็นเงินค่าภาษีอากรที่ผู้จ่ายเงินหรือผู้อื่นออกแทนให้สำหรับเงินได้ประเภทต่าง ๆ \r\nโดยภาษีเงินได้ประกอบด้วย ภาษีเงินได้บุคคลธรรมดา ภาษีที่จัดเก็บจากบุคคลทั่วไป หรือจากหน่วยภาษีที่มีลักษณะพิเศษ ตามที่กฎหมายกำหนดและมีรายได้เกิดขึ้นตามเกณฑ์ที่กำหนด โดยปกติจัดเก็บเป็นรายปี รายได้ที่เกิดขึ้นในปีใดๆ ผู้มีรายได้มีหน้าที่ต้องนำไปแสดงรายการตนเองตามแบบแสดงรายการภาษีที่กำหนดภายในเดือนมกราคมถึงมีนาคมของปีถัดไป สำหรับผู้มีเงินได้บางกรณีกฎหมายยังกำหนดให้ยื่นแบบฯ เสียภาษีตอนครึ่งปี สำหรับรายได้ ที่เกิดขึ้นจริงในช่วงครึ่งปีแรก เพื่อเป็นการบรรเทาภาระภาษีที่ต้องชำระและเงินได้บางกรณี กฎหมายกำหนดให้ผู้จ่ายทำหน้าที่หักภาษี ณ ที่จ่ายจากเงินได้ที่จ่ายบางส่วน เพื่อให้มีการทยอยชำระภาษีขณะที่มีเงินได้เกิดขึ้นอีกหรือจากหน่วยภาษีที่มีลักษณะพิเศษ ตามที่กฎหมายกำหนดและมีรายได้เกิดขึ้นตามเกณฑ์ที่กำหนด โดยปกติจัดเก็บเป็นรายปี รายได้ที่เกิดขึ้นในปีใดๆ ผู้มีรายได้มีหน้าที่ต้องนำไปแสดงรายการตนเองตามแบบแสดงรายการภาษีที่กำหนดภายในเดือนมกราคมถึงมีนาคมของปีถัดไป สำหรับผู้มีเงินได้บางกรณีกฎหมายยังกำหนดให้ยื่นแบบฯ เสียภาษีตอนครึ่งปี สำหรับรายได้ ที่เกิดขึ้นจริงในช่วงครึ่งปีแรก เพื่อเป็นการบรรเทาภาระภาษีที่ต้องชำระและเงินได้บางกรณี กฎหมายกำหนดให้ ผู้จ่ายทำหน้าที่หักภาษี ณ ที่จ่ายจากเงินได้ที่จ่ายบางส่วน เพื่อให้มีการทยอยชำระภาษีขณะที่มีเงินได้เกิดขึ้นอีกด้วย\r\n(2) ภาษีเงินได้นิติบุคคล เป็นภาษีอากรประเภทหนึ่งที่บัญญัติไว้ ในประมวลรัษฎากร จัดเก็บจากเงินได้ของบริษัท หรือ ห้างหุ้นส่วนนิติบุคคลมีหลักการจัดเก็บที่สำคัญๆ',
    source:
      "กรมสรรพากร. (2018). ภาษีเงินได้.กฎหมายประมวลรัษฎากร, 6 มิถุนายน 2562. https://www.rd.go.th/publish/38055.0.html",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ภ"
  },
  {
    keyword: "ภาษีเงินได้นิติบุคคล",
    meaning:
      "ภาษีอากรประเภทหนึ่งที่บัญญัติไว้ ในประมวลรัษฎากร จัดเก็บจากเงินได้ของบริษัท หรือ ห้างหุ้นส่วนนิติบุคคลมีหลักการจัดเก็บที่สำคัญๆ โดยลำดับดังนี้                                           \r\n1.  ผู้มีหน้าที่เสียภาษีเงินได้นิติบุคคล    \r\n2.  นิติบุคคลที่ไม่ต้องเสียภาษีเงินได้       \r\n3.  ฐานภาษีของภาษีเงินได้นิติบุคคล    \r\n4. ภาษีเงินได้นิติบุคคลคำนวณจากกำไรสุทธิ                     ",
    source:
      "กรมสรรพากร. (2018). ภาษีเงินได้นิติบุคคล, 6 มิถุนายน 2562. https://www.rd.go.th/publish/308.0.html",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ภ"
  },
  {
    keyword: "ภาษีก้าวหน้า",
    meaning:
      "ฐานภาษียิ่งสูงยิ่งต้องเสียภาษีในอัตราที่สูงขึ้น เช่น ภาษีเงินได้บุคคลธรรมดา ที่มีอัตราภาษีร้อยละ 5-37 โดยเงินได้พึงประเมินยิ่งสูงยิ่งต้องเสียภาษีในอัตราสูง",
    source:
      "สำนักนโยบายการออมและการลงทุน. อัตราภาษีก้าวหน้า, 21 พฤศจิกายน 2562. http://regulationbodyofknowledge.org/wp-content/uploads/2013/04/glossary_THAI.pdf",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ภ"
  },
  {
    keyword: "ภาษีจากความมั่งคั่ง (Comprehensive Property Tax)",
    meaning:
      "จัดเก็บจากสินทรัพย์ ได้แก่ บ้าน, รถ, เรือยอร์ช, เงินฝากธนาคาร, กองทุน, เงินออมในประกันชีวิต, เงินบำนาญ, เงินลงทุนในอสังหาริมทรัพย์, Unincorporated Business, Corporate Stock, หลักประกันทางการเงิน, และ Personal Trust ซึ่งจะก่อให้เกิดอำนาจซื้อต่อไป โดยจะไม่ซ้ำซ้อนกับภาษีเงินได้ที่ได้รับจากสินทรัพย์ที่มีสภาพคล่องสูง เช่น เงินสดจากการทำงาน สินทรัพย์แต่ละประเภทจะมีฐานในการคำนวณภาษี ความมั่งคั่ง ดังนี้\r\n1. สินทรัพย์ประเภท อัญมณี รถยนต์ บ้าน เรือยอร์ช จะคำนวณฐานภาษีจากราคาตลาดหรือราคาซื้อขาย\r\n2. สินทรัพย์ประเภท งานศิลปะ ของสะสม จะคำนวณฐานภาษีจากราคาประเมินตนเอง",
    source:
      "จารุพัสตร์ พลทรัพย์ เศรษฐกรปฏิบัติการ สำนักนโยบายภาษี สำนักงานเศรษฐกิจการคลัง. (2557). ภาษีความมั่งคั่ง, 12 พฤศจิกายน 2562. http://www2.fpo.go.th/FPO/modules/Content/getfile.php?contentfileID=7315",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ภ"
  },
  {
    keyword: "ภาษีผลิตภัณฑ์",
    meaning:
      "เน้นไปที่วัสดุ/ปัจจัยการผลิตที่เป็นโทษต่อสิ่งแวดล้อม ตลอดจนความสามารถในการนำกลับมาใช้ซ้ำผ่านกระบวนการรีไซเคิล เช่น การเก็บภาษีที่ต้นทาง (ผู้ผลิต ผู้นำเข้า) โดยมีวัตถุประสงค์เพื่อให้ผู้ประกอบการเปลี่ยนหรือเลือกใช้ปัจจัยการผลิตที่เป็นมิตรต่อสิ่งแวดล้อมมากยิ่งขึ้น",
    source:
      "นางสาวภารดี นาคสาย เศรษฐกรปฏิบัติการ สำนักนโยบายภาษี สำนักงานเศรษฐกิจการคลัง. (2562). มาตรการทางภาษีกับการแก้ไขปัญหาสิ่งแวดล้อม, 3 ตุลาคม 2562. http://www.fpo.go.th/main/getattachment/General-information-public-service/Tax-Policy-Journal/10446/Tax-Policy-Journal_Jan-2019_Material-Tax_Final.pdf.aspx",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ภ"
  },
  {
    keyword: "ภาษีมูลค่าเพิ่ม",
    meaning:
      "ภาษีที่เก็บจากผู้ขายสินค้าในประเทศ การให้บริการในประเทศ และการนำเข้าสินค้า ผู้ประกอบการที่ขายสินค้าหรือให้บริการในทางธุรกิจหรือวิชาชีพเป็นปกติธุระ ไม่ว่าจะประกอบกิจการในรูปของบุคคลธรรมดา คณะบุคคลหรือห้างหุ้นส่วนสามัญที่มิใช่นิติบุคคล หรือนิติบุคคลใด ๆ หากมีรายรับจากการขายสินค้าหรือให้บริการเกินกว่า 1.8 ล้านบาทต่อปี มีหน้าที่ต้องยื่นคำขอจดทะเบียนภาษีมูลค่าเพิ่ม เพื่อเป็นผู้ประกอบการจดทะเบียน โดยคำนวณภาษีที่ต้องเสียจากภาษีขายหักด้วยภาษีซื้อในแต่ละเดือนภาษี",
    source:
      "กรมสรรพากร. (2561). หน้าที่ทางภาษีของ SMEs, 29 สิงหาคม 2562. http://www.rd.go.th/publish/38055.0.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ภ"
  },
  {
    keyword: "ภาษีอากร",
    meaning:
      "ทรัพยากรที่โอนจากภาคเอกชนแบบบังคับไปสู่ภาครัฐ เพื่อใช้จ่ายในกิจกรรมตามวัตถุประสงค์ของภาครัฐ เน้นประโยชน์ส่วนรวมของประชาชน โดยผู้เสียภาษีไม่จำเป็นต้องได้ประโยชน์ตามจำนวนเงินที่จ่ายประเภทของภาษีอากรแบ่งเป็นภาษีทางตรงและภาษีทางอ้อม ซึ่งกฎหมายที่รัฐบาลใช้ในการเรียกเก็บภาษี คือ ประมวลรัษฎากร\r\n",
    source:
      "ชัยรัตน์ เอี่ยมกุลวัฒน์ เศรษฐศาสตร์สาธารณะ, ความรู้ทั่วไปเกี่ยวกับภาษีอากร .18 พฤศจิกายน 2562. http://pioneer.netserv.chula.ac.th/~achairat/PE09%202017%20Tax%20in%20General.pdf",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ภ"
  },
  {
    keyword: "ภูมิปัญญา",
    meaning: "พื้นความรู้ความสามารถ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ภูมิปัญญา , \r\n5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "3,4",
    mappear: "15,16",
    rappear: 1,
    firstalpha: "ภ"
  },
  {
    keyword: "ภูมิปัญญาท้องถิ่น",
    meaning:
      "ความรู้ที่เกิดจากประสบการณ์ในชีวิตของคนเราผ่านกระบวนการศึกษา สังเกต วิเคราะห์จนเกิดปัญญาและตกผลึกมาเป็นองค์ความรู้ที่ประกอบกันขึ้นมาจากความรู้เฉพาะในหลายเรื่อง ความรู้ดังกล่าวไม่ได้แยกย่อยออกมาให้เห็นเป็นศาสตร์เฉพาะสาขาวิชาต่างๆ อาจกล่าวว่า ภูมิปัญญาท้องถิ่นจัดเป็นพื้นฐานขององค์ความรู้สมัยใหม่ที่ช่วยในการเรียนรู้ การแก้ปัญหา การจัดการและการปรับตัวในการดำเนินชีวิตของคนเรา",
    source:
      "ความหมายของภูมิปัญญาท้องถิ่น กรมวิชาการ. ภูมิปัญญาท้องถิ่น, (2538) . http://rdi.nsru.ac.th/knowledge/meaning.php",
    sappear: "4,5",
    mappear: 18,
    rappear: "",
    firstalpha: "ภ"
  },
  {
    keyword: "ภูมิภาคเอเชียแปซิฟิก",
    meaning:
      "1. เอเชียตะวันออกเฉียงเหนือ (5 ประเทศ) ได้แก่ จีน ญี่ปุ่น เกาหลีใต้ มองโกเลีย และรัสเซีย\r\n2. เอเชียตะวันออกเฉียงใต้ (8 ประเทศ) ได้แก่ กัมพูชา อินโดนีเซีย ลาว มาเลเซีย ฟิลิปปินส์ สิงคโปร์ ไทย และเวียดนาม\r\n3. โอเชียเนีย/หมู่เกาะต่าง ๆ ในมหาสมุทรแปซิฟิกตอนกลาง ตะวันตก และตอนใต้ (6 ประเทศ) ได้แก่ ออสเตรเลีย ฟิจิ ไมโครนีเซีย นิวซีแลนด์ ปาปัวนิวกินี และหมู่เกาะมาร์แชลล์\r\n4. อเมริกา (8 ประเทศ) ได้แก่ แคนาดา ชิลี โคลัมเบีย เม็กซิโก เปรู สหรัฐอเมริกา เอกวาดอร์ และคอสตาริก้า",
    source:
      "สำนักงานเลขาธิการสภาผู้แทนราษฎร. การประชุมรัฐสภาภาคพื้นเอเชียและแปซิฟิก (Asia Pacific Parliamentary Forum - APPF), 20 กันยายน 2562. https://www.parliament.go.th/ewtadmin/ewt/parliament_parcy/ewt_news.php?nid=35259&filename",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ภ"
  },
  {
    keyword: "ภูมิภาคเอเชียตะวันออกเฉียงใต้",
    meaning:
      "พื้นที่ตั้งอยู่ละติจูดที่ 10 องศาใต้ ถึงละติจูดที่ 28  องศาเหนือ และระหว่างลองติจูดที่ 92 - 140 ตะวันออก หรืออยู่ระหว่าง เอเชียตะวันออกกับเอเชียใต้ มีเนื้อที่ 4.5 ล้าน ตร.กม. มีประชากร 440  ล้านคน (พ.ศ.2533) ประกอบด้วยดินแดนที่เป็นคาบสมุทรอินโดจีน และหมู่เกาะ ในมหาสมุทรอินเดียและแปซิฟิค ประกอบด้วย 11 ประเทศคือ ไทย พม่า ลาว  กัมพูชา เวียดนาม มาเลเซีย สิงคโปร์ อินโดนีเซีย ฟิลิปปินส์ ติมอร์เลสเต และบรูไน",
    source:
      "สำนักความร่วมมือระหว่างประเทศและวิเทศสัมพันธ์. เอเชียตะวันออกเฉียงใต้, 6 มิถุนายน 2562. http://www.oic.ops.go.th/index.php/2014-05-08-02-35-50/2016-10-10-09-56-12/2016-11-14-02-54-30",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ภ"
  },
  {
    keyword: "ภูมิรัฐศาสตร์",
    meaning:
      "รัฐประกอบขึ้นมาด้วยองค์ประกอบสองประการ คือ ประชากรและแผ่นดิน ดังนั้นแล้ว รัฐจึงเปรียบเสมือนสิ่งมีชีวิต (Organic State) คือ รัฐนั้นสามารถที่จะเจริญเติบโตได้ดังเช่นสิ่งมีชีวิตอื่น ๆ ดังนั้นแล้ว พรมแดนของรัฐจึงสามารถเปลี่ยนแปลงได้ตลอดเวลา ขึ้นอยู่กับการเติบโตของรัฐ ในการนี้รัฐใดที่มีอำนาจที่เข้มแข็งก็จะใช้กำลัง (กองทัพ) รุกรานรัฐอื่นเพื่อปรับปรุงอาณาเขตดินแดนของตน",
    source:
      "วิทยาลัยป้องกันราชอาณาจักร สถาบันวิชาการป้องกันประเทศ. (2561). การใช้ภูมิรัฐศาสตร์ช่วยในการกำหนดยุทธศาสตร์ชาติ, 4 ตุลาคม 2562. http://www.thaindc.org/images/pulldown_1485785805/2NDC_SR_February_2018-reduce.pdf",
    sappear: 5,
    mappear: 1,
    rappear: "5,10",
    firstalpha: "ภ"
  },
  {
    keyword: "ภูมิสถาปัตยกรรม",
    meaning:
      "เกี่ยวข้องกับธรรมชาติ นิเวศวิทยา คุณภาพของสิ่งแวดล้อมที่มองเห็นได้ด้วยตา และเกี่ยวข้องกับทั้งคน สัตว์และพืชพรรณที่ใช้สอยหรือขึ้นอยู่ในพื้นที่นั้นๆ\r\nลักษณะของงานภูมิสถาปัตยกรรมประเภทต่างๆ เรียงลำดับจากงานขนาดใหญ่ไปหางานขนาดเล็ก โดยสังเขป ดังนี้\r\n1. งานวิเคราะห์ภูมิทัศน์และทรัพยากรภาค คือ การวิเคราะห์พื้นที่ขนาดใหญ่ที่ใช้พื้นที่ลุ่มน้ำ เช่น ลุ่มน้ำเจ้าพระยา หรือลุ่มน้ำ ที่มีขนาดเล็กลง ไม่ใช้เขตการปกครอง\r\n2. งานผังเมือง ผังชุมชน และเคหการ\r\n3. งานวางผังและออกแบบบริเวณวิทยาเขตและนิคมอุตสาหกรรม \r\n4. งานออกแบบสวนสาธารณะ สนามกีฬา และสนามเด็กเล่น\r\n5. งานปรับปรุงภูมิทัศน์เมือง\r\n6. งานออกแบบและวางแผนภูมิทัศน์ ทางหลวงและถนนในเมือง\r\n7. งานอนุรักษ์ธรรมชาติ ศิลปกรรม และสถานที่สำคัญทางประวัติศาสตร์\r\n8. งานตกแต่งสวนและออกแบบปลูกต้นไม้ (Planting design) \r\n9. งานออกแบบภูมิทัศน์สวนหลังคาหรือดาดฟ้า\r\n10. งานออกแบบสวนภายในอาคาร (Interior landscape)",
    source:
      "สารานุกรมไทยสำหรับเยาวชน. ประเภทของงานภูมิสถาปัตยกรรม, 4 ตุลาคม 2562. http://kanchanapisek.or.th/kp6/sub/book/book.php?book=39&chap=4&page=t39-4-infodetail04.html",
    sappear: 5,
    mappear: 19,
    rappear: "",
    firstalpha: "ภ"
  },
  {
    keyword: "ภูมิสังคม",
    meaning:
      "สภาพทางกายภาพ ลักษณะของพื้นที่ วิถีชีวิต ค่านิยม ความหลากหลายของวัฒนธรรม ประเพณี ที่อยู่รอบๆท้องถิ่นที่อยู่อาศัยนั้นๆ ซึ่งมีความแตกต่างกันไปในแต่ละแห่ง ตามภูมิประเทศ โดยการพัฒนาหนึ่งๆในท้องถิ่นนั้นๆต้องคำนึงเสมอ",
    source:
      "มนูญ มุกข์ประดิษฐ์ กรรมการและรองเลขาธิการมูลนิธิชัยพัฒนา อดีตเลขาธิการ กปร. ภูมิสังคมกับแนวพระราชดำริ, 4 ตุลาคม 2562. http://61.19.50.68/dsdw/buzzfile/20160615174950-517.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ภ"
  },
  {
    keyword: "ภูมิสารสนเทศ",
    meaning:
      "เทคโนโลยีสารสนเทศเพื่อบูรณาการเทคโนโลยีด้านการสำรวจการทำแผนที่ และการวิเคราะห์ข้อมูลทางพื้นที่เข้าด้วยกัน เพื่อศึกษาเกี่ยวกับโลก ได้แก่ ระบบกำหนดตำแหน่งบนพื้นโลก ระบบการรับรู้จากระยะไกล และระบบสารสนเทศภูมิศาสตร์",
    source:
      "พระราชกฤษฎีกาจัดตั้งสำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ(องค์การมหาชน) (ฉบับที่ 2) พ.ศ. 2562 (2562, 31 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 72 ก หน้า 104.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/072/T_0103.PDF",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ภ"
  },
  {
    keyword: "มนุษยธรรม",
    meaning: "ธรรมของคน, ธรรมที่มนุษย์พึงมีต่อกัน มีเมตตากรุณาเป็นต้น",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. มนุษยธรรม. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 1,
    rappear: 1,
    firstalpha: "ม"
  },
  {
    keyword: "มรดกโลก",
    meaning:
      "สถานที่ อันได้แก่ ป่าไม้ ภูเขา ทะเลสาบ ทะเลทราย อนุสาวรีย์ สิ่งก่อสร้างต่างๆ รวมไปถึงเมือง ซึ่งคัดเลือกโดยองค์การยูเนสโกตั้งแต่ปี พ.ศ. 2515 เพื่อเป็นการบ่งบอกถึงคุณค่าของสิ่งที่มนุษยชาติ หรือธรรมชาติได้สร้างขึ้นมา และควรจะปกป้องสิ่งเหล่านั้นได้อย่างไร เพื่อให้ได้ตกทอดไปถึงอนาคต\r\n",
    source:
      "หอสมุดแห่งชาติรัชมังคลาภิเษก จันทบุรี. (2558). มรดกโลก, 19 มิถุนายน 2562. http://www.finearts.go.th/chantaburilibrary/parameters/km/item/%E0%B8%A1%E0%B8%A3%E0%B8%94%E0%B8%81%E0%B9%82%E0%B8%A5%E0%B8%81.html",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "มรดกทางวัฒนธรรม",
    meaning:
      "อนุสรณ์สถาน กลุ่มอาคารและสถานที่ ซึ่งมีคุณค่าทางประวัติศาสตร์ สุนทรียภาพ โบราณคดี วิทยาศาสตร์ ชาติพันธุ์วิทยา หรือมานุษยวิทยา ไม่ว่าจะเป็นงานทางด้านสถาปัตยกรรม ประติมากรรม จิตรกรรม หรือแหล่งโบราณคดีทางธรรมชาติ เช่น ถ้ำ หรือสถานที่สำคัญที่อาจเป็นผลงานจากฝีมือมนุษย์หรือเป็นผลงานร่วมกันระหว่างธรรมชาติและมนุษย์",
    source:
      "รองศาสตราจารย์มานพ พราหมณโชติ. คำจำกัดความ มรดกทางวัฒนธรรม, 19 มิถุนายน 2562. http://www.info.ru.ac.th/province/Sukhotai/world3.htm",
    sappear: "",
    mappear: 15,
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "มลพิษ",
    meaning: "พิษเกิดจากความมัวหมองหรือความสกปรก",
    source:
      "สำนักงานราชบัณฑิตยสภา. มลพิษ , 18 พฤศจิกายน 2562. http://www.royin.go.th/?knowledges=pollution-%E0%B8%A1%E0%B8%A5%E0%B8%A0%E0%B8%B2%E0%B8%A7%E0%B8%B0-%E0%B8%AB%E0%B8%A3%E0%B8%B7%E0%B8%AD-%E0%B8%A1%E0%B8%A5%E0%B8%9E%E0%B8%B4%E0%B8%A9",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ม"
  },
  {
    keyword: "มหภาค ",
    meaning:
      "การศึกษากิจกรรมทางเศรษฐกิจในภาพรวมหรือระดับประเทศ เช่น รายได้ประชาชาติ การบริโภค การออม การลงทุน ภาวะการจ้างงานของประเทศ การเงินและการคลังของประเทศ การค้าระหว่างประเทศ อัตราดอกเบี้ย ",
    source:
      "ธนาคารแห่งประเทศไทย.เศรษฐศาสตร์เล่มเดียวอยู่.https://www.bot.or.th/Thai/ResearchAndPublications/Doc_Publication/Book_Economic2555.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ม"
  },
  {
    keyword: "มหาอำนาจ",
    meaning:
      "เรียกประเทศที่มีพลังทางด้านเศรษฐกิจหรือทางทหารสูง ว่า ประเทศมหาอำนาจ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. มหาอำนาจ. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ม"
  },
  {
    keyword: "มัธยัสถ์",
    meaning: "ใช้จ่ายอย่างประหยัด",
    source:
      "พจนานุกรม ฉบับราชบัณฑิตยสถาน พ.ศ. 2554. มัธยัสถ์ , 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "มาตรการคุ้มครองพยานและผู้ที่เกี่ยวข้อง",
    meaning:
      "การกำหนดวิธีการคุ้มครองความปลอดภัยแก่พยานให้สำนักงานดำเนินการอย่างหนึ่งอย่างใดดังต่อไปนี้\r\n (1) สั่งการให้พนักงานเจ้าหน้าที่ดำเนินการคุ้มครองความปลอดภัย โดยกำหนดให้พนักงานเจ้าหน้าที่คนหนึ่งเป็นหัวหน้าชุดและพนักงานเจ้าหน้าที่อื่นเป็นชุดคุ้มครองความปลอดภัย\r\n(2) จัดทำคำสั่งแต่งตั้งชุดคุ้มครองความปลอดภัย ตามแบบแนบท้ายระเบียบนี้ (แบบ สคพ.๗ และ สคพ. ๗/๑)\r\n(3) จัดพนักงานเจ้าหน้าที่ ที่เป็นสุภาพสตรีปฏิบัติหน้าที่เป็นชุดคุ้มครองความปลอดภัยแก่สตรีหรือเด็ก\r\n(4) จัดให้พยานอยู่ในสถานที่ที่ปลอดภัยตามที่สำนักงานเห็นสมควรและเหมาะสม\r\n(5) ปกปิดมิให้มีการเปิดเผยถึงการคุ้มครอง รวมทั้งชื่อตัว ชื่อสกุล ที่อยู่ ภาพ หรือข้อมูลอย่างอื่นที่สามารถระบุตัวพยานได้ตามความเหมาะสมแก่สถานะและสภาพของพยานและลักษณะของคดีอาญาที่เกี่ยวข้อง\r\n(6) สำนักงานอาจนำมาตรการการคุ้มครองความปลอดภัยตามกฎหมายอื่นมาดำเนินการอย่างหนึ่งอย่างใด เช่น การสืบพยานล่วงหน้า การยื่นคำร้องขอคัดค้านการปล่อยตัวชั่วคราว การประสานส่งกลับภูมิลำเนา หรือสิทธิประโยชน์อื่นใดของพยาน เป็นต้น เพื่ออำนวยความสะดวกและความปลอดภัยแก่พยาน\r\n(7) สำนักงานอาจจัดกิจกรรมอย่างหนึ่งอย่างใดตามความเหมาะสม เพื่อลดภาวะตึงเครียด ความวิตกกังวลของพยาน",
    source:
      "ประชาพิจารณ์กฎหมายไทย. ร่างระเบียบกรมคุ้มครองสิทธิและเสรีภาพ ว่าด้วยการคุ้มครองความปลอดภัยแก่พยานในคดีอาญา ตามมาตรการทั่วไป พ.ศ. 2561, 29 ตุลาคม 2562. http://www.lawamendment.go.th/index.php/laws-department/item/1228-2018-04-03-03-17-47",
    sappear: "",
    mappear: 21,
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "มาตรการจูงใจทางภาษี",
    meaning:
      "หรือมาตรการภาษีเป็นเครื่องมือสำคัญของรัฐในการส่งเสริมให้เกิดกิจกรรมทางเศรษฐกิจ โดยเฉพาะการลงทุนหรือทำโครงการในเรื่องที่รัฐต้องการสนับสนุน ซึ่งการลงทุนเกิดขึ้นได้ทั้งจากเงินลงทุนในประเทศ และเกิดขึ้นจากเงินลงทุนต่างประเทศ",
    source:
      "เวทางค์ พ่วงทรัพย์ ผู้เชี่ยวชาญด้านดุลยภาพการออมและการลงทุน สำนักงานเศรษฐกิจการคลัง. (2559). การวิเคราะห์ผลสัมฤทธิมาตรการภาษีเพื่อส่งเสริมการส่งออกบริการ, 17 ตุลาคม 2562. http://www.mfa.go.th/dvifa/contents/filemanager/files/nbt/nbt8/IS/8012.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ม"
  },
  {
    keyword: "มาตรการทางภาษี",
    meaning:
      "มาตรการเพื่อเสริมสร้างการแข่งขันให้กับภาคเอกชนซึ่งเป็นกลไกสำคัญในการผลักดันระบบเศรษฐกิจของประเทศเจริญเติบโตต่อไแได้ นอกจากเป็นการเสริมสร้างการแข่งขันให้กับประเทศแล้วกรมสรรพากรยังมีมาตราการภาษีเพื่อลดการเหลื่อมล้ำทางสังคม ช่วยเหลือชุมชน และสิ่งแวดล้อมอย่างต่อเนื่อง เพื่อให้ทุกภาคส่วนได้มีโอกาสอย่างเท่าเทียมกัน",
    source:
      "สำนักวิชาการแผนภาษี กรมสรรพากร. มาตรการภาษีน่ารู้, 12 พฤศจิกายน 2562. http://www.rd.go.th/phichit/fileadmin/document/datacenter/TaxMeasurements.pdf",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "มาตรการบริษัทจัดการพลังงาน (ESCO)",
    meaning:
      "ธุรกิจที่ให้บริการในด้านการอนุรักษ์พลังงาน และ/หรือพลังงานทดแทน ที่ให้บริการครบวงจร โดยการบริการจะครอบคลุมถึงการให้คำปรึกษา การเสนอโครงการ การบริหารโครงการ การออกแบบทางวิศวกรรม วิเคราะห์การใช้พลังงาน ติดตั้งอุปกรณ์ และดำเนินงานสำหรับโครงการอนุรักษพลังงานและ/หรือพลังงานทดแทน การจัดหาแหล่งเงินทุน สำหรับโครงการด้านพลังงาน ",
    source:
      "สถาบันพลังงานเพื่ออุตสาหกรรม สภาอุตสาหกรรมแห่งประเทศไทย. การอนุรักษ์พลังงานด้วยบริษัทจัดการพลังงาน (Energy Service Company : ESCO), 10 กันยายน 2562. file:///C:/Users/admin/Downloads/12.%E0%B8%9A%E0%B8%A3%E0%B8%B4%E0%B8%A9%E0%B8%B1%E0%B8%97%E0%B8%88%E0%B8%B1%E0%B8%94%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%9E%E0%B8%A5%E0%B8%B1%E0%B8%87%E0%B8%87%E0%B8%B2%E0%B8%99%20(ESCO)%20Re.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ม"
  },
  {
    keyword: "มาตรการราคาพิเศษ (Feed-in Tariff : FiT)",
    meaning:
      "มาตรการส่งเสริมการรับซื้อไฟฟ้าจากพลังงานหมุนเวียนประเภทหนึ่งที่ใช้กันอย่างแพร่หลายในต่างประเทศ เพื่อจูงใจให้ผู้ประกอบการเอกชนเข้ามาลงทุนในธุรกิจโรงไฟฟ้าพลังงานหมุนเวียน (เนื่องจาก การผลิตไฟฟ้าจากพลังงานหมุนเวียนมีต้นทุนค่อนข้างสูง) ซึ่งอัตรา FiT จะอยู่ในรูปแบบอัตรารับซื้อไฟฟ้าคงที่ตลอดอายุโครงการ (มีการปรับเพิ่มสำหรับกลุ่มที่มีการใช้เชื้อเพลิง) โดยอัตรา FiT จะไม่เปลี่ยนแปลงไปตามค่าไฟฐานและค่า Ft ทำให้มีราคาที่ชัดเจนและเกิดความเป็นธรรม",
    source:
      "สำนักงานนโยบายและแผนพลังงาน (สนพ.) กระทรวงพลังงาน. (2559). นโยบายการรับซื้อไฟฟ้าจากพลังงานหมุนเวียน, 19 กรกฎาคม 2562. http://www.eppo.go.th/index.php/th/electricity/plan-buy-renewenergy",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ม"
  },
  {
    keyword: "มาตรการส่วนเพิ่มค่าไฟฟ้า (Adder)",
    meaning:
      "ส่วนเพิ่มจากราคาการรับซื้อไฟฟ้าขายส่ง เพื่อจูงใจให้เกิดการลงทุนจากภาคเอกชนในการสร้างโรงไฟฟ้าพลังงานหมุนเวียน",
    source:
      "การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย. (2561). คำศัพท์พลังงานไฟฟ้า, 16 ตุลาคม 2562. https://www.egat.co.th/index.php?option=com_kdglossary&view=glossary&category=3",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ม"
  },
  {
    keyword: "มาตรฐาน ILO",
    meaning:
      "องค์การแรงงานระหว่างประเทศกำหนดมาตรฐานแรงงานระหว่างประเทศ (International Labour Organization : ILO) ไว้หลายรูปแบบ ทั้งรูปแบบที่มีสภาพบังคับ และรูปแบบที่เป็นแนวทางซึ่งไม่มีสภาพบังคับ เรียกโดยรวมว่า ตราสาร (Instruments) ซึ่งตราสารทุกฉบับของ ILO ได้ผ่านการพิจารณาและรับรองในระบบไตรภาคีแล้ว โดยคณะกรรมการพิเศษเฉพาะด้านต่าง ๆ หรือโดยที่ประชุมใหญ่แรงงานระหว่างประเทศ",
    source:
      "อังคณา เตชะโกเมนท์ สำนักพัฒนามาตรฐานแรงงาน. ข้อมูลเบื้องต้นเกี่ยวกับองค์การแรงงานระหว่างประเทศ (International Labour Organization : ILO), 25 มิถุนายน 2562. http://www.mol.go.th/content/page/%E0%B8%82%E0%B9%89%E0%B8%AD%E0%B8%A1%E0%B8%B9%E0%B8%A5%E0%B9%80%E0%B8%9A%E0%B8%B7%E0%B9%89%E0%B8%AD%E0%B8%87%E0%B8%95%E0%B9%89%E0%B8%99%E0%B9%80%E0%B8%81%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%A7%E0%B8%81%E0%B8%B1%E0%B8%9A-ilo",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ม"
  },
  {
    keyword: "มาตรฐานเกษตรอินทรีย์",
    meaning:
      "มาตรฐานที่จัดทำขึ้นโดยคณะอนุกรรมการมาตรฐานของสำนักมาตรฐานเกษตรอินทรีย์ (มกท.) ตามแนวทางมาตรฐานเกษตรอินทรีย์ขั้นพื้นฐานของสหพันธ์เกษตรอินทรีย์นานาชาติ (International Federation of Oganic Agriculture Movements หรือ IFOAM) ซึ่ง มกท. มีมาตรฐานครอบคลุมในเรื่องการผลิตพืชอินทรีย์ การปฏิบัติหลังการเก็บเกี่ยวและการแปรรูปผลิตภัณฑ์อินทรีย์ การเก็บผลิตผลจากธรรมชาติ การผลิตปัจจัยการผลิตเพื่อการค้า การเพาะเลี้ยงสัตว์น้ำอินทรีย์ รายการอาหารอินทรีย์ การเลี้ยงสัตว์ และการเลี้ยงผึ้ง ซึ่งทำให้ มกท. สามารถให้บริการตรวจสอบและรับรองผลิตภัณฑ์อินทรีย์ได้ในทุกขั้นตอน ตั้งแต่การผลิตในระดับฟาร์มการนำผลิตผลจากฟาร์มมาแปรรูปในโรงงาน และจำหน่ายเป็นผลิตภัณฑ์แปรรูป",
    source:
      "สำนักมาตรฐานเกษตรอินทรีย์ (มกท.). (2560). มาตรฐานเกษตรอินทรีย์ มกท., 6 สิงหาคม 2562. http://actorganic-cert.or.th/wp-content/uploads/2017/10/act_standards_2016_v4_revision24-02-17.pdf",
    sappear: 2,
    mappear: 3,
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "มาตรฐานการวิจัย",
    meaning:
      "ข้อกำหนดเกี่ยวกับคุณลักษณะและคุณภาพที่พึงประสงค์\r\nของการวิจัยและนวัตกรรมที่ต้องการให้เกิดขึ้นในทุกกระบวนการของการวิจัยและนวัตกรรมอย่างเป็นระบบและสอดคล้องกับมาตรฐานสากล ทั้งนี้ รวมถึงจริยธรรมที่นักวิจัยพึงปฏิบัติด้วย",
    source:
      "พระราชบัญญัติการส่งเสริมวิทยาศาสตร์ การวิจัยและนวัตกรรม พ.ศ. 2562. (2562, 25 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 68 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/068/T_0001.PDF",
    sappear: "",
    mappear: 23,
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "มาตรฐานการศึกษา",
    meaning:
      "ข้อกำหนดเกี่ยวกับคุณลักษณะ คุณภาพ ที่พึงประสงค์\r\nและมาตรฐานที่ต้องการให้เกิดขึ้นในสถานศึกษาทุกแห่ง และเพื่อใช้เป็นหลักในการเทียบเคียงสำหรับ\r\nการส่งเสริมและกำกับดูแล การตรวจสอบ การประเมินผลและการประกันคุณภาพทางการศึกษา",
    source:
      "พระราชบัญญัติการศึกษาแห่งชาติ พ.ศ. 2542. (2542, 19 สิงหาคม). ราชกิจจานุเบกษา เล่ม 113 ตอนที่ 74 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/074/1.PDF   ",
    sappear: "",
    mappear: "",
    rappear: 12,
    firstalpha: "ม"
  },
  {
    keyword: "มาตรฐานทางจริยธรรม",
    meaning:
      "1. ยึดมั่นในสถาบันหลักของประเทศอันได้แก่ ชาติ ศาสนา พระมหากษัตริย์ และการปกครองระบอบประชาธิปไตยอันมีพระมหากษัตริย์ทรงเป็นประมุข\r\n2. ซื่อสัตย์สุจริต มีจิตสำนึกที่ดีและความรับผิดชอบต่อหน้าที่\r\n3. ยืนหยัดในสิ่งที่ถูกต้องชอบธรรม \r\n4. ยึดถือประโยชน์ส่วนรวมเป็นที่ตั้ง และมีจิตสาธารณะ \r\n5. มุ่งผลสัมฤทธิ์ของงาน\r\n6. ไม่เลือกปฏิบัติโดยไม่เป็นธรรม \r\n7. ดำรงตนเป็นแบบอย่างที่ดีและรักษาภาพลักษณ์ของทางราชการ",
    source:
      "สำนักงาน ก.พ. มาตรฐานทางจริยธรรมตามรัฐธรรมนูญแห่งราชอาณาจักรไทย (ฉบับพุทธศักราช 2540 – ฉบับพุทธศักราช 2560), 17 ตุลาคม 2562. https://www.ocsc.go.th/sites/default/files/attachment/article/maatrthaanthaangcchriythrrm.pdf\r\n",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ม"
  },
  {
    keyword: "มาตรฐานสิ่งแวดล้อม",
    meaning:
      "ค่ามาตรฐานคุณภาพน้ำ อากาศ เสียงและสภาวะอื่น ๆ ของสิ่งแวดล้อม ซึ่งกำหนดเป็นเกณฑ์ทั่วไปสำหรับการส่งเสริมและรักษาคุณภาพสิ่งแวดล้อม",
    source:
      "กรมควบคุมมลพิษ.บัญชีรายชื่อคำศัพท์, 18 กันยายน 2562. http://www.pcd.go.th/info_serv/QandA/defaultThai.cfm?task=listVocab",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "มาตรฐานสินค้า",
    meaning:
      "คุณภาพ ชั้น ประเภท หรือชนิดของสินค้ามาตรฐานที่กำหนดขึ้นโดยใช้ปริมาณ หน่วย น้ำหนัก ปริมาตร ขนาด ส่วนผสม ส่วนประกอบ ส่วนสัด สี ตัวอย่าง และอื่น ๆ ทั้งนี้แต่อย่างใดอย่างหนึ่งหรือหลายอย่างเป็นเกณฑ์รวมตลอดถึงวิธีการบรรจุ หุ้มห่อ หรือผูกมัด และวัตถุที่ใช้ในการนั้นด้วย",
    source:
      "พระราชบัญญัติมาตรฐานสินค้าขาออก (ฉบับที่ 2)  พ.ศ. 2522. (2522, 9 พฤษภาคม). ราชกิจจานุเบกษา. เล่มที่ 96 ตอนที่ 74 หน้า 15.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2522/A/074/14.PDF ",
    sappear: "",
    mappear: 3,
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "มาตรวิทยา",
    meaning:
      "ศาสตร์เกี่ยวกับการวัดปริมาณและการประยุกต์ใช้ศาสตร์นั้น และให้หมายความรวมถึงกิจกรรมทางวิทยาศาสตร์ที่เกี่ยวกับการสอบเทียบ ปรับตั้งความถูกต้องของเครื่องมือและอุปกรณ์ที่ใช้ในการวัดปริมาณหรือวิเคราะห์ทดสอบ",
    source:
      "พระราชบัญญัติพัฒนาระบบมาตรวิทยาแห่งชาติ (ฉบับที่ 2) พ.ศ. 2559. (2559, 5 สิงหาคม). ราชกิจจานุเบกษา. เล่ม 133 ตอนที่ 67 ก หน้า 51. http://www.ratchakitcha.soc.go.th/DATA/PDF/2559/A/067/51.PDF",
    sappear: "",
    mappear: 8,
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "มิติด้านโอกาสของดัชนีชี้วัดความก้าวหน้าทางสังคม",
    meaning:
      "ดัชนีชี้วัดความก้าวหน้าทางสังคม (Social Progress Index) เป็นกรอบในการวัดผลการพัฒนาประเทศด้านเศรษฐกิจ ด้านสังคมและด้านสิ่งแวดล้อม โดยดำเนินการประมวลผลดัชนีชี้วัดความก้าวหน้าทางสังคมเป็นประจำทุกปี และมีการนำเสนอข้อมูลเป็นรายประเทศ จำนวน 133 ประเทศ ประกอบด้วย 3 มิติหลัก ได้แก่ (1) ความต้องการพื้นฐานของมนุษย์ (2) พื้นฐานคุณภาพชีวิตที่ดี และ (3) โอกาส \r\nซึ่งมิติด้านโอกาส ประกอบด้วย 4 องค์ประกอบ ได้แก่ (1) สิทธิส่วนบุคคล (2) อิสรภาพและการมีทางเลือก (3) การเปิดรับความแตกต่าง และ (4) การเข้าถึงการศึกษาขั้นสูง",
    source:
      "Social Progress Imperative. Methodology, 15 พฤศจิกายน 2562. https://www.socialprogress.org/index/global/methodology",
    sappear: "",
    mappear: 15,
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "มูลค่าเพิ่มทางเศรษฐกิจอย่างทวีคูณ (Economic Multiplier)",
    meaning:
      "การดึงดูดเศรษฐกิจออกจากภาวะถดถอยด้วยการกระตุ้นปัจจัยทางอุปสงค์ เพื่อให้เกิดกำลังซื้อของประชาชน อันจะนำไปสู่กิจกรรมต่อเนื่องทางเศรษฐกิจอื่นๆ เช่น การจ้างงาน หรือการลงทุนเพื่อเพิ่มกำลังการผลิต",
    source:
      "อานันท์ เกียรติสารพิภพ นิติกรชำนาญการ สำนักวิชาการ. (2560). Multiplier Effect นโยบายยอดนิยมในการกระตุ้นเศรษฐกิจ, 8 ตุลาคม 2562. https://library2.parliament.go.th/ebook/content-issue/2560/hi2560-001.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ม"
  },
  {
    keyword: "มูลค่าของ FDI",
    meaning:
      "การลงทุนโดยตรงจากต่างประเทศ (Foreign Direct Investment: FDI) มูลค่า FDI คาดการณ์อยู่บนพื้นฐานของการขยายตัวทางเศรษฐกิจของภูมิภาคหลัก ผลประกอบการที่ดีของตลาดหุ้น และการปรับตัวสูงขึ้นของปริมาณการค้าโลกซึ่งภาพรวมทางเศรษฐกิจที่ดีมีพัฒนาการจะส่งผลดีต่อการพิจารณาของบริษัทข้ามชาติขนาดใหญ่ (Multinational Enterprise: MNE) ในการตัดสินใจลงทุน  อย่างไรก็ตาม ความไม่มั่นคงทางการเมืองและความไม่แน่นอนด้านนโยบายที่เพิ่มขึ้นอาจส่งผลต่อการตัดสินใจในประเด็นดังกล่าว\r\n",
    source:
      "กองความร่วมมือการลงทุนต่างประเทศ. (2560). รายงานภาวะการลงทุนโดยตรงจากต่างประเทศในประเทศไทย, \r\n30 สิงหาคม 2562. https://www.boi.go.th/upload/content/Foreign%20Investment%20Report%20\r\n2017_5b7a3c1d2a86a.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ม"
  },
  {
    keyword: "มูลฝอย",
    meaning:
      "เศษกระดาษ เศษผ้า เศษอาหาร เศษสินค้า\r\nถุงพลาสติก ภาชนะที่ใส่อาหาร เถ้า มูลสัตว์หรือซากสัตว์รวมตลอดถึงสิ่งอื่นใดที่เก็บกวาดจาก\r\nถนน ตลาด ที่เลี้ยงสัตว์หรือที่อื่น",
    source:
      "พระราชบัญญัติรักษาความสะอาดและความเป็นระเบียบเรียบร้อยของบ้านเมือง พ.ศ. 2534. (2534, 28 กุมภาพันธ์). เล่มที่ 109 ตอนที่ 15 หน้า 29. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/015/28.PDF",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "มูลฝอยติดเชื้อ",
    meaning:
      "มูลฝอยที่มีเชื้อโรคปะปนอยู่ในปริมาณหรือมีความเข้มข้นซึ่งถ้ามีการสัมผัสหรือใกล้ชิดกับมูลฝอยนั้นแล้วสามารถทำให้เกิดดรคได้",
    source:
      "กฎกระทรวงว่าด้วยการกำจัดมูลฝอยติดเชื้อ พ.ศ. 2545. (2545, 5 กันยายน). ราชกิจจานุเบกษา. เล่ม 119 ตอนที่ 86 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/00099809.PDF",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ม"
  },
  {
    keyword: "ยกฟ้อง",
    meaning:
      "การไร้ความผิดของผู้ที่เป็นจำเลย หรือการที่คดีนั้นอาจจะไม่สมควรเป็นมูลเหตุให้ฟ้องกันได้",
    source:
      "ระเบียบการพิจารณาคดีศาลตุลาการ. (2561). ศาลยกฟ้องเกิดจากสาเหตุใด ก, 12 กันยายน 2562. https://www.judicialaccountability.org/%E0%B8%A8%E0%B8%B2%E0%B8%A5%E0%B8%A2%E0%B8%81%E0%B8%9F%E0%B9%89%E0%B8%AD%E0%B8%87%E0%B9%80%E0%B8%81%E0%B8%B4%E0%B8%94%E0%B8%88%E0%B8%B2%E0%B8%81%E0%B8%AA%E0%B8%B2%E0%B9%80%E0%B8%AB%E0%B8%95%E0%B8%B8/",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ย"
  },
  {
    keyword: "ยกระดับกระบวนทัศน์",
    meaning:
      "ยกระดับระบบคิด วิธีคิด หรือแบบของการคิดที่ใช้เป็นแนวในการศึกษาวิจัยเรื่องใดเรื่องหนึ่ง หรือเป็นแนวในการจัดระบบในสังคม",
    source:
      "สำนักงานราชบัณฑิตยสถาน. (2550). กระบวนทัศน์, 11 พฤศจิกายน 2562. http://www.royin.go.th/?knowledges=%E0%B8%81%E0%B8%A3%E0%B8%B0%E0%B8%9A%E0%B8%A7%E0%B8%99%E0%B8%97%E0%B8%B1%E0%B8%A8%E0%B8%99%E0%B9%8C-%E0%B9%91%E0%B9%98-%E0%B9%80%E0%B8%A1%E0%B8%A9%E0%B8%B2%E0%B8%A2%E0%B8%99-%E0%B9%92%E0%B9%95",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ย"
  },
  {
    keyword: "ยานยนต์ไฟฟ้าแบตเตอรี่ (Battery Electric vehicle: BEV)",
    meaning:
      "การขับเคลื่อนด้วยพลังงานไฟฟ้าทั้งหมด ซึ่งต้องใช้แบตเตอรี่ที่มีความจุสูง เช่น เทคโนโลยีลิเที่ยม-ไอออน มีระยะทางการใช้งานระดับสั้นถึงปานกลาง โดยต้องชาร์จพลังงานจากสถานีอัดประจุเท่านั้น",
    source:
      "ฝ่ายวิจัยนโยบาย สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ. (2560). อุตสาหกรรมยานยนต์ไฟฟ้า, 3 ตุลาคม 2562. https://waa.inter.nstda.or.th/prs/pub/EV.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ย"
  },
  {
    keyword: "ยึดประชาชนเป็นศูนย์กลาง",
    meaning:
      "การทำงานในเชิงรุกและมองไปข้างหน้า โดยตั้งคำถามกับตนเองเสมอว่าประชาชนจะ\r\nได้อะไร มุ่งเน้นแก้ไขปัญหาและตอบสนองความต้องการของประชาชน โดยไม่ต้องรอให้\r\nเข้ามาติดต่อขอรับบริการหรือร้องขอความช่วยเหลือจากทางราชการ (Proactive Public\r\nServices) รวมทั้งใช้ประโยชน์จากข้อมูลภาครัฐ (Big Government Data) และระบบ\r\nดิจิทัลสมัยใหม่ในการจัดบริการสาธารณะ ที่ตรงกับความต้องการของประชาชน\r\n(Personalized หรือ Tailored Services) พร้อมทั้งอำนวยความสะดวก โดยมีการ\r\nเชื่อมโยงกันเองของทางราชการเพื่อให้บริการได้เสร็จสิ้นในจุดเดียว ประชาชนสามารถ\r\nเรียกใช้บริการของทางราชการได้ตลอดเวลาตามความต้องการของตนและผ่านการติดต่อ\r\nได้หลายช่องทางผสมผสานกัน ทั้งการติดต่อมาด้วยตนเอง เว็บไซต์โซเชียลมีเดีย หรือ\r\nแอปพลิเคชั่นทางโทรศัพท์มือถือ",
    source:
      "สำนักงานคณะกรรมการพัฒนาระบบราชการ. (2561). อภิธานศัพท์ ยึดประชาชนเป็นศูนย์กลาง, 2 กันยายน 2562. http://hp.anamai.moph.go.th/article_attach/%E0%B8%AD%E0%B8%A0%E0%B8%B4%E0%B8%98%E0%B8%B2%E0%B8%99%E0%B8%A8%E0%B8%B1%E0%B8%9E%E0%B8%97%E0%B9%8C%207%2004%2061-1.pdf",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ย"
  },
  {
    keyword: "ยุค internet of thing",
    meaning:
      "ภาครัฐบาล ภาคเอกชน ภาคอุตสาหกรรมการผลิต ตลอดจนประชาชนทั่วไป ได้นำ IoT ไปประยุกต์ใช้ในการทำงานและชีวิตประจำวัน เพื่อสร้างรายได้ โอกาส และความสะดวกสบายยิ่งขึ้นในอุตสาหกรรมและโครงการต่าง ๆ เช่น\r\n1. Smart Industry เพื่อเตรียมความพร้อมก่อนเข้าสู่ยุคของการปฏิวัติอุตสาหกรรม Industry 4.0\r\n2. Smart City เพื่อนำมาปรับใช้ร่วมกับโครงสร้างพื้นฐาน และระบบต่าง ๆ ของเมืองใน 4 ด้าน คือ ด้านการท่องเที่ยว ด้านความปลอดภัย ด้านสิ่งแวดล้อม และด้านเศรษฐกิจ โดยพัฒนา IoT เพื่อตอบสนอง และอำนวยความสะดวกในแต่ละด้านของเมือง\r\n3. Smart Life เพื่อให้รูปแบบของการใช้ชีวิตของมนุษย์เปลี่ยนไปจากเดิม มนุษย์สามารถพูดคุยกับสิ่งของได้สิ่งของสามารถพูดคุยและรับรู้พฤติกรรมของมนุษย์ได้ ซึ่งในอนาคตเทคโนโลยีจะมีการพัฒนาให้สิ่งของสามารถพูดคุยกันเองได้โดยไม่ต้องผ่านมนุษย์",
    source:
      "ศูนย์เทคโนโลยีสารสนเทศและการสื่อสาร สำนักงานปลัดกระทรวงวิทยาศาสตร์และเทคโนโลยี. IoT กำลังจะเปลี่ยนโลก?, 10 กันยายน 2562. https://www.ops.go.th/main/index.php/knowledge-base/article-pr/655-iot-%E0%B8%81%E0%B8%B3%E0%B8%A5%E0%B8%B1%E0%B8%87%E0%B8%88%E0%B8%B0%E0%B9%80%E0%B8%9B%E0%B8%A5%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%99%E0%B9%82%E0%B8%A5%E0%B8%81.html",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ย"
  },
  {
    keyword: "ยุคโลกาภิวัตน์",
    meaning:
      "การแพร่กระจายไปทั่วโลก; การที่ประชาคมโลกไม่ว่าจะอยู่ ณ จุดใด สามารถรับรู้ สัมพันธ์ หรือรับผลกระทบจากสิ่งที่เกิดขึ้นได้อย่างรวดเร็วกว้างขวาง ซึ่งเนื่องมาจากการพัฒนาระบบสารสนเทศ",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2558).  globalisa(za)tion-โลกาภิวัตน์, 29 สิงหาคม 2562. http://www.royin.go.th/?\r\nknowledges=globalisazation-%E0%B9%82%E0%B8%A5%E0%B8%81%E0%B8%B2%E0%B8%A0%E0%\r\nB8%B4%E0%B8%A7%E0%B8%B1%E0%B8%95%E0%B8%99%E0%B9%8C",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ย"
  },
  {
    keyword: "ยุติธรรมทางแพ่ง",
    meaning:
      "กระบวนการสําหรับดําเนินคดีแพ่ง เช่น กรณีผิดสัญญา ซึ่งเป็นการฝ่าฝืนกฎหมายแพ่ง การที่จะบังคับให้ฝ่ายที่ผิดสัญญาชดใช้ค่าเสียหายจะต้องดําเนินการอย่างไร ซึ่งมีบทบัญญัติอยู่ในประมวลกฎหมายวิธีพิจารณาความแพ่ง",
    source:
      "ศาสตราจารย์นายแพทย์วิรัติพาณิชย์พงษ์ อดีตสมาชิกวุฒิสภา ผู้เชี่ยวชาญสาขาศัลยศาสตร์ทั่วไป ผู้เชี่ยวชาญสาขานิติเวชศาสตร์ . กระบวนการยุติธรรมในระบอบประชาธิปไตย 100 ปี, 17 กันยายน 2562. http://www.constitutionalcourt.or.th/occ_web/ewt_dl_link.php?nid=1467",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ย"
  },
  {
    keyword: "ยุติธรรมทางคดีปกครอง",
    meaning:
      "กระบวนการยุติธรรมอีกประเภทหนึ่งในระบบศาลคู่ (Duality of Jurisdiction) ที่ใช้อยู่ในนานาอารยประเทศตามแบบของศาลในประเทศกลุ่ม Civil law ทั่วไป ซึ่งจะมีความแตกต่างจากศาลในประเทศกลุ่ม Common law เช่น ประเทศอังกฤษ สหรัฐอเมริกา และในอีกหลายประเทศที่เคยได้รับอิทธิพลทางการปกครองและกฎหมายจากประเทศอังกฤษ",
    source:
      "ศาสตราจารย์ ดร. อักขราทร จุฬารัตน. (2548). ศาลปกครอง, 17 ตุลาคม 2562. http://www.public-law.net/publaw/view.aspx?id=690",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ย"
  },
  {
    keyword: "ยุติธรรมทางอาญา",
    meaning:
      "กระบวนการสําหรับดําเนินคดีอาญา กล่าวคือ เมื่อมีการกระทําผิดทางอาญาแล้ว การนําตัวผู้กระทําผิดมาลงโทษจะต้องกระทํา อย่างไร บทบัญญัติที่กําหนดวิธีดําเนินคดีอาญามีอยู่ในประมวลกฎหมายวิธีพิจารณาความอาญา",
    source:
      "ศาสตราจารย์นายแพทย์วิรัติพาณิชย์พงษ์ อดีตสมาชิกวุฒิสภา ผู้เชี่ยวชาญสาขาศัลยศาสตร์ทั่วไป ผู้เชี่ยวชาญสาขานิติเวชศาสตร์ . กระบวนการยุติธรรมในระบอบประชาธิปไตย 100 ปี, 17 กันยายน 2562. http://www.constitutionalcourt.or.th/occ_web/ewt_dl_link.php?nid=1467",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ย"
  },
  {
    keyword: "ยุทโธปกรณ์",
    meaning:
      "วัสดุอุปกรณ์ทั้งปวงและยุทธภัณฑ์ทุกชนิดซึ่งใช้ในราชการทหาร รวมทั้งเครื่องมือยานยนต์ ชิ้นส่วนอะไหล่สาธารณูปโภคอันจำเป็นเพื่อปฏิบัติการรบหรือเพื่อดำรงและสนับสนุนกิจกรรมทางทหารโดยไม่คำนึงถึงว่าจะมีความมุ่งหมายทางธุรการหรือทางการรบ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ยุทโธปกรณ์ , 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 1,
    mappear: "",
    rappear: "",
    firstalpha: "ย"
  },
  {
    keyword: "ยุทธศาสตร์แนวทางดำเนินงาน “เข้าใจ เข้าถึง พัฒนา”",
    meaning:
      'วิธีการแห่งศาสตร์พระราชาเพื่อการพัฒนาที่ยั่งยืน ที่พระบาทสมเด็จพระปรมินทรมหาภูมิพลอดุลยเดชทรงใช้เป็นวิธีการทรงงานมาตลอดรัชสมัย "เข้าใจ" คือ เข้าใจสภาพภูมิประเทศและมนุษย์ "เข้าถึง" คือ เข้าถึงภูมิสังคมและข้อมูลเพื่อให้การสร้างสรรค์นั้นตอบสนองความต้องการของประชาชน และ "พัฒนา" คือ กำหนดเป็นแนวทางการพัฒนาด้วยความรู้และภูมิปัญญาที่ไม่จำกัดอยู่เพียงมิติใดมิติหนึ่ง รวมถึงการทดลองและปรับปรุงจนได้ผลลัพธ์ที่ยั่งยืนและประยุกต์ใช้ได้ไม่รู้จบ',
    source:
      "โครงการเฉลิมพระเกียรติของสภานิติบัญญัติแห่งชาติ รวบรวมกฎหมายที่สนับสนุนโครงการอันเนื่องมาจากพระราชดำริ. (2560, 6 เมษายน).  ศาสตร์ของพระราชา,  6 ธันวาคม 2562. https://www.senate.go.th/pdf/the_wisdom_of_the_monarch.pdf",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ย"
  },
  {
    keyword: "ยุทธศาสตร์ชาติ",
    meaning:
      "ยุทธศาสตร์ชาติตามกฎหมายว่าด้วยการจัดทำยุทธศาสตร์ชาติ \r\nซึ่งเป็นเป้าหมายการพัฒนาประเทศอย่างยั่งยืนตามหลักธรรมาภิบาล เพื่อใช้เป็นกรอบในการจัดทำแผนต่าง ๆ ให้สอดคล้องและบูรณาการกันเพื่อให้เกิดเป็นพลังผลักดันร่วมกันไปสู่เป้าหมายดังกล่าว",
    source:
      "รัฐธรรมนูญแห่งราชอาณาจักรไทย พ.ศ. 2560 หมวด 6 แนวนโยบายแห่งรัฐ มาตรา 65 (2560, 6 เมษายน) \r\nราชกิจจานุเบกษา เล่ม 134 ตอนที่ 40 ก หน้า 17. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/A/040/1.PDF",
    sappear: 4,
    mappear: "15,16,17",
    rappear: 2,
    firstalpha: "ย"
  },
  {
    keyword: "ยุทธศาสตร์ระยะกลางและระยะยาว",
    meaning:
      "การกำหนดทิศทางการพัฒนา (Roadmap)โดยแบ่งเป็น 3 ช่วงระยะเวลา ได้แก่ การพัฒนาระยะสั้น (1-5 ปี) ระยะปานกลาง (6-10 ปี) และระยะยาว (11-20 ปี) เพื่อเป็นกรอบการดำเนินงานของ สบน. ในแต่ละช่วงระยะให้มีความเหมาะสมยกระดับความสำเร็จอย่างต่อเนื่องไปสู่เป้าหมายในระยะ 20 ปี",
    source:
      "กลุ่มพัฒนาระบบบริหาร สำนักงานบริหารหนี้สาธารณะ. (2560). ยุทธศาสตร์ของสำนักงานบริหารหนี้สาธารณะระยะยาว (20 ปี) พ.ศ. 2560-2579 และระยะปานกลาง (5 ปี) พ.ศ. 2560-2564, 30 ตุลาคม 2562. http://www1.pdmo.go.th/upload/plan_pdf/plan_20171002135930.pdf",
    sappear: 6,
    mappear: "",
    rappear: "",
    firstalpha: "ย"
  },
  {
    keyword: "รถยนต์ไฟฟ้า",
    meaning:
      "รถยนต์ที่ขับเคลื่อนด้วยมอเตอร์ไฟฟ้า ซึ่งพลังงานไฟฟ้าจะเก็บอยู่ในแบตเตอรี่หรืออุปกรณ์เก็บพลังงานไฟฟ้าแบบอื่น ๆ ด้วย ข้อดีของมอเตอร์ไฟฟ้าที่ให้แรงบิดได้ทันทีทําให้รถพลังงานไฟฟ้ามีอัตราเร่งที่เรียบและรวดเร็ว โดยจะมีชุดอุปกรณ์หลักคอแบตเตอรี่ มีความจุพลังงานไฟฟ้าสูงซึ่งเก็บไว้ในรถ โดยมีมอเตอร์ไฟฟ้าที่ทําหน้าที่ในการขับเคลื่อนโดยใช้พลังงานจากแบตเตอรี่ ส่วนมากเรื่อง\r\nของระยะเวลาและระยะทางของรถยนต์\r\nไฟฟ้าจะขึ้นอยู่กับขนาดความจุของแบตเตอรี่เป็นสําคัญ",
    source:
      "กานต์ ภักดีสุข. ปัจจัยด้านทัศนคติ ปัจจัยด้านส่วนประสมทางการตลาด และการยอมรับเทคโนโลยีที่มีผลต่อการตัดสินใจซื้อรถยนต์ไฟฟ้าของประชาชนในกรุงเทพมหานครและปริมณฑล หน้า 6, 17 กันยายน 2562. http://dspace.bu.ac.th/bitstream/123456789/3801/1/karn_pakde.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword:
      "ร่วมลงทุนแบบ Build, operate,and transfer (BOT)                           ",
    meaning:
      "เอกชนเป็นผู้ลงทุนพัฒนาและดำเนินโครงการ รับความเสี่ยงจากผลประกอบการ และต้องมีการส่งมอบกรรมสิทธิ์ทรัพย์สินของโครงการให้แก่ภาครัฐเมื่อพร้อมเริ่มเปิดให้บริการ (BTO) หรือเมื่อสิ้นสุดระยะเวลาสัญญา (BOT) โดยภาครัฐอาจกําหนดสิทธิพิเศษเพื่อจูงใจเอกชน เช่น สิทธิในการให้บริการ หรือสัญญาซื้อขายบริการเพื่อประกันรายได้เป็นต้น และอาจกําหนดให้เอกชนจ่ายค่าตอบแทนในรูปแบบต่างๆ",
    source:
      "สำนักวิเคราะห์โครงการลงทุนภาครัฐ สำนักงานสภาพัฒนาการเศรษฐกิจและสงคมแห่งชาติ. (2553). โครงการศึกษาการเพิ่มบทบาทภาคเอกชนในโครงการลงทุนภาครัฐ, 4 กันยายน 2562. http://www.nesdc.go.th/ewt_w3c/ewt_dl_link.php?nid=2652",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "รวมศูนย์อำนาจ",
    meaning:
      "หรือ Centralization คือภาวะที่เกิดการกระจุกตัวของอำนาจขึ้นในรัฐ เช่นมีการรวมศูนย์อำนาจไว้ที่รัฐบาลหรือส่วนกลางเป็นหลัก ทำให้การสั่งการหรือการดำเนินนโยบายต้องเป็นไปโดยยึดกับส่วนกลางเป็นหลัก  ",
    source:
      "ผู้ช่วยศาสตราจารย์ ดร.วสันต์ เหลืองประภัสร์. (2558). การรวมศูนย์อำนาจและการกระจายอำนาจกับการบริหารราชการแผ่นดินไทย: การทบทวนแนวคิด ข้อถกเถียง และข้อพิจารณาเพื่อการปฏิรูป, 18 มิถุนายน 2562. http://kpi3.uds.co.th/addpdf/วารสารปีที่-13-ฉบับที่-1-เดื/?edmc=2116",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "ระเบิดจากภายใน (การเมือง/การมีส่วนร่วมของประชาชน)",
    meaning:
      "มุ่งพัฒนาเพื่อสร้างความเข้มแข็งให้คนและครอบครัวในชุมชนที่เข้าไปพัฒนาให้มีสภาพพร้อมที่จะรับการพัฒนาเสียก่อน แล้วจึงค่อยออกมาสู่สังคมภายนอก มิใช่การนำเอาความเจริญจากสังคมภายนอกเข้าไปหาชุมชนและหมู่บ้าน ซึ่งหลายชุมชนยังไม่ทันได้มีโอกาสเตรียมตัวหรือตั้งตัว จึงไม่สามารถปรับตัวได้ทันกับกระแสการเปลี่ยนแปลงและนำไปสู่ความล่มสลายได้",
    source:
      "สำนักงานคณะกรรมการพิเศษเพื่อประสานงานโครงการอันเนื่องมาจากพระราชดำริ (สำนักงาน กปร.). ระเบิดจากข้างใน, 17 กันยายน 2562. http://www.rdpb.go.th/th/King/%E0%B8%AB%E0%B8%A5%E0%B8%B1%E0%B8%81%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%97%E0%B8%A3%E0%B8%87%E0%B8%87%E0%B8%B2%E0%B8%99-c24/%E0%B8%A3%E0%B8%B0%E0%B9%80%E0%B8%9A%E0%B8%B4%E0%B8%94%E0%B8%88%E0%B8%B2%E0%B8%81%E0%B8%82%E0%B9%89%E0%B8%B2%E0%B8%87%E0%B9%83%E0%B8%99-v163",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ร"
  },
  {
    keyword: "ระดับ Digital Government Maturity Model (Gartner)",
    meaning:
      "การพัฒนารัฐบาลดิจิทัลของหน่วยงานภาครัฐได้ออกเป็น 5 ระดับ ดังนี้\r\n1) Level 1: E-Government\r\nรัฐบาลอิเล็กทรอนิกส์เป็นจุดเริ่มต้นของการมุ่งสู่รัฐบาลดิจิทัล ทั้งนี้ ในระดับการพัฒนาขั้นนี้ภาครัฐมีการให้บริการต่างๆ ผ่านเว็บไซต์ของหน่วยงาน แต่เป็นเพียงการบริการเฉพาะด้านหรือบางส่วนเท่านั้น นอกจากนี้ บางหน่วยงานที่มีความเกี่ยวข้องหรือทำงานในสายงานเดียวกัน อาจร่วมมือกันเพื่อรวมศูนย์ของบริการอิเล็กทรอนิกส์เข้าไว้ยังจุด (Portal) เดียวกัน\r\n2) Level 2: Open Government\r\nการพัฒนาสู่ระดับการพัฒนารัฐบาลดิจิทัลในขั้นนี้ จำเป็นต้องอาศัยแรงผลักดันจากผู้บริหารระดับสูงของหน่วยงานภาครัฐ และตัวหน่วยงานภาครัฐเองจะต้องขับเคลื่อนสู่การเป็นรัฐบาลดิจิทัลมากขึ้น ในที่นี้ หน่วยงานภาครัฐจะเพิ่มอัตราการใช้ประโยชน์จากเทคโนโลยีต่างๆ และข้อมูลที่หน่วยงานมีอยู่ หากเป็นข้อมูลบนเอกสาร ก็จะต้องทำให้กลายเป็นข้อมูลอิเล็กทรอนิกส์ และเริ่มดำเนินการเปิดเผยข้อมูลสู่สาธารณะ (Open Public Data)\r\n3) Level 3: Data-Centric Government\r\nเพื่อยกระดับการให้บริการและการท างานภาครัฐ การพัฒนารัฐบาลดิจิทัลในขั้นนี้มุ่งเน้นไปที่การสร้างเว็บไซต์หรือระบบที่ให้บริการและตอบสนองผู้ใช้ (ประชาชน ภาคธุรกิจ และหน่วยงานภาครัฐด้วยกันเอง) ในการใช้ประโยชน์จากข้อมูลที่เปิดเผย โดยแต่ละหน่วยงานภาครัฐจะเริ่มให้ความสำคัญกับการบริหารจัดการระบบเทคโนโลยีสารสนเทศและข้อมูลขององค์กร เช่นเดียวกับการปรับเปลี่ยนองค์กรไปสู่การเป็นรัฐบาลดิจิทัล โดยการนำเอาเทคโนโลยีต่างๆ มาปรับใช้มากยิ่งขึ้น\r\n4) Level 4: Fully Digital Government\r\nการเกิดขึ้นของรัฐบาลดิจิทัลจะนำไปสู่รูปแบบบริการและการดำเนินงานของภาครัฐในรูปแบบใหม่ที่ไม่เคยเกิดขึ้น การน าเทคโนโลยีสำคัญมาปรับใช้เพื่อเพิ่มประสิทธิภาพและประสิทธิผล ประกอบกับการสร้างความร่วมมือระหว่างรัฐกับรัฐ และรัฐกับเอกชน จะส่งผลให้สภาพแวดล้อมเชิงดิจิทัลของประเทศเกิดการพัฒนาไปอย่างรวดเร็ว ทั้งนี้ การใช้ประโยชน์จากเทคโนโลยีและข้อมูลเป็นหัวใจสำคัญของรัฐบาลดิจิทัล ซึ่งจะต้องอาศัยการบูรณาการข้ามหน่วยงานในการใช้เทคโนโลยีหรือโครงสร้างพื้นฐานกลางร่วมกัน เช่นเดียวกับการแบ่งปันข้อมูลที่เป็นประโยชน์ต่อการดำเนินงานของแต่ละหน่วยงานภาครัฐ\r\n5) Level 5: Smart Government\r\nท้ายที่สุด รัฐบาลดิจิทัลจะมุ่งสู่การเป็นรัฐบาลอัจฉริยะ (Smart Government) โดยการขับเคลื่อนผ่านการนำเอาเทคโนโลยี Smart Machines มาปรับใช้กับการดำเนินงานและการให้บริการต่างๆ ของรัฐบาล และเพื่อการนั้น จำเป็นต้องอาศัยการสนับสนุนจากทุกภาคส่วน ไม่เว้นแต่จากตัวผู้บริหารที่มีวิสัยทัศน์ หากแต่รวมถึงนโยบายผลักดันจากรัฐบาล สภาพแวดล้อมเชิงดิจิทัลของประเทศ ตลอดจนภาคธุรกิจ ภาคอุตสาหกรรม และภาคประชาชนที่มีความต้องการใช้ประโยชน์จากบริการดิจิทัลของภาครัฐ\r\n",
    source:
      "ส่วนนโยบายรัฐบาลอิเล็กทรอนิกส์ ฝ่ายนโยบายและยุทธศาสตร์ สำนักงานรัฐบาลอิเล็กทรอนิกส์ (องค์การมหาชน) (สรอ.). (2559 (ร่าง) แผนพัฒนารัฐบาลดิจิทัลของประเทศไทย พ.ศ. 2560-2564, 4 ตุลาคม 2562. https://waa.inter.nstda.or.th/stks/pub/2017/20171208-draft-dg-plan-2560-2564.pdf",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระดับความพึงพอใจในคุณภาพการให้บริการของภาครัฐ",
    meaning:
      "ประเมินระดับความพึงพอใจในคุณภาพการให้บริการของภาครัฐ ซึ่งสามารถจำแนกได้ 2 ด้าน ได้แก่\r\n1. ความพึงพอใจด้านกระบวนการขั้นตอน\r\n2. ความพึงพอใจด้านเจ้าหน้าที่ผู้ให้บริการ",
    source:
      "สำนักงานคณะกรรมการพัฒนาระบบราชการ. คุณภาพการบริหารจัดการภาครัฐ, 21 กรกฎาคม 2562. https://www.opdc.go.th/file/reader/bEF8fDQwNDZ8fGZpbGVfdXBsb2Fk",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword:
      "ระดับความมั่นคงปลอดภัยภายในประเทศและศักยภาพตำรวจระดับสากล (WISPI)",
    meaning:
      "จัดทำโดยสมาคมตำรวจศึกษาสากล (IPSA) โดยพิจารณาจากปัจจัย 4 ด้านหลัก ได้แก่ ด้านบุคลากร ผลสัมฤทธิ์ การบังคับใช้กฎหมายและปฏิบัติหลักสิทธิมนุษยชน  และกระบวนการ",
    source:
      "สมาคมตำรวจศึกษาสากล. World Unternal Security&Police Index, 24 กันยายน 2562. http://www.ipsa-police.org/images/uploaded/Pdf%20file/WISPI%20Report.pdf",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระดับทวิภาคี",
    meaning: "การทำความตกลงทางการค้าของประเทศ 2 ประเทศ ",
    source:
      "กรมศุลกากร.  ความสำคัญและความเป็นมาของ FTA, 17 กันยายน 2562. http://www.customs.go.th/content_with_menu1_group_link.php?ini_content=fta_and_wto_160809_01&ini_menu=menu_interest_and_law_160421_03&ini_content_group=usage_fta_and_wto_01&lang=th&left_menu=menu_interest_and_law_160421_03_160928_01",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ร"
  },
  {
    keyword: "ระดับพหุภาคี",
    meaning: "การทำความตกลงทางการค้าเป็นกลุ่มประเทศ",
    source:
      "กรมศุลกากร.  ความสำคัญและความเป็นมาของ FTA, 17 กันยายน 2562. http://www.customs.go.th/content_with_menu1_group_link.php?ini_content=fta_and_wto_160809_01&ini_menu=menu_interest_and_law_160421_03&ini_content_group=usage_fta_and_wto_01&lang=th&left_menu=menu_interest_and_law_160421_03_160928_01",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบ Content Delivery Network (CDN)",
    meaning:
      "Content Delivery Network หรือ Content Distributed Network คือ ระบบเครือข่ายการนำส่งข้อมูลดิจิตอลขนาดใหญ่ ที่ประกอบด้วย เครื่อง Server หลายๆเครื่อง ที่ตั้งใน Data Center จำนวนมากที่เชื่อมต่อกับ Internet โดยหน้าที่ CDN คือ การส่งข้อมูลให้ถึงผู้ใช้ปลายทาง (End User) อย่างรวดเร็ว และมีประสิทธิภาพ พร้อมให้ผู้ใช้ปลายทาง (End User) เข้าถึงข้อมูลได้ตลอดเวลา โดยใช้วิธีกระจาย traffic ไปยังเครื่อง Server ต่างๆจำนวนมากบนเครือข่าย เพื่อเป็นการลดการรองรับ traffic จำนวนมาก บนเครื่อง Server เครื่องใดเครื่องหนึ่ง",
    source:
      "บริษัท นิภา เทคโนโลยี จำกัด. Content Delivery Network (CDN), 17 ตุลาคม 2562. https://www.ispio.com/cdn/",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบ e-Budgeting",
    meaning:
      "กระบวนการจัดสรรงบประมาณ โดยใช้เครื่องมืออิเล็กทรอนิกส์เข้ามาดำเนินการในกระบวนการงบประมาณ ทั้งการอนุมัติ เบิกจ่าย รวมถึงกระบวนการจัดซื้อจัดจ้างภาครัฐและข้อมูลส่วนราชการ มีความสะดวกรวดเร็ว คล่องตัว ที่สำคัญมีความโปร่งใส",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์. (2555). E-Budgeting, 25 มิถุนายน 2562. https://www.etda.or.th/terminology-detail/1055.html",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบ e-GP",
    meaning:
      "ระบบจัดซื้อจัดจ้างภาครัฐด้วยอิเล็กทรอนิกส์ (e-Government Procurement: e-GP)",
    source:
      "กองการพัสดุภาครัฐ กรมบัญชีกลาง. คู่มือลงทะเบียนในระบบ e-GP สำหรับหน่วยงานของรัฐ, 29 สิงหาคม 2562. \r\nhttp://www.thaitobacco.or.th/th/wp-content/uploads/2017/09/1.-%E0%B8%84%E0%B8%B9%E0%B9%\r\n88%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%A5%E0%B8%87%E0%B8%97%E0%B8%B0%E0%B9%\r\n80%E0%B8%9A%E0%B8%B5%E0%B8%A2%E0%B8%99%E0%B8%AB%E0%B8%99%E0%B9%88%E0%B8%\r\nA7%E0%B8%A2%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B8%A0%E0%B8%B2%E0%B8%84%E0%B8%\r\nA3%E0%B8%B1%E0%B8%90.pdf",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบ Environmental Checklist",
    meaning:
      "การจัดทำรายงานข้อมูลด้านสิ่งแวดล้อม (Checklist) พร้อมมาตรการป้องกันและแก้ไขผลกระทบสิ่งแวดล้อม และมาตรการติดตามตรวจสอบคุณภาพสิ่งแวดล้อม ตามแบบฟอร์มที่สำนักนโยบายและแผนทรัพยากรธรรมชาติและสิ่งแวดล้อมกำหนด",
    source:
      "ไชยาพงษ์ เทพประสิทธิ์ มหาวิทยาลัยเกษตรศาสตร์. การวิเคราะห์ผลกระทบสิ่งแวดล้อม (EIA), 4 กันยายน 2562.  http://irre.ku.ac.th/slideshow/pdf/11.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบ GFMIS",
    meaning:
      "ระบบงานด้านการเงินการคลังที่นำระบบอิเล็กทรอนิกส์มาพัฒนาให้เหมาะสมกับการปฏิบัติงานของหน่วยงานภาครัฐ และถือเป็นเครื่องมือในการเพิ่มประสิทธิภาพการบริหารงานการคลังภาครัฐ สามารถใช้เป็นข้อมูลในการตัดสินใจ นโยบายการคลัง และการปรับทิศทางเศรษฐกิจของประเทศได้อย่างทันท่วงที",
    source:
      "กรมชลประทาน. ระบบบริหารการเงินการคลังภาครัฐแบบอิเล็กทรอนิกส์ (Government Fiscal Management Information System: GFMIS), 4 กันยายน 2562. http://kromchol.rid.go.th/fad/fad_acc/Account%20_S/KACC-1/B-%203.doc",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบ kiosk",
    meaning:
      "ตู้บริการอเนกประสงค์ภาครัฐ หรือ Government Smart Kiosk เป็นช่องทางเพื่อการเข้าถึงข้อมูลและบริการภาครัฐ แบบครบวงจร ในรูปแบบดิจิทัล ผ่านพื้นที่ให้บริการหน่วยงานของรัฐและพื้นที่สาธารณะ ครอบคลุมในทุกภูมิภาคทั่วประเทศด้วยการยืนยันตัวตนในการเข้าถึงบริการด้วยบัตรประจำตัวประชาชนแบบอเนกประสงค์ (Smart Card) ที่มีระบบการรักษาความปลอดภัยสูง สามารถใช้บริการได้อย่างมั่นใจ",
    source:
      "สำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมกาชน). (2562). ตู้อเนกประสงค์ภาครัฐ, 17 ตุลาคม 2562. https://www.dga.or.th/th/profile/2123/",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบ Lateral Entry",
    meaning:
      "คัดสรรคนเข้าดำรงตำแหน่งจากทักษะ ความชำนาญ และความสามารถของบุคลากร โดยเป็นการคัดสรรจากภายนอกภาครัฐ จะช่วยแก้ไขปัญหาการขาดแคลนบุคลากรระดับสูงในภาครัฐของไทยที่จะเกิดขึ้นในอนาคตอันใกล้ได้",
    source:
      "กองบริหารงานวิจัยและประกันคุณภาพการศึกษา. (2560). Thailand 4.0 โมเดลขับเคลื่อนประเทศไทยสู่ความมั่งคั่ง มั่นคง และยั่งยืน, 16 ตุลาคม 2562. https://www.xn--12c4cbf7aots1ayx.com/pdf/092559/1502425056.pdf",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบ SMART Boiler Monitoring System",
    meaning:
      "ระบบที่เชื่อมต่ออุปกรณ์การวัดของหม้อน้ำ และแสดงผลข้อมูลการวัดแบบ Data Visualization ที่ทำให้ข้อมูลเชิงปริมาณดูน่าสนใจ เข้าใจง่าย และเห็นภาพรวมชัดเจน",
    source:
      "กระทรวงพลังงาน. 2561. สัมมนาเปิดโครงการวิศกรรมเชิงลึกเพื่อเพิ่มประสิทธิภาพพลังงานความร้อนในโรงงานอุตสาหกรรมภายใต้เงินกองทุนเพื่อส่งเสริมการอนุรักษ์พลังงาน, 4 กันยายน 2562. http://www.enervision.co.th/wp-content/uploads/2018/03/%E0%B8%AA%E0%B8%B1%E0%B8%A1%E0%B8%A1%E0%B8%99%E0%B8%B2%E0%B9%80%E0%B8%9B%E0%B8%B4%E0%B8%94%E0%B9%82%E0%B8%84%E0%B8%A3%E0%B8%87%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%A7%E0%B8%B4%E0%B8%A8%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B9%80%E0%B8%8A%E0%B8%B4%E0%B8%87%E0%B8%A5%E0%B8%B6%E0%B8%81.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบเกษตรพันธสัญญา (Contract Farming)",
    meaning:
      'ระบบการเกษตร การเลี้ยงสัตว์ หรือการเพาะปลูกพืช ที่มีการทำสัญญาซื้อขายผลผลิตล่วงหน้าระหว่างฝ่ายเกษตรกร หรือเจ้าของฟาร์ม กับคู่สัญญา คือ "ผู้รับประกัน" ซึ่งมักเป็นบริษัทเอกชนที่สัญญาว่าจะซื้อผลผลิตคืนจากอีกฝ่ายในราคาที่ตกลงกันตั้งแต่ต้น เรียกว่า "ราคาประกัน" ซึ่งจะเปลี่ยนแปลงได้ก็ต่อเมื่อครบกำหนดสัญญา',
    source:
      "ส่วนพัฒนาความร่วมมือภาคเอกชนและกิจการพิเศษ สำนักพัฒนาและส่งเสริมการบริหารราชการจังหวัด\r\nสำนักงานปลัดกระทรวงมหาดไทย. การทำการเกษตรแบบมีสัญญา (Contract Farming), 19 กรกฎาคม 2562. http://jpp.moi.go.th/detail.php?section=11&id=72",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบเซ็นเซอร์",
    meaning:
      "ระบบที่ทําหน้าที่ตรวจวัดการเปลี่ยนแปลงคุณสมบัติ หรือลักษณะของสิ่งต่างๆ โดยรอบวัตถุเป้าหมาย และนำข้อมูลจำนวนมหาศาล (Big Data) ที่ได้จากการตรวจวัดเข้าสู่กระบวนการแจกแจง และวิเคราะห์พฤติกรรมของการเปลี่ยนแปลง ประมวลผลเป็นองค์ความรู้และปัญญาประดิษฐ์ (Artificial Intelligence) ให้มนุษย์สามารถนำองค์ความรู้มาใช้เพื่อเพิ่มประสิทธิภาพลดขั้นตอนของกระบวนการทำงาน",
    source:
      "ศูนย์เทคโนโลยีสารสนเทศและการสื่อสาร. เทคโนโลยีเซนเซอร์ (Sensor Technology) https://www.ops.go.th/main/index.php/knowledge-base/article-pr/1520-sensor.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบเตรียมพร้อมแห่งชาติ",
    meaning:
      "การเตรียมการด้านต่างๆ ของหน่วยงานรัฐ รัฐวิสาหกิจ ภาคเอกชน องค์กรเอกชน องค์กรปกครองท้องถิ่น องค์กรชุมชน และ ภาคประชาชน ตั้งแต่ในภาวะปกติเพื่อให้มีนโยบาย ยุทธศาสตร์แผน แนวทางดำเนินการ มาตรการ และกิจกรรมเพื่อป้องกัน ลดผลกระทบ บรรเทา และระงับสถานการณ์ในภาวะไม่ปกติ โดยในห้วงที่ผ่านมา สำหรับประเทศไทย ได้จัดให้มีการเตรียมพร้อมของประเทศในการรับมือภัยคุกคามต่างๆ ทั้งที่เกิดจากภัยธรรมชาติและภัยที่มนุษย์สร้างขึ้น โดยกำหนดให้มีแผนเตรียมพร้อมแห่งชาติอย่างต่อเนื่อง ดังนี้\r\n- แผนเตรียมพร้อมแห่งชาติ พ.ศ. 2517 \r\n- แผนเตรียมพร้อมแห่งชาติ พ.ศ. 2520 \r\n- แผนเตรียมพร้อมแห่งชาติ พ.ศ. 2535 \r\n- นโยบายการเตรียมพร้อมแห่งชาติ พ.ศ. 2548\r\n- ยุทธศาสตร์การเตรียมพร้อมแห่งชาติ (พ.ศ. 2557– 2561) ซึ่งให้ความสำคัญกับการเตรียมพร้อมใน 3 ด้าน คือ ด้านสาธารณภัย ด้านภัยจากการสู้รบ และด้านวิกฤตการณ์ความมั่นคง อาทิ อาทิปัญหาอาชญากรรมข้ามชาติปัญหาความมั่นคงทางทะเล",
    source:
      "สำนักงานสภาความมั่นคงแห่งชาติ. (2561, 27 กันยายน). แผนเตรียมพร้อมแห่งชาติ พ.ศ. 2560-2564, 6 ธันวาคม 2562. http://www.nsc.go.th/Lists/List3/Attachments/37/แผนเตรียมพร้อมแห่งชาติ%20(พ.ศ.%20๒๕๖๐%20-%20๒๕๖๔).pdf",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบเศรษฐกิจยุคดิจิทัล",
    meaning:
      "การขับเคลื่อนเศรษฐกิจของประเทศโดยการนำเอาไอทีหรือเทคโนโลยีดิจิทัลเข้ามาใช้เพื่อเพิ่มผลผลิต เพิ่มผลงาน โดยใช้เวลาน้อยลงและสร้างมูลค่าเพิ่มให้แก่สินค้าและบริการต่าง ๆ เพื่อให้เราแข่งขันกับชาติต่าง ๆ ได้ โดยเฉพาะอย่างยิ่ง ยุคปัจจุบันที่การใช้สมาร์ทดีไวซ์ต่าง ๆ ไม่ว่าจะเป็นสมาร์ทโฟนและแท็บเล็ต ติดต่อสื่อสารกันผ่านเครือข่ายไร้สายความเร็วสูง (Wireless Broadband) เช่น 3G, 4G ซึ่งใช้งานได้ง่ายกว่า PC มาก ทำให้เกิดการใช้งานในวงกว้าง แม้กระทั่งในคนที่ไม่เคยใช้คอมพิวเตอร์หรืออินเทอร์เน็ตมาก่อน ซึ่งทำให้เกิดโอกาสทางธุรกิจใหม่ ๆ มากมายในแทบทุกสาขาเศรษฐกิจ",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์. เศรษฐกิจดิจิทัล DIGITAL ECONOMY, 19 กรกฎาคม 2562. https://www.etda.or.th/digital-economy.html",
    sappear: 2,
    mappear: 6,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบแรงงานสัมพันธ์",
    meaning:
      "ความสัมพันธ์ในด้านการจ้างงานระหว่างนายจ้างลูกจ้าง ซึ่งรวมถึงทุกสิ่งทุกอย่างที่เกี่ยวกับการว่าจ้างทำงาน นับตั้งแต่เงื่อนไขการจ้าง สภาพการทำงานและผลประโยชน์จากการทำงานร่วมกันของทั้งสองฝ่าย รวมทั้งสาเหตุต่างๆ ที่มีผลต่อสัมพันธภาพระหว่างนายจ้างลูกจ้าง ตลอดจนการร่วมเจรจาต่อรอง และการสร้างความเข้าใจอันดีต่อกัน เพื่อการอยู่ร่วมกันต่อไป",
    source:
      "กรมสวัสดิการและคุ้มครองแรงงาน. คำศัพท์ด้านแรงงาน, 18 พฤศติกายน 2562. https://www.labour.go.th/index.php/component/seoglossary/1-dictionary/L",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบโครงข่ายไฟฟ้า",
    meaning: "ระบบส่งไฟฟ้าหรือระบบจำหน่ายไฟฟ้า",
    source:
      "พระราชบัญญัติการประกอบกิจการพลังงาน พ.ศ. 2550. (2550, 9 ธันวาคม). ราชกิจจานุเบกษา. เล่มที่ 124 ตอนที่ 89 ก หน้าที่ 13. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบโครงข่ายไฟฟ้าทันสมัย (Grid Modernization)",
    meaning:
      "พัฒนาระบบไฟฟ้าด้วยระบบเทคโนโลยีสารสนเทศและสื่อสาร รองรับ Smart Grid, Microgrid,ยานยนต์ไฟฟ้า ระบบกักเก็บพลังงานไฟฟ้า และส่งเสริมการใช้มาตรฐาน IEC 61850 สำหรับการทำงานร่วมกันได้(Interoperability) ของอุปกรณ์ต่างๆ ภายในสถานีไฟฟ้า และระบบไฟฟ้า",
    source:
      "นายเสริมสกุล คล้ายแก้ว ผู้ว่าการการไฟฟ้าส่วนภูมิภาค. (2561). แผนการดำเนินงานผู้ว่าการการไฟฟ้าส่วนภูมิภาค ปี 2561, 10 กันยายน 2562. http://www.oic.go.th/FILEWEB/CABINFOCENTER3/DRAWER094/GENERAL/DATA0001/00001458.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบโครงข่ายไฟฟ้าอัจฉริยะ",
    meaning:
      "หรือสมาร์ทกริด (Smart Grid) คือ การนำเทคโนโลยีหลากหลายประเภทเข้ามาทำงานร่วมกันในระบบไฟฟ้า โดยครอบคลุมเทคโนโลยีด้านการผลิตไฟฟ้า ด้านการส่งไฟฟ้า ด้านการจำหน่ายไฟฟ้า ไปจนถึงด้านผู้ใช้ไฟฟ้า ซึ่งยังครอบคลุมไปถึงภาคการขนส่งที่สามารถรองรับการนำยานยนต์ไฟฟ้า (Electric Vehicle: EV) เข้ามาใช้งานในอนาคตด้วย ",
    source:
      "สำนักงานนโยบายและแผนพลังงาน กระทรวงพลังงาน. คู่มือ Smart Grid โครงข่ายไฟฟ้าอัจฉริยะ, 18 พฤศจิกายน 2562. https://thai-smartgrid.com/wp-content/uploads/2019/11/Manual-Smart-Grid.pdf",
    sappear: "2,5",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบโครงข่ายไฟฟ้าอาเซียน (ASEAN Power Grid: APG)",
    meaning:
      "การเชื่อมโยงโครงข่ายระบบไฟฟ้าระหว่างประเทศสมาชิก ผ่านระบบส่งไฟฟ้าแรงสูง เพื่อให้แต่ละประเทศใช้ทรัพยากรต่างๆ ร่วมกันให้เกิดประโยชน์สูงสุด ส่งเสริมแนวคิดการใช้พลังงานอย่างยั่งยืนและมีประสิทธิภาพเพื่อเสริมความมั่นคงทางด้านพลังงานและเศรษฐกิจ",
    source:
      "สำนักงานนโยบายและแผนพลังงาน (สนพ.) กระทรวงพลังงาน. (2559). แผนพัฒนาระบบไฟฟ้ารองรับ AEC, 3 ตุลาคม 2562. http://www.eppo.go.th/index.php/th/electricity/plan-aec/aec-develop-electricity",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบโครงข่ายสมาร์ทกริด",
    meaning:
      "หรือระบบโครงข่ายไฟฟ้าอัจฉริยะ คือ การนำเทคโนโลยีหลากหลายประเภทเข้ามาทำงานร่วมกันในระบบไฟฟ้า โดยครอบคลุมเทคโนโลยีด้านการผลิตไฟฟ้า ด้านการส่งไฟฟ้า ด้านการจำหน่ายไฟฟ้า ไปจนถึงด้านผู้ใช้ไฟฟ้า ซึ่งยังครอบคลุมไปถึงภาคการขนส่งที่สามารถรองรับการนำยานยนต์ไฟฟ้า (Electric Vehicle: EV) เข้ามาใช้งานในอนาคตด้วย ",
    source:
      "สำนักงานนโยบายและแผนพลังงาน กระทรวงพลังงาน. คู่มือ Smart Grid โครงข่ายไฟฟ้าอัจฉริยะ, 18 พฤศจิกายน 2562. https://thai-smartgrid.com/wp-content/uploads/2019/11/Manual-Smart-Grid.pdf",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบโซลาร์ลอยน้ำ (Solar Floating)",
    meaning: "การติดตั้งแผงโซลาร์เซลล์บนผืนน้ำ",
    source:
      'SCG. Floating Solar Farm "โซลาร์ฟาร์มลอยน้ำ" รายแรกในประเทศไทย, 25 ตุลาคม 2562. https://www.scg.com/innovation/floating-solar-farm/',
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบโลจิสติกส์",
    meaning:
      "กระบวนการทำงานที่เกี่ยวข้องกับการวางแผน การดำเนินการและการควบคุมการทำงานขององค์กร รวมทั้งการบริหารจัดการข้อมูลและธุรกรรมทางการเงินที่เกี่ยวข้องให้เกิดการเคลื่อนย้าย การจัดเก็บ การรวบรวม การกระจายสินค้า วัตถุดิบ ชิ้นส่วนประกอบ และการบริการให้มีประสิทธิภาพ และประสิทธิภาพสูงสุด โดยคำนึงถึงความต้องการและความพึงพอใจของลูกค้าเป็นสำคัญ และระบบโลจิสติกส์ยังเป็นกระบวนการหนึ่งของการจัดการสินค้าและบริการตลอดห่วงโซ่อุปทาน ",
    source:
      "สำนักงานคณะกรรมการดิจิทอลเพื่อเศรษฐกิจและสังคมแห่งชาติ กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม. (2562). นโยบายและแผนระดับชาติว่าด้วยการพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม, 8 ตุลาคม 2562. https://www.etda.or.th/content_files/2/files/05_Thailand_Digital_Plan.pdf",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบกลาง",
    meaning:
      "ระบบเทคโนโลยีสารสนเทศและเครือข่ายเชื่อมโยงที่จัดทำขึ้น เพื่อเผยแพร่ข้อมูลเกี่ยวกับการจัดทำร่างกฎหมายและการประเมินผลสัมฤทธิ์ รวมทั้งการเข้าถึงบทบัญญัติ\r\nของกฎหมายของประชาชน ",
    source:
      "พระราชบัญญัติหลักเกณฑ์การจัดทำร่างกฎหมายและการประเมินผลสัมฤทธิ์ของกฎหมาย พ.ศ. 2562. (2562, 31 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136  ตอนที่ 72 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/072/T_0001.PDF\r\n",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบกักเก็บพลังงาน (Energy Storage System: ESS)",
    meaning:
      "ระบบและอุปกรณ์ ที่สามารถเปลี่ยนพลังงานไฟฟ้าเป็นพลังงานในรูปแบบอื่นเพื่อให้สามารถกักเก็บไว้เพื่อการใช้งานในเวลาอื่นที่จำเป็นได้ โดยระบบกักเก็บพลังงานจะแปลงพลังงานที่กักเก็บไว้ในกลับมาเป็นพลังงานไฟฟ้าอีกครั้งเมื่อมีความต้องการใช้ไฟฟ้า ระบบกักเก็บพลังงานนั้นมีหลากหลายรูปแบบและมีตั้งแต่ขนาดเล็ก เช่น แบตเตอรี่โทรศัพท์ ไปจนถึงขนาดใหญ่ เช่น โรงไฟฟ้าพลังงานน้ำแบบสูบกลับ",
    source:
      "ศูนย์ประสานงานการออกแบบอาคารเพื่อการอนุรักษ์พลังงาน. ระบบกักเก็บพลังงาน(Energy Storage System: ESS), 3 ตุลาคม 2562. http://old.2e-building.com/article.php?cat=knowledge&id=358",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบการเฝ้าระวังการทุจริต (Watch Dog)",
    meaning:
      "หมาเฝ้าบ้านจะสอดส่อง ตรวจสอบ เปิดโปงการทุจริต หลักสูตรการอบรมจะสอนให้รู้วิธีการและการใช้เครื่องไม้เครื่องมือต่างๆ สำหรับให้ทำหน้าที่หมาเฝ้าบ้านได้ รวมทั้งความรู้ด้านกฎหมาย การจัดซื้อจัดจ้างภาครัฐ และการเข้าถึงแหล่งข้อมูลทำให้การทุจริตคอร์รัปชั่นถูกเปิดโปงไปแล้วนับพันราย เรื่องที่ถูกเปิดโปงส่วนใหญ่ได้เข้าสู่กระบวนการตรวจสอบของรัฐ เช่น สำนักงานตรวจเงินแผ่นดิน (สตง.) และคณะกรรมการป้องกันและปราบปรามการทุจริตภาครัฐ (ป.ป.ท.) ยังผลให้สามารถยับยั้งการทุจริตที่จะเกิดขึ้นแก่โครงการหลายโครงการ และยับยั้งความเสียหายที่จะเกิดขึ้นแก่งบประมาณแผ่นดิน นอกจากนั้น ยังทำให้สามารถเรียกเงินหลวงคืนในกรณีที่มีการเบิกจ่ายไปแล้ว และดำเนินการทางวินัยและอาญาแก่ผู้กระทำผิดด้วย",
    source:
      "องค์กรต่อต้านคอร์รัปชัน (ประเทศไทย). หมาเฝ้าบ้าน, วันที่ 29 สิงหาคม 2560. http://www.anticorruption.in.th/2016/th/detail/509/4/%E0%B8%AB%E0%B8%A1%E0%B8%B2%E0%B9%80%E0%B8%9D%E0%B9%89%E0%B8%B2%E0%B8%9A%E0%B9%89%E0%B8%B2%E0%B8%99",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบการเรียนรู้ตลอดชีวิต",
    meaning:
      "การศึกษาที่เกิดจากการผสมผสานระหว่างการศึกษาในระบบ การศึกษานอกระบบและการศึกษาตามอัธยาศัย เพื่อให้สามารถพัฒนาคุณภาพชีวิตได้อย่างต่อเนื่องตลอดชีวิต",
    source:
      "พระราชบัญญัติการศึกษาแห่งชาติ พ.ศ. 2542. (2542, 19 สิงหาคม). ราชกิจจานุเบกษา. เล่ม 116 ตอนที่ 74 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/074/1.PDF",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบการกักเก็บพลังงาน",
    meaning:
      "ระบบและอุปกรณ์ที่สามารถเปลี่ยนพลังงานไฟฟ้าเป็นพลังงานในรูปแบบอื่นเพื่อให้สามารถกักเก็บพลังงานไว้ เพื่อการใช้งานในเวลาอื่นที่จำเป็นได้ โดยระบบกักเก็บพลังงานจะแปลงพลังงานที่กักเก็บไว้ให้กลับมาเป็นพลังงานไฟฟ้าอีกครั้งเมื่อมีความต้องการใช้ไฟฟ้า",
    source:
      "ศูนย์ประสานงานการออกแบบอาคารเพื่อการอนุรักษ์พลังงาน. ระบบกักเก็บพลังงาน(Energy Storage System: ESS), 3 ตุลาคม 2562. http://old.2e-building.com/article.php?cat=knowledge&id=358",
    sappear: "",
    mappear: 7,
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบการประเมินสมรรถนะ",
    meaning:
      "1. สื่อสารหรือถ่ายทอดระบบสมรรถนะ สื่อสารให้กับบุคลากรทุกคนรับทราบรายละเอียดของระบบสมรรถนะ ตั้งแต่แนวคิดหลักการ ประโยชน์ของสมรรถนะ ขั้นตอนการพัฒนา พจนานุกรมสมรรถนะ วิธีการประเมินสมรรถนะ และนโยบายการนำระบบสมรรถนะไปใช้ในการบริหารทรัพยากรบุคคล ทั้งนี้ เพื่อให้บุคลากรทุกคนมีความรู้ ความเข้าใจ เห็นประโยชน์ และให้ความร่วมมือในการนำไปใช้ในการวัดประเมิน และพัฒนาสมรรถนะของตนเอง\r\n2. ทำการประเมินสมรรถนะบุคลากรเป็นรายบุคคล การประเมินสมรรถนะของข้าราชการกรมคุ้มครองสิทธิและเสรีภาพ จะใช้ในการประเมินผล ในส่วนของผลการประเมินพฤติกรรมการปฏิบัติข้าราชการหรือสมรรถนะ ใช้มาตรวัดการประเมินสมรรถนะตามวิธีการพิจารณาสัดส่วนพฤติกรรมที่แสดงออกต่อพฤติกรรมที่คาดหวัง โดยมาตรวัดแบบนี้ใช้ประเมินว่าผู้รับการประเมิน ได้แสดงสมรรถนะตามที่กำหนดมากน้อยเพียงใด คิดเป็นสัดส่วนมากน้อยอย่างไรเทียบกับระดับพฤติกรรมที่คาดหวัง ซึ่งถ้าผู้รับการประเมินแสดงพฤติกรรมที่คาดหวังมากก็จะได้คะแนนประเมินสูง\r\n3. จัดทำแผนการพัฒนาบุคลากรในภาพรวมและรายบุคคล สำหรับรูปแบบและวิธีการพัฒนาข้าราชการของกรมคุ้มครองสิทธิและเสรีภาพ อ้างอิงตามระบบของสำนักงาน ก.พ. ที่กำหนดให้การวางแผนพัฒนารายบุคคล เป็นวิธีการการหนึ่งในการพัฒนาบุคลากรโดยกำหนดกรอบแนวทางที่ช่วยให้บุคลากรบรรลุถึงเป้าหมายขององค์กร เป็นแผนปฏิบัติการที่จะพัฒนาบุคลากรไปสู่เป้าหมายตามที่บุคลากรหน่วยงานและองค์กรต้องการหรือคาดหวังให้เกิดขึ้น",
    source:
      "กระทรวงยุติธรรม. แนวทางการประเมินและพัฒนาสมรรถนะรายบุคคล, 6 พฤศจิกายน. http://www.rlpd.go.th/rlpdnew/images/2560/6.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบกำลังสำรอง",
    meaning:
      "ระบบกำลังที่มิใช่กำลังทหารประจำการและทหารกองประจำการ ซึ่งได้แก่ กำลังกึ่งทหาร กลุ่มพลังมวลชนจัดตั้ง กลุ่มพลังมวลชนอื่น กำลังพลสำรองที่เป็นทหารกองเกินและทหารกองหนุนตามกฎหมายว่าด้วยการรับราชการทหารและกำลังพลสำรองตามกฎหมายว่าด้วยกำลังพลสำรอง",
    source:
      "พลตรี ณรงค์ พฤกษารุ่งเรื่อง กองทัพบก กระทรวงกลาโหม. (2560). ระบบกำลังสำรองต่อความมั่นคงของรัฐศึกษาเฉพาะกรณีระบบการบรรจุและการใช้กำลังสำรอง, 31 ตุลาคม 2562. http://www.dsdw2016.dsdw.go.th/doc_pr/ndc_2559-2560/PDF/wpa_8116/ALL.pdf",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบขนส่งมวลชนทางราง",
    meaning:
      "การสนับสนุนภาครัฐในการยกระดับระบบขนส่งทางรางให้ทันสมัย มีประสิทธิภาพในการเดินรถสูง และลดอัตราการเกิดอุบัติเหตุ รวมทั้งสนับสนุนภาคเอกชนในการพัฒนาผลิตภัณฑ์เพื่อสนับสนุนการพัฒนาอุตสาหกรรมระบบขนส่งทางรางและอุตสาหกรรมเกี่ยวเนื่อง ลดการนำเข้าเทคโนโลยีจากต่างประเทศ",
    source:
      "สำนักงานการวิจัยแห่งชาติ. คำจำกัดความของแต่ละสำขำยุทธศาสตร์, 10 กันยายน 2562. https://www.nrms.go.th/FileUpload/AttatchFile/News/255911061328545615277.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบข้อมูล",
    meaning:
      "กระบวนการประมวลผลด้วยเครื่องมืออิเล็กทรอนิกส์สำหรับสร้าง  ส่ง  รับ  เก็บรักษา  หรือประมวลผลข้อมูลอิเล็กทรอนิกส์",
    source:
      "พระราชบัญญัติว่าด้วยธุรกรรมทางอิเล็กทรอนิกส์ พ.ศ. 2544\r\n (2544, 4 ธันวาคม). ราชกิจจานุเบกษา. เล่ม 118 ตอนที่ 112 ก หน้า 27 http://www.ratchakitcha.soc.go.th/DATA/PDF/00027390.PDF",
    sappear: "",
    mappear: 17,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบคลาวด์ภาครัฐ (Government Cloud Service)",
    meaning:
      "โครงสร้างพื้นฐานบนอินเทอร์เน็ตแบบใช้ทรัพยากรร่วมกัน โดยสำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน) (สพร.) ให้บริการแก่หน่วยงานภาครัฐด้วยเทคโนโลยี Cloud ซึ่งเก็บทรัพยากรไว้บนอินเทอร์เน็ต สามารถเรียกใช้งานผ่านเครือข่ายได้ตลอดเวลาจากระยะไกล ปรับขนาดได้ตามความต้องการของผู้ใช้ มีการจัดสรรทรัพยากร ลดภาระการบริหารจัดการ และมีความมั่นคงปลอดภัยสูง",
    source:
      "สำนักงานพัฒนารัฐบาลดิจิทัล (สพร.). (2562). การพัฒนาระบบคลาวด์ภาครัฐ Government Cloud, 4 กันยายน 2562. https://www.dga.or.th/th/profile/881/",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบคุมประพฤติในชุมชน (ในการบวนการยุติธรรม)",
    meaning:
      "การป้องกันอาชญากรรม และกิจกรรมที่เกี่ยวกับความยุติธรรมในรูปแบบต่างๆ ในความรับผิดชอบของหน่วยงานในกระบวนการยุติธรรมหน่วยใดหน่วยหนึ่งที่เปิดโอกาสให้ชุมชนเข้ามามีส่วนร่วมในการป้องกันหรือในกิจกรรมนั้น ๆ โดยมีเป้าหมายสุดท้ายเพื่อคุณภาพชีวิตของชุมชน",
    source:
      "นายสมชาติเอี่ยมอนุพงษ์ ผู้เชี่ยวชาญพิเศษด้านการแก้ไขฟื้นฟูและกิจกรรมชุมชน กรมคุมประพฤติ กระทรวงยุติธรรม. ยุติธรรมชุมชนคืออะไร, 8 ตุลาคม 2562. file:///C:/Users/admin/Downloads/hits355.pdf",
    sappear: 6,
    mappear: 22,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword:
      "ระบบจัดการพลังงานแบบกระจายศูนย์ (Distributed Energy Resource Management System: DERMS)",
    meaning:
      "ระบบบริหารจัดการที่รองรับการเชื่อมต่อของแหล่งผลิตไฟฟ้าแบบกระจายตัวที่เชื่อมต่อกับระบบไฟฟ้าของการไฟฟ้าในจุดต่างๆ เพื่อความปลอดภัยของผู้ปฏิบัติงานและประชาชนทั่วไป โดยยังคงรักษาคุณภาพไฟฟ้าและความเชื่อถือได้ของระบบให้อยู่ในเกณฑ์มาตรฐาน ซึ่งเป็นส่วนหนึ่งของระบบ Active Network Management Operation ที่มีการควบคุมและเฝ้ามองทางไกล รวมถึงการพยากรณ์การผลิตไฟฟ้าจากระบบผลิตโดยแลกเปลี่ยนข้อมูลผ่านแบบ Digital Interface กับศูนย์ควบคุมตามมาตรฐานที่กำหนด",
    source:
      "การไฟฟ้าส่วนภูมิภาค. (2561). รายงานผลการศึกษาดูงานด้านโครงข่ายไฟฟ้าอัจฉริยะ และพลังงานทดแทน, 4 กันยายน 2562. http://www.oic.go.th/FILEWEB/CABINFOCENTER2/DRAWER043/GENERAL/DATA0001/00001807.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบจำหน่ายพลังงานไฟฟ้า",
    meaning:
      "จำหน่ายพลังงานไฟฟ้าให้แก่การไฟฟ้านครหลวง การไฟฟ้าส่วนภูมิภาค ผู้ใช้ไฟฟ้ารายอื่นๆ ตามที่กฎหมายกำหนด รวมทั้งประเทศใกล้เคียง",
    source:
      "การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย. (2561). การดำเนินงานด้านพลังงานไฟฟ้า, 7 ตุลาคม 2562. http://www.egat.co.th/index.php?option=com_content&view=article&id=1184&Itemid=132",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบดาวเทียม",
    meaning:
      "วัตถุที่มนุษย์สร้างขึ้นเลียนแบบดาวบริวารของดาวเคราะห์ เพื่อให้โคจรรอบโลกหรือรอบเทห์ฟากฟ้าอื่น มีอุปกรณ์สำหรับเก็บรวบรวมข้อมูลเกี่ยวกับอวกาศ และถ่ายทอดข้อมูลนั้นมายังโลก วัตถุลักษณะดังกล่าวที่โคจรรอบโลกใช้เป็นอุปกรณ์โทรคมนาคมด้วย เช่น ถ่ายทอดคลื่นวิทยุ และโทรทัศน์ข้ามทวีป เป็นต้น",
    source:
      "สำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ. (2558). ดาวเทียม (Satellites), 22 ตุลาคม2562. https://www.gistda.or.th/main/th/node/962",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ร"
  },
  {
    keyword:
      "ระบบดิจิทัลกับการเฝ้าระวังทางสังคม (Digital Community Watch Dog : DCWD)",
    meaning:
      "ระบบดิจิทัลเพื่อการเฝ้าระวังและเสริมสร้างวินัยและความเข้มแข็งของชุมชนสังคม โดยเป็นระบบรับเรื่องร้องเรียนปัญหาความเดือดร้อนของประชาชนทั่วประเทศ เช่น อบายมุข การจราจร การคุ้มครองผู้บริโภค สิ่งแวดล้อม เป็นต้น โดยระบบซอฟต์แวร์มีลักษณะทำงานด้วยตัวเอง เป็นการรับข้อมูลจากประชาชนผู้ร้องเรียนและแยกตามประเภทของปัญหาแล้วส่งต่อไปยังหน่วยงานที่รับผิดชอบในแต่ละปัญหา หรือร้องเรียนต่อไปยังหน่วยงานโดยตรง",
    source:
      "คณะกรรมาธิการขับเคลื่อนการปฏิรูปประเทศด้านสังคม สภาขับเคลื่อนการปฏิรูปประเทศ. (2560). ดิจิทัลเพื่อการเฝ้าระวังทางสังคมเสริมสร้างวินัยและความเข้มแข็งของชุมชนสังคม (Digital Community Watch Dog), 10 กันยายน 2562. \r\n\r\nhttps://library2.parliament.go.th/giventake/content_nrsa2558/d070360-02.pdf",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบนวัตกรรมแบบเปิด",
    meaning:
      "การผสมผสานองค์ความรู้ทั้งภายในและภายนอกองค์กร เพื่อให้บรรลุวัตถุประสงค์ที่ได้กำหนดไว้ โดยเป็นกระบวนการเร่งให้เกิดการสร้างนวัตกรรมภายในองค์กร และขยายตลาดเพื่อใช้นวัตกรรมกับภายนอกองค์กร",
    source:
      "ดร.สุชาต อุดมโสภกิจ สำนักงานคณะกรรมการนโยบายวิทยาศาสตร์ เทคโนโลยีและนวัตกรรมแห่งชาติ (สวทน.). (2558). การสร้างนวัตกรรมแบบเปิด (open innovation), 16 ตุลาคม 2562. http://www.tpa.or.th/publisher/pdfFileDownloadS/tn244_p57-60.pdf",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบนวัตกรรมแห่งชาติ (National Innovation System: NIS)",
    meaning:
      "ความเชื่อมโยงระหว่างผู้มีส่วนเกี่ยวข้องในการสร้างสรรค์นวัตกรรม ซึ่งเป็นกลไกสำคัญที่นำไปสู่การปรับปรุงประสิทธิภาพด้านเทคโนโลยี โดยความก้าวหน้าทางนวัตกรรมและทางเทคนิคเป็นผลมาจากความสัมพันธ์ที่ซับซ้อนระหว่างผู้ที่มีส่วนเกี่ยวข้องที่ทำหน้าที่ผลิต แจกจ่าย และปรับใช้ความรู้อย่างหลากหลาย ทั้งในรูปแบบของความร่วมมือ กิจกรรม และการไหลเวียนขององค์ความรู้ และเทคโนโลยี (OECD, National Innovation System, 1997) ",
    source:
      "ดร.ปัทมา เธียรวิศิษฎ์สกุล รองเลขาธิการ สำนักสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. (2560). นวัตกรรมนำสู่อนาคตประเทศไทย, 10 กันยายน 2562. https://www.nesdb.go.th/download/document/Yearend/2017/PPT_Group2.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบนิเวศ",
    meaning:
      "ความสัมพันธ์อย่างเป็นระบบที่อยู่ในสิ่งแวดล้อมรอบๆ ตัว เช่น ความสัมพันธ์ระหว่างสัตว์ พืช หรือแม้แต่มนุษย์ ซึ่งในระบบนิเวศจะมีสิ่งมีชีวิตแต่ละกลุ่มที่มีความสัมพันธ์กันเป็นทอดๆ เช่น สัตว์กินพืช สัตว์กินสัตว์ และสัตว์ที่กินทั้งพืชและสัตว์ สุดท้ายเมื่อสิ่งมีชีวิตตายลงจุลินทรีย์ก็ทำหน้าที่ย่อยสลายซากสิ่งมีชีวิต เมื่อใดก็ตามที่มีการเปลี่ยนแปลงในระบบนิเวศเกิดขึ้น เช่น มีสารเคมีแปลกปลอมเข้ามาทำลายสิ่งมีชีวิตเพียงชนิดใดชนิดหนึ่งย่อมส่งผลต่อสิ่งมีชีวิตอื่น ๆ อย่าง หลีกเลี่ยงไม่ได้ เพราะในระบบนิเวศทุกๆ สิ่งมีความสัมพันธ์เชื่อมโยงกันอย่างแยกไม่ออกทีเดียว",
    source:
      "สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ (สวทช.). ระบบนิเวศ คืออะไร?, 25 มิถุนายน 2562. https://www.nstda.or.th/th/vdo-nstda/science-day-techno/3660-ecosystem",
    sappear: 5,
    mappear: "18,19",
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบนิเวศทางทะเล",
    meaning:
      "ระบบนิเวศที่ปรากฏอยู่ตามบริเวณชายฝั่งทะเล และในท้องทะเล ได้แก่ เกาะ สันดอน \r\nและสันทรายชายฝั่ง หาดปะการัง ปะการังใต้น้ำ",
    source:
      "สารานุกรมไทยสำหรับเยาวชน โดยพระราชประสงค์ในพระบาทสมเด็จพระเจ้าอยู่หัว. เล่มที่ 27. เรื่องที่ 3 การท่องเที่ยวเชิงนิเวศ การจำแนกระบบนิเวศ, 30 สิงหาคม 2562.\r\nhttp://saranukromthai.or.th/sub/book/book.php?book=27&chap=3&page=t27-3-infodetail06.html",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบนิเวศป่าไม้",
    meaning:
      "ความสัมพันธ์ระหว่างป่ากับปัจจัยแวดล้อมต่างๆ ที่มีส่วนเกี่ยวข้องทั้งภายนอกและภายใน ซึ่งป่าไม้ไม่ใช่เป็นพื้นที่ที่มีเพียงต้นไม้เจริญเติบโตร่วมกันเท่านั้น แต่ประกอบด้วย 1) ต้นไม้ 2) วัตถุสารที่ต้นไม้และสัตว์ใช้เป็นที่ยึดเหนี่ยว ธาตุอาหารและความชื้น 3) พันธุ์ไม้อื่นๆที่มาอยู่ร่วมกันก่อให้เกิดร่มเงาต่อกัน แก่งแย่งกัน อาศัยประโยชน์ซึ่งกันและกัน หรือทำลายกัน 4) สัตว์ที่ใช้อาหารจากพืช อาศัยประโยชน์และให้ประโยชน์กับพืช 5) จุลินทรีย์ที่ได้และให้ประโยชน์โดยตรงและโดยอ้อมต่อต้นไม้ และ 6) ดิน สภาพภูมิประเทศ ความชื้น สภาพอากาศรวมถึงไฟป่า ซึ่งมีผลโดยตรงต่อสิ่งมีชีวิตทุกชนิดในป่า",
    source:
      "การจ่ายค่าตอบแทนการบริการของระบบนิเวศ. สำนักวิจัยการอนุรักษ์ป่าไม้และพันธ์พืช. กรมอุทยานแห่งชาติ สัตว์ป่า และพันธุ์พืช. 21 พฤศจิกายน 2562\r\n\r\nhttp://it2.dnp.go.th/wp-content/uploads/%E0%B8%A5%E0%B8%B3%E0%B8%94%E0%B8%B1%E0%B8%9A%E0%B8%97%E0%B8%B5%E0%B9%88-6-%E0%B9%80%E0%B8%A3%E0%B8%94%E0%B8%94%E0%B9%8C%E0%B8%9E%E0%B8%A5%E0%B8%B1%E0%B8%AA-%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%AA%E0%B8%B4%E0%B9%88%E0%B8%87%E0%B9%81%E0%B8%A7%E0%B8%94%E0%B8%A5%E0%B9%89%E0%B8%AD%E0%B8%A1%E0%B8%9B%E0%B9%88%E0%B8%B2%E0%B9%84%E0%B8%A1%E0%B9%89_Mobile-.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบบริการปฐมภูมิ",
    meaning:
      "บริการทางการแพทย์และสาธารณสุขที่มุ่งหมาย\r\nดูแลสุขภาพของบุคคลในเขตพื้นที่รับผิดชอบในลักษณะองค์รวม ตั้งแต่แรก ต่อเนื่อง และผสมผสานครอบคลุมทั้งการส่งเสริมสุขภาพ \r\nการควบคุมโรค การป้องกันโรค การตรวจวินิจฉัยโรค การรักษาพยาบาลและการฟื้นฟูสุขภาพ โดยหน่วยบริการปฐมภูมิหรือเครือข่ายหน่วยบริการปฐมภูมิที่ประกอบด้วยแพทย์ เวชศาสตร์ครอบครัวและคณะผู้ให้บริการสุขภาพปฐมภูมิ รวมทั้งเชื่อมโยงกับครอบครัว ชุมชนและบริการทางการแพทย์และสาธารณสุขระดับ\r\nทุติยภูมิและตติยภูม",
    source:
      "พระราชบัญญัติระบบสุขภาพปฐมภูมิ พ.ศ. 2562. (2562, 30 เมษายน). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 56 ก หน้า 165-185.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/056/T_0165.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบบริหารแบบเครือข่าย",
    meaning:
      "ระบบบริหารแบบเครือข่าย ประกอบด้วย\r\n1. ความยืดหยุ่น (flexibility) ระบบบริหารภาครัฐโดยอาศัยเครือข่ายจะมีความยืดหยุ่นและมีความคล่องตัวกว่าระบบการบริหารแบบลำดับขั้นตอน\r\n2. นวัตกรรม (innovation) ระบบเครือข่ายจะเสนอบริการใหม่อยู่เสมอเมื่อเทียบกับหน่วยงานของรัฐที่ติดอยู่กับกฎระเบียบต่างๆ\r\n3. ความเชี่ยวชาญเฉพาะทาง (specialization) ระบบเครือข่ายจะทำให้หน่วยงานของรัฐให้ความสนใจอยู่กับภารกิจหลักของหน่วยงานโดยการจ้างผู้เชี่ยวชาญมาช่วยดำเนินการภารกิจส่วนอื่น\r\n4. ความรวดเร็ว (speed) การที่ไม่มีการควบคุมโดยตรงและสมาชิกในเครือข่ายมีอิสระในการตัดสินใจเองทำให้เกิดการตัดสินใจมีความรวดเร็วสามารถตอบสนองต่อปัญหาต่างๆด้วยความรวดเร็ว",
    source:
      "สรัญญา จุฑานิล คณะรัฐศาสนศาสตร์ สถาบันบัณฑิตพัฒนบริหารศาสตร์. (2556). การบริหารเครือข่ายของสถาบันพัฒนาองค์กรชุมชนสำนักงานปฏิบัติการภาคตะวันออกเฉียงเหนือ. 29 ตุลาคม 2562. http://libdcms.nida.ac.th/thesis6/2556/b181852.pdf",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบบริหารแบบมีส่วนร่วม",
    meaning:
      "การบริหารโดยให้บุคคลในองค์กรหรือบุคคลที่มีส่วนเกี่ยวข้องในกระบวนการการตัดสินใจใช้ความคิดสร้างสรรค์ ความเชี่ยวชาญ ในการบริหารให้บรรลุวัตถุประสงค์ หรือแก้ไขปัญหาต่างๆ ที่เกิดจากการบริหารงานที่มีความสำคัญ ซึ่งการบริหารงานแบบมีส่วนร่วมก่อให้เกิดความเข้าใจร่วมกันในการปฏิบัติงานที่มุ่งหวัง และกระบวนการการตัดสินใจที่สามารถรองรับพฤติกรรมของบุคคลในองค์กรได้กว้างขวางและเกิดการยอมรับได้เป็นหลักการของการบริหารงานที่มีผลต่อการดำเนินการเชิงวิเคราะห์ ซึ่งนำไปสู่การตัดสินใจได้ ลดช่องว่างของระบบการสื่อสารในองค์กรและขจัดปัญหาความขัดแย้ง",
    source:
      "นิเวศน์ วงศ์สุวรรณ และอินถา ศิริวรรณ. (2560). การบริหารแบบมีส่วนร่วม. วารสารมหาจุฬาวิชาการ.  4 (1), 176-187.\r\nhttps://www.tci-thaijo.org/index.php/JMA/index",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบบริหารจัดการทรัพยากรธรรมชาติและสิ่งแวดล้อม",
    meaning:
      "การดำเนินงานต่อทรัพยากรธรรมชาติ และสิ่งแวดล้อม อย่างมีประสิทธิภาพ ทั้งในด้านการจัดหา การเก็บรักษา การซ่อมแซม การใช้อย่างประหยัด และการสงวนรักษา เพื่อให้ทรัพยากรธรรมชาติ และสิ่งแวดล้อมนั้น สามารถเอื้ออำนวยประโยชน์แก่มวลมนุษย์ได้ใช้ตลอดไปอย่างไม่ขาดแคลน หรือมีปัญหาใดๆ หรืออาจจะหมายถึงกระบวนการจัดการ แผนงาน หรือกิจกรรมในการจัดสรร และการใช้ทรัพยากรธรรมชาติ และสิ่งแวดล้อม เพื่อสนองความต้องการในระดับต่างๆ ของมนุษย์ และเพื่อให้บรรลุเป้าหมายสูงสุดของการพัฒนาคือ เสถียรภาพทางเศรษฐกิจ สังคม และคุณภาพสิ่งแวดล้อม โดยยึดหลักการอนุรักษ์ ด้วยการใช้ทรัพยากรธรรมชาติ และสิ่งแวดล้อมอย่างฉลาด ประหยัด และก่อให้เกิดผลเสียต่อสิ่งแวดล้อมน้อยที่สุดเท่าที่จะทำได้",
    source:
      "สารานุกรมไทยสำหรับเยาวชนฯ เล่มที่ 19. เรื่องที่ 1.การจัดการทรัพยากรธรรมชาติและสิ่งแวดล้อม. ความหมายของการจัดการทรัพยากรธรรมชาติและสิ่งแวดล้อม, 10 กันยายน 2562\r\nhttp://saranukromthai.or.th/sub/book/book.php?book=19&chap=1&page=t19-1-infodetail02.html",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบบริหารจัดการทรัพยากรบุคคลภาครัฐ ",
    meaning:
      "กระบวนการที่ผู้บริหารใช้ศิลปะและกลยุทธ์ ดำเนินการสรรหา คัดเลือก และ บรรจุบุคคลที่มีคุณสมบัติเหมาะสม ให้ปฏิบัติงานในองค์การพร้อมทั้งสนใจพัฒนาธำรงรักษาให้สมาชิกที่ปฏิบัติงานในองค์กรเพิ่มพูน ความรู้ความสามารถ มีสุขภาพกายและสุขภาพจิตที่ดีในการทำงาน และยังรวมไปถึงการแสวงหาวิธีการที่ทำให้สมาชิกในองค์กรที่ต้องพ้นจากการทำงานด้วยเหตุทุพพลภาพ เกษียณอายุหรือเหตุอื่นใดในงานให้สามารถดำรงชีวิตอยู่ ในสังคมได้อย่างมีความสุข โดยมี สำนักงานคณะกรรมการข้าราชการพลเรือน (ก.พ.) เป็นองค์การกลางด้านการบริหารทรัพยากรบุคคลในราชการพลเรือน ภายใต้ระบบคุณธรรมทำหน้าที่ส่งเสริมการพัฒนาข้าราชการ และเจ้าหน้าที่ของรัฐให้มีคุณภาพชีวิตและการทำงานที่ดี และพัฒนาระบบการบริหารกำลังคนในราชการให้เป็นกลไกการขับเคลื่อนยุทธศาสตร์ชาติอย่างมีประสิทธิภาพ",
    source:
      "สำนักงานคณะกรรมการข้าราชการพลเรือน. ยุทธศาสตร์ สำนักงานคณะกรรมการข้าราชการพลเรือน (ก.พ.) ระยะ 20 ปี (พ.ศ. 2560-2579), 20 พฤศจิกายน 2562. https://www.ocsc.go.th/node/2346",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบบริหารจัดการศึกษา",
    meaning:
      "กระทรวงมีอำนาจหน้าที่เกี่ยวกับการส่งเสริม และกำกับดูแลการศึกษาทุกระดับและทุกประเภท กำหนดนโยบาย แผน และมาตรฐานการศึกษา สนับสนุนทรัพยากรเพื่อการศึกษา ส่งเสริมและประสานงานการศาสนา ศิลปะ วัฒนธรรม และการกีฬาเพื่อการศึกษา รวมทั้งการติดตาม ตรวจสอบ และประเมินผลการจัดการศึกษาและราชการอื่นตามที่มีกฎหมายกำหนดให้เป็นอำนาจหน้าที่ของกระทรวงหรือส่วนราชการที่สังกัดกระทรวง",
    source:
      "พระราชบัญญัติการศึกษาแห่งชาติ พ.ศ. 2542. (2542, 19 สิงหาคม). ราชกิจจานุเบกษา. เล่ม 116 ตอนที่ 74 ก หน้า 9. http://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/074/1.PDF",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบประกันภัยทางการเกษตร",
    meaning:
      "การจัดการความเสี่ยงและการพัฒนาระบบสัญญาณเตือนภัยล่วงหน้า เพื่อรองรับเหตุการณ์ภัยพิบัติในเชิงรุกโดยไม่รอให้เหตุการณ์ภัยธรรมชาติเกิดขึ้นก่อน การใช้ระบบการประกันภัยจึงถือเป็นผลิตภัณฑ์ทางการเงินรูปแบบหนึ่งที่ช่วยให้เกษตรสามารถคาดการณ์และป้องกันความความเสี่ยงด้านการเงินได้ด้วยตนเอง โดยในระบบประกันภัย เกษตรกรในฐานะผู้เอาประกันภัยสามารถถ่ายโอนความเสี่ยงไปยังบริษัทประกันภัย เพื่อจะได้รับความคุ้มครองทางการเงิน หรือได้รับการชดเชยหากเกิดความเสียหายขึ้น ถือเป็นทางเลือกเพิ่มเติมในการบริหารความเสี่ยงทางการเงินได้ด้วยตนเองนอกเหนือจากการใช้บริการสินเชื่อเพื่อการเพาะปลูก หรือลดต้นทุนการผลิต",
    source:
      "สำนักงานเลขาธิการสภาผู้แทนราษฎร ปฏิบัติหน้าที่สำนักงานเลขาธิการ สภาขับเคลื่อนการปฏิรูปประเทศ. (2559). ด้านเศรษฐกิจ เรื่อง การปฏิรูปการประกันภัยการเกษตร, 23 ธันวาคม 2562. https://www.parliament.go.th/ewtadmin/ewt/parliament_parcy/download/usergroup_disaster/6-5.pdf",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบประกันภัยพืชผล",
    meaning:
      "การประกันภัยที่ให้ความคุ้มครองความเสียหายหรือสูญเสียต่อพืชผลที่เอาประกันภัย ซึ่งเกิดจากภัยตามที่ระบุไว้ในกรมธรรม์ โดยอาจกำหนดให้คุ้มครองภัยทุกชนิด หรืออาจกำหนดให้คุ้มครองเฉพาะบางภัย เช่น น้ำท่วม ภัยแล้ง ลมพายุ ลูกเห็บตก เป็นต้น ทั้งนี้ขึ้นอยู่กับพื้นที่และชนิดของพืชที่จะก่อให้เกิดความเสียหายแตกต่างกัน โดยทั่วไปจะกำหนดให้คุ้มครองเฉพาะภัยธรรมชาติ ซึ่งเป็นภัยที่อยู่นอกเหนือการควบคุมของมนุษย์",
    source:
      "สำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย (คปภ.). การประกันภัยพืชผล (Crop Insurance), 4 กันยายน 2562. http://www.oic.or.th/th/education/insurance/miscellaneous/crop",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบประกันสังคม",
    meaning:
      "การสร้างหลักประกันในการดำรงชีวิตในกลุ่มของสมาชิกที่มีรายได้ และจ่ายเงินสมทบเข้ากองทุนประกันสังคมเพื่อรับผิดชอบเฉลี่ยความเสี่ยงที่อาจเกิดขึ้นจากการเจ็บป่วย คลอดบุตรทุพพลภาพ ตาย สงเคราะห์ ชราภาพ และการว่างงาน เพื่อให้ได้รับการรักษาพยาบาล และมีการทดแทนรายได้อย่างต่อเนื่อง",
    source:
      "สำนักงานประกันสังคม. กองทุนประกันสังคม, 4 ตุลาคม 2562. http://capr.tsu.ac.th/UserFiles/01-%E0%B8%AA%E0%B8%B4%E0%B8%97%E0%B8%98%E0%B8%B4%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B9%82%E0%B8%A2%E0%B8%8A%E0%B8%99%E0%B9%8C.pdf",
    sappear: 4,
    mappear: 17,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบพิทักษ์คุณธรรม",
    meaning:
      "คณะกรรมการพิทักษ์ระบบคุณธรรม หรือ ก.พ.ค. ซึ่งเป็นคณะกรรมการที่เกิดขึ้นตามพระราชบัญญัติระเบียบข้าราชการพลเรือน พ.ศ. 2551 เพื่อเป็นกลไกสำคัญในการพิทักษ์ระบบคุณธรรมในระบบราชการพลเรือนสามัญ  โดยให้มีอำนาจหน้าที่ในการเสนอแนะต่อ ก.พ. หรือองค์กรกลางบริหารงานบุคคลอื่น เพื่อจัดให้มีหรือปรับปรุงนโยบายการบริหารทรัพยากรบุคคลในส่วนที่เกี่ยวกับการพิทักษ์ระบบคุณธรรม พิจารณาวินิจฉัยอุทธรณ์และเรื่องร้องทุกข์ พิจารณาเรื่องการคุ้มครองระบบคุณธรรม รวมไปถึงการออกกฎ ก.พ.ค. ระเบียบและหลักเกณฑ์ที่เกี่ยวข้อง",
    source:
      "สำนักงานคณะกรรมการข้าราชการพลเรือน (สำนักงาน ก.พ.). การพิทักษ์ระบบคุณธรรม, 10 กันยายน 2562.  https://www.ocsc.go.th/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%9E%E0%B8%B4%E0%B8%97%E0%B8%B1%E0%B8%81%E0%B8%A9%E0%B9%8C%E0%B8%A3%E0%B8%B0%E0%B8%9A%E0%B8%9A%E0%B8%84%E0%B8%B8%E0%B8%93%E0%B8%98%E0%B8%A3%E0%B8%A3%E0%B8%A1",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบมาตรฐานบัญชี",
    meaning:
      "หลักการบัญชีและวิธีปฏิบัติทางการบัญชีที่รับรองทั่วไปหรือมาตรฐานการบัญชีที่กำหนดตามกฎหมายว่าด้วยการนั้น",
    source:
      "กรมพัฒนาธุรกิจการค้า กระทรวงพานิชย์. (2543). พระราชบัญญัติการบัญชี พ.ศ. 2543, 7 พฤศจิกายน 2562. https://www.dbd.go.th/ewt_news.php?nid=1078",
    sappear: "",
    mappear: 16,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบยุติธรรมเชิงสมานฉันท์ (Restorative justice)",
    meaning:
      "กระบวนการใด ๆ ที่สร้างความสัมพันธ์ระหว่างผู้กระทำความผิดและผู้เสียหายกลับคืนสู่ความสัมพันธ์ที่ดีต่อกัน โดยใช้วิธีการสร้างกระบวนการที่มีส่วนร่วมหลายฝ่าย ได้แก่ ฝ่ายผู้กระทำความผิดฝ่ายผู้เสียหาย สังคมชุมชน และเจ้าพนักงานในกระบวนการยุติธรรม ทั้งนี้กระบวนการดังกล่าวดำเนินการเพื่อสร้างความสัมพันธ์ที่ดีแทนการลงโทษจำคุกหรือลงโทษอื่นตามที่กฎหมายกำหนด ซึ่งอาจรวมถึง การเจรจา (Mediation) การไกล่เกลี่ย (Conciliation) การประชุมกลุ่มเพื่อระงับข้อพิพาท (Conferencing and Sentencing Circles)",
    source:
      "สำนักงานคณะกรรมการกฤษฎีกา. กระบวนการยุติธรรมเชิงสมานฉันท์, 2 กันยายน 2562. http://web.krisdika.go.th/pdfPage.jsp?type=act&actCode=210",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบยุติธรรมทางเลือก",
    meaning:
      "ระบบยุติธรรมที่คุ้มครองสิทธิเสรีภาพประชาชน ให้ความเป็นธรรมในทางกฎหมายหรือแก้ไขปัญหาความขัดแย้งของบุคคล โดยใช้รูปแบบแตกต่างจากระบบยุติธรรมกระแสหลัก กล่าวคือ เน้นการปรับเปลี่ยนทัศนะจากการแก้แค้นทดแทนของกระบวนการยุติธรรมกระแสหลักไปสู่ทัศนะใหม่ คือเป็นทัศนะที่สมานฉันท์ เช่น ระบบยุติธรรมชุมชนที่เน้นการแก้ไขข้อขัดแย้ง ข้อพิพาททางแพ่ง หรือทางอาญาที่ยอมความได้ โดยใช้กระบวนการไกล่เกลี่ย และการประณีประนอม เพื่อยุติข้อพิพาทในระดับชุมชน ก่อนนำคดีขึ้นศาล ทั้งนี้กระบวนการดังกล่าวทำให้ระเบียบสังคมดีขึ้น เกิดความยั่งยืนอย่างแท้จริง และสุดท้ายนำไปสู่ความสงบสุขตามเจตนารมณ์ของกฎหมายเหมือนกัน",
    source:
      "คณะทำงานเตรียมการปฏิรูปเพื่อคืนความสุขแก่คนในชาติ สำนักงานปลัดกระทรวงกลาโหม. (2557). กรอบความเห็นร่วมปฏิรูปประเทศไทยด้านกฎหมายและกระบวนการยุติธรรม, 11 ธันวาคม 2562. https://library2.parliament.go.th/giventake/content_nrcinf/nrc2557-issue3-reform01.pdf",
    sappear: 6,
    mappear: "",
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบรถไฟฟ้า",
    meaning:
      "รถไฟฟ้า ทางรถไฟฟ้า สถานีรถไฟฟ้า ระบบพลังงาน ระบบควบคุมการเดินรถ ระบบสื่อสาร ระบบระบายอากาศ และศูนย์ซ่อมบำรุง",
    source:
      "พระราชบัญญัติการรถไฟฟ้าขนส่งมวลชนแห่งประเทศไทย พ.ศ. 2543. (2543,1 ธันวาคม). ราชกิจจานุเบกษา.เล่ม 117 ตอนที่ 114 ก หน้า 2 http://www.ratchakitcha.soc.go.th/DATA/PDF/00019502.PDF",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบราชการ 4.0",
    meaning:
      "ระบบราชการต้องปรับเปลี่ยนแนวคิดและวิธีการท างานใหม่เพื่อพลิกโฉม (transform)\r\nให้สามารถเป็นที่เชื่อถือไว้วางใจและเป็นพึ่งของประชาชนได้อย่างแท้จริง (Credible and\r\nTrusted Government) ",
    source:
      "สำนักงานคณะกรรมการพัฒนาระบบราชการ. (2561). อภิธานศัพท์ ระบบราชการ 4.0, 2 กันยายน 2562. http://hp.anamai.moph.go.th/article_attach/%E0%B8%AD%E0%B8%A0%E0%B8%B4%E0%B8%98%E0%B8%B2%E0%B8%99%E0%B8%A8%E0%B8%B1%E0%B8%9E%E0%B8%97%E0%B9%8C%207%2004%2061-1.pdf",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบราชการแบบดั้งเดิม (Bureaucracy)",
    meaning:
      "การจัดการที่มุ่งเน้นองค์การที่มีเหตุมีผล บิดาแห่งระบบราชการคือ แม็กซ์ เวเบอร์ (Max Weber) องค์การระบบราชการมีลักษณะที่สำคัญ ดังนี้ \r\n\t1.. มีการกำหนดหน้าที่แยกจากกันตามความชำนาญเฉพาะด้าน \t    \r\n2. มีการกำหนดสายการบังคับบัญชาอย่างเป็นทางการ\r\n\t3. มีการคัดเลือกบุคคลเข้าทำงานตามความรู้ความสามารถ \r\n\t4. มีการกำหนดกฎระเบียบต่างๆ อย่างชัดเจน\r\n\t5. มีการปฏิบัติงานที่ไม่อิงความสัมพันธ์ส่วน\r\n",
    source:
      "กรมส่งเสริมการปกครองท้องถิ่น. ความรู้เรื่องระบบการจัดการองค์กร, 25 ตุลาคม 2562. http://www.dla.go.th/upload/ebook/column/2019/3/2257_6065.ppt",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบวนเกษตร",
    meaning:
      "ระบบที่นำเอาการเกษตรเข้ามาผสมผสานกับป่าไม้ และถือเป็นการประนีประนอมกันระหว่างราษฎรผู้ต้องการที่ดินเพื่อการเกษตรกับเจ้าหน้าที่ของรัฐที่ต้องการรักษาพื้นที่ป่าไม้ไว้และต้องการให้มีพื้นที่ป่าไม้เพิ่มขึ้น",
    source:
      "อำนวย คอวนิช มหาวิทยาลัยเกษตรศาตร์. (2527). นโยบายและผลการดำเนินงานตามโครงการปลูกสร้าง สวนป่าในประเทศไทย, 25 ตุลาคม 2562. http://www.fio.co.th/fio/km/docKM58/1.4.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบศูนย์บริการร่วม ณ จุดเดียว ( One stop Service)",
    meaning:
      "หน่วยงานที่รวมบริการของส่วนราชการเดียวกันหรือต่างส่วนราชการมาปฏิบัติราชการร่วมกันในการให้บริการและอำนวยความสะดวกแก่ผู้ใช้บริการและประชาชน",
    source:
      "พระราชกฤษฎีกาว่าด้วยการมอบอำนาจ พ.ศ. 2550. (2550, 22 พฤศจิกายน). ราชกิจจานุเบกษา. เล่มที่ 124 ตอนที่ 84 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2550/A/084/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบสวัสดิการถ้วนหน้า",
    meaning:
      "สิ่งที่ประชาชนควรจะได้ ทุกคนต้องได้รับ เพราะหากระบุว่าให้เฉพาะคนจน ปัญหาที่เกิดขึ้นคือคนที่เข้าถึงสวัสดิการจริงๆ ไม่ใช่คนจน แต่คนจนจริง ๆ กลับไม่ได้รับ จึงทำให้เกิดความไม่เป็นธรรม แต่ถ้าให้แบบถ้วนหน้า แม้คนรวยจะได้รับด้วย ก็ยังดีกว่าคนจนจะไม่ได้รับ เช่น รักษาพยาบาลฟรี เรียนฟรี และคนที่เกิดมาลำบากกว่าคนอื่น เช่น หูหนวก ตาบอด พิการ หรือผู้ประสบภัย เขาต้องได้มากกว่าคนอื่น และการที่ได้มากกว่าถือว่าเป็นธรรม",
    source:
      "รศ.ดร.กิตติพัฒน์ นนทปัทมะดุลย์ คณะสังคมสงเคราะห์ศาสตร์ มหาวิทยาลัยธรรมศาสตร์. (2558). สวัสดิการถ้วนหน้า ความเป็นไปได้ในสังคมไทย, 7 ตุลาคม 2562. http://social-agenda.org/social-watch-thailand-2016/%E0%B8%AA%E0%B8%A7%E0%B8%B1%E0%B8%AA%E0%B8%94%E0%B8%B4%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%96%E0%B9%89%E0%B8%A7%E0%B8%99%E0%B8%AB%E0%B8%99%E0%B9%89%E0%B8%B2-%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B9%80/",
    sappear: 4,
    mappear: "",
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบสังคมเศรษฐกิจแบบผสมผสาน",
    meaning:
      "ระบบเศรษฐกิจที่ทั้งรัฐบาลและเอกชนรับผิดชอบร่วมกันในการตัดสินใจว่าจะผลิตอะไร ผลิตเท่าใด ผลิตอย่างไร และแบ่งปันผลผลิตกันอย่างไร ระบบนี้รัฐบาลจะเข้ามาดำเนินการวางแผนในกิจกรรมเศรษฐกิจเฉพาะบางอย่าง อาทิ กิจการที่ต้องใช้เงินลงทุนสูง หรือเป็นกิจการที่หากมีการผูกขาดโดยภาคเอกชนจะส่งผลให้ประชาชนส่วนใหญ่ได้รับความเดือดร้อน โดยภาคธุรกิจทั่ว ๆ ไปจะปล่อยให้เอกชนเป็นผู้ดำเนินการโดยอาศัยกลไกราคาเป็นเครื่องนำทาง",
    source:
      "สำนักนโยบายการออมและการลงทุน. (2558). ระบบเศรษฐกิจแบบผสม (Mixed economy)ล 2 กันยายน 2562.  http://www2.fpo.go.th/S-I/Source/word/Word.php?Language=Thai&BeginRec=1941&NumRecShow=8&sort=1&search=",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบสัญญาคุณธรรม (Integrity and Transparency)",
    meaning:
      "เครื่องมือที่หน่วยงานภาครัฐทั่วประเทศได้มีส่วนร่วมในการส่งเสริมให้การบริหารราชการของประเทศไทยเป็นไปอย่างมีคุณธรรม ความโปร่งใส และส่งผลให้การทุจริตในภาพรวมของประเทศลดน้อยลงไปได้ ไม่มากก็น้อย",
    source:
      "สำนักประเมินคุณธรรมและความโปร่งใส  สำนักงานคณะกรรมการป้องกันและปราบปรามการทุจริตแห่งชาติ (สำนักงาน ป.ป.ช.). การประเมินคุณธรรมและความโปร่งใสในการดำเนินงานของหน่วยงานภาครัฐ (ITA), 2 กันยายน 2562. http://www.dede.go.th/main.php?filename=ITA_new",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบสัมปทาน",
    meaning:
      "ระบบที่ประเทศผู้เป็นเจ้าของทรัพยากรไม่ต้องลงทุนและไม่ต้องรับผิดชอบความเสี่ยง เพราะผู้รับสัมปทานจะเป็นผู้ลงทุนเองทั้งหมดและรับความเสี่ยงไปแต่เพียงผู้เดียว  หากบริษัทไม่พบปิโตรเลียมหรือพบแต่ไม่สามารถผลิตในเชิงพาณิชย์ได้ บริษัทต้องคืนพื้นที่ดังกล่าวให้รัฐ หากบริษัทพบแหล่งและทำการผลิตก็จะต้องเสียค่าภาคหลวงเป็นอัตราร้อยละที่กำหนดไว้ของปริมาณการผลิตทั้งหมด บริษัทสามารถนำเงินลงทุนทั้งหมดมาหักเป็นค่าใช้จ่ายของปีได้ และเมื่อประกอบการจนได้ผลกำไรแล้วจะต้องเสียภาษีรายได้ปิโตรเลียม ซึ่งในกฎหมายของไทยกำหนดที่เป็นร้อยละ 50",
    source:
      "บริษัท ปตท.สำรวจและผลิตปิโตรเลียม จำกัด (มหาชน). ระบบสัมปทาน, 2 กันยายน 2562. https://www2.pttep.com/Energyliteracy/PTTEP/issue.aspx?id=27",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบสาธารณสุข",
    meaning:
      "กิจกรรมทางสาธารณสุขต่างๆที่ทำให้สุขภาพของประชาชนดีขึ้นกิจกรรมทางสังคมที่มุ่งเพื่อสุขภาพ เช่น การควบคุมการบริโภคยาสูบ ความสำคัญของระบบสาธารณสุข ระบบสาธารณสุขก่อให้เกิดความรู้เรื่องโรคภัยไข้เจ็บและแนวทางการรักษาโรค ช่วยให้มนุษย์ปรับปรุงการดำเนินชีวิต และสิ่งแวดล้อมให้ปลอดภัย",
    source:
      "สรุปบทที่1 ระบบสาธารณสุข, 19 กรกฎาคม 2562. http://phadmin2552.freetzi.com/file/53705/summary/1.pdf",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบสารสนเทศ",
    meaning:
      "งานประยุกต์คอมพิวเตอร์เพื่อจัดเก็บบันทึกและประมวลข้อมูล เพื่อให้เกิดเป็นรายงานที่ผู้ปฏิบัติงานและผู้บริหารจะนำไปใช้เพื่อการจัดการได้",
    source:
      "กรมควบคุมมลพิษ.บัญชีรายชื่อคำศัพท์, 18 กันยายน 2562. http://www.pcd.go.th/info_serv/QandA/defaultThai.cfm?task=listVocab",
    sappear: "",
    mappear: "",
    rappear: "4,5,6",
    firstalpha: "ร"
  },
  {
    keyword: "ระบบสารสนเทศการงบประมาณ (Smart e-Budgeting)",
    meaning:
      "ระบบการจัดการงบประมาณอิเล็กทรอนิกส์มีระบบงานย่อย3 ระบบ\r\nคือ ระบบการวางแผนงบประมาณ ระบบการจัดทำคำของบประมาณ และระบบพิจารณางบประมาณ โดยเชื่อมโยงข้อมูลกับระบบแผนที่การงบประมาณ (e-BGIS)\r\n 1. สำหรับส่วนราชการฯ และจังหวัด/กลุ่มจังหวัด ใช้บันทึกข้อมูลข้อเสนองบประมาณรายจ่ายประจำปีงบประมาณเบื้องต้น (Pre – ceiling) เพื่อใช้เป็นข้อมูลกรอบวงเงินคำของบประมาณรายจ่ายประจำปีและสรุปภาพรวมแผนความต้องการคำขอฯ เบื้องต้น สำนักงบประมาณพิจารณากรอบวงเงินคำขอฯ\r\n2. ส่วนราชการฯ บันทึกรายละเอียดคำของบประมาณรายจ่ายประจำปี โดยสามารถพิมพ์เอกสารตามแบบคำขอฯ ในขั้นคำขอฯ หน่วยงานได้จากระบบ e-Budgeting เพื่อส่งให้สำนักงบประมาณพิจารณารายละเอียดคำของบประมาณในมิติต่าง ๆ",
    source:
      "ศูนย์เทคโนโลยีสารสนเทศ ส่วนพัฒนาระบบข้อมูลการงบประมาณ 2 สำนักงบประมาณ. (2561). คู่มือสรุปการจัดทำงบประมาณรายจ่ายประจำปี ด้วยระบบสารสนเทศด้านการงบประมาณ, 17 กันยายน 2562. http://www.mua.go.th/users/budget/doc/e-budgeting61.pdf",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบสารสนเทศด้านสุขภาพ",
    meaning:
      "ระบบที่มีการบูรณาการของข้อมูลจากแหล่งต่างๆเข้าด้วยกัน ระบบสารสนเทศที่มีข้อมูลสุขภาพต่างๆ และสามารถแลกเปลี่ยนข้อมูลและเชื่อมโยงกันได้ จะทำให้เกิดกลไกการแลกเปลี่ยนข้อมูลสุขภาพ ที่ตอบสนองความต้องการของผู้ใช้ข้อมูลในหลากหลายบทบาทและภาคส่วน ซึ่งจะก่อให้เกิดประโยชน์ต่อระบบสุขภาพ ดังนี้\r\n1. คุณภาพการบริการสุขภาพดีขึ้น\r\n2. ป้องกันความผิดพลาดจากการให้บริการสุขภาพ\r\n3. เพิ่มประสิทธิภาพของการบริการสุขภาพ\r\n4. ลดความสูญเปล่าจากการให้บริการสุขภาพเกิดจำเป็น\r\n5. เพิ่มประสิทธิภาพการบริหารจัดจากบริการสุขภาพ\r\n6. ลดภาระงานด้านเอกสาร\r\n7. ทำให้ประเทศสามารถขยายการให้บริการด้านสุขภาพได้ทั่วถึง\r\n8. งานสาธารณสุขและสุขภาพประชาชน ได้รับการพัฒนา และมีประสิทธิภาพมากขึ้น",
    source:
      "สำนักกรรมาธิการ 3 สำนักงานเลขาธิการวุฒิสภา ปฏิบัติหน้าที่สำนักงานเลขาธิการสภานิติบัญญัติแห่งชาติ. รายงานการพิจารณาศึกษา เรื่อง ระบบสารสนเทศด้านมาตรฐานและข้อมูลการแพทย์ คณะกรรมาธิการการสาธารณสุข สภานิติบัญญัติแห่งชาติ, 17 กันยายน 2562. https://library2.parliament.go.th/giventake/content_nla2557/d031759-05.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบสุขภาพปฐมภูมิ",
    meaning:
      "กลไกและกระบวนการในการประสานความร่วมมือ\r\nเพื่อจัดบริการสุขภาพปฐมภูมิ โดยการมีส่วนร่วมระหว่างภาครัฐ องค์กรปกครองส่วนท้องถิ่น ภาคเอกชน\r\nและภาคประชาชน รวมทั้งการส่งต่อผู้รับบริการและการเชื่อมโยงข้อมูลระหว่างหน่วยบริการทั้งระดับ\r\nปฐมภูมิ ทุติยภูมิ และตติยภูมิ ",
    source:
      "พระราชบัญญํติระบบสุขภาพปฐมภูมิ พ.ศ. 2562. (2562, 30 เมษายน). ราชกิจจาบุเษก. เล่ม 136 ตอนที่ 56 ก หน้า 166.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/056/T_0165.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบหลักประกันสุขภาพ",
    meaning:
      "ระบบหลักประกันสุขภาพที่รัฐจ่ายเงินงบประมาณแผ่นดินสนับสนุน และ/หรือมีส่วนร่วมในการบริหารจัดการ ได้แก่ระบบสวัสดิการรักษาพยาบาลข้าราชการ ระบบประกันสุขภาพตามกฎหมายว่าด้วยประกันสังคม ระบบหลักประกันสุขภาพแห่งชาติ ระบบสวัสดิการรักษาพยาบาลของรัฐวิสาหกิจ องค์กรปกครองส่วนท้องถิ่น ระบบบริการการแพทย์ฉุกเฉิน ครูโรงเรียนเอกชนตามกฎหมายว่าด้วยโรงเรียนเอกชน ระบบประกันสุขภาพตามกฎหมายว่าด้วยการคุ้มครองผู้ประสบภัยจากรถ ระบบประกันสุขภาพตามกฎหมายว่าด้วยกองทุนเงินทดแทน ระบบสวัสดิการด้านสุขภาพและประกันสุขภาพสำหรับคนที่รอพิสูจน์สถานะและสิทธิ คนไร้รัฐไร้สัญชาติ และบุคคลซึ่งมีภูมิลำเนาอยู่ในราชอาณาจักรแต่มิได้มีสัญชาติไทย เป็นต้น รวมถึงระบบประกันสุขภาพอื่นที่มีการประกาศกำหนด",
    source:
      "สำนักงานหลักประกันสุขภาพแห่งชาติ. (2560). แผนแม่บทบูรณาการพัฒนาระบบประกันสุขภาพระยะต้น (พ.ศ.2561 - 2564) ระยะปานกลาง/ระยะยาว (พ.ศ.2565 - 2579), 17 กันยายน 2562. https://www.nhso.go.th/files/userfiles/file/Final_%E0%B9%81%E0%B8%9C%E0%B8%99%E0%B9%81%E0%B8%A1%E0%B9%88%E0%B8%9A%E0%B8%97%E0%B8%9A%E0%B8%B9%E0%B8%A3%E0%B8%93%E0%B8%B2%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%A3%E0%B8%B0%E0%B8%9A%E0%B8%9A%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%81%E0%B8%B1%E0%B8%99%E0%B8%AF_%E0%B8%93%2022%20%E0%B8%9E%E0%B8%84_60_Am.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ร"
  },
  {
    keyword: "ระบบอุปถัมป์",
    meaning:
      "ระบบความสัมพันธ์ของคน 2 ฝ่าย ซึ่งมีความไม่เท่าเทียมกัน ฝ่ายที่อยู่เหนือกว่า คือ ผู้ที่มีทรัพยากรมากกว่าหรือมีอำนาจมากกว่าจะอยู่ในฐานะอุปถัมภ์ ฝ่ายที่อยู่ต่ำกว่า คือ ผู้ที่มีทรัพยากรน้อยกว่าหรือมีอำนาจด้วยกว่าจะเป็นผู้รับอุปถัมภ์ ต่างฝ่ายต่างมีการแสวงหาแงกเปลี่ยนผลประโยชน์กันในลักษณะต่างตอบแทนตามเงื่อนไขที่มีต่อกัน ซึ่งระบบอุปถัมภ์มีชื่ออื่นที่มีความหมายใกล้เคียงกัน เช่น ระบบชุบเลี้ยง ระบบเส้นสาย ระบบเลือกที่รักมักที่ชังหรือระบบคนพิเศษ ระบบวงศาคณาญาติหรือระบบเล่นพรรคเล่นพวก",
    source:
      "กองส่งเสริมจริยธรรมและป้องกันการทุจริต กรมทางหลวงชนบท. (2561). รู้ไว้ไกลโทษ, 25 ตุลาคม 2562. http://deac.drr.go.th/sites/deac.drr.go.th/files/15-11-2561.pdf",
    sappear: 6,
    mappear: "",
    rappear: "2,4,1",
    firstalpha: "ร"
  },
  {
    keyword: "ระบอบทุนนิยม",
    meaning:
      "ระบบเศรษฐกิจที่เอกชนมีบทบาทสำคัญในการเป็นเจ้าของปัจจัยการผลิต และเป็นผู้ประกอบการทางเศรษฐกิจ  ในระบบทุนนิยม เอกชนหรือองค์การธุรกิจสามารถใช้ปัจจัยการผลิตได้อย่างเสรีโดยที่รัฐไม่เข้ามาแทรกแซงการทำงาน  ระบบเศรษฐกิจแบบทุนนิยมจะขับเคลื่อนโดยการแข่งขันภายใต้กลไกตลาดและมีกำไรเป็นสิ่งจูงใจให้ผลิตสินค้าและบริการ",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2552). ทุนนิยม-สังคมนิยม, 17 กันยายน 2562. http://www.royin.go.th/?knowledges=%E0%B8%97%E0%B8%B8%E0%B8%99%E0%B8%99%E0%B8%B4%E0%B8%A2%E0%B8%A1-%E0%B8%AA%E0%B8%B1%E0%B8%87%E0%B8%84%E0%B8%A1%E0%B8%99%E0%B8%B4%E0%B8%A2%E0%B8%A1-%E0%B9%91%E0%B9%97-%E0%B8%9E%E0%B8%A4%E0%B8%A8",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ร"
  },
  {
    keyword: "รัฐชายฝั่งทะเล",
    meaning:
      "1. น่านน้ำภายใน หมายถึง น่านน้ำที่อยู่ภายในเส้นฐาน เช่น อ่าว ปากแม่น้ำ ทะเลสาบ รัฐชายฝั่งมีอำนาจอธิปไตย เหนือน่านน้ำภายใน ทำนองเดียวกันกับที่มีเหนือดินแดนซึ่งเป็นพื้นแผ่นดิน\r\n2. ทะเลอาณาเขต หมายถึง อาณาเขตทางทะเลของรัฐชายฝั่ง ที่วัดความกว้างออกจากเส้นฐาน ตามที่รัฐชายฝั่งได้กำหนดขึ้น ไม่เกิน 12 ไมล์ทะเล โดยรัฐชายฝั่ง มีอำนาจอธิปไตยเหนือทะเลอาณาเขตของตน และอำนาจอธิปไตยนี้ ครอบคลุมไปถึงห้วงอากาศ เหนือพื้นท้องทะเล และใต้ผิวพื้นท้องทะเลของทะเลอาณาเขตนั้นๆ ด้วย\r\n3. เขตต่อเนื่อง เป็นเขตที่อยู่ต่อเนื่องจากเส้นขอบนอกของทะเลอาณาเขต ออกไปอีก 12 ไมล์ทะเล ในเขตต่อเนื่องนี้ รัฐชายฝั่งมีอำนาจในการควบคุมเพื่อวัตถุประสงค์ต่างๆ ดังนี้ป้องกันมิให้มีการฝ่าฝืนกฎหมาย และข้อบังคับว่าด้วยศุลกากร การเข้าเมือง รัษฎากร และสุขาภิบาล อันจะทำให้เกิดในดินแดน หรือในทะเลอาณาเขตของตน และลงโทษผู้กระทำฝ่าฝืนกฎหมายและข้อบังคับดังกล่าวคุ้มครองวัตถุโบราณหรือวัตถุทางประวัติศาสตร์ที่อยู่บนพื้นทะเลในเขตต่อเนื่อง\r\n4) เขตเศรษฐกิจจำเพาะ มีความกว้างไม่เกิน ๒๐๐ ไมล์ทะเลจากเส้นฐาน ซึ่งรัฐชายฝั่งมีสิทธิอธิปไตยในการสำรวจ แสวงประโยชน์ อนุรักษ์ และการจัดการทรัพยากรธรรมชาติ ทั้งที่มีชีวิตและไม่มีชีวิต ส่วนกิจกรรมที่ไม่เกี่ยวข้องกับทางเศรษฐกิจ เช่น การเดินเรือ การบิน ไม่ตกอยู่ในสิทธิอธิปไตย ของรัฐชายฝั่ง\r\n5) ไหล่ทวีป ประกอบด้วยพื้นทะเล และใต้ผิวพื้นของพื้นที่ใต้น้ำ ซึ่งยืดขยายจากทะเลอาณาเขตไปจนถึงขอบ ที่ด้านนอกสุดของทวีปที่มีน้ำลึกไม่เกิน ๒๐๐ เมตร หรือที่ระยะ ๒๐๐ ไมล์ทะเลจากเส้นฐาน ซึ่งใช้วัดความกว้างของทะเลอาณาเขต ในกรณีที่ริมขอบของทวีปยืดขยายออกไป ไม่ถึงระยะดังกล่าวตามกฎหมายทะเล รัฐชายฝั่งมีสิทธิอธิปไตยเหนือทรัพยากรธรรมชาติ ทั้งบน และใต้ผิวพื้นไหล่ทวีป ไม่ว่าจะมีชีวิตหรือไม่มีชีวิต ส่วนรัฐอื่นๆ ยังมีสิทธิ ที่จะวางสายเคเบิล หรือท่อทางใต้ทะเลบนไหล่ทวีปนั้นได้ โดยต้องได้รับความยินยอม จากรัฐชายฝั่งก่อน\r\n6) ทะเลหลวง หมายถึง ส่วนของทะเลที่มิใช่ส่วนหนึ่งของเขตเศรษฐกิจจำเพาะ ทะเลอาณาเขต หรือน่านน้ำภายใน โดยทุกรัฐมีเสรีภาพในการใช้ทะเลหลวง เพื่อการเดินเรือ การบิน การวางสายเคเบิลและท่อทางใต้ทะเล การประมง การสร้างเกาะเทียม และสิ่งติดตั้งอื่นๆ รวมทั้งการค้นคว้าวิจัยทางวิทยาศาสตร์",
    source:
      "สารานุกรมไทยสำหรับเยาวชน. การแบ่งเขตทางทะเล, 30 กันยายน 2562. http://kanchanapisek.or.th/kp6/sub/book/book.php?book=32&chap=5&page=t32-5-infodetail06.html",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ร"
  },
  {
    keyword: "รัฐธรรมนูญ",
    meaning:
      "บทกฎหมายสูงสุดที่จัดระเบียบการปกครองประเทศ กำหนดรูปแบบและระบอบการปกครองของประเทศ สิทธิ เสรีภาพ และหน้าที่ของประชาชน อำนาจหน้าที่ขององค์กร และความสัมพันธ์ระหว่างองค์กร",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. รัฐธรรมนูญ. 20 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ร"
  },
  {
    keyword: "รัฐธรรมาธิปไตย",
    meaning:
      "1. ผู้ปกครองรัฐจะต้องยึดมั่นตั้งมั่นในธรรม ยึดเอาความถูกต้องชอบธรรมธรรมเป็นใหญ่ในการใช้อำนาจปกครองรัฐ ซึ่งหมายถึงการใช้อำนาจการบริหารประเทศที่ชอบธรรม\r\n2. ผู้ปกครองจะต้องเข้าสู่อำนาจของการปกครองรัฐด้วยระบบที่เป็นธรรมถูกต้องชอบธรรม และสร้างระบบและกฎหมายในการปกครองรัฐที่ชอบธรรม ไม่เอื้อประโยชน์ต่อฝ่ายใดฝ่ายหนึ่ง ซึ่งหมายถึงการใช้อำนาจนิติบัญญัติที่ชอบธรรม\r\n3. มีมติที่เป็นธรรม ผู้ปกครองรัฐจะต้องมีความเที่ยงธรรมตัดสินใจในอันจะทำหรือไม่ทำการใดๆ ต้องอาศัยมติของสังคมที่ชอบธรรมได้แก่ความเห็นของประชาชนเป็นหลัก เพื่อรักษา มิตรภาพ ภารดรภาพ สิทธิเสรีภาพของประชาชน ซึ่งหมายถึงการใช้อำนาจตุลาการที่ชอบธรรม",
    source:
      "สุริยา รักษาเมือง มหาจุฬาลงกรณ์ราชวิทยาลัย. (2561). ธรรมาธิปไตย : อุดมคติเพื่อการสร้างความสมดุลแห่งอำนาจในการปกครองรัฐ, 30 กันยายน 2562. file:///C:/Users/admin/Downloads/161911-Article%20Text-448438-1-10-20181222.pdf",
    sappear: "",
    mappear: 1,
    rappear: 1,
    firstalpha: "ร"
  },
  {
    keyword: "รัฐบาลดิจิทัล",
    meaning:
      "การนำเทคโนโลยีดิจิทัลมาใช้เป็นเครื่องมือในการบริหารงาน ภาครัฐและการบริการสาธารณะ โดยปรับปรุงการบริหารจัดการและบูรณาการข้อมูลภาครัฐและการทำงานให้มีความสอดคล้องและเชื่อมโยงเข้าด้วยกันอย่างมั่นคงปลอดภัยและมีธรรมาภิบาล เพื่อเพิ่มประสิทธิภาพ และอำนวยความสะดวกในการให้บริการประชาชน ในการเปิดเผยข้อมูลภาครัฐต่อสาธารณชน และสร้างการมีส่วนร่วมของทุกภาคส่วน",
    source:
      "พระราชบัญญัติการบริหารงานและการให้บริการภาครัฐผ่านระบบดิจิทัล พ.ศ. 2562 (2562, 22 พฤษภาคม).ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 67 ก หน้า 57.  http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/067/T_0057.PDF",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "รัฐบาลอิเล็กทรอนิกส์",
    meaning:
      "การนำระบบเทคโนโลยีสารสนเทศและการสื่อสารมาประยุกต์ใช้ในองค์การ เพื่อพัฒนาระบบการบริหารจัดการและระบบการให้บริการของหน่วยงานภาครัฐให้มีประสิทธิภาพ โปร่งใส และสามารถตรวจสอบได้ ",
    source:
      "สำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน).  การเปลี่ยนภาครัฐสู่ยุคดิจิทัล, 2 กันยายน 2562. https://www.dga.or.th/upload/download/file_74d73af09053ed5071f9aa5c539ba74c.pdf",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "รัฐประหาร",
    meaning: "หมายถึงการใช้กำลังเปลี่ยนแปลงคณะรัฐบาลโดยฉับพลัน ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. รัฐประหาร. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ร"
  },
  {
    keyword: "รัฐวิสาหกิจ",
    meaning:
      "1. องค์การของรัฐบาลตามกฎหมายว่าด้วยการจัดตั้งองค์การของรัฐบาล กิจการของรัฐซึ่งมีกฎหมายจัดตั้งขึ้น หรือหน่วยงานธุรกิจที่รัฐบาลเป็นเจ้าของ\r\n2. บริษัทจํากัดหรือบริษัทมหาชนจํากัดที่ส่วนราชการหรือรัฐวิสาหกิจตาม 1 มีทุนรวมอยู่ด้วยเกินร้อยละห้าสิบ\r\n3. บริษัทจํากัดหรือบริษัทมหาชนจํากัดที่ส่วนราชการและรัฐวิสาหกิจตาม 1 หรือ 2 หรือที่รัฐวิสาหกจตาม 1 และ 2 หรือที่รัฐวิสาหกิจตาม 2 มีทุนรวมอยู่ด้วยเกินร้อยละห้าสิบ",
    source:
      "พระราชบัญญัติวิธีการงบประมาณ พ.ศ. 2561. (2561,17 พฤศจิกายน) ราชกิจจานุเบกษา. เล่มที่ 135 ตอนที่ 92 ก หน้า 3 http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/092/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "รัฐสภา",
    meaning:
      "ที่ประชุมระดับชาติของสภาผู้แทนราษฎรและวุฒิสภา ซึ่งมีอำนาจทางนิติบัญญัติ  ทำหน้าที่ออก\r\nกฎหมาย ควบคุม  ดูแลการบริหารราชการแผ่นดินของคณะรัฐมนตรี และให้ความเห็นชอบในเรื่องสำคัญของประเทศ เช่น การประกาศสงคราม  การทำหนังสือสัญญาระหว่างประเทศ.",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2555). รัฐสภา, 29 สิงหาคม 2562. \r\nhttp://www.royin.go.th/?knowledges=%E0%B8%A3%E0%B8%B1%E0%B8%90%E0%B8%AA%E0%B8%\r\nA0%E0%B8%B2-%E0%B9%94-%E0%B8%95%E0%B8%B8%E0%B8%A5%E0%B8%B2%E0%B8%84%E0%\r\nB8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%95",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ร"
  },
  {
    keyword: "รากเหง้า",
    meaning: "ต้นเหตุ เช่น โลภ โกรธ หลง เป็นรากเหง้าของความชั่วทั้งปวง",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วิจารณญาณ. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 4,
    mappear: 15,
    rappear: 5,
    firstalpha: "ร"
  },
  {
    keyword: "ราชการส่วนกลาง",
    meaning:
      "การปกครอง ดูแล และการปฏิบัติภารกิจของรัฐในฐานะเป็นศูนย์กลางของการบริหารราชการแผ่นดิน โดยจัดแบ่งองค์กรในการปฏิบัติหน้าที่เป็นสำนักนายกรัฐมนตรี กระทรวง ทบวง กรม หรือส่วนราชการที่เรียกชื่ออย่างอื่นและมีฐานะเป็นกรม เช่น ราชบัณฑิตยสถาน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ราชการส่วนกลาง. 17 กันยายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "ราชการส่วนท้องถิ่น",
    meaning:
      "การปกครอง ดูแล จัดการ และการให้บริการของรัฐ ที่รัฐกระจายอำนาจให้ประชาชนในท้องถิ่นเข้ามามีส่วนในการดำเนินการ เพื่อสนองความต้องการส่วนรวมของประชาชนในท้องที่นั้น โดยจัดเป็นองค์กรในรูปแบบต่าง ๆ คือ องค์การบริหารส่วนจังหวัด เทศบาล องค์การบริหารส่วนตำบล และรูปแบบอื่นที่มีกฎหมายจัดตั้งขึ้นเป็นการเฉพาะ เช่น กรุงเทพมหานคร เมืองพัทยา",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ราชการส่วนท้องถิ่น,17 กันยายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "ราชการส่วนภูมิภาค",
    meaning:
      "การปกครอง ดูแล จัดการ และการปฏิบัติภารกิจของรัฐ ที่แยกไปดำเนินงานในพื้นที่นอกเขตนครหลวง เพื่ออำนวยความสะดวกแก่ประชาชนในท้องที่ในฐานะตัวแทนของราชการบริหารส่วนกลาง โดยแบ่งเขตการดำเนินงานออกเป็น จังหวัด อำเภอ ตำบล และหมู่บ้าน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ราชการส่วนภูมิภาค.17 กันยายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "ราชกิจจานุเบกษา",
    meaning:
      "สิ่งพิมพ์ของทางราชการที่จัดให้มีขึ้นเป็นการเฉพาะเพื่อเป็นที่ประกาศข้อมูลข่าวสารของทางราชการที่ประสงค์จะให้ประชาชนได้ทราบ เช่น กฎหมาย ประกาศคนล้มละลาย การจัดตั้งห้างหุ่นส่วนบริษัท\r\n     ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ราชกิจจานุเบกษา. 16 กันยายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ร"
  },
  {
    keyword: "ราชประชาสมาสัย",
    meaning: "พระราชาและประชาชนย่อมพึ่งพาอาศัยกัน",
    source:
      "จรูญ ปิรยะวราภรณ์ นายแพทย์ทรงคุณวุฒิ กรมควบคุมโรค กระทรวงสาธารณสุข. (2552). \r\nราชประชาสมาสัย 50 ปีแห่งการสนองพระราชปณิธาน, 29 สิงหาคม 2562. \r\nhttp://www.rdpb.go.th/rdpb/upload/document/%E0%B8%A3%E0%B8%B2%E0%B8%8A%E0%B8%\r\n9B%E0%B8%A3%E0%B8%B0%E0%B8%8A%E0%B8%B2%E0%B8%AA%E0%B8%A1%E0%B8%B2%\r\nE0%B8%AA%E0%B8%B1%E0%B8%A2%20%E0%B9%95%E0%B9%90%20%E0%B8%9B%E0%B8%\r\nB5%E0%B9%81%E0%B8%AB%E0%B9%88%E0%B8%87%E0%B8%81%E0%B8%B2%E0%B8%A3%\r\nE0%B8%AA%E0%B8%99%E0%B8%AD%E0%B8%87%E0%B8%9E%E0%B8%A3%E0%B8%B0%E0%\r\nB8%A3%E0%B8%B2%E0%B8%8A.pdf",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ร"
  },
  {
    keyword: "รายได้ประชาชาติ (ตัวชี้วัด)",
    meaning:
      "ข้อมูลแสดงภาพระบบเศรษฐกิจของประเทศไทย โดยมีกรอบแนวคิดตามมาตรฐานสากล ซึ่งมีการพัฒนามาเป็นลำดับ โดยมีรูปแบบการนําเสนอข้อมูล ประกอบด้วยบัญชีมาตรฐาน 6 บัญชี ได้แก่ \r\n(1) บัญชีการผลิต (Domestic Product) \r\n(2) บัญชีรายได้ประชาชาติ (National Income)\r\n(3) บัญชีการสะสมทุน (Domestic Capital Formation)\r\n(4) บัญชีภาคครัวเรือนและสถาบันไม่แสวงกําไร (Households and Private Non-profit Institutions)\r\n(5) บัญชีภาครัฐบาล (General Government)\r\n(6) บัญชีต่างประเทศ (External Transaction) ",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ (2531), กรอบแนวคิด สถิติรายได้ประชาชาติรายปีของประเทศไทย. http://www.nesdc.go.th/article_attach/2009static.pdf",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "ร"
  },
  {
    keyword: "รูปธรรม",
    meaning:
      "1. สิ่งที่รู้ได้ทางตา หู จมูก ลิ้น กาย อันได้แก่ รูป เสียง กลิ่น รส และสิ่งที่สามารถสัมผัสได้ด้วยกาย, คู่กับ นามธรรม คือสิ่งที่รู้ได้เฉพาะทางใจเท่านั้น\r\n2. สิ่งที่สามารถแสดงออกมาให้ปรากฏเป็นจริงเป็นจังมิใช่เป็นเพียงทฤษฎีเท่านั้น, สิ่งที่สามารถปฏิบัติได้, เช่น ต้องทำโครงการพัฒนาชนบทให้เป็นรูปธรรมด้วยการจัดให้มีนํ้ากินนํ้าใช้เป็นต้น",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. รูปธรรม. 5 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ร"
  },
  {
    keyword: "ล้มละลาย",
    meaning: "สิ้นเนื้อประดาตัว, หมดทรัพย์สมบัติของตัว\r\n",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ล้มละลาย. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/\r\n",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ล"
  },
  {
    keyword: "วนเกษตร",
    meaning:
      "รูปแบบความสัมพันธ์ของการอยู่ร่วมกันระหว่างการใช้ที่ดินเพื่อการเกษตรและพื้นที่ป่าไม้อย่างยั่งยืน โดยการปลูกพืชและเลี้ยงสัตว์จะต้องมีความสอดคล้องเกื้อกูลกับระบบนิเวศป่าไม้ในท้องถิ่น วนเกษตรเป็นรูปแบบที่พัฒนาคุณภาพชีวิตของเกษตรกร เกิดการเพิ่มขึ้นของผลผลิตพืชและสัตว์ เน้นการมีกินมีใช้ภายในครัวเรือน มีการนำทรัพยากรธรรมชาติที่มีอยู่มาใช้ประโยชน์ได้อย่างมีประสิทธิภาพ มีการดำรงชีวิตที่ผสมผสาน กลมกลืนกับทรัพยากรธรรมชาติและสิ่งแวดล้อม มีการปลูกพืชพรรณสมุนไพรชนิดต่างๆ ก่อให้เกิดอาหาร ยารักษาโรค และสิ่งของใช้สอย มีการสร้างสวัสดิการให้แก่ชีวิตในระยะยาวโดยการปลูกป่า ซึ่งจะได้มีไม้ไว้ใช้ก่อสร้างหรือตัดไปขายเพื่อเป็นรายได้ที่ไม่ต้องลงทุนมาก มีการางแผนการใช้ที่ดินอย่างมีประสิทธิภาพ เพื่อช่วยให้ผลผลิตทาง การเกษตรเพิ่มขึ้น ฟื้นฟูสภาพแวดล้อมและทรัพยากรธรรมชาติ รวมทั้งมีการอนุรักษ์ความหลากหลายทางชีวภาพและพันธุ์พืช สัตว์น้ำ ที่ดำรงอยู่ได้ในระบบนิเวศที่มีความสมดุลทางทรัพยากรธรรมชาติ",
    source:
      "สำนักงานปลัดกระทรวงเกษตรและสหกรณ์. (2559). วนเกษตร, 6 สิงหาคม 2562. https://www.opsmoac.go.th/sustainable_agri-sustainable_agri-preview-382891791794",
    sappear: 2,
    mappear: 3,
    rappear: "",
    firstalpha: "ว"
  },
  {
    keyword: "วนอุทยาน",
    meaning:
      "ป่าสงวนที่มีลักษณะธรรมชาติสวยงาม เช่นมีนํ้าตก ถํ้า และทางราชการได้เข้าไปปรับปรุงตกแต่งสถานที่ให้เป็นที่พักผ่อนหย่อนใจของประชาชน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วนอุทยาน. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ว"
  },
  {
    keyword: "วรรณกรรม",
    meaning:
      "งานนิพนธ์ที่ทำขึ้นทุกชนิด เช่น หนังสือ จุลสาร สิ่งเขียน สิ่งพิมพ์ ปาฐกถา เทศนา คำปราศรัย สุนทรพจน์ และให้หมายความรวมถึงโปรแกรมคอมพิวเตอร์ด้วย\r\n",
    source:
      "พระราชบัญญัติลิขสิทธิ์ พ.ศ. 2537 (2537,21 ธันวาคม) ราชกิจจานุเบกษา.เล่ม 111 ตอนที่ 59 ก  หน้า 2 http://www.ratchakitcha.soc.go.th/DATA/PDF/2537/A/059/1.PDF",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "ว"
  },
  {
    keyword: "วัฏจักร ",
    meaning:
      "ช่วงระยะเวลาของเหตุการณ์หรือกิจกรรมชุดหนึ่ง ซึ่งเกิดขึ้นและดำเนินติดต่อกันไปอย่างมีระเบียบจนจบลง ณ จุดเริ่มต้นนั้นอีก เช่น วัฏจักรแห่งฤดูกาล วัฏจักรแห่งพืช.",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วัฏจักร, 21 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ว"
  },
  {
    keyword: "วัฒนธรรม",
    meaning:
      "วิถีการดําเนินชีวิต ความคิด ความเชื่อ คานิยม จารีตประเพณีพิธีกรรม และภูมิปญญา ซึ่งกลุมชนและสังคมได  รวมสรางสรรค สั่งสม ปลูกฝง สืบทอด เรียนรูปรับปรุง และเปลี่ยนแปลง เพื่อใหเกิดความเจริญงอกงาม ทั้งด้านจิตใจและวัตถุ อยางสันติสุขและยั่งยืน",
    source:
      "พระราชบัญญัติวัฒนธรรมแห่งชาติ พ.ศ. 2553. (2553, 12 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 127 ตอนที่ 69 ก หน้า 30. http://www.ratchakitcha.soc.go.th/DATA/PDF/2553/A/069/29.PDF",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "ว"
  },
  {
    keyword: "วัฒนธรรมการทำงานที่มุ่งผลสัมฤทธิ์",
    meaning:
      "การปฏิบัติงานได้ตามมาตรฐาน เกณฑ์ขององค์กร สร้างสรรค์พัฒนาผลงาน หรือกระบวนงานให้บรรลุผลตามเป้าหมาย",
    source:
      "กรมสุขภาพจิต. (2559). การมุ่งผลสัมฤทธิ์ (Achievement Motivation), 12 พฤศจิกายน 2562. https://plan.dmh.go.th/forums/index.php?topic=1031.0",
    sappear: 6,
    mappear: "",
    rappear: "",
    firstalpha: "ว"
  },
  {
    keyword: "วัฒนธรรมทางการเมือง",
    meaning:
      "ค่านิยม ความเชื่อ ความรู้สึกนึกคิดเกี่ยวกับกระบวนการทางการเมือง ทัศนคติส่วนบุคคลและความโน้มเอียงที่มีต่อการเมือง ซึ่งจะกำหนดพฤติกรรมของบุคคลในระบบการเมือง วิถีทางการเมือง อุดมการณ์ทางการเมือง และครอบคลุมถึงความชอบธรรมในการปกครอง อํานาจอธิปไตย ความเป็นชาติ การปกครองโดยยึดหลักกฎหมาย และมติมหาชน",
    source:
      "นายอริย์ธัช แก้วเกาะสะบ้า วิทยากรชํานาญการพิเศษ สำนักวิชาการ สำนักงานเลขาธิการสภาผู้แทนราษฎร. (2669, 9 กันยายน) วัฒนธรรมทางการเมืองแบบประชาธิปไตย, 6 ธันวาคม 2562. https://library2.parliament.go.th/ejournal/content_af/2559/sep2559-1.pdf",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ว"
  },
  {
    keyword: "วัตถุดิบพลังงานทดแทน",
    meaning:
      " พลังงานทุกชนิดที่นำมาใช้ทดแทนน้้ามันเชื้อเพลิง\r\nประกอบด้วย\r\n1. พลังงานที่ใช้แล้วหมดไปหรือต้องใช้ระยะเวลายาวนานในการเกิดทดแทน\r\nเช่น ถ่านหิน ก๊าซธรรมชาติ หินน้้ามันนิวเคลียร์ เป็นต้น\r\n2. พลังงานที่สามารถหมุนเวียนกลับมาใช้ใหม่ได้ในระยะเวลาสั้นๆ เช่น ลม น้้า แสงอาทิตย์ ชีวมวล ก๊าซชีวภาพ ขยะ เชื้อเพลิงชีวภาพ คลื่นทะเล เป็นต้น",
    source:
      "กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน กระทรวงพลังงาน. ชี้แจงหลักเกณฑ์และการจัดทำเอกสารการประกวด, 6 ธันวาคม 2562. http://www.able.co.th/TEA/TEA2016/repalcement.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ว"
  },
  {
    keyword: "วัตถุอันตราย",
    meaning:
      "วัตถุระเบิดได้ วัตถุไวไฟ วัตถุออกซิไดซ์ และวัตถุ\r\nเปอร์ออกไซด์ วัตถุมีพิษ วัตถุที่ทำให้เกิดโรค วัตถุกัมมันตรังสี วัตถุที่ก่อให้เกิดการเปลี่ยนแปลงทาง\r\nพันธุกรรม วัตถุกัดกร่อน วัตถุที่ก่อให้เกิดการระคายเคือง วัตถุอย่างอื่นไม่ว่าจะเป็นเคมีภัณฑ์ หรือสิ่ง\r\nอื่นใดที่อาจทำให้เกิดอันตรายแก่บุคคล สัตว์ พืช ทรัพย์ หรือสิ่งแวดล้อม",
    source:
      "พระราชบัญญัติส่งเสริมและรักษาคุณภาพสิ่งแวดล้อมแห่งชาติ พ.ศ. 2535. (2535, 4 เมษายน). ราชกิจจานุเบกษา. เล่ม 109 ตอนที่ 17 หน้า 3.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/037/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ว"
  },
  {
    keyword: "วัยทำงาน",
    meaning:
      "วัยแรงงาน 15-59 ปี เป็นวัยที่ก่อให้เกิดผลผลิตทางด้านเศรษฐกิจ และมีส่วนสำคัญต่อฐานะทางเศรษฐกิจของประเทศ ในสัดส่วนที่สูงกว่าวัยอื่นๆ (ร้อยละ 67) ",
    source:
      'สำนักงานสถิติแห่งชาติ. "วัยทำงานกับการดูแลสุขภาพ...”, 16 กันยายน 2562. http://www.nso.go.th/sites/2014/Pages/%E0%B8%9A%E0%B8%A3%E0%B8%B4%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%AA%E0%B8%96%E0%B8%B4%E0%B8%95%E0%B8%B4%20%E0%B8%9A%E0%B8%97%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B9%80%E0%B8%94%E0%B9%88%E0%B8%99/%E0%B8%A7%E0%B8%B1%E0%B8%A2%E0%B8%97%E0%B8%B3%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B8%81%E0%B8%B1%E0%B8%9A%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%94%E0%B8%B9%E0%B9%81%E0%B8%A5%E0%B8%AA%E0%B8%B8%E0%B8%82%E0%B8%A0%E0%B8%B2%E0%B8%9E.aspx',
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ว"
  },
  {
    keyword: "วัสดุชีวภาพ",
    meaning:
      "วัสดุที่นำมาใช้กับระบบชีวภาพของสิ่งมีชีวิตทั้งระบบหรือบางส่วนของระบบ วัสดุนี้อาจได้มาจากการสังเคราะห์หรือจากธรรมชาติที่อาจเป็นวัสดุโลหะเซรามิกส์พอลิเมอร์ก็ได้ แต่ต้องมีสมบัติความเข้ากันได้ทางชีวภาพ (biocompatibility) นอกเหนือจากสมบัติอื่น ๆ ที่ในตัววัสดุนั้น ๆ มีอยู่แล้ว เช่น ความยืดหยุ่น ความแข็งแรง น้ำหนักเบา เป็นต้น ในยุคปัจจุบันนอกจากจะนำวัสดุชีวภาพมาใช้ซ่อมแซมหรือทดแทนเนื้อเยื่อที่ถูกทำลายซึ่งเป็นประโยชน์ในด้านการแพทย์แล้ว มันยังถูกนำมาใช้ในด้านความงาม เช่น ใช้เป็นวัสดุเสริมทรวงอกได้อีกด้วย",
    source:
      "ประยูร ส่งสิริฤทธิกุล. เทคโนโลยีวัสดุ+วัสดุขั้นสูง. มหาวิทยาลัยเทคโนโลยีสุรนารี,  \r\n4 กรกฎาคม 2562. http://science.sut.ac.th/physics/Doc/Man%20&%20Tec%2008%20-%20Materials%20Technology%20-%20Advanced%20Mat%20(Slide).pdf",
    sappear: 2,
    mappear: 4,
    rappear: "",
    firstalpha: "ว"
  },
  {
    keyword: "วัสดุย่อยสลายยาก",
    meaning:
      "มูลฝอยที่ย่อยสลายได้ยากหรืออาจจะย่อยสลายได้เองตามธรรมชาติ  แต่ไม่คุ้มค่ากับต้นทุนในการนำกลับมาทำเป็นผลิตภัณฑ์ใหม่โดยผ่านกรรมวิธีการผลิตทางอุตสาหกรรม  เช่น  กล่องบรรจุนมพร้อมดื่ม  โฟม  ซองหรือถุงพลาสติกสำหรับบรรจุอาหารด้วยวิธีสูญญากาศ  ซองหรือถุงพลาสติกสำหรับบรรจุเครื่องอุปโภคด้วยวิธีรีดความร้อน  เป็นต้น",
    source:
      "กรมควบคุมมลพิษ กระทรวงทรัพยากรธรรมชาติและสิ่งแวดล้อม. ปัญหาสิ่งแวดล้อมจากขยะมูลฝอย, 12 พฤศจิกายน 2562. http://www.pcd.go.th/info_serv/waste_rubbish.htm",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ว"
  },
  {
    keyword: "ว่างงาน",
    meaning:
      "การที่ผู้ประกันตนต้องหยุดงานเนื่องจากนิติสัมพันธ์ระหว่างนายจ้างและลูกจ้างตามสัญญาจ้างแรงงานสิ้นสุดลง",
    source:
      "พระราชบัญญัติประกันสังคม พ.ศ. 2533 (2533,1 กันยายน)  ราชกิจจานุเบกษา. เล่ม 107 ตอนที่ 161 ก หน้า 5 http://www.ratchakitcha.soc.go.th/DATA/PDF/2533/A/161/1.PDF",
    sappear: "",
    mappear: 17,
    rappear: "",
    firstalpha: "ว"
  },
  {
    keyword: "วาตภัย",
    meaning: "ภัยอันตรายที่เกิดจากพายุ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วาตภัย. 18 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ว"
  },
  {
    keyword: "วิจารณญาณ",
    meaning: "ปัญญาที่สามารถรู้หรือให้เหตุผลที่ถูกต้องได้",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วิจารณญาณ. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ว"
  },
  {
    keyword: "วินัยการเงินการคลังของรัฐ",
    meaning:
      "วินัยการคลังเป็นการควบคุมการใช้จ่ายและผลการดำเนินงานทางการคลังของรัฐบาล อาทิ รายจ่าย การก่อหนี้ ตลอดจนภาระผูกพันทางงบประมาณอื่นของรัฐบาล ฯลฯ เพื่อให้เป็นไปตามระดับที่กฎหมายกำหนด และไม่เป็นภาระต่องบประมาณในอนาคต",
    source:
      "เจตน์  ดิษฐอุดม สถาบันพระปกเกล้า. วินัยการคลัง, 11 กันยายน 2562. http://wiki.kpi.ac.th/index.php?title=%E0%B8%A7%E0%B8%B4%E0%B8%99%E0%B8%B1%E0%B8%A2%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%84%E0%B8%A5%E0%B8%B1%E0%B8%87",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ว"
  },
  {
    keyword: "วินิจฉัย",
    meaning: "ตัดสิน, ชี้ขาด,ไตร่ตรอง, ใคร่ครวญ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วินิจฉัย. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ว"
  },
  {
    keyword: "วิสัยทัศน์",
    meaning: "การมองการณ์ไกล, วิทัศน์",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วิสัยทัศน์, 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 5,
    mappear: 15,
    rappear: 1,
    firstalpha: "ว"
  },
  {
    keyword: "วิสามัญฆาตกรรม",
    meaning:
      "การสังหารชีวิตผู้กระทำผิดกฎหมายอาญาร้ายแรง โดยเจ้าพนักงานไม่มีเจตนาที่จะฆ่าผู้กระทำความผิด เพียงแต่ใช้สิทธิในการป้องกันตนเองเนื่องจากผู้กระทำผิดขัดขืนการจับกุมด้วยการใช้อาวุธร้ายแรงซึ่งอาจเป็นอันตรายต่อเจ้าพนักงานหรือผู้บริสุทธิ์ได้",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2554). วิสามัญฆาตกรรม, 26 กันยายน 2562. http://www.royin.go.th/?knowledges=%E0%B8%A7%E0%B8%B4%E0%B8%AA%E0%B8%B2%E0%B8%A1%E0%B8%B1%E0%B8%8D%E0%B8%86%E0%B8%B2%E0%B8%95%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1-%E0%B9%92%E0%B9%90-%E0%B8%A1%E0%B8%B5%E0%B8%99%E0%B8%B2%E0%B8%84%E0%B8%A1",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ว"
  },
  {
    keyword: "วิสาหกิจ",
    meaning:
      "กิจการผลิตสินค้า กิจการให้บริการ กิจการค้าส่ง กิจการค้าปลีก หรือกิจการอื่นตามที่รัฐมนตรีประกาศในราชกิจจานุเบกษา",
    source:
      "พระราชบัญญัติส่งเสริมวิสาหกิจขนาดกลางและขนาดย่อม พ.ศ. 2543. (2543,17 กุมภาพันธ์). ราชกิจจานุเบกษา. เล่ม 117 ตอนที่ 9 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/00018688.PDF",
    sappear: "",
    mappear: 8,
    rappear: 3,
    firstalpha: "ว"
  },
  {
    keyword: "วิสาหกิจเพื่อสังคม",
    meaning:
      "บริษัท ห้างหุ้นส่วนนิติบุคคล หรือนิติบุคคลอื่น ที่ตั้งขึ้นตามกฎหมายไทย ซึ่งดำเนินกิจการเกี่ยวกับการผลิต การจำหน่ายสินค้าหรือการบริการ โดยมีวัตถุประสงค์เพื่อสังคมเป็นเป้าหมายหลักของกิจการ และได้รับการจดทะเบียนตามพระราชบัญญัติส่งเสริมวิสาหกิจเพื่อสังคม พ.ศ. ๒๕๖๒",
    source:
      "พระราชบัญญัติส่งเสริมวิสาหกิจเพื่อสังคม พ.ศ. 2562 (2562, 19 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 67 ก หน้า 33. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/067/T_0032.PDF",
    sappear: "2,4",
    mappear: "8,10,16",
    rappear: "5,9",
    firstalpha: "ว"
  },
  {
    keyword: "วิสาหกิจเริ่มต้น",
    meaning:
      "กิจการขนาดเล็กที่กำลังเริ่มเติบโตและใช้นวัตกรรมในการผลิต\r\nสินค้าและบริการ อย่างไรก็ตาม นิยามของวิสาหกิจเริ่มต้น นั้น ยังไม่มีความชัดเจนเท่าที่ควร แต่เมื่อพิจารณากำหนดนิยาม\r\nนี้ในแต่ละประเทศ จะเห็นได้ว่า มีหลักเกณฑสำคัญที่ใช้ประกอบในการพิจารณา อยู่ 3 ประการ คือ เกณฑ์ลักษณะของกิจการ ระยะเวลาการดำเนินกิจการ และผลประกอบการต่อปีของวิสาหกิจเริ่มต้น",
    source:
      "สำนักงานนวัตกรรมแห่งชาติ, Thailand Toward Startup Nation, 24 96]k8, 2561.\r\nhttps://www.startupthailand.org/wp-content/uploads/2018/11/white-paper.pdf",
    sappear: 2,
    mappear: 4,
    rappear: "",
    firstalpha: "ว"
  },
  {
    keyword: "วิสาหกิจขนาดกลาง",
    meaning:
      "กิจการที่มีลักษณะ ดังนี้ \r\n1. กิจการผลิตสินค้าที่มีจำนวนการจ้างงานเกินกว่า 50 คน แต่ไม่เกิน 200 คน หรือมีรายได้ต่อปีเกินกว่าหนึ่งร้อยล้านบาทแต่ไม่เกินห้าร้อยล้านบาท \r\n2. กิจการให้บริการ กิจการค้าส่ง หรือกิจการค้าปลีก ที่มีจำนวนการจ้างงานเกินกว่า 30 คน แต่ไม่เกิน 100 คน หรือมีรายได้ต่อปีเกินกว่าห้าสิบล้านบาทแต่ไม่เกินสามร้อยล้านบาท",
    source:
      "กฎกระทรวงกำหนดลักษณะของวิสาหกิจขนาดกลางและขนาดย่อม พ.ศ. 2562. (2563, 7 มกราคม 2563). ราชกิจจานุเบกษา. เล่ม 137 ตอนที่ 1 ก หน้า 1.  http://www.ratchakitcha.soc.go.th/DATA/PDF/2563/A/001/T_0001.PDF",
    sappear: "",
    mappear: 8,
    rappear: 5,
    firstalpha: "ว"
  },
  {
    keyword: "วิสาหกิจขนาดกลางและขนาดย่อม",
    meaning:
      "วิสาหกิจขนาดกลางหรือวิสาหกิจขนาดย่อม ได้แก่ วิสาหกิจที่มีจำนวน การจ้างงาน รายได้ มูลค่าสินทรัพย์ถาวร หรือทุนจดทะเบียนที่ชำระแล้ว ตามหลักเกณฑ์ที่กำหนด ในกฎกระทรวง\r\nวิสาหกิจขนาดย่อม ได้แก่ กิจการที่มีลักษณะดังต่อไปนี้\r\n- กิจการผลิตสินค้า ที่มีจำนวนการจ้างงานไม่เกิน 50 คน หรือมีมูลค่าสินทรัพย์ถาวรไม่เกิน 50 ล้านบาท\r\n- กิจการให้บริการที่มีจำนวนการจ้างงานไม่เกิน 50 คน หรือมีมูลค่าสินทรัพย์ถาวรไม่เกิน 50 ล้านบาท\r\n- กิจการค้าส่งที่มีจำนวนการจ้างงานไม่เกิน 25 คน หรือมีมูลค่าสินทรัพย์ถาวรไม่เกิน 50 ล้านบาท\r\n- กิจการค้าปลีกที่มีจำนวนการจ้างงานไม่เกิน 15 คน หรือมีมูลค่าสินทรัพย์ถาวรไม่เกิน 30 ล้านบาท\r\nวิสาหกิจขนาดกลาง ได้แก่ กิจการที่มีลักษณะดังต่อไปนี้\r\n- กิจการผลิตสินค้า ที่มีจำนวนการจ้างงานเกินกว่า 50 คน แต่ไม่เกิน 200 คนหรือมีมูลค่าสินทรัพย์ถาวรเกินกว่า 50 ล้านบาท แต่ไม่เกิน 200 ล้านบาท\r\n- กิจการให้บริการ ที่มีจำนวนการจ้างงานเกินกว่า 50 คน แต่ไม่เกิน 200 คนหรือมีมูลค่าสินทรัพย์ถาวรเกินกว่า 50 ล้านบาท แต่ไม่เกิน 200 ล้านบาท\r\n- กิจการค้าส่ง ที่มีจำนวนการจ้างงานเกินกว่า 25 คน แต่ไม่เกิน 50 คน หรือมีมูลค่าสินทรัพย์ถาวรเกินกว่า 50 ล้านบาท แต่ไม่เกิน 100 ล้านบาท\r\n- กิจการค้าปลีก ที่มีจำนวนการจ้างงานเกินกว่า 15 คน แต่ไม่เกิน 30 คน หรือมีมูลค่าสินทรัพย์ถาวรเกินกว่า 30 ล้านบาท แต่ไม่เกิน 60 ล้านบาท",
    source:
      "​พระราชบัญญัติส่งเสริมวิสาหกิจขนาดกลางและขนาดย่อม (ฉบับที่ 2) พ.ศ. 2561 (2561,19 เมษายน). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 27 ก หน้า 24.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/027/24.PDF\r\nกฎกระทรวงกำหนดจำนวนการจ้างงานและมูลค่าสินทรัพย์ถาวรของวิสาหกิจขนาดกลางและขนาดย่อม พ.ศ. 2545 (2545,20 กันยายน). ราชกิจจานุเบกษา. เล่ม 119 ตอนที่ 93 ก หน้า 17. \r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/00102303.PDF\r\nสำนักงานส่งเสริมวิสาหกิจขนาดกลางและขนาดย่อม. https://www.sme.go.th/upload/mod_download/%E0%B8%99%E0%B8%B4%E0%B8%A2%E0%B8%B2%E0%B8%A1%20SMEs.pdf\r\n",
    sappear: "",
    mappear: 8,
    rappear: 3,
    firstalpha: "ว"
  },
  {
    keyword: "วิสาหกิจขนาดย่อม",
    meaning:
      "กิจการที่มีลักษณะ ดังนี้ \r\n1. กิจการผลิตสินค้าที่มีจำนวนการจ้างงานไม่เกิน 50 คนหรือมีรายได้ต่อปีไม่เกินหนึ่งร้อยล้านบาท \r\n2. กิจการให้บริการ กิจการค้าส่ง หรือกิจการค้าปลีก ที่มีจำนวนการจ้างงานไม่เกิน 30 คนหรือรายได้ต่อปีไม่เกินห้าสิบล้านบาท",
    source:
      "กฎกระทรวงกำหนดลักษณะของวิสาหกิจขนาดกลางและขนาดย่อม พ.ศ. 2562. (2563, 7 มกราคม 2563). ราชกิจจานุเบกษา. เล่ม 137 ตอนที่ 1 ก หน้า 1.  http://www.ratchakitcha.soc.go.th/DATA/PDF/2563/A/001/T_0001.PDF",
    sappear: "",
    mappear: 8,
    rappear: 5,
    firstalpha: "ว"
  },
  {
    keyword: "วิสาหกิจชุมชน",
    meaning:
      "กิจการของชุมชนเกี่ยวกับการผลิตสินค้า การให้บริการ หรือการอื่น ๆ ที่ดำเนินการโดยคณะบุคคลที่มีความผูกพัน มีวิถีชีวิตร่วมกันและรวมตัวกันประกอบกิจการดังกล่าว ไม่ว่าจะเป็นนิติบุคคลในรูปแบบใดหรือไม่เป็นนิติบุคคล เพื่อสร้างรายได้และเพื่อการพึ่งพาตนเองของครอบครัว ชุมชน และระหว่างชุมชน",
    source:
      "พระราชบัญญัติส่งเสริมวิสาหกิจชุมชน พ.ศ. 2548. (2548, 18 มกราคม). ราชกิจจานุเบกษา. เล่ม 122 ตอนที่ 6 ก หน้า 1.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/0A/00152770.PDF",
    sappear: "2,5",
    mappear: "4,8,16",
    rappear: "5,6,9",
    firstalpha: "ว"
  },
  {
    keyword: "วุฒิสภา",
    meaning:
      "สภานิติบัญญัติสภาหนึ่ง อาจประกอบด้วยสมาชิกที่มาจากการแต่งตั้ง เลือกตั้ง หรือแต่งตั้งและเลือกตั้งผสมกัน มีหน้าที่กลั่นกรองกฎหมายและหน้าที่อื่นตามที่รัฐธรรมนูญกำหนด",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ.2554. วุฒิสภา. 6 มิถุนายน 2562. http://www.royin.go.th/dictionary/index.php",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ว"
  },
  {
    keyword: "ศักดิ์ศรีความเป็นมนุษย์",
    meaning:
      "คุณสมบัติ จิตใจ สิทธิเฉพาะตัวที่พึงสงวนของมนุษย์ทุกคน และรักษาไว้มิให้บุคคลอื่นมาล่วงละเมิดได้ การถูกละเมิดศักดิ์ศรีความเป็นมนุษย์จึงเป็นสิ่งที่ต้องได้รับการคุ้มครอง และได้รับความยุติธรรม",
    source:
      "ดรงสุรชัย ศรีสารคาม ที่ปรึกษาประจำสำนักนายกรัฐมนตรี. ศักดิ์ศรีความเป็นมนุษย์, 19 พฤศจิกายน 2562. http://elibrary.constitutionalcourt.or.th/document/documents/documents/Individual_Study_224.pdf",
    sappear: "4,6",
    mappear: "",
    rappear: 1,
    firstalpha: "ศ"
  },
  {
    keyword: "ศักยภาพ",
    meaning:
      "ภาวะแฝง, อำนาจหรือคุณสมบัติที่มีแฝงอยู่ในสิ่งต่าง ๆ อาจทำให้พัฒนาหรือให้ปรากฏเป็นสิ่งที่ประจักษ์ได้ เช่น เขามีศักยภาพในการทำงานสูง น้ำตกขนาดใหญ่มีศักยภาพในการให้พลังงานได้มาก",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ.2554. ศักยภาพ. 6 มิถุนายน 2562. http://www.royin.go.th/dictionary/index.php",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ศ"
  },
  {
    keyword: "ศัตรูพืช",
    meaning:
      "หมายความว่า สิ่งซึ่งเป็นอันตรายแก่พืช เช่น เชื้อโรคพืช แมลง สัตว์ หรือพืชที่อาจก่อให้เกิดความเสียหายแก่พืช",
    source:
      "พระราชบัญญัติกักพืช พ.ศ. 2507. (2507, 21 มีนาคม). ราชกิจจานุเบกษา. เล่มที่ 81 ตอนที่ 27 หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2507/A/027/1.PDF",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ศ"
  },
  {
    keyword: "ศาลชํานัญพิเศษ",
    meaning:
      "1. ศาลทรัพย์สินทางปัญญาและการค้าระหว่างประเทศตามกฎหมายว่าด้วยการจัดตั้งศาลทรัพย์สินทางปัญญาและการค้าระหว่างประเทศและวิธีการพิจารณาคดีทรัพย์สินทางปัญญาและการค้าระหว่างประเทศ\r\n2. ศาลภาษีอากรตามกฎหมายว่าด้วยการจัดตั้งศาลภาษีอากรและวิธีพิจารณาคดีภาษีอากร\r\n3. ศาลแรงงานตามกฎหมายว่าด้วยการจัดตั้งศาลแรงงานและวิธีพิจารณาคดีแรงงาน\r\n4. ศาลล้มละลายตามกฎหมายว่าด้วยการจัดตั้งศาลแรงงานและวิธีพิจารณาคดีล้มละลาย\r\n5. ศาลเยาวชนและครอบครัวตามกฎหมายว่าด้วยศาลเยาวชนและครอบครัวและวิธีพิจารณาคดีเยาวชนและครอบครัว",
    source:
      "พระราชบัญญัติจัดตั้งศาลอุทธรณ์คดีชำนาญพิเศษ พ.ศ. 2558. (2558, 14 ธันวาคม). ราชกิจจานุเบกษา. เล่ม 132 ตอนที่ 120 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2558/A/120/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "ศ"
  },
  {
    keyword: "ศาสตร์พระราชา",
    meaning:
      "องค์ความรู้ที่พระบาทสมเด็จพระปรมินทรมหาภูมิพลอดุลยเดช บรมนาถบพิตร (ร.9) พระราชทานแก่ปวงชนชาวไทย ผ่านโครงการอันเนื่องมาจากพระราชดำาริกว่า 4,000 โครงการ และผ่านศูนย์ศึกษาการพัฒนาอันเนื่องมาจากพระราชดำริ เป็นผลของการทรงงานอย่างหนักตลอดรัชสมัย ๑๙ ของพระองค์ ในการพัฒนาประเทศอย่างยั่งยืน พระองค์ทรงมีหลักในการพัฒนา 3 ขั้นตอน ได้แก่ \r\n1. หลักคิด คือเป้าหมายในการทรงงานเพื่อประโยชน์สุขของประชาชน\r\n2. หลักทฤษฎี คือ แนวคิดและทฤษฎีที่ได้มีการทดสอบและพิสูจน์แล้วและได้พระราชทานสู่การปฏิบัติจริง \r\n3. หลักปฏิบัติ คือ ขั้นตอนของการดำเนินงานโครงการอย่างมีประสิทธิภาพและมีประสิทธิผล ในการดำเนินโครงการได้พระราชทานหลักการ “เข้าใจ เข้าถึงและพัฒนา” เข้าใจ คือ เข้าใจสภาพภูมิประเทศและมนุษย์ เข้าถึง คือ เข้าถึงภูมิสังคมและข้อมูลเพื่อให้การสร้างสรรค์นั้นตอบสนองความต้องการของประชาชน และพัฒนา คือ กำหนดเป็นแนวทางการพัฒนาด้วยความรู้และภูมิปัญญาที่ไม่จำกัดอยู่เพียงมิติใดมิติหนึ่ง รวมถึงการทดลองและปรับปรุงจนได้ผลลัพธ์ที่ยั่งยืนและประยุกต์ใช้ได้ไม่รู้จบ ทั้งนี้ ศาสตร์ของพระราชา ปวงพสกนิกรชาวไทย ได้น้อมนำมาเป็นแบบอย่างที่ดีในการประพฤติตน รวมทั้งรัฐบาลและข้าราชการได้น้อมนำไป\r\nประยุกต์ใช้ในการบริหารราชการแผ่นดิน เพื่อสร้างชาติและพัฒนาประเทศ อย่างสมดุลและยั่งยืนโดยเสมอกัน",
    source:
      "โครงการเฉลิมพระเกียรติของสภานิติบัญญัติแห่งชาติ รวบรวมกฎหมายที่สนับสนุนโครงการอันเนื่องมาจากพระราชดำริ. (2560, 6 เมษายน).  ศาสตร์ของพระราชา,  6 ธันวาคม 2562. https://www.senate.go.th/pdf/the_wisdom_of_the_monarch.pdf",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ศ"
  },
  {
    keyword: "ศิลปกรรม",
    meaning:
      " หมายความว่า งานอันมีลักษณะอย่างหนึ่งอย่างใดหรือหลายอย่างดังต่ไปนี้ \r\n1. งานจิตรกรรม ได้แก่ งานสร้างสรรค์รูปทรงที่ประกอบด้วยเส้น แสง สี หรือสิ่งอื่น อย่างใดอย่างหนึ่งหรือหลายอย่างรวมกัน ลงบนวัสดุอย่างเดียวหรือหลายอย่าง\r\n2. งานประติมากรรม ได้แก่ งานสร้างสรรค์รูปทรงที่เกี่ยวกับปริมาตรที่สัมผัสและจับต้องได้\r\n3. งานภาพพิมพ์ ได้แก่ งานสร้างสรรค์ภาพด้วยกรรมวิธีทางการพิมพ์ และหมายความรวมถึงแม่พิมพ์หรือแบบพิมพ์ที่ใช้ในการพิมพ์ด้วย\r\n4. งานสถาปัตยกรรม ได้แก่ งานออกแบบอาคารหรือสิ่งปลูกสร้าง งานออกแบบตกแต่งภายในหรือภายนอก ตลอดจนบริเวณของอาคารหรือสิ่งปลูกสร้าง หรือการสร้างสรรค์หุ่นจำลองของอาคารหรือสิ่งปลูกสร้าง\r\n5. งานภาพถ่าย ได้แก่ งานสร้างสรรค์ภาพที่เกิดจากการใช้เครื่องมือบันทึกภาพโดยให้แสงผ่านเลนซ์ไปยังฟิล์มหรือกระจก และล้างด้วยน้ำยาซึ่งมีสูตรเฉพาะ หรือด้วยกรรมวิธีใด ๆ อันทำให้เกิดภาพขึ้น หรือการบันทึกภาพโดยเครื่องมือหรือวิธีการอย่างอื่น\r\n6. งานภาพประกอบ แผนที่ โครงสร้าง ภาพร่าง หรืองาน\r\n7. งานศิลปประยุกต์ ได้แก่ งานที่นำเอางานตาม 1 ถึง 6 อย่างใดอย่างหนึ่งหรือหลายอย่างรวมกันไปใช้ประโยชน์อย่างอื่น นอกเหนือจากการชื่นชมในคุณค่าของตัวงานดังกล่าวนั้น เช่น นำไปใช้สอย นำไปตกแต่งวัสดุหรือสิ่งของอันเป็นเครื่องใช้ หรือนำไปใช้เพื่อประโยชน์ทางการค้า\r\nทั้งนี้ ไม่ว่างานตาม 1 ถึง 7 จะมีคุณค่าทางศิลปะหรือไม่ และให้หมายความรวมถึงภาพถ่ายและแผนผังของงานดังกล่าวด้วย\r\n",
    source:
      "พระราชบัญญัติลิขสิทธิ์ พ.ศ. 2537 (2537,21 ธันวาคม) ราชกิจจานุเบกษา.เล่ม 111 ตอนที่ 59 ก  หน้า 2 http://www.ratchakitcha.soc.go.th/DATA/PDF/2537/A/059/1.PDF",
    sappear: "",
    mappear: 6,
    rappear: "",
    firstalpha: "ศ"
  },
  {
    keyword: "ศิลปวัฒนธรรม",
    meaning:
      "สิ่งที่มนุษย์สร้างสรรค์ขึ้นมาด้วยความสามารถและสติปัญญา ศิลปวัฒนธรรมเป็นสิ่งที่แสดงถึงความเจริญงอกงามทั้งทางด้านวัตถุและด้านจิตใจ ซึ่งสิ่งต่างๆ เหล่านั้นได้เป็นมรดกตกทอดมาจนถึงปัจจุบัน",
    source:
      "แหล่งบริการวิชาการและแลกเปลี่ยนเรียนรู้ วสส.ยะลา. (2559). ศิลปวัฒนธรรมของไทย, 5 กรกฎาคม 2562. http://202.183.204.137/km/?p=6939",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ศ"
  },
  {
    keyword: "ศูนย์กลางด้านดิจิทัลของภูมิภาคอาเซียน",
    meaning:
      "หรือ digital hub คือ ศูนย์รวมในการติดต่อสื่อสาร แลกเปลี่ยนข้อมูลสารสนเทศ การดำเนินธุรกิจรวมถึงการดำเนินกิจกรรมที่เกี่ยวข้องกับเทคโนโลยีดิจิทัล เพื่อให้เกิดการเชื่อมโยงถึงกันที่สะดวก รวดเร็ว และมีประสิทธิภาพของศูนย์ข้อมูล ซึ่ง digital hub ในนี้ที่คือศูนย์กลางด้านดิจิทัลที่อยู่ในบริเวณภูมิภาคอาเซียน ",
    source:
      "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม. (2562). นโยบายและแผนระดับชาติว่าด้วยการพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม, 23 กรกฎาคม 2562. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/047/T_0001.PDF",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "ศ"
  },
  {
    keyword: "ศูนย์สารสนเทศพลังงานแห่งชาติ",
    meaning:
      "หน่วยงานกลางด้านพลังงานในการจัดเก็บ รวบรวม วิเคราะห์คาดการณ์อย่างเป็นระบบ น่าเชื่อถือ มีมาตรฐานระดับสากล และมีความเป็นอิสระในการเผยแพร่ข้อมูลเพื่อตอบสนองความต้องการของทุกภาคส่วนที่ต้องการใช้ข้อมูลพลังงาน",
    source:
      "สภาขับเคลื่อนการปฏิรูปประเทศ. (2559). การพัฒนาศูนย์ข้อมูลพลังงานแห่งชาติ, 30 กันยายน 2562. https://www.parliament.go.th/ewtadmin/ewt/parliament_parcy/download/usergroup_disaster/7-5.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ศ"
  },
  {
    keyword: "สกุลเงินดิจิทัล",
    meaning:
      '"สกุลเงินดิจิทัล หรือ คริปโทเคอร์เรนซี (cryptocurrency)" เช่น บิทคอยน์ (Bitcoin) เป็นสกุลเงินใหม่ที่สร้างขึ้นจากกลไกคณิตศาสตร์ที่กำหนดจำนวนไว้จำกัด ต้องใช้ระบบคอมพิวเตอร์ถอดรหัสเพื่อนำเงินออกจากกลไก สกุลเงินใหม่นี้สร้างขึ้นเพื่อลดการรวมศูนย์ของระบบการชำระเงินผ่านสถาบันการเงินให้สามารถกระจายไปยังผู้ใช้ในเครือข่ายสกุลเงินนั้นๆ ได้ โดยใช้เทคโนโลยีบล็อกเชน (blockchain) ติดตามการเคลื่อนไหวของเงินแม้จะไม่มีตัวกลางและสามารถป้องกันการปลอมแปลงได้ด้วย การชำระ/โอนเงินจึงอยู่แค่ภายในเครือข่าย ซึ่งมีข้อดีที่รวดเร็ว ต้นทุนต่ำ และปลอดภัย แต่ธนาคารกลางส่วนใหญ่ยังไม่รับรองว่าบรรดาคริปโทเคอร์เรนซีที่เอกชนสร้างขึ้นมา สามารถใช้ชำระหนี้ได้ตามกฎหมาย คริปโทเคอร์เรนซีจึงทำหน้าที่ของเงินได้ไม่ครบ เพราะยังไม่เป็นสื่อกลางในการชำระเงินและไม่ถูกใช้เป็นหน่วยกำหนดราคาสิ่งของแถมมูลค่ายังผันผวนมาก แต่ถ้าเป็น "สกุลเงินดิจิทัลที่ธนาคารกลางออกใช้ (central bank digital currency: CBDC)" จะมีคุณสมบัติของเงินที่ครบถ้วนเพราะมีมูลค่าแน่นอนใช้แทนสกุลเงินท้องถิ่นได้ตามกฎหมาย',
    source:
      "ฐิติมา ชูเชิด. ธนาคารแห่งประเทศไทย. 'สกุลเงินดิจิทัล' ใกล้ตัวเราแค่ไหน?, 8 กรกฎาคม 2562. https://www.bot.or.th/Thai/ResearchAndPublications/articles/Pages/Article_01Feb2019.aspx",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สงครามตัวแทน",
    meaning:
      "ประเทศมหาอำนาจทั้ง 2 ฝ่ายต่างแข่งขันกัน โดยพยายามสร้างแสนยานุภาพทางการทหารของตนไว้ข่มขู่ฝ่ายตรงข้าม โดยประเทศมหาอำนาจจะไม่ทำสงครามกันโดยตรง แต่จะสนับสนุนให้ประเทศพันธมิตรของตนเข้าทำสงครามแทน",
    source:
      "ญาณิศา โยวัง และ วรรณี วงค์ทอ. สงครามตัวแทน, 8 กรกฎาคม 2562. https://sites.google.com/site/coldwaryanisaandwannee/sngkhram-tawthaen",
    sappear: "",
    mappear: 2,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สถานการณ์ฉุกเฉิน",
    meaning:
      "สถานการณ์อันกระทบหรืออาจกระทบต่อ\r\nความสงบเรียบร้อยของประชาชนหรือเป็นภัยต่อความมั่นคงของรัฐหรืออาจทําให้ประเทศหรือส่วนใด\r\nส่วนหนึ่งของประเทศตกอยู่ในภาวะคับขันหรือมีการกระทําความผิดเกี่ยวกับการก่อการร้ายตามประมวลกฎหมายอาญา การรบหรือการสงคราม ซึ่งจําเป็นต้องมีมาตรการเร่งด่วนเพื่อรักษาไว้ซึ่งการ\r\nปกครองระบอบประชาธิปไตยอันมีพระมหากษัตริย์ทรงเป็นประมุขตามรัฐธรรมนูญแห่งราชอาณาจักร\r\nไทย เอกราชและบูรณภาพแห่งอาณาเขต ผลประโยชน์ของชาติการปฏิบัติตามกฎหมาย ความ\r\nปลอดภัยของประชาชน การดํารงชีวิตโดยปกติสุขของประชาชน การคุ้มครองสิทธิเสรีภาพ ความสงบ\r\nเรียบร้อยหรือประโยชน์ส่วนรวม หรือการป้องปัดหรือแก้ไขเยียวยาความเสียหายจากภัยพิบัติ\r\nสาธารณะอันมีมาอย่างฉุกเฉินและร้ายแรง",
    source:
      "พระราชกำหนดการบริหารราชการในสถานการณ์ฉุกเฉิน พ.ศ. 2548. (2548, 16 กรกฎาคม). ราชกิจจานุเบกษา. เล่ม 122 ตอนที่ 58 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2548/00166932.PDF",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สถานบริการ",
    meaning:
      "สถานบริการสาธารณสุขของรัฐ ของเอกชน และของสภากาชาดไทย\r\nหนวยบริการการประกอบโรคศิลปะสาขาตางๆ และสถานบริการสาธารณสุขอื่นที่คณะกรรมการกําหนดเพิ่มเติม\r\n",
    source:
      "พระราชบัญญัติสุขภาพแห่งชาติ พ.ศ. 2550. (2550, 19 มีนาคม). ราชกิจจานุเบกษา. เล่ม 124 ตอนที่ 16 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2550/A/016/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ส"
  },
  {
    keyword: "สถานพยาบาล",
    meaning:
      "สถานที่รวมตลอดถึงยานพาหนะซึ่งจัดไว้เพื่อการประกอบโรคศิลปะตามกฎหมายว่าด้วยการประกอบโรคศิลปะการประกอบวิชาชีพเวชกรรมตามกฎหมายว่าด้วยวิชาชีพเวชกรรม การประกอบวิชาชีพการพยาบาลและการผดุงครรภ์ตามกฎหมายว่าด้วยวิชาชีพการพยาบาลและการผดุงครรภ์ หรือการประกอบวิชาชีพทันตกรรมตามกฎหมายว่าด้วยวิชาชีพทันตกรรม ทั้งนี้ โดยกระทำเป็นปกติธุระ ไม่ว่าจะได้รับประโยชน์ตอบแทนหรือไม่แต่ไม่รวมถึงสถานที่ขายยาตามกฎหมายว่าด้วยยา ซึ่งประกอบธุรกิจการขายยาโดยเฉพาะ\r\n",
    source:
      "พระราชบัญญัติสถานพยาบาล พ.ศ. 2541 (2541,24 มีนาคม) ราชกิจจานุเบกษา.เล่ม115 ตอนที่ 15 ก  หน้า 32 http://www.ratchakitcha.soc.go.th/DATA/PDF/2541/A/015/32.PDF",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สถานศึกษา",
    meaning:
      "สถานศึกษาตามกฎหมายว่าด้วยการศึกษาแห่งชาติ และ ให้หมายความรวมถึงศูนย์พัฒนาเด็กปฐมวัยด้วย",
    source:
      "พระราชบัญญัติ กองทุนเพื่อความเสมอภาคทางการศึกษา\r\nพ.ศ. 2561. (2561, 13 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 135 ตอนที่ 33 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/033/1.PDF",
    sappear: "",
    mappear: 11,
    rappear: 12,
    firstalpha: "ส"
  },
  {
    keyword: "สถานะสิทธิและคนต่างด้าว",
    meaning:
      "แรงงานต่างด้าวสัญชาติพม่า ลาว และกัมพูชา ที่ได้รับอนุญาตให้ทำงานในประเทศไทย ปัจจุบันมี 3 กลุ่ม คือ\r\n1. กลุ่มแรงงานต่างด้าวสัญชาติพม่า ลาว และกัมพูชาที่หลบหนีเข้าเมืองและได้รับการผ่อนผันให้อยู่อาศัยและทำงานในประเทศไทยเป็นการชั่วคราวตามมติคณะรัฐมนตรี\r\n2. กลุ่มแรงงานต่างด้าวสัญชาติพม่า ลาว และกัมพูชา ที่ได้รับการพิสูจน์สัญชาติ\r\n3. กลุ่มแรงงานต่างด้าวสัญชาติพม่า ลาว และกัมพูชารายใหม่ที่นำเข้ามาทำงานอย่างถูกต้องตามกฎหมายตามบันทึกความเข้าใจว่าด้วยความร่วมมือด้านการจ้างแรงงานระหว่างรัฐ \r\n   แรงงานต่างด้าวที่เข้ามาทำงานในประเทศไทยทุกคนจะได้รับสิทธิในการคุ้มครองแรงงานให้ได้รับสิทธิตามมาตรฐานแรงงานโดยยึดหลักความเสมอภาคและเท่าเทียมกันไม่เลือกปฏิบัติไม่ว่าจะเป็นแรงงานต่างด้าวที่เข้าเมืองถูกกฎหมายหรือลักลอบเข้าเมืองผิดกฎหมาย หากเป็นลูกจ้างตามพระราชบัญญัติคุ้มครองแรงงาน พ.ศ. 2541 ย่อมจะได้รับการคุ้มครองตามกฎหมายเช่นเดียวกับแรงงานไทย ",
    source:
      "สำนักบริหารแรงงานต่างด้าว กรมการจัดหางาน. ข้อควรรู้สำหรับนายจ้างและแรงงานต่างด้าวสัญชาติพม่า ลาว กัมพูชา ที่ทำงานในประเทศไทย, 13 กันยายน 2562. https://www.doe.go.th/prd/assets/upload/files/alien_th/a05187f91b18fa9dbbc55ab3096a824e.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ส"
  },
  {
    keyword: "สถานีจ่ายไฟฟ้า (Substation)",
    meaning:
      "สถานที่ตั้งอุปกรณ์ตัดตอนไฟฟ้าและอุปกรณ์แปลงแรงดันไฟฟ้า เป็นสถานที่ติดตั้งอุปกรณ์ที่ใช้ควบคุมการไหลของพลังงานไฟฟ้า เป็นจุดที่เชื่อมโยงระหว่างสายส่งไฟฟ้าจากจุดต่างๆ ถึงกัน และมีอุปกรณ์สำหรับป้องกันระบบติดตั้งไว้เพื่อตัดสายส่งที่มีปัญหาลัดวงจรออกจากการจ่ายไฟฟ้า",
    source:
      "การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย. (2561). คำศัพท์พลังงานไฟฟ้า, 16 ตุลาคม 2562. https://www.egat.co.th/index.php?option=com_kdglossary&view=glossary&category=3",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ส"
  },
  {
    keyword: "สถานีประจุไฟฟ้าสำหรับรถยนต์ไฟฟ้า Solar Charging Station",
    meaning:
      "การติดตั้งสถานีอัดประจุไฟฟ้า โดยเชื่อมต่อกับระบบโครงข่ายของการไฟฟ้าและมีการติดตั้งระบบผลิตไฟฟ้าแสงอาทิตย์ร่วมกับแบตเตอรี่ที่สถานีอัดประจุไฟฟ้า เพื่อนำพลังงานไฟฟ้าที่ผลิตจากระบบผลิตไฟฟ้าแสงอาทิตย์และถูกเก็บไว้ในแบตเตอรี่ มาใช้ร่วมกับไฟฟ้าที่ซื้อจากการไฟฟ้าเพื่อให้บริการอัดประจุไฟฟ้า",
    source:
      "สำนักงานคณะกรรมการกำกับกิจการพลังงานร่วมกับ มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี. (2561). คู่มือประกอบกิจการสถานีอัดประจุไฟฟ้าสำหรับยานยนต์ไฟฟ้า (EV), 17 กันยายน 2562. http://www.erc.or.th/ERCWeb2/Upload/Document/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%81%E0%B8%AD%E0%B8%9A%E0%B8%81%E0%B8%B4%E0%B8%88%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%AA%E0%B8%96%E0%B8%B2%E0%B8%99%E0%B8%B5%E0%B8%AD%E0%B8%B1%E0%B8%94%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%88%E0%B8%B8%E0%B9%84%E0%B8%9F%E0%B8%9F%E0%B9%89%E0%B8%B2_%E0%B8%89%E0%B8%9A%E0%B8%B1%E0%B8%9A%E0%B8%AA%E0%B8%A1%E0%B8%9A%E0%B8%B9%E0%B8%A3%E0%B8%93%E0%B9%8C.pdf",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ส"
  },
  {
    keyword: "สถาบัน PTB",
    meaning:
      "สถาบันมาตรวิทยาแห่งสหพันธ์สาธารณรัฐเยอรมนี PTB (Physikalisch-Technische Bundesanstalt) ",
    source:
      "สถาบันมาตรวิทยาแห่งชาติ (มว.). (2559). มว. จับมือ PTB NMIJ ดันเวิร์คช็อปพัฒนามาตรวิทยาเอเชีย, 30 สิงหาคม 2562.\r\n http://www.nimt.or.th/main/?p=713",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ส"
  },
  {
    keyword: "สถาบันเกษตรกร",
    meaning:
      "กลุ่มเกษตรกร สหกรณ์การเกษตร ชุมนุมสหกรณ์การเกษตรตามกฎหมายว่าด้วยสหกรณ์",
    source:
      "พระราชบัญญัติการปฏิรูปที่ดินเพื่อเกษตรกรรม พ.ศ.2518 (2518, 5 มีนาคม). ราชกิจจานุเบกษา. เล่ม 92 ตอนที่ 54 หน้า 12. http://www.ratchakitcha.soc.go.th/DATA/PDF/2518/A/054/10.PDF",
    sappear: "",
    mappear: 3,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สถาบันการเงินเฉพาะกิจ",
    meaning:
      "การดำเนินการตามนโยบายของรัฐในการพัฒนาส่งเสริมเศรษฐกิจ และสนับสนุนการลงทุนต่าง ๆ โดยอยู่ภายใต้การกำกับดูแลของกระทรวงการคลัง ซึ่งได้มอบหมายให้ ธปท. ทำหน้าที่ตรวจสอบผลการดำเนินงานและความเสี่ยง และรายงานผลการตรวจสอบไปยังรัฐมนตรีว่าการกระทรวงการคลัง",
    source:
      "ศูนย์คุ้มครองผู้ใช้บริการทางการเงิน. สถาบันการเงินเฉพาะกิจ (Specialized Financial Institutions : SFIs), 8 กรกฎาคม 2562. https://www.1213.or.th/th/aboutfcc/finservices/Pages/SFIs.aspx",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ส"
  },
  {
    keyword: "สถาบันการเงินประชาชน",
    meaning:
      "องค์กรการเงินชุมชนซึ่งได้จดทะเบียนเป็นสถาบันการเงินประชาชนตามพระราชบัญญัติ",
    source:
      "พระราชบัญญัติสถาบันการเงินประชาชน พ.ศ. 2562. (2562, 30 เมษายน). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 56 ก หน้า 46. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/056/T_0045.PDF",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "ส"
  },
  {
    keyword: "สถาบันการโอนสิทธิการพัฒนาพื้นที่",
    meaning:
      "การซื้อขาย “สิทธิ” ในด้านพัฒนาบนที่ดิน ระหว่าง พื้นที่ที่ต้องการจะควบคุมการพัฒนาหรืออนุรักษ์ (Sending Areas) และ พื้นที่ที่มีการเจริญเติบโตและได้รับการสนับสนุนการพัฒนา (Receiving Areas)",
    source:
      "TDR: การโอนสิทธิพัฒนาพื้นที่ ผังเมืองใหม่รองรับรถไฟฟ้า. สมาคมอสังหาริมทรัพย์ไทย, 28 ตุลาคม 2562. http://thairealestate.org/content/detail/412/TDR%3A-%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%82%E0%B8%AD%E0%B8%99%E0%B8%AA%E0%B8%B4%E0%B8%97%E0%B8%98%E0%B8%B4%E0%B8%9E%E0%B8%B1%E0%B8%92%E0%B8%99%E0%B8%B2%E0%B8%9E%E0%B8%B7%E0%B9%89%E0%B8%99%E0%B8%97%E0%B8%B5%E0%B9%88-%E0%B8%9C%E0%B8%B1%E0%B8%87%E0%B9%80%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%87%E0%B9%83%E0%B8%AB%E0%B8%A1%E0%B9%88%E0%B8%A3%E0%B8%AD%E0%B8%87%E0%B8%A3%E0%B8%B1%E0%B8%9A%E0%B8%A3%E0%B8%96%E0%B9%84%E0%B8%9F%E0%B8%9F%E0%B9%89%E0%B8%B2",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ส"
  },
  {
    keyword: "สถาบันการประชาสัมพันธ์",
    meaning:
      "หน่วยงานสังกัดกรมประชาสัมพันธ์ที่มีภารกิจด้านการจัดหลักสูตรฝึกอบรมบุคลากร ทั้งของกรมประชาสัมพันธ์ หน่วยงานภายนอกทั้งภาครัฐและเอกชน รวมถึงประชาชนทั่วไป ให้เป็นบุคลากรมืออาชีพด้านการประชาสัมพันธ์และสื่อสารมวลชนของประเทศ",
    source:
      "สถาบันการประชาสัมพันธ์. 54 ปี มุ่งมั่นพัฒนาวิชาการประชาสัมพันธ์และสื่อสารมวลชน. หน้า 4, 3 ตุลาคม 2562. https://training.prd.go.th/download/document/year54.pdf",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ส"
  },
  {
    keyword: "สถาบันทางการเมือง",
    meaning:
      "แบบแผนของพฤติกรรมหรือการกระทำทางการเมืองซึ่งถูกสร้าง วางระเบียบกฎเกณฑ์ บรรทัดฐานและกระบวนการต่าง ๆ โดยมีโครงสร้างและองค์กรทางการเมืองที่กำหนดรูปแบบและวิธีการในการประพฤติปฏิบัติหรือกระทำทางการเมืองและมีปฏิสัมพันธ์หรือกระทำที่เกี่ยวข้องกับกิจกรรมทางการเมืองของบุคคลในสังคม",
    source:
      "บูฆอรี ยีหมะ มหาวิทยาลัยราชภัฏสงขลา. การวิเคราะห์การเมืองแนวสถาบันนิยม และรัฐธรรมนูญนิยม, 2 กันยายน 2562. http://www.stou.ac.th/Schoolnew/polsci/UploadedFile/81713-5.pdf",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ส"
  },
  {
    keyword: "สถาบันทางสังคม",
    meaning:
      'จากบริบทในยุทธศาสตร์ชาติด้านการพัฒนาและเสริมสร้างศักยภาพทรัพยากรมนุษย์\r\n\r\n"การปรับเปลี่ยนค่านิยมและวัฒนธรรม มุ่งเน้นให้สถาบันทางสังคมร่วมปลูกฝังค่านิยมวัฒนธรรม\r\nที่พึงประสงค์ โดยบูรณาการร่วมระหว่าง “ครอบครัว ชุมชน ศาสนา การศึกษา และสื่อ” ในการหล่อหลอมคนไทยให้มีคุณธรรม จริยธรรม ในลักษณะที่เป็น ‘วิถี’ การดำเนินชีวิต"\r\n\r\nสถาบันทางสังคม จึงหมายถึง ที่รวมของบรรทัดฐาน ระเบียบ แบบแผน แนวทางปฏิบัติอย่างเป็นระเบียบระบบ เป็นที่ยอมรับของคนส่วนใหญ่ในสังคมอย่างเป็นทางการ มีความมั่นคง ไม่เปลี่ยนแปลงง่าย เพื่อตอบสนองความต้องการและการดำรงอยู่ของสังคม โดยมีหน้าที่เพื่อจัดระเบียบและระบบของสังคมให้เหมาะสมกับการขยายตัวและความเจริญก้าวหน้าของสังคม โดยกำหนดรูปแบบหรือควบคุมพฤติกรรมของบุคคลในสังคมและความสัมพันธ์ทางสังคมให้เป็นไปตามบรรทัดฐานของสังคม ทั้งนี้ หน้าที่เฉพาะเป็นไปตามภาระหน้าที่ของสถาบันสังคมแต่ละประเภท เช่น สถาบันครอบครัว สถาบันเศรษฐกิจ สถาบันการเมืองและการปกครอง สถาบันศาสนา และสถาบันการศึกษา\r\n',
    source:
      "มหาวิทยาลัยราชภัฏอุดรธานี. สถาบันทางสังคม, 21 พฤศจิกายน 2562. http://www.udru.ac.th/oldsite/attachments/elearning/02/18.pdf",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สถาบันหรือองค์กรคลังปัญญากลาง (Think Tank)",
    meaning:
      "หน่วยงาน/องค์การ/สถาบัน อันมีหน้าที่ด้านวิชาการและการวิจัยสำหรับการให้คำปรึกษาการเสนอแนวคิด การแก้ปัญหาที่ซับซ้อน การพยากรณ์การพัฒนาแผนในอนาคต โดยเฉพาะในประเด็นด้านการเมือง การทหาร เศรษฐกิจ และสังคม",
    source:
      "กลุ่มงานวิจัยและพัฒนา สำนักวิชาการ และสำนักงานเลขาธิการสภาผู้แทนราษฎร. (2558). เอกสารข่าวสารงานวิจัยและพัฒนา, 2 กันยายน 2562. http://library2.parliament.go.th/ejournal/content_rd/2558/14_152/t14_152.pdf",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ส"
  },
  {
    keyword: "สถาบันหลัก",
    meaning:
      "ชาติ ศาสนา พระมหากษัตริย์ และการปกครองระบอบประชาธิปไตยอันมีพระมหากษัตริย์ทรงเป็นประมุข",
    source:
      "สำนักงานคณะกรรมการข้าราชการพลเรือน. มาตรฐานทางจริยธรรมสำหรับเจ้าหน้าที่ของรัฐ, 17 ตุลาคม 2562. https://www.ocsc.go.th/sites/default/files/attachment/article/maatrthaanthaangcchriythrrm.pdf",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สถาบันหลักของชาติ",
    meaning:
      "ประเทศไทยมีสถาบันหลัก 3 สถาบัน ซึ่งถือเป็นเอกลักษณ์ของชาติไทย คือ สถาบันชาติ สถาบันศาสนา และสถาบันพระมหากษัตริย์ โดยทั้ง 3 สถาบันนี้ จะขาดสถาบันใดสถาบันหนึ่งมิได้ เพราะต่างอาศัยเกี่ยวข้องซึ่งกันและกัน ",
    source:
      "มหาวิทยาลัยธรรมศาสตร์, 14 สิงหาคม 2562. http://digi.library.tu.ac.th/thesis/po/0136/06CHAPTER_1.pdf",
    sappear: 1,
    mappear: "",
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สถาบันอนุญาโตตุลาการ",
    meaning:
      "จัดตั้งขึ้นตามพระราชบัญญัติสถาบันอนุญาโตตุลาการ พ.ศ. 2550 เพื่อส่งเสริมและพัฒนากระบวนการประนอมข้อพิพาทและอนุญาโตตุลาการ ดำเนินการเกี่ยวกับการระงับข้อพิพาทโดยวิธีประนอมข้อพิพาทและอนุญาโตตุลาการ รวมถึงการส่งเสริมและเผยแพร่ความรู้เกี่ยวกับการประนอมข้อพิพาทและอนุญาโตตุลาการรวมทั้งกฎหมายที่เกี่ยวข้อง",
    source:
      "สถาบันอนุญาโตตุลาการ. ความเป็นมาของ THAC ( Thailand Arbitration Center ), 2 กันยายน 2562. https://www.moj.go.th/pdf/road%20map/6.2_280360.pdf",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ส"
  },
  {
    keyword: "สถาปัตยกรรม",
    meaning:
      "การออกแบบก่อสร้างสิ่งต่างๆ ทั้งสิ่งก่อสร้างที่คนทั่วไปอยู่อาศัยได้ เช่น ตึก อาคาร บ้าน เป็นต้น และสิ่งก่อสร้างที่คนเข้าไปอยู่อาศัยไม่ได้ เช่น สถูป เจดีย์ อนุสาวรีย์ เป็นต้น นอกจากนี้ ยังรวมถึงการกำหนดผังบริเวณต่างๆ เพื่อให้เกิดความสวยงามและเป็นประโยชน์แก่การใช้สอยตามต้องการ งานสถาปัตยกรรมเป็นแหล่งรวมของงานศิลปะทางกายภาพเกือบทุกชนิด และมักมีรูปแบบแสดงเอกลักษณ์ของสังคมนั้นๆ ในช่วงเวลานั้นๆ เราแบ่งลักษณะงานของสถาปัตยกรรมออกได้เป็น 3 แขนง คือ (1) สถาปัตยกรรมออกแบบสิ่งก่อสร้าง เช่น การออกแบบสร้างตึก อาคาร บ้านเรือน เป็นต้น (2) ภูมิสถาปัตย์ เช่น การออกแบบวางผังจัดบริเวณ วางผังปลูกต้นไม้ จัดสวน เป็นต้น  (3) สถาปัตยกรรมผังเมือง ได้แก่ การออกแบบบริเวณเมืองให้เป็นระเบียบ มีความสะอาด มีความรวดเร็ว ในการติดต่อ และถูกหลักสุขาภิบาล เราเรียกผู้สร้างงานสถาปัตยกรรมว่า สถาปนิก",
    source:
      "ทีมงานทรูปลูกปัญญา. (2558). สถาปัตยกรรม หมายถึงอะไร, 1 กรกฎาคม 2562. http://www.trueplookpanya.com/new/asktrueplookpanya/questiondetail/13957",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สนธิสัญญาความร่วมมือระหว่างประเทศ",
    meaning:
      "ความตกลงระหว่างประเทศที่ทำขึ้นเป็นลายลักษณ์อักษร ระหว่างบุคคลในระหว่างประเทศ (รัฐกับรัฐ หรือรัฐกับองค์การระหว่างประเทศ หรือระหว่างองค์การระหว่างประเทศกับองค์การระหว่างประเทศ) และอยู่ภายใต้บังคับของกฎหมายระหว่างประเทศ โดยมุ่งก่อให้เกิดสิทธิและพันธะทางกฎหมายแก่ภาคีของสนธิสัญญา ไม่ว่าจะทำขึ้นเป็นฉบับเดียวหรือหลายฉบับผนวกกัน",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์. (2555). สนธิสัญญา (Treaty), 11 กันยายน 2562. https://www.etda.or.th/terminology-detail/1203.html",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สภาขับเคลื่อนการปฏิรูปประเทศ",
    meaning:
      "ดำเนินการปฏิรูปประเทศ ตามรัฐธรรมนูญ\r\nมาตรา 39/2 เพื่อดําเนินการให้เกิดการปฏิรูปด้านต่างๆ สืบต่อจากสภาปฏิรูปแห่งชาติ\r\nโดยให้คํานึงถึงความสําคัญเร่งด่วนและความสัมฤทธิผลของการปฏิรูปในระยะเวลาที่เหลืออยู่ ด้วยการประสานงานการปฏิรูปกับสภานิติบัญญัติแห่งชาติ คณะรัฐมนตรี คณะรักษาความสงบแห่งชาติ คณะกรรมการร่างรัฐธรรมนูญ หน่วยงานและองค์กรอื่น รวมถึงส่วนราชการ และประชาชนทุกภาคส่วน",
    source:
      "ข้อบังคับสภาขับเคลื่อนการปฏิรูปประเทศ\r\nพ.ศ. 2558. (2558, 3 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม 132 ตอนพิเศษ 279 ง หน้า 24.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2558/E/279/21.PDF",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ส"
  },
  {
    keyword: "สภานิติบัญญัติแห่งชาติ",
    meaning:
      "สภาระดับชาติที่ตั้งขึ้นเพื่อทำหน้าที่แทนรัฐสภา สภาผู้แทนราษฎร และวุฒิสภาตามการปกครองในระบอบประชาธิปไตย โดยสภานิติบัญญัติแห่งชาติ ส่วนใหญ่จะเกิดขึ้นภายหลังเมื่อมีการปฏิวัติ รัฐประหาร ลักษณะเป็นสภาเดียว มีสมาชิกมาจากการแต่งตั้งตามธรรมนูญการปกครองแห่งราชอาณาจักรไทย หรือตามรัฐธรรมนูญแห่งราชอาณาจักรไทยฉบับชั่วคราว โดยให้มีอำนาจ หน้าที่ ตามที่ธรรมนูญการปกครอง หรือรัฐธรรมนูญกำหนดไว้ ซึ่งโดยทั่วไปจะมีการกำหนดให้มีอำนาจหน้าที่เช่นเดียวกับรัฐสภา สภาผู้แทนราษฎร และวุฒิสภา",
    source:
      "สถิตย์ ส่งศรีบุญสิทธิ์. สภานิติบัญญัติแห่งชาติ, 1 กรกฎาคม 2562.http://wiki.kpi.ac.th/index.php?title=%E0%B8%AA%E0%B8%A0%E0%B8%B2%E0%B8%99%E0%B8%B4%E0%B8%95%E0%B8%B4%E0%B8%9A%E0%B8%B1%E0%B8%8D%E0%B8%8D%E0%B8%B1%E0%B8%95%E0%B8%B4%E0%B9%81%E0%B8%AB%E0%B9%88%E0%B8%87%E0%B8%8A%E0%B8%B2%E0%B8%95%E0%B8%B4_(%E0%B8%AA%E0%B8%96%E0%B8%B4%E0%B8%95%E0%B8%A2%E0%B9%8C_%E0%B8%AA%E0%B9%88%E0%B8%87%E0%B8%A8%E0%B8%A3%E0%B8%B5%E0%B8%9A%E0%B8%B8%E0%B8%8D%E0%B8%AA%E0%B8%B4%E0%B8%97%E0%B8%98%E0%B8%B4%E0%B9%8C)",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ส"
  },
  {
    keyword: "สภาปฏิรูปแห่งชาติ",
    meaning:
      "สภาปฏิรูปแห่งชาติ (สปช.) ตั้งขึ้นตามมาตรา 27 แห่งรัฐธรรมนูญแห่งราชอาณาจักรไทย (ฉบับชั่วคราว) พุทธศักราช 2557 ให้มีสภาปฏิรูปแห่งชาติ ทำหน้าที่ศึกษาและเสนอแนะแนวทางเพื่อการปฏิรูปประเทศด้านต่าง ๆ คือ \r\n1. การเมือง \r\n2. การบริหารราชการแผ่นดิน \r\n3. กฎหมายและกระบวนการยุติธรรม \r\n4. การปกครองท้องถิ่น \r\n5. การศึกษา \r\n6. เศรษฐกิจ \r\n7. พลังงาน \r\n8. สาธารณสุขและสิ่งแวดล้อม \r\n9. สื่อสารมวลชน \r\n10. สังคม \r\n11. อื่น ๆ \r\nพร้อมเสนอความเห็นต่อคณะกรรมาธิการเพื่อประโยชน์ในการจัดทำร่างรัฐธรรมนูญ สปช. ประกอบด้วย สมาชิกจํานวนไม่เกิน 250 คน",
    source:
      "กลุ่มงานพัฒนาทรัพยากรสารสนเทศ สำนักวิชาการ สำนักงานเลขาธิการสภาผู้แทนราษฎร. (2559). \r\nเอกสารประกอบการปฏิรูป, 29 สิงหาคม 2562. https://library2.parliament.go.th/giventake/nrc2557-info.html",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ส"
  },
  {
    keyword: "สภาพภูมิอากาศ",
    meaning:
      "ความหมายแคบ หมายถึง “ค่าเฉลี่ยอากาศ” หรือในความหมายที่รัดกุม\r\nมากกว่านั้นจะใช้หมายถึง คำอธิบายทางสถิติในแง่ของค่าเฉลี่ยและความผันแปร\r\nของปริมาณตัวแปรที่พื้นผิวโลก เช่น อุณหภูมิ หยาดน้ำฟ้า และลม ในช่วงระยะ\r\nเวลาหนึ่ง ซึ่งช่วงระยะเวลาที่ใช้วัดทั่วไปคือ 30 ปี\r\nความหมายกว้าง คือ สภาวะ รวมถึงคำอธิบายทางสถิติ\r\nของระบบภูมิอากาศ (climate system)",
    source:
      "กรมป้องกันและบรรเทาสาธารณภัย. หนังสือคำศัพท์ด้านการบริหารจัดการความเสี่ยงจากภัยพิบัติ, 9 กันยายน 2562. http://www.disaster.go.th/th/download-src.php?did=1225",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สภาพลเมือง",
    meaning:
      '"สภาพลเมือง” สามารถเกิดขึ้นได้โดยไม่ต้องรอรัฐธรรมนูญ ซึ่งเริ่มจากชุมชน หมู่บ้าน ตำบล เทศบาล เริ่มจากสมาชิกผู้มีจิตสำนึกคำนึงถึงประโยชน์ส่วนรวมมานั่งพูดคุยกันในเรื่องที่เกี่ยวกับการรักษาสิทธิ์และผลประโยชน์สาธารณะ ตั้งแต่ระดับหมู่บ้าน ตำบล รวมตัวกัน จัดตั้งเป็นสภาพลเมือง เพื่อเข้าไปมีส่วนร่วมในการตัดสินใจทางการเมืองระดับท้องถิ่น และพัฒนาเป็นสภาพลเมืองในระดับชาติ',
    source:
      "ศูนย์พัฒนาการเมืองภาคพลเมือง สถาบันพระปกเกล้า จังหวัดลำพูน. สภาพลเมือง, 11 กันยายน 2562.\r\nhttps://kaewpanya.rmutl.ac.th/kservice/lpkpi/admin/courses/kpi1.pdf",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ส"
  },
  {
    keyword: "สภาวการณ์",
    meaning: "เหตุการณ์ที่เป็นไปตามธรรมชาติ ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สภาวการณ์. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ส"
  },
  {
    keyword: "สมดุลนิเวศ",
    meaning:
      "สภาวะความคงที่ในการแลกเปลี่ยนความสัมพันธ์ระหว่างสิ่งมีชีวิตกับสิ่งแวดล้อม ซึ่งในระบบนิเวศนั้น สิ่งมีชีวิต และไม่มีชีวิต จะมีการแลกเปลี่ยนพลังงาน และสสารซึ่งกันและกัน ขณะเดียวกันความสัมพันธ์ระหว่างสิ่งมีชีวิตด้วยกัน คือ การถ่ายทอดพลังงานไปตามห่วงโซ่อาหาร มีองค์ประกอบภายในระบบที่ทำหน้าที่เป็นผู้ผลิต ผู้บริโภค และผู้ย่อยสลาย ซึ่งความสมดุลของระบบนิเวศจะคงอยู่ได้ ตราบเท่าที่มีความหลากหลายของสิ่งมีชีวิตภายในระบบ ซึ่งความหลากหลายของสิ่งมีชีวิต จะทำให้เกิดความสัมพันธ์ที่เป็นระเบียบ และสลับซับซ้อน ซึ่งเมื่อใดก็ตามที่องค์ประกอบส่วนใดส่วนหนึ่งถูกทำให้กระทบกระเทือน แม้เพียงเล็กน้อย ผลกระทบอันนั้นจะถูกส่งทอดต่อไปถึงองค์ประกอบอื่นๆ ทั่วทั้งระบบ แต่ในความซับซ้อนของระบบนิเวศ มันก็จะสามารถที่จะปรับตัวเข้าสู่สภาวะแห่งความสมดุลได้ใหม่อีกครั้ง เพื่อให้ระบบคงอยู่ต่อไปได้ แต่หากผลกระทบนั้นรุนแรงเกินกว่าที่ระบบจะปรับตัวให้เข้าสู่สมดุลได้ ระบบนั้นทั้งระบบก็จะแตกสลายลง",
    source:
      "สารานุกรมไทยสำหรับเยาวชน เล่มที่ 17. เรื่องที่ 3 ระบบนิเวศและความสัมพันธ์ระหว่างธรรมชาติกับสิ่งมีชีวิต, 1 กรกฎาคม 2562. http://kanchanapisek.or.th/kp6/sub/book/book.php?book=17&chap=3&page=t17-3-infodetail09.html",
    sappear: 5,
    mappear: 19,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สมรรถนะ",
    meaning:
      "กลุ่มของทักษะ ความรู้ ความสามารถ รวมทั้งพฤติกรรม คุณลักษณะและทัศนคติที่บุคลากรจำเป็นต้องมีเพื่อปฏิบัติงานอย่างมีประสิทธิภาพ ประสิทธิผล และเพื่อให้บรรลุผลสำเร็จตรงตามวัตถุประสงค์และเป้าหมายขององค์กร\r\n",
    source:
      "สำนักงานคณะกรรมการข้าราชการพลเรือน. (2561). สมรรถนะ (Competency). 11 กันยายน 2562.\r\nhttps://www.ocsc.go.th/sites/default/files/attachment/page/aptitude_development.pdf",
    sappear: "",
    mappear: 12,
    rappear: 2,
    firstalpha: "ส"
  },
  {
    keyword: "สมรรถนะทางเศรษฐกิจ",
    meaning:
      "การรักษาเสถียรภาพเศรษฐกิจและ สร้างความเชื่อมั่น การส่งเสริมการค้าและการลงทุนที่อยู่บนการแข่งขันที่เป็นธรรมและรับผิดชอบ ต่อสังคม ตลอดจนการพัฒนาประเทศสู่ความเป็นชาติการค้าเพื่อให้ได้ประโยชน์จากห่วงโซ่มูลค่า ในภูมิภาค และเป็นการยกระดับไปสู่ส่วนบนของห่วงโซ่มูลค่ามากขึ้น",
    source:
      "สำนักเลขาธิการนายกรัฐมนตรี. กรอบยุทธศาสตร์ชาติระยะ 20 ปี (พ.ศ. 2560-2579), 28 ตุลาคม 2562. http://www.thaigov.go.th/uploads/document/22/2016/09/pdf/p1.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ส"
  },
  {
    keyword: "สมรรถนะหลัก (Core Competency)",
    meaning:
      "คุณลักษณะเชิงพฤติกรรมที่กําหนดเป็นคุณลักษณะรวมของข้าราชการพลเรือนทั้งระบบ เพื่อเป็นการหล่อหลอมค่านิยมและพฤติกรรมที่พึงประสงค์ร่วมกัน",
    source:
      "อนุชิต ฮุนสวัสดิกุล ที่ปรึกษาด้านวิชาการ โครงการพัฒนานักบริหารการเปลี่ยนแปลงรุ่นใหม่ สํานักงาน ก.พ.ร. (2561). \r\nการพัฒนาสมรรถนะหลัก(สําหรับข้าราชการใหม่), 30 สิงหาคม 2562. https://www.ocsc.go.th/sites/default/files/\r\nattachment/page/aptitude_development.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ส"
  },
  {
    keyword: "สมานฉันท์",
    meaning: "ความพอใจร่วมกัน, ความเห็นพ้องกัน, เช่น มีความเห็นเป็นสมานฉันท์",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สมานฉันท์. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ส"
  },
  {
    keyword: "สมุททานุภาพ",
    meaning:
      "อำนาจ กำลังอำนาจ หรือศักยภาพของชาติ (หรือรัฐใดรัฐหนึ่ง) ในการที่จะใช้ทะเลให้เกิดประโยชน์ตามที่ต้องการ",
    source:
      "พลเรือเอก สามารถ จำปีรัตน์. นาวิกศาสตร์. (2556). สมุททานุภาพ, 6 สิงหาคม 2562. http://www.rtni.org/th/library/wp-content/uploads/2014/03/%E0%B8%99%E0%B8%B2%E0%B8%A7%E0%B8%B4%E0%B8%81%E0%B8%A8%E0%B8%B2%E0%B8%AA%E0%B8%95%E0%B8%A3%E0%B9%8C-%E0%B8%9E%E0%B8%A2-2556_SEA-POWER-%E0%B8%AA%E0%B8%A1%E0%B8%B8%E0%B8%97%E0%B8%97%E0%B8%B2%E0%B8%99%E0%B8%B8%E0%B8%A0%E0%B8%B2%E0%B8%9E-%E0%B9%80%E0%B8%99%E0%B8%B7%E0%B9%89%E0%B8%AD%E0%B8%AB%E0%B8%B2-%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%AB%E0%B8%A1%E0%B8%B2%E0%B8%A2-%E0%B8%97%E0%B8%AB%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%A3%E0%B8%B7%E0%B8%AD%E0%B9%84%E0%B8%97%E0%B8%A2-%E0%B8%84%E0%B8%A7%E0%B8%A3%E0%B8%A3%E0%B8%B9%E0%B9%89%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B9%81%E0%B8%88%E0%B9%89%E0%B8%87-%E0%B8%95%E0%B8%AD%E0%B8%99%E0%B8%97%E0%B8%B5%E0%B9%88-%E0%B9%92_01.pdf",
    sappear: 1,
    mappear: "",
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สมุทราภิบาล",
    meaning:
      "การดำเนินการตามนโยบาย การกระทำ และกิจกรรมต่างๆที่เกี่ยวกับทะเลและมหาสมุทร ซึ่งเกี่ยวข้องและได้รับอิทธิพลจากผู้มีส่วนร่วมในภาคส่วนอื่นๆ เป็นจำนวนมากนอกเหนือจากภาครัฐ ทำให้ภาครัฐไม่ใช่ผู้มีบทบาทที่สำคัญแต่ผู้เดียวในการวางนโยบาย ทั้งนี้ เพราะความซับซ้อนของประเด็นต่างๆทางทะเลและมหาสมุทรที่เป็นสมบัติร่วมไม่มีรัฐหรือชาติใดเป็นเจ้าของแต่ผู้เดียวเป็นผลให้มนุษย์ใช้ทรัพยากรต่างๆอย่างขาดสำนึก โดยถือว่าเป็นทรัพยากรร่วมที่ทุกคนสามารถใช้ประโยชน์ได้โดยไม่ต้องร่วมรับผิดชอบในการดูแลรักษา จึงทำให้กฎเณฑ์ในการใช้ทะเลและมหาสมุทรต้องดำเนินการผ่านข้อตกลงระหว่างประเทศ ซึ่งทำให้มีความจำเป็นที่จะต้องมีรูปแบบการบริหารจัดการที่มีธรรมาธิบาล เพื่อที่จะให้การใช้ประโยชน์ที่หลากหลายจากทะเลและมหาสมุทรเป็นไปอย่างยั่งยืน",
    source:
      "สถาบันระหว่างประเทศเพื่อการค้าและการพัฒนา. (2559). ความมั่นคงทางทะเล, 14 สิงหาคม 2562. https://www.parliament.go.th/ewtadmin/ewt/parliament_parcy/download/article/article_20170626115304.pdf",
    sappear: 1,
    mappear: "",
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สร้างวินัยทางการเงิน",
    meaning:
      "กิจกรรมทางการเงินที่ต้องมีการวางแผน จัดการอย่างเป็นระบบและดำเนินการอย่างมีวินัย ",
    source:
      "ทวีศักดิ์ มานะกุล. วินัยทางการเงินกับความอยู่รอดของระบบเศรษฐกิจ, 2 สิงหาคม 2562.  http://www.1359.go.th/FIDP/Source/Article/Source/data/article04.pdf",
    sappear: "",
    mappear: 8,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สวนพฤกษศาสตร์",
    meaning:
      "พื้นที่ที่มีการจัดรวบรวมพรรณไม้ โดยมีการจัดแยกพรรณไม้ออกเป็นหมวดหมู่ตามหลักพฤกษศาสตร์หรือตามหลักอนุกรมวิธานพืชเพื่อให้เป็นแหล่งอนุรักษ์ความหลากหลายทางชีวภาพ เป็นสถานที่ศึกษาค้นคว้าวิจัยทางวิชาการ และใช้เป็นสถานที่พักผ่อนหย่อนใจของประชาชน",
    source:
      "พระราชบัญญัติอุทยานแห่งชาติ พ.ศ. 2562 (2562, 29 พฤษภาคม 2562). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 71 ก หน้า 146.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/071/T_0145.PDF\r\n",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ส"
  },
  {
    keyword: "ส่วนราชการ",
    meaning:
      "กระทรวง ทบวง กรม หรือส่วนราชการที่เรียกชื่ออย่างอื่นและมีฐานะเป็นกรม และให้หมายความรวมถึงจังหวัดและกลุ่มจังหวัดตามกฎหมายว่าด้วยระเบียบ\r\nบริหารราชการแผ่นดินด้วย\r\n",
    source:
      "พระราชบัญญัติวิธีการงบประมาณ พ.ศ. 2561. (2561,17 พฤศจิกายน) ราชกิจจานุเบกษา. เล่มที่ 135 ตอนที่ 92 ก หน้า 3 http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/A/092/1.PDF\r\n",
    sappear: 1,
    mappear: "",
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สวนรุกขชาติ",
    meaning:
      "พื้นที่ที่มีการรวบรวมและอนุรักษ์พรรณไม้ที่มีค่า หายาก หรือ ใกล้สูญพันธุ์ซึ่งมีอยู่ในท้องถิ่น เพื่อให้ได้รับความรู้เกี่ยวกับพันธุ์ไม้ และการพักผ่อนหย่อนใจของประชาชน",
    source:
      "พระราชบัญญัติอุทยานแห่งชาติ พ.ศ. 2562 (2562, 29 พฤษภาคม 2562). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 71 ก หน้า 146.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/071/T_0145.PDF\r\n",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ส"
  },
  {
    keyword: "สวัสดิการ",
    meaning:
      "บริการหรือกิจกรรมใดๆ ที่หน่วยงานราชการ หรือองค์กรธุรกิจเอกชนจัดให้มีขึ้น เพื่อให้ข้าราชการ พนักงาน หรือผู้ที่ปฏิบัติงานอยู่ในองค์กรนั้นๆ ได้รับความสะดวกสบายในการทํางานมีความมั่นคงในอาชีพ มีหลักประกันที่แน่นอนในการดําเนินชีวิต หรือได้รับประโยชน์อื่นใดนอกเหนือจากเงินเดือน หรือค่าจ้างที่ได้รับอยู่เป็นประจํา เพื่อเป็นสิ่งจูงใจให้ผู้ปฏิบัติงานมีขวัญและกําลังใจที่ดี และสามารถใช้กําลังกาย กําลังใจ และสติปัญญาความสามารถของตนในการปฏิบัติงานอย่างเต็มที่ไม่ต้องวิตกกังวล ปัญหายุ่งยากทั้งในทางส่วนตัวและครอบครัวทําให้มีความพอใจในงาน มีความรักงานและตั้งใจที่จะทํางานนั้นให้นานที่สุด ซึ่งสวัสดิการที่สมบูรณ์แบบจะเป็นสวัสดิการที่ให้แก่ลูกจ้าง ทั้งในขณะที่ทํางาน นอกเวลาทํางานแต่ยังอยู่ในที่ทํางาน นอกสถานที่ทํางาน และครอบครัวและชุมชน",
    source:
      "สภาอุตสาหกรรมแห่งประเทศไทย. ความหมายและขอบเขตของคำว่า “สวสัดิการ”, 19 มิถุนายน 2562. http://ftiweb.off.fti.or.th/intranet/file/banner/welfare.pdf",
    sappear: 4,
    mappear: 17,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สวัสดิการชุมชน",
    meaning:
      "การสร้างหลักประกันเพื่อความมั่นคงของคนในชุมชน หมายรวมถึงทุกอย่างที่จะทำให้คนในชุมชนมีความเป็นอยู่ที่ดีขึ้น ทั้งในรูปของสิ่งของ เงินทุน น้ำใจ การช่วยเหลือเกื้อกูล เป็นเรื่องที่เกี่ยวกับวิถีชีวิตตั้งแต่ เกิด แก่ เจ็บ ตาย เป็นระบบการช่วยเหลือเกื้อกูลของคนในท้องถิ่น ที่มีรูปแบบและวิธีการที่หลากหลาย เป็นเรื่องราวเกี่ยวข้องกับวิถีชีวิต ตั้งแต่เกิดจนกระทั่งตาย ก่อให้เกิดรายได้ลดรายจ่าย นำไปสู่การแก้ไขปัญหาความยากจน",
    source:
      "สถาบันพัฒนาองค์กรชุมชน (องค์การมหาชน). (2561). คู่,มือการดำเนินงานสวัสดิการชุมชน 8 กรกฎาคม2562. https://web.codi.or.th/wp-content/plugins/download-attachments/includes/download.php?id=5030",
    sappear: "",
    mappear: 17,
    rappear: 9,
    firstalpha: "ส"
  },
  {
    keyword: "สวัสดิการทางสังคม",
    meaning:
      "ระบบการจัดบริการทางสังคม เกี่ยวกับการป้องกัน  การแก้ไขปัญหา  การพัฒนาและการส่งเสริมความมั่นคงทางสังคม  ตอบสนองความจำเป็นขั้นพื้นฐานของประชาชน  มีคุณภาพชีวิต และพึ่งตนเองได้ทั่วถึง  เหมาะสม  เป็นธรรม ตามมาตรฐาน ทั้งทางด้านการศึกษา สุขภาพอนามัย ที่อยู่อาศัย การทำงานและการมีรายได้ นันทนาการ กระบวนการยุติธรรมและบริการทางสังคมทั่วไป  \r\nโดยคำนึงถึงศักดิ์ศรีความเป็นมนุษย์  สิทธิที่ประชาชนจะต้องได้รับ  และมีส่วนร่วมในการจัดสวัสดิการสังคมทุกระดับ",
    source:
      "พระราชบัญญัติส่งเสริมการจัดสวัสดิการสังคม พ.ศ. 2546 (2546, 24 กันยายน). ราชกิจจานุเบกษา. เล่ม 120 ตอนที่ 94 ก หน้า 6. http://www.ratchakitcha.soc.go.th/DATA/PDF/00130692.PDF",
    sappear: 4,
    mappear: 15,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สวัสดิการสังคม",
    meaning:
      "ระบบการจัดบริการทางสังคมซึ่งเกี่ยวกับการป้องกันการแก้ไขปัญหา การพัฒนา และการส่งเสริมความมั่นคงทางสังคม เพื่อตอบสนองความจําเป็นขั้นพื้นฐานของประชาชน ให้มีคุณภาพชีวิตที่ดีและพึ่งตนเองได้อย่างทั่วถึง เหมาะสม เป็นธรรมและให้เป็นไปตามมาตรฐานโดยคํานึงถึงศักดิ์ศรีความเป็นมนุษย์ สิทธิที่ประชาชนจะต้องได้รับและการมีส่วนร่วมในการจัดสวัสดิการสังคมทุกระดับ ",
    source:
      "สํานักงานส่งเสริมและสนับสนุนวิชาการ กรมพัฒนาสังคมและสวัสดิการ. การศึกษาการพัฒนารูปแบบการพัฒนาสังคมและสวัสดิการที่สอดคล้องกับความต้องการขององค์กรปกครองส่วนท้องถิ่นและการพัฒนาสังคมของประเทศ, 18 ตุลาคม 2562. http://61.19.50.68/dsdw/doc_pr/20120203103456.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ส"
  },
  {
    keyword: "สหกรณ์",
    meaning:
      "คณะบุคคลซึ่งร่วมกันดำเนินกิจการเพื่อประโยชน์ทางเศรษฐกิจ\r\nและสังคมของสมาชิกสหกรณ์ผู้มีสัญชาติไทย โดยช่วยตนเองและช่วยเหลือซึ่งกันและกัน และได้จดทะเบียนตามพระราชบัญญัตินี้",
    source:
      "พระราชบัญญัติสหกรณ์ (ฉบับที่ 3) พ.ศ. 2562. (2562, 20 มีนาคม). ราชกิจจานุเบกษา. เล่มที่ 136 ตอนที่ 34 ก หน้า 28. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/034/T_0027.PDF",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สหประชาชาติ",
    meaning:
      "องค์การระหว่างประเทศที่จัดตั้งขึ้นโดยมีวัตถุประสงค์สำคัญ คือ การป้องกันสงคราม การยืนยันรับรองสิทธิมนุษยชนขั้นพื้นฐาน การเคารพและปฏิบัติตามพันธกรณีที่เกิดจากสนธิสัญญาและกฎหมายระหว่างประเทศ, เรียกชื่อเต็มว่า องค์การสหประชาชาติ (United Nations Organization)",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ.2554. ธนาคารโลก. 6 มิถุนายน 2562. http://www.royin.go.th/dictionary/index.php",
    sappear: "",
    mappear: 2,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สังคมคาร์บอนต่ำ (Low Carbon Society)",
    meaning:
      "สังคมที่ผู้คนส่วนใหญ่ในสังคมหันมาร่วมมือลดการปล่อยก๊าซคาร์บอนไดออกไซด์ในทุกรูปแบบหรือในกิจกรรมต่างๆ ที่เกิดจากการดำรงชีวิตปกติโดยเฉพาะการลดปริมาณก๊าซคาร์บอนไดออกไซด์ที่ปล่อยออกมาจากกระบวนการผลิตของโรงงานหรือภาคอุตสาหกรรม เพื่อจะได้อยู่ร่วมกันในสังคมที่มีคุณภาพชีวิตที่ดี",
    source:
      "กรมส่งเสริมคุณภาพสิ่งแวดล้อม. สังคมคาร์บอนต่ำ DEPARTMENT OF ENVIRONMETAL QULITY PROMOTION, 21 พฤศจิกายน 2562.\r\nhttps://actionforclimate.deqp.go.th/?p=6624",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ส"
  },
  {
    keyword: "สังคมคุณภาพ",
    meaning:
      "คือ สังคมที่พัฒนาไปตามแนวคิดคุณภาพสังคม (Social Quality) ที่เน้นมิติการพัฒนาใน 4 มิติ คือ มิติความมั่นคงทางสังคมและเศรษฐกิจ (Socio – Economic Security) มิติความครอบคลุมทางสังคม (Social Inclusion) มิติความสมานฉันท์ทางสังคม (Social Cohesion) และมิติการเสริมสร้างพลังทางสังคม (Social Empowerment)",
    source:
      "กฤติยา อนุวงศ์. (2560). การพัฒนาสังคมไทยให้เป็นสังคมคุณภาพ เพื่อรองรับไทยแลนด์ 4.0, 14 มิถุนายน 2562. https://www.tci-thaijo.org/index.php/jsd/article/view/89839",
    sappear: 4,
    mappear: "",
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สังคมพหุวัฒนธรรม",
    meaning:
      "ประชากร กลุ่มคน หลากหลายชาติพันธุ์มาอยู่รวมกันในสังคมหนึ่ง ซึ่งมีความแตกต่างทางด้านขนบธรรมเนียม ประเพณี ภาษา วัฒนธรรม ศาสนา ความเชื่อ รวมถึงวิถีชีวิตความเป็นอยู่ของผู้คน วิธีการคิด การมีปฏิสัมพันธ์การสื่อสาร รวมถึงบุคคลที่มาจากพื้นฐานหรืออัตลักษณ์เดียวกัน",
    source:
      "ศูนย์มุสลิมศึกษา สถาบันเอเชียศึกษา 2549, 135 ; บัญญัติ ยงย่วน 2551, 93-94 ; ดุสิต หวันเหล็ม 2552, 68 ; เอกรินทร์ สังข์ทอง 2552,4\r\nhttp://kb.psu.ac.th/psukb/bitstream/2010/8487/6/Chapter2.pdf",
    sappear: 4,
    mappear: 1,
    rappear: 9,
    firstalpha: "ส"
  },
  {
    keyword: "สังคมยุคดิจิทัล",
    meaning:
      "สังคมที่สื่อและเทคโนโลยีมีอิทธิพลต่อการดำเนินชีวิต ช่วยให้ผู้คนในสังคมมีความสะดวกในการติดต่อสื่อสารและสืบค้นข้อมูล สามารถเชื่อมโยงถึงกันได้ทุกที่ ทุกเวลา ส่งผลต่อวิธีคิดของตั้งแต่วัยเด็กจนถึงวัยสูงอายุ คนร่วมสมัยในยุคดิจิทัลจึงต้องมีการปรับตัวให้เท่าทันเทคโนโลยี ต้องพัฒนาความรู้และการคิดวิเคราะห์ข้อมูลข่าวสาร เพื่อนำสารสนเทศมาช่วยในการตัดสินใจได้อย่างถูกต้อง การเรียนรู้สิ่งใหม่ไม่หยุดนิ่ง แล้วประยุกต์ใช้ให้เกิดประโยชน์สูงสุด\r\n",
    source:
      " มหาวิทยาลัยมหิดล สถาบันวิจัยประชากรและสังคม. (2561). จดหมายข่าวประชากรและการพัฒนา, 14 มิถุนายน 2562. http://www.newsletter.ipsr.mahidol.ac.th/index.php/component/content/article/128-popdev-vol39-no1/572-digital-social.html",
    sappear: 4,
    mappear: "",
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สังคมสูงวัย",
    meaning:
      "สังคมที่ประชากรกำลังมีอายุสูงขึ้น สังเกตได้จากอัตราส่วนร้อยของประชากรสูงอายุเพิ่มสูงขึ้นเรื่อยๆ แบ่งออกเป็น 3 ระดับ \r\n “สังคมสูงวัย” (Aged society) หมายถึงสังคมที่มีประชากรอายุ 60 ปีขึ้นไป มากกว่าร้อยละ 10 ของประชากรทั้งหมด \r\n“สังคมสูงอายุอย่างสมบูรณ์” (Complete-aged society) หมายถึง สังคมที่มีประชากรอายุ 60 ปีขึ้นไป มากกว่าร้อยละ 20 ของประชากรทั้งหมด\r\n“สังคมสูงอายุระดับสุดยอด” (Super-aged society) หมายถึง สังคมที่มีประชากรอายุ 60 ปีขึ้นไป มากกว่าร้อยละ 28 ของประชากรทั้งหมด",
    source:
      "สถานการณ์ผู้สูงอายุไทย พ.ศ. 2561, มูลนิธิสถาบันวิจัยและพัฒนาผู้สูงอายุไทย (มส.ผส.)\r\nสถาบันวิจัยประชากรและสังคม มหาวิทยาลัยมหิดล. 21 พฤศจิกายน 2562.\r\nhttp://www.dop.go.th/download/knowledge/th1573033396-261_0.pdf",
    sappear: 4,
    mappear: "2,13,15, 23",
    rappear: "2,9",
    firstalpha: "ส"
  },
  {
    keyword: "สัญญาการซื้อขายไฟฟ้า (Power Purchasing Agreement:PPA)",
    meaning:
      "ข้อตกลงเป็นลายลักษณ์อักษรเพื่อซื้อขายไฟฟ้าระหว่างผู้ผลิตไฟฟ้าขนาดเล็กมากกับการไฟฟ้าฝ่ายจําหน่าย \r\n1. ให้ผู้ยื่นขอผลิตไฟฟ้าขนาดเล็กมากที่ผ่านการคัดเลือกทําสัญญาซื้อขายไฟฟ้ากับการไฟฟ้าฝ่ายจําหน่ายตามแบบสัญญาซื้อขายไฟฟ้าที่การไฟฟ้าฝ่ายจําหน่ายกําหนด โดยความเห็นชอบของ กกพ. \r\n2. ห้ามผู้ผลิตไฟฟ้าขนาดเล็กมากโอนสิทธิและหน้าที่ตามคําเสนอขอขายไฟฟ้าหรือในสัญญาซื้อขายไฟฟ้าให้กับผู้อื่น เว้นแต่จะได้รับการยินยอมจากการไฟฟ้าฝ่ายจําหน่ายตามหลักเกณฑ์ของการไฟฟ้าฝ่ายจําหน่ายที่ได้รับความเห็นชอบจาก กกพ. ",
    source:
      "ระเบียบคณะกรรมการกํากับกิจการพลังงานว่าด้วยการจัดหาไฟฟ้าจากผู้ผลิตไฟฟ้าขนาดเล็กมากโครงการผลิตไฟฟ้าจากพลังงานหมุนเวียน พ.ศ. 2561. (2561, 9 มีนาคม). ราชกิจจานุเบกษา. เล่ม 135 ตอนพิเศษ 54 ง หน้า 16. http://www.ratchakitcha.soc.go.th/DATA/PDF/2561/E/054/15.PDF\r\n",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ส"
  },
  {
    keyword: "สัญญาขายฝาก",
    meaning:
      "สัญญาซึ่งบุคคลฝ่ายหนึ่งเรียกว่าผู้ขายโอนกรรมสิทธิ์แห่งทรัพย์สินให้แก่บุคคลอีกฝ่ายหนึ่งเรียกว่าผู้ซื้อ และผู้ซื้อตกลงว่าจะใช้ราคาทรัพย์สินนั้นให้แก่ผู้ขาย โดยมีข้อตกลงกันว่าผู้ขายไถ่ทรัพย์นั้นคืนได้",
    source:
      "นายยงยุทธ ภู่ประดับกฤต นางสาวพงษ์พิลัย วรรณราช และนางสาวอรดา เชาวน์วโรดม ศูนย์ข้อมูลกฎหมายกลาง สำนักงานคณะกรรมการกฤษฎีกา . สัญญาขายฝาก, 18 พฤศจิกายน 2562. http://web.krisdika.go.th/data/legalform/form_171/form_171.pdf",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ส"
  },
  {
    keyword: "สัญญาประชาคม",
    meaning:
      "ความตกลงร่วมกันของประชาชน กลุ่มคน และกลุ่มผลประโยชน์ต่างๆ ที่มีแนวความคิดหลากหลายและแตกต่างกัน เพื่อแสวงหาความตกลงและการแก้ไขปัญหาที่มีผลกระทบในวงกว้าง ซึ่งหากปล่อยไว้อาจจะก่อให้เกิดความแตกแยกในสังคม อันจะเกิดผลเสียต่อความมั่นคงและการพัฒนาประเทศชาติ",
    source:
      "สถาบันดำรงราชานุภาพ. สัญญาประชาคม, 20 สิงหาคม 2562. http://www.stabundamrong.go.th/web/thainiyom/thai13/1.pdf",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "ส"
  },
  {
    keyword:
      "สัญญารับประกันผลประหยัดพลังงาน (Energy Performance Contract: EPC)",
    meaning:
      "สัญญาที่มีการลงนามระหว่างบริษัทจัดการพลังงาน และเจ้าของสถานประกอบการ ซึ่งจะมีผลบังคับใช้ตั้งแต่การติดตั้งเครื่องจักรอุปกรณ์ ไปจนถึงระยะเวลาสิ้นสุดโครงการในสัญญาพลังงานจะมีการกำหนดปริมาณของพลังงานที่สามารถประหยัดได้เมื่อเทียบกับระดับการใช้พลังงานปกติ (Baseline Energy Use) ของกระบวนการผลิต เครื่องจักร อุปกรณ์ หรือระบบนั้นๆ ที่จะดำเนินการ โดยจะระบุระดับการใช้พลังงานปกติไว้ในสัญญาพลังงานด้วย ",
    source:
      "สภาอุตสาหกรรมแห่งประเทศไทย. สัญญาพลังงาน, 30 สิงหาคม 2562. https://thaiesco.org/thai/network_contract.aspx",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "ส"
  },
  {
    keyword: "สัดส่วนกำลังแรงงานด้านวิทยาศาสตร์และเทคโนโลยี",
    meaning:
      "1. ผู้สำเร็จการศึกษาตั้งแต่ระดับ ปวช. ขึ้นไปในสาขาวิทยาศาสตร์และเทคโนโลยี ได้แก่ วิทยาศาสตร์ธรรมชาติ (Natural science) วิศวกรรมศาสตร์และเทคโนโลยี (Engineering and technology) วิทยาศาสตร์การแพทย์ (Medical science) และเกษตรศาสตร์ (Agricultural science) หรือ\r\n2. ผู้ที่ไม่ได้สำเร็จการศึกษาในสาขาวิทยาศาสตร์และเทคโนโลยี แต่ปฏิบัติงานในตำแหน่งที่ต้องการบุคลากรที่จบการศึกษาในสาขาวิทยาศาสตร์และเทคโนโลยีตั้งแต่ระดับ ปวช. ขึ้นไป เช่น ผู้ประกอบอาชีพและช่างเทคนิคด้านฟิสิกส์ คณิตศาสตร์ วิศวกรรมศาสตร์ และวิทยาศาสตร์เกี่ยวกับสิ่งมีชีวิตและสุขภาพ รวมทั้งผู้ประกอบอาชีพอื่นๆ ที่เกี่ยวข้อง",
    source:
      "สำนักงานสภานโยบายการอุดมศึกษา วิทยาศาสตร์ วิจัย และนวัตกรรมแห่งชาติ. คำอธิบายข้อมูลกำลังแรงงานด้านวิทยาศาสตร์และเทคโนโลยีของประเทศไทย, 18 กันยายน 2562. http://stiic.sti.or.th/tableinfo/%e0%b8%84%e0%b8%b3%e0%b8%ad%e0%b8%98%e0%b8%b4%e0%b8%9a%e0%b8%b2%e0%b8%a2-lf-t011/",
    sappear: "",
    mappear: 11,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword:
      "สัดส่วนประชากรอายุ 25 – 59 ปีที่มีการเตรียมการเพื่อยามสูงอายุทั้งมิติทางเศรษฐกิจ สังคม สุขภาพ และสภาพแวดล้อม เทียบกับจำนวนประชากรอายุ 25-59 ปี ทั้งหมด ",
    meaning:
      "การเตรียมการเพื่อยามสูงอายุด้านเศรษฐกิจ ประชากรและสังคม สุขภาพ สภาพแวดล้อม และด้านเทคโนโลยีและนวัตกรรม พิจารณาจากคะแนนโดยเฉลี่ยรวมของการเตรียมการในประเด็นต่าง ๆ ดังนี้\r\n1. การเตรียมเรื่องการทำศพสำหรับตนเอง\r\n2. การศึกษาเกี่ยวกับสิทธิที่ผู้สูงอายุพึงได้รับตามกฎหมาย\r\n3. การทำงานให้ชุมชนหรือเป็นอาสาสมัครเมื่ออยู่ในวัยสูงอายุ\r\n4. การใช้ชีวิตเมื่ออยู่ในวัยสูงอายุ\r\n5. การออมหรือการสะสมเงินทองทรัพย์สินให้เพียงพอ เพื่อใช้ในวัยสูงอายุ\r\n6. การศึกษาธรรมะหรือเข้าร่วมกิจกรรมทางศาสนาที่บ่อยขึ้นเมื่ออยู่ในวัยสูงอายุ\r\n7. การทำตนเองให้มีสภาพทางจิตใจที่ดีหรือปล่อยวางก่อนวัยสูงอายุ\r\n8. การทำตัวเองให้มีสุขภาพกายที่แข็งแรงก่อนวัยสูงอายุ\r\n9. การจะให้ใครเป็นผู้ดูแลในช่วงวัยสูงอายุ\r\n10. การจะอยู่กับใครเมื่ออยู่ในวัยสูงอายุ",
    source:
      "วิทยาลัยประชากรศาสตร์ จุฬาลงกรณ์มหาวิทยาลัย. การเตรียมการเพื่อยามสูงอายุด้านเศรษฐกิจ สังคม สุขภาพ และสภาพแวดล้อม, 11 กันยายน 2562. http://www.cps.chula.ac.th/newcps/hot_news_detail.php?id=307",
    sappear: 4,
    mappear: 15,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สัดส่วนผู้สูงอายุที่ประสบปัญหาความยากจนหลายมิติลดลง",
    meaning:
      "ความยากจนหลายมิติ ประกอบด้วย 5 มิติ ได้แก่ (1) ด้านสุขภาพ (2) ด้านความเป็นอยู่ (3) ด้านการศึกษา (4) ด้านรายได้ และ (5) ด้านการเข้าถึงบริการภาครัฐ ซึ่งเป็นการนำข้อมูลจากระบบข้อมูลขนาดใหญ่สำหรับการพัฒนาคนตลอดช่วงชีวิต (Thai People Map and Analytics Platform: TPMAP) มาใช้ในการชี้เป้าระดับบุคคลและครัวเรือน เพื่อแก้ไขปัญหาความยากจนหลายมิติระดับบุคคลและครัวเรือนในระดับพื้นที่ที่เหมาะสมและครอบคลุมกลุ่มเป้าหมายได้อย่างมีประสิทธิภาพยิ่งขึ้น",
    source:
      "ระบบ TPMAP Thai People Map and Analytics Platform. ความยากจนหลายมิติ, 15 พฤศจิกายน 2562. https://www.tpmap.in.th/",
    sappear: "",
    mappear: 15,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สัดส่วนภาระหนี้ต่อรายได้ (debt service ratio) (ร้อยละ)",
    meaning:
      "หนึ่งในมาตรการที่สามารถนำมาใช้เพื่อช่วยแก้ปัญหาหนี้ครัวเรือนได้ โดยหน่วยงานที่มีอำนาจกำกับดูแลสถาบันการเงินสามารถบังคับใช้หรือขอความร่วมมือไม่ให้สถาบันการเงินปล่อยสินเชื่อแก่ผู้กู้ที่มีระดับ DSR สูงเกินกว่าระดับที่หน่วยงานกำกับดูแลเห็นว่าอาจส่งผลให้ผู้กู้เริ่มมีปัญหาในการชำระหนี้ ซึ่งอาจก่อให้เกิดความเสี่ยงต่อสถาบันการเงินที่ปล่อยกู้ได้",
    source:
      "ธนาคารแห่งประเทศไทย (2558). มาตรการเพื่อแก้ปัญหาหนี้ครัวเรือนในต่างประเทศ: Debt Service Ratio, 12 กันยายน 2562. https://www.bot.or.th/Thai/FinancialInstitutions/Highlights/ASEANCommunity/BankersTalk/Vol3Issue1.pdf",
    sappear: "",
    mappear: 16,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สัตบุรุษ",
    meaning:
      "คนที่เป็นสัมมาทิฐิ, คนดีน่านับถือ มีคุณธรรม ประพฤติอยู่ในศีลในธรรม",
    source:
      "ราชบัณฑิตยสถาน. สัตบุรุษ , 19 กรกฎาคม 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "ส"
  },
  {
    keyword: "สัตยาบัน",
    meaning:
      "การยืนยันรับรองความตกลงระหว่างประเทศที่ได้กระทำขึ้นไว้ การรับรองนิติกรรมที่เป็นโมฆียะอันเป็นผลให้นิติกรรมนั้นสมบูรณ์มาแต่เริ่มแรก",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สัตยาบัน. 22 ตุลาคม 2562. http://www.royin.go.th/dictionar  ",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ส"
  },
  {
    keyword: "สันติภาพ (การเมือง)",
    meaning:
      'สภาวะแห่งความสันติหรือไม่มีการโต้เถียงอย่างรุนแรงกันเกิดขึ้น "สันติภาพ" ใช้อธิบายการยุติแห่งความขัดแย้งอย่างใช้ความรุนแรง สันติภาพสามารถนำมาใช้อธิบายความสัมพันธ์ของผู้คนที่มีความเคารพ ความยุติธรรมและความหวังดี',
    source:
      "สำนักงานเลขานุการทูตสันติภาพ. (2555). ความหมาย “สันติภาพ”, 7 พฤศจิกายน 2562. http://www.upf.or.th/2010/index.php?option=com_content&view=article&id=192%3Athe-meaning-of-peace&catid=49%3Aambassader-for-peace&Itemid=37",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ส"
  },
  {
    keyword: "สันติวิธี",
    meaning: "วิธีที่จะก่อให้เกิดความสงบ เช่น เจรจาสงบศึกโดยสันติวิธี",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สันติวิธี. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ส"
  },
  {
    keyword: "สันติสุข ",
    meaning:
      "ความสุขที่เกิดจากความสงบ เช่น รัฐบาลบริหารประเทศเพื่อสันติสุขของประชาชน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. \r\nสันติสุข, 20 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 1,
    mappear: "",
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สัมมาชีพ",
    meaning:
      "อาชีพที่สุจริต, อาชีพที่ชอบธรรม เช่น การทำไร่ทำนานับว่าเป็นสัมมาชีพอย่างหนึ่ง",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สัมมาชีพ, 30 สิงหาคม 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 11,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สัมมาชีพชุมชน",
    meaning:
      "ชุมชนที่มีการประกอบอาชีพโดยชอบ ไม่เบียดเบียนตนเอง ไม่เบียดเบียนผู้อื่น ไม่เบียดเบียนสิ่งแวดล้อม และมีรายได้มากกว่ารายจ่าย เป็นความพยายามที่จะปรับจากการทำมาหากินเป็นทำมาค้าขาย โดยไม่ได้เอากำไรสูงสุดเป็นตัวตั้งหรือเป็นเป้าหมายสุดท้าย และต้องคำนึงถึงความเป็นธรรมทางสังคม คือ ความสุขของตนและคนทำงาน รวมถึงประโยชน์ของผู้บริโภคและผู้รับบริการเป็นหลัก",
    source:
      "กรมการพัฒนาชุมชน กระทรวงมหาดไทย. แนวทางการสร้างสัมมาชีพชุมชน ปี ๒๕๖๒, 30 สิงหาคม 2562.\r\nhttp://district.cdd.go.th/phichai/wp-content/uploads/sites/860/2019/03/แนวทางการสร้างสัมมาชีพชุมชน-2562.pdf",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "ส"
  },
  {
    keyword: "สาธารณภัย",
    meaning:
      "อัคคีภัย วาตภัย อุทกภัย ภัยแล้ง โรคระบาดในมนุษย์โรคระบาดสัตว์ โรคระบาดสัตว์น้ำ การระบาดของศัตรูพืช ตลอดจนภัยอื่นๆ อันมีผลกระทบต่อสาธารณชน ไม่ว่าเกิดจากธรรมชาติ มีผู้ทำให้เกิดขึ้น อุบัติเหตุ หรือเหตุอื่นใด ซึ่งก่อให้เกิดอันตรายแก่ชีวิต ร่างกายของประชาชน หรือความเสียหายแก่ทรัพย์สินของประชาชน หรือของรัฐ และให้หมายความรวมถึงภัยทางอากาศ และการก่อวินาศกรรมด้วย\r\n",
    source:
      "พระราชบัญญัติป้องกันและบรรเทาสาธารณภัย พ.ศ. 2550 (2550, 28 สิงหาคม). ราชกิจจานุเบกษา. เล่มที่ 124 ตอนที่ 52 ก หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2550/A/052/1.PDF",
    sappear: "",
    mappear: 1,
    rappear: 8,
    firstalpha: "ส"
  },
  {
    keyword: "สาธารณูปโภค",
    meaning:
      "บริการสาธารณะที่จัดทำเพื่ออำนวยประโยชน์แก่ประชาชนในสิ่งอุปโภคที่จำเป็นต่อการดำเนินชีวิต เช่น การไฟฟ้า การประปา การเดินรถประจำทาง โทรศัพท์",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สาธารณูปโภค. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 5,
    mappear: "",
    rappear: 5,
    firstalpha: "ส"
  },
  {
    keyword: "สาธารณูปโภคพื้นฐาน",
    meaning:
      "บริการสาธารณะที่จัดทำเพื่ออำนวยประโยชน์แก่ประชาชนในสิ่งอุปโภคที่จำเป็นต่อการดำเนินชีวิต",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ.2554. สาธารณูปโภค. 25 ตุลาคม 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ส"
  },
  {
    keyword: "สาธารณูปการ",
    meaning:
      "กิจการเกี่ยวกับการสงเคราะห์บุคคลที่ไม่สามารถช่วยตัวเองได้ เช่น คนชรา คนพิการ เด็กกำพร้า.",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สาธารณูปโภค. 18 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สารเคมี",
    meaning:
      "สารที่ประกอบด้วยธาตุชนิดเดียวกันหรือสารประกอบจากธาตุต่างๆรวมกันด้วยพันธะเคมี ได้แก่ ธาตุ (Element), สารประกอบ (Compound), สารผสม (Mixture)",
    source:
      "กรมโรงงานุตสาหกรรม. กฎหมายที่เกี่ยวข้องและการตรวจโรงงานที่มีการใช้สารเคมี, 31 กรกฎาคม 2562. http://www.asew-expo.com/Portals/0/conference/Presenttation/Day9/9%20June%2017%20(MR214)%20DIW%20%E0%B8%81%E0%B8%8E%E0%B8%AB%E0%B8%A1%E0%B8%B2%E0%B8%A2%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B9%80%E0%B8%81%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%A7%E0%B8%82%E0%B9%89%E0%B8%AD%E0%B8%87%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%95%E0%B8%A3%E0%B8%A7%E0%B8%88%E0%B9%82%E0%B8%A3%E0%B8%87%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%A1%E0%B8%B5%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%83%E0%B8%8A%E0%B9%89%E0%B8%AA%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%84%E0%B8%A1%E0%B8%B5.pdf",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สารตั้งต้น",
    meaning:
      "เคมีภัณฑ์หรือสารสังเคราะห์ที่ใช้ประโยชน์ในภาคอุตสาหกรรมอย่างถูกกฎหมาย แต่มักนำมาใช้เป็นสารตั้งต้นในการผสมกับสารอื่นให้ได้สารที่ต้องการ เพื่อผลิตยาหรือวัตถุดิบเสพติด จึงต้องมีการควบคุมอย่างเข้มงวด ทั้งแหล่งผลิต ทางผ่าน และปลายทาง ทั้งการใช้และปริมาณ เพื่อป้องกันการรั่วไหลหรือลักลอบนำไปผลิตยาหรือวัตถุดิบเสพติดที่ผิดกฎหมาย",
    source:
      "กองควบคุมวัตถุเสพติด สำนักงานคณะกรรมการอาหารและยา.  สารตั้งต้นและเคมีภัณฑ์ที่ใช้ในการลักลอบผลิตยาเสพติด, 6 ธันวาคม 2562. http://www.fda.moph.go.th/sites/Narcotics/SitePages/Narcotics_List_substrate.aspx",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สารบัญญัติ",
    meaning: "กฎหมายที่ว่าด้วยสิทธิ หน้าที่ และความรับผิดชอบของบุคคลทั่วไป ",
    source:
      "พจนานุกรมกฎหมาย โดย ขุนสมาหารหิตะคดี (โป๊ โปรคุปต์). (2553). กฎหมาย. 14 มิถุนายน 2562. https://th.wikisource.org/wiki/%E0%B8%9E%E0%B8%88%E0%B8%99%E0%B8%B2%E0%B8%99%E0%B8%B8%E0%B8%81%E0%B8%A3%E0%B8%A1%E0%B8%81%E0%B8%8E%E0%B8%AB%E0%B8%A1%E0%B8%B2%E0%B8%A2/%E0%B8%81%E0%B8%8E%E0%B8%AB%E0%B8%A1%E0%B8%B2%E0%B8%A2",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "ส"
  },
  {
    keyword: "สารสนเทศภาครัฐ",
    meaning:
      "การนำระบบเทคโนโลยีสารสนเทศมาใช้ในการพัฒนาฐานข้อมูลของหน่วยงานของรัฐต่างๆ ทุกระดับให้เชื่อมโยงกัน ทำให้หน่วยงานของรัฐสามารถบริหารจัดการงานได้อย่างมีประสิทธิภาพและมีประสิทธิผล",
    source:
      "สำนักวิชาการ สำนักงานเลขาธิการสภาผู้แทนราษฎร. การบริหารจดการภาครัฐ : รัฐบาลอิเล็กทรอนิกส์ (e–Government), 25 ตุลาคม 2562. https://library2.parliament.go.th/ejournal/content_af/2558/apr2558-2.pdf",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ส"
  },
  {
    keyword: "สารัตถะ",
    meaning: "เนื้อหาหลัก, ใจความสำคัญ, ความคิดสำคัญของเรื่อง",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สารัตถะ. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ส"
  },
  {
    keyword: "สิ่งแวดล้อม",
    meaning:
      "สิ่งต่าง ๆ ที่มีลักษณะทางกายภาพและชีวภาพที่อยู่รอบตัวมนุษย์ซึ่งเกิดขึ้นโดยธรรมชาติและสิ่งที่มนุษย์ได้ทําขึ้น",
    source:
      "พระราชบัญญัติส่งเสริมและรักษาคุณภาพสิ่งแวดล้อมแห่งชาติ พ.ศ. 2535. (2535, 4 เมษายน). ราชกิจจานุเบกษา. เล่ม 109 ตอนที่ 17 หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/037/1.PDF",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สิ่งปฏิกูล",
    meaning: "สิ่งสกปรกน่ารังเกียจ เช่น ขยะเป็นสิ่งปฏิกูล",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สิ่งปฏิกูล. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สิทธิ",
    meaning:
      "ประโยชน์ที่กฎหมายรับรองและให้ความคุ้มครองป้องกัน เช่น สิทธิในชีวิตและร่างกาย มิให้ใครมาทำร้ายทุบตีเรา หรือสิทธิในทรัพย์สิน หากมีใครมารุกล้ำ หรือเอาทรัพย์สินของเราไปโดยไม่ได้รับอนุญาต ก็จะถือว่า ละเมิดสิทธิ ทำผิดกฎหมาย ",
    source:
      "สำนักงานคณะกรรมการการเลือกตั้ง. สาระน่ารู้เกี่ยวกับรัฐธรรมนูญ ชุด สิทธิ เสรีภาพ และหน้าที่ของปวงชนชาวไทย, 18 กันยายน 2562.\r\nhttps://www.ect.go.th/nakhonsawan/ewt_dl_link.php?nid=225",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ส"
  },
  {
    keyword: "สิทธิ เสรีภาพ",
    meaning:
      "การประกันสิทธิและเสรีภาพในชีวิตและร่างกายในเคหสถาน การเลือกที่อยู่อาศัย การเดินทาง เกียรติยศชื่อเสียง ความเป็นส่วนตัว การสื่อสารของบุคคล การนับถือศาสนา การป้องกันมิให้รัฐบังคับใช้แรงงาน",
    source:
      "สุเทพ เอี่ยมคง สถาบันพระปกเกล้า. (2559). สิทธิและเสรีภาพของชนชาวไทย, 20 สิงหาคม 2562. \r\nhttp://wiki.kpi.ac.th/index.php?title=%E0%B8%AA%E0%B8%B4%E0%B8%97%E0%B8%98%E0%B8%B4%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B9%80%E0%B8%AA%E0%B8%A3%E0%B8%B5%E0%B8%A0%E0%B8%B2%E0%B8%9E%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B8%8A%E0%B8%99%E0%B8%8A%E0%B8%B2%E0%B8%A7%E0%B9%84%E0%B8%97%E0%B8%A2",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ส"
  },
  {
    keyword: "สิทธิเสรีภาพส่วนบุคคล",
    meaning:
      "การประกันสิทธิและเสรีภาพในชีวิตและร่างกายในเคหสถาน การเลือกที่อยู่อาศัย การเดินทาง เกียรติยศชื่อเสียง ความเป็นส่วนตัว การสื่อสารของบุคคล การนับถือศาสนา การป้องกันมิให้รัฐบังคับใช้แรงงาน",
    source:
      "สุเทพ เอี่ยมคง สถาบันพระปกเกล้า. (2559). สิทธิและเสรีภาพของชนชาวไทย, 30 สิงหาคม 2562. \r\nhttp://wiki.kpi.ac.th/index.php?title=%E0%B8%AA%E0%B8%B4%E0%B8%97%E0%B8%98%E0%B8%B4%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B9%80%E0%B8%AA%E0%B8%A3%E0%B8%B5%E0%B8%A0%E0%B8%B2%E0%B8%9E%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B8%8A%E0%B8%99%E0%B8%8A%E0%B8%B2%E0%B8%A7%E0%B9%84%E0%B8%97%E0%B8%A2",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ส"
  },
  {
    keyword: "สิทธิขั้นพื้นฐาน",
    meaning:
      "1. สิทธิเท่าเทียมกันของชายและหญิง\r\n2. สิทธิที่จะได้รับการคุ้มครองตามกฎหมายโดยเท่าเทียมกัน\r\n3. สิทธิทางการเมือง ประชาชนมีสิทธิในการแสดงความ คิดเห็น การเข้าร่วมกิจกรรมทางการเมือง\r\n4. สิทธิในทรัพย์สิน ประชาชนชาวไทยมีสิทธิที่จะเป็น เจ้าของทรัพย์สินส่วนบุคคลได้\r\n5. สิทธิในครอบครัว ประชาชนจะได้รับการคุ้มครองจาก รัฐในการดํารงชีวิตในครอบครัว\r\n6. สิทธิเสนอเรื่องราวร้องทุกข์ เมื่อได้รับความไม่เป็นธรรม\r\n7. สิทธิในการรับการศึกษาขั้นมูลฐาน\r\n8. สิทธิที่จะฟ้องหน่วยราชการ เมื่อเห็นเจ้าพนักงานของ หน่วยราชการทําไม่ถูกต้อง",
    source:
      "กรมประชาสัมพันธ์. (2559). สิทธิพื้นฐานของประชาชนในระบบประชาธิปไตย, 18 กันยายน 2562. \r\nhttps://www.prd.go.th/ewt_news.php?nid=153069&filename=index",
    sappear: "",
    mappear: 17,
    rappear: 4,
    firstalpha: "ส"
  },
  {
    keyword: "สิทธิชุมชน",
    meaning:
      "ข้อตกลง กฎเกณฑ์ทางสังคมที่พัฒนาให้กลุ่มคนร่วมกันจัดการทรัพยากร การจัดการทางเศรษฐกิจ สังคมและอื่น ๆ โดยกลุ่มคนดังกล่าวมีความสัมพันธ์ทางสังคมร่วมกัน มีวัฒนธรรมร่วมกัน จำเป็นต้องจัดการร่วมกัน โดยชุมชนได้สร้างข้อตกลงหรือกติกาในการจัดการทรัพยากร เศรษฐกิจ สังคม ข้อตกลงอาจเป็นลายลักษณ์อักษร หรือกฎจารีตประเพณี ซึ่งข้อตกลงเป็นเรื่องของการเรียนรู้ การต่อสู้ ต่อรองทั้งภายใน ระหว่างชุมชนหรือภายนอกชุมชน ข้อตกลงร่วมจึงมีการปรับเปลี่ยนตามสถานการณ์ทางเศรษฐกิจการเมือง และสังคม สิทธิชุมชนจึงมีขอบเขตที่กว้าง ยืดหยุ่น และปรับเปลี่ยนได้\r\n",
    source:
      "สำนักงานเลขาธิการสภาผู้แทนราษฎร. สิทธิชุมชนตามรัฐธรรมนูญ. 25 กรกฎาคม 2562. https://www.parliament.go.th/ewtadmin/ewt/parliament_parcy/download/article/article_20120829143243.pdf?vcode=-2",
    sappear: 4,
    mappear: "",
    rappear: 9,
    firstalpha: "ส"
  },
  {
    keyword: "สิทธิบัตร",
    meaning:
      "หนังสือสำคัญที่ออกให้เพื่อคุ้มครองการประดิษฐ์ หรือการออกแบบผลิตภัณฑ์ ",
    source:
      "พระราชบัญญัติสิทธิบัตร 2522 (2522, 16 มีนาคม). ราชกิจจานุเบกษา. เล่ม 96 ตอนที่ 35. หน้า 2 http://www.ratchakitcha.soc.go.th/DATA/PDF/2522/A/035/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ส"
  },
  {
    keyword: "สิทธิพลเมืองและสิทธิทางการเมือง",
    meaning:
      "สิทธิในการมีชีวิตอยู่ เสรีภาพจากการถูกทรมาน การห้ามบุคคลมิให้ตกอยู่ในภาวะเยี่ยงทาส การห้ามบุคคลมิให้ถูกจับกุมโดยตามอำเภอใจ การปฏิบัติต่อผู้ถูกลิดรอนเสรีภาพอย่างมีมนุษยธรรม การห้ามบุคคลถูกจำคุกด้วยเหตุที่ไม่สามารถชำระหนี้ตามสัญญาได้ เสรีภาพในการโยกย้ายถิ่นฐาน ความเสมอภาคของบุคคลภายใต้กฎหมาย การห้ามมิให้มีการบังคับใช้กฎหมายอาญาย้อนหลัง สิทธิการได้รับรองเป็นบุคคลตามกฎหมาย การห้ามแทรกแซงความเป็นส่วนตัว การคุ้มครองเสรีภาพทางความคิด เสรีภาพในการแสดงความคิดเห็นและการแสดงออก การห้ามการโฆษณาชวนเชื่อเพื่อการสงครามหรือก่อให้เกิดความเกลียดชังทางเชื้อชาติ สิทธิที่จะอยู่ในชุมนุมอย่างสันติ การรวมกันเป็นสมาคม สิทธิของชายหญิงที่อยู่ในวัยที่เหมาะสมในการมีครอบครัว การคุ้มครองสิทธิเด็ก และการที่พลเมืองทุกคนมีสิทธิที่จะมีส่วนในกิจการสาธารณะ การรับรองว่าบุคคลทั้งปวงย่อมเสมอภาคกันตามกฎหมายและได้รับการคุ้มครองอย่างเท่าเทียมกัน การรับรองสิทธิของชนกลุ่มน้อยทางเผ่าพันธุ์ ศาสนา และภาษาภายในรัฐ",
    source:
      "คณะกรรมการสิทธิมนุษยชนแห่งชาติ. กติการะหว่างประเทศว่าด้วยสิทธิพลเมืองและสิทธิทางการเมือง (International Covenant on Civil and Political Rights - ICCPR) ,หน้า 16. 15 สิงหาคม 2562. \r\nhttp://www.nhrc.or.th/Human-Rights-Knowledge/International-Human-Rights-Affairs/International-Law-of-human-rights/ICCPR_th.aspx",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ส"
  },
  {
    keyword: "สิทธิมนุษยชน",
    meaning:
      "ศักดิ์ศรีความเป็นมนุษย์ สิทธิ เสรีภาพและความเสมอภาคของบุคคล บรรดาที่ได้รับการรับรองหรือคุ้มครองตามรัฐธรรมนูญ ตามกฎหมาย หรือตามหนังสือสัญญาที่ประเทศไทยเป็นภาคีและมีพันธกรณีที่จะต้องปฏิบัติตาม",
    source:
      "พระราชบัญญัติประกอบรัฐธรรมนูญว่าด้วยคณะกรรมการสิทธิมนุษยชนแห่งชาติ พ.ศ. 2560 (2560, 12 ธันวาคม). ราชกิจจานุเบกษา.  เล่ม 134 ตอนที่ 123 กhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2560/A/123/1.PDF",
    sappear: 4,
    mappear: 15,
    rappear: 1,
    firstalpha: "ส"
  },
  {
    keyword: "สินไถ่",
    meaning: "จำนวนเงินที่ชำระเพื่อไถ่ทรัพย์สินคืนจากการขายฝาก",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. สินไถ่. 18 พฤศจิกายน 2562 http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "ส"
  },
  {
    keyword: "สินค้า",
    meaning: "สิ่งของที่ผลิตหรือมีไว้เพื่อขาย",
    source:
      "พระราชบัญญัติคุ้มครองผู้บริโภค พ.ศ. 2522. (2522, 4 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 96 ตอนที่ 72 ก หน้า 21 .http://www.ratchakitcha.soc.go.th/DATA/PDF/2522/A/072/20.PDF",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ส"
  },
  {
    keyword: "สินค้าเกษตร",
    meaning:
      "ผลิตผลหรือผลิตภัณฑ์อันเกิดจากการกสิกรรม การประมง การปศุสัตว์ หรือการป่าไม้ และผลพลอยได้\r\nของผลิตผลหรือผลิตภัณฑ์ดังกล่าว",
    source:
      "พระราชบัญญัติมาตรฐานสินค้าเกษตร พ.ศ. 2551. (2551, 22 กุมภาพันธ์). ราชกิจจานุเบกษา. เล่ม 125 ตอนที่ 37 ก หน้า 2 .http://www.ratchakitcha.soc.go.th/DATA/PDF/2551/A/037/1.PDF",
    sappear: "",
    mappear: 3,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สินค้าสิ่งบ่งชี้ทางภูมิศาสตร์",
    meaning:
      "สินค้าที่ใช้สิ่งบ่งชี้ทางภูมิศาสตร์มักจะเป็นสินค้าที่มีชื่อเสียงและได้รับความนิยม เนื่องจากมีคุณสมบัติพิเศษหรือมีลักษณะเฉพาะที่เกิดจากอิทธิพลสิ่งแวดล้อมทางภูมิศาสตร์ เช่น สภาพแวดล้อม ดิน ฟ้า อากาศ ของแหล่งภูมิศาสตร์นั้นๆ ตลอดจนทักษะความชำนาญและภูมิปัญญาของกลุ่มชนที่อาศัยอยู่ในแหล่งภูมิศาสตร์นั้นๆ  สิ่งบ่งชี้ทางภูมิศาสตร์  อาจแบ่งได้เป็น 2 ลักษณะคือ\r\n         1. สิ่งบ่งชี้ทางภูมิศาสตร์โดยตรง (Direct Geographical Indication) กล่าวคือ เป็นชื่อทางภูมิศาสตร์ที่เกี่ยวข้องกับสินค้านั้น ๆโดยตรง  เช่น ไชยา เพชรบูรณ์ เป็นต้น\r\n         2. สิ่งบ่งชี้ทางภูมิศาสตร์โดยอ้อม (Indirect Geographical Indication) กล่าวคือ เป็นสัญลักษณ์ หรือสิ่งอื่นใดที่ไม่ใช่ชื่อทางภูมิศาสตร์  ซึ่งใช้เพื่อบ่งบอกแหล่งภูมิศาสตร์อันเป็นแหล่งกำเนิดหรือแหล่งผลิตของสินค้า เช่น สัญลักษณ์ประจำอำเภอ หรือจังหวัด รูปย่าโม  รูปหอไอเฟลเป็นต้น",
    source:
      "กรมทรัพย์สินทางปัญญา กระทรวงพานิชย์. (2559). ความรู้เบื้องต้น เรื่องสิ่งบางชี้ทางภูมิศาสตร์, 15 สิงหาคม 2562. http://www.ipthailand.go.th/th/faq/item/%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%A3%E0%B8%B9%E0%B9%89%E0%B9%80%E0%B8%9A%E0%B8%B7%E0%B9%89%E0%B8%AD%E0%B8%87%E0%B8%95%E0%B9%89%E0%B8%99-%E0%B9%80%E0%B8%A3%E0%B8%B7%E0%B9%88%E0%B8%AD%E0%B8%87%E0%B8%AA%E0%B8%B4%E0%B9%88%E0%B8%87%E0%B8%9A%E0%B9%88%E0%B8%87%E0%B8%8A%E0%B8%B5%E0%B9%89%E0%B8%97%E0%B8%B2%E0%B8%87%E0%B8%A0%E0%B8%B9%E0%B8%A1%E0%B8%B4%E0%B8%A8%E0%B8%B2%E0%B8%AA%E0%B8%95%E0%B8%A3%E0%B9%8C.html",
    sappear: 2,
    mappear: 3,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สินทรัพย์",
    meaning: "บรรดาทรัพย์สินซึ่งบุคคลเป็นเจ้าของ เช่น เงิน ทรัพย์",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วิจารณญาณ. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ส"
  },
  {
    keyword: "สื่อโฆษณา",
    meaning:
      "สิ่งที่ใช้เป็นสื่อในการโฆษณา เช่น หนังสือพิมพ์ สิ่งพิมพ์ วิทยุกระจายเสียง วิทยุโทรทัศน์ ไปรษณีย์โทรเลข โทรศัพท์ หรือป้าย\r\n",
    source:
      "พระราชบัญญัติคุ้มครองผู้บริโภค พ.ศ. 2522. (2522, 4 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 96 ตอนที่ 72 ก หน้า 22 .http://www.ratchakitcha.soc.go.th/DATA/PDF/2522/A/072/20.PDF",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ส"
  },
  {
    keyword: "สื่อการเรียนรู้",
    meaning:
      "ทุกสิ่งทุกอย่างรอบตัวผู้เรียนที่ช่วยผู้เรียนเกิดการเรียนรู้ ไม่ว่าจะเป็นวัสดุ อุปกรณ์ วิธีการ คน สัตว์ สิ่งของ หรือแนวความคิดที่ถ่ายทอดความรู้เพิ่มประสบการณ์ หรือเป็นเครื่องมือที่กระตุ้นให้เกิดการแสวงหาความรู้ด้วยตนเอง",
    source:
      "มหาวิทยาลัยมหิดล. อภิธานศัพท์ สื่อการเรียนรู้, 8 กรกฎาคม 2562. https://www.eg.mahidol.ac.th/egmu/images/Plan/Glossary.pdf",
    sappear: "",
    mappear: 12,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สื่อปลอดภัยและสร้างสรรค์",
    meaning:
      "สื่อที่มีเนื้อหาส่งเสริมศีลธรรม จริยธรรม วัฒนธรรมและความมั่นคง ส่งเสริมความคิดสร้างสรรค์ การเรียนรู้ทักษะการใช้ชีวิตของประชาชนโโยเฉพาะเด็กและเยาวชน และส่งเสริมความสัมพันธ์ที่ดีในครอบครัวและสังคม รวมถึงการส่งเสริมให้ประชาชนมีความสามัคคีและสามารถใช้ชีวิตในสังคมที่มีความหลากหลายได้อย่างเป็นสุข",
    source:
      "พระราชบัญญัติกองทุนพัฒนาสื่อปลอดภัยและสร้างสรรค์ พ.ศ. 2558. (2558, 26 มีนาคม). ราชกิจจานุเบกษา. เล่ม 132 ตอนที่ 21 ก หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2558/A/021/30.PDF",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "ส"
  },
  {
    keyword: "สื่อสร้างสรรค์",
    meaning:
      "สื่อที่มีเนื้อหาส่งเสริมศีลธรรม จริยธรรม วัฒนธรรมและความมั่นคง ส่งเสริมความคิดสร้างสรรค์ การเรียนรู้ทักษะการใช้ชีวิตของประชาชนโโยเฉพาะเด็กและเยาวชน และส่งเสริมความสัมพันธ์ที่ดีในครอบครัวและสังคม รวมถึงการส่งเสริมให้ประชาชนมีความสามัคคีและสามารถใช้ชีวิตในสังคมที่มีความหลากหลายได้อย่างเป็นสุข",
    source:
      "พระราชบัญญัติกองทุนพัฒนาสื่อปลอดภัยและสร้างสรรค์ พ.ศ. 2558. (2558, 26 มีนาคม). ราชกิจจานุเบกษา. เล่ม 132 ตอนที่ 21 ก หน้า 1. http://www.ratchakitcha.soc.go.th/DATA/PDF/2558/A/021/30.PDF",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สื่อสังคมออนไลน์",
    meaning:
      "สื่อที่ผู้ใช้งานสามารถเข้าถึงได้สะดวก รวดเร็ว และเป็นที่นิยมในปัจจุบัน โดยเข้ามาแบ่งปันความรู้ ข้อมูล ข่าวสารต่าง ๆ ให้แก่กันได้อย่างอิสระและโต้ตอบแสดงความคิดเห็นกันได้อย่างทันท่วงทีแบบ 2 ทาง (Interactive) ผ่านเครือข่ายสังคมหรือชุมชนออนไลน์ (Social Network) ซึ่งมักประกอบไปด้วยการแชท การส่งข้อความ การส่งอีเมล วีดีโอ เพลง การอัปโหลดรูป และบล็อก (Blog)",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์ (ETDA) โครงการสร้างความตระหนักในการใช้อินเทอร์เน็ตให้เสริมสร้างรายได้และรู้เท่าทันภัยคุกคามไซเบอร์. วัยใส วัยเก๋า ฉลาดรู้เน็ต, 6 ธันวาคม 2562. https://www.etda.or.th/publishing-detail/internet-for-better-life-handbook-2.html",
    sappear: "",
    mappear: "1,7",
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สุขาภิบาล",
    meaning:
      "“สุขาภิบาล” มาจากคำว่า สุข+อภิบาล ดังนั้น คำว่า การสุขาภิบาล หมายถึง การระวังรักษาเพื่อให้เกิดความสุข ",
    source:
      "ภานุวัฒน์ อ่อนเทศ. ด้านการสุขาภิบาล, 17 มิถุนายน 2562. http://bangkokgreencity.bangkok.go.th/greencity/sanitation.aspx",
    sappear: 5,
    mappear: "",
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "สุนทรียภาพทางธรรมชาติ",
    meaning:
      "การรับรู้จากธรรมชาติ ทำให้มนุษย์เข้าใจคุณค่าต่างๆ อันเป็นประโยชน์ในการดำเนินชีวิต และนำมาสร้างสรรค์เป็นกฎเกณฑ์ของความงาม กลมกลืนกันจนถึงกับเชื่อว่า ธรรมชาติเป็นมารดาของความรู้ทั้งหลายในโลก",
    source:
      "พระมหา ดร.จิตติภัทร อจลธมฺโม พระ ดร.หัสดี กิตฺตินนฺโท มหาวิทยาลัยมหาจุฬาลงกรณราชวิทยาลัย วิทยาเขตนครราชสีมา. วิชา สุนทรียศาสตร์ (AESTHETICS), 11 กันยายน 2562. http://nkr.mcu.ac.th/gs2/index.php/service/costcheck/category/10-learndoc1.html?download=22:2013-06-28-10-16-38",
    sappear: 5,
    mappear: 19,
    rappear: "",
    firstalpha: "ส"
  },
  {
    keyword: "หญ้าทะเล",
    meaning:
      "ระบบนิเวศหญ้าทะเลประกอบด้วยกลุ่มของพืชดอกที่ปรับตัวเติบโตอยู่ได้ในทะเลและสามารถเจริญได้ดีในบริเวณน้ำตื้นที่มีแสงแดดส่องถึงโครงสร้างของใบที่ซับซ้อนมีความสำคัญในด้านเป็นแหล่งที่อยู่อาศัยแหล่งอนุบาลตัวอ่อนสัตว์น้ำตลอดจนเป็นแหล่งหากินของสัตว์ทะเลนานาชนิดรวมถึงสัตว์น้ำเศรษฐกิจอันได้แก่ ปลา กุ้ง ปู หอยหลายชนิดและยังมีส่วนช่วยในการกรองและปรับปรุงคุณภาพน้ำ รวมทั้งมีรากที่คอยยึดจับเพื่อป้องกันการพังทลายของหน้าดินได้เป็นอย่างดี ",
    source:
      "กรมทัพยากรทางทะเลและชายฝั่ง. (2560). ระบบนิเวศหญ้าทะเล, 5 สิงหาคม 2562. https://km.dmcr.go.th/th/c_4/d_759",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "ห"
  },
  {
    keyword: "หน่วยงานของรัฐ",
    meaning:
      "หมายความว่า หน่วยงานที่เป็นของรัฐไม่ว่าจะเป็นส่วนราชการ รัฐวิสาหกิจ องค์การมหาชน หรือในรูปแบบอื่นใด และไม่ว่าจะเป็นองค์กรในฝ่ายบริหาร ฝ่ายนิติบัญญัติ ฝ่ายตุลาการหรือเป็นองค์กรอิสระหรือองค์กรอัยการ",
    source:
      "พระราชบัญญัติการจัดทำยุทธศาสตร์ชาติ พ.ศ. 2560 (2560, 31 กรกฎาคม). ราชกิจจานุเบกษา. เล่ม 134 ตอนที่ 79 ก หน้า 1.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2560/A/079/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "ห"
  },
  {
    keyword: "หน่วยบริการ",
    meaning:
      "สถานบริการที่ได้ขึ้นทะเบียนไว้ตามพระราชบัญญัติหลักประกันสุขภาพแห่งชาติ",
    source:
      "พระราชบัญญัติหลักประกันสุขภาพแห่งชาติ พ.ศ. 2545. (2545, 18 พฤศจิกายน). ราชกิจจานุเบกษา. เล่ม119 ตอนที่ 116 ก หน้า 2. \r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/00117199.PDF",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "ห"
  },
  {
    keyword: "หน้าที่พลเมือง",
    meaning:
      "การกำหนดให้พลเมืองปฏิบัติตามกฎหมายที่มีอยู่แล้ว เช่น การเสียภาษีอากร การรับราชการทหาร การป้องกันประเทศ การช่วยเหลือเจ้าหน้าที่ของรัฐ หรือการไปเลือกตั้ง",
    source:
      'คณะกรรมการเสริมสร้างความเป็นพลเมืองในระบอบประชาธิปไตยตามวิถีรัฐธรรมนูญ. การถอดบทเรียน "แบบอย่างที่ดีในการเสริมสร้างความเป็นพลเมือง : มิติในประเทศและมิติของอาเซียน, 25 กันยายน 2562. https://www.parliament.go.th/ewtadmin/ewt/ac/download/article/article_20170626142634.pdf',
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ห"
  },
  {
    keyword: "หนี้ในระบบ",
    meaning:
      "1. หนี้ที่เกิดขึ้นจากโครงการส่งเสริมของรัฐ\r\n2. หนี้ที่เกิดขึ้นจากการกู้ยืมจากสถาบันการเงิน\r\n3. หนี้ที่เกิดขึ้นจากการกู้ยืมจากสถาบันเกษตรกร\r\n",
    source:
      "พระราชบัญญัติกองทุนฟื้นฟูและพัฒนาเกษตรกร (ฉบับที่ 2 พ ศ 2544) (2544,12 พฤศจิกายน)  ราชกิจจานุเบกษา. เล่ม 118 ตอนที่ 104 ก หน้า 18 http://www.ratchakitcha.soc.go.th/DATA/PDF/00026780.PDF",
    sappear: "",
    mappear: 16,
    rappear: "",
    firstalpha: "ห"
  },
  {
    keyword: "หนี้สาธารณะ",
    meaning:
      "หนี้ที่กระทรวงการคลัง หน่วยงานของรัฐ หรือรัฐวิสาหกิจกู้ หรือหนี้ที่กระทรวงการคลังค้ำประกัน แต่ไม่รวมถึงหนี้ของรัฐวิสาหกิจที่ทําธุรกิจให้กู้ยืมเงินธุรกิจบริหารสินทรัพย์ หรือธุรกิจประกันสินเชื่อ โดยกระทรวงการคลังไม่ได้ค้ำประกัน และหนี้ของธนาคารแห่งประเทศไทย",
    source:
      "พระราชบัญญัติการบริหารหนี้สาธารณะ (ฉบับที่ 3) พ.ศ. 2560. (2560, 27 ธันวาคม). ราชกิจจานุเบกษา. เล่ม 134 ตอนที่ 131 ก หน้า 32. http://www.ratchakitcha.soc.go.th/DATA/PDF/2560/A/131/31.PDF",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ห"
  },
  {
    keyword: "หลัก Meritocracy",
    meaning:
      "หลักการบริหารที่เน้นความรู้ความสามารถของบุคคลเป็นหลัก หรือที่เรียกว่า ระบบคุณธรรม (the merit system) ที่ไม่ได้หมายถึง ‘ศีลธรรมอันดี’ แต่คือระบบการคัดสรรคนเข้าทำงาน โดยยึดหลักความรู้ความสามารถในการทำงาน หรือโดยสรุป คือ เป็นระบบสังคมที่เชื่อการสำเร็จด้วยตนเองไม่ใช้สิทธิพิเศษทางชนชั้น โดยแนวคิดความเสมอภาค (Equality) ความสามารถ (Competence) ความมั่นคง (Security) และความเป็นกลางในทางการเมือง (Political neutrality)",
    source:
      "สุรินทร์ ปัทมาสศนุพงศ์. (2558). เรียนรู้จากสิงคโปร์ สร้างคนด้วย Meritocracy, 12 กรกฎาคม 2562. \r\n https://aftershake.thaipbs.or.th/?p=910",
    sappear: "",
    mappear: "",
    rappear: 11,
    firstalpha: "ห"
  },
  {
    keyword: "หลักการบริหารบ้านเมืองที่ดี",
    meaning:
      "การบริหารกิจการบ้านเมืองที่ดี ได้แก่ การบริหารราชการเพื่อบรรลุเป้าหมาย ดังต่อไปนี้ 1. เกิดประโยชน์สุขของประชาชน 2. เกิดผลสัมฤธิ์ต่อภารกิจของรัฐ 3. มีประสิทธิภาพและเกิดความคุ้มค่าในเชิงภารกิจของรัฐ 4. ไม่มีขั้นตอนการปฏิบัติงานเกินความจำเป็น 5. มีการปรับปรุงภารกิจของส่วนราชการให้ทันต่อสถานการณ์ 6. ประชาชนได้รับการอำนวยความสะดวกและได้รับการตอบสนองความต้องการ 7. มีการประเมินผลการปฏิบัติราชการอย่างสม่ำเสมอ",
    source:
      "พระราชกฤษฎีกาว่าด้วยหลักเกณฑ์และวิธีการบริหารกิจการบ้านเมืองที่ดี พ.ศ. 2546 (2546, ตุลาคม 9). ราชกิจจานุเบกษา. เล่มที่ 120 ตอนที่ 100 ก หน้าที่ 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/00130026.PDF",
    sappear: "",
    mappear: 20,
    rappear: "",
    firstalpha: "ห"
  },
  {
    keyword: "หลักธรรมาภิบาล",
    meaning:
      "ความหมายของหลักธรรมาภิบาลของการบริหารกิจการบ้านเมืองที่ดี ซึ่งประกอบด้วย 4 หลักการสำคัญ และ 10 หลักการย่อย ดังนี้ 1) การบริหารจัดการภาครัฐแนวใหม่  (New Public Management) ประกอบด้วยหลักประสิทธิภาพ  (Efficiency) หลักประสิทธิผล (Effective) และหลักการตอบสนอง (Responsive)  2) ค่านิยมประชาธิปไตย   (Democratic Value) ประกอบ ด้วยหลักภาระรับผิดชอบ/สามารถตรวจสอบได้ (Accountability) หลักความเปิดเผย/โปร่งใส  (Transparency)  หลักนิติธรรม (Rule of Law) และหลักความเสมอภาค (Equity) 3) ประชารัฐ (Participatory State) ประกอบด้วยหลักการกระจายอำนาจ (Decentralization) และหลักการมีส่วนร่วม/การมุ่งเน้นฉันทามติ (Participation/Consensus Oriented)   4) ความรับผิดชอบทางการบริหาร  (Administrative Responsibility) ประกอบด้วยหลักคุณธรรม/จริยธรรม (Morality/Ethics)\r\n",
    source:
      "สำนักงานคณะกรรมการพัฒนาระบบราชการ. (2554). หลักธรรมาภิบาลของการบริหารกิจการบ้านเมืองที่ดี. 18 มิถุนายน 2562.\r\nhttps://www2.opdc.go.th/content.php?menu_id=5&content_id=2442",
    sappear: "1,6",
    mappear: 20,
    rappear: "1,2",
    firstalpha: "ห"
  },
  {
    keyword: "หลักนิติธรรม",
    meaning:
      "การตรากฎหมาย กฎ ระเบียบข้อบังคับและกติกาต่าง ๆ ให้ทันสมัยและเป็นธรรม ตลอดจนเป็นที่ยอมรับของสังคมและสมาชิก โดยมีการยินยอมพร้อมใจและถือปฏิบัติร่วมกันอย่างเสมอภาคและเป็นธรรม เป็นการสถาปนาการปกครองภายใต้กฎหมาย มิใช่กระทำตามอำเภอใจหรืออำนาจบุคคล โดยหลักนิติธรรมถือเป็นองค์ประกอบสำคัญของหลักธรรมาภิบาล และประกอบด้วย 7 หลักการ คือ \r\n1. หลักการแบ่งแยกอำนาจ \r\n2. หลักการคุ้มครองสิทธิและเสรีภาพ \r\n3. หลักความชอบธรรมด้วยกฎหมายของฝ่ายตุลาการและฝ่ายปกครอง\r\n4. หลักความชอบด้วยกฎหมายในทางเนื้อหา \r\n5. หลักความเป็นอิสระของผู้พิพากษา \r\n6. หลัก “ไม่มีความผิด และไม่มีโทษโดยไม่มีกฎหมาย” \r\n7. หลักความเป็นกฎหมายสูงสุดของรัฐธรรมนูญ",
    source:
      "ศาลรัฐธรรมนูญ. หลักนิติธรรม, 6 ธันวาคม 2562. http://www.constitutionalcourt.or.th/occ_web/ewt_dl_link.php?nid=1283",
    sappear: "",
    mappear: "1,22",
    rappear: 11,
    firstalpha: "ห"
  },
  {
    keyword: "หลักประกันทางธุรกิจ",
    meaning:
      "การนำทรัพย์สินทุกชนิดที่สามารถนำมาใช้เป็นหลักประกันได้ตามกฎหมาย ผู้ให้หลักประกันและผู้รับหลักประกัน จะต้องตกลงกันเองว่าจะให้และจะรับหลักประกันดังกล่าวหรือไม่",
    source:
      "สำนักงานทะเบียนหลักประกันทางธุรกิจ.  “เรียนรู้ไปด้วยกัน...กับกฎหมายหลักประกันทางธุรกิจ, 18 กันยายน 2562. https://www.dbd.go.th/chiangrai/ewt_dl_link.php?nid=1787",
    sappear: "",
    mappear: 8,
    rappear: "",
    firstalpha: "ห"
  },
  {
    keyword: "หลักประกันสิทธิของผู้เสียหาย",
    meaning:
      "การช่วยเหลือ เยียวยาผู้ที่ถูกละเมิดสิทธิให้ได้รับการช่วยเหลืออย่างเป็นธรรม ด้วยการพัฒนา ระบบ มาตรการและดำเนินการช่วยเหลือประชาชนที่ตกเป็นผู้เสียหายและจำเลยในคดีอาญาตามกฎหมายว่าด้วยค่าตอบแทนผู้เสียหายและค่าทดแทนและค่าใช้จ่ายแก่จำเลยในคดีอาญา การคุ้มครองพยานในคดีอาญาตามกฎหมาย การรับเรื่องราวร้องทุกข์และให้คำปรึกษาทางกฎหมาย  ซึ่งเป็นมาตรการในเชิงช่วยเหลือ เยียวยา (รับ)",
    source:
      "กรมคุ้มครองสิทธิและเสรีภาพ กระทรวงยุติธรรม. (2555). ภารกิจหลัก, 28 ตุลาคม 2562. http://www.rlpd.go.th/rlpdnew/2012-06-20-05-54-34/2012-06-20-06-00-54",
    sappear: 4,
    mappear: "",
    rappear: "",
    firstalpha: "ห"
  },
  {
    keyword: "หลักประชามติ",
    meaning:
      "(๑) มติของประชาชนส่วนใหญ่ในประเทศที่แสดงออกในเรื่องใดเรื่องหนึ่งหรือที่ใดที่หนึ่ง (Plebiscite)\r\n(๒) มติประชาชนที่รัฐให้สิทธิออกเสียงลงคะแนนรับรองร่างกฎหมายที่สำคัญที่ได้ผ่านสภานิติบัญญัติแล้ว หรือให้ตัดสินในปัญหาที่สำคัญในการบริหารประเทศ (Referendum) \r\n \r\n \r\n \r\n \r\n",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. ประชามติ, 17 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "ห"
  },
  {
    keyword: "หลักปรัชญาเศรษฐกิจพอเพียง",
    meaning:
      "ปรัชญาที่พระบาทสมเด็จพระเจ้าอยู่หัวพระราชทานเป็นแนวทางการดำรงชีวิตและปฏิบัติตนของประชาชนตั้งแต่ระดับครอบครัว ระดับชุมชน จนถึงระดับรัฐ ให้ดำเนินไปในทางสายกลาง ไม่ประมาท ไม่โลภ ไม่เบียดเบียนผู้อื่น คำนึงถึงความพอประมาณ ความมีเหตุผล มีภูมิคุ้มกันในตัว ตลอดจนใช้ความรู้และคุณธรรม เป็นพื้นฐานในการดำรงชีวิตให้รอดพ้นจากวิกฤติ มีความมั่นคงและยั่งยืนท่ามกลางกระแสโลกาภิวัตน์และความเปลี่ยนแปลงต่าง ๆ.",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. เศรษฐกิจพอเพียง, 17 มิถุนายน 2562.\r\nhttp://www.royin.go.th/dictionary/",
    sappear: "4,5",
    mappear: "1,15,16,19",
    rappear: 2,
    firstalpha: "ห"
  },
  {
    keyword: "หลักสิทธิมนุษยชน ",
    meaning:
      "สิทธิที่มนุษย์ทุกคนมีความเท่าเทียมกัน มีศักดิ์ศรีของความเป็นมนุษย์ สิทธิ เสรีภาพ และความเสมอภาคของบุคคลที่ได้รับการรับรอง ทั้งความคิดและการกระทำที่ไม่มีการล่วงละเมิดได้ โดยได้รับการคุ้มครองตามรัฐธรรมนูญแห่งราชอาณาจักรไทยและสนธิสัญญาระหว่างประเทศ",
    source:
      "คณะกรรมการสิทธิมนุษยชนแห่งชาติ. หลักสิทธิมนุษยชน, 3 กรกฎาคม 2562. https://sites.google.com/site/krukarn17825/hlak-siththi-mnusy-chn",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "ห"
  },
  {
    keyword: "หลักสูตรแกนกลาง",
    meaning:
      "หลักสูตรในส่วนที่สำนักงานคณะกรรมการการศึกษาขั้นพื้นฐานกำหนดเพื่อใช้ในการพัฒนาผู้เรียนทุกคนในระดับการศึกษาขั้นพื้นฐาน หลักสูตรแกนกลางมีองค์ประกอบสำคัญ ได้แก่ มาตรฐานการเรียนรู้และตัวชี้วัด สาระการเรียนรู้แกนกลาง โครงสร้างเวลาเรียนพื้นฐานซึ่งระบุการจัดเวลาเรียนของแต่ละกลุ่มสาระการเรียนรู้กิจกรรมพัฒนาผู้เรียน และเกณฑ์กลางในการจบหลักสูตร ซึ่งจะเป็นกรอบทิศทางในการพัฒนากรอบหลักสูตรระดับท้องถิ่นและหลักสูตรสถานศึกษา เป็นส่วนจำเป็นสำหรับพัฒนาเยาวชนไทยทุกคนให้เป็นพลเมืองดี\r\nของชาติและสามารถดำรงชีวิตอยู่ได้อย่างมีความสุข ก้าวทันต่อการเปลี่ยนแปลงทางเศรษฐกิจ สังคม ความเจริญทางวิทยาการในโลกยุคปัจจุบัน ",
    source:
      "สำนักงานคณะกรรมการการศึกษาขั้นพื้นฐาน. นิยามคำศัพท์หลักสูตร หลักสูตรแกนกลางการศึกษาขั้นพื้นฐาน พุทธศักราช 2551, 11 กันยายน 2562. https://oer.learn.in.th/search_detail/result/24553",
    sappear: "",
    mappear: 12,
    rappear: "",
    firstalpha: "ห"
  },
  {
    keyword: "ห่วงโซ่คุณค่า",
    meaning:
      "กิจกรรมที่มีความสัมพันธ์ และเชื่อมโยงกัน เพื่อสร้างมูลค่าเพิ่มให้กับปัจจัยการผลิต โดยเริ่มตั้งแต่กระบวนการนำวัตถุดิบป้อนเข้าสู่กระบวนการผลิต กระบวนการจัดจำหน่าย กระบวนการจัด ส่งสินค้าสู่ผู้บริโภค และกระบวนการบริการหลังการขาย การสร้างคุณค่าให้กับสินค้าหรือบริการนั้น อาจจะเป็นการกระทำโดยบริษัทเดียวหรือหลายบริษัท ด้วยการแบ่งขอบเขตของกิจกรรมแล้วส่งต่อคุณค่าในแต่ละช่วงต่อเนื่องกันไป",
    source:
      "สมาคมส่งเสริมเทคโนโลยี (ไทย-ญี่ปุ่น). ห่วงโซ่คุณค่า (ตอนจบ) Value chain ในงานโลจิสติกส์, 14 สิงหาคม 2562. http://www.tpa.or.th/publisher/pdfFileDownloadS/TN211A_p039-44.pdf",
    sappear: 4,
    mappear: 16,
    rappear: "",
    firstalpha: "ห"
  },
  {
    keyword: "ห่วงโซ่มูลค่า",
    meaning:
      "กิจกรรมที่สร้างมูลค่าเพิ่มทั้งหมดที่เกิดขึ้นกับผลิตภัณฑ์ นับแต่ขั้นตอนการออกแบบผลิตภัณฑ์ จนกระทั่งสินค้านั้นถึงมือผู้บริโภคขั้นสุดท้าย รวมทั้งบริการหลังจากนั้น (after-sales services) อาทิ เริ่มตั้งแต่ขั้นตอนการวิจัย (R&D) การออกแบบ การผลิต การขนส่ง การโฆษณา การขาย และการบริการหลังการขาย โดยแต่ละกิจกรรมจะสร้างมูลค่าเพิ่มให้กับสินค้า ถ้ากิจกรรมเหล่านี้กระจายอยู่ในหลายประเทศ/ภูมิภาค ก็จะเรียกว่า ห่วงโซ่มูลค่าโลก (Global Value Chain: GVC) ",
    source:
      "สำนักการค้าสินค้า (2557). ไทยกับการมีส่วนร่วมในห่วงโซ่มูลค่าโลก (Global Value Chain: GVC), 31 กรกฎาคม 2562. http://www.thaifta.com/ThaiFTA/Portals/0/GlobalValueChain.pdf",
    sappear: "2,4",
    mappear: "2,4,8,4,16,18",
    rappear: 8,
    firstalpha: "ห"
  },
  {
    keyword: "ห่วงโซ่อาหาร",
    meaning:
      "การถ่ายทอดไปตามลำดับขั้นของการกินอาหารภายในระบบนิเวศ โดยเป็นการกินต่อกันเป็นทอดๆ ขบวนการนี้มีความสําคัญมากต่อสิ่งมีชีวิต เนื่องจากอาหารที่ถูกกินเข้าไปจะถูกนําไปใช้ในการเจริญเติบโต และการสืบพันธุ์ รวมทั้งกระบวนการทํางานต่างๆ ของร่างกาย การถ่ายทอดพลังงานที่ได้จากอาหารจากสิ่งมีชีวิตหนึ่งไปยังสิ่งมีชีวิตอีกชนิดหนึ่งใน การถ่ายทอดพลังงานและอาหารจากผู้ผลิตไปยังผู้บริโภค จะไมถึง 100 เปอร์เซ็นต์ เนื่องจากพลังงานบางส่วนจะถูกนําไปใช้ ในกิจกรรมต่างๆ ในการดํารงชีวิต ทําให้มีพลังงานเพียง 10% เท่านั้นที่ถูกส่งต่อไปยังสิ่งมีชีวิตหรือผู้บริโภคที่อยู่ระดับสูงสุด เมื่อมีห่วงโซ่อาหารหลายๆ ห่วงโซ่อาหารก็จะเกิดเป็นสายใยอาหารขึ้นในธรรมชาติการถ่ายทอดพลังงานและสารอาหารไม่เป็นสายตรงเสมอไป เพราะสิ่งมีชีวิตหนึ่งอาจกินอาหารได้หลายชนิด และขณะเดียวกันอาจตกเป็นเหยื่อของผู้ล่าชนิดอื่นๆ อีกหลายชนิดเช่นกัน ดังนั้น ห่วงโซ่อาหารของแต่ละระบบนิเวศ จึงมีความสัมพันธ์กันโดยมีการกินข้ามห่วงโซ่อาหาร การถ่ายทอดพลังงานจึงมีความซับซ้อนมากขึ้นและสัมพันธ์เกี่ยวโยงไปมาหลายห่วงโซ่อาหาร ความสัมพันธ์ในลักษณะการกินที่เกี่ยวโยงกัน และมีความซับซ้อนนี้เรียกว่า สายใยอาหาร (Food Web) หรือข่ายใยอาหาร สายใยอาหารประกอบด้วยห่วงโซ่อาหารหลายสายเชื่อมโยงกัน แสดงให้เห็นถึงความสัมพันธ์ระหว่างสิ่งมีชีวิตในชุมชนที่มีต่อกันอย่างซับซ้อนได้",
    source:
      "คณะวิทยาศาสตร์ มหาวิทยาลัยสงขลานครินทร์ วิทยาเขตหาดใหญ่.สายใยอาหารในระบบนิเวศป่าชายเลน, 21 พฤศจิกายน 2562. https://www.sci.psu.ac.th/chm/biodiversity/mangrove_food.html",
    sappear: 5,
    mappear: 18,
    rappear: "",
    firstalpha: "ห"
  },
  {
    keyword: "ห่วงโซ่อุปทาน",
    meaning:
      "การใช้ระบบของหน่วยงาน คน เทคโนโลยี กิจกรรม ข้อมูลข่าวสาร และทรัพยากร มาประยุกต์เข้าด้วยกัน เพื่อการเคลื่อนย้ายสินค้าหรือบริการ จากผู้จัดหาไปยังลูกค้า กิจกรรมของห่วงโซ่อุปทานจะแปรสภาพทรัพยากรธรรมชาติ วัตถุดิบ และวัสดุอื่นๆให้กลายเป็นสินค้าสำเร็จ แล้วส่งไปจนถึงลูกค้าคนสุดท้าย (ผู้บริโภค หรือ End Customer)",
    source:
      "วิกิพีเดีย สารานุกรมเสรี. (2560). ห่วงโซ่อุปทาน, 14 มิถุนายน 2562. https://th.wikipedia.org/wiki/ห่วงโซ่อุปทาน",
    sappear: "2,5",
    mappear: "2,3,5,7,16",
    rappear: 5,
    firstalpha: "ห"
  },
  {
    keyword: "ห้องสมุดมีชีวิต",
    meaning:
      "รูปแบบอุทยานการเรียนรู้ เพื่อเป็นกลไกในการสนับสนุนส่งเสริมการอ่านและการเรียนรู้ของเยาวชน ตลอดจนผลลัพธ์และผลกระทบที่มีต่อสังคม",
    source:
      "สำนักงานอุทยานการเรียนรู้ (สอร.). “ห้องสมุดมีชีวิต”รูปแบบอุทยานการเรียนรู้, 6 ธันวาคม 2562. \r\nhttps://www.tkpark.or.th/stocks/extra/000575.pdf",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "ห"
  },
  {
    keyword: "หัตถกรรม",
    meaning: "งานช่างที่ทำด้วยมือ โดยถือประโยชน์ใช้สอยเป็นหลัก",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. วิจารณญาณ. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "ห"
  },
  {
    keyword: "หุ้นส่วนยุทธศาสตร์",
    meaning:
      "ลักษณะความสัมพันธ์ระหว่างสองประเทศที่มีความใกล้ชิดสนิทสนมอย่างยิ่งอยู่บนพื้นฐานของความเสมอภาค มีนโยบายและแนวคิดทางการเมือง เศรษฐกิจ สังคม และการทหารไปในแนวทางเดียวกัน",
    source:
      "สถาบันการต่างประเทศเทวะวงศ์วโรปการ กระทรวงการต่างประเทศ. หนังสือคำศัพท์-คำย่อทางการทูต สถาบันการต่างประเทศ กต. (ฉบับปรับปรุงครั้งที่ 2), 6 ธันวาคม 2562. http://www.mfa.go.th/dvifa/th/code?c=a",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "ห"
  },
  {
    keyword: "องค์กร Social Progress Imperative",
    meaning:
      "องค์กรที่ไม่แสวงหาผลกำไรของสหรัฐอเมริกา ดำเนินการจัดอันดับดัชนีความก้าวหน้าทางสังคม จำนวน 133 ประเทศ เป็นประจำทุกปี",
    source:
      "Social Progress Imperative, 18 กันยายน 2562. https://www.socialprogress.org/about-us",
    sappear: "",
    mappear: 15,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "องค์กรไม่แสวงหากำไร",
    meaning:
      "องค์กรที่ดำเนินงานโดยไม่หวังผลกำไร โดยผลิตสินค้าและบริการให้กับประชาชนหรือสังคมโดยไม่คิดราคาหรือแบบให้เปล่าหรือจำหน่ายในราคาที่ไม่คุ้มทุนหรือในราคาที่ไม่มีนัยสำคัญทางเศรษฐกิจ ครอบคลุมองค์กรประเภทมูลนิธิ สมาคม องค์กรทางศาสนา และพรรคการเมือง เป็นต้น",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. บัญชีองค์กรไม่แสวงหากำไรของประเทศไทย พ.ศ. 2549-2551, 6 ธันวาคม 2562. \r\nhttp://www.nesdc.go.th/ewt_dl_link.php?nid=5525&filename=npi_page",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "อ"
  },
  {
    keyword: "องค์กรจัดเก็บภาษีกึ่งอิสระ",
    meaning:
      "หน่วยจัดเก็บภาษีมีความเป็นอิสระในการบริหารจัดการองค์กรมีความเป็นอิสระในการบริหารจัดการกฎหมายภาษี และสามารถสร้างความมั่นใจได้ว่ามีการบริหารจัดการองค์กรอย่างมีประสิทธิภาพ ภายใต้การดูแลขององค์กรจัดเก็บภาษีกึ่งอิสระ มีโครงสร้างองค์กรที่คล้ายคลึงกันในด้านของการมีคณะกรรมการบริหารงานหรือสภาที่ปรึกษาซึ่งมีจํานวนสมาชิกประมาณ 7 - 10 คน ประกอบด้วยผู้แทนจากภาครัฐและภาคเอกชน ",
    source:
      "นางสาวจารุพัสตร์ พลทรัพย์ เศรษฐกรชํานาญการ สํานักนโยบายภาษี สํานักงานเศรษฐกิจการคลัง, (2562). การจัดตั้งองค์กรจัดเก็บภาษีกึ่งอิสระ (Semi-Autonomous Revenue Autority: SARA) ในประเทศสิงคโปร์ มาเลเซีย ญี่ปุ่น และสวีเดน, 4 ตุลาคม 2562. http://www.fpo.go.th/main/getattachment/General-information-public-service/Tax-Policy-Journal/10552/TaxJournalV10.pdf.aspx",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "อ"
  },
  {
    keyword: "องค์กรปกครองส่วนท้องถิ่น",
    meaning:
      "องค์กรของราชการบริหารส่วนท้องถิ่นที่จัดตั้งขึ้นในรูปแบบต่าง ๆ โดยราชการบริหารส่วนท้องถิ่น คือ การปกครอง ดูแล จัดการ และการให้บริการของรัฐ ที่รัฐกระจายอำนาจให้ประชาชนในท้องถิ่นเข้ามามีส่วนในการดำเนินการ เพื่อสนองความต้องการส่วนรวมของประชาชนในท้องที่นั้น โดยจัดเป็นองค์กรในรูปแบบต่าง ๆ คือ องค์การบริหารส่วนจังหวัด เทศบาล องค์การบริหารส่วนตำบล และรูปแบบอื่นที่มีกฎหมายจัดตั้งขึ้นเป็นการเฉพาะ เช่น กรุงเทพมหานคร เมืองพัทยา\r\n",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. องค์กรปกครองส่วนท้องถิ่น. 18 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 18,
    rappear: 2,
    firstalpha: "อ"
  },
  {
    keyword: "องค์กรฝ่ายตุลาการ",
    meaning:
      "องค์กรที่ทําหน้าที่ตรวจสอบการใช้อํานาจของเจ้าหน้าที่ของรัฐ และคุ้มครองสิทธิเสรีภาพของบุคคล องค์กรตุลาการเป็นสถาบันผู้ใช้อํานาจอธิปไตยสถาบันหนึ่งในสาม นอกเหนือจากสถาบันผู้ใช้อํานาจนิติบัญญัติและสถาบันผู้ใช้อํานาจบริหาร",
    source:
      "นายนิพนธ์ ใจสําราญ ประธานศาลอุทธรณ์ภาค 7. หลักนิติธรรมในบริบทของศาลยุติธรรมไทย, 16 กันยายน 2562. http://www.constitutionalcourt.or.th/occ_web/ewt_dl_link.php?nid=1414",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "อ"
  },
  {
    keyword: "องค์กรมีขีดสมรรถนะสูง\r\n",
    meaning:
      "องค์กรที่ประสบความสำเร็จอย่างต่อเนื่อง มีผลงานโดดเด่นเป็นที่ยอมรับในกลุ่มอุตสาหกรรมเดียวกัน สร้างผลตอบแทนทางธุรกิจและผลตอบแทนต่อผู้มีส่วนได้ส่วนเสียอย่างยั่งยืน และมีความสามารถเด่นชัดในการสร้างมาตรฐานการทำงานที่เป็นเลิศ เพื่อสร้างและธำรงไว้ในความสามารถทางการแข่งขันที่เหนือกว่า",
    source:
      "คณะพาณิชยศาสตร์และการบัญชี จุฬาลงกรณ์มหาวิทยาลัย สำหรับสำนักงานคณะกรรมการพัฒนาระบบราชการ. (2549). รายงานผลการศึกษาพัฒนารูปแบบเบื้องต้นของหน่วยงานภาครัฐ : องค์การที่มีขีดสมรรถนะสูง. 8 พฤศจิกายน 2562. https://www2.opdc.go.th/oldweb/thai/High_Performance_Organize/HighPerformanceOrganize.pdf",
    sappear: 6,
    mappear: 20,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "องค์กรวิชาชีพ",
    meaning:
      "องค์กรที่จัดตั้งขึ้นตามที่บัญญัติไว้ตามกฎหมายวิชาชีพ เพื่อทำหน้าที่เป็นผู้กำกับดูแลมาตรฐานการทำงานและจริยธรรมของผู้ประกอบวิชาชีพประเภทต่างๆ เช่น กลุ่มผู้ประกอบวิชาชีพแพทย์ ทันตแพทย์ พยาบาล เภสัชกรรม ได้แก่ แพทยสภา ทันตแพทย์สภา สภาการพยาบาล สภาเภสัชกรรม เป็นต้น",
    source:
      "Supaporn. (2558). องค์กรวิชาชีพภายในประเทศ, 8 กรกฎาคม 2562. https://prezi.com/sw2zq9sdg_op/presentation/",
    sappear: "",
    mappear: "",
    rappear: 8,
    firstalpha: "อ"
  },
  {
    keyword: "องค์กรอัยการ",
    meaning:
      "องค์กรอัยการประกอบด้วย ก.อ. อัยการสูงสุดและพนักงานอัยการอื่น โดยมีสำนักงานอัยการสูงสุดเป็นหน่วยธุรการ\r\nสำนักงานอัยการสูงสุดเป็นส่วนราชการที่มีอิสระในการบริหารงานบุคคล การงบประมาณและการดำเนินการอื่นๆ และนิติบุคคล โดยมีอัยการสุงสุดเป็นผู้บังคับบัญชาและเป็นผู้แทนนิติบุคคล",
    source:
      "พระราชบัญญัติองค์กรอัยการและพนักงานอัยการ พ.ศ. 2553 (2553, 7 ธันวาคม). ราชกิจจานุเบกษา. เล่ม 127 ตอนที่ 75 ก หน้า 40. http://www.ratchakitcha.soc.go.th/DATA/PDF/2553/A/075/38.PDF",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "อ"
  },
  {
    keyword: "องค์กรอิสระ",
    meaning:
      "องค์กรอิสระเป็นองค์กรที่จัดตั้งขึ้นให้มีความอิสระในการปฏิบัติหน้าที่ ให้เป็นไปตามรัฐธรรมนูญและกฎหมายการปฏิบัติหน้าที่และการใช้อํานาจขององค์กรอิสระต้องเป็นไปโดยสุจริต เที่ยงธรรม กล้าหาญและปราศจากอคติทั้งปวงในการใช้ดุลพินิจ",
    source:
      "รัฐธรรมนูญแห่งราชอาณาจักรไทย พ.ศ. 2560 (2560, 6 เมษายน). ราชกิจจานุเบกษา. เล่ม 134 ตอนที่ 40 ก หน้า 62.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2560/A/040/1.PDF",
    sappear: 6,
    mappear: 20,
    rappear: 1,
    firstalpha: "อ"
  },
  {
    keyword: "องค์กรอิสระของรัฐ",
    meaning:
      "องค์กรอิสระตามรัฐธรรมนูญเป็นองค์กรที่จัดตั้งขึ้นให้มีความอิสระในการปฏิบัติหน้าที่เพื่อดำเนินการหรือตรวจสอบการใช้อำนาจรัฐให้เป็นไปตามรัฐธรรมนูญและกฎหมาย เพื่อให้การบริหารราชการแผ่นดินของประเทศเดินไปข้างหน้าอย่างมีประสิทธิภาพ สุจริต โปร่งใส เที่ยงธรรม กล้าหาญปราศจากอคติในการใช้ดุลยพินิจ และปราศจากการแทรกแซงขององค์กรอื่นของรัฐหรือสถาบันการเมืองอื่น รวมทั้งอยู่เหนือกระแสและการกดดันใด ๆ ที่เกิดขึ้นภายในสังคมในช่วงเวลาใดเวลาหนึ่ง ",
    source:
      "สำนักงานคณะกรรมการการเลือกตั้ง. (2560). องค์กรอิสระและการตรวจสอบอำนาจรัฐ, 16 กันยายน 2562. https://www.ect.go.th/lamphun/ewt_dl_link.php?nid=489",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "อ"
  },
  {
    keyword: "องค์การมหาชน",
    meaning:
      "องค์การมหาชนที่จัดตั้งขึ้นโดยพระราชกฤษฎีกาที่ออกตามความในพระราชบัญญัติองค์การมหาชน พ.ศ. 2542 โดยรัฐบาลมีแผนงานหรือนโยบายด้านใดด้านหนึ่งโดยเฉพาะเพื่อจัดทำบริการสาธารณะ และมีความมุ่งหมายให้มีการใช้ประโยชน์ทรัพยากรและบุคลากรให้เกิดประสิทธิภาพสูงสุด",
    source:
      "พระราชบัญญัติองค์การมหาชน พ.ศ. 2542 (2542, 24 กุมภาพันธ์). ราชกิจจานุเบกษา. เล่ม 116 ตอนที่ 9 ก. หน้า 5.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2542/A/009/5.PDF\r\n",
    sappear: "",
    mappear: "",
    rappear: "1,2",
    firstalpha: "อ"
  },
  {
    keyword: "องค์ความรู้",
    meaning:
      "ความรู้ซึ่งได้มาจากการวิเคราะห์และสังเคราะห์ แล้วนำมาบูรณาการเข้าเป็นความรู้ในระดับที่สูงขึ้น",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. องค์ความรู้. 11 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 2,
    firstalpha: "อ"
  },
  {
    keyword: "องค์ความรู้เชิงสหวิทยาการ",
    meaning:
      "องค์ความรู้ใหม่ที่มีลักษณะของการผสมผสานศาสตร์หลากหลายสาขาวิชาเข้าด้วยกัน เช่น เศรษฐศาสตร์วิทยาศาสตร์ เทคโนโลยี อักษรศาสตร์ รัฐศาสตร์ ฯลฯ\r\n",
    source:
      "กระทรวงเทคโนโลยีสารสนเทศและการสื่อสาร. (2559). แผนพัฒนาดิจิทัลเพื่อเศรษฐกิจและสังคม, 12 กันยายน 2562. http://www.mdes.go.th/assets/portals/1/files/590613_4Digital_Economy_Plan-Book.pdf",
    sappear: "",
    mappear: 21,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "องคาพยพ",
    meaning:
      "ส่วนน้อยและใหญ่แห่งร่างกาย, อวัยวะน้อยใหญ่ หรือ ส่วนทั้งหลายที่ประกอบกันเข้าเป็นสิ่งใดสิ่งหนึ่ง",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2552). องคาพยพ, 1 กรกฎาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%AD%E0%B8%87%E0%B8%84%E0%B8%B2%E0%B8%9E%E0%B8%A2%E0%B8%9E-%E0%B9%91%E0%B9%97-%E0%B8%A1%E0%B8%81%E0%B8%A3%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%92",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อธิปไตย",
    meaning: "อำนาจสูงสุดของรัฐที่จะใช้บังคับบัญชาภายในอาณาเขตของตน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. \r\nอธิปไตย, 20 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: 1,
    mappear: "",
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อนามัยเจริญพันธุ์",
    meaning:
      "ภาวะความแข็งแรงสมบูรณ์ของร่างกายและจิตใจที่เป็นผลอันเกิดจากกระบวนการทำหน้าที่ของระบบสุขภาพทางเพศและการเจริญพันธุ์ตลอดช่วงชีวิต ซึ่งทําให้ประชาชนมีคุณภาพชีวิตที่ดีและอยู่ในสังคมได้อย่างมีความสุข",
    source:
      "พระราชบัญญัติ การป้องกันและแก้ไขปัญหาการตั้งครรภ์ในวัยรุ่น พ.ศ. 2559 (2559, 31 มีนาคม).\r\nราชกิจจานุเบกษา. เล่ม 113 ตอนที่ 30 ก หน้า 2.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2559/A/030/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 9,
    firstalpha: "อ"
  },
  {
    keyword: "อนามัยแม่และเด็ก",
    meaning:
      "การดูแลสุขภาพของหญิงทั้งก่อน ระหว่างและหลังตั้งครรภ์ให้มีการตั้งครรภ์ที่ปลอดภัย พร้อมทั้งมีบุตรที่สมบูรณ์แข็งแรงและได้รับการเลี้ยงดูอย่างมีคุณภาพ เป้าหมายนี้จะบรรลุผลได้ควรเริ่มตั้งแต่การดูแลหญิงขณะติงครรภ์ให้มีสุขภาพดี มีการคลอดที่ปลอดภัยและสุขภาพหลังคลอดที่ดีเพื่อการเลี้ยงดูบุตรอย่างเหมาะสม",
    source:
      "สำนักวิจัยและพัฒนา มหาวิทยาลัยสงขลานครินทร์. (2550). อนามัยแม่และเด็ก, 5 สิงหาคม 2562. https://rdo.psu.ac.th/th/images/D3/Dissemination/Knowledge/KNL-No-1-2550.pdf",
    sappear: 3,
    mappear: "",
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อนุบัญญัติ",
    meaning: "พระราชกฤษฎีกา/กฎกระทรวง/ระเบียบ ข้อบังคับ ประกาศ คำสั่ง",
    source:
      "กลุ่มงานราชกิจจานุเบกษา. (2550). ราชกิจจานุเบกษา, 25 กันยายน 2562. http://www.ratchakitcha.soc.go.th/RKJ/announce/answer.jsp?id=988",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "อ"
  },
  {
    keyword: "อนุรักษ์พลังงาน",
    meaning: "ผลิตและใช้พลังงานอย่างมีประสิทธิภาพและประหยัด",
    source:
      "พระราชบัญญัติการส่งเสริมการอนุรักษ์พลังงาน 2535. (2535, 2 เมษายน). ราชกิจานุเบกษา. เล่ม 109 ตอน 33 หน้า 2.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "อ"
  },
  {
    keyword: "อนุวัติ",
    meaning: "ทำตาม, ประพฤติตาม, ปฏิบัติตาม",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. \r\nอนุวัติ, 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "อ"
  },
  {
    keyword: "อนุวัติการ",
    meaning:
      "การดำเนินการให้เป็นผลตามบทบัญญัติแห่งอนุสัญญา (implement the provisions of a convention) โดยการตรากฎหมายภายในประเทศ หรือปรับแก้กฎหมายภายในประเทศ เพื่อให้สอดคล้องและรองรับกับพันธกรณีอนุสัญญา",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์. (2555). อนุวัติการ (Implementation), 24 กรกฎาคม 2562. https://www.etda.or.th/terminology-detail/1211.html",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "อ"
  },
  {
    keyword: "อนุสัญญาความหลากหลายทางชีวภาพ",
    meaning:
      "ข้อตกลงด้านสิ่งแวดล้อมระหว่างประเทศที่มีเจตนารมณ์ให้รัฐบาลทุกประเทศพัฒนาประเทศโดยไม่ละเลยการอนุรักษ์สิ่งแวดล้อมและทรัพยากรธรรมชาติ โดยมีการกําหนดวัตถุประสงค์หลักไว้ 3 ประการ คือ \r\n 1. เพื่ออนุรักษ์ความหลากหลายทางชีวภาพ \r\n 2. เพื่อใช้ประโยชน์จากความหลากหลายทางชีวภาพอย่างยั่งยืน \r\n 3. เพื่อแบ่งปันผลประโยชน์ที่ได้จากการใช้ทรัพยากรพันธุกรรมอย่างเท่าเทียมและยุติธรรม",
    source:
      "ศูนย์เผยแพร่ข้อมูลข่าวสารความปลอดภัยทางชีวภาพ กรมประมง. (ม.ป.ป). อนุสัญญาว่าด้วยความหลากหลายทางชีวภาพ, 6 มิถุนายน 2562. https://www.fisheries.go.th/bch/index.php/79-information/73-cbd",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "อ"
  },
  {
    keyword: "อนุสัญญาภาษีซ้อน",
    meaning:
      "ความตกลงระหว่างรัฐที่จะพยายามขจัดความซ้ำซ้อนของการจัดเก็บภาษี\r\n",
    source:
      "นิรันดร์ ประจวบเหมาะ นักวิชาการภาษีเชี่ยวชาญ สำนักวิชาการแผนภาษี. การจัดเก็บภาษีตามประมวลรัษฎากรและอนุสัญญาภาษีซ้อน, 5 กันยายน 2562. http://www.mfa.go.th/business/contents/files/cooperation-20120412-161706-330881.ppt\r\n",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "อ"
  },
  {
    keyword:
      "อนุสัญญาสหประชาชาติ ว่าด้วยการต่อต้านการทุจริต (United Nations Convention against Corruption : UNCAC)",
    meaning:
      "กฎหมายระหว่างประเทศด้านการต่อต้านการทุจริตในระดับนานาชาติฉบับแรก โดยมีพันธกรณีต่อรัฐภาคีแบ่งออกเป็น 3 ระดับ ได้แก่ \r\n1. พันธกรณีที่รัฐภาคีจะต้องปฏิบัติตาม \r\n2. พันธกรณีที่รัฐภาคีมีสิทธิเลือกที่จะกระทำหรือไม่ก็ได้ \r\n3. พันธกรณีที่รัฐภาคีจะต้องพิจารณา \r\nโดยแบ่งเนื้อหาหลักในอนุสัญญา UNCAC ได้ 5 หมวดหมู่ คือ \r\n1. หมวดการป้องกันการทุจริต \r\n2. หมวดการกำหนดความผิดทางอาญาและการบังคับใช้กฎหมาย\r\n3. หมวดความร่วมมือระหว่างประเทศ \r\n4. หมวดการติดตามทรัพย์สินคืน \r\n5. หมวดความช่วยเหลือด้านเทคนิคและการแลกเปลี่ยนข้อมูล \r\nซึ่งปัจจุบันมีรัฐภาคีรวม 186 ประเทศรวมประเทศไทย",
    source:
      "ศูนย์ปฏิบัติการต่อต้านการทุจริต กระทรวงต่างประเทศ. (2561). บทความน่ารู้ : อนุสัญญาสหประชาชาติว่าด้วยการต่อต้านการทุจริต (United Nations Convention against Corruption – UNCAC), 6 มิถุนายน 2562. http://www.mfa.go.th/acc/th/news/6825/92645-อนุสัญญาสหประชาชาติว่าด้วยการต่อต้านการทุจริต-(Uni.html",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "อ"
  },
  {
    keyword: "อนุสิทธิบัตร",
    meaning:
      "หนังสือสำคัญที่รัฐออกให้เพื่อคุ้มครองการประดิษฐ์จะมีลักษณะคล้ายกันกับการประดิษฐ์ แต่เป็นความคิดสร้างสรรค์ที่มีระดับการพัฒนาเทคโนโลยีไม่สูงมาก หรือเป็นการประดิษฐ์คิดค้นเพียงเล็กน้อย และมีประโยชน์ใช้สอยมากขึ้น",
    source:
      "กรมทรัพย์สินทางปัญญา. อนุสิทธิบัตร. 20 มิถุนายน 2562 http://www.ipthailand.go.th/th/gi-011/item/%E0%B8%AA%E0%B8%B4%E0%B8%97%E0%B8%98%E0%B8%B4%E0%B8%9A%E0%B8%B1%E0%B8%95%E0%B8%A3-%E0%B8%AD%E0%B8%99%E0%B8%B8%E0%B8%AA%E0%B8%B4%E0%B8%97%E0%B8%98%E0%B8%B4%E0%B8%9A%E0%B8%B1%E0%B8%95%E0%B8%A3.html",
    sappear: "",
    mappear: 23,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อภิบาลการคลังระบบหลักประกันสุขภาพ",
    meaning:
      "สร้างความเป็นธรรมให้แก่ผู้มีสิทธิในระบบประกันสุขภาพต่าง ๆ และสามารถสร้างความยั่งยืนทางการเงินของระบบประกันสุขภาพของประเทศได้",
    source:
      "สำนักงานวิจัยเพื่อการพัฒนาหลักประกันสุขภาพไทย (สวปก.) เครือสถาบันวิจัยระบบสาธารณสุข (สวรส.). (2556). การพัฒนาแนวทางอภิบาลระบบหลักประกันสุขภาพ, 17 ตุลาคม 2562. http://hisro.or.th/main/download/book024.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "อ"
  },
  {
    keyword: "อภิบาลระบบบริการสุขภาพ",
    meaning:
      "การบริหาร การจัดการ การดูแล การปฏิสัมพันธ์กันระหว่างภาครัฐ องค์กรสาธารณะต่าง ๆ ภาคธุรกิจ ภาคประชาสังคม ที่มีความเกี่ยวข้องกับสุขภาพประชาชนในการกำหนดทิศทางระบบสุขภาพโดยรวม การพัฒนานโยบายสาธารณะเพื่อสุขภาพการกำกับดูแล การแก้ไขปัญหาความท้าทายต่าง ๆ และสร้างสรรค์โอกาส โดยคาดหวังว่าทุก ๆ คนจะได้รับประโยชน์สูงสุดและมีความสุข",
    source:
      "กระทรวงสาธารณสุข. ระบบสุขภาพของประเทศไทย, 8 ตุลาคม 2562. http://wops.moph.go.th/ops/thp/thp/userfiles/7_%20lesson6.pdf",
    sappear: "",
    mappear: "",
    rappear: 7,
    firstalpha: "อ"
  },
  {
    keyword: "อัตรา Feed-in Tariff",
    meaning:
      "มาตรการส่งเสริมการรับซื้อไฟฟ้าจากพลังงานหมุนเวียนประเภทหนึ่งที่ใช้กันอย่างแพร่หลายในต่างประเทศ เพื่อจูงใจให้ผู้ประกอบการเอกชนเข้ามาลงทุนในธุรกิจโรงไฟฟ้าพลังงานหมุนเวียน (เนื่องจากการผลิตไฟฟ้าจากพลังงานหมุนเวียนมีต้นทุนค่อนข้างสูง) ซึ่งอัตรา FiT จะอยู่ในรูปแบบอัตรารับซื้อไฟฟ้าคงที่ตลอดอายุโครงการ (มีการปรับเพิ่มสำหรับกลุ่มที่มีการใช้เชื้อเพลิง) โดยอัตรา FiT จะไม่เปลี่ยนแปลงไปตามค่าไฟฐานและค่า Ft ทำให้มีราคาที่ชัดเจนและเกิดความเป็นธรรม",
    source:
      "สำนักงานนโยบายและแผนพลังงาน (สนพ.) กระทรวงพลังงาน. (2559). นโยบายการรับซื้อไฟฟ้าจากพลังงานหมุนเวียน, 8 กรกฎาคม 2562. http://www.eppo.go.th/index.php/th/electricity/plan-buy-renewenergy",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "อ"
  },
  {
    keyword:
      "อัตราการเติบโตของรายได้ของกลุ่มประชากรร้อยละ 40 ที่มีรายได้ต่ำสุด",
    meaning:
      "รายได้เฉลี่ยต่อหัวของกลุ่มเป้าหมายประชากรร้อยละ 40 ที่มีรายได้ต่ำสุด (Bottom 40)",
    source:
      "สำนักงานสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ. รายงานการวิเคราะห์สถานการณ์ความยากจนและความเหลื่อมล้ำ ปี 2560, 15 สิงหาคม 2562. http://social.nesdc.go.th/social/Portals/0/Documents/%E0%B8%A3%E0%B8%B2%E0%B8%A2%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B8%AA%E0%B8%96%E0%B8%B2%E0%B8%99%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%93%E0%B9%8C%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%A2%E0%B8%B2%E0%B8%81%E0%B8%88%E0%B8%99%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B9%80%E0%B8%AB%E0%B8%A5%E0%B8%B7%E0%B9%88%E0%B8%AD%E0%B8%A1%E0%B8%A5%E0%B9%89%E0%B8%B3%202560_2268.pdf",
    sappear: "",
    mappear: 16,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword:
      "อัตราการนอนโรงพยาบาลโดยไม่จำเป็นด้วยภาวะที่ควรควบคุมด้วยบริการผู้ป่วยนอก (ambulatory care sensitive conditions : ACSC)",
    meaning:
      "เป็นกลุ่มโรคหรือภาวะซึ่งหากได้รับการดูแลรักษาแบบผู้ป่วยนอกที่เหมาะสมแล้ว จะสามารถป้องกันการนอนพักรักษาตัวในโรงพยาบาลโดยไม่จำเป็นได้",
    source:
      "จิรุตม์ ศรีรัตนบัลล์ และดาวรุ่ง คำวงศ์. (2559). การประเมินสถานการณ์ของการบริการปฐมภูมิในเขตกรุงเทพมหานครด้วยการศึกษา Ambulatory care sensitive conditions, 24 ธันวาคม 2562. https://kb.hsri.or.th/dspace/handle/11228/4420?locale-attribute=th",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อัตราความรอบรู้ด้านสุขภาวะของประชากร",
    meaning:
      "ความสามารถและทักษะในการเข้าถึงข้อมูล ความรู้ ความเข้าใจ เพื่อวิเคราะห์ ประเมินการปฏิบัติและการจัดการตนเอง รวมทั้งสามารถชี้แนะเรื่องสุขภาพส่วนบุคคล ครอบครัว และชุมชนเพื่อสุขภาพที่ดี",
    source:
      "กรมสนับสนุนบริการสุขภาพ กระทรวงสาธารณสุข. (2561). การเสริมสร้างและประเมินความรอบรู้ด้านสุขภาพและพฤติกรรมสุขภาพ, 1 สิงหาคม 2562. https://www.ayo.moph.go.th/ncd/file_upload/subblocks/HLO_chanuanthong.pdf",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อัตราค่าบริการ",
    meaning:
      "ราคาพลังงานต่อหน่วย ค่าตอบแทน หรือเงื่อนไขสำหรับการให้บริการ ค่าธรรมเนียมอื่นๆ ที่ผู้รับใบอนุญาติเรียกเก็บจากผู้ใช้พลังงาน",
    source:
      "พระราชบัญญัติการประกอบกิจการพลังงาน พ.ศ. 2550. (2550, 9 ธันวาคม). ราชกิจจานุเบกษา. เล่มที่ 124 ตอนที่ 89 ก หน้าที่ 14. http://www.ratchakitcha.soc.go.th/DATA/PDF/2535/A/033/1.PDF",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "อ"
  },
  {
    keyword: "อัตราผู้เสียชีวิตจากอุบัติเหตุทางถนน (คนต่อประชากร 1 แสนคน)",
    meaning:
      "สัดส่วนระหว่างจำนวนผู้เสียชีวิตที่ปรากฏในสถิติคดีอุบัติเหตุจราจรทางบกแยกรายจังหวัด ต่อ จำนวนประชากรในแต่ละจังหวัด 1 แสนคน",
    source:
      "สำนักงานตำรวจแห่งชาติและกรมการปกครอง กระทรวงมหาดไทย. อัตราการเสียชีวิตจากอุบัติเหตุทางถนน ต่อ ประชากร 100,000 คน แยกรายจังหวัด. 20 กันยายน 2562. http://trso.thairoads.org/statistic/watch/detail/137",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อัตราส่วนของครัวเรือนที่ใช้อินเตอร์เน็ต (ร้อยละ)",
    meaning:
      "แนวโน้มการใช้คอมพิวเตอร์ อินเทอร์เน็ต และโทรศัพท์มือถือของประชากรอายุ 6 ปีขึ้นไป (ในช่วงระยะเวลา 5 ปี ระหว่างปี 2556-2560 พบว่า ผู้ใช้คอมพิวเตอร์ลดลง จากร้อยละ 35 เป็นร้อยละ 30.8 ผู้ใช้อินเทอร์เน็ตเพิ่มขึ้นจากร้อยละ 28.9 เป็นร้อยละ 52.9 ผู้ใช้โทรศัพท์มือถือเพิ่มขึ้นจากร้อยละ 73.3 เป็นร้อยละ 88.2 ในการเข้าถึงอินเทอร์เน็ตส่วนใหญ่ใช้โทรศัพท์มือถือแบบ Smart Phone ในการเข้าถึงอินเทอร์เน็ตค่อนข้างสูง ร้อยละ 93.7 ใช้ PC ร้อยละ 45.4 ใช้ Notebook ร้อยละ 20.8 และ Tablet ร้อยละ 10.2 ซึ่งประชากรกลุ่มอายุ 15-24 ปี มีการใช้อินเทอร์เน็ตสูงสุดที่สุด ร้อยละ 89.8 และส่วนใหญ่เป็นกิจกรรมที่ใช้ Social Network ร้อยละ 94.0)",
    source:
      "สำนักงานสถิติแห่งชาติ. (2560). สรุปผลที่สำคัญ\r\nการสำรวจกำรมีกำรใช้เทคโนโลยีสำรสนเทศและกำรสื่อสารในครัวเรือน พ.ศ. 2560, 14 พฤศจิกายน 2562. http://www.nso.go.th/sites/2014/DocLib13/ด้านICT/เทคโนโลยีในครัวเรือน/2560/สรุปผลที่สำคัญ-%20ICTครัวเรือน.pdf",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อัตลักษณ์",
    meaning:
      "ผลรวมของลักษณะเฉพาะของสิ่งใดสิ่งหนึ่งซึ่งทำให้สิ่งนั้นเป็นที่รู้จักหรือจำได้",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2550). อัตลักษณ์, \r\n19 มิถุนายน 2562. http://www.royin.go.th/?knowledges=อัตลักษณ์-๑๖-มิถุนายน-๒๕",
    sappear: 5,
    mappear: 2,
    rappear: 8,
    firstalpha: "อ"
  },
  {
    keyword: "อันดับของ Digital Evolution Index ของไทย",
    meaning:
      "ดัชนีดิจิตอลวิวัฒน์ (Digital Evolution Index : DEI) โดย The Fletcher School at Tufts University ได้แบ่ง 50 ประเทศชั้นนำตามระดับความก้าวหน้าทางดิจิตอลและโอกาสในการพัฒนาเป็น 4 กลุ่ม คือ \r\n1. Stand Out (กลุ่มโดดเด่น)\r\n2. Stall Out (กลุ่มชะงักงัน) \r\n3. Break Out (กลุ่มอุบัติใหม่) \r\n4. Watch Out (กลุ่มเฝ้าระวัง) \r\nซึ่งประเทศไทยถูกจัดให้อยู่ในกลุ่มอุบัติใหม่ (Break Out) คือ กลุ่มประเทศที่มีศักยภาพในการพัฒนาเศรษฐกิจดิจิตอลสูง ซึ่งถึงแม้ระดับความก้าวหน้าอาจยังไม่สูงมากนักในปัจจุบัน แต่มีโอกาสก้าวขึ้นไปอยู่ในกลุ่มโดดเด่นได้ต่อไปในอนาคต",
    source:
      "กองศึกษาวิจัยทางยุทธศาสตร์และความมั่นคงฯ. (2558). โอกาสและความก้าวหน้า “เศรษฐกิจดิจิตอล” ของไทย, 10 กันยายน 2562.   http://www.sscthailand.org/uploads_ssc/%E0%B8%89%E0%B8%9A%E0%B8%B1%E0%B8%9A%E0%B8%97%E0%B8%B5%E0%B9%88%2011-58%20%E0%B9%82%E0%B8%AD%E0%B8%81%E0%B8%B2%E0%B8%AA%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%81%E0%B9%89%E0%B8%B2%E0%B8%A7%E0%B8%AB%E0%B8%99%E0%B9%89%E0%B8%B2%20%E0%B9%80%E0%B8%A8%E0%B8%A3%E0%B8%A9%E0%B8%90%E0%B8%81%E0%B8%B4%E0%B8%88%E0%B8%94%E0%B8%B4%E0%B8%88%E0%B8%B4%E0%B8%95%E0%B8%AD%E0%B8%A5%20%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B9%84%E0%B8%97%E0%B8%A2.pdf",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อันดับของประเทศด้านความยั่งยืนและคุณภาพสิ่งแวดล้อมในระดับโลก ",
    meaning:
      "มูลนิธิแบร์เทลส์มันน์ (Bertelsmann Stiftung) ร่วมกับเครือข่ายการแก้ปัญหาเพื่อการพัฒนาที่ยั่งยืน ดำเนินการจัดอันดับของประเทศด้านความยั่งยืนและคุณภาพสิ่งแวดล้อมในระดับโลก จำนวน 162 ประเทศในทุกปี เพื่อรายงานผลการตอบสนองต่อเป้าหมายการพัฒนาที่ยั่งยืน 17 เป้าหมาย",
    source:
      "Sustainable Development Solutions Network (SDSN). Sustainable Development Report , 17 สิงหาคม 2562. https://s3.amazonaws.com/sustainabledevelopment.report/2019/2019_sustainable_development_report.pdf",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อันดับขีดความสามารถในการแข่งขันของประเทศ ด้านการศึกษา",
    meaning:
      "สถาบันเพื่อพัฒนาการจัดการนานาชาติ (IMD) ได้จัดอันดับความสามารถในการแข่งขันด้านการศึกษา ซึ่งเป็น 1 ใน 5 ของปัจจัยย่อยในปัจจัยหลักด้านโครงสร้างพื้นฐาน ซึ่งประเทศไทยมีอันดับด้านการศึกษาอยู่ในอันดับ 56 ลดลง 2 อันดับเมื่อเปรียบเทียบกับปี 2560 หากเปรียบเทียบกับประเทศในภูมิภาคอาเซียน พบว่า ประเทศไทยมีอันดับดีกว่าอินโดนีเซียและฟิลิปปินส์ (อันดับ 57, 61) ส่วนมาเลเซียและสิงคโปร์ ได้อันดับดีกว่าประเทศไทย (อันดับ 34 , 2) ทั้งนี้ สิงคโปร์มีสมรรถนะด้านการศึกษาสูงเป็นอันดับ 2 ของโลก",
    source:
      "สำนักงานเลขาธิการสภาการศึกษา. สมรรถนะการศึกษาของประเทศไทยในเวทีสากล ปี 2561 (IMD 2018), 2 สิงหาคม 2562.   http://backoffice.onec.go.th/uploaded2/Outstand/201806/IMD2018.pdf",
    sappear: "",
    mappear: 12,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อันดับความยาก-ง่ายในการประกอบธุรกิจ (Ease of Doing Business)",
    meaning:
      "ตัวแปรที่สำคัญต่อการตัดสินใจในการดำเนินธุรกิจในประเทศนั้นๆ การประเมินระดับความสะดวกในการเข้าไปประกอบธุรกิจหรือการดำเนินธุรกิจในประเทศใด พิจารณาตั้งแต่ความสะดวกในการเริ่มต้นประกอบธุรกิจ การดำเนินธุรกิจ และเมื่อเกิดปัญหาทางธุรกิจ ว่ามีขั้นตอนและระยะเวลาการให้บริการ การอำนวยความสะดวก ต้นทุนและค่าใช้จ่ายในการดำเนินการ และกฎระเบียบของภาครัฐที่สนับสนุนต่อการประกอบธุรกิจหรือไม่อย่างไร",
    source:
      "ณัฐพรพรรณ อุตมา โครงการจัดตั้งสำนักงานเศรษฐกิจชายแดนและโลจิสติกส์. ความยากง่ายในการประกอบธุรกิจ (EASE OF DOING BUSINESS), 11 กันยายน 2562. http://rs.mfu.ac.th/obels/?p=1259",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "อ"
  },
  {
    keyword: "อันดับความสามารถในการแข่งขันด้านโครงสร้างพื้นฐาน",
    meaning:
      "สถาบันเพื่อพัฒนาการจัดการนานาชาติ (IMD) ได้ประเมินคุณภาพโครงสร้างพื้นฐานและจัดอันดับความสามารถในการแข่งขันของประเทศโดยพิจารณาจากข้อมูล 2 ส่วน ได้แก่ ข้อมูลระบบขนส่งและจราจร (ข้อมูลทุติยภูมิ: Hard Data) และข้อมูลจากการสำรวจความคิดเห็น (EOS) ดังนั้น ภาครัฐจำเป็นต้องดำเนินการเพื่อเพิ่มอันดับคุณภาพโครงสร้างพื้นฐานของประเทศ ดังนี้\r\n1. การปรับปรุงด้านข้อมูลระบบขนส่งและจราจร (ข้อมูลทุติยภูมิ: Hard Data)\r\n2. การปรับปรุงเพื่อเพิ่มระดับความพึงพอใจ (ข้อมูลปฐมภูมิ)\r\n",
    source:
      "ศูนย์เทคโนโลยีสารสนเทศการขนส่งและจราจร สำนักงานนโยบายและแผนการขนส่งและจราจร. อันดับความสามารถในการแข่งขันของประเทศไทย ปี 2561 (ค.ศ. 2018) โดยสถาบันการจัดการนานาชาติ (International Institute for Management Development: IMD). 20 กันยายน 2562. http://www.otp.go.th/uploads/tiny_uploads/DataStatistics/2562/25230823-IMD2018.pdf",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อันดับความสามารถในการแข่งขันด้านการค้าระหว่างประเทศโดย IMD",
    meaning:
      "การจัดอันดับการแข่งขันของ IMD ได้พิจารณาปัจจัย 4 ประการ คือ \r\n1. ภาวะเศรษฐกิจ \r\n2. ประสิทธิภาพภาครัฐ \r\n3. ประสิทธิภาพภาคธุรกิจ \r\n4. โครงสร้างพื้นฐาน \r\nโดยในแต่ละปัจจัยจะแบ่งเป็น 5 ด้านย่อย และสามารถจำแนกได้ถึง 255 เครื่องชี้วัด ",
    source:
      "นครินทร์ อมเรศ. ฝ่ายนโยบายโครงสร้างเศรษฐกิจ ธนาคารแห่งประเทศไทย. อันดับการแข่งขันของไทยดีได้อีก ?, 11 กันยายน 2562. https://www.bot.or.th/Thai/ResearchAndPublications/articles/Pages/Article_10Jun2019.aspx",
    sappear: "",
    mappear: 8,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อันดับความสามารถด้านประสิทธิภาพแรงงาน โดย WEF",
    meaning:
      "สภาเศรษฐกิจโลก (World Economic Forum : WEF) ได้จัดอันดับความสามารถในการแข่งขันของประเทศต่าง ๆ โดยได้กำหนดปัจจัยที่นำมาใช้ในการจัดอันดับ เรียกว่า Global Competitiveness Index (GCI) ไว้ 3 ปัจจัยหลัก และ 12 ปัจจัยย่อย ดังนี้\r\n1. ปัจจัยพื้นฐาน (Basic requirements) ประกอบด้วย 4 ปัจจัยย่อย ได้แก่ (1) ปัจจัยเกี่ยวกับสถาบัน (Institutions)  (2) โครงสร้างพื้นฐาน (Infrastructure) (3) สภาพแวดล้อมทางเศรษฐกิจมหภาค (Macroeconomic environment) และ (4) สุขภาพและการศึกษาขั้นพื้นฐาน (Health and primary education)\r\n2. ปัจจัยยกระดับประสิทธิภาพ (Efficiency enhancers) ประกอบด้วย 6 ปัจจัยย่อย ได้แก่ (1) การฝึกอบรมและการศึกษาขั้นสูง (Higher education and training) (2) ประสิทธิภาพของตลาดสินค้า (Goods market efficiency) (3) ประสิทธิภาพของตลาดแรงงาน (Labor market efficiency) (4) พัฒนาการของตลาดการเงิน (Financial market development) (5) ความพร้อมด้านเทคโนโลยี (Technological readiness) และ (6) ขนาดของตลาด (Market size)\r\n3. ปัจจัยนวัตกรรมและศักยภาพทางธุรกิจ (Innovation and sophistication factors) ประกอบด้วย 2 ปัจจัยย่อย ได้แก่ (1) ศักยภาพทางธุรกิจ (Business sophistication) และ (2) นวัตกรรม (Innovation)",
    source:
      "สำนักงานคณะกรรมการนโยบายวิทยาศาสตร์ เทคโนโลยีและนวัตกรรมแห่งชาติ. บทวิเคราะห์การจัดอันดับความสามารถในการแข่งขันของประเทศไทย ประจำปี 2017 - 2018 โดย World Economic Forum: WEF. 19 พฤศจิกายน 2562. http://sti.or.th/sti/news-detail.php?news_type=2&news_id=250&",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword:
      "อันดับความสามารถทางการแข่งขันด้านการท่องเที่ยวของประเทศไทย โดย Travel & Tourism Competitiveness Index (TTCI)",
    meaning:
      "จัดอันดับขีดความสามารถในการแข่งขันด้านการท่องเที่ยวของ140 ประเทศทั่วโลก (สองปีครั้ง) สำหรับให้ประเทศต่างๆ ประเมินความสามารถด้านการท่องเที่ยวที่เป็นปัจจัยสำคัญต่อความสามารถในการแข่งขันด้านการท่องเที่ยวเปรียบเทียบกับประเทศอื่น ๆ โดยการวัดจากปัจจัยหลัก 4 ด้าน ได้แก่ด้านสภาวะแวดล้อมที่เอื้ออำนวย(EnablingEnvironment) นโยบายด้านการท่องเที่ยวและเงื่อนไขในการอำนวยความสะดวก (T&T Policy and Enabling Conditions) โครงสร้างพื้นฐาน (Infrastructure) และทรัพยากรธรรมชาติและ\r\nทรัพยากรทางวัฒนธรรมที่มีอยู่ (Naturaland CulturalResources)",
    source:
      "สำนักงานปลัดกระทรวงการท่องเที่ยวและกีฬา. (2562). รายงานภาวะเศรษฐกิจการท่องเที่ยว ฉบับที่ 1 ปี 2562, 30 ตุลาคม 2562. https://www.mots.go.th/download/article/article_20191025094442.pdf",
    sappear: "",
    mappear: 5,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อันดับดัชนีนวัตกรรมโลก",
    meaning:
      "ดัชนีชี้วัดความสามารถทางด้านนวัตกรรมของโลก จาก 126 ประเทศทั่วโลก ซึ่งดัชนีนวัตกรรมโลกจะผลักดันให้เกิดนวัตกรรมด้านต่างๆ ทั้งปัจจัยนำเข้าทางนวัตกรรม ประกอบด้วย ปัจจัยด้านสถาบัน ด้านทุนมนุษย์และการวิจัย ด้านโครงสร้างพื้นฐาน ด้านระบบตลาด ด้านระบบธุรกิจ และ ปัจจัยผลผลิตทางนวัตกรรม ประกอยด้วยปัจจัยด้านผลผลิตจากความคิดสร้างสรรค์  ",
    source:
      "กนช รัติวานิช ผู้จัดการส่งเสริมนวัตกรรม สำนักงานนวัตกรรมแห่งชาติ. (2561). การจ้างเหมาประชาสัมพันธ์งานสัปดาห์นวัตกรรมไทย พ.ศ. 2561, 17 ตุลาคม 2562. https://www.nia.or.th/nia/wp-content/uploads/2018/08/20180822_TOR_%e0%b8%ad0058_61.pdf",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "อ"
  },
  {
    keyword:
      "อันดับด้านรายได้การท่องเที่ยวเชิงสุขภาพของประเทศไทย โดย Global Wellness Institute ",
    meaning:
      "ปี 2561 ประเทศไทยมีอันดับรายได้จากการท่องเที่ยวเชิงสุขภาพอยู่ในอันดับที่ 13 ของโลก ซึ่งมาจากการที่นักท่องเที่ยวเชิงสุขภาพเป็นกลุ่มที่มีการศึกษาดี ฐานะปานกลางถึงสูง มีจำนวนวันที่พักยาวนาน และมีการใช้จ่ายเฉลี่ยต่อการท่องเที่ยวแต่ละครั้งสูงกว่านักท่องเที่ยวทั่วไป โดยส่วนใหญ่นักท่องเที่ยวมักเดินทางมาเพื่อรักษาโรคเฉพาะทาง และบริการด้านศัลยกรรมความงาม เนื่องจากเทคโนโลยีด้านการแพทย์ของไทยค่อนข้างทันสมัย และค่าใช้จ่ายต่ำกว่าประเทศอื่น",
    source:
      "กระทรวงการท่องเที่ยวและกีฬา. รายงานภาวะเศรษฐกิจท่องเที่ยว ฉบับที่ 3. 6 ธันวาคม 2562. https://www.mots.go.th/content.php?nid=7618",
    sappear: "",
    mappear: 5,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อาเซียน",
    meaning:
      "ASEAN (Association of South-East Asian Nations)\r\nสมาคมแห่งประชาชาติเอเชียตะวันออกเฉียงใต้ หรือ อาเซียน\r\nจัดตั้งขึ้นตามปฏิญญากรุงเทพ (Bangkok Declaration) เมื่อวันที่ 8 สิงหาคม 2510 เพื่อร่วมมือและส่งเสริมสันติภาพ เสถียรภาพ ความเจริญทางเศรษฐกิจ ความก้าวหน้าทางสังคม วัฒนธรรม วิชาการ วิทยาศาสตร์และการบริหารในภูมิภาค โดยมีสมาชิกเริ่มแรก 5 ประเทศ คือ อินโดนิเซีย มาเลเซีย ฟิลิปปินส์ สิงคโปร์และไทย ต่อมามีประเทศสมาชิกเข้าร่วมเพิ่ม ได้แก่ บรูไนดารุสซาลาม เวียดนาม ลาว พม่า และกัมพูชา",
    source:
      "สถาบันการต่างประเทศเทวะวงศ์วโรปการ กระทรวงการต่างประเทศ. หนังสือคำศัพท์-คำย่อทางการทูต สถาบันการต่างประเทศ กระทรวงการต่างประเทศ. (ฉบับปรับปรุงครั้งที่ 2), 6 ธันวาคม 2562. http://www.mfa.go.th/dvifa/th/code?c=a",
    sappear: "",
    mappear: "1,2,18",
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อาคารชลศาสตร์",
    meaning:
      "อาคารใดๆ ที่ได้จัดทำขึ้นเพื่อการเก็บกัก เพื่อบังคับควบคุมซึ่งปริมาณและระดับน้ำตามที่ต้องการ เพื่อนำไปใช้ประโยชน์ในการชลประทาน การประปา การไฟฟ้าพลังน้ำ การคมนาคมทางน้ำ การบรรเทาและป้องกันอุทกภัย การรักษา สภาพทางระบบนิเวศวิทยาและสิ่งแวดล้อม รวมถึงการพักผ่อนหย่อนใจ การประมง และอื่นๆ",
    source:
      "รายการ กึ๋น ชป.. (2558). การออกแบบ การเขียนแบบของงานชลประทาน, 8 กรกฎาคม 2562. http://km.rid7.com/images/rio7radio2015/pdf/2-07-58%20%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%AD%E0%B8%AD%E0%B8%81%E0%B9%81%E0%B8%9A%E0%B8%9A%20%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%82%E0%B8%B5%E0%B8%A2%E0%B8%99%E0%B9%81%E0%B8%9A%E0%B8%9A%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B8%87%E0%B8%B2%E0%B8%99%E0%B8%8A%E0%B8%A5%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%97%E0%B8%B2%E0%B8%99.pdf",
    sappear: 5,
    mappear: 19,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อาชญากรรม",
    meaning:
      "พฤติกรรมที่ฝ่าฝืนข้อห้ามของรัฐในส่วนที่เกี่ยวกับกฎหมายอาญาโดยผู้กระทำมีเจตนาชั่วร้าย และจากการฝ่าฝืนดังกล่าว ผู้กระทำจะต้องได้รับโทษทางอาญา",
    source:
      "องค์การรักษาความปลอดภัยฝ่ายพลเรือน (Civilian SECurity Organization). (2558). ความหมายของอาชญากรรม, \r\n29 สิงหาคม 2562.\r\nhttps://www.secnia.go.th/2016/01/13/%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%\r\nAB%E0%B8%A1%E0%B8%B2%E0%B8%A2%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B8%AD%E0%\r\nB8%B2%E0%B8%8A%E0%B8%8D%E0%B8%B2%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1/",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "อ"
  },
  {
    keyword: "อาชญากรรมข้ามชาติ",
    meaning:
      "การกระทำขององค์กรหรือกลุ่มบุคคล สมคบ และร่วมมือกระทำความผิดต่อเนื่องจากประเทศหนึ่งไปยังอีกประเทศหนึ่งหรือหลายประเทศอันเป็นความผิดตามกฎหมายหรือบทลงโทษของประเทศที่องค์กรหรือกลุ่มบุคคลเหล่านั้นดำเนินการ เพื่อมุ่งแสวงหาผลประโยชน์และอำนาจที่ขัดต่อกฎหมายและศีลธรรม ก่อให้เกิดผลกระทบต่อความสัมพันธ์และความมั่นคงของบุคคล องค์กร เศรษฐกิจ สังคม การเมือง และอื่นๆ",
    source:
      "สำนักงานสภาความมั่นคงแห่งชาติ. (2561, 10 กรกฎาคม). ยุทธศาสตร์ในการป้องกันและแก้ไขปัญหาอาชญากรรมข้ามขาติ พ.ศ. 2558-2564, 6 ธันวาคม 2562. http://www.nsc.go.th/Lists/List3/Attachments/34/ยุทธศาสตร์ในการป้องกันและแก้ไขปัญหาอาชญากรรมข้ามชาติ%20พ.ศ.๒๕๕๘-๒๕๖๔.pdf",
    sappear: "",
    mappear: "1,21",
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อาชญากรรมทางเศรษฐกิจ",
    meaning:
      "การกระทำที่ผิดกฎหมาย โดยอาชญากรจะใช้วิธีการหลอกหลวงหรือฉ้อโกงทรัพย์สินของผู้อื่นแทนการใช้กำลังข่มขู่คุกคามโดยตรง โดยเฉพาะจะใช้ความสามารถพิเศษทางวิขาขีพหรือทางเทคนิคหรือทางเทคโนโลยีที่ก้าวหน้า เพื่อบรรลุวัตถุประสงค์ของตน โดยอาชญากรอาจเป็นผู้ที่มีการศึกษาดีหรือนิติบุคคลในธุรกิจประเภทต่าง ๆ ซึ่งจะก่อให้เกิดความสูญเสียทางการเงิน ผลกระทบต่อเศรษฐกิจและความมั่นคง ทั้งนี้ ความก้าวหน้าทางเทคโนโลยีอาจทำให้อาชญากรรมทางเศรษฐกิจขยายตัวกลายเป็นองค์กรอาชญากรรมที่มีลักษณะเป็นเครือข่ายหรือข้ามชาติ ",
    source:
      "ปรัชญา ปิ่นมณี. (2551, 1 มีนาคม). วารสารเศรษฐศาสตร์ธรรมศาสตร์ ปีที่ 26 ฉบับที่ 1. อาชญากรรมทางเศรษฐกิจในแบบจำลองการเจริญเติบโจภายใต้กระบวนการเรียนรู้จากการกระทำ, 6 ธันวาคม 2562 http://www.econ.tu.ac.th/oldweb/doc/article/fulltext/179.pdf",
    sappear: "",
    mappear: 1,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อาชญากรรมทางไซเบอร์",
    meaning:
      "การก่อภัยคุกคามทางไซเบอร์ ซึ่งเป็นการกระทำหรือการดำเนินการใด ๆ โดยมิชอบโดยใช้คอมพิวเตอร์หรือระบบคอมพิวเตอร์หรือโปรแกรมไม่พึงประสงค์โดยมุ่งหมายให้เกิดการประทุษร้ายต่อระบบคอมพิวเตอร์ ข้อมูลคอมพิวเตอร์ หรือข้อมูลอื่นที่เกี่ยวข้อง และเป็นภยันตรายที่ใกล้จะถึงที่จะก่อให้เกิดความเสียหายหรือส่งผลกระทบต่อการทำงานของคอมพิวเตอร์ ระบบคอมพิวเตอร์ หรือข้อมูลอื่นที่เกี่ยวข้อง",
    source:
      "พระราชบัญญัติการรักษาความมั่นคงปลอดภัยไซเบอร์ พ.ศ. 2562. (2562,27 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 69 ก. หน้า 21. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/069/T_0020.PDF",
    sappear: 1,
    mappear: "",
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อาชญากรรมทางไซเบอร์ในโลกดิจิทัล",
    meaning:
      "การก่อภัยคุกคามทางไซเบอร์ ซึ่งเป็นการกระทำหรือการดำเนินการใด ๆ โดยมิชอบโดยใช้คอมพิวเตอร์หรือระบบคอมพิวเตอร์หรือโปรแกรมไม่พึงประสงค์โดยมุ่งหมายให้เกิดการประทุษร้ายต่อระบบคอมพิวเตอร์ ข้อมูลคอมพิวเตอร์ หรือข้อมูลอื่นที่เกี่ยวข้อง ",
    source:
      "พระราชบัญญัติการรักษาความมั่นคงปลอดภัยไซเบอร์ พ.ศ. 2562 (2562, 27 พฤษภาคม). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 69 ก. หน้า 21. http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/069/T_0020.PDF\r\n \r\n",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "อ"
  },
  {
    keyword: "อาชญาบัตร",
    meaning: "ใบอนุญาตซึ่งพนักงานเจ้าหน้าที่ออกให้แก่ผู้รับอนุญาต",
    source:
      "พระราชบัญญัติการประมง พ.ศ. 2490. (27 เมษายน 2552). มาตรา 4 (10).\r\nhttp://web.krisdika.go.th/data/law/law2/%A125/%A125-20-9999-update.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "อ"
  },
  {
    keyword: "อาชีวศึกษาระบบทวิภาคี",
    meaning:
      "การจัดการเรียนการสอนระบบหนึ่ง ที่มุ่งเน้นให้ผู้เรียนมีโอกาสฝึกภาคปฏิบัติในสถานประกอบการมากกว่าระบบปกติ ซึ่งผู้เรียนจะต้องเรียนรายวิชาในหลักสูตรประกาศนียบัตรวิชาชีพ (ปวช.) หรือ ประกาศนียบัตรวิชาชีพชั้นสูง (ปวส.) โดยเมื่อสำเร็จการศึกษาแล้วจะได้ประกาศนียบัตรวิชาชีพ (ปวช.) หรือประกาศนียบัตร วิชาชีพชั้นสูง (ปวส.) เช่นเดียวกับผู้สำเร็จการศึกษา ระบบปกติ\r\n ประโยชน์ที่ผู้เรียนจะได้รับจากการศึกษาระบบทวิภาคี \r\n  1. ความชำนาญจากการฝึกอาชีพในสถานประกอบการและมีความรู้ทางด้านวิชาการ\r\n  จากสถานศึกษา \r\n  2. เงินค่าเบี้ยเลี้ยงหรือสวัสดิการอื่น ๆ ที่สถานประกอบการจัดให้ \r\n  3. ได้รับประกาศนียบัตรวิชาชีพ หรือประกาศนียบัตรวิชาชีพชั้นสูงจากสถานศึกษา \r\n  4. ได้รับวุฒิบัตรและใบรับรองการฝึกอาชีพจากสถานประกอบการ \r\n  5. โอกาสในการทำงานหรือศึกษาต่อ",
    source:
      "วิทยาลัยอาชีวศึกษาลำปาง สาขาวิชาการจัดการธุรกิจ อาชีวศึกษาระบบทวิภาคี. การเรียนการสอนอาชีวศึกษาระบบทวิภาคี, 1 กรกฎาคม 2562. http://www.lampangvc.ac.th/DVT/index.htm",
    sappear: "",
    mappear: 12,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อาชีวอนามัย",
    meaning:
      "ศาสตร์และศิลปะเกี่ยวกับการดูแลสุขภาพอนามัย และความปลอดภัยของผู้ประกอบอาชีพ อันรวมถึงการป้องกันโรค การส่งเสริมสุขภาพ การรักษาพยาบาล การฟื้นฟูสมรรถภาพ และการจัดการ เพื่อให้ผู้ประกอบอาชีพทุกอาชีพ สามารถที่จะประกอบอาชีพได้อย่างปลอดโรค ปลอดภัย มีสภาวะที่สมบูรณ์ทั้งทางด้านร่างกาย จิตใจ และสามารถปฏิบัติงานได้อย่างมีประสิทธิผล",
    source:
      "สารานุกรมไทยสำหรับเยาวชนฯ  เล่มที่ 22. อาชีวอนามัย (Occupational Health), 5 สิงหาคม 2562. http://saranukromthai.or.th/sub/book/book.php?book=22&chap=6&page=t22-6-infodetail01.html",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "อ"
  },
  {
    keyword: "อาชีวอนามัยสิ่งแวดล้อม",
    meaning:
      "การจัดการกับปัจจัยทางกายภาพ เคมี และชีวภาพ ที่อยู่ภายนอกตัวคนและปัจจัยเกี่ยวข้องที่มีผลกระทบต่อพฤติกรรมอนามัยสิ่งแวดล้อม ประกอบด้วยการประเมินและการควบคุมปัจจัยสิ่งแวดล้อม ที่สามารถส่งผลกระทบต่อสุขภาพ โดยมีเป้าหมายเพื่อการป้องกันโรคและการสร้างสภาพแวดล้อมที่เอื้อต่อสุขภาพ ทั้งสำหรับคนรุ่นปัจจุบันและรุ่นลูกหลานในอนาคต",
    source:
      "ศูนย์สารสนเทศยุทธศาสตร์ภาครัฐ สำนักงานสถิติแห่งชาติ. (2561). อนามัยสิ่งแวดล้อม. 20 กันยายน 2562. http://service.nic.go.th/strategy.php?file=strategy/policy-34",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อายุความ",
    meaning:
      "ในคดีอาญา ถ้ามิได้ฟ้องและได้ตัวผู้กระทำความผิดมายังศาลภายในกำหนดดังต่อไปนี้ นับแต่วันกระทำความผิด เป็นอันขาดอายุความ\r\n1. ยี่สิบปี สำหรับความผิดต้องระวางโทษประหารชีวิต จำคุกตลอดชีวิต หรือจำคุกยี่สิบปี\r\n2. สิบห้าปี สำหรับความผิดต้องระวางโทษจำคุกกว่าเจ็ดปีแต่ยังไม่ถึงยี่สิบปี\r\n3. สิบปี สำหรับความผิดต้องระวางโทษจำคุกกว่าหนึ่งปีถึงเจ็ดปี\r\n4. ห้าปี สำหรับความผิดต้องระวางโทษจำคุกกว่าหนึ่งเดือนถึงหนึ่งปี\r\n5. หนึ่งปี สำหรับความผิดต้องระวางโทษจำคุกตั้งแต่หนึ่งเดือนลงมา หรือต้องระวางโทษอย่างอื่น\r\nถ้าได้ฟ้องและได้ตัวผู้กระทำความผิดมายังศาลแล้ว ผู้กระทำความผิดหลบหนีหรือวิกลจริต และศาลสั่งงดการพิจารณาไว้จนเกินกำหนดดังกล่าวแล้วนับแต่วันที่หลบหนีหรือวันที่ศาลสั่งงดการพิจารณา ก็ให้ถือว่าเป็นอันขาดอายุความเช่นเดียวกัน",
    source:
      "สถาบันนิติธรรมาลัย. (2560). หมวด 9 อายุความ (มาตรา 95 - 101), 29 สิงหาคม 2562. \r\nhttp://www.drthawip.com/criminalcode/1-15",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "อ"
  },
  {
    keyword: "อายุคาดเฉลี่ยของการมีสุขภาพดี",
    meaning:
      "การคาดประมาณจำนวนปีโดยเฉลี่ยของการมีชีวิตอยู่ของประชากร โดยปรับกับผลรวมของสถานะสุขภาพระดับต่างๆในแต่ละช่วงชีวิต ซึ่งมรการให้น้ำหนักของสถานะสุขภาพตั้งแต่ 0 ซึ่งหมายถึงการตายไปจนถึง 1 ซึ่งหมายถึงสุขภาพสมบูรณ์ที่สุด ซึ่งจำนวนปีเฉลี่ยของการมีชีวิตอยู่ จะถูกปรับค่าให้ลดลง หากประชากรทุกคนไม่ได้มีสุขภาพที่สมบูรณ์ที่สุด และจำนวนปีลดลงมาก หากประชากรที่มีชีวิตอยู่นั้น มีสุขภาพที่ไม่ดี",
    source:
      "สำนักงานพัฒนาระบบข้อมูลข่าวสุขภาพ. สุขภาพกาย (Physical Health), 9 ธันวาคม 2562. https://www.hiso.or.th/hiso/picture/reportHealth/nn_report51.pdf",
    sappear: "",
    mappear: 13,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อำนาจแบบนุ่มนวล",
    meaning:
      "หรือ Soft Power ในเชิงการต่างประเทศ คือ อำนาจที่เกิดจากการสร้างเสน่ห์หรืออำนาจในการโน้มน้าวด้วยทรัพยากรเชิงอำนาจที่สำคัญ 3 ประการ ได้แก่ วัฒนธรรม ค่านิยม และนโยบายต่างประเทศ ซึ่งแตกต่างจากอำนาจแบบเดิมที่เรียกว่า hard power อันเป็นอำนาจเชิงบังคับจากการใช้กำลังทหารและพลังทางเศรษฐกิจ ด้วยทรัพยากรเชิงอำนาจ เช่น ยุทโธปกรณ์ อำนาจทางการทหาร แสนยานุภาพ ที่กระทำผ่านวิธีการใช้กำลังสลับกับการให้รางวัล",
    source:
      "ชุตินันท์ ทักษณาภินันท์. (2551). Soft Power ของญี่ปุ่น: จากนโยบายเชิงรับสู่เชิงรุก (วิทยานิพนธ์ปริญญามหาบัณฑิต). มหาวิทยาลัยธรรมศาสตร์, คณะศิลปศาสตร์, สาขาวิชาญี่ปุ่นศึกษา, 6 มิถุนายน 2562, http://digi.library.tu.ac.th/thesis/lib/0706/10CHAPTER_2.pdf",
    sappear: "",
    mappear: 2,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อำนาจนิติบัญญัติ",
    meaning:
      "อำนาจที่ใช้โดยรัฐสภา (สมาชิกสภาผู้แทนราษฎรและสมาชิกวุฒิสภา) ทำหน้าที่ออกกฎหมายและควบคุมฝ่ายบริหาร\r\n\r\n",
    source:
      "สำนักงานคณะกรรมการการเลือกตั้ง.หลักการสำคัญของการปกครองระบอบประชาธิปไตย. อำนาจนิติบัญญัติ หน้า 2. 18 กันยายน 2562.\r\nhttps://www.ect.go.th/dec/ewt_dl_link.php?nid=75",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "อ"
  },
  {
    keyword: "อำนาจบริหาร",
    meaning:
      "อำนาจที่ใช้โดยคณะรัฐมนตรี หรือรัฐบาล คระรัฐมนตรีเป็นฝ่ายบริหาร ทำหน้าที่บริหารราชการแผ่นดิน",
    source:
      "สำนักงานคณะกรรมการการเลือกตั้ง.หลักการสำคัญของการปกครองระบอบประชาธิปไตย. อำนาจบริหาร หน้า 2. 18 กันยายน 2562.\r\nhttps://www.ect.go.th/dec/ewt_dl_link.php?nid=75",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "อ"
  },
  {
    keyword: "อำนาจอธิปไตย",
    meaning: "อำนาจสูงสุดของรัฐที่จะใช้บังคับบัญชาภายในอาณาเขตของตน",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. อำนาจอธิปไตย. 10 มิถุนายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 1,
    firstalpha: "อ"
  },
  {
    keyword: "อิเล็กทรอนิกส์",
    meaning:
      "วิทยาศาสตร์กายภาพแขนงหนึ่งที่นำมาประยุกต์ใช้กับการศึกษาวงจรไฟฟ้าที่ใช้สารกึ่งตัวนำและอุปกรณ์อื่น ๆ ซึ่งควบคุมการเคลื่อนที่ของอิเล็กตรอนได้",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554. อิเล็กทรอนิกส์, 21 พฤศจิกายน 2562. http://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อิเล็กทรอนิกส์อัจฉริยะ",
    meaning:
      "อุปกรณ์เครื่องใช้ต่างๆ ที่ติดตั้งระบบสมองกลฝังตัว เพื่อให้มีคุณสมบัติใหม่ และสามารถสื่อสารระหว่างกันอย่างอิสระผ่านอินเทอร์เน็ตในทุกสิ่ง (Internet of Things: IoT) เช่น ระบบการจราจรอัจฉริยะ ระบบควบคุมพลังงานในอาคารแบบฉลาด และระบบอิเล็กทรอนิกส์ทางการแพทย์อัจฉริยะ ขึ้นอยู่กับว่าจะนำไปประยุกต์ใช้กับอะไร สำหรับการใช้อิเล็กทรอนิกส์อัจฉริยะในไทยแยกเป็น 3 กลุ่ม ได้แก่ 1. กลุ่มการสื่อสารและโฆษณา 2. กลุ่มอุตสาหกรรมด้านสุขภาพ เช่น ระบบการแพทย์ทางไกลอาจจะเริ่มต้นจากการให้คำปรึกษาเบื้องต้น เปิดโอกาสให้แพทย์กับผู้ป่วยสามารถสื่อสารกันได้ง่ายขึ้น และกลุ่มที่ 3 อุตสาหกรรมค้าปลีกที่นำระบบอิเล็กทรอนิกส์อัจฉริยะไปใช้ในการแนะนำสินค้าหรือบริการแก่ผู้บริโภค ถือว่ามีความเป็นไปได้มากซึ่งเป็นผลมาจากสภาวการณ์แข่งขันรุนแรง อุตสาหกรรมอิเล็กทรอนิกส์อัจฉริยะเป็นการต่อยอดอุตสาหกรรมเดิมที่มีศักยภาพ (First S-curve) ซึ่งเป็นการลงทุนในกลุ่มอุตสาหกรรมเดิมที่มีอยู่แล้ว เพื่อเพิ่มประสิทธิภาพการใช้ปัจจัยผลิต โดยการลงทุนชนิดนี้จะส่งผลต่อการเจริญเติบโตทางเศรษฐกิจในระยะสั้น และระยะกลางในลักษณะการต่อยอด",
    source:
      "สถาบันทรัพย์สินทางปัญญาแห่งจุฬาลงกรณ์มหาวิทยาลัย. (2560). รายงานฉบับสมบูรณ์การวิเคราะห์แนวโน้มเทคโนโลยีและอุตสาหกรรม อุตสาหกรรมอิเล็กทรอนิกส์อัจฉริยะ, 18 กันยายน 2562. https://www.ipthailand.go.th/images/3534/web_01052018/Report_CHU/7_Smart_electronics_06.12.2017_CHU.pdf",
    sappear: 2,
    mappear: 4,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อินเทอร์เน็ตบรอดแบรนด์",
    meaning:
      "โครงข่ายการสื่อสารความเร็วสูง ที่สามารถรับส่งข้อมูลจำนวนมากผ่านสื่อใช้สาย เช่น เคเบิลใยแก้วนำแสง สายเคเบิลทีวี สายโทรศัพท์ (DSL) หรือสื่อไร้สายเช่น 3G และ WiMax",
    source:
      "สำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์ (สพธอ.). (2556). Broadband network, 11 กันยายน 2562. https://www.etda.or.th/terminology-detail/1564.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "อ"
  },
  {
    keyword: "อินเวอร์เตอร์",
    meaning:
      "ระบบควบคุมการทำงานของคอมเพรสเซอร์ ช่วยให้เกิดการใช้กระแสไฟต่ำ แต่ได้พลังงานออกมาสูง ช่วยลดกำลังไฟฟ้าที่ใช้งานได้อย่างมีประสิทธิภาพ",
    source:
      "ศูนย์เทคโนโลยีสารสนเทศและการสื่อสาร สำนักงานปลัดกระทรวง. (2552). อินเวอร์เตอร์, 19 กันยายน 2562. http://www.moe.go.th/index.php/%E0%B8%82%E0%B9%88%E0%B8%B2%E0%B8%A7%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%81%E0%B8%B2%E0%B8%A8/%E0%B9%80%E0%B8%99%E0%B8%84%E0%B9%80%E0%B8%97%E0%B8%84%E0%B8%A3%E0%B9%88%E0%B8%A7%E0%B8%A1%E0%B8%81%E0%B8%B1%E0%B8%9A%E0%B9%80%E0%B8%AD%E0%B8%81%E0%B8%8A%E0%B8%99%E0%B8%AA%E0%B8%A3%E0%B9%89%E0%B8%B2%E0%B8%87%E0%B8%AD%E0%B8%87%E0%B8%84%E0%B9%8C%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B8%A3%E0%B8%B9%E0%B9%89%E0%B9%83%E0%B8%AB%E0%B8%A1%E0%B9%88/news11/8295",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "อ"
  },
  {
    keyword: "อินโดจีน",
    meaning:
      'อินโดจีน (Indochina) หรือ คาบสมุทรอินโดจีน (Indochinese Peninsula) เป็นคาบสมุทรที่ยื่นออกมาจากแผ่นดินใหญ่ของทวีปเอเชีย และเป็นส่วนหนึ่งของภูมิภาคเอเชียตะวันออกเฉียงใต้ ที่มาของชื่อว่า อินโดจีน เนื่องจากคาบสมุทรนี้ตั้งอยู่ทางใต้ของสาธารณรัฐประชาชนจีน และ ทางตะวันออกของประเทศอินเดีย คำว่า "Indochina" มีที่มาจากคำว่า Indochine ในภาษาฝรั่งเศส และถูกใช้ในระหว่างยุคล่าอาณานิคม ในทางประวัติศาสตร์แล้ว ประเทศในอินโดจีนส่วนใหญ่ได้รับอิทธิพลทางวัฒนธรรมจากอินเดียและจีน',
    source:
      "พลาดิศัย สิทธิธัญกิจ. (2547). อินโดจีน, 6 มิถุนายน 2562. https://www.mekongrivertoday.com/indochina.htm",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรม",
    meaning:
      "กิจกรรมที่ใช้ทุนและแรงงานเพื่อผลิตสิ่งของหรือจัดให้มีบริการ มักเป็นการประกอบธุรกิจขนาดใหญ่ที่ต้องใช้แรงงานและเงินทุนมาก และหมายถึง งานที่ต้องใช้คนจำนวนมากและใช้เทคโนโลยี\r\n\r\n\r\n",
    source:
      "สำนักงานราชบัณฑิตยสภา พ.ศ. 2554. อุตสาหกรรม, 30 สิงหาคม 2562. http://www.royin.go.th\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรมเชิงนิเวศ ",
    meaning:
      "เมืองหรือพื้นที่ซึ่งมีการพัฒนาอุตสาหกรรมโดยให้มีความเชื่อมโยงของนิคมอุตสาหกรรม สวนอุตสาหกรรม เขตประกอบการอุตสาหกรรม หรือชุมชนอุตสาหกรรมกับกลุ่มโรงงาน องค์กร หน่วยงานท้องถิ่นและชุมชนโดยรอบให้เจริญเติบโตไปด้วยกันภายใต้การกำกับดูแลสิ่งแวดล้อมที่ดี และการร่วมมือกันขับเคลื่อนอย่างจริงจังของคนในพื้นที่ โดยสามารถดำเนินการได้ทุกระดับตั้งแต่ (1) ระดับปัจเจกชน เช่น ครอบครัวและโรงงาน (Eco Family / Green Factory) (2) ระดับกลุ่มอุตสาหกรรมหรือชุมชน เช่น นิคมอุตสาหกรรมหรือหมู่บ้านหรือตำบล (Eco Industrial Zone / Estate) และ (3) ระดับเมือง (Eco Town / Eco City) หรือเครือข่ายของเมืองหรือจังหวัด",
    source:
      "สถาบันสิ่งแวดล้อมอุตสาหกรรม สภาอุตสาหกรรมแห่งประเทศไทย. (2562). ขอบเขต นิยามและ KPI การพัฒนาเมืองอุตสาหกรรมเชิงนิเวศ , 21 พฤศจิกายน 2562. https://www.iei.or.th/knowladge.php",
    sappear: "",
    mappear: 18,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรมและบริการการแพทย์ครบวงจร",
    meaning:
      "อุตสาหกรรมการแพทย์ครบวงจรเป็นการสร้างอุตสาหกรรมใหม่ต่อยอดจากธุรกิจการรักษาพยาบาล และการท่องเที่ยวเชิงสุขภาพที่ประเทศไทยมีฐานเดิมที่แข็งแรง โดยเพิ่มธุรกิจด้านอุปกรณ์ทางการแพทย์จากพื้นฐานด้านอิเล็กทรอนิกส์และโทรคมนาคม และอุตสาหกรรมเวชภัณฑ์จากพื้นฐานด้านการเกษตรและเคมีชีวภาพ อุตสาหกรรม ซึ่งอุตสาหกรรมการแพทย์ครบวงจรเป็นอุตสาหกรรมที่มีอัตราการเจริญเติบโตเฉลี่ยร้อยละ 3.2 และเป็นอุตสาหกรรมที่เติบโตค่อนข้างเร็วในกลุ่มประเทศที่พัฒนาแล้ว ทั้งนี้การแพทย์ครบวงจรของไทยประกอบด้วย 3 ส่วน ได้แก่  1. การให้บริการสมัยใหม่ คือ การให้บริการด้านการแพทย์ผ่านอินเทอร์เน็ตและสมาร์ทโฟน (eHealth and mHealth) โดยใช้เทคโนโลยีการเชื่อมต่อและระบบเวชระเบียนอิเล็กทรอนิกส์ (Electronic Medical Records: EMRs) เพื่อให้คำปรึกษาทางการแพทย์และให้บริการรักษาทางไกลกับผู้ป่วยทั้งในและต่างประเทศ เพื่อเป็นทางเลือกแทนการเสียค่ารักษา หรือเพื่อให้บริการผู้ป่วยในพื้นที่ห่างไกล  2. การวิจัยและผลิตอุปกรณ์ทางการแพทย์ เพื่อการวินิจฉัยและติดตามผลระยะไกล (Remote Health Monitoring Devices) ซึ่งมีรากฐานมาจากการพัฒนาของเครื่องรับรู้ (Sensors) และอุปกรณ์การวัดสมัยใหม่ โดยอุปกรณ์วินิจฉัยและติดตามผลระยะไกล สามารถตอบสนองความต้องการของกลุ่มผู้บริโภคที่ต้องการวินิจฉัยโรคด้วยตนเอง เช่น วัดความดันโลหิต วัดอัตราการเต้นของหัวใจ เป็นต้น  3. การวิจัยยาและผลิตเวชภัณฑ์ การวิจัยยาและการผลิตยาที่ทันสมัยนั้น เพื่อลดกระบวนการและลดระยะเวลาการทดลองยาสมัยใหม่ โดยจะมุ่งเน้นที่การผลิตยาชีววัตถุคล้ายคลึง (Biosimilar) ซึ่งคือยาสามัญของยาชีววัตถุต้นแบบ (Biologic) ที่มีการวิจัยและจดสิทธิบัตรแต่สิทธิบัตรหมดอายุลงแล้ว ซึ่งปัจจุบันยาชีววัตถุมีการเติบโตอย่างรวดเร็วจนมีขนาดใหญ่กว่ายาสามัญทั่วไป",
    source:
      "สำนักงานคณะกรรมการนโยบายเขตพัฒนาพิเศษภาคตะวันออก (สกพอ.). (2562). อุตสาหกรรมการแพทย์ครบวงจร, 6 มิถุนายน 2562. https://www.eeco.or.th/industry/%E0%B8%AD%E0%B8%B8%E0%B8%95%E0%B8%AA%E0%B8%B2%E0%B8%AB%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%81%E0%B8%9E%E0%B8%97%E0%B8%A2%E0%B9%8C%E0%B8%84%E0%B8%A3%E0%B8%9A%E0%B8%A7%E0%B8%87%E0%B8%88%E0%B8%A3",
    sappear: 2,
    mappear: 4,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรมและบริการอนาคต",
    meaning:
      "แนวคิดในการพัฒนาหรือการดัดแปลงเทคโนโลยีและการสร้างนวัตกรรมว่าเป็นกระบวนการที่ไม่ได้เกิดขึ้นเฉพาะจากประสบการณ์ในโรงงานอุตสาหกรรมเพียงเท่านั้น องค์ความรู้ที่เกิดขึ้นจากภาคการศึกษาจะเป็นรากฐานสําคัญของการเพิ่มสมรรถนะ (Capability) ของภาคการผลิต ซึ่งจะนําไปสู่ความสําเร็จในการปฏิรูปภาคการผลิต หากพิจารณาจากประสบการณ์ของประเทศที่ก้าวข้ามกับดักประเทศรายได้ปานกลางได้นั้น จะพบว่า ประเทศเหล่านี้เริ่มต้นจากการปฏิรูปภาคการศึกษา เพื่อเป็นรากฐานในการสร้างเทคโนโลยีและนวัตกรรมสําหรับสินค้าที่เป็นเป้าหมายของประเทศ เรียกว่าเป็นการผลิตสินค้าที่ใช้ความรู้เข้มข้น (Knowledge-Intensive) ซึ่งความสําเร็จในการผลิตสินค้าที่ซับซ้อนนี้จะเป็นเครื่องมือในการเพิ่มความสามารถในการแข่งขันกับประเทศกําลังพัฒนาที่ได้เปรียบจากการมีค่าจ้างแรงงานตํ่า",
    source:
      "พาณุวงศ์ คัมภิรารักษ์ แก้วตา โรหิตรัตนะ คณะพาณิชยศาสตร์และการบัญชี มหาวิทยาลัยธรรมศาสตร์. (2561). อุตสาหกรรม 4.0 อุตสาหกรรมแห่งอนาคตของไทย, 18 กันยายน 2562. https://www.tci-thaijo.org/index.php/wms/article/download/147021/108327/",
    sappear: 2,
    mappear: 4,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรมแห่งอนาคต",
    meaning:
      "แนวคิดในการพัฒนาหรือการดัดแปลงเทคโนโลยีและการสร้างนวัตกรรมว่าเป็นกระบวนการที่ไม่ได้เกิดขึ้นเฉพาะจากประสบการณ์ในโรงงานอุตสาหกรรมเพียงเท่านั้น องค์ความรู้ที่เกิดขึ้นจากภาคการศึกษาจะเป็นรากฐานสําคัญของการเพิ่มสมรรถนะ (Capability) ของภาคการผลิต ซึ่งจะนําไปสู่ความสําเร็จในการปฏิรูปภาคการผลิต หากพิจารณาจากประสบการณ์ของประเทศที่ก้าวข้ามกับดักประเทศรายได้ปานกลางได้นั้น จะพบว่า ประเทศเหล่านี้เริ่มต้นจากการปฏิรูปภาคการศึกษา เพื่อเป็นรากฐานในการสร้างเทคโนโลยีและนวัตกรรมสําหรับสินค้าที่เป็นเป้าหมายของประเทศ เรียกว่าเป็นการผลิตสินค้าที่ใช้ความรู้เข้มข้น (Knowledge-Intensive) ซึ่งความสําเร็จในการผลิตสินค้าที่ซับซ้อนนี้จะเป็นเครื่องมือในการเพิ่มความสามารถในการแข่งขันกับประเทศกําลังพัฒนาที่ได้เปรียบจากการมีค่าจ้างแรงงานตํ่า",
    source:
      "พาณุวงศ์ คัมภิรารักษ์ แก้วตา โรหิตรัตนะ คณะพาณิชยศาสตร์และการบัญชี มหาวิทยาลัยธรรมศาสตร์. (2561). อุตสาหกรรม 4.0 อุตสาหกรรมแห่งอนาคตของไทย, 18 กันยายน 2562. https://www.tci-thaijo.org/index.php/wms/article/download/147021/108327/",
    sappear: "",
    mappear: 7,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรมโรงไฟฟ้าชีวมวล",
    meaning:
      "โรงไฟฟ้าที่ใช้เศษวัสดุต่าง ๆ ที่เป็นชีวมวล เป็นเชื้อเพลิงในการผลิตไฟฟ้า หรือ ผลิตไอน้ำซึ่งอาจเป็นวัสดุชนิดเดียวกันหรือหลายชนิดรวมกัน เช่น\r\n- โรงน้ำตาลใช้กากอ้อยที่ได้จากการหีบอ้อยเป็นเชื้อเพลิงในการผลิตไฟฟ้า\r\n- โรงสีข้าว ที่ใช้แกลบเป็นเชื้อเพลิงหลักในการผลิตไฟฟ้า\r\n- การใช้ก๊าซชีวภาพ (Biogas) จากการหมักน้ําเสีย (จากกระบวนการผลิตทางอุตสาหกรรม) หรือมูลสัตว์(จากฟาร์มเลี้ยงสัตว์) มาผลิตกระแสไฟฟ้า",
    source:
      "นางสาวกาญจนา สวยสม นักวิชาการสิงแวดล้อมชํานาญการพิเศษ ส่วนมลพิษจากอุตสาหกรรม สํานักจัดการคุณภาพอากาศและเสียง กรมควบคุมมลพิษ. มลพิษจากโรงงานไฟฟ้าชีวมวล และกระบวนการทำ EIA, 16 กันยายน 2562. http://envocc.ddc.moph.go.th/uploads/%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%8A%E0%B8%B8%E0%B8%A1/25-26_08_61/25-3.pdf",
    sappear: "",
    mappear: "",
    rappear: 6,
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรมการเกษตร",
    meaning:
      "อุตสาหกรรมการแปรรูปผลผลิตทางการเกษตรไปเป็นเครื่องอุปโภคและบริโภค ได้แก่ อุตสาหกรรมอาหารและเครื่องดื่ม อุตสาหกรรมยาและเครื่องสำอาง และอุตสาหกรรมสิ่งทอ เป็นต้น โซ่อุปทานของอุตสาหกรรมเกษตรมีลักษณะเฉพาะเนื่องจากเกิดจากการแปรรูปวัตถุดิบที่เป็นผลิตผลทางการเกษตร ซึ่งมีลักษณะเด่นแตกต่างจากวัตถุดิบในอุตสาหกรรมอื่นๆ",
    source:
      "พรธิภา องค์คุณารักษ์. (2553). 'การจัดการโซ่อุปทานสำหรับอุตสาหกรรมเกษตร', 6 มิถุนายน 2562. http://www.sru.agro.ku.ac.th/thai/articles.php?sru_id=1",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรมการเกษตรครบวงจร",
    meaning:
      "อุตสาหกรรมการแปรรูปผลผลิตทางการเกษตรไปเป็นเครื่องอุปโภคและบริโภค ได้แก่ อุตสาหกรรมอาหารและเครื่องดื่ม อุตสาหกรรมยาและเครื่องสำอาง และอุตสาหกรรมสิ่งทอ เป็นต้น โซ่อุปทานของอุตสาหกรรมเกษตรมีลักษณะเฉพาะเนื่องจากเกิดจากการแปรรูปวัตถุดิบที่เป็นผลิตผลทางการเกษตร ซึ่งมีลักษณะเด่นแตกต่างจากวัตถุดิบในอุตสาหกรรมอื่นๆ",
    source:
      "พรธิภา องค์คุณารักษ์. (2553). 'การจัดการโซ่อุปทานสำหรับอุตสาหกรรมเกษตร', 6 มิถุนายน 2562. http://www.sru.agro.ku.ac.th/thai/articles.php?sru_id=1",
    sappear: 2,
    mappear: 6,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรมการแพทย์",
    meaning:
      "อุตสาหกรรมใหม่ต่อยอดจากธุรกิจการรักษาพยาบาล และการท่องเที่ยวเชิงสุขภาพที่ประเทศไทยมีฐานเดิมที่แข็งแรง โดยเพิ่มธุรกิจด้านอุปกรณ์ทางการแพทย์จากพื้นฐานด้านอิเล็กทรอนิกส์และโทรคมนาคม และอุตสาหกรรมเวชภัณฑ์จากพื้นฐานด้านการเกษตรและเคมีชีวภาพ อุตสาหกรรม ซึ่งอุตสาหกรรมการแพทย์ครบวงจรมีอัตราการเจริญเติบโตเฉลี่ยร้อยละ 3.2 และเป็นอุตสาหกรรมที่เติบโตค่อนข้างเร็วในกลุ่มประเทศที่พัฒนาแล้ว\r\nทั้งนี้การแพทย์ครบวงจรของไทยประกอบด้วย 3 ส่วน ได้แก่\r\n1. การให้บริการสมัยใหม่ คือ การให้บริการด้านการแพทย์ผ่านอินเทอร์เน็ตและสมาร์ทโฟน (eHealth and mHealth) โดยใช้เทคโนโลยีการเชื่อมต่อและระบบเวชระเบียนอิเล็กทรอนิกส์ (Electronic Medical Records: EMRs) เพื่อให้คำปรึกษาทางการแพทย์และให้บริการรักษาทางไกลกับผู้ป่วยทั้งในและต่างประเทศ เพื่อเป็นทางเลือกแทนการเสียค่ารักษา หรือเพื่อให้บริการผู้ป่วยในพื้นที่ห่างไกล\r\n2. การวิจัยและผลิตอุปกรณ์ทางการแพทย์ เพื่อการวินิจฉัยและติดตามผลระยะไกล (Remote Health Monitoring Devices) ซึ่งมีรากฐานมาจากการพัฒนาของเครื่องรับรู้ (Sensors) และอุปกรณ์การวัดสมัยใหม่ โดยอุปกรณ์วินิจฉัยและติดตามผลระยะไกล สามารถตอบสนองความต้องการของกลุ่มผู้บริโภคที่ต้องการวินิจฉัยโรคด้วยตนเอง  เช่น วัดความดันโลหิต วัดอัตราการเต้นของหัวใจ เป็นต้น\r\n3. การวิจัยยาและผลิตเวชภัณฑ์ การวิจัยยาและการผลิตยาที่ทันสมัยนั้น เพื่อลดกระบวนการและลดระยะเวลาการทดลองยาสมัยใหม่ โดยจะมุ่งเน้นที่การผลิตยาชีววัตถุคล้ายคลึง (Biosimilar) ซึ่งคือยาสามัญของยาชีววัตถุต้นแบบ (Biologic) ที่มีการวิจัยและจดสิทธิบัตรแต่สิทธิบัตรหมดอายุลงแล้ว ซึ่งปัจจุบันยาชีววัตถุมีการเติบโตอย่างรวดเร็วจนมีขนาดใหญ่กว่ายาสามัญทั่วไป",
    source:
      "สำนักงานคณะกรรมการนโยบายเขตพัฒนาพิเศษภาคตะวันออก (สกพอ.). (2561). อุตสาหกรรมการแพทย์ครบวงจร, 11 กันยายน 2562. https://www.eeco.or.th/industry/%E0%B8%AD%E0%B8%B8%E0%B8%95%E0%B8%AA%E0%B8%B2%E0%B8%AB%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%81%E0%B8%9E%E0%B8%97%E0%B8%A2%E0%B9%8C%E0%B8%84%E0%B8%A3%E0%B8%9A%E0%B8%A7%E0%B8%87%E0%B8%88%E0%B8%A3",
    sappear: 2,
    mappear: 4,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรมการแพทย์ครบวงจร\r\n",
    meaning:
      "อุตสาหกรรมใหม่ต่อยอดจากธุรกิจการรักษาพยาบาล และการท่องเที่ยวเชิงสุขภาพที่ประเทศไทยมีฐานเดิมที่แข็งแรง โดยเพิ่มธุรกิจด้านอุปกรณ์ทางการแพทย์จากพื้นฐานด้านอิเล็กทรอนิกส์และโทรคมนาคม และอุตสาหกรรมเวชภัณฑ์จากพื้นฐานด้านการเกษตรและเคมีชีวภาพ อุตสาหกรรม ซึ่งอุตสาหกรรมการแพทย์ครบวงจรมีอัตราการเจริญเติบโตเฉลี่ยร้อยละ 3.2 และเป็นอุตสาหกรรมที่เติบโตค่อนข้างเร็วในกลุ่มประเทศที่พัฒนาแล้ว\r\nทั้งนี้การแพทย์ครบวงจรของไทยประกอบด้วย 3 ส่วน ได้แก่\r\n1. การให้บริการสมัยใหม่ คือ การให้บริการด้านการแพทย์ผ่านอินเทอร์เน็ตและสมาร์ทโฟน (eHealth and mHealth) โดยใช้เทคโนโลยีการเชื่อมต่อและระบบเวชระเบียนอิเล็กทรอนิกส์ (Electronic Medical Records: EMRs) เพื่อให้คำปรึกษาทางการแพทย์และให้บริการรักษาทางไกลกับผู้ป่วยทั้งในและต่างประเทศ เพื่อเป็นทางเลือกแทนการเสียค่ารักษา หรือเพื่อให้บริการผู้ป่วยในพื้นที่ห่างไกล\r\n2. การวิจัยและผลิตอุปกรณ์ทางการแพทย์ เพื่อการวินิจฉัยและติดตามผลระยะไกล (Remote Health Monitoring Devices) ซึ่งมีรากฐานมาจากการพัฒนาของเครื่องรับรู้ (Sensors) และอุปกรณ์การวัดสมัยใหม่ โดยอุปกรณ์วินิจฉัยและติดตามผลระยะไกล สามารถตอบสนองความต้องการของกลุ่มผู้บริโภคที่ต้องการวินิจฉัยโรคด้วยตนเอง  เช่น วัดความดันโลหิต วัดอัตราการเต้นของหัวใจ เป็นต้น\r\n3. การวิจัยยาและผลิตเวชภัณฑ์ การวิจัยยาและการผลิตยาที่ทันสมัยนั้น เพื่อลดกระบวนการและลดระยะเวลาการทดลองยาสมัยใหม่ โดยจะมุ่งเน้นที่การผลิตยาชีววัตถุคล้ายคลึง (Biosimilar) ซึ่งคือยาสามัญของยาชีววัตถุต้นแบบ (Biologic) ที่มีการวิจัยและจดสิทธิบัตรแต่สิทธิบัตรหมดอายุลงแล้ว ซึ่งปัจจุบันยาชีววัตถุมีการเติบโตอย่างรวดเร็วจนมีขนาดใหญ่กว่ายาสามัญทั่วไป",
    source:
      "สำนักงานคณะกรรมการนโยบายเขตพัฒนาพิเศษภาคตะวันออก (สกพอ.). (2561). อุตสาหกรรมการแพทย์ครบวงจร, 11 กันยายน 2562. https://www.eeco.or.th/industry/%E0%B8%AD%E0%B8%B8%E0%B8%95%E0%B8%AA%E0%B8%B2%E0%B8%AB%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%81%E0%B8%9E%E0%B8%97%E0%B8%A2%E0%B9%8C%E0%B8%84%E0%B8%A3%E0%B8%9A%E0%B8%A7%E0%B8%87%E0%B8%88%E0%B8%A3",
    sappear: 2,
    mappear: 4,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรมการท่องเที่ยว",
    meaning:
      "ประกอบขึ้นจากส่วนต่างๆ มากมายทั้งภาครัฐและเอกชนโดยรวมถึงการพัฒนา การผลิต การแจกจ่าย การตลาด และการบริการ โดยมีวัตถุประสงค์ในการให้บริการและตอบสนองความต้องการของนักท่องเที่ยว",
    source:
      "นายเจษฎา ขวัญเมือง และคณะ. Tourism around the world คลังคำศัพท์, 30 กรกฎาคม 2562. https://touristbuu.wordpress.com/%E0%B8%84%E0%B8%A5%E0%B8%B1%E0%B8%87%E0%B8%84%E0%B8%B3%E0%B8%A8%E0%B8%B1%E0%B8%9E%E0%B8%97%E0%B9%8C/",
    sappear: "",
    mappear: 5,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรมชีวภาพ",
    meaning:
      "อุตสาหกรรมที่อาศัยเทคโนโลยีชีวภาพ (Biotechnology) ในการผลิตสินค้า เช่น เคมีภัณฑ์ อาหาร ยา อาหารสัตว์บรรจุภัณฑ์ เป็นต้น และถือเป็นอุตสาหกรรมใหม่ที่ประเทศไทยมีศักยภาพด้านการผลิต จากการเป็นแหล่งวัตถุดิบทางชีวภาพที่หลากหลาย โดยอุตสาหกรรมดังกล่าวจะใช้สินค้าเกษตรของประเทศ เช่น อ้อย มันสำปะหลัง ปาล์มน้ำมัน มาแปรรูปด้วยเทคโนโลยีชีวภาพ ซึ่งจะช่วยเพิ่มมูลค่าให้แก่สินค้าเกษตร",
    source:
      "สำนักงานเศรษฐกิจอุตสาหกรรม กระทรวงอุตสาหกรรม. (2561). มาตรการพัฒนาอุตสาหกรรมชีวภาพของไทยปี พ.ศ. 2561-2570, 12 กันยายน 2562. http://www.oie.go.th/sites/default/files/attachments/plan/bio_plan.pdf\r\n",
    sappear: "",
    mappear: 4,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรมท่องเที่ยว",
    meaning:
      "อุตสาหกรรมที่จัดให้มีหรือให้บริการเกี่ยวกับการท่องเที่ยวทั้งภายในและภายนอกราชอาณาจักรโดยมีค่าตอบแทน และหมายความรวมถึง \r\n(1) ธุรกิจนําเที่ยว\r\n(2) ธุรกิจโรงแรมนักท่องเที่ยว\r\n(3) ธุรกิจภัตตาคาร สถานบริการและสถานที่ตากอากาศสําหรับนักท่องเที่ยว\r\n(4) ธุรกิจการขายของที่ระลึกหรือสินค้าสําหรับนักท่องเที่ยว\r\n(5) ธุรกิจการกีฬาสําหรับนักท่องเที่ยว\r\n(6) การดําเนินงานนิทรรศการ งานแสดง งานออกร้าน การโฆษณาเผยแพร่ หรือการดําเนินงานอื่นใดโดยมีความมุ่งหมายเพื่อชักนําหรือส่งเสริมให้มีการเดินทางท่องเที่ยว\r\n",
    source:
      "พระราชบัญญัติการท่องเที่ยวแห่งประเทศไทย พ.ศ. 2522 (2522, 4 พฤษภาคม). ราชกิจจานุเบกษา. เล่มที่ 96 ตอนที่ 72 หน้า 2. http://www.ratchakitcha.soc.go.th/DATA/PDF/2522/A/072/1.PDF",
    sappear: "",
    mappear: 5,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรมบนฐานชีวภาพ\r\n",
    meaning:
      'การใช้ทรัพยากรฐานชีวภาพ (พืช สัตว์ จุลินทรีย์) รวมถึงวัสดุเหลือทิ้งทางการเกษตร ของเสีย/น้ำเสียจากโรงงานอุตสาหกรรม ฟาร์มปศุสัตว์\r\nและชุมชน พัฒนาต่อยอดเป็น "ผลิตภัณฑ์ชีวภาพ" ที่มีมูลค่าสูง ก่อให้เกิดความก้าวหน้าและนวัตกรรมในมิติใหม่ ๆ ที่ส่งผลต่อการปฏิรูปภาคเกษตร อาหาร สาธารณสุขและการแพทย์ พลังงาน อุตสาหกรรมเคมี ภาคสังคมและภาคเศรษฐกิจของโลก',
    source:
      "สำนักงานเลขาธิการสภาผู้แทนราษฎร. (2559). การปฏิรูปเศรษฐกิจชีวภาพ, 8 ตุลาคม 2562. https://www.parliament.go.th/ewtadmin/ewt/parliament_parcy/download/usergroup_disaster/6-9.pdf",
    sappear: 2,
    mappear: "",
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรมป้องกันประเทศ",
    meaning:
      "การวิจัย การพัฒนา การผลิต การประกอบรวม การปรับปรุง การซ่อมสร้าง การเปลี่ยนลักษณะ การแปรสภาพ หรือการให้บริการซึ่งผลิตภัณฑ์ที่ใช้ในการป้องกันประเทศโดยอาจมีค่าตอบแทนหรือไม่ก็ได้",
    source:
      "พระราชบัญญัติเทคโนโลยีป้องกันประเทศ พ.ศ. 2562.  (2562, 30 เมษายน). ราชกิจจานุเบกษา. เล่ม 136 ตอนที่ 56 ก หน้า 18.\r\nhttp://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/056/T_0017.PDF",
    sappear: 2,
    mappear: 4,
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อุตสาหกรรมสีเขียว (Green Industry)",
    meaning:
      "อุตสาหกรรมที่ยึดมั่นในการประกอบกิจการที่เป็นมิตรต่อสิ่งแวดล้อม เพื่อการพัฒนาอย่างยั่งยืน",
    source:
      "ดร.รัตนาวรรณ มั่งคั่ง. อุตสาหกรรมสีเขียว (Green Industry, GI), 6 มิถุนายน 2562. https://www.iei.or.th/media/www/file/470/15337591401345519.pdf ",
    sappear: "",
    mappear: "",
    rappear: 10,
    firstalpha: "อ"
  },
  {
    keyword: "อุทธรณ์",
    meaning:
      "ขอให้พิจารณาใหม่ในทางศาล หมายถึง ยื่นคำร้องหรือคำคัดค้านต่อศาลอุทธรณ์",
    source:
      "สำนักงานราชบัณฑิตยสภา. (2551). อุทธรณ์, \r\n29 สิงหาคม 2562. http://www.royin.go.th/?knowledges=%E0%B8%AD%E0%B8%B8%E0%B8%97%E0%B8%98%E0%B8%A3%E0%B8%93%E0%B9%8C-%E0%B9%96-%E0%B8%A1%E0%B8%81%E0%B8%A3%E0%B8%B2%E0%B8%84%E0%B8%A1-%E0%B9%92%E0%B9%95%E0%B9%95%E0%B9%91",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "อ"
  },
  {
    keyword: "อุทธรณ์ฎีกา",
    meaning:
      "คำคัดค้านคำพิพากษาหรือคำสั่งของศาลล่าง กล่าวคือ การอุทธรณ์คำพิพากษาหรือคำสั่งของศาลชั้นต้นต้องอุทธรณ์ไปยังศาลอุทธรณ์และการฎีกาก็คือคำคัดค้านคำพิพากษาหรือคำสั่งของศาลอุทธรณ์ และจะเป็นอุทธรณ์หรือฎีกาตามกฎหมายก็ต่อเมื่อมีผู้อุทธรณ์หรือผู้ฎีกายืนยันมาในอุทธรณ์หรือฎีกาว่าคำพิพากษาหรือคำสั่งของศาลล่างไม่ถูกต้อง และขอให้มีการแก้ไขอุทธรณ์ ฎีกา ",
    source:
      "สราวุธ เบญจกุล รองเลขาธิการสำนักงานศาลยุติธรรมและโฆษกสำนักงานศาลยุติธรรม. (2550). อุทธรณ์ ฎีกา…คำสั่งปล่อยชั่วคราว, 6 มิถุนายน 2562. https://mgronline.com/crime/detail/9500000093127",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "อ"
  },
  {
    keyword: "อุบัติใหม่",
    meaning:
      "การกำเนิดขึ้นใหม่โดยที่ไม่เคยมีหรือเกิดขึ้นมาก่อน ยกตัวอย่างเช่น โรคติดเชื้ออุบัติใหม่ หมายถึง โรคติดเชื้อชนิดใหม่ๆ ที่ปรากฏว่า มีรายงานผู้ป่วยเพิ่มขึ้น ในระยะประมาณสองทศวรรษที่ผ่านมา หรือโรคติดเชื้อที่มีแนวโน้มที่จะพบมากขึ้น ในอนาคตอันใกล้ คำจำกัดความนี้ครอบคลุมถึงโรคที่เกิดขึ้นใหม่ในอาณาบริเวณใดบริเวณหนึ่ง หรือโรคที่เพิ่งจะแพร่ระบาดเข้าไปสู่อีกอาณาบริเวณหนึ่ง และยังรวมถึงโรคติดเชื้อ ที่เคยควบคุมได้ด้วยยาปฏิชีวนะ แต่มาบัดนี้เกิดการดื้อยาต่างๆ เหล่านั้น",
    source:
      "ศาสตราจารย์เกียรติคุณ แพทย์หญิง พวงทอง ไกรพิบูลย์. (2558). โรคอุบัติใหม่ (Emerging infectious disease) โรคอุบัติซ้ำ (Re-emerging infectious disease), 6 มิถุนายน 2562. http://haamor.com/th/%E0%B9%82%E0%B8%A3%E0%B8%84%E0%B8%AD%E0%B8%B8%E0%B8%9A%E0%B8%B1%E0%B8%95%E0%B8%B4%E0%B9%83%E0%B8%AB%E0%B8%A1%E0%B9%88/",
    sappear: "",
    mappear: 18,
    rappear: 6,
    firstalpha: "อ"
  },
  {
    keyword: "อุบัติภัย",
    meaning: "ภัยที่เกิดจากอุบัติเหตุ",
    source:
      "พจนานุกรมฉบับราชบัณฑิตยสถาน พ.ศ. 2554 อุบัติภัย. 20 สิงหาคม 2562 \r\nhttp://www.royin.go.th/dictionary/",
    sappear: "",
    mappear: "",
    rappear: 3,
    firstalpha: "อ"
  },
  {
    keyword: "อุปกรณ์อิเล็กทรอนิกส์ติดตามตัว (EM)",
    meaning:
      "อุปกรณ์รับส่งสัญญาณอิเล็กทรอนิกส์พร้อมกับชุดอุปกรณ์ที่เกี่ยวข้องเพื่อใช้ในการติดตามตัว รวมถึงการตรวจสอบ ความเคลื่อนไหว หรือตำแหน่งของผู้ถูกคุมประพฤติให้ปฏิบัติตามเงื่อนไข ที่ศาลหรือเจ้าพนักงานผู้มีอำนาจสั่ง อาทิ การห้ามออกหรือห้ามเข้า บริเวณที่กำหนด โดยอาจกำหนดช่วงเวลาด้วยก็ได้ ซึ่งจะดำเนินการควบคู่กับมาตรการแก้ไขฟื้นฟู",
    source:
      "กรมคุมประพฤติ กระทรวงยุติธรรม. ความรู้ทั่วไปเกี่ยวกับอุปกรณ์อิเล็กทรอนิกส์ ติดตามตัว สำหรับประชาชน, 6 มิถุนายน 2562. http://www.oic.go.th/FILEWEB/CABINFOCENTER14/DRAWER081/GENERAL/DATA0000/00000175.PDF",
    sappear: "",
    mappear: "",
    rappear: 4,
    firstalpha: "อ"
  },
  {
    keyword: "อุปทาน",
    meaning:
      "ปริมาณความต้องการเสนอขายสินค้า ณ ระดับราคาใด ราคาหนึ่ง ในเวลาใดเวลาหนึ่ง โดยกำหนดให้สิ่งอื่น ๆ คงที่",
    source:
      "รศ. สุกัญญา ตันธนวัฒน์ และคณะ. (2552). เอกสารประกอบคำบรรยาย วิชา EC103 เศรษฐศาสตร์ทั่วไป, 6 มิถุนายน 2562.\r\n http://econ.tu.ac.th/class/archan/Napon/EC212_2-56/Lecture/EC212_2_56",
    sappear: 5,
    mappear: "2,18",
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อุปสงค์",
    meaning:
      "การเสนอเลือกซื้อสินค้าในปริมาณที่ผู้บริโภคต้องการ ในราคาต่างๆ ในเวลาใดเวลาหนึ่ง มีความต้องการจงใจที่จะซื้อ และความสามารถที่จะซื้อในช่วงเวลานั้น ดังนั้นแล้วจึงเป็นความต้องการที่สามารถซื้อได้จริงตอบสนองความต้องการของผู้บริโภค ซึ่งการที่ผู้บริโภคต้องการที่จะซื้อสินค้าหรือบริการในระยะเวลาใดระยะเวลาหนึ่ง จะมีมากน้อยซึ่งขึ้นอยู่กับปัจจัยต่างๆ ดังนี้\r\n 1. ราคาสินค้าชนิดนั้น\r\n 2. ระดับรายได้ของผู้บริโภค\r\n 3. ราคาสินค้าและบริการชนิดอื่นๆที่เกี่ยวข้อ\r\n 4. รสนิยมของผู้บริโภค\r\n 5. จำนวนประชากร\r\n 6. การโฆษณา\r\n 7. ช่วงระยะเวลาหรือฤดูกาล เป็นต้น",
    source:
      "Accountclub.net . (2561). อุปสงค์ (Demand) คืออะไร, 6 มิถุนายน 2562. http://www.accountclub.net/2018/01/10/%E0%B8%AD%E0%B8%B8%E0%B8%9B%E0%B8%AA%E0%B8%87%E0%B8%84%E0%B9%8C-demand-%E0%B8%84%E0%B8%B7%E0%B8%AD%E0%B8%AD%E0%B8%B0%E0%B9%84%E0%B8%A3/",
    sappear: 5,
    mappear: "2,18",
    rappear: "",
    firstalpha: "อ"
  },
  {
    keyword: "อุปสรรคทางการค้าที่ไม่ใช่ภาษี (Non-Tariff Barriers)     ",
    meaning:
      "กฎระเบียบข้อบังคับที่รัฐบาลประเทศต่าง ๆ กำหนดขึ้นเพื่อเป็นสร้างอุปสรรคต่อการส่งออกของประเทศคู่ค้า หรือเพื่อกีดกันการนำเข้าที่ไม่สอดคล้องกับความตกลงระหว่างประเทศ โดยทั่วไปพบว่าประเทศต่าง ๆ นำมาตรการที่มิใช่ภาษีมาใช้อย่างเข้มงวดเกินไป จนทำให้ ประเทศอื่นมองว่าเป็นมาตรการที่ไม่เป็นธรรม กลายเป็นอุปสรรคทางการค้าที่มิใช่ภาษีเกิดขึ้น เช่น การกำหนดคุณภาพที่เกินมาตรฐานสากลหรือการเข้มงวดในการตรวจสอบมาตรฐานสินค้า และใช้เวลาในการตรวจสอบนานมากจนอาจทำให้สินค้าเกิดความเสียหายตลอดจนการปฏิบัติด้านพิธีการศุลกากรที่ไม่เป็นธรรม เช่น \r\n- การบริหารโควตาภาษี (Tariffs Rate Quatas: TRQs) \r\n- สวัสดิภาพสัตว์ (Animal Welfare) \r\n- มาตรฐานสิ่งแวดล้อมที่เกี่ยวข้องกับการค้า (Trade-Related Environmental Measures) \r\n- การปิดฉลากสินค้าตัดแต่งสารพันธุกรรม (Genetically Modified Organisms: GMOs) \r\n- มาตรฐานแรงงาน (Trade and Labour Standard) เป็นต้น \r\nซึ่งการใช้มาตรการฝ่ายเดียวและอ้างว่าประเทศคู่ค้าไม่ปฏิบัติตามความตกลงของ WTO อย่างมีประสิทธิภาพ เช่น \r\n- ประเด็นทรัพย์สินทางปัญญา \r\n- กฎระเบียบเกี่ยวกับกระบวนการตรวจสอบสินค้าและพิธีการศุลกากร \r\n- เงื่อนไขการลงทุนและนโยบายการแข่งขัน เป็นต้น",
    source:
      "กรมเจรจาการค้าระหว่างประเทศ กระทรวงพาณิชย์. (2556). ความรู้เบื้องต้นเกี่ยวกับ มาตรการที่มิใช่ภาษี(Non – Tariff Measures: NTMs) และอุปสรรคทางการค้าที่มิใช่ภาษี(Non-Tariff Barriers: NTBs), 12 มิถุนายน 2562. https://www.moc.go.th/index.php/moc-news-center-eng/item/non-tariff-measures-ntms-non-tariff-barriers-ntbs-11-2556.html",
    sappear: "",
    mappear: "",
    rappear: 5,
    firstalpha: "อ"
  }
];

export default {
  _data
};
